/******/ (function(modules) { // webpackBootstrap
/******/ 	function hotDisposeChunk(chunkId) {
/******/ 		delete installedChunks[chunkId];
/******/ 	}
/******/ 	var parentHotUpdateCallback = window["webpackHotUpdate"];
/******/ 	window["webpackHotUpdate"] = // eslint-disable-next-line no-unused-vars
/******/ 	function webpackHotUpdateCallback(chunkId, moreModules) {
/******/ 		hotAddUpdateChunk(chunkId, moreModules);
/******/ 		if (parentHotUpdateCallback) parentHotUpdateCallback(chunkId, moreModules);
/******/ 	} ;
/******/
/******/ 	// eslint-disable-next-line no-unused-vars
/******/ 	function hotDownloadUpdateChunk(chunkId) {
/******/ 		var head = document.getElementsByTagName("head")[0];
/******/ 		var script = document.createElement("script");
/******/ 		script.charset = "utf-8";
/******/ 		script.src = __webpack_require__.p + "" + chunkId + "." + hotCurrentHash + ".hot-update.js";
/******/ 		;
/******/ 		head.appendChild(script);
/******/ 	}
/******/
/******/ 	// eslint-disable-next-line no-unused-vars
/******/ 	function hotDownloadManifest(requestTimeout) {
/******/ 		requestTimeout = requestTimeout || 10000;
/******/ 		return new Promise(function(resolve, reject) {
/******/ 			if (typeof XMLHttpRequest === "undefined")
/******/ 				return reject(new Error("No browser support"));
/******/ 			try {
/******/ 				var request = new XMLHttpRequest();
/******/ 				var requestPath = __webpack_require__.p + "" + hotCurrentHash + ".hot-update.json";
/******/ 				request.open("GET", requestPath, true);
/******/ 				request.timeout = requestTimeout;
/******/ 				request.send(null);
/******/ 			} catch (err) {
/******/ 				return reject(err);
/******/ 			}
/******/ 			request.onreadystatechange = function() {
/******/ 				if (request.readyState !== 4) return;
/******/ 				if (request.status === 0) {
/******/ 					// timeout
/******/ 					reject(
/******/ 						new Error("Manifest request to " + requestPath + " timed out.")
/******/ 					);
/******/ 				} else if (request.status === 404) {
/******/ 					// no update available
/******/ 					resolve();
/******/ 				} else if (request.status !== 200 && request.status !== 304) {
/******/ 					// other failure
/******/ 					reject(new Error("Manifest request to " + requestPath + " failed."));
/******/ 				} else {
/******/ 					// success
/******/ 					try {
/******/ 						var update = JSON.parse(request.responseText);
/******/ 					} catch (e) {
/******/ 						reject(e);
/******/ 						return;
/******/ 					}
/******/ 					resolve(update);
/******/ 				}
/******/ 			};
/******/ 		});
/******/ 	}
/******/
/******/ 	var hotApplyOnUpdate = true;
/******/ 	var hotCurrentHash = "8e9bd78920c3f397a653"; // eslint-disable-line no-unused-vars
/******/ 	var hotRequestTimeout = 10000;
/******/ 	var hotCurrentModuleData = {};
/******/ 	var hotCurrentChildModule; // eslint-disable-line no-unused-vars
/******/ 	var hotCurrentParents = []; // eslint-disable-line no-unused-vars
/******/ 	var hotCurrentParentsTemp = []; // eslint-disable-line no-unused-vars
/******/
/******/ 	// eslint-disable-next-line no-unused-vars
/******/ 	function hotCreateRequire(moduleId) {
/******/ 		var me = installedModules[moduleId];
/******/ 		if (!me) return __webpack_require__;
/******/ 		var fn = function(request) {
/******/ 			if (me.hot.active) {
/******/ 				if (installedModules[request]) {
/******/ 					if (!installedModules[request].parents.includes(moduleId))
/******/ 						installedModules[request].parents.push(moduleId);
/******/ 				} else {
/******/ 					hotCurrentParents = [moduleId];
/******/ 					hotCurrentChildModule = request;
/******/ 				}
/******/ 				if (!me.children.includes(request)) me.children.push(request);
/******/ 			} else {
/******/ 				console.warn(
/******/ 					"[HMR] unexpected require(" +
/******/ 						request +
/******/ 						") from disposed module " +
/******/ 						moduleId
/******/ 				);
/******/ 				hotCurrentParents = [];
/******/ 			}
/******/ 			return __webpack_require__(request);
/******/ 		};
/******/ 		var ObjectFactory = function ObjectFactory(name) {
/******/ 			return {
/******/ 				configurable: true,
/******/ 				enumerable: true,
/******/ 				get: function() {
/******/ 					return __webpack_require__[name];
/******/ 				},
/******/ 				set: function(value) {
/******/ 					__webpack_require__[name] = value;
/******/ 				}
/******/ 			};
/******/ 		};
/******/ 		for (var name in __webpack_require__) {
/******/ 			if (
/******/ 				Object.prototype.hasOwnProperty.call(__webpack_require__, name) &&
/******/ 				name !== "e"
/******/ 			) {
/******/ 				Object.defineProperty(fn, name, ObjectFactory(name));
/******/ 			}
/******/ 		}
/******/ 		fn.e = function(chunkId) {
/******/ 			if (hotStatus === "ready") hotSetStatus("prepare");
/******/ 			hotChunksLoading++;
/******/ 			return __webpack_require__.e(chunkId).then(finishChunkLoading, function(err) {
/******/ 				finishChunkLoading();
/******/ 				throw err;
/******/ 			});
/******/
/******/ 			function finishChunkLoading() {
/******/ 				hotChunksLoading--;
/******/ 				if (hotStatus === "prepare") {
/******/ 					if (!hotWaitingFilesMap[chunkId]) {
/******/ 						hotEnsureUpdateChunk(chunkId);
/******/ 					}
/******/ 					if (hotChunksLoading === 0 && hotWaitingFiles === 0) {
/******/ 						hotUpdateDownloaded();
/******/ 					}
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 		return fn;
/******/ 	}
/******/
/******/ 	// eslint-disable-next-line no-unused-vars
/******/ 	function hotCreateModule(moduleId) {
/******/ 		var hot = {
/******/ 			// private stuff
/******/ 			_acceptedDependencies: {},
/******/ 			_declinedDependencies: {},
/******/ 			_selfAccepted: false,
/******/ 			_selfDeclined: false,
/******/ 			_disposeHandlers: [],
/******/ 			_main: hotCurrentChildModule !== moduleId,
/******/
/******/ 			// Module API
/******/ 			active: true,
/******/ 			accept: function(dep, callback) {
/******/ 				if (typeof dep === "undefined") hot._selfAccepted = true;
/******/ 				else if (typeof dep === "function") hot._selfAccepted = dep;
/******/ 				else if (typeof dep === "object")
/******/ 					for (var i = 0; i < dep.length; i++)
/******/ 						hot._acceptedDependencies[dep[i]] = callback || function() {};
/******/ 				else hot._acceptedDependencies[dep] = callback || function() {};
/******/ 			},
/******/ 			decline: function(dep) {
/******/ 				if (typeof dep === "undefined") hot._selfDeclined = true;
/******/ 				else if (typeof dep === "object")
/******/ 					for (var i = 0; i < dep.length; i++)
/******/ 						hot._declinedDependencies[dep[i]] = true;
/******/ 				else hot._declinedDependencies[dep] = true;
/******/ 			},
/******/ 			dispose: function(callback) {
/******/ 				hot._disposeHandlers.push(callback);
/******/ 			},
/******/ 			addDisposeHandler: function(callback) {
/******/ 				hot._disposeHandlers.push(callback);
/******/ 			},
/******/ 			removeDisposeHandler: function(callback) {
/******/ 				var idx = hot._disposeHandlers.indexOf(callback);
/******/ 				if (idx >= 0) hot._disposeHandlers.splice(idx, 1);
/******/ 			},
/******/
/******/ 			// Management API
/******/ 			check: hotCheck,
/******/ 			apply: hotApply,
/******/ 			status: function(l) {
/******/ 				if (!l) return hotStatus;
/******/ 				hotStatusHandlers.push(l);
/******/ 			},
/******/ 			addStatusHandler: function(l) {
/******/ 				hotStatusHandlers.push(l);
/******/ 			},
/******/ 			removeStatusHandler: function(l) {
/******/ 				var idx = hotStatusHandlers.indexOf(l);
/******/ 				if (idx >= 0) hotStatusHandlers.splice(idx, 1);
/******/ 			},
/******/
/******/ 			//inherit from previous dispose call
/******/ 			data: hotCurrentModuleData[moduleId]
/******/ 		};
/******/ 		hotCurrentChildModule = undefined;
/******/ 		return hot;
/******/ 	}
/******/
/******/ 	var hotStatusHandlers = [];
/******/ 	var hotStatus = "idle";
/******/
/******/ 	function hotSetStatus(newStatus) {
/******/ 		hotStatus = newStatus;
/******/ 		for (var i = 0; i < hotStatusHandlers.length; i++)
/******/ 			hotStatusHandlers[i].call(null, newStatus);
/******/ 	}
/******/
/******/ 	// while downloading
/******/ 	var hotWaitingFiles = 0;
/******/ 	var hotChunksLoading = 0;
/******/ 	var hotWaitingFilesMap = {};
/******/ 	var hotRequestedFilesMap = {};
/******/ 	var hotAvailableFilesMap = {};
/******/ 	var hotDeferred;
/******/
/******/ 	// The update info
/******/ 	var hotUpdate, hotUpdateNewHash;
/******/
/******/ 	function toModuleId(id) {
/******/ 		var isNumber = +id + "" === id;
/******/ 		return isNumber ? +id : id;
/******/ 	}
/******/
/******/ 	function hotCheck(apply) {
/******/ 		if (hotStatus !== "idle")
/******/ 			throw new Error("check() is only allowed in idle status");
/******/ 		hotApplyOnUpdate = apply;
/******/ 		hotSetStatus("check");
/******/ 		return hotDownloadManifest(hotRequestTimeout).then(function(update) {
/******/ 			if (!update) {
/******/ 				hotSetStatus("idle");
/******/ 				return null;
/******/ 			}
/******/ 			hotRequestedFilesMap = {};
/******/ 			hotWaitingFilesMap = {};
/******/ 			hotAvailableFilesMap = update.c;
/******/ 			hotUpdateNewHash = update.h;
/******/
/******/ 			hotSetStatus("prepare");
/******/ 			var promise = new Promise(function(resolve, reject) {
/******/ 				hotDeferred = {
/******/ 					resolve: resolve,
/******/ 					reject: reject
/******/ 				};
/******/ 			});
/******/ 			hotUpdate = {};
/******/ 			var chunkId = 1;
/******/ 			{
/******/ 				// eslint-disable-line no-lone-blocks
/******/ 				/*globals chunkId */
/******/ 				hotEnsureUpdateChunk(chunkId);
/******/ 			}
/******/ 			if (
/******/ 				hotStatus === "prepare" &&
/******/ 				hotChunksLoading === 0 &&
/******/ 				hotWaitingFiles === 0
/******/ 			) {
/******/ 				hotUpdateDownloaded();
/******/ 			}
/******/ 			return promise;
/******/ 		});
/******/ 	}
/******/
/******/ 	// eslint-disable-next-line no-unused-vars
/******/ 	function hotAddUpdateChunk(chunkId, moreModules) {
/******/ 		if (!hotAvailableFilesMap[chunkId] || !hotRequestedFilesMap[chunkId])
/******/ 			return;
/******/ 		hotRequestedFilesMap[chunkId] = false;
/******/ 		for (var moduleId in moreModules) {
/******/ 			if (Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				hotUpdate[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if (--hotWaitingFiles === 0 && hotChunksLoading === 0) {
/******/ 			hotUpdateDownloaded();
/******/ 		}
/******/ 	}
/******/
/******/ 	function hotEnsureUpdateChunk(chunkId) {
/******/ 		if (!hotAvailableFilesMap[chunkId]) {
/******/ 			hotWaitingFilesMap[chunkId] = true;
/******/ 		} else {
/******/ 			hotRequestedFilesMap[chunkId] = true;
/******/ 			hotWaitingFiles++;
/******/ 			hotDownloadUpdateChunk(chunkId);
/******/ 		}
/******/ 	}
/******/
/******/ 	function hotUpdateDownloaded() {
/******/ 		hotSetStatus("ready");
/******/ 		var deferred = hotDeferred;
/******/ 		hotDeferred = null;
/******/ 		if (!deferred) return;
/******/ 		if (hotApplyOnUpdate) {
/******/ 			// Wrap deferred object in Promise to mark it as a well-handled Promise to
/******/ 			// avoid triggering uncaught exception warning in Chrome.
/******/ 			// See https://bugs.chromium.org/p/chromium/issues/detail?id=465666
/******/ 			Promise.resolve()
/******/ 				.then(function() {
/******/ 					return hotApply(hotApplyOnUpdate);
/******/ 				})
/******/ 				.then(
/******/ 					function(result) {
/******/ 						deferred.resolve(result);
/******/ 					},
/******/ 					function(err) {
/******/ 						deferred.reject(err);
/******/ 					}
/******/ 				);
/******/ 		} else {
/******/ 			var outdatedModules = [];
/******/ 			for (var id in hotUpdate) {
/******/ 				if (Object.prototype.hasOwnProperty.call(hotUpdate, id)) {
/******/ 					outdatedModules.push(toModuleId(id));
/******/ 				}
/******/ 			}
/******/ 			deferred.resolve(outdatedModules);
/******/ 		}
/******/ 	}
/******/
/******/ 	function hotApply(options) {
/******/ 		if (hotStatus !== "ready")
/******/ 			throw new Error("apply() is only allowed in ready status");
/******/ 		options = options || {};
/******/
/******/ 		var cb;
/******/ 		var i;
/******/ 		var j;
/******/ 		var module;
/******/ 		var moduleId;
/******/
/******/ 		function getAffectedStuff(updateModuleId) {
/******/ 			var outdatedModules = [updateModuleId];
/******/ 			var outdatedDependencies = {};
/******/
/******/ 			var queue = outdatedModules.slice().map(function(id) {
/******/ 				return {
/******/ 					chain: [id],
/******/ 					id: id
/******/ 				};
/******/ 			});
/******/ 			while (queue.length > 0) {
/******/ 				var queueItem = queue.pop();
/******/ 				var moduleId = queueItem.id;
/******/ 				var chain = queueItem.chain;
/******/ 				module = installedModules[moduleId];
/******/ 				if (!module || module.hot._selfAccepted) continue;
/******/ 				if (module.hot._selfDeclined) {
/******/ 					return {
/******/ 						type: "self-declined",
/******/ 						chain: chain,
/******/ 						moduleId: moduleId
/******/ 					};
/******/ 				}
/******/ 				if (module.hot._main) {
/******/ 					return {
/******/ 						type: "unaccepted",
/******/ 						chain: chain,
/******/ 						moduleId: moduleId
/******/ 					};
/******/ 				}
/******/ 				for (var i = 0; i < module.parents.length; i++) {
/******/ 					var parentId = module.parents[i];
/******/ 					var parent = installedModules[parentId];
/******/ 					if (!parent) continue;
/******/ 					if (parent.hot._declinedDependencies[moduleId]) {
/******/ 						return {
/******/ 							type: "declined",
/******/ 							chain: chain.concat([parentId]),
/******/ 							moduleId: moduleId,
/******/ 							parentId: parentId
/******/ 						};
/******/ 					}
/******/ 					if (outdatedModules.includes(parentId)) continue;
/******/ 					if (parent.hot._acceptedDependencies[moduleId]) {
/******/ 						if (!outdatedDependencies[parentId])
/******/ 							outdatedDependencies[parentId] = [];
/******/ 						addAllToSet(outdatedDependencies[parentId], [moduleId]);
/******/ 						continue;
/******/ 					}
/******/ 					delete outdatedDependencies[parentId];
/******/ 					outdatedModules.push(parentId);
/******/ 					queue.push({
/******/ 						chain: chain.concat([parentId]),
/******/ 						id: parentId
/******/ 					});
/******/ 				}
/******/ 			}
/******/
/******/ 			return {
/******/ 				type: "accepted",
/******/ 				moduleId: updateModuleId,
/******/ 				outdatedModules: outdatedModules,
/******/ 				outdatedDependencies: outdatedDependencies
/******/ 			};
/******/ 		}
/******/
/******/ 		function addAllToSet(a, b) {
/******/ 			for (var i = 0; i < b.length; i++) {
/******/ 				var item = b[i];
/******/ 				if (!a.includes(item)) a.push(item);
/******/ 			}
/******/ 		}
/******/
/******/ 		// at begin all updates modules are outdated
/******/ 		// the "outdated" status can propagate to parents if they don't accept the children
/******/ 		var outdatedDependencies = {};
/******/ 		var outdatedModules = [];
/******/ 		var appliedUpdate = {};
/******/
/******/ 		var warnUnexpectedRequire = function warnUnexpectedRequire() {
/******/ 			console.warn(
/******/ 				"[HMR] unexpected require(" + result.moduleId + ") to disposed module"
/******/ 			);
/******/ 		};
/******/
/******/ 		for (var id in hotUpdate) {
/******/ 			if (Object.prototype.hasOwnProperty.call(hotUpdate, id)) {
/******/ 				moduleId = toModuleId(id);
/******/ 				var result;
/******/ 				if (hotUpdate[id]) {
/******/ 					result = getAffectedStuff(moduleId);
/******/ 				} else {
/******/ 					result = {
/******/ 						type: "disposed",
/******/ 						moduleId: id
/******/ 					};
/******/ 				}
/******/ 				var abortError = false;
/******/ 				var doApply = false;
/******/ 				var doDispose = false;
/******/ 				var chainInfo = "";
/******/ 				if (result.chain) {
/******/ 					chainInfo = "\nUpdate propagation: " + result.chain.join(" -> ");
/******/ 				}
/******/ 				switch (result.type) {
/******/ 					case "self-declined":
/******/ 						if (options.onDeclined) options.onDeclined(result);
/******/ 						if (!options.ignoreDeclined)
/******/ 							abortError = new Error(
/******/ 								"Aborted because of self decline: " +
/******/ 									result.moduleId +
/******/ 									chainInfo
/******/ 							);
/******/ 						break;
/******/ 					case "declined":
/******/ 						if (options.onDeclined) options.onDeclined(result);
/******/ 						if (!options.ignoreDeclined)
/******/ 							abortError = new Error(
/******/ 								"Aborted because of declined dependency: " +
/******/ 									result.moduleId +
/******/ 									" in " +
/******/ 									result.parentId +
/******/ 									chainInfo
/******/ 							);
/******/ 						break;
/******/ 					case "unaccepted":
/******/ 						if (options.onUnaccepted) options.onUnaccepted(result);
/******/ 						if (!options.ignoreUnaccepted)
/******/ 							abortError = new Error(
/******/ 								"Aborted because " + moduleId + " is not accepted" + chainInfo
/******/ 							);
/******/ 						break;
/******/ 					case "accepted":
/******/ 						if (options.onAccepted) options.onAccepted(result);
/******/ 						doApply = true;
/******/ 						break;
/******/ 					case "disposed":
/******/ 						if (options.onDisposed) options.onDisposed(result);
/******/ 						doDispose = true;
/******/ 						break;
/******/ 					default:
/******/ 						throw new Error("Unexception type " + result.type);
/******/ 				}
/******/ 				if (abortError) {
/******/ 					hotSetStatus("abort");
/******/ 					return Promise.reject(abortError);
/******/ 				}
/******/ 				if (doApply) {
/******/ 					appliedUpdate[moduleId] = hotUpdate[moduleId];
/******/ 					addAllToSet(outdatedModules, result.outdatedModules);
/******/ 					for (moduleId in result.outdatedDependencies) {
/******/ 						if (
/******/ 							Object.prototype.hasOwnProperty.call(
/******/ 								result.outdatedDependencies,
/******/ 								moduleId
/******/ 							)
/******/ 						) {
/******/ 							if (!outdatedDependencies[moduleId])
/******/ 								outdatedDependencies[moduleId] = [];
/******/ 							addAllToSet(
/******/ 								outdatedDependencies[moduleId],
/******/ 								result.outdatedDependencies[moduleId]
/******/ 							);
/******/ 						}
/******/ 					}
/******/ 				}
/******/ 				if (doDispose) {
/******/ 					addAllToSet(outdatedModules, [result.moduleId]);
/******/ 					appliedUpdate[moduleId] = warnUnexpectedRequire;
/******/ 				}
/******/ 			}
/******/ 		}
/******/
/******/ 		// Store self accepted outdated modules to require them later by the module system
/******/ 		var outdatedSelfAcceptedModules = [];
/******/ 		for (i = 0; i < outdatedModules.length; i++) {
/******/ 			moduleId = outdatedModules[i];
/******/ 			if (
/******/ 				installedModules[moduleId] &&
/******/ 				installedModules[moduleId].hot._selfAccepted
/******/ 			)
/******/ 				outdatedSelfAcceptedModules.push({
/******/ 					module: moduleId,
/******/ 					errorHandler: installedModules[moduleId].hot._selfAccepted
/******/ 				});
/******/ 		}
/******/
/******/ 		// Now in "dispose" phase
/******/ 		hotSetStatus("dispose");
/******/ 		Object.keys(hotAvailableFilesMap).forEach(function(chunkId) {
/******/ 			if (hotAvailableFilesMap[chunkId] === false) {
/******/ 				hotDisposeChunk(chunkId);
/******/ 			}
/******/ 		});
/******/
/******/ 		var idx;
/******/ 		var queue = outdatedModules.slice();
/******/ 		while (queue.length > 0) {
/******/ 			moduleId = queue.pop();
/******/ 			module = installedModules[moduleId];
/******/ 			if (!module) continue;
/******/
/******/ 			var data = {};
/******/
/******/ 			// Call dispose handlers
/******/ 			var disposeHandlers = module.hot._disposeHandlers;
/******/ 			for (j = 0; j < disposeHandlers.length; j++) {
/******/ 				cb = disposeHandlers[j];
/******/ 				cb(data);
/******/ 			}
/******/ 			hotCurrentModuleData[moduleId] = data;
/******/
/******/ 			// disable module (this disables requires from this module)
/******/ 			module.hot.active = false;
/******/
/******/ 			// remove module from cache
/******/ 			delete installedModules[moduleId];
/******/
/******/ 			// when disposing there is no need to call dispose handler
/******/ 			delete outdatedDependencies[moduleId];
/******/
/******/ 			// remove "parents" references from all children
/******/ 			for (j = 0; j < module.children.length; j++) {
/******/ 				var child = installedModules[module.children[j]];
/******/ 				if (!child) continue;
/******/ 				idx = child.parents.indexOf(moduleId);
/******/ 				if (idx >= 0) {
/******/ 					child.parents.splice(idx, 1);
/******/ 				}
/******/ 			}
/******/ 		}
/******/
/******/ 		// remove outdated dependency from module children
/******/ 		var dependency;
/******/ 		var moduleOutdatedDependencies;
/******/ 		for (moduleId in outdatedDependencies) {
/******/ 			if (
/******/ 				Object.prototype.hasOwnProperty.call(outdatedDependencies, moduleId)
/******/ 			) {
/******/ 				module = installedModules[moduleId];
/******/ 				if (module) {
/******/ 					moduleOutdatedDependencies = outdatedDependencies[moduleId];
/******/ 					for (j = 0; j < moduleOutdatedDependencies.length; j++) {
/******/ 						dependency = moduleOutdatedDependencies[j];
/******/ 						idx = module.children.indexOf(dependency);
/******/ 						if (idx >= 0) module.children.splice(idx, 1);
/******/ 					}
/******/ 				}
/******/ 			}
/******/ 		}
/******/
/******/ 		// Not in "apply" phase
/******/ 		hotSetStatus("apply");
/******/
/******/ 		hotCurrentHash = hotUpdateNewHash;
/******/
/******/ 		// insert new code
/******/ 		for (moduleId in appliedUpdate) {
/******/ 			if (Object.prototype.hasOwnProperty.call(appliedUpdate, moduleId)) {
/******/ 				modules[moduleId] = appliedUpdate[moduleId];
/******/ 			}
/******/ 		}
/******/
/******/ 		// call accept handlers
/******/ 		var error = null;
/******/ 		for (moduleId in outdatedDependencies) {
/******/ 			if (
/******/ 				Object.prototype.hasOwnProperty.call(outdatedDependencies, moduleId)
/******/ 			) {
/******/ 				module = installedModules[moduleId];
/******/ 				if (module) {
/******/ 					moduleOutdatedDependencies = outdatedDependencies[moduleId];
/******/ 					var callbacks = [];
/******/ 					for (i = 0; i < moduleOutdatedDependencies.length; i++) {
/******/ 						dependency = moduleOutdatedDependencies[i];
/******/ 						cb = module.hot._acceptedDependencies[dependency];
/******/ 						if (cb) {
/******/ 							if (callbacks.includes(cb)) continue;
/******/ 							callbacks.push(cb);
/******/ 						}
/******/ 					}
/******/ 					for (i = 0; i < callbacks.length; i++) {
/******/ 						cb = callbacks[i];
/******/ 						try {
/******/ 							cb(moduleOutdatedDependencies);
/******/ 						} catch (err) {
/******/ 							if (options.onErrored) {
/******/ 								options.onErrored({
/******/ 									type: "accept-errored",
/******/ 									moduleId: moduleId,
/******/ 									dependencyId: moduleOutdatedDependencies[i],
/******/ 									error: err
/******/ 								});
/******/ 							}
/******/ 							if (!options.ignoreErrored) {
/******/ 								if (!error) error = err;
/******/ 							}
/******/ 						}
/******/ 					}
/******/ 				}
/******/ 			}
/******/ 		}
/******/
/******/ 		// Load self accepted modules
/******/ 		for (i = 0; i < outdatedSelfAcceptedModules.length; i++) {
/******/ 			var item = outdatedSelfAcceptedModules[i];
/******/ 			moduleId = item.module;
/******/ 			hotCurrentParents = [moduleId];
/******/ 			try {
/******/ 				__webpack_require__(moduleId);
/******/ 			} catch (err) {
/******/ 				if (typeof item.errorHandler === "function") {
/******/ 					try {
/******/ 						item.errorHandler(err);
/******/ 					} catch (err2) {
/******/ 						if (options.onErrored) {
/******/ 							options.onErrored({
/******/ 								type: "self-accept-error-handler-errored",
/******/ 								moduleId: moduleId,
/******/ 								error: err2,
/******/ 								originalError: err
/******/ 							});
/******/ 						}
/******/ 						if (!options.ignoreErrored) {
/******/ 							if (!error) error = err2;
/******/ 						}
/******/ 						if (!error) error = err;
/******/ 					}
/******/ 				} else {
/******/ 					if (options.onErrored) {
/******/ 						options.onErrored({
/******/ 							type: "self-accept-errored",
/******/ 							moduleId: moduleId,
/******/ 							error: err
/******/ 						});
/******/ 					}
/******/ 					if (!options.ignoreErrored) {
/******/ 						if (!error) error = err;
/******/ 					}
/******/ 				}
/******/ 			}
/******/ 		}
/******/
/******/ 		// handle errors in accept handlers and self accepted module load
/******/ 		if (error) {
/******/ 			hotSetStatus("fail");
/******/ 			return Promise.reject(error);
/******/ 		}
/******/
/******/ 		hotSetStatus("idle");
/******/ 		return new Promise(function(resolve) {
/******/ 			resolve(outdatedModules);
/******/ 		});
/******/ 	}
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {},
/******/ 			hot: hotCreateModule(moduleId),
/******/ 			parents: (hotCurrentParentsTemp = hotCurrentParents, hotCurrentParents = [], hotCurrentParentsTemp),
/******/ 			children: []
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, hotCreateRequire(moduleId));
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/assets/";
/******/
/******/ 	// __webpack_hash__
/******/ 	__webpack_require__.h = function() { return hotCurrentHash; };
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return hotCreateRequire(374)(__webpack_require__.s = 374);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

  var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  * jQuery JavaScript Library v3.6.0
  * https://jquery.com/
  *
  * Includes Sizzle.js
  * https://sizzlejs.com/
  *
  * Copyright OpenJS Foundation and other contributors
  * Released under the MIT license
  * https://jquery.org/license
  *
  * Date: 2021-03-02T17:08Z
  */
 ( function( global, factory ) {

   "use strict";

   if ( typeof module === "object" && typeof module.exports === "object" ) {

     // For CommonJS and CommonJS-like environments where a proper `window`
     // is present, execute the factory and get jQuery.
     // For environments that do not have a `window` with a `document`
     // (such as Node.js), expose a factory as module.exports.
     // This accentuates the need for the creation of a real `window`.
     // e.g. var jQuery = require("jquery")(window);
     // See ticket #14549 for more info.
     module.exports = global.document ?
       factory( global, true ) :
       function( w ) {
         if ( !w.document ) {
           throw new Error( "jQuery requires a window with a document" );
         }
         return factory( w );
       };
   } else {
     factory( global );
   }

 // Pass this if window is not defined yet
 } )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

 // Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
 // throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
 // arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
 // enough that all such attempts are guarded in a try block.
 "use strict";

 var arr = [];

 var getProto = Object.getPrototypeOf;

 var slice = arr.slice;

 var flat = arr.flat ? function( array ) {
   return arr.flat.call( array );
 } : function( array ) {
   return arr.concat.apply( [], array );
 };


 var push = arr.push;

 var indexOf = arr.indexOf;

 var class2type = {};

 var toString = class2type.toString;

 var hasOwn = class2type.hasOwnProperty;

 var fnToString = hasOwn.toString;

 var ObjectFunctionString = fnToString.call( Object );

 var support = {};

 var isFunction = function isFunction( obj ) {

     // Support: Chrome <=57, Firefox <=52
     // In some browsers, typeof returns "function" for HTML <object> elements
     // (i.e., `typeof document.createElement( "object" ) === "function"`).
     // We don't want to classify *any* DOM node as a function.
     // Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
     // Plus for old WebKit, typeof returns "function" for HTML collections
     // (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
     return typeof obj === "function" && typeof obj.nodeType !== "number" &&
       typeof obj.item !== "function";
   };


 var isWindow = function isWindow( obj ) {
     return obj != null && obj === obj.window;
   };


 var document = window.document;



   var preservedScriptAttributes = {
     type: true,
     src: true,
     nonce: true,
     noModule: true
   };

   function DOMEval( code, node, doc ) {
     doc = doc || document;

     var i, val,
       script = doc.createElement( "script" );

     script.text = code;
     if ( node ) {
       for ( i in preservedScriptAttributes ) {

         // Support: Firefox 64+, Edge 18+
         // Some browsers don't support the "nonce" property on scripts.
         // On the other hand, just using `getAttribute` is not enough as
         // the `nonce` attribute is reset to an empty string whenever it
         // becomes browsing-context connected.
         // See https://github.com/whatwg/html/issues/2369
         // See https://html.spec.whatwg.org/#nonce-attributes
         // The `node.getAttribute` check was added for the sake of
         // `jQuery.globalEval` so that it can fake a nonce-containing node
         // via an object.
         val = node[ i ] || node.getAttribute && node.getAttribute( i );
         if ( val ) {
           script.setAttribute( i, val );
         }
       }
     }
     doc.head.appendChild( script ).parentNode.removeChild( script );
   }


 function toType( obj ) {
   if ( obj == null ) {
     return obj + "";
   }

   // Support: Android <=2.3 only (functionish RegExp)
   return typeof obj === "object" || typeof obj === "function" ?
     class2type[ toString.call( obj ) ] || "object" :
     typeof obj;
 }
 /* global Symbol */
 // Defining this global in .eslintrc.json would create a danger of using the global
 // unguarded in another place, it seems safer to define global only for this module



 var
   version = "3.6.0",

   // Define a local copy of jQuery
   jQuery = function( selector, context ) {

     // The jQuery object is actually just the init constructor 'enhanced'
     // Need init if jQuery is called (just allow error to be thrown if not included)
     return new jQuery.fn.init( selector, context );
   };

 jQuery.fn = jQuery.prototype = {

   // The current version of jQuery being used
   jquery: version,

   constructor: jQuery,

   // The default length of a jQuery object is 0
   length: 0,

   toArray: function() {
     return slice.call( this );
   },

   // Get the Nth element in the matched element set OR
   // Get the whole matched element set as a clean array
   get: function( num ) {

     // Return all the elements in a clean array
     if ( num == null ) {
       return slice.call( this );
     }

     // Return just the one element from the set
     return num < 0 ? this[ num + this.length ] : this[ num ];
   },

   // Take an array of elements and push it onto the stack
   // (returning the new matched element set)
   pushStack: function( elems ) {

     // Build a new jQuery matched element set
     var ret = jQuery.merge( this.constructor(), elems );

     // Add the old object onto the stack (as a reference)
     ret.prevObject = this;

     // Return the newly-formed element set
     return ret;
   },

   // Execute a callback for every element in the matched set.
   each: function( callback ) {
     return jQuery.each( this, callback );
   },

   map: function( callback ) {
     return this.pushStack( jQuery.map( this, function( elem, i ) {
       return callback.call( elem, i, elem );
     } ) );
   },

   slice: function() {
     return this.pushStack( slice.apply( this, arguments ) );
   },

   first: function() {
     return this.eq( 0 );
   },

   last: function() {
     return this.eq( -1 );
   },

   even: function() {
     return this.pushStack( jQuery.grep( this, function( _elem, i ) {
       return ( i + 1 ) % 2;
     } ) );
   },

   odd: function() {
     return this.pushStack( jQuery.grep( this, function( _elem, i ) {
       return i % 2;
     } ) );
   },

   eq: function( i ) {
     var len = this.length,
       j = +i + ( i < 0 ? len : 0 );
     return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
   },

   end: function() {
     return this.prevObject || this.constructor();
   },

   // For internal use only.
   // Behaves like an Array's method, not like a jQuery method.
   push: push,
   sort: arr.sort,
   splice: arr.splice
 };

 jQuery.extend = jQuery.fn.extend = function() {
   var options, name, src, copy, copyIsArray, clone,
     target = arguments[ 0 ] || {},
     i = 1,
     length = arguments.length,
     deep = false;

   // Handle a deep copy situation
   if ( typeof target === "boolean" ) {
     deep = target;

     // Skip the boolean and the target
     target = arguments[ i ] || {};
     i++;
   }

   // Handle case when target is a string or something (possible in deep copy)
   if ( typeof target !== "object" && !isFunction( target ) ) {
     target = {};
   }

   // Extend jQuery itself if only one argument is passed
   if ( i === length ) {
     target = this;
     i--;
   }

   for ( ; i < length; i++ ) {

     // Only deal with non-null/undefined values
     if ( ( options = arguments[ i ] ) != null ) {

       // Extend the base object
       for ( name in options ) {
         copy = options[ name ];

         // Prevent Object.prototype pollution
         // Prevent never-ending loop
         if ( name === "__proto__" || target === copy ) {
           continue;
         }

         // Recurse if we're merging plain objects or arrays
         if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
           ( copyIsArray = Array.isArray( copy ) ) ) ) {
           src = target[ name ];

           // Ensure proper type for the source value
           if ( copyIsArray && !Array.isArray( src ) ) {
             clone = [];
           } else if ( !copyIsArray && !jQuery.isPlainObject( src ) ) {
             clone = {};
           } else {
             clone = src;
           }
           copyIsArray = false;

           // Never move original objects, clone them
           target[ name ] = jQuery.extend( deep, clone, copy );

         // Don't bring in undefined values
         } else if ( copy !== undefined ) {
           target[ name ] = copy;
         }
       }
     }
   }

   // Return the modified object
   return target;
 };

 jQuery.extend( {

   // Unique for each copy of jQuery on the page
   expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

   // Assume jQuery is ready without the ready module
   isReady: true,

   error: function( msg ) {
     throw new Error( msg );
   },

   noop: function() {},

   isPlainObject: function( obj ) {
     var proto, Ctor;

     // Detect obvious negatives
     // Use toString instead of jQuery.type to catch host objects
     if ( !obj || toString.call( obj ) !== "[object Object]" ) {
       return false;
     }

     proto = getProto( obj );

     // Objects with no prototype (e.g., `Object.create( null )`) are plain
     if ( !proto ) {
       return true;
     }

     // Objects with prototype are plain iff they were constructed by a global Object function
     Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
     return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
   },

   isEmptyObject: function( obj ) {
     var name;

     for ( name in obj ) {
       return false;
     }
     return true;
   },

   // Evaluates a script in a provided context; falls back to the global one
   // if not specified.
   globalEval: function( code, options, doc ) {
     DOMEval( code, { nonce: options && options.nonce }, doc );
   },

   each: function( obj, callback ) {
     var length, i = 0;

     if ( isArrayLike( obj ) ) {
       length = obj.length;
       for ( ; i < length; i++ ) {
         if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
           break;
         }
       }
     } else {
       for ( i in obj ) {
         if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
           break;
         }
       }
     }

     return obj;
   },

   // results is for internal usage only
   makeArray: function( arr, results ) {
     var ret = results || [];

     if ( arr != null ) {
       if ( isArrayLike( Object( arr ) ) ) {
         jQuery.merge( ret,
           typeof arr === "string" ?
             [ arr ] : arr
         );
       } else {
         push.call( ret, arr );
       }
     }

     return ret;
   },

   inArray: function( elem, arr, i ) {
     return arr == null ? -1 : indexOf.call( arr, elem, i );
   },

   // Support: Android <=4.0 only, PhantomJS 1 only
   // push.apply(_, arraylike) throws on ancient WebKit
   merge: function( first, second ) {
     var len = +second.length,
       j = 0,
       i = first.length;

     for ( ; j < len; j++ ) {
       first[ i++ ] = second[ j ];
     }

     first.length = i;

     return first;
   },

   grep: function( elems, callback, invert ) {
     var callbackInverse,
       matches = [],
       i = 0,
       length = elems.length,
       callbackExpect = !invert;

     // Go through the array, only saving the items
     // that pass the validator function
     for ( ; i < length; i++ ) {
       callbackInverse = !callback( elems[ i ], i );
       if ( callbackInverse !== callbackExpect ) {
         matches.push( elems[ i ] );
       }
     }

     return matches;
   },

   // arg is for internal usage only
   map: function( elems, callback, arg ) {
     var length, value,
       i = 0,
       ret = [];

     // Go through the array, translating each of the items to their new values
     if ( isArrayLike( elems ) ) {
       length = elems.length;
       for ( ; i < length; i++ ) {
         value = callback( elems[ i ], i, arg );

         if ( value != null ) {
           ret.push( value );
         }
       }

     // Go through every key on the object,
     } else {
       for ( i in elems ) {
         value = callback( elems[ i ], i, arg );

         if ( value != null ) {
           ret.push( value );
         }
       }
     }

     // Flatten any nested arrays
     return flat( ret );
   },

   // A global GUID counter for objects
   guid: 1,

   // jQuery.support is not used in Core but other projects attach their
   // properties to it so it needs to exist.
   support: support
 } );

 if ( typeof Symbol === "function" ) {
   jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
 }

 // Populate the class2type map
 jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
   function( _i, name ) {
     class2type[ "[object " + name + "]" ] = name.toLowerCase();
   } );

 function isArrayLike( obj ) {

   // Support: real iOS 8.2 only (not reproducible in simulator)
   // `in` check used to prevent JIT error (gh-2145)
   // hasOwn isn't used here due to false negatives
   // regarding Nodelist length in IE
   var length = !!obj && "length" in obj && obj.length,
     type = toType( obj );

   if ( isFunction( obj ) || isWindow( obj ) ) {
     return false;
   }

   return type === "array" || length === 0 ||
     typeof length === "number" && length > 0 && ( length - 1 ) in obj;
 }
 var Sizzle =
 /*!
  * Sizzle CSS Selector Engine v2.3.6
  * https://sizzlejs.com/
  *
  * Copyright JS Foundation and other contributors
  * Released under the MIT license
  * https://js.foundation/
  *
  * Date: 2021-02-16
  */
 ( function( window ) {
 var i,
   support,
   Expr,
   getText,
   isXML,
   tokenize,
   compile,
   select,
   outermostContext,
   sortInput,
   hasDuplicate,

   // Local document vars
   setDocument,
   document,
   docElem,
   documentIsHTML,
   rbuggyQSA,
   rbuggyMatches,
   matches,
   contains,

   // Instance-specific data
   expando = "sizzle" + 1 * new Date(),
   preferredDoc = window.document,
   dirruns = 0,
   done = 0,
   classCache = createCache(),
   tokenCache = createCache(),
   compilerCache = createCache(),
   nonnativeSelectorCache = createCache(),
   sortOrder = function( a, b ) {
     if ( a === b ) {
       hasDuplicate = true;
     }
     return 0;
   },

   // Instance methods
   hasOwn = ( {} ).hasOwnProperty,
   arr = [],
   pop = arr.pop,
   pushNative = arr.push,
   push = arr.push,
   slice = arr.slice,

   // Use a stripped-down indexOf as it's faster than native
   // https://jsperf.com/thor-indexof-vs-for/5
   indexOf = function( list, elem ) {
     var i = 0,
       len = list.length;
     for ( ; i < len; i++ ) {
       if ( list[ i ] === elem ) {
         return i;
       }
     }
     return -1;
   },

   booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|" +
     "ismap|loop|multiple|open|readonly|required|scoped",

   // Regular expressions

   // http://www.w3.org/TR/css3-selectors/#whitespace
   whitespace = "[\\x20\\t\\r\\n\\f]",

   // https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
   identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace +
     "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",

   // Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
   attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +

     // Operator (capture 2)
     "*([*^$|!~]?=)" + whitespace +

     // "Attribute values must be CSS identifiers [capture 5]
     // or strings [capture 3 or capture 4]"
     "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" +
     whitespace + "*\\]",

   pseudos = ":(" + identifier + ")(?:\\((" +

     // To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
     // 1. quoted (capture 3; capture 4 or capture 5)
     "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +

     // 2. simple (capture 6)
     "((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +

     // 3. anything else (capture 2)
     ".*" +
     ")\\)|)",

   // Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
   rwhitespace = new RegExp( whitespace + "+", "g" ),
   rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" +
     whitespace + "+$", "g" ),

   rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
   rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace +
     "*" ),
   rdescend = new RegExp( whitespace + "|>" ),

   rpseudo = new RegExp( pseudos ),
   ridentifier = new RegExp( "^" + identifier + "$" ),

   matchExpr = {
     "ID": new RegExp( "^#(" + identifier + ")" ),
     "CLASS": new RegExp( "^\\.(" + identifier + ")" ),
     "TAG": new RegExp( "^(" + identifier + "|[*])" ),
     "ATTR": new RegExp( "^" + attributes ),
     "PSEUDO": new RegExp( "^" + pseudos ),
     "CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
       whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" +
       whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
     "bool": new RegExp( "^(?:" + booleans + ")$", "i" ),

     // For use in libraries implementing .is()
     // We use this for POS matching in `select`
     "needsContext": new RegExp( "^" + whitespace +
       "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace +
       "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
   },

   rhtml = /HTML$/i,
   rinputs = /^(?:input|select|textarea|button)$/i,
   rheader = /^h\d$/i,

   rnative = /^[^{]+\{\s*\[native \w/,

   // Easily-parseable/retrievable ID or TAG or CLASS selectors
   rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

   rsibling = /[+~]/,

   // CSS escapes
   // http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
   runescape = new RegExp( "\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g" ),
   funescape = function( escape, nonHex ) {
     var high = "0x" + escape.slice( 1 ) - 0x10000;

     return nonHex ?

       // Strip the backslash prefix from a non-hex escape sequence
       nonHex :

       // Replace a hexadecimal escape sequence with the encoded Unicode code point
       // Support: IE <=11+
       // For values outside the Basic Multilingual Plane (BMP), manually construct a
       // surrogate pair
       high < 0 ?
         String.fromCharCode( high + 0x10000 ) :
         String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
   },

   // CSS string/identifier serialization
   // https://drafts.csswg.org/cssom/#common-serializing-idioms
   rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
   fcssescape = function( ch, asCodePoint ) {
     if ( asCodePoint ) {

       // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
       if ( ch === "\0" ) {
         return "\uFFFD";
       }

       // Control characters and (dependent upon position) numbers get escaped as code points
       return ch.slice( 0, -1 ) + "\\" +
         ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
     }

     // Other potentially-special ASCII characters get backslash-escaped
     return "\\" + ch;
   },

   // Used for iframes
   // See setDocument()
   // Removing the function wrapper causes a "Permission Denied"
   // error in IE
   unloadHandler = function() {
     setDocument();
   },

   inDisabledFieldset = addCombinator(
     function( elem ) {
       return elem.disabled === true && elem.nodeName.toLowerCase() === "fieldset";
     },
     { dir: "parentNode", next: "legend" }
   );

 // Optimize for push.apply( _, NodeList )
 try {
   push.apply(
     ( arr = slice.call( preferredDoc.childNodes ) ),
     preferredDoc.childNodes
   );

   // Support: Android<4.0
   // Detect silently failing push.apply
   // eslint-disable-next-line no-unused-expressions
   arr[ preferredDoc.childNodes.length ].nodeType;
 } catch ( e ) {
   push = { apply: arr.length ?

     // Leverage slice if possible
     function( target, els ) {
       pushNative.apply( target, slice.call( els ) );
     } :

     // Support: IE<9
     // Otherwise append directly
     function( target, els ) {
       var j = target.length,
         i = 0;

       // Can't trust NodeList.length
       while ( ( target[ j++ ] = els[ i++ ] ) ) {}
       target.length = j - 1;
     }
   };
 }

 function Sizzle( selector, context, results, seed ) {
   var m, i, elem, nid, match, groups, newSelector,
     newContext = context && context.ownerDocument,

     // nodeType defaults to 9, since context defaults to document
     nodeType = context ? context.nodeType : 9;

   results = results || [];

   // Return early from calls with invalid selector or context
   if ( typeof selector !== "string" || !selector ||
     nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

     return results;
   }

   // Try to shortcut find operations (as opposed to filters) in HTML documents
   if ( !seed ) {
     setDocument( context );
     context = context || document;

     if ( documentIsHTML ) {

       // If the selector is sufficiently simple, try using a "get*By*" DOM method
       // (excepting DocumentFragment context, where the methods don't exist)
       if ( nodeType !== 11 && ( match = rquickExpr.exec( selector ) ) ) {

         // ID selector
         if ( ( m = match[ 1 ] ) ) {

           // Document context
           if ( nodeType === 9 ) {
             if ( ( elem = context.getElementById( m ) ) ) {

               // Support: IE, Opera, Webkit
               // TODO: identify versions
               // getElementById can match elements by name instead of ID
               if ( elem.id === m ) {
                 results.push( elem );
                 return results;
               }
             } else {
               return results;
             }

           // Element context
           } else {

             // Support: IE, Opera, Webkit
             // TODO: identify versions
             // getElementById can match elements by name instead of ID
             if ( newContext && ( elem = newContext.getElementById( m ) ) &&
               contains( context, elem ) &&
               elem.id === m ) {

               results.push( elem );
               return results;
             }
           }

         // Type selector
         } else if ( match[ 2 ] ) {
           push.apply( results, context.getElementsByTagName( selector ) );
           return results;

         // Class selector
         } else if ( ( m = match[ 3 ] ) && support.getElementsByClassName &&
           context.getElementsByClassName ) {

           push.apply( results, context.getElementsByClassName( m ) );
           return results;
         }
       }

       // Take advantage of querySelectorAll
       if ( support.qsa &&
         !nonnativeSelectorCache[ selector + " " ] &&
         ( !rbuggyQSA || !rbuggyQSA.test( selector ) ) &&

         // Support: IE 8 only
         // Exclude object elements
         ( nodeType !== 1 || context.nodeName.toLowerCase() !== "object" ) ) {

         newSelector = selector;
         newContext = context;

         // qSA considers elements outside a scoping root when evaluating child or
         // descendant combinators, which is not what we want.
         // In such cases, we work around the behavior by prefixing every selector in the
         // list with an ID selector referencing the scope context.
         // The technique has to be used as well when a leading combinator is used
         // as such selectors are not recognized by querySelectorAll.
         // Thanks to Andrew Dupont for this technique.
         if ( nodeType === 1 &&
           ( rdescend.test( selector ) || rcombinators.test( selector ) ) ) {

           // Expand context for sibling selectors
           newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
             context;

           // We can use :scope instead of the ID hack if the browser
           // supports it & if we're not changing the context.
           if ( newContext !== context || !support.scope ) {

             // Capture the context ID, setting it first if necessary
             if ( ( nid = context.getAttribute( "id" ) ) ) {
               nid = nid.replace( rcssescape, fcssescape );
             } else {
               context.setAttribute( "id", ( nid = expando ) );
             }
           }

           // Prefix every selector in the list
           groups = tokenize( selector );
           i = groups.length;
           while ( i-- ) {
             groups[ i ] = ( nid ? "#" + nid : ":scope" ) + " " +
               toSelector( groups[ i ] );
           }
           newSelector = groups.join( "," );
         }

         try {
           push.apply( results,
             newContext.querySelectorAll( newSelector )
           );
           return results;
         } catch ( qsaError ) {
           nonnativeSelectorCache( selector, true );
         } finally {
           if ( nid === expando ) {
             context.removeAttribute( "id" );
           }
         }
       }
     }
   }

   // All others
   return select( selector.replace( rtrim, "$1" ), context, results, seed );
 }

 /**
  * Create key-value caches of limited size
  * @returns {function(string, object)} Returns the Object data after storing it on itself with
  *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
  *	deleting the oldest entry
  */
 function createCache() {
   var keys = [];

   function cache( key, value ) {

     // Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
     if ( keys.push( key + " " ) > Expr.cacheLength ) {

       // Only keep the most recent entries
       delete cache[ keys.shift() ];
     }
     return ( cache[ key + " " ] = value );
   }
   return cache;
 }

 /**
  * Mark a function for special use by Sizzle
  * @param {Function} fn The function to mark
  */
 function markFunction( fn ) {
   fn[ expando ] = true;
   return fn;
 }

 /**
  * Support testing using an element
  * @param {Function} fn Passed the created element and returns a boolean result
  */
 function assert( fn ) {
   var el = document.createElement( "fieldset" );

   try {
     return !!fn( el );
   } catch ( e ) {
     return false;
   } finally {

     // Remove from its parent by default
     if ( el.parentNode ) {
       el.parentNode.removeChild( el );
     }

     // release memory in IE
     el = null;
   }
 }

 /**
  * Adds the same handler for all of the specified attrs
  * @param {String} attrs Pipe-separated list of attributes
  * @param {Function} handler The method that will be applied
  */
 function addHandle( attrs, handler ) {
   var arr = attrs.split( "|" ),
     i = arr.length;

   while ( i-- ) {
     Expr.attrHandle[ arr[ i ] ] = handler;
   }
 }

 /**
  * Checks document order of two siblings
  * @param {Element} a
  * @param {Element} b
  * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
  */
 function siblingCheck( a, b ) {
   var cur = b && a,
     diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
       a.sourceIndex - b.sourceIndex;

   // Use IE sourceIndex if available on both nodes
   if ( diff ) {
     return diff;
   }

   // Check if b follows a
   if ( cur ) {
     while ( ( cur = cur.nextSibling ) ) {
       if ( cur === b ) {
         return -1;
       }
     }
   }

   return a ? 1 : -1;
 }

 /**
  * Returns a function to use in pseudos for input types
  * @param {String} type
  */
 function createInputPseudo( type ) {
   return function( elem ) {
     var name = elem.nodeName.toLowerCase();
     return name === "input" && elem.type === type;
   };
 }

 /**
  * Returns a function to use in pseudos for buttons
  * @param {String} type
  */
 function createButtonPseudo( type ) {
   return function( elem ) {
     var name = elem.nodeName.toLowerCase();
     return ( name === "input" || name === "button" ) && elem.type === type;
   };
 }

 /**
  * Returns a function to use in pseudos for :enabled/:disabled
  * @param {Boolean} disabled true for :disabled; false for :enabled
  */
 function createDisabledPseudo( disabled ) {

   // Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
   return function( elem ) {

     // Only certain elements can match :enabled or :disabled
     // https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
     // https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
     if ( "form" in elem ) {

       // Check for inherited disabledness on relevant non-disabled elements:
       // * listed form-associated elements in a disabled fieldset
       //   https://html.spec.whatwg.org/multipage/forms.html#category-listed
       //   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
       // * option elements in a disabled optgroup
       //   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
       // All such elements have a "form" property.
       if ( elem.parentNode && elem.disabled === false ) {

         // Option elements defer to a parent optgroup if present
         if ( "label" in elem ) {
           if ( "label" in elem.parentNode ) {
             return elem.parentNode.disabled === disabled;
           } else {
             return elem.disabled === disabled;
           }
         }

         // Support: IE 6 - 11
         // Use the isDisabled shortcut property to check for disabled fieldset ancestors
         return elem.isDisabled === disabled ||

           // Where there is no isDisabled, check manually
           /* jshint -W018 */
           elem.isDisabled !== !disabled &&
           inDisabledFieldset( elem ) === disabled;
       }

       return elem.disabled === disabled;

     // Try to winnow out elements that can't be disabled before trusting the disabled property.
     // Some victims get caught in our net (label, legend, menu, track), but it shouldn't
     // even exist on them, let alone have a boolean value.
     } else if ( "label" in elem ) {
       return elem.disabled === disabled;
     }

     // Remaining elements are neither :enabled nor :disabled
     return false;
   };
 }

 /**
  * Returns a function to use in pseudos for positionals
  * @param {Function} fn
  */
 function createPositionalPseudo( fn ) {
   return markFunction( function( argument ) {
     argument = +argument;
     return markFunction( function( seed, matches ) {
       var j,
         matchIndexes = fn( [], seed.length, argument ),
         i = matchIndexes.length;

       // Match elements found at the specified indexes
       while ( i-- ) {
         if ( seed[ ( j = matchIndexes[ i ] ) ] ) {
           seed[ j ] = !( matches[ j ] = seed[ j ] );
         }
       }
     } );
   } );
 }

 /**
  * Checks a node for validity as a Sizzle context
  * @param {Element|Object=} context
  * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
  */
 function testContext( context ) {
   return context && typeof context.getElementsByTagName !== "undefined" && context;
 }

 // Expose support vars for convenience
 support = Sizzle.support = {};

 /**
  * Detects XML nodes
  * @param {Element|Object} elem An element or a document
  * @returns {Boolean} True iff elem is a non-HTML XML node
  */
 isXML = Sizzle.isXML = function( elem ) {
   var namespace = elem && elem.namespaceURI,
     docElem = elem && ( elem.ownerDocument || elem ).documentElement;

   // Support: IE <=8
   // Assume HTML when documentElement doesn't yet exist, such as inside loading iframes
   // https://bugs.jquery.com/ticket/4833
   return !rhtml.test( namespace || docElem && docElem.nodeName || "HTML" );
 };

 /**
  * Sets document-related variables once based on the current document
  * @param {Element|Object} [doc] An element or document object to use to set the document
  * @returns {Object} Returns the current document
  */
 setDocument = Sizzle.setDocument = function( node ) {
   var hasCompare, subWindow,
     doc = node ? node.ownerDocument || node : preferredDoc;

   // Return early if doc is invalid or already selected
   // Support: IE 11+, Edge 17 - 18+
   // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
   // two documents; shallow comparisons work.
   // eslint-disable-next-line eqeqeq
   if ( doc == document || doc.nodeType !== 9 || !doc.documentElement ) {
     return document;
   }

   // Update global variables
   document = doc;
   docElem = document.documentElement;
   documentIsHTML = !isXML( document );

   // Support: IE 9 - 11+, Edge 12 - 18+
   // Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
   // Support: IE 11+, Edge 17 - 18+
   // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
   // two documents; shallow comparisons work.
   // eslint-disable-next-line eqeqeq
   if ( preferredDoc != document &&
     ( subWindow = document.defaultView ) && subWindow.top !== subWindow ) {

     // Support: IE 11, Edge
     if ( subWindow.addEventListener ) {
       subWindow.addEventListener( "unload", unloadHandler, false );

     // Support: IE 9 - 10 only
     } else if ( subWindow.attachEvent ) {
       subWindow.attachEvent( "onunload", unloadHandler );
     }
   }

   // Support: IE 8 - 11+, Edge 12 - 18+, Chrome <=16 - 25 only, Firefox <=3.6 - 31 only,
   // Safari 4 - 5 only, Opera <=11.6 - 12.x only
   // IE/Edge & older browsers don't support the :scope pseudo-class.
   // Support: Safari 6.0 only
   // Safari 6.0 supports :scope but it's an alias of :root there.
   support.scope = assert( function( el ) {
     docElem.appendChild( el ).appendChild( document.createElement( "div" ) );
     return typeof el.querySelectorAll !== "undefined" &&
       !el.querySelectorAll( ":scope fieldset div" ).length;
   } );

   /* Attributes
   ---------------------------------------------------------------------- */

   // Support: IE<8
   // Verify that getAttribute really returns attributes and not properties
   // (excepting IE8 booleans)
   support.attributes = assert( function( el ) {
     el.className = "i";
     return !el.getAttribute( "className" );
   } );

   /* getElement(s)By*
   ---------------------------------------------------------------------- */

   // Check if getElementsByTagName("*") returns only elements
   support.getElementsByTagName = assert( function( el ) {
     el.appendChild( document.createComment( "" ) );
     return !el.getElementsByTagName( "*" ).length;
   } );

   // Support: IE<9
   support.getElementsByClassName = rnative.test( document.getElementsByClassName );

   // Support: IE<10
   // Check if getElementById returns elements by name
   // The broken getElementById methods don't pick up programmatically-set names,
   // so use a roundabout getElementsByName test
   support.getById = assert( function( el ) {
     docElem.appendChild( el ).id = expando;
     return !document.getElementsByName || !document.getElementsByName( expando ).length;
   } );

   // ID filter and find
   if ( support.getById ) {
     Expr.filter[ "ID" ] = function( id ) {
       var attrId = id.replace( runescape, funescape );
       return function( elem ) {
         return elem.getAttribute( "id" ) === attrId;
       };
     };
     Expr.find[ "ID" ] = function( id, context ) {
       if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
         var elem = context.getElementById( id );
         return elem ? [ elem ] : [];
       }
     };
   } else {
     Expr.filter[ "ID" ] =  function( id ) {
       var attrId = id.replace( runescape, funescape );
       return function( elem ) {
         var node = typeof elem.getAttributeNode !== "undefined" &&
           elem.getAttributeNode( "id" );
         return node && node.value === attrId;
       };
     };

     // Support: IE 6 - 7 only
     // getElementById is not reliable as a find shortcut
     Expr.find[ "ID" ] = function( id, context ) {
       if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
         var node, i, elems,
           elem = context.getElementById( id );

         if ( elem ) {

           // Verify the id attribute
           node = elem.getAttributeNode( "id" );
           if ( node && node.value === id ) {
             return [ elem ];
           }

           // Fall back on getElementsByName
           elems = context.getElementsByName( id );
           i = 0;
           while ( ( elem = elems[ i++ ] ) ) {
             node = elem.getAttributeNode( "id" );
             if ( node && node.value === id ) {
               return [ elem ];
             }
           }
         }

         return [];
       }
     };
   }

   // Tag
   Expr.find[ "TAG" ] = support.getElementsByTagName ?
     function( tag, context ) {
       if ( typeof context.getElementsByTagName !== "undefined" ) {
         return context.getElementsByTagName( tag );

       // DocumentFragment nodes don't have gEBTN
       } else if ( support.qsa ) {
         return context.querySelectorAll( tag );
       }
     } :

     function( tag, context ) {
       var elem,
         tmp = [],
         i = 0,

         // By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
         results = context.getElementsByTagName( tag );

       // Filter out possible comments
       if ( tag === "*" ) {
         while ( ( elem = results[ i++ ] ) ) {
           if ( elem.nodeType === 1 ) {
             tmp.push( elem );
           }
         }

         return tmp;
       }
       return results;
     };

   // Class
   Expr.find[ "CLASS" ] = support.getElementsByClassName && function( className, context ) {
     if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
       return context.getElementsByClassName( className );
     }
   };

   /* QSA/matchesSelector
   ---------------------------------------------------------------------- */

   // QSA and matchesSelector support

   // matchesSelector(:active) reports false when true (IE9/Opera 11.5)
   rbuggyMatches = [];

   // qSa(:focus) reports false when true (Chrome 21)
   // We allow this because of a bug in IE8/9 that throws an error
   // whenever `document.activeElement` is accessed on an iframe
   // So, we allow :focus to pass through QSA all the time to avoid the IE error
   // See https://bugs.jquery.com/ticket/13378
   rbuggyQSA = [];

   if ( ( support.qsa = rnative.test( document.querySelectorAll ) ) ) {

     // Build QSA regex
     // Regex strategy adopted from Diego Perini
     assert( function( el ) {

       var input;

       // Select is set to empty string on purpose
       // This is to test IE's treatment of not explicitly
       // setting a boolean content attribute,
       // since its presence should be enough
       // https://bugs.jquery.com/ticket/12359
       docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
         "<select id='" + expando + "-\r\\' msallowcapture=''>" +
         "<option selected=''></option></select>";

       // Support: IE8, Opera 11-12.16
       // Nothing should be selected when empty strings follow ^= or $= or *=
       // The test attribute must be unknown in Opera but "safe" for WinRT
       // https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
       if ( el.querySelectorAll( "[msallowcapture^='']" ).length ) {
         rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
       }

       // Support: IE8
       // Boolean attributes and "value" are not treated correctly
       if ( !el.querySelectorAll( "[selected]" ).length ) {
         rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
       }

       // Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
       if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
         rbuggyQSA.push( "~=" );
       }

       // Support: IE 11+, Edge 15 - 18+
       // IE 11/Edge don't find elements on a `[name='']` query in some cases.
       // Adding a temporary attribute to the document before the selection works
       // around the issue.
       // Interestingly, IE 10 & older don't seem to have the issue.
       input = document.createElement( "input" );
       input.setAttribute( "name", "" );
       el.appendChild( input );
       if ( !el.querySelectorAll( "[name='']" ).length ) {
         rbuggyQSA.push( "\\[" + whitespace + "*name" + whitespace + "*=" +
           whitespace + "*(?:''|\"\")" );
       }

       // Webkit/Opera - :checked should return selected option elements
       // http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
       // IE8 throws error here and will not see later tests
       if ( !el.querySelectorAll( ":checked" ).length ) {
         rbuggyQSA.push( ":checked" );
       }

       // Support: Safari 8+, iOS 8+
       // https://bugs.webkit.org/show_bug.cgi?id=136851
       // In-page `selector#id sibling-combinator selector` fails
       if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
         rbuggyQSA.push( ".#.+[+~]" );
       }

       // Support: Firefox <=3.6 - 5 only
       // Old Firefox doesn't throw on a badly-escaped identifier.
       el.querySelectorAll( "\\\f" );
       rbuggyQSA.push( "[\\r\\n\\f]" );
     } );

     assert( function( el ) {
       el.innerHTML = "<a href='' disabled='disabled'></a>" +
         "<select disabled='disabled'><option/></select>";

       // Support: Windows 8 Native Apps
       // The type and name attributes are restricted during .innerHTML assignment
       var input = document.createElement( "input" );
       input.setAttribute( "type", "hidden" );
       el.appendChild( input ).setAttribute( "name", "D" );

       // Support: IE8
       // Enforce case-sensitivity of name attribute
       if ( el.querySelectorAll( "[name=d]" ).length ) {
         rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
       }

       // FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
       // IE8 throws error here and will not see later tests
       if ( el.querySelectorAll( ":enabled" ).length !== 2 ) {
         rbuggyQSA.push( ":enabled", ":disabled" );
       }

       // Support: IE9-11+
       // IE's :disabled selector does not pick up the children of disabled fieldsets
       docElem.appendChild( el ).disabled = true;
       if ( el.querySelectorAll( ":disabled" ).length !== 2 ) {
         rbuggyQSA.push( ":enabled", ":disabled" );
       }

       // Support: Opera 10 - 11 only
       // Opera 10-11 does not throw on post-comma invalid pseudos
       el.querySelectorAll( "*,:x" );
       rbuggyQSA.push( ",.*:" );
     } );
   }

   if ( ( support.matchesSelector = rnative.test( ( matches = docElem.matches ||
     docElem.webkitMatchesSelector ||
     docElem.mozMatchesSelector ||
     docElem.oMatchesSelector ||
     docElem.msMatchesSelector ) ) ) ) {

     assert( function( el ) {

       // Check to see if it's possible to do matchesSelector
       // on a disconnected node (IE 9)
       support.disconnectedMatch = matches.call( el, "*" );

       // This should fail with an exception
       // Gecko does not error, returns false instead
       matches.call( el, "[s!='']:x" );
       rbuggyMatches.push( "!=", pseudos );
     } );
   }

   rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join( "|" ) );
   rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join( "|" ) );

   /* Contains
   ---------------------------------------------------------------------- */
   hasCompare = rnative.test( docElem.compareDocumentPosition );

   // Element contains another
   // Purposefully self-exclusive
   // As in, an element does not contain itself
   contains = hasCompare || rnative.test( docElem.contains ) ?
     function( a, b ) {
       var adown = a.nodeType === 9 ? a.documentElement : a,
         bup = b && b.parentNode;
       return a === bup || !!( bup && bup.nodeType === 1 && (
         adown.contains ?
           adown.contains( bup ) :
           a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
       ) );
     } :
     function( a, b ) {
       if ( b ) {
         while ( ( b = b.parentNode ) ) {
           if ( b === a ) {
             return true;
           }
         }
       }
       return false;
     };

   /* Sorting
   ---------------------------------------------------------------------- */

   // Document order sorting
   sortOrder = hasCompare ?
   function( a, b ) {

     // Flag for duplicate removal
     if ( a === b ) {
       hasDuplicate = true;
       return 0;
     }

     // Sort on method existence if only one input has compareDocumentPosition
     var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
     if ( compare ) {
       return compare;
     }

     // Calculate position if both inputs belong to the same document
     // Support: IE 11+, Edge 17 - 18+
     // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
     // two documents; shallow comparisons work.
     // eslint-disable-next-line eqeqeq
     compare = ( a.ownerDocument || a ) == ( b.ownerDocument || b ) ?
       a.compareDocumentPosition( b ) :

       // Otherwise we know they are disconnected
       1;

     // Disconnected nodes
     if ( compare & 1 ||
       ( !support.sortDetached && b.compareDocumentPosition( a ) === compare ) ) {

       // Choose the first element that is related to our preferred document
       // Support: IE 11+, Edge 17 - 18+
       // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
       // two documents; shallow comparisons work.
       // eslint-disable-next-line eqeqeq
       if ( a == document || a.ownerDocument == preferredDoc &&
         contains( preferredDoc, a ) ) {
         return -1;
       }

       // Support: IE 11+, Edge 17 - 18+
       // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
       // two documents; shallow comparisons work.
       // eslint-disable-next-line eqeqeq
       if ( b == document || b.ownerDocument == preferredDoc &&
         contains( preferredDoc, b ) ) {
         return 1;
       }

       // Maintain original order
       return sortInput ?
         ( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
         0;
     }

     return compare & 4 ? -1 : 1;
   } :
   function( a, b ) {

     // Exit early if the nodes are identical
     if ( a === b ) {
       hasDuplicate = true;
       return 0;
     }

     var cur,
       i = 0,
       aup = a.parentNode,
       bup = b.parentNode,
       ap = [ a ],
       bp = [ b ];

     // Parentless nodes are either documents or disconnected
     if ( !aup || !bup ) {

       // Support: IE 11+, Edge 17 - 18+
       // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
       // two documents; shallow comparisons work.
       /* eslint-disable eqeqeq */
       return a == document ? -1 :
         b == document ? 1 :
         /* eslint-enable eqeqeq */
         aup ? -1 :
         bup ? 1 :
         sortInput ?
         ( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
         0;

     // If the nodes are siblings, we can do a quick check
     } else if ( aup === bup ) {
       return siblingCheck( a, b );
     }

     // Otherwise we need full lists of their ancestors for comparison
     cur = a;
     while ( ( cur = cur.parentNode ) ) {
       ap.unshift( cur );
     }
     cur = b;
     while ( ( cur = cur.parentNode ) ) {
       bp.unshift( cur );
     }

     // Walk down the tree looking for a discrepancy
     while ( ap[ i ] === bp[ i ] ) {
       i++;
     }

     return i ?

       // Do a sibling check if the nodes have a common ancestor
       siblingCheck( ap[ i ], bp[ i ] ) :

       // Otherwise nodes in our document sort first
       // Support: IE 11+, Edge 17 - 18+
       // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
       // two documents; shallow comparisons work.
       /* eslint-disable eqeqeq */
       ap[ i ] == preferredDoc ? -1 :
       bp[ i ] == preferredDoc ? 1 :
       /* eslint-enable eqeqeq */
       0;
   };

   return document;
 };

 Sizzle.matches = function( expr, elements ) {
   return Sizzle( expr, null, null, elements );
 };

 Sizzle.matchesSelector = function( elem, expr ) {
   setDocument( elem );

   if ( support.matchesSelector && documentIsHTML &&
     !nonnativeSelectorCache[ expr + " " ] &&
     ( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
     ( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

     try {
       var ret = matches.call( elem, expr );

       // IE 9's matchesSelector returns false on disconnected nodes
       if ( ret || support.disconnectedMatch ||

         // As well, disconnected nodes are said to be in a document
         // fragment in IE 9
         elem.document && elem.document.nodeType !== 11 ) {
         return ret;
       }
     } catch ( e ) {
       nonnativeSelectorCache( expr, true );
     }
   }

   return Sizzle( expr, document, null, [ elem ] ).length > 0;
 };

 Sizzle.contains = function( context, elem ) {

   // Set document vars if needed
   // Support: IE 11+, Edge 17 - 18+
   // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
   // two documents; shallow comparisons work.
   // eslint-disable-next-line eqeqeq
   if ( ( context.ownerDocument || context ) != document ) {
     setDocument( context );
   }
   return contains( context, elem );
 };

 Sizzle.attr = function( elem, name ) {

   // Set document vars if needed
   // Support: IE 11+, Edge 17 - 18+
   // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
   // two documents; shallow comparisons work.
   // eslint-disable-next-line eqeqeq
   if ( ( elem.ownerDocument || elem ) != document ) {
     setDocument( elem );
   }

   var fn = Expr.attrHandle[ name.toLowerCase() ],

     // Don't get fooled by Object.prototype properties (jQuery #13807)
     val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
       fn( elem, name, !documentIsHTML ) :
       undefined;

   return val !== undefined ?
     val :
     support.attributes || !documentIsHTML ?
       elem.getAttribute( name ) :
       ( val = elem.getAttributeNode( name ) ) && val.specified ?
         val.value :
         null;
 };

 Sizzle.escape = function( sel ) {
   return ( sel + "" ).replace( rcssescape, fcssescape );
 };

 Sizzle.error = function( msg ) {
   throw new Error( "Syntax error, unrecognized expression: " + msg );
 };

 /**
  * Document sorting and removing duplicates
  * @param {ArrayLike} results
  */
 Sizzle.uniqueSort = function( results ) {
   var elem,
     duplicates = [],
     j = 0,
     i = 0;

   // Unless we *know* we can detect duplicates, assume their presence
   hasDuplicate = !support.detectDuplicates;
   sortInput = !support.sortStable && results.slice( 0 );
   results.sort( sortOrder );

   if ( hasDuplicate ) {
     while ( ( elem = results[ i++ ] ) ) {
       if ( elem === results[ i ] ) {
         j = duplicates.push( i );
       }
     }
     while ( j-- ) {
       results.splice( duplicates[ j ], 1 );
     }
   }

   // Clear input after sorting to release objects
   // See https://github.com/jquery/sizzle/pull/225
   sortInput = null;

   return results;
 };

 /**
  * Utility function for retrieving the text value of an array of DOM nodes
  * @param {Array|Element} elem
  */
 getText = Sizzle.getText = function( elem ) {
   var node,
     ret = "",
     i = 0,
     nodeType = elem.nodeType;

   if ( !nodeType ) {

     // If no nodeType, this is expected to be an array
     while ( ( node = elem[ i++ ] ) ) {

       // Do not traverse comment nodes
       ret += getText( node );
     }
   } else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {

     // Use textContent for elements
     // innerText usage removed for consistency of new lines (jQuery #11153)
     if ( typeof elem.textContent === "string" ) {
       return elem.textContent;
     } else {

       // Traverse its children
       for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
         ret += getText( elem );
       }
     }
   } else if ( nodeType === 3 || nodeType === 4 ) {
     return elem.nodeValue;
   }

   // Do not include comment or processing instruction nodes

   return ret;
 };

 Expr = Sizzle.selectors = {

   // Can be adjusted by the user
   cacheLength: 50,

   createPseudo: markFunction,

   match: matchExpr,

   attrHandle: {},

   find: {},

   relative: {
     ">": { dir: "parentNode", first: true },
     " ": { dir: "parentNode" },
     "+": { dir: "previousSibling", first: true },
     "~": { dir: "previousSibling" }
   },

   preFilter: {
     "ATTR": function( match ) {
       match[ 1 ] = match[ 1 ].replace( runescape, funescape );

       // Move the given value to match[3] whether quoted or unquoted
       match[ 3 ] = ( match[ 3 ] || match[ 4 ] ||
         match[ 5 ] || "" ).replace( runescape, funescape );

       if ( match[ 2 ] === "~=" ) {
         match[ 3 ] = " " + match[ 3 ] + " ";
       }

       return match.slice( 0, 4 );
     },

     "CHILD": function( match ) {

       /* matches from matchExpr["CHILD"]
         1 type (only|nth|...)
         2 what (child|of-type)
         3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
         4 xn-component of xn+y argument ([+-]?\d*n|)
         5 sign of xn-component
         6 x of xn-component
         7 sign of y-component
         8 y of y-component
       */
       match[ 1 ] = match[ 1 ].toLowerCase();

       if ( match[ 1 ].slice( 0, 3 ) === "nth" ) {

         // nth-* requires argument
         if ( !match[ 3 ] ) {
           Sizzle.error( match[ 0 ] );
         }

         // numeric x and y parameters for Expr.filter.CHILD
         // remember that false/true cast respectively to 0/1
         match[ 4 ] = +( match[ 4 ] ?
           match[ 5 ] + ( match[ 6 ] || 1 ) :
           2 * ( match[ 3 ] === "even" || match[ 3 ] === "odd" ) );
         match[ 5 ] = +( ( match[ 7 ] + match[ 8 ] ) || match[ 3 ] === "odd" );

         // other types prohibit arguments
       } else if ( match[ 3 ] ) {
         Sizzle.error( match[ 0 ] );
       }

       return match;
     },

     "PSEUDO": function( match ) {
       var excess,
         unquoted = !match[ 6 ] && match[ 2 ];

       if ( matchExpr[ "CHILD" ].test( match[ 0 ] ) ) {
         return null;
       }

       // Accept quoted arguments as-is
       if ( match[ 3 ] ) {
         match[ 2 ] = match[ 4 ] || match[ 5 ] || "";

       // Strip excess characters from unquoted arguments
       } else if ( unquoted && rpseudo.test( unquoted ) &&

         // Get excess from tokenize (recursively)
         ( excess = tokenize( unquoted, true ) ) &&

         // advance to the next closing parenthesis
         ( excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length ) ) {

         // excess is a negative index
         match[ 0 ] = match[ 0 ].slice( 0, excess );
         match[ 2 ] = unquoted.slice( 0, excess );
       }

       // Return only captures needed by the pseudo filter method (type and argument)
       return match.slice( 0, 3 );
     }
   },

   filter: {

     "TAG": function( nodeNameSelector ) {
       var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
       return nodeNameSelector === "*" ?
         function() {
           return true;
         } :
         function( elem ) {
           return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
         };
     },

     "CLASS": function( className ) {
       var pattern = classCache[ className + " " ];

       return pattern ||
         ( pattern = new RegExp( "(^|" + whitespace +
           ")" + className + "(" + whitespace + "|$)" ) ) && classCache(
             className, function( elem ) {
               return pattern.test(
                 typeof elem.className === "string" && elem.className ||
                 typeof elem.getAttribute !== "undefined" &&
                   elem.getAttribute( "class" ) ||
                 ""
               );
         } );
     },

     "ATTR": function( name, operator, check ) {
       return function( elem ) {
         var result = Sizzle.attr( elem, name );

         if ( result == null ) {
           return operator === "!=";
         }
         if ( !operator ) {
           return true;
         }

         result += "";

         /* eslint-disable max-len */

         return operator === "=" ? result === check :
           operator === "!=" ? result !== check :
           operator === "^=" ? check && result.indexOf( check ) === 0 :
           operator === "*=" ? check && result.indexOf( check ) > -1 :
           operator === "$=" ? check && result.slice( -check.length ) === check :
           operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
           operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
           false;
         /* eslint-enable max-len */

       };
     },

     "CHILD": function( type, what, _argument, first, last ) {
       var simple = type.slice( 0, 3 ) !== "nth",
         forward = type.slice( -4 ) !== "last",
         ofType = what === "of-type";

       return first === 1 && last === 0 ?

         // Shortcut for :nth-*(n)
         function( elem ) {
           return !!elem.parentNode;
         } :

         function( elem, _context, xml ) {
           var cache, uniqueCache, outerCache, node, nodeIndex, start,
             dir = simple !== forward ? "nextSibling" : "previousSibling",
             parent = elem.parentNode,
             name = ofType && elem.nodeName.toLowerCase(),
             useCache = !xml && !ofType,
             diff = false;

           if ( parent ) {

             // :(first|last|only)-(child|of-type)
             if ( simple ) {
               while ( dir ) {
                 node = elem;
                 while ( ( node = node[ dir ] ) ) {
                   if ( ofType ?
                     node.nodeName.toLowerCase() === name :
                     node.nodeType === 1 ) {

                     return false;
                   }
                 }

                 // Reverse direction for :only-* (if we haven't yet done so)
                 start = dir = type === "only" && !start && "nextSibling";
               }
               return true;
             }

             start = [ forward ? parent.firstChild : parent.lastChild ];

             // non-xml :nth-child(...) stores cache data on `parent`
             if ( forward && useCache ) {

               // Seek `elem` from a previously-cached index

               // ...in a gzip-friendly way
               node = parent;
               outerCache = node[ expando ] || ( node[ expando ] = {} );

               // Support: IE <9 only
               // Defend against cloned attroperties (jQuery gh-1709)
               uniqueCache = outerCache[ node.uniqueID ] ||
                 ( outerCache[ node.uniqueID ] = {} );

               cache = uniqueCache[ type ] || [];
               nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
               diff = nodeIndex && cache[ 2 ];
               node = nodeIndex && parent.childNodes[ nodeIndex ];

               while ( ( node = ++nodeIndex && node && node[ dir ] ||

                 // Fallback to seeking `elem` from the start
                 ( diff = nodeIndex = 0 ) || start.pop() ) ) {

                 // When found, cache indexes on `parent` and break
                 if ( node.nodeType === 1 && ++diff && node === elem ) {
                   uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
                   break;
                 }
               }

             } else {

               // Use previously-cached element index if available
               if ( useCache ) {

                 // ...in a gzip-friendly way
                 node = elem;
                 outerCache = node[ expando ] || ( node[ expando ] = {} );

                 // Support: IE <9 only
                 // Defend against cloned attroperties (jQuery gh-1709)
                 uniqueCache = outerCache[ node.uniqueID ] ||
                   ( outerCache[ node.uniqueID ] = {} );

                 cache = uniqueCache[ type ] || [];
                 nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
                 diff = nodeIndex;
               }

               // xml :nth-child(...)
               // or :nth-last-child(...) or :nth(-last)?-of-type(...)
               if ( diff === false ) {

                 // Use the same loop as above to seek `elem` from the start
                 while ( ( node = ++nodeIndex && node && node[ dir ] ||
                   ( diff = nodeIndex = 0 ) || start.pop() ) ) {

                   if ( ( ofType ?
                     node.nodeName.toLowerCase() === name :
                     node.nodeType === 1 ) &&
                     ++diff ) {

                     // Cache the index of each encountered element
                     if ( useCache ) {
                       outerCache = node[ expando ] ||
                         ( node[ expando ] = {} );

                       // Support: IE <9 only
                       // Defend against cloned attroperties (jQuery gh-1709)
                       uniqueCache = outerCache[ node.uniqueID ] ||
                         ( outerCache[ node.uniqueID ] = {} );

                       uniqueCache[ type ] = [ dirruns, diff ];
                     }

                     if ( node === elem ) {
                       break;
                     }
                   }
                 }
               }
             }

             // Incorporate the offset, then check against cycle size
             diff -= last;
             return diff === first || ( diff % first === 0 && diff / first >= 0 );
           }
         };
     },

     "PSEUDO": function( pseudo, argument ) {

       // pseudo-class names are case-insensitive
       // http://www.w3.org/TR/selectors/#pseudo-classes
       // Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
       // Remember that setFilters inherits from pseudos
       var args,
         fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
           Sizzle.error( "unsupported pseudo: " + pseudo );

       // The user may use createPseudo to indicate that
       // arguments are needed to create the filter function
       // just as Sizzle does
       if ( fn[ expando ] ) {
         return fn( argument );
       }

       // But maintain support for old signatures
       if ( fn.length > 1 ) {
         args = [ pseudo, pseudo, "", argument ];
         return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
           markFunction( function( seed, matches ) {
             var idx,
               matched = fn( seed, argument ),
               i = matched.length;
             while ( i-- ) {
               idx = indexOf( seed, matched[ i ] );
               seed[ idx ] = !( matches[ idx ] = matched[ i ] );
             }
           } ) :
           function( elem ) {
             return fn( elem, 0, args );
           };
       }

       return fn;
     }
   },

   pseudos: {

     // Potentially complex pseudos
     "not": markFunction( function( selector ) {

       // Trim the selector passed to compile
       // to avoid treating leading and trailing
       // spaces as combinators
       var input = [],
         results = [],
         matcher = compile( selector.replace( rtrim, "$1" ) );

       return matcher[ expando ] ?
         markFunction( function( seed, matches, _context, xml ) {
           var elem,
             unmatched = matcher( seed, null, xml, [] ),
             i = seed.length;

           // Match elements unmatched by `matcher`
           while ( i-- ) {
             if ( ( elem = unmatched[ i ] ) ) {
               seed[ i ] = !( matches[ i ] = elem );
             }
           }
         } ) :
         function( elem, _context, xml ) {
           input[ 0 ] = elem;
           matcher( input, null, xml, results );

           // Don't keep the element (issue #299)
           input[ 0 ] = null;
           return !results.pop();
         };
     } ),

     "has": markFunction( function( selector ) {
       return function( elem ) {
         return Sizzle( selector, elem ).length > 0;
       };
     } ),

     "contains": markFunction( function( text ) {
       text = text.replace( runescape, funescape );
       return function( elem ) {
         return ( elem.textContent || getText( elem ) ).indexOf( text ) > -1;
       };
     } ),

     // "Whether an element is represented by a :lang() selector
     // is based solely on the element's language value
     // being equal to the identifier C,
     // or beginning with the identifier C immediately followed by "-".
     // The matching of C against the element's language value is performed case-insensitively.
     // The identifier C does not have to be a valid language name."
     // http://www.w3.org/TR/selectors/#lang-pseudo
     "lang": markFunction( function( lang ) {

       // lang value must be a valid identifier
       if ( !ridentifier.test( lang || "" ) ) {
         Sizzle.error( "unsupported lang: " + lang );
       }
       lang = lang.replace( runescape, funescape ).toLowerCase();
       return function( elem ) {
         var elemLang;
         do {
           if ( ( elemLang = documentIsHTML ?
             elem.lang :
             elem.getAttribute( "xml:lang" ) || elem.getAttribute( "lang" ) ) ) {

             elemLang = elemLang.toLowerCase();
             return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
           }
         } while ( ( elem = elem.parentNode ) && elem.nodeType === 1 );
         return false;
       };
     } ),

     // Miscellaneous
     "target": function( elem ) {
       var hash = window.location && window.location.hash;
       return hash && hash.slice( 1 ) === elem.id;
     },

     "root": function( elem ) {
       return elem === docElem;
     },

     "focus": function( elem ) {
       return elem === document.activeElement &&
         ( !document.hasFocus || document.hasFocus() ) &&
         !!( elem.type || elem.href || ~elem.tabIndex );
     },

     // Boolean properties
     "enabled": createDisabledPseudo( false ),
     "disabled": createDisabledPseudo( true ),

     "checked": function( elem ) {

       // In CSS3, :checked should return both checked and selected elements
       // http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
       var nodeName = elem.nodeName.toLowerCase();
       return ( nodeName === "input" && !!elem.checked ) ||
         ( nodeName === "option" && !!elem.selected );
     },

     "selected": function( elem ) {

       // Accessing this property makes selected-by-default
       // options in Safari work properly
       if ( elem.parentNode ) {
         // eslint-disable-next-line no-unused-expressions
         elem.parentNode.selectedIndex;
       }

       return elem.selected === true;
     },

     // Contents
     "empty": function( elem ) {

       // http://www.w3.org/TR/selectors/#empty-pseudo
       // :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
       //   but not by others (comment: 8; processing instruction: 7; etc.)
       // nodeType < 6 works because attributes (2) do not appear as children
       for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
         if ( elem.nodeType < 6 ) {
           return false;
         }
       }
       return true;
     },

     "parent": function( elem ) {
       return !Expr.pseudos[ "empty" ]( elem );
     },

     // Element/input types
     "header": function( elem ) {
       return rheader.test( elem.nodeName );
     },

     "input": function( elem ) {
       return rinputs.test( elem.nodeName );
     },

     "button": function( elem ) {
       var name = elem.nodeName.toLowerCase();
       return name === "input" && elem.type === "button" || name === "button";
     },

     "text": function( elem ) {
       var attr;
       return elem.nodeName.toLowerCase() === "input" &&
         elem.type === "text" &&

         // Support: IE<8
         // New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
         ( ( attr = elem.getAttribute( "type" ) ) == null ||
           attr.toLowerCase() === "text" );
     },

     // Position-in-collection
     "first": createPositionalPseudo( function() {
       return [ 0 ];
     } ),

     "last": createPositionalPseudo( function( _matchIndexes, length ) {
       return [ length - 1 ];
     } ),

     "eq": createPositionalPseudo( function( _matchIndexes, length, argument ) {
       return [ argument < 0 ? argument + length : argument ];
     } ),

     "even": createPositionalPseudo( function( matchIndexes, length ) {
       var i = 0;
       for ( ; i < length; i += 2 ) {
         matchIndexes.push( i );
       }
       return matchIndexes;
     } ),

     "odd": createPositionalPseudo( function( matchIndexes, length ) {
       var i = 1;
       for ( ; i < length; i += 2 ) {
         matchIndexes.push( i );
       }
       return matchIndexes;
     } ),

     "lt": createPositionalPseudo( function( matchIndexes, length, argument ) {
       var i = argument < 0 ?
         argument + length :
         argument > length ?
           length :
           argument;
       for ( ; --i >= 0; ) {
         matchIndexes.push( i );
       }
       return matchIndexes;
     } ),

     "gt": createPositionalPseudo( function( matchIndexes, length, argument ) {
       var i = argument < 0 ? argument + length : argument;
       for ( ; ++i < length; ) {
         matchIndexes.push( i );
       }
       return matchIndexes;
     } )
   }
 };

 Expr.pseudos[ "nth" ] = Expr.pseudos[ "eq" ];

 // Add button/input type pseudos
 for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
   Expr.pseudos[ i ] = createInputPseudo( i );
 }
 for ( i in { submit: true, reset: true } ) {
   Expr.pseudos[ i ] = createButtonPseudo( i );
 }

 // Easy API for creating new setFilters
 function setFilters() {}
 setFilters.prototype = Expr.filters = Expr.pseudos;
 Expr.setFilters = new setFilters();

 tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
   var matched, match, tokens, type,
     soFar, groups, preFilters,
     cached = tokenCache[ selector + " " ];

   if ( cached ) {
     return parseOnly ? 0 : cached.slice( 0 );
   }

   soFar = selector;
   groups = [];
   preFilters = Expr.preFilter;

   while ( soFar ) {

     // Comma and first run
     if ( !matched || ( match = rcomma.exec( soFar ) ) ) {
       if ( match ) {

         // Don't consume trailing commas as valid
         soFar = soFar.slice( match[ 0 ].length ) || soFar;
       }
       groups.push( ( tokens = [] ) );
     }

     matched = false;

     // Combinators
     if ( ( match = rcombinators.exec( soFar ) ) ) {
       matched = match.shift();
       tokens.push( {
         value: matched,

         // Cast descendant combinators to space
         type: match[ 0 ].replace( rtrim, " " )
       } );
       soFar = soFar.slice( matched.length );
     }

     // Filters
     for ( type in Expr.filter ) {
       if ( ( match = matchExpr[ type ].exec( soFar ) ) && ( !preFilters[ type ] ||
         ( match = preFilters[ type ]( match ) ) ) ) {
         matched = match.shift();
         tokens.push( {
           value: matched,
           type: type,
           matches: match
         } );
         soFar = soFar.slice( matched.length );
       }
     }

     if ( !matched ) {
       break;
     }
   }

   // Return the length of the invalid excess
   // if we're just parsing
   // Otherwise, throw an error or return tokens
   return parseOnly ?
     soFar.length :
     soFar ?
       Sizzle.error( selector ) :

       // Cache the tokens
       tokenCache( selector, groups ).slice( 0 );
 };

 function toSelector( tokens ) {
   var i = 0,
     len = tokens.length,
     selector = "";
   for ( ; i < len; i++ ) {
     selector += tokens[ i ].value;
   }
   return selector;
 }

 function addCombinator( matcher, combinator, base ) {
   var dir = combinator.dir,
     skip = combinator.next,
     key = skip || dir,
     checkNonElements = base && key === "parentNode",
     doneName = done++;

   return combinator.first ?

     // Check against closest ancestor/preceding element
     function( elem, context, xml ) {
       while ( ( elem = elem[ dir ] ) ) {
         if ( elem.nodeType === 1 || checkNonElements ) {
           return matcher( elem, context, xml );
         }
       }
       return false;
     } :

     // Check against all ancestor/preceding elements
     function( elem, context, xml ) {
       var oldCache, uniqueCache, outerCache,
         newCache = [ dirruns, doneName ];

       // We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
       if ( xml ) {
         while ( ( elem = elem[ dir ] ) ) {
           if ( elem.nodeType === 1 || checkNonElements ) {
             if ( matcher( elem, context, xml ) ) {
               return true;
             }
           }
         }
       } else {
         while ( ( elem = elem[ dir ] ) ) {
           if ( elem.nodeType === 1 || checkNonElements ) {
             outerCache = elem[ expando ] || ( elem[ expando ] = {} );

             // Support: IE <9 only
             // Defend against cloned attroperties (jQuery gh-1709)
             uniqueCache = outerCache[ elem.uniqueID ] ||
               ( outerCache[ elem.uniqueID ] = {} );

             if ( skip && skip === elem.nodeName.toLowerCase() ) {
               elem = elem[ dir ] || elem;
             } else if ( ( oldCache = uniqueCache[ key ] ) &&
               oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

               // Assign to newCache so results back-propagate to previous elements
               return ( newCache[ 2 ] = oldCache[ 2 ] );
             } else {

               // Reuse newcache so results back-propagate to previous elements
               uniqueCache[ key ] = newCache;

               // A match means we're done; a fail means we have to keep checking
               if ( ( newCache[ 2 ] = matcher( elem, context, xml ) ) ) {
                 return true;
               }
             }
           }
         }
       }
       return false;
     };
 }

 function elementMatcher( matchers ) {
   return matchers.length > 1 ?
     function( elem, context, xml ) {
       var i = matchers.length;
       while ( i-- ) {
         if ( !matchers[ i ]( elem, context, xml ) ) {
           return false;
         }
       }
       return true;
     } :
     matchers[ 0 ];
 }

 function multipleContexts( selector, contexts, results ) {
   var i = 0,
     len = contexts.length;
   for ( ; i < len; i++ ) {
     Sizzle( selector, contexts[ i ], results );
   }
   return results;
 }

 function condense( unmatched, map, filter, context, xml ) {
   var elem,
     newUnmatched = [],
     i = 0,
     len = unmatched.length,
     mapped = map != null;

   for ( ; i < len; i++ ) {
     if ( ( elem = unmatched[ i ] ) ) {
       if ( !filter || filter( elem, context, xml ) ) {
         newUnmatched.push( elem );
         if ( mapped ) {
           map.push( i );
         }
       }
     }
   }

   return newUnmatched;
 }

 function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
   if ( postFilter && !postFilter[ expando ] ) {
     postFilter = setMatcher( postFilter );
   }
   if ( postFinder && !postFinder[ expando ] ) {
     postFinder = setMatcher( postFinder, postSelector );
   }
   return markFunction( function( seed, results, context, xml ) {
     var temp, i, elem,
       preMap = [],
       postMap = [],
       preexisting = results.length,

       // Get initial elements from seed or context
       elems = seed || multipleContexts(
         selector || "*",
         context.nodeType ? [ context ] : context,
         []
       ),

       // Prefilter to get matcher input, preserving a map for seed-results synchronization
       matcherIn = preFilter && ( seed || !selector ) ?
         condense( elems, preMap, preFilter, context, xml ) :
         elems,

       matcherOut = matcher ?

         // If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
         postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

           // ...intermediate processing is necessary
           [] :

           // ...otherwise use results directly
           results :
         matcherIn;

     // Find primary matches
     if ( matcher ) {
       matcher( matcherIn, matcherOut, context, xml );
     }

     // Apply postFilter
     if ( postFilter ) {
       temp = condense( matcherOut, postMap );
       postFilter( temp, [], context, xml );

       // Un-match failing elements by moving them back to matcherIn
       i = temp.length;
       while ( i-- ) {
         if ( ( elem = temp[ i ] ) ) {
           matcherOut[ postMap[ i ] ] = !( matcherIn[ postMap[ i ] ] = elem );
         }
       }
     }

     if ( seed ) {
       if ( postFinder || preFilter ) {
         if ( postFinder ) {

           // Get the final matcherOut by condensing this intermediate into postFinder contexts
           temp = [];
           i = matcherOut.length;
           while ( i-- ) {
             if ( ( elem = matcherOut[ i ] ) ) {

               // Restore matcherIn since elem is not yet a final match
               temp.push( ( matcherIn[ i ] = elem ) );
             }
           }
           postFinder( null, ( matcherOut = [] ), temp, xml );
         }

         // Move matched elements from seed to results to keep them synchronized
         i = matcherOut.length;
         while ( i-- ) {
           if ( ( elem = matcherOut[ i ] ) &&
             ( temp = postFinder ? indexOf( seed, elem ) : preMap[ i ] ) > -1 ) {

             seed[ temp ] = !( results[ temp ] = elem );
           }
         }
       }

     // Add elements to results, through postFinder if defined
     } else {
       matcherOut = condense(
         matcherOut === results ?
           matcherOut.splice( preexisting, matcherOut.length ) :
           matcherOut
       );
       if ( postFinder ) {
         postFinder( null, results, matcherOut, xml );
       } else {
         push.apply( results, matcherOut );
       }
     }
   } );
 }

 function matcherFromTokens( tokens ) {
   var checkContext, matcher, j,
     len = tokens.length,
     leadingRelative = Expr.relative[ tokens[ 0 ].type ],
     implicitRelative = leadingRelative || Expr.relative[ " " ],
     i = leadingRelative ? 1 : 0,

     // The foundational matcher ensures that elements are reachable from top-level context(s)
     matchContext = addCombinator( function( elem ) {
       return elem === checkContext;
     }, implicitRelative, true ),
     matchAnyContext = addCombinator( function( elem ) {
       return indexOf( checkContext, elem ) > -1;
     }, implicitRelative, true ),
     matchers = [ function( elem, context, xml ) {
       var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
         ( checkContext = context ).nodeType ?
           matchContext( elem, context, xml ) :
           matchAnyContext( elem, context, xml ) );

       // Avoid hanging onto element (issue #299)
       checkContext = null;
       return ret;
     } ];

   for ( ; i < len; i++ ) {
     if ( ( matcher = Expr.relative[ tokens[ i ].type ] ) ) {
       matchers = [ addCombinator( elementMatcher( matchers ), matcher ) ];
     } else {
       matcher = Expr.filter[ tokens[ i ].type ].apply( null, tokens[ i ].matches );

       // Return special upon seeing a positional matcher
       if ( matcher[ expando ] ) {

         // Find the next relative operator (if any) for proper handling
         j = ++i;
         for ( ; j < len; j++ ) {
           if ( Expr.relative[ tokens[ j ].type ] ) {
             break;
           }
         }
         return setMatcher(
           i > 1 && elementMatcher( matchers ),
           i > 1 && toSelector(

           // If the preceding token was a descendant combinator, insert an implicit any-element `*`
           tokens
             .slice( 0, i - 1 )
             .concat( { value: tokens[ i - 2 ].type === " " ? "*" : "" } )
           ).replace( rtrim, "$1" ),
           matcher,
           i < j && matcherFromTokens( tokens.slice( i, j ) ),
           j < len && matcherFromTokens( ( tokens = tokens.slice( j ) ) ),
           j < len && toSelector( tokens )
         );
       }
       matchers.push( matcher );
     }
   }

   return elementMatcher( matchers );
 }

 function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
   var bySet = setMatchers.length > 0,
     byElement = elementMatchers.length > 0,
     superMatcher = function( seed, context, xml, results, outermost ) {
       var elem, j, matcher,
         matchedCount = 0,
         i = "0",
         unmatched = seed && [],
         setMatched = [],
         contextBackup = outermostContext,

         // We must always have either seed elements or outermost context
         elems = seed || byElement && Expr.find[ "TAG" ]( "*", outermost ),

         // Use integer dirruns iff this is the outermost matcher
         dirrunsUnique = ( dirruns += contextBackup == null ? 1 : Math.random() || 0.1 ),
         len = elems.length;

       if ( outermost ) {

         // Support: IE 11+, Edge 17 - 18+
         // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
         // two documents; shallow comparisons work.
         // eslint-disable-next-line eqeqeq
         outermostContext = context == document || context || outermost;
       }

       // Add elements passing elementMatchers directly to results
       // Support: IE<9, Safari
       // Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
       for ( ; i !== len && ( elem = elems[ i ] ) != null; i++ ) {
         if ( byElement && elem ) {
           j = 0;

           // Support: IE 11+, Edge 17 - 18+
           // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
           // two documents; shallow comparisons work.
           // eslint-disable-next-line eqeqeq
           if ( !context && elem.ownerDocument != document ) {
             setDocument( elem );
             xml = !documentIsHTML;
           }
           while ( ( matcher = elementMatchers[ j++ ] ) ) {
             if ( matcher( elem, context || document, xml ) ) {
               results.push( elem );
               break;
             }
           }
           if ( outermost ) {
             dirruns = dirrunsUnique;
           }
         }

         // Track unmatched elements for set filters
         if ( bySet ) {

           // They will have gone through all possible matchers
           if ( ( elem = !matcher && elem ) ) {
             matchedCount--;
           }

           // Lengthen the array for every element, matched or not
           if ( seed ) {
             unmatched.push( elem );
           }
         }
       }

       // `i` is now the count of elements visited above, and adding it to `matchedCount`
       // makes the latter nonnegative.
       matchedCount += i;

       // Apply set filters to unmatched elements
       // NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
       // equals `i`), unless we didn't visit _any_ elements in the above loop because we have
       // no element matchers and no seed.
       // Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
       // case, which will result in a "00" `matchedCount` that differs from `i` but is also
       // numerically zero.
       if ( bySet && i !== matchedCount ) {
         j = 0;
         while ( ( matcher = setMatchers[ j++ ] ) ) {
           matcher( unmatched, setMatched, context, xml );
         }

         if ( seed ) {

           // Reintegrate element matches to eliminate the need for sorting
           if ( matchedCount > 0 ) {
             while ( i-- ) {
               if ( !( unmatched[ i ] || setMatched[ i ] ) ) {
                 setMatched[ i ] = pop.call( results );
               }
             }
           }

           // Discard index placeholder values to get only actual matches
           setMatched = condense( setMatched );
         }

         // Add matches to results
         push.apply( results, setMatched );

         // Seedless set matches succeeding multiple successful matchers stipulate sorting
         if ( outermost && !seed && setMatched.length > 0 &&
           ( matchedCount + setMatchers.length ) > 1 ) {

           Sizzle.uniqueSort( results );
         }
       }

       // Override manipulation of globals by nested matchers
       if ( outermost ) {
         dirruns = dirrunsUnique;
         outermostContext = contextBackup;
       }

       return unmatched;
     };

   return bySet ?
     markFunction( superMatcher ) :
     superMatcher;
 }

 compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
   var i,
     setMatchers = [],
     elementMatchers = [],
     cached = compilerCache[ selector + " " ];

   if ( !cached ) {

     // Generate a function of recursive functions that can be used to check each element
     if ( !match ) {
       match = tokenize( selector );
     }
     i = match.length;
     while ( i-- ) {
       cached = matcherFromTokens( match[ i ] );
       if ( cached[ expando ] ) {
         setMatchers.push( cached );
       } else {
         elementMatchers.push( cached );
       }
     }

     // Cache the compiled function
     cached = compilerCache(
       selector,
       matcherFromGroupMatchers( elementMatchers, setMatchers )
     );

     // Save selector and tokenization
     cached.selector = selector;
   }
   return cached;
 };

 /**
  * A low-level selection function that works with Sizzle's compiled
  *  selector functions
  * @param {String|Function} selector A selector or a pre-compiled
  *  selector function built with Sizzle.compile
  * @param {Element} context
  * @param {Array} [results]
  * @param {Array} [seed] A set of elements to match against
  */
 select = Sizzle.select = function( selector, context, results, seed ) {
   var i, tokens, token, type, find,
     compiled = typeof selector === "function" && selector,
     match = !seed && tokenize( ( selector = compiled.selector || selector ) );

   results = results || [];

   // Try to minimize operations if there is only one selector in the list and no seed
   // (the latter of which guarantees us context)
   if ( match.length === 1 ) {

     // Reduce context if the leading compound selector is an ID
     tokens = match[ 0 ] = match[ 0 ].slice( 0 );
     if ( tokens.length > 2 && ( token = tokens[ 0 ] ).type === "ID" &&
       context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[ 1 ].type ] ) {

       context = ( Expr.find[ "ID" ]( token.matches[ 0 ]
         .replace( runescape, funescape ), context ) || [] )[ 0 ];
       if ( !context ) {
         return results;

       // Precompiled matchers will still verify ancestry, so step up a level
       } else if ( compiled ) {
         context = context.parentNode;
       }

       selector = selector.slice( tokens.shift().value.length );
     }

     // Fetch a seed set for right-to-left matching
     i = matchExpr[ "needsContext" ].test( selector ) ? 0 : tokens.length;
     while ( i-- ) {
       token = tokens[ i ];

       // Abort if we hit a combinator
       if ( Expr.relative[ ( type = token.type ) ] ) {
         break;
       }
       if ( ( find = Expr.find[ type ] ) ) {

         // Search, expanding context for leading sibling combinators
         if ( ( seed = find(
           token.matches[ 0 ].replace( runescape, funescape ),
           rsibling.test( tokens[ 0 ].type ) && testContext( context.parentNode ) ||
             context
         ) ) ) {

           // If seed is empty or no tokens remain, we can return early
           tokens.splice( i, 1 );
           selector = seed.length && toSelector( tokens );
           if ( !selector ) {
             push.apply( results, seed );
             return results;
           }

           break;
         }
       }
     }
   }

   // Compile and execute a filtering function if one is not provided
   // Provide `match` to avoid retokenization if we modified the selector above
   ( compiled || compile( selector, match ) )(
     seed,
     context,
     !documentIsHTML,
     results,
     !context || rsibling.test( selector ) && testContext( context.parentNode ) || context
   );
   return results;
 };

 // One-time assignments

 // Sort stability
 support.sortStable = expando.split( "" ).sort( sortOrder ).join( "" ) === expando;

 // Support: Chrome 14-35+
 // Always assume duplicates if they aren't passed to the comparison function
 support.detectDuplicates = !!hasDuplicate;

 // Initialize against the default document
 setDocument();

 // Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
 // Detached nodes confoundingly follow *each other*
 support.sortDetached = assert( function( el ) {

   // Should return 1, but returns 4 (following)
   return el.compareDocumentPosition( document.createElement( "fieldset" ) ) & 1;
 } );

 // Support: IE<8
 // Prevent attribute/property "interpolation"
 // https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
 if ( !assert( function( el ) {
   el.innerHTML = "<a href='#'></a>";
   return el.firstChild.getAttribute( "href" ) === "#";
 } ) ) {
   addHandle( "type|href|height|width", function( elem, name, isXML ) {
     if ( !isXML ) {
       return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
     }
   } );
 }

 // Support: IE<9
 // Use defaultValue in place of getAttribute("value")
 if ( !support.attributes || !assert( function( el ) {
   el.innerHTML = "<input/>";
   el.firstChild.setAttribute( "value", "" );
   return el.firstChild.getAttribute( "value" ) === "";
 } ) ) {
   addHandle( "value", function( elem, _name, isXML ) {
     if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
       return elem.defaultValue;
     }
   } );
 }

 // Support: IE<9
 // Use getAttributeNode to fetch booleans when getAttribute lies
 if ( !assert( function( el ) {
   return el.getAttribute( "disabled" ) == null;
 } ) ) {
   addHandle( booleans, function( elem, name, isXML ) {
     var val;
     if ( !isXML ) {
       return elem[ name ] === true ? name.toLowerCase() :
         ( val = elem.getAttributeNode( name ) ) && val.specified ?
           val.value :
           null;
     }
   } );
 }

 return Sizzle;

 } )( window );



 jQuery.find = Sizzle;
 jQuery.expr = Sizzle.selectors;

 // Deprecated
 jQuery.expr[ ":" ] = jQuery.expr.pseudos;
 jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
 jQuery.text = Sizzle.getText;
 jQuery.isXMLDoc = Sizzle.isXML;
 jQuery.contains = Sizzle.contains;
 jQuery.escapeSelector = Sizzle.escape;




 var dir = function( elem, dir, until ) {
   var matched = [],
     truncate = until !== undefined;

   while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
     if ( elem.nodeType === 1 ) {
       if ( truncate && jQuery( elem ).is( until ) ) {
         break;
       }
       matched.push( elem );
     }
   }
   return matched;
 };


 var siblings = function( n, elem ) {
   var matched = [];

   for ( ; n; n = n.nextSibling ) {
     if ( n.nodeType === 1 && n !== elem ) {
       matched.push( n );
     }
   }

   return matched;
 };


 var rneedsContext = jQuery.expr.match.needsContext;



 function nodeName( elem, name ) {

   return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

 }
 var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );



 // Implement the identical functionality for filter and not
 function winnow( elements, qualifier, not ) {
   if ( isFunction( qualifier ) ) {
     return jQuery.grep( elements, function( elem, i ) {
       return !!qualifier.call( elem, i, elem ) !== not;
     } );
   }

   // Single element
   if ( qualifier.nodeType ) {
     return jQuery.grep( elements, function( elem ) {
       return ( elem === qualifier ) !== not;
     } );
   }

   // Arraylike of elements (jQuery, arguments, Array)
   if ( typeof qualifier !== "string" ) {
     return jQuery.grep( elements, function( elem ) {
       return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
     } );
   }

   // Filtered directly for both simple and complex selectors
   return jQuery.filter( qualifier, elements, not );
 }

 jQuery.filter = function( expr, elems, not ) {
   var elem = elems[ 0 ];

   if ( not ) {
     expr = ":not(" + expr + ")";
   }

   if ( elems.length === 1 && elem.nodeType === 1 ) {
     return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
   }

   return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
     return elem.nodeType === 1;
   } ) );
 };

 jQuery.fn.extend( {
   find: function( selector ) {
     var i, ret,
       len = this.length,
       self = this;

     if ( typeof selector !== "string" ) {
       return this.pushStack( jQuery( selector ).filter( function() {
         for ( i = 0; i < len; i++ ) {
           if ( jQuery.contains( self[ i ], this ) ) {
             return true;
           }
         }
       } ) );
     }

     ret = this.pushStack( [] );

     for ( i = 0; i < len; i++ ) {
       jQuery.find( selector, self[ i ], ret );
     }

     return len > 1 ? jQuery.uniqueSort( ret ) : ret;
   },
   filter: function( selector ) {
     return this.pushStack( winnow( this, selector || [], false ) );
   },
   not: function( selector ) {
     return this.pushStack( winnow( this, selector || [], true ) );
   },
   is: function( selector ) {
     return !!winnow(
       this,

       // If this is a positional/relative selector, check membership in the returned set
       // so $("p:first").is("p:last") won't return true for a doc with two "p".
       typeof selector === "string" && rneedsContext.test( selector ) ?
         jQuery( selector ) :
         selector || [],
       false
     ).length;
   }
 } );


 // Initialize a jQuery object


 // A central reference to the root jQuery(document)
 var rootjQuery,

   // A simple way to check for HTML strings
   // Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
   // Strict HTML recognition (#11290: must start with <)
   // Shortcut simple #id case for speed
   rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

   init = jQuery.fn.init = function( selector, context, root ) {
     var match, elem;

     // HANDLE: $(""), $(null), $(undefined), $(false)
     if ( !selector ) {
       return this;
     }

     // Method init() accepts an alternate rootjQuery
     // so migrate can support jQuery.sub (gh-2101)
     root = root || rootjQuery;

     // Handle HTML strings
     if ( typeof selector === "string" ) {
       if ( selector[ 0 ] === "<" &&
         selector[ selector.length - 1 ] === ">" &&
         selector.length >= 3 ) {

         // Assume that strings that start and end with <> are HTML and skip the regex check
         match = [ null, selector, null ];

       } else {
         match = rquickExpr.exec( selector );
       }

       // Match html or make sure no context is specified for #id
       if ( match && ( match[ 1 ] || !context ) ) {

         // HANDLE: $(html) -> $(array)
         if ( match[ 1 ] ) {
           context = context instanceof jQuery ? context[ 0 ] : context;

           // Option to run scripts is true for back-compat
           // Intentionally let the error be thrown if parseHTML is not present
           jQuery.merge( this, jQuery.parseHTML(
             match[ 1 ],
             context && context.nodeType ? context.ownerDocument || context : document,
             true
           ) );

           // HANDLE: $(html, props)
           if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
             for ( match in context ) {

               // Properties of context are called as methods if possible
               if ( isFunction( this[ match ] ) ) {
                 this[ match ]( context[ match ] );

               // ...and otherwise set as attributes
               } else {
                 this.attr( match, context[ match ] );
               }
             }
           }

           return this;

         // HANDLE: $(#id)
         } else {
           elem = document.getElementById( match[ 2 ] );

           if ( elem ) {

             // Inject the element directly into the jQuery object
             this[ 0 ] = elem;
             this.length = 1;
           }
           return this;
         }

       // HANDLE: $(expr, $(...))
       } else if ( !context || context.jquery ) {
         return ( context || root ).find( selector );

       // HANDLE: $(expr, context)
       // (which is just equivalent to: $(context).find(expr)
       } else {
         return this.constructor( context ).find( selector );
       }

     // HANDLE: $(DOMElement)
     } else if ( selector.nodeType ) {
       this[ 0 ] = selector;
       this.length = 1;
       return this;

     // HANDLE: $(function)
     // Shortcut for document ready
     } else if ( isFunction( selector ) ) {
       return root.ready !== undefined ?
         root.ready( selector ) :

         // Execute immediately if ready is not present
         selector( jQuery );
     }

     return jQuery.makeArray( selector, this );
   };

 // Give the init function the jQuery prototype for later instantiation
 init.prototype = jQuery.fn;

 // Initialize central reference
 rootjQuery = jQuery( document );


 var rparentsprev = /^(?:parents|prev(?:Until|All))/,

   // Methods guaranteed to produce a unique set when starting from a unique set
   guaranteedUnique = {
     children: true,
     contents: true,
     next: true,
     prev: true
   };

 jQuery.fn.extend( {
   has: function( target ) {
     var targets = jQuery( target, this ),
       l = targets.length;

     return this.filter( function() {
       var i = 0;
       for ( ; i < l; i++ ) {
         if ( jQuery.contains( this, targets[ i ] ) ) {
           return true;
         }
       }
     } );
   },

   closest: function( selectors, context ) {
     var cur,
       i = 0,
       l = this.length,
       matched = [],
       targets = typeof selectors !== "string" && jQuery( selectors );

     // Positional selectors never match, since there's no _selection_ context
     if ( !rneedsContext.test( selectors ) ) {
       for ( ; i < l; i++ ) {
         for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

           // Always skip document fragments
           if ( cur.nodeType < 11 && ( targets ?
             targets.index( cur ) > -1 :

             // Don't pass non-elements to Sizzle
             cur.nodeType === 1 &&
               jQuery.find.matchesSelector( cur, selectors ) ) ) {

             matched.push( cur );
             break;
           }
         }
       }
     }

     return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
   },

   // Determine the position of an element within the set
   index: function( elem ) {

     // No argument, return index in parent
     if ( !elem ) {
       return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
     }

     // Index in selector
     if ( typeof elem === "string" ) {
       return indexOf.call( jQuery( elem ), this[ 0 ] );
     }

     // Locate the position of the desired element
     return indexOf.call( this,

       // If it receives a jQuery object, the first element is used
       elem.jquery ? elem[ 0 ] : elem
     );
   },

   add: function( selector, context ) {
     return this.pushStack(
       jQuery.uniqueSort(
         jQuery.merge( this.get(), jQuery( selector, context ) )
       )
     );
   },

   addBack: function( selector ) {
     return this.add( selector == null ?
       this.prevObject : this.prevObject.filter( selector )
     );
   }
 } );

 function sibling( cur, dir ) {
   while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
   return cur;
 }

 jQuery.each( {
   parent: function( elem ) {
     var parent = elem.parentNode;
     return parent && parent.nodeType !== 11 ? parent : null;
   },
   parents: function( elem ) {
     return dir( elem, "parentNode" );
   },
   parentsUntil: function( elem, _i, until ) {
     return dir( elem, "parentNode", until );
   },
   next: function( elem ) {
     return sibling( elem, "nextSibling" );
   },
   prev: function( elem ) {
     return sibling( elem, "previousSibling" );
   },
   nextAll: function( elem ) {
     return dir( elem, "nextSibling" );
   },
   prevAll: function( elem ) {
     return dir( elem, "previousSibling" );
   },
   nextUntil: function( elem, _i, until ) {
     return dir( elem, "nextSibling", until );
   },
   prevUntil: function( elem, _i, until ) {
     return dir( elem, "previousSibling", until );
   },
   siblings: function( elem ) {
     return siblings( ( elem.parentNode || {} ).firstChild, elem );
   },
   children: function( elem ) {
     return siblings( elem.firstChild );
   },
   contents: function( elem ) {
     if ( elem.contentDocument != null &&

       // Support: IE 11+
       // <object> elements with no `data` attribute has an object
       // `contentDocument` with a `null` prototype.
       getProto( elem.contentDocument ) ) {

       return elem.contentDocument;
     }

     // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
     // Treat the template element as a regular one in browsers that
     // don't support it.
     if ( nodeName( elem, "template" ) ) {
       elem = elem.content || elem;
     }

     return jQuery.merge( [], elem.childNodes );
   }
 }, function( name, fn ) {
   jQuery.fn[ name ] = function( until, selector ) {
     var matched = jQuery.map( this, fn, until );

     if ( name.slice( -5 ) !== "Until" ) {
       selector = until;
     }

     if ( selector && typeof selector === "string" ) {
       matched = jQuery.filter( selector, matched );
     }

     if ( this.length > 1 ) {

       // Remove duplicates
       if ( !guaranteedUnique[ name ] ) {
         jQuery.uniqueSort( matched );
       }

       // Reverse order for parents* and prev-derivatives
       if ( rparentsprev.test( name ) ) {
         matched.reverse();
       }
     }

     return this.pushStack( matched );
   };
 } );
 var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );



 // Convert String-formatted options into Object-formatted ones
 function createOptions( options ) {
   var object = {};
   jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
     object[ flag ] = true;
   } );
   return object;
 }

 /*
  * Create a callback list using the following parameters:
  *
  *	options: an optional list of space-separated options that will change how
  *			the callback list behaves or a more traditional option object
  *
  * By default a callback list will act like an event callback list and can be
  * "fired" multiple times.
  *
  * Possible options:
  *
  *	once:			will ensure the callback list can only be fired once (like a Deferred)
  *
  *	memory:			will keep track of previous values and will call any callback added
  *					after the list has been fired right away with the latest "memorized"
  *					values (like a Deferred)
  *
  *	unique:			will ensure a callback can only be added once (no duplicate in the list)
  *
  *	stopOnFalse:	interrupt callings when a callback returns false
  *
  */
 jQuery.Callbacks = function( options ) {

   // Convert options from String-formatted to Object-formatted if needed
   // (we check in cache first)
   options = typeof options === "string" ?
     createOptions( options ) :
     jQuery.extend( {}, options );

   var // Flag to know if list is currently firing
     firing,

     // Last fire value for non-forgettable lists
     memory,

     // Flag to know if list was already fired
     fired,

     // Flag to prevent firing
     locked,

     // Actual callback list
     list = [],

     // Queue of execution data for repeatable lists
     queue = [],

     // Index of currently firing callback (modified by add/remove as needed)
     firingIndex = -1,

     // Fire callbacks
     fire = function() {

       // Enforce single-firing
       locked = locked || options.once;

       // Execute callbacks for all pending executions,
       // respecting firingIndex overrides and runtime changes
       fired = firing = true;
       for ( ; queue.length; firingIndex = -1 ) {
         memory = queue.shift();
         while ( ++firingIndex < list.length ) {

           // Run callback and check for early termination
           if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
             options.stopOnFalse ) {

             // Jump to end and forget the data so .add doesn't re-fire
             firingIndex = list.length;
             memory = false;
           }
         }
       }

       // Forget the data if we're done with it
       if ( !options.memory ) {
         memory = false;
       }

       firing = false;

       // Clean up if we're done firing for good
       if ( locked ) {

         // Keep an empty list if we have data for future add calls
         if ( memory ) {
           list = [];

         // Otherwise, this object is spent
         } else {
           list = "";
         }
       }
     },

     // Actual Callbacks object
     self = {

       // Add a callback or a collection of callbacks to the list
       add: function() {
         if ( list ) {

           // If we have memory from a past run, we should fire after adding
           if ( memory && !firing ) {
             firingIndex = list.length - 1;
             queue.push( memory );
           }

           ( function add( args ) {
             jQuery.each( args, function( _, arg ) {
               if ( isFunction( arg ) ) {
                 if ( !options.unique || !self.has( arg ) ) {
                   list.push( arg );
                 }
               } else if ( arg && arg.length && toType( arg ) !== "string" ) {

                 // Inspect recursively
                 add( arg );
               }
             } );
           } )( arguments );

           if ( memory && !firing ) {
             fire();
           }
         }
         return this;
       },

       // Remove a callback from the list
       remove: function() {
         jQuery.each( arguments, function( _, arg ) {
           var index;
           while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
             list.splice( index, 1 );

             // Handle firing indexes
             if ( index <= firingIndex ) {
               firingIndex--;
             }
           }
         } );
         return this;
       },

       // Check if a given callback is in the list.
       // If no argument is given, return whether or not list has callbacks attached.
       has: function( fn ) {
         return fn ?
           jQuery.inArray( fn, list ) > -1 :
           list.length > 0;
       },

       // Remove all callbacks from the list
       empty: function() {
         if ( list ) {
           list = [];
         }
         return this;
       },

       // Disable .fire and .add
       // Abort any current/pending executions
       // Clear all callbacks and values
       disable: function() {
         locked = queue = [];
         list = memory = "";
         return this;
       },
       disabled: function() {
         return !list;
       },

       // Disable .fire
       // Also disable .add unless we have memory (since it would have no effect)
       // Abort any pending executions
       lock: function() {
         locked = queue = [];
         if ( !memory && !firing ) {
           list = memory = "";
         }
         return this;
       },
       locked: function() {
         return !!locked;
       },

       // Call all callbacks with the given context and arguments
       fireWith: function( context, args ) {
         if ( !locked ) {
           args = args || [];
           args = [ context, args.slice ? args.slice() : args ];
           queue.push( args );
           if ( !firing ) {
             fire();
           }
         }
         return this;
       },

       // Call all the callbacks with the given arguments
       fire: function() {
         self.fireWith( this, arguments );
         return this;
       },

       // To know if the callbacks have already been called at least once
       fired: function() {
         return !!fired;
       }
     };

   return self;
 };


 function Identity( v ) {
   return v;
 }
 function Thrower( ex ) {
   throw ex;
 }

 function adoptValue( value, resolve, reject, noValue ) {
   var method;

   try {

     // Check for promise aspect first to privilege synchronous behavior
     if ( value && isFunction( ( method = value.promise ) ) ) {
       method.call( value ).done( resolve ).fail( reject );

     // Other thenables
     } else if ( value && isFunction( ( method = value.then ) ) ) {
       method.call( value, resolve, reject );

     // Other non-thenables
     } else {

       // Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
       // * false: [ value ].slice( 0 ) => resolve( value )
       // * true: [ value ].slice( 1 ) => resolve()
       resolve.apply( undefined, [ value ].slice( noValue ) );
     }

   // For Promises/A+, convert exceptions into rejections
   // Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
   // Deferred#then to conditionally suppress rejection.
   } catch ( value ) {

     // Support: Android 4.0 only
     // Strict mode functions invoked without .call/.apply get global-object context
     reject.apply( undefined, [ value ] );
   }
 }

 jQuery.extend( {

   Deferred: function( func ) {
     var tuples = [

         // action, add listener, callbacks,
         // ... .then handlers, argument index, [final state]
         [ "notify", "progress", jQuery.Callbacks( "memory" ),
           jQuery.Callbacks( "memory" ), 2 ],
         [ "resolve", "done", jQuery.Callbacks( "once memory" ),
           jQuery.Callbacks( "once memory" ), 0, "resolved" ],
         [ "reject", "fail", jQuery.Callbacks( "once memory" ),
           jQuery.Callbacks( "once memory" ), 1, "rejected" ]
       ],
       state = "pending",
       promise = {
         state: function() {
           return state;
         },
         always: function() {
           deferred.done( arguments ).fail( arguments );
           return this;
         },
         "catch": function( fn ) {
           return promise.then( null, fn );
         },

         // Keep pipe for back-compat
         pipe: function( /* fnDone, fnFail, fnProgress */ ) {
           var fns = arguments;

           return jQuery.Deferred( function( newDefer ) {
             jQuery.each( tuples, function( _i, tuple ) {

               // Map tuples (progress, done, fail) to arguments (done, fail, progress)
               var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

               // deferred.progress(function() { bind to newDefer or newDefer.notify })
               // deferred.done(function() { bind to newDefer or newDefer.resolve })
               // deferred.fail(function() { bind to newDefer or newDefer.reject })
               deferred[ tuple[ 1 ] ]( function() {
                 var returned = fn && fn.apply( this, arguments );
                 if ( returned && isFunction( returned.promise ) ) {
                   returned.promise()
                     .progress( newDefer.notify )
                     .done( newDefer.resolve )
                     .fail( newDefer.reject );
                 } else {
                   newDefer[ tuple[ 0 ] + "With" ](
                     this,
                     fn ? [ returned ] : arguments
                   );
                 }
               } );
             } );
             fns = null;
           } ).promise();
         },
         then: function( onFulfilled, onRejected, onProgress ) {
           var maxDepth = 0;
           function resolve( depth, deferred, handler, special ) {
             return function() {
               var that = this,
                 args = arguments,
                 mightThrow = function() {
                   var returned, then;

                   // Support: Promises/A+ section 2.3.3.3.3
                   // https://promisesaplus.com/#point-59
                   // Ignore double-resolution attempts
                   if ( depth < maxDepth ) {
                     return;
                   }

                   returned = handler.apply( that, args );

                   // Support: Promises/A+ section 2.3.1
                   // https://promisesaplus.com/#point-48
                   if ( returned === deferred.promise() ) {
                     throw new TypeError( "Thenable self-resolution" );
                   }

                   // Support: Promises/A+ sections 2.3.3.1, 3.5
                   // https://promisesaplus.com/#point-54
                   // https://promisesaplus.com/#point-75
                   // Retrieve `then` only once
                   then = returned &&

                     // Support: Promises/A+ section 2.3.4
                     // https://promisesaplus.com/#point-64
                     // Only check objects and functions for thenability
                     ( typeof returned === "object" ||
                       typeof returned === "function" ) &&
                     returned.then;

                   // Handle a returned thenable
                   if ( isFunction( then ) ) {

                     // Special processors (notify) just wait for resolution
                     if ( special ) {
                       then.call(
                         returned,
                         resolve( maxDepth, deferred, Identity, special ),
                         resolve( maxDepth, deferred, Thrower, special )
                       );

                     // Normal processors (resolve) also hook into progress
                     } else {

                       // ...and disregard older resolution values
                       maxDepth++;

                       then.call(
                         returned,
                         resolve( maxDepth, deferred, Identity, special ),
                         resolve( maxDepth, deferred, Thrower, special ),
                         resolve( maxDepth, deferred, Identity,
                           deferred.notifyWith )
                       );
                     }

                   // Handle all other returned values
                   } else {

                     // Only substitute handlers pass on context
                     // and multiple values (non-spec behavior)
                     if ( handler !== Identity ) {
                       that = undefined;
                       args = [ returned ];
                     }

                     // Process the value(s)
                     // Default process is resolve
                     ( special || deferred.resolveWith )( that, args );
                   }
                 },

                 // Only normal processors (resolve) catch and reject exceptions
                 process = special ?
                   mightThrow :
                   function() {
                     try {
                       mightThrow();
                     } catch ( e ) {

                       if ( jQuery.Deferred.exceptionHook ) {
                         jQuery.Deferred.exceptionHook( e,
                           process.stackTrace );
                       }

                       // Support: Promises/A+ section 2.3.3.3.4.1
                       // https://promisesaplus.com/#point-61
                       // Ignore post-resolution exceptions
                       if ( depth + 1 >= maxDepth ) {

                         // Only substitute handlers pass on context
                         // and multiple values (non-spec behavior)
                         if ( handler !== Thrower ) {
                           that = undefined;
                           args = [ e ];
                         }

                         deferred.rejectWith( that, args );
                       }
                     }
                   };

               // Support: Promises/A+ section 2.3.3.3.1
               // https://promisesaplus.com/#point-57
               // Re-resolve promises immediately to dodge false rejection from
               // subsequent errors
               if ( depth ) {
                 process();
               } else {

                 // Call an optional hook to record the stack, in case of exception
                 // since it's otherwise lost when execution goes async
                 if ( jQuery.Deferred.getStackHook ) {
                   process.stackTrace = jQuery.Deferred.getStackHook();
                 }
                 window.setTimeout( process );
               }
             };
           }

           return jQuery.Deferred( function( newDefer ) {

             // progress_handlers.add( ... )
             tuples[ 0 ][ 3 ].add(
               resolve(
                 0,
                 newDefer,
                 isFunction( onProgress ) ?
                   onProgress :
                   Identity,
                 newDefer.notifyWith
               )
             );

             // fulfilled_handlers.add( ... )
             tuples[ 1 ][ 3 ].add(
               resolve(
                 0,
                 newDefer,
                 isFunction( onFulfilled ) ?
                   onFulfilled :
                   Identity
               )
             );

             // rejected_handlers.add( ... )
             tuples[ 2 ][ 3 ].add(
               resolve(
                 0,
                 newDefer,
                 isFunction( onRejected ) ?
                   onRejected :
                   Thrower
               )
             );
           } ).promise();
         },

         // Get a promise for this deferred
         // If obj is provided, the promise aspect is added to the object
         promise: function( obj ) {
           return obj != null ? jQuery.extend( obj, promise ) : promise;
         }
       },
       deferred = {};

     // Add list-specific methods
     jQuery.each( tuples, function( i, tuple ) {
       var list = tuple[ 2 ],
         stateString = tuple[ 5 ];

       // promise.progress = list.add
       // promise.done = list.add
       // promise.fail = list.add
       promise[ tuple[ 1 ] ] = list.add;

       // Handle state
       if ( stateString ) {
         list.add(
           function() {

             // state = "resolved" (i.e., fulfilled)
             // state = "rejected"
             state = stateString;
           },

           // rejected_callbacks.disable
           // fulfilled_callbacks.disable
           tuples[ 3 - i ][ 2 ].disable,

           // rejected_handlers.disable
           // fulfilled_handlers.disable
           tuples[ 3 - i ][ 3 ].disable,

           // progress_callbacks.lock
           tuples[ 0 ][ 2 ].lock,

           // progress_handlers.lock
           tuples[ 0 ][ 3 ].lock
         );
       }

       // progress_handlers.fire
       // fulfilled_handlers.fire
       // rejected_handlers.fire
       list.add( tuple[ 3 ].fire );

       // deferred.notify = function() { deferred.notifyWith(...) }
       // deferred.resolve = function() { deferred.resolveWith(...) }
       // deferred.reject = function() { deferred.rejectWith(...) }
       deferred[ tuple[ 0 ] ] = function() {
         deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
         return this;
       };

       // deferred.notifyWith = list.fireWith
       // deferred.resolveWith = list.fireWith
       // deferred.rejectWith = list.fireWith
       deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
     } );

     // Make the deferred a promise
     promise.promise( deferred );

     // Call given func if any
     if ( func ) {
       func.call( deferred, deferred );
     }

     // All done!
     return deferred;
   },

   // Deferred helper
   when: function( singleValue ) {
     var

       // count of uncompleted subordinates
       remaining = arguments.length,

       // count of unprocessed arguments
       i = remaining,

       // subordinate fulfillment data
       resolveContexts = Array( i ),
       resolveValues = slice.call( arguments ),

       // the primary Deferred
       primary = jQuery.Deferred(),

       // subordinate callback factory
       updateFunc = function( i ) {
         return function( value ) {
           resolveContexts[ i ] = this;
           resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
           if ( !( --remaining ) ) {
             primary.resolveWith( resolveContexts, resolveValues );
           }
         };
       };

     // Single- and empty arguments are adopted like Promise.resolve
     if ( remaining <= 1 ) {
       adoptValue( singleValue, primary.done( updateFunc( i ) ).resolve, primary.reject,
         !remaining );

       // Use .then() to unwrap secondary thenables (cf. gh-3000)
       if ( primary.state() === "pending" ||
         isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

         return primary.then();
       }
     }

     // Multiple arguments are aggregated like Promise.all array elements
     while ( i-- ) {
       adoptValue( resolveValues[ i ], updateFunc( i ), primary.reject );
     }

     return primary.promise();
   }
 } );


 // These usually indicate a programmer mistake during development,
 // warn about them ASAP rather than swallowing them by default.
 var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

 jQuery.Deferred.exceptionHook = function( error, stack ) {

   // Support: IE 8 - 9 only
   // Console exists when dev tools are open, which can happen at any time
   if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
     window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
   }
 };




 jQuery.readyException = function( error ) {
   window.setTimeout( function() {
     throw error;
   } );
 };




 // The deferred used on DOM ready
 var readyList = jQuery.Deferred();

 jQuery.fn.ready = function( fn ) {

   readyList
     .then( fn )

     // Wrap jQuery.readyException in a function so that the lookup
     // happens at the time of error handling instead of callback
     // registration.
     .catch( function( error ) {
       jQuery.readyException( error );
     } );

   return this;
 };

 jQuery.extend( {

   // Is the DOM ready to be used? Set to true once it occurs.
   isReady: false,

   // A counter to track how many items to wait for before
   // the ready event fires. See #6781
   readyWait: 1,

   // Handle when the DOM is ready
   ready: function( wait ) {

     // Abort if there are pending holds or we're already ready
     if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
       return;
     }

     // Remember that the DOM is ready
     jQuery.isReady = true;

     // If a normal DOM Ready event fired, decrement, and wait if need be
     if ( wait !== true && --jQuery.readyWait > 0 ) {
       return;
     }

     // If there are functions bound, to execute
     readyList.resolveWith( document, [ jQuery ] );
   }
 } );

 jQuery.ready.then = readyList.then;

 // The ready event handler and self cleanup method
 function completed() {
   document.removeEventListener( "DOMContentLoaded", completed );
   window.removeEventListener( "load", completed );
   jQuery.ready();
 }

 // Catch cases where $(document).ready() is called
 // after the browser event has already occurred.
 // Support: IE <=9 - 10 only
 // Older IE sometimes signals "interactive" too soon
 if ( document.readyState === "complete" ||
   ( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

   // Handle it asynchronously to allow scripts the opportunity to delay ready
   window.setTimeout( jQuery.ready );

 } else {

   // Use the handy event callback
   document.addEventListener( "DOMContentLoaded", completed );

   // A fallback to window.onload, that will always work
   window.addEventListener( "load", completed );
 }




 // Multifunctional method to get and set values of a collection
 // The value/s can optionally be executed if it's a function
 var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
   var i = 0,
     len = elems.length,
     bulk = key == null;

   // Sets many values
   if ( toType( key ) === "object" ) {
     chainable = true;
     for ( i in key ) {
       access( elems, fn, i, key[ i ], true, emptyGet, raw );
     }

   // Sets one value
   } else if ( value !== undefined ) {
     chainable = true;

     if ( !isFunction( value ) ) {
       raw = true;
     }

     if ( bulk ) {

       // Bulk operations run against the entire set
       if ( raw ) {
         fn.call( elems, value );
         fn = null;

       // ...except when executing function values
       } else {
         bulk = fn;
         fn = function( elem, _key, value ) {
           return bulk.call( jQuery( elem ), value );
         };
       }
     }

     if ( fn ) {
       for ( ; i < len; i++ ) {
         fn(
           elems[ i ], key, raw ?
             value :
             value.call( elems[ i ], i, fn( elems[ i ], key ) )
         );
       }
     }
   }

   if ( chainable ) {
     return elems;
   }

   // Gets
   if ( bulk ) {
     return fn.call( elems );
   }

   return len ? fn( elems[ 0 ], key ) : emptyGet;
 };


 // Matches dashed string for camelizing
 var rmsPrefix = /^-ms-/,
   rdashAlpha = /-([a-z])/g;

 // Used by camelCase as callback to replace()
 function fcamelCase( _all, letter ) {
   return letter.toUpperCase();
 }

 // Convert dashed to camelCase; used by the css and data modules
 // Support: IE <=9 - 11, Edge 12 - 15
 // Microsoft forgot to hump their vendor prefix (#9572)
 function camelCase( string ) {
   return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
 }
 var acceptData = function( owner ) {

   // Accepts only:
   //  - Node
   //    - Node.ELEMENT_NODE
   //    - Node.DOCUMENT_NODE
   //  - Object
   //    - Any
   return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
 };




 function Data() {
   this.expando = jQuery.expando + Data.uid++;
 }

 Data.uid = 1;

 Data.prototype = {

   cache: function( owner ) {

     // Check if the owner object already has a cache
     var value = owner[ this.expando ];

     // If not, create one
     if ( !value ) {
       value = {};

       // We can accept data for non-element nodes in modern browsers,
       // but we should not, see #8335.
       // Always return an empty object.
       if ( acceptData( owner ) ) {

         // If it is a node unlikely to be stringify-ed or looped over
         // use plain assignment
         if ( owner.nodeType ) {
           owner[ this.expando ] = value;

         // Otherwise secure it in a non-enumerable property
         // configurable must be true to allow the property to be
         // deleted when data is removed
         } else {
           Object.defineProperty( owner, this.expando, {
             value: value,
             configurable: true
           } );
         }
       }
     }

     return value;
   },
   set: function( owner, data, value ) {
     var prop,
       cache = this.cache( owner );

     // Handle: [ owner, key, value ] args
     // Always use camelCase key (gh-2257)
     if ( typeof data === "string" ) {
       cache[ camelCase( data ) ] = value;

     // Handle: [ owner, { properties } ] args
     } else {

       // Copy the properties one-by-one to the cache object
       for ( prop in data ) {
         cache[ camelCase( prop ) ] = data[ prop ];
       }
     }
     return cache;
   },
   get: function( owner, key ) {
     return key === undefined ?
       this.cache( owner ) :

       // Always use camelCase key (gh-2257)
       owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
   },
   access: function( owner, key, value ) {

     // In cases where either:
     //
     //   1. No key was specified
     //   2. A string key was specified, but no value provided
     //
     // Take the "read" path and allow the get method to determine
     // which value to return, respectively either:
     //
     //   1. The entire cache object
     //   2. The data stored at the key
     //
     if ( key === undefined ||
         ( ( key && typeof key === "string" ) && value === undefined ) ) {

       return this.get( owner, key );
     }

     // When the key is not a string, or both a key and value
     // are specified, set or extend (existing objects) with either:
     //
     //   1. An object of properties
     //   2. A key and value
     //
     this.set( owner, key, value );

     // Since the "set" path can have two possible entry points
     // return the expected data based on which path was taken[*]
     return value !== undefined ? value : key;
   },
   remove: function( owner, key ) {
     var i,
       cache = owner[ this.expando ];

     if ( cache === undefined ) {
       return;
     }

     if ( key !== undefined ) {

       // Support array or space separated string of keys
       if ( Array.isArray( key ) ) {

         // If key is an array of keys...
         // We always set camelCase keys, so remove that.
         key = key.map( camelCase );
       } else {
         key = camelCase( key );

         // If a key with the spaces exists, use it.
         // Otherwise, create an array by matching non-whitespace
         key = key in cache ?
           [ key ] :
           ( key.match( rnothtmlwhite ) || [] );
       }

       i = key.length;

       while ( i-- ) {
         delete cache[ key[ i ] ];
       }
     }

     // Remove the expando if there's no more data
     if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

       // Support: Chrome <=35 - 45
       // Webkit & Blink performance suffers when deleting properties
       // from DOM nodes, so set to undefined instead
       // https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
       if ( owner.nodeType ) {
         owner[ this.expando ] = undefined;
       } else {
         delete owner[ this.expando ];
       }
     }
   },
   hasData: function( owner ) {
     var cache = owner[ this.expando ];
     return cache !== undefined && !jQuery.isEmptyObject( cache );
   }
 };
 var dataPriv = new Data();

 var dataUser = new Data();



 //	Implementation Summary
 //
 //	1. Enforce API surface and semantic compatibility with 1.9.x branch
 //	2. Improve the module's maintainability by reducing the storage
 //		paths to a single mechanism.
 //	3. Use the same single mechanism to support "private" and "user" data.
 //	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
 //	5. Avoid exposing implementation details on user objects (eg. expando properties)
 //	6. Provide a clear path for implementation upgrade to WeakMap in 2014

 var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
   rmultiDash = /[A-Z]/g;

 function getData( data ) {
   if ( data === "true" ) {
     return true;
   }

   if ( data === "false" ) {
     return false;
   }

   if ( data === "null" ) {
     return null;
   }

   // Only convert to a number if it doesn't change the string
   if ( data === +data + "" ) {
     return +data;
   }

   if ( rbrace.test( data ) ) {
     return JSON.parse( data );
   }

   return data;
 }

 function dataAttr( elem, key, data ) {
   var name;

   // If nothing was found internally, try to fetch any
   // data from the HTML5 data-* attribute
   if ( data === undefined && elem.nodeType === 1 ) {
     name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
     data = elem.getAttribute( name );

     if ( typeof data === "string" ) {
       try {
         data = getData( data );
       } catch ( e ) {}

       // Make sure we set the data so it isn't changed later
       dataUser.set( elem, key, data );
     } else {
       data = undefined;
     }
   }
   return data;
 }

 jQuery.extend( {
   hasData: function( elem ) {
     return dataUser.hasData( elem ) || dataPriv.hasData( elem );
   },

   data: function( elem, name, data ) {
     return dataUser.access( elem, name, data );
   },

   removeData: function( elem, name ) {
     dataUser.remove( elem, name );
   },

   // TODO: Now that all calls to _data and _removeData have been replaced
   // with direct calls to dataPriv methods, these can be deprecated.
   _data: function( elem, name, data ) {
     return dataPriv.access( elem, name, data );
   },

   _removeData: function( elem, name ) {
     dataPriv.remove( elem, name );
   }
 } );

 jQuery.fn.extend( {
   data: function( key, value ) {
     var i, name, data,
       elem = this[ 0 ],
       attrs = elem && elem.attributes;

     // Gets all values
     if ( key === undefined ) {
       if ( this.length ) {
         data = dataUser.get( elem );

         if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
           i = attrs.length;
           while ( i-- ) {

             // Support: IE 11 only
             // The attrs elements can be null (#14894)
             if ( attrs[ i ] ) {
               name = attrs[ i ].name;
               if ( name.indexOf( "data-" ) === 0 ) {
                 name = camelCase( name.slice( 5 ) );
                 dataAttr( elem, name, data[ name ] );
               }
             }
           }
           dataPriv.set( elem, "hasDataAttrs", true );
         }
       }

       return data;
     }

     // Sets multiple values
     if ( typeof key === "object" ) {
       return this.each( function() {
         dataUser.set( this, key );
       } );
     }

     return access( this, function( value ) {
       var data;

       // The calling jQuery object (element matches) is not empty
       // (and therefore has an element appears at this[ 0 ]) and the
       // `value` parameter was not undefined. An empty jQuery object
       // will result in `undefined` for elem = this[ 0 ] which will
       // throw an exception if an attempt to read a data cache is made.
       if ( elem && value === undefined ) {

         // Attempt to get data from the cache
         // The key will always be camelCased in Data
         data = dataUser.get( elem, key );
         if ( data !== undefined ) {
           return data;
         }

         // Attempt to "discover" the data in
         // HTML5 custom data-* attrs
         data = dataAttr( elem, key );
         if ( data !== undefined ) {
           return data;
         }

         // We tried really hard, but the data doesn't exist.
         return;
       }

       // Set the data...
       this.each( function() {

         // We always store the camelCased key
         dataUser.set( this, key, value );
       } );
     }, null, value, arguments.length > 1, null, true );
   },

   removeData: function( key ) {
     return this.each( function() {
       dataUser.remove( this, key );
     } );
   }
 } );


 jQuery.extend( {
   queue: function( elem, type, data ) {
     var queue;

     if ( elem ) {
       type = ( type || "fx" ) + "queue";
       queue = dataPriv.get( elem, type );

       // Speed up dequeue by getting out quickly if this is just a lookup
       if ( data ) {
         if ( !queue || Array.isArray( data ) ) {
           queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
         } else {
           queue.push( data );
         }
       }
       return queue || [];
     }
   },

   dequeue: function( elem, type ) {
     type = type || "fx";

     var queue = jQuery.queue( elem, type ),
       startLength = queue.length,
       fn = queue.shift(),
       hooks = jQuery._queueHooks( elem, type ),
       next = function() {
         jQuery.dequeue( elem, type );
       };

     // If the fx queue is dequeued, always remove the progress sentinel
     if ( fn === "inprogress" ) {
       fn = queue.shift();
       startLength--;
     }

     if ( fn ) {

       // Add a progress sentinel to prevent the fx queue from being
       // automatically dequeued
       if ( type === "fx" ) {
         queue.unshift( "inprogress" );
       }

       // Clear up the last queue stop function
       delete hooks.stop;
       fn.call( elem, next, hooks );
     }

     if ( !startLength && hooks ) {
       hooks.empty.fire();
     }
   },

   // Not public - generate a queueHooks object, or return the current one
   _queueHooks: function( elem, type ) {
     var key = type + "queueHooks";
     return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
       empty: jQuery.Callbacks( "once memory" ).add( function() {
         dataPriv.remove( elem, [ type + "queue", key ] );
       } )
     } );
   }
 } );

 jQuery.fn.extend( {
   queue: function( type, data ) {
     var setter = 2;

     if ( typeof type !== "string" ) {
       data = type;
       type = "fx";
       setter--;
     }

     if ( arguments.length < setter ) {
       return jQuery.queue( this[ 0 ], type );
     }

     return data === undefined ?
       this :
       this.each( function() {
         var queue = jQuery.queue( this, type, data );

         // Ensure a hooks for this queue
         jQuery._queueHooks( this, type );

         if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
           jQuery.dequeue( this, type );
         }
       } );
   },
   dequeue: function( type ) {
     return this.each( function() {
       jQuery.dequeue( this, type );
     } );
   },
   clearQueue: function( type ) {
     return this.queue( type || "fx", [] );
   },

   // Get a promise resolved when queues of a certain type
   // are emptied (fx is the type by default)
   promise: function( type, obj ) {
     var tmp,
       count = 1,
       defer = jQuery.Deferred(),
       elements = this,
       i = this.length,
       resolve = function() {
         if ( !( --count ) ) {
           defer.resolveWith( elements, [ elements ] );
         }
       };

     if ( typeof type !== "string" ) {
       obj = type;
       type = undefined;
     }
     type = type || "fx";

     while ( i-- ) {
       tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
       if ( tmp && tmp.empty ) {
         count++;
         tmp.empty.add( resolve );
       }
     }
     resolve();
     return defer.promise( obj );
   }
 } );
 var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

 var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


 var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

 var documentElement = document.documentElement;



   var isAttached = function( elem ) {
       return jQuery.contains( elem.ownerDocument, elem );
     },
     composed = { composed: true };

   // Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
   // Check attachment across shadow DOM boundaries when possible (gh-3504)
   // Support: iOS 10.0-10.2 only
   // Early iOS 10 versions support `attachShadow` but not `getRootNode`,
   // leading to errors. We need to check for `getRootNode`.
   if ( documentElement.getRootNode ) {
     isAttached = function( elem ) {
       return jQuery.contains( elem.ownerDocument, elem ) ||
         elem.getRootNode( composed ) === elem.ownerDocument;
     };
   }
 var isHiddenWithinTree = function( elem, el ) {

     // isHiddenWithinTree might be called from jQuery#filter function;
     // in that case, element will be second argument
     elem = el || elem;

     // Inline style trumps all
     return elem.style.display === "none" ||
       elem.style.display === "" &&

       // Otherwise, check computed style
       // Support: Firefox <=43 - 45
       // Disconnected elements can have computed display: none, so first confirm that elem is
       // in the document.
       isAttached( elem ) &&

       jQuery.css( elem, "display" ) === "none";
   };



 function adjustCSS( elem, prop, valueParts, tween ) {
   var adjusted, scale,
     maxIterations = 20,
     currentValue = tween ?
       function() {
         return tween.cur();
       } :
       function() {
         return jQuery.css( elem, prop, "" );
       },
     initial = currentValue(),
     unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

     // Starting value computation is required for potential unit mismatches
     initialInUnit = elem.nodeType &&
       ( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
       rcssNum.exec( jQuery.css( elem, prop ) );

   if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

     // Support: Firefox <=54
     // Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
     initial = initial / 2;

     // Trust units reported by jQuery.css
     unit = unit || initialInUnit[ 3 ];

     // Iteratively approximate from a nonzero starting point
     initialInUnit = +initial || 1;

     while ( maxIterations-- ) {

       // Evaluate and update our best guess (doubling guesses that zero out).
       // Finish if the scale equals or crosses 1 (making the old*new product non-positive).
       jQuery.style( elem, prop, initialInUnit + unit );
       if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
         maxIterations = 0;
       }
       initialInUnit = initialInUnit / scale;

     }

     initialInUnit = initialInUnit * 2;
     jQuery.style( elem, prop, initialInUnit + unit );

     // Make sure we update the tween properties later on
     valueParts = valueParts || [];
   }

   if ( valueParts ) {
     initialInUnit = +initialInUnit || +initial || 0;

     // Apply relative offset (+=/-=) if specified
     adjusted = valueParts[ 1 ] ?
       initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
       +valueParts[ 2 ];
     if ( tween ) {
       tween.unit = unit;
       tween.start = initialInUnit;
       tween.end = adjusted;
     }
   }
   return adjusted;
 }


 var defaultDisplayMap = {};

 function getDefaultDisplay( elem ) {
   var temp,
     doc = elem.ownerDocument,
     nodeName = elem.nodeName,
     display = defaultDisplayMap[ nodeName ];

   if ( display ) {
     return display;
   }

   temp = doc.body.appendChild( doc.createElement( nodeName ) );
   display = jQuery.css( temp, "display" );

   temp.parentNode.removeChild( temp );

   if ( display === "none" ) {
     display = "block";
   }
   defaultDisplayMap[ nodeName ] = display;

   return display;
 }

 function showHide( elements, show ) {
   var display, elem,
     values = [],
     index = 0,
     length = elements.length;

   // Determine new display value for elements that need to change
   for ( ; index < length; index++ ) {
     elem = elements[ index ];
     if ( !elem.style ) {
       continue;
     }

     display = elem.style.display;
     if ( show ) {

       // Since we force visibility upon cascade-hidden elements, an immediate (and slow)
       // check is required in this first loop unless we have a nonempty display value (either
       // inline or about-to-be-restored)
       if ( display === "none" ) {
         values[ index ] = dataPriv.get( elem, "display" ) || null;
         if ( !values[ index ] ) {
           elem.style.display = "";
         }
       }
       if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
         values[ index ] = getDefaultDisplay( elem );
       }
     } else {
       if ( display !== "none" ) {
         values[ index ] = "none";

         // Remember what we're overwriting
         dataPriv.set( elem, "display", display );
       }
     }
   }

   // Set the display of the elements in a second loop to avoid constant reflow
   for ( index = 0; index < length; index++ ) {
     if ( values[ index ] != null ) {
       elements[ index ].style.display = values[ index ];
     }
   }

   return elements;
 }

 jQuery.fn.extend( {
   show: function() {
     return showHide( this, true );
   },
   hide: function() {
     return showHide( this );
   },
   toggle: function( state ) {
     if ( typeof state === "boolean" ) {
       return state ? this.show() : this.hide();
     }

     return this.each( function() {
       if ( isHiddenWithinTree( this ) ) {
         jQuery( this ).show();
       } else {
         jQuery( this ).hide();
       }
     } );
   }
 } );
 var rcheckableType = ( /^(?:checkbox|radio)$/i );

 var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]*)/i );

 var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );



 ( function() {
   var fragment = document.createDocumentFragment(),
     div = fragment.appendChild( document.createElement( "div" ) ),
     input = document.createElement( "input" );

   // Support: Android 4.0 - 4.3 only
   // Check state lost if the name is set (#11217)
   // Support: Windows Web Apps (WWA)
   // `name` and `type` must use .setAttribute for WWA (#14901)
   input.setAttribute( "type", "radio" );
   input.setAttribute( "checked", "checked" );
   input.setAttribute( "name", "t" );

   div.appendChild( input );

   // Support: Android <=4.1 only
   // Older WebKit doesn't clone checked state correctly in fragments
   support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

   // Support: IE <=11 only
   // Make sure textarea (and checkbox) defaultValue is properly cloned
   div.innerHTML = "<textarea>x</textarea>";
   support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;

   // Support: IE <=9 only
   // IE <=9 replaces <option> tags with their contents when inserted outside of
   // the select element.
   div.innerHTML = "<option></option>";
   support.option = !!div.lastChild;
 } )();


 // We have to close these tags to support XHTML (#13200)
 var wrapMap = {

   // XHTML parsers do not magically insert elements in the
   // same way that tag soup parsers do. So we cannot shorten
   // this by omitting <tbody> or other required elements.
   thead: [ 1, "<table>", "</table>" ],
   col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
   tr: [ 2, "<table><tbody>", "</tbody></table>" ],
   td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

   _default: [ 0, "", "" ]
 };

 wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
 wrapMap.th = wrapMap.td;

 // Support: IE <=9 only
 if ( !support.option ) {
   wrapMap.optgroup = wrapMap.option = [ 1, "<select multiple='multiple'>", "</select>" ];
 }


 function getAll( context, tag ) {

   // Support: IE <=9 - 11 only
   // Use typeof to avoid zero-argument method invocation on host objects (#15151)
   var ret;

   if ( typeof context.getElementsByTagName !== "undefined" ) {
     ret = context.getElementsByTagName( tag || "*" );

   } else if ( typeof context.querySelectorAll !== "undefined" ) {
     ret = context.querySelectorAll( tag || "*" );

   } else {
     ret = [];
   }

   if ( tag === undefined || tag && nodeName( context, tag ) ) {
     return jQuery.merge( [ context ], ret );
   }

   return ret;
 }


 // Mark scripts as having already been evaluated
 function setGlobalEval( elems, refElements ) {
   var i = 0,
     l = elems.length;

   for ( ; i < l; i++ ) {
     dataPriv.set(
       elems[ i ],
       "globalEval",
       !refElements || dataPriv.get( refElements[ i ], "globalEval" )
     );
   }
 }


 var rhtml = /<|&#?\w+;/;

 function buildFragment( elems, context, scripts, selection, ignored ) {
   var elem, tmp, tag, wrap, attached, j,
     fragment = context.createDocumentFragment(),
     nodes = [],
     i = 0,
     l = elems.length;

   for ( ; i < l; i++ ) {
     elem = elems[ i ];

     if ( elem || elem === 0 ) {

       // Add nodes directly
       if ( toType( elem ) === "object" ) {

         // Support: Android <=4.0 only, PhantomJS 1 only
         // push.apply(_, arraylike) throws on ancient WebKit
         jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

       // Convert non-html into a text node
       } else if ( !rhtml.test( elem ) ) {
         nodes.push( context.createTextNode( elem ) );

       // Convert html into DOM nodes
       } else {
         tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

         // Deserialize a standard representation
         tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
         wrap = wrapMap[ tag ] || wrapMap._default;
         tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

         // Descend through wrappers to the right content
         j = wrap[ 0 ];
         while ( j-- ) {
           tmp = tmp.lastChild;
         }

         // Support: Android <=4.0 only, PhantomJS 1 only
         // push.apply(_, arraylike) throws on ancient WebKit
         jQuery.merge( nodes, tmp.childNodes );

         // Remember the top-level container
         tmp = fragment.firstChild;

         // Ensure the created nodes are orphaned (#12392)
         tmp.textContent = "";
       }
     }
   }

   // Remove wrapper from fragment
   fragment.textContent = "";

   i = 0;
   while ( ( elem = nodes[ i++ ] ) ) {

     // Skip elements already in the context collection (trac-4087)
     if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
       if ( ignored ) {
         ignored.push( elem );
       }
       continue;
     }

     attached = isAttached( elem );

     // Append to fragment
     tmp = getAll( fragment.appendChild( elem ), "script" );

     // Preserve script evaluation history
     if ( attached ) {
       setGlobalEval( tmp );
     }

     // Capture executables
     if ( scripts ) {
       j = 0;
       while ( ( elem = tmp[ j++ ] ) ) {
         if ( rscriptType.test( elem.type || "" ) ) {
           scripts.push( elem );
         }
       }
     }
   }

   return fragment;
 }


 var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

 function returnTrue() {
   return true;
 }

 function returnFalse() {
   return false;
 }

 // Support: IE <=9 - 11+
 // focus() and blur() are asynchronous, except when they are no-op.
 // So expect focus to be synchronous when the element is already active,
 // and blur to be synchronous when the element is not already active.
 // (focus and blur are always synchronous in other supported browsers,
 // this just defines when we can count on it).
 function expectSync( elem, type ) {
   return ( elem === safeActiveElement() ) === ( type === "focus" );
 }

 // Support: IE <=9 only
 // Accessing document.activeElement can throw unexpectedly
 // https://bugs.jquery.com/ticket/13393
 function safeActiveElement() {
   try {
     return document.activeElement;
   } catch ( err ) { }
 }

 function on( elem, types, selector, data, fn, one ) {
   var origFn, type;

   // Types can be a map of types/handlers
   if ( typeof types === "object" ) {

     // ( types-Object, selector, data )
     if ( typeof selector !== "string" ) {

       // ( types-Object, data )
       data = data || selector;
       selector = undefined;
     }
     for ( type in types ) {
       on( elem, type, selector, data, types[ type ], one );
     }
     return elem;
   }

   if ( data == null && fn == null ) {

     // ( types, fn )
     fn = selector;
     data = selector = undefined;
   } else if ( fn == null ) {
     if ( typeof selector === "string" ) {

       // ( types, selector, fn )
       fn = data;
       data = undefined;
     } else {

       // ( types, data, fn )
       fn = data;
       data = selector;
       selector = undefined;
     }
   }
   if ( fn === false ) {
     fn = returnFalse;
   } else if ( !fn ) {
     return elem;
   }

   if ( one === 1 ) {
     origFn = fn;
     fn = function( event ) {

       // Can use an empty set, since event contains the info
       jQuery().off( event );
       return origFn.apply( this, arguments );
     };

     // Use same guid so caller can remove using origFn
     fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
   }
   return elem.each( function() {
     jQuery.event.add( this, types, fn, data, selector );
   } );
 }

 /*
  * Helper functions for managing events -- not part of the public interface.
  * Props to Dean Edwards' addEvent library for many of the ideas.
  */
 jQuery.event = {

   global: {},

   add: function( elem, types, handler, data, selector ) {

     var handleObjIn, eventHandle, tmp,
       events, t, handleObj,
       special, handlers, type, namespaces, origType,
       elemData = dataPriv.get( elem );

     // Only attach events to objects that accept data
     if ( !acceptData( elem ) ) {
       return;
     }

     // Caller can pass in an object of custom data in lieu of the handler
     if ( handler.handler ) {
       handleObjIn = handler;
       handler = handleObjIn.handler;
       selector = handleObjIn.selector;
     }

     // Ensure that invalid selectors throw exceptions at attach time
     // Evaluate against documentElement in case elem is a non-element node (e.g., document)
     if ( selector ) {
       jQuery.find.matchesSelector( documentElement, selector );
     }

     // Make sure that the handler has a unique ID, used to find/remove it later
     if ( !handler.guid ) {
       handler.guid = jQuery.guid++;
     }

     // Init the element's event structure and main handler, if this is the first
     if ( !( events = elemData.events ) ) {
       events = elemData.events = Object.create( null );
     }
     if ( !( eventHandle = elemData.handle ) ) {
       eventHandle = elemData.handle = function( e ) {

         // Discard the second event of a jQuery.event.trigger() and
         // when an event is called after a page has unloaded
         return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
           jQuery.event.dispatch.apply( elem, arguments ) : undefined;
       };
     }

     // Handle multiple events separated by a space
     types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
     t = types.length;
     while ( t-- ) {
       tmp = rtypenamespace.exec( types[ t ] ) || [];
       type = origType = tmp[ 1 ];
       namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

       // There *must* be a type, no attaching namespace-only handlers
       if ( !type ) {
         continue;
       }

       // If event changes its type, use the special event handlers for the changed type
       special = jQuery.event.special[ type ] || {};

       // If selector defined, determine special event api type, otherwise given type
       type = ( selector ? special.delegateType : special.bindType ) || type;

       // Update special based on newly reset type
       special = jQuery.event.special[ type ] || {};

       // handleObj is passed to all event handlers
       handleObj = jQuery.extend( {
         type: type,
         origType: origType,
         data: data,
         handler: handler,
         guid: handler.guid,
         selector: selector,
         needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
         namespace: namespaces.join( "." )
       }, handleObjIn );

       // Init the event handler queue if we're the first
       if ( !( handlers = events[ type ] ) ) {
         handlers = events[ type ] = [];
         handlers.delegateCount = 0;

         // Only use addEventListener if the special events handler returns false
         if ( !special.setup ||
           special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

           if ( elem.addEventListener ) {
             elem.addEventListener( type, eventHandle );
           }
         }
       }

       if ( special.add ) {
         special.add.call( elem, handleObj );

         if ( !handleObj.handler.guid ) {
           handleObj.handler.guid = handler.guid;
         }
       }

       // Add to the element's handler list, delegates in front
       if ( selector ) {
         handlers.splice( handlers.delegateCount++, 0, handleObj );
       } else {
         handlers.push( handleObj );
       }

       // Keep track of which events have ever been used, for event optimization
       jQuery.event.global[ type ] = true;
     }

   },

   // Detach an event or set of events from an element
   remove: function( elem, types, handler, selector, mappedTypes ) {

     var j, origCount, tmp,
       events, t, handleObj,
       special, handlers, type, namespaces, origType,
       elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

     if ( !elemData || !( events = elemData.events ) ) {
       return;
     }

     // Once for each type.namespace in types; type may be omitted
     types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
     t = types.length;
     while ( t-- ) {
       tmp = rtypenamespace.exec( types[ t ] ) || [];
       type = origType = tmp[ 1 ];
       namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

       // Unbind all events (on this namespace, if provided) for the element
       if ( !type ) {
         for ( type in events ) {
           jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
         }
         continue;
       }

       special = jQuery.event.special[ type ] || {};
       type = ( selector ? special.delegateType : special.bindType ) || type;
       handlers = events[ type ] || [];
       tmp = tmp[ 2 ] &&
         new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

       // Remove matching events
       origCount = j = handlers.length;
       while ( j-- ) {
         handleObj = handlers[ j ];

         if ( ( mappedTypes || origType === handleObj.origType ) &&
           ( !handler || handler.guid === handleObj.guid ) &&
           ( !tmp || tmp.test( handleObj.namespace ) ) &&
           ( !selector || selector === handleObj.selector ||
             selector === "**" && handleObj.selector ) ) {
           handlers.splice( j, 1 );

           if ( handleObj.selector ) {
             handlers.delegateCount--;
           }
           if ( special.remove ) {
             special.remove.call( elem, handleObj );
           }
         }
       }

       // Remove generic event handler if we removed something and no more handlers exist
       // (avoids potential for endless recursion during removal of special event handlers)
       if ( origCount && !handlers.length ) {
         if ( !special.teardown ||
           special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

           jQuery.removeEvent( elem, type, elemData.handle );
         }

         delete events[ type ];
       }
     }

     // Remove data and the expando if it's no longer used
     if ( jQuery.isEmptyObject( events ) ) {
       dataPriv.remove( elem, "handle events" );
     }
   },

   dispatch: function( nativeEvent ) {

     var i, j, ret, matched, handleObj, handlerQueue,
       args = new Array( arguments.length ),

       // Make a writable jQuery.Event from the native event object
       event = jQuery.event.fix( nativeEvent ),

       handlers = (
         dataPriv.get( this, "events" ) || Object.create( null )
       )[ event.type ] || [],
       special = jQuery.event.special[ event.type ] || {};

     // Use the fix-ed jQuery.Event rather than the (read-only) native event
     args[ 0 ] = event;

     for ( i = 1; i < arguments.length; i++ ) {
       args[ i ] = arguments[ i ];
     }

     event.delegateTarget = this;

     // Call the preDispatch hook for the mapped type, and let it bail if desired
     if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
       return;
     }

     // Determine handlers
     handlerQueue = jQuery.event.handlers.call( this, event, handlers );

     // Run delegates first; they may want to stop propagation beneath us
     i = 0;
     while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
       event.currentTarget = matched.elem;

       j = 0;
       while ( ( handleObj = matched.handlers[ j++ ] ) &&
         !event.isImmediatePropagationStopped() ) {

         // If the event is namespaced, then each handler is only invoked if it is
         // specially universal or its namespaces are a superset of the event's.
         if ( !event.rnamespace || handleObj.namespace === false ||
           event.rnamespace.test( handleObj.namespace ) ) {

           event.handleObj = handleObj;
           event.data = handleObj.data;

           ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
             handleObj.handler ).apply( matched.elem, args );

           if ( ret !== undefined ) {
             if ( ( event.result = ret ) === false ) {
               event.preventDefault();
               event.stopPropagation();
             }
           }
         }
       }
     }

     // Call the postDispatch hook for the mapped type
     if ( special.postDispatch ) {
       special.postDispatch.call( this, event );
     }

     return event.result;
   },

   handlers: function( event, handlers ) {
     var i, handleObj, sel, matchedHandlers, matchedSelectors,
       handlerQueue = [],
       delegateCount = handlers.delegateCount,
       cur = event.target;

     // Find delegate handlers
     if ( delegateCount &&

       // Support: IE <=9
       // Black-hole SVG <use> instance trees (trac-13180)
       cur.nodeType &&

       // Support: Firefox <=42
       // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
       // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
       // Support: IE 11 only
       // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
       !( event.type === "click" && event.button >= 1 ) ) {

       for ( ; cur !== this; cur = cur.parentNode || this ) {

         // Don't check non-elements (#13208)
         // Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
         if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
           matchedHandlers = [];
           matchedSelectors = {};
           for ( i = 0; i < delegateCount; i++ ) {
             handleObj = handlers[ i ];

             // Don't conflict with Object.prototype properties (#13203)
             sel = handleObj.selector + " ";

             if ( matchedSelectors[ sel ] === undefined ) {
               matchedSelectors[ sel ] = handleObj.needsContext ?
                 jQuery( sel, this ).index( cur ) > -1 :
                 jQuery.find( sel, this, null, [ cur ] ).length;
             }
             if ( matchedSelectors[ sel ] ) {
               matchedHandlers.push( handleObj );
             }
           }
           if ( matchedHandlers.length ) {
             handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
           }
         }
       }
     }

     // Add the remaining (directly-bound) handlers
     cur = this;
     if ( delegateCount < handlers.length ) {
       handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
     }

     return handlerQueue;
   },

   addProp: function( name, hook ) {
     Object.defineProperty( jQuery.Event.prototype, name, {
       enumerable: true,
       configurable: true,

       get: isFunction( hook ) ?
         function() {
           if ( this.originalEvent ) {
             return hook( this.originalEvent );
           }
         } :
         function() {
           if ( this.originalEvent ) {
             return this.originalEvent[ name ];
           }
         },

       set: function( value ) {
         Object.defineProperty( this, name, {
           enumerable: true,
           configurable: true,
           writable: true,
           value: value
         } );
       }
     } );
   },

   fix: function( originalEvent ) {
     return originalEvent[ jQuery.expando ] ?
       originalEvent :
       new jQuery.Event( originalEvent );
   },

   special: {
     load: {

       // Prevent triggered image.load events from bubbling to window.load
       noBubble: true
     },
     click: {

       // Utilize native event to ensure correct state for checkable inputs
       setup: function( data ) {

         // For mutual compressibility with _default, replace `this` access with a local var.
         // `|| data` is dead code meant only to preserve the variable through minification.
         var el = this || data;

         // Claim the first handler
         if ( rcheckableType.test( el.type ) &&
           el.click && nodeName( el, "input" ) ) {

           // dataPriv.set( el, "click", ... )
           leverageNative( el, "click", returnTrue );
         }

         // Return false to allow normal processing in the caller
         return false;
       },
       trigger: function( data ) {

         // For mutual compressibility with _default, replace `this` access with a local var.
         // `|| data` is dead code meant only to preserve the variable through minification.
         var el = this || data;

         // Force setup before triggering a click
         if ( rcheckableType.test( el.type ) &&
           el.click && nodeName( el, "input" ) ) {

           leverageNative( el, "click" );
         }

         // Return non-false to allow normal event-path propagation
         return true;
       },

       // For cross-browser consistency, suppress native .click() on links
       // Also prevent it if we're currently inside a leveraged native-event stack
       _default: function( event ) {
         var target = event.target;
         return rcheckableType.test( target.type ) &&
           target.click && nodeName( target, "input" ) &&
           dataPriv.get( target, "click" ) ||
           nodeName( target, "a" );
       }
     },

     beforeunload: {
       postDispatch: function( event ) {

         // Support: Firefox 20+
         // Firefox doesn't alert if the returnValue field is not set.
         if ( event.result !== undefined && event.originalEvent ) {
           event.originalEvent.returnValue = event.result;
         }
       }
     }
   }
 };

 // Ensure the presence of an event listener that handles manually-triggered
 // synthetic events by interrupting progress until reinvoked in response to
 // *native* events that it fires directly, ensuring that state changes have
 // already occurred before other listeners are invoked.
 function leverageNative( el, type, expectSync ) {

   // Missing expectSync indicates a trigger call, which must force setup through jQuery.event.add
   if ( !expectSync ) {
     if ( dataPriv.get( el, type ) === undefined ) {
       jQuery.event.add( el, type, returnTrue );
     }
     return;
   }

   // Register the controller as a special universal handler for all event namespaces
   dataPriv.set( el, type, false );
   jQuery.event.add( el, type, {
     namespace: false,
     handler: function( event ) {
       var notAsync, result,
         saved = dataPriv.get( this, type );

       if ( ( event.isTrigger & 1 ) && this[ type ] ) {

         // Interrupt processing of the outer synthetic .trigger()ed event
         // Saved data should be false in such cases, but might be a leftover capture object
         // from an async native handler (gh-4350)
         if ( !saved.length ) {

           // Store arguments for use when handling the inner native event
           // There will always be at least one argument (an event object), so this array
           // will not be confused with a leftover capture object.
           saved = slice.call( arguments );
           dataPriv.set( this, type, saved );

           // Trigger the native event and capture its result
           // Support: IE <=9 - 11+
           // focus() and blur() are asynchronous
           notAsync = expectSync( this, type );
           this[ type ]();
           result = dataPriv.get( this, type );
           if ( saved !== result || notAsync ) {
             dataPriv.set( this, type, false );
           } else {
             result = {};
           }
           if ( saved !== result ) {

             // Cancel the outer synthetic event
             event.stopImmediatePropagation();
             event.preventDefault();

             // Support: Chrome 86+
             // In Chrome, if an element having a focusout handler is blurred by
             // clicking outside of it, it invokes the handler synchronously. If
             // that handler calls `.remove()` on the element, the data is cleared,
             // leaving `result` undefined. We need to guard against this.
             return result && result.value;
           }

         // If this is an inner synthetic event for an event with a bubbling surrogate
         // (focus or blur), assume that the surrogate already propagated from triggering the
         // native event and prevent that from happening again here.
         // This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
         // bubbling surrogate propagates *after* the non-bubbling base), but that seems
         // less bad than duplication.
         } else if ( ( jQuery.event.special[ type ] || {} ).delegateType ) {
           event.stopPropagation();
         }

       // If this is a native event triggered above, everything is now in order
       // Fire an inner synthetic event with the original arguments
       } else if ( saved.length ) {

         // ...and capture the result
         dataPriv.set( this, type, {
           value: jQuery.event.trigger(

             // Support: IE <=9 - 11+
             // Extend with the prototype to reset the above stopImmediatePropagation()
             jQuery.extend( saved[ 0 ], jQuery.Event.prototype ),
             saved.slice( 1 ),
             this
           )
         } );

         // Abort handling of the native event
         event.stopImmediatePropagation();
       }
     }
   } );
 }

 jQuery.removeEvent = function( elem, type, handle ) {

   // This "if" is needed for plain objects
   if ( elem.removeEventListener ) {
     elem.removeEventListener( type, handle );
   }
 };

 jQuery.Event = function( src, props ) {

   // Allow instantiation without the 'new' keyword
   if ( !( this instanceof jQuery.Event ) ) {
     return new jQuery.Event( src, props );
   }

   // Event object
   if ( src && src.type ) {
     this.originalEvent = src;
     this.type = src.type;

     // Events bubbling up the document may have been marked as prevented
     // by a handler lower down the tree; reflect the correct value.
     this.isDefaultPrevented = src.defaultPrevented ||
         src.defaultPrevented === undefined &&

         // Support: Android <=2.3 only
         src.returnValue === false ?
       returnTrue :
       returnFalse;

     // Create target properties
     // Support: Safari <=6 - 7 only
     // Target should not be a text node (#504, #13143)
     this.target = ( src.target && src.target.nodeType === 3 ) ?
       src.target.parentNode :
       src.target;

     this.currentTarget = src.currentTarget;
     this.relatedTarget = src.relatedTarget;

   // Event type
   } else {
     this.type = src;
   }

   // Put explicitly provided properties onto the event object
   if ( props ) {
     jQuery.extend( this, props );
   }

   // Create a timestamp if incoming event doesn't have one
   this.timeStamp = src && src.timeStamp || Date.now();

   // Mark it as fixed
   this[ jQuery.expando ] = true;
 };

 // jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
 // https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
 jQuery.Event.prototype = {
   constructor: jQuery.Event,
   isDefaultPrevented: returnFalse,
   isPropagationStopped: returnFalse,
   isImmediatePropagationStopped: returnFalse,
   isSimulated: false,

   preventDefault: function() {
     var e = this.originalEvent;

     this.isDefaultPrevented = returnTrue;

     if ( e && !this.isSimulated ) {
       e.preventDefault();
     }
   },
   stopPropagation: function() {
     var e = this.originalEvent;

     this.isPropagationStopped = returnTrue;

     if ( e && !this.isSimulated ) {
       e.stopPropagation();
     }
   },
   stopImmediatePropagation: function() {
     var e = this.originalEvent;

     this.isImmediatePropagationStopped = returnTrue;

     if ( e && !this.isSimulated ) {
       e.stopImmediatePropagation();
     }

     this.stopPropagation();
   }
 };

 // Includes all common event props including KeyEvent and MouseEvent specific props
 jQuery.each( {
   altKey: true,
   bubbles: true,
   cancelable: true,
   changedTouches: true,
   ctrlKey: true,
   detail: true,
   eventPhase: true,
   metaKey: true,
   pageX: true,
   pageY: true,
   shiftKey: true,
   view: true,
   "char": true,
   code: true,
   charCode: true,
   key: true,
   keyCode: true,
   button: true,
   buttons: true,
   clientX: true,
   clientY: true,
   offsetX: true,
   offsetY: true,
   pointerId: true,
   pointerType: true,
   screenX: true,
   screenY: true,
   targetTouches: true,
   toElement: true,
   touches: true,
   which: true
 }, jQuery.event.addProp );

 jQuery.each( { focus: "focusin", blur: "focusout" }, function( type, delegateType ) {
   jQuery.event.special[ type ] = {

     // Utilize native event if possible so blur/focus sequence is correct
     setup: function() {

       // Claim the first handler
       // dataPriv.set( this, "focus", ... )
       // dataPriv.set( this, "blur", ... )
       leverageNative( this, type, expectSync );

       // Return false to allow normal processing in the caller
       return false;
     },
     trigger: function() {

       // Force setup before trigger
       leverageNative( this, type );

       // Return non-false to allow normal event-path propagation
       return true;
     },

     // Suppress native focus or blur as it's already being fired
     // in leverageNative.
     _default: function() {
       return true;
     },

     delegateType: delegateType
   };
 } );

 // Create mouseenter/leave events using mouseover/out and event-time checks
 // so that event delegation works in jQuery.
 // Do the same for pointerenter/pointerleave and pointerover/pointerout
 //
 // Support: Safari 7 only
 // Safari sends mouseenter too often; see:
 // https://bugs.chromium.org/p/chromium/issues/detail?id=470258
 // for the description of the bug (it existed in older Chrome versions as well).
 jQuery.each( {
   mouseenter: "mouseover",
   mouseleave: "mouseout",
   pointerenter: "pointerover",
   pointerleave: "pointerout"
 }, function( orig, fix ) {
   jQuery.event.special[ orig ] = {
     delegateType: fix,
     bindType: fix,

     handle: function( event ) {
       var ret,
         target = this,
         related = event.relatedTarget,
         handleObj = event.handleObj;

       // For mouseenter/leave call the handler if related is outside the target.
       // NB: No relatedTarget if the mouse left/entered the browser window
       if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
         event.type = handleObj.origType;
         ret = handleObj.handler.apply( this, arguments );
         event.type = fix;
       }
       return ret;
     }
   };
 } );

 jQuery.fn.extend( {

   on: function( types, selector, data, fn ) {
     return on( this, types, selector, data, fn );
   },
   one: function( types, selector, data, fn ) {
     return on( this, types, selector, data, fn, 1 );
   },
   off: function( types, selector, fn ) {
     var handleObj, type;
     if ( types && types.preventDefault && types.handleObj ) {

       // ( event )  dispatched jQuery.Event
       handleObj = types.handleObj;
       jQuery( types.delegateTarget ).off(
         handleObj.namespace ?
           handleObj.origType + "." + handleObj.namespace :
           handleObj.origType,
         handleObj.selector,
         handleObj.handler
       );
       return this;
     }
     if ( typeof types === "object" ) {

       // ( types-object [, selector] )
       for ( type in types ) {
         this.off( type, selector, types[ type ] );
       }
       return this;
     }
     if ( selector === false || typeof selector === "function" ) {

       // ( types [, fn] )
       fn = selector;
       selector = undefined;
     }
     if ( fn === false ) {
       fn = returnFalse;
     }
     return this.each( function() {
       jQuery.event.remove( this, types, fn, selector );
     } );
   }
 } );


 var

   // Support: IE <=10 - 11, Edge 12 - 13 only
   // In IE/Edge using regex groups here causes severe slowdowns.
   // See https://connect.microsoft.com/IE/feedback/details/1736512/
   rnoInnerhtml = /<script|<style|<link/i,

   // checked="checked" or checked
   rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
   rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

 // Prefer a tbody over its parent table for containing new rows
 function manipulationTarget( elem, content ) {
   if ( nodeName( elem, "table" ) &&
     nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

     return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
   }

   return elem;
 }

 // Replace/restore the type attribute of script elements for safe DOM manipulation
 function disableScript( elem ) {
   elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
   return elem;
 }
 function restoreScript( elem ) {
   if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
     elem.type = elem.type.slice( 5 );
   } else {
     elem.removeAttribute( "type" );
   }

   return elem;
 }

 function cloneCopyEvent( src, dest ) {
   var i, l, type, pdataOld, udataOld, udataCur, events;

   if ( dest.nodeType !== 1 ) {
     return;
   }

   // 1. Copy private data: events, handlers, etc.
   if ( dataPriv.hasData( src ) ) {
     pdataOld = dataPriv.get( src );
     events = pdataOld.events;

     if ( events ) {
       dataPriv.remove( dest, "handle events" );

       for ( type in events ) {
         for ( i = 0, l = events[ type ].length; i < l; i++ ) {
           jQuery.event.add( dest, type, events[ type ][ i ] );
         }
       }
     }
   }

   // 2. Copy user data
   if ( dataUser.hasData( src ) ) {
     udataOld = dataUser.access( src );
     udataCur = jQuery.extend( {}, udataOld );

     dataUser.set( dest, udataCur );
   }
 }

 // Fix IE bugs, see support tests
 function fixInput( src, dest ) {
   var nodeName = dest.nodeName.toLowerCase();

   // Fails to persist the checked state of a cloned checkbox or radio button.
   if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
     dest.checked = src.checked;

   // Fails to return the selected option to the default selected state when cloning options
   } else if ( nodeName === "input" || nodeName === "textarea" ) {
     dest.defaultValue = src.defaultValue;
   }
 }

 function domManip( collection, args, callback, ignored ) {

   // Flatten any nested arrays
   args = flat( args );

   var fragment, first, scripts, hasScripts, node, doc,
     i = 0,
     l = collection.length,
     iNoClone = l - 1,
     value = args[ 0 ],
     valueIsFunction = isFunction( value );

   // We can't cloneNode fragments that contain checked, in WebKit
   if ( valueIsFunction ||
       ( l > 1 && typeof value === "string" &&
         !support.checkClone && rchecked.test( value ) ) ) {
     return collection.each( function( index ) {
       var self = collection.eq( index );
       if ( valueIsFunction ) {
         args[ 0 ] = value.call( this, index, self.html() );
       }
       domManip( self, args, callback, ignored );
     } );
   }

   if ( l ) {
     fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
     first = fragment.firstChild;

     if ( fragment.childNodes.length === 1 ) {
       fragment = first;
     }

     // Require either new content or an interest in ignored elements to invoke the callback
     if ( first || ignored ) {
       scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
       hasScripts = scripts.length;

       // Use the original fragment for the last item
       // instead of the first because it can end up
       // being emptied incorrectly in certain situations (#8070).
       for ( ; i < l; i++ ) {
         node = fragment;

         if ( i !== iNoClone ) {
           node = jQuery.clone( node, true, true );

           // Keep references to cloned scripts for later restoration
           if ( hasScripts ) {

             // Support: Android <=4.0 only, PhantomJS 1 only
             // push.apply(_, arraylike) throws on ancient WebKit
             jQuery.merge( scripts, getAll( node, "script" ) );
           }
         }

         callback.call( collection[ i ], node, i );
       }

       if ( hasScripts ) {
         doc = scripts[ scripts.length - 1 ].ownerDocument;

         // Reenable scripts
         jQuery.map( scripts, restoreScript );

         // Evaluate executable scripts on first document insertion
         for ( i = 0; i < hasScripts; i++ ) {
           node = scripts[ i ];
           if ( rscriptType.test( node.type || "" ) &&
             !dataPriv.access( node, "globalEval" ) &&
             jQuery.contains( doc, node ) ) {

             if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {

               // Optional AJAX dependency, but won't run scripts if not present
               if ( jQuery._evalUrl && !node.noModule ) {
                 jQuery._evalUrl( node.src, {
                   nonce: node.nonce || node.getAttribute( "nonce" )
                 }, doc );
               }
             } else {
               DOMEval( node.textContent.replace( rcleanScript, "" ), node, doc );
             }
           }
         }
       }
     }
   }

   return collection;
 }

 function remove( elem, selector, keepData ) {
   var node,
     nodes = selector ? jQuery.filter( selector, elem ) : elem,
     i = 0;

   for ( ; ( node = nodes[ i ] ) != null; i++ ) {
     if ( !keepData && node.nodeType === 1 ) {
       jQuery.cleanData( getAll( node ) );
     }

     if ( node.parentNode ) {
       if ( keepData && isAttached( node ) ) {
         setGlobalEval( getAll( node, "script" ) );
       }
       node.parentNode.removeChild( node );
     }
   }

   return elem;
 }

 jQuery.extend( {
   htmlPrefilter: function( html ) {
     return html;
   },

   clone: function( elem, dataAndEvents, deepDataAndEvents ) {
     var i, l, srcElements, destElements,
       clone = elem.cloneNode( true ),
       inPage = isAttached( elem );

     // Fix IE cloning issues
     if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
         !jQuery.isXMLDoc( elem ) ) {

       // We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
       destElements = getAll( clone );
       srcElements = getAll( elem );

       for ( i = 0, l = srcElements.length; i < l; i++ ) {
         fixInput( srcElements[ i ], destElements[ i ] );
       }
     }

     // Copy the events from the original to the clone
     if ( dataAndEvents ) {
       if ( deepDataAndEvents ) {
         srcElements = srcElements || getAll( elem );
         destElements = destElements || getAll( clone );

         for ( i = 0, l = srcElements.length; i < l; i++ ) {
           cloneCopyEvent( srcElements[ i ], destElements[ i ] );
         }
       } else {
         cloneCopyEvent( elem, clone );
       }
     }

     // Preserve script evaluation history
     destElements = getAll( clone, "script" );
     if ( destElements.length > 0 ) {
       setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
     }

     // Return the cloned set
     return clone;
   },

   cleanData: function( elems ) {
     var data, elem, type,
       special = jQuery.event.special,
       i = 0;

     for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
       if ( acceptData( elem ) ) {
         if ( ( data = elem[ dataPriv.expando ] ) ) {
           if ( data.events ) {
             for ( type in data.events ) {
               if ( special[ type ] ) {
                 jQuery.event.remove( elem, type );

               // This is a shortcut to avoid jQuery.event.remove's overhead
               } else {
                 jQuery.removeEvent( elem, type, data.handle );
               }
             }
           }

           // Support: Chrome <=35 - 45+
           // Assign undefined instead of using delete, see Data#remove
           elem[ dataPriv.expando ] = undefined;
         }
         if ( elem[ dataUser.expando ] ) {

           // Support: Chrome <=35 - 45+
           // Assign undefined instead of using delete, see Data#remove
           elem[ dataUser.expando ] = undefined;
         }
       }
     }
   }
 } );

 jQuery.fn.extend( {
   detach: function( selector ) {
     return remove( this, selector, true );
   },

   remove: function( selector ) {
     return remove( this, selector );
   },

   text: function( value ) {
     return access( this, function( value ) {
       return value === undefined ?
         jQuery.text( this ) :
         this.empty().each( function() {
           if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
             this.textContent = value;
           }
         } );
     }, null, value, arguments.length );
   },

   append: function() {
     return domManip( this, arguments, function( elem ) {
       if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
         var target = manipulationTarget( this, elem );
         target.appendChild( elem );
       }
     } );
   },

   prepend: function() {
     return domManip( this, arguments, function( elem ) {
       if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
         var target = manipulationTarget( this, elem );
         target.insertBefore( elem, target.firstChild );
       }
     } );
   },

   before: function() {
     return domManip( this, arguments, function( elem ) {
       if ( this.parentNode ) {
         this.parentNode.insertBefore( elem, this );
       }
     } );
   },

   after: function() {
     return domManip( this, arguments, function( elem ) {
       if ( this.parentNode ) {
         this.parentNode.insertBefore( elem, this.nextSibling );
       }
     } );
   },

   empty: function() {
     var elem,
       i = 0;

     for ( ; ( elem = this[ i ] ) != null; i++ ) {
       if ( elem.nodeType === 1 ) {

         // Prevent memory leaks
         jQuery.cleanData( getAll( elem, false ) );

         // Remove any remaining nodes
         elem.textContent = "";
       }
     }

     return this;
   },

   clone: function( dataAndEvents, deepDataAndEvents ) {
     dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
     deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

     return this.map( function() {
       return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
     } );
   },

   html: function( value ) {
     return access( this, function( value ) {
       var elem = this[ 0 ] || {},
         i = 0,
         l = this.length;

       if ( value === undefined && elem.nodeType === 1 ) {
         return elem.innerHTML;
       }

       // See if we can take a shortcut and just use innerHTML
       if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
         !wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

         value = jQuery.htmlPrefilter( value );

         try {
           for ( ; i < l; i++ ) {
             elem = this[ i ] || {};

             // Remove element nodes and prevent memory leaks
             if ( elem.nodeType === 1 ) {
               jQuery.cleanData( getAll( elem, false ) );
               elem.innerHTML = value;
             }
           }

           elem = 0;

         // If using innerHTML throws an exception, use the fallback method
         } catch ( e ) {}
       }

       if ( elem ) {
         this.empty().append( value );
       }
     }, null, value, arguments.length );
   },

   replaceWith: function() {
     var ignored = [];

     // Make the changes, replacing each non-ignored context element with the new content
     return domManip( this, arguments, function( elem ) {
       var parent = this.parentNode;

       if ( jQuery.inArray( this, ignored ) < 0 ) {
         jQuery.cleanData( getAll( this ) );
         if ( parent ) {
           parent.replaceChild( elem, this );
         }
       }

     // Force callback invocation
     }, ignored );
   }
 } );

 jQuery.each( {
   appendTo: "append",
   prependTo: "prepend",
   insertBefore: "before",
   insertAfter: "after",
   replaceAll: "replaceWith"
 }, function( name, original ) {
   jQuery.fn[ name ] = function( selector ) {
     var elems,
       ret = [],
       insert = jQuery( selector ),
       last = insert.length - 1,
       i = 0;

     for ( ; i <= last; i++ ) {
       elems = i === last ? this : this.clone( true );
       jQuery( insert[ i ] )[ original ]( elems );

       // Support: Android <=4.0 only, PhantomJS 1 only
       // .get() because push.apply(_, arraylike) throws on ancient WebKit
       push.apply( ret, elems.get() );
     }

     return this.pushStack( ret );
   };
 } );
 var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

 var getStyles = function( elem ) {

     // Support: IE <=11 only, Firefox <=30 (#15098, #14150)
     // IE throws on elements created in popups
     // FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
     var view = elem.ownerDocument.defaultView;

     if ( !view || !view.opener ) {
       view = window;
     }

     return view.getComputedStyle( elem );
   };

 var swap = function( elem, options, callback ) {
   var ret, name,
     old = {};

   // Remember the old values, and insert the new ones
   for ( name in options ) {
     old[ name ] = elem.style[ name ];
     elem.style[ name ] = options[ name ];
   }

   ret = callback.call( elem );

   // Revert the old values
   for ( name in options ) {
     elem.style[ name ] = old[ name ];
   }

   return ret;
 };


 var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );



 ( function() {

   // Executing both pixelPosition & boxSizingReliable tests require only one layout
   // so they're executed at the same time to save the second computation.
   function computeStyleTests() {

     // This is a singleton, we need to execute it only once
     if ( !div ) {
       return;
     }

     container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
       "margin-top:1px;padding:0;border:0";
     div.style.cssText =
       "position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
       "margin:auto;border:1px;padding:1px;" +
       "width:60%;top:1%";
     documentElement.appendChild( container ).appendChild( div );

     var divStyle = window.getComputedStyle( div );
     pixelPositionVal = divStyle.top !== "1%";

     // Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
     reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;

     // Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
     // Some styles come back with percentage values, even though they shouldn't
     div.style.right = "60%";
     pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;

     // Support: IE 9 - 11 only
     // Detect misreporting of content dimensions for box-sizing:border-box elements
     boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;

     // Support: IE 9 only
     // Detect overflow:scroll screwiness (gh-3699)
     // Support: Chrome <=64
     // Don't get tricked when zoom affects offsetWidth (gh-4029)
     div.style.position = "absolute";
     scrollboxSizeVal = roundPixelMeasures( div.offsetWidth / 3 ) === 12;

     documentElement.removeChild( container );

     // Nullify the div so it wouldn't be stored in the memory and
     // it will also be a sign that checks already performed
     div = null;
   }

   function roundPixelMeasures( measure ) {
     return Math.round( parseFloat( measure ) );
   }

   var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
     reliableTrDimensionsVal, reliableMarginLeftVal,
     container = document.createElement( "div" ),
     div = document.createElement( "div" );

   // Finish early in limited (non-browser) environments
   if ( !div.style ) {
     return;
   }

   // Support: IE <=9 - 11 only
   // Style of cloned element affects source element cloned (#8908)
   div.style.backgroundClip = "content-box";
   div.cloneNode( true ).style.backgroundClip = "";
   support.clearCloneStyle = div.style.backgroundClip === "content-box";

   jQuery.extend( support, {
     boxSizingReliable: function() {
       computeStyleTests();
       return boxSizingReliableVal;
     },
     pixelBoxStyles: function() {
       computeStyleTests();
       return pixelBoxStylesVal;
     },
     pixelPosition: function() {
       computeStyleTests();
       return pixelPositionVal;
     },
     reliableMarginLeft: function() {
       computeStyleTests();
       return reliableMarginLeftVal;
     },
     scrollboxSize: function() {
       computeStyleTests();
       return scrollboxSizeVal;
     },

     // Support: IE 9 - 11+, Edge 15 - 18+
     // IE/Edge misreport `getComputedStyle` of table rows with width/height
     // set in CSS while `offset*` properties report correct values.
     // Behavior in IE 9 is more subtle than in newer versions & it passes
     // some versions of this test; make sure not to make it pass there!
     //
     // Support: Firefox 70+
     // Only Firefox includes border widths
     // in computed dimensions. (gh-4529)
     reliableTrDimensions: function() {
       var table, tr, trChild, trStyle;
       if ( reliableTrDimensionsVal == null ) {
         table = document.createElement( "table" );
         tr = document.createElement( "tr" );
         trChild = document.createElement( "div" );

         table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
         tr.style.cssText = "border:1px solid";

         // Support: Chrome 86+
         // Height set through cssText does not get applied.
         // Computed height then comes back as 0.
         tr.style.height = "1px";
         trChild.style.height = "9px";

         // Support: Android 8 Chrome 86+
         // In our bodyBackground.html iframe,
         // display for all div elements is set to "inline",
         // which causes a problem only in Android 8 Chrome 86.
         // Ensuring the div is display: block
         // gets around this issue.
         trChild.style.display = "block";

         documentElement
           .appendChild( table )
           .appendChild( tr )
           .appendChild( trChild );

         trStyle = window.getComputedStyle( tr );
         reliableTrDimensionsVal = ( parseInt( trStyle.height, 10 ) +
           parseInt( trStyle.borderTopWidth, 10 ) +
           parseInt( trStyle.borderBottomWidth, 10 ) ) === tr.offsetHeight;

         documentElement.removeChild( table );
       }
       return reliableTrDimensionsVal;
     }
   } );
 } )();


 function curCSS( elem, name, computed ) {
   var width, minWidth, maxWidth, ret,

     // Support: Firefox 51+
     // Retrieving style before computed somehow
     // fixes an issue with getting wrong values
     // on detached elements
     style = elem.style;

   computed = computed || getStyles( elem );

   // getPropertyValue is needed for:
   //   .css('filter') (IE 9 only, #12537)
   //   .css('--customProperty) (#3144)
   if ( computed ) {
     ret = computed.getPropertyValue( name ) || computed[ name ];

     if ( ret === "" && !isAttached( elem ) ) {
       ret = jQuery.style( elem, name );
     }

     // A tribute to the "awesome hack by Dean Edwards"
     // Android Browser returns percentage for some values,
     // but width seems to be reliably pixels.
     // This is against the CSSOM draft spec:
     // https://drafts.csswg.org/cssom/#resolved-values
     if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {

       // Remember the original values
       width = style.width;
       minWidth = style.minWidth;
       maxWidth = style.maxWidth;

       // Put in the new values to get a computed value out
       style.minWidth = style.maxWidth = style.width = ret;
       ret = computed.width;

       // Revert the changed values
       style.width = width;
       style.minWidth = minWidth;
       style.maxWidth = maxWidth;
     }
   }

   return ret !== undefined ?

     // Support: IE <=9 - 11 only
     // IE returns zIndex value as an integer.
     ret + "" :
     ret;
 }


 function addGetHookIf( conditionFn, hookFn ) {

   // Define the hook, we'll check on the first run if it's really needed.
   return {
     get: function() {
       if ( conditionFn() ) {

         // Hook not needed (or it's not possible to use it due
         // to missing dependency), remove it.
         delete this.get;
         return;
       }

       // Hook needed; redefine it so that the support test is not executed again.
       return ( this.get = hookFn ).apply( this, arguments );
     }
   };
 }


 var cssPrefixes = [ "Webkit", "Moz", "ms" ],
   emptyStyle = document.createElement( "div" ).style,
   vendorProps = {};

 // Return a vendor-prefixed property or undefined
 function vendorPropName( name ) {

   // Check for vendor prefixed names
   var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
     i = cssPrefixes.length;

   while ( i-- ) {
     name = cssPrefixes[ i ] + capName;
     if ( name in emptyStyle ) {
       return name;
     }
   }
 }

 // Return a potentially-mapped jQuery.cssProps or vendor prefixed property
 function finalPropName( name ) {
   var final = jQuery.cssProps[ name ] || vendorProps[ name ];

   if ( final ) {
     return final;
   }
   if ( name in emptyStyle ) {
     return name;
   }
   return vendorProps[ name ] = vendorPropName( name ) || name;
 }


 var

   // Swappable if display is none or starts with table
   // except "table", "table-cell", or "table-caption"
   // See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
   rdisplayswap = /^(none|table(?!-c[ea]).+)/,
   rcustomProp = /^--/,
   cssShow = { position: "absolute", visibility: "hidden", display: "block" },
   cssNormalTransform = {
     letterSpacing: "0",
     fontWeight: "400"
   };

 function setPositiveNumber( _elem, value, subtract ) {

   // Any relative (+/-) values have already been
   // normalized at this point
   var matches = rcssNum.exec( value );
   return matches ?

     // Guard against undefined "subtract", e.g., when used as in cssHooks
     Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
     value;
 }

 function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
   var i = dimension === "width" ? 1 : 0,
     extra = 0,
     delta = 0;

   // Adjustment may not be necessary
   if ( box === ( isBorderBox ? "border" : "content" ) ) {
     return 0;
   }

   for ( ; i < 4; i += 2 ) {

     // Both box models exclude margin
     if ( box === "margin" ) {
       delta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
     }

     // If we get here with a content-box, we're seeking "padding" or "border" or "margin"
     if ( !isBorderBox ) {

       // Add padding
       delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

       // For "border" or "margin", add border
       if ( box !== "padding" ) {
         delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );

       // But still keep track of it otherwise
       } else {
         extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
       }

     // If we get here with a border-box (content + padding + border), we're seeking "content" or
     // "padding" or "margin"
     } else {

       // For "content", subtract padding
       if ( box === "content" ) {
         delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
       }

       // For "content" or "padding", subtract border
       if ( box !== "margin" ) {
         delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
       }
     }
   }

   // Account for positive content-box scroll gutter when requested by providing computedVal
   if ( !isBorderBox && computedVal >= 0 ) {

     // offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
     // Assuming integer scroll gutter, subtract the rest and round down
     delta += Math.max( 0, Math.ceil(
       elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
       computedVal -
       delta -
       extra -
       0.5

     // If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
     // Use an explicit zero to avoid NaN (gh-3964)
     ) ) || 0;
   }

   return delta;
 }

 function getWidthOrHeight( elem, dimension, extra ) {

   // Start with computed style
   var styles = getStyles( elem ),

     // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
     // Fake content-box until we know it's needed to know the true value.
     boxSizingNeeded = !support.boxSizingReliable() || extra,
     isBorderBox = boxSizingNeeded &&
       jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
     valueIsBorderBox = isBorderBox,

     val = curCSS( elem, dimension, styles ),
     offsetProp = "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 );

   // Support: Firefox <=54
   // Return a confounding non-pixel value or feign ignorance, as appropriate.
   if ( rnumnonpx.test( val ) ) {
     if ( !extra ) {
       return val;
     }
     val = "auto";
   }


   // Support: IE 9 - 11 only
   // Use offsetWidth/offsetHeight for when box sizing is unreliable.
   // In those cases, the computed value can be trusted to be border-box.
   if ( ( !support.boxSizingReliable() && isBorderBox ||

     // Support: IE 10 - 11+, Edge 15 - 18+
     // IE/Edge misreport `getComputedStyle` of table rows with width/height
     // set in CSS while `offset*` properties report correct values.
     // Interestingly, in some cases IE 9 doesn't suffer from this issue.
     !support.reliableTrDimensions() && nodeName( elem, "tr" ) ||

     // Fall back to offsetWidth/offsetHeight when value is "auto"
     // This happens for inline elements with no explicit setting (gh-3571)
     val === "auto" ||

     // Support: Android <=4.1 - 4.3 only
     // Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
     !parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) &&

     // Make sure the element is visible & connected
     elem.getClientRects().length ) {

     isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

     // Where available, offsetWidth/offsetHeight approximate border box dimensions.
     // Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
     // retrieved value as a content box dimension.
     valueIsBorderBox = offsetProp in elem;
     if ( valueIsBorderBox ) {
       val = elem[ offsetProp ];
     }
   }

   // Normalize "" and auto
   val = parseFloat( val ) || 0;

   // Adjust for the element's box model
   return ( val +
     boxModelAdjustment(
       elem,
       dimension,
       extra || ( isBorderBox ? "border" : "content" ),
       valueIsBorderBox,
       styles,

       // Provide the current computed size to request scroll gutter calculation (gh-3589)
       val
     )
   ) + "px";
 }

 jQuery.extend( {

   // Add in style property hooks for overriding the default
   // behavior of getting and setting a style property
   cssHooks: {
     opacity: {
       get: function( elem, computed ) {
         if ( computed ) {

           // We should always get a number back from opacity
           var ret = curCSS( elem, "opacity" );
           return ret === "" ? "1" : ret;
         }
       }
     }
   },

   // Don't automatically add "px" to these possibly-unitless properties
   cssNumber: {
     "animationIterationCount": true,
     "columnCount": true,
     "fillOpacity": true,
     "flexGrow": true,
     "flexShrink": true,
     "fontWeight": true,
     "gridArea": true,
     "gridColumn": true,
     "gridColumnEnd": true,
     "gridColumnStart": true,
     "gridRow": true,
     "gridRowEnd": true,
     "gridRowStart": true,
     "lineHeight": true,
     "opacity": true,
     "order": true,
     "orphans": true,
     "widows": true,
     "zIndex": true,
     "zoom": true
   },

   // Add in properties whose names you wish to fix before
   // setting or getting the value
   cssProps: {},

   // Get and set the style property on a DOM Node
   style: function( elem, name, value, extra ) {

     // Don't set styles on text and comment nodes
     if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
       return;
     }

     // Make sure that we're working with the right name
     var ret, type, hooks,
       origName = camelCase( name ),
       isCustomProp = rcustomProp.test( name ),
       style = elem.style;

     // Make sure that we're working with the right name. We don't
     // want to query the value if it is a CSS custom property
     // since they are user-defined.
     if ( !isCustomProp ) {
       name = finalPropName( origName );
     }

     // Gets hook for the prefixed version, then unprefixed version
     hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

     // Check if we're setting a value
     if ( value !== undefined ) {
       type = typeof value;

       // Convert "+=" or "-=" to relative numbers (#7345)
       if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
         value = adjustCSS( elem, name, ret );

         // Fixes bug #9237
         type = "number";
       }

       // Make sure that null and NaN values aren't set (#7116)
       if ( value == null || value !== value ) {
         return;
       }

       // If a number was passed in, add the unit (except for certain CSS properties)
       // The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
       // "px" to a few hardcoded values.
       if ( type === "number" && !isCustomProp ) {
         value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
       }

       // background-* props affect original clone's values
       if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
         style[ name ] = "inherit";
       }

       // If a hook was provided, use that value, otherwise just set the specified value
       if ( !hooks || !( "set" in hooks ) ||
         ( value = hooks.set( elem, value, extra ) ) !== undefined ) {

         if ( isCustomProp ) {
           style.setProperty( name, value );
         } else {
           style[ name ] = value;
         }
       }

     } else {

       // If a hook was provided get the non-computed value from there
       if ( hooks && "get" in hooks &&
         ( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

         return ret;
       }

       // Otherwise just get the value from the style object
       return style[ name ];
     }
   },

   css: function( elem, name, extra, styles ) {
     var val, num, hooks,
       origName = camelCase( name ),
       isCustomProp = rcustomProp.test( name );

     // Make sure that we're working with the right name. We don't
     // want to modify the value if it is a CSS custom property
     // since they are user-defined.
     if ( !isCustomProp ) {
       name = finalPropName( origName );
     }

     // Try prefixed name followed by the unprefixed name
     hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

     // If a hook was provided get the computed value from there
     if ( hooks && "get" in hooks ) {
       val = hooks.get( elem, true, extra );
     }

     // Otherwise, if a way to get the computed value exists, use that
     if ( val === undefined ) {
       val = curCSS( elem, name, styles );
     }

     // Convert "normal" to computed value
     if ( val === "normal" && name in cssNormalTransform ) {
       val = cssNormalTransform[ name ];
     }

     // Make numeric if forced or a qualifier was provided and val looks numeric
     if ( extra === "" || extra ) {
       num = parseFloat( val );
       return extra === true || isFinite( num ) ? num || 0 : val;
     }

     return val;
   }
 } );

 jQuery.each( [ "height", "width" ], function( _i, dimension ) {
   jQuery.cssHooks[ dimension ] = {
     get: function( elem, computed, extra ) {
       if ( computed ) {

         // Certain elements can have dimension info if we invisibly show them
         // but it must have a current display style that would benefit
         return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

           // Support: Safari 8+
           // Table columns in Safari have non-zero offsetWidth & zero
           // getBoundingClientRect().width unless display is changed.
           // Support: IE <=11 only
           // Running getBoundingClientRect on a disconnected node
           // in IE throws an error.
           ( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
           swap( elem, cssShow, function() {
             return getWidthOrHeight( elem, dimension, extra );
           } ) :
           getWidthOrHeight( elem, dimension, extra );
       }
     },

     set: function( elem, value, extra ) {
       var matches,
         styles = getStyles( elem ),

         // Only read styles.position if the test has a chance to fail
         // to avoid forcing a reflow.
         scrollboxSizeBuggy = !support.scrollboxSize() &&
           styles.position === "absolute",

         // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
         boxSizingNeeded = scrollboxSizeBuggy || extra,
         isBorderBox = boxSizingNeeded &&
           jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
         subtract = extra ?
           boxModelAdjustment(
             elem,
             dimension,
             extra,
             isBorderBox,
             styles
           ) :
           0;

       // Account for unreliable border-box dimensions by comparing offset* to computed and
       // faking a content-box to get border and padding (gh-3699)
       if ( isBorderBox && scrollboxSizeBuggy ) {
         subtract -= Math.ceil(
           elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
           parseFloat( styles[ dimension ] ) -
           boxModelAdjustment( elem, dimension, "border", false, styles ) -
           0.5
         );
       }

       // Convert to pixels if value adjustment is needed
       if ( subtract && ( matches = rcssNum.exec( value ) ) &&
         ( matches[ 3 ] || "px" ) !== "px" ) {

         elem.style[ dimension ] = value;
         value = jQuery.css( elem, dimension );
       }

       return setPositiveNumber( elem, value, subtract );
     }
   };
 } );

 jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
   function( elem, computed ) {
     if ( computed ) {
       return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
         elem.getBoundingClientRect().left -
           swap( elem, { marginLeft: 0 }, function() {
             return elem.getBoundingClientRect().left;
           } )
       ) + "px";
     }
   }
 );

 // These hooks are used by animate to expand properties
 jQuery.each( {
   margin: "",
   padding: "",
   border: "Width"
 }, function( prefix, suffix ) {
   jQuery.cssHooks[ prefix + suffix ] = {
     expand: function( value ) {
       var i = 0,
         expanded = {},

         // Assumes a single number if not a string
         parts = typeof value === "string" ? value.split( " " ) : [ value ];

       for ( ; i < 4; i++ ) {
         expanded[ prefix + cssExpand[ i ] + suffix ] =
           parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
       }

       return expanded;
     }
   };

   if ( prefix !== "margin" ) {
     jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
   }
 } );

 jQuery.fn.extend( {
   css: function( name, value ) {
     return access( this, function( elem, name, value ) {
       var styles, len,
         map = {},
         i = 0;

       if ( Array.isArray( name ) ) {
         styles = getStyles( elem );
         len = name.length;

         for ( ; i < len; i++ ) {
           map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
         }

         return map;
       }

       return value !== undefined ?
         jQuery.style( elem, name, value ) :
         jQuery.css( elem, name );
     }, name, value, arguments.length > 1 );
   }
 } );


 function Tween( elem, options, prop, end, easing ) {
   return new Tween.prototype.init( elem, options, prop, end, easing );
 }
 jQuery.Tween = Tween;

 Tween.prototype = {
   constructor: Tween,
   init: function( elem, options, prop, end, easing, unit ) {
     this.elem = elem;
     this.prop = prop;
     this.easing = easing || jQuery.easing._default;
     this.options = options;
     this.start = this.now = this.cur();
     this.end = end;
     this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
   },
   cur: function() {
     var hooks = Tween.propHooks[ this.prop ];

     return hooks && hooks.get ?
       hooks.get( this ) :
       Tween.propHooks._default.get( this );
   },
   run: function( percent ) {
     var eased,
       hooks = Tween.propHooks[ this.prop ];

     if ( this.options.duration ) {
       this.pos = eased = jQuery.easing[ this.easing ](
         percent, this.options.duration * percent, 0, 1, this.options.duration
       );
     } else {
       this.pos = eased = percent;
     }
     this.now = ( this.end - this.start ) * eased + this.start;

     if ( this.options.step ) {
       this.options.step.call( this.elem, this.now, this );
     }

     if ( hooks && hooks.set ) {
       hooks.set( this );
     } else {
       Tween.propHooks._default.set( this );
     }
     return this;
   }
 };

 Tween.prototype.init.prototype = Tween.prototype;

 Tween.propHooks = {
   _default: {
     get: function( tween ) {
       var result;

       // Use a property on the element directly when it is not a DOM element,
       // or when there is no matching style property that exists.
       if ( tween.elem.nodeType !== 1 ||
         tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
         return tween.elem[ tween.prop ];
       }

       // Passing an empty string as a 3rd parameter to .css will automatically
       // attempt a parseFloat and fallback to a string if the parse fails.
       // Simple values such as "10px" are parsed to Float;
       // complex values such as "rotate(1rad)" are returned as-is.
       result = jQuery.css( tween.elem, tween.prop, "" );

       // Empty strings, null, undefined and "auto" are converted to 0.
       return !result || result === "auto" ? 0 : result;
     },
     set: function( tween ) {

       // Use step hook for back compat.
       // Use cssHook if its there.
       // Use .style if available and use plain properties where available.
       if ( jQuery.fx.step[ tween.prop ] ) {
         jQuery.fx.step[ tween.prop ]( tween );
       } else if ( tween.elem.nodeType === 1 && (
         jQuery.cssHooks[ tween.prop ] ||
           tween.elem.style[ finalPropName( tween.prop ) ] != null ) ) {
         jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
       } else {
         tween.elem[ tween.prop ] = tween.now;
       }
     }
   }
 };

 // Support: IE <=9 only
 // Panic based approach to setting things on disconnected nodes
 Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
   set: function( tween ) {
     if ( tween.elem.nodeType && tween.elem.parentNode ) {
       tween.elem[ tween.prop ] = tween.now;
     }
   }
 };

 jQuery.easing = {
   linear: function( p ) {
     return p;
   },
   swing: function( p ) {
     return 0.5 - Math.cos( p * Math.PI ) / 2;
   },
   _default: "swing"
 };

 jQuery.fx = Tween.prototype.init;

 // Back compat <1.8 extension point
 jQuery.fx.step = {};




 var
   fxNow, inProgress,
   rfxtypes = /^(?:toggle|show|hide)$/,
   rrun = /queueHooks$/;

 function schedule() {
   if ( inProgress ) {
     if ( document.hidden === false && window.requestAnimationFrame ) {
       window.requestAnimationFrame( schedule );
     } else {
       window.setTimeout( schedule, jQuery.fx.interval );
     }

     jQuery.fx.tick();
   }
 }

 // Animations created synchronously will run synchronously
 function createFxNow() {
   window.setTimeout( function() {
     fxNow = undefined;
   } );
   return ( fxNow = Date.now() );
 }

 // Generate parameters to create a standard animation
 function genFx( type, includeWidth ) {
   var which,
     i = 0,
     attrs = { height: type };

   // If we include width, step value is 1 to do all cssExpand values,
   // otherwise step value is 2 to skip over Left and Right
   includeWidth = includeWidth ? 1 : 0;
   for ( ; i < 4; i += 2 - includeWidth ) {
     which = cssExpand[ i ];
     attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
   }

   if ( includeWidth ) {
     attrs.opacity = attrs.width = type;
   }

   return attrs;
 }

 function createTween( value, prop, animation ) {
   var tween,
     collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
     index = 0,
     length = collection.length;
   for ( ; index < length; index++ ) {
     if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

       // We're done with this property
       return tween;
     }
   }
 }

 function defaultPrefilter( elem, props, opts ) {
   var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
     isBox = "width" in props || "height" in props,
     anim = this,
     orig = {},
     style = elem.style,
     hidden = elem.nodeType && isHiddenWithinTree( elem ),
     dataShow = dataPriv.get( elem, "fxshow" );

   // Queue-skipping animations hijack the fx hooks
   if ( !opts.queue ) {
     hooks = jQuery._queueHooks( elem, "fx" );
     if ( hooks.unqueued == null ) {
       hooks.unqueued = 0;
       oldfire = hooks.empty.fire;
       hooks.empty.fire = function() {
         if ( !hooks.unqueued ) {
           oldfire();
         }
       };
     }
     hooks.unqueued++;

     anim.always( function() {

       // Ensure the complete handler is called before this completes
       anim.always( function() {
         hooks.unqueued--;
         if ( !jQuery.queue( elem, "fx" ).length ) {
           hooks.empty.fire();
         }
       } );
     } );
   }

   // Detect show/hide animations
   for ( prop in props ) {
     value = props[ prop ];
     if ( rfxtypes.test( value ) ) {
       delete props[ prop ];
       toggle = toggle || value === "toggle";
       if ( value === ( hidden ? "hide" : "show" ) ) {

         // Pretend to be hidden if this is a "show" and
         // there is still data from a stopped show/hide
         if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
           hidden = true;

         // Ignore all other no-op show/hide data
         } else {
           continue;
         }
       }
       orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
     }
   }

   // Bail out if this is a no-op like .hide().hide()
   propTween = !jQuery.isEmptyObject( props );
   if ( !propTween && jQuery.isEmptyObject( orig ) ) {
     return;
   }

   // Restrict "overflow" and "display" styles during box animations
   if ( isBox && elem.nodeType === 1 ) {

     // Support: IE <=9 - 11, Edge 12 - 15
     // Record all 3 overflow attributes because IE does not infer the shorthand
     // from identically-valued overflowX and overflowY and Edge just mirrors
     // the overflowX value there.
     opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

     // Identify a display type, preferring old show/hide data over the CSS cascade
     restoreDisplay = dataShow && dataShow.display;
     if ( restoreDisplay == null ) {
       restoreDisplay = dataPriv.get( elem, "display" );
     }
     display = jQuery.css( elem, "display" );
     if ( display === "none" ) {
       if ( restoreDisplay ) {
         display = restoreDisplay;
       } else {

         // Get nonempty value(s) by temporarily forcing visibility
         showHide( [ elem ], true );
         restoreDisplay = elem.style.display || restoreDisplay;
         display = jQuery.css( elem, "display" );
         showHide( [ elem ] );
       }
     }

     // Animate inline elements as inline-block
     if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
       if ( jQuery.css( elem, "float" ) === "none" ) {

         // Restore the original display value at the end of pure show/hide animations
         if ( !propTween ) {
           anim.done( function() {
             style.display = restoreDisplay;
           } );
           if ( restoreDisplay == null ) {
             display = style.display;
             restoreDisplay = display === "none" ? "" : display;
           }
         }
         style.display = "inline-block";
       }
     }
   }

   if ( opts.overflow ) {
     style.overflow = "hidden";
     anim.always( function() {
       style.overflow = opts.overflow[ 0 ];
       style.overflowX = opts.overflow[ 1 ];
       style.overflowY = opts.overflow[ 2 ];
     } );
   }

   // Implement show/hide animations
   propTween = false;
   for ( prop in orig ) {

     // General show/hide setup for this element animation
     if ( !propTween ) {
       if ( dataShow ) {
         if ( "hidden" in dataShow ) {
           hidden = dataShow.hidden;
         }
       } else {
         dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
       }

       // Store hidden/visible for toggle so `.stop().toggle()` "reverses"
       if ( toggle ) {
         dataShow.hidden = !hidden;
       }

       // Show elements before animating them
       if ( hidden ) {
         showHide( [ elem ], true );
       }

       /* eslint-disable no-loop-func */

       anim.done( function() {

         /* eslint-enable no-loop-func */

         // The final step of a "hide" animation is actually hiding the element
         if ( !hidden ) {
           showHide( [ elem ] );
         }
         dataPriv.remove( elem, "fxshow" );
         for ( prop in orig ) {
           jQuery.style( elem, prop, orig[ prop ] );
         }
       } );
     }

     // Per-property setup
     propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
     if ( !( prop in dataShow ) ) {
       dataShow[ prop ] = propTween.start;
       if ( hidden ) {
         propTween.end = propTween.start;
         propTween.start = 0;
       }
     }
   }
 }

 function propFilter( props, specialEasing ) {
   var index, name, easing, value, hooks;

   // camelCase, specialEasing and expand cssHook pass
   for ( index in props ) {
     name = camelCase( index );
     easing = specialEasing[ name ];
     value = props[ index ];
     if ( Array.isArray( value ) ) {
       easing = value[ 1 ];
       value = props[ index ] = value[ 0 ];
     }

     if ( index !== name ) {
       props[ name ] = value;
       delete props[ index ];
     }

     hooks = jQuery.cssHooks[ name ];
     if ( hooks && "expand" in hooks ) {
       value = hooks.expand( value );
       delete props[ name ];

       // Not quite $.extend, this won't overwrite existing keys.
       // Reusing 'index' because we have the correct "name"
       for ( index in value ) {
         if ( !( index in props ) ) {
           props[ index ] = value[ index ];
           specialEasing[ index ] = easing;
         }
       }
     } else {
       specialEasing[ name ] = easing;
     }
   }
 }

 function Animation( elem, properties, options ) {
   var result,
     stopped,
     index = 0,
     length = Animation.prefilters.length,
     deferred = jQuery.Deferred().always( function() {

       // Don't match elem in the :animated selector
       delete tick.elem;
     } ),
     tick = function() {
       if ( stopped ) {
         return false;
       }
       var currentTime = fxNow || createFxNow(),
         remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

         // Support: Android 2.3 only
         // Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
         temp = remaining / animation.duration || 0,
         percent = 1 - temp,
         index = 0,
         length = animation.tweens.length;

       for ( ; index < length; index++ ) {
         animation.tweens[ index ].run( percent );
       }

       deferred.notifyWith( elem, [ animation, percent, remaining ] );

       // If there's more to do, yield
       if ( percent < 1 && length ) {
         return remaining;
       }

       // If this was an empty animation, synthesize a final progress notification
       if ( !length ) {
         deferred.notifyWith( elem, [ animation, 1, 0 ] );
       }

       // Resolve the animation and report its conclusion
       deferred.resolveWith( elem, [ animation ] );
       return false;
     },
     animation = deferred.promise( {
       elem: elem,
       props: jQuery.extend( {}, properties ),
       opts: jQuery.extend( true, {
         specialEasing: {},
         easing: jQuery.easing._default
       }, options ),
       originalProperties: properties,
       originalOptions: options,
       startTime: fxNow || createFxNow(),
       duration: options.duration,
       tweens: [],
       createTween: function( prop, end ) {
         var tween = jQuery.Tween( elem, animation.opts, prop, end,
           animation.opts.specialEasing[ prop ] || animation.opts.easing );
         animation.tweens.push( tween );
         return tween;
       },
       stop: function( gotoEnd ) {
         var index = 0,

           // If we are going to the end, we want to run all the tweens
           // otherwise we skip this part
           length = gotoEnd ? animation.tweens.length : 0;
         if ( stopped ) {
           return this;
         }
         stopped = true;
         for ( ; index < length; index++ ) {
           animation.tweens[ index ].run( 1 );
         }

         // Resolve when we played the last frame; otherwise, reject
         if ( gotoEnd ) {
           deferred.notifyWith( elem, [ animation, 1, 0 ] );
           deferred.resolveWith( elem, [ animation, gotoEnd ] );
         } else {
           deferred.rejectWith( elem, [ animation, gotoEnd ] );
         }
         return this;
       }
     } ),
     props = animation.props;

   propFilter( props, animation.opts.specialEasing );

   for ( ; index < length; index++ ) {
     result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
     if ( result ) {
       if ( isFunction( result.stop ) ) {
         jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
           result.stop.bind( result );
       }
       return result;
     }
   }

   jQuery.map( props, createTween, animation );

   if ( isFunction( animation.opts.start ) ) {
     animation.opts.start.call( elem, animation );
   }

   // Attach callbacks from options
   animation
     .progress( animation.opts.progress )
     .done( animation.opts.done, animation.opts.complete )
     .fail( animation.opts.fail )
     .always( animation.opts.always );

   jQuery.fx.timer(
     jQuery.extend( tick, {
       elem: elem,
       anim: animation,
       queue: animation.opts.queue
     } )
   );

   return animation;
 }

 jQuery.Animation = jQuery.extend( Animation, {

   tweeners: {
     "*": [ function( prop, value ) {
       var tween = this.createTween( prop, value );
       adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
       return tween;
     } ]
   },

   tweener: function( props, callback ) {
     if ( isFunction( props ) ) {
       callback = props;
       props = [ "*" ];
     } else {
       props = props.match( rnothtmlwhite );
     }

     var prop,
       index = 0,
       length = props.length;

     for ( ; index < length; index++ ) {
       prop = props[ index ];
       Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
       Animation.tweeners[ prop ].unshift( callback );
     }
   },

   prefilters: [ defaultPrefilter ],

   prefilter: function( callback, prepend ) {
     if ( prepend ) {
       Animation.prefilters.unshift( callback );
     } else {
       Animation.prefilters.push( callback );
     }
   }
 } );

 jQuery.speed = function( speed, easing, fn ) {
   var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
     complete: fn || !fn && easing ||
       isFunction( speed ) && speed,
     duration: speed,
     easing: fn && easing || easing && !isFunction( easing ) && easing
   };

   // Go to the end state if fx are off
   if ( jQuery.fx.off ) {
     opt.duration = 0;

   } else {
     if ( typeof opt.duration !== "number" ) {
       if ( opt.duration in jQuery.fx.speeds ) {
         opt.duration = jQuery.fx.speeds[ opt.duration ];

       } else {
         opt.duration = jQuery.fx.speeds._default;
       }
     }
   }

   // Normalize opt.queue - true/undefined/null -> "fx"
   if ( opt.queue == null || opt.queue === true ) {
     opt.queue = "fx";
   }

   // Queueing
   opt.old = opt.complete;

   opt.complete = function() {
     if ( isFunction( opt.old ) ) {
       opt.old.call( this );
     }

     if ( opt.queue ) {
       jQuery.dequeue( this, opt.queue );
     }
   };

   return opt;
 };

 jQuery.fn.extend( {
   fadeTo: function( speed, to, easing, callback ) {

     // Show any hidden elements after setting opacity to 0
     return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

       // Animate to the value specified
       .end().animate( { opacity: to }, speed, easing, callback );
   },
   animate: function( prop, speed, easing, callback ) {
     var empty = jQuery.isEmptyObject( prop ),
       optall = jQuery.speed( speed, easing, callback ),
       doAnimation = function() {

         // Operate on a copy of prop so per-property easing won't be lost
         var anim = Animation( this, jQuery.extend( {}, prop ), optall );

         // Empty animations, or finishing resolves immediately
         if ( empty || dataPriv.get( this, "finish" ) ) {
           anim.stop( true );
         }
       };

     doAnimation.finish = doAnimation;

     return empty || optall.queue === false ?
       this.each( doAnimation ) :
       this.queue( optall.queue, doAnimation );
   },
   stop: function( type, clearQueue, gotoEnd ) {
     var stopQueue = function( hooks ) {
       var stop = hooks.stop;
       delete hooks.stop;
       stop( gotoEnd );
     };

     if ( typeof type !== "string" ) {
       gotoEnd = clearQueue;
       clearQueue = type;
       type = undefined;
     }
     if ( clearQueue ) {
       this.queue( type || "fx", [] );
     }

     return this.each( function() {
       var dequeue = true,
         index = type != null && type + "queueHooks",
         timers = jQuery.timers,
         data = dataPriv.get( this );

       if ( index ) {
         if ( data[ index ] && data[ index ].stop ) {
           stopQueue( data[ index ] );
         }
       } else {
         for ( index in data ) {
           if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
             stopQueue( data[ index ] );
           }
         }
       }

       for ( index = timers.length; index--; ) {
         if ( timers[ index ].elem === this &&
           ( type == null || timers[ index ].queue === type ) ) {

           timers[ index ].anim.stop( gotoEnd );
           dequeue = false;
           timers.splice( index, 1 );
         }
       }

       // Start the next in the queue if the last step wasn't forced.
       // Timers currently will call their complete callbacks, which
       // will dequeue but only if they were gotoEnd.
       if ( dequeue || !gotoEnd ) {
         jQuery.dequeue( this, type );
       }
     } );
   },
   finish: function( type ) {
     if ( type !== false ) {
       type = type || "fx";
     }
     return this.each( function() {
       var index,
         data = dataPriv.get( this ),
         queue = data[ type + "queue" ],
         hooks = data[ type + "queueHooks" ],
         timers = jQuery.timers,
         length = queue ? queue.length : 0;

       // Enable finishing flag on private data
       data.finish = true;

       // Empty the queue first
       jQuery.queue( this, type, [] );

       if ( hooks && hooks.stop ) {
         hooks.stop.call( this, true );
       }

       // Look for any active animations, and finish them
       for ( index = timers.length; index--; ) {
         if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
           timers[ index ].anim.stop( true );
           timers.splice( index, 1 );
         }
       }

       // Look for any animations in the old queue and finish them
       for ( index = 0; index < length; index++ ) {
         if ( queue[ index ] && queue[ index ].finish ) {
           queue[ index ].finish.call( this );
         }
       }

       // Turn off finishing flag
       delete data.finish;
     } );
   }
 } );

 jQuery.each( [ "toggle", "show", "hide" ], function( _i, name ) {
   var cssFn = jQuery.fn[ name ];
   jQuery.fn[ name ] = function( speed, easing, callback ) {
     return speed == null || typeof speed === "boolean" ?
       cssFn.apply( this, arguments ) :
       this.animate( genFx( name, true ), speed, easing, callback );
   };
 } );

 // Generate shortcuts for custom animations
 jQuery.each( {
   slideDown: genFx( "show" ),
   slideUp: genFx( "hide" ),
   slideToggle: genFx( "toggle" ),
   fadeIn: { opacity: "show" },
   fadeOut: { opacity: "hide" },
   fadeToggle: { opacity: "toggle" }
 }, function( name, props ) {
   jQuery.fn[ name ] = function( speed, easing, callback ) {
     return this.animate( props, speed, easing, callback );
   };
 } );

 jQuery.timers = [];
 jQuery.fx.tick = function() {
   var timer,
     i = 0,
     timers = jQuery.timers;

   fxNow = Date.now();

   for ( ; i < timers.length; i++ ) {
     timer = timers[ i ];

     // Run the timer and safely remove it when done (allowing for external removal)
     if ( !timer() && timers[ i ] === timer ) {
       timers.splice( i--, 1 );
     }
   }

   if ( !timers.length ) {
     jQuery.fx.stop();
   }
   fxNow = undefined;
 };

 jQuery.fx.timer = function( timer ) {
   jQuery.timers.push( timer );
   jQuery.fx.start();
 };

 jQuery.fx.interval = 13;
 jQuery.fx.start = function() {
   if ( inProgress ) {
     return;
   }

   inProgress = true;
   schedule();
 };

 jQuery.fx.stop = function() {
   inProgress = null;
 };

 jQuery.fx.speeds = {
   slow: 600,
   fast: 200,

   // Default speed
   _default: 400
 };


 // Based off of the plugin by Clint Helfers, with permission.
 // https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
 jQuery.fn.delay = function( time, type ) {
   time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
   type = type || "fx";

   return this.queue( type, function( next, hooks ) {
     var timeout = window.setTimeout( next, time );
     hooks.stop = function() {
       window.clearTimeout( timeout );
     };
   } );
 };


 ( function() {
   var input = document.createElement( "input" ),
     select = document.createElement( "select" ),
     opt = select.appendChild( document.createElement( "option" ) );

   input.type = "checkbox";

   // Support: Android <=4.3 only
   // Default value for a checkbox should be "on"
   support.checkOn = input.value !== "";

   // Support: IE <=11 only
   // Must access selectedIndex to make default options select
   support.optSelected = opt.selected;

   // Support: IE <=11 only
   // An input loses its value after becoming a radio
   input = document.createElement( "input" );
   input.value = "t";
   input.type = "radio";
   support.radioValue = input.value === "t";
 } )();


 var boolHook,
   attrHandle = jQuery.expr.attrHandle;

 jQuery.fn.extend( {
   attr: function( name, value ) {
     return access( this, jQuery.attr, name, value, arguments.length > 1 );
   },

   removeAttr: function( name ) {
     return this.each( function() {
       jQuery.removeAttr( this, name );
     } );
   }
 } );

 jQuery.extend( {
   attr: function( elem, name, value ) {
     var ret, hooks,
       nType = elem.nodeType;

     // Don't get/set attributes on text, comment and attribute nodes
     if ( nType === 3 || nType === 8 || nType === 2 ) {
       return;
     }

     // Fallback to prop when attributes are not supported
     if ( typeof elem.getAttribute === "undefined" ) {
       return jQuery.prop( elem, name, value );
     }

     // Attribute hooks are determined by the lowercase version
     // Grab necessary hook if one is defined
     if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
       hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
         ( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
     }

     if ( value !== undefined ) {
       if ( value === null ) {
         jQuery.removeAttr( elem, name );
         return;
       }

       if ( hooks && "set" in hooks &&
         ( ret = hooks.set( elem, value, name ) ) !== undefined ) {
         return ret;
       }

       elem.setAttribute( name, value + "" );
       return value;
     }

     if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
       return ret;
     }

     ret = jQuery.find.attr( elem, name );

     // Non-existent attributes return null, we normalize to undefined
     return ret == null ? undefined : ret;
   },

   attrHooks: {
     type: {
       set: function( elem, value ) {
         if ( !support.radioValue && value === "radio" &&
           nodeName( elem, "input" ) ) {
           var val = elem.value;
           elem.setAttribute( "type", value );
           if ( val ) {
             elem.value = val;
           }
           return value;
         }
       }
     }
   },

   removeAttr: function( elem, value ) {
     var name,
       i = 0,

       // Attribute names can contain non-HTML whitespace characters
       // https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
       attrNames = value && value.match( rnothtmlwhite );

     if ( attrNames && elem.nodeType === 1 ) {
       while ( ( name = attrNames[ i++ ] ) ) {
         elem.removeAttribute( name );
       }
     }
   }
 } );

 // Hooks for boolean attributes
 boolHook = {
   set: function( elem, value, name ) {
     if ( value === false ) {

       // Remove boolean attributes when set to false
       jQuery.removeAttr( elem, name );
     } else {
       elem.setAttribute( name, name );
     }
     return name;
   }
 };

 jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( _i, name ) {
   var getter = attrHandle[ name ] || jQuery.find.attr;

   attrHandle[ name ] = function( elem, name, isXML ) {
     var ret, handle,
       lowercaseName = name.toLowerCase();

     if ( !isXML ) {

       // Avoid an infinite loop by temporarily removing this function from the getter
       handle = attrHandle[ lowercaseName ];
       attrHandle[ lowercaseName ] = ret;
       ret = getter( elem, name, isXML ) != null ?
         lowercaseName :
         null;
       attrHandle[ lowercaseName ] = handle;
     }
     return ret;
   };
 } );




 var rfocusable = /^(?:input|select|textarea|button)$/i,
   rclickable = /^(?:a|area)$/i;

 jQuery.fn.extend( {
   prop: function( name, value ) {
     return access( this, jQuery.prop, name, value, arguments.length > 1 );
   },

   removeProp: function( name ) {
     return this.each( function() {
       delete this[ jQuery.propFix[ name ] || name ];
     } );
   }
 } );

 jQuery.extend( {
   prop: function( elem, name, value ) {
     var ret, hooks,
       nType = elem.nodeType;

     // Don't get/set properties on text, comment and attribute nodes
     if ( nType === 3 || nType === 8 || nType === 2 ) {
       return;
     }

     if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

       // Fix name and attach hooks
       name = jQuery.propFix[ name ] || name;
       hooks = jQuery.propHooks[ name ];
     }

     if ( value !== undefined ) {
       if ( hooks && "set" in hooks &&
         ( ret = hooks.set( elem, value, name ) ) !== undefined ) {
         return ret;
       }

       return ( elem[ name ] = value );
     }

     if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
       return ret;
     }

     return elem[ name ];
   },

   propHooks: {
     tabIndex: {
       get: function( elem ) {

         // Support: IE <=9 - 11 only
         // elem.tabIndex doesn't always return the
         // correct value when it hasn't been explicitly set
         // https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
         // Use proper attribute retrieval(#12072)
         var tabindex = jQuery.find.attr( elem, "tabindex" );

         if ( tabindex ) {
           return parseInt( tabindex, 10 );
         }

         if (
           rfocusable.test( elem.nodeName ) ||
           rclickable.test( elem.nodeName ) &&
           elem.href
         ) {
           return 0;
         }

         return -1;
       }
     }
   },

   propFix: {
     "for": "htmlFor",
     "class": "className"
   }
 } );

 // Support: IE <=11 only
 // Accessing the selectedIndex property
 // forces the browser to respect setting selected
 // on the option
 // The getter ensures a default option is selected
 // when in an optgroup
 // eslint rule "no-unused-expressions" is disabled for this code
 // since it considers such accessions noop
 if ( !support.optSelected ) {
   jQuery.propHooks.selected = {
     get: function( elem ) {

       /* eslint no-unused-expressions: "off" */

       var parent = elem.parentNode;
       if ( parent && parent.parentNode ) {
         parent.parentNode.selectedIndex;
       }
       return null;
     },
     set: function( elem ) {

       /* eslint no-unused-expressions: "off" */

       var parent = elem.parentNode;
       if ( parent ) {
         parent.selectedIndex;

         if ( parent.parentNode ) {
           parent.parentNode.selectedIndex;
         }
       }
     }
   };
 }

 jQuery.each( [
   "tabIndex",
   "readOnly",
   "maxLength",
   "cellSpacing",
   "cellPadding",
   "rowSpan",
   "colSpan",
   "useMap",
   "frameBorder",
   "contentEditable"
 ], function() {
   jQuery.propFix[ this.toLowerCase() ] = this;
 } );




   // Strip and collapse whitespace according to HTML spec
   // https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
   function stripAndCollapse( value ) {
     var tokens = value.match( rnothtmlwhite ) || [];
     return tokens.join( " " );
   }


 function getClass( elem ) {
   return elem.getAttribute && elem.getAttribute( "class" ) || "";
 }

 function classesToArray( value ) {
   if ( Array.isArray( value ) ) {
     return value;
   }
   if ( typeof value === "string" ) {
     return value.match( rnothtmlwhite ) || [];
   }
   return [];
 }

 jQuery.fn.extend( {
   addClass: function( value ) {
     var classes, elem, cur, curValue, clazz, j, finalValue,
       i = 0;

     if ( isFunction( value ) ) {
       return this.each( function( j ) {
         jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
       } );
     }

     classes = classesToArray( value );

     if ( classes.length ) {
       while ( ( elem = this[ i++ ] ) ) {
         curValue = getClass( elem );
         cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

         if ( cur ) {
           j = 0;
           while ( ( clazz = classes[ j++ ] ) ) {
             if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
               cur += clazz + " ";
             }
           }

           // Only assign if different to avoid unneeded rendering.
           finalValue = stripAndCollapse( cur );
           if ( curValue !== finalValue ) {
             elem.setAttribute( "class", finalValue );
           }
         }
       }
     }

     return this;
   },

   removeClass: function( value ) {
     var classes, elem, cur, curValue, clazz, j, finalValue,
       i = 0;

     if ( isFunction( value ) ) {
       return this.each( function( j ) {
         jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
       } );
     }

     if ( !arguments.length ) {
       return this.attr( "class", "" );
     }

     classes = classesToArray( value );

     if ( classes.length ) {
       while ( ( elem = this[ i++ ] ) ) {
         curValue = getClass( elem );

         // This expression is here for better compressibility (see addClass)
         cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

         if ( cur ) {
           j = 0;
           while ( ( clazz = classes[ j++ ] ) ) {

             // Remove *all* instances
             while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
               cur = cur.replace( " " + clazz + " ", " " );
             }
           }

           // Only assign if different to avoid unneeded rendering.
           finalValue = stripAndCollapse( cur );
           if ( curValue !== finalValue ) {
             elem.setAttribute( "class", finalValue );
           }
         }
       }
     }

     return this;
   },

   toggleClass: function( value, stateVal ) {
     var type = typeof value,
       isValidValue = type === "string" || Array.isArray( value );

     if ( typeof stateVal === "boolean" && isValidValue ) {
       return stateVal ? this.addClass( value ) : this.removeClass( value );
     }

     if ( isFunction( value ) ) {
       return this.each( function( i ) {
         jQuery( this ).toggleClass(
           value.call( this, i, getClass( this ), stateVal ),
           stateVal
         );
       } );
     }

     return this.each( function() {
       var className, i, self, classNames;

       if ( isValidValue ) {

         // Toggle individual class names
         i = 0;
         self = jQuery( this );
         classNames = classesToArray( value );

         while ( ( className = classNames[ i++ ] ) ) {

           // Check each className given, space separated list
           if ( self.hasClass( className ) ) {
             self.removeClass( className );
           } else {
             self.addClass( className );
           }
         }

       // Toggle whole class name
       } else if ( value === undefined || type === "boolean" ) {
         className = getClass( this );
         if ( className ) {

           // Store className if set
           dataPriv.set( this, "__className__", className );
         }

         // If the element has a class name or if we're passed `false`,
         // then remove the whole classname (if there was one, the above saved it).
         // Otherwise bring back whatever was previously saved (if anything),
         // falling back to the empty string if nothing was stored.
         if ( this.setAttribute ) {
           this.setAttribute( "class",
             className || value === false ?
               "" :
               dataPriv.get( this, "__className__" ) || ""
           );
         }
       }
     } );
   },

   hasClass: function( selector ) {
     var className, elem,
       i = 0;

     className = " " + selector + " ";
     while ( ( elem = this[ i++ ] ) ) {
       if ( elem.nodeType === 1 &&
         ( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
         return true;
       }
     }

     return false;
   }
 } );




 var rreturn = /\r/g;

 jQuery.fn.extend( {
   val: function( value ) {
     var hooks, ret, valueIsFunction,
       elem = this[ 0 ];

     if ( !arguments.length ) {
       if ( elem ) {
         hooks = jQuery.valHooks[ elem.type ] ||
           jQuery.valHooks[ elem.nodeName.toLowerCase() ];

         if ( hooks &&
           "get" in hooks &&
           ( ret = hooks.get( elem, "value" ) ) !== undefined
         ) {
           return ret;
         }

         ret = elem.value;

         // Handle most common string cases
         if ( typeof ret === "string" ) {
           return ret.replace( rreturn, "" );
         }

         // Handle cases where value is null/undef or number
         return ret == null ? "" : ret;
       }

       return;
     }

     valueIsFunction = isFunction( value );

     return this.each( function( i ) {
       var val;

       if ( this.nodeType !== 1 ) {
         return;
       }

       if ( valueIsFunction ) {
         val = value.call( this, i, jQuery( this ).val() );
       } else {
         val = value;
       }

       // Treat null/undefined as ""; convert numbers to string
       if ( val == null ) {
         val = "";

       } else if ( typeof val === "number" ) {
         val += "";

       } else if ( Array.isArray( val ) ) {
         val = jQuery.map( val, function( value ) {
           return value == null ? "" : value + "";
         } );
       }

       hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

       // If set returns undefined, fall back to normal setting
       if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
         this.value = val;
       }
     } );
   }
 } );

 jQuery.extend( {
   valHooks: {
     option: {
       get: function( elem ) {

         var val = jQuery.find.attr( elem, "value" );
         return val != null ?
           val :

           // Support: IE <=10 - 11 only
           // option.text throws exceptions (#14686, #14858)
           // Strip and collapse whitespace
           // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
           stripAndCollapse( jQuery.text( elem ) );
       }
     },
     select: {
       get: function( elem ) {
         var value, option, i,
           options = elem.options,
           index = elem.selectedIndex,
           one = elem.type === "select-one",
           values = one ? null : [],
           max = one ? index + 1 : options.length;

         if ( index < 0 ) {
           i = max;

         } else {
           i = one ? index : 0;
         }

         // Loop through all the selected options
         for ( ; i < max; i++ ) {
           option = options[ i ];

           // Support: IE <=9 only
           // IE8-9 doesn't update selected after form reset (#2551)
           if ( ( option.selected || i === index ) &&

               // Don't return options that are disabled or in a disabled optgroup
               !option.disabled &&
               ( !option.parentNode.disabled ||
                 !nodeName( option.parentNode, "optgroup" ) ) ) {

             // Get the specific value for the option
             value = jQuery( option ).val();

             // We don't need an array for one selects
             if ( one ) {
               return value;
             }

             // Multi-Selects return an array
             values.push( value );
           }
         }

         return values;
       },

       set: function( elem, value ) {
         var optionSet, option,
           options = elem.options,
           values = jQuery.makeArray( value ),
           i = options.length;

         while ( i-- ) {
           option = options[ i ];

           /* eslint-disable no-cond-assign */

           if ( option.selected =
             jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
           ) {
             optionSet = true;
           }

           /* eslint-enable no-cond-assign */
         }

         // Force browsers to behave consistently when non-matching value is set
         if ( !optionSet ) {
           elem.selectedIndex = -1;
         }
         return values;
       }
     }
   }
 } );

 // Radios and checkboxes getter/setter
 jQuery.each( [ "radio", "checkbox" ], function() {
   jQuery.valHooks[ this ] = {
     set: function( elem, value ) {
       if ( Array.isArray( value ) ) {
         return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
       }
     }
   };
   if ( !support.checkOn ) {
     jQuery.valHooks[ this ].get = function( elem ) {
       return elem.getAttribute( "value" ) === null ? "on" : elem.value;
     };
   }
 } );




 // Return jQuery for attributes-only inclusion


 support.focusin = "onfocusin" in window;


 var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
   stopPropagationCallback = function( e ) {
     e.stopPropagation();
   };

 jQuery.extend( jQuery.event, {

   trigger: function( event, data, elem, onlyHandlers ) {

     var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
       eventPath = [ elem || document ],
       type = hasOwn.call( event, "type" ) ? event.type : event,
       namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

     cur = lastElement = tmp = elem = elem || document;

     // Don't do events on text and comment nodes
     if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
       return;
     }

     // focus/blur morphs to focusin/out; ensure we're not firing them right now
     if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
       return;
     }

     if ( type.indexOf( "." ) > -1 ) {

       // Namespaced trigger; create a regexp to match event type in handle()
       namespaces = type.split( "." );
       type = namespaces.shift();
       namespaces.sort();
     }
     ontype = type.indexOf( ":" ) < 0 && "on" + type;

     // Caller can pass in a jQuery.Event object, Object, or just an event type string
     event = event[ jQuery.expando ] ?
       event :
       new jQuery.Event( type, typeof event === "object" && event );

     // Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
     event.isTrigger = onlyHandlers ? 2 : 3;
     event.namespace = namespaces.join( "." );
     event.rnamespace = event.namespace ?
       new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
       null;

     // Clean up the event in case it is being reused
     event.result = undefined;
     if ( !event.target ) {
       event.target = elem;
     }

     // Clone any incoming data and prepend the event, creating the handler arg list
     data = data == null ?
       [ event ] :
       jQuery.makeArray( data, [ event ] );

     // Allow special events to draw outside the lines
     special = jQuery.event.special[ type ] || {};
     if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
       return;
     }

     // Determine event propagation path in advance, per W3C events spec (#9951)
     // Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
     if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {

       bubbleType = special.delegateType || type;
       if ( !rfocusMorph.test( bubbleType + type ) ) {
         cur = cur.parentNode;
       }
       for ( ; cur; cur = cur.parentNode ) {
         eventPath.push( cur );
         tmp = cur;
       }

       // Only add window if we got to document (e.g., not plain obj or detached DOM)
       if ( tmp === ( elem.ownerDocument || document ) ) {
         eventPath.push( tmp.defaultView || tmp.parentWindow || window );
       }
     }

     // Fire handlers on the event path
     i = 0;
     while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
       lastElement = cur;
       event.type = i > 1 ?
         bubbleType :
         special.bindType || type;

       // jQuery handler
       handle = ( dataPriv.get( cur, "events" ) || Object.create( null ) )[ event.type ] &&
         dataPriv.get( cur, "handle" );
       if ( handle ) {
         handle.apply( cur, data );
       }

       // Native handler
       handle = ontype && cur[ ontype ];
       if ( handle && handle.apply && acceptData( cur ) ) {
         event.result = handle.apply( cur, data );
         if ( event.result === false ) {
           event.preventDefault();
         }
       }
     }
     event.type = type;

     // If nobody prevented the default action, do it now
     if ( !onlyHandlers && !event.isDefaultPrevented() ) {

       if ( ( !special._default ||
         special._default.apply( eventPath.pop(), data ) === false ) &&
         acceptData( elem ) ) {

         // Call a native DOM method on the target with the same name as the event.
         // Don't do default actions on window, that's where global variables be (#6170)
         if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {

           // Don't re-trigger an onFOO event when we call its FOO() method
           tmp = elem[ ontype ];

           if ( tmp ) {
             elem[ ontype ] = null;
           }

           // Prevent re-triggering of the same event, since we already bubbled it above
           jQuery.event.triggered = type;

           if ( event.isPropagationStopped() ) {
             lastElement.addEventListener( type, stopPropagationCallback );
           }

           elem[ type ]();

           if ( event.isPropagationStopped() ) {
             lastElement.removeEventListener( type, stopPropagationCallback );
           }

           jQuery.event.triggered = undefined;

           if ( tmp ) {
             elem[ ontype ] = tmp;
           }
         }
       }
     }

     return event.result;
   },

   // Piggyback on a donor event to simulate a different one
   // Used only for `focus(in | out)` events
   simulate: function( type, elem, event ) {
     var e = jQuery.extend(
       new jQuery.Event(),
       event,
       {
         type: type,
         isSimulated: true
       }
     );

     jQuery.event.trigger( e, null, elem );
   }

 } );

 jQuery.fn.extend( {

   trigger: function( type, data ) {
     return this.each( function() {
       jQuery.event.trigger( type, data, this );
     } );
   },
   triggerHandler: function( type, data ) {
     var elem = this[ 0 ];
     if ( elem ) {
       return jQuery.event.trigger( type, data, elem, true );
     }
   }
 } );


 // Support: Firefox <=44
 // Firefox doesn't have focus(in | out) events
 // Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
 //
 // Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
 // focus(in | out) events fire after focus & blur events,
 // which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
 // Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
 if ( !support.focusin ) {
   jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {

     // Attach a single capturing handler on the document while someone wants focusin/focusout
     var handler = function( event ) {
       jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
     };

     jQuery.event.special[ fix ] = {
       setup: function() {

         // Handle: regular nodes (via `this.ownerDocument`), window
         // (via `this.document`) & document (via `this`).
         var doc = this.ownerDocument || this.document || this,
           attaches = dataPriv.access( doc, fix );

         if ( !attaches ) {
           doc.addEventListener( orig, handler, true );
         }
         dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
       },
       teardown: function() {
         var doc = this.ownerDocument || this.document || this,
           attaches = dataPriv.access( doc, fix ) - 1;

         if ( !attaches ) {
           doc.removeEventListener( orig, handler, true );
           dataPriv.remove( doc, fix );

         } else {
           dataPriv.access( doc, fix, attaches );
         }
       }
     };
   } );
 }
 var location = window.location;

 var nonce = { guid: Date.now() };

 var rquery = ( /\?/ );



 // Cross-browser xml parsing
 jQuery.parseXML = function( data ) {
   var xml, parserErrorElem;
   if ( !data || typeof data !== "string" ) {
     return null;
   }

   // Support: IE 9 - 11 only
   // IE throws on parseFromString with invalid input.
   try {
     xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
   } catch ( e ) {}

   parserErrorElem = xml && xml.getElementsByTagName( "parsererror" )[ 0 ];
   if ( !xml || parserErrorElem ) {
     jQuery.error( "Invalid XML: " + (
       parserErrorElem ?
         jQuery.map( parserErrorElem.childNodes, function( el ) {
           return el.textContent;
         } ).join( "\n" ) :
         data
     ) );
   }
   return xml;
 };


 var
   rbracket = /\[\]$/,
   rCRLF = /\r?\n/g,
   rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
   rsubmittable = /^(?:input|select|textarea|keygen)/i;

 function buildParams( prefix, obj, traditional, add ) {
   var name;

   if ( Array.isArray( obj ) ) {

     // Serialize array item.
     jQuery.each( obj, function( i, v ) {
       if ( traditional || rbracket.test( prefix ) ) {

         // Treat each array item as a scalar.
         add( prefix, v );

       } else {

         // Item is non-scalar (array or object), encode its numeric index.
         buildParams(
           prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
           v,
           traditional,
           add
         );
       }
     } );

   } else if ( !traditional && toType( obj ) === "object" ) {

     // Serialize object item.
     for ( name in obj ) {
       buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
     }

   } else {

     // Serialize scalar item.
     add( prefix, obj );
   }
 }

 // Serialize an array of form elements or a set of
 // key/values into a query string
 jQuery.param = function( a, traditional ) {
   var prefix,
     s = [],
     add = function( key, valueOrFunction ) {

       // If value is a function, invoke it and use its return value
       var value = isFunction( valueOrFunction ) ?
         valueOrFunction() :
         valueOrFunction;

       s[ s.length ] = encodeURIComponent( key ) + "=" +
         encodeURIComponent( value == null ? "" : value );
     };

   if ( a == null ) {
     return "";
   }

   // If an array was passed in, assume that it is an array of form elements.
   if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

     // Serialize the form elements
     jQuery.each( a, function() {
       add( this.name, this.value );
     } );

   } else {

     // If traditional, encode the "old" way (the way 1.3.2 or older
     // did it), otherwise encode params recursively.
     for ( prefix in a ) {
       buildParams( prefix, a[ prefix ], traditional, add );
     }
   }

   // Return the resulting serialization
   return s.join( "&" );
 };

 jQuery.fn.extend( {
   serialize: function() {
     return jQuery.param( this.serializeArray() );
   },
   serializeArray: function() {
     return this.map( function() {

       // Can add propHook for "elements" to filter or add form elements
       var elements = jQuery.prop( this, "elements" );
       return elements ? jQuery.makeArray( elements ) : this;
     } ).filter( function() {
       var type = this.type;

       // Use .is( ":disabled" ) so that fieldset[disabled] works
       return this.name && !jQuery( this ).is( ":disabled" ) &&
         rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
         ( this.checked || !rcheckableType.test( type ) );
     } ).map( function( _i, elem ) {
       var val = jQuery( this ).val();

       if ( val == null ) {
         return null;
       }

       if ( Array.isArray( val ) ) {
         return jQuery.map( val, function( val ) {
           return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
         } );
       }

       return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
     } ).get();
   }
 } );


 var
   r20 = /%20/g,
   rhash = /#.*$/,
   rantiCache = /([?&])_=[^&]*/,
   rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

   // #7653, #8125, #8152: local protocol detection
   rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
   rnoContent = /^(?:GET|HEAD)$/,
   rprotocol = /^\/\//,

   /* Prefilters
    * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
    * 2) These are called:
    *    - BEFORE asking for a transport
    *    - AFTER param serialization (s.data is a string if s.processData is true)
    * 3) key is the dataType
    * 4) the catchall symbol "*" can be used
    * 5) execution will start with transport dataType and THEN continue down to "*" if needed
    */
   prefilters = {},

   /* Transports bindings
    * 1) key is the dataType
    * 2) the catchall symbol "*" can be used
    * 3) selection will start with transport dataType and THEN go to "*" if needed
    */
   transports = {},

   // Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
   allTypes = "*/".concat( "*" ),

   // Anchor tag for parsing the document origin
   originAnchor = document.createElement( "a" );

 originAnchor.href = location.href;

 // Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
 function addToPrefiltersOrTransports( structure ) {

   // dataTypeExpression is optional and defaults to "*"
   return function( dataTypeExpression, func ) {

     if ( typeof dataTypeExpression !== "string" ) {
       func = dataTypeExpression;
       dataTypeExpression = "*";
     }

     var dataType,
       i = 0,
       dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

     if ( isFunction( func ) ) {

       // For each dataType in the dataTypeExpression
       while ( ( dataType = dataTypes[ i++ ] ) ) {

         // Prepend if requested
         if ( dataType[ 0 ] === "+" ) {
           dataType = dataType.slice( 1 ) || "*";
           ( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

         // Otherwise append
         } else {
           ( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
         }
       }
     }
   };
 }

 // Base inspection function for prefilters and transports
 function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

   var inspected = {},
     seekingTransport = ( structure === transports );

   function inspect( dataType ) {
     var selected;
     inspected[ dataType ] = true;
     jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
       var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
       if ( typeof dataTypeOrTransport === "string" &&
         !seekingTransport && !inspected[ dataTypeOrTransport ] ) {

         options.dataTypes.unshift( dataTypeOrTransport );
         inspect( dataTypeOrTransport );
         return false;
       } else if ( seekingTransport ) {
         return !( selected = dataTypeOrTransport );
       }
     } );
     return selected;
   }

   return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
 }

 // A special extend for ajax options
 // that takes "flat" options (not to be deep extended)
 // Fixes #9887
 function ajaxExtend( target, src ) {
   var key, deep,
     flatOptions = jQuery.ajaxSettings.flatOptions || {};

   for ( key in src ) {
     if ( src[ key ] !== undefined ) {
       ( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
     }
   }
   if ( deep ) {
     jQuery.extend( true, target, deep );
   }

   return target;
 }

 /* Handles responses to an ajax request:
  * - finds the right dataType (mediates between content-type and expected dataType)
  * - returns the corresponding response
  */
 function ajaxHandleResponses( s, jqXHR, responses ) {

   var ct, type, finalDataType, firstDataType,
     contents = s.contents,
     dataTypes = s.dataTypes;

   // Remove auto dataType and get content-type in the process
   while ( dataTypes[ 0 ] === "*" ) {
     dataTypes.shift();
     if ( ct === undefined ) {
       ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
     }
   }

   // Check if we're dealing with a known content-type
   if ( ct ) {
     for ( type in contents ) {
       if ( contents[ type ] && contents[ type ].test( ct ) ) {
         dataTypes.unshift( type );
         break;
       }
     }
   }

   // Check to see if we have a response for the expected dataType
   if ( dataTypes[ 0 ] in responses ) {
     finalDataType = dataTypes[ 0 ];
   } else {

     // Try convertible dataTypes
     for ( type in responses ) {
       if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
         finalDataType = type;
         break;
       }
       if ( !firstDataType ) {
         firstDataType = type;
       }
     }

     // Or just use first one
     finalDataType = finalDataType || firstDataType;
   }

   // If we found a dataType
   // We add the dataType to the list if needed
   // and return the corresponding response
   if ( finalDataType ) {
     if ( finalDataType !== dataTypes[ 0 ] ) {
       dataTypes.unshift( finalDataType );
     }
     return responses[ finalDataType ];
   }
 }

 /* Chain conversions given the request and the original response
  * Also sets the responseXXX fields on the jqXHR instance
  */
 function ajaxConvert( s, response, jqXHR, isSuccess ) {
   var conv2, current, conv, tmp, prev,
     converters = {},

     // Work with a copy of dataTypes in case we need to modify it for conversion
     dataTypes = s.dataTypes.slice();

   // Create converters map with lowercased keys
   if ( dataTypes[ 1 ] ) {
     for ( conv in s.converters ) {
       converters[ conv.toLowerCase() ] = s.converters[ conv ];
     }
   }

   current = dataTypes.shift();

   // Convert to each sequential dataType
   while ( current ) {

     if ( s.responseFields[ current ] ) {
       jqXHR[ s.responseFields[ current ] ] = response;
     }

     // Apply the dataFilter if provided
     if ( !prev && isSuccess && s.dataFilter ) {
       response = s.dataFilter( response, s.dataType );
     }

     prev = current;
     current = dataTypes.shift();

     if ( current ) {

       // There's only work to do if current dataType is non-auto
       if ( current === "*" ) {

         current = prev;

       // Convert response if prev dataType is non-auto and differs from current
       } else if ( prev !== "*" && prev !== current ) {

         // Seek a direct converter
         conv = converters[ prev + " " + current ] || converters[ "* " + current ];

         // If none found, seek a pair
         if ( !conv ) {
           for ( conv2 in converters ) {

             // If conv2 outputs current
             tmp = conv2.split( " " );
             if ( tmp[ 1 ] === current ) {

               // If prev can be converted to accepted input
               conv = converters[ prev + " " + tmp[ 0 ] ] ||
                 converters[ "* " + tmp[ 0 ] ];
               if ( conv ) {

                 // Condense equivalence converters
                 if ( conv === true ) {
                   conv = converters[ conv2 ];

                 // Otherwise, insert the intermediate dataType
                 } else if ( converters[ conv2 ] !== true ) {
                   current = tmp[ 0 ];
                   dataTypes.unshift( tmp[ 1 ] );
                 }
                 break;
               }
             }
           }
         }

         // Apply converter (if not an equivalence)
         if ( conv !== true ) {

           // Unless errors are allowed to bubble, catch and return them
           if ( conv && s.throws ) {
             response = conv( response );
           } else {
             try {
               response = conv( response );
             } catch ( e ) {
               return {
                 state: "parsererror",
                 error: conv ? e : "No conversion from " + prev + " to " + current
               };
             }
           }
         }
       }
     }
   }

   return { state: "success", data: response };
 }

 jQuery.extend( {

   // Counter for holding the number of active queries
   active: 0,

   // Last-Modified header cache for next request
   lastModified: {},
   etag: {},

   ajaxSettings: {
     url: location.href,
     type: "GET",
     isLocal: rlocalProtocol.test( location.protocol ),
     global: true,
     processData: true,
     async: true,
     contentType: "application/x-www-form-urlencoded; charset=UTF-8",

     /*
     timeout: 0,
     data: null,
     dataType: null,
     username: null,
     password: null,
     cache: null,
     throws: false,
     traditional: false,
     headers: {},
     */

     accepts: {
       "*": allTypes,
       text: "text/plain",
       html: "text/html",
       xml: "application/xml, text/xml",
       json: "application/json, text/javascript"
     },

     contents: {
       xml: /\bxml\b/,
       html: /\bhtml/,
       json: /\bjson\b/
     },

     responseFields: {
       xml: "responseXML",
       text: "responseText",
       json: "responseJSON"
     },

     // Data converters
     // Keys separate source (or catchall "*") and destination types with a single space
     converters: {

       // Convert anything to text
       "* text": String,

       // Text to html (true = no transformation)
       "text html": true,

       // Evaluate text as a json expression
       "text json": JSON.parse,

       // Parse text as xml
       "text xml": jQuery.parseXML
     },

     // For options that shouldn't be deep extended:
     // you can add your own custom options here if
     // and when you create one that shouldn't be
     // deep extended (see ajaxExtend)
     flatOptions: {
       url: true,
       context: true
     }
   },

   // Creates a full fledged settings object into target
   // with both ajaxSettings and settings fields.
   // If target is omitted, writes into ajaxSettings.
   ajaxSetup: function( target, settings ) {
     return settings ?

       // Building a settings object
       ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

       // Extending ajaxSettings
       ajaxExtend( jQuery.ajaxSettings, target );
   },

   ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
   ajaxTransport: addToPrefiltersOrTransports( transports ),

   // Main method
   ajax: function( url, options ) {

     // If url is an object, simulate pre-1.5 signature
     if ( typeof url === "object" ) {
       options = url;
       url = undefined;
     }

     // Force options to be an object
     options = options || {};

     var transport,

       // URL without anti-cache param
       cacheURL,

       // Response headers
       responseHeadersString,
       responseHeaders,

       // timeout handle
       timeoutTimer,

       // Url cleanup var
       urlAnchor,

       // Request state (becomes false upon send and true upon completion)
       completed,

       // To know if global events are to be dispatched
       fireGlobals,

       // Loop variable
       i,

       // uncached part of the url
       uncached,

       // Create the final options object
       s = jQuery.ajaxSetup( {}, options ),

       // Callbacks context
       callbackContext = s.context || s,

       // Context for global events is callbackContext if it is a DOM node or jQuery collection
       globalEventContext = s.context &&
         ( callbackContext.nodeType || callbackContext.jquery ) ?
         jQuery( callbackContext ) :
         jQuery.event,

       // Deferreds
       deferred = jQuery.Deferred(),
       completeDeferred = jQuery.Callbacks( "once memory" ),

       // Status-dependent callbacks
       statusCode = s.statusCode || {},

       // Headers (they are sent all at once)
       requestHeaders = {},
       requestHeadersNames = {},

       // Default abort message
       strAbort = "canceled",

       // Fake xhr
       jqXHR = {
         readyState: 0,

         // Builds headers hashtable if needed
         getResponseHeader: function( key ) {
           var match;
           if ( completed ) {
             if ( !responseHeaders ) {
               responseHeaders = {};
               while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
                 responseHeaders[ match[ 1 ].toLowerCase() + " " ] =
                   ( responseHeaders[ match[ 1 ].toLowerCase() + " " ] || [] )
                     .concat( match[ 2 ] );
               }
             }
             match = responseHeaders[ key.toLowerCase() + " " ];
           }
           return match == null ? null : match.join( ", " );
         },

         // Raw string
         getAllResponseHeaders: function() {
           return completed ? responseHeadersString : null;
         },

         // Caches the header
         setRequestHeader: function( name, value ) {
           if ( completed == null ) {
             name = requestHeadersNames[ name.toLowerCase() ] =
               requestHeadersNames[ name.toLowerCase() ] || name;
             requestHeaders[ name ] = value;
           }
           return this;
         },

         // Overrides response content-type header
         overrideMimeType: function( type ) {
           if ( completed == null ) {
             s.mimeType = type;
           }
           return this;
         },

         // Status-dependent callbacks
         statusCode: function( map ) {
           var code;
           if ( map ) {
             if ( completed ) {

               // Execute the appropriate callbacks
               jqXHR.always( map[ jqXHR.status ] );
             } else {

               // Lazy-add the new callbacks in a way that preserves old ones
               for ( code in map ) {
                 statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
               }
             }
           }
           return this;
         },

         // Cancel the request
         abort: function( statusText ) {
           var finalText = statusText || strAbort;
           if ( transport ) {
             transport.abort( finalText );
           }
           done( 0, finalText );
           return this;
         }
       };

     // Attach deferreds
     deferred.promise( jqXHR );

     // Add protocol if not provided (prefilters might expect it)
     // Handle falsy url in the settings object (#10093: consistency with old signature)
     // We also use the url parameter if available
     s.url = ( ( url || s.url || location.href ) + "" )
       .replace( rprotocol, location.protocol + "//" );

     // Alias method option to type as per ticket #12004
     s.type = options.method || options.type || s.method || s.type;

     // Extract dataTypes list
     s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

     // A cross-domain request is in order when the origin doesn't match the current origin.
     if ( s.crossDomain == null ) {
       urlAnchor = document.createElement( "a" );

       // Support: IE <=8 - 11, Edge 12 - 15
       // IE throws exception on accessing the href property if url is malformed,
       // e.g. http://example.com:80x/
       try {
         urlAnchor.href = s.url;

         // Support: IE <=8 - 11 only
         // Anchor's host property isn't correctly set when s.url is relative
         urlAnchor.href = urlAnchor.href;
         s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
           urlAnchor.protocol + "//" + urlAnchor.host;
       } catch ( e ) {

         // If there is an error parsing the URL, assume it is crossDomain,
         // it can be rejected by the transport if it is invalid
         s.crossDomain = true;
       }
     }

     // Convert data if not already a string
     if ( s.data && s.processData && typeof s.data !== "string" ) {
       s.data = jQuery.param( s.data, s.traditional );
     }

     // Apply prefilters
     inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

     // If request was aborted inside a prefilter, stop there
     if ( completed ) {
       return jqXHR;
     }

     // We can fire global events as of now if asked to
     // Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
     fireGlobals = jQuery.event && s.global;

     // Watch for a new set of requests
     if ( fireGlobals && jQuery.active++ === 0 ) {
       jQuery.event.trigger( "ajaxStart" );
     }

     // Uppercase the type
     s.type = s.type.toUpperCase();

     // Determine if request has content
     s.hasContent = !rnoContent.test( s.type );

     // Save the URL in case we're toying with the If-Modified-Since
     // and/or If-None-Match header later on
     // Remove hash to simplify url manipulation
     cacheURL = s.url.replace( rhash, "" );

     // More options handling for requests with no content
     if ( !s.hasContent ) {

       // Remember the hash so we can put it back
       uncached = s.url.slice( cacheURL.length );

       // If data is available and should be processed, append data to url
       if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
         cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

         // #9682: remove data so that it's not used in an eventual retry
         delete s.data;
       }

       // Add or update anti-cache param if needed
       if ( s.cache === false ) {
         cacheURL = cacheURL.replace( rantiCache, "$1" );
         uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce.guid++ ) +
           uncached;
       }

       // Put hash and anti-cache on the URL that will be requested (gh-1732)
       s.url = cacheURL + uncached;

     // Change '%20' to '+' if this is encoded form body content (gh-2658)
     } else if ( s.data && s.processData &&
       ( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
       s.data = s.data.replace( r20, "+" );
     }

     // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
     if ( s.ifModified ) {
       if ( jQuery.lastModified[ cacheURL ] ) {
         jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
       }
       if ( jQuery.etag[ cacheURL ] ) {
         jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
       }
     }

     // Set the correct header, if data is being sent
     if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
       jqXHR.setRequestHeader( "Content-Type", s.contentType );
     }

     // Set the Accepts header for the server, depending on the dataType
     jqXHR.setRequestHeader(
       "Accept",
       s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
         s.accepts[ s.dataTypes[ 0 ] ] +
           ( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
         s.accepts[ "*" ]
     );

     // Check for headers option
     for ( i in s.headers ) {
       jqXHR.setRequestHeader( i, s.headers[ i ] );
     }

     // Allow custom headers/mimetypes and early abort
     if ( s.beforeSend &&
       ( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

       // Abort if not done already and return
       return jqXHR.abort();
     }

     // Aborting is no longer a cancellation
     strAbort = "abort";

     // Install callbacks on deferreds
     completeDeferred.add( s.complete );
     jqXHR.done( s.success );
     jqXHR.fail( s.error );

     // Get transport
     transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

     // If no transport, we auto-abort
     if ( !transport ) {
       done( -1, "No Transport" );
     } else {
       jqXHR.readyState = 1;

       // Send global event
       if ( fireGlobals ) {
         globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
       }

       // If request was aborted inside ajaxSend, stop there
       if ( completed ) {
         return jqXHR;
       }

       // Timeout
       if ( s.async && s.timeout > 0 ) {
         timeoutTimer = window.setTimeout( function() {
           jqXHR.abort( "timeout" );
         }, s.timeout );
       }

       try {
         completed = false;
         transport.send( requestHeaders, done );
       } catch ( e ) {

         // Rethrow post-completion exceptions
         if ( completed ) {
           throw e;
         }

         // Propagate others as results
         done( -1, e );
       }
     }

     // Callback for when everything is done
     function done( status, nativeStatusText, responses, headers ) {
       var isSuccess, success, error, response, modified,
         statusText = nativeStatusText;

       // Ignore repeat invocations
       if ( completed ) {
         return;
       }

       completed = true;

       // Clear timeout if it exists
       if ( timeoutTimer ) {
         window.clearTimeout( timeoutTimer );
       }

       // Dereference transport for early garbage collection
       // (no matter how long the jqXHR object will be used)
       transport = undefined;

       // Cache response headers
       responseHeadersString = headers || "";

       // Set readyState
       jqXHR.readyState = status > 0 ? 4 : 0;

       // Determine if successful
       isSuccess = status >= 200 && status < 300 || status === 304;

       // Get response data
       if ( responses ) {
         response = ajaxHandleResponses( s, jqXHR, responses );
       }

       // Use a noop converter for missing script but not if jsonp
       if ( !isSuccess &&
         jQuery.inArray( "script", s.dataTypes ) > -1 &&
         jQuery.inArray( "json", s.dataTypes ) < 0 ) {
         s.converters[ "text script" ] = function() {};
       }

       // Convert no matter what (that way responseXXX fields are always set)
       response = ajaxConvert( s, response, jqXHR, isSuccess );

       // If successful, handle type chaining
       if ( isSuccess ) {

         // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
         if ( s.ifModified ) {
           modified = jqXHR.getResponseHeader( "Last-Modified" );
           if ( modified ) {
             jQuery.lastModified[ cacheURL ] = modified;
           }
           modified = jqXHR.getResponseHeader( "etag" );
           if ( modified ) {
             jQuery.etag[ cacheURL ] = modified;
           }
         }

         // if no content
         if ( status === 204 || s.type === "HEAD" ) {
           statusText = "nocontent";

         // if not modified
         } else if ( status === 304 ) {
           statusText = "notmodified";

         // If we have data, let's convert it
         } else {
           statusText = response.state;
           success = response.data;
           error = response.error;
           isSuccess = !error;
         }
       } else {

         // Extract error from statusText and normalize for non-aborts
         error = statusText;
         if ( status || !statusText ) {
           statusText = "error";
           if ( status < 0 ) {
             status = 0;
           }
         }
       }

       // Set data for the fake xhr object
       jqXHR.status = status;
       jqXHR.statusText = ( nativeStatusText || statusText ) + "";

       // Success/Error
       if ( isSuccess ) {
         deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
       } else {
         deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
       }

       // Status-dependent callbacks
       jqXHR.statusCode( statusCode );
       statusCode = undefined;

       if ( fireGlobals ) {
         globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
           [ jqXHR, s, isSuccess ? success : error ] );
       }

       // Complete
       completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

       if ( fireGlobals ) {
         globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

         // Handle the global AJAX counter
         if ( !( --jQuery.active ) ) {
           jQuery.event.trigger( "ajaxStop" );
         }
       }
     }

     return jqXHR;
   },

   getJSON: function( url, data, callback ) {
     return jQuery.get( url, data, callback, "json" );
   },

   getScript: function( url, callback ) {
     return jQuery.get( url, undefined, callback, "script" );
   }
 } );

 jQuery.each( [ "get", "post" ], function( _i, method ) {
   jQuery[ method ] = function( url, data, callback, type ) {

     // Shift arguments if data argument was omitted
     if ( isFunction( data ) ) {
       type = type || callback;
       callback = data;
       data = undefined;
     }

     // The url can be an options object (which then must have .url)
     return jQuery.ajax( jQuery.extend( {
       url: url,
       type: method,
       dataType: type,
       data: data,
       success: callback
     }, jQuery.isPlainObject( url ) && url ) );
   };
 } );

 jQuery.ajaxPrefilter( function( s ) {
   var i;
   for ( i in s.headers ) {
     if ( i.toLowerCase() === "content-type" ) {
       s.contentType = s.headers[ i ] || "";
     }
   }
 } );


 jQuery._evalUrl = function( url, options, doc ) {
   return jQuery.ajax( {
     url: url,

     // Make this explicit, since user can override this through ajaxSetup (#11264)
     type: "GET",
     dataType: "script",
     cache: true,
     async: false,
     global: false,

     // Only evaluate the response if it is successful (gh-4126)
     // dataFilter is not invoked for failure responses, so using it instead
     // of the default converter is kludgy but it works.
     converters: {
       "text script": function() {}
     },
     dataFilter: function( response ) {
       jQuery.globalEval( response, options, doc );
     }
   } );
 };


 jQuery.fn.extend( {
   wrapAll: function( html ) {
     var wrap;

     if ( this[ 0 ] ) {
       if ( isFunction( html ) ) {
         html = html.call( this[ 0 ] );
       }

       // The elements to wrap the target around
       wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

       if ( this[ 0 ].parentNode ) {
         wrap.insertBefore( this[ 0 ] );
       }

       wrap.map( function() {
         var elem = this;

         while ( elem.firstElementChild ) {
           elem = elem.firstElementChild;
         }

         return elem;
       } ).append( this );
     }

     return this;
   },

   wrapInner: function( html ) {
     if ( isFunction( html ) ) {
       return this.each( function( i ) {
         jQuery( this ).wrapInner( html.call( this, i ) );
       } );
     }

     return this.each( function() {
       var self = jQuery( this ),
         contents = self.contents();

       if ( contents.length ) {
         contents.wrapAll( html );

       } else {
         self.append( html );
       }
     } );
   },

   wrap: function( html ) {
     var htmlIsFunction = isFunction( html );

     return this.each( function( i ) {
       jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
     } );
   },

   unwrap: function( selector ) {
     this.parent( selector ).not( "body" ).each( function() {
       jQuery( this ).replaceWith( this.childNodes );
     } );
     return this;
   }
 } );


 jQuery.expr.pseudos.hidden = function( elem ) {
   return !jQuery.expr.pseudos.visible( elem );
 };
 jQuery.expr.pseudos.visible = function( elem ) {
   return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
 };




 jQuery.ajaxSettings.xhr = function() {
   try {
     return new window.XMLHttpRequest();
   } catch ( e ) {}
 };

 var xhrSuccessStatus = {

     // File protocol always yields status code 0, assume 200
     0: 200,

     // Support: IE <=9 only
     // #1450: sometimes IE returns 1223 when it should be 204
     1223: 204
   },
   xhrSupported = jQuery.ajaxSettings.xhr();

 support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
 support.ajax = xhrSupported = !!xhrSupported;

 jQuery.ajaxTransport( function( options ) {
   var callback, errorCallback;

   // Cross domain only allowed if supported through XMLHttpRequest
   if ( support.cors || xhrSupported && !options.crossDomain ) {
     return {
       send: function( headers, complete ) {
         var i,
           xhr = options.xhr();

         xhr.open(
           options.type,
           options.url,
           options.async,
           options.username,
           options.password
         );

         // Apply custom fields if provided
         if ( options.xhrFields ) {
           for ( i in options.xhrFields ) {
             xhr[ i ] = options.xhrFields[ i ];
           }
         }

         // Override mime type if needed
         if ( options.mimeType && xhr.overrideMimeType ) {
           xhr.overrideMimeType( options.mimeType );
         }

         // X-Requested-With header
         // For cross-domain requests, seeing as conditions for a preflight are
         // akin to a jigsaw puzzle, we simply never set it to be sure.
         // (it can always be set on a per-request basis or even using ajaxSetup)
         // For same-domain requests, won't change header if already provided.
         if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
           headers[ "X-Requested-With" ] = "XMLHttpRequest";
         }

         // Set headers
         for ( i in headers ) {
           xhr.setRequestHeader( i, headers[ i ] );
         }

         // Callback
         callback = function( type ) {
           return function() {
             if ( callback ) {
               callback = errorCallback = xhr.onload =
                 xhr.onerror = xhr.onabort = xhr.ontimeout =
                   xhr.onreadystatechange = null;

               if ( type === "abort" ) {
                 xhr.abort();
               } else if ( type === "error" ) {

                 // Support: IE <=9 only
                 // On a manual native abort, IE9 throws
                 // errors on any property access that is not readyState
                 if ( typeof xhr.status !== "number" ) {
                   complete( 0, "error" );
                 } else {
                   complete(

                     // File: protocol always yields status 0; see #8605, #14207
                     xhr.status,
                     xhr.statusText
                   );
                 }
               } else {
                 complete(
                   xhrSuccessStatus[ xhr.status ] || xhr.status,
                   xhr.statusText,

                   // Support: IE <=9 only
                   // IE9 has no XHR2 but throws on binary (trac-11426)
                   // For XHR2 non-text, let the caller handle it (gh-2498)
                   ( xhr.responseType || "text" ) !== "text"  ||
                   typeof xhr.responseText !== "string" ?
                     { binary: xhr.response } :
                     { text: xhr.responseText },
                   xhr.getAllResponseHeaders()
                 );
               }
             }
           };
         };

         // Listen to events
         xhr.onload = callback();
         errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );

         // Support: IE 9 only
         // Use onreadystatechange to replace onabort
         // to handle uncaught aborts
         if ( xhr.onabort !== undefined ) {
           xhr.onabort = errorCallback;
         } else {
           xhr.onreadystatechange = function() {

             // Check readyState before timeout as it changes
             if ( xhr.readyState === 4 ) {

               // Allow onerror to be called first,
               // but that will not handle a native abort
               // Also, save errorCallback to a variable
               // as xhr.onerror cannot be accessed
               window.setTimeout( function() {
                 if ( callback ) {
                   errorCallback();
                 }
               } );
             }
           };
         }

         // Create the abort callback
         callback = callback( "abort" );

         try {

           // Do send the request (this may raise an exception)
           xhr.send( options.hasContent && options.data || null );
         } catch ( e ) {

           // #14683: Only rethrow if this hasn't been notified as an error yet
           if ( callback ) {
             throw e;
           }
         }
       },

       abort: function() {
         if ( callback ) {
           callback();
         }
       }
     };
   }
 } );




 // Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
 jQuery.ajaxPrefilter( function( s ) {
   if ( s.crossDomain ) {
     s.contents.script = false;
   }
 } );

 // Install script dataType
 jQuery.ajaxSetup( {
   accepts: {
     script: "text/javascript, application/javascript, " +
       "application/ecmascript, application/x-ecmascript"
   },
   contents: {
     script: /\b(?:java|ecma)script\b/
   },
   converters: {
     "text script": function( text ) {
       jQuery.globalEval( text );
       return text;
     }
   }
 } );

 // Handle cache's special case and crossDomain
 jQuery.ajaxPrefilter( "script", function( s ) {
   if ( s.cache === undefined ) {
     s.cache = false;
   }
   if ( s.crossDomain ) {
     s.type = "GET";
   }
 } );

 // Bind script tag hack transport
 jQuery.ajaxTransport( "script", function( s ) {

   // This transport only deals with cross domain or forced-by-attrs requests
   if ( s.crossDomain || s.scriptAttrs ) {
     var script, callback;
     return {
       send: function( _, complete ) {
         script = jQuery( "<script>" )
           .attr( s.scriptAttrs || {} )
           .prop( { charset: s.scriptCharset, src: s.url } )
           .on( "load error", callback = function( evt ) {
             script.remove();
             callback = null;
             if ( evt ) {
               complete( evt.type === "error" ? 404 : 200, evt.type );
             }
           } );

         // Use native DOM manipulation to avoid our domManip AJAX trickery
         document.head.appendChild( script[ 0 ] );
       },
       abort: function() {
         if ( callback ) {
           callback();
         }
       }
     };
   }
 } );




 var oldCallbacks = [],
   rjsonp = /(=)\?(?=&|$)|\?\?/;

 // Default jsonp settings
 jQuery.ajaxSetup( {
   jsonp: "callback",
   jsonpCallback: function() {
     var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce.guid++ ) );
     this[ callback ] = true;
     return callback;
   }
 } );

 // Detect, normalize options and install callbacks for jsonp requests
 jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

   var callbackName, overwritten, responseContainer,
     jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
       "url" :
       typeof s.data === "string" &&
         ( s.contentType || "" )
           .indexOf( "application/x-www-form-urlencoded" ) === 0 &&
         rjsonp.test( s.data ) && "data"
     );

   // Handle iff the expected data type is "jsonp" or we have a parameter to set
   if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

     // Get callback name, remembering preexisting value associated with it
     callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
       s.jsonpCallback() :
       s.jsonpCallback;

     // Insert callback into url or form data
     if ( jsonProp ) {
       s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
     } else if ( s.jsonp !== false ) {
       s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
     }

     // Use data converter to retrieve json after script execution
     s.converters[ "script json" ] = function() {
       if ( !responseContainer ) {
         jQuery.error( callbackName + " was not called" );
       }
       return responseContainer[ 0 ];
     };

     // Force json dataType
     s.dataTypes[ 0 ] = "json";

     // Install callback
     overwritten = window[ callbackName ];
     window[ callbackName ] = function() {
       responseContainer = arguments;
     };

     // Clean-up function (fires after converters)
     jqXHR.always( function() {

       // If previous value didn't exist - remove it
       if ( overwritten === undefined ) {
         jQuery( window ).removeProp( callbackName );

       // Otherwise restore preexisting value
       } else {
         window[ callbackName ] = overwritten;
       }

       // Save back as free
       if ( s[ callbackName ] ) {

         // Make sure that re-using the options doesn't screw things around
         s.jsonpCallback = originalSettings.jsonpCallback;

         // Save the callback name for future use
         oldCallbacks.push( callbackName );
       }

       // Call if it was a function and we have a response
       if ( responseContainer && isFunction( overwritten ) ) {
         overwritten( responseContainer[ 0 ] );
       }

       responseContainer = overwritten = undefined;
     } );

     // Delegate to script
     return "script";
   }
 } );




 // Support: Safari 8 only
 // In Safari 8 documents created via document.implementation.createHTMLDocument
 // collapse sibling forms: the second one becomes a child of the first one.
 // Because of that, this security measure has to be disabled in Safari 8.
 // https://bugs.webkit.org/show_bug.cgi?id=137337
 support.createHTMLDocument = ( function() {
   var body = document.implementation.createHTMLDocument( "" ).body;
   body.innerHTML = "<form></form><form></form>";
   return body.childNodes.length === 2;
 } )();


 // Argument "data" should be string of html
 // context (optional): If specified, the fragment will be created in this context,
 // defaults to document
 // keepScripts (optional): If true, will include scripts passed in the html string
 jQuery.parseHTML = function( data, context, keepScripts ) {
   if ( typeof data !== "string" ) {
     return [];
   }
   if ( typeof context === "boolean" ) {
     keepScripts = context;
     context = false;
   }

   var base, parsed, scripts;

   if ( !context ) {

     // Stop scripts or inline event handlers from being executed immediately
     // by using document.implementation
     if ( support.createHTMLDocument ) {
       context = document.implementation.createHTMLDocument( "" );

       // Set the base href for the created document
       // so any parsed elements with URLs
       // are based on the document's URL (gh-2965)
       base = context.createElement( "base" );
       base.href = document.location.href;
       context.head.appendChild( base );
     } else {
       context = document;
     }
   }

   parsed = rsingleTag.exec( data );
   scripts = !keepScripts && [];

   // Single tag
   if ( parsed ) {
     return [ context.createElement( parsed[ 1 ] ) ];
   }

   parsed = buildFragment( [ data ], context, scripts );

   if ( scripts && scripts.length ) {
     jQuery( scripts ).remove();
   }

   return jQuery.merge( [], parsed.childNodes );
 };


 /**
  * Load a url into a page
  */
 jQuery.fn.load = function( url, params, callback ) {
   var selector, type, response,
     self = this,
     off = url.indexOf( " " );

   if ( off > -1 ) {
     selector = stripAndCollapse( url.slice( off ) );
     url = url.slice( 0, off );
   }

   // If it's a function
   if ( isFunction( params ) ) {

     // We assume that it's the callback
     callback = params;
     params = undefined;

   // Otherwise, build a param string
   } else if ( params && typeof params === "object" ) {
     type = "POST";
   }

   // If we have elements to modify, make the request
   if ( self.length > 0 ) {
     jQuery.ajax( {
       url: url,

       // If "type" variable is undefined, then "GET" method will be used.
       // Make value of this field explicit since
       // user can override it through ajaxSetup method
       type: type || "GET",
       dataType: "html",
       data: params
     } ).done( function( responseText ) {

       // Save response for use in complete callback
       response = arguments;

       self.html( selector ?

         // If a selector was specified, locate the right elements in a dummy div
         // Exclude scripts to avoid IE 'Permission Denied' errors
         jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

         // Otherwise use the full result
         responseText );

     // If the request succeeds, this function gets "data", "status", "jqXHR"
     // but they are ignored because response was set above.
     // If it fails, this function gets "jqXHR", "status", "error"
     } ).always( callback && function( jqXHR, status ) {
       self.each( function() {
         callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
       } );
     } );
   }

   return this;
 };




 jQuery.expr.pseudos.animated = function( elem ) {
   return jQuery.grep( jQuery.timers, function( fn ) {
     return elem === fn.elem;
   } ).length;
 };




 jQuery.offset = {
   setOffset: function( elem, options, i ) {
     var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
       position = jQuery.css( elem, "position" ),
       curElem = jQuery( elem ),
       props = {};

     // Set position first, in-case top/left are set even on static elem
     if ( position === "static" ) {
       elem.style.position = "relative";
     }

     curOffset = curElem.offset();
     curCSSTop = jQuery.css( elem, "top" );
     curCSSLeft = jQuery.css( elem, "left" );
     calculatePosition = ( position === "absolute" || position === "fixed" ) &&
       ( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

     // Need to be able to calculate position if either
     // top or left is auto and position is either absolute or fixed
     if ( calculatePosition ) {
       curPosition = curElem.position();
       curTop = curPosition.top;
       curLeft = curPosition.left;

     } else {
       curTop = parseFloat( curCSSTop ) || 0;
       curLeft = parseFloat( curCSSLeft ) || 0;
     }

     if ( isFunction( options ) ) {

       // Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
       options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
     }

     if ( options.top != null ) {
       props.top = ( options.top - curOffset.top ) + curTop;
     }
     if ( options.left != null ) {
       props.left = ( options.left - curOffset.left ) + curLeft;
     }

     if ( "using" in options ) {
       options.using.call( elem, props );

     } else {
       curElem.css( props );
     }
   }
 };

 jQuery.fn.extend( {

   // offset() relates an element's border box to the document origin
   offset: function( options ) {

     // Preserve chaining for setter
     if ( arguments.length ) {
       return options === undefined ?
         this :
         this.each( function( i ) {
           jQuery.offset.setOffset( this, options, i );
         } );
     }

     var rect, win,
       elem = this[ 0 ];

     if ( !elem ) {
       return;
     }

     // Return zeros for disconnected and hidden (display: none) elements (gh-2310)
     // Support: IE <=11 only
     // Running getBoundingClientRect on a
     // disconnected node in IE throws an error
     if ( !elem.getClientRects().length ) {
       return { top: 0, left: 0 };
     }

     // Get document-relative position by adding viewport scroll to viewport-relative gBCR
     rect = elem.getBoundingClientRect();
     win = elem.ownerDocument.defaultView;
     return {
       top: rect.top + win.pageYOffset,
       left: rect.left + win.pageXOffset
     };
   },

   // position() relates an element's margin box to its offset parent's padding box
   // This corresponds to the behavior of CSS absolute positioning
   position: function() {
     if ( !this[ 0 ] ) {
       return;
     }

     var offsetParent, offset, doc,
       elem = this[ 0 ],
       parentOffset = { top: 0, left: 0 };

     // position:fixed elements are offset from the viewport, which itself always has zero offset
     if ( jQuery.css( elem, "position" ) === "fixed" ) {

       // Assume position:fixed implies availability of getBoundingClientRect
       offset = elem.getBoundingClientRect();

     } else {
       offset = this.offset();

       // Account for the *real* offset parent, which can be the document or its root element
       // when a statically positioned element is identified
       doc = elem.ownerDocument;
       offsetParent = elem.offsetParent || doc.documentElement;
       while ( offsetParent &&
         ( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
         jQuery.css( offsetParent, "position" ) === "static" ) {

         offsetParent = offsetParent.parentNode;
       }
       if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {

         // Incorporate borders into its offset, since they are outside its content origin
         parentOffset = jQuery( offsetParent ).offset();
         parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
         parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
       }
     }

     // Subtract parent offsets and element margins
     return {
       top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
       left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
     };
   },

   // This method will return documentElement in the following cases:
   // 1) For the element inside the iframe without offsetParent, this method will return
   //    documentElement of the parent window
   // 2) For the hidden or detached element
   // 3) For body or html element, i.e. in case of the html node - it will return itself
   //
   // but those exceptions were never presented as a real life use-cases
   // and might be considered as more preferable results.
   //
   // This logic, however, is not guaranteed and can change at any point in the future
   offsetParent: function() {
     return this.map( function() {
       var offsetParent = this.offsetParent;

       while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
         offsetParent = offsetParent.offsetParent;
       }

       return offsetParent || documentElement;
     } );
   }
 } );

 // Create scrollLeft and scrollTop methods
 jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
   var top = "pageYOffset" === prop;

   jQuery.fn[ method ] = function( val ) {
     return access( this, function( elem, method, val ) {

       // Coalesce documents and windows
       var win;
       if ( isWindow( elem ) ) {
         win = elem;
       } else if ( elem.nodeType === 9 ) {
         win = elem.defaultView;
       }

       if ( val === undefined ) {
         return win ? win[ prop ] : elem[ method ];
       }

       if ( win ) {
         win.scrollTo(
           !top ? val : win.pageXOffset,
           top ? val : win.pageYOffset
         );

       } else {
         elem[ method ] = val;
       }
     }, method, val, arguments.length );
   };
 } );

 // Support: Safari <=7 - 9.1, Chrome <=37 - 49
 // Add the top/left cssHooks using jQuery.fn.position
 // Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
 // Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
 // getComputedStyle returns percent when specified for top/left/bottom/right;
 // rather than make the css module depend on the offset module, just check for it here
 jQuery.each( [ "top", "left" ], function( _i, prop ) {
   jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
     function( elem, computed ) {
       if ( computed ) {
         computed = curCSS( elem, prop );

         // If curCSS returns percentage, fallback to offset
         return rnumnonpx.test( computed ) ?
           jQuery( elem ).position()[ prop ] + "px" :
           computed;
       }
     }
   );
 } );


 // Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
 jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
   jQuery.each( {
     padding: "inner" + name,
     content: type,
     "": "outer" + name
   }, function( defaultExtra, funcName ) {

     // Margin is only for outerHeight, outerWidth
     jQuery.fn[ funcName ] = function( margin, value ) {
       var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
         extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

       return access( this, function( elem, type, value ) {
         var doc;

         if ( isWindow( elem ) ) {

           // $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
           return funcName.indexOf( "outer" ) === 0 ?
             elem[ "inner" + name ] :
             elem.document.documentElement[ "client" + name ];
         }

         // Get document width or height
         if ( elem.nodeType === 9 ) {
           doc = elem.documentElement;

           // Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
           // whichever is greatest
           return Math.max(
             elem.body[ "scroll" + name ], doc[ "scroll" + name ],
             elem.body[ "offset" + name ], doc[ "offset" + name ],
             doc[ "client" + name ]
           );
         }

         return value === undefined ?

           // Get width or height on the element, requesting but not forcing parseFloat
           jQuery.css( elem, type, extra ) :

           // Set width or height on the element
           jQuery.style( elem, type, value, extra );
       }, type, chainable ? margin : undefined, chainable );
     };
   } );
 } );


 jQuery.each( [
   "ajaxStart",
   "ajaxStop",
   "ajaxComplete",
   "ajaxError",
   "ajaxSuccess",
   "ajaxSend"
 ], function( _i, type ) {
   jQuery.fn[ type ] = function( fn ) {
     return this.on( type, fn );
   };
 } );




 jQuery.fn.extend( {

   bind: function( types, data, fn ) {
     return this.on( types, null, data, fn );
   },
   unbind: function( types, fn ) {
     return this.off( types, null, fn );
   },

   delegate: function( selector, types, data, fn ) {
     return this.on( types, selector, data, fn );
   },
   undelegate: function( selector, types, fn ) {

     // ( namespace ) or ( selector, types [, fn] )
     return arguments.length === 1 ?
       this.off( selector, "**" ) :
       this.off( types, selector || "**", fn );
   },

   hover: function( fnOver, fnOut ) {
     return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
   }
 } );

 jQuery.each(
   ( "blur focus focusin focusout resize scroll click dblclick " +
   "mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
   "change select submit keydown keypress keyup contextmenu" ).split( " " ),
   function( _i, name ) {

     // Handle event binding
     jQuery.fn[ name ] = function( data, fn ) {
       return arguments.length > 0 ?
         this.on( name, null, data, fn ) :
         this.trigger( name );
     };
   }
 );




 // Support: Android <=4.0 only
 // Make sure we trim BOM and NBSP
 var rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;

 // Bind a function to a context, optionally partially applying any
 // arguments.
 // jQuery.proxy is deprecated to promote standards (specifically Function#bind)
 // However, it is not slated for removal any time soon
 jQuery.proxy = function( fn, context ) {
   var tmp, args, proxy;

   if ( typeof context === "string" ) {
     tmp = fn[ context ];
     context = fn;
     fn = tmp;
   }

   // Quick check to determine if target is callable, in the spec
   // this throws a TypeError, but we will just return undefined.
   if ( !isFunction( fn ) ) {
     return undefined;
   }

   // Simulated bind
   args = slice.call( arguments, 2 );
   proxy = function() {
     return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
   };

   // Set the guid of unique handler to the same of original handler, so it can be removed
   proxy.guid = fn.guid = fn.guid || jQuery.guid++;

   return proxy;
 };

 jQuery.holdReady = function( hold ) {
   if ( hold ) {
     jQuery.readyWait++;
   } else {
     jQuery.ready( true );
   }
 };
 jQuery.isArray = Array.isArray;
 jQuery.parseJSON = JSON.parse;
 jQuery.nodeName = nodeName;
 jQuery.isFunction = isFunction;
 jQuery.isWindow = isWindow;
 jQuery.camelCase = camelCase;
 jQuery.type = toType;

 jQuery.now = Date.now;

 jQuery.isNumeric = function( obj ) {

   // As of jQuery 3.0, isNumeric is limited to
   // strings and numbers (primitives or objects)
   // that can be coerced to finite numbers (gh-2662)
   var type = jQuery.type( obj );
   return ( type === "number" || type === "string" ) &&

     // parseFloat NaNs numeric-cast false positives ("")
     // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
     // subtraction forces infinities to NaN
     !isNaN( obj - parseFloat( obj ) );
 };

 jQuery.trim = function( text ) {
   return text == null ?
     "" :
     ( text + "" ).replace( rtrim, "" );
 };



 // Register as a named AMD module, since jQuery can be concatenated with other
 // files that may use define, but not via a proper concatenation script that
 // understands anonymous AMD modules. A named AMD is safest and most robust
 // way to register. Lowercase jquery is used because AMD module names are
 // derived from file names, and jQuery is normally delivered in a lowercase
 // file name. Do this after creating the global so that if an AMD module wants
 // to call noConflict to hide this version of jQuery, it will work.

 // Note that for maximum portability, libraries that are not jQuery should
 // declare themselves as anonymous modules, and avoid setting a global if an
 // AMD loader is present. jQuery is a special case. For more information, see
 // https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

 if ( true ) {
   !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
     return jQuery;
   }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
         __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
 }




 var

   // Map over jQuery in case of overwrite
   _jQuery = window.jQuery,

   // Map over the $ in case of overwrite
   _$ = window.$;

 jQuery.noConflict = function( deep ) {
   if ( window.$ === jQuery ) {
     window.$ = _$;
   }

   if ( deep && window.jQuery === jQuery ) {
     window.jQuery = _jQuery;
   }

   return jQuery;
 };

 // Expose jQuery and $ identifiers, even in AMD
 // (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
 // and CommonJS for browser emulators (#13566)
 if ( typeof noGlobal === "undefined" ) {
   window.jQuery = window.$ = jQuery;
 }




 return jQuery;
 } );


 /***/ }),
 /* 1 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";

 // CONCATENATED MODULE: ./node_modules/@shopify/theme-sections/section.js
 var SECTION_ID_ATTR = 'data-section-id';

 function Section(container, properties) {
   this.container = validateContainerElement(container);
   this.id = container.getAttribute(SECTION_ID_ATTR);
   this.extensions = [];

   // eslint-disable-next-line es5/no-es6-static-methods
   Object.assign(this, validatePropertiesObject(properties));

   this.onLoad();
 }

 Section.prototype = {
   onLoad: Function.prototype,
   onUnload: Function.prototype,
   onSelect: Function.prototype,
   onDeselect: Function.prototype,
   onBlockSelect: Function.prototype,
   onBlockDeselect: Function.prototype,

   extend: function extend(extension) {
     this.extensions.push(extension); // Save original extension

     // eslint-disable-next-line es5/no-es6-static-methods
     var extensionClone = Object.assign({}, extension);
     delete extensionClone.init; // Remove init function before assigning extension properties

     // eslint-disable-next-line es5/no-es6-static-methods
     Object.assign(this, extensionClone);

     if (typeof extension.init === 'function') {
       extension.init.apply(this);
     }
   }
 };

 function validateContainerElement(container) {
   if (!(container instanceof Element)) {
     throw new TypeError(
       'Theme Sections: Attempted to load section. The section container provided is not a DOM element.'
     );
   }
   if (container.getAttribute(SECTION_ID_ATTR) === null) {
     throw new Error(
       'Theme Sections: The section container provided does not have an id assigned to the ' +
         SECTION_ID_ATTR +
         ' attribute.'
     );
   }

   return container;
 }

 function validatePropertiesObject(value) {
   if (
     (typeof value !== 'undefined' && typeof value !== 'object') ||
     value === null
   ) {
     throw new TypeError(
       'Theme Sections: The properties object provided is not a valid'
     );
   }

   return value;
 }

 // Object.assign() polyfill from https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign#Polyfill
 if (typeof Object.assign != 'function') {
   // Must be writable: true, enumerable: false, configurable: true
   Object.defineProperty(Object, 'assign', {
     value: function assign(target) {
       // .length of function is 2
       'use strict';
       if (target == null) {
         // TypeError if undefined or null
         throw new TypeError('Cannot convert undefined or null to object');
       }

       var to = Object(target);

       for (var index = 1; index < arguments.length; index++) {
         var nextSource = arguments[index];

         if (nextSource != null) {
           // Skip over if undefined or null
           for (var nextKey in nextSource) {
             // Avoid bugs when hasOwnProperty is shadowed
             if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
               to[nextKey] = nextSource[nextKey];
             }
           }
         }
       }
       return to;
     },
     writable: true,
     configurable: true
   });
 }

 // CONCATENATED MODULE: ./node_modules/@shopify/theme-sections/theme-sections.js
 /* unused harmony export registered */
 /* unused harmony export instances */
 /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return register; });
 /* unused harmony export unregister */
 /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return load; });
 /* unused harmony export unload */
 /* unused harmony export extend */
 /* unused harmony export getInstances */
 /* unused harmony export getInstanceById */
 /* unused harmony export isInstance */
 /*
  * @shopify/theme-sections
  * -----------------------------------------------------------------------------
  *
  * A framework to provide structure to your Shopify sections and a load and unload
  * lifecycle. The lifecycle is automatically connected to theme editor events so
  * that your sections load and unload as the editor changes the content and
  * settings of your sections.
  */



 var SECTION_TYPE_ATTR = 'data-section-type';
 var theme_sections_SECTION_ID_ATTR = 'data-section-id';

 window.Shopify = window.Shopify || {};
 window.Shopify.theme = window.Shopify.theme || {};
 window.Shopify.theme.sections = window.Shopify.theme.sections || {};

 var registered = (window.Shopify.theme.sections.registered =
   window.Shopify.theme.sections.registered || {});
 var instances = (window.Shopify.theme.sections.instances =
   window.Shopify.theme.sections.instances || []);

 function register(type, properties) {
   if (typeof type !== 'string') {
     throw new TypeError(
       'Theme Sections: The first argument for .register must be a string that specifies the type of the section being registered'
     );
   }

   if (typeof registered[type] !== 'undefined') {
     throw new Error(
       'Theme Sections: A section of type "' +
         type +
         '" has already been registered. You cannot register the same section type twice'
     );
   }

   function TypedSection(container) {
     Section.call(this, container, properties);
   }

   TypedSection.constructor = Section;
   TypedSection.prototype = Object.create(Section.prototype);
   TypedSection.prototype.type = type;

   return (registered[type] = TypedSection);
 }

 function unregister(types) {
   types = normalizeType(types);

   types.forEach(function(type) {
     delete registered[type];
   });
 }

 function load(types, containers) {
   types = normalizeType(types);

   if (typeof containers === 'undefined') {
     containers = document.querySelectorAll('[' + SECTION_TYPE_ATTR + ']');
   }

   containers = normalizeContainers(containers);

   types.forEach(function(type) {
     var TypedSection = registered[type];

     if (typeof TypedSection === 'undefined') {
       return;
     }

     containers = containers.filter(function(container) {
       // Filter from list of containers because container already has an instance loaded
       if (isInstance(container)) {
         return false;
       }

       // Filter from list of containers because container doesn't have data-section-type attribute
       if (container.getAttribute(SECTION_TYPE_ATTR) === null) {
         return false;
       }

       // Keep in list of containers because current type doesn't match
       if (container.getAttribute(SECTION_TYPE_ATTR) !== type) {
         return true;
       }

       instances.push(new TypedSection(container));

       // Filter from list of containers because container now has an instance loaded
       return false;
     });
   });
 }

 function unload(selector) {
   var instancesToUnload = getInstances(selector);

   instancesToUnload.forEach(function(instance) {
     var index = instances
       .map(function(e) {
         return e.id;
       })
       .indexOf(instance.id);
     instances.splice(index, 1);
     instance.onUnload();
   });
 }

 function extend(selector, extension) {
   var instancesToExtend = getInstances(selector);

   instancesToExtend.forEach(function(instance) {
     instance.extend(extension);
   });
 }

 function getInstances(selector) {
   var filteredInstances = [];

   // Fetch first element if its an array
   if (NodeList.prototype.isPrototypeOf(selector) || Array.isArray(selector)) {
     var firstElement = selector[0];
   }

   // If selector element is DOM element
   if (selector instanceof Element || firstElement instanceof Element) {
     var containers = normalizeContainers(selector);

     containers.forEach(function(container) {
       filteredInstances = filteredInstances.concat(
         instances.filter(function(instance) {
           return instance.container === container;
         })
       );
     });

     // If select is type string
   } else if (typeof selector === 'string' || typeof firstElement === 'string') {
     var types = normalizeType(selector);

     types.forEach(function(type) {
       filteredInstances = filteredInstances.concat(
         instances.filter(function(instance) {
           return instance.type === type;
         })
       );
     });
   }

   return filteredInstances;
 }

 function getInstanceById(id) {
   var instance;

   for (var i = 0; i < instances.length; i++) {
     if (instances[i].id === id) {
       instance = instances[i];
       break;
     }
   }
   return instance;
 }

 function isInstance(selector) {
   return getInstances(selector).length > 0;
 }

 function normalizeType(types) {
   // If '*' then fetch all registered section types
   if (types === '*') {
     types = Object.keys(registered);

     // If a single section type string is passed, put it in an array
   } else if (typeof types === 'string') {
     types = [types];

     // If single section constructor is passed, transform to array with section
     // type string
   } else if (types.constructor === Section) {
     types = [types.prototype.type];

     // If array of typed section constructors is passed, transform the array to
     // type strings
   } else if (Array.isArray(types) && types[0].constructor === Section) {
     types = types.map(function(TypedSection) {
       return TypedSection.prototype.type;
     });
   }

   types = types.map(function(type) {
     return type.toLowerCase();
   });

   return types;
 }

 function normalizeContainers(containers) {
   // Nodelist with entries
   if (NodeList.prototype.isPrototypeOf(containers) && containers.length > 0) {
     containers = Array.prototype.slice.call(containers);

     // Empty Nodelist
   } else if (
     NodeList.prototype.isPrototypeOf(containers) &&
     containers.length === 0
   ) {
     containers = [];

     // Handle null (document.querySelector() returns null with no match)
   } else if (containers === null) {
     containers = [];

     // Single DOM element
   } else if (!Array.isArray(containers) && containers instanceof Element) {
     containers = [containers];
   }

   return containers;
 }

 if (window.Shopify.designMode) {
   document.addEventListener('shopify:section:load', function(event) {
     var id = event.detail.sectionId;
     var container = event.target.querySelector(
       '[' + theme_sections_SECTION_ID_ATTR + '="' + id + '"]'
     );

     if (container !== null) {
       load(container.getAttribute(SECTION_TYPE_ATTR), container);
     }
   });

   document.addEventListener('shopify:section:unload', function(event) {
     var id = event.detail.sectionId;
     var container = event.target.querySelector(
       '[' + theme_sections_SECTION_ID_ATTR + '="' + id + '"]'
     );
     var instance = getInstances(container)[0];

     if (typeof instance === 'object') {
       unload(container);
     }
   });

   document.addEventListener('shopify:section:select', function(event) {
     var instance = getInstanceById(event.detail.sectionId);

     if (typeof instance === 'object') {
       instance.onSelect(event);
     }
   });

   document.addEventListener('shopify:section:deselect', function(event) {
     var instance = getInstanceById(event.detail.sectionId);

     if (typeof instance === 'object') {
       instance.onDeselect(event);
     }
   });

   document.addEventListener('shopify:block:select', function(event) {
     var instance = getInstanceById(event.detail.sectionId);

     if (typeof instance === 'object') {
       instance.onBlockSelect(event);
     }
   });

   document.addEventListener('shopify:block:deselect', function(event) {
     var instance = getInstanceById(event.detail.sectionId);

     if (typeof instance === 'object') {
       instance.onBlockDeselect(event);
     }
   });
 }


 /***/ }),
 /* 2 */
 /***/ (function(module, exports, __webpack_require__) {

 /* WEBPACK VAR INJECTION */(function(global) {var check = function (it) {
   return it && it.Math == Math && it;
 };

 // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
 module.exports =
   // eslint-disable-next-line es/no-global-this -- safe
   check(typeof globalThis == 'object' && globalThis) ||
   check(typeof window == 'object' && window) ||
   // eslint-disable-next-line no-restricted-globals -- safe
   check(typeof self == 'object' && self) ||
   check(typeof global == 'object' && global) ||
   // eslint-disable-next-line no-new-func -- fallback
   (function () { return this; })() || Function('return this')();

 /* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(69)))

 /***/ }),
 /* 3 */
 /***/ (function(module, exports, __webpack_require__) {

 var TO_STRING_TAG_SUPPORT = __webpack_require__(100);
 var redefine = __webpack_require__(32);
 var toString = __webpack_require__(166);

 // `Object.prototype.toString` method
 // https://tc39.es/ecma262/#sec-object.prototype.tostring
 if (!TO_STRING_TAG_SUPPORT) {
   redefine(Object.prototype, 'toString', toString, { unsafe: true });
 }


 /***/ }),
 /* 4 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";
 /* unused harmony export extend */
 /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getDocument; });
 /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getWindow; });
 /* unused harmony export ssrDocument */
 /* unused harmony export ssrWindow */
 /**
  * SSR Window 3.0.0
  * Better handling for window object in SSR environment
  * https://github.com/nolimits4web/ssr-window
  *
  * Copyright 2020, Vladimir Kharlampidi
  *
  * Licensed under MIT
  *
  * Released on: November 9, 2020
  */
 /* eslint-disable no-param-reassign */
 function isObject(obj) {
     return (obj !== null &&
         typeof obj === 'object' &&
         'constructor' in obj &&
         obj.constructor === Object);
 }
 function extend(target, src) {
     if (target === void 0) { target = {}; }
     if (src === void 0) { src = {}; }
     Object.keys(src).forEach(function (key) {
         if (typeof target[key] === 'undefined')
             target[key] = src[key];
         else if (isObject(src[key]) &&
             isObject(target[key]) &&
             Object.keys(src[key]).length > 0) {
             extend(target[key], src[key]);
         }
     });
 }

 var ssrDocument = {
     body: {},
     addEventListener: function () { },
     removeEventListener: function () { },
     activeElement: {
         blur: function () { },
         nodeName: '',
     },
     querySelector: function () {
         return null;
     },
     querySelectorAll: function () {
         return [];
     },
     getElementById: function () {
         return null;
     },
     createEvent: function () {
         return {
             initEvent: function () { },
         };
     },
     createElement: function () {
         return {
             children: [],
             childNodes: [],
             style: {},
             setAttribute: function () { },
             getElementsByTagName: function () {
                 return [];
             },
         };
     },
     createElementNS: function () {
         return {};
     },
     importNode: function () {
         return null;
     },
     location: {
         hash: '',
         host: '',
         hostname: '',
         href: '',
         origin: '',
         pathname: '',
         protocol: '',
         search: '',
     },
 };
 function getDocument() {
     var doc = typeof document !== 'undefined' ? document : {};
     extend(doc, ssrDocument);
     return doc;
 }

 var ssrWindow = {
     document: ssrDocument,
     navigator: {
         userAgent: '',
     },
     location: {
         hash: '',
         host: '',
         hostname: '',
         href: '',
         origin: '',
         pathname: '',
         protocol: '',
         search: '',
     },
     history: {
         replaceState: function () { },
         pushState: function () { },
         go: function () { },
         back: function () { },
     },
     CustomEvent: function CustomEvent() {
         return this;
     },
     addEventListener: function () { },
     removeEventListener: function () { },
     getComputedStyle: function () {
         return {
             getPropertyValue: function () {
                 return '';
             },
         };
     },
     Image: function () { },
     Date: function () { },
     screen: {},
     setTimeout: function () { },
     clearTimeout: function () { },
     matchMedia: function () {
         return {};
     },
     requestAnimationFrame: function (callback) {
         if (typeof setTimeout === 'undefined') {
             callback();
             return null;
         }
         return setTimeout(callback, 0);
     },
     cancelAnimationFrame: function (id) {
         if (typeof setTimeout === 'undefined') {
             return;
         }
         clearTimeout(id);
     },
 };
 function getWindow() {
     var win = typeof window !== 'undefined' ? window : {};
     extend(win, ssrWindow);
     return win;
 }




 /***/ }),
 /* 5 */
 /***/ (function(module, exports) {

 var FunctionPrototype = Function.prototype;
 var bind = FunctionPrototype.bind;
 var call = FunctionPrototype.call;
 var callBind = bind && bind.bind(call);

 module.exports = bind ? function (fn) {
   return fn && callBind(call, fn);
 } : function (fn) {
   return fn && function () {
     return call.apply(fn, arguments);
   };
 };


 /***/ }),
 /* 6 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";
 /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return deleteProps; });
 /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return nextTick; });
 /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return now; });
 /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getTranslate; });
 /* unused harmony export isObject */
 /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return extend; });
 /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return bindModuleMethods; });
 /* unused harmony export getComputedStyle */
 /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return classesToSelector; });
 /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createElementIfNotDefined; });
 /* harmony import */ var ssr_window__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4);


 function deleteProps(obj) {
   var object = obj;
   Object.keys(object).forEach(function (key) {
     try {
       object[key] = null;
     } catch (e) {// no getter for object
     }

     try {
       delete object[key];
     } catch (e) {// something got wrong
     }
   });
 }

 function nextTick(callback, delay) {
   if (delay === void 0) {
     delay = 0;
   }

   return setTimeout(callback, delay);
 }

 function now() {
   return Date.now();
 }

 function getComputedStyle(el) {
   var window = Object(ssr_window__WEBPACK_IMPORTED_MODULE_0__[/* getWindow */ "b"])();
   var style;

   if (window.getComputedStyle) {
     style = window.getComputedStyle(el, null);
   }

   if (!style && el.currentStyle) {
     style = el.currentStyle;
   }

   if (!style) {
     style = el.style;
   }

   return style;
 }

 function getTranslate(el, axis) {
   if (axis === void 0) {
     axis = 'x';
   }

   var window = Object(ssr_window__WEBPACK_IMPORTED_MODULE_0__[/* getWindow */ "b"])();
   var matrix;
   var curTransform;
   var transformMatrix;
   var curStyle = getComputedStyle(el, null);

   if (window.WebKitCSSMatrix) {
     curTransform = curStyle.transform || curStyle.webkitTransform;

     if (curTransform.split(',').length > 6) {
       curTransform = curTransform.split(', ').map(function (a) {
         return a.replace(',', '.');
       }).join(', ');
     } // Some old versions of Webkit choke when 'none' is passed; pass
     // empty string instead in this case


     transformMatrix = new window.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
   } else {
     transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
     matrix = transformMatrix.toString().split(',');
   }

   if (axis === 'x') {
     // Latest Chrome and webkits Fix
     if (window.WebKitCSSMatrix) curTransform = transformMatrix.m41; // Crazy IE10 Matrix
     else if (matrix.length === 16) curTransform = parseFloat(matrix[12]); // Normal Browsers
       else curTransform = parseFloat(matrix[4]);
   }

   if (axis === 'y') {
     // Latest Chrome and webkits Fix
     if (window.WebKitCSSMatrix) curTransform = transformMatrix.m42; // Crazy IE10 Matrix
     else if (matrix.length === 16) curTransform = parseFloat(matrix[13]); // Normal Browsers
       else curTransform = parseFloat(matrix[5]);
   }

   return curTransform || 0;
 }

 function isObject(o) {
   return typeof o === 'object' && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === 'Object';
 }

 function isNode(node) {
   // eslint-disable-next-line
   if (typeof window !== 'undefined' && typeof window.HTMLElement !== 'undefined') {
     return node instanceof HTMLElement;
   }

   return node && (node.nodeType === 1 || node.nodeType === 11);
 }

 function extend() {
   var to = Object(arguments.length <= 0 ? undefined : arguments[0]);
   var noExtend = ['__proto__', 'constructor', 'prototype'];

   for (var i = 1; i < arguments.length; i += 1) {
     var nextSource = i < 0 || arguments.length <= i ? undefined : arguments[i];

     if (nextSource !== undefined && nextSource !== null && !isNode(nextSource)) {
       var keysArray = Object.keys(Object(nextSource)).filter(function (key) {
         return noExtend.indexOf(key) < 0;
       });

       for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1) {
         var nextKey = keysArray[nextIndex];
         var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);

         if (desc !== undefined && desc.enumerable) {
           if (isObject(to[nextKey]) && isObject(nextSource[nextKey])) {
             if (nextSource[nextKey].__swiper__) {
               to[nextKey] = nextSource[nextKey];
             } else {
               extend(to[nextKey], nextSource[nextKey]);
             }
           } else if (!isObject(to[nextKey]) && isObject(nextSource[nextKey])) {
             to[nextKey] = {};

             if (nextSource[nextKey].__swiper__) {
               to[nextKey] = nextSource[nextKey];
             } else {
               extend(to[nextKey], nextSource[nextKey]);
             }
           } else {
             to[nextKey] = nextSource[nextKey];
           }
         }
       }
     }
   }

   return to;
 }

 function bindModuleMethods(instance, obj) {
   Object.keys(obj).forEach(function (key) {
     if (isObject(obj[key])) {
       Object.keys(obj[key]).forEach(function (subKey) {
         if (typeof obj[key][subKey] === 'function') {
           obj[key][subKey] = obj[key][subKey].bind(instance);
         }
       });
     }

     instance[key] = obj[key];
   });
 }

 function classesToSelector(classes) {
   if (classes === void 0) {
     classes = '';
   }

   return "." + classes.trim().replace(/([\.:!\/])/g, '\\$1') // eslint-disable-line
   .replace(/ /g, '.');
 }

 function createElementIfNotDefined($container, params, createElements, checkProps) {
   var document = Object(ssr_window__WEBPACK_IMPORTED_MODULE_0__[/* getDocument */ "a"])();

   if (createElements) {
     Object.keys(checkProps).forEach(function (key) {
       if (!params[key] && params.auto === true) {
         var element = document.createElement('div');
         element.className = checkProps[key];
         $container.append(element);
         params[key] = element;
       }
     });
   }

   return params;
 }



 /***/ }),
 /* 7 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";
 __webpack_require__.r(__webpack_exports__);
 /* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3);
 /* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8);
 /* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_1__);
 /* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40);
 /* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_2__);
 /* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29);
 /* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_3__);
 /* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25);
 /* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_4__);
 /* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44);
 /* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_5__);
 /* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(43);
 /* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_6__);
 /* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(103);
 /* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(172);








 function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

 function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

 function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

 function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

 function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

 function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }


 swiper__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"].use([swiper__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"]]);
 var selectors = {
   arrow: "[data-slider-arrow]",
   cardImageWrapper: "[data-card-image-wrapper]"
 };
 var modifiers = {
   initialized: "initialized"
 };

 var Slider = /*#__PURE__*/function () {
   function Slider(container, options) {
     var _this = this;

     _classCallCheck(this, Slider);

     this.container = container;
     this.options = _objectSpread({
       slidesPerView: "auto",
       spaceBetween: 0,
       navigation: true,
       on: {
         afterInit: function afterInit() {
           _this.setArrowsVerticalPosition();

           _this.container.classList.add(modifiers.initialized);
         },
         beforeResize: function beforeResize() {
           _this.setArrowsVerticalPosition();
         }
       }
     }, options);
     this.init();
   }

   _createClass(Slider, [{
     key: "init",
     value: function init() {
       var _this$container$query;

       if (!this.container) {
         return null;
       }

       this.cardImageWrapper = (_this$container$query = this.container.querySelector(selectors.cardImageWrapper)) !== null && _this$container$query !== void 0 ? _this$container$query : null;
       this.slider = new swiper__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"](this.container, this.options);
     }
   }, {
     key: "setArrowsVerticalPosition",
     value: function setArrowsVerticalPosition() {
       if (!this.options.navigation || !this.cardImageWrapper) {
         return null;
       }

       var arrows = this.container.querySelectorAll(selectors.arrow);

       if (!arrows) {
         return null;
       }

       var position = "".concat(this.cardImageWrapper.offsetHeight / 2, "px");
       arrows.forEach(function (arrow) {
         arrow.style.top = position;
       });
     }
   }]);

   return Slider;
 }();

 /* harmony default export */ __webpack_exports__["default"] = (Slider);

 /***/ }),
 /* 8 */
 /***/ (function(module, exports, __webpack_require__) {

 var global = __webpack_require__(2);
 var DOMIterables = __webpack_require__(206);
 var DOMTokenListPrototype = __webpack_require__(205);
 var forEach = __webpack_require__(340);
 var createNonEnumerableProperty = __webpack_require__(48);

 var handlePrototype = function (CollectionPrototype) {
   // some Chrome versions have non-configurable methods on DOMTokenList
   if (CollectionPrototype && CollectionPrototype.forEach !== forEach) try {
     createNonEnumerableProperty(CollectionPrototype, 'forEach', forEach);
   } catch (error) {
     CollectionPrototype.forEach = forEach;
   }
 };

 for (var COLLECTION_NAME in DOMIterables) {
   if (DOMIterables[COLLECTION_NAME]) {
     handlePrototype(global[COLLECTION_NAME] && global[COLLECTION_NAME].prototype);
   }
 }

 handlePrototype(DOMTokenListPrototype);


 /***/ }),
 /* 9 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";

 // EXTERNAL MODULE: ./node_modules/ssr-window/ssr-window.esm.js
 var ssr_window_esm = __webpack_require__(4);

 // CONCATENATED MODULE: ./node_modules/dom7/dom7.esm.js
 /**
  * Dom7 3.0.0
  * Minimalistic JavaScript library for DOM manipulation, with a jQuery-compatible API
  * https://framework7.io/docs/dom7.html
  *
  * Copyright 2020, Vladimir Kharlampidi
  *
  * Licensed under MIT
  *
  * Released on: November 9, 2020
  */


 function _inheritsLoose(subClass, superClass) {
   subClass.prototype = Object.create(superClass.prototype);
   subClass.prototype.constructor = subClass;
   subClass.__proto__ = superClass;
 }

 function _getPrototypeOf(o) {
   _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
     return o.__proto__ || Object.getPrototypeOf(o);
   };
   return _getPrototypeOf(o);
 }

 function _setPrototypeOf(o, p) {
   _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
     o.__proto__ = p;
     return o;
   };

   return _setPrototypeOf(o, p);
 }

 function _isNativeReflectConstruct() {
   if (typeof Reflect === "undefined" || !Reflect.construct) return false;
   if (Reflect.construct.sham) return false;
   if (typeof Proxy === "function") return true;

   try {
     Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
     return true;
   } catch (e) {
     return false;
   }
 }

 function _construct(Parent, args, Class) {
   if (_isNativeReflectConstruct()) {
     _construct = Reflect.construct;
   } else {
     _construct = function _construct(Parent, args, Class) {
       var a = [null];
       a.push.apply(a, args);
       var Constructor = Function.bind.apply(Parent, a);
       var instance = new Constructor();
       if (Class) _setPrototypeOf(instance, Class.prototype);
       return instance;
     };
   }

   return _construct.apply(null, arguments);
 }

 function _isNativeFunction(fn) {
   return Function.toString.call(fn).indexOf("[native code]") !== -1;
 }

 function _wrapNativeSuper(Class) {
   var _cache = typeof Map === "function" ? new Map() : undefined;

   _wrapNativeSuper = function _wrapNativeSuper(Class) {
     if (Class === null || !_isNativeFunction(Class)) return Class;

     if (typeof Class !== "function") {
       throw new TypeError("Super expression must either be null or a function");
     }

     if (typeof _cache !== "undefined") {
       if (_cache.has(Class)) return _cache.get(Class);

       _cache.set(Class, Wrapper);
     }

     function Wrapper() {
       return _construct(Class, arguments, _getPrototypeOf(this).constructor);
     }

     Wrapper.prototype = Object.create(Class.prototype, {
       constructor: {
         value: Wrapper,
         enumerable: false,
         writable: true,
         configurable: true
       }
     });
     return _setPrototypeOf(Wrapper, Class);
   };

   return _wrapNativeSuper(Class);
 }

 function _assertThisInitialized(self) {
   if (self === void 0) {
     throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
   }

   return self;
 }

 /* eslint-disable no-proto */
 function makeReactive(obj) {
   var proto = obj.__proto__;
   Object.defineProperty(obj, '__proto__', {
     get: function get() {
       return proto;
     },
     set: function set(value) {
       proto.__proto__ = value;
     }
   });
 }

 var Dom7 = /*#__PURE__*/function (_Array) {
   _inheritsLoose(Dom7, _Array);

   function Dom7(items) {
     var _this;

     _this = _Array.call.apply(_Array, [this].concat(items)) || this;
     makeReactive(_assertThisInitialized(_this));
     return _this;
   }

   return Dom7;
 }( /*#__PURE__*/_wrapNativeSuper(Array));

 function arrayFlat(arr) {
   if (arr === void 0) {
     arr = [];
   }

   var res = [];
   arr.forEach(function (el) {
     if (Array.isArray(el)) {
       res.push.apply(res, arrayFlat(el));
     } else {
       res.push(el);
     }
   });
   return res;
 }
 function arrayFilter(arr, callback) {
   return Array.prototype.filter.call(arr, callback);
 }
 function arrayUnique(arr) {
   var uniqueArray = [];

   for (var i = 0; i < arr.length; i += 1) {
     if (uniqueArray.indexOf(arr[i]) === -1) uniqueArray.push(arr[i]);
   }

   return uniqueArray;
 }
 function toCamelCase(string) {
   return string.toLowerCase().replace(/-(.)/g, function (match, group) {
     return group.toUpperCase();
   });
 }

 function qsa(selector, context) {
   if (typeof selector !== 'string') {
     return [selector];
   }

   var a = [];
   var res = context.querySelectorAll(selector);

   for (var i = 0; i < res.length; i += 1) {
     a.push(res[i]);
   }

   return a;
 }

 function $(selector, context) {
   var window = Object(ssr_window_esm["b" /* getWindow */])();
   var document = Object(ssr_window_esm["a" /* getDocument */])();
   var arr = [];

   if (!context && selector instanceof Dom7) {
     return selector;
   }

   if (!selector) {
     return new Dom7(arr);
   }

   if (typeof selector === 'string') {
     var html = selector.trim();

     if (html.indexOf('<') >= 0 && html.indexOf('>') >= 0) {
       var toCreate = 'div';
       if (html.indexOf('<li') === 0) toCreate = 'ul';
       if (html.indexOf('<tr') === 0) toCreate = 'tbody';
       if (html.indexOf('<td') === 0 || html.indexOf('<th') === 0) toCreate = 'tr';
       if (html.indexOf('<tbody') === 0) toCreate = 'table';
       if (html.indexOf('<option') === 0) toCreate = 'select';
       var tempParent = document.createElement(toCreate);
       tempParent.innerHTML = html;

       for (var i = 0; i < tempParent.childNodes.length; i += 1) {
         arr.push(tempParent.childNodes[i]);
       }
     } else {
       arr = qsa(selector.trim(), context || document);
     } // arr = qsa(selector, document);

   } else if (selector.nodeType || selector === window || selector === document) {
     arr.push(selector);
   } else if (Array.isArray(selector)) {
     if (selector instanceof Dom7) return selector;
     arr = selector;
   }

   return new Dom7(arrayUnique(arr));
 }

 $.fn = Dom7.prototype;

 function addClass() {
   for (var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++) {
     classes[_key] = arguments[_key];
   }

   var classNames = arrayFlat(classes.map(function (c) {
     return c.split(' ');
   }));
   this.forEach(function (el) {
     var _el$classList;

     (_el$classList = el.classList).add.apply(_el$classList, classNames);
   });
   return this;
 }

 function removeClass() {
   for (var _len2 = arguments.length, classes = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
     classes[_key2] = arguments[_key2];
   }

   var classNames = arrayFlat(classes.map(function (c) {
     return c.split(' ');
   }));
   this.forEach(function (el) {
     var _el$classList2;

     (_el$classList2 = el.classList).remove.apply(_el$classList2, classNames);
   });
   return this;
 }

 function toggleClass() {
   for (var _len3 = arguments.length, classes = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
     classes[_key3] = arguments[_key3];
   }

   var classNames = arrayFlat(classes.map(function (c) {
     return c.split(' ');
   }));
   this.forEach(function (el) {
     classNames.forEach(function (className) {
       el.classList.toggle(className);
     });
   });
 }

 function hasClass() {
   for (var _len4 = arguments.length, classes = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
     classes[_key4] = arguments[_key4];
   }

   var classNames = arrayFlat(classes.map(function (c) {
     return c.split(' ');
   }));
   return arrayFilter(this, function (el) {
     return classNames.filter(function (className) {
       return el.classList.contains(className);
     }).length > 0;
   }).length > 0;
 }

 function attr(attrs, value) {
   if (arguments.length === 1 && typeof attrs === 'string') {
     // Get attr
     if (this[0]) return this[0].getAttribute(attrs);
     return undefined;
   } // Set attrs


   for (var i = 0; i < this.length; i += 1) {
     if (arguments.length === 2) {
       // String
       this[i].setAttribute(attrs, value);
     } else {
       // Object
       for (var attrName in attrs) {
         this[i][attrName] = attrs[attrName];
         this[i].setAttribute(attrName, attrs[attrName]);
       }
     }
   }

   return this;
 }

 function removeAttr(attr) {
   for (var i = 0; i < this.length; i += 1) {
     this[i].removeAttribute(attr);
   }

   return this;
 }

 function prop(props, value) {
   if (arguments.length === 1 && typeof props === 'string') {
     // Get prop
     if (this[0]) return this[0][props];
   } else {
     // Set props
     for (var i = 0; i < this.length; i += 1) {
       if (arguments.length === 2) {
         // String
         this[i][props] = value;
       } else {
         // Object
         for (var propName in props) {
           this[i][propName] = props[propName];
         }
       }
     }

     return this;
   }

   return this;
 }

 function data(key, value) {
   var el;

   if (typeof value === 'undefined') {
     el = this[0];
     if (!el) return undefined; // Get value

     if (el.dom7ElementDataStorage && key in el.dom7ElementDataStorage) {
       return el.dom7ElementDataStorage[key];
     }

     var dataKey = el.getAttribute("data-" + key);

     if (dataKey) {
       return dataKey;
     }

     return undefined;
   } // Set value


   for (var i = 0; i < this.length; i += 1) {
     el = this[i];
     if (!el.dom7ElementDataStorage) el.dom7ElementDataStorage = {};
     el.dom7ElementDataStorage[key] = value;
   }

   return this;
 }

 function removeData(key) {
   for (var i = 0; i < this.length; i += 1) {
     var el = this[i];

     if (el.dom7ElementDataStorage && el.dom7ElementDataStorage[key]) {
       el.dom7ElementDataStorage[key] = null;
       delete el.dom7ElementDataStorage[key];
     }
   }
 }

 function dataset() {
   var el = this[0];
   if (!el) return undefined;
   var dataset = {}; // eslint-disable-line

   if (el.dataset) {
     for (var dataKey in el.dataset) {
       dataset[dataKey] = el.dataset[dataKey];
     }
   } else {
     for (var i = 0; i < el.attributes.length; i += 1) {
       var _attr = el.attributes[i];

       if (_attr.name.indexOf('data-') >= 0) {
         dataset[toCamelCase(_attr.name.split('data-')[1])] = _attr.value;
       }
     }
   }

   for (var key in dataset) {
     if (dataset[key] === 'false') dataset[key] = false;else if (dataset[key] === 'true') dataset[key] = true;else if (parseFloat(dataset[key]) === dataset[key] * 1) dataset[key] *= 1;
   }

   return dataset;
 }

 function val(value) {
   if (typeof value === 'undefined') {
     // get value
     var el = this[0];
     if (!el) return undefined;

     if (el.multiple && el.nodeName.toLowerCase() === 'select') {
       var values = [];

       for (var i = 0; i < el.selectedOptions.length; i += 1) {
         values.push(el.selectedOptions[i].value);
       }

       return values;
     }

     return el.value;
   } // set value


   for (var _i = 0; _i < this.length; _i += 1) {
     var _el = this[_i];

     if (Array.isArray(value) && _el.multiple && _el.nodeName.toLowerCase() === 'select') {
       for (var j = 0; j < _el.options.length; j += 1) {
         _el.options[j].selected = value.indexOf(_el.options[j].value) >= 0;
       }
     } else {
       _el.value = value;
     }
   }

   return this;
 }

 function dom7_esm_value(value) {
   return this.val(value);
 }

 function transform(transform) {
   for (var i = 0; i < this.length; i += 1) {
     this[i].style.transform = transform;
   }

   return this;
 }

 function transition(duration) {
   for (var i = 0; i < this.length; i += 1) {
     this[i].style.transitionDuration = typeof duration !== 'string' ? duration + "ms" : duration;
   }

   return this;
 }

 function on() {
   for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
     args[_key5] = arguments[_key5];
   }

   var eventType = args[0],
       targetSelector = args[1],
       listener = args[2],
       capture = args[3];

   if (typeof args[1] === 'function') {
     eventType = args[0];
     listener = args[1];
     capture = args[2];
     targetSelector = undefined;
   }

   if (!capture) capture = false;

   function handleLiveEvent(e) {
     var target = e.target;
     if (!target) return;
     var eventData = e.target.dom7EventData || [];

     if (eventData.indexOf(e) < 0) {
       eventData.unshift(e);
     }

     if ($(target).is(targetSelector)) listener.apply(target, eventData);else {
       var _parents = $(target).parents(); // eslint-disable-line


       for (var k = 0; k < _parents.length; k += 1) {
         if ($(_parents[k]).is(targetSelector)) listener.apply(_parents[k], eventData);
       }
     }
   }

   function handleEvent(e) {
     var eventData = e && e.target ? e.target.dom7EventData || [] : [];

     if (eventData.indexOf(e) < 0) {
       eventData.unshift(e);
     }

     listener.apply(this, eventData);
   }

   var events = eventType.split(' ');
   var j;

   for (var i = 0; i < this.length; i += 1) {
     var el = this[i];

     if (!targetSelector) {
       for (j = 0; j < events.length; j += 1) {
         var event = events[j];
         if (!el.dom7Listeners) el.dom7Listeners = {};
         if (!el.dom7Listeners[event]) el.dom7Listeners[event] = [];
         el.dom7Listeners[event].push({
           listener: listener,
           proxyListener: handleEvent
         });
         el.addEventListener(event, handleEvent, capture);
       }
     } else {
       // Live events
       for (j = 0; j < events.length; j += 1) {
         var _event = events[j];
         if (!el.dom7LiveListeners) el.dom7LiveListeners = {};
         if (!el.dom7LiveListeners[_event]) el.dom7LiveListeners[_event] = [];

         el.dom7LiveListeners[_event].push({
           listener: listener,
           proxyListener: handleLiveEvent
         });

         el.addEventListener(_event, handleLiveEvent, capture);
       }
     }
   }

   return this;
 }

 function off() {
   for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
     args[_key6] = arguments[_key6];
   }

   var eventType = args[0],
       targetSelector = args[1],
       listener = args[2],
       capture = args[3];

   if (typeof args[1] === 'function') {
     eventType = args[0];
     listener = args[1];
     capture = args[2];
     targetSelector = undefined;
   }

   if (!capture) capture = false;
   var events = eventType.split(' ');

   for (var i = 0; i < events.length; i += 1) {
     var event = events[i];

     for (var j = 0; j < this.length; j += 1) {
       var el = this[j];
       var handlers = void 0;

       if (!targetSelector && el.dom7Listeners) {
         handlers = el.dom7Listeners[event];
       } else if (targetSelector && el.dom7LiveListeners) {
         handlers = el.dom7LiveListeners[event];
       }

       if (handlers && handlers.length) {
         for (var k = handlers.length - 1; k >= 0; k -= 1) {
           var handler = handlers[k];

           if (listener && handler.listener === listener) {
             el.removeEventListener(event, handler.proxyListener, capture);
             handlers.splice(k, 1);
           } else if (listener && handler.listener && handler.listener.dom7proxy && handler.listener.dom7proxy === listener) {
             el.removeEventListener(event, handler.proxyListener, capture);
             handlers.splice(k, 1);
           } else if (!listener) {
             el.removeEventListener(event, handler.proxyListener, capture);
             handlers.splice(k, 1);
           }
         }
       }
     }
   }

   return this;
 }

 function once() {
   var dom = this;

   for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
     args[_key7] = arguments[_key7];
   }

   var eventName = args[0],
       targetSelector = args[1],
       listener = args[2],
       capture = args[3];

   if (typeof args[1] === 'function') {
     eventName = args[0];
     listener = args[1];
     capture = args[2];
     targetSelector = undefined;
   }

   function onceHandler() {
     for (var _len8 = arguments.length, eventArgs = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
       eventArgs[_key8] = arguments[_key8];
     }

     listener.apply(this, eventArgs);
     dom.off(eventName, targetSelector, onceHandler, capture);

     if (onceHandler.dom7proxy) {
       delete onceHandler.dom7proxy;
     }
   }

   onceHandler.dom7proxy = listener;
   return dom.on(eventName, targetSelector, onceHandler, capture);
 }

 function trigger() {
   var window = Object(ssr_window_esm["b" /* getWindow */])();

   for (var _len9 = arguments.length, args = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
     args[_key9] = arguments[_key9];
   }

   var events = args[0].split(' ');
   var eventData = args[1];

   for (var i = 0; i < events.length; i += 1) {
     var event = events[i];

     for (var j = 0; j < this.length; j += 1) {
       var el = this[j];

       if (window.CustomEvent) {
         var evt = new window.CustomEvent(event, {
           detail: eventData,
           bubbles: true,
           cancelable: true
         });
         el.dom7EventData = args.filter(function (data, dataIndex) {
           return dataIndex > 0;
         });
         el.dispatchEvent(evt);
         el.dom7EventData = [];
         delete el.dom7EventData;
       }
     }
   }

   return this;
 }

 function transitionEnd(callback) {
   var dom = this;

   function fireCallBack(e) {
     if (e.target !== this) return;
     callback.call(this, e);
     dom.off('transitionend', fireCallBack);
   }

   if (callback) {
     dom.on('transitionend', fireCallBack);
   }

   return this;
 }

 function animationEnd(callback) {
   var dom = this;

   function fireCallBack(e) {
     if (e.target !== this) return;
     callback.call(this, e);
     dom.off('animationend', fireCallBack);
   }

   if (callback) {
     dom.on('animationend', fireCallBack);
   }

   return this;
 }

 function width() {
   var window = Object(ssr_window_esm["b" /* getWindow */])();

   if (this[0] === window) {
     return window.innerWidth;
   }

   if (this.length > 0) {
     return parseFloat(this.css('width'));
   }

   return null;
 }

 function dom7_esm_outerWidth(includeMargins) {
   if (this.length > 0) {
     if (includeMargins) {
       var _styles = this.styles();

       return this[0].offsetWidth + parseFloat(_styles.getPropertyValue('margin-right')) + parseFloat(_styles.getPropertyValue('margin-left'));
     }

     return this[0].offsetWidth;
   }

   return null;
 }

 function height() {
   var window = Object(ssr_window_esm["b" /* getWindow */])();

   if (this[0] === window) {
     return window.innerHeight;
   }

   if (this.length > 0) {
     return parseFloat(this.css('height'));
   }

   return null;
 }

 function dom7_esm_outerHeight(includeMargins) {
   if (this.length > 0) {
     if (includeMargins) {
       var _styles2 = this.styles();

       return this[0].offsetHeight + parseFloat(_styles2.getPropertyValue('margin-top')) + parseFloat(_styles2.getPropertyValue('margin-bottom'));
     }

     return this[0].offsetHeight;
   }

   return null;
 }

 function offset() {
   if (this.length > 0) {
     var window = Object(ssr_window_esm["b" /* getWindow */])();
     var document = Object(ssr_window_esm["a" /* getDocument */])();
     var el = this[0];
     var box = el.getBoundingClientRect();
     var body = document.body;
     var clientTop = el.clientTop || body.clientTop || 0;
     var clientLeft = el.clientLeft || body.clientLeft || 0;
     var scrollTop = el === window ? window.scrollY : el.scrollTop;
     var scrollLeft = el === window ? window.scrollX : el.scrollLeft;
     return {
       top: box.top + scrollTop - clientTop,
       left: box.left + scrollLeft - clientLeft
     };
   }

   return null;
 }

 function hide() {
   for (var i = 0; i < this.length; i += 1) {
     this[i].style.display = 'none';
   }

   return this;
 }

 function show() {
   var window = Object(ssr_window_esm["b" /* getWindow */])();

   for (var i = 0; i < this.length; i += 1) {
     var el = this[i];

     if (el.style.display === 'none') {
       el.style.display = '';
     }

     if (window.getComputedStyle(el, null).getPropertyValue('display') === 'none') {
       // Still not visible
       el.style.display = 'block';
     }
   }

   return this;
 }

 function styles() {
   var window = Object(ssr_window_esm["b" /* getWindow */])();
   if (this[0]) return window.getComputedStyle(this[0], null);
   return {};
 }

 function css(props, value) {
   var window = Object(ssr_window_esm["b" /* getWindow */])();
   var i;

   if (arguments.length === 1) {
     if (typeof props === 'string') {
       // .css('width')
       if (this[0]) return window.getComputedStyle(this[0], null).getPropertyValue(props);
     } else {
       // .css({ width: '100px' })
       for (i = 0; i < this.length; i += 1) {
         for (var _prop in props) {
           this[i].style[_prop] = props[_prop];
         }
       }

       return this;
     }
   }

   if (arguments.length === 2 && typeof props === 'string') {
     // .css('width', '100px')
     for (i = 0; i < this.length; i += 1) {
       this[i].style[props] = value;
     }

     return this;
   }

   return this;
 }

 function each(callback) {
   if (!callback) return this;
   this.forEach(function (el, index) {
     callback.apply(el, [el, index]);
   });
   return this;
 }

 function filter(callback) {
   var result = arrayFilter(this, callback);
   return $(result);
 }

 function dom7_esm_html(html) {
   if (typeof html === 'undefined') {
     return this[0] ? this[0].innerHTML : null;
   }

   for (var i = 0; i < this.length; i += 1) {
     this[i].innerHTML = html;
   }

   return this;
 }

 function dom7_esm_text(text) {
   if (typeof text === 'undefined') {
     return this[0] ? this[0].textContent.trim() : null;
   }

   for (var i = 0; i < this.length; i += 1) {
     this[i].textContent = text;
   }

   return this;
 }

 function is(selector) {
   var window = Object(ssr_window_esm["b" /* getWindow */])();
   var document = Object(ssr_window_esm["a" /* getDocument */])();
   var el = this[0];
   var compareWith;
   var i;
   if (!el || typeof selector === 'undefined') return false;

   if (typeof selector === 'string') {
     if (el.matches) return el.matches(selector);
     if (el.webkitMatchesSelector) return el.webkitMatchesSelector(selector);
     if (el.msMatchesSelector) return el.msMatchesSelector(selector);
     compareWith = $(selector);

     for (i = 0; i < compareWith.length; i += 1) {
       if (compareWith[i] === el) return true;
     }

     return false;
   }

   if (selector === document) {
     return el === document;
   }

   if (selector === window) {
     return el === window;
   }

   if (selector.nodeType || selector instanceof Dom7) {
     compareWith = selector.nodeType ? [selector] : selector;

     for (i = 0; i < compareWith.length; i += 1) {
       if (compareWith[i] === el) return true;
     }

     return false;
   }

   return false;
 }

 function index() {
   var child = this[0];
   var i;

   if (child) {
     i = 0; // eslint-disable-next-line

     while ((child = child.previousSibling) !== null) {
       if (child.nodeType === 1) i += 1;
     }

     return i;
   }

   return undefined;
 }

 function eq(index) {
   if (typeof index === 'undefined') return this;
   var length = this.length;

   if (index > length - 1) {
     return $([]);
   }

   if (index < 0) {
     var returnIndex = length + index;
     if (returnIndex < 0) return $([]);
     return $([this[returnIndex]]);
   }

   return $([this[index]]);
 }

 function append() {
   var newChild;
   var document = Object(ssr_window_esm["a" /* getDocument */])();

   for (var k = 0; k < arguments.length; k += 1) {
     newChild = k < 0 || arguments.length <= k ? undefined : arguments[k];

     for (var i = 0; i < this.length; i += 1) {
       if (typeof newChild === 'string') {
         var tempDiv = document.createElement('div');
         tempDiv.innerHTML = newChild;

         while (tempDiv.firstChild) {
           this[i].appendChild(tempDiv.firstChild);
         }
       } else if (newChild instanceof Dom7) {
         for (var j = 0; j < newChild.length; j += 1) {
           this[i].appendChild(newChild[j]);
         }
       } else {
         this[i].appendChild(newChild);
       }
     }
   }

   return this;
 }

 function appendTo(parent) {
   $(parent).append(this);
   return this;
 }

 function prepend(newChild) {
   var document = Object(ssr_window_esm["a" /* getDocument */])();
   var i;
   var j;

   for (i = 0; i < this.length; i += 1) {
     if (typeof newChild === 'string') {
       var tempDiv = document.createElement('div');
       tempDiv.innerHTML = newChild;

       for (j = tempDiv.childNodes.length - 1; j >= 0; j -= 1) {
         this[i].insertBefore(tempDiv.childNodes[j], this[i].childNodes[0]);
       }
     } else if (newChild instanceof Dom7) {
       for (j = 0; j < newChild.length; j += 1) {
         this[i].insertBefore(newChild[j], this[i].childNodes[0]);
       }
     } else {
       this[i].insertBefore(newChild, this[i].childNodes[0]);
     }
   }

   return this;
 }

 function prependTo(parent) {
   $(parent).prepend(this);
   return this;
 }

 function insertBefore(selector) {
   var before = $(selector);

   for (var i = 0; i < this.length; i += 1) {
     if (before.length === 1) {
       before[0].parentNode.insertBefore(this[i], before[0]);
     } else if (before.length > 1) {
       for (var j = 0; j < before.length; j += 1) {
         before[j].parentNode.insertBefore(this[i].cloneNode(true), before[j]);
       }
     }
   }
 }

 function insertAfter(selector) {
   var after = $(selector);

   for (var i = 0; i < this.length; i += 1) {
     if (after.length === 1) {
       after[0].parentNode.insertBefore(this[i], after[0].nextSibling);
     } else if (after.length > 1) {
       for (var j = 0; j < after.length; j += 1) {
         after[j].parentNode.insertBefore(this[i].cloneNode(true), after[j].nextSibling);
       }
     }
   }
 }

 function next(selector) {
   if (this.length > 0) {
     if (selector) {
       if (this[0].nextElementSibling && $(this[0].nextElementSibling).is(selector)) {
         return $([this[0].nextElementSibling]);
       }

       return $([]);
     }

     if (this[0].nextElementSibling) return $([this[0].nextElementSibling]);
     return $([]);
   }

   return $([]);
 }

 function nextAll(selector) {
   var nextEls = [];
   var el = this[0];
   if (!el) return $([]);

   while (el.nextElementSibling) {
     var _next = el.nextElementSibling; // eslint-disable-line

     if (selector) {
       if ($(_next).is(selector)) nextEls.push(_next);
     } else nextEls.push(_next);

     el = _next;
   }

   return $(nextEls);
 }

 function prev(selector) {
   if (this.length > 0) {
     var el = this[0];

     if (selector) {
       if (el.previousElementSibling && $(el.previousElementSibling).is(selector)) {
         return $([el.previousElementSibling]);
       }

       return $([]);
     }

     if (el.previousElementSibling) return $([el.previousElementSibling]);
     return $([]);
   }

   return $([]);
 }

 function prevAll(selector) {
   var prevEls = [];
   var el = this[0];
   if (!el) return $([]);

   while (el.previousElementSibling) {
     var _prev = el.previousElementSibling; // eslint-disable-line

     if (selector) {
       if ($(_prev).is(selector)) prevEls.push(_prev);
     } else prevEls.push(_prev);

     el = _prev;
   }

   return $(prevEls);
 }

 function siblings(selector) {
   return this.nextAll(selector).add(this.prevAll(selector));
 }

 function dom7_esm_parent(selector) {
   var parents = []; // eslint-disable-line

   for (var i = 0; i < this.length; i += 1) {
     if (this[i].parentNode !== null) {
       if (selector) {
         if ($(this[i].parentNode).is(selector)) parents.push(this[i].parentNode);
       } else {
         parents.push(this[i].parentNode);
       }
     }
   }

   return $(parents);
 }

 function parents(selector) {
   var parents = []; // eslint-disable-line

   for (var i = 0; i < this.length; i += 1) {
     var _parent = this[i].parentNode; // eslint-disable-line

     while (_parent) {
       if (selector) {
         if ($(_parent).is(selector)) parents.push(_parent);
       } else {
         parents.push(_parent);
       }

       _parent = _parent.parentNode;
     }
   }

   return $(parents);
 }

 function closest(selector) {
   var closest = this; // eslint-disable-line

   if (typeof selector === 'undefined') {
     return $([]);
   }

   if (!closest.is(selector)) {
     closest = closest.parents(selector).eq(0);
   }

   return closest;
 }

 function find(selector) {
   var foundElements = [];

   for (var i = 0; i < this.length; i += 1) {
     var found = this[i].querySelectorAll(selector);

     for (var j = 0; j < found.length; j += 1) {
       foundElements.push(found[j]);
     }
   }

   return $(foundElements);
 }

 function children(selector) {
   var children = []; // eslint-disable-line

   for (var i = 0; i < this.length; i += 1) {
     var childNodes = this[i].children;

     for (var j = 0; j < childNodes.length; j += 1) {
       if (!selector || $(childNodes[j]).is(selector)) {
         children.push(childNodes[j]);
       }
     }
   }

   return $(children);
 }

 function remove() {
   for (var i = 0; i < this.length; i += 1) {
     if (this[i].parentNode) this[i].parentNode.removeChild(this[i]);
   }

   return this;
 }

 function detach() {
   return this.remove();
 }

 function add() {
   var dom = this;
   var i;
   var j;

   for (var _len10 = arguments.length, els = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
     els[_key10] = arguments[_key10];
   }

   for (i = 0; i < els.length; i += 1) {
     var toAdd = $(els[i]);

     for (j = 0; j < toAdd.length; j += 1) {
       dom.push(toAdd[j]);
     }
   }

   return dom;
 }

 function empty() {
   for (var i = 0; i < this.length; i += 1) {
     var el = this[i];

     if (el.nodeType === 1) {
       for (var j = 0; j < el.childNodes.length; j += 1) {
         if (el.childNodes[j].parentNode) {
           el.childNodes[j].parentNode.removeChild(el.childNodes[j]);
         }
       }

       el.textContent = '';
     }
   }

   return this;
 }

 function scrollTo() {
   var window = Object(ssr_window_esm["b" /* getWindow */])();

   for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
     args[_key] = arguments[_key];
   }

   var left = args[0],
       top = args[1],
       duration = args[2],
       easing = args[3],
       callback = args[4];

   if (args.length === 4 && typeof easing === 'function') {
     callback = easing;
     left = args[0];
     top = args[1];
     duration = args[2];
     callback = args[3];
     easing = args[4];
   }

   if (typeof easing === 'undefined') easing = 'swing';
   return this.each(function animate() {
     var el = this;
     var currentTop;
     var currentLeft;
     var maxTop;
     var maxLeft;
     var newTop;
     var newLeft;
     var scrollTop; // eslint-disable-line

     var scrollLeft; // eslint-disable-line

     var animateTop = top > 0 || top === 0;
     var animateLeft = left > 0 || left === 0;

     if (typeof easing === 'undefined') {
       easing = 'swing';
     }

     if (animateTop) {
       currentTop = el.scrollTop;

       if (!duration) {
         el.scrollTop = top;
       }
     }

     if (animateLeft) {
       currentLeft = el.scrollLeft;

       if (!duration) {
         el.scrollLeft = left;
       }
     }

     if (!duration) return;

     if (animateTop) {
       maxTop = el.scrollHeight - el.offsetHeight;
       newTop = Math.max(Math.min(top, maxTop), 0);
     }

     if (animateLeft) {
       maxLeft = el.scrollWidth - el.offsetWidth;
       newLeft = Math.max(Math.min(left, maxLeft), 0);
     }

     var startTime = null;
     if (animateTop && newTop === currentTop) animateTop = false;
     if (animateLeft && newLeft === currentLeft) animateLeft = false;

     function render(time) {
       if (time === void 0) {
         time = new Date().getTime();
       }

       if (startTime === null) {
         startTime = time;
       }

       var progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
       var easeProgress = easing === 'linear' ? progress : 0.5 - Math.cos(progress * Math.PI) / 2;
       var done;
       if (animateTop) scrollTop = currentTop + easeProgress * (newTop - currentTop);
       if (animateLeft) scrollLeft = currentLeft + easeProgress * (newLeft - currentLeft);

       if (animateTop && newTop > currentTop && scrollTop >= newTop) {
         el.scrollTop = newTop;
         done = true;
       }

       if (animateTop && newTop < currentTop && scrollTop <= newTop) {
         el.scrollTop = newTop;
         done = true;
       }

       if (animateLeft && newLeft > currentLeft && scrollLeft >= newLeft) {
         el.scrollLeft = newLeft;
         done = true;
       }

       if (animateLeft && newLeft < currentLeft && scrollLeft <= newLeft) {
         el.scrollLeft = newLeft;
         done = true;
       }

       if (done) {
         if (callback) callback();
         return;
       }

       if (animateTop) el.scrollTop = scrollTop;
       if (animateLeft) el.scrollLeft = scrollLeft;
       window.requestAnimationFrame(render);
     }

     window.requestAnimationFrame(render);
   });
 } // scrollTop(top, duration, easing, callback) {


 function dom7_esm_scrollTop() {
   for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
     args[_key2] = arguments[_key2];
   }

   var top = args[0],
       duration = args[1],
       easing = args[2],
       callback = args[3];

   if (args.length === 3 && typeof easing === 'function') {
     top = args[0];
     duration = args[1];
     callback = args[2];
     easing = args[3];
   }

   var dom = this;

   if (typeof top === 'undefined') {
     if (dom.length > 0) return dom[0].scrollTop;
     return null;
   }

   return dom.scrollTo(undefined, top, duration, easing, callback);
 }

 function dom7_esm_scrollLeft() {
   for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
     args[_key3] = arguments[_key3];
   }

   var left = args[0],
       duration = args[1],
       easing = args[2],
       callback = args[3];

   if (args.length === 3 && typeof easing === 'function') {
     left = args[0];
     duration = args[1];
     callback = args[2];
     easing = args[3];
   }

   var dom = this;

   if (typeof left === 'undefined') {
     if (dom.length > 0) return dom[0].scrollLeft;
     return null;
   }

   return dom.scrollTo(left, undefined, duration, easing, callback);
 }

 function animate(initialProps, initialParams) {
   var window = Object(ssr_window_esm["b" /* getWindow */])();
   var els = this;
   var a = {
     props: Object.assign({}, initialProps),
     params: Object.assign({
       duration: 300,
       easing: 'swing' // or 'linear'

       /* Callbacks
       begin(elements)
       complete(elements)
       progress(elements, complete, remaining, start, tweenValue)
       */

     }, initialParams),
     elements: els,
     animating: false,
     que: [],
     easingProgress: function easingProgress(easing, progress) {
       if (easing === 'swing') {
         return 0.5 - Math.cos(progress * Math.PI) / 2;
       }

       if (typeof easing === 'function') {
         return easing(progress);
       }

       return progress;
     },
     stop: function stop() {
       if (a.frameId) {
         window.cancelAnimationFrame(a.frameId);
       }

       a.animating = false;
       a.elements.each(function (el) {
         var element = el;
         delete element.dom7AnimateInstance;
       });
       a.que = [];
     },
     done: function done(complete) {
       a.animating = false;
       a.elements.each(function (el) {
         var element = el;
         delete element.dom7AnimateInstance;
       });
       if (complete) complete(els);

       if (a.que.length > 0) {
         var que = a.que.shift();
         a.animate(que[0], que[1]);
       }
     },
     animate: function animate(props, params) {
       if (a.animating) {
         a.que.push([props, params]);
         return a;
       }

       var elements = []; // Define & Cache Initials & Units

       a.elements.each(function (el, index) {
         var initialFullValue;
         var initialValue;
         var unit;
         var finalValue;
         var finalFullValue;
         if (!el.dom7AnimateInstance) a.elements[index].dom7AnimateInstance = a;
         elements[index] = {
           container: el
         };
         Object.keys(props).forEach(function (prop) {
           initialFullValue = window.getComputedStyle(el, null).getPropertyValue(prop).replace(',', '.');
           initialValue = parseFloat(initialFullValue);
           unit = initialFullValue.replace(initialValue, '');
           finalValue = parseFloat(props[prop]);
           finalFullValue = props[prop] + unit;
           elements[index][prop] = {
             initialFullValue: initialFullValue,
             initialValue: initialValue,
             unit: unit,
             finalValue: finalValue,
             finalFullValue: finalFullValue,
             currentValue: initialValue
           };
         });
       });
       var startTime = null;
       var time;
       var elementsDone = 0;
       var propsDone = 0;
       var done;
       var began = false;
       a.animating = true;

       function render() {
         time = new Date().getTime();
         var progress;
         var easeProgress; // let el;

         if (!began) {
           began = true;
           if (params.begin) params.begin(els);
         }

         if (startTime === null) {
           startTime = time;
         }

         if (params.progress) {
           // eslint-disable-next-line
           params.progress(els, Math.max(Math.min((time - startTime) / params.duration, 1), 0), startTime + params.duration - time < 0 ? 0 : startTime + params.duration - time, startTime);
         }

         elements.forEach(function (element) {
           var el = element;
           if (done || el.done) return;
           Object.keys(props).forEach(function (prop) {
             if (done || el.done) return;
             progress = Math.max(Math.min((time - startTime) / params.duration, 1), 0);
             easeProgress = a.easingProgress(params.easing, progress);
             var _el$prop = el[prop],
                 initialValue = _el$prop.initialValue,
                 finalValue = _el$prop.finalValue,
                 unit = _el$prop.unit;
             el[prop].currentValue = initialValue + easeProgress * (finalValue - initialValue);
             var currentValue = el[prop].currentValue;

             if (finalValue > initialValue && currentValue >= finalValue || finalValue < initialValue && currentValue <= finalValue) {
               el.container.style[prop] = finalValue + unit;
               propsDone += 1;

               if (propsDone === Object.keys(props).length) {
                 el.done = true;
                 elementsDone += 1;
               }

               if (elementsDone === elements.length) {
                 done = true;
               }
             }

             if (done) {
               a.done(params.complete);
               return;
             }

             el.container.style[prop] = currentValue + unit;
           });
         });
         if (done) return; // Then call

         a.frameId = window.requestAnimationFrame(render);
       }

       a.frameId = window.requestAnimationFrame(render);
       return a;
     }
   };

   if (a.elements.length === 0) {
     return els;
   }

   var animateInstance;

   for (var i = 0; i < a.elements.length; i += 1) {
     if (a.elements[i].dom7AnimateInstance) {
       animateInstance = a.elements[i].dom7AnimateInstance;
     } else a.elements[i].dom7AnimateInstance = a;
   }

   if (!animateInstance) {
     animateInstance = a;
   }

   if (initialProps === 'stop') {
     animateInstance.stop();
   } else {
     animateInstance.animate(a.props, a.params);
   }

   return els;
 }

 function stop() {
   var els = this;

   for (var i = 0; i < els.length; i += 1) {
     if (els[i].dom7AnimateInstance) {
       els[i].dom7AnimateInstance.stop();
     }
   }
 }

 var noTrigger = 'resize scroll'.split(' ');

 function shortcut(name) {
   function eventHandler() {
     for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
       args[_key] = arguments[_key];
     }

     if (typeof args[0] === 'undefined') {
       for (var i = 0; i < this.length; i += 1) {
         if (noTrigger.indexOf(name) < 0) {
           if (name in this[i]) this[i][name]();else {
             $(this[i]).trigger(name);
           }
         }
       }

       return this;
     }

     return this.on.apply(this, [name].concat(args));
   }

   return eventHandler;
 }

 var click = shortcut('click');
 var dom7_esm_blur = shortcut('blur');
 var dom7_esm_focus = shortcut('focus');
 var focusin = shortcut('focusin');
 var focusout = shortcut('focusout');
 var keyup = shortcut('keyup');
 var keydown = shortcut('keydown');
 var keypress = shortcut('keypress');
 var dom7_esm_submit = shortcut('submit');
 var change = shortcut('change');
 var mousedown = shortcut('mousedown');
 var mousemove = shortcut('mousemove');
 var mouseup = shortcut('mouseup');
 var mouseenter = shortcut('mouseenter');
 var mouseleave = shortcut('mouseleave');
 var mouseout = shortcut('mouseout');
 var mouseover = shortcut('mouseover');
 var touchstart = shortcut('touchstart');
 var touchend = shortcut('touchend');
 var touchmove = shortcut('touchmove');
 var resize = shortcut('resize');
 var dom7_esm_scroll = shortcut('scroll');

 /* harmony default export */ var dom7_esm = ($);


 // CONCATENATED MODULE: ./node_modules/swiper/esm/utils/dom.js

 var Methods = {
   addClass: addClass,
   removeClass: removeClass,
   hasClass: hasClass,
   toggleClass: toggleClass,
   attr: attr,
   removeAttr: removeAttr,
   transform: transform,
   transition: transition,
   on: on,
   off: off,
   trigger: trigger,
   transitionEnd: transitionEnd,
   outerWidth: dom7_esm_outerWidth,
   outerHeight: dom7_esm_outerHeight,
   styles: styles,
   offset: offset,
   css: css,
   each: each,
   html: dom7_esm_html,
   text: dom7_esm_text,
   is: is,
   index: index,
   eq: eq,
   append: append,
   prepend: prepend,
   next: next,
   nextAll: nextAll,
   prev: prev,
   prevAll: prevAll,
   parent: dom7_esm_parent,
   parents: parents,
   closest: closest,
   find: find,
   children: children,
   filter: filter,
   remove: remove
 };
 Object.keys(Methods).forEach(function (methodName) {
   Object.defineProperty($.fn, methodName, {
     value: Methods[methodName],
     writable: true
   });
 });
 /* harmony default export */ var dom = __webpack_exports__["a"] = ($);

 /***/ }),
 /* 10 */
 /***/ (function(module, exports) {

 module.exports = function (exec) {
   try {
     return !!exec();
   } catch (error) {
     return true;
   }
 };


 /***/ }),
 /* 11 */
 /***/ (function(module, exports) {

 // `IsCallable` abstract operation
 // https://tc39.es/ecma262/#sec-iscallable
 module.exports = function (argument) {
   return typeof argument == 'function';
 };


 /***/ }),
 /* 12 */
 /***/ (function(module, exports, __webpack_require__) {

 var global = __webpack_require__(2);
 var shared = __webpack_require__(99);
 var hasOwn = __webpack_require__(19);
 var uid = __webpack_require__(96);
 var NATIVE_SYMBOL = __webpack_require__(111);
 var USE_SYMBOL_AS_UID = __webpack_require__(122);

 var WellKnownSymbolsStore = shared('wks');
 var Symbol = global.Symbol;
 var symbolFor = Symbol && Symbol['for'];
 var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol : Symbol && Symbol.withoutSetter || uid;

 module.exports = function (name) {
   if (!hasOwn(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL || typeof WellKnownSymbolsStore[name] == 'string')) {
     var description = 'Symbol.' + name;
     if (NATIVE_SYMBOL && hasOwn(Symbol, name)) {
       WellKnownSymbolsStore[name] = Symbol[name];
     } else if (USE_SYMBOL_AS_UID && symbolFor) {
       WellKnownSymbolsStore[name] = symbolFor(description);
     } else {
       WellKnownSymbolsStore[name] = createWellKnownSymbol(description);
     }
   } return WellKnownSymbolsStore[name];
 };


 /***/ }),
 /* 13 */
 /***/ (function(module, exports, __webpack_require__) {

 var global = __webpack_require__(2);
 var getOwnPropertyDescriptor = __webpack_require__(52).f;
 var createNonEnumerableProperty = __webpack_require__(48);
 var redefine = __webpack_require__(32);
 var setGlobal = __webpack_require__(97);
 var copyConstructorProperties = __webpack_require__(140);
 var isForced = __webpack_require__(86);

 /*
   options.target      - name of the target object
   options.global      - target is the global object
   options.stat        - export as static methods of target
   options.proto       - export as prototype methods of target
   options.real        - real prototype method for the `pure` version
   options.forced      - export even if the native feature is available
   options.bind        - bind methods to the target, required for the `pure` version
   options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
   options.unsafe      - use the simple assignment of property instead of delete + defineProperty
   options.sham        - add a flag to not completely full polyfills
   options.enumerable  - export as enumerable property
   options.noTargetGet - prevent calling a getter on target
   options.name        - the .name of the function if it does not match the key
 */
 module.exports = function (options, source) {
   var TARGET = options.target;
   var GLOBAL = options.global;
   var STATIC = options.stat;
   var FORCED, target, key, targetProperty, sourceProperty, descriptor;
   if (GLOBAL) {
     target = global;
   } else if (STATIC) {
     target = global[TARGET] || setGlobal(TARGET, {});
   } else {
     target = (global[TARGET] || {}).prototype;
   }
   if (target) for (key in source) {
     sourceProperty = source[key];
     if (options.noTargetGet) {
       descriptor = getOwnPropertyDescriptor(target, key);
       targetProperty = descriptor && descriptor.value;
     } else targetProperty = target[key];
     FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
     // contained in target
     if (!FORCED && targetProperty !== undefined) {
       if (typeof sourceProperty == typeof targetProperty) continue;
       copyConstructorProperties(sourceProperty, targetProperty);
     }
     // add a flag to not completely full polyfills
     if (options.sham || (targetProperty && targetProperty.sham)) {
       createNonEnumerableProperty(sourceProperty, 'sham', true);
     }
     // extend global
     redefine(target, key, sourceProperty, options);
   }
 };


 /***/ }),
 /* 14 */
 /***/ (function(module, exports, __webpack_require__) {

 "use strict";

 var $ = __webpack_require__(13);
 var IS_PURE = __webpack_require__(60);
 var global = __webpack_require__(2);
 var getBuiltIn = __webpack_require__(33);
 var call = __webpack_require__(22);
 var NativePromise = __webpack_require__(373);
 var redefine = __webpack_require__(32);
 var redefineAll = __webpack_require__(165);
 var setPrototypeOf = __webpack_require__(164);
 var setToStringTag = __webpack_require__(108);
 var setSpecies = __webpack_require__(163);
 var aCallable = __webpack_require__(57);
 var isCallable = __webpack_require__(11);
 var isObject = __webpack_require__(18);
 var anInstance = __webpack_require__(136);
 var inspectSource = __webpack_require__(76);
 var iterate = __webpack_require__(162);
 var checkCorrectnessOfIteration = __webpack_require__(160);
 var speciesConstructor = __webpack_require__(215);
 var task = __webpack_require__(213).set;
 var microtask = __webpack_require__(371);
 var promiseResolve = __webpack_require__(368);
 var hostReportErrors = __webpack_require__(367);
 var newPromiseCapabilityModule = __webpack_require__(211);
 var perform = __webpack_require__(366);
 var InternalStateModule = __webpack_require__(53);
 var isForced = __webpack_require__(86);
 var wellKnownSymbol = __webpack_require__(12);
 var IS_BROWSER = __webpack_require__(365);
 var IS_NODE = __webpack_require__(159);
 var V8_VERSION = __webpack_require__(95);

 var SPECIES = wellKnownSymbol('species');
 var PROMISE = 'Promise';

 var getInternalState = InternalStateModule.get;
 var setInternalState = InternalStateModule.set;
 var getInternalPromiseState = InternalStateModule.getterFor(PROMISE);
 var NativePromisePrototype = NativePromise && NativePromise.prototype;
 var PromiseConstructor = NativePromise;
 var PromisePrototype = NativePromisePrototype;
 var TypeError = global.TypeError;
 var document = global.document;
 var process = global.process;
 var newPromiseCapability = newPromiseCapabilityModule.f;
 var newGenericPromiseCapability = newPromiseCapability;

 var DISPATCH_EVENT = !!(document && document.createEvent && global.dispatchEvent);
 var NATIVE_REJECTION_EVENT = isCallable(global.PromiseRejectionEvent);
 var UNHANDLED_REJECTION = 'unhandledrejection';
 var REJECTION_HANDLED = 'rejectionhandled';
 var PENDING = 0;
 var FULFILLED = 1;
 var REJECTED = 2;
 var HANDLED = 1;
 var UNHANDLED = 2;
 var SUBCLASSING = false;

 var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen;

 var FORCED = isForced(PROMISE, function () {
   var PROMISE_CONSTRUCTOR_SOURCE = inspectSource(PromiseConstructor);
   var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String(PromiseConstructor);
   // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
   // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
   // We can't detect it synchronously, so just check versions
   if (!GLOBAL_CORE_JS_PROMISE && V8_VERSION === 66) return true;
   // We need Promise#finally in the pure version for preventing prototype pollution
   if (IS_PURE && !PromisePrototype['finally']) return true;
   // We can't use @@species feature detection in V8 since it causes
   // deoptimization and performance degradation
   // https://github.com/zloirock/core-js/issues/679
   if (V8_VERSION >= 51 && /native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) return false;
   // Detect correctness of subclassing with @@species support
   var promise = new PromiseConstructor(function (resolve) { resolve(1); });
   var FakePromise = function (exec) {
     exec(function () { /* empty */ }, function () { /* empty */ });
   };
   var constructor = promise.constructor = {};
   constructor[SPECIES] = FakePromise;
   SUBCLASSING = promise.then(function () { /* empty */ }) instanceof FakePromise;
   if (!SUBCLASSING) return true;
   // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
   return !GLOBAL_CORE_JS_PROMISE && IS_BROWSER && !NATIVE_REJECTION_EVENT;
 });

 var INCORRECT_ITERATION = FORCED || !checkCorrectnessOfIteration(function (iterable) {
   PromiseConstructor.all(iterable)['catch'](function () { /* empty */ });
 });

 // helpers
 var isThenable = function (it) {
   var then;
   return isObject(it) && isCallable(then = it.then) ? then : false;
 };

 var notify = function (state, isReject) {
   if (state.notified) return;
   state.notified = true;
   var chain = state.reactions;
   microtask(function () {
     var value = state.value;
     var ok = state.state == FULFILLED;
     var index = 0;
     // variable length - can't use forEach
     while (chain.length > index) {
       var reaction = chain[index++];
       var handler = ok ? reaction.ok : reaction.fail;
       var resolve = reaction.resolve;
       var reject = reaction.reject;
       var domain = reaction.domain;
       var result, then, exited;
       try {
         if (handler) {
           if (!ok) {
             if (state.rejection === UNHANDLED) onHandleUnhandled(state);
             state.rejection = HANDLED;
           }
           if (handler === true) result = value;
           else {
             if (domain) domain.enter();
             result = handler(value); // can throw
             if (domain) {
               domain.exit();
               exited = true;
             }
           }
           if (result === reaction.promise) {
             reject(TypeError('Promise-chain cycle'));
           } else if (then = isThenable(result)) {
             call(then, result, resolve, reject);
           } else resolve(result);
         } else reject(value);
       } catch (error) {
         if (domain && !exited) domain.exit();
         reject(error);
       }
     }
     state.reactions = [];
     state.notified = false;
     if (isReject && !state.rejection) onUnhandled(state);
   });
 };

 var dispatchEvent = function (name, promise, reason) {
   var event, handler;
   if (DISPATCH_EVENT) {
     event = document.createEvent('Event');
     event.promise = promise;
     event.reason = reason;
     event.initEvent(name, false, true);
     global.dispatchEvent(event);
   } else event = { promise: promise, reason: reason };
   if (!NATIVE_REJECTION_EVENT && (handler = global['on' + name])) handler(event);
   else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
 };

 var onUnhandled = function (state) {
   call(task, global, function () {
     var promise = state.facade;
     var value = state.value;
     var IS_UNHANDLED = isUnhandled(state);
     var result;
     if (IS_UNHANDLED) {
       result = perform(function () {
         if (IS_NODE) {
           process.emit('unhandledRejection', value, promise);
         } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
       });
       // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
       state.rejection = IS_NODE || isUnhandled(state) ? UNHANDLED : HANDLED;
       if (result.error) throw result.value;
     }
   });
 };

 var isUnhandled = function (state) {
   return state.rejection !== HANDLED && !state.parent;
 };

 var onHandleUnhandled = function (state) {
   call(task, global, function () {
     var promise = state.facade;
     if (IS_NODE) {
       process.emit('rejectionHandled', promise);
     } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
   });
 };

 var bind = function (fn, state, unwrap) {
   return function (value) {
     fn(state, value, unwrap);
   };
 };

 var internalReject = function (state, value, unwrap) {
   if (state.done) return;
   state.done = true;
   if (unwrap) state = unwrap;
   state.value = value;
   state.state = REJECTED;
   notify(state, true);
 };

 var internalResolve = function (state, value, unwrap) {
   if (state.done) return;
   state.done = true;
   if (unwrap) state = unwrap;
   try {
     if (state.facade === value) throw TypeError("Promise can't be resolved itself");
     var then = isThenable(value);
     if (then) {
       microtask(function () {
         var wrapper = { done: false };
         try {
           call(then, value,
             bind(internalResolve, wrapper, state),
             bind(internalReject, wrapper, state)
           );
         } catch (error) {
           internalReject(wrapper, error, state);
         }
       });
     } else {
       state.value = value;
       state.state = FULFILLED;
       notify(state, false);
     }
   } catch (error) {
     internalReject({ done: false }, error, state);
   }
 };

 // constructor polyfill
 if (FORCED) {
   // 25.4.3.1 Promise(executor)
   PromiseConstructor = function Promise(executor) {
     anInstance(this, PromisePrototype);
     aCallable(executor);
     call(Internal, this);
     var state = getInternalState(this);
     try {
       executor(bind(internalResolve, state), bind(internalReject, state));
     } catch (error) {
       internalReject(state, error);
     }
   };
   PromisePrototype = PromiseConstructor.prototype;
   // eslint-disable-next-line no-unused-vars -- required for `.length`
   Internal = function Promise(executor) {
     setInternalState(this, {
       type: PROMISE,
       done: false,
       notified: false,
       parent: false,
       reactions: [],
       rejection: false,
       state: PENDING,
       value: undefined
     });
   };
   Internal.prototype = redefineAll(PromisePrototype, {
     // `Promise.prototype.then` method
     // https://tc39.es/ecma262/#sec-promise.prototype.then
     then: function then(onFulfilled, onRejected) {
       var state = getInternalPromiseState(this);
       var reactions = state.reactions;
       var reaction = newPromiseCapability(speciesConstructor(this, PromiseConstructor));
       reaction.ok = isCallable(onFulfilled) ? onFulfilled : true;
       reaction.fail = isCallable(onRejected) && onRejected;
       reaction.domain = IS_NODE ? process.domain : undefined;
       state.parent = true;
       reactions[reactions.length] = reaction;
       if (state.state != PENDING) notify(state, false);
       return reaction.promise;
     },
     // `Promise.prototype.catch` method
     // https://tc39.es/ecma262/#sec-promise.prototype.catch
     'catch': function (onRejected) {
       return this.then(undefined, onRejected);
     }
   });
   OwnPromiseCapability = function () {
     var promise = new Internal();
     var state = getInternalState(promise);
     this.promise = promise;
     this.resolve = bind(internalResolve, state);
     this.reject = bind(internalReject, state);
   };
   newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
     return C === PromiseConstructor || C === PromiseWrapper
       ? new OwnPromiseCapability(C)
       : newGenericPromiseCapability(C);
   };

   if (!IS_PURE && isCallable(NativePromise) && NativePromisePrototype !== Object.prototype) {
     nativeThen = NativePromisePrototype.then;

     if (!SUBCLASSING) {
       // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
       redefine(NativePromisePrototype, 'then', function then(onFulfilled, onRejected) {
         var that = this;
         return new PromiseConstructor(function (resolve, reject) {
           call(nativeThen, that, resolve, reject);
         }).then(onFulfilled, onRejected);
       // https://github.com/zloirock/core-js/issues/640
       }, { unsafe: true });

       // makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
       redefine(NativePromisePrototype, 'catch', PromisePrototype['catch'], { unsafe: true });
     }

     // make `.constructor === Promise` work for native promise-based APIs
     try {
       delete NativePromisePrototype.constructor;
     } catch (error) { /* empty */ }

     // make `instanceof Promise` work for native promise-based APIs
     if (setPrototypeOf) {
       setPrototypeOf(NativePromisePrototype, PromisePrototype);
     }
   }
 }

 $({ global: true, wrap: true, forced: FORCED }, {
   Promise: PromiseConstructor
 });

 setToStringTag(PromiseConstructor, PROMISE, false, true);
 setSpecies(PROMISE);

 PromiseWrapper = getBuiltIn(PROMISE);

 // statics
 $({ target: PROMISE, stat: true, forced: FORCED }, {
   // `Promise.reject` method
   // https://tc39.es/ecma262/#sec-promise.reject
   reject: function reject(r) {
     var capability = newPromiseCapability(this);
     call(capability.reject, undefined, r);
     return capability.promise;
   }
 });

 $({ target: PROMISE, stat: true, forced: IS_PURE || FORCED }, {
   // `Promise.resolve` method
   // https://tc39.es/ecma262/#sec-promise.resolve
   resolve: function resolve(x) {
     return promiseResolve(IS_PURE && this === PromiseWrapper ? PromiseConstructor : this, x);
   }
 });

 $({ target: PROMISE, stat: true, forced: INCORRECT_ITERATION }, {
   // `Promise.all` method
   // https://tc39.es/ecma262/#sec-promise.all
   all: function all(iterable) {
     var C = this;
     var capability = newPromiseCapability(C);
     var resolve = capability.resolve;
     var reject = capability.reject;
     var result = perform(function () {
       var $promiseResolve = aCallable(C.resolve);
       var values = [];
       var counter = 0;
       var remaining = 1;
       iterate(iterable, function (promise) {
         var index = counter++;
         var alreadyCalled = false;
         remaining++;
         call($promiseResolve, C, promise).then(function (value) {
           if (alreadyCalled) return;
           alreadyCalled = true;
           values[index] = value;
           --remaining || resolve(values);
         }, reject);
       });
       --remaining || resolve(values);
     });
     if (result.error) reject(result.value);
     return capability.promise;
   },
   // `Promise.race` method
   // https://tc39.es/ecma262/#sec-promise.race
   race: function race(iterable) {
     var C = this;
     var capability = newPromiseCapability(C);
     var reject = capability.reject;
     var result = perform(function () {
       var $promiseResolve = aCallable(C.resolve);
       iterate(iterable, function (promise) {
         call($promiseResolve, C, promise).then(capability.resolve, reject);
       });
     });
     if (result.error) reject(result.value);
     return capability.promise;
   }
 });


 /***/ }),
 /* 15 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";

 // EXTERNAL MODULE: ./node_modules/regenerator-runtime/runtime.js
 var runtime = __webpack_require__(16);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.map.js
 var es_array_map = __webpack_require__(51);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.exec.js
 var es_regexp_exec = __webpack_require__(21);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.replace.js
 var es_string_replace = __webpack_require__(54);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
 var es_object_to_string = __webpack_require__(3);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.values.js
 var es_object_values = __webpack_require__(342);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.for-each.js
 var web_dom_collections_for_each = __webpack_require__(8);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
 var es_object_keys = __webpack_require__(40);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.includes.js
 var es_array_includes = __webpack_require__(82);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.includes.js
 var es_string_includes = __webpack_require__(81);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.starts-with.js
 var es_string_starts_with = __webpack_require__(339);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
 var es_array_concat = __webpack_require__(50);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.find.js
 var es_array_find = __webpack_require__(39);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.iterator.js
 var es_array_iterator = __webpack_require__(31);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.promise.js
 var es_promise = __webpack_require__(14);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.iterator.js
 var es_string_iterator = __webpack_require__(27);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.iterator.js
 var web_dom_collections_iterator = __webpack_require__(41);

 // EXTERNAL MODULE: ./node_modules/axios/index.js
 var axios = __webpack_require__(24);
 var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

 // EXTERNAL MODULE: ./node_modules/qs/lib/index.js
 var lib = __webpack_require__(171);
 var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

 // CONCATENATED MODULE: ./src/scripts/core/settings.js




 function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

 function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }


 /* harmony default export */ var core_settings = ({
   loaded: false,
   settings: {},
   load: function load() {
     var _this = this;

     return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
       var settings;
       return regeneratorRuntime.wrap(function _callee$(_context) {
         while (1) {
           switch (_context.prev = _context.next) {
             case 0:
               _context.next = 2;
               return axios_default.a.get("/?view=settings", {
                 responseType: "json"
               }).then(function (response) {
                 return response.data;
               });

             case 2:
               settings = _context.sent;
               _this.loaded = true;
               _this.settings = settings;
               document.dispatchEvent(new CustomEvent("theme:settings:loaded", {
                 detail: {
                   settings: settings
                 }
               }));

             case 6:
             case "end":
               return _context.stop();
           }
         }
       }, _callee);
     }))();
   },
   get: function get(name) {
     return this.settings[name];
   },
   all: function all() {
     return this.settings;
   }
 });
 // EXTERNAL MODULE: ./src/scripts/vue/store/wishlist/wishlist.js + 1 modules
 var wishlist = __webpack_require__(77);

 // CONCATENATED MODULE: ./src/scripts/vue/store/cart/cart.js
 /* unused harmony export STATE_LOADING */
 /* unused harmony export STATE_CART */
 /* unused harmony export STATE_SETTINGS */
 /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return GETTER_CART; });
 /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return GETTER_SETTINGS; });
 /* unused harmony export MUTATION_UPDATE_LOADING */
 /* unused harmony export MUTATION_UPDATE_CART */
 /* unused harmony export MUTATION_UPDATE_SETTINGS */
 /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ACTION_INIT_CART; });
 /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ACTION_GET_CART; });
 /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACTION_ADD_TO_CART; });
 /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ACTION_REMOVE_ITEM; });
 /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ACTION_CHANGE_QUANTITY; });
 /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ACTION_SAVE_FOR_LATER; });
 var _getters, _mutations, _actions;

 function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



















 function cart_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

 function cart_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { cart_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { cart_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }





 var STATE_LOADING = "loading";
 var STATE_CART = "cart";
 var STATE_SETTINGS = "settings";
 var GETTER_CART = "cart";
 var GETTER_SETTINGS = "settings";
 var MUTATION_UPDATE_LOADING = "updateLoading";
 var MUTATION_UPDATE_CART = "updateCart";
 var MUTATION_UPDATE_SETTINGS = "updateSettings";
 var ACTION_INIT_CART = "initCart";
 var ACTION_GET_CART = "getCart";
 var ACTION_ADD_TO_CART = "addToCart";
 var ACTION_REMOVE_ITEM = "removeItem";
 var ACTION_CHANGE_QUANTITY = "changeQuantity";
 var ACTION_SAVE_FOR_LATER = "saveForLater";
 var api = {
   getCart: function getCart() {
     return cart_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
       var response, html, data;
       return regeneratorRuntime.wrap(function _callee$(_context) {
         while (1) {
           switch (_context.prev = _context.next) {
             case 0:
               _context.next = 2;
               return axios_default.a.get("/cart?view=object-json");

             case 2:
               response = _context.sent.data;
               html = document.createElement("div");
               html.innerHTML = response;
               data = JSON.parse(html.querySelector("[data-json-response]").innerHTML);
               data.items.map(function (item) {
                 item.title = item.title.replace("&#39;", "'");
                 return item;
               });
               return _context.abrupt("return", data);

             case 8:
             case "end":
               return _context.stop();
           }
         }
       }, _callee);
     }))();
   },
   addItem: function addItem(item) {
     return this.addItems([item]).then(function (response) {
       return response.data;
     });
   },
   addItems: function addItems() {
     var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
     return axios_default.a.post("/cart/add.js", lib_default.a.stringify({
       items: items
     }), {
       headers: {
         Accept: "*/*",
         "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
         "X-Requested-With": "XMLHttpRequest"
       }
     });
   },
   changeItem: function changeItem(newItem) {
     return axios_default.a.post("/cart/change.js", lib_default.a.stringify(newItem), {
       headers: {
         Accept: "*/*",
         "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
         "X-Requested-With": "XMLHttpRequest"
       }
     }).then(function (res) {
       return res.data;
     });
   },
   changeQuantity: function changeQuantity(key, quantity) {
     return this.changeItem({
       id: key,
       quantity: quantity
     });
   },
   removeItem: function removeItem(key) {
     return this.changeQuantity(key, 0);
   }
 };
 /* harmony default export */ var cart = __webpack_exports__["i"] = ({
   namespaced: true,
   state: function state() {
     var _ref;

     return _ref = {}, _defineProperty(_ref, STATE_LOADING, true), _defineProperty(_ref, STATE_CART, {
       items: []
     }), _defineProperty(_ref, STATE_SETTINGS, {}), _ref;
   },
   getters: (_getters = {}, _defineProperty(_getters, GETTER_CART, function (state) {
     return state[STATE_CART];
   }), _defineProperty(_getters, GETTER_SETTINGS, function (state) {
     return state[STATE_SETTINGS];
   }), _getters),
   mutations: (_mutations = {}, _defineProperty(_mutations, MUTATION_UPDATE_CART, function (state, cart) {
     cart.item_count = Object.values(cart.items).reduce(function (total, item) {
       if (item.quantity > 0) total += item.quantity;
       return total;
     }, 0);
     cart.items.forEach(function (item) {
       if (item.properties === null) {
         item.filteredProperties = {};
         return null;
       }

       var properties = Object.keys(item.properties);

       if (properties.includes("_original_variant")) {
         var original_variant = item.properties["_original_variant"];
         item.url = original_variant.url;
       }

       item.filteredProperties = properties.reduce(function (result, property) {
         if (property.startsWith("_")) {
           return result;
         }

         if (["shipping_interval_unit_type", "shipping_interval_frequency"].includes(property)) {
           return result;
         }

         result[property] = item.properties[property];
         return result;
       }, {});

       if (properties.includes("shipping_interval_unit_type") && properties.includes("shipping_interval_frequency")) {
         item.filteredProperties["Subscription"] = "".concat(item.properties["shipping_interval_frequency"], " ").concat(item.properties["shipping_interval_unit_type"]);
       }
     });
     document.dispatchEvent(new CustomEvent("cart:item_count", {
       detail: {
         item_count: cart.item_count
       }
     }));
     state[STATE_CART] = cart;
   }), _defineProperty(_mutations, MUTATION_UPDATE_LOADING, function (state, loading) {
     state[STATE_LOADING] = loading;
   }), _defineProperty(_mutations, MUTATION_UPDATE_SETTINGS, function (state, settings) {
     state[STATE_SETTINGS] = settings;
   }), _mutations),
   actions: (_actions = {}, _defineProperty(_actions, ACTION_INIT_CART, function (context) {
     return cart_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
       return regeneratorRuntime.wrap(function _callee2$(_context2) {
         while (1) {
           switch (_context2.prev = _context2.next) {
             case 0:
               context.commit(MUTATION_UPDATE_LOADING, true);
               context.commit(MUTATION_UPDATE_SETTINGS, core_settings.all());
               _context2.next = 4;
               return context.dispatch(ACTION_GET_CART);

             case 4:
               context.commit(MUTATION_UPDATE_LOADING, false);

             case 5:
             case "end":
               return _context2.stop();
           }
         }
       }, _callee2);
     }))();
   }), _defineProperty(_actions, ACTION_GET_CART, function (context) {
     var _arguments = arguments;
     return cart_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
       var _ref2, _ref2$errorCallback, errorCallback, cart;

       return regeneratorRuntime.wrap(function _callee3$(_context3) {
         while (1) {
           switch (_context3.prev = _context3.next) {
             case 0:
               _ref2 = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : {}, _ref2$errorCallback = _ref2.errorCallback, errorCallback = _ref2$errorCallback === void 0 ? function () {} : _ref2$errorCallback;
               context.commit(MUTATION_UPDATE_LOADING, true);
               _context3.prev = 2;
               _context3.next = 5;
               return api.getCart();

             case 5:
               cart = _context3.sent;
               context.commit(MUTATION_UPDATE_CART, cart);
               context.commit(MUTATION_UPDATE_LOADING, false);
               _context3.next = 14;
               break;

             case 10:
               _context3.prev = 10;
               _context3.t0 = _context3["catch"](2);
               _context3.next = 14;
               return errorCallback(_context3.t0);

             case 14:
             case "end":
               return _context3.stop();
           }
         }
       }, _callee3, null, [[2, 10]]);
     }))();
   }), _defineProperty(_actions, ACTION_ADD_TO_CART, function (context) {
     var _arguments2 = arguments;
     return cart_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
       var _ref3, products, _ref3$errorCallback, errorCallback, cart;

       return regeneratorRuntime.wrap(function _callee4$(_context4) {
         while (1) {
           switch (_context4.prev = _context4.next) {
             case 0:
               _ref3 = _arguments2.length > 1 && _arguments2[1] !== undefined ? _arguments2[1] : {}, products = _ref3.products, _ref3$errorCallback = _ref3.errorCallback, errorCallback = _ref3$errorCallback === void 0 ? function () {} : _ref3$errorCallback;
               context.commit(MUTATION_UPDATE_LOADING, true);
               _context4.prev = 2;
               _context4.next = 5;
               return api.addItems(products);

             case 5:
               _context4.next = 7;
               return context.dispatch(ACTION_GET_CART);

             case 7:
               context.commit(MUTATION_UPDATE_LOADING, false);
               document.dispatchEvent(new CustomEvent("track:cart:added", {
                 detail: {// find items
                 }
               }));
               _context4.next = 15;
               break;

             case 11:
               _context4.prev = 11;
               _context4.t0 = _context4["catch"](2);
               _context4.next = 15;
               return errorCallback(_context4.t0);

             case 15:
             case "end":
              cart = context.state.cart;

              // console.log("ACTION_ADD_TO_CART" , cart)
               const cartItems = [];
               cart.items.forEach(function (item) {
                 var unit_price = (item.final_line_price / 100) / item.quantity
                 var number = unit_price;
                 var roundedNumber = number.toFixed(2);

              
                 cartItems.push({
                   name: item.title,
                   price_currency_code: cart.currency,
                   product_id: String(item.product_id),
                   quantity: item.quantity,
                   sku_id: item.sku,
                   unit_price: parseFloat(roundedNumber),
                 });
               });
              //console.log("const cartItems = [];", cartItems)
              //  if (cartItems.length === 1 && cartItems[0].name.includes("Roaring Journals Print Edition")) {
              //   const subtotalElement = document.querySelector(".minicart__subtotal-value.shipping_price");
              //   if (subtotalElement) {
              //       subtotalElement.textContent = "Free";
              //   }
              //  }
                nostojs(api => {
                 api.defaultSession()
                   .setCart({
                     items: cartItems,
                   })
                   .viewCart()
                   .update()
               });
               return _context4.stop();
           }
         }
       }, _callee4, null, [[2, 11]]);
     }))();
   }), _defineProperty(_actions, ACTION_REMOVE_ITEM, function (context) {
     var _arguments3 = arguments;
     return cart_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
       var _ref4, key, _ref4$errorCallback, errorCallback, item, cart;

       return regeneratorRuntime.wrap(function _callee5$(_context5) {
         while (1) {
           switch (_context5.prev = _context5.next) {
             case 0:
               _ref4 = _arguments3.length > 1 && _arguments3[1] !== undefined ? _arguments3[1] : {}, key = _ref4.key, _ref4$errorCallback = _ref4.errorCallback, errorCallback = _ref4$errorCallback === void 0 ? function () {} : _ref4$errorCallback;
               context.commit(MUTATION_UPDATE_LOADING, true);
               _context5.prev = 2;
               _context5.next = 5;
               return api.removeItem(key);

             case 5:
               _context5.next = 7;
               return context.dispatch(ACTION_GET_CART);

             case 7:
               context.commit(MUTATION_UPDATE_LOADING, false);
               item = context.state[STATE_CART].items.find(function (item) {
                 return item.key === key;
               });
               document.dispatchEvent(new CustomEvent("track:cart:removed", {
                 detail: {
                   item: item
                 }
               }));
               _context5.next = 16;
               break;

             case 12:
               _context5.prev = 12;
               _context5.t0 = _context5["catch"](2);
               _context5.next = 16;
               return errorCallback(_context5.t0);

             case 16:
             case "end":
                cart = context.state.cart;
                //console.log("ACTION_REMOVE" , cart)
                const cartItems = [];
                cart.items.forEach(function (item) {
                  var unit_price = (item.final_line_price / 100) / item.quantity
                  var number = unit_price;
                  var roundedNumber = number.toFixed(2);
                  //console.log("remove to cart", roundedNumber);
                  cartItems.push({
                    name: item.title,
                    price_currency_code: cart.currency,
                    product_id: String(item.product_id),
                    quantity: item.quantity,
                    sku_id: item.sku,
                    unit_price: parseFloat(roundedNumber),
                  });
                });
                //console.log("const remove = [];", cartItems)
                nostojs(api => {
                  api.defaultSession()
                    .setCart({
                      items: cartItems,
                    })
                    .viewCart()
                    .update()
                });
               return _context5.stop();
           }
         }
       }, _callee5, null, [[2, 12]]);
     }))();
   }), _defineProperty(_actions, ACTION_CHANGE_QUANTITY, function (context) {
     var _arguments4 = arguments;
     return cart_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
       var _ref5, key, quantity, _ref5$errorCallback, errorCallback, item, cart;

       return regeneratorRuntime.wrap(function _callee6$(_context6) {
         while (1) {
           switch (_context6.prev = _context6.next) {
             case 0:
               _ref5 = _arguments4.length > 1 && _arguments4[1] !== undefined ? _arguments4[1] : {}, key = _ref5.key, quantity = _ref5.quantity, _ref5$errorCallback = _ref5.errorCallback, errorCallback = _ref5$errorCallback === void 0 ? function () {} : _ref5$errorCallback;
               context.commit(MUTATION_UPDATE_LOADING, false);
               _context6.prev = 2;
               _context6.next = 5;
               return api.changeQuantity(key, quantity);

             case 5:
               _context6.next = 7;
               return context.dispatch(ACTION_GET_CART);

             case 7:
               context.commit(MUTATION_UPDATE_LOADING, false);
               item = context.state[STATE_CART].items.find(function (item) {
                 return item.key === key;
               });
               document.dispatchEvent(new CustomEvent("track:cart:changed-quantity", {
                 detail: {
                   item: item
                 }
               }));
               _context6.next = 16;
               break;

             case 12:
               _context6.prev = 12;
               _context6.t0 = _context6["catch"](2);
               _context6.next = 16;
               return errorCallback(_context6.t0);

             case 16:
             case "end":
                cart = context.state.cart;
                //console.log("ACTION_QUANTIY" , cart)
                const cartItems = [];
                cart.items.forEach(function (item) {
                  var unit_price = (item.final_line_price / 100) / item.quantity
                  var number = unit_price;
                  var roundedNumber = number.toFixed(2);
                  //console.log("quantity cart", roundedNumber);
                  cartItems.push({
                    name: item.title,
                    price_currency_code: cart.currency,
                    product_id: String(item.product_id),
                    quantity: item.quantity,
                    sku_id: item.sku,
                    unit_price: parseFloat(roundedNumber),
                  });
                });
                //console.log("const quantity = [];", cartItems)
                nostojs(api => {
                  api.defaultSession()
                    .setCart({
                      items: cartItems,
                    })
                    .viewCart()
                    .update()
                });
               return _context6.stop();
           }
         }
       }, _callee6, null, [[2, 12]]);
     }))();
   }), _defineProperty(_actions, ACTION_SAVE_FOR_LATER, function (context) {
     var _arguments5 = arguments;
     return cart_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
       var _ref6, key, _ref6$errorCallback, errorCallback, item;

       return regeneratorRuntime.wrap(function _callee7$(_context7) {
         while (1) {
           switch (_context7.prev = _context7.next) {
             case 0:
               _ref6 = _arguments5.length > 1 && _arguments5[1] !== undefined ? _arguments5[1] : {}, key = _ref6.key, _ref6$errorCallback = _ref6.errorCallback, errorCallback = _ref6$errorCallback === void 0 ? function () {} : _ref6$errorCallback;
               context.commit(MUTATION_UPDATE_LOADING, false);
               item = context.state[STATE_CART].items.find(function (item) {
                 return item.key === key;
               });

               if (item) {
                 _context7.next = 5;
                 break;
               }

               return _context7.abrupt("return");

             case 5:
               _context7.prev = 5;
               _context7.next = 8;
               return Promise.all([context.dispatch("wishlist/".concat(wishlist["a" /* ACTION_ADD_TO_WISHLIST */]), {
                 product: item.product,
                 variant: item.variant,
                 errorCallback: errorCallback
               }, {
                 root: true
               }), context.dispatch(ACTION_REMOVE_ITEM, {
                 key: key,
                 errorCallback: errorCallback
               })]);

             case 8:
               _context7.next = 10;
               return context.dispatch(ACTION_GET_CART);

             case 10:
               context.commit(MUTATION_UPDATE_LOADING, false);
               document.dispatchEvent(new CustomEvent("track:cart:saved-for-later", {
                 detail: {
                   item: item
                 }
               }));
               _context7.next = 18;
               break;

             case 14:
               _context7.prev = 14;
               _context7.t0 = _context7["catch"](5);
               _context7.next = 18;
               return errorCallback(_context7.t0);

             case 18:
             case "end":
               return _context7.stop();
           }
         }
       }, _callee7, null, [[5, 14]]);
     }))();
   }), _actions)
 });

 /***/ }),
 /* 16 */
 /***/ (function(module, exports, __webpack_require__) {

 /**
  * Copyright (c) 2014-present, Facebook, Inc.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */

 var runtime = (function (exports) {
   "use strict";

   var Op = Object.prototype;
   var hasOwn = Op.hasOwnProperty;
   var undefined; // More compressible than void 0.
   var $Symbol = typeof Symbol === "function" ? Symbol : {};
   var iteratorSymbol = $Symbol.iterator || "@@iterator";
   var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
   var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

   function define(obj, key, value) {
     Object.defineProperty(obj, key, {
       value: value,
       enumerable: true,
       configurable: true,
       writable: true
     });
     return obj[key];
   }
   try {
     // IE 8 has a broken Object.defineProperty that only works on DOM objects.
     define({}, "");
   } catch (err) {
     define = function(obj, key, value) {
       return obj[key] = value;
     };
   }

   function wrap(innerFn, outerFn, self, tryLocsList) {
     // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
     var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
     var generator = Object.create(protoGenerator.prototype);
     var context = new Context(tryLocsList || []);

     // The ._invoke method unifies the implementations of the .next,
     // .throw, and .return methods.
     generator._invoke = makeInvokeMethod(innerFn, self, context);

     return generator;
   }
   exports.wrap = wrap;

   // Try/catch helper to minimize deoptimizations. Returns a completion
   // record like context.tryEntries[i].completion. This interface could
   // have been (and was previously) designed to take a closure to be
   // invoked without arguments, but in all the cases we care about we
   // already have an existing method we want to call, so there's no need
   // to create a new function object. We can even get away with assuming
   // the method takes exactly one argument, since that happens to be true
   // in every case, so we don't have to touch the arguments object. The
   // only additional allocation required is the completion record, which
   // has a stable shape and so hopefully should be cheap to allocate.
   function tryCatch(fn, obj, arg) {
     try {
       return { type: "normal", arg: fn.call(obj, arg) };
     } catch (err) {
       return { type: "throw", arg: err };
     }
   }

   var GenStateSuspendedStart = "suspendedStart";
   var GenStateSuspendedYield = "suspendedYield";
   var GenStateExecuting = "executing";
   var GenStateCompleted = "completed";

   // Returning this object from the innerFn has the same effect as
   // breaking out of the dispatch switch statement.
   var ContinueSentinel = {};

   // Dummy constructor functions that we use as the .constructor and
   // .constructor.prototype properties for functions that return Generator
   // objects. For full spec compliance, you may wish to configure your
   // minifier not to mangle the names of these two functions.
   function Generator() {}
   function GeneratorFunction() {}
   function GeneratorFunctionPrototype() {}

   // This is a polyfill for %IteratorPrototype% for environments that
   // don't natively support it.
   var IteratorPrototype = {};
   define(IteratorPrototype, iteratorSymbol, function () {
     return this;
   });

   var getProto = Object.getPrototypeOf;
   var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
   if (NativeIteratorPrototype &&
       NativeIteratorPrototype !== Op &&
       hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
     // This environment has a native %IteratorPrototype%; use it instead
     // of the polyfill.
     IteratorPrototype = NativeIteratorPrototype;
   }

   var Gp = GeneratorFunctionPrototype.prototype =
     Generator.prototype = Object.create(IteratorPrototype);
   GeneratorFunction.prototype = GeneratorFunctionPrototype;
   define(Gp, "constructor", GeneratorFunctionPrototype);
   define(GeneratorFunctionPrototype, "constructor", GeneratorFunction);
   GeneratorFunction.displayName = define(
     GeneratorFunctionPrototype,
     toStringTagSymbol,
     "GeneratorFunction"
   );

   // Helper for defining the .next, .throw, and .return methods of the
   // Iterator interface in terms of a single ._invoke method.
   function defineIteratorMethods(prototype) {
     ["next", "throw", "return"].forEach(function(method) {
       define(prototype, method, function(arg) {
         return this._invoke(method, arg);
       });
     });
   }

   exports.isGeneratorFunction = function(genFun) {
     var ctor = typeof genFun === "function" && genFun.constructor;
     return ctor
       ? ctor === GeneratorFunction ||
         // For the native GeneratorFunction constructor, the best we can
         // do is to check its .name property.
         (ctor.displayName || ctor.name) === "GeneratorFunction"
       : false;
   };

   exports.mark = function(genFun) {
     if (Object.setPrototypeOf) {
       Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
     } else {
       genFun.__proto__ = GeneratorFunctionPrototype;
       define(genFun, toStringTagSymbol, "GeneratorFunction");
     }
     genFun.prototype = Object.create(Gp);
     return genFun;
   };

   // Within the body of any async function, `await x` is transformed to
   // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
   // `hasOwn.call(value, "__await")` to determine if the yielded value is
   // meant to be awaited.
   exports.awrap = function(arg) {
     return { __await: arg };
   };

   function AsyncIterator(generator, PromiseImpl) {
     function invoke(method, arg, resolve, reject) {
       var record = tryCatch(generator[method], generator, arg);
       if (record.type === "throw") {
         reject(record.arg);
       } else {
         var result = record.arg;
         var value = result.value;
         if (value &&
             typeof value === "object" &&
             hasOwn.call(value, "__await")) {
           return PromiseImpl.resolve(value.__await).then(function(value) {
             invoke("next", value, resolve, reject);
           }, function(err) {
             invoke("throw", err, resolve, reject);
           });
         }

         return PromiseImpl.resolve(value).then(function(unwrapped) {
           // When a yielded Promise is resolved, its final value becomes
           // the .value of the Promise<{value,done}> result for the
           // current iteration.
           result.value = unwrapped;
           resolve(result);
         }, function(error) {
           // If a rejected Promise was yielded, throw the rejection back
           // into the async generator function so it can be handled there.
           return invoke("throw", error, resolve, reject);
         });
       }
     }

     var previousPromise;

     function enqueue(method, arg) {
       function callInvokeWithMethodAndArg() {
         return new PromiseImpl(function(resolve, reject) {
           invoke(method, arg, resolve, reject);
         });
       }

       return previousPromise =
         // If enqueue has been called before, then we want to wait until
         // all previous Promises have been resolved before calling invoke,
         // so that results are always delivered in the correct order. If
         // enqueue has not been called before, then it is important to
         // call invoke immediately, without waiting on a callback to fire,
         // so that the async generator function has the opportunity to do
         // any necessary setup in a predictable way. This predictability
         // is why the Promise constructor synchronously invokes its
         // executor callback, and why async functions synchronously
         // execute code before the first await. Since we implement simple
         // async functions in terms of async generators, it is especially
         // important to get this right, even though it requires care.
         previousPromise ? previousPromise.then(
           callInvokeWithMethodAndArg,
           // Avoid propagating failures to Promises returned by later
           // invocations of the iterator.
           callInvokeWithMethodAndArg
         ) : callInvokeWithMethodAndArg();
     }

     // Define the unified helper method that is used to implement .next,
     // .throw, and .return (see defineIteratorMethods).
     this._invoke = enqueue;
   }

   defineIteratorMethods(AsyncIterator.prototype);
   define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
     return this;
   });
   exports.AsyncIterator = AsyncIterator;

   // Note that simple async functions are implemented on top of
   // AsyncIterator objects; they just return a Promise for the value of
   // the final result produced by the iterator.
   exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
     if (PromiseImpl === void 0) PromiseImpl = Promise;

     var iter = new AsyncIterator(
       wrap(innerFn, outerFn, self, tryLocsList),
       PromiseImpl
     );

     return exports.isGeneratorFunction(outerFn)
       ? iter // If outerFn is a generator, return the full iterator.
       : iter.next().then(function(result) {
           return result.done ? result.value : iter.next();
         });
   };

   function makeInvokeMethod(innerFn, self, context) {
     var state = GenStateSuspendedStart;

     return function invoke(method, arg) {
       if (state === GenStateExecuting) {
         throw new Error("Generator is already running");
       }

       if (state === GenStateCompleted) {
         if (method === "throw") {
           throw arg;
         }

         // Be forgiving, per 25.3.3.3.3 of the spec:
         // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
         return doneResult();
       }

       context.method = method;
       context.arg = arg;

       while (true) {
         var delegate = context.delegate;
         if (delegate) {
           var delegateResult = maybeInvokeDelegate(delegate, context);
           if (delegateResult) {
             if (delegateResult === ContinueSentinel) continue;
             return delegateResult;
           }
         }

         if (context.method === "next") {
           // Setting context._sent for legacy support of Babel's
           // function.sent implementation.
           context.sent = context._sent = context.arg;

         } else if (context.method === "throw") {
           if (state === GenStateSuspendedStart) {
             state = GenStateCompleted;
             throw context.arg;
           }

           context.dispatchException(context.arg);

         } else if (context.method === "return") {
           context.abrupt("return", context.arg);
         }

         state = GenStateExecuting;

         var record = tryCatch(innerFn, self, context);
         if (record.type === "normal") {
           // If an exception is thrown from innerFn, we leave state ===
           // GenStateExecuting and loop back for another invocation.
           state = context.done
             ? GenStateCompleted
             : GenStateSuspendedYield;

           if (record.arg === ContinueSentinel) {
             continue;
           }

           return {
             value: record.arg,
             done: context.done
           };

         } else if (record.type === "throw") {
           state = GenStateCompleted;
           // Dispatch the exception by looping back around to the
           // context.dispatchException(context.arg) call above.
           context.method = "throw";
           context.arg = record.arg;
         }
       }
     };
   }

   // Call delegate.iterator[context.method](context.arg) and handle the
   // result, either by returning a { value, done } result from the
   // delegate iterator, or by modifying context.method and context.arg,
   // setting context.delegate to null, and returning the ContinueSentinel.
   function maybeInvokeDelegate(delegate, context) {
     var method = delegate.iterator[context.method];
     if (method === undefined) {
       // A .throw or .return when the delegate iterator has no .throw
       // method always terminates the yield* loop.
       context.delegate = null;

       if (context.method === "throw") {
         // Note: ["return"] must be used for ES3 parsing compatibility.
         if (delegate.iterator["return"]) {
           // If the delegate iterator has a return method, give it a
           // chance to clean up.
           context.method = "return";
           context.arg = undefined;
           maybeInvokeDelegate(delegate, context);

           if (context.method === "throw") {
             // If maybeInvokeDelegate(context) changed context.method from
             // "return" to "throw", let that override the TypeError below.
             return ContinueSentinel;
           }
         }

         context.method = "throw";
         context.arg = new TypeError(
           "The iterator does not provide a 'throw' method");
       }

       return ContinueSentinel;
     }

     var record = tryCatch(method, delegate.iterator, context.arg);

     if (record.type === "throw") {
       context.method = "throw";
       context.arg = record.arg;
       context.delegate = null;
       return ContinueSentinel;
     }

     var info = record.arg;

     if (! info) {
       context.method = "throw";
       context.arg = new TypeError("iterator result is not an object");
       context.delegate = null;
       return ContinueSentinel;
     }

     if (info.done) {
       // Assign the result of the finished delegate to the temporary
       // variable specified by delegate.resultName (see delegateYield).
       context[delegate.resultName] = info.value;

       // Resume execution at the desired location (see delegateYield).
       context.next = delegate.nextLoc;

       // If context.method was "throw" but the delegate handled the
       // exception, let the outer generator proceed normally. If
       // context.method was "next", forget context.arg since it has been
       // "consumed" by the delegate iterator. If context.method was
       // "return", allow the original .return call to continue in the
       // outer generator.
       if (context.method !== "return") {
         context.method = "next";
         context.arg = undefined;
       }

     } else {
       // Re-yield the result returned by the delegate method.
       return info;
     }

     // The delegate iterator is finished, so forget it and continue with
     // the outer generator.
     context.delegate = null;
     return ContinueSentinel;
   }

   // Define Generator.prototype.{next,throw,return} in terms of the
   // unified ._invoke helper method.
   defineIteratorMethods(Gp);

   define(Gp, toStringTagSymbol, "Generator");

   // A Generator should always return itself as the iterator object when the
   // @@iterator function is called on it. Some browsers' implementations of the
   // iterator prototype chain incorrectly implement this, causing the Generator
   // object to not be returned from this call. This ensures that doesn't happen.
   // See https://github.com/facebook/regenerator/issues/274 for more details.
   define(Gp, iteratorSymbol, function() {
     return this;
   });

   define(Gp, "toString", function() {
     return "[object Generator]";
   });

   function pushTryEntry(locs) {
     var entry = { tryLoc: locs[0] };

     if (1 in locs) {
       entry.catchLoc = locs[1];
     }

     if (2 in locs) {
       entry.finallyLoc = locs[2];
       entry.afterLoc = locs[3];
     }

     this.tryEntries.push(entry);
   }

   function resetTryEntry(entry) {
     var record = entry.completion || {};
     record.type = "normal";
     delete record.arg;
     entry.completion = record;
   }

   function Context(tryLocsList) {
     // The root entry object (effectively a try statement without a catch
     // or a finally block) gives us a place to store values thrown from
     // locations where there is no enclosing try statement.
     this.tryEntries = [{ tryLoc: "root" }];
     tryLocsList.forEach(pushTryEntry, this);
     this.reset(true);
   }

   exports.keys = function(object) {
     var keys = [];
     for (var key in object) {
       keys.push(key);
     }
     keys.reverse();

     // Rather than returning an object with a next method, we keep
     // things simple and return the next function itself.
     return function next() {
       while (keys.length) {
         var key = keys.pop();
         if (key in object) {
           next.value = key;
           next.done = false;
           return next;
         }
       }

       // To avoid creating an additional object, we just hang the .value
       // and .done properties off the next function object itself. This
       // also ensures that the minifier will not anonymize the function.
       next.done = true;
       return next;
     };
   };

   function values(iterable) {
     if (iterable) {
       var iteratorMethod = iterable[iteratorSymbol];
       if (iteratorMethod) {
         return iteratorMethod.call(iterable);
       }

       if (typeof iterable.next === "function") {
         return iterable;
       }

       if (!isNaN(iterable.length)) {
         var i = -1, next = function next() {
           while (++i < iterable.length) {
             if (hasOwn.call(iterable, i)) {
               next.value = iterable[i];
               next.done = false;
               return next;
             }
           }

           next.value = undefined;
           next.done = true;

           return next;
         };

         return next.next = next;
       }
     }

     // Return an iterator with no values.
     return { next: doneResult };
   }
   exports.values = values;

   function doneResult() {
     return { value: undefined, done: true };
   }

   Context.prototype = {
     constructor: Context,

     reset: function(skipTempReset) {
       this.prev = 0;
       this.next = 0;
       // Resetting context._sent for legacy support of Babel's
       // function.sent implementation.
       this.sent = this._sent = undefined;
       this.done = false;
       this.delegate = null;

       this.method = "next";
       this.arg = undefined;

       this.tryEntries.forEach(resetTryEntry);

       if (!skipTempReset) {
         for (var name in this) {
           // Not sure about the optimal order of these conditions:
           if (name.charAt(0) === "t" &&
               hasOwn.call(this, name) &&
               !isNaN(+name.slice(1))) {
             this[name] = undefined;
           }
         }
       }
     },

     stop: function() {
       this.done = true;

       var rootEntry = this.tryEntries[0];
       var rootRecord = rootEntry.completion;
       if (rootRecord.type === "throw") {
         throw rootRecord.arg;
       }

       return this.rval;
     },

     dispatchException: function(exception) {
       if (this.done) {
         throw exception;
       }

       var context = this;
       function handle(loc, caught) {
         record.type = "throw";
         record.arg = exception;
         context.next = loc;

         if (caught) {
           // If the dispatched exception was caught by a catch block,
           // then let that catch block handle the exception normally.
           context.method = "next";
           context.arg = undefined;
         }

         return !! caught;
       }

       for (var i = this.tryEntries.length - 1; i >= 0; --i) {
         var entry = this.tryEntries[i];
         var record = entry.completion;

         if (entry.tryLoc === "root") {
           // Exception thrown outside of any try block that could handle
           // it, so set the completion value of the entire function to
           // throw the exception.
           return handle("end");
         }

         if (entry.tryLoc <= this.prev) {
           var hasCatch = hasOwn.call(entry, "catchLoc");
           var hasFinally = hasOwn.call(entry, "finallyLoc");

           if (hasCatch && hasFinally) {
             if (this.prev < entry.catchLoc) {
               return handle(entry.catchLoc, true);
             } else if (this.prev < entry.finallyLoc) {
               return handle(entry.finallyLoc);
             }

           } else if (hasCatch) {
             if (this.prev < entry.catchLoc) {
               return handle(entry.catchLoc, true);
             }

           } else if (hasFinally) {
             if (this.prev < entry.finallyLoc) {
               return handle(entry.finallyLoc);
             }

           } else {
             throw new Error("try statement without catch or finally");
           }
         }
       }
     },

     abrupt: function(type, arg) {
       for (var i = this.tryEntries.length - 1; i >= 0; --i) {
         var entry = this.tryEntries[i];
         if (entry.tryLoc <= this.prev &&
             hasOwn.call(entry, "finallyLoc") &&
             this.prev < entry.finallyLoc) {
           var finallyEntry = entry;
           break;
         }
       }

       if (finallyEntry &&
           (type === "break" ||
            type === "continue") &&
           finallyEntry.tryLoc <= arg &&
           arg <= finallyEntry.finallyLoc) {
         // Ignore the finally entry if control is not jumping to a
         // location outside the try/catch block.
         finallyEntry = null;
       }

       var record = finallyEntry ? finallyEntry.completion : {};
       record.type = type;
       record.arg = arg;

       if (finallyEntry) {
         this.method = "next";
         this.next = finallyEntry.finallyLoc;
         return ContinueSentinel;
       }

       return this.complete(record);
     },

     complete: function(record, afterLoc) {
       if (record.type === "throw") {
         throw record.arg;
       }

       if (record.type === "break" ||
           record.type === "continue") {
         this.next = record.arg;
       } else if (record.type === "return") {
         this.rval = this.arg = record.arg;
         this.method = "return";
         this.next = "end";
       } else if (record.type === "normal" && afterLoc) {
         this.next = afterLoc;
       }

       return ContinueSentinel;
     },

     finish: function(finallyLoc) {
       for (var i = this.tryEntries.length - 1; i >= 0; --i) {
         var entry = this.tryEntries[i];
         if (entry.finallyLoc === finallyLoc) {
           this.complete(entry.completion, entry.afterLoc);
           resetTryEntry(entry);
           return ContinueSentinel;
         }
       }
     },

     "catch": function(tryLoc) {
       for (var i = this.tryEntries.length - 1; i >= 0; --i) {
         var entry = this.tryEntries[i];
         if (entry.tryLoc === tryLoc) {
           var record = entry.completion;
           if (record.type === "throw") {
             var thrown = record.arg;
             resetTryEntry(entry);
           }
           return thrown;
         }
       }

       // The context.catch method must only be called with a location
       // argument that corresponds to a known catch block.
       throw new Error("illegal catch attempt");
     },

     delegateYield: function(iterable, resultName, nextLoc) {
       this.delegate = {
         iterator: values(iterable),
         resultName: resultName,
         nextLoc: nextLoc
       };

       if (this.method === "next") {
         // Deliberately forget the last sent value so that we don't
         // accidentally pass it on to the delegate.
         this.arg = undefined;
       }

       return ContinueSentinel;
     }
   };

   // Regardless of whether this script is executing as a CommonJS module
   // or not, return the runtime object so that we can declare the variable
   // regeneratorRuntime in the outer scope, which allows this module to be
   // injected easily by `bin/regenerator --include-runtime script.js`.
   return exports;

 }(
   // If this script is executing as a CommonJS module, use module.exports
   // as the regeneratorRuntime namespace. Otherwise create a new empty
   // object. Either way, the resulting object will be used to initialize
   // the regeneratorRuntime variable at the top of this file.
    true ? module.exports : undefined
 ));

 try {
   regeneratorRuntime = runtime;
 } catch (accidentalStrictMode) {
   // This module should not be running in strict mode, so the above
   // assignment should always work unless something is misconfigured. Just
   // in case runtime.js accidentally runs in strict mode, in modern engines
   // we can explicitly access globalThis. In older engines we can escape
   // strict mode using a global Function call. This could conceivably fail
   // if a Content Security Policy forbids using Function, but in that case
   // the proper solution is to fix the accidental strict mode problem. If
   // you've misconfigured your bundler to force strict mode and applied a
   // CSP to forbid Function, and you're not willing to fix either of those
   // problems, please detail your unique predicament in a GitHub issue.
   if (typeof globalThis === "object") {
     globalThis.regeneratorRuntime = runtime;
   } else {
     Function("r", "regeneratorRuntime = r")(runtime);
   }
 }


 /***/ }),
 /* 17 */
 /***/ (function(module, exports, __webpack_require__) {

 var global = __webpack_require__(2);
 var isObject = __webpack_require__(18);

 var String = global.String;
 var TypeError = global.TypeError;

 // `Assert: Type(argument) is Object`
 module.exports = function (argument) {
   if (isObject(argument)) return argument;
   throw TypeError(String(argument) + ' is not an object');
 };


 /***/ }),
 /* 18 */
 /***/ (function(module, exports, __webpack_require__) {

 var isCallable = __webpack_require__(11);

 module.exports = function (it) {
   return typeof it == 'object' ? it !== null : isCallable(it);
 };


 /***/ }),
 /* 19 */
 /***/ (function(module, exports, __webpack_require__) {

 var uncurryThis = __webpack_require__(5);
 var toObject = __webpack_require__(42);

 var hasOwnProperty = uncurryThis({}.hasOwnProperty);

 // `HasOwnProperty` abstract operation
 // https://tc39.es/ecma262/#sec-hasownproperty
 module.exports = Object.hasOwn || function hasOwn(it, key) {
   return hasOwnProperty(toObject(it), key);
 };


 /***/ }),
 /* 20 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";
 /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return store; });
 /* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36);
 /* harmony import */ var vuex__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79);
 /* harmony import */ var _cart_cart__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15);
 /* harmony import */ var _wishlist_wishlist__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77);
 /* harmony import */ var _recently_viewed_products_recently_viewed_products__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(78);
 /* harmony import */ var _instant_search_instant_search__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35);






 vue__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].use(vuex__WEBPACK_IMPORTED_MODULE_1__[/* default */ "b"]);
 var store = new vuex__WEBPACK_IMPORTED_MODULE_1__[/* default */ "b"].Store({
   modules: {
     cart: _cart_cart__WEBPACK_IMPORTED_MODULE_2__[/* default */ "i"],
     "recently-viewed-products": _recently_viewed_products_recently_viewed_products__WEBPACK_IMPORTED_MODULE_4__[/* default */ "c"],
     wishlist: _wishlist_wishlist__WEBPACK_IMPORTED_MODULE_3__[/* default */ "c"],
     "header-instant-search": _instant_search_instant_search__WEBPACK_IMPORTED_MODULE_5__[/* default */ "k"]
   }
 });

 /***/ }),
 /* 21 */
 /***/ (function(module, exports, __webpack_require__) {

 "use strict";

 var $ = __webpack_require__(13);
 var exec = __webpack_require__(133);

 // `RegExp.prototype.exec` method
 // https://tc39.es/ecma262/#sec-regexp.prototype.exec
 $({ target: 'RegExp', proto: true, forced: /./.exec !== exec }, {
   exec: exec
 });


 /***/ }),
 /* 22 */
 /***/ (function(module, exports) {

 var call = Function.prototype.call;

 module.exports = call.bind ? call.bind(call) : function () {
   return call.apply(call, arguments);
 };


 /***/ }),
 /* 23 */
 /***/ (function(module, exports, __webpack_require__) {

 var fails = __webpack_require__(10);

 // Detect IE8's incomplete defineProperty implementation
 module.exports = !fails(function () {
   // eslint-disable-next-line es/no-object-defineproperty -- required for testing
   return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
 });


 /***/ }),
 /* 24 */
 /***/ (function(module, exports, __webpack_require__) {

 module.exports = __webpack_require__(360);

 /***/ }),
 /* 25 */
 /***/ (function(module, exports, __webpack_require__) {

 "use strict";

 var $ = __webpack_require__(13);
 var $filter = __webpack_require__(83).filter;
 var arrayMethodHasSpeciesSupport = __webpack_require__(127);

 var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('filter');

 // `Array.prototype.filter` method
 // https://tc39.es/ecma262/#sec-array.prototype.filter
 // with adding support of @@species
 $({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
   filter: function filter(callbackfn /* , thisArg */) {
     return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
   }
 });


 /***/ }),
 /* 26 */
 /***/ (function(module, exports, __webpack_require__) {

 var global = __webpack_require__(2);
 var DESCRIPTORS = __webpack_require__(23);
 var IE8_DOM_DEFINE = __webpack_require__(121);
 var anObject = __webpack_require__(17);
 var toPropertyKey = __webpack_require__(93);

 var TypeError = global.TypeError;
 // eslint-disable-next-line es/no-object-defineproperty -- safe
 var $defineProperty = Object.defineProperty;

 // `Object.defineProperty` method
 // https://tc39.es/ecma262/#sec-object.defineproperty
 exports.f = DESCRIPTORS ? $defineProperty : function defineProperty(O, P, Attributes) {
   anObject(O);
   P = toPropertyKey(P);
   anObject(Attributes);
   if (IE8_DOM_DEFINE) try {
     return $defineProperty(O, P, Attributes);
   } catch (error) { /* empty */ }
   if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
   if ('value' in Attributes) O[P] = Attributes.value;
   return O;
 };


 /***/ }),
 /* 27 */
 /***/ (function(module, exports, __webpack_require__) {

 "use strict";

 var charAt = __webpack_require__(207).charAt;
 var toString = __webpack_require__(28);
 var InternalStateModule = __webpack_require__(53);
 var defineIterator = __webpack_require__(157);

 var STRING_ITERATOR = 'String Iterator';
 var setInternalState = InternalStateModule.set;
 var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);

 // `String.prototype[@@iterator]` method
 // https://tc39.es/ecma262/#sec-string.prototype-@@iterator
 defineIterator(String, 'String', function (iterated) {
   setInternalState(this, {
     type: STRING_ITERATOR,
     string: toString(iterated),
     index: 0
   });
 // `%StringIteratorPrototype%.next` method
 // https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
 }, function next() {
   var state = getInternalState(this);
   var string = state.string;
   var index = state.index;
   var point;
   if (index >= string.length) return { value: undefined, done: true };
   point = charAt(string, index);
   state.index += point.length;
   return { value: point, done: false };
 });


 /***/ }),
 /* 28 */
 /***/ (function(module, exports, __webpack_require__) {

 var global = __webpack_require__(2);
 var classof = __webpack_require__(75);

 var String = global.String;

 module.exports = function (argument) {
   if (classof(argument) === 'Symbol') throw TypeError('Cannot convert a Symbol value to a string');
   return String(argument);
 };


 /***/ }),
 /* 29 */
 /***/ (function(module, exports, __webpack_require__) {

 "use strict";

 var $ = __webpack_require__(13);
 var global = __webpack_require__(2);
 var getBuiltIn = __webpack_require__(33);
 var apply = __webpack_require__(117);
 var call = __webpack_require__(22);
 var uncurryThis = __webpack_require__(5);
 var IS_PURE = __webpack_require__(60);
 var DESCRIPTORS = __webpack_require__(23);
 var NATIVE_SYMBOL = __webpack_require__(111);
 var fails = __webpack_require__(10);
 var hasOwn = __webpack_require__(19);
 var isArray = __webpack_require__(105);
 var isCallable = __webpack_require__(11);
 var isObject = __webpack_require__(18);
 var isPrototypeOf = __webpack_require__(59);
 var isSymbol = __webpack_require__(92);
 var anObject = __webpack_require__(17);
 var toObject = __webpack_require__(42);
 var toIndexedObject = __webpack_require__(30);
 var toPropertyKey = __webpack_require__(93);
 var $toString = __webpack_require__(28);
 var createPropertyDescriptor = __webpack_require__(67);
 var nativeObjectCreate = __webpack_require__(55);
 var objectKeys = __webpack_require__(84);
 var getOwnPropertyNamesModule = __webpack_require__(74);
 var getOwnPropertyNamesExternal = __webpack_require__(190);
 var getOwnPropertySymbolsModule = __webpack_require__(119);
 var getOwnPropertyDescriptorModule = __webpack_require__(52);
 var definePropertyModule = __webpack_require__(26);
 var propertyIsEnumerableModule = __webpack_require__(109);
 var arraySlice = __webpack_require__(85);
 var redefine = __webpack_require__(32);
 var shared = __webpack_require__(99);
 var sharedKey = __webpack_require__(91);
 var hiddenKeys = __webpack_require__(66);
 var uid = __webpack_require__(96);
 var wellKnownSymbol = __webpack_require__(12);
 var wrappedWellKnownSymbolModule = __webpack_require__(189);
 var defineWellKnownSymbol = __webpack_require__(188);
 var setToStringTag = __webpack_require__(108);
 var InternalStateModule = __webpack_require__(53);
 var $forEach = __webpack_require__(83).forEach;

 var HIDDEN = sharedKey('hidden');
 var SYMBOL = 'Symbol';
 var PROTOTYPE = 'prototype';
 var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

 var setInternalState = InternalStateModule.set;
 var getInternalState = InternalStateModule.getterFor(SYMBOL);

 var ObjectPrototype = Object[PROTOTYPE];
 var $Symbol = global.Symbol;
 var SymbolPrototype = $Symbol && $Symbol[PROTOTYPE];
 var TypeError = global.TypeError;
 var QObject = global.QObject;
 var $stringify = getBuiltIn('JSON', 'stringify');
 var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
 var nativeDefineProperty = definePropertyModule.f;
 var nativeGetOwnPropertyNames = getOwnPropertyNamesExternal.f;
 var nativePropertyIsEnumerable = propertyIsEnumerableModule.f;
 var push = uncurryThis([].push);

 var AllSymbols = shared('symbols');
 var ObjectPrototypeSymbols = shared('op-symbols');
 var StringToSymbolRegistry = shared('string-to-symbol-registry');
 var SymbolToStringRegistry = shared('symbol-to-string-registry');
 var WellKnownSymbolsStore = shared('wks');

 // Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
 var USE_SETTER = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

 // fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
 var setSymbolDescriptor = DESCRIPTORS && fails(function () {
   return nativeObjectCreate(nativeDefineProperty({}, 'a', {
     get: function () { return nativeDefineProperty(this, 'a', { value: 7 }).a; }
   })).a != 7;
 }) ? function (O, P, Attributes) {
   var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor(ObjectPrototype, P);
   if (ObjectPrototypeDescriptor) delete ObjectPrototype[P];
   nativeDefineProperty(O, P, Attributes);
   if (ObjectPrototypeDescriptor && O !== ObjectPrototype) {
     nativeDefineProperty(ObjectPrototype, P, ObjectPrototypeDescriptor);
   }
 } : nativeDefineProperty;

 var wrap = function (tag, description) {
   var symbol = AllSymbols[tag] = nativeObjectCreate(SymbolPrototype);
   setInternalState(symbol, {
     type: SYMBOL,
     tag: tag,
     description: description
   });
   if (!DESCRIPTORS) symbol.description = description;
   return symbol;
 };

 var $defineProperty = function defineProperty(O, P, Attributes) {
   if (O === ObjectPrototype) $defineProperty(ObjectPrototypeSymbols, P, Attributes);
   anObject(O);
   var key = toPropertyKey(P);
   anObject(Attributes);
   if (hasOwn(AllSymbols, key)) {
     if (!Attributes.enumerable) {
       if (!hasOwn(O, HIDDEN)) nativeDefineProperty(O, HIDDEN, createPropertyDescriptor(1, {}));
       O[HIDDEN][key] = true;
     } else {
       if (hasOwn(O, HIDDEN) && O[HIDDEN][key]) O[HIDDEN][key] = false;
       Attributes = nativeObjectCreate(Attributes, { enumerable: createPropertyDescriptor(0, false) });
     } return setSymbolDescriptor(O, key, Attributes);
   } return nativeDefineProperty(O, key, Attributes);
 };

 var $defineProperties = function defineProperties(O, Properties) {
   anObject(O);
   var properties = toIndexedObject(Properties);
   var keys = objectKeys(properties).concat($getOwnPropertySymbols(properties));
   $forEach(keys, function (key) {
     if (!DESCRIPTORS || call($propertyIsEnumerable, properties, key)) $defineProperty(O, key, properties[key]);
   });
   return O;
 };

 var $create = function create(O, Properties) {
   return Properties === undefined ? nativeObjectCreate(O) : $defineProperties(nativeObjectCreate(O), Properties);
 };

 var $propertyIsEnumerable = function propertyIsEnumerable(V) {
   var P = toPropertyKey(V);
   var enumerable = call(nativePropertyIsEnumerable, this, P);
   if (this === ObjectPrototype && hasOwn(AllSymbols, P) && !hasOwn(ObjectPrototypeSymbols, P)) return false;
   return enumerable || !hasOwn(this, P) || !hasOwn(AllSymbols, P) || hasOwn(this, HIDDEN) && this[HIDDEN][P]
     ? enumerable : true;
 };

 var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
   var it = toIndexedObject(O);
   var key = toPropertyKey(P);
   if (it === ObjectPrototype && hasOwn(AllSymbols, key) && !hasOwn(ObjectPrototypeSymbols, key)) return;
   var descriptor = nativeGetOwnPropertyDescriptor(it, key);
   if (descriptor && hasOwn(AllSymbols, key) && !(hasOwn(it, HIDDEN) && it[HIDDEN][key])) {
     descriptor.enumerable = true;
   }
   return descriptor;
 };

 var $getOwnPropertyNames = function getOwnPropertyNames(O) {
   var names = nativeGetOwnPropertyNames(toIndexedObject(O));
   var result = [];
   $forEach(names, function (key) {
     if (!hasOwn(AllSymbols, key) && !hasOwn(hiddenKeys, key)) push(result, key);
   });
   return result;
 };

 var $getOwnPropertySymbols = function getOwnPropertySymbols(O) {
   var IS_OBJECT_PROTOTYPE = O === ObjectPrototype;
   var names = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject(O));
   var result = [];
   $forEach(names, function (key) {
     if (hasOwn(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || hasOwn(ObjectPrototype, key))) {
       push(result, AllSymbols[key]);
     }
   });
   return result;
 };

 // `Symbol` constructor
 // https://tc39.es/ecma262/#sec-symbol-constructor
 if (!NATIVE_SYMBOL) {
   $Symbol = function Symbol() {
     if (isPrototypeOf(SymbolPrototype, this)) throw TypeError('Symbol is not a constructor');
     var description = !arguments.length || arguments[0] === undefined ? undefined : $toString(arguments[0]);
     var tag = uid(description);
     var setter = function (value) {
       if (this === ObjectPrototype) call(setter, ObjectPrototypeSymbols, value);
       if (hasOwn(this, HIDDEN) && hasOwn(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
       setSymbolDescriptor(this, tag, createPropertyDescriptor(1, value));
     };
     if (DESCRIPTORS && USE_SETTER) setSymbolDescriptor(ObjectPrototype, tag, { configurable: true, set: setter });
     return wrap(tag, description);
   };

   SymbolPrototype = $Symbol[PROTOTYPE];

   redefine(SymbolPrototype, 'toString', function toString() {
     return getInternalState(this).tag;
   });

   redefine($Symbol, 'withoutSetter', function (description) {
     return wrap(uid(description), description);
   });

   propertyIsEnumerableModule.f = $propertyIsEnumerable;
   definePropertyModule.f = $defineProperty;
   getOwnPropertyDescriptorModule.f = $getOwnPropertyDescriptor;
   getOwnPropertyNamesModule.f = getOwnPropertyNamesExternal.f = $getOwnPropertyNames;
   getOwnPropertySymbolsModule.f = $getOwnPropertySymbols;

   wrappedWellKnownSymbolModule.f = function (name) {
     return wrap(wellKnownSymbol(name), name);
   };

   if (DESCRIPTORS) {
     // https://github.com/tc39/proposal-Symbol-description
     nativeDefineProperty(SymbolPrototype, 'description', {
       configurable: true,
       get: function description() {
         return getInternalState(this).description;
       }
     });
     if (!IS_PURE) {
       redefine(ObjectPrototype, 'propertyIsEnumerable', $propertyIsEnumerable, { unsafe: true });
     }
   }
 }

 $({ global: true, wrap: true, forced: !NATIVE_SYMBOL, sham: !NATIVE_SYMBOL }, {
   Symbol: $Symbol
 });

 $forEach(objectKeys(WellKnownSymbolsStore), function (name) {
   defineWellKnownSymbol(name);
 });

 $({ target: SYMBOL, stat: true, forced: !NATIVE_SYMBOL }, {
   // `Symbol.for` method
   // https://tc39.es/ecma262/#sec-symbol.for
   'for': function (key) {
     var string = $toString(key);
     if (hasOwn(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
     var symbol = $Symbol(string);
     StringToSymbolRegistry[string] = symbol;
     SymbolToStringRegistry[symbol] = string;
     return symbol;
   },
   // `Symbol.keyFor` method
   // https://tc39.es/ecma262/#sec-symbol.keyfor
   keyFor: function keyFor(sym) {
     if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol');
     if (hasOwn(SymbolToStringRegistry, sym)) return SymbolToStringRegistry[sym];
   },
   useSetter: function () { USE_SETTER = true; },
   useSimple: function () { USE_SETTER = false; }
 });

 $({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL, sham: !DESCRIPTORS }, {
   // `Object.create` method
   // https://tc39.es/ecma262/#sec-object.create
   create: $create,
   // `Object.defineProperty` method
   // https://tc39.es/ecma262/#sec-object.defineproperty
   defineProperty: $defineProperty,
   // `Object.defineProperties` method
   // https://tc39.es/ecma262/#sec-object.defineproperties
   defineProperties: $defineProperties,
   // `Object.getOwnPropertyDescriptor` method
   // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
   getOwnPropertyDescriptor: $getOwnPropertyDescriptor
 });

 $({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL }, {
   // `Object.getOwnPropertyNames` method
   // https://tc39.es/ecma262/#sec-object.getownpropertynames
   getOwnPropertyNames: $getOwnPropertyNames,
   // `Object.getOwnPropertySymbols` method
   // https://tc39.es/ecma262/#sec-object.getownpropertysymbols
   getOwnPropertySymbols: $getOwnPropertySymbols
 });

 // Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
 // https://bugs.chromium.org/p/v8/issues/detail?id=3443
 $({ target: 'Object', stat: true, forced: fails(function () { getOwnPropertySymbolsModule.f(1); }) }, {
   getOwnPropertySymbols: function getOwnPropertySymbols(it) {
     return getOwnPropertySymbolsModule.f(toObject(it));
   }
 });

 // `JSON.stringify` method behavior with symbols
 // https://tc39.es/ecma262/#sec-json.stringify
 if ($stringify) {
   var FORCED_JSON_STRINGIFY = !NATIVE_SYMBOL || fails(function () {
     var symbol = $Symbol();
     // MS Edge converts symbol values to JSON as {}
     return $stringify([symbol]) != '[null]'
       // WebKit converts symbol values to JSON as null
       || $stringify({ a: symbol }) != '{}'
       // V8 throws on boxed symbols
       || $stringify(Object(symbol)) != '{}';
   });

   $({ target: 'JSON', stat: true, forced: FORCED_JSON_STRINGIFY }, {
     // eslint-disable-next-line no-unused-vars -- required for `.length`
     stringify: function stringify(it, replacer, space) {
       var args = arraySlice(arguments);
       var $replacer = replacer;
       if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
       if (!isArray(replacer)) replacer = function (key, value) {
         if (isCallable($replacer)) value = call($replacer, this, key, value);
         if (!isSymbol(value)) return value;
       };
       args[1] = replacer;
       return apply($stringify, null, args);
     }
   });
 }

 // `Symbol.prototype[@@toPrimitive]` method
 // https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
 if (!SymbolPrototype[TO_PRIMITIVE]) {
   var valueOf = SymbolPrototype.valueOf;
   // eslint-disable-next-line no-unused-vars -- required for .length
   redefine(SymbolPrototype, TO_PRIMITIVE, function (hint) {
     // TODO: improve hint logic
     return call(valueOf, this);
   });
 }
 // `Symbol.prototype[@@toStringTag]` property
 // https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
 setToStringTag($Symbol, SYMBOL);

 hiddenKeys[HIDDEN] = true;


 /***/ }),
 /* 30 */
 /***/ (function(module, exports, __webpack_require__) {

 // toObject with fallback for non-array-like ES3 strings
 var IndexedObject = __webpack_require__(89);
 var requireObjectCoercible = __webpack_require__(37);

 module.exports = function (it) {
   return IndexedObject(requireObjectCoercible(it));
 };


 /***/ }),
 /* 31 */
 /***/ (function(module, exports, __webpack_require__) {

 "use strict";

 var toIndexedObject = __webpack_require__(30);
 var addToUnscopables = __webpack_require__(116);
 var Iterators = __webpack_require__(118);
 var InternalStateModule = __webpack_require__(53);
 var defineIterator = __webpack_require__(157);

 var ARRAY_ITERATOR = 'Array Iterator';
 var setInternalState = InternalStateModule.set;
 var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);

 // `Array.prototype.entries` method
 // https://tc39.es/ecma262/#sec-array.prototype.entries
 // `Array.prototype.keys` method
 // https://tc39.es/ecma262/#sec-array.prototype.keys
 // `Array.prototype.values` method
 // https://tc39.es/ecma262/#sec-array.prototype.values
 // `Array.prototype[@@iterator]` method
 // https://tc39.es/ecma262/#sec-array.prototype-@@iterator
 // `CreateArrayIterator` internal method
 // https://tc39.es/ecma262/#sec-createarrayiterator
 module.exports = defineIterator(Array, 'Array', function (iterated, kind) {
   setInternalState(this, {
     type: ARRAY_ITERATOR,
     target: toIndexedObject(iterated), // target
     index: 0,                          // next index
     kind: kind                         // kind
   });
 // `%ArrayIteratorPrototype%.next` method
 // https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
 }, function () {
   var state = getInternalState(this);
   var target = state.target;
   var kind = state.kind;
   var index = state.index++;
   if (!target || index >= target.length) {
     state.target = undefined;
     return { value: undefined, done: true };
   }
   if (kind == 'keys') return { value: index, done: false };
   if (kind == 'values') return { value: target[index], done: false };
   return { value: [index, target[index]], done: false };
 }, 'values');

 // argumentsList[@@iterator] is %ArrayProto_values%
 // https://tc39.es/ecma262/#sec-createunmappedargumentsobject
 // https://tc39.es/ecma262/#sec-createmappedargumentsobject
 Iterators.Arguments = Iterators.Array;

 // https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
 addToUnscopables('keys');
 addToUnscopables('values');
 addToUnscopables('entries');


 /***/ }),
 /* 32 */
 /***/ (function(module, exports, __webpack_require__) {

 var global = __webpack_require__(2);
 var isCallable = __webpack_require__(11);
 var hasOwn = __webpack_require__(19);
 var createNonEnumerableProperty = __webpack_require__(48);
 var setGlobal = __webpack_require__(97);
 var inspectSource = __webpack_require__(76);
 var InternalStateModule = __webpack_require__(53);
 var CONFIGURABLE_FUNCTION_NAME = __webpack_require__(90).CONFIGURABLE;

 var getInternalState = InternalStateModule.get;
 var enforceInternalState = InternalStateModule.enforce;
 var TEMPLATE = String(String).split('String');

 (module.exports = function (O, key, value, options) {
   var unsafe = options ? !!options.unsafe : false;
   var simple = options ? !!options.enumerable : false;
   var noTargetGet = options ? !!options.noTargetGet : false;
   var name = options && options.name !== undefined ? options.name : key;
   var state;
   if (isCallable(value)) {
     if (String(name).slice(0, 7) === 'Symbol(') {
       name = '[' + String(name).replace(/^Symbol\(([^)]*)\)/, '$1') + ']';
     }
     if (!hasOwn(value, 'name') || (CONFIGURABLE_FUNCTION_NAME && value.name !== name)) {
       createNonEnumerableProperty(value, 'name', name);
     }
     state = enforceInternalState(value);
     if (!state.source) {
       state.source = TEMPLATE.join(typeof name == 'string' ? name : '');
     }
   }
   if (O === global) {
     if (simple) O[key] = value;
     else setGlobal(key, value);
     return;
   } else if (!unsafe) {
     delete O[key];
   } else if (!noTargetGet && O[key]) {
     simple = true;
   }
   if (simple) O[key] = value;
   else createNonEnumerableProperty(O, key, value);
 // add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
 })(Function.prototype, 'toString', function toString() {
   return isCallable(this) && getInternalState(this).source || inspectSource(this);
 });


 /***/ }),
 /* 33 */
 /***/ (function(module, exports, __webpack_require__) {

 var global = __webpack_require__(2);
 var isCallable = __webpack_require__(11);

 var aFunction = function (argument) {
   return isCallable(argument) ? argument : undefined;
 };

 module.exports = function (namespace, method) {
   return arguments.length < 2 ? aFunction(global[namespace]) : global[namespace] && global[namespace][method];
 };


 /***/ }),
 /* 34 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";
 /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
 /* globals __VUE_SSR_CONTEXT__ */

 // IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
 // This module is a runtime utility for cleaner component module output and will
 // be included in the final webpack user bundle.

 function normalizeComponent (
   scriptExports,
   render,
   staticRenderFns,
   functionalTemplate,
   injectStyles,
   scopeId,
   moduleIdentifier, /* server only */
   shadowMode /* vue-cli only */
 ) {
   // Vue.extend constructor export interop
   var options = typeof scriptExports === 'function'
     ? scriptExports.options
     : scriptExports

   // render functions
   if (render) {
     options.render = render
     options.staticRenderFns = staticRenderFns
     options._compiled = true
   }

   // functional template
   if (functionalTemplate) {
     options.functional = true
   }

   // scopedId
   if (scopeId) {
     options._scopeId = 'data-v-' + scopeId
   }

   var hook
   if (moduleIdentifier) { // server build
     hook = function (context) {
       // 2.3 injection
       context =
         context || // cached call
         (this.$vnode && this.$vnode.ssrContext) || // stateful
         (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
       // 2.2 with runInNewContext: true
       if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
         context = __VUE_SSR_CONTEXT__
       }
       // inject component styles
       if (injectStyles) {
         injectStyles.call(this, context)
       }
       // register component module identifier for async chunk inferrence
       if (context && context._registeredComponents) {
         context._registeredComponents.add(moduleIdentifier)
       }
     }
     // used by ssr in case component is cached and beforeCreate
     // never gets called
     options._ssrRegister = hook
   } else if (injectStyles) {
     hook = shadowMode
       ? function () {
         injectStyles.call(
           this,
           (options.functional ? this.parent : this).$root.$options.shadowRoot
         )
       }
       : injectStyles
   }

   if (hook) {
     if (options.functional) {
       // for template-only hot-reload because in that case the render fn doesn't
       // go through the normalizer
       options._injectStyles = hook
       // register for functional component in vue file
       var originalRender = options.render
       options.render = function renderWithStyleInjection (h, context) {
         hook.call(context)
         return originalRender(h, context)
       }
     } else {
       // inject component registration as beforeCreate hook
       var existing = options.beforeCreate
       options.beforeCreate = existing
         ? [].concat(existing, hook)
         : [hook]
     }
   }

   return {
     exports: scriptExports,
     options: options
   }
 }


 /***/ }),
 /* 35 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";
 /* unused harmony export STATE_LOADING */
 /* unused harmony export STATE_QUERY */
 /* unused harmony export STATE_OPENED */
 /* unused harmony export STATE_PRODUCTS */
 /* unused harmony export STATE_SUGGESTIONS */
 /* unused harmony export STATE_TERM_SUGGESTION */
 /* unused harmony export MUTATION_UPDATE_LOADING */
 /* unused harmony export MUTATION_UPDATE_OPENED */
 /* unused harmony export MUTATION_UPDATE_QUERY */
 /* unused harmony export MUTATION_UPDATE_PRODUCTS */
 /* unused harmony export MUTATION_UPDATE_SUGGESTIONS */
 /* unused harmony export MUTATION_UPDATE_TERM_SUGGESTION */
 /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ACTION_INIT_INSTANT_SEARCH; });
 /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ACTION_GET_RESULTS_BY_QUERY; });
 /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ACTION_OPEN_DROPDOWN; });
 /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACTION_CLOSE_DROPDOWN; });
 /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return GETTER_LOADING; });
 /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return GETTER_OPENED; });
 /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return GETTER_QUERY; });
 /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return GETTER_SUGGESTIONS; });
 /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return GETTER_PRODUCTS; });
 /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return GETTER_TERM_SUGGESTION; });
 /* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3);
 /* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14);
 /* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_1__);
 /* harmony import */ var regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16);
 /* harmony import */ var regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_2__);
 /* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51);
 /* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_3__);
 /* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21);
 /* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_4__);
 /* harmony import */ var core_js_modules_es_string_search_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(125);
 /* harmony import */ var core_js_modules_es_string_search_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_search_js__WEBPACK_IMPORTED_MODULE_5__);
 /* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(24);
 /* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_6__);
 /* harmony import */ var _core_objects__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(38);



 var _getters, _mutations, _actions;



 function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

 function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }





 function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



 var STATE_LOADING = "loading";
 var STATE_QUERY = "query";
 var STATE_OPENED = "opened";
 var STATE_PRODUCTS = "products";
 var STATE_SUGGESTIONS = "suggestions";
 var STATE_TERM_SUGGESTION = "termSuggestion";
 var MUTATION_UPDATE_LOADING = "updateLoading";
 var MUTATION_UPDATE_OPENED = "updateOpened";
 var MUTATION_UPDATE_QUERY = "updateQuery";
 var MUTATION_UPDATE_PRODUCTS = "updateProducts";
 var MUTATION_UPDATE_SUGGESTIONS = "updateSuggestions";
 var MUTATION_UPDATE_TERM_SUGGESTION = "updateTermSuggestion";
 var ACTION_INIT_INSTANT_SEARCH = "initInstantSearch";
 var ACTION_GET_RESULTS_BY_QUERY = "getResultsByQuery";
 var ACTION_OPEN_DROPDOWN = "openDropdown";
 var ACTION_CLOSE_DROPDOWN = "closeDropdown";
 var GETTER_LOADING = "getLoading";
 var GETTER_OPENED = "getOpened";
 var GETTER_QUERY = "getQuery";
 var GETTER_SUGGESTIONS = "getSuggestions";
 var GETTER_PRODUCTS = "getProducts";
 var GETTER_TERM_SUGGESTION = "termSuggestion";
 var client = axios__WEBPACK_IMPORTED_MODULE_6___default.a.create({
   baseURL: "https://services.mybcapps.com"
 });
 /* harmony default export */ __webpack_exports__["k"] = ({
   namespaced: true,
   state: function state() {
     var _ref;

     return _ref = {}, _defineProperty(_ref, STATE_LOADING, true), _defineProperty(_ref, STATE_QUERY, ""), _defineProperty(_ref, STATE_OPENED, false), _defineProperty(_ref, STATE_PRODUCTS, []), _defineProperty(_ref, STATE_SUGGESTIONS, []), _defineProperty(_ref, STATE_TERM_SUGGESTION, []), _ref;
   },
   getters: (_getters = {}, _defineProperty(_getters, GETTER_LOADING, function (state) {
     return state[STATE_LOADING];
   }), _defineProperty(_getters, GETTER_OPENED, function (state) {
     return state[STATE_OPENED];
   }), _defineProperty(_getters, GETTER_QUERY, function (state) {
     return state[STATE_QUERY];
   }), _defineProperty(_getters, GETTER_SUGGESTIONS, function (state) {
     return state[STATE_SUGGESTIONS];
   }), _defineProperty(_getters, GETTER_PRODUCTS, function (state) {
     return state[STATE_PRODUCTS];
   }), _defineProperty(_getters, GETTER_TERM_SUGGESTION, function (state) {
     return state[STATE_TERM_SUGGESTION];
   }), _getters),
   mutations: (_mutations = {}, _defineProperty(_mutations, MUTATION_UPDATE_PRODUCTS, function (state, products) {
     products.map(function (product) {
       product.price_min = product.price_min * 100;
       product.price_max = product.price_max * 100;
       if (!product.price) product.price = product.price_min;
     });
     state[STATE_PRODUCTS] = products;
   }), _defineProperty(_mutations, MUTATION_UPDATE_QUERY, function (state, query) {
     state[STATE_QUERY] = query;
   }), _defineProperty(_mutations, MUTATION_UPDATE_OPENED, function (state, opened) {
     state[STATE_OPENED] = opened;
   }), _defineProperty(_mutations, MUTATION_UPDATE_SUGGESTIONS, function (state, suggestions) {
     state[STATE_SUGGESTIONS] = suggestions;
   }), _defineProperty(_mutations, MUTATION_UPDATE_LOADING, function (state, loading) {
     state[STATE_LOADING] = loading;
   }), _defineProperty(_mutations, MUTATION_UPDATE_TERM_SUGGESTION, function (state, loading) {
     state[STATE_TERM_SUGGESTION] = loading;
   }), _mutations),
   actions: (_actions = {}, _defineProperty(_actions, ACTION_INIT_INSTANT_SEARCH, function (context) {
     return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
       return regeneratorRuntime.wrap(function _callee$(_context) {
         while (1) {
           switch (_context.prev = _context.next) {
             case 0:
              // context.commit(MUTATION_UPDATE_TERM_SUGGESTION, window.boostPFSAppConfig?.settings?.search?.searchBoxOnclick?.searchTermSuggestion?.data);

             case 1:
             case "end":
               return _context.stop();
           }
         }
       }, _callee);
     }))();
   }), _defineProperty(_actions, ACTION_GET_RESULTS_BY_QUERY, function (context, _ref2) {
     return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
       var query, _ref2$errorCallback, errorCallback, result;

       return regeneratorRuntime.wrap(function _callee2$(_context2) {
         while (1) {
           switch (_context2.prev = _context2.next) {
             case 0:
               query = _ref2.query, _ref2$errorCallback = _ref2.errorCallback, errorCallback = _ref2$errorCallback === void 0 ? function () {} : _ref2$errorCallback;
               context.commit(MUTATION_UPDATE_QUERY, query);

               if (query) {
                 _context2.next = 6;
                 break;
               }

               _context2.next = 5;
               return context.dispatch(ACTION_CLOSE_DROPDOWN);

             case 5:
               return _context2.abrupt("return");

             case 6:
               _context2.next = 8;
               return context.dispatch(ACTION_OPEN_DROPDOWN);

             case 8:
               context.commit(MUTATION_UPDATE_LOADING, true);
               _context2.prev = 9;
               _context2.next = 12;
               return client.get("/bc-sf-filter/search/suggest", {
                 params: {
                   q: query,
                   shop: _core_objects__WEBPACK_IMPORTED_MODULE_7__[/* default */ "c"].get("shop.permanent_domain"),
                   page_limit: 5,
                   suggestion_limit: 5,
                   product_limit: 8
                 }
               });

             case 12:
               result = _context2.sent;
               context.commit(MUTATION_UPDATE_PRODUCTS, result.data["products"]);
               context.commit(MUTATION_UPDATE_SUGGESTIONS, result.data["suggestions"]);
               _context2.next = 20;
               break;

             case 17:
               _context2.prev = 17;
               _context2.t0 = _context2["catch"](9);
               errorCallback(_context2.t0);

             case 20:
               context.commit(MUTATION_UPDATE_LOADING, false);

             case 21:
             case "end":
               return _context2.stop();
           }
         }
       }, _callee2, null, [[9, 17]]);
     }))();
   }), _defineProperty(_actions, ACTION_OPEN_DROPDOWN, function (context) {
     context.commit(MUTATION_UPDATE_OPENED, true);
   }), _defineProperty(_actions, ACTION_CLOSE_DROPDOWN, function (context) {
     context.commit(MUTATION_UPDATE_OPENED, false);
   }), _actions)
 });

 /***/ }),
 /* 36 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";
 /* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
  * Vue.js v2.6.14
  * (c) 2014-2021 Evan You
  * Released under the MIT License.
  */
 /*  */

 var emptyObject = Object.freeze({});

 // These helpers produce better VM code in JS engines due to their
 // explicitness and function inlining.
 function isUndef (v) {
   return v === undefined || v === null
 }

 function isDef (v) {
   return v !== undefined && v !== null
 }

 function isTrue (v) {
   return v === true
 }

 function isFalse (v) {
   return v === false
 }

 /**
  * Check if value is primitive.
  */
 function isPrimitive (value) {
   return (
     typeof value === 'string' ||
     typeof value === 'number' ||
     // $flow-disable-line
     typeof value === 'symbol' ||
     typeof value === 'boolean'
   )
 }

 /**
  * Quick object check - this is primarily used to tell
  * Objects from primitive values when we know the value
  * is a JSON-compliant type.
  */
 function isObject (obj) {
   return obj !== null && typeof obj === 'object'
 }

 /**
  * Get the raw type string of a value, e.g., [object Object].
  */
 var _toString = Object.prototype.toString;

 function toRawType (value) {
   return _toString.call(value).slice(8, -1)
 }

 /**
  * Strict object type check. Only returns true
  * for plain JavaScript objects.
  */
 function isPlainObject (obj) {
   return _toString.call(obj) === '[object Object]'
 }

 function isRegExp (v) {
   return _toString.call(v) === '[object RegExp]'
 }

 /**
  * Check if val is a valid array index.
  */
 function isValidArrayIndex (val) {
   var n = parseFloat(String(val));
   return n >= 0 && Math.floor(n) === n && isFinite(val)
 }

 function isPromise (val) {
   return (
     isDef(val) &&
     typeof val.then === 'function' &&
     typeof val.catch === 'function'
   )
 }

 /**
  * Convert a value to a string that is actually rendered.
  */
 function toString (val) {
   return val == null
     ? ''
     : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
       ? JSON.stringify(val, null, 2)
       : String(val)
 }

 /**
  * Convert an input value to a number for persistence.
  * If the conversion fails, return original string.
  */
 function toNumber (val) {
   var n = parseFloat(val);
   return isNaN(n) ? val : n
 }

 /**
  * Make a map and return a function for checking if a key
  * is in that map.
  */
 function makeMap (
   str,
   expectsLowerCase
 ) {
   var map = Object.create(null);
   var list = str.split(',');
   for (var i = 0; i < list.length; i++) {
     map[list[i]] = true;
   }
   return expectsLowerCase
     ? function (val) { return map[val.toLowerCase()]; }
     : function (val) { return map[val]; }
 }

 /**
  * Check if a tag is a built-in tag.
  */
 var isBuiltInTag = makeMap('slot,component', true);

 /**
  * Check if an attribute is a reserved attribute.
  */
 var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

 /**
  * Remove an item from an array.
  */
 function remove (arr, item) {
   if (arr.length) {
     var index = arr.indexOf(item);
     if (index > -1) {
       return arr.splice(index, 1)
     }
   }
 }

 /**
  * Check whether an object has the property.
  */
 var hasOwnProperty = Object.prototype.hasOwnProperty;
 function hasOwn (obj, key) {
   return hasOwnProperty.call(obj, key)
 }

 /**
  * Create a cached version of a pure function.
  */
 function cached (fn) {
   var cache = Object.create(null);
   return (function cachedFn (str) {
     var hit = cache[str];
     return hit || (cache[str] = fn(str))
   })
 }

 /**
  * Camelize a hyphen-delimited string.
  */
 var camelizeRE = /-(\w)/g;
 var camelize = cached(function (str) {
   return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
 });

 /**
  * Capitalize a string.
  */
 var capitalize = cached(function (str) {
   return str.charAt(0).toUpperCase() + str.slice(1)
 });

 /**
  * Hyphenate a camelCase string.
  */
 var hyphenateRE = /\B([A-Z])/g;
 var hyphenate = cached(function (str) {
   return str.replace(hyphenateRE, '-$1').toLowerCase()
 });

 /**
  * Simple bind polyfill for environments that do not support it,
  * e.g., PhantomJS 1.x. Technically, we don't need this anymore
  * since native bind is now performant enough in most browsers.
  * But removing it would mean breaking code that was able to run in
  * PhantomJS 1.x, so this must be kept for backward compatibility.
  */

 /* istanbul ignore next */
 function polyfillBind (fn, ctx) {
   function boundFn (a) {
     var l = arguments.length;
     return l
       ? l > 1
         ? fn.apply(ctx, arguments)
         : fn.call(ctx, a)
       : fn.call(ctx)
   }

   boundFn._length = fn.length;
   return boundFn
 }

 function nativeBind (fn, ctx) {
   return fn.bind(ctx)
 }

 var bind = Function.prototype.bind
   ? nativeBind
   : polyfillBind;

 /**
  * Convert an Array-like object to a real Array.
  */
 function toArray (list, start) {
   start = start || 0;
   var i = list.length - start;
   var ret = new Array(i);
   while (i--) {
     ret[i] = list[i + start];
   }
   return ret
 }

 /**
  * Mix properties into target object.
  */
 function extend (to, _from) {
   for (var key in _from) {
     to[key] = _from[key];
   }
   return to
 }

 /**
  * Merge an Array of Objects into a single Object.
  */
 function toObject (arr) {
   var res = {};
   for (var i = 0; i < arr.length; i++) {
     if (arr[i]) {
       extend(res, arr[i]);
     }
   }
   return res
 }

 /* eslint-disable no-unused-vars */

 /**
  * Perform no operation.
  * Stubbing args to make Flow happy without leaving useless transpiled code
  * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
  */
 function noop (a, b, c) {}

 /**
  * Always return false.
  */
 var no = function (a, b, c) { return false; };

 /* eslint-enable no-unused-vars */

 /**
  * Return the same value.
  */
 var identity = function (_) { return _; };

 /**
  * Check if two values are loosely equal - that is,
  * if they are plain objects, do they have the same shape?
  */
 function looseEqual (a, b) {
   if (a === b) { return true }
   var isObjectA = isObject(a);
   var isObjectB = isObject(b);
   if (isObjectA && isObjectB) {
     try {
       var isArrayA = Array.isArray(a);
       var isArrayB = Array.isArray(b);
       if (isArrayA && isArrayB) {
         return a.length === b.length && a.every(function (e, i) {
           return looseEqual(e, b[i])
         })
       } else if (a instanceof Date && b instanceof Date) {
         return a.getTime() === b.getTime()
       } else if (!isArrayA && !isArrayB) {
         var keysA = Object.keys(a);
         var keysB = Object.keys(b);
         return keysA.length === keysB.length && keysA.every(function (key) {
           return looseEqual(a[key], b[key])
         })
       } else {
         /* istanbul ignore next */
         return false
       }
     } catch (e) {
       /* istanbul ignore next */
       return false
     }
   } else if (!isObjectA && !isObjectB) {
     return String(a) === String(b)
   } else {
     return false
   }
 }

 /**
  * Return the first index at which a loosely equal value can be
  * found in the array (if value is a plain object, the array must
  * contain an object of the same shape), or -1 if it is not present.
  */
 function looseIndexOf (arr, val) {
   for (var i = 0; i < arr.length; i++) {
     if (looseEqual(arr[i], val)) { return i }
   }
   return -1
 }

 /**
  * Ensure a function is called only once.
  */
 function once (fn) {
   var called = false;
   return function () {
     if (!called) {
       called = true;
       fn.apply(this, arguments);
     }
   }
 }

 var SSR_ATTR = 'data-server-rendered';

 var ASSET_TYPES = [
   'component',
   'directive',
   'filter'
 ];

 var LIFECYCLE_HOOKS = [
   'beforeCreate',
   'created',
   'beforeMount',
   'mounted',
   'beforeUpdate',
   'updated',
   'beforeDestroy',
   'destroyed',
   'activated',
   'deactivated',
   'errorCaptured',
   'serverPrefetch'
 ];

 /*  */



 var config = ({
   /**
    * Option merge strategies (used in core/util/options)
    */
   // $flow-disable-line
   optionMergeStrategies: Object.create(null),

   /**
    * Whether to suppress warnings.
    */
   silent: false,

   /**
    * Show production mode tip message on boot?
    */
   productionTip: "production" !== 'production',

   /**
    * Whether to enable devtools
    */
   devtools: "production" !== 'production',

   /**
    * Whether to record perf
    */
   performance: false,

   /**
    * Error handler for watcher errors
    */
   errorHandler: null,

   /**
    * Warn handler for watcher warns
    */
   warnHandler: null,

   /**
    * Ignore certain custom elements
    */
   ignoredElements: [],

   /**
    * Custom user key aliases for v-on
    */
   // $flow-disable-line
   keyCodes: Object.create(null),

   /**
    * Check if a tag is reserved so that it cannot be registered as a
    * component. This is platform-dependent and may be overwritten.
    */
   isReservedTag: no,

   /**
    * Check if an attribute is reserved so that it cannot be used as a component
    * prop. This is platform-dependent and may be overwritten.
    */
   isReservedAttr: no,

   /**
    * Check if a tag is an unknown element.
    * Platform-dependent.
    */
   isUnknownElement: no,

   /**
    * Get the namespace of an element
    */
   getTagNamespace: noop,

   /**
    * Parse the real tag name for the specific platform.
    */
   parsePlatformTagName: identity,

   /**
    * Check if an attribute must be bound using property, e.g. value
    * Platform-dependent.
    */
   mustUseProp: no,

   /**
    * Perform updates asynchronously. Intended to be used by Vue Test Utils
    * This will significantly reduce performance if set to false.
    */
   async: true,

   /**
    * Exposed for legacy reasons
    */
   _lifecycleHooks: LIFECYCLE_HOOKS
 });

 /*  */

 /**
  * unicode letters used for parsing html tags, component names and property paths.
  * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
  * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
  */
 var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

 /**
  * Check if a string starts with $ or _
  */
 function isReserved (str) {
   var c = (str + '').charCodeAt(0);
   return c === 0x24 || c === 0x5F
 }

 /**
  * Define a property.
  */
 function def (obj, key, val, enumerable) {
   Object.defineProperty(obj, key, {
     value: val,
     enumerable: !!enumerable,
     writable: true,
     configurable: true
   });
 }

 /**
  * Parse simple path.
  */
 var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
 function parsePath (path) {
   if (bailRE.test(path)) {
     return
   }
   var segments = path.split('.');
   return function (obj) {
     for (var i = 0; i < segments.length; i++) {
       if (!obj) { return }
       obj = obj[segments[i]];
     }
     return obj
   }
 }

 /*  */

 // can we use __proto__?
 var hasProto = '__proto__' in {};

 // Browser environment sniffing
 var inBrowser = typeof window !== 'undefined';
 var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
 var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
 var UA = inBrowser && window.navigator.userAgent.toLowerCase();
 var isIE = UA && /msie|trident/.test(UA);
 var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
 var isEdge = UA && UA.indexOf('edge/') > 0;
 var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
 var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
 var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
 var isPhantomJS = UA && /phantomjs/.test(UA);
 var isFF = UA && UA.match(/firefox\/(\d+)/);

 // Firefox has a "watch" function on Object.prototype...
 var nativeWatch = ({}).watch;

 var supportsPassive = false;
 if (inBrowser) {
   try {
     var opts = {};
     Object.defineProperty(opts, 'passive', ({
       get: function get () {
         /* istanbul ignore next */
         supportsPassive = true;
       }
     })); // https://github.com/facebook/flow/issues/285
     window.addEventListener('test-passive', null, opts);
   } catch (e) {}
 }

 // this needs to be lazy-evaled because vue may be required before
 // vue-server-renderer can set VUE_ENV
 var _isServer;
 var isServerRendering = function () {
   if (_isServer === undefined) {
     /* istanbul ignore if */
     if (!inBrowser && !inWeex && typeof global !== 'undefined') {
       // detect presence of vue-server-renderer and avoid
       // Webpack shimming the process
       _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
     } else {
       _isServer = false;
     }
   }
   return _isServer
 };

 // detect devtools
 var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

 /* istanbul ignore next */
 function isNative (Ctor) {
   return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
 }

 var hasSymbol =
   typeof Symbol !== 'undefined' && isNative(Symbol) &&
   typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

 var _Set;
 /* istanbul ignore if */ // $flow-disable-line
 if (typeof Set !== 'undefined' && isNative(Set)) {
   // use native Set when available.
   _Set = Set;
 } else {
   // a non-standard Set polyfill that only works with primitive keys.
   _Set = /*@__PURE__*/(function () {
     function Set () {
       this.set = Object.create(null);
     }
     Set.prototype.has = function has (key) {
       return this.set[key] === true
     };
     Set.prototype.add = function add (key) {
       this.set[key] = true;
     };
     Set.prototype.clear = function clear () {
       this.set = Object.create(null);
     };

     return Set;
   }());
 }

 /*  */

 var warn = noop;
 var tip = noop;
 var generateComponentTrace = (noop); // work around flow check
 var formatComponentName = (noop);

 if (false) { var repeat, classify, classifyRE, hasConsole; }

 /*  */

 var uid = 0;

 /**
  * A dep is an observable that can have multiple
  * directives subscribing to it.
  */
 var Dep = function Dep () {
   this.id = uid++;
   this.subs = [];
 };

 Dep.prototype.addSub = function addSub (sub) {
   this.subs.push(sub);
 };

 Dep.prototype.removeSub = function removeSub (sub) {
   remove(this.subs, sub);
 };

 Dep.prototype.depend = function depend () {
   if (Dep.target) {
     Dep.target.addDep(this);
   }
 };

 Dep.prototype.notify = function notify () {
   // stabilize the subscriber list first
   var subs = this.subs.slice();
   if (false) {}
   for (var i = 0, l = subs.length; i < l; i++) {
     subs[i].update();
   }
 };

 // The current target watcher being evaluated.
 // This is globally unique because only one watcher
 // can be evaluated at a time.
 Dep.target = null;
 var targetStack = [];

 function pushTarget (target) {
   targetStack.push(target);
   Dep.target = target;
 }

 function popTarget () {
   targetStack.pop();
   Dep.target = targetStack[targetStack.length - 1];
 }

 /*  */

 var VNode = function VNode (
   tag,
   data,
   children,
   text,
   elm,
   context,
   componentOptions,
   asyncFactory
 ) {
   this.tag = tag;
   this.data = data;
   this.children = children;
   this.text = text;
   this.elm = elm;
   this.ns = undefined;
   this.context = context;
   this.fnContext = undefined;
   this.fnOptions = undefined;
   this.fnScopeId = undefined;
   this.key = data && data.key;
   this.componentOptions = componentOptions;
   this.componentInstance = undefined;
   this.parent = undefined;
   this.raw = false;
   this.isStatic = false;
   this.isRootInsert = true;
   this.isComment = false;
   this.isCloned = false;
   this.isOnce = false;
   this.asyncFactory = asyncFactory;
   this.asyncMeta = undefined;
   this.isAsyncPlaceholder = false;
 };

 var prototypeAccessors = { child: { configurable: true } };

 // DEPRECATED: alias for componentInstance for backwards compat.
 /* istanbul ignore next */
 prototypeAccessors.child.get = function () {
   return this.componentInstance
 };

 Object.defineProperties( VNode.prototype, prototypeAccessors );

 var createEmptyVNode = function (text) {
   if ( text === void 0 ) text = '';

   var node = new VNode();
   node.text = text;
   node.isComment = true;
   return node
 };

 function createTextVNode (val) {
   return new VNode(undefined, undefined, undefined, String(val))
 }

 // optimized shallow clone
 // used for static nodes and slot nodes because they may be reused across
 // multiple renders, cloning them avoids errors when DOM manipulations rely
 // on their elm reference.
 function cloneVNode (vnode) {
   var cloned = new VNode(
     vnode.tag,
     vnode.data,
     // #7975
     // clone children array to avoid mutating original in case of cloning
     // a child.
     vnode.children && vnode.children.slice(),
     vnode.text,
     vnode.elm,
     vnode.context,
     vnode.componentOptions,
     vnode.asyncFactory
   );
   cloned.ns = vnode.ns;
   cloned.isStatic = vnode.isStatic;
   cloned.key = vnode.key;
   cloned.isComment = vnode.isComment;
   cloned.fnContext = vnode.fnContext;
   cloned.fnOptions = vnode.fnOptions;
   cloned.fnScopeId = vnode.fnScopeId;
   cloned.asyncMeta = vnode.asyncMeta;
   cloned.isCloned = true;
   return cloned
 }

 /*
  * not type checking this file because flow doesn't play well with
  * dynamically accessing methods on Array prototype
  */

 var arrayProto = Array.prototype;
 var arrayMethods = Object.create(arrayProto);

 var methodsToPatch = [
   'push',
   'pop',
   'shift',
   'unshift',
   'splice',
   'sort',
   'reverse'
 ];

 /**
  * Intercept mutating methods and emit events
  */
 methodsToPatch.forEach(function (method) {
   // cache original method
   var original = arrayProto[method];
   def(arrayMethods, method, function mutator () {
     var args = [], len = arguments.length;
     while ( len-- ) args[ len ] = arguments[ len ];

     var result = original.apply(this, args);
     var ob = this.__ob__;
     var inserted;
     switch (method) {
       case 'push':
       case 'unshift':
         inserted = args;
         break
       case 'splice':
         inserted = args.slice(2);
         break
     }
     if (inserted) { ob.observeArray(inserted); }
     // notify change
     ob.dep.notify();
     return result
   });
 });

 /*  */

 var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

 /**
  * In some cases we may want to disable observation inside a component's
  * update computation.
  */
 var shouldObserve = true;

 function toggleObserving (value) {
   shouldObserve = value;
 }

 /**
  * Observer class that is attached to each observed
  * object. Once attached, the observer converts the target
  * object's property keys into getter/setters that
  * collect dependencies and dispatch updates.
  */
 var Observer = function Observer (value) {
   this.value = value;
   this.dep = new Dep();
   this.vmCount = 0;
   def(value, '__ob__', this);
   if (Array.isArray(value)) {
     if (hasProto) {
       protoAugment(value, arrayMethods);
     } else {
       copyAugment(value, arrayMethods, arrayKeys);
     }
     this.observeArray(value);
   } else {
     this.walk(value);
   }
 };

 /**
  * Walk through all properties and convert them into
  * getter/setters. This method should only be called when
  * value type is Object.
  */
 Observer.prototype.walk = function walk (obj) {
   var keys = Object.keys(obj);
   for (var i = 0; i < keys.length; i++) {
     defineReactive$$1(obj, keys[i]);
   }
 };

 /**
  * Observe a list of Array items.
  */
 Observer.prototype.observeArray = function observeArray (items) {
   for (var i = 0, l = items.length; i < l; i++) {
     observe(items[i]);
   }
 };

 // helpers

 /**
  * Augment a target Object or Array by intercepting
  * the prototype chain using __proto__
  */
 function protoAugment (target, src) {
   /* eslint-disable no-proto */
   target.__proto__ = src;
   /* eslint-enable no-proto */
 }

 /**
  * Augment a target Object or Array by defining
  * hidden properties.
  */
 /* istanbul ignore next */
 function copyAugment (target, src, keys) {
   for (var i = 0, l = keys.length; i < l; i++) {
     var key = keys[i];
     def(target, key, src[key]);
   }
 }

 /**
  * Attempt to create an observer instance for a value,
  * returns the new observer if successfully observed,
  * or the existing observer if the value already has one.
  */
 function observe (value, asRootData) {
   if (!isObject(value) || value instanceof VNode) {
     return
   }
   var ob;
   if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
     ob = value.__ob__;
   } else if (
     shouldObserve &&
     !isServerRendering() &&
     (Array.isArray(value) || isPlainObject(value)) &&
     Object.isExtensible(value) &&
     !value._isVue
   ) {
     ob = new Observer(value);
   }
   if (asRootData && ob) {
     ob.vmCount++;
   }
   return ob
 }

 /**
  * Define a reactive property on an Object.
  */
 function defineReactive$$1 (
   obj,
   key,
   val,
   customSetter,
   shallow
 ) {
   var dep = new Dep();

   var property = Object.getOwnPropertyDescriptor(obj, key);
   if (property && property.configurable === false) {
     return
   }

   // cater for pre-defined getter/setters
   var getter = property && property.get;
   var setter = property && property.set;
   if ((!getter || setter) && arguments.length === 2) {
     val = obj[key];
   }

   var childOb = !shallow && observe(val);
   Object.defineProperty(obj, key, {
     enumerable: true,
     configurable: true,
     get: function reactiveGetter () {
       var value = getter ? getter.call(obj) : val;
       if (Dep.target) {
         dep.depend();
         if (childOb) {
           childOb.dep.depend();
           if (Array.isArray(value)) {
             dependArray(value);
           }
         }
       }
       return value
     },
     set: function reactiveSetter (newVal) {
       var value = getter ? getter.call(obj) : val;
       /* eslint-disable no-self-compare */
       if (newVal === value || (newVal !== newVal && value !== value)) {
         return
       }
       /* eslint-enable no-self-compare */
       if (false) {}
       // #7981: for accessor properties without setter
       if (getter && !setter) { return }
       if (setter) {
         setter.call(obj, newVal);
       } else {
         val = newVal;
       }
       childOb = !shallow && observe(newVal);
       dep.notify();
     }
   });
 }

 /**
  * Set a property on an object. Adds the new property and
  * triggers change notification if the property doesn't
  * already exist.
  */
 function set (target, key, val) {
   if (false
   ) {}
   if (Array.isArray(target) && isValidArrayIndex(key)) {
     target.length = Math.max(target.length, key);
     target.splice(key, 1, val);
     return val
   }
   if (key in target && !(key in Object.prototype)) {
     target[key] = val;
     return val
   }
   var ob = (target).__ob__;
   if (target._isVue || (ob && ob.vmCount)) {
     "production" !== 'production' && warn(
       'Avoid adding reactive properties to a Vue instance or its root $data ' +
       'at runtime - declare it upfront in the data option.'
     );
     return val
   }
   if (!ob) {
     target[key] = val;
     return val
   }
   defineReactive$$1(ob.value, key, val);
   ob.dep.notify();
   return val
 }

 /**
  * Delete a property and trigger change if necessary.
  */
 function del (target, key) {
   if (false
   ) {}
   if (Array.isArray(target) && isValidArrayIndex(key)) {
     target.splice(key, 1);
     return
   }
   var ob = (target).__ob__;
   if (target._isVue || (ob && ob.vmCount)) {
     "production" !== 'production' && warn(
       'Avoid deleting properties on a Vue instance or its root $data ' +
       '- just set it to null.'
     );
     return
   }
   if (!hasOwn(target, key)) {
     return
   }
   delete target[key];
   if (!ob) {
     return
   }
   ob.dep.notify();
 }

 /**
  * Collect dependencies on array elements when the array is touched, since
  * we cannot intercept array element access like property getters.
  */
 function dependArray (value) {
   for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
     e = value[i];
     e && e.__ob__ && e.__ob__.dep.depend();
     if (Array.isArray(e)) {
       dependArray(e);
     }
   }
 }

 /*  */

 /**
  * Option overwriting strategies are functions that handle
  * how to merge a parent option value and a child option
  * value into the final value.
  */
 var strats = config.optionMergeStrategies;

 /**
  * Options with restrictions
  */
 if (false) {}

 /**
  * Helper that recursively merges two data objects together.
  */
 function mergeData (to, from) {
   if (!from) { return to }
   var key, toVal, fromVal;

   var keys = hasSymbol
     ? Reflect.ownKeys(from)
     : Object.keys(from);

   for (var i = 0; i < keys.length; i++) {
     key = keys[i];
     // in case the object is already observed...
     if (key === '__ob__') { continue }
     toVal = to[key];
     fromVal = from[key];
     if (!hasOwn(to, key)) {
       set(to, key, fromVal);
     } else if (
       toVal !== fromVal &&
       isPlainObject(toVal) &&
       isPlainObject(fromVal)
     ) {
       mergeData(toVal, fromVal);
     }
   }
   return to
 }

 /**
  * Data
  */
 function mergeDataOrFn (
   parentVal,
   childVal,
   vm
 ) {
   if (!vm) {
     // in a Vue.extend merge, both should be functions
     if (!childVal) {
       return parentVal
     }
     if (!parentVal) {
       return childVal
     }
     // when parentVal & childVal are both present,
     // we need to return a function that returns the
     // merged result of both functions... no need to
     // check if parentVal is a function here because
     // it has to be a function to pass previous merges.
     return function mergedDataFn () {
       return mergeData(
         typeof childVal === 'function' ? childVal.call(this, this) : childVal,
         typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
       )
     }
   } else {
     return function mergedInstanceDataFn () {
       // instance merge
       var instanceData = typeof childVal === 'function'
         ? childVal.call(vm, vm)
         : childVal;
       var defaultData = typeof parentVal === 'function'
         ? parentVal.call(vm, vm)
         : parentVal;
       if (instanceData) {
         return mergeData(instanceData, defaultData)
       } else {
         return defaultData
       }
     }
   }
 }

 strats.data = function (
   parentVal,
   childVal,
   vm
 ) {
   if (!vm) {
     if (childVal && typeof childVal !== 'function') {
       "production" !== 'production' && warn(
         'The "data" option should be a function ' +
         'that returns a per-instance value in component ' +
         'definitions.',
         vm
       );

       return parentVal
     }
     return mergeDataOrFn(parentVal, childVal)
   }

   return mergeDataOrFn(parentVal, childVal, vm)
 };

 /**
  * Hooks and props are merged as arrays.
  */
 function mergeHook (
   parentVal,
   childVal
 ) {
   var res = childVal
     ? parentVal
       ? parentVal.concat(childVal)
       : Array.isArray(childVal)
         ? childVal
         : [childVal]
     : parentVal;
   return res
     ? dedupeHooks(res)
     : res
 }

 function dedupeHooks (hooks) {
   var res = [];
   for (var i = 0; i < hooks.length; i++) {
     if (res.indexOf(hooks[i]) === -1) {
       res.push(hooks[i]);
     }
   }
   return res
 }

 LIFECYCLE_HOOKS.forEach(function (hook) {
   strats[hook] = mergeHook;
 });

 /**
  * Assets
  *
  * When a vm is present (instance creation), we need to do
  * a three-way merge between constructor options, instance
  * options and parent options.
  */
 function mergeAssets (
   parentVal,
   childVal,
   vm,
   key
 ) {
   var res = Object.create(parentVal || null);
   if (childVal) {
     "production" !== 'production' && assertObjectType(key, childVal, vm);
     return extend(res, childVal)
   } else {
     return res
   }
 }

 ASSET_TYPES.forEach(function (type) {
   strats[type + 's'] = mergeAssets;
 });

 /**
  * Watchers.
  *
  * Watchers hashes should not overwrite one
  * another, so we merge them as arrays.
  */
 strats.watch = function (
   parentVal,
   childVal,
   vm,
   key
 ) {
   // work around Firefox's Object.prototype.watch...
   if (parentVal === nativeWatch) { parentVal = undefined; }
   if (childVal === nativeWatch) { childVal = undefined; }
   /* istanbul ignore if */
   if (!childVal) { return Object.create(parentVal || null) }
   if (false) {}
   if (!parentVal) { return childVal }
   var ret = {};
   extend(ret, parentVal);
   for (var key$1 in childVal) {
     var parent = ret[key$1];
     var child = childVal[key$1];
     if (parent && !Array.isArray(parent)) {
       parent = [parent];
     }
     ret[key$1] = parent
       ? parent.concat(child)
       : Array.isArray(child) ? child : [child];
   }
   return ret
 };

 /**
  * Other object hashes.
  */
 strats.props =
 strats.methods =
 strats.inject =
 strats.computed = function (
   parentVal,
   childVal,
   vm,
   key
 ) {
   if (childVal && "production" !== 'production') {
     assertObjectType(key, childVal, vm);
   }
   if (!parentVal) { return childVal }
   var ret = Object.create(null);
   extend(ret, parentVal);
   if (childVal) { extend(ret, childVal); }
   return ret
 };
 strats.provide = mergeDataOrFn;

 /**
  * Default strategy.
  */
 var defaultStrat = function (parentVal, childVal) {
   return childVal === undefined
     ? parentVal
     : childVal
 };

 /**
  * Validate component names
  */
 function checkComponents (options) {
   for (var key in options.components) {
     validateComponentName(key);
   }
 }

 function validateComponentName (name) {
   if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp.source) + "]*$")).test(name)) {
     warn(
       'Invalid component name: "' + name + '". Component names ' +
       'should conform to valid custom element name in html5 specification.'
     );
   }
   if (isBuiltInTag(name) || config.isReservedTag(name)) {
     warn(
       'Do not use built-in or reserved HTML elements as component ' +
       'id: ' + name
     );
   }
 }

 /**
  * Ensure all props option syntax are normalized into the
  * Object-based format.
  */
 function normalizeProps (options, vm) {
   var props = options.props;
   if (!props) { return }
   var res = {};
   var i, val, name;
   if (Array.isArray(props)) {
     i = props.length;
     while (i--) {
       val = props[i];
       if (typeof val === 'string') {
         name = camelize(val);
         res[name] = { type: null };
       } else if (false) {}
     }
   } else if (isPlainObject(props)) {
     for (var key in props) {
       val = props[key];
       name = camelize(key);
       res[name] = isPlainObject(val)
         ? val
         : { type: val };
     }
   } else if (false) {}
   options.props = res;
 }

 /**
  * Normalize all injections into Object-based format
  */
 function normalizeInject (options, vm) {
   var inject = options.inject;
   if (!inject) { return }
   var normalized = options.inject = {};
   if (Array.isArray(inject)) {
     for (var i = 0; i < inject.length; i++) {
       normalized[inject[i]] = { from: inject[i] };
     }
   } else if (isPlainObject(inject)) {
     for (var key in inject) {
       var val = inject[key];
       normalized[key] = isPlainObject(val)
         ? extend({ from: key }, val)
         : { from: val };
     }
   } else if (false) {}
 }

 /**
  * Normalize raw function directives into object format.
  */
 function normalizeDirectives (options) {
   var dirs = options.directives;
   if (dirs) {
     for (var key in dirs) {
       var def$$1 = dirs[key];
       if (typeof def$$1 === 'function') {
         dirs[key] = { bind: def$$1, update: def$$1 };
       }
     }
   }
 }

 function assertObjectType (name, value, vm) {
   if (!isPlainObject(value)) {
     warn(
       "Invalid value for option \"" + name + "\": expected an Object, " +
       "but got " + (toRawType(value)) + ".",
       vm
     );
   }
 }

 /**
  * Merge two option objects into a new one.
  * Core utility used in both instantiation and inheritance.
  */
 function mergeOptions (
   parent,
   child,
   vm
 ) {
   if (false) {}

   if (typeof child === 'function') {
     child = child.options;
   }

   normalizeProps(child, vm);
   normalizeInject(child, vm);
   normalizeDirectives(child);

   // Apply extends and mixins on the child options,
   // but only if it is a raw options object that isn't
   // the result of another mergeOptions call.
   // Only merged options has the _base property.
   if (!child._base) {
     if (child.extends) {
       parent = mergeOptions(parent, child.extends, vm);
     }
     if (child.mixins) {
       for (var i = 0, l = child.mixins.length; i < l; i++) {
         parent = mergeOptions(parent, child.mixins[i], vm);
       }
     }
   }

   var options = {};
   var key;
   for (key in parent) {
     mergeField(key);
   }
   for (key in child) {
     if (!hasOwn(parent, key)) {
       mergeField(key);
     }
   }
   function mergeField (key) {
     var strat = strats[key] || defaultStrat;
     options[key] = strat(parent[key], child[key], vm, key);
   }
   return options
 }

 /**
  * Resolve an asset.
  * This function is used because child instances need access
  * to assets defined in its ancestor chain.
  */
 function resolveAsset (
   options,
   type,
   id,
   warnMissing
 ) {
   /* istanbul ignore if */
   if (typeof id !== 'string') {
     return
   }
   var assets = options[type];
   // check local registration variations first
   if (hasOwn(assets, id)) { return assets[id] }
   var camelizedId = camelize(id);
   if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
   var PascalCaseId = capitalize(camelizedId);
   if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
   // fallback to prototype chain
   var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
   if (false) {}
   return res
 }

 /*  */



 function validateProp (
   key,
   propOptions,
   propsData,
   vm
 ) {
   var prop = propOptions[key];
   var absent = !hasOwn(propsData, key);
   var value = propsData[key];
   // boolean casting
   var booleanIndex = getTypeIndex(Boolean, prop.type);
   if (booleanIndex > -1) {
     if (absent && !hasOwn(prop, 'default')) {
       value = false;
     } else if (value === '' || value === hyphenate(key)) {
       // only cast empty string / same name to boolean if
       // boolean has higher priority
       var stringIndex = getTypeIndex(String, prop.type);
       if (stringIndex < 0 || booleanIndex < stringIndex) {
         value = true;
       }
     }
   }
   // check default value
   if (value === undefined) {
     value = getPropDefaultValue(vm, prop, key);
     // since the default value is a fresh copy,
     // make sure to observe it.
     var prevShouldObserve = shouldObserve;
     toggleObserving(true);
     observe(value);
     toggleObserving(prevShouldObserve);
   }
   if (
     false
   ) {}
   return value
 }

 /**
  * Get the default value of a prop.
  */
 function getPropDefaultValue (vm, prop, key) {
   // no default, return undefined
   if (!hasOwn(prop, 'default')) {
     return undefined
   }
   var def = prop.default;
   // warn against non-factory defaults for Object & Array
   if (false) {}
   // the raw prop value was also undefined from previous render,
   // return previous default value to avoid unnecessary watcher trigger
   if (vm && vm.$options.propsData &&
     vm.$options.propsData[key] === undefined &&
     vm._props[key] !== undefined
   ) {
     return vm._props[key]
   }
   // call factory function for non-Function types
   // a value is Function if its prototype is function even across different execution context
   return typeof def === 'function' && getType(prop.type) !== 'Function'
     ? def.call(vm)
     : def
 }

 /**
  * Assert whether a prop is valid.
  */
 function assertProp (
   prop,
   name,
   value,
   vm,
   absent
 ) {
   if (prop.required && absent) {
     warn(
       'Missing required prop: "' + name + '"',
       vm
     );
     return
   }
   if (value == null && !prop.required) {
     return
   }
   var type = prop.type;
   var valid = !type || type === true;
   var expectedTypes = [];
   if (type) {
     if (!Array.isArray(type)) {
       type = [type];
     }
     for (var i = 0; i < type.length && !valid; i++) {
       var assertedType = assertType(value, type[i], vm);
       expectedTypes.push(assertedType.expectedType || '');
       valid = assertedType.valid;
     }
   }

   var haveExpectedTypes = expectedTypes.some(function (t) { return t; });
   if (!valid && haveExpectedTypes) {
     warn(
       getInvalidTypeMessage(name, value, expectedTypes),
       vm
     );
     return
   }
   var validator = prop.validator;
   if (validator) {
     if (!validator(value)) {
       warn(
         'Invalid prop: custom validator check failed for prop "' + name + '".',
         vm
       );
     }
   }
 }

 var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol|BigInt)$/;

 function assertType (value, type, vm) {
   var valid;
   var expectedType = getType(type);
   if (simpleCheckRE.test(expectedType)) {
     var t = typeof value;
     valid = t === expectedType.toLowerCase();
     // for primitive wrapper objects
     if (!valid && t === 'object') {
       valid = value instanceof type;
     }
   } else if (expectedType === 'Object') {
     valid = isPlainObject(value);
   } else if (expectedType === 'Array') {
     valid = Array.isArray(value);
   } else {
     try {
       valid = value instanceof type;
     } catch (e) {
       warn('Invalid prop type: "' + String(type) + '" is not a constructor', vm);
       valid = false;
     }
   }
   return {
     valid: valid,
     expectedType: expectedType
   }
 }

 var functionTypeCheckRE = /^\s*function (\w+)/;

 /**
  * Use function string name to check built-in types,
  * because a simple equality check will fail when running
  * across different vms / iframes.
  */
 function getType (fn) {
   var match = fn && fn.toString().match(functionTypeCheckRE);
   return match ? match[1] : ''
 }

 function isSameType (a, b) {
   return getType(a) === getType(b)
 }

 function getTypeIndex (type, expectedTypes) {
   if (!Array.isArray(expectedTypes)) {
     return isSameType(expectedTypes, type) ? 0 : -1
   }
   for (var i = 0, len = expectedTypes.length; i < len; i++) {
     if (isSameType(expectedTypes[i], type)) {
       return i
     }
   }
   return -1
 }

 function getInvalidTypeMessage (name, value, expectedTypes) {
   var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
     " Expected " + (expectedTypes.map(capitalize).join(', '));
   var expectedType = expectedTypes[0];
   var receivedType = toRawType(value);
   // check if we need to specify expected value
   if (
     expectedTypes.length === 1 &&
     isExplicable(expectedType) &&
     isExplicable(typeof value) &&
     !isBoolean(expectedType, receivedType)
   ) {
     message += " with value " + (styleValue(value, expectedType));
   }
   message += ", got " + receivedType + " ";
   // check if we need to specify received value
   if (isExplicable(receivedType)) {
     message += "with value " + (styleValue(value, receivedType)) + ".";
   }
   return message
 }

 function styleValue (value, type) {
   if (type === 'String') {
     return ("\"" + value + "\"")
   } else if (type === 'Number') {
     return ("" + (Number(value)))
   } else {
     return ("" + value)
   }
 }

 var EXPLICABLE_TYPES = ['string', 'number', 'boolean'];
 function isExplicable (value) {
   return EXPLICABLE_TYPES.some(function (elem) { return value.toLowerCase() === elem; })
 }

 function isBoolean () {
   var args = [], len = arguments.length;
   while ( len-- ) args[ len ] = arguments[ len ];

   return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
 }

 /*  */

 function handleError (err, vm, info) {
   // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
   // See: https://github.com/vuejs/vuex/issues/1505
   pushTarget();
   try {
     if (vm) {
       var cur = vm;
       while ((cur = cur.$parent)) {
         var hooks = cur.$options.errorCaptured;
         if (hooks) {
           for (var i = 0; i < hooks.length; i++) {
             try {
               var capture = hooks[i].call(cur, err, vm, info) === false;
               if (capture) { return }
             } catch (e) {
               globalHandleError(e, cur, 'errorCaptured hook');
             }
           }
         }
       }
     }
     globalHandleError(err, vm, info);
   } finally {
     popTarget();
   }
 }

 function invokeWithErrorHandling (
   handler,
   context,
   args,
   vm,
   info
 ) {
   var res;
   try {
     res = args ? handler.apply(context, args) : handler.call(context);
     if (res && !res._isVue && isPromise(res) && !res._handled) {
       res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
       // issue #9511
       // avoid catch triggering multiple times when nested calls
       res._handled = true;
     }
   } catch (e) {
     handleError(e, vm, info);
   }
   return res
 }

 function globalHandleError (err, vm, info) {
   if (config.errorHandler) {
     try {
       return config.errorHandler.call(null, err, vm, info)
     } catch (e) {
       // if the user intentionally throws the original error in the handler,
       // do not log it twice
       if (e !== err) {
         logError(e, null, 'config.errorHandler');
       }
     }
   }
   logError(err, vm, info);
 }

 function logError (err, vm, info) {
   if (false) {}
   /* istanbul ignore else */
   if ((inBrowser || inWeex) && typeof console !== 'undefined') {
     console.error(err);
   } else {
     throw err
   }
 }

 /*  */

 var isUsingMicroTask = false;

 var callbacks = [];
 var pending = false;

 function flushCallbacks () {
   pending = false;
   var copies = callbacks.slice(0);
   callbacks.length = 0;
   for (var i = 0; i < copies.length; i++) {
     copies[i]();
   }
 }

 // Here we have async deferring wrappers using microtasks.
 // In 2.5 we used (macro) tasks (in combination with microtasks).
 // However, it has subtle problems when state is changed right before repaint
 // (e.g. #6813, out-in transitions).
 // Also, using (macro) tasks in event handler would cause some weird behaviors
 // that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
 // So we now use microtasks everywhere, again.
 // A major drawback of this tradeoff is that there are some scenarios
 // where microtasks have too high a priority and fire in between supposedly
 // sequential events (e.g. #4521, #6690, which have workarounds)
 // or even between bubbling of the same event (#6566).
 var timerFunc;

 // The nextTick behavior leverages the microtask queue, which can be accessed
 // via either native Promise.then or MutationObserver.
 // MutationObserver has wider support, however it is seriously bugged in
 // UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
 // completely stops working after triggering a few times... so, if native
 // Promise is available, we will use it:
 /* istanbul ignore next, $flow-disable-line */
 if (typeof Promise !== 'undefined' && isNative(Promise)) {
   var p = Promise.resolve();
   timerFunc = function () {
     p.then(flushCallbacks);
     // In problematic UIWebViews, Promise.then doesn't completely break, but
     // it can get stuck in a weird state where callbacks are pushed into the
     // microtask queue but the queue isn't being flushed, until the browser
     // needs to do some other work, e.g. handle a timer. Therefore we can
     // "force" the microtask queue to be flushed by adding an empty timer.
     if (isIOS) { setTimeout(noop); }
   };
   isUsingMicroTask = true;
 } else if (!isIE && typeof MutationObserver !== 'undefined' && (
   isNative(MutationObserver) ||
   // PhantomJS and iOS 7.x
   MutationObserver.toString() === '[object MutationObserverConstructor]'
 )) {
   // Use MutationObserver where native Promise is not available,
   // e.g. PhantomJS, iOS7, Android 4.4
   // (#6466 MutationObserver is unreliable in IE11)
   var counter = 1;
   var observer = new MutationObserver(flushCallbacks);
   var textNode = document.createTextNode(String(counter));
   observer.observe(textNode, {
     characterData: true
   });
   timerFunc = function () {
     counter = (counter + 1) % 2;
     textNode.data = String(counter);
   };
   isUsingMicroTask = true;
 } else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
   // Fallback to setImmediate.
   // Technically it leverages the (macro) task queue,
   // but it is still a better choice than setTimeout.
   timerFunc = function () {
     setImmediate(flushCallbacks);
   };
 } else {
   // Fallback to setTimeout.
   timerFunc = function () {
     setTimeout(flushCallbacks, 0);
   };
 }

 function nextTick (cb, ctx) {
   var _resolve;
   callbacks.push(function () {
     if (cb) {
       try {
         cb.call(ctx);
       } catch (e) {
         handleError(e, ctx, 'nextTick');
       }
     } else if (_resolve) {
       _resolve(ctx);
     }
   });
   if (!pending) {
     pending = true;
     timerFunc();
   }
   // $flow-disable-line
   if (!cb && typeof Promise !== 'undefined') {
     return new Promise(function (resolve) {
       _resolve = resolve;
     })
   }
 }

 /*  */

 /* not type checking this file because flow doesn't play well with Proxy */

 var initProxy;

 if (false) { var getHandler, hasHandler, isBuiltInModifier, hasProxy, warnReservedPrefix, warnNonPresent, allowedGlobals; }

 /*  */

 var seenObjects = new _Set();

 /**
  * Recursively traverse an object to evoke all converted
  * getters, so that every nested property inside the object
  * is collected as a "deep" dependency.
  */
 function traverse (val) {
   _traverse(val, seenObjects);
   seenObjects.clear();
 }

 function _traverse (val, seen) {
   var i, keys;
   var isA = Array.isArray(val);
   if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
     return
   }
   if (val.__ob__) {
     var depId = val.__ob__.dep.id;
     if (seen.has(depId)) {
       return
     }
     seen.add(depId);
   }
   if (isA) {
     i = val.length;
     while (i--) { _traverse(val[i], seen); }
   } else {
     keys = Object.keys(val);
     i = keys.length;
     while (i--) { _traverse(val[keys[i]], seen); }
   }
 }

 var mark;
 var measure;

 if (false) { var perf; }

 /*  */

 var normalizeEvent = cached(function (name) {
   var passive = name.charAt(0) === '&';
   name = passive ? name.slice(1) : name;
   var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
   name = once$$1 ? name.slice(1) : name;
   var capture = name.charAt(0) === '!';
   name = capture ? name.slice(1) : name;
   return {
     name: name,
     once: once$$1,
     capture: capture,
     passive: passive
   }
 });

 function createFnInvoker (fns, vm) {
   function invoker () {
     var arguments$1 = arguments;

     var fns = invoker.fns;
     if (Array.isArray(fns)) {
       var cloned = fns.slice();
       for (var i = 0; i < cloned.length; i++) {
         invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
       }
     } else {
       // return handler return value for single handlers
       return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
     }
   }
   invoker.fns = fns;
   return invoker
 }

 function updateListeners (
   on,
   oldOn,
   add,
   remove$$1,
   createOnceHandler,
   vm
 ) {
   var name, def$$1, cur, old, event;
   for (name in on) {
     def$$1 = cur = on[name];
     old = oldOn[name];
     event = normalizeEvent(name);
     if (isUndef(cur)) {
       "production" !== 'production' && warn(
         "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
         vm
       );
     } else if (isUndef(old)) {
       if (isUndef(cur.fns)) {
         cur = on[name] = createFnInvoker(cur, vm);
       }
       if (isTrue(event.once)) {
         cur = on[name] = createOnceHandler(event.name, cur, event.capture);
       }
       add(event.name, cur, event.capture, event.passive, event.params);
     } else if (cur !== old) {
       old.fns = cur;
       on[name] = old;
     }
   }
   for (name in oldOn) {
     if (isUndef(on[name])) {
       event = normalizeEvent(name);
       remove$$1(event.name, oldOn[name], event.capture);
     }
   }
 }

 /*  */

 function mergeVNodeHook (def, hookKey, hook) {
   if (def instanceof VNode) {
     def = def.data.hook || (def.data.hook = {});
   }
   var invoker;
   var oldHook = def[hookKey];

   function wrappedHook () {
     hook.apply(this, arguments);
     // important: remove merged hook to ensure it's called only once
     // and prevent memory leak
     remove(invoker.fns, wrappedHook);
   }

   if (isUndef(oldHook)) {
     // no existing hook
     invoker = createFnInvoker([wrappedHook]);
   } else {
     /* istanbul ignore if */
     if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
       // already a merged invoker
       invoker = oldHook;
       invoker.fns.push(wrappedHook);
     } else {
       // existing plain hook
       invoker = createFnInvoker([oldHook, wrappedHook]);
     }
   }

   invoker.merged = true;
   def[hookKey] = invoker;
 }

 /*  */

 function extractPropsFromVNodeData (
   data,
   Ctor,
   tag
 ) {
   // we are only extracting raw values here.
   // validation and default values are handled in the child
   // component itself.
   var propOptions = Ctor.options.props;
   if (isUndef(propOptions)) {
     return
   }
   var res = {};
   var attrs = data.attrs;
   var props = data.props;
   if (isDef(attrs) || isDef(props)) {
     for (var key in propOptions) {
       var altKey = hyphenate(key);
       if (false) { var keyInLowerCase; }
       checkProp(res, props, key, altKey, true) ||
       checkProp(res, attrs, key, altKey, false);
     }
   }
   return res
 }

 function checkProp (
   res,
   hash,
   key,
   altKey,
   preserve
 ) {
   if (isDef(hash)) {
     if (hasOwn(hash, key)) {
       res[key] = hash[key];
       if (!preserve) {
         delete hash[key];
       }
       return true
     } else if (hasOwn(hash, altKey)) {
       res[key] = hash[altKey];
       if (!preserve) {
         delete hash[altKey];
       }
       return true
     }
   }
   return false
 }

 /*  */

 // The template compiler attempts to minimize the need for normalization by
 // statically analyzing the template at compile time.
 //
 // For plain HTML markup, normalization can be completely skipped because the
 // generated render function is guaranteed to return Array<VNode>. There are
 // two cases where extra normalization is needed:

 // 1. When the children contains components - because a functional component
 // may return an Array instead of a single root. In this case, just a simple
 // normalization is needed - if any child is an Array, we flatten the whole
 // thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
 // because functional components already normalize their own children.
 function simpleNormalizeChildren (children) {
   for (var i = 0; i < children.length; i++) {
     if (Array.isArray(children[i])) {
       return Array.prototype.concat.apply([], children)
     }
   }
   return children
 }

 // 2. When the children contains constructs that always generated nested Arrays,
 // e.g. <template>, <slot>, v-for, or when the children is provided by user
 // with hand-written render functions / JSX. In such cases a full normalization
 // is needed to cater to all possible types of children values.
 function normalizeChildren (children) {
   return isPrimitive(children)
     ? [createTextVNode(children)]
     : Array.isArray(children)
       ? normalizeArrayChildren(children)
       : undefined
 }

 function isTextNode (node) {
   return isDef(node) && isDef(node.text) && isFalse(node.isComment)
 }

 function normalizeArrayChildren (children, nestedIndex) {
   var res = [];
   var i, c, lastIndex, last;
   for (i = 0; i < children.length; i++) {
     c = children[i];
     if (isUndef(c) || typeof c === 'boolean') { continue }
     lastIndex = res.length - 1;
     last = res[lastIndex];
     //  nested
     if (Array.isArray(c)) {
       if (c.length > 0) {
         c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
         // merge adjacent text nodes
         if (isTextNode(c[0]) && isTextNode(last)) {
           res[lastIndex] = createTextVNode(last.text + (c[0]).text);
           c.shift();
         }
         res.push.apply(res, c);
       }
     } else if (isPrimitive(c)) {
       if (isTextNode(last)) {
         // merge adjacent text nodes
         // this is necessary for SSR hydration because text nodes are
         // essentially merged when rendered to HTML strings
         res[lastIndex] = createTextVNode(last.text + c);
       } else if (c !== '') {
         // convert primitive to vnode
         res.push(createTextVNode(c));
       }
     } else {
       if (isTextNode(c) && isTextNode(last)) {
         // merge adjacent text nodes
         res[lastIndex] = createTextVNode(last.text + c.text);
       } else {
         // default key for nested array children (likely generated by v-for)
         if (isTrue(children._isVList) &&
           isDef(c.tag) &&
           isUndef(c.key) &&
           isDef(nestedIndex)) {
           c.key = "__vlist" + nestedIndex + "_" + i + "__";
         }
         res.push(c);
       }
     }
   }
   return res
 }

 /*  */

 function initProvide (vm) {
   var provide = vm.$options.provide;
   if (provide) {
     vm._provided = typeof provide === 'function'
       ? provide.call(vm)
       : provide;
   }
 }

 function initInjections (vm) {
   var result = resolveInject(vm.$options.inject, vm);
   if (result) {
     toggleObserving(false);
     Object.keys(result).forEach(function (key) {
       /* istanbul ignore else */
       if (false) {} else {
         defineReactive$$1(vm, key, result[key]);
       }
     });
     toggleObserving(true);
   }
 }

 function resolveInject (inject, vm) {
   if (inject) {
     // inject is :any because flow is not smart enough to figure out cached
     var result = Object.create(null);
     var keys = hasSymbol
       ? Reflect.ownKeys(inject)
       : Object.keys(inject);

     for (var i = 0; i < keys.length; i++) {
       var key = keys[i];
       // #6574 in case the inject object is observed...
       if (key === '__ob__') { continue }
       var provideKey = inject[key].from;
       var source = vm;
       while (source) {
         if (source._provided && hasOwn(source._provided, provideKey)) {
           result[key] = source._provided[provideKey];
           break
         }
         source = source.$parent;
       }
       if (!source) {
         if ('default' in inject[key]) {
           var provideDefault = inject[key].default;
           result[key] = typeof provideDefault === 'function'
             ? provideDefault.call(vm)
             : provideDefault;
         } else if (false) {}
       }
     }
     return result
   }
 }

 /*  */



 /**
  * Runtime helper for resolving raw children VNodes into a slot object.
  */
 function resolveSlots (
   children,
   context
 ) {
   if (!children || !children.length) {
     return {}
   }
   var slots = {};
   for (var i = 0, l = children.length; i < l; i++) {
     var child = children[i];
     var data = child.data;
     // remove slot attribute if the node is resolved as a Vue slot node
     if (data && data.attrs && data.attrs.slot) {
       delete data.attrs.slot;
     }
     // named slots should only be respected if the vnode was rendered in the
     // same context.
     if ((child.context === context || child.fnContext === context) &&
       data && data.slot != null
     ) {
       var name = data.slot;
       var slot = (slots[name] || (slots[name] = []));
       if (child.tag === 'template') {
         slot.push.apply(slot, child.children || []);
       } else {
         slot.push(child);
       }
     } else {
       (slots.default || (slots.default = [])).push(child);
     }
   }
   // ignore slots that contains only whitespace
   for (var name$1 in slots) {
     if (slots[name$1].every(isWhitespace)) {
       delete slots[name$1];
     }
   }
   return slots
 }

 function isWhitespace (node) {
   return (node.isComment && !node.asyncFactory) || node.text === ' '
 }

 /*  */

 function isAsyncPlaceholder (node) {
   return node.isComment && node.asyncFactory
 }

 /*  */

 function normalizeScopedSlots (
   slots,
   normalSlots,
   prevSlots
 ) {
   var res;
   var hasNormalSlots = Object.keys(normalSlots).length > 0;
   var isStable = slots ? !!slots.$stable : !hasNormalSlots;
   var key = slots && slots.$key;
   if (!slots) {
     res = {};
   } else if (slots._normalized) {
     // fast path 1: child component re-render only, parent did not change
     return slots._normalized
   } else if (
     isStable &&
     prevSlots &&
     prevSlots !== emptyObject &&
     key === prevSlots.$key &&
     !hasNormalSlots &&
     !prevSlots.$hasNormal
   ) {
     // fast path 2: stable scoped slots w/ no normal slots to proxy,
     // only need to normalize once
     return prevSlots
   } else {
     res = {};
     for (var key$1 in slots) {
       if (slots[key$1] && key$1[0] !== '$') {
         res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
       }
     }
   }
   // expose normal slots on scopedSlots
   for (var key$2 in normalSlots) {
     if (!(key$2 in res)) {
       res[key$2] = proxyNormalSlot(normalSlots, key$2);
     }
   }
   // avoriaz seems to mock a non-extensible $scopedSlots object
   // and when that is passed down this would cause an error
   if (slots && Object.isExtensible(slots)) {
     (slots)._normalized = res;
   }
   def(res, '$stable', isStable);
   def(res, '$key', key);
   def(res, '$hasNormal', hasNormalSlots);
   return res
 }

 function normalizeScopedSlot(normalSlots, key, fn) {
   var normalized = function () {
     var res = arguments.length ? fn.apply(null, arguments) : fn({});
     res = res && typeof res === 'object' && !Array.isArray(res)
       ? [res] // single vnode
       : normalizeChildren(res);
     var vnode = res && res[0];
     return res && (
       !vnode ||
       (res.length === 1 && vnode.isComment && !isAsyncPlaceholder(vnode)) // #9658, #10391
     ) ? undefined
       : res
   };
   // this is a slot using the new v-slot syntax without scope. although it is
   // compiled as a scoped slot, render fn users would expect it to be present
   // on this.$slots because the usage is semantically a normal slot.
   if (fn.proxy) {
     Object.defineProperty(normalSlots, key, {
       get: normalized,
       enumerable: true,
       configurable: true
     });
   }
   return normalized
 }

 function proxyNormalSlot(slots, key) {
   return function () { return slots[key]; }
 }

 /*  */

 /**
  * Runtime helper for rendering v-for lists.
  */
 function renderList (
   val,
   render
 ) {
   var ret, i, l, keys, key;
   if (Array.isArray(val) || typeof val === 'string') {
     ret = new Array(val.length);
     for (i = 0, l = val.length; i < l; i++) {
       ret[i] = render(val[i], i);
     }
   } else if (typeof val === 'number') {
     ret = new Array(val);
     for (i = 0; i < val; i++) {
       ret[i] = render(i + 1, i);
     }
   } else if (isObject(val)) {
     if (hasSymbol && val[Symbol.iterator]) {
       ret = [];
       var iterator = val[Symbol.iterator]();
       var result = iterator.next();
       while (!result.done) {
         ret.push(render(result.value, ret.length));
         result = iterator.next();
       }
     } else {
       keys = Object.keys(val);
       ret = new Array(keys.length);
       for (i = 0, l = keys.length; i < l; i++) {
         key = keys[i];
         ret[i] = render(val[key], key, i);
       }
     }
   }
   if (!isDef(ret)) {
     ret = [];
   }
   (ret)._isVList = true;
   return ret
 }

 /*  */

 /**
  * Runtime helper for rendering <slot>
  */
 function renderSlot (
   name,
   fallbackRender,
   props,
   bindObject
 ) {
   var scopedSlotFn = this.$scopedSlots[name];
   var nodes;
   if (scopedSlotFn) {
     // scoped slot
     props = props || {};
     if (bindObject) {
       if (false) {}
       props = extend(extend({}, bindObject), props);
     }
     nodes =
       scopedSlotFn(props) ||
       (typeof fallbackRender === 'function' ? fallbackRender() : fallbackRender);
   } else {
     nodes =
       this.$slots[name] ||
       (typeof fallbackRender === 'function' ? fallbackRender() : fallbackRender);
   }

   var target = props && props.slot;
   if (target) {
     return this.$createElement('template', { slot: target }, nodes)
   } else {
     return nodes
   }
 }

 /*  */

 /**
  * Runtime helper for resolving filters
  */
 function resolveFilter (id) {
   return resolveAsset(this.$options, 'filters', id, true) || identity
 }

 /*  */

 function isKeyNotMatch (expect, actual) {
   if (Array.isArray(expect)) {
     return expect.indexOf(actual) === -1
   } else {
     return expect !== actual
   }
 }

 /**
  * Runtime helper for checking keyCodes from config.
  * exposed as Vue.prototype._k
  * passing in eventKeyName as last argument separately for backwards compat
  */
 function checkKeyCodes (
   eventKeyCode,
   key,
   builtInKeyCode,
   eventKeyName,
   builtInKeyName
 ) {
   var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
   if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
     return isKeyNotMatch(builtInKeyName, eventKeyName)
   } else if (mappedKeyCode) {
     return isKeyNotMatch(mappedKeyCode, eventKeyCode)
   } else if (eventKeyName) {
     return hyphenate(eventKeyName) !== key
   }
   return eventKeyCode === undefined
 }

 /*  */

 /**
  * Runtime helper for merging v-bind="object" into a VNode's data.
  */
 function bindObjectProps (
   data,
   tag,
   value,
   asProp,
   isSync
 ) {
   if (value) {
     if (!isObject(value)) {
       "production" !== 'production' && warn(
         'v-bind without argument expects an Object or Array value',
         this
       );
     } else {
       if (Array.isArray(value)) {
         value = toObject(value);
       }
       var hash;
       var loop = function ( key ) {
         if (
           key === 'class' ||
           key === 'style' ||
           isReservedAttribute(key)
         ) {
           hash = data;
         } else {
           var type = data.attrs && data.attrs.type;
           hash = asProp || config.mustUseProp(tag, type, key)
             ? data.domProps || (data.domProps = {})
             : data.attrs || (data.attrs = {});
         }
         var camelizedKey = camelize(key);
         var hyphenatedKey = hyphenate(key);
         if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
           hash[key] = value[key];

           if (isSync) {
             var on = data.on || (data.on = {});
             on[("update:" + key)] = function ($event) {
               value[key] = $event;
             };
           }
         }
       };

       for (var key in value) loop( key );
     }
   }
   return data
 }

 /*  */

 /**
  * Runtime helper for rendering static trees.
  */
 function renderStatic (
   index,
   isInFor
 ) {
   var cached = this._staticTrees || (this._staticTrees = []);
   var tree = cached[index];
   // if has already-rendered static tree and not inside v-for,
   // we can reuse the same tree.
   if (tree && !isInFor) {
     return tree
   }
   // otherwise, render a fresh tree.
   tree = cached[index] = this.$options.staticRenderFns[index].call(
     this._renderProxy,
     null,
     this // for render fns generated for functional component templates
   );
   markStatic(tree, ("__static__" + index), false);
   return tree
 }

 /**
  * Runtime helper for v-once.
  * Effectively it means marking the node as static with a unique key.
  */
 function markOnce (
   tree,
   index,
   key
 ) {
   markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
   return tree
 }

 function markStatic (
   tree,
   key,
   isOnce
 ) {
   if (Array.isArray(tree)) {
     for (var i = 0; i < tree.length; i++) {
       if (tree[i] && typeof tree[i] !== 'string') {
         markStaticNode(tree[i], (key + "_" + i), isOnce);
       }
     }
   } else {
     markStaticNode(tree, key, isOnce);
   }
 }

 function markStaticNode (node, key, isOnce) {
   node.isStatic = true;
   node.key = key;
   node.isOnce = isOnce;
 }

 /*  */

 function bindObjectListeners (data, value) {
   if (value) {
     if (!isPlainObject(value)) {
       "production" !== 'production' && warn(
         'v-on without argument expects an Object value',
         this
       );
     } else {
       var on = data.on = data.on ? extend({}, data.on) : {};
       for (var key in value) {
         var existing = on[key];
         var ours = value[key];
         on[key] = existing ? [].concat(existing, ours) : ours;
       }
     }
   }
   return data
 }

 /*  */

 function resolveScopedSlots (
   fns, // see flow/vnode
   res,
   // the following are added in 2.6
   hasDynamicKeys,
   contentHashKey
 ) {
   res = res || { $stable: !hasDynamicKeys };
   for (var i = 0; i < fns.length; i++) {
     var slot = fns[i];
     if (Array.isArray(slot)) {
       resolveScopedSlots(slot, res, hasDynamicKeys);
     } else if (slot) {
       // marker for reverse proxying v-slot without scope on this.$slots
       if (slot.proxy) {
         slot.fn.proxy = true;
       }
       res[slot.key] = slot.fn;
     }
   }
   if (contentHashKey) {
     (res).$key = contentHashKey;
   }
   return res
 }

 /*  */

 function bindDynamicKeys (baseObj, values) {
   for (var i = 0; i < values.length; i += 2) {
     var key = values[i];
     if (typeof key === 'string' && key) {
       baseObj[values[i]] = values[i + 1];
     } else if (false) {}
   }
   return baseObj
 }

 // helper to dynamically append modifier runtime markers to event names.
 // ensure only append when value is already string, otherwise it will be cast
 // to string and cause the type check to miss.
 function prependModifier (value, symbol) {
   return typeof value === 'string' ? symbol + value : value
 }

 /*  */

 function installRenderHelpers (target) {
   target._o = markOnce;
   target._n = toNumber;
   target._s = toString;
   target._l = renderList;
   target._t = renderSlot;
   target._q = looseEqual;
   target._i = looseIndexOf;
   target._m = renderStatic;
   target._f = resolveFilter;
   target._k = checkKeyCodes;
   target._b = bindObjectProps;
   target._v = createTextVNode;
   target._e = createEmptyVNode;
   target._u = resolveScopedSlots;
   target._g = bindObjectListeners;
   target._d = bindDynamicKeys;
   target._p = prependModifier;
 }

 /*  */

 function FunctionalRenderContext (
   data,
   props,
   children,
   parent,
   Ctor
 ) {
   var this$1 = this;

   var options = Ctor.options;
   // ensure the createElement function in functional components
   // gets a unique context - this is necessary for correct named slot check
   var contextVm;
   if (hasOwn(parent, '_uid')) {
     contextVm = Object.create(parent);
     // $flow-disable-line
     contextVm._original = parent;
   } else {
     // the context vm passed in is a functional context as well.
     // in this case we want to make sure we are able to get a hold to the
     // real context instance.
     contextVm = parent;
     // $flow-disable-line
     parent = parent._original;
   }
   var isCompiled = isTrue(options._compiled);
   var needNormalization = !isCompiled;

   this.data = data;
   this.props = props;
   this.children = children;
   this.parent = parent;
   this.listeners = data.on || emptyObject;
   this.injections = resolveInject(options.inject, parent);
   this.slots = function () {
     if (!this$1.$slots) {
       normalizeScopedSlots(
         data.scopedSlots,
         this$1.$slots = resolveSlots(children, parent)
       );
     }
     return this$1.$slots
   };

   Object.defineProperty(this, 'scopedSlots', ({
     enumerable: true,
     get: function get () {
       return normalizeScopedSlots(data.scopedSlots, this.slots())
     }
   }));

   // support for compiled functional template
   if (isCompiled) {
     // exposing $options for renderStatic()
     this.$options = options;
     // pre-resolve slots for renderSlot()
     this.$slots = this.slots();
     this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
   }

   if (options._scopeId) {
     this._c = function (a, b, c, d) {
       var vnode = createElement(contextVm, a, b, c, d, needNormalization);
       if (vnode && !Array.isArray(vnode)) {
         vnode.fnScopeId = options._scopeId;
         vnode.fnContext = parent;
       }
       return vnode
     };
   } else {
     this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
   }
 }

 installRenderHelpers(FunctionalRenderContext.prototype);

 function createFunctionalComponent (
   Ctor,
   propsData,
   data,
   contextVm,
   children
 ) {
   var options = Ctor.options;
   var props = {};
   var propOptions = options.props;
   if (isDef(propOptions)) {
     for (var key in propOptions) {
       props[key] = validateProp(key, propOptions, propsData || emptyObject);
     }
   } else {
     if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
     if (isDef(data.props)) { mergeProps(props, data.props); }
   }

   var renderContext = new FunctionalRenderContext(
     data,
     props,
     children,
     contextVm,
     Ctor
   );

   var vnode = options.render.call(null, renderContext._c, renderContext);

   if (vnode instanceof VNode) {
     return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
   } else if (Array.isArray(vnode)) {
     var vnodes = normalizeChildren(vnode) || [];
     var res = new Array(vnodes.length);
     for (var i = 0; i < vnodes.length; i++) {
       res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
     }
     return res
   }
 }

 function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
   // #7817 clone node before setting fnContext, otherwise if the node is reused
   // (e.g. it was from a cached normal slot) the fnContext causes named slots
   // that should not be matched to match.
   var clone = cloneVNode(vnode);
   clone.fnContext = contextVm;
   clone.fnOptions = options;
   if (false) {}
   if (data.slot) {
     (clone.data || (clone.data = {})).slot = data.slot;
   }
   return clone
 }

 function mergeProps (to, from) {
   for (var key in from) {
     to[camelize(key)] = from[key];
   }
 }

 /*  */

 /*  */

 /*  */

 /*  */

 // inline hooks to be invoked on component VNodes during patch
 var componentVNodeHooks = {
   init: function init (vnode, hydrating) {
     if (
       vnode.componentInstance &&
       !vnode.componentInstance._isDestroyed &&
       vnode.data.keepAlive
     ) {
       // kept-alive components, treat as a patch
       var mountedNode = vnode; // work around flow
       componentVNodeHooks.prepatch(mountedNode, mountedNode);
     } else {
       var child = vnode.componentInstance = createComponentInstanceForVnode(
         vnode,
         activeInstance
       );
       child.$mount(hydrating ? vnode.elm : undefined, hydrating);
     }
   },

   prepatch: function prepatch (oldVnode, vnode) {
     var options = vnode.componentOptions;
     var child = vnode.componentInstance = oldVnode.componentInstance;
     updateChildComponent(
       child,
       options.propsData, // updated props
       options.listeners, // updated listeners
       vnode, // new parent vnode
       options.children // new children
     );
   },

   insert: function insert (vnode) {
     var context = vnode.context;
     var componentInstance = vnode.componentInstance;
     if (!componentInstance._isMounted) {
       componentInstance._isMounted = true;
       callHook(componentInstance, 'mounted');
     }
     if (vnode.data.keepAlive) {
       if (context._isMounted) {
         // vue-router#1212
         // During updates, a kept-alive component's child components may
         // change, so directly walking the tree here may call activated hooks
         // on incorrect children. Instead we push them into a queue which will
         // be processed after the whole patch process ended.
         queueActivatedComponent(componentInstance);
       } else {
         activateChildComponent(componentInstance, true /* direct */);
       }
     }
   },

   destroy: function destroy (vnode) {
     var componentInstance = vnode.componentInstance;
     if (!componentInstance._isDestroyed) {
       if (!vnode.data.keepAlive) {
         componentInstance.$destroy();
       } else {
         deactivateChildComponent(componentInstance, true /* direct */);
       }
     }
   }
 };

 var hooksToMerge = Object.keys(componentVNodeHooks);

 function createComponent (
   Ctor,
   data,
   context,
   children,
   tag
 ) {
   if (isUndef(Ctor)) {
     return
   }

   var baseCtor = context.$options._base;

   // plain options object: turn it into a constructor
   if (isObject(Ctor)) {
     Ctor = baseCtor.extend(Ctor);
   }

   // if at this stage it's not a constructor or an async component factory,
   // reject.
   if (typeof Ctor !== 'function') {
     if (false) {}
     return
   }

   // async component
   var asyncFactory;
   if (isUndef(Ctor.cid)) {
     asyncFactory = Ctor;
     Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
     if (Ctor === undefined) {
       // return a placeholder node for async component, which is rendered
       // as a comment node but preserves all the raw information for the node.
       // the information will be used for async server-rendering and hydration.
       return createAsyncPlaceholder(
         asyncFactory,
         data,
         context,
         children,
         tag
       )
     }
   }

   data = data || {};

   // resolve constructor options in case global mixins are applied after
   // component constructor creation
   resolveConstructorOptions(Ctor);

   // transform component v-model data into props & events
   if (isDef(data.model)) {
     transformModel(Ctor.options, data);
   }

   // extract props
   var propsData = extractPropsFromVNodeData(data, Ctor, tag);

   // functional component
   if (isTrue(Ctor.options.functional)) {
     return createFunctionalComponent(Ctor, propsData, data, context, children)
   }

   // extract listeners, since these needs to be treated as
   // child component listeners instead of DOM listeners
   var listeners = data.on;
   // replace with listeners with .native modifier
   // so it gets processed during parent component patch.
   data.on = data.nativeOn;

   if (isTrue(Ctor.options.abstract)) {
     // abstract components do not keep anything
     // other than props & listeners & slot

     // work around flow
     var slot = data.slot;
     data = {};
     if (slot) {
       data.slot = slot;
     }
   }

   // install component management hooks onto the placeholder node
   installComponentHooks(data);

   // return a placeholder vnode
   var name = Ctor.options.name || tag;
   var vnode = new VNode(
     ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
     data, undefined, undefined, undefined, context,
     { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
     asyncFactory
   );

   return vnode
 }

 function createComponentInstanceForVnode (
   // we know it's MountedComponentVNode but flow doesn't
   vnode,
   // activeInstance in lifecycle state
   parent
 ) {
   var options = {
     _isComponent: true,
     _parentVnode: vnode,
     parent: parent
   };
   // check inline-template render functions
   var inlineTemplate = vnode.data.inlineTemplate;
   if (isDef(inlineTemplate)) {
     options.render = inlineTemplate.render;
     options.staticRenderFns = inlineTemplate.staticRenderFns;
   }
   return new vnode.componentOptions.Ctor(options)
 }

 function installComponentHooks (data) {
   var hooks = data.hook || (data.hook = {});
   for (var i = 0; i < hooksToMerge.length; i++) {
     var key = hooksToMerge[i];
     var existing = hooks[key];
     var toMerge = componentVNodeHooks[key];
     if (existing !== toMerge && !(existing && existing._merged)) {
       hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
     }
   }
 }

 function mergeHook$1 (f1, f2) {
   var merged = function (a, b) {
     // flow complains about extra args which is why we use any
     f1(a, b);
     f2(a, b);
   };
   merged._merged = true;
   return merged
 }

 // transform component v-model info (value and callback) into
 // prop and event handler respectively.
 function transformModel (options, data) {
   var prop = (options.model && options.model.prop) || 'value';
   var event = (options.model && options.model.event) || 'input'
   ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
   var on = data.on || (data.on = {});
   var existing = on[event];
   var callback = data.model.callback;
   if (isDef(existing)) {
     if (
       Array.isArray(existing)
         ? existing.indexOf(callback) === -1
         : existing !== callback
     ) {
       on[event] = [callback].concat(existing);
     }
   } else {
     on[event] = callback;
   }
 }

 /*  */

 var SIMPLE_NORMALIZE = 1;
 var ALWAYS_NORMALIZE = 2;

 // wrapper function for providing a more flexible interface
 // without getting yelled at by flow
 function createElement (
   context,
   tag,
   data,
   children,
   normalizationType,
   alwaysNormalize
 ) {
   if (Array.isArray(data) || isPrimitive(data)) {
     normalizationType = children;
     children = data;
     data = undefined;
   }
   if (isTrue(alwaysNormalize)) {
     normalizationType = ALWAYS_NORMALIZE;
   }
   return _createElement(context, tag, data, children, normalizationType)
 }

 function _createElement (
   context,
   tag,
   data,
   children,
   normalizationType
 ) {
   if (isDef(data) && isDef((data).__ob__)) {
     "production" !== 'production' && warn(
       "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
       'Always create fresh vnode data objects in each render!',
       context
     );
     return createEmptyVNode()
   }
   // object syntax in v-bind
   if (isDef(data) && isDef(data.is)) {
     tag = data.is;
   }
   if (!tag) {
     // in case of component :is set to falsy value
     return createEmptyVNode()
   }
   // warn against non-primitive key
   if (false
   ) {}
   // support single function children as default scoped slot
   if (Array.isArray(children) &&
     typeof children[0] === 'function'
   ) {
     data = data || {};
     data.scopedSlots = { default: children[0] };
     children.length = 0;
   }
   if (normalizationType === ALWAYS_NORMALIZE) {
     children = normalizeChildren(children);
   } else if (normalizationType === SIMPLE_NORMALIZE) {
     children = simpleNormalizeChildren(children);
   }
   var vnode, ns;
   if (typeof tag === 'string') {
     var Ctor;
     ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
     if (config.isReservedTag(tag)) {
       // platform built-in elements
       if (false) {}
       vnode = new VNode(
         config.parsePlatformTagName(tag), data, children,
         undefined, undefined, context
       );
     } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
       // component
       vnode = createComponent(Ctor, data, context, children, tag);
     } else {
       // unknown or unlisted namespaced elements
       // check at runtime because it may get assigned a namespace when its
       // parent normalizes children
       vnode = new VNode(
         tag, data, children,
         undefined, undefined, context
       );
     }
   } else {
     // direct component options / constructor
     vnode = createComponent(tag, data, context, children);
   }
   if (Array.isArray(vnode)) {
     return vnode
   } else if (isDef(vnode)) {
     if (isDef(ns)) { applyNS(vnode, ns); }
     if (isDef(data)) { registerDeepBindings(data); }
     return vnode
   } else {
     return createEmptyVNode()
   }
 }

 function applyNS (vnode, ns, force) {
   vnode.ns = ns;
   if (vnode.tag === 'foreignObject') {
     // use default namespace inside foreignObject
     ns = undefined;
     force = true;
   }
   if (isDef(vnode.children)) {
     for (var i = 0, l = vnode.children.length; i < l; i++) {
       var child = vnode.children[i];
       if (isDef(child.tag) && (
         isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
         applyNS(child, ns, force);
       }
     }
   }
 }

 // ref #5318
 // necessary to ensure parent re-render when deep bindings like :style and
 // :class are used on slot nodes
 function registerDeepBindings (data) {
   if (isObject(data.style)) {
     traverse(data.style);
   }
   if (isObject(data.class)) {
     traverse(data.class);
   }
 }

 /*  */

 function initRender (vm) {
   vm._vnode = null; // the root of the child tree
   vm._staticTrees = null; // v-once cached trees
   var options = vm.$options;
   var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
   var renderContext = parentVnode && parentVnode.context;
   vm.$slots = resolveSlots(options._renderChildren, renderContext);
   vm.$scopedSlots = emptyObject;
   // bind the createElement fn to this instance
   // so that we get proper render context inside it.
   // args order: tag, data, children, normalizationType, alwaysNormalize
   // internal version is used by render functions compiled from templates
   vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
   // normalization is always applied for the public version, used in
   // user-written render functions.
   vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

   // $attrs & $listeners are exposed for easier HOC creation.
   // they need to be reactive so that HOCs using them are always updated
   var parentData = parentVnode && parentVnode.data;

   /* istanbul ignore else */
   if (false) {} else {
     defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
     defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, null, true);
   }
 }

 var currentRenderingInstance = null;

 function renderMixin (Vue) {
   // install runtime convenience helpers
   installRenderHelpers(Vue.prototype);

   Vue.prototype.$nextTick = function (fn) {
     return nextTick(fn, this)
   };

   Vue.prototype._render = function () {
     var vm = this;
     var ref = vm.$options;
     var render = ref.render;
     var _parentVnode = ref._parentVnode;

     if (_parentVnode) {
       vm.$scopedSlots = normalizeScopedSlots(
         _parentVnode.data.scopedSlots,
         vm.$slots,
         vm.$scopedSlots
       );
     }

     // set parent vnode. this allows render functions to have access
     // to the data on the placeholder node.
     vm.$vnode = _parentVnode;
     // render self
     var vnode;
     try {
       // There's no need to maintain a stack because all render fns are called
       // separately from one another. Nested component's render fns are called
       // when parent component is patched.
       currentRenderingInstance = vm;
       vnode = render.call(vm._renderProxy, vm.$createElement);
     } catch (e) {
       handleError(e, vm, "render");
       // return error render result,
       // or previous vnode to prevent render error causing blank component
       /* istanbul ignore else */
       if (false) {} else {
         vnode = vm._vnode;
       }
     } finally {
       currentRenderingInstance = null;
     }
     // if the returned array contains only a single node, allow it
     if (Array.isArray(vnode) && vnode.length === 1) {
       vnode = vnode[0];
     }
     // return empty vnode in case the render function errored out
     if (!(vnode instanceof VNode)) {
       if (false) {}
       vnode = createEmptyVNode();
     }
     // set parent
     vnode.parent = _parentVnode;
     return vnode
   };
 }

 /*  */

 function ensureCtor (comp, base) {
   if (
     comp.__esModule ||
     (hasSymbol && comp[Symbol.toStringTag] === 'Module')
   ) {
     comp = comp.default;
   }
   return isObject(comp)
     ? base.extend(comp)
     : comp
 }

 function createAsyncPlaceholder (
   factory,
   data,
   context,
   children,
   tag
 ) {
   var node = createEmptyVNode();
   node.asyncFactory = factory;
   node.asyncMeta = { data: data, context: context, children: children, tag: tag };
   return node
 }

 function resolveAsyncComponent (
   factory,
   baseCtor
 ) {
   if (isTrue(factory.error) && isDef(factory.errorComp)) {
     return factory.errorComp
   }

   if (isDef(factory.resolved)) {
     return factory.resolved
   }

   var owner = currentRenderingInstance;
   if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
     // already pending
     factory.owners.push(owner);
   }

   if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
     return factory.loadingComp
   }

   if (owner && !isDef(factory.owners)) {
     var owners = factory.owners = [owner];
     var sync = true;
     var timerLoading = null;
     var timerTimeout = null

     ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

     var forceRender = function (renderCompleted) {
       for (var i = 0, l = owners.length; i < l; i++) {
         (owners[i]).$forceUpdate();
       }

       if (renderCompleted) {
         owners.length = 0;
         if (timerLoading !== null) {
           clearTimeout(timerLoading);
           timerLoading = null;
         }
         if (timerTimeout !== null) {
           clearTimeout(timerTimeout);
           timerTimeout = null;
         }
       }
     };

     var resolve = once(function (res) {
       // cache resolved
       factory.resolved = ensureCtor(res, baseCtor);
       // invoke callbacks only if this is not a synchronous resolve
       // (async resolves are shimmed as synchronous during SSR)
       if (!sync) {
         forceRender(true);
       } else {
         owners.length = 0;
       }
     });

     var reject = once(function (reason) {
       "production" !== 'production' && warn(
         "Failed to resolve async component: " + (String(factory)) +
         (reason ? ("\nReason: " + reason) : '')
       );
       if (isDef(factory.errorComp)) {
         factory.error = true;
         forceRender(true);
       }
     });

     var res = factory(resolve, reject);

     if (isObject(res)) {
       if (isPromise(res)) {
         // () => Promise
         if (isUndef(factory.resolved)) {
           res.then(resolve, reject);
         }
       } else if (isPromise(res.component)) {
         res.component.then(resolve, reject);

         if (isDef(res.error)) {
           factory.errorComp = ensureCtor(res.error, baseCtor);
         }

         if (isDef(res.loading)) {
           factory.loadingComp = ensureCtor(res.loading, baseCtor);
           if (res.delay === 0) {
             factory.loading = true;
           } else {
             timerLoading = setTimeout(function () {
               timerLoading = null;
               if (isUndef(factory.resolved) && isUndef(factory.error)) {
                 factory.loading = true;
                 forceRender(false);
               }
             }, res.delay || 200);
           }
         }

         if (isDef(res.timeout)) {
           timerTimeout = setTimeout(function () {
             timerTimeout = null;
             if (isUndef(factory.resolved)) {
               reject(
                  false
                   ? (undefined)
                   : null
               );
             }
           }, res.timeout);
         }
       }
     }

     sync = false;
     // return in case resolved synchronously
     return factory.loading
       ? factory.loadingComp
       : factory.resolved
   }
 }

 /*  */

 function getFirstComponentChild (children) {
   if (Array.isArray(children)) {
     for (var i = 0; i < children.length; i++) {
       var c = children[i];
       if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
         return c
       }
     }
   }
 }

 /*  */

 /*  */

 function initEvents (vm) {
   vm._events = Object.create(null);
   vm._hasHookEvent = false;
   // init parent attached events
   var listeners = vm.$options._parentListeners;
   if (listeners) {
     updateComponentListeners(vm, listeners);
   }
 }

 var target;

 function add (event, fn) {
   target.$on(event, fn);
 }

 function remove$1 (event, fn) {
   target.$off(event, fn);
 }

 function createOnceHandler (event, fn) {
   var _target = target;
   return function onceHandler () {
     var res = fn.apply(null, arguments);
     if (res !== null) {
       _target.$off(event, onceHandler);
     }
   }
 }

 function updateComponentListeners (
   vm,
   listeners,
   oldListeners
 ) {
   target = vm;
   updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
   target = undefined;
 }

 function eventsMixin (Vue) {
   var hookRE = /^hook:/;
   Vue.prototype.$on = function (event, fn) {
     var vm = this;
     if (Array.isArray(event)) {
       for (var i = 0, l = event.length; i < l; i++) {
         vm.$on(event[i], fn);
       }
     } else {
       (vm._events[event] || (vm._events[event] = [])).push(fn);
       // optimize hook:event cost by using a boolean flag marked at registration
       // instead of a hash lookup
       if (hookRE.test(event)) {
         vm._hasHookEvent = true;
       }
     }
     return vm
   };

   Vue.prototype.$once = function (event, fn) {
     var vm = this;
     function on () {
       vm.$off(event, on);
       fn.apply(vm, arguments);
     }
     on.fn = fn;
     vm.$on(event, on);
     return vm
   };

   Vue.prototype.$off = function (event, fn) {
     var vm = this;
     // all
     if (!arguments.length) {
       vm._events = Object.create(null);
       return vm
     }
     // array of events
     if (Array.isArray(event)) {
       for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
         vm.$off(event[i$1], fn);
       }
       return vm
     }
     // specific event
     var cbs = vm._events[event];
     if (!cbs) {
       return vm
     }
     if (!fn) {
       vm._events[event] = null;
       return vm
     }
     // specific handler
     var cb;
     var i = cbs.length;
     while (i--) {
       cb = cbs[i];
       if (cb === fn || cb.fn === fn) {
         cbs.splice(i, 1);
         break
       }
     }
     return vm
   };

   Vue.prototype.$emit = function (event) {
     var vm = this;
     if (false) { var lowerCaseEvent; }
     var cbs = vm._events[event];
     if (cbs) {
       cbs = cbs.length > 1 ? toArray(cbs) : cbs;
       var args = toArray(arguments, 1);
       var info = "event handler for \"" + event + "\"";
       for (var i = 0, l = cbs.length; i < l; i++) {
         invokeWithErrorHandling(cbs[i], vm, args, vm, info);
       }
     }
     return vm
   };
 }

 /*  */

 var activeInstance = null;
 var isUpdatingChildComponent = false;

 function setActiveInstance(vm) {
   var prevActiveInstance = activeInstance;
   activeInstance = vm;
   return function () {
     activeInstance = prevActiveInstance;
   }
 }

 function initLifecycle (vm) {
   var options = vm.$options;

   // locate first non-abstract parent
   var parent = options.parent;
   if (parent && !options.abstract) {
     while (parent.$options.abstract && parent.$parent) {
       parent = parent.$parent;
     }
     parent.$children.push(vm);
   }

   vm.$parent = parent;
   vm.$root = parent ? parent.$root : vm;

   vm.$children = [];
   vm.$refs = {};

   vm._watcher = null;
   vm._inactive = null;
   vm._directInactive = false;
   vm._isMounted = false;
   vm._isDestroyed = false;
   vm._isBeingDestroyed = false;
 }

 function lifecycleMixin (Vue) {
   Vue.prototype._update = function (vnode, hydrating) {
     var vm = this;
     var prevEl = vm.$el;
     var prevVnode = vm._vnode;
     var restoreActiveInstance = setActiveInstance(vm);
     vm._vnode = vnode;
     // Vue.prototype.__patch__ is injected in entry points
     // based on the rendering backend used.
     if (!prevVnode) {
       // initial render
       vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
     } else {
       // updates
       vm.$el = vm.__patch__(prevVnode, vnode);
     }
     restoreActiveInstance();
     // update __vue__ reference
     if (prevEl) {
       prevEl.__vue__ = null;
     }
     if (vm.$el) {
       vm.$el.__vue__ = vm;
     }
     // if parent is an HOC, update its $el as well
     if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
       vm.$parent.$el = vm.$el;
     }
     // updated hook is called by the scheduler to ensure that children are
     // updated in a parent's updated hook.
   };

   Vue.prototype.$forceUpdate = function () {
     var vm = this;
     if (vm._watcher) {
       vm._watcher.update();
     }
   };

   Vue.prototype.$destroy = function () {
     var vm = this;
     if (vm._isBeingDestroyed) {
       return
     }
     callHook(vm, 'beforeDestroy');
     vm._isBeingDestroyed = true;
     // remove self from parent
     var parent = vm.$parent;
     if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
       remove(parent.$children, vm);
     }
     // teardown watchers
     if (vm._watcher) {
       vm._watcher.teardown();
     }
     var i = vm._watchers.length;
     while (i--) {
       vm._watchers[i].teardown();
     }
     // remove reference from data ob
     // frozen object may not have observer.
     if (vm._data.__ob__) {
       vm._data.__ob__.vmCount--;
     }
     // call the last hook...
     vm._isDestroyed = true;
     // invoke destroy hooks on current rendered tree
     vm.__patch__(vm._vnode, null);
     // fire destroyed hook
     callHook(vm, 'destroyed');
     // turn off all instance listeners.
     vm.$off();
     // remove __vue__ reference
     if (vm.$el) {
       vm.$el.__vue__ = null;
     }
     // release circular reference (#6759)
     if (vm.$vnode) {
       vm.$vnode.parent = null;
     }
   };
 }

 function mountComponent (
   vm,
   el,
   hydrating
 ) {
   vm.$el = el;
   if (!vm.$options.render) {
     vm.$options.render = createEmptyVNode;
     if (false) {}
   }
   callHook(vm, 'beforeMount');

   var updateComponent;
   /* istanbul ignore if */
   if (false) {} else {
     updateComponent = function () {
       vm._update(vm._render(), hydrating);
     };
   }

   // we set this to vm._watcher inside the watcher's constructor
   // since the watcher's initial patch may call $forceUpdate (e.g. inside child
   // component's mounted hook), which relies on vm._watcher being already defined
   new Watcher(vm, updateComponent, noop, {
     before: function before () {
       if (vm._isMounted && !vm._isDestroyed) {
         callHook(vm, 'beforeUpdate');
       }
     }
   }, true /* isRenderWatcher */);
   hydrating = false;

   // manually mounted instance, call mounted on self
   // mounted is called for render-created child components in its inserted hook
   if (vm.$vnode == null) {
     vm._isMounted = true;
     callHook(vm, 'mounted');
   }
   return vm
 }

 function updateChildComponent (
   vm,
   propsData,
   listeners,
   parentVnode,
   renderChildren
 ) {
   if (false) {}

   // determine whether component has slot children
   // we need to do this before overwriting $options._renderChildren.

   // check if there are dynamic scopedSlots (hand-written or compiled but with
   // dynamic slot names). Static scoped slots compiled from template has the
   // "$stable" marker.
   var newScopedSlots = parentVnode.data.scopedSlots;
   var oldScopedSlots = vm.$scopedSlots;
   var hasDynamicScopedSlot = !!(
     (newScopedSlots && !newScopedSlots.$stable) ||
     (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
     (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key) ||
     (!newScopedSlots && vm.$scopedSlots.$key)
   );

   // Any static slot children from the parent may have changed during parent's
   // update. Dynamic scoped slots may also have changed. In such cases, a forced
   // update is necessary to ensure correctness.
   var needsForceUpdate = !!(
     renderChildren ||               // has new static slots
     vm.$options._renderChildren ||  // has old static slots
     hasDynamicScopedSlot
   );

   vm.$options._parentVnode = parentVnode;
   vm.$vnode = parentVnode; // update vm's placeholder node without re-render

   if (vm._vnode) { // update child tree's parent
     vm._vnode.parent = parentVnode;
   }
   vm.$options._renderChildren = renderChildren;

   // update $attrs and $listeners hash
   // these are also reactive so they may trigger child update if the child
   // used them during render
   vm.$attrs = parentVnode.data.attrs || emptyObject;
   vm.$listeners = listeners || emptyObject;

   // update props
   if (propsData && vm.$options.props) {
     toggleObserving(false);
     var props = vm._props;
     var propKeys = vm.$options._propKeys || [];
     for (var i = 0; i < propKeys.length; i++) {
       var key = propKeys[i];
       var propOptions = vm.$options.props; // wtf flow?
       props[key] = validateProp(key, propOptions, propsData, vm);
     }
     toggleObserving(true);
     // keep a copy of raw propsData
     vm.$options.propsData = propsData;
   }

   // update listeners
   listeners = listeners || emptyObject;
   var oldListeners = vm.$options._parentListeners;
   vm.$options._parentListeners = listeners;
   updateComponentListeners(vm, listeners, oldListeners);

   // resolve slots + force update if has children
   if (needsForceUpdate) {
     vm.$slots = resolveSlots(renderChildren, parentVnode.context);
     vm.$forceUpdate();
   }

   if (false) {}
 }

 function isInInactiveTree (vm) {
   while (vm && (vm = vm.$parent)) {
     if (vm._inactive) { return true }
   }
   return false
 }

 function activateChildComponent (vm, direct) {
   if (direct) {
     vm._directInactive = false;
     if (isInInactiveTree(vm)) {
       return
     }
   } else if (vm._directInactive) {
     return
   }
   if (vm._inactive || vm._inactive === null) {
     vm._inactive = false;
     for (var i = 0; i < vm.$children.length; i++) {
       activateChildComponent(vm.$children[i]);
     }
     callHook(vm, 'activated');
   }
 }

 function deactivateChildComponent (vm, direct) {
   if (direct) {
     vm._directInactive = true;
     if (isInInactiveTree(vm)) {
       return
     }
   }
   if (!vm._inactive) {
     vm._inactive = true;
     for (var i = 0; i < vm.$children.length; i++) {
       deactivateChildComponent(vm.$children[i]);
     }
     callHook(vm, 'deactivated');
   }
 }

 function callHook (vm, hook) {
   // #7573 disable dep collection when invoking lifecycle hooks
   pushTarget();
   var handlers = vm.$options[hook];
   var info = hook + " hook";
   if (handlers) {
     for (var i = 0, j = handlers.length; i < j; i++) {
       invokeWithErrorHandling(handlers[i], vm, null, vm, info);
     }
   }
   if (vm._hasHookEvent) {
     vm.$emit('hook:' + hook);
   }
   popTarget();
 }

 /*  */

 var MAX_UPDATE_COUNT = 100;

 var queue = [];
 var activatedChildren = [];
 var has = {};
 var circular = {};
 var waiting = false;
 var flushing = false;
 var index = 0;

 /**
  * Reset the scheduler's state.
  */
 function resetSchedulerState () {
   index = queue.length = activatedChildren.length = 0;
   has = {};
   if (false) {}
   waiting = flushing = false;
 }

 // Async edge case #6566 requires saving the timestamp when event listeners are
 // attached. However, calling performance.now() has a perf overhead especially
 // if the page has thousands of event listeners. Instead, we take a timestamp
 // every time the scheduler flushes and use that for all event listeners
 // attached during that flush.
 var currentFlushTimestamp = 0;

 // Async edge case fix requires storing an event listener's attach timestamp.
 var getNow = Date.now;

 // Determine what event timestamp the browser is using. Annoyingly, the
 // timestamp can either be hi-res (relative to page load) or low-res
 // (relative to UNIX epoch), so in order to compare time we have to use the
 // same timestamp type when saving the flush timestamp.
 // All IE versions use low-res event timestamps, and have problematic clock
 // implementations (#9632)
 if (inBrowser && !isIE) {
   var performance = window.performance;
   if (
     performance &&
     typeof performance.now === 'function' &&
     getNow() > document.createEvent('Event').timeStamp
   ) {
     // if the event timestamp, although evaluated AFTER the Date.now(), is
     // smaller than it, it means the event is using a hi-res timestamp,
     // and we need to use the hi-res version for event listener timestamps as
     // well.
     getNow = function () { return performance.now(); };
   }
 }

 /**
  * Flush both queues and run the watchers.
  */
 function flushSchedulerQueue () {
   currentFlushTimestamp = getNow();
   flushing = true;
   var watcher, id;

   // Sort queue before flush.
   // This ensures that:
   // 1. Components are updated from parent to child. (because parent is always
   //    created before the child)
   // 2. A component's user watchers are run before its render watcher (because
   //    user watchers are created before the render watcher)
   // 3. If a component is destroyed during a parent component's watcher run,
   //    its watchers can be skipped.
   queue.sort(function (a, b) { return a.id - b.id; });

   // do not cache length because more watchers might be pushed
   // as we run existing watchers
   for (index = 0; index < queue.length; index++) {
     watcher = queue[index];
     if (watcher.before) {
       watcher.before();
     }
     id = watcher.id;
     has[id] = null;
     watcher.run();
     // in dev build, check and stop circular updates.
     if (false) {}
   }

   // keep copies of post queues before resetting state
   var activatedQueue = activatedChildren.slice();
   var updatedQueue = queue.slice();

   resetSchedulerState();

   // call component updated and activated hooks
   callActivatedHooks(activatedQueue);
   callUpdatedHooks(updatedQueue);

   // devtool hook
   /* istanbul ignore if */
   if (devtools && config.devtools) {
     devtools.emit('flush');
   }
 }

 function callUpdatedHooks (queue) {
   var i = queue.length;
   while (i--) {
     var watcher = queue[i];
     var vm = watcher.vm;
     if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
       callHook(vm, 'updated');
     }
   }
 }

 /**
  * Queue a kept-alive component that was activated during patch.
  * The queue will be processed after the entire tree has been patched.
  */
 function queueActivatedComponent (vm) {
   // setting _inactive to false here so that a render function can
   // rely on checking whether it's in an inactive tree (e.g. router-view)
   vm._inactive = false;
   activatedChildren.push(vm);
 }

 function callActivatedHooks (queue) {
   for (var i = 0; i < queue.length; i++) {
     queue[i]._inactive = true;
     activateChildComponent(queue[i], true /* true */);
   }
 }

 /**
  * Push a watcher into the watcher queue.
  * Jobs with duplicate IDs will be skipped unless it's
  * pushed when the queue is being flushed.
  */
 function queueWatcher (watcher) {
   var id = watcher.id;
   if (has[id] == null) {
     has[id] = true;
     if (!flushing) {
       queue.push(watcher);
     } else {
       // if already flushing, splice the watcher based on its id
       // if already past its id, it will be run next immediately.
       var i = queue.length - 1;
       while (i > index && queue[i].id > watcher.id) {
         i--;
       }
       queue.splice(i + 1, 0, watcher);
     }
     // queue the flush
     if (!waiting) {
       waiting = true;

       if (false) {}
       nextTick(flushSchedulerQueue);
     }
   }
 }

 /*  */



 var uid$2 = 0;

 /**
  * A watcher parses an expression, collects dependencies,
  * and fires callback when the expression value changes.
  * This is used for both the $watch() api and directives.
  */
 var Watcher = function Watcher (
   vm,
   expOrFn,
   cb,
   options,
   isRenderWatcher
 ) {
   this.vm = vm;
   if (isRenderWatcher) {
     vm._watcher = this;
   }
   vm._watchers.push(this);
   // options
   if (options) {
     this.deep = !!options.deep;
     this.user = !!options.user;
     this.lazy = !!options.lazy;
     this.sync = !!options.sync;
     this.before = options.before;
   } else {
     this.deep = this.user = this.lazy = this.sync = false;
   }
   this.cb = cb;
   this.id = ++uid$2; // uid for batching
   this.active = true;
   this.dirty = this.lazy; // for lazy watchers
   this.deps = [];
   this.newDeps = [];
   this.depIds = new _Set();
   this.newDepIds = new _Set();
   this.expression =  false
     ? undefined
     : '';
   // parse expression for getter
   if (typeof expOrFn === 'function') {
     this.getter = expOrFn;
   } else {
     this.getter = parsePath(expOrFn);
     if (!this.getter) {
       this.getter = noop;
       "production" !== 'production' && warn(
         "Failed watching path: \"" + expOrFn + "\" " +
         'Watcher only accepts simple dot-delimited paths. ' +
         'For full control, use a function instead.',
         vm
       );
     }
   }
   this.value = this.lazy
     ? undefined
     : this.get();
 };

 /**
  * Evaluate the getter, and re-collect dependencies.
  */
 Watcher.prototype.get = function get () {
   pushTarget(this);
   var value;
   var vm = this.vm;
   try {
     value = this.getter.call(vm, vm);
   } catch (e) {
     if (this.user) {
       handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
     } else {
       throw e
     }
   } finally {
     // "touch" every property so they are all tracked as
     // dependencies for deep watching
     if (this.deep) {
       traverse(value);
     }
     popTarget();
     this.cleanupDeps();
   }
   return value
 };

 /**
  * Add a dependency to this directive.
  */
 Watcher.prototype.addDep = function addDep (dep) {
   var id = dep.id;
   if (!this.newDepIds.has(id)) {
     this.newDepIds.add(id);
     this.newDeps.push(dep);
     if (!this.depIds.has(id)) {
       dep.addSub(this);
     }
   }
 };

 /**
  * Clean up for dependency collection.
  */
 Watcher.prototype.cleanupDeps = function cleanupDeps () {
   var i = this.deps.length;
   while (i--) {
     var dep = this.deps[i];
     if (!this.newDepIds.has(dep.id)) {
       dep.removeSub(this);
     }
   }
   var tmp = this.depIds;
   this.depIds = this.newDepIds;
   this.newDepIds = tmp;
   this.newDepIds.clear();
   tmp = this.deps;
   this.deps = this.newDeps;
   this.newDeps = tmp;
   this.newDeps.length = 0;
 };

 /**
  * Subscriber interface.
  * Will be called when a dependency changes.
  */
 Watcher.prototype.update = function update () {
   /* istanbul ignore else */
   if (this.lazy) {
     this.dirty = true;
   } else if (this.sync) {
     this.run();
   } else {
     queueWatcher(this);
   }
 };

 /**
  * Scheduler job interface.
  * Will be called by the scheduler.
  */
 Watcher.prototype.run = function run () {
   if (this.active) {
     var value = this.get();
     if (
       value !== this.value ||
       // Deep watchers and watchers on Object/Arrays should fire even
       // when the value is the same, because the value may
       // have mutated.
       isObject(value) ||
       this.deep
     ) {
       // set new value
       var oldValue = this.value;
       this.value = value;
       if (this.user) {
         var info = "callback for watcher \"" + (this.expression) + "\"";
         invokeWithErrorHandling(this.cb, this.vm, [value, oldValue], this.vm, info);
       } else {
         this.cb.call(this.vm, value, oldValue);
       }
     }
   }
 };

 /**
  * Evaluate the value of the watcher.
  * This only gets called for lazy watchers.
  */
 Watcher.prototype.evaluate = function evaluate () {
   this.value = this.get();
   this.dirty = false;
 };

 /**
  * Depend on all deps collected by this watcher.
  */
 Watcher.prototype.depend = function depend () {
   var i = this.deps.length;
   while (i--) {
     this.deps[i].depend();
   }
 };

 /**
  * Remove self from all dependencies' subscriber list.
  */
 Watcher.prototype.teardown = function teardown () {
   if (this.active) {
     // remove self from vm's watcher list
     // this is a somewhat expensive operation so we skip it
     // if the vm is being destroyed.
     if (!this.vm._isBeingDestroyed) {
       remove(this.vm._watchers, this);
     }
     var i = this.deps.length;
     while (i--) {
       this.deps[i].removeSub(this);
     }
     this.active = false;
   }
 };

 /*  */

 var sharedPropertyDefinition = {
   enumerable: true,
   configurable: true,
   get: noop,
   set: noop
 };

 function proxy (target, sourceKey, key) {
   sharedPropertyDefinition.get = function proxyGetter () {
     return this[sourceKey][key]
   };
   sharedPropertyDefinition.set = function proxySetter (val) {
     this[sourceKey][key] = val;
   };
   Object.defineProperty(target, key, sharedPropertyDefinition);
 }

 function initState (vm) {
   vm._watchers = [];
   var opts = vm.$options;
   if (opts.props) { initProps(vm, opts.props); }
   if (opts.methods) { initMethods(vm, opts.methods); }
   if (opts.data) {
     initData(vm);
   } else {
     observe(vm._data = {}, true /* asRootData */);
   }
   if (opts.computed) { initComputed(vm, opts.computed); }
   if (opts.watch && opts.watch !== nativeWatch) {
     initWatch(vm, opts.watch);
   }
 }

 function initProps (vm, propsOptions) {
   var propsData = vm.$options.propsData || {};
   var props = vm._props = {};
   // cache prop keys so that future props updates can iterate using Array
   // instead of dynamic object key enumeration.
   var keys = vm.$options._propKeys = [];
   var isRoot = !vm.$parent;
   // root instance props should be converted
   if (!isRoot) {
     toggleObserving(false);
   }
   var loop = function ( key ) {
     keys.push(key);
     var value = validateProp(key, propsOptions, propsData, vm);
     /* istanbul ignore else */
     if (false) { var hyphenatedKey; } else {
       defineReactive$$1(props, key, value);
     }
     // static props are already proxied on the component's prototype
     // during Vue.extend(). We only need to proxy props defined at
     // instantiation here.
     if (!(key in vm)) {
       proxy(vm, "_props", key);
     }
   };

   for (var key in propsOptions) loop( key );
   toggleObserving(true);
 }

 function initData (vm) {
   var data = vm.$options.data;
   data = vm._data = typeof data === 'function'
     ? getData(data, vm)
     : data || {};
   if (!isPlainObject(data)) {
     data = {};
     "production" !== 'production' && warn(
       'data functions should return an object:\n' +
       'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
       vm
     );
   }
   // proxy data on instance
   var keys = Object.keys(data);
   var props = vm.$options.props;
   var methods = vm.$options.methods;
   var i = keys.length;
   while (i--) {
     var key = keys[i];
     if (false) {}
     if (props && hasOwn(props, key)) {
       "production" !== 'production' && warn(
         "The data property \"" + key + "\" is already declared as a prop. " +
         "Use prop default value instead.",
         vm
       );
     } else if (!isReserved(key)) {
       proxy(vm, "_data", key);
     }
   }
   // observe data
   observe(data, true /* asRootData */);
 }

 function getData (data, vm) {
   // #7573 disable dep collection when invoking data getters
   pushTarget();
   try {
     return data.call(vm, vm)
   } catch (e) {
     handleError(e, vm, "data()");
     return {}
   } finally {
     popTarget();
   }
 }

 var computedWatcherOptions = { lazy: true };

 function initComputed (vm, computed) {
   // $flow-disable-line
   var watchers = vm._computedWatchers = Object.create(null);
   // computed properties are just getters during SSR
   var isSSR = isServerRendering();

   for (var key in computed) {
     var userDef = computed[key];
     var getter = typeof userDef === 'function' ? userDef : userDef.get;
     if (false) {}

     if (!isSSR) {
       // create internal watcher for the computed property.
       watchers[key] = new Watcher(
         vm,
         getter || noop,
         noop,
         computedWatcherOptions
       );
     }

     // component-defined computed properties are already defined on the
     // component prototype. We only need to define computed properties defined
     // at instantiation here.
     if (!(key in vm)) {
       defineComputed(vm, key, userDef);
     } else if (false) {}
   }
 }

 function defineComputed (
   target,
   key,
   userDef
 ) {
   var shouldCache = !isServerRendering();
   if (typeof userDef === 'function') {
     sharedPropertyDefinition.get = shouldCache
       ? createComputedGetter(key)
       : createGetterInvoker(userDef);
     sharedPropertyDefinition.set = noop;
   } else {
     sharedPropertyDefinition.get = userDef.get
       ? shouldCache && userDef.cache !== false
         ? createComputedGetter(key)
         : createGetterInvoker(userDef.get)
       : noop;
     sharedPropertyDefinition.set = userDef.set || noop;
   }
   if (false) {}
   Object.defineProperty(target, key, sharedPropertyDefinition);
 }

 function createComputedGetter (key) {
   return function computedGetter () {
     var watcher = this._computedWatchers && this._computedWatchers[key];
     if (watcher) {
       if (watcher.dirty) {
         watcher.evaluate();
       }
       if (Dep.target) {
         watcher.depend();
       }
       return watcher.value
     }
   }
 }

 function createGetterInvoker(fn) {
   return function computedGetter () {
     return fn.call(this, this)
   }
 }

 function initMethods (vm, methods) {
   var props = vm.$options.props;
   for (var key in methods) {
     if (false) {}
     vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
   }
 }

 function initWatch (vm, watch) {
   for (var key in watch) {
     var handler = watch[key];
     if (Array.isArray(handler)) {
       for (var i = 0; i < handler.length; i++) {
         createWatcher(vm, key, handler[i]);
       }
     } else {
       createWatcher(vm, key, handler);
     }
   }
 }

 function createWatcher (
   vm,
   expOrFn,
   handler,
   options
 ) {
   if (isPlainObject(handler)) {
     options = handler;
     handler = handler.handler;
   }
   if (typeof handler === 'string') {
     handler = vm[handler];
   }
   return vm.$watch(expOrFn, handler, options)
 }

 function stateMixin (Vue) {
   // flow somehow has problems with directly declared definition object
   // when using Object.defineProperty, so we have to procedurally build up
   // the object here.
   var dataDef = {};
   dataDef.get = function () { return this._data };
   var propsDef = {};
   propsDef.get = function () { return this._props };
   if (false) {}
   Object.defineProperty(Vue.prototype, '$data', dataDef);
   Object.defineProperty(Vue.prototype, '$props', propsDef);

   Vue.prototype.$set = set;
   Vue.prototype.$delete = del;

   Vue.prototype.$watch = function (
     expOrFn,
     cb,
     options
   ) {
     var vm = this;
     if (isPlainObject(cb)) {
       return createWatcher(vm, expOrFn, cb, options)
     }
     options = options || {};
     options.user = true;
     var watcher = new Watcher(vm, expOrFn, cb, options);
     if (options.immediate) {
       var info = "callback for immediate watcher \"" + (watcher.expression) + "\"";
       pushTarget();
       invokeWithErrorHandling(cb, vm, [watcher.value], vm, info);
       popTarget();
     }
     return function unwatchFn () {
       watcher.teardown();
     }
   };
 }

 /*  */

 var uid$3 = 0;

 function initMixin (Vue) {
   Vue.prototype._init = function (options) {
     var vm = this;
     // a uid
     vm._uid = uid$3++;

     var startTag, endTag;
     /* istanbul ignore if */
     if (false) {}

     // a flag to avoid this being observed
     vm._isVue = true;
     // merge options
     if (options && options._isComponent) {
       // optimize internal component instantiation
       // since dynamic options merging is pretty slow, and none of the
       // internal component options needs special treatment.
       initInternalComponent(vm, options);
     } else {
       vm.$options = mergeOptions(
         resolveConstructorOptions(vm.constructor),
         options || {},
         vm
       );
     }
     /* istanbul ignore else */
     if (false) {} else {
       vm._renderProxy = vm;
     }
     // expose real self
     vm._self = vm;
     initLifecycle(vm);
     initEvents(vm);
     initRender(vm);
     callHook(vm, 'beforeCreate');
     initInjections(vm); // resolve injections before data/props
     initState(vm);
     initProvide(vm); // resolve provide after data/props
     callHook(vm, 'created');

     /* istanbul ignore if */
     if (false) {}

     if (vm.$options.el) {
       vm.$mount(vm.$options.el);
     }
   };
 }

 function initInternalComponent (vm, options) {
   var opts = vm.$options = Object.create(vm.constructor.options);
   // doing this because it's faster than dynamic enumeration.
   var parentVnode = options._parentVnode;
   opts.parent = options.parent;
   opts._parentVnode = parentVnode;

   var vnodeComponentOptions = parentVnode.componentOptions;
   opts.propsData = vnodeComponentOptions.propsData;
   opts._parentListeners = vnodeComponentOptions.listeners;
   opts._renderChildren = vnodeComponentOptions.children;
   opts._componentTag = vnodeComponentOptions.tag;

   if (options.render) {
     opts.render = options.render;
     opts.staticRenderFns = options.staticRenderFns;
   }
 }

 function resolveConstructorOptions (Ctor) {
   var options = Ctor.options;
   if (Ctor.super) {
     var superOptions = resolveConstructorOptions(Ctor.super);
     var cachedSuperOptions = Ctor.superOptions;
     if (superOptions !== cachedSuperOptions) {
       // super option changed,
       // need to resolve new options.
       Ctor.superOptions = superOptions;
       // check if there are any late-modified/attached options (#4976)
       var modifiedOptions = resolveModifiedOptions(Ctor);
       // update base extend options
       if (modifiedOptions) {
         extend(Ctor.extendOptions, modifiedOptions);
       }
       options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
       if (options.name) {
         options.components[options.name] = Ctor;
       }
     }
   }
   return options
 }

 function resolveModifiedOptions (Ctor) {
   var modified;
   var latest = Ctor.options;
   var sealed = Ctor.sealedOptions;
   for (var key in latest) {
     if (latest[key] !== sealed[key]) {
       if (!modified) { modified = {}; }
       modified[key] = latest[key];
     }
   }
   return modified
 }

 function Vue (options) {
   if (false
   ) {}
   this._init(options);
 }

 initMixin(Vue);
 stateMixin(Vue);
 eventsMixin(Vue);
 lifecycleMixin(Vue);
 renderMixin(Vue);

 /*  */

 function initUse (Vue) {
   Vue.use = function (plugin) {
     var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
     if (installedPlugins.indexOf(plugin) > -1) {
       return this
     }

     // additional parameters
     var args = toArray(arguments, 1);
     args.unshift(this);
     if (typeof plugin.install === 'function') {
       plugin.install.apply(plugin, args);
     } else if (typeof plugin === 'function') {
       plugin.apply(null, args);
     }
     installedPlugins.push(plugin);
     return this
   };
 }

 /*  */

 function initMixin$1 (Vue) {
   Vue.mixin = function (mixin) {
     this.options = mergeOptions(this.options, mixin);
     return this
   };
 }

 /*  */

 function initExtend (Vue) {
   /**
    * Each instance constructor, including Vue, has a unique
    * cid. This enables us to create wrapped "child
    * constructors" for prototypal inheritance and cache them.
    */
   Vue.cid = 0;
   var cid = 1;

   /**
    * Class inheritance
    */
   Vue.extend = function (extendOptions) {
     extendOptions = extendOptions || {};
     var Super = this;
     var SuperId = Super.cid;
     var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
     if (cachedCtors[SuperId]) {
       return cachedCtors[SuperId]
     }

     var name = extendOptions.name || Super.options.name;
     if (false) {}

     var Sub = function VueComponent (options) {
       this._init(options);
     };
     Sub.prototype = Object.create(Super.prototype);
     Sub.prototype.constructor = Sub;
     Sub.cid = cid++;
     Sub.options = mergeOptions(
       Super.options,
       extendOptions
     );
     Sub['super'] = Super;

     // For props and computed properties, we define the proxy getters on
     // the Vue instances at extension time, on the extended prototype. This
     // avoids Object.defineProperty calls for each instance created.
     if (Sub.options.props) {
       initProps$1(Sub);
     }
     if (Sub.options.computed) {
       initComputed$1(Sub);
     }

     // allow further extension/mixin/plugin usage
     Sub.extend = Super.extend;
     Sub.mixin = Super.mixin;
     Sub.use = Super.use;

     // create asset registers, so extended classes
     // can have their private assets too.
     ASSET_TYPES.forEach(function (type) {
       Sub[type] = Super[type];
     });
     // enable recursive self-lookup
     if (name) {
       Sub.options.components[name] = Sub;
     }

     // keep a reference to the super options at extension time.
     // later at instantiation we can check if Super's options have
     // been updated.
     Sub.superOptions = Super.options;
     Sub.extendOptions = extendOptions;
     Sub.sealedOptions = extend({}, Sub.options);

     // cache constructor
     cachedCtors[SuperId] = Sub;
     return Sub
   };
 }

 function initProps$1 (Comp) {
   var props = Comp.options.props;
   for (var key in props) {
     proxy(Comp.prototype, "_props", key);
   }
 }

 function initComputed$1 (Comp) {
   var computed = Comp.options.computed;
   for (var key in computed) {
     defineComputed(Comp.prototype, key, computed[key]);
   }
 }

 /*  */

 function initAssetRegisters (Vue) {
   /**
    * Create asset registration methods.
    */
   ASSET_TYPES.forEach(function (type) {
     Vue[type] = function (
       id,
       definition
     ) {
       if (!definition) {
         return this.options[type + 's'][id]
       } else {
         /* istanbul ignore if */
         if (false) {}
         if (type === 'component' && isPlainObject(definition)) {
           definition.name = definition.name || id;
           definition = this.options._base.extend(definition);
         }
         if (type === 'directive' && typeof definition === 'function') {
           definition = { bind: definition, update: definition };
         }
         this.options[type + 's'][id] = definition;
         return definition
       }
     };
   });
 }

 /*  */





 function getComponentName (opts) {
   return opts && (opts.Ctor.options.name || opts.tag)
 }

 function matches (pattern, name) {
   if (Array.isArray(pattern)) {
     return pattern.indexOf(name) > -1
   } else if (typeof pattern === 'string') {
     return pattern.split(',').indexOf(name) > -1
   } else if (isRegExp(pattern)) {
     return pattern.test(name)
   }
   /* istanbul ignore next */
   return false
 }

 function pruneCache (keepAliveInstance, filter) {
   var cache = keepAliveInstance.cache;
   var keys = keepAliveInstance.keys;
   var _vnode = keepAliveInstance._vnode;
   for (var key in cache) {
     var entry = cache[key];
     if (entry) {
       var name = entry.name;
       if (name && !filter(name)) {
         pruneCacheEntry(cache, key, keys, _vnode);
       }
     }
   }
 }

 function pruneCacheEntry (
   cache,
   key,
   keys,
   current
 ) {
   var entry = cache[key];
   if (entry && (!current || entry.tag !== current.tag)) {
     entry.componentInstance.$destroy();
   }
   cache[key] = null;
   remove(keys, key);
 }

 var patternTypes = [String, RegExp, Array];

 var KeepAlive = {
   name: 'keep-alive',
   abstract: true,

   props: {
     include: patternTypes,
     exclude: patternTypes,
     max: [String, Number]
   },

   methods: {
     cacheVNode: function cacheVNode() {
       var ref = this;
       var cache = ref.cache;
       var keys = ref.keys;
       var vnodeToCache = ref.vnodeToCache;
       var keyToCache = ref.keyToCache;
       if (vnodeToCache) {
         var tag = vnodeToCache.tag;
         var componentInstance = vnodeToCache.componentInstance;
         var componentOptions = vnodeToCache.componentOptions;
         cache[keyToCache] = {
           name: getComponentName(componentOptions),
           tag: tag,
           componentInstance: componentInstance,
         };
         keys.push(keyToCache);
         // prune oldest entry
         if (this.max && keys.length > parseInt(this.max)) {
           pruneCacheEntry(cache, keys[0], keys, this._vnode);
         }
         this.vnodeToCache = null;
       }
     }
   },

   created: function created () {
     this.cache = Object.create(null);
     this.keys = [];
   },

   destroyed: function destroyed () {
     for (var key in this.cache) {
       pruneCacheEntry(this.cache, key, this.keys);
     }
   },

   mounted: function mounted () {
     var this$1 = this;

     this.cacheVNode();
     this.$watch('include', function (val) {
       pruneCache(this$1, function (name) { return matches(val, name); });
     });
     this.$watch('exclude', function (val) {
       pruneCache(this$1, function (name) { return !matches(val, name); });
     });
   },

   updated: function updated () {
     this.cacheVNode();
   },

   render: function render () {
     var slot = this.$slots.default;
     var vnode = getFirstComponentChild(slot);
     var componentOptions = vnode && vnode.componentOptions;
     if (componentOptions) {
       // check pattern
       var name = getComponentName(componentOptions);
       var ref = this;
       var include = ref.include;
       var exclude = ref.exclude;
       if (
         // not included
         (include && (!name || !matches(include, name))) ||
         // excluded
         (exclude && name && matches(exclude, name))
       ) {
         return vnode
       }

       var ref$1 = this;
       var cache = ref$1.cache;
       var keys = ref$1.keys;
       var key = vnode.key == null
         // same constructor may get registered as different local components
         // so cid alone is not enough (#3269)
         ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
         : vnode.key;
       if (cache[key]) {
         vnode.componentInstance = cache[key].componentInstance;
         // make current key freshest
         remove(keys, key);
         keys.push(key);
       } else {
         // delay setting the cache until update
         this.vnodeToCache = vnode;
         this.keyToCache = key;
       }

       vnode.data.keepAlive = true;
     }
     return vnode || (slot && slot[0])
   }
 };

 var builtInComponents = {
   KeepAlive: KeepAlive
 };

 /*  */

 function initGlobalAPI (Vue) {
   // config
   var configDef = {};
   configDef.get = function () { return config; };
   if (false) {}
   Object.defineProperty(Vue, 'config', configDef);

   // exposed util methods.
   // NOTE: these are not considered part of the public API - avoid relying on
   // them unless you are aware of the risk.
   Vue.util = {
     warn: warn,
     extend: extend,
     mergeOptions: mergeOptions,
     defineReactive: defineReactive$$1
   };

   Vue.set = set;
   Vue.delete = del;
   Vue.nextTick = nextTick;

   // 2.6 explicit observable API
   Vue.observable = function (obj) {
     observe(obj);
     return obj
   };

   Vue.options = Object.create(null);
   ASSET_TYPES.forEach(function (type) {
     Vue.options[type + 's'] = Object.create(null);
   });

   // this is used to identify the "base" constructor to extend all plain-object
   // components with in Weex's multi-instance scenarios.
   Vue.options._base = Vue;

   extend(Vue.options.components, builtInComponents);

   initUse(Vue);
   initMixin$1(Vue);
   initExtend(Vue);
   initAssetRegisters(Vue);
 }

 initGlobalAPI(Vue);

 Object.defineProperty(Vue.prototype, '$isServer', {
   get: isServerRendering
 });

 Object.defineProperty(Vue.prototype, '$ssrContext', {
   get: function get () {
     /* istanbul ignore next */
     return this.$vnode && this.$vnode.ssrContext
   }
 });

 // expose FunctionalRenderContext for ssr runtime helper installation
 Object.defineProperty(Vue, 'FunctionalRenderContext', {
   value: FunctionalRenderContext
 });

 Vue.version = '2.6.14';

 /*  */

 // these are reserved for web because they are directly compiled away
 // during template compilation
 var isReservedAttr = makeMap('style,class');

 // attributes that should be using props for binding
 var acceptValue = makeMap('input,textarea,option,select,progress');
 var mustUseProp = function (tag, type, attr) {
   return (
     (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
     (attr === 'selected' && tag === 'option') ||
     (attr === 'checked' && tag === 'input') ||
     (attr === 'muted' && tag === 'video')
   )
 };

 var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

 var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

 var convertEnumeratedValue = function (key, value) {
   return isFalsyAttrValue(value) || value === 'false'
     ? 'false'
     // allow arbitrary string value for contenteditable
     : key === 'contenteditable' && isValidContentEditableValue(value)
       ? value
       : 'true'
 };

 var isBooleanAttr = makeMap(
   'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
   'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
   'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
   'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
   'required,reversed,scoped,seamless,selected,sortable,' +
   'truespeed,typemustmatch,visible'
 );

 var xlinkNS = 'http://www.w3.org/1999/xlink';

 var isXlink = function (name) {
   return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
 };

 var getXlinkProp = function (name) {
   return isXlink(name) ? name.slice(6, name.length) : ''
 };

 var isFalsyAttrValue = function (val) {
   return val == null || val === false
 };

 /*  */

 function genClassForVnode (vnode) {
   var data = vnode.data;
   var parentNode = vnode;
   var childNode = vnode;
   while (isDef(childNode.componentInstance)) {
     childNode = childNode.componentInstance._vnode;
     if (childNode && childNode.data) {
       data = mergeClassData(childNode.data, data);
     }
   }
   while (isDef(parentNode = parentNode.parent)) {
     if (parentNode && parentNode.data) {
       data = mergeClassData(data, parentNode.data);
     }
   }
   return renderClass(data.staticClass, data.class)
 }

 function mergeClassData (child, parent) {
   return {
     staticClass: concat(child.staticClass, parent.staticClass),
     class: isDef(child.class)
       ? [child.class, parent.class]
       : parent.class
   }
 }

 function renderClass (
   staticClass,
   dynamicClass
 ) {
   if (isDef(staticClass) || isDef(dynamicClass)) {
     return concat(staticClass, stringifyClass(dynamicClass))
   }
   /* istanbul ignore next */
   return ''
 }

 function concat (a, b) {
   return a ? b ? (a + ' ' + b) : a : (b || '')
 }

 function stringifyClass (value) {
   if (Array.isArray(value)) {
     return stringifyArray(value)
   }
   if (isObject(value)) {
     return stringifyObject(value)
   }
   if (typeof value === 'string') {
     return value
   }
   /* istanbul ignore next */
   return ''
 }

 function stringifyArray (value) {
   var res = '';
   var stringified;
   for (var i = 0, l = value.length; i < l; i++) {
     if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
       if (res) { res += ' '; }
       res += stringified;
     }
   }
   return res
 }

 function stringifyObject (value) {
   var res = '';
   for (var key in value) {
     if (value[key]) {
       if (res) { res += ' '; }
       res += key;
     }
   }
   return res
 }

 /*  */

 var namespaceMap = {
   svg: 'http://www.w3.org/2000/svg',
   math: 'http://www.w3.org/1998/Math/MathML'
 };

 var isHTMLTag = makeMap(
   'html,body,base,head,link,meta,style,title,' +
   'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
   'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
   'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
   's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
   'embed,object,param,source,canvas,script,noscript,del,ins,' +
   'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
   'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
   'output,progress,select,textarea,' +
   'details,dialog,menu,menuitem,summary,' +
   'content,element,shadow,template,blockquote,iframe,tfoot'
 );

 // this map is intentionally selective, only covering SVG elements that may
 // contain child elements.
 var isSVG = makeMap(
   'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
   'foreignobject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
   'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
   true
 );

 var isReservedTag = function (tag) {
   return isHTMLTag(tag) || isSVG(tag)
 };

 function getTagNamespace (tag) {
   if (isSVG(tag)) {
     return 'svg'
   }
   // basic support for MathML
   // note it doesn't support other MathML elements being component roots
   if (tag === 'math') {
     return 'math'
   }
 }

 var unknownElementCache = Object.create(null);
 function isUnknownElement (tag) {
   /* istanbul ignore if */
   if (!inBrowser) {
     return true
   }
   if (isReservedTag(tag)) {
     return false
   }
   tag = tag.toLowerCase();
   /* istanbul ignore if */
   if (unknownElementCache[tag] != null) {
     return unknownElementCache[tag]
   }
   var el = document.createElement(tag);
   if (tag.indexOf('-') > -1) {
     // http://stackoverflow.com/a/28210364/1070244
     return (unknownElementCache[tag] = (
       el.constructor === window.HTMLUnknownElement ||
       el.constructor === window.HTMLElement
     ))
   } else {
     return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
   }
 }

 var isTextInputType = makeMap('text,number,password,search,email,tel,url');

 /*  */

 /**
  * Query an element selector if it's not an element already.
  */
 function query (el) {
   if (typeof el === 'string') {
     var selected = document.querySelector(el);
     if (!selected) {
       "production" !== 'production' && warn(
         'Cannot find element: ' + el
       );
       return document.createElement('div')
     }
     return selected
   } else {
     return el
   }
 }

 /*  */

 function createElement$1 (tagName, vnode) {
   var elm = document.createElement(tagName);
   if (tagName !== 'select') {
     return elm
   }
   // false or null will remove the attribute but undefined will not
   if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
     elm.setAttribute('multiple', 'multiple');
   }
   return elm
 }

 function createElementNS (namespace, tagName) {
   return document.createElementNS(namespaceMap[namespace], tagName)
 }

 function createTextNode (text) {
   return document.createTextNode(text)
 }

 function createComment (text) {
   return document.createComment(text)
 }

 function insertBefore (parentNode, newNode, referenceNode) {
   parentNode.insertBefore(newNode, referenceNode);
 }

 function removeChild (node, child) {
   node.removeChild(child);
 }

 function appendChild (node, child) {
   node.appendChild(child);
 }

 function parentNode (node) {
   return node.parentNode
 }

 function nextSibling (node) {
   return node.nextSibling
 }

 function tagName (node) {
   return node.tagName
 }

 function setTextContent (node, text) {
   node.textContent = text;
 }

 function setStyleScope (node, scopeId) {
   node.setAttribute(scopeId, '');
 }

 var nodeOps = /*#__PURE__*/Object.freeze({
   createElement: createElement$1,
   createElementNS: createElementNS,
   createTextNode: createTextNode,
   createComment: createComment,
   insertBefore: insertBefore,
   removeChild: removeChild,
   appendChild: appendChild,
   parentNode: parentNode,
   nextSibling: nextSibling,
   tagName: tagName,
   setTextContent: setTextContent,
   setStyleScope: setStyleScope
 });

 /*  */

 var ref = {
   create: function create (_, vnode) {
     registerRef(vnode);
   },
   update: function update (oldVnode, vnode) {
     if (oldVnode.data.ref !== vnode.data.ref) {
       registerRef(oldVnode, true);
       registerRef(vnode);
     }
   },
   destroy: function destroy (vnode) {
     registerRef(vnode, true);
   }
 };

 function registerRef (vnode, isRemoval) {
   var key = vnode.data.ref;
   if (!isDef(key)) { return }

   var vm = vnode.context;
   var ref = vnode.componentInstance || vnode.elm;
   var refs = vm.$refs;
   if (isRemoval) {
     if (Array.isArray(refs[key])) {
       remove(refs[key], ref);
     } else if (refs[key] === ref) {
       refs[key] = undefined;
     }
   } else {
     if (vnode.data.refInFor) {
       if (!Array.isArray(refs[key])) {
         refs[key] = [ref];
       } else if (refs[key].indexOf(ref) < 0) {
         // $flow-disable-line
         refs[key].push(ref);
       }
     } else {
       refs[key] = ref;
     }
   }
 }

 /**
  * Virtual DOM patching algorithm based on Snabbdom by
  * Simon Friis Vindum (@paldepind)
  * Licensed under the MIT License
  * https://github.com/paldepind/snabbdom/blob/master/LICENSE
  *
  * modified by Evan You (@yyx990803)
  *
  * Not type-checking this because this file is perf-critical and the cost
  * of making flow understand it is not worth it.
  */

 var emptyNode = new VNode('', {}, []);

 var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

 function sameVnode (a, b) {
   return (
     a.key === b.key &&
     a.asyncFactory === b.asyncFactory && (
       (
         a.tag === b.tag &&
         a.isComment === b.isComment &&
         isDef(a.data) === isDef(b.data) &&
         sameInputType(a, b)
       ) || (
         isTrue(a.isAsyncPlaceholder) &&
         isUndef(b.asyncFactory.error)
       )
     )
   )
 }

 function sameInputType (a, b) {
   if (a.tag !== 'input') { return true }
   var i;
   var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
   var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
   return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
 }

 function createKeyToOldIdx (children, beginIdx, endIdx) {
   var i, key;
   var map = {};
   for (i = beginIdx; i <= endIdx; ++i) {
     key = children[i].key;
     if (isDef(key)) { map[key] = i; }
   }
   return map
 }

 function createPatchFunction (backend) {
   var i, j;
   var cbs = {};

   var modules = backend.modules;
   var nodeOps = backend.nodeOps;

   for (i = 0; i < hooks.length; ++i) {
     cbs[hooks[i]] = [];
     for (j = 0; j < modules.length; ++j) {
       if (isDef(modules[j][hooks[i]])) {
         cbs[hooks[i]].push(modules[j][hooks[i]]);
       }
     }
   }

   function emptyNodeAt (elm) {
     return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
   }

   function createRmCb (childElm, listeners) {
     function remove$$1 () {
       if (--remove$$1.listeners === 0) {
         removeNode(childElm);
       }
     }
     remove$$1.listeners = listeners;
     return remove$$1
   }

   function removeNode (el) {
     var parent = nodeOps.parentNode(el);
     // element may have already been removed due to v-html / v-text
     if (isDef(parent)) {
       nodeOps.removeChild(parent, el);
     }
   }

   function isUnknownElement$$1 (vnode, inVPre) {
     return (
       !inVPre &&
       !vnode.ns &&
       !(
         config.ignoredElements.length &&
         config.ignoredElements.some(function (ignore) {
           return isRegExp(ignore)
             ? ignore.test(vnode.tag)
             : ignore === vnode.tag
         })
       ) &&
       config.isUnknownElement(vnode.tag)
     )
   }

   var creatingElmInVPre = 0;

   function createElm (
     vnode,
     insertedVnodeQueue,
     parentElm,
     refElm,
     nested,
     ownerArray,
     index
   ) {
     if (isDef(vnode.elm) && isDef(ownerArray)) {
       // This vnode was used in a previous render!
       // now it's used as a new node, overwriting its elm would cause
       // potential patch errors down the road when it's used as an insertion
       // reference node. Instead, we clone the node on-demand before creating
       // associated DOM element for it.
       vnode = ownerArray[index] = cloneVNode(vnode);
     }

     vnode.isRootInsert = !nested; // for transition enter check
     if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
       return
     }

     var data = vnode.data;
     var children = vnode.children;
     var tag = vnode.tag;
     if (isDef(tag)) {
       if (false) {}

       vnode.elm = vnode.ns
         ? nodeOps.createElementNS(vnode.ns, tag)
         : nodeOps.createElement(tag, vnode);
       setScope(vnode);

       /* istanbul ignore if */
       {
         createChildren(vnode, children, insertedVnodeQueue);
         if (isDef(data)) {
           invokeCreateHooks(vnode, insertedVnodeQueue);
         }
         insert(parentElm, vnode.elm, refElm);
       }

       if (false) {}
     } else if (isTrue(vnode.isComment)) {
       vnode.elm = nodeOps.createComment(vnode.text);
       insert(parentElm, vnode.elm, refElm);
     } else {
       vnode.elm = nodeOps.createTextNode(vnode.text);
       insert(parentElm, vnode.elm, refElm);
     }
   }

   function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
     var i = vnode.data;
     if (isDef(i)) {
       var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
       if (isDef(i = i.hook) && isDef(i = i.init)) {
         i(vnode, false /* hydrating */);
       }
       // after calling the init hook, if the vnode is a child component
       // it should've created a child instance and mounted it. the child
       // component also has set the placeholder vnode's elm.
       // in that case we can just return the element and be done.
       if (isDef(vnode.componentInstance)) {
         initComponent(vnode, insertedVnodeQueue);
         insert(parentElm, vnode.elm, refElm);
         if (isTrue(isReactivated)) {
           reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
         }
         return true
       }
     }
   }

   function initComponent (vnode, insertedVnodeQueue) {
     if (isDef(vnode.data.pendingInsert)) {
       insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
       vnode.data.pendingInsert = null;
     }
     vnode.elm = vnode.componentInstance.$el;
     if (isPatchable(vnode)) {
       invokeCreateHooks(vnode, insertedVnodeQueue);
       setScope(vnode);
     } else {
       // empty component root.
       // skip all element-related modules except for ref (#3455)
       registerRef(vnode);
       // make sure to invoke the insert hook
       insertedVnodeQueue.push(vnode);
     }
   }

   function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
     var i;
     // hack for #4339: a reactivated component with inner transition
     // does not trigger because the inner node's created hooks are not called
     // again. It's not ideal to involve module-specific logic in here but
     // there doesn't seem to be a better way to do it.
     var innerNode = vnode;
     while (innerNode.componentInstance) {
       innerNode = innerNode.componentInstance._vnode;
       if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
         for (i = 0; i < cbs.activate.length; ++i) {
           cbs.activate[i](emptyNode, innerNode);
         }
         insertedVnodeQueue.push(innerNode);
         break
       }
     }
     // unlike a newly created component,
     // a reactivated keep-alive component doesn't insert itself
     insert(parentElm, vnode.elm, refElm);
   }

   function insert (parent, elm, ref$$1) {
     if (isDef(parent)) {
       if (isDef(ref$$1)) {
         if (nodeOps.parentNode(ref$$1) === parent) {
           nodeOps.insertBefore(parent, elm, ref$$1);
         }
       } else {
         nodeOps.appendChild(parent, elm);
       }
     }
   }

   function createChildren (vnode, children, insertedVnodeQueue) {
     if (Array.isArray(children)) {
       if (false) {}
       for (var i = 0; i < children.length; ++i) {
         createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
       }
     } else if (isPrimitive(vnode.text)) {
       nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
     }
   }

   function isPatchable (vnode) {
     while (vnode.componentInstance) {
       vnode = vnode.componentInstance._vnode;
     }
     return isDef(vnode.tag)
   }

   function invokeCreateHooks (vnode, insertedVnodeQueue) {
     for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
       cbs.create[i$1](emptyNode, vnode);
     }
     i = vnode.data.hook; // Reuse variable
     if (isDef(i)) {
       if (isDef(i.create)) { i.create(emptyNode, vnode); }
       if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
     }
   }

   // set scope id attribute for scoped CSS.
   // this is implemented as a special case to avoid the overhead
   // of going through the normal attribute patching process.
   function setScope (vnode) {
     var i;
     if (isDef(i = vnode.fnScopeId)) {
       nodeOps.setStyleScope(vnode.elm, i);
     } else {
       var ancestor = vnode;
       while (ancestor) {
         if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
           nodeOps.setStyleScope(vnode.elm, i);
         }
         ancestor = ancestor.parent;
       }
     }
     // for slot content they should also get the scopeId from the host instance.
     if (isDef(i = activeInstance) &&
       i !== vnode.context &&
       i !== vnode.fnContext &&
       isDef(i = i.$options._scopeId)
     ) {
       nodeOps.setStyleScope(vnode.elm, i);
     }
   }

   function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
     for (; startIdx <= endIdx; ++startIdx) {
       createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
     }
   }

   function invokeDestroyHook (vnode) {
     var i, j;
     var data = vnode.data;
     if (isDef(data)) {
       if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
       for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
     }
     if (isDef(i = vnode.children)) {
       for (j = 0; j < vnode.children.length; ++j) {
         invokeDestroyHook(vnode.children[j]);
       }
     }
   }

   function removeVnodes (vnodes, startIdx, endIdx) {
     for (; startIdx <= endIdx; ++startIdx) {
       var ch = vnodes[startIdx];
       if (isDef(ch)) {
         if (isDef(ch.tag)) {
           removeAndInvokeRemoveHook(ch);
           invokeDestroyHook(ch);
         } else { // Text node
           removeNode(ch.elm);
         }
       }
     }
   }

   function removeAndInvokeRemoveHook (vnode, rm) {
     if (isDef(rm) || isDef(vnode.data)) {
       var i;
       var listeners = cbs.remove.length + 1;
       if (isDef(rm)) {
         // we have a recursively passed down rm callback
         // increase the listeners count
         rm.listeners += listeners;
       } else {
         // directly removing
         rm = createRmCb(vnode.elm, listeners);
       }
       // recursively invoke hooks on child component root node
       if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
         removeAndInvokeRemoveHook(i, rm);
       }
       for (i = 0; i < cbs.remove.length; ++i) {
         cbs.remove[i](vnode, rm);
       }
       if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
         i(vnode, rm);
       } else {
         rm();
       }
     } else {
       removeNode(vnode.elm);
     }
   }

   function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
     var oldStartIdx = 0;
     var newStartIdx = 0;
     var oldEndIdx = oldCh.length - 1;
     var oldStartVnode = oldCh[0];
     var oldEndVnode = oldCh[oldEndIdx];
     var newEndIdx = newCh.length - 1;
     var newStartVnode = newCh[0];
     var newEndVnode = newCh[newEndIdx];
     var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

     // removeOnly is a special flag used only by <transition-group>
     // to ensure removed elements stay in correct relative positions
     // during leaving transitions
     var canMove = !removeOnly;

     if (false) {}

     while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
       if (isUndef(oldStartVnode)) {
         oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
       } else if (isUndef(oldEndVnode)) {
         oldEndVnode = oldCh[--oldEndIdx];
       } else if (sameVnode(oldStartVnode, newStartVnode)) {
         patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
         oldStartVnode = oldCh[++oldStartIdx];
         newStartVnode = newCh[++newStartIdx];
       } else if (sameVnode(oldEndVnode, newEndVnode)) {
         patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
         oldEndVnode = oldCh[--oldEndIdx];
         newEndVnode = newCh[--newEndIdx];
       } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
         patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
         canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
         oldStartVnode = oldCh[++oldStartIdx];
         newEndVnode = newCh[--newEndIdx];
       } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
         patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
         canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
         oldEndVnode = oldCh[--oldEndIdx];
         newStartVnode = newCh[++newStartIdx];
       } else {
         if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
         idxInOld = isDef(newStartVnode.key)
           ? oldKeyToIdx[newStartVnode.key]
           : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
         if (isUndef(idxInOld)) { // New element
           createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
         } else {
           vnodeToMove = oldCh[idxInOld];
           if (sameVnode(vnodeToMove, newStartVnode)) {
             patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
             oldCh[idxInOld] = undefined;
             canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
           } else {
             // same key but different element. treat as new element
             createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
           }
         }
         newStartVnode = newCh[++newStartIdx];
       }
     }
     if (oldStartIdx > oldEndIdx) {
       refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
       addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
     } else if (newStartIdx > newEndIdx) {
       removeVnodes(oldCh, oldStartIdx, oldEndIdx);
     }
   }

   function checkDuplicateKeys (children) {
     var seenKeys = {};
     for (var i = 0; i < children.length; i++) {
       var vnode = children[i];
       var key = vnode.key;
       if (isDef(key)) {
         if (seenKeys[key]) {
           warn(
             ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
             vnode.context
           );
         } else {
           seenKeys[key] = true;
         }
       }
     }
   }

   function findIdxInOld (node, oldCh, start, end) {
     for (var i = start; i < end; i++) {
       var c = oldCh[i];
       if (isDef(c) && sameVnode(node, c)) { return i }
     }
   }

   function patchVnode (
     oldVnode,
     vnode,
     insertedVnodeQueue,
     ownerArray,
     index,
     removeOnly
   ) {
     if (oldVnode === vnode) {
       return
     }

     if (isDef(vnode.elm) && isDef(ownerArray)) {
       // clone reused vnode
       vnode = ownerArray[index] = cloneVNode(vnode);
     }

     var elm = vnode.elm = oldVnode.elm;

     if (isTrue(oldVnode.isAsyncPlaceholder)) {
       if (isDef(vnode.asyncFactory.resolved)) {
         hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
       } else {
         vnode.isAsyncPlaceholder = true;
       }
       return
     }

     // reuse element for static trees.
     // note we only do this if the vnode is cloned -
     // if the new node is not cloned it means the render functions have been
     // reset by the hot-reload-api and we need to do a proper re-render.
     if (isTrue(vnode.isStatic) &&
       isTrue(oldVnode.isStatic) &&
       vnode.key === oldVnode.key &&
       (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
     ) {
       vnode.componentInstance = oldVnode.componentInstance;
       return
     }

     var i;
     var data = vnode.data;
     if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
       i(oldVnode, vnode);
     }

     var oldCh = oldVnode.children;
     var ch = vnode.children;
     if (isDef(data) && isPatchable(vnode)) {
       for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
       if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
     }
     if (isUndef(vnode.text)) {
       if (isDef(oldCh) && isDef(ch)) {
         if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
       } else if (isDef(ch)) {
         if (false) {}
         if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
         addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
       } else if (isDef(oldCh)) {
         removeVnodes(oldCh, 0, oldCh.length - 1);
       } else if (isDef(oldVnode.text)) {
         nodeOps.setTextContent(elm, '');
       }
     } else if (oldVnode.text !== vnode.text) {
       nodeOps.setTextContent(elm, vnode.text);
     }
     if (isDef(data)) {
       if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
     }
   }

   function invokeInsertHook (vnode, queue, initial) {
     // delay insert hooks for component root nodes, invoke them after the
     // element is really inserted
     if (isTrue(initial) && isDef(vnode.parent)) {
       vnode.parent.data.pendingInsert = queue;
     } else {
       for (var i = 0; i < queue.length; ++i) {
         queue[i].data.hook.insert(queue[i]);
       }
     }
   }

   var hydrationBailed = false;
   // list of modules that can skip create hook during hydration because they
   // are already rendered on the client or has no need for initialization
   // Note: style is excluded because it relies on initial clone for future
   // deep updates (#7063).
   var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

   // Note: this is a browser-only function so we can assume elms are DOM nodes.
   function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
     var i;
     var tag = vnode.tag;
     var data = vnode.data;
     var children = vnode.children;
     inVPre = inVPre || (data && data.pre);
     vnode.elm = elm;

     if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
       vnode.isAsyncPlaceholder = true;
       return true
     }
     // assert node match
     if (false) {}
     if (isDef(data)) {
       if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
       if (isDef(i = vnode.componentInstance)) {
         // child component. it should have hydrated its own tree.
         initComponent(vnode, insertedVnodeQueue);
         return true
       }
     }
     if (isDef(tag)) {
       if (isDef(children)) {
         // empty element, allow client to pick up and populate children
         if (!elm.hasChildNodes()) {
           createChildren(vnode, children, insertedVnodeQueue);
         } else {
           // v-html and domProps: innerHTML
           if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
             if (i !== elm.innerHTML) {
               /* istanbul ignore if */
               if (false
               ) {}
               return false
             }
           } else {
             // iterate and compare children lists
             var childrenMatch = true;
             var childNode = elm.firstChild;
             for (var i$1 = 0; i$1 < children.length; i$1++) {
               if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                 childrenMatch = false;
                 break
               }
               childNode = childNode.nextSibling;
             }
             // if childNode is not null, it means the actual childNodes list is
             // longer than the virtual children list.
             if (!childrenMatch || childNode) {
               /* istanbul ignore if */
               if (false
               ) {}
               return false
             }
           }
         }
       }
       if (isDef(data)) {
         var fullInvoke = false;
         for (var key in data) {
           if (!isRenderedModule(key)) {
             fullInvoke = true;
             invokeCreateHooks(vnode, insertedVnodeQueue);
             break
           }
         }
         if (!fullInvoke && data['class']) {
           // ensure collecting deps for deep class bindings for future updates
           traverse(data['class']);
         }
       }
     } else if (elm.data !== vnode.text) {
       elm.data = vnode.text;
     }
     return true
   }

   function assertNodeMatch (node, vnode, inVPre) {
     if (isDef(vnode.tag)) {
       return vnode.tag.indexOf('vue-component') === 0 || (
         !isUnknownElement$$1(vnode, inVPre) &&
         vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
       )
     } else {
       return node.nodeType === (vnode.isComment ? 8 : 3)
     }
   }

   return function patch (oldVnode, vnode, hydrating, removeOnly) {
     if (isUndef(vnode)) {
       if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
       return
     }

     var isInitialPatch = false;
     var insertedVnodeQueue = [];

     if (isUndef(oldVnode)) {
       // empty mount (likely as component), create new root element
       isInitialPatch = true;
       createElm(vnode, insertedVnodeQueue);
     } else {
       var isRealElement = isDef(oldVnode.nodeType);
       if (!isRealElement && sameVnode(oldVnode, vnode)) {
         // patch existing root node
         patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
       } else {
         if (isRealElement) {
           // mounting to a real element
           // check if this is server-rendered content and if we can perform
           // a successful hydration.
           if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
             oldVnode.removeAttribute(SSR_ATTR);
             hydrating = true;
           }
           if (isTrue(hydrating)) {
             if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
               invokeInsertHook(vnode, insertedVnodeQueue, true);
               return oldVnode
             } else if (false) {}
           }
           // either not server-rendered, or hydration failed.
           // create an empty node and replace it
           oldVnode = emptyNodeAt(oldVnode);
         }

         // replacing existing element
         var oldElm = oldVnode.elm;
         var parentElm = nodeOps.parentNode(oldElm);

         // create new node
         createElm(
           vnode,
           insertedVnodeQueue,
           // extremely rare edge case: do not insert if old element is in a
           // leaving transition. Only happens when combining transition +
           // keep-alive + HOCs. (#4590)
           oldElm._leaveCb ? null : parentElm,
           nodeOps.nextSibling(oldElm)
         );

         // update parent placeholder node element, recursively
         if (isDef(vnode.parent)) {
           var ancestor = vnode.parent;
           var patchable = isPatchable(vnode);
           while (ancestor) {
             for (var i = 0; i < cbs.destroy.length; ++i) {
               cbs.destroy[i](ancestor);
             }
             ancestor.elm = vnode.elm;
             if (patchable) {
               for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                 cbs.create[i$1](emptyNode, ancestor);
               }
               // #6513
               // invoke insert hooks that may have been merged by create hooks.
               // e.g. for directives that uses the "inserted" hook.
               var insert = ancestor.data.hook.insert;
               if (insert.merged) {
                 // start at index 1 to avoid re-invoking component mounted hook
                 for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                   insert.fns[i$2]();
                 }
               }
             } else {
               registerRef(ancestor);
             }
             ancestor = ancestor.parent;
           }
         }

         // destroy old node
         if (isDef(parentElm)) {
           removeVnodes([oldVnode], 0, 0);
         } else if (isDef(oldVnode.tag)) {
           invokeDestroyHook(oldVnode);
         }
       }
     }

     invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
     return vnode.elm
   }
 }

 /*  */

 var directives = {
   create: updateDirectives,
   update: updateDirectives,
   destroy: function unbindDirectives (vnode) {
     updateDirectives(vnode, emptyNode);
   }
 };

 function updateDirectives (oldVnode, vnode) {
   if (oldVnode.data.directives || vnode.data.directives) {
     _update(oldVnode, vnode);
   }
 }

 function _update (oldVnode, vnode) {
   var isCreate = oldVnode === emptyNode;
   var isDestroy = vnode === emptyNode;
   var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
   var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

   var dirsWithInsert = [];
   var dirsWithPostpatch = [];

   var key, oldDir, dir;
   for (key in newDirs) {
     oldDir = oldDirs[key];
     dir = newDirs[key];
     if (!oldDir) {
       // new directive, bind
       callHook$1(dir, 'bind', vnode, oldVnode);
       if (dir.def && dir.def.inserted) {
         dirsWithInsert.push(dir);
       }
     } else {
       // existing directive, update
       dir.oldValue = oldDir.value;
       dir.oldArg = oldDir.arg;
       callHook$1(dir, 'update', vnode, oldVnode);
       if (dir.def && dir.def.componentUpdated) {
         dirsWithPostpatch.push(dir);
       }
     }
   }

   if (dirsWithInsert.length) {
     var callInsert = function () {
       for (var i = 0; i < dirsWithInsert.length; i++) {
         callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
       }
     };
     if (isCreate) {
       mergeVNodeHook(vnode, 'insert', callInsert);
     } else {
       callInsert();
     }
   }

   if (dirsWithPostpatch.length) {
     mergeVNodeHook(vnode, 'postpatch', function () {
       for (var i = 0; i < dirsWithPostpatch.length; i++) {
         callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
       }
     });
   }

   if (!isCreate) {
     for (key in oldDirs) {
       if (!newDirs[key]) {
         // no longer present, unbind
         callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
       }
     }
   }
 }

 var emptyModifiers = Object.create(null);

 function normalizeDirectives$1 (
   dirs,
   vm
 ) {
   var res = Object.create(null);
   if (!dirs) {
     // $flow-disable-line
     return res
   }
   var i, dir;
   for (i = 0; i < dirs.length; i++) {
     dir = dirs[i];
     if (!dir.modifiers) {
       // $flow-disable-line
       dir.modifiers = emptyModifiers;
     }
     res[getRawDirName(dir)] = dir;
     dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
   }
   // $flow-disable-line
   return res
 }

 function getRawDirName (dir) {
   return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
 }

 function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
   var fn = dir.def && dir.def[hook];
   if (fn) {
     try {
       fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
     } catch (e) {
       handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
     }
   }
 }

 var baseModules = [
   ref,
   directives
 ];

 /*  */

 function updateAttrs (oldVnode, vnode) {
   var opts = vnode.componentOptions;
   if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
     return
   }
   if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
     return
   }
   var key, cur, old;
   var elm = vnode.elm;
   var oldAttrs = oldVnode.data.attrs || {};
   var attrs = vnode.data.attrs || {};
   // clone observed objects, as the user probably wants to mutate it
   if (isDef(attrs.__ob__)) {
     attrs = vnode.data.attrs = extend({}, attrs);
   }

   for (key in attrs) {
     cur = attrs[key];
     old = oldAttrs[key];
     if (old !== cur) {
       setAttr(elm, key, cur, vnode.data.pre);
     }
   }
   // #4391: in IE9, setting type can reset value for input[type=radio]
   // #6666: IE/Edge forces progress value down to 1 before setting a max
   /* istanbul ignore if */
   if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
     setAttr(elm, 'value', attrs.value);
   }
   for (key in oldAttrs) {
     if (isUndef(attrs[key])) {
       if (isXlink(key)) {
         elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
       } else if (!isEnumeratedAttr(key)) {
         elm.removeAttribute(key);
       }
     }
   }
 }

 function setAttr (el, key, value, isInPre) {
   if (isInPre || el.tagName.indexOf('-') > -1) {
     baseSetAttr(el, key, value);
   } else if (isBooleanAttr(key)) {
     // set attribute for blank value
     // e.g. <option disabled>Select one</option>
     if (isFalsyAttrValue(value)) {
       el.removeAttribute(key);
     } else {
       // technically allowfullscreen is a boolean attribute for <iframe>,
       // but Flash expects a value of "true" when used on <embed> tag
       value = key === 'allowfullscreen' && el.tagName === 'EMBED'
         ? 'true'
         : key;
       el.setAttribute(key, value);
     }
   } else if (isEnumeratedAttr(key)) {
     el.setAttribute(key, convertEnumeratedValue(key, value));
   } else if (isXlink(key)) {
     if (isFalsyAttrValue(value)) {
       el.removeAttributeNS(xlinkNS, getXlinkProp(key));
     } else {
       el.setAttributeNS(xlinkNS, key, value);
     }
   } else {
     baseSetAttr(el, key, value);
   }
 }

 function baseSetAttr (el, key, value) {
   if (isFalsyAttrValue(value)) {
     el.removeAttribute(key);
   } else {
     // #7138: IE10 & 11 fires input event when setting placeholder on
     // <textarea>... block the first input event and remove the blocker
     // immediately.
     /* istanbul ignore if */
     if (
       isIE && !isIE9 &&
       el.tagName === 'TEXTAREA' &&
       key === 'placeholder' && value !== '' && !el.__ieph
     ) {
       var blocker = function (e) {
         e.stopImmediatePropagation();
         el.removeEventListener('input', blocker);
       };
       el.addEventListener('input', blocker);
       // $flow-disable-line
       el.__ieph = true; /* IE placeholder patched */
     }
     el.setAttribute(key, value);
   }
 }

 var attrs = {
   create: updateAttrs,
   update: updateAttrs
 };

 /*  */

 function updateClass (oldVnode, vnode) {
   var el = vnode.elm;
   var data = vnode.data;
   var oldData = oldVnode.data;
   if (
     isUndef(data.staticClass) &&
     isUndef(data.class) && (
       isUndef(oldData) || (
         isUndef(oldData.staticClass) &&
         isUndef(oldData.class)
       )
     )
   ) {
     return
   }

   var cls = genClassForVnode(vnode);

   // handle transition classes
   var transitionClass = el._transitionClasses;
   if (isDef(transitionClass)) {
     cls = concat(cls, stringifyClass(transitionClass));
   }

   // set the class
   if (cls !== el._prevClass) {
     el.setAttribute('class', cls);
     el._prevClass = cls;
   }
 }

 var klass = {
   create: updateClass,
   update: updateClass
 };

 /*  */

 /*  */

 /*  */

 /*  */

 // in some cases, the event used has to be determined at runtime
 // so we used some reserved tokens during compile.
 var RANGE_TOKEN = '__r';
 var CHECKBOX_RADIO_TOKEN = '__c';

 /*  */

 // normalize v-model event tokens that can only be determined at runtime.
 // it's important to place the event as the first in the array because
 // the whole point is ensuring the v-model callback gets called before
 // user-attached handlers.
 function normalizeEvents (on) {
   /* istanbul ignore if */
   if (isDef(on[RANGE_TOKEN])) {
     // IE input[type=range] only supports `change` event
     var event = isIE ? 'change' : 'input';
     on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
     delete on[RANGE_TOKEN];
   }
   // This was originally intended to fix #4521 but no longer necessary
   // after 2.5. Keeping it for backwards compat with generated code from < 2.4
   /* istanbul ignore if */
   if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
     on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
     delete on[CHECKBOX_RADIO_TOKEN];
   }
 }

 var target$1;

 function createOnceHandler$1 (event, handler, capture) {
   var _target = target$1; // save current target element in closure
   return function onceHandler () {
     var res = handler.apply(null, arguments);
     if (res !== null) {
       remove$2(event, onceHandler, capture, _target);
     }
   }
 }

 // #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
 // implementation and does not fire microtasks in between event propagation, so
 // safe to exclude.
 var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

 function add$1 (
   name,
   handler,
   capture,
   passive
 ) {
   // async edge case #6566: inner click event triggers patch, event handler
   // attached to outer element during patch, and triggered again. This
   // happens because browsers fire microtask ticks between event propagation.
   // the solution is simple: we save the timestamp when a handler is attached,
   // and the handler would only fire if the event passed to it was fired
   // AFTER it was attached.
   if (useMicrotaskFix) {
     var attachedTimestamp = currentFlushTimestamp;
     var original = handler;
     handler = original._wrapper = function (e) {
       if (
         // no bubbling, should always fire.
         // this is just a safety net in case event.timeStamp is unreliable in
         // certain weird environments...
         e.target === e.currentTarget ||
         // event is fired after handler attachment
         e.timeStamp >= attachedTimestamp ||
         // bail for environments that have buggy event.timeStamp implementations
         // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
         // #9681 QtWebEngine event.timeStamp is negative value
         e.timeStamp <= 0 ||
         // #9448 bail if event is fired in another document in a multi-page
         // electron/nw.js app, since event.timeStamp will be using a different
         // starting reference
         e.target.ownerDocument !== document
       ) {
         return original.apply(this, arguments)
       }
     };
   }
   target$1.addEventListener(
     name,
     handler,
     supportsPassive
       ? { capture: capture, passive: passive }
       : capture
   );
 }

 function remove$2 (
   name,
   handler,
   capture,
   _target
 ) {
   (_target || target$1).removeEventListener(
     name,
     handler._wrapper || handler,
     capture
   );
 }

 function updateDOMListeners (oldVnode, vnode) {
   if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
     return
   }
   var on = vnode.data.on || {};
   var oldOn = oldVnode.data.on || {};
   target$1 = vnode.elm;
   normalizeEvents(on);
   updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
   target$1 = undefined;
 }

 var events = {
   create: updateDOMListeners,
   update: updateDOMListeners
 };

 /*  */

 var svgContainer;

 function updateDOMProps (oldVnode, vnode) {
   if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
     return
   }
   var key, cur;
   var elm = vnode.elm;
   var oldProps = oldVnode.data.domProps || {};
   var props = vnode.data.domProps || {};
   // clone observed objects, as the user probably wants to mutate it
   if (isDef(props.__ob__)) {
     props = vnode.data.domProps = extend({}, props);
   }

   for (key in oldProps) {
     if (!(key in props)) {
       elm[key] = '';
     }
   }

   for (key in props) {
     cur = props[key];
     // ignore children if the node has textContent or innerHTML,
     // as these will throw away existing DOM nodes and cause removal errors
     // on subsequent patches (#3360)
     if (key === 'textContent' || key === 'innerHTML') {
       if (vnode.children) { vnode.children.length = 0; }
       if (cur === oldProps[key]) { continue }
       // #6601 work around Chrome version <= 55 bug where single textNode
       // replaced by innerHTML/textContent retains its parentNode property
       if (elm.childNodes.length === 1) {
         elm.removeChild(elm.childNodes[0]);
       }
     }

     if (key === 'value' && elm.tagName !== 'PROGRESS') {
       // store value as _value as well since
       // non-string values will be stringified
       elm._value = cur;
       // avoid resetting cursor position when value is the same
       var strCur = isUndef(cur) ? '' : String(cur);
       if (shouldUpdateValue(elm, strCur)) {
         elm.value = strCur;
       }
     } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
       // IE doesn't support innerHTML for SVG elements
       svgContainer = svgContainer || document.createElement('div');
       svgContainer.innerHTML = "<svg>" + cur + "</svg>";
       var svg = svgContainer.firstChild;
       while (elm.firstChild) {
         elm.removeChild(elm.firstChild);
       }
       while (svg.firstChild) {
         elm.appendChild(svg.firstChild);
       }
     } else if (
       // skip the update if old and new VDOM state is the same.
       // `value` is handled separately because the DOM value may be temporarily
       // out of sync with VDOM state due to focus, composition and modifiers.
       // This  #4521 by skipping the unnecessary `checked` update.
       cur !== oldProps[key]
     ) {
       // some property updates can throw
       // e.g. `value` on <progress> w/ non-finite value
       try {
         elm[key] = cur;
       } catch (e) {}
     }
   }
 }

 // check platforms/web/util/attrs.js acceptValue


 function shouldUpdateValue (elm, checkVal) {
   return (!elm.composing && (
     elm.tagName === 'OPTION' ||
     isNotInFocusAndDirty(elm, checkVal) ||
     isDirtyWithModifiers(elm, checkVal)
   ))
 }

 function isNotInFocusAndDirty (elm, checkVal) {
   // return true when textbox (.number and .trim) loses focus and its value is
   // not equal to the updated value
   var notInFocus = true;
   // #6157
   // work around IE bug when accessing document.activeElement in an iframe
   try { notInFocus = document.activeElement !== elm; } catch (e) {}
   return notInFocus && elm.value !== checkVal
 }

 function isDirtyWithModifiers (elm, newVal) {
   var value = elm.value;
   var modifiers = elm._vModifiers; // injected by v-model runtime
   if (isDef(modifiers)) {
     if (modifiers.number) {
       return toNumber(value) !== toNumber(newVal)
     }
     if (modifiers.trim) {
       return value.trim() !== newVal.trim()
     }
   }
   return value !== newVal
 }

 var domProps = {
   create: updateDOMProps,
   update: updateDOMProps
 };

 /*  */

 var parseStyleText = cached(function (cssText) {
   var res = {};
   var listDelimiter = /;(?![^(]*\))/g;
   var propertyDelimiter = /:(.+)/;
   cssText.split(listDelimiter).forEach(function (item) {
     if (item) {
       var tmp = item.split(propertyDelimiter);
       tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
     }
   });
   return res
 });

 // merge static and dynamic style data on the same vnode
 function normalizeStyleData (data) {
   var style = normalizeStyleBinding(data.style);
   // static style is pre-processed into an object during compilation
   // and is always a fresh object, so it's safe to merge into it
   return data.staticStyle
     ? extend(data.staticStyle, style)
     : style
 }

 // normalize possible array / string values into Object
 function normalizeStyleBinding (bindingStyle) {
   if (Array.isArray(bindingStyle)) {
     return toObject(bindingStyle)
   }
   if (typeof bindingStyle === 'string') {
     return parseStyleText(bindingStyle)
   }
   return bindingStyle
 }

 /**
  * parent component style should be after child's
  * so that parent component's style could override it
  */
 function getStyle (vnode, checkChild) {
   var res = {};
   var styleData;

   if (checkChild) {
     var childNode = vnode;
     while (childNode.componentInstance) {
       childNode = childNode.componentInstance._vnode;
       if (
         childNode && childNode.data &&
         (styleData = normalizeStyleData(childNode.data))
       ) {
         extend(res, styleData);
       }
     }
   }

   if ((styleData = normalizeStyleData(vnode.data))) {
     extend(res, styleData);
   }

   var parentNode = vnode;
   while ((parentNode = parentNode.parent)) {
     if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
       extend(res, styleData);
     }
   }
   return res
 }

 /*  */

 var cssVarRE = /^--/;
 var importantRE = /\s*!important$/;
 var setProp = function (el, name, val) {
   /* istanbul ignore if */
   if (cssVarRE.test(name)) {
     el.style.setProperty(name, val);
   } else if (importantRE.test(val)) {
     el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
   } else {
     var normalizedName = normalize(name);
     if (Array.isArray(val)) {
       // Support values array created by autoprefixer, e.g.
       // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
       // Set them one by one, and the browser will only set those it can recognize
       for (var i = 0, len = val.length; i < len; i++) {
         el.style[normalizedName] = val[i];
       }
     } else {
       el.style[normalizedName] = val;
     }
   }
 };

 var vendorNames = ['Webkit', 'Moz', 'ms'];

 var emptyStyle;
 var normalize = cached(function (prop) {
   emptyStyle = emptyStyle || document.createElement('div').style;
   prop = camelize(prop);
   if (prop !== 'filter' && (prop in emptyStyle)) {
     return prop
   }
   var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
   for (var i = 0; i < vendorNames.length; i++) {
     var name = vendorNames[i] + capName;
     if (name in emptyStyle) {
       return name
     }
   }
 });

 function updateStyle (oldVnode, vnode) {
   var data = vnode.data;
   var oldData = oldVnode.data;

   if (isUndef(data.staticStyle) && isUndef(data.style) &&
     isUndef(oldData.staticStyle) && isUndef(oldData.style)
   ) {
     return
   }

   var cur, name;
   var el = vnode.elm;
   var oldStaticStyle = oldData.staticStyle;
   var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

   // if static style exists, stylebinding already merged into it when doing normalizeStyleData
   var oldStyle = oldStaticStyle || oldStyleBinding;

   var style = normalizeStyleBinding(vnode.data.style) || {};

   // store normalized style under a different key for next diff
   // make sure to clone it if it's reactive, since the user likely wants
   // to mutate it.
   vnode.data.normalizedStyle = isDef(style.__ob__)
     ? extend({}, style)
     : style;

   var newStyle = getStyle(vnode, true);

   for (name in oldStyle) {
     if (isUndef(newStyle[name])) {
       setProp(el, name, '');
     }
   }
   for (name in newStyle) {
     cur = newStyle[name];
     if (cur !== oldStyle[name]) {
       // ie9 setting to null has no effect, must use empty string
       setProp(el, name, cur == null ? '' : cur);
     }
   }
 }

 var style = {
   create: updateStyle,
   update: updateStyle
 };

 /*  */

 var whitespaceRE = /\s+/;

 /**
  * Add class with compatibility for SVG since classList is not supported on
  * SVG elements in IE
  */
 function addClass (el, cls) {
   /* istanbul ignore if */
   if (!cls || !(cls = cls.trim())) {
     return
   }

   /* istanbul ignore else */
   if (el.classList) {
     if (cls.indexOf(' ') > -1) {
       cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
     } else {
       el.classList.add(cls);
     }
   } else {
     var cur = " " + (el.getAttribute('class') || '') + " ";
     if (cur.indexOf(' ' + cls + ' ') < 0) {
       el.setAttribute('class', (cur + cls).trim());
     }
   }
 }

 /**
  * Remove class with compatibility for SVG since classList is not supported on
  * SVG elements in IE
  */
 function removeClass (el, cls) {
   /* istanbul ignore if */
   if (!cls || !(cls = cls.trim())) {
     return
   }

   /* istanbul ignore else */
   if (el.classList) {
     if (cls.indexOf(' ') > -1) {
       cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
     } else {
       el.classList.remove(cls);
     }
     if (!el.classList.length) {
       el.removeAttribute('class');
     }
   } else {
     var cur = " " + (el.getAttribute('class') || '') + " ";
     var tar = ' ' + cls + ' ';
     while (cur.indexOf(tar) >= 0) {
       cur = cur.replace(tar, ' ');
     }
     cur = cur.trim();
     if (cur) {
       el.setAttribute('class', cur);
     } else {
       el.removeAttribute('class');
     }
   }
 }

 /*  */

 function resolveTransition (def$$1) {
   if (!def$$1) {
     return
   }
   /* istanbul ignore else */
   if (typeof def$$1 === 'object') {
     var res = {};
     if (def$$1.css !== false) {
       extend(res, autoCssTransition(def$$1.name || 'v'));
     }
     extend(res, def$$1);
     return res
   } else if (typeof def$$1 === 'string') {
     return autoCssTransition(def$$1)
   }
 }

 var autoCssTransition = cached(function (name) {
   return {
     enterClass: (name + "-enter"),
     enterToClass: (name + "-enter-to"),
     enterActiveClass: (name + "-enter-active"),
     leaveClass: (name + "-leave"),
     leaveToClass: (name + "-leave-to"),
     leaveActiveClass: (name + "-leave-active")
   }
 });

 var hasTransition = inBrowser && !isIE9;
 var TRANSITION = 'transition';
 var ANIMATION = 'animation';

 // Transition property/event sniffing
 var transitionProp = 'transition';
 var transitionEndEvent = 'transitionend';
 var animationProp = 'animation';
 var animationEndEvent = 'animationend';
 if (hasTransition) {
   /* istanbul ignore if */
   if (window.ontransitionend === undefined &&
     window.onwebkittransitionend !== undefined
   ) {
     transitionProp = 'WebkitTransition';
     transitionEndEvent = 'webkitTransitionEnd';
   }
   if (window.onanimationend === undefined &&
     window.onwebkitanimationend !== undefined
   ) {
     animationProp = 'WebkitAnimation';
     animationEndEvent = 'webkitAnimationEnd';
   }
 }

 // binding to window is necessary to make hot reload work in IE in strict mode
 var raf = inBrowser
   ? window.requestAnimationFrame
     ? window.requestAnimationFrame.bind(window)
     : setTimeout
   : /* istanbul ignore next */ function (fn) { return fn(); };

 function nextFrame (fn) {
   raf(function () {
     raf(fn);
   });
 }

 function addTransitionClass (el, cls) {
   var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
   if (transitionClasses.indexOf(cls) < 0) {
     transitionClasses.push(cls);
     addClass(el, cls);
   }
 }

 function removeTransitionClass (el, cls) {
   if (el._transitionClasses) {
     remove(el._transitionClasses, cls);
   }
   removeClass(el, cls);
 }

 function whenTransitionEnds (
   el,
   expectedType,
   cb
 ) {
   var ref = getTransitionInfo(el, expectedType);
   var type = ref.type;
   var timeout = ref.timeout;
   var propCount = ref.propCount;
   if (!type) { return cb() }
   var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
   var ended = 0;
   var end = function () {
     el.removeEventListener(event, onEnd);
     cb();
   };
   var onEnd = function (e) {
     if (e.target === el) {
       if (++ended >= propCount) {
         end();
       }
     }
   };
   setTimeout(function () {
     if (ended < propCount) {
       end();
     }
   }, timeout + 1);
   el.addEventListener(event, onEnd);
 }

 var transformRE = /\b(transform|all)(,|$)/;

 function getTransitionInfo (el, expectedType) {
   var styles = window.getComputedStyle(el);
   // JSDOM may return undefined for transition properties
   var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
   var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
   var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
   var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
   var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
   var animationTimeout = getTimeout(animationDelays, animationDurations);

   var type;
   var timeout = 0;
   var propCount = 0;
   /* istanbul ignore if */
   if (expectedType === TRANSITION) {
     if (transitionTimeout > 0) {
       type = TRANSITION;
       timeout = transitionTimeout;
       propCount = transitionDurations.length;
     }
   } else if (expectedType === ANIMATION) {
     if (animationTimeout > 0) {
       type = ANIMATION;
       timeout = animationTimeout;
       propCount = animationDurations.length;
     }
   } else {
     timeout = Math.max(transitionTimeout, animationTimeout);
     type = timeout > 0
       ? transitionTimeout > animationTimeout
         ? TRANSITION
         : ANIMATION
       : null;
     propCount = type
       ? type === TRANSITION
         ? transitionDurations.length
         : animationDurations.length
       : 0;
   }
   var hasTransform =
     type === TRANSITION &&
     transformRE.test(styles[transitionProp + 'Property']);
   return {
     type: type,
     timeout: timeout,
     propCount: propCount,
     hasTransform: hasTransform
   }
 }

 function getTimeout (delays, durations) {
   /* istanbul ignore next */
   while (delays.length < durations.length) {
     delays = delays.concat(delays);
   }

   return Math.max.apply(null, durations.map(function (d, i) {
     return toMs(d) + toMs(delays[i])
   }))
 }

 // Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
 // in a locale-dependent way, using a comma instead of a dot.
 // If comma is not replaced with a dot, the input will be rounded down (i.e. acting
 // as a floor function) causing unexpected behaviors
 function toMs (s) {
   return Number(s.slice(0, -1).replace(',', '.')) * 1000
 }

 /*  */

 function enter (vnode, toggleDisplay) {
   var el = vnode.elm;

   // call leave callback now
   if (isDef(el._leaveCb)) {
     el._leaveCb.cancelled = true;
     el._leaveCb();
   }

   var data = resolveTransition(vnode.data.transition);
   if (isUndef(data)) {
     return
   }

   /* istanbul ignore if */
   if (isDef(el._enterCb) || el.nodeType !== 1) {
     return
   }

   var css = data.css;
   var type = data.type;
   var enterClass = data.enterClass;
   var enterToClass = data.enterToClass;
   var enterActiveClass = data.enterActiveClass;
   var appearClass = data.appearClass;
   var appearToClass = data.appearToClass;
   var appearActiveClass = data.appearActiveClass;
   var beforeEnter = data.beforeEnter;
   var enter = data.enter;
   var afterEnter = data.afterEnter;
   var enterCancelled = data.enterCancelled;
   var beforeAppear = data.beforeAppear;
   var appear = data.appear;
   var afterAppear = data.afterAppear;
   var appearCancelled = data.appearCancelled;
   var duration = data.duration;

   // activeInstance will always be the <transition> component managing this
   // transition. One edge case to check is when the <transition> is placed
   // as the root node of a child component. In that case we need to check
   // <transition>'s parent for appear check.
   var context = activeInstance;
   var transitionNode = activeInstance.$vnode;
   while (transitionNode && transitionNode.parent) {
     context = transitionNode.context;
     transitionNode = transitionNode.parent;
   }

   var isAppear = !context._isMounted || !vnode.isRootInsert;

   if (isAppear && !appear && appear !== '') {
     return
   }

   var startClass = isAppear && appearClass
     ? appearClass
     : enterClass;
   var activeClass = isAppear && appearActiveClass
     ? appearActiveClass
     : enterActiveClass;
   var toClass = isAppear && appearToClass
     ? appearToClass
     : enterToClass;

   var beforeEnterHook = isAppear
     ? (beforeAppear || beforeEnter)
     : beforeEnter;
   var enterHook = isAppear
     ? (typeof appear === 'function' ? appear : enter)
     : enter;
   var afterEnterHook = isAppear
     ? (afterAppear || afterEnter)
     : afterEnter;
   var enterCancelledHook = isAppear
     ? (appearCancelled || enterCancelled)
     : enterCancelled;

   var explicitEnterDuration = toNumber(
     isObject(duration)
       ? duration.enter
       : duration
   );

   if (false) {}

   var expectsCSS = css !== false && !isIE9;
   var userWantsControl = getHookArgumentsLength(enterHook);

   var cb = el._enterCb = once(function () {
     if (expectsCSS) {
       removeTransitionClass(el, toClass);
       removeTransitionClass(el, activeClass);
     }
     if (cb.cancelled) {
       if (expectsCSS) {
         removeTransitionClass(el, startClass);
       }
       enterCancelledHook && enterCancelledHook(el);
     } else {
       afterEnterHook && afterEnterHook(el);
     }
     el._enterCb = null;
   });

   if (!vnode.data.show) {
     // remove pending leave element on enter by injecting an insert hook
     mergeVNodeHook(vnode, 'insert', function () {
       var parent = el.parentNode;
       var pendingNode = parent && parent._pending && parent._pending[vnode.key];
       if (pendingNode &&
         pendingNode.tag === vnode.tag &&
         pendingNode.elm._leaveCb
       ) {
         pendingNode.elm._leaveCb();
       }
       enterHook && enterHook(el, cb);
     });
   }

   // start enter transition
   beforeEnterHook && beforeEnterHook(el);
   if (expectsCSS) {
     addTransitionClass(el, startClass);
     addTransitionClass(el, activeClass);
     nextFrame(function () {
       removeTransitionClass(el, startClass);
       if (!cb.cancelled) {
         addTransitionClass(el, toClass);
         if (!userWantsControl) {
           if (isValidDuration(explicitEnterDuration)) {
             setTimeout(cb, explicitEnterDuration);
           } else {
             whenTransitionEnds(el, type, cb);
           }
         }
       }
     });
   }

   if (vnode.data.show) {
     toggleDisplay && toggleDisplay();
     enterHook && enterHook(el, cb);
   }

   if (!expectsCSS && !userWantsControl) {
     cb();
   }
 }

 function leave (vnode, rm) {
   var el = vnode.elm;

   // call enter callback now
   if (isDef(el._enterCb)) {
     el._enterCb.cancelled = true;
     el._enterCb();
   }

   var data = resolveTransition(vnode.data.transition);
   if (isUndef(data) || el.nodeType !== 1) {
     return rm()
   }

   /* istanbul ignore if */
   if (isDef(el._leaveCb)) {
     return
   }

   var css = data.css;
   var type = data.type;
   var leaveClass = data.leaveClass;
   var leaveToClass = data.leaveToClass;
   var leaveActiveClass = data.leaveActiveClass;
   var beforeLeave = data.beforeLeave;
   var leave = data.leave;
   var afterLeave = data.afterLeave;
   var leaveCancelled = data.leaveCancelled;
   var delayLeave = data.delayLeave;
   var duration = data.duration;

   var expectsCSS = css !== false && !isIE9;
   var userWantsControl = getHookArgumentsLength(leave);

   var explicitLeaveDuration = toNumber(
     isObject(duration)
       ? duration.leave
       : duration
   );

   if (false) {}

   var cb = el._leaveCb = once(function () {
     if (el.parentNode && el.parentNode._pending) {
       el.parentNode._pending[vnode.key] = null;
     }
     if (expectsCSS) {
       removeTransitionClass(el, leaveToClass);
       removeTransitionClass(el, leaveActiveClass);
     }
     if (cb.cancelled) {
       if (expectsCSS) {
         removeTransitionClass(el, leaveClass);
       }
       leaveCancelled && leaveCancelled(el);
     } else {
       rm();
       afterLeave && afterLeave(el);
     }
     el._leaveCb = null;
   });

   if (delayLeave) {
     delayLeave(performLeave);
   } else {
     performLeave();
   }

   function performLeave () {
     // the delayed leave may have already been cancelled
     if (cb.cancelled) {
       return
     }
     // record leaving element
     if (!vnode.data.show && el.parentNode) {
       (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
     }
     beforeLeave && beforeLeave(el);
     if (expectsCSS) {
       addTransitionClass(el, leaveClass);
       addTransitionClass(el, leaveActiveClass);
       nextFrame(function () {
         removeTransitionClass(el, leaveClass);
         if (!cb.cancelled) {
           addTransitionClass(el, leaveToClass);
           if (!userWantsControl) {
             if (isValidDuration(explicitLeaveDuration)) {
               setTimeout(cb, explicitLeaveDuration);
             } else {
               whenTransitionEnds(el, type, cb);
             }
           }
         }
       });
     }
     leave && leave(el, cb);
     if (!expectsCSS && !userWantsControl) {
       cb();
     }
   }
 }

 // only used in dev mode
 function checkDuration (val, name, vnode) {
   if (typeof val !== 'number') {
     warn(
       "<transition> explicit " + name + " duration is not a valid number - " +
       "got " + (JSON.stringify(val)) + ".",
       vnode.context
     );
   } else if (isNaN(val)) {
     warn(
       "<transition> explicit " + name + " duration is NaN - " +
       'the duration expression might be incorrect.',
       vnode.context
     );
   }
 }

 function isValidDuration (val) {
   return typeof val === 'number' && !isNaN(val)
 }

 /**
  * Normalize a transition hook's argument length. The hook may be:
  * - a merged hook (invoker) with the original in .fns
  * - a wrapped component method (check ._length)
  * - a plain function (.length)
  */
 function getHookArgumentsLength (fn) {
   if (isUndef(fn)) {
     return false
   }
   var invokerFns = fn.fns;
   if (isDef(invokerFns)) {
     // invoker
     return getHookArgumentsLength(
       Array.isArray(invokerFns)
         ? invokerFns[0]
         : invokerFns
     )
   } else {
     return (fn._length || fn.length) > 1
   }
 }

 function _enter (_, vnode) {
   if (vnode.data.show !== true) {
     enter(vnode);
   }
 }

 var transition = inBrowser ? {
   create: _enter,
   activate: _enter,
   remove: function remove$$1 (vnode, rm) {
     /* istanbul ignore else */
     if (vnode.data.show !== true) {
       leave(vnode, rm);
     } else {
       rm();
     }
   }
 } : {};

 var platformModules = [
   attrs,
   klass,
   events,
   domProps,
   style,
   transition
 ];

 /*  */

 // the directive module should be applied last, after all
 // built-in modules have been applied.
 var modules = platformModules.concat(baseModules);

 var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

 /**
  * Not type checking this file because flow doesn't like attaching
  * properties to Elements.
  */

 /* istanbul ignore if */
 if (isIE9) {
   // http://www.matts411.com/post/internet-explorer-9-oninput/
   document.addEventListener('selectionchange', function () {
     var el = document.activeElement;
     if (el && el.vmodel) {
       trigger(el, 'input');
     }
   });
 }

 var directive = {
   inserted: function inserted (el, binding, vnode, oldVnode) {
     if (vnode.tag === 'select') {
       // #6903
       if (oldVnode.elm && !oldVnode.elm._vOptions) {
         mergeVNodeHook(vnode, 'postpatch', function () {
           directive.componentUpdated(el, binding, vnode);
         });
       } else {
         setSelected(el, binding, vnode.context);
       }
       el._vOptions = [].map.call(el.options, getValue);
     } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
       el._vModifiers = binding.modifiers;
       if (!binding.modifiers.lazy) {
         el.addEventListener('compositionstart', onCompositionStart);
         el.addEventListener('compositionend', onCompositionEnd);
         // Safari < 10.2 & UIWebView doesn't fire compositionend when
         // switching focus before confirming composition choice
         // this also fixes the issue where some browsers e.g. iOS Chrome
         // fires "change" instead of "input" on autocomplete.
         el.addEventListener('change', onCompositionEnd);
         /* istanbul ignore if */
         if (isIE9) {
           el.vmodel = true;
         }
       }
     }
   },

   componentUpdated: function componentUpdated (el, binding, vnode) {
     if (vnode.tag === 'select') {
       setSelected(el, binding, vnode.context);
       // in case the options rendered by v-for have changed,
       // it's possible that the value is out-of-sync with the rendered options.
       // detect such cases and filter out values that no longer has a matching
       // option in the DOM.
       var prevOptions = el._vOptions;
       var curOptions = el._vOptions = [].map.call(el.options, getValue);
       if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
         // trigger change event if
         // no matching option found for at least one value
         var needReset = el.multiple
           ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
           : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
         if (needReset) {
           trigger(el, 'change');
         }
       }
     }
   }
 };

 function setSelected (el, binding, vm) {
   actuallySetSelected(el, binding, vm);
   /* istanbul ignore if */
   if (isIE || isEdge) {
     setTimeout(function () {
       actuallySetSelected(el, binding, vm);
     }, 0);
   }
 }

 function actuallySetSelected (el, binding, vm) {
   var value = binding.value;
   var isMultiple = el.multiple;
   if (isMultiple && !Array.isArray(value)) {
     "production" !== 'production' && warn(
       "<select multiple v-model=\"" + (binding.expression) + "\"> " +
       "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
       vm
     );
     return
   }
   var selected, option;
   for (var i = 0, l = el.options.length; i < l; i++) {
     option = el.options[i];
     if (isMultiple) {
       selected = looseIndexOf(value, getValue(option)) > -1;
       if (option.selected !== selected) {
         option.selected = selected;
       }
     } else {
       if (looseEqual(getValue(option), value)) {
         if (el.selectedIndex !== i) {
           el.selectedIndex = i;
         }
         return
       }
     }
   }
   if (!isMultiple) {
     el.selectedIndex = -1;
   }
 }

 function hasNoMatchingOption (value, options) {
   return options.every(function (o) { return !looseEqual(o, value); })
 }

 function getValue (option) {
   return '_value' in option
     ? option._value
     : option.value
 }

 function onCompositionStart (e) {
   e.target.composing = true;
 }

 function onCompositionEnd (e) {
   // prevent triggering an input event for no reason
   if (!e.target.composing) { return }
   e.target.composing = false;
   trigger(e.target, 'input');
 }

 function trigger (el, type) {
   var e = document.createEvent('HTMLEvents');
   e.initEvent(type, true, true);
   el.dispatchEvent(e);
 }

 /*  */

 // recursively search for possible transition defined inside the component root
 function locateNode (vnode) {
   return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
     ? locateNode(vnode.componentInstance._vnode)
     : vnode
 }

 var show = {
   bind: function bind (el, ref, vnode) {
     var value = ref.value;

     vnode = locateNode(vnode);
     var transition$$1 = vnode.data && vnode.data.transition;
     var originalDisplay = el.__vOriginalDisplay =
       el.style.display === 'none' ? '' : el.style.display;
     if (value && transition$$1) {
       vnode.data.show = true;
       enter(vnode, function () {
         el.style.display = originalDisplay;
       });
     } else {
       el.style.display = value ? originalDisplay : 'none';
     }
   },

   update: function update (el, ref, vnode) {
     var value = ref.value;
     var oldValue = ref.oldValue;

     /* istanbul ignore if */
     if (!value === !oldValue) { return }
     vnode = locateNode(vnode);
     var transition$$1 = vnode.data && vnode.data.transition;
     if (transition$$1) {
       vnode.data.show = true;
       if (value) {
         enter(vnode, function () {
           el.style.display = el.__vOriginalDisplay;
         });
       } else {
         leave(vnode, function () {
           el.style.display = 'none';
         });
       }
     } else {
       el.style.display = value ? el.__vOriginalDisplay : 'none';
     }
   },

   unbind: function unbind (
     el,
     binding,
     vnode,
     oldVnode,
     isDestroy
   ) {
     if (!isDestroy) {
       el.style.display = el.__vOriginalDisplay;
     }
   }
 };

 var platformDirectives = {
   model: directive,
   show: show
 };

 /*  */

 var transitionProps = {
   name: String,
   appear: Boolean,
   css: Boolean,
   mode: String,
   type: String,
   enterClass: String,
   leaveClass: String,
   enterToClass: String,
   leaveToClass: String,
   enterActiveClass: String,
   leaveActiveClass: String,
   appearClass: String,
   appearActiveClass: String,
   appearToClass: String,
   duration: [Number, String, Object]
 };

 // in case the child is also an abstract component, e.g. <keep-alive>
 // we want to recursively retrieve the real component to be rendered
 function getRealChild (vnode) {
   var compOptions = vnode && vnode.componentOptions;
   if (compOptions && compOptions.Ctor.options.abstract) {
     return getRealChild(getFirstComponentChild(compOptions.children))
   } else {
     return vnode
   }
 }

 function extractTransitionData (comp) {
   var data = {};
   var options = comp.$options;
   // props
   for (var key in options.propsData) {
     data[key] = comp[key];
   }
   // events.
   // extract listeners and pass them directly to the transition methods
   var listeners = options._parentListeners;
   for (var key$1 in listeners) {
     data[camelize(key$1)] = listeners[key$1];
   }
   return data
 }

 function placeholder (h, rawChild) {
   if (/\d-keep-alive$/.test(rawChild.tag)) {
     return h('keep-alive', {
       props: rawChild.componentOptions.propsData
     })
   }
 }

 function hasParentTransition (vnode) {
   while ((vnode = vnode.parent)) {
     if (vnode.data.transition) {
       return true
     }
   }
 }

 function isSameChild (child, oldChild) {
   return oldChild.key === child.key && oldChild.tag === child.tag
 }

 var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

 var isVShowDirective = function (d) { return d.name === 'show'; };

 var Transition = {
   name: 'transition',
   props: transitionProps,
   abstract: true,

   render: function render (h) {
     var this$1 = this;

     var children = this.$slots.default;
     if (!children) {
       return
     }

     // filter out text nodes (possible whitespaces)
     children = children.filter(isNotTextNode);
     /* istanbul ignore if */
     if (!children.length) {
       return
     }

     // warn multiple elements
     if (false) {}

     var mode = this.mode;

     // warn invalid mode
     if (false
     ) {}

     var rawChild = children[0];

     // if this is a component root node and the component's
     // parent container node also has transition, skip.
     if (hasParentTransition(this.$vnode)) {
       return rawChild
     }

     // apply transition data to child
     // use getRealChild() to ignore abstract components e.g. keep-alive
     var child = getRealChild(rawChild);
     /* istanbul ignore if */
     if (!child) {
       return rawChild
     }

     if (this._leaving) {
       return placeholder(h, rawChild)
     }

     // ensure a key that is unique to the vnode type and to this transition
     // component instance. This key will be used to remove pending leaving nodes
     // during entering.
     var id = "__transition-" + (this._uid) + "-";
     child.key = child.key == null
       ? child.isComment
         ? id + 'comment'
         : id + child.tag
       : isPrimitive(child.key)
         ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
         : child.key;

     var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
     var oldRawChild = this._vnode;
     var oldChild = getRealChild(oldRawChild);

     // mark v-show
     // so that the transition module can hand over the control to the directive
     if (child.data.directives && child.data.directives.some(isVShowDirective)) {
       child.data.show = true;
     }

     if (
       oldChild &&
       oldChild.data &&
       !isSameChild(child, oldChild) &&
       !isAsyncPlaceholder(oldChild) &&
       // #6687 component root is a comment node
       !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
     ) {
       // replace old child transition data with fresh one
       // important for dynamic transitions!
       var oldData = oldChild.data.transition = extend({}, data);
       // handle transition mode
       if (mode === 'out-in') {
         // return placeholder node and queue update when leave finishes
         this._leaving = true;
         mergeVNodeHook(oldData, 'afterLeave', function () {
           this$1._leaving = false;
           this$1.$forceUpdate();
         });
         return placeholder(h, rawChild)
       } else if (mode === 'in-out') {
         if (isAsyncPlaceholder(child)) {
           return oldRawChild
         }
         var delayedLeave;
         var performLeave = function () { delayedLeave(); };
         mergeVNodeHook(data, 'afterEnter', performLeave);
         mergeVNodeHook(data, 'enterCancelled', performLeave);
         mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
       }
     }

     return rawChild
   }
 };

 /*  */

 var props = extend({
   tag: String,
   moveClass: String
 }, transitionProps);

 delete props.mode;

 var TransitionGroup = {
   props: props,

   beforeMount: function beforeMount () {
     var this$1 = this;

     var update = this._update;
     this._update = function (vnode, hydrating) {
       var restoreActiveInstance = setActiveInstance(this$1);
       // force removing pass
       this$1.__patch__(
         this$1._vnode,
         this$1.kept,
         false, // hydrating
         true // removeOnly (!important, avoids unnecessary moves)
       );
       this$1._vnode = this$1.kept;
       restoreActiveInstance();
       update.call(this$1, vnode, hydrating);
     };
   },

   render: function render (h) {
     var tag = this.tag || this.$vnode.data.tag || 'span';
     var map = Object.create(null);
     var prevChildren = this.prevChildren = this.children;
     var rawChildren = this.$slots.default || [];
     var children = this.children = [];
     var transitionData = extractTransitionData(this);

     for (var i = 0; i < rawChildren.length; i++) {
       var c = rawChildren[i];
       if (c.tag) {
         if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
           children.push(c);
           map[c.key] = c
           ;(c.data || (c.data = {})).transition = transitionData;
         } else if (false) { var name, opts; }
       }
     }

     if (prevChildren) {
       var kept = [];
       var removed = [];
       for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
         var c$1 = prevChildren[i$1];
         c$1.data.transition = transitionData;
         c$1.data.pos = c$1.elm.getBoundingClientRect();
         if (map[c$1.key]) {
           kept.push(c$1);
         } else {
           removed.push(c$1);
         }
       }
       this.kept = h(tag, null, kept);
       this.removed = removed;
     }

     return h(tag, null, children)
   },

   updated: function updated () {
     var children = this.prevChildren;
     var moveClass = this.moveClass || ((this.name || 'v') + '-move');
     if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
       return
     }

     // we divide the work into three loops to avoid mixing DOM reads and writes
     // in each iteration - which helps prevent layout thrashing.
     children.forEach(callPendingCbs);
     children.forEach(recordPosition);
     children.forEach(applyTranslation);

     // force reflow to put everything in position
     // assign to this to avoid being removed in tree-shaking
     // $flow-disable-line
     this._reflow = document.body.offsetHeight;

     children.forEach(function (c) {
       if (c.data.moved) {
         var el = c.elm;
         var s = el.style;
         addTransitionClass(el, moveClass);
         s.transform = s.WebkitTransform = s.transitionDuration = '';
         el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
           if (e && e.target !== el) {
             return
           }
           if (!e || /transform$/.test(e.propertyName)) {
             el.removeEventListener(transitionEndEvent, cb);
             el._moveCb = null;
             removeTransitionClass(el, moveClass);
           }
         });
       }
     });
   },

   methods: {
     hasMove: function hasMove (el, moveClass) {
       /* istanbul ignore if */
       if (!hasTransition) {
         return false
       }
       /* istanbul ignore if */
       if (this._hasMove) {
         return this._hasMove
       }
       // Detect whether an element with the move class applied has
       // CSS transitions. Since the element may be inside an entering
       // transition at this very moment, we make a clone of it and remove
       // all other transition classes applied to ensure only the move class
       // is applied.
       var clone = el.cloneNode();
       if (el._transitionClasses) {
         el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
       }
       addClass(clone, moveClass);
       clone.style.display = 'none';
       this.$el.appendChild(clone);
       var info = getTransitionInfo(clone);
       this.$el.removeChild(clone);
       return (this._hasMove = info.hasTransform)
     }
   }
 };

 function callPendingCbs (c) {
   /* istanbul ignore if */
   if (c.elm._moveCb) {
     c.elm._moveCb();
   }
   /* istanbul ignore if */
   if (c.elm._enterCb) {
     c.elm._enterCb();
   }
 }

 function recordPosition (c) {
   c.data.newPos = c.elm.getBoundingClientRect();
 }

 function applyTranslation (c) {
   var oldPos = c.data.pos;
   var newPos = c.data.newPos;
   var dx = oldPos.left - newPos.left;
   var dy = oldPos.top - newPos.top;
   if (dx || dy) {
     c.data.moved = true;
     var s = c.elm.style;
     s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
     s.transitionDuration = '0s';
   }
 }

 var platformComponents = {
   Transition: Transition,
   TransitionGroup: TransitionGroup
 };

 /*  */

 // install platform specific utils
 Vue.config.mustUseProp = mustUseProp;
 Vue.config.isReservedTag = isReservedTag;
 Vue.config.isReservedAttr = isReservedAttr;
 Vue.config.getTagNamespace = getTagNamespace;
 Vue.config.isUnknownElement = isUnknownElement;

 // install platform runtime directives & components
 extend(Vue.options.directives, platformDirectives);
 extend(Vue.options.components, platformComponents);

 // install platform patch function
 Vue.prototype.__patch__ = inBrowser ? patch : noop;

 // public mount method
 Vue.prototype.$mount = function (
   el,
   hydrating
 ) {
   el = el && inBrowser ? query(el) : undefined;
   return mountComponent(this, el, hydrating)
 };

 // devtools global hook
 /* istanbul ignore next */
 if (inBrowser) {
   setTimeout(function () {
     if (config.devtools) {
       if (devtools) {
         devtools.emit('init', Vue);
       } else if (
         false
       ) {}
     }
     if (false
     ) {}
   }, 0);
 }

 /*  */

 /* harmony default export */ __webpack_exports__["a"] = (Vue);

 /* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(69), __webpack_require__(319).setImmediate))

 /***/ }),
 /* 37 */
 /***/ (function(module, exports, __webpack_require__) {

 var global = __webpack_require__(2);

 var TypeError = global.TypeError;

 // `RequireObjectCoercible` abstract operation
 // https://tc39.es/ecma262/#sec-requireobjectcoercible
 module.exports = function (it) {
   if (it == undefined) throw TypeError("Can't call method on " + it);
   return it;
 };


 /***/ }),
 /* 38 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";

 // EXTERNAL MODULE: ./node_modules/regenerator-runtime/runtime.js
 var runtime = __webpack_require__(16);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
 var es_object_to_string = __webpack_require__(3);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.exec.js
 var es_regexp_exec = __webpack_require__(21);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.split.js
 var es_string_split = __webpack_require__(106);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.promise.js
 var es_promise = __webpack_require__(14);

 // EXTERNAL MODULE: ./node_modules/axios/index.js
 var axios = __webpack_require__(24);
 var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

 // CONCATENATED MODULE: ./src/scripts/core/helpers/unescape.js
 function unescape_unescape(value) {
   var doc = new DOMParser().parseFromString(value, "text/html");
   return doc.body.innerHTML;
 }
 // CONCATENATED MODULE: ./src/scripts/core/objects.js
 /* unused harmony export ROUTE_ROOT */
 /* unused harmony export ROUTE_ACCOUNT */
 /* unused harmony export ROUTE_ACCOUNT_LOGIN */
 /* unused harmony export ROUTE_ACCOUNT_LOGOUT */
 /* unused harmony export ROUTE_ACCOUNT_REGISTER */
 /* unused harmony export ROUTE_ACCOUNT_ADDRESSES */
 /* unused harmony export ROUTE_COLLECTIONS */
 /* unused harmony export ROUTE_ALL_PRODUCTS */
 /* unused harmony export ROUTE_SEARCH */
 /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ROUTE_CART; });
 /* unused harmony export ROUTE_CART_ADD */
 /* unused harmony export ROUTE_CART_CHANGE */
 /* unused harmony export ROUTE_CART_CLEAR */
 /* unused harmony export ROUTE_PRODUCT_RECOMMENDATIONS */
 /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHECKOUT; });
 /* unused harmony export loaded */
 /* unused harmony export objects */
 /* unused harmony export load */
 /* unused harmony export routes */
 /* unused harmony export get */
 /* unused harmony export all */






 function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

 function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }



 var ROUTE_ROOT = "root_url";
 var ROUTE_ACCOUNT = "account_url";
 var ROUTE_ACCOUNT_LOGIN = "account_login_url";
 var ROUTE_ACCOUNT_LOGOUT = "account_logout_url";
 var ROUTE_ACCOUNT_REGISTER = "account_register_url";
 var ROUTE_ACCOUNT_ADDRESSES = "account_addresses_url";
 var ROUTE_COLLECTIONS = "collections_url";
 var ROUTE_ALL_PRODUCTS = "all_products_collection_url";
 var ROUTE_SEARCH = "search_url";
 var ROUTE_CART = "cart_url";
 var ROUTE_CART_ADD = "cart_add_url";
 var ROUTE_CART_CHANGE = "cart_change_url";
 var ROUTE_CART_CLEAR = "cart_clear_url";
 var ROUTE_PRODUCT_RECOMMENDATIONS = "product_recommendations_url";
 var CHECKOUT = "checkout";
 var loaded = false;
 var objects = {};
 function load() {
   return _load.apply(this, arguments);
 }

 function _load() {
   _load = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
     var response;
     return regeneratorRuntime.wrap(function _callee$(_context) {
       while (1) {
         switch (_context.prev = _context.next) {
           case 0:
             _context.next = 2;
             return axios_default.a.get("/?view=objects", {
               responseType: "json"
             }).then(function (response) {
               return response.data;
             });

           case 2:
             response = _context.sent;
             loaded = true;
             objects = response;
             document.dispatchEvent(new CustomEvent("theme:objects:loaded", {
               detail: {
                 objects: objects
               }
             }));

           case 6:
           case "end":
             return _context.stop();
         }
       }
     }, _callee);
   }));
   return _load.apply(this, arguments);
 }

 function routes(route) {
   return objects.routes[route];
 }
 function get(name) {
   try {
     var value = name.split(".").reduce(function (objects, key) {
       if (objects.hasOwnProperty(key)) {
         return objects[key];
       }

       return null;
     }, objects);
     return unescape_unescape(value);
   } catch (error) {}

   return null;
 }
 function objects_all() {
   return objects;
 }
 /* harmony default export */ var core_objects = __webpack_exports__["c"] = ({
   loaded: false,
   objects: {},
   load: load,
   routes: routes,
   get: get,
   all: objects_all
 });

 /***/ }),
 /* 39 */
 /***/ (function(module, exports, __webpack_require__) {

 "use strict";

 var $ = __webpack_require__(13);
 var $find = __webpack_require__(83).find;
 var addToUnscopables = __webpack_require__(116);

 var FIND = 'find';
 var SKIPS_HOLES = true;

 // Shouldn't skip holes
 if (FIND in []) Array(1)[FIND](function () { SKIPS_HOLES = false; });

 // `Array.prototype.find` method
 // https://tc39.es/ecma262/#sec-array.prototype.find
 $({ target: 'Array', proto: true, forced: SKIPS_HOLES }, {
   find: function find(callbackfn /* , that = undefined */) {
     return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
   }
 });

 // https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
 addToUnscopables(FIND);


 /***/ }),
 /* 40 */
 /***/ (function(module, exports, __webpack_require__) {

 var $ = __webpack_require__(13);
 var toObject = __webpack_require__(42);
 var nativeKeys = __webpack_require__(84);
 var fails = __webpack_require__(10);

 var FAILS_ON_PRIMITIVES = fails(function () { nativeKeys(1); });

 // `Object.keys` method
 // https://tc39.es/ecma262/#sec-object.keys
 $({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES }, {
   keys: function keys(it) {
     return nativeKeys(toObject(it));
   }
 });


 /***/ }),
 /* 41 */
 /***/ (function(module, exports, __webpack_require__) {

 var global = __webpack_require__(2);
 var DOMIterables = __webpack_require__(206);
 var DOMTokenListPrototype = __webpack_require__(205);
 var ArrayIteratorMethods = __webpack_require__(31);
 var createNonEnumerableProperty = __webpack_require__(48);
 var wellKnownSymbol = __webpack_require__(12);

 var ITERATOR = wellKnownSymbol('iterator');
 var TO_STRING_TAG = wellKnownSymbol('toStringTag');
 var ArrayValues = ArrayIteratorMethods.values;

 var handlePrototype = function (CollectionPrototype, COLLECTION_NAME) {
   if (CollectionPrototype) {
     // some Chrome versions have non-configurable methods on DOMTokenList
     if (CollectionPrototype[ITERATOR] !== ArrayValues) try {
       createNonEnumerableProperty(CollectionPrototype, ITERATOR, ArrayValues);
     } catch (error) {
       CollectionPrototype[ITERATOR] = ArrayValues;
     }
     if (!CollectionPrototype[TO_STRING_TAG]) {
       createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
     }
     if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
       // some Chrome versions have non-configurable methods on DOMTokenList
       if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
         createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
       } catch (error) {
         CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
       }
     }
   }
 };

 for (var COLLECTION_NAME in DOMIterables) {
   handlePrototype(global[COLLECTION_NAME] && global[COLLECTION_NAME].prototype, COLLECTION_NAME);
 }

 handlePrototype(DOMTokenListPrototype, 'DOMTokenList');


 /***/ }),
 /* 42 */
 /***/ (function(module, exports, __webpack_require__) {

 var global = __webpack_require__(2);
 var requireObjectCoercible = __webpack_require__(37);

 var Object = global.Object;

 // `ToObject` abstract operation
 // https://tc39.es/ecma262/#sec-toobject
 module.exports = function (argument) {
   return Object(requireObjectCoercible(argument));
 };


 /***/ }),
 /* 43 */
 /***/ (function(module, exports, __webpack_require__) {

 var $ = __webpack_require__(13);
 var DESCRIPTORS = __webpack_require__(23);
 var ownKeys = __webpack_require__(139);
 var toIndexedObject = __webpack_require__(30);
 var getOwnPropertyDescriptorModule = __webpack_require__(52);
 var createProperty = __webpack_require__(126);

 // `Object.getOwnPropertyDescriptors` method
 // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
 $({ target: 'Object', stat: true, sham: !DESCRIPTORS }, {
   getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
     var O = toIndexedObject(object);
     var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
     var keys = ownKeys(O);
     var result = {};
     var index = 0;
     var key, descriptor;
     while (keys.length > index) {
       descriptor = getOwnPropertyDescriptor(O, key = keys[index++]);
       if (descriptor !== undefined) createProperty(result, key, descriptor);
     }
     return result;
   }
 });


 /***/ }),
 /* 44 */
 /***/ (function(module, exports, __webpack_require__) {

 var $ = __webpack_require__(13);
 var fails = __webpack_require__(10);
 var toIndexedObject = __webpack_require__(30);
 var nativeGetOwnPropertyDescriptor = __webpack_require__(52).f;
 var DESCRIPTORS = __webpack_require__(23);

 var FAILS_ON_PRIMITIVES = fails(function () { nativeGetOwnPropertyDescriptor(1); });
 var FORCED = !DESCRIPTORS || FAILS_ON_PRIMITIVES;

 // `Object.getOwnPropertyDescriptor` method
 // https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
 $({ target: 'Object', stat: true, forced: FORCED, sham: !DESCRIPTORS }, {
   getOwnPropertyDescriptor: function getOwnPropertyDescriptor(it, key) {
     return nativeGetOwnPropertyDescriptor(toIndexedObject(it), key);
   }
 });


 /***/ }),
 /* 45 */
 /***/ (function(module, exports, __webpack_require__) {

 "use strict";


 var bind = __webpack_require__(202);

 // utils is a library of generic helper functions non-specific to axios

 var toString = Object.prototype.toString;

 /**
  * Determine if a value is an Array
  *
  * @param {Object} val The value to test
  * @returns {boolean} True if value is an Array, otherwise false
  */
 function isArray(val) {
   return toString.call(val) === '[object Array]';
 }

 /**
  * Determine if a value is undefined
  *
  * @param {Object} val The value to test
  * @returns {boolean} True if the value is undefined, otherwise false
  */
 function isUndefined(val) {
   return typeof val === 'undefined';
 }

 /**
  * Determine if a value is a Buffer
  *
  * @param {Object} val The value to test
  * @returns {boolean} True if value is a Buffer, otherwise false
  */
 function isBuffer(val) {
   return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
     && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
 }

 /**
  * Determine if a value is an ArrayBuffer
  *
  * @param {Object} val The value to test
  * @returns {boolean} True if value is an ArrayBuffer, otherwise false
  */
 function isArrayBuffer(val) {
   return toString.call(val) === '[object ArrayBuffer]';
 }

 /**
  * Determine if a value is a FormData
  *
  * @param {Object} val The value to test
  * @returns {boolean} True if value is an FormData, otherwise false
  */
 function isFormData(val) {
   return (typeof FormData !== 'undefined') && (val instanceof FormData);
 }

 /**
  * Determine if a value is a view on an ArrayBuffer
  *
  * @param {Object} val The value to test
  * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
  */
 function isArrayBufferView(val) {
   var result;
   if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
     result = ArrayBuffer.isView(val);
   } else {
     result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
   }
   return result;
 }

 /**
  * Determine if a value is a String
  *
  * @param {Object} val The value to test
  * @returns {boolean} True if value is a String, otherwise false
  */
 function isString(val) {
   return typeof val === 'string';
 }

 /**
  * Determine if a value is a Number
  *
  * @param {Object} val The value to test
  * @returns {boolean} True if value is a Number, otherwise false
  */
 function isNumber(val) {
   return typeof val === 'number';
 }

 /**
  * Determine if a value is an Object
  *
  * @param {Object} val The value to test
  * @returns {boolean} True if value is an Object, otherwise false
  */
 function isObject(val) {
   return val !== null && typeof val === 'object';
 }

 /**
  * Determine if a value is a plain Object
  *
  * @param {Object} val The value to test
  * @return {boolean} True if value is a plain Object, otherwise false
  */
 function isPlainObject(val) {
   if (toString.call(val) !== '[object Object]') {
     return false;
   }

   var prototype = Object.getPrototypeOf(val);
   return prototype === null || prototype === Object.prototype;
 }

 /**
  * Determine if a value is a Date
  *
  * @param {Object} val The value to test
  * @returns {boolean} True if value is a Date, otherwise false
  */
 function isDate(val) {
   return toString.call(val) === '[object Date]';
 }

 /**
  * Determine if a value is a File
  *
  * @param {Object} val The value to test
  * @returns {boolean} True if value is a File, otherwise false
  */
 function isFile(val) {
   return toString.call(val) === '[object File]';
 }

 /**
  * Determine if a value is a Blob
  *
  * @param {Object} val The value to test
  * @returns {boolean} True if value is a Blob, otherwise false
  */
 function isBlob(val) {
   return toString.call(val) === '[object Blob]';
 }

 /**
  * Determine if a value is a Function
  *
  * @param {Object} val The value to test
  * @returns {boolean} True if value is a Function, otherwise false
  */
 function isFunction(val) {
   return toString.call(val) === '[object Function]';
 }

 /**
  * Determine if a value is a Stream
  *
  * @param {Object} val The value to test
  * @returns {boolean} True if value is a Stream, otherwise false
  */
 function isStream(val) {
   return isObject(val) && isFunction(val.pipe);
 }

 /**
  * Determine if a value is a URLSearchParams object
  *
  * @param {Object} val The value to test
  * @returns {boolean} True if value is a URLSearchParams object, otherwise false
  */
 function isURLSearchParams(val) {
   return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
 }

 /**
  * Trim excess whitespace off the beginning and end of a string
  *
  * @param {String} str The String to trim
  * @returns {String} The String freed of excess whitespace
  */
 function trim(str) {
   return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
 }

 /**
  * Determine if we're running in a standard browser environment
  *
  * This allows axios to run in a web worker, and react-native.
  * Both environments support XMLHttpRequest, but not fully standard globals.
  *
  * web workers:
  *  typeof window -> undefined
  *  typeof document -> undefined
  *
  * react-native:
  *  navigator.product -> 'ReactNative'
  * nativescript
  *  navigator.product -> 'NativeScript' or 'NS'
  */
 function isStandardBrowserEnv() {
   if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                            navigator.product === 'NativeScript' ||
                                            navigator.product === 'NS')) {
     return false;
   }
   return (
     typeof window !== 'undefined' &&
     typeof document !== 'undefined'
   );
 }

 /**
  * Iterate over an Array or an Object invoking a function for each item.
  *
  * If `obj` is an Array callback will be called passing
  * the value, index, and complete array for each item.
  *
  * If 'obj' is an Object callback will be called passing
  * the value, key, and complete object for each property.
  *
  * @param {Object|Array} obj The object to iterate
  * @param {Function} fn The callback to invoke for each item
  */
 function forEach(obj, fn) {
   // Don't bother if no value provided
   if (obj === null || typeof obj === 'undefined') {
     return;
   }

   // Force an array if not already something iterable
   if (typeof obj !== 'object') {
     /*eslint no-param-reassign:0*/
     obj = [obj];
   }

   if (isArray(obj)) {
     // Iterate over array values
     for (var i = 0, l = obj.length; i < l; i++) {
       fn.call(null, obj[i], i, obj);
     }
   } else {
     // Iterate over object keys
     for (var key in obj) {
       if (Object.prototype.hasOwnProperty.call(obj, key)) {
         fn.call(null, obj[key], key, obj);
       }
     }
   }
 }

 /**
  * Accepts varargs expecting each argument to be an object, then
  * immutably merges the properties of each object and returns result.
  *
  * When multiple objects contain the same key the later object in
  * the arguments list will take precedence.
  *
  * Example:
  *
  * ```js
  * var result = merge({foo: 123}, {foo: 456});
  * console.log(result.foo); // outputs 456
  * ```
  *
  * @param {Object} obj1 Object to merge
  * @returns {Object} Result of all merge properties
  */
 function merge(/* obj1, obj2, obj3, ... */) {
   var result = {};
   function assignValue(val, key) {
     if (isPlainObject(result[key]) && isPlainObject(val)) {
       result[key] = merge(result[key], val);
     } else if (isPlainObject(val)) {
       result[key] = merge({}, val);
     } else if (isArray(val)) {
       result[key] = val.slice();
     } else {
       result[key] = val;
     }
   }

   for (var i = 0, l = arguments.length; i < l; i++) {
     forEach(arguments[i], assignValue);
   }
   return result;
 }

 /**
  * Extends object a by mutably adding to it the properties of object b.
  *
  * @param {Object} a The object to be extended
  * @param {Object} b The object to copy properties from
  * @param {Object} thisArg The object to bind function to
  * @return {Object} The resulting value of object a
  */
 function extend(a, b, thisArg) {
   forEach(b, function assignValue(val, key) {
     if (thisArg && typeof val === 'function') {
       a[key] = bind(val, thisArg);
     } else {
       a[key] = val;
     }
   });
   return a;
 }

 /**
  * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
  *
  * @param {string} content with BOM
  * @return {string} content value without BOM
  */
 function stripBOM(content) {
   if (content.charCodeAt(0) === 0xFEFF) {
     content = content.slice(1);
   }
   return content;
 }

 module.exports = {
   isArray: isArray,
   isArrayBuffer: isArrayBuffer,
   isBuffer: isBuffer,
   isFormData: isFormData,
   isArrayBufferView: isArrayBufferView,
   isString: isString,
   isNumber: isNumber,
   isObject: isObject,
   isPlainObject: isPlainObject,
   isUndefined: isUndefined,
   isDate: isDate,
   isFile: isFile,
   isBlob: isBlob,
   isFunction: isFunction,
   isStream: isStream,
   isURLSearchParams: isURLSearchParams,
   isStandardBrowserEnv: isStandardBrowserEnv,
   forEach: forEach,
   merge: merge,
   extend: extend,
   trim: trim,
   stripBOM: stripBOM
 };


 /***/ }),
 /* 46 */
 /***/ (function(module, exports, __webpack_require__) {

 var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  * JavaScript Cookie v2.2.1
  * https://github.com/js-cookie/js-cookie
  *
  * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
  * Released under the MIT license
  */
 ;(function (factory) {
   var registeredInModuleLoader;
   if (true) {
     !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
         __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
         (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
         __WEBPACK_AMD_DEFINE_FACTORY__),
         __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
     registeredInModuleLoader = true;
   }
   if (true) {
     module.exports = factory();
     registeredInModuleLoader = true;
   }
   if (!registeredInModuleLoader) {
     var OldCookies = window.Cookies;
     var api = window.Cookies = factory();
     api.noConflict = function () {
       window.Cookies = OldCookies;
       return api;
     };
   }
 }(function () {
   function extend () {
     var i = 0;
     var result = {};
     for (; i < arguments.length; i++) {
       var attributes = arguments[ i ];
       for (var key in attributes) {
         result[key] = attributes[key];
       }
     }
     return result;
   }

   function decode (s) {
     return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
   }

   function init (converter) {
     function api() {}

     function set (key, value, attributes) {
       if (typeof document === 'undefined') {
         return;
       }

       attributes = extend({
         path: '/'
       }, api.defaults, attributes);

       if (typeof attributes.expires === 'number') {
         attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
       }

       // We're using "expires" because "max-age" is not supported by IE
       attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

       try {
         var result = JSON.stringify(value);
         if (/^[\{\[]/.test(result)) {
           value = result;
         }
       } catch (e) {}

       value = converter.write ?
         converter.write(value, key) :
         encodeURIComponent(String(value))
           .replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);

       key = encodeURIComponent(String(key))
         .replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
         .replace(/[\(\)]/g, escape);

       var stringifiedAttributes = '';
       for (var attributeName in attributes) {
         if (!attributes[attributeName]) {
           continue;
         }
         stringifiedAttributes += '; ' + attributeName;
         if (attributes[attributeName] === true) {
           continue;
         }

         // Considers RFC 6265 section 5.2:
         // ...
         // 3.  If the remaining unparsed-attributes contains a %x3B (";")
         //     character:
         // Consume the characters of the unparsed-attributes up to,
         // not including, the first %x3B (";") character.
         // ...
         stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
       }

       return (document.cookie = key + '=' + value + stringifiedAttributes);
     }

     function get (key, json) {
       if (typeof document === 'undefined') {
         return;
       }

       var jar = {};
       // To prevent the for loop in the first place assign an empty array
       // in case there are no cookies at all.
       var cookies = document.cookie ? document.cookie.split('; ') : [];
       var i = 0;

       for (; i < cookies.length; i++) {
         var parts = cookies[i].split('=');
         var cookie = parts.slice(1).join('=');

         if (!json && cookie.charAt(0) === '"') {
           cookie = cookie.slice(1, -1);
         }

         try {
           var name = decode(parts[0]);
           cookie = (converter.read || converter)(cookie, name) ||
             decode(cookie);

           if (json) {
             try {
               cookie = JSON.parse(cookie);
             } catch (e) {}
           }

           jar[name] = cookie;

           if (key === name) {
             break;
           }
         } catch (e) {}
       }

       return key ? jar[key] : jar;
     }

     api.set = set;
     api.get = function (key) {
       return get(key, false /* read as raw */);
     };
     api.getJSON = function (key) {
       return get(key, true /* read as json */);
     };
     api.remove = function (key, attributes) {
       set(key, '', extend(attributes, {
         expires: -1
       }));
     };

     api.defaults = {};

     api.withConverter = init;

     return api;
   }

   return init(function () {});
 }));


 /***/ }),
 /* 47 */
 /***/ (function(module, exports, __webpack_require__) {

 var uncurryThis = __webpack_require__(5);

 var toString = uncurryThis({}.toString);
 var stringSlice = uncurryThis(''.slice);

 module.exports = function (it) {
   return stringSlice(toString(it), 8, -1);
 };


 /***/ }),
 /* 48 */
 /***/ (function(module, exports, __webpack_require__) {

 var DESCRIPTORS = __webpack_require__(23);
 var definePropertyModule = __webpack_require__(26);
 var createPropertyDescriptor = __webpack_require__(67);

 module.exports = DESCRIPTORS ? function (object, key, value) {
   return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
 } : function (object, key, value) {
   object[key] = value;
   return object;
 };


 /***/ }),
 /* 49 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";
 __webpack_require__.r(__webpack_exports__);
 /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "initProductCards", function() { return initProductCards; });
 /* harmony import */ var regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(16);
 /* harmony import */ var regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73);
 /* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_1__);
 /* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27);
 /* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_2__);
 /* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3);
 /* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_3__);
 /* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8);
 /* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_4__);
 /* harmony import */ var core_js_modules_es_number_to_fixed_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(317);
 /* harmony import */ var core_js_modules_es_number_to_fixed_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_to_fixed_js__WEBPACK_IMPORTED_MODULE_5__);
 /* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(51);
 /* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_6__);
 /* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(25);
 /* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_7__);
 /* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(21);
 /* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_8__);
 /* harmony import */ var core_js_modules_es_string_split_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(106);
 /* harmony import */ var core_js_modules_es_string_split_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split_js__WEBPACK_IMPORTED_MODULE_9__);
 /* harmony import */ var core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(82);
 /* harmony import */ var core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_10__);
 /* harmony import */ var core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(81);
 /* harmony import */ var core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_11__);
 /* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(14);
 /* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_12__);
 /* harmony import */ var _shopify_theme_currency__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(71);
 /* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(46);
 /* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(js_cookie__WEBPACK_IMPORTED_MODULE_14__);
 /* harmony import */ var _vue_store__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(20);
 /* harmony import */ var _vue_store_cart_cart__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(15);


 function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

 function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

















 var selectors = {
   productBox: "[data-product]",
   productColors: "[data-product-colors]",
   productColor: "[data-product-color]",
   productSizes: "[data-product-sizes]",
   productSize: "[data-product-size]",
   productImg: "[data-product-img]",
   productJson: "[data-product-json]",
   productComparedAtPrice: "[data-product-compared-at-price]",
   productPrice: "[data-product-price]",
   productViewBandge: "[data-product-view]",
   productSaleBadge: "[data-product-sale]",
   productBestSellerBadge: "[data-product-best-seller]",
   productNewBandge: "[data-product-new]",
   productNewSale: "[data-product-new-sale]" //,
   // revert: "[data-revert]",
   // revertContainer: "[data-revert-container]"

 };
 var modifiers = {
   bandgeNone: "product-card__badge-wrapper--none",
   imageShow: "product-card__images-box--show"
 };

 function ProductCard(container) {
   this.container = container;
   this.productJson = JSON.parse(this.container.querySelector(selectors.productJson).innerHTML);
   this.images = Array.from(this.container.querySelectorAll(selectors.productImg));
   this.colorsBox = this.container.querySelector(selectors.productColors);
   this.colors = Array.from(this.container.querySelectorAll(selectors.productColor));
   this.sizesBoxs = this.container.querySelectorAll(selectors.productSizes);
   this.sizes = Array.from(this.container.querySelectorAll(selectors.productSize));
   this.comparedAtPrice = this.container.querySelectorAll(selectors.productComparedAtPrice);
   this.price = this.container.querySelectorAll(selectors.productPrice);
   this.viewedBadge = this.container.querySelector(selectors.productViewBandge);
   this.newBadge = this.container.querySelector(selectors.productNewBandge);
   this.newSaleBadge = this.container.querySelector(selectors.productNewSale);
   this.saleBadge = this.container.querySelector(selectors.productSaleBadge);
   this.bestSellerBadge = this.container.querySelector(selectors.productBestSellerBadge); // this.reverts = this.container.querySelectorAll(selectors.revert);

   this.productBadges();
   setTimeout(() => {
    this.initEvents();
   }, 1200)
   /* this.initEvents(); */ // this.initRevert();

 }

 ProductCard.prototype.initEvents = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
   var _this = this;

   return regeneratorRuntime.wrap(function _callee$(_context) {

    this.images = Array.from(this.container.querySelectorAll(selectors.productImg));
    this.colorsBox = this.container.querySelector(selectors.productColors);
    this.colors = Array.from(this.container.querySelectorAll(selectors.productColor));

     while (1) {
       switch (_context.prev = _context.next) {
         case 0:
           //async
           this.colorsBox.addEventListener("click", function (event) {
             event.preventDefault();
             event.stopPropagation();
             var target = event.target;

             if (target.dataset.productColor) {
               var color_num = target.dataset.productColor;

               _this.onColorOptionChange.bind(_this).call(target, color_num);
             }
           });

           if (this.sizesBoxs) {
             _context.next = 3;
             break;
           }

           return _context.abrupt("return");

         case 3:
           this.sizesBoxs.forEach(function (sizeBox) {
             sizeBox.addEventListener("click", function (event) {
               event.preventDefault();
               event.stopPropagation();
               var target = event.target.tagName == 'LI' ? event.target : event.target.parentNode;

               if (target.dataset.productFastadd === "true") {
                 var variantId = target.dataset.productVariant;

                 _this.addItems([{
                   id: variantId,
                   quantity: 1
                 }]);
               }
             });
           });

         case 4:
         case "end":
           return _context.stop();
       }
     }
   }, _callee, this);
 }));
 ProductCard.prototype.addItems = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
   var items,
       errorCallback,
       _args2 = arguments;
   return regeneratorRuntime.wrap(function _callee2$(_context2) {
     while (1) {
       switch (_context2.prev = _context2.next) {
         case 0:
           items = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : [];
           errorCallback = typeof event.detail.errorCallback === "function" ? event.detail.errorCallback : function () {};
           _context2.next = 4;
           return _vue_store__WEBPACK_IMPORTED_MODULE_15__[/* store */ "a"].dispatch("cart/".concat(_vue_store_cart_cart__WEBPACK_IMPORTED_MODULE_16__[/* ACTION_ADD_TO_CART */ "a"]), {
             products: items,
             errorCallback: errorCallback
           });

         case 4:
           document.dispatchEvent(new CustomEvent("minicart:open"));
           document.dispatchEvent(new CustomEvent("cart_changed"));
         case 5:
         case "end":
           return _context2.stop();
       }
     }
   }, _callee2);
 }));

 ProductCard.prototype.onColorOptionChange = function (color_num) {
   this.updateImage(color_num);
   this.updateColor(color_num);
   this.updateSize(color_num);
   this.updateComparedAtPrice(color_num);
   this.updatePrices(color_num);
   this.productBadges(color_num - 1);
   this.updateSalesBadge(color_num);
 };

 ProductCard.prototype.updateImage = function (color_num) {
   this.images.forEach(function (image) {
     image.classList.remove(modifiers.imageShow);

     if (image.dataset.productImg === color_num) {
       image.classList.add(modifiers.imageShow);
     }
   });
 };

 ProductCard.prototype.updateColor = function (color_num) {
   this.colors.forEach((color) => {
     color.classList.remove("product-card__color-item--active");

     if (color.dataset.productColor === color_num) {
       color.classList.add("product-card__color-item--active");

       if (window.innerWidth > 768) {
         color.closest('.product-card').classList.remove('first-hover');
       }

       console.log("The color item is active");

       this.container.querySelectorAll('.product-card__title').forEach(title => {
         title.innerHTML = color.dataset.colorTitle;
       })
     }
   });
 };

 ProductCard.prototype.updateSize = function (color_num) {
   if (!this.sizes) return;
   this.sizes.forEach(function (size) {
     size.classList.remove("product-card__sizes-list--active");

     if (size.dataset.productSize === color_num) {
       size.classList.add("product-card__sizes-list--active");
     }
   });
 };

 ProductCard.prototype.updateComparedAtPrice = function (color_num) {
   if (!this.productJson) return;
   var json = this.productJson
   this.comparedAtPrice.forEach((comparedAtPrice) => {
     if (this.productJson[color_num - 1].compareAtPrice > this.productJson[color_num - 1].price) {
       comparedAtPrice.innerText = Object(_shopify_theme_currency__WEBPACK_IMPORTED_MODULE_13__[/* formatMoney */ "a"])(this.productJson[color_num - 1].compareAtPrice);
       comparedAtPrice.classList.remove("hidden");
       
     } else {
       comparedAtPrice.classList.add("hidden");
    
     }
   });
 };

 ProductCard.prototype.updatePrices = function (color_num) {
   if (!this.productJson) return;
   this.price.forEach((price) => {
     price.innerText = Object(_shopify_theme_currency__WEBPACK_IMPORTED_MODULE_13__[/* formatMoney */ "a"])(this.productJson[color_num - 1].price);
   });
 };

 ProductCard.prototype.updateSalesBadge = function (color_num) {
   if (!this.productJson) return;

   if (this.saleBadge && this.productJson[color_num - 1].compareAtPrice) {
     var percentage = this.productJson[color_num - 1].price / this.productJson[color_num - 1].compareAtPrice;
     percentage = (1 - percentage).toFixed(2) * 100;
    
     this.saleBadge.innerHTML = "<div class=\"product-card__badge\">".concat(percentage, "% Off</div>");
     if (percentage > 0 ){
      this.saleBadge.innerHTML = "<div class=\"product-card__badge\" style=\"display:block;\">".concat(percentage, "% Off</div>");
    }
   } else if (this.saleBadge && !this.productJson[color_num - 1].compareAtPrice) {
     this.saleBadge.innerHTML = "<div class=\"product-card__badge\"></div>";
   }
 };

 ProductCard.prototype.productBadges = function () {
   var numColor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
   var recently_viewed = js_cookie__WEBPACK_IMPORTED_MODULE_14___default.a.get("recently_viewed");
   var productViewedBandge = false;
   var ids = recently_viewed.split(",").filter(function (id) {
     return id;
   }).map(function (id) {
     return +id;
   });
   
   if (this.colorsBox){
    if (this.colorsBox.querySelector(".product-card__color-item--active")){

    }else {
      return;
    }
    
   }
   if (!this.productJson) return;

   //if (!this.productJson || !this.colorsBox.querySelector(".product-card__color-item--active")) return;

   if (numColor === null && this.colorsBox) {
     numColor = this.colorsBox.querySelector(".product-card__color-item--active").dataset.productColor - 1;
   }

   /* console.log(color_num); */

   if (this.productJson && this.productJson[numColor]) {
    if (ids.includes(this.productJson[numColor].id)) {
        productViewedBandge = true;
    }
   }
   
   if (this.newSaleBadge && this.productJson[numColor].tags.includes('new-sale')) {
    this.viewedBadge.classList.add(modifiers.bandgeNone);
    this.newSaleBadge.classList.remove(modifiers.bandgeNone);
   } else if (productViewedBandge) {
     this.viewedBadge.classList.remove(modifiers.bandgeNone);
     if (this.newBadge) this.newBadge.classList.add(modifiers.bandgeNone);
     if (this.saleBadge) this.saleBadge.classList.add(modifiers.bandgeNone);
     if (this.bestSellerBadge) this.bestSellerBadge.classList.add(modifiers.bandgeNone);
   } else {
     this.viewedBadge.classList.add(modifiers.bandgeNone);

     if (this.newBadge && this.productJson[numColor]?.tags?.includes('collection:New')) {
       this.newBadge.classList.remove(modifiers.bandgeNone);
     } else {
        this.newBadge?.classList.add(modifiers.bandgeNone);
     }

     if (this.saleBadge && this.productJson[numColor].compareAtPrice) {
       this.saleBadge.classList.remove(modifiers.bandgeNone);
     } else {
      this.saleBadge?.classList.add(modifiers.bandgeNone);
     }

     if (this.bestSellerBadge) {
       this.bestSellerBadge.classList.remove(modifiers.bandgeNone);
     };
   }
 }; 
 
 // ProductCard.prototype.initRevert = function () {
 // 	if (!this.reverts) return null;
 //
 // 	this.reverts.forEach((revert) => {
 // 		revert.addEventListener("click", () => {
 // 			if (revert.dataset.revert === "front") {
 // 				this.container
 // 					.querySelector('[data-revert-container="front"]')
 // 					.classList.remove("product-card__revert-no-view");
 // 				this.container
 // 					.querySelector('[data-revert-container="back"]')
 // 					.classList.remove("product-card__revert-view");
 // 			} else if (revert.dataset.revert === "back") {
 // 				this.container
 // 					.querySelector('[data-revert-container="front"]')
 // 					.classList.add("product-card__revert-no-view");
 // 				this.container
 // 					.querySelector('[data-revert-container="back"]')
 // 					.classList.add("product-card__revert-view");
 // 			}
 // 		});
 // 	});
 // };


 function initProductCards() {
   var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "[data-product-card]";
   var containers = document.querySelectorAll(selector);

   if (!containers.length) {
     return;
   }

   Array.from(containers).filter(function (element) {
     return !element.classList.contains("product-card--initialized")
   }).forEach(function (element) {
     new ProductCard(element);
     element.classList.add("product-card--initialized");
   });

   setTimeout(() => {
    if (window.innerWidth > 768) {
      document.querySelectorAll('.product-card--boost').forEach(function(element) {
        const image_wrapper = element.querySelector('.product-card__image-wrapper');

        image_wrapper.addEventListener('mouseover', function(evt) {
          evt.currentTarget.closest('.product-card--boost').classList.add('first-hover');
        });
        image_wrapper.addEventListener('mouseleave', function(evt) {
          evt.currentTarget.closest('.product-card--boost').classList.remove('first-hover');
        });
      })
    }
  }, 5000);
  
      $(document).on("click", ".quick-add-mobile", function(event) {
        event.preventDefault();
        event.stopPropagation();
        
        // $(event.target).closest('.product-card__content').find('.myModal').css('display', 'block');
        // $(event.target).closest('.product-card__content').find('.myModal').addClass('open');
        $('.modal-general').addClass('open');
        $('.modal-general').css('display', 'block');
        $('.modal-general').html($(event.target).closest('.product-card__content').find('.myModal').html());
        $("body").css("overflow", "hidden");
    });

    $(document).on("click", ".myModal .close", function(event) {
        event.preventDefault();
        event.stopPropagation();

        $('.myModal').css('display', 'none');
        $(event.target).closest('.product-card__content').find('.myModal').removeClass('open');
        $("body").css("overflow", "auto");
    });

    $(document).on("click", ".product-card__sizes-item", function(event) {
        event.preventDefault();
        event.stopPropagation();
        let target = event.target.tagName == 'LI' ? event.target : event.target.parentNode;

        if (target.dataset.productFastadd === "true") {
            let variantId = target.dataset.productVariant;

            const productCardInstance = window.initProductCards(document.querySelector('.product-card'));

            productCardInstance.addItems([{
                id: variantId,
                quantity: 1
            }]);
        }

        setTimeout(function() {
            $('.myModal').css('display', 'none');
            $(event.target).closest('.product-card__content').find('.myModal').removeClass('open');
        }, 1500);
        $("body").css("overflow", "auto");
    });
 }

 window.initProductCards = function (selectors) {
   return new ProductCard(selectors);
 };

 /* harmony default export */ __webpack_exports__["default"] = (ProductCard);

 /***/ }),
 /* 50 */
 /***/ (function(module, exports, __webpack_require__) {

 "use strict";

 var $ = __webpack_require__(13);
 var global = __webpack_require__(2);
 var fails = __webpack_require__(10);
 var isArray = __webpack_require__(105);
 var isObject = __webpack_require__(18);
 var toObject = __webpack_require__(42);
 var lengthOfArrayLike = __webpack_require__(56);
 var createProperty = __webpack_require__(126);
 var arraySpeciesCreate = __webpack_require__(128);
 var arrayMethodHasSpeciesSupport = __webpack_require__(127);
 var wellKnownSymbol = __webpack_require__(12);
 var V8_VERSION = __webpack_require__(95);

 var IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable');
 var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
 var MAXIMUM_ALLOWED_INDEX_EXCEEDED = 'Maximum allowed index exceeded';
 var TypeError = global.TypeError;

 // We can't use this feature detection in V8 since it causes
 // deoptimization and serious performance degradation
 // https://github.com/zloirock/core-js/issues/679
 var IS_CONCAT_SPREADABLE_SUPPORT = V8_VERSION >= 51 || !fails(function () {
   var array = [];
   array[IS_CONCAT_SPREADABLE] = false;
   return array.concat()[0] !== array;
 });

 var SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('concat');

 var isConcatSpreadable = function (O) {
   if (!isObject(O)) return false;
   var spreadable = O[IS_CONCAT_SPREADABLE];
   return spreadable !== undefined ? !!spreadable : isArray(O);
 };

 var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !SPECIES_SUPPORT;

 // `Array.prototype.concat` method
 // https://tc39.es/ecma262/#sec-array.prototype.concat
 // with adding support of @@isConcatSpreadable and @@species
 $({ target: 'Array', proto: true, forced: FORCED }, {
   // eslint-disable-next-line no-unused-vars -- required for `.length`
   concat: function concat(arg) {
     var O = toObject(this);
     var A = arraySpeciesCreate(O, 0);
     var n = 0;
     var i, k, length, len, E;
     for (i = -1, length = arguments.length; i < length; i++) {
       E = i === -1 ? O : arguments[i];
       if (isConcatSpreadable(E)) {
         len = lengthOfArrayLike(E);
         if (n + len > MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
         for (k = 0; k < len; k++, n++) if (k in E) createProperty(A, n, E[k]);
       } else {
         if (n >= MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
         createProperty(A, n++, E);
       }
     }
     A.length = n;
     return A;
   }
 });


 /***/ }),
 /* 51 */
 /***/ (function(module, exports, __webpack_require__) {

 "use strict";

 var $ = __webpack_require__(13);
 var $map = __webpack_require__(83).map;
 var arrayMethodHasSpeciesSupport = __webpack_require__(127);

 var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('map');

 // `Array.prototype.map` method
 // https://tc39.es/ecma262/#sec-array.prototype.map
 // with adding support of @@species
 $({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
   map: function map(callbackfn /* , thisArg */) {
     return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
   }
 });


 /***/ }),
 /* 52 */
 /***/ (function(module, exports, __webpack_require__) {

 var DESCRIPTORS = __webpack_require__(23);
 var call = __webpack_require__(22);
 var propertyIsEnumerableModule = __webpack_require__(109);
 var createPropertyDescriptor = __webpack_require__(67);
 var toIndexedObject = __webpack_require__(30);
 var toPropertyKey = __webpack_require__(93);
 var hasOwn = __webpack_require__(19);
 var IE8_DOM_DEFINE = __webpack_require__(121);

 // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
 var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

 // `Object.getOwnPropertyDescriptor` method
 // https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
 exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
   O = toIndexedObject(O);
   P = toPropertyKey(P);
   if (IE8_DOM_DEFINE) try {
     return $getOwnPropertyDescriptor(O, P);
   } catch (error) { /* empty */ }
   if (hasOwn(O, P)) return createPropertyDescriptor(!call(propertyIsEnumerableModule.f, O, P), O[P]);
 };


 /***/ }),
 /* 53 */
 /***/ (function(module, exports, __webpack_require__) {

 var NATIVE_WEAK_MAP = __webpack_require__(167);
 var global = __webpack_require__(2);
 var uncurryThis = __webpack_require__(5);
 var isObject = __webpack_require__(18);
 var createNonEnumerableProperty = __webpack_require__(48);
 var hasOwn = __webpack_require__(19);
 var shared = __webpack_require__(98);
 var sharedKey = __webpack_require__(91);
 var hiddenKeys = __webpack_require__(66);

 var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
 var TypeError = global.TypeError;
 var WeakMap = global.WeakMap;
 var set, get, has;

 var enforce = function (it) {
   return has(it) ? get(it) : set(it, {});
 };

 var getterFor = function (TYPE) {
   return function (it) {
     var state;
     if (!isObject(it) || (state = get(it)).type !== TYPE) {
       throw TypeError('Incompatible receiver, ' + TYPE + ' required');
     } return state;
   };
 };

 if (NATIVE_WEAK_MAP || shared.state) {
   var store = shared.state || (shared.state = new WeakMap());
   var wmget = uncurryThis(store.get);
   var wmhas = uncurryThis(store.has);
   var wmset = uncurryThis(store.set);
   set = function (it, metadata) {
     if (wmhas(store, it)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
     metadata.facade = it;
     wmset(store, it, metadata);
     return metadata;
   };
   get = function (it) {
     return wmget(store, it) || {};
   };
   has = function (it) {
     return wmhas(store, it);
   };
 } else {
   var STATE = sharedKey('state');
   hiddenKeys[STATE] = true;
   set = function (it, metadata) {
     if (hasOwn(it, STATE)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
     metadata.facade = it;
     createNonEnumerableProperty(it, STATE, metadata);
     return metadata;
   };
   get = function (it) {
     return hasOwn(it, STATE) ? it[STATE] : {};
   };
   has = function (it) {
     return hasOwn(it, STATE);
   };
 }

 module.exports = {
   set: set,
   get: get,
   has: has,
   enforce: enforce,
   getterFor: getterFor
 };


 /***/ }),
 /* 54 */
 /***/ (function(module, exports, __webpack_require__) {

 "use strict";

 var apply = __webpack_require__(117);
 var call = __webpack_require__(22);
 var uncurryThis = __webpack_require__(5);
 var fixRegExpWellKnownSymbolLogic = __webpack_require__(131);
 var fails = __webpack_require__(10);
 var anObject = __webpack_require__(17);
 var isCallable = __webpack_require__(11);
 var toIntegerOrInfinity = __webpack_require__(65);
 var toLength = __webpack_require__(88);
 var toString = __webpack_require__(28);
 var requireObjectCoercible = __webpack_require__(37);
 var advanceStringIndex = __webpack_require__(153);
 var getMethod = __webpack_require__(58);
 var getSubstitution = __webpack_require__(194);
 var regExpExec = __webpack_require__(129);
 var wellKnownSymbol = __webpack_require__(12);

 var REPLACE = wellKnownSymbol('replace');
 var max = Math.max;
 var min = Math.min;
 var concat = uncurryThis([].concat);
 var push = uncurryThis([].push);
 var stringIndexOf = uncurryThis(''.indexOf);
 var stringSlice = uncurryThis(''.slice);

 var maybeToString = function (it) {
   return it === undefined ? it : String(it);
 };

 // IE <= 11 replaces $0 with the whole match, as if it was $&
 // https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
 var REPLACE_KEEPS_$0 = (function () {
   // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
   return 'a'.replace(/./, '$0') === '$0';
 })();

 // Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
 var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = (function () {
   if (/./[REPLACE]) {
     return /./[REPLACE]('a', '$0') === '';
   }
   return false;
 })();

 var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
   var re = /./;
   re.exec = function () {
     var result = [];
     result.groups = { a: '7' };
     return result;
   };
   // eslint-disable-next-line regexp/no-useless-dollar-replacements -- false positive
   return ''.replace(re, '$<a>') !== '7';
 });

 // @@replace logic
 fixRegExpWellKnownSymbolLogic('replace', function (_, nativeReplace, maybeCallNative) {
   var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';

   return [
     // `String.prototype.replace` method
     // https://tc39.es/ecma262/#sec-string.prototype.replace
     function replace(searchValue, replaceValue) {
       var O = requireObjectCoercible(this);
       var replacer = searchValue == undefined ? undefined : getMethod(searchValue, REPLACE);
       return replacer
         ? call(replacer, searchValue, O, replaceValue)
         : call(nativeReplace, toString(O), searchValue, replaceValue);
     },
     // `RegExp.prototype[@@replace]` method
     // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
     function (string, replaceValue) {
       var rx = anObject(this);
       var S = toString(string);

       if (
         typeof replaceValue == 'string' &&
         stringIndexOf(replaceValue, UNSAFE_SUBSTITUTE) === -1 &&
         stringIndexOf(replaceValue, '$<') === -1
       ) {
         var res = maybeCallNative(nativeReplace, rx, S, replaceValue);
         if (res.done) return res.value;
       }

       var functionalReplace = isCallable(replaceValue);
       if (!functionalReplace) replaceValue = toString(replaceValue);

       var global = rx.global;
       if (global) {
         var fullUnicode = rx.unicode;
         rx.lastIndex = 0;
       }
       var results = [];
       while (true) {
         var result = regExpExec(rx, S);
         if (result === null) break;

         push(results, result);
         if (!global) break;

         var matchStr = toString(result[0]);
         if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
       }

       var accumulatedResult = '';
       var nextSourcePosition = 0;
       for (var i = 0; i < results.length; i++) {
         result = results[i];

         var matched = toString(result[0]);
         var position = max(min(toIntegerOrInfinity(result.index), S.length), 0);
         var captures = [];
         // NOTE: This is equivalent to
         //   captures = result.slice(1).map(maybeToString)
         // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
         // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
         // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
         for (var j = 1; j < result.length; j++) push(captures, maybeToString(result[j]));
         var namedCaptures = result.groups;
         if (functionalReplace) {
           var replacerArgs = concat([matched], captures, position, S);
           if (namedCaptures !== undefined) push(replacerArgs, namedCaptures);
           var replacement = toString(apply(replaceValue, undefined, replacerArgs));
         } else {
           replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
         }
         if (position >= nextSourcePosition) {
           accumulatedResult += stringSlice(S, nextSourcePosition, position) + replacement;
           nextSourcePosition = position + matched.length;
         }
       }
       return accumulatedResult + stringSlice(S, nextSourcePosition);
     }
   ];
 }, !REPLACE_SUPPORTS_NAMED_GROUPS || !REPLACE_KEEPS_$0 || REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);


 /***/ }),
 /* 55 */
 /***/ (function(module, exports, __webpack_require__) {

 /* global ActiveXObject -- old IE, WSH */
 var anObject = __webpack_require__(17);
 var defineProperties = __webpack_require__(158);
 var enumBugKeys = __webpack_require__(87);
 var hiddenKeys = __webpack_require__(66);
 var html = __webpack_require__(134);
 var documentCreateElement = __webpack_require__(94);
 var sharedKey = __webpack_require__(91);

 var GT = '>';
 var LT = '<';
 var PROTOTYPE = 'prototype';
 var SCRIPT = 'script';
 var IE_PROTO = sharedKey('IE_PROTO');

 var EmptyConstructor = function () { /* empty */ };

 var scriptTag = function (content) {
   return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
 };

 // Create object with fake `null` prototype: use ActiveX Object with cleared prototype
 var NullProtoObjectViaActiveX = function (activeXDocument) {
   activeXDocument.write(scriptTag(''));
   activeXDocument.close();
   var temp = activeXDocument.parentWindow.Object;
   activeXDocument = null; // avoid memory leak
   return temp;
 };

 // Create object with fake `null` prototype: use iframe Object with cleared prototype
 var NullProtoObjectViaIFrame = function () {
   // Thrash, waste and sodomy: IE GC bug
   var iframe = documentCreateElement('iframe');
   var JS = 'java' + SCRIPT + ':';
   var iframeDocument;
   iframe.style.display = 'none';
   html.appendChild(iframe);
   // https://github.com/zloirock/core-js/issues/475
   iframe.src = String(JS);
   iframeDocument = iframe.contentWindow.document;
   iframeDocument.open();
   iframeDocument.write(scriptTag('document.F=Object'));
   iframeDocument.close();
   return iframeDocument.F;
 };

 // Check for document.domain and active x support
 // No need to use active x approach when document.domain is not set
 // see https://github.com/es-shims/es5-shim/issues/150
 // variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
 // avoid IE GC bug
 var activeXDocument;
 var NullProtoObject = function () {
   try {
     activeXDocument = new ActiveXObject('htmlfile');
   } catch (error) { /* ignore */ }
   NullProtoObject = typeof document != 'undefined'
     ? document.domain && activeXDocument
       ? NullProtoObjectViaActiveX(activeXDocument) // old IE
       : NullProtoObjectViaIFrame()
     : NullProtoObjectViaActiveX(activeXDocument); // WSH
   var length = enumBugKeys.length;
   while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
   return NullProtoObject();
 };

 hiddenKeys[IE_PROTO] = true;

 // `Object.create` method
 // https://tc39.es/ecma262/#sec-object.create
 module.exports = Object.create || function create(O, Properties) {
   var result;
   if (O !== null) {
     EmptyConstructor[PROTOTYPE] = anObject(O);
     result = new EmptyConstructor();
     EmptyConstructor[PROTOTYPE] = null;
     // add "__proto__" for Object.getPrototypeOf polyfill
     result[IE_PROTO] = O;
   } else result = NullProtoObject();
   return Properties === undefined ? result : defineProperties(result, Properties);
 };


 /***/ }),
 /* 56 */
 /***/ (function(module, exports, __webpack_require__) {

 var toLength = __webpack_require__(88);

 // `LengthOfArrayLike` abstract operation
 // https://tc39.es/ecma262/#sec-lengthofarraylike
 module.exports = function (obj) {
   return toLength(obj.length);
 };


 /***/ }),
 /* 57 */
 /***/ (function(module, exports, __webpack_require__) {

 var global = __webpack_require__(2);
 var isCallable = __webpack_require__(11);
 var tryToString = __webpack_require__(110);

 var TypeError = global.TypeError;

 // `Assert: IsCallable(argument) is true`
 module.exports = function (argument) {
   if (isCallable(argument)) return argument;
   throw TypeError(tryToString(argument) + ' is not a function');
 };


 /***/ }),
 /* 58 */
 /***/ (function(module, exports, __webpack_require__) {

 var aCallable = __webpack_require__(57);

 // `GetMethod` abstract operation
 // https://tc39.es/ecma262/#sec-getmethod
 module.exports = function (V, P) {
   var func = V[P];
   return func == null ? undefined : aCallable(func);
 };


 /***/ }),
 /* 59 */
 /***/ (function(module, exports, __webpack_require__) {

 var uncurryThis = __webpack_require__(5);

 module.exports = uncurryThis({}.isPrototypeOf);


 /***/ }),
 /* 60 */
 /***/ (function(module, exports) {

 module.exports = false;


 /***/ }),
 /* 61 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";
 /* unused harmony export loaded */
 /* unused harmony export settings */
 /* unused harmony export load */
 /* unused harmony export get */
 /* unused harmony export all */
 /* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24);
 /* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);


 let loaded = false;
 let settings = {};

 async function load() {
     const response = await axios__WEBPACK_IMPORTED_MODULE_0___default.a
         .get("/?view=settings", {
             responseType: "json"
         })
         .then((response) => response.data);

     loaded = true;
     settings = response;

     document.dispatchEvent(
         new CustomEvent("theme:settings:loaded", {
             detail: {
                 settings
             }
         })
     );
 }

 function get(name) {
     return settings[name];
 }

 function all() {
     return settings;
 }

 /* harmony default export */ __webpack_exports__["a"] = ({
     loaded,
     settings,
     load,
     get,
     all,
 });

 /***/ }),
 /* 62 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";
 __webpack_require__.r(__webpack_exports__);
 /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "disableBodyScroll", function() { return disableBodyScroll; });
 /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "clearAllBodyScrollLocks", function() { return clearAllBodyScrollLocks; });
 /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "enableBodyScroll", function() { return enableBodyScroll; });
 function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

 // Older browsers don't support event options, feature detect it.

 // Adopted and modified solution from Bohdan Didukh (2017)
 // https://stackoverflow.com/questions/41594997/ios-10-safari-prevent-scrolling-behind-a-fixed-overlay-and-maintain-scroll-posi

 var hasPassiveEvents = false;
 if (typeof window !== 'undefined') {
   var passiveTestOptions = {
     get passive() {
       hasPassiveEvents = true;
       return undefined;
     }
   };
   window.addEventListener('testPassive', null, passiveTestOptions);
   window.removeEventListener('testPassive', null, passiveTestOptions);
 }

 var isIosDevice = typeof window !== 'undefined' && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || window.navigator.platform === 'MacIntel' && window.navigator.maxTouchPoints > 1);


 var locks = [];
 var documentListenerAdded = false;
 var initialClientY = -1;
 var previousBodyOverflowSetting = void 0;
 var previousBodyPaddingRight = void 0;

 // returns true if `el` should be allowed to receive touchmove events.
 var allowTouchMove = function allowTouchMove(el) {
   return locks.some(function (lock) {
     if (lock.options.allowTouchMove && lock.options.allowTouchMove(el)) {
       return true;
     }

     return false;
   });
 };

 var preventDefault = function preventDefault(rawEvent) {
   var e = rawEvent || window.event;

   // For the case whereby consumers adds a touchmove event listener to document.
   // Recall that we do document.addEventListener('touchmove', preventDefault, { passive: false })
   // in disableBodyScroll - so if we provide this opportunity to allowTouchMove, then
   // the touchmove event on document will break.
   if (allowTouchMove(e.target)) {
     return true;
   }

   // Do not prevent if the event has more than one touch (usually meaning this is a multi touch gesture like pinch to zoom).
   if (e.touches.length > 1) return true;

   if (e.preventDefault) e.preventDefault();

   return false;
 };

 var setOverflowHidden = function setOverflowHidden(options) {
   // If previousBodyPaddingRight is already set, don't set it again.
   if (previousBodyPaddingRight === undefined) {
     var _reserveScrollBarGap = !!options && options.reserveScrollBarGap === true;
     var scrollBarGap = window.innerWidth - document.documentElement.clientWidth;

     if (_reserveScrollBarGap && scrollBarGap > 0) {
       previousBodyPaddingRight = document.body.style.paddingRight;
       document.body.style.paddingRight = scrollBarGap + 'px';
     }
   }

   // If previousBodyOverflowSetting is already set, don't set it again.
   if (previousBodyOverflowSetting === undefined) {
     previousBodyOverflowSetting = document.body.style.overflow;
     document.body.style.overflow = 'hidden';
   }
 };

 var restoreOverflowSetting = function restoreOverflowSetting() {
   if (previousBodyPaddingRight !== undefined) {
     document.body.style.paddingRight = previousBodyPaddingRight;

     // Restore previousBodyPaddingRight to undefined so setOverflowHidden knows it
     // can be set again.
     previousBodyPaddingRight = undefined;
   }

   if (previousBodyOverflowSetting !== undefined) {
     document.body.style.overflow = previousBodyOverflowSetting;

     // Restore previousBodyOverflowSetting to undefined
     // so setOverflowHidden knows it can be set again.
     previousBodyOverflowSetting = undefined;
   }
 };

 // https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollHeight#Problems_and_solutions
 var isTargetElementTotallyScrolled = function isTargetElementTotallyScrolled(targetElement) {
   return targetElement ? targetElement.scrollHeight - targetElement.scrollTop <= targetElement.clientHeight : false;
 };

 var handleScroll = function handleScroll(event, targetElement) {
   var clientY = event.targetTouches[0].clientY - initialClientY;

   if (allowTouchMove(event.target)) {
     return false;
   }

   if (targetElement && targetElement.scrollTop === 0 && clientY > 0) {
     // element is at the top of its scroll.
     return preventDefault(event);
   }

   if (isTargetElementTotallyScrolled(targetElement) && clientY < 0) {
     // element is at the bottom of its scroll.
     return preventDefault(event);
   }

   event.stopPropagation();
   return true;
 };

 var disableBodyScroll = function disableBodyScroll(targetElement, options) {
   // targetElement must be provided
   if (!targetElement) {
     // eslint-disable-next-line no-console
     console.error('disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.');
     return;
   }

   // disableBodyScroll must not have been called on this targetElement before
   if (locks.some(function (lock) {
     return lock.targetElement === targetElement;
   })) {
     return;
   }

   var lock = {
     targetElement: targetElement,
     options: options || {}
   };

   locks = [].concat(_toConsumableArray(locks), [lock]);

   if (isIosDevice) {
     targetElement.ontouchstart = function (event) {
       if (event.targetTouches.length === 1) {
         // detect single touch.
         initialClientY = event.targetTouches[0].clientY;
       }
     };
     targetElement.ontouchmove = function (event) {
       if (event.targetTouches.length === 1) {
         // detect single touch.
         handleScroll(event, targetElement);
       }
     };

     if (!documentListenerAdded) {
       document.addEventListener('touchmove', preventDefault, hasPassiveEvents ? { passive: false } : undefined);
       documentListenerAdded = true;
     }
   } else {
     setOverflowHidden(options);
   }
 };

 var clearAllBodyScrollLocks = function clearAllBodyScrollLocks() {
   if (isIosDevice) {
     // Clear all locks ontouchstart/ontouchmove handlers, and the references.
     locks.forEach(function (lock) {
       lock.targetElement.ontouchstart = null;
       lock.targetElement.ontouchmove = null;
     });

     if (documentListenerAdded) {
       document.removeEventListener('touchmove', preventDefault, hasPassiveEvents ? { passive: false } : undefined);
       documentListenerAdded = false;
     }

     // Reset initial clientY.
     initialClientY = -1;
   } else {
     restoreOverflowSetting();
   }

   locks = [];
 };

 var enableBodyScroll = function enableBodyScroll(targetElement) {
   if (!targetElement) {
     // eslint-disable-next-line no-console
     console.error('enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.');
     return;
   }

   locks = locks.filter(function (lock) {
     return lock.targetElement !== targetElement;
   });

   if (isIosDevice) {
     targetElement.ontouchstart = null;
     targetElement.ontouchmove = null;

     if (documentListenerAdded && locks.length === 0) {
       document.removeEventListener('touchmove', preventDefault, hasPassiveEvents ? { passive: false } : undefined);
       documentListenerAdded = false;
     }
   } else if (!locks.length) {
     restoreOverflowSetting();
   }
 };



 /***/ }),
 /* 63 */
 /***/ (function(module, exports, __webpack_require__) {

 var DESCRIPTORS = __webpack_require__(23);
 var FUNCTION_NAME_EXISTS = __webpack_require__(90).EXISTS;
 var uncurryThis = __webpack_require__(5);
 var defineProperty = __webpack_require__(26).f;

 var FunctionPrototype = Function.prototype;
 var functionToString = uncurryThis(FunctionPrototype.toString);
 var nameRE = /^\s*function ([^ (]*)/;
 var regExpExec = uncurryThis(nameRE.exec);
 var NAME = 'name';

 // Function instances `.name` property
 // https://tc39.es/ecma262/#sec-function-instances-name
 if (DESCRIPTORS && !FUNCTION_NAME_EXISTS) {
   defineProperty(FunctionPrototype, NAME, {
     configurable: true,
     get: function () {
       try {
         return regExpExec(nameRE, functionToString(this))[1];
       } catch (error) {
         return '';
       }
     }
   });
 }


 /***/ }),
 /* 64 */
 /***/ (function(module, exports, __webpack_require__) {

 var uncurryThis = __webpack_require__(5);
 var aCallable = __webpack_require__(57);

 var bind = uncurryThis(uncurryThis.bind);

 // optional / simple context binding
 module.exports = function (fn, that) {
   aCallable(fn);
   return that === undefined ? fn : bind ? bind(fn, that) : function (/* ...args */) {
     return fn.apply(that, arguments);
   };
 };


 /***/ }),
 /* 65 */
 /***/ (function(module, exports) {

 var ceil = Math.ceil;
 var floor = Math.floor;

 // `ToIntegerOrInfinity` abstract operation
 // https://tc39.es/ecma262/#sec-tointegerorinfinity
 module.exports = function (argument) {
   var number = +argument;
   // eslint-disable-next-line no-self-compare -- safe
   return number !== number || number === 0 ? 0 : (number > 0 ? floor : ceil)(number);
 };


 /***/ }),
 /* 66 */
 /***/ (function(module, exports) {

 module.exports = {};


 /***/ }),
 /* 67 */
 /***/ (function(module, exports) {

 module.exports = function (bitmap, value) {
   return {
     enumerable: !(bitmap & 1),
     configurable: !(bitmap & 2),
     writable: !(bitmap & 4),
     value: value
   };
 };


 /***/ }),
 /* 68 */
 /***/ (function(module, exports, __webpack_require__) {

 var getBuiltIn = __webpack_require__(33);

 module.exports = getBuiltIn('navigator', 'userAgent') || '';


 /***/ }),
 /* 69 */
 /***/ (function(module, exports) {

 var g;

 // This works in non-strict mode
 g = (function() {
   return this;
 })();

 try {
   // This works if eval is allowed (see CSP)
   g = g || Function("return this")() || (1, eval)("this");
 } catch (e) {
   // This works if the window reference is available
   if (typeof window === "object") g = window;
 }

 // g can still be undefined, but nothing to do about it...
 // We return undefined, instead of nothing here, so it's
 // easier to handle this case. if(!global) { ...}

 module.exports = g;


 /***/ }),
 /* 70 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";

 // EXTERNAL MODULE: ./node_modules/axios/index.js
 var axios = __webpack_require__(24);
 var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

 // CONCATENATED MODULE: ./node_modules/@savchukoleksii/shopify-theme-translations-tool/src/helpers/unescape.js
 function unescape_unescape(value) {
   const doc = new DOMParser().parseFromString(value, "text/html");

   return doc.body.innerHTML;
 }

 // CONCATENATED MODULE: ./node_modules/@savchukoleksii/shopify-theme-translations-tool/src/index.js
 /* unused harmony export load */
 /* unused harmony export get */
 /* unused harmony export all */



 let loaded = false;
 let translations = {};

 async function load() {
     const loadedTranslations = await axios_default.a
         .get("/?view=translations", {
             responseType: "json"
         })
         .then((response) => response.data);

     loaded = true;
     translations = loadedTranslations;

     document.dispatchEvent(
         new CustomEvent("theme:translations:loaded", {
             detail: {
                 translations: loadedTranslations
             }
         })
     );
 }

 function get(name, params = {}) {
     if(!loaded) {
         throw new Error("You must load translations");
     }

     try {
         const translation = name.split(".").reduce((translations, key) => {
             if (translations.hasOwnProperty(key)) {
                 return translations[key];
             }

             throw new Error("Translation missed");
         }, translations);

         return Object.keys(params).reduce((result = "", key) => {
             let regex = new RegExp(`{{(\\s+)?(${key})(\\s+)?}}`, "gm");

             return result.replace(regex, params[key]);
         }, unescape_unescape(translation));
     } catch (e) {}

     return `"${name}" translation missed`;
 }

 function src_all() {
     if(!loaded) {
         throw new Error("You must load translations");
     }

     return translations;
 }

 /* harmony default export */ var src = __webpack_exports__["a"] = ({
     load,
     get,
     all: src_all
 });

 /***/ }),
 /* 71 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";
 /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return formatMoney; });
 /**
  * Currency Helpers
  * -----------------------------------------------------------------------------
  * A collection of useful functions that help with currency formatting
  *
  * Current contents
  * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
  *
  */

 const moneyFormat = '${{amount}}';

 /**
  * Format money values based on your shop currency settings
  * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
  * or 3.00 dollars
  * @param  {String} format - shop money_format setting
  * @return {String} value - formatted value
  */
 function formatMoney(cents, format) {
   if (typeof cents === 'string') {
     cents = cents.replace('.', '');
   }
   let value = '';
   const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
   const formatString = format || moneyFormat;

   function formatWithDelimiters(
     number,
     precision = 2,
     thousands = ',',
     decimal = '.'
   ) {
     if (isNaN(number) || number == null) {
       return 0;
     }

     number = (number / 100.0).toFixed(precision);

     const parts = number.split('.');
     const dollarsAmount = parts[0].replace(
       /(\d)(?=(\d\d\d)+(?!\d))/g,
       `$1${thousands}`
     );
     const centsAmount = parts[1] ? decimal + parts[1] : '';

     return dollarsAmount + centsAmount;
   }

   switch (formatString.match(placeholderRegex)[1]) {
     case 'amount':
       value = formatWithDelimiters(cents, 2);
       break;
     case 'amount_no_decimals':
       value = formatWithDelimiters(cents, 0);
       break;
     case 'amount_with_comma_separator':
       value = formatWithDelimiters(cents, 2, '.', ',');
       break;
     case 'amount_no_decimals_with_comma_separator':
       value = formatWithDelimiters(cents, 0, '.', ',');
       break;
   }

   return formatString.replace(placeholderRegex, value);
 }


 /***/ }),
 /* 72 */
 /***/ (function(module, exports, __webpack_require__) {

 "use strict";

 var uncurryThis = __webpack_require__(5);
 var PROPER_FUNCTION_NAME = __webpack_require__(90).PROPER;
 var redefine = __webpack_require__(32);
 var anObject = __webpack_require__(17);
 var isPrototypeOf = __webpack_require__(59);
 var $toString = __webpack_require__(28);
 var fails = __webpack_require__(10);
 var regExpFlags = __webpack_require__(132);

 var TO_STRING = 'toString';
 var RegExpPrototype = RegExp.prototype;
 var n$ToString = RegExpPrototype[TO_STRING];
 var getFlags = uncurryThis(regExpFlags);

 var NOT_GENERIC = fails(function () { return n$ToString.call({ source: 'a', flags: 'b' }) != '/a/b'; });
 // FF44- RegExp#toString has a wrong name
 var INCORRECT_NAME = PROPER_FUNCTION_NAME && n$ToString.name != TO_STRING;

 // `RegExp.prototype.toString` method
 // https://tc39.es/ecma262/#sec-regexp.prototype.tostring
 if (NOT_GENERIC || INCORRECT_NAME) {
   redefine(RegExp.prototype, TO_STRING, function toString() {
     var R = anObject(this);
     var p = $toString(R.source);
     var rf = R.flags;
     var f = $toString(rf === undefined && isPrototypeOf(RegExpPrototype, R) && !('flags' in RegExpPrototype) ? getFlags(R) : rf);
     return '/' + p + '/' + f;
   }, { unsafe: true });
 }


 /***/ }),
 /* 73 */
 /***/ (function(module, exports, __webpack_require__) {

 var $ = __webpack_require__(13);
 var from = __webpack_require__(326);
 var checkCorrectnessOfIteration = __webpack_require__(160);

 var INCORRECT_ITERATION = !checkCorrectnessOfIteration(function (iterable) {
   // eslint-disable-next-line es/no-array-from -- required for testing
   Array.from(iterable);
 });

 // `Array.from` method
 // https://tc39.es/ecma262/#sec-array.from
 $({ target: 'Array', stat: true, forced: INCORRECT_ITERATION }, {
   from: from
 });


 /***/ }),
 /* 74 */
 /***/ (function(module, exports, __webpack_require__) {

 var internalObjectKeys = __webpack_require__(120);
 var enumBugKeys = __webpack_require__(87);

 var hiddenKeys = enumBugKeys.concat('length', 'prototype');

 // `Object.getOwnPropertyNames` method
 // https://tc39.es/ecma262/#sec-object.getownpropertynames
 // eslint-disable-next-line es/no-object-getownpropertynames -- safe
 exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
   return internalObjectKeys(O, hiddenKeys);
 };


 /***/ }),
 /* 75 */
 /***/ (function(module, exports, __webpack_require__) {

 var global = __webpack_require__(2);
 var TO_STRING_TAG_SUPPORT = __webpack_require__(100);
 var isCallable = __webpack_require__(11);
 var classofRaw = __webpack_require__(47);
 var wellKnownSymbol = __webpack_require__(12);

 var TO_STRING_TAG = wellKnownSymbol('toStringTag');
 var Object = global.Object;

 // ES3 wrong here
 var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

 // fallback for IE11 Script Access Denied error
 var tryGet = function (it, key) {
   try {
     return it[key];
   } catch (error) { /* empty */ }
 };

 // getting tag from ES6+ `Object.prototype.toString`
 module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
   var O, tag, result;
   return it === undefined ? 'Undefined' : it === null ? 'Null'
     // @@toStringTag case
     : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG)) == 'string' ? tag
     // builtinTag case
     : CORRECT_ARGUMENTS ? classofRaw(O)
     // ES3 arguments fallback
     : (result = classofRaw(O)) == 'Object' && isCallable(O.callee) ? 'Arguments' : result;
 };


 /***/ }),
 /* 76 */
 /***/ (function(module, exports, __webpack_require__) {

 var uncurryThis = __webpack_require__(5);
 var isCallable = __webpack_require__(11);
 var store = __webpack_require__(98);

 var functionToString = uncurryThis(Function.toString);

 // this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
 if (!isCallable(store.inspectSource)) {
   store.inspectSource = function (it) {
     return functionToString(it);
   };
 }

 module.exports = store.inspectSource;


 /***/ }),
 /* 77 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
 var es_object_to_string = __webpack_require__(3);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.promise.js
 var es_promise = __webpack_require__(14);

 // EXTERNAL MODULE: ./node_modules/regenerator-runtime/runtime.js
 var runtime = __webpack_require__(16);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.for-each.js
 var web_dom_collections_for_each = __webpack_require__(8);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
 var es_array_concat = __webpack_require__(50);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.exec.js
 var es_regexp_exec = __webpack_require__(21);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.replace.js
 var es_string_replace = __webpack_require__(54);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.join.js
 var es_array_join = __webpack_require__(115);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.map.js
 var es_array_map = __webpack_require__(51);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.includes.js
 var es_array_includes = __webpack_require__(82);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.includes.js
 var es_string_includes = __webpack_require__(81);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
 var es_object_keys = __webpack_require__(40);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
 var es_symbol = __webpack_require__(29);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.filter.js
 var es_array_filter = __webpack_require__(25);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptor.js
 var es_object_get_own_property_descriptor = __webpack_require__(44);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptors.js
 var es_object_get_own_property_descriptors = __webpack_require__(43);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.description.js
 var es_symbol_description = __webpack_require__(104);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.iterator.js
 var es_symbol_iterator = __webpack_require__(114);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.iterator.js
 var es_array_iterator = __webpack_require__(31);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.iterator.js
 var es_string_iterator = __webpack_require__(27);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.iterator.js
 var web_dom_collections_iterator = __webpack_require__(41);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.from.js
 var es_array_from = __webpack_require__(73);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.slice.js
 var es_array_slice = __webpack_require__(80);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
 var es_function_name = __webpack_require__(63);

 // EXTERNAL MODULE: ./node_modules/axios/index.js
 var axios = __webpack_require__(24);
 var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

 // CONCATENATED MODULE: ./src/scripts/core/helpers/swym.js
 function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

 function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

 function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

 function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

 function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

 function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

 function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

 function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

 function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


























 function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

 function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }


 var EVENT_UNKNOWN = 0;
 var EVENT_PRODUCT = 1;
 var EVENT_CATEGORY = 2;
 var EVENT_CART = 3;
 var EVENT_WISHLIST = 4;
 var EVENT_COUPON = 5;

 function getVariantImageSrc(product, variant) {
   return function () {
     if (variant.image) {
       return variant.image.src;
     }

     if (product.featured_image) {
       return product.featured_image.src;
     }

     return null;
   }();
 }

 function onWishlistLoad() {
   var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
     return regeneratorRuntime.wrap(function _callee$(_context) {
       while (1) {
         switch (_context.prev = _context.next) {
           case 0:
           case "end":
             return _context.stop();
         }
       }
     }, _callee);
   }));

   if (!window.SwymCallbacks) {
     window.SwymCallbacks = [];
   }

   window.SwymCallbacks.push( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
     return regeneratorRuntime.wrap(function _callee2$(_context2) {
       while (1) {
         switch (_context2.prev = _context2.next) {
           case 0:
             _context2.next = 2;
             return action();

           case 2:
             return _context2.abrupt("return", _context2.sent);

           case 3:
           case "end":
             return _context2.stop();
         }
       }
     }, _callee2);
   })));
 }
 function getProductsByIds() {
   return _getProductsByIds.apply(this, arguments);
 }

 function _getProductsByIds() {
   _getProductsByIds = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
     var ids,
         search,
         response,
         html,
         _args3 = arguments;
     return regeneratorRuntime.wrap(function _callee3$(_context3) {
       while (1) {
         switch (_context3.prev = _context3.next) {
           case 0:
             ids = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : [];
             search = encodeURI(ids.map(function (id) {
               return "id:".concat(id);
             }).join(" OR "));
             _context3.next = 4;
             return axios_default.a.get("/search?q=".concat(search, "&type=product&view=products-json"));

           case 4:
             response = _context3.sent.data;
             html = document.createElement("div");
             html.innerHTML = response;
             return _context3.abrupt("return", JSON.parse(html.querySelector("[data-json-response]").innerHTML));

           case 8:
           case "end":
             return _context3.stop();
         }
       }
     }, _callee3);
   }));
   return _getProductsByIds.apply(this, arguments);
 }

 function getWishlistProducts() {
   return _getWishlistProducts.apply(this, arguments);
 }

 function _getWishlistProducts() {
   _getWishlistProducts = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
     return regeneratorRuntime.wrap(function _callee5$(_context5) {
       while (1) {
         switch (_context5.prev = _context5.next) {
           case 0:
             _context5.next = 2;
             return new Promise(function (resolve, reject) {
               try {
                 window._swat.fetch( /*#__PURE__*/function () {
                   var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(response) {
                     var ids, wishlistedVariantsIds, wishlistProducts, wishlistedItems;
                     return regeneratorRuntime.wrap(function _callee4$(_context4) {
                       while (1) {
                         switch (_context4.prev = _context4.next) {
                           case 0:
                             ids = response.map(function (item) {
                               return item.empi;
                             });
                             wishlistedVariantsIds = response.reduce(function (items, item) {
                               return _objectSpread(_objectSpread({}, items), {}, _defineProperty({}, item.empi, [].concat(_toConsumableArray(items[item.empi] || []), [item.epi])));
                             }, {});
                             _context4.prev = 2;
                             _context4.next = 5;
                             return getProductsByIds(ids);

                           case 5:
                             wishlistProducts = _context4.sent.reduce(function (products, product) {
                               return _objectSpread(_objectSpread({}, products), {}, _defineProperty({}, product.id, _objectSpread(_objectSpread({}, product), {}, {
                                 variants: product.variants.map(function (variant) {
                                   var _wishlistedVariantsId;

                                   return _objectSpread(_objectSpread({}, variant), {}, {
                                     wishlisted: ((_wishlistedVariantsId = wishlistedVariantsIds[product.id]) !== null && _wishlistedVariantsId !== void 0 ? _wishlistedVariantsId : []).includes(variant.id)
                                   });
                                 })
                               })));
                             }, {});
                             wishlistedItems = response.reduce(function (items, item) {
                               return [].concat(_toConsumableArray(items), [_objectSpread(_objectSpread({}, wishlistProducts[item.empi]), {}, {
                                 wishlisted_variant_id: item.epi
                               })]);
                             }, []);
                             return _context4.abrupt("return", resolve(wishlistedItems));

                           case 10:
                             _context4.prev = 10;
                             _context4.t0 = _context4["catch"](2);
                             return _context4.abrupt("return", reject(_context4.t0));

                           case 13:
                           case "end":
                             return _context4.stop();
                         }
                       }
                     }, _callee4, null, [[2, 10]]);
                   }));

                   return function (_x5) {
                     return _ref5.apply(this, arguments);
                   };
                 }());
               } catch (error) {
                 return reject(error);
               }
             });

           case 2:
             return _context5.abrupt("return", _context5.sent);

           case 3:
           case "end":
             return _context5.stop();
         }
       }
     }, _callee5);
   }));
   return _getWishlistProducts.apply(this, arguments);
 }

 function addToWishlist(_x, _x2) {
   return _addToWishlist.apply(this, arguments);
 }

 function _addToWishlist() {
   _addToWishlist = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(product, variant) {
     return regeneratorRuntime.wrap(function _callee6$(_context6) {
       while (1) {
         switch (_context6.prev = _context6.next) {
           case 0:
             _context6.next = 2;
             return new Promise(function (resolve, reject) {
               try {
                 if (!variant) {
                   variant = product.variants[0];
                 }

                 window._swat.addToWishList({
                   et: EVENT_WISHLIST,
                   empi: product.id,
                   epi: variant.id || product.id,
                   dt: product.title,
                   du: "https://".concat(window.Shopify.shop).concat(product.url),
                   ct: product.type,
                   bt: product.vendor,
                   pr: variant.price / 100 || product.price / 100,
                   iu: getVariantImageSrc(product, variant).replace("https", "").replace("http", ""),
                   variants: [_defineProperty({}, variant.title, variant.id)],
                   stk: variant.inventory_quantity,
                   uri: "https://".concat(window.Shopify.shop).concat(product.url),
                   ri: {},
                   rc: "default",
                   type: "product-variant",
                   _cv: true,
                   vi: variant.title,
                   cprops: {}
                 }, function (response) {
                   return resolve(response);
                 });
               } catch (error) {
                 return reject(error);
               }
             });

           case 2:
             return _context6.abrupt("return", _context6.sent);

           case 3:
           case "end":
             return _context6.stop();
         }
       }
     }, _callee6);
   }));
   return _addToWishlist.apply(this, arguments);
 }

 function removeFromWishList(_x3, _x4) {
   return _removeFromWishList.apply(this, arguments);
 }

 function _removeFromWishList() {
   _removeFromWishList = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(product, variant) {
     return regeneratorRuntime.wrap(function _callee7$(_context7) {
       while (1) {
         switch (_context7.prev = _context7.next) {
           case 0:
             _context7.next = 2;
             return new Promise(function (resolve, reject) {
               try {
                 if (!variant) {
                   variant = product.variants[0];
                 }

                 window._swat.removeFromWishList({
                   et: -1,
                   empi: product.id,
                   epi: variant.id || product.id,
                   dt: product.title,
                   du: "https://".concat(window.Shopify.shop).concat(product.url),
                   ct: product.type,
                   pr: variant.price / 100 || product.price / 100,
                   iu: getVariantImageSrc(product, variant).replace("https", "").replace("http", ""),
                   variants: [_defineProperty({}, variant.title, variant.id)],
                   stk: variant.inventory_quantity,
                   uri: "https://".concat(window.Shopify.shop).concat(product.url),
                   ri: {},
                   rc: "default",
                   type: "product-variant",
                   _cv: true,
                   vi: variant.title
                 }, function (response) {
                   return resolve(response);
                 });
               } catch (error) {
                 return reject(error);
               }
             });

           case 2:
             return _context7.abrupt("return", _context7.sent);

           case 3:
           case "end":
             return _context7.stop();
         }
       }
     }, _callee7);
   }));
   return _removeFromWishList.apply(this, arguments);
 }

 function getWishlistCount() {
   return _getWishlistCount.apply(this, arguments);
 }

 function _getWishlistCount() {
   _getWishlistCount = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
     return regeneratorRuntime.wrap(function _callee8$(_context8) {
       while (1) {
         switch (_context8.prev = _context8.next) {
           case 0:
             _context8.next = 2;
             return new Promise(function (resolve, reject) {
               try {
                 window._swat.wishlistCount(function (response) {
                   return resolve(response);
                 });
               } catch (error) {
                 return reject(error);
               }
             });

           case 2:
             return _context8.abrupt("return", _context8.sent);

           case 3:
           case "end":
             return _context8.stop();
         }
       }
     }, _callee8);
   }));
   return _getWishlistCount.apply(this, arguments);
 }

 function addProductToWishlistObject(product) {
   var current_variant = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
   ["SwymViewProducts", "SwymWatchProducts", "SwymProductVariants"].forEach(function (key) {
     if (!window[key]) {
       window[key] = {};
     }
   });
   var products = {};

   if (!current_variant) {
     current_variant = product.variants[0];
   }

   product.variants.forEach(function (variant) {
     var variantData = {
       empi: product.id,
       epi: variant.id,
       du: "https://".concat(window.Shopify.shop).concat(product.url),
       dt: product.title,
       ct: product.type,
       iu: getVariantImageSrc(product, variant).replace("https", "").replace("http", ""),
       stk: variant.inventory_quantity,
       pr: variant.price / 100,
       variants: [_defineProperty({}, variant.title, variant.id)]
     };

     if (variant.compare_at_price) {
       variantData = _objectSpread(_objectSpread({}, variantData), {}, {
         op: variant.compare_at_price / 100
       });
     }

     window.SwymProductVariants[variant.id] = variantData;
     window.SwymWatchProducts[variant.id] = products[variant.id] = {
       id: variant.id,
       available: variant.available,
       inventory_management: variant.inventory_management,
       inventory_quantity: variant.inventory_quantity,
       title: variant.title,
       inventory_policy: variant.inventory_policy
     };
   });
   var productData = {
     empi: product.id,
     epi: current_variant.id,
     dt: product.title,
     du: "https://".concat(window.Shopify.shop).concat(product.url),
     ct: product.type,
     pr: current_variant.price / 100,
     stk: current_variant.inventory_quantity,
     iu: getVariantImageSrc(product, current_variant).replace("https", "").replace("http", ""),
     variants: [_defineProperty({}, current_variant.title, current_variant.id)]
   };

   if (current_variant.compare_at_price) {
     productData = _objectSpread(_objectSpread({}, productData), {}, {
       op: current_variant.compare_at_price / 100
     });
   }

   window.SwymViewProducts[product.handle] = window.SwymViewProducts[product.id] = productData;
   window.SwymWatchProducts[product.handle] = window.SwymWatchProducts[product.id] = products;
 }
 /* harmony default export */ var swym = ({
   addProductToWishlistObject: addProductToWishlistObject,
   onWishlistLoad: onWishlistLoad,
   getWishlistProducts: getWishlistProducts,
   addToWishlist: addToWishlist,
   removeFromWishList: removeFromWishList,
   getWishlistCount: getWishlistCount
 });
 // CONCATENATED MODULE: ./src/scripts/vue/store/wishlist/wishlist.js
 /* unused harmony export STATE_LOADING */
 /* unused harmony export STATE_WISHLIST */
 /* unused harmony export MUTATION_UPDATE_LOADING */
 /* unused harmony export MUTATION_UPDATE_WISHLIST */
 /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ACTION_INIT_WISHLIST; });
 /* unused harmony export ACTION_GET_WISHLIST_PRODUCTS */
 /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACTION_ADD_TO_WISHLIST; });
 /* unused harmony export ACTION_REMOVE_FROM_WISHLIST */



 var _mutations, _actions;



 function wishlist_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

 function wishlist_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { wishlist_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { wishlist_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

 function wishlist_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


 var STATE_LOADING = "loading";
 var STATE_WISHLIST = "wishlist";
 var MUTATION_UPDATE_LOADING = "updateLoading";
 var MUTATION_UPDATE_WISHLIST = "updateWishlist";
 var ACTION_INIT_WISHLIST = "initWishlist";
 var ACTION_GET_WISHLIST_PRODUCTS = "getWishlistProducts";
 var ACTION_ADD_TO_WISHLIST = "addToWishlist";
 var ACTION_REMOVE_FROM_WISHLIST = "removeFromWishlist";
 /* harmony default export */ var wishlist = __webpack_exports__["c"] = ({
   namespaced: true,
   state: function state() {
     var _ref;

     return _ref = {}, wishlist_defineProperty(_ref, STATE_LOADING, true), wishlist_defineProperty(_ref, STATE_WISHLIST, []), _ref;
   },
   getters: {},
   mutations: (_mutations = {}, wishlist_defineProperty(_mutations, MUTATION_UPDATE_LOADING, function (state, loading) {
     state[STATE_LOADING] = loading;
   }), wishlist_defineProperty(_mutations, MUTATION_UPDATE_WISHLIST, function (state, products) {
     document.dispatchEvent(new CustomEvent("wishlist:item_count", {
       detail: {
         item_count: products.length
       }
     }));
     state[STATE_WISHLIST] = products;
   }), _mutations),
   actions: (_actions = {}, wishlist_defineProperty(_actions, ACTION_INIT_WISHLIST, function (context) {
     var _arguments = arguments;
     return wishlist_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
       var _ref2, _ref2$errorCallback, errorCallback;

       return regeneratorRuntime.wrap(function _callee2$(_context2) {
         while (1) {
           switch (_context2.prev = _context2.next) {
             case 0:
               _ref2 = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : {}, _ref2$errorCallback = _ref2.errorCallback, errorCallback = _ref2$errorCallback === void 0 ? function () {} : _ref2$errorCallback;

               try {
                 onWishlistLoad( /*#__PURE__*/wishlist_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                   return regeneratorRuntime.wrap(function _callee$(_context) {
                     while (1) {
                       switch (_context.prev = _context.next) {
                         case 0:
                           _context.next = 2;
                           return context.dispatch(ACTION_GET_WISHLIST_PRODUCTS, {
                             errorCallback: errorCallback
                           });

                         case 2:
                         case "end":
                           return _context.stop();
                       }
                     }
                   }, _callee);
                 })));
               } catch (error) {}

             case 2:
             case "end":
               return _context2.stop();
           }
         }
       }, _callee2);
     }))();
   }), wishlist_defineProperty(_actions, ACTION_GET_WISHLIST_PRODUCTS, function (context) {
     var _arguments2 = arguments;
     return wishlist_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
       var _ref4, _ref4$errorCallback, errorCallback, products;

       return regeneratorRuntime.wrap(function _callee3$(_context3) {
         while (1) {
           switch (_context3.prev = _context3.next) {
             case 0:
               _ref4 = _arguments2.length > 1 && _arguments2[1] !== undefined ? _arguments2[1] : {}, _ref4$errorCallback = _ref4.errorCallback, errorCallback = _ref4$errorCallback === void 0 ? function () {} : _ref4$errorCallback;
               context.commit(MUTATION_UPDATE_LOADING, true);
               _context3.prev = 2;
               _context3.next = 5;
               return getWishlistProducts();

             case 5:
               products = _context3.sent;
               context.commit(MUTATION_UPDATE_WISHLIST, products);
               context.commit(MUTATION_UPDATE_LOADING, false);
               _context3.next = 14;
               break;

             case 10:
               _context3.prev = 10;
               _context3.t0 = _context3["catch"](2);
               _context3.next = 14;
               return errorCallback(_context3.t0);

             case 14:
             case "end":
               return _context3.stop();
           }
         }
       }, _callee3, null, [[2, 10]]);
     }))();
   }), wishlist_defineProperty(_actions, ACTION_ADD_TO_WISHLIST, function (context) {
     var _arguments3 = arguments;
     return wishlist_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
       var _ref5, product, _ref5$variant, variant, _ref5$errorCallback, errorCallback;

       return regeneratorRuntime.wrap(function _callee4$(_context4) {
         while (1) {
           switch (_context4.prev = _context4.next) {
             case 0:
               _ref5 = _arguments3.length > 1 && _arguments3[1] !== undefined ? _arguments3[1] : {}, product = _ref5.product, _ref5$variant = _ref5.variant, variant = _ref5$variant === void 0 ? null : _ref5$variant, _ref5$errorCallback = _ref5.errorCallback, errorCallback = _ref5$errorCallback === void 0 ? function () {} : _ref5$errorCallback;
               context.commit(MUTATION_UPDATE_LOADING, true);
               _context4.prev = 2;
               _context4.next = 5;
               return addToWishlist(product, variant);

             case 5:
               _context4.next = 7;
               return context.dispatch(ACTION_GET_WISHLIST_PRODUCTS);

             case 7:
               _context4.next = 13;
               break;

             case 9:
               _context4.prev = 9;
               _context4.t0 = _context4["catch"](2);
               _context4.next = 13;
               return errorCallback(_context4.t0);

             case 13:
               context.commit(MUTATION_UPDATE_LOADING, false);

             case 14:
             case "end":
               return _context4.stop();
           }
         }
       }, _callee4, null, [[2, 9]]);
     }))();
   }), wishlist_defineProperty(_actions, ACTION_REMOVE_FROM_WISHLIST, function (context) {
     var _arguments4 = arguments;
     return wishlist_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
       var _ref6, product, _ref6$variant, variant, _ref6$errorCallback, errorCallback;

       return regeneratorRuntime.wrap(function _callee5$(_context5) {
         while (1) {
           switch (_context5.prev = _context5.next) {
             case 0:
               _ref6 = _arguments4.length > 1 && _arguments4[1] !== undefined ? _arguments4[1] : {}, product = _ref6.product, _ref6$variant = _ref6.variant, variant = _ref6$variant === void 0 ? null : _ref6$variant, _ref6$errorCallback = _ref6.errorCallback, errorCallback = _ref6$errorCallback === void 0 ? function () {} : _ref6$errorCallback;
               context.commit(MUTATION_UPDATE_LOADING, true);
               _context5.prev = 2;
               _context5.next = 5;
               return removeFromWishList(product, variant);

             case 5:
               _context5.next = 7;
               return context.dispatch(ACTION_GET_WISHLIST_PRODUCTS);

             case 7:
               _context5.next = 13;
               break;

             case 9:
               _context5.prev = 9;
               _context5.t0 = _context5["catch"](2);
               _context5.next = 13;
               return errorCallback(_context5.t0);

             case 13:
               context.commit(MUTATION_UPDATE_LOADING, false);

             case 14:
             case "end":
               return _context5.stop();
           }
         }
       }, _callee5, null, [[2, 9]]);
     }))();
   }), _actions)
 });

 /***/ }),
 /* 78 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";
 /* unused harmony export STATE_LOADING */
 /* unused harmony export STATE_PRODUCTS */
 /* unused harmony export MUTATION_UPDATE_LOADING */
 /* unused harmony export MUTATION_UPDATE_PRODUCTS */
 /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACTION_INIT_RECENTLY_VIEWED_PRODUCTS; });
 /* unused harmony export ACTION_GET_RECENTLY_VIEWED_PRODUCTS */
 /* unused harmony export ACTION_ADD_TO_RECENTLY_VIEWED_PRODUCTS */
 /* unused harmony export ACTION_REMOVE_FROM_RECENTLY_VIEWED_PRODUCTS */
 /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GETTER_PRODUCTS; });
 /* harmony import */ var regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(16);
 /* harmony import */ var regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51);
 /* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_1__);
 /* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25);
 /* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2__);
 /* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3);
 /* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_3__);
 /* harmony import */ var core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82);
 /* harmony import */ var core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_4__);
 /* harmony import */ var core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(81);
 /* harmony import */ var core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_5__);
 /* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14);
 /* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_6__);
 /* harmony import */ var _core_helpers_recentlyViewedProducts__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(112);
 /* harmony import */ var _cart_cart__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(15);
 var _mutations, _actions;



 function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

 function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }








 function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



 var STATE_LOADING = "loading";
 var STATE_PRODUCTS = "products";
 var MUTATION_UPDATE_LOADING = "updateLoading";
 var MUTATION_UPDATE_PRODUCTS = "updateProducts";
 var ACTION_INIT_RECENTLY_VIEWED_PRODUCTS = "initRecentlyViewedProducts";
 var ACTION_GET_RECENTLY_VIEWED_PRODUCTS = "getRecentlyViewedProducts";
 var ACTION_ADD_TO_RECENTLY_VIEWED_PRODUCTS = "addToRecentlyViewedProducts";
 var ACTION_REMOVE_FROM_RECENTLY_VIEWED_PRODUCTS = "removeFromRecentlyViewedProducts";
 var GETTER_PRODUCTS = "products";
 /* harmony default export */ __webpack_exports__["c"] = ({
   namespaced: true,
   state: function state() {
     var _ref;

     return _ref = {}, _defineProperty(_ref, STATE_LOADING, true), _defineProperty(_ref, STATE_PRODUCTS, []), _ref;
   },
   getters: _defineProperty({}, GETTER_PRODUCTS, function (state, getters, rootState, rootGetters) {
     var cart = rootGetters["cart/".concat(_cart_cart__WEBPACK_IMPORTED_MODULE_8__[/* GETTER_CART */ "g"])];
     var product_ids = cart.items.map(function (item) {
       return item.product_id;
     });
     return state[STATE_PRODUCTS].filter(function (product) {
       return !product_ids.includes(product.id);
     });
   }),
   mutations: (_mutations = {}, _defineProperty(_mutations, MUTATION_UPDATE_LOADING, function (state, loading) {
     state[STATE_LOADING] = loading;
   }), _defineProperty(_mutations, MUTATION_UPDATE_PRODUCTS, function (state, products) {
     state[STATE_PRODUCTS] = products;
   }), _mutations),
   actions: (_actions = {}, _defineProperty(_actions, ACTION_INIT_RECENTLY_VIEWED_PRODUCTS, function (context) {
     var _arguments = arguments;
     return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
       var _ref2, _ref2$errorCallback, errorCallback;

       return regeneratorRuntime.wrap(function _callee$(_context) {
         while (1) {
           switch (_context.prev = _context.next) {
             case 0:
               _ref2 = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : {}, _ref2$errorCallback = _ref2.errorCallback, errorCallback = _ref2$errorCallback === void 0 ? function () {} : _ref2$errorCallback;
               _context.next = 3;
               return context.dispatch(ACTION_GET_RECENTLY_VIEWED_PRODUCTS, {
                 errorCallback: errorCallback
               });

             case 3:
             case "end":
               return _context.stop();
           }
         }
       }, _callee);
     }))();
   }), _defineProperty(_actions, ACTION_GET_RECENTLY_VIEWED_PRODUCTS, function (context, _ref3) {
     return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
       var _ref3$errorCallback, errorCallback, products;

       return regeneratorRuntime.wrap(function _callee2$(_context2) {
         while (1) {
           switch (_context2.prev = _context2.next) {
             case 0:
               _ref3$errorCallback = _ref3.errorCallback, errorCallback = _ref3$errorCallback === void 0 ? function () {} : _ref3$errorCallback;
               context.commit(MUTATION_UPDATE_LOADING, true);
               _context2.prev = 2;
               _context2.next = 5;
               return Object(_core_helpers_recentlyViewedProducts__WEBPACK_IMPORTED_MODULE_7__[/* getRecentlyViewedProducts */ "c"])();

             case 5:
               products = _context2.sent;
               context.commit(MUTATION_UPDATE_PRODUCTS, products);
               context.commit(MUTATION_UPDATE_LOADING, false);
               _context2.next = 14;
               break;

             case 10:
               _context2.prev = 10;
               _context2.t0 = _context2["catch"](2);
               _context2.next = 14;
               return errorCallback(_context2.t0);

             case 14:
             case "end":
               return _context2.stop();
           }
         }
       }, _callee2, null, [[2, 10]]);
     }))();
   }), _defineProperty(_actions, ACTION_ADD_TO_RECENTLY_VIEWED_PRODUCTS, function (context) {
     var _arguments2 = arguments;
     return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
       var _ref4, id, _ref4$errorCallback, errorCallback;

       return regeneratorRuntime.wrap(function _callee3$(_context3) {
         while (1) {
           switch (_context3.prev = _context3.next) {
             case 0:
               _ref4 = _arguments2.length > 1 && _arguments2[1] !== undefined ? _arguments2[1] : {}, id = _ref4.id, _ref4$errorCallback = _ref4.errorCallback, errorCallback = _ref4$errorCallback === void 0 ? function () {} : _ref4$errorCallback;
               context.commit(MUTATION_UPDATE_LOADING, true);
               _context3.prev = 2;
               _context3.next = 5;
               return Object(_core_helpers_recentlyViewedProducts__WEBPACK_IMPORTED_MODULE_7__[/* addToRecentlyViewedProducts */ "b"])(id);

             case 5:
               _context3.next = 7;
               return context.dispatch(ACTION_GET_RECENTLY_VIEWED_PRODUCTS);

             case 7:
               _context3.next = 13;
               break;

             case 9:
               _context3.prev = 9;
               _context3.t0 = _context3["catch"](2);
               _context3.next = 13;
               return errorCallback(_context3.t0);

             case 13:
               context.commit(MUTATION_UPDATE_LOADING, false);

             case 14:
             case "end":
               return _context3.stop();
           }
         }
       }, _callee3, null, [[2, 9]]);
     }))();
   }), _defineProperty(_actions, ACTION_REMOVE_FROM_RECENTLY_VIEWED_PRODUCTS, function (context) {
     var _arguments3 = arguments;
     return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
       var _ref5, id, _ref5$errorCallback, errorCallback;

       return regeneratorRuntime.wrap(function _callee4$(_context4) {
         while (1) {
           switch (_context4.prev = _context4.next) {
             case 0:
               _ref5 = _arguments3.length > 1 && _arguments3[1] !== undefined ? _arguments3[1] : {}, id = _ref5.id, _ref5$errorCallback = _ref5.errorCallback, errorCallback = _ref5$errorCallback === void 0 ? function () {} : _ref5$errorCallback;
               context.commit(MUTATION_UPDATE_LOADING, true);
               _context4.prev = 2;
               _context4.next = 5;
               return Object(_core_helpers_recentlyViewedProducts__WEBPACK_IMPORTED_MODULE_7__[/* removeFromRecentlyViewedProducts */ "d"])(id);

             case 5:
               _context4.next = 7;
               return context.dispatch(ACTION_GET_RECENTLY_VIEWED_PRODUCTS);

             case 7:
               _context4.next = 13;
               break;

             case 9:
               _context4.prev = 9;
               _context4.t0 = _context4["catch"](2);
               _context4.next = 13;
               return errorCallback(_context4.t0);

             case 13:
               context.commit(MUTATION_UPDATE_LOADING, false);

             case 14:
             case "end":
               return _context4.stop();
           }
         }
       }, _callee4, null, [[2, 9]]);
     }))();
   }), _actions)
 });

 /***/ }),
 /* 79 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";
 /* WEBPACK VAR INJECTION */(function(global) {/* unused harmony export Store */
 /* unused harmony export createLogger */
 /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createNamespacedHelpers; });
 /* unused harmony export install */
 /* unused harmony export mapActions */
 /* unused harmony export mapGetters */
 /* unused harmony export mapMutations */
 /* unused harmony export mapState */
 /*!
  * vuex v3.6.2
  * (c) 2021 Evan You
  * @license MIT
  */
 function applyMixin (Vue) {
   var version = Number(Vue.version.split('.')[0]);

   if (version >= 2) {
     Vue.mixin({ beforeCreate: vuexInit });
   } else {
     // override init and inject vuex init procedure
     // for 1.x backwards compatibility.
     var _init = Vue.prototype._init;
     Vue.prototype._init = function (options) {
       if ( options === void 0 ) options = {};

       options.init = options.init
         ? [vuexInit].concat(options.init)
         : vuexInit;
       _init.call(this, options);
     };
   }

   /**
    * Vuex init hook, injected into each instances init hooks list.
    */

   function vuexInit () {
     var options = this.$options;
     // store injection
     if (options.store) {
       this.$store = typeof options.store === 'function'
         ? options.store()
         : options.store;
     } else if (options.parent && options.parent.$store) {
       this.$store = options.parent.$store;
     }
   }
 }

 var target = typeof window !== 'undefined'
   ? window
   : typeof global !== 'undefined'
     ? global
     : {};
 var devtoolHook = target.__VUE_DEVTOOLS_GLOBAL_HOOK__;

 function devtoolPlugin (store) {
   if (!devtoolHook) { return }

   store._devtoolHook = devtoolHook;

   devtoolHook.emit('vuex:init', store);

   devtoolHook.on('vuex:travel-to-state', function (targetState) {
     store.replaceState(targetState);
   });

   store.subscribe(function (mutation, state) {
     devtoolHook.emit('vuex:mutation', mutation, state);
   }, { prepend: true });

   store.subscribeAction(function (action, state) {
     devtoolHook.emit('vuex:action', action, state);
   }, { prepend: true });
 }

 /**
  * Get the first item that pass the test
  * by second argument function
  *
  * @param {Array} list
  * @param {Function} f
  * @return {*}
  */
 function find (list, f) {
   return list.filter(f)[0]
 }

 /**
  * Deep copy the given object considering circular structure.
  * This function caches all nested objects and its copies.
  * If it detects circular structure, use cached copy to avoid infinite loop.
  *
  * @param {*} obj
  * @param {Array<Object>} cache
  * @return {*}
  */
 function deepCopy (obj, cache) {
   if ( cache === void 0 ) cache = [];

   // just return if obj is immutable value
   if (obj === null || typeof obj !== 'object') {
     return obj
   }

   // if obj is hit, it is in circular structure
   var hit = find(cache, function (c) { return c.original === obj; });
   if (hit) {
     return hit.copy
   }

   var copy = Array.isArray(obj) ? [] : {};
   // put the copy into cache at first
   // because we want to refer it in recursive deepCopy
   cache.push({
     original: obj,
     copy: copy
   });

   Object.keys(obj).forEach(function (key) {
     copy[key] = deepCopy(obj[key], cache);
   });

   return copy
 }

 /**
  * forEach for object
  */
 function forEachValue (obj, fn) {
   Object.keys(obj).forEach(function (key) { return fn(obj[key], key); });
 }

 function isObject (obj) {
   return obj !== null && typeof obj === 'object'
 }

 function isPromise (val) {
   return val && typeof val.then === 'function'
 }

 function assert (condition, msg) {
   if (!condition) { throw new Error(("[vuex] " + msg)) }
 }

 function partial (fn, arg) {
   return function () {
     return fn(arg)
   }
 }

 // Base data struct for store's module, package with some attribute and method
 var Module = function Module (rawModule, runtime) {
   this.runtime = runtime;
   // Store some children item
   this._children = Object.create(null);
   // Store the origin module object which passed by programmer
   this._rawModule = rawModule;
   var rawState = rawModule.state;

   // Store the origin module's state
   this.state = (typeof rawState === 'function' ? rawState() : rawState) || {};
 };

 var prototypeAccessors = { namespaced: { configurable: true } };

 prototypeAccessors.namespaced.get = function () {
   return !!this._rawModule.namespaced
 };

 Module.prototype.addChild = function addChild (key, module) {
   this._children[key] = module;
 };

 Module.prototype.removeChild = function removeChild (key) {
   delete this._children[key];
 };

 Module.prototype.getChild = function getChild (key) {
   return this._children[key]
 };

 Module.prototype.hasChild = function hasChild (key) {
   return key in this._children
 };

 Module.prototype.update = function update (rawModule) {
   this._rawModule.namespaced = rawModule.namespaced;
   if (rawModule.actions) {
     this._rawModule.actions = rawModule.actions;
   }
   if (rawModule.mutations) {
     this._rawModule.mutations = rawModule.mutations;
   }
   if (rawModule.getters) {
     this._rawModule.getters = rawModule.getters;
   }
 };

 Module.prototype.forEachChild = function forEachChild (fn) {
   forEachValue(this._children, fn);
 };

 Module.prototype.forEachGetter = function forEachGetter (fn) {
   if (this._rawModule.getters) {
     forEachValue(this._rawModule.getters, fn);
   }
 };

 Module.prototype.forEachAction = function forEachAction (fn) {
   if (this._rawModule.actions) {
     forEachValue(this._rawModule.actions, fn);
   }
 };

 Module.prototype.forEachMutation = function forEachMutation (fn) {
   if (this._rawModule.mutations) {
     forEachValue(this._rawModule.mutations, fn);
   }
 };

 Object.defineProperties( Module.prototype, prototypeAccessors );

 var ModuleCollection = function ModuleCollection (rawRootModule) {
   // register root module (Vuex.Store options)
   this.register([], rawRootModule, false);
 };

 ModuleCollection.prototype.get = function get (path) {
   return path.reduce(function (module, key) {
     return module.getChild(key)
   }, this.root)
 };

 ModuleCollection.prototype.getNamespace = function getNamespace (path) {
   var module = this.root;
   return path.reduce(function (namespace, key) {
     module = module.getChild(key);
     return namespace + (module.namespaced ? key + '/' : '')
   }, '')
 };

 ModuleCollection.prototype.update = function update$1 (rawRootModule) {
   update([], this.root, rawRootModule);
 };

 ModuleCollection.prototype.register = function register (path, rawModule, runtime) {
     var this$1 = this;
     if ( runtime === void 0 ) runtime = true;

   if ((false)) {}

   var newModule = new Module(rawModule, runtime);
   if (path.length === 0) {
     this.root = newModule;
   } else {
     var parent = this.get(path.slice(0, -1));
     parent.addChild(path[path.length - 1], newModule);
   }

   // register nested modules
   if (rawModule.modules) {
     forEachValue(rawModule.modules, function (rawChildModule, key) {
       this$1.register(path.concat(key), rawChildModule, runtime);
     });
   }
 };

 ModuleCollection.prototype.unregister = function unregister (path) {
   var parent = this.get(path.slice(0, -1));
   var key = path[path.length - 1];
   var child = parent.getChild(key);

   if (!child) {
     if ((false)) {}
     return
   }

   if (!child.runtime) {
     return
   }

   parent.removeChild(key);
 };

 ModuleCollection.prototype.isRegistered = function isRegistered (path) {
   var parent = this.get(path.slice(0, -1));
   var key = path[path.length - 1];

   if (parent) {
     return parent.hasChild(key)
   }

   return false
 };

 function update (path, targetModule, newModule) {
   if ((false)) {}

   // update target module
   targetModule.update(newModule);

   // update nested modules
   if (newModule.modules) {
     for (var key in newModule.modules) {
       if (!targetModule.getChild(key)) {
         if ((false)) {}
         return
       }
       update(
         path.concat(key),
         targetModule.getChild(key),
         newModule.modules[key]
       );
     }
   }
 }

 var functionAssert = {
   assert: function (value) { return typeof value === 'function'; },
   expected: 'function'
 };

 var objectAssert = {
   assert: function (value) { return typeof value === 'function' ||
     (typeof value === 'object' && typeof value.handler === 'function'); },
   expected: 'function or object with "handler" function'
 };

 var assertTypes = {
   getters: functionAssert,
   mutations: functionAssert,
   actions: objectAssert
 };

 function assertRawModule (path, rawModule) {
   Object.keys(assertTypes).forEach(function (key) {
     if (!rawModule[key]) { return }

     var assertOptions = assertTypes[key];

     forEachValue(rawModule[key], function (value, type) {
       assert(
         assertOptions.assert(value),
         makeAssertionMessage(path, key, type, value, assertOptions.expected)
       );
     });
   });
 }

 function makeAssertionMessage (path, key, type, value, expected) {
   var buf = key + " should be " + expected + " but \"" + key + "." + type + "\"";
   if (path.length > 0) {
     buf += " in module \"" + (path.join('.')) + "\"";
   }
   buf += " is " + (JSON.stringify(value)) + ".";
   return buf
 }

 var Vue; // bind on install

 var Store = function Store (options) {
   var this$1 = this;
   if ( options === void 0 ) options = {};

   // Auto install if it is not done yet and `window` has `Vue`.
   // To allow users to avoid auto-installation in some cases,
   // this code should be placed here. See #731
   if (!Vue && typeof window !== 'undefined' && window.Vue) {
     install(window.Vue);
   }

   if ((false)) {}

   var plugins = options.plugins; if ( plugins === void 0 ) plugins = [];
   var strict = options.strict; if ( strict === void 0 ) strict = false;

   // store internal state
   this._committing = false;
   this._actions = Object.create(null);
   this._actionSubscribers = [];
   this._mutations = Object.create(null);
   this._wrappedGetters = Object.create(null);
   this._modules = new ModuleCollection(options);
   this._modulesNamespaceMap = Object.create(null);
   this._subscribers = [];
   this._watcherVM = new Vue();
   this._makeLocalGettersCache = Object.create(null);

   // bind commit and dispatch to self
   var store = this;
   var ref = this;
   var dispatch = ref.dispatch;
   var commit = ref.commit;
   this.dispatch = function boundDispatch (type, payload) {
     return dispatch.call(store, type, payload)
   };
   this.commit = function boundCommit (type, payload, options) {
     return commit.call(store, type, payload, options)
   };

   // strict mode
   this.strict = strict;

   var state = this._modules.root.state;

   // init root module.
   // this also recursively registers all sub-modules
   // and collects all module getters inside this._wrappedGetters
   installModule(this, state, [], this._modules.root);

   // initialize the store vm, which is responsible for the reactivity
   // (also registers _wrappedGetters as computed properties)
   resetStoreVM(this, state);

   // apply plugins
   plugins.forEach(function (plugin) { return plugin(this$1); });

   var useDevtools = options.devtools !== undefined ? options.devtools : Vue.config.devtools;
   if (useDevtools) {
     devtoolPlugin(this);
   }
 };

 var prototypeAccessors$1 = { state: { configurable: true } };

 prototypeAccessors$1.state.get = function () {
   return this._vm._data.$$state
 };

 prototypeAccessors$1.state.set = function (v) {
   if ((false)) {}
 };

 Store.prototype.commit = function commit (_type, _payload, _options) {
     var this$1 = this;

   // check object-style commit
   var ref = unifyObjectStyle(_type, _payload, _options);
     var type = ref.type;
     var payload = ref.payload;
     var options = ref.options;

   var mutation = { type: type, payload: payload };
   var entry = this._mutations[type];
   if (!entry) {
     if ((false)) {}
     return
   }
   this._withCommit(function () {
     entry.forEach(function commitIterator (handler) {
       handler(payload);
     });
   });

   this._subscribers
     .slice() // shallow copy to prevent iterator invalidation if subscriber synchronously calls unsubscribe
     .forEach(function (sub) { return sub(mutation, this$1.state); });

   if (
     false
   ) {}
 };

 Store.prototype.dispatch = function dispatch (_type, _payload) {
     var this$1 = this;

   // check object-style dispatch
   var ref = unifyObjectStyle(_type, _payload);
     var type = ref.type;
     var payload = ref.payload;

   var action = { type: type, payload: payload };
   var entry = this._actions[type];
   if (!entry) {
     if ((false)) {}
     return
   }

   try {
     this._actionSubscribers
       .slice() // shallow copy to prevent iterator invalidation if subscriber synchronously calls unsubscribe
       .filter(function (sub) { return sub.before; })
       .forEach(function (sub) { return sub.before(action, this$1.state); });
   } catch (e) {
     if ((false)) {}
   }

   var result = entry.length > 1
     ? Promise.all(entry.map(function (handler) { return handler(payload); }))
     : entry[0](payload);

   return new Promise(function (resolve, reject) {
     result.then(function (res) {
       try {
         this$1._actionSubscribers
           .filter(function (sub) { return sub.after; })
           .forEach(function (sub) { return sub.after(action, this$1.state); });
       } catch (e) {
         if ((false)) {}
       }
       resolve(res);
     }, function (error) {
       try {
         this$1._actionSubscribers
           .filter(function (sub) { return sub.error; })
           .forEach(function (sub) { return sub.error(action, this$1.state, error); });
       } catch (e) {
         if ((false)) {}
       }
       reject(error);
     });
   })
 };

 Store.prototype.subscribe = function subscribe (fn, options) {
   return genericSubscribe(fn, this._subscribers, options)
 };

 Store.prototype.subscribeAction = function subscribeAction (fn, options) {
   var subs = typeof fn === 'function' ? { before: fn } : fn;
   return genericSubscribe(subs, this._actionSubscribers, options)
 };

 Store.prototype.watch = function watch (getter, cb, options) {
     var this$1 = this;

   if ((false)) {}
   return this._watcherVM.$watch(function () { return getter(this$1.state, this$1.getters); }, cb, options)
 };

 Store.prototype.replaceState = function replaceState (state) {
     var this$1 = this;

   this._withCommit(function () {
     this$1._vm._data.$$state = state;
   });
 };

 Store.prototype.registerModule = function registerModule (path, rawModule, options) {
     if ( options === void 0 ) options = {};

   if (typeof path === 'string') { path = [path]; }

   if ((false)) {}

   this._modules.register(path, rawModule);
   installModule(this, this.state, path, this._modules.get(path), options.preserveState);
   // reset store to update getters...
   resetStoreVM(this, this.state);
 };

 Store.prototype.unregisterModule = function unregisterModule (path) {
     var this$1 = this;

   if (typeof path === 'string') { path = [path]; }

   if ((false)) {}

   this._modules.unregister(path);
   this._withCommit(function () {
     var parentState = getNestedState(this$1.state, path.slice(0, -1));
     Vue.delete(parentState, path[path.length - 1]);
   });
   resetStore(this);
 };

 Store.prototype.hasModule = function hasModule (path) {
   if (typeof path === 'string') { path = [path]; }

   if ((false)) {}

   return this._modules.isRegistered(path)
 };

 Store.prototype.hotUpdate = function hotUpdate (newOptions) {
   this._modules.update(newOptions);
   resetStore(this, true);
 };

 Store.prototype._withCommit = function _withCommit (fn) {
   var committing = this._committing;
   this._committing = true;
   fn();
   this._committing = committing;
 };

 Object.defineProperties( Store.prototype, prototypeAccessors$1 );

 function genericSubscribe (fn, subs, options) {
   if (subs.indexOf(fn) < 0) {
     options && options.prepend
       ? subs.unshift(fn)
       : subs.push(fn);
   }
   return function () {
     var i = subs.indexOf(fn);
     if (i > -1) {
       subs.splice(i, 1);
     }
   }
 }

 function resetStore (store, hot) {
   store._actions = Object.create(null);
   store._mutations = Object.create(null);
   store._wrappedGetters = Object.create(null);
   store._modulesNamespaceMap = Object.create(null);
   var state = store.state;
   // init all modules
   installModule(store, state, [], store._modules.root, true);
   // reset vm
   resetStoreVM(store, state, hot);
 }

 function resetStoreVM (store, state, hot) {
   var oldVm = store._vm;

   // bind store public getters
   store.getters = {};
   // reset local getters cache
   store._makeLocalGettersCache = Object.create(null);
   var wrappedGetters = store._wrappedGetters;
   var computed = {};
   forEachValue(wrappedGetters, function (fn, key) {
     // use computed to leverage its lazy-caching mechanism
     // direct inline function use will lead to closure preserving oldVm.
     // using partial to return function with only arguments preserved in closure environment.
     computed[key] = partial(fn, store);
     Object.defineProperty(store.getters, key, {
       get: function () { return store._vm[key]; },
       enumerable: true // for local getters
     });
   });

   // use a Vue instance to store the state tree
   // suppress warnings just in case the user has added
   // some funky global mixins
   var silent = Vue.config.silent;
   Vue.config.silent = true;
   store._vm = new Vue({
     data: {
       $$state: state
     },
     computed: computed
   });
   Vue.config.silent = silent;

   // enable strict mode for new vm
   if (store.strict) {
     enableStrictMode(store);
   }

   if (oldVm) {
     if (hot) {
       // dispatch changes in all subscribed watchers
       // to force getter re-evaluation for hot reloading.
       store._withCommit(function () {
         oldVm._data.$$state = null;
       });
     }
     Vue.nextTick(function () { return oldVm.$destroy(); });
   }
 }

 function installModule (store, rootState, path, module, hot) {
   var isRoot = !path.length;
   var namespace = store._modules.getNamespace(path);

   // register in namespace map
   if (module.namespaced) {
     if (store._modulesNamespaceMap[namespace] && ("production" !== 'production')) {
       console.error(("[vuex] duplicate namespace " + namespace + " for the namespaced module " + (path.join('/'))));
     }
     store._modulesNamespaceMap[namespace] = module;
   }

   // set state
   if (!isRoot && !hot) {
     var parentState = getNestedState(rootState, path.slice(0, -1));
     var moduleName = path[path.length - 1];
     store._withCommit(function () {
       if ((false)) {}
       Vue.set(parentState, moduleName, module.state);
     });
   }

   var local = module.context = makeLocalContext(store, namespace, path);

   module.forEachMutation(function (mutation, key) {
     var namespacedType = namespace + key;
     registerMutation(store, namespacedType, mutation, local);
   });

   module.forEachAction(function (action, key) {
     var type = action.root ? key : namespace + key;
     var handler = action.handler || action;
     registerAction(store, type, handler, local);
   });

   module.forEachGetter(function (getter, key) {
     var namespacedType = namespace + key;
     registerGetter(store, namespacedType, getter, local);
   });

   module.forEachChild(function (child, key) {
     installModule(store, rootState, path.concat(key), child, hot);
   });
 }

 /**
  * make localized dispatch, commit, getters and state
  * if there is no namespace, just use root ones
  */
 function makeLocalContext (store, namespace, path) {
   var noNamespace = namespace === '';

   var local = {
     dispatch: noNamespace ? store.dispatch : function (_type, _payload, _options) {
       var args = unifyObjectStyle(_type, _payload, _options);
       var payload = args.payload;
       var options = args.options;
       var type = args.type;

       if (!options || !options.root) {
         type = namespace + type;
         if (false) {}
       }

       return store.dispatch(type, payload)
     },

     commit: noNamespace ? store.commit : function (_type, _payload, _options) {
       var args = unifyObjectStyle(_type, _payload, _options);
       var payload = args.payload;
       var options = args.options;
       var type = args.type;

       if (!options || !options.root) {
         type = namespace + type;
         if (false) {}
       }

       store.commit(type, payload, options);
     }
   };

   // getters and state object must be gotten lazily
   // because they will be changed by vm update
   Object.defineProperties(local, {
     getters: {
       get: noNamespace
         ? function () { return store.getters; }
         : function () { return makeLocalGetters(store, namespace); }
     },
     state: {
       get: function () { return getNestedState(store.state, path); }
     }
   });

   return local
 }

 function makeLocalGetters (store, namespace) {
   if (!store._makeLocalGettersCache[namespace]) {
     var gettersProxy = {};
     var splitPos = namespace.length;
     Object.keys(store.getters).forEach(function (type) {
       // skip if the target getter is not match this namespace
       if (type.slice(0, splitPos) !== namespace) { return }

       // extract local getter type
       var localType = type.slice(splitPos);

       // Add a port to the getters proxy.
       // Define as getter property because
       // we do not want to evaluate the getters in this time.
       Object.defineProperty(gettersProxy, localType, {
         get: function () { return store.getters[type]; },
         enumerable: true
       });
     });
     store._makeLocalGettersCache[namespace] = gettersProxy;
   }

   return store._makeLocalGettersCache[namespace]
 }

 function registerMutation (store, type, handler, local) {
   var entry = store._mutations[type] || (store._mutations[type] = []);
   entry.push(function wrappedMutationHandler (payload) {
     handler.call(store, local.state, payload);
   });
 }

 function registerAction (store, type, handler, local) {
   var entry = store._actions[type] || (store._actions[type] = []);
   entry.push(function wrappedActionHandler (payload) {
     var res = handler.call(store, {
       dispatch: local.dispatch,
       commit: local.commit,
       getters: local.getters,
       state: local.state,
       rootGetters: store.getters,
       rootState: store.state
     }, payload);
     if (!isPromise(res)) {
       res = Promise.resolve(res);
     }
     if (store._devtoolHook) {
       return res.catch(function (err) {
         store._devtoolHook.emit('vuex:error', err);
         throw err
       })
     } else {
       return res
     }
   });
 }

 function registerGetter (store, type, rawGetter, local) {
   if (store._wrappedGetters[type]) {
     if ((false)) {}
     return
   }
   store._wrappedGetters[type] = function wrappedGetter (store) {
     return rawGetter(
       local.state, // local state
       local.getters, // local getters
       store.state, // root state
       store.getters // root getters
     )
   };
 }

 function enableStrictMode (store) {
   store._vm.$watch(function () { return this._data.$$state }, function () {
     if ((false)) {}
   }, { deep: true, sync: true });
 }

 function getNestedState (state, path) {
   return path.reduce(function (state, key) { return state[key]; }, state)
 }

 function unifyObjectStyle (type, payload, options) {
   if (isObject(type) && type.type) {
     options = payload;
     payload = type;
     type = type.type;
   }

   if ((false)) {}

   return { type: type, payload: payload, options: options }
 }

 function install (_Vue) {
   if (Vue && _Vue === Vue) {
     if ((false)) {}
     return
   }
   Vue = _Vue;
   applyMixin(Vue);
 }

 /**
  * Reduce the code which written in Vue.js for getting the state.
  * @param {String} [namespace] - Module's namespace
  * @param {Object|Array} states # Object's item can be a function which accept state and getters for param, you can do something for state and getters in it.
  * @param {Object}
  */
 var mapState = normalizeNamespace(function (namespace, states) {
   var res = {};
   if (false) {}
   normalizeMap(states).forEach(function (ref) {
     var key = ref.key;
     var val = ref.val;

     res[key] = function mappedState () {
       var state = this.$store.state;
       var getters = this.$store.getters;
       if (namespace) {
         var module = getModuleByNamespace(this.$store, 'mapState', namespace);
         if (!module) {
           return
         }
         state = module.context.state;
         getters = module.context.getters;
       }
       return typeof val === 'function'
         ? val.call(this, state, getters)
         : state[val]
     };
     // mark vuex getter for devtools
     res[key].vuex = true;
   });
   return res
 });

 /**
  * Reduce the code which written in Vue.js for committing the mutation
  * @param {String} [namespace] - Module's namespace
  * @param {Object|Array} mutations # Object's item can be a function which accept `commit` function as the first param, it can accept another params. You can commit mutation and do any other things in this function. specially, You need to pass anthor params from the mapped function.
  * @return {Object}
  */
 var mapMutations = normalizeNamespace(function (namespace, mutations) {
   var res = {};
   if (false) {}
   normalizeMap(mutations).forEach(function (ref) {
     var key = ref.key;
     var val = ref.val;

     res[key] = function mappedMutation () {
       var args = [], len = arguments.length;
       while ( len-- ) args[ len ] = arguments[ len ];

       // Get the commit method from store
       var commit = this.$store.commit;
       if (namespace) {
         var module = getModuleByNamespace(this.$store, 'mapMutations', namespace);
         if (!module) {
           return
         }
         commit = module.context.commit;
       }
       return typeof val === 'function'
         ? val.apply(this, [commit].concat(args))
         : commit.apply(this.$store, [val].concat(args))
     };
   });
   return res
 });

 /**
  * Reduce the code which written in Vue.js for getting the getters
  * @param {String} [namespace] - Module's namespace
  * @param {Object|Array} getters
  * @return {Object}
  */
 var mapGetters = normalizeNamespace(function (namespace, getters) {
   var res = {};
   if (false) {}
   normalizeMap(getters).forEach(function (ref) {
     var key = ref.key;
     var val = ref.val;

     // The namespace has been mutated by normalizeNamespace
     val = namespace + val;
     res[key] = function mappedGetter () {
       if (namespace && !getModuleByNamespace(this.$store, 'mapGetters', namespace)) {
         return
       }
       if (false) {}
       return this.$store.getters[val]
     };
     // mark vuex getter for devtools
     res[key].vuex = true;
   });
   return res
 });

 /**
  * Reduce the code which written in Vue.js for dispatch the action
  * @param {String} [namespace] - Module's namespace
  * @param {Object|Array} actions # Object's item can be a function which accept `dispatch` function as the first param, it can accept anthor params. You can dispatch action and do any other things in this function. specially, You need to pass anthor params from the mapped function.
  * @return {Object}
  */
 var mapActions = normalizeNamespace(function (namespace, actions) {
   var res = {};
   if (false) {}
   normalizeMap(actions).forEach(function (ref) {
     var key = ref.key;
     var val = ref.val;

     res[key] = function mappedAction () {
       var args = [], len = arguments.length;
       while ( len-- ) args[ len ] = arguments[ len ];

       // get dispatch function from store
       var dispatch = this.$store.dispatch;
       if (namespace) {
         var module = getModuleByNamespace(this.$store, 'mapActions', namespace);
         if (!module) {
           return
         }
         dispatch = module.context.dispatch;
       }
       return typeof val === 'function'
         ? val.apply(this, [dispatch].concat(args))
         : dispatch.apply(this.$store, [val].concat(args))
     };
   });
   return res
 });

 /**
  * Rebinding namespace param for mapXXX function in special scoped, and return them by simple object
  * @param {String} namespace
  * @return {Object}
  */
 var createNamespacedHelpers = function (namespace) { return ({
   mapState: mapState.bind(null, namespace),
   mapGetters: mapGetters.bind(null, namespace),
   mapMutations: mapMutations.bind(null, namespace),
   mapActions: mapActions.bind(null, namespace)
 }); };

 /**
  * Normalize the map
  * normalizeMap([1, 2, 3]) => [ { key: 1, val: 1 }, { key: 2, val: 2 }, { key: 3, val: 3 } ]
  * normalizeMap({a: 1, b: 2, c: 3}) => [ { key: 'a', val: 1 }, { key: 'b', val: 2 }, { key: 'c', val: 3 } ]
  * @param {Array|Object} map
  * @return {Object}
  */
 function normalizeMap (map) {
   if (!isValidMap(map)) {
     return []
   }
   return Array.isArray(map)
     ? map.map(function (key) { return ({ key: key, val: key }); })
     : Object.keys(map).map(function (key) { return ({ key: key, val: map[key] }); })
 }

 /**
  * Validate whether given map is valid or not
  * @param {*} map
  * @return {Boolean}
  */
 function isValidMap (map) {
   return Array.isArray(map) || isObject(map)
 }

 /**
  * Return a function expect two param contains namespace and map. it will normalize the namespace and then the param's function will handle the new namespace and the map.
  * @param {Function} fn
  * @return {Function}
  */
 function normalizeNamespace (fn) {
   return function (namespace, map) {
     if (typeof namespace !== 'string') {
       map = namespace;
       namespace = '';
     } else if (namespace.charAt(namespace.length - 1) !== '/') {
       namespace += '/';
     }
     return fn(namespace, map)
   }
 }

 /**
  * Search a special module from store by namespace. if module not exist, print error message.
  * @param {Object} store
  * @param {String} helper
  * @param {String} namespace
  * @return {Object}
  */
 function getModuleByNamespace (store, helper, namespace) {
   var module = store._modulesNamespaceMap[namespace];
   if (false) {}
   return module
 }

 // Credits: borrowed code from fcomb/redux-logger

 function createLogger (ref) {
   if ( ref === void 0 ) ref = {};
   var collapsed = ref.collapsed; if ( collapsed === void 0 ) collapsed = true;
   var filter = ref.filter; if ( filter === void 0 ) filter = function (mutation, stateBefore, stateAfter) { return true; };
   var transformer = ref.transformer; if ( transformer === void 0 ) transformer = function (state) { return state; };
   var mutationTransformer = ref.mutationTransformer; if ( mutationTransformer === void 0 ) mutationTransformer = function (mut) { return mut; };
   var actionFilter = ref.actionFilter; if ( actionFilter === void 0 ) actionFilter = function (action, state) { return true; };
   var actionTransformer = ref.actionTransformer; if ( actionTransformer === void 0 ) actionTransformer = function (act) { return act; };
   var logMutations = ref.logMutations; if ( logMutations === void 0 ) logMutations = true;
   var logActions = ref.logActions; if ( logActions === void 0 ) logActions = true;
   var logger = ref.logger; if ( logger === void 0 ) logger = console;

   return function (store) {
     var prevState = deepCopy(store.state);

     if (typeof logger === 'undefined') {
       return
     }

     if (logMutations) {
       store.subscribe(function (mutation, state) {
         var nextState = deepCopy(state);

         if (filter(mutation, prevState, nextState)) {
           var formattedTime = getFormattedTime();
           var formattedMutation = mutationTransformer(mutation);
           var message = "mutation " + (mutation.type) + formattedTime;

           startMessage(logger, message, collapsed);
           logger.log('%c prev state', 'color: #9E9E9E; font-weight: bold', transformer(prevState));
           logger.log('%c mutation', 'color: #03A9F4; font-weight: bold', formattedMutation);
           logger.log('%c next state', 'color: #4CAF50; font-weight: bold', transformer(nextState));
           endMessage(logger);
         }

         prevState = nextState;
       });
     }

     if (logActions) {
       store.subscribeAction(function (action, state) {
         if (actionFilter(action, state)) {
           var formattedTime = getFormattedTime();
           var formattedAction = actionTransformer(action);
           var message = "action " + (action.type) + formattedTime;

           startMessage(logger, message, collapsed);
           logger.log('%c action', 'color: #03A9F4; font-weight: bold', formattedAction);
           endMessage(logger);
         }
       });
     }
   }
 }

 function startMessage (logger, message, collapsed) {
   var startMessage = collapsed
     ? logger.groupCollapsed
     : logger.group;

   // render
   try {
     startMessage.call(logger, message);
   } catch (e) {
     logger.log(message);
   }
 }

 function endMessage (logger) {
   try {
     logger.groupEnd();
   } catch (e) {
     logger.log('—— log end ——');
   }
 }

 function getFormattedTime () {
   var time = new Date();
   return (" @ " + (pad(time.getHours(), 2)) + ":" + (pad(time.getMinutes(), 2)) + ":" + (pad(time.getSeconds(), 2)) + "." + (pad(time.getMilliseconds(), 3)))
 }

 function repeat (str, times) {
   return (new Array(times + 1)).join(str)
 }

 function pad (num, maxLength) {
   return repeat('0', maxLength - num.toString().length) + num
 }

 var index = {
   Store: Store,
   install: install,
   version: '3.6.2',
   mapState: mapState,
   mapMutations: mapMutations,
   mapGetters: mapGetters,
   mapActions: mapActions,
   createNamespacedHelpers: createNamespacedHelpers,
   createLogger: createLogger
 };

 /* harmony default export */ __webpack_exports__["b"] = (index);


 /* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(69)))

 /***/ }),
 /* 80 */
 /***/ (function(module, exports, __webpack_require__) {

 "use strict";

 var $ = __webpack_require__(13);
 var global = __webpack_require__(2);
 var isArray = __webpack_require__(105);
 var isConstructor = __webpack_require__(107);
 var isObject = __webpack_require__(18);
 var toAbsoluteIndex = __webpack_require__(137);
 var lengthOfArrayLike = __webpack_require__(56);
 var toIndexedObject = __webpack_require__(30);
 var createProperty = __webpack_require__(126);
 var wellKnownSymbol = __webpack_require__(12);
 var arrayMethodHasSpeciesSupport = __webpack_require__(127);
 var un$Slice = __webpack_require__(85);

 var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('slice');

 var SPECIES = wellKnownSymbol('species');
 var Array = global.Array;
 var max = Math.max;

 // `Array.prototype.slice` method
 // https://tc39.es/ecma262/#sec-array.prototype.slice
 // fallback for not array-like ES3 strings and DOM objects
 $({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
   slice: function slice(start, end) {
     var O = toIndexedObject(this);
     var length = lengthOfArrayLike(O);
     var k = toAbsoluteIndex(start, length);
     var fin = toAbsoluteIndex(end === undefined ? length : end, length);
     // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
     var Constructor, result, n;
     if (isArray(O)) {
       Constructor = O.constructor;
       // cross-realm fallback
       if (isConstructor(Constructor) && (Constructor === Array || isArray(Constructor.prototype))) {
         Constructor = undefined;
       } else if (isObject(Constructor)) {
         Constructor = Constructor[SPECIES];
         if (Constructor === null) Constructor = undefined;
       }
       if (Constructor === Array || Constructor === undefined) {
         return un$Slice(O, k, fin);
       }
     }
     result = new (Constructor === undefined ? Array : Constructor)(max(fin - k, 0));
     for (n = 0; k < fin; k++, n++) if (k in O) createProperty(result, n, O[k]);
     result.length = n;
     return result;
   }
 });


 /***/ }),
 /* 81 */
 /***/ (function(module, exports, __webpack_require__) {

 "use strict";

 var $ = __webpack_require__(13);
 var uncurryThis = __webpack_require__(5);
 var notARegExp = __webpack_require__(193);
 var requireObjectCoercible = __webpack_require__(37);
 var toString = __webpack_require__(28);
 var correctIsRegExpLogic = __webpack_require__(192);

 var stringIndexOf = uncurryThis(''.indexOf);

 // `String.prototype.includes` method
 // https://tc39.es/ecma262/#sec-string.prototype.includes
 $({ target: 'String', proto: true, forced: !correctIsRegExpLogic('includes') }, {
   includes: function includes(searchString /* , position = 0 */) {
     return !!~stringIndexOf(
       toString(requireObjectCoercible(this)),
       toString(notARegExp(searchString)),
       arguments.length > 1 ? arguments[1] : undefined
     );
   }
 });


 /***/ }),
 /* 82 */
 /***/ (function(module, exports, __webpack_require__) {

 "use strict";

 var $ = __webpack_require__(13);
 var $includes = __webpack_require__(138).includes;
 var addToUnscopables = __webpack_require__(116);

 // `Array.prototype.includes` method
 // https://tc39.es/ecma262/#sec-array.prototype.includes
 $({ target: 'Array', proto: true }, {
   includes: function includes(el /* , fromIndex = 0 */) {
     return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
   }
 });

 // https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
 addToUnscopables('includes');


 /***/ }),
 /* 83 */
 /***/ (function(module, exports, __webpack_require__) {

 var bind = __webpack_require__(64);
 var uncurryThis = __webpack_require__(5);
 var IndexedObject = __webpack_require__(89);
 var toObject = __webpack_require__(42);
 var lengthOfArrayLike = __webpack_require__(56);
 var arraySpeciesCreate = __webpack_require__(128);

 var push = uncurryThis([].push);

 // `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
 var createMethod = function (TYPE) {
   var IS_MAP = TYPE == 1;
   var IS_FILTER = TYPE == 2;
   var IS_SOME = TYPE == 3;
   var IS_EVERY = TYPE == 4;
   var IS_FIND_INDEX = TYPE == 6;
   var IS_FILTER_REJECT = TYPE == 7;
   var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
   return function ($this, callbackfn, that, specificCreate) {
     var O = toObject($this);
     var self = IndexedObject(O);
     var boundFunction = bind(callbackfn, that);
     var length = lengthOfArrayLike(self);
     var index = 0;
     var create = specificCreate || arraySpeciesCreate;
     var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
     var value, result;
     for (;length > index; index++) if (NO_HOLES || index in self) {
       value = self[index];
       result = boundFunction(value, index, O);
       if (TYPE) {
         if (IS_MAP) target[index] = result; // map
         else if (result) switch (TYPE) {
           case 3: return true;              // some
           case 5: return value;             // find
           case 6: return index;             // findIndex
           case 2: push(target, value);      // filter
         } else switch (TYPE) {
           case 4: return false;             // every
           case 7: push(target, value);      // filterReject
         }
       }
     }
     return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
   };
 };

 module.exports = {
   // `Array.prototype.forEach` method
   // https://tc39.es/ecma262/#sec-array.prototype.foreach
   forEach: createMethod(0),
   // `Array.prototype.map` method
   // https://tc39.es/ecma262/#sec-array.prototype.map
   map: createMethod(1),
   // `Array.prototype.filter` method
   // https://tc39.es/ecma262/#sec-array.prototype.filter
   filter: createMethod(2),
   // `Array.prototype.some` method
   // https://tc39.es/ecma262/#sec-array.prototype.some
   some: createMethod(3),
   // `Array.prototype.every` method
   // https://tc39.es/ecma262/#sec-array.prototype.every
   every: createMethod(4),
   // `Array.prototype.find` method
   // https://tc39.es/ecma262/#sec-array.prototype.find
   find: createMethod(5),
   // `Array.prototype.findIndex` method
   // https://tc39.es/ecma262/#sec-array.prototype.findIndex
   findIndex: createMethod(6),
   // `Array.prototype.filterReject` method
   // https://github.com/tc39/proposal-array-filtering
   filterReject: createMethod(7)
 };


 /***/ }),
 /* 84 */
 /***/ (function(module, exports, __webpack_require__) {

 var internalObjectKeys = __webpack_require__(120);
 var enumBugKeys = __webpack_require__(87);

 // `Object.keys` method
 // https://tc39.es/ecma262/#sec-object.keys
 // eslint-disable-next-line es/no-object-keys -- safe
 module.exports = Object.keys || function keys(O) {
   return internalObjectKeys(O, enumBugKeys);
 };


 /***/ }),
 /* 85 */
 /***/ (function(module, exports, __webpack_require__) {

 var uncurryThis = __webpack_require__(5);

 module.exports = uncurryThis([].slice);


 /***/ }),
 /* 86 */
 /***/ (function(module, exports, __webpack_require__) {

 var fails = __webpack_require__(10);
 var isCallable = __webpack_require__(11);

 var replacement = /#|\.prototype\./;

 var isForced = function (feature, detection) {
   var value = data[normalize(feature)];
   return value == POLYFILL ? true
     : value == NATIVE ? false
     : isCallable(detection) ? fails(detection)
     : !!detection;
 };

 var normalize = isForced.normalize = function (string) {
   return String(string).replace(replacement, '.').toLowerCase();
 };

 var data = isForced.data = {};
 var NATIVE = isForced.NATIVE = 'N';
 var POLYFILL = isForced.POLYFILL = 'P';

 module.exports = isForced;


 /***/ }),
 /* 87 */
 /***/ (function(module, exports) {

 // IE8- don't enum bug keys
 module.exports = [
   'constructor',
   'hasOwnProperty',
   'isPrototypeOf',
   'propertyIsEnumerable',
   'toLocaleString',
   'toString',
   'valueOf'
 ];


 /***/ }),
 /* 88 */
 /***/ (function(module, exports, __webpack_require__) {

 var toIntegerOrInfinity = __webpack_require__(65);

 var min = Math.min;

 // `ToLength` abstract operation
 // https://tc39.es/ecma262/#sec-tolength
 module.exports = function (argument) {
   return argument > 0 ? min(toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
 };


 /***/ }),
 /* 89 */
 /***/ (function(module, exports, __webpack_require__) {

 var global = __webpack_require__(2);
 var uncurryThis = __webpack_require__(5);
 var fails = __webpack_require__(10);
 var classof = __webpack_require__(47);

 var Object = global.Object;
 var split = uncurryThis(''.split);

 // fallback for non-array-like ES3 and non-enumerable old V8 strings
 module.exports = fails(function () {
   // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
   // eslint-disable-next-line no-prototype-builtins -- safe
   return !Object('z').propertyIsEnumerable(0);
 }) ? function (it) {
   return classof(it) == 'String' ? split(it, '') : Object(it);
 } : Object;


 /***/ }),
 /* 90 */
 /***/ (function(module, exports, __webpack_require__) {

 var DESCRIPTORS = __webpack_require__(23);
 var hasOwn = __webpack_require__(19);

 var FunctionPrototype = Function.prototype;
 // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
 var getDescriptor = DESCRIPTORS && Object.getOwnPropertyDescriptor;

 var EXISTS = hasOwn(FunctionPrototype, 'name');
 // additional protection from minified / mangled / dropped function names
 var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
 var CONFIGURABLE = EXISTS && (!DESCRIPTORS || (DESCRIPTORS && getDescriptor(FunctionPrototype, 'name').configurable));

 module.exports = {
   EXISTS: EXISTS,
   PROPER: PROPER,
   CONFIGURABLE: CONFIGURABLE
 };


 /***/ }),
 /* 91 */
 /***/ (function(module, exports, __webpack_require__) {

 var shared = __webpack_require__(99);
 var uid = __webpack_require__(96);

 var keys = shared('keys');

 module.exports = function (key) {
   return keys[key] || (keys[key] = uid(key));
 };


 /***/ }),
 /* 92 */
 /***/ (function(module, exports, __webpack_require__) {

 var global = __webpack_require__(2);
 var getBuiltIn = __webpack_require__(33);
 var isCallable = __webpack_require__(11);
 var isPrototypeOf = __webpack_require__(59);
 var USE_SYMBOL_AS_UID = __webpack_require__(122);

 var Object = global.Object;

 module.exports = USE_SYMBOL_AS_UID ? function (it) {
   return typeof it == 'symbol';
 } : function (it) {
   var $Symbol = getBuiltIn('Symbol');
   return isCallable($Symbol) && isPrototypeOf($Symbol.prototype, Object(it));
 };


 /***/ }),
 /* 93 */
 /***/ (function(module, exports, __webpack_require__) {

 var toPrimitive = __webpack_require__(141);
 var isSymbol = __webpack_require__(92);

 // `ToPropertyKey` abstract operation
 // https://tc39.es/ecma262/#sec-topropertykey
 module.exports = function (argument) {
   var key = toPrimitive(argument, 'string');
   return isSymbol(key) ? key : key + '';
 };


 /***/ }),
 /* 94 */
 /***/ (function(module, exports, __webpack_require__) {

 var global = __webpack_require__(2);
 var isObject = __webpack_require__(18);

 var document = global.document;
 // typeof document.createElement is 'object' in old IE
 var EXISTS = isObject(document) && isObject(document.createElement);

 module.exports = function (it) {
   return EXISTS ? document.createElement(it) : {};
 };


 /***/ }),
 /* 95 */
 /***/ (function(module, exports, __webpack_require__) {

 var global = __webpack_require__(2);
 var userAgent = __webpack_require__(68);

 var process = global.process;
 var Deno = global.Deno;
 var versions = process && process.versions || Deno && Deno.version;
 var v8 = versions && versions.v8;
 var match, version;

 if (v8) {
   match = v8.split('.');
   // in old Chrome, versions of V8 isn't V8 = Chrome / 10
   // but their correct versions are not interesting for us
   version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
 }

 // BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
 // so check `userAgent` even if `.v8` exists, but 0
 if (!version && userAgent) {
   match = userAgent.match(/Edge\/(\d+)/);
   if (!match || match[1] >= 74) {
     match = userAgent.match(/Chrome\/(\d+)/);
     if (match) version = +match[1];
   }
 }

 module.exports = version;


 /***/ }),
 /* 96 */
 /***/ (function(module, exports, __webpack_require__) {

 var uncurryThis = __webpack_require__(5);

 var id = 0;
 var postfix = Math.random();
 var toString = uncurryThis(1.0.toString);

 module.exports = function (key) {
   return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString(++id + postfix, 36);
 };


 /***/ }),
 /* 97 */
 /***/ (function(module, exports, __webpack_require__) {

 var global = __webpack_require__(2);

 // eslint-disable-next-line es/no-object-defineproperty -- safe
 var defineProperty = Object.defineProperty;

 module.exports = function (key, value) {
   try {
     defineProperty(global, key, { value: value, configurable: true, writable: true });
   } catch (error) {
     global[key] = value;
   } return value;
 };


 /***/ }),
 /* 98 */
 /***/ (function(module, exports, __webpack_require__) {

 var global = __webpack_require__(2);
 var setGlobal = __webpack_require__(97);

 var SHARED = '__core-js_shared__';
 var store = global[SHARED] || setGlobal(SHARED, {});

 module.exports = store;


 /***/ }),
 /* 99 */
 /***/ (function(module, exports, __webpack_require__) {

 var IS_PURE = __webpack_require__(60);
 var store = __webpack_require__(98);

 (module.exports = function (key, value) {
   return store[key] || (store[key] = value !== undefined ? value : {});
 })('versions', []).push({
   version: '3.19.1',
   mode: IS_PURE ? 'pure' : 'global',
   copyright: '© 2021 Denis Pushkarev (zloirock.ru)'
 });


 /***/ }),
 /* 100 */
 /***/ (function(module, exports, __webpack_require__) {

 var wellKnownSymbol = __webpack_require__(12);

 var TO_STRING_TAG = wellKnownSymbol('toStringTag');
 var test = {};

 test[TO_STRING_TAG] = 'z';

 module.exports = String(test) === '[object z]';


 /***/ }),
 /* 101 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";
 __webpack_require__.r(__webpack_exports__);
 function Popup(container) {
   this.container = container;

   if (!this.container) {
     return null;
   }

   this.selectors = {
     container: "[data-popup]",
     close: "[data-popup-close]"
   };
   this.initEvents();
 }

 Popup.prototype.initEvents = function () {
   var _this = this;

   document.addEventListener("click", function (event) {
     var target = event.target;
     var closeButton = target.closest(_this.selectors.close);

     if (!closeButton) {
       return null;
     }

     var popup = closeButton.closest(_this.selectors.container);
     document.dispatchEvent(new CustomEvent("popup:close", {
       detail: {
         popup: popup
       }
     }));
   });
 };

 Popup.prototype.open = function () {
   document.dispatchEvent(new CustomEvent("popup:open", {
     detail: {
       popup: this.container
     }
   }));
 };

 Popup.prototype.close = function () {
   document.dispatchEvent(new CustomEvent("popup:close", {
     detail: {
       popup: this.container
     }
   }));
 };

 /* harmony default export */ __webpack_exports__["default"] = (Popup);

 /***/ }),
 /* 102 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";
 /* unused harmony export preload */
 /* unused harmony export loadImage */
 /* unused harmony export imageSize */
 /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getSizedImageUrl; });
 /* unused harmony export removeProtocol */
 /**
  * Image Helper Functions
  * -----------------------------------------------------------------------------
  * https://github.com/Shopify/slate.git.
  *
  */

 /**
  * Preloads an image in memory and uses the browsers cache to store it until needed.
  *
  * @param {Array} images - A list of image urls
  * @param {String} size - A shopify image size attribute
  */

 function preload(images, size) {
   if (typeof images === 'string') {
     images = [images];
   }

   for (let i = 0; i < images.length; i++) {
     const image = images[i];
     loadImage(getSizedImageUrl(image, size));
   }
 }

 /**
  * Loads and caches an image in the browsers cache.
  * @param {string} path - An image url
  */
 function loadImage(path) {
   new Image().src = path;
 }

 /**
  * Find the Shopify image attribute size
  *
  * @param {string} src
  * @returns {null}
  */
 function imageSize(src) {
   const match = src.match(
     /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/
   );

   if (match) {
     return match[1];
   } else {
     return null;
   }
 }

 /**
  * Adds a Shopify size attribute to a URL
  *
  * @param src
  * @param size
  * @returns {*}
  */
 function getSizedImageUrl(src, size) {
   if (size === null) {
     return src;
   }

   if (size === 'master') {
     return removeProtocol(src);
   }

   const match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

   if (match) {
     const prefix = src.split(match[0]);
     const suffix = match[0];

     return removeProtocol(`${prefix[0]}_${size}${suffix}`);
   } else {
     return null;
   }
 }

 function removeProtocol(path) {
   return path.replace(/http(s)?:/, '');
 }


 /***/ }),
 /* 103 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";

 // EXTERNAL MODULE: ./node_modules/ssr-window/ssr-window.esm.js
 var ssr_window_esm = __webpack_require__(4);

 // EXTERNAL MODULE: ./node_modules/swiper/esm/utils/dom.js + 1 modules
 var dom = __webpack_require__(9);

 // EXTERNAL MODULE: ./node_modules/swiper/esm/utils/utils.js
 var utils = __webpack_require__(6);

 // CONCATENATED MODULE: ./node_modules/swiper/esm/utils/get-support.js

 var get_support_support;

 function calcSupport() {
   var window = Object(ssr_window_esm["b" /* getWindow */])();
   var document = Object(ssr_window_esm["a" /* getDocument */])();
   return {
     touch: !!('ontouchstart' in window || window.DocumentTouch && document instanceof window.DocumentTouch),
     pointerEvents: !!window.PointerEvent && 'maxTouchPoints' in window.navigator && window.navigator.maxTouchPoints >= 0,
     observer: function checkObserver() {
       return 'MutationObserver' in window || 'WebkitMutationObserver' in window;
     }(),
     passiveListener: function checkPassiveListener() {
       var supportsPassive = false;

       try {
         var opts = Object.defineProperty({}, 'passive', {
           // eslint-disable-next-line
           get: function get() {
             supportsPassive = true;
           }
         });
         window.addEventListener('testPassiveListener', null, opts);
       } catch (e) {// No support
       }

       return supportsPassive;
     }(),
     gestures: function checkGestures() {
       return 'ongesturestart' in window;
     }()
   };
 }

 function getSupport() {
   if (!get_support_support) {
     get_support_support = calcSupport();
   }

   return get_support_support;
 }


 // CONCATENATED MODULE: ./node_modules/swiper/esm/utils/get-device.js


 var get_device_device;

 function calcDevice(_temp) {
   var _ref = _temp === void 0 ? {} : _temp,
       userAgent = _ref.userAgent;

   var support = getSupport();
   var window = Object(ssr_window_esm["b" /* getWindow */])();
   var platform = window.navigator.platform;
   var ua = userAgent || window.navigator.userAgent;
   var device = {
     ios: false,
     android: false
   };
   var screenWidth = window.screen.width;
   var screenHeight = window.screen.height;
   var android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line

   var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
   var ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
   var iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
   var windows = platform === 'Win32';
   var macos = platform === 'MacIntel'; // iPadOs 13 fix

   var iPadScreens = ['1024x1366', '1366x1024', '834x1194', '1194x834', '834x1112', '1112x834', '768x1024', '1024x768', '820x1180', '1180x820', '810x1080', '1080x810'];

   if (!ipad && macos && support.touch && iPadScreens.indexOf(screenWidth + "x" + screenHeight) >= 0) {
     ipad = ua.match(/(Version)\/([\d.]+)/);
     if (!ipad) ipad = [0, 1, '13_0_0'];
     macos = false;
   } // Android


   if (android && !windows) {
     device.os = 'android';
     device.android = true;
   }

   if (ipad || iphone || ipod) {
     device.os = 'ios';
     device.ios = true;
   } // Export object


   return device;
 }

 function getDevice(overrides) {
   if (overrides === void 0) {
     overrides = {};
   }

   if (!get_device_device) {
     get_device_device = calcDevice(overrides);
   }

   return get_device_device;
 }


 // CONCATENATED MODULE: ./node_modules/swiper/esm/utils/get-browser.js

 var browser;

 function calcBrowser() {
   var window = Object(ssr_window_esm["b" /* getWindow */])();

   function isSafari() {
     var ua = window.navigator.userAgent.toLowerCase();
     return ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0;
   }

   return {
     isEdge: !!window.navigator.userAgent.match(/Edge/g),
     isSafari: isSafari(),
     isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window.navigator.userAgent)
   };
 }

 function getBrowser() {
   if (!browser) {
     browser = calcBrowser();
   }

   return browser;
 }


 // CONCATENATED MODULE: ./node_modules/swiper/esm/modules/resize/resize.js



 var resize_supportsResizeObserver = function supportsResizeObserver() {
   var window = Object(ssr_window_esm["b" /* getWindow */])();
   return typeof window.ResizeObserver !== 'undefined';
 };

 /* harmony default export */ var resize = ({
   name: 'resize',
   create: function create() {
     var swiper = this;
     Object(utils["e" /* extend */])(swiper, {
       resize: {
         observer: null,
         createObserver: function createObserver() {
           if (!swiper || swiper.destroyed || !swiper.initialized) return;
           swiper.resize.observer = new ResizeObserver(function (entries) {
             var width = swiper.width,
                 height = swiper.height;
             var newWidth = width;
             var newHeight = height;
             entries.forEach(function (_ref) {
               var contentBoxSize = _ref.contentBoxSize,
                   contentRect = _ref.contentRect,
                   target = _ref.target;
               if (target && target !== swiper.el) return;
               newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
               newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
             });

             if (newWidth !== width || newHeight !== height) {
               swiper.resize.resizeHandler();
             }
           });
           swiper.resize.observer.observe(swiper.el);
         },
         removeObserver: function removeObserver() {
           if (swiper.resize.observer && swiper.resize.observer.unobserve && swiper.el) {
             swiper.resize.observer.unobserve(swiper.el);
             swiper.resize.observer = null;
           }
         },
         resizeHandler: function resizeHandler() {
           if (!swiper || swiper.destroyed || !swiper.initialized) return;
           swiper.emit('beforeResize');
           swiper.emit('resize');
         },
         orientationChangeHandler: function orientationChangeHandler() {
           if (!swiper || swiper.destroyed || !swiper.initialized) return;
           swiper.emit('orientationchange');
         }
       }
     });
   },
   on: {
     init: function init(swiper) {
       var window = Object(ssr_window_esm["b" /* getWindow */])();

       if (swiper.params.resizeObserver && resize_supportsResizeObserver()) {
         swiper.resize.createObserver();
         return;
       } // Emit resize


       window.addEventListener('resize', swiper.resize.resizeHandler); // Emit orientationchange

       window.addEventListener('orientationchange', swiper.resize.orientationChangeHandler);
     },
     destroy: function destroy(swiper) {
       var window = Object(ssr_window_esm["b" /* getWindow */])();
       swiper.resize.removeObserver();
       window.removeEventListener('resize', swiper.resize.resizeHandler);
       window.removeEventListener('orientationchange', swiper.resize.orientationChangeHandler);
     }
   }
 });
 // CONCATENATED MODULE: ./node_modules/swiper/esm/modules/observer/observer.js
 function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



 var Observer = {
   attach: function attach(target, options) {
     if (options === void 0) {
       options = {};
     }

     var window = Object(ssr_window_esm["b" /* getWindow */])();
     var swiper = this;
     var ObserverFunc = window.MutationObserver || window.WebkitMutationObserver;
     var observer = new ObserverFunc(function (mutations) {
       // The observerUpdate event should only be triggered
       // once despite the number of mutations.  Additional
       // triggers are redundant and are very costly
       if (mutations.length === 1) {
         swiper.emit('observerUpdate', mutations[0]);
         return;
       }

       var observerUpdate = function observerUpdate() {
         swiper.emit('observerUpdate', mutations[0]);
       };

       if (window.requestAnimationFrame) {
         window.requestAnimationFrame(observerUpdate);
       } else {
         window.setTimeout(observerUpdate, 0);
       }
     });
     observer.observe(target, {
       attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
       childList: typeof options.childList === 'undefined' ? true : options.childList,
       characterData: typeof options.characterData === 'undefined' ? true : options.characterData
     });
     swiper.observer.observers.push(observer);
   },
   init: function init() {
     var swiper = this;
     if (!swiper.support.observer || !swiper.params.observer) return;

     if (swiper.params.observeParents) {
       var containerParents = swiper.$el.parents();

       for (var i = 0; i < containerParents.length; i += 1) {
         swiper.observer.attach(containerParents[i]);
       }
     } // Observe container


     swiper.observer.attach(swiper.$el[0], {
       childList: swiper.params.observeSlideChildren
     }); // Observe wrapper

     swiper.observer.attach(swiper.$wrapperEl[0], {
       attributes: false
     });
   },
   destroy: function destroy() {
     var swiper = this;
     swiper.observer.observers.forEach(function (observer) {
       observer.disconnect();
     });
     swiper.observer.observers = [];
   }
 };
 /* harmony default export */ var observer_observer = ({
   name: 'observer',
   params: {
     observer: false,
     observeParents: false,
     observeSlideChildren: false
   },
   create: function create() {
     var swiper = this;
     Object(utils["a" /* bindModuleMethods */])(swiper, {
       observer: _extends({}, Observer, {
         observers: []
       })
     });
   },
   on: {
     init: function init(swiper) {
       swiper.observer.init();
     },
     destroy: function destroy(swiper) {
       swiper.observer.destroy();
     }
   }
 });
 // CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/modular.js

 /* harmony default export */ var modular = ({
   useParams: function useParams(instanceParams) {
     var instance = this;
     if (!instance.modules) return;
     Object.keys(instance.modules).forEach(function (moduleName) {
       var module = instance.modules[moduleName]; // Extend params

       if (module.params) {
         Object(utils["e" /* extend */])(instanceParams, module.params);
       }
     });
   },
   useModules: function useModules(modulesParams) {
     if (modulesParams === void 0) {
       modulesParams = {};
     }

     var instance = this;
     if (!instance.modules) return;
     Object.keys(instance.modules).forEach(function (moduleName) {
       var module = instance.modules[moduleName];
       var moduleParams = modulesParams[moduleName] || {}; // Add event listeners

       if (module.on && instance.on) {
         Object.keys(module.on).forEach(function (moduleEventName) {
           instance.on(moduleEventName, module.on[moduleEventName]);
         });
       } // Module create callback


       if (module.create) {
         module.create.bind(instance)(moduleParams);
       }
     });
   }
 });
 // CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/events-emitter.js
 /* eslint-disable no-underscore-dangle */
 /* harmony default export */ var events_emitter = ({
   on: function on(events, handler, priority) {
     var self = this;
     if (typeof handler !== 'function') return self;
     var method = priority ? 'unshift' : 'push';
     events.split(' ').forEach(function (event) {
       if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
       self.eventsListeners[event][method](handler);
     });
     return self;
   },
   once: function once(events, handler, priority) {
     var self = this;
     if (typeof handler !== 'function') return self;

     function onceHandler() {
       self.off(events, onceHandler);

       if (onceHandler.__emitterProxy) {
         delete onceHandler.__emitterProxy;
       }

       for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
         args[_key] = arguments[_key];
       }

       handler.apply(self, args);
     }

     onceHandler.__emitterProxy = handler;
     return self.on(events, onceHandler, priority);
   },
   onAny: function onAny(handler, priority) {
     var self = this;
     if (typeof handler !== 'function') return self;
     var method = priority ? 'unshift' : 'push';

     if (self.eventsAnyListeners.indexOf(handler) < 0) {
       self.eventsAnyListeners[method](handler);
     }

     return self;
   },
   offAny: function offAny(handler) {
     var self = this;
     if (!self.eventsAnyListeners) return self;
     var index = self.eventsAnyListeners.indexOf(handler);

     if (index >= 0) {
       self.eventsAnyListeners.splice(index, 1);
     }

     return self;
   },
   off: function off(events, handler) {
     var self = this;
     if (!self.eventsListeners) return self;
     events.split(' ').forEach(function (event) {
       if (typeof handler === 'undefined') {
         self.eventsListeners[event] = [];
       } else if (self.eventsListeners[event]) {
         self.eventsListeners[event].forEach(function (eventHandler, index) {
           if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) {
             self.eventsListeners[event].splice(index, 1);
           }
         });
       }
     });
     return self;
   },
   emit: function emit() {
     var self = this;
     if (!self.eventsListeners) return self;
     var events;
     var data;
     var context;

     for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
       args[_key2] = arguments[_key2];
     }

     if (typeof args[0] === 'string' || Array.isArray(args[0])) {
       events = args[0];
       data = args.slice(1, args.length);
       context = self;
     } else {
       events = args[0].events;
       data = args[0].data;
       context = args[0].context || self;
     }

     data.unshift(context);
     var eventsArray = Array.isArray(events) ? events : events.split(' ');
     eventsArray.forEach(function (event) {
       if (self.eventsAnyListeners && self.eventsAnyListeners.length) {
         self.eventsAnyListeners.forEach(function (eventHandler) {
           eventHandler.apply(context, [event].concat(data));
         });
       }

       if (self.eventsListeners && self.eventsListeners[event]) {
         self.eventsListeners[event].forEach(function (eventHandler) {
           eventHandler.apply(context, data);
         });
       }
     });
     return self;
   }
 });
 // CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/update/updateSize.js

 function updateSize() {
   var swiper = this;
   var width;
   var height;
   var $el = swiper.$el;

   if (typeof swiper.params.width !== 'undefined' && swiper.params.width !== null) {
     width = swiper.params.width;
   } else {
     width = $el[0].clientWidth;
   }

   if (typeof swiper.params.height !== 'undefined' && swiper.params.height !== null) {
     height = swiper.params.height;
   } else {
     height = $el[0].clientHeight;
   }

   if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) {
     return;
   } // Subtract paddings


   width = width - parseInt($el.css('padding-left') || 0, 10) - parseInt($el.css('padding-right') || 0, 10);
   height = height - parseInt($el.css('padding-top') || 0, 10) - parseInt($el.css('padding-bottom') || 0, 10);
   if (Number.isNaN(width)) width = 0;
   if (Number.isNaN(height)) height = 0;
   Object(utils["e" /* extend */])(swiper, {
     width: width,
     height: height,
     size: swiper.isHorizontal() ? width : height
   });
 }
 // CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/update/updateSlides.js

 function updateSlides() {
   var swiper = this;

   function getDirectionLabel(property) {
     if (swiper.isHorizontal()) {
       return property;
     } // prettier-ignore


     return {
       'width': 'height',
       'margin-top': 'margin-left',
       'margin-bottom ': 'margin-right',
       'margin-left': 'margin-top',
       'margin-right': 'margin-bottom',
       'padding-left': 'padding-top',
       'padding-right': 'padding-bottom',
       'marginRight': 'marginBottom'
     }[property];
   }

   function getDirectionPropertyValue(node, label) {
     return parseFloat(node.getPropertyValue(getDirectionLabel(label)) || 0);
   }

   var params = swiper.params;
   var $wrapperEl = swiper.$wrapperEl,
       swiperSize = swiper.size,
       rtl = swiper.rtlTranslate,
       wrongRTL = swiper.wrongRTL;
   var isVirtual = swiper.virtual && params.virtual.enabled;
   var previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
   var slides = $wrapperEl.children("." + swiper.params.slideClass);
   var slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
   var snapGrid = [];
   var slidesGrid = [];
   var slidesSizesGrid = [];
   var offsetBefore = params.slidesOffsetBefore;

   if (typeof offsetBefore === 'function') {
     offsetBefore = params.slidesOffsetBefore.call(swiper);
   }

   var offsetAfter = params.slidesOffsetAfter;

   if (typeof offsetAfter === 'function') {
     offsetAfter = params.slidesOffsetAfter.call(swiper);
   }

   var previousSnapGridLength = swiper.snapGrid.length;
   var previousSlidesGridLength = swiper.slidesGrid.length;
   var spaceBetween = params.spaceBetween;
   var slidePosition = -offsetBefore;
   var prevSlideSize = 0;
   var index = 0;

   if (typeof swiperSize === 'undefined') {
     return;
   }

   if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) {
     spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiperSize;
   }

   swiper.virtualSize = -spaceBetween; // reset margins

   if (rtl) slides.css({
     marginLeft: '',
     marginBottom: '',
     marginTop: ''
   });else slides.css({
     marginRight: '',
     marginBottom: '',
     marginTop: ''
   });
   var slidesNumberEvenToRows;

   if (params.slidesPerColumn > 1) {
     if (Math.floor(slidesLength / params.slidesPerColumn) === slidesLength / swiper.params.slidesPerColumn) {
       slidesNumberEvenToRows = slidesLength;
     } else {
       slidesNumberEvenToRows = Math.ceil(slidesLength / params.slidesPerColumn) * params.slidesPerColumn;
     }

     if (params.slidesPerView !== 'auto' && params.slidesPerColumnFill === 'row') {
       slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, params.slidesPerView * params.slidesPerColumn);
     }
   } // Calc slides


   var slideSize;
   var slidesPerColumn = params.slidesPerColumn;
   var slidesPerRow = slidesNumberEvenToRows / slidesPerColumn;
   var numFullColumns = Math.floor(slidesLength / params.slidesPerColumn);

   for (var i = 0; i < slidesLength; i += 1) {
     slideSize = 0;
     var slide = slides.eq(i);

     if (params.slidesPerColumn > 1) {
       // Set slides order
       var newSlideOrderIndex = void 0;
       var column = void 0;
       var row = void 0;

       if (params.slidesPerColumnFill === 'row' && params.slidesPerGroup > 1) {
         var groupIndex = Math.floor(i / (params.slidesPerGroup * params.slidesPerColumn));
         var slideIndexInGroup = i - params.slidesPerColumn * params.slidesPerGroup * groupIndex;
         var columnsInGroup = groupIndex === 0 ? params.slidesPerGroup : Math.min(Math.ceil((slidesLength - groupIndex * slidesPerColumn * params.slidesPerGroup) / slidesPerColumn), params.slidesPerGroup);
         row = Math.floor(slideIndexInGroup / columnsInGroup);
         column = slideIndexInGroup - row * columnsInGroup + groupIndex * params.slidesPerGroup;
         newSlideOrderIndex = column + row * slidesNumberEvenToRows / slidesPerColumn;
         slide.css({
           '-webkit-box-ordinal-group': newSlideOrderIndex,
           '-moz-box-ordinal-group': newSlideOrderIndex,
           '-ms-flex-order': newSlideOrderIndex,
           '-webkit-order': newSlideOrderIndex,
           order: newSlideOrderIndex
         });
       } else if (params.slidesPerColumnFill === 'column') {
         column = Math.floor(i / slidesPerColumn);
         row = i - column * slidesPerColumn;

         if (column > numFullColumns || column === numFullColumns && row === slidesPerColumn - 1) {
           row += 1;

           if (row >= slidesPerColumn) {
             row = 0;
             column += 1;
           }
         }
       } else {
         row = Math.floor(i / slidesPerRow);
         column = i - row * slidesPerRow;
       }

       slide.css(getDirectionLabel('margin-top'), row !== 0 ? params.spaceBetween && params.spaceBetween + "px" : '');
     }

     if (slide.css('display') === 'none') continue; // eslint-disable-line

     if (params.slidesPerView === 'auto') {
       var slideStyles = getComputedStyle(slide[0]);
       var currentTransform = slide[0].style.transform;
       var currentWebKitTransform = slide[0].style.webkitTransform;

       if (currentTransform) {
         slide[0].style.transform = 'none';
       }

       if (currentWebKitTransform) {
         slide[0].style.webkitTransform = 'none';
       }

       if (params.roundLengths) {
         slideSize = swiper.isHorizontal() ? slide.outerWidth(true) : slide.outerHeight(true);
       } else {
         // eslint-disable-next-line
         var width = getDirectionPropertyValue(slideStyles, 'width');
         var paddingLeft = getDirectionPropertyValue(slideStyles, 'padding-left');
         var paddingRight = getDirectionPropertyValue(slideStyles, 'padding-right');
         var marginLeft = getDirectionPropertyValue(slideStyles, 'margin-left');
         var marginRight = getDirectionPropertyValue(slideStyles, 'margin-right');
         var boxSizing = slideStyles.getPropertyValue('box-sizing');

         if (boxSizing && boxSizing === 'border-box') {
           slideSize = width + marginLeft + marginRight;
         } else {
           var _slide$ = slide[0],
               clientWidth = _slide$.clientWidth,
               offsetWidth = _slide$.offsetWidth;
           slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
         }
       }

       if (currentTransform) {
         slide[0].style.transform = currentTransform;
       }

       if (currentWebKitTransform) {
         slide[0].style.webkitTransform = currentWebKitTransform;
       }

       if (params.roundLengths) slideSize = Math.floor(slideSize);
     } else {
       slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
       if (params.roundLengths) slideSize = Math.floor(slideSize);

       if (slides[i]) {
         slides[i].style[getDirectionLabel('width')] = slideSize + "px";
       }
     }

     if (slides[i]) {
       slides[i].swiperSlideSize = slideSize;
     }

     slidesSizesGrid.push(slideSize);

     if (params.centeredSlides) {
       slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
       if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
       if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
       if (Math.abs(slidePosition) < 1 / 1000) slidePosition = 0;
       if (params.roundLengths) slidePosition = Math.floor(slidePosition);
       if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
       slidesGrid.push(slidePosition);
     } else {
       if (params.roundLengths) slidePosition = Math.floor(slidePosition);
       if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
       slidesGrid.push(slidePosition);
       slidePosition = slidePosition + slideSize + spaceBetween;
     }

     swiper.virtualSize += slideSize + spaceBetween;
     prevSlideSize = slideSize;
     index += 1;
   }

   swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
   var newSlidesGrid;

   if (rtl && wrongRTL && (params.effect === 'slide' || params.effect === 'coverflow')) {
     $wrapperEl.css({
       width: swiper.virtualSize + params.spaceBetween + "px"
     });
   }

   if (params.setWrapperSize) {
     var _$wrapperEl$css;

     $wrapperEl.css((_$wrapperEl$css = {}, _$wrapperEl$css[getDirectionLabel('width')] = swiper.virtualSize + params.spaceBetween + "px", _$wrapperEl$css));
   }

   if (params.slidesPerColumn > 1) {
     var _$wrapperEl$css2;

     swiper.virtualSize = (slideSize + params.spaceBetween) * slidesNumberEvenToRows;
     swiper.virtualSize = Math.ceil(swiper.virtualSize / params.slidesPerColumn) - params.spaceBetween;
     $wrapperEl.css((_$wrapperEl$css2 = {}, _$wrapperEl$css2[getDirectionLabel('width')] = swiper.virtualSize + params.spaceBetween + "px", _$wrapperEl$css2));

     if (params.centeredSlides) {
       newSlidesGrid = [];

       for (var _i = 0; _i < snapGrid.length; _i += 1) {
         var slidesGridItem = snapGrid[_i];
         if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
         if (snapGrid[_i] < swiper.virtualSize + snapGrid[0]) newSlidesGrid.push(slidesGridItem);
       }

       snapGrid = newSlidesGrid;
     }
   } // Remove last grid elements depending on width


   if (!params.centeredSlides) {
     newSlidesGrid = [];

     for (var _i2 = 0; _i2 < snapGrid.length; _i2 += 1) {
       var _slidesGridItem = snapGrid[_i2];
       if (params.roundLengths) _slidesGridItem = Math.floor(_slidesGridItem);

       if (snapGrid[_i2] <= swiper.virtualSize - swiperSize) {
         newSlidesGrid.push(_slidesGridItem);
       }
     }

     snapGrid = newSlidesGrid;

     if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) {
       snapGrid.push(swiper.virtualSize - swiperSize);
     }
   }

   if (snapGrid.length === 0) snapGrid = [0];

   if (params.spaceBetween !== 0) {
     var _slides$filter$css;

     var key = swiper.isHorizontal() && rtl ? 'marginLeft' : getDirectionLabel('marginRight');
     slides.filter(function (_, slideIndex) {
       if (!params.cssMode) return true;

       if (slideIndex === slides.length - 1) {
         return false;
       }

       return true;
     }).css((_slides$filter$css = {}, _slides$filter$css[key] = spaceBetween + "px", _slides$filter$css));
   }

   if (params.centeredSlides && params.centeredSlidesBounds) {
     var allSlidesSize = 0;
     slidesSizesGrid.forEach(function (slideSizeValue) {
       allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
     });
     allSlidesSize -= params.spaceBetween;
     var maxSnap = allSlidesSize - swiperSize;
     snapGrid = snapGrid.map(function (snap) {
       if (snap < 0) return -offsetBefore;
       if (snap > maxSnap) return maxSnap + offsetAfter;
       return snap;
     });
   }

   if (params.centerInsufficientSlides) {
     var _allSlidesSize = 0;
     slidesSizesGrid.forEach(function (slideSizeValue) {
       _allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
     });
     _allSlidesSize -= params.spaceBetween;

     if (_allSlidesSize < swiperSize) {
       var allSlidesOffset = (swiperSize - _allSlidesSize) / 2;
       snapGrid.forEach(function (snap, snapIndex) {
         snapGrid[snapIndex] = snap - allSlidesOffset;
       });
       slidesGrid.forEach(function (snap, snapIndex) {
         slidesGrid[snapIndex] = snap + allSlidesOffset;
       });
     }
   }

   Object(utils["e" /* extend */])(swiper, {
     slides: slides,
     snapGrid: snapGrid,
     slidesGrid: slidesGrid,
     slidesSizesGrid: slidesSizesGrid
   });

   if (slidesLength !== previousSlidesLength) {
     swiper.emit('slidesLengthChange');
   }

   if (snapGrid.length !== previousSnapGridLength) {
     if (swiper.params.watchOverflow) swiper.checkOverflow();
     swiper.emit('snapGridLengthChange');
   }

   if (slidesGrid.length !== previousSlidesGridLength) {
     swiper.emit('slidesGridLengthChange');
   }

   if (params.watchSlidesProgress || params.watchSlidesVisibility) {
     swiper.updateSlidesOffset();
   }
 }
 // CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/update/updateAutoHeight.js
 function updateAutoHeight(speed) {
   var swiper = this;
   var activeSlides = [];
   var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
   var newHeight = 0;
   var i;

   if (typeof speed === 'number') {
     swiper.setTransition(speed);
   } else if (speed === true) {
     swiper.setTransition(swiper.params.speed);
   }

   var getSlideByIndex = function getSlideByIndex(index) {
     if (isVirtual) {
       return swiper.slides.filter(function (el) {
         return parseInt(el.getAttribute('data-swiper-slide-index'), 10) === index;
       })[0];
     }

     return swiper.slides.eq(index)[0];
   }; // Find slides currently in view


   if (swiper.params.slidesPerView !== 'auto' && swiper.params.slidesPerView > 1) {
     if (swiper.params.centeredSlides) {
       swiper.visibleSlides.each(function (slide) {
         activeSlides.push(slide);
       });
     } else {
       for (i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1) {
         var index = swiper.activeIndex + i;
         if (index > swiper.slides.length && !isVirtual) break;
         activeSlides.push(getSlideByIndex(index));
       }
     }
   } else {
     activeSlides.push(getSlideByIndex(swiper.activeIndex));
   } // Find new height from highest slide in view


   for (i = 0; i < activeSlides.length; i += 1) {
     if (typeof activeSlides[i] !== 'undefined') {
       var height = activeSlides[i].offsetHeight;
       newHeight = height > newHeight ? height : newHeight;
     }
   } // Update Height


   if (newHeight) swiper.$wrapperEl.css('height', newHeight + "px");
 }
 // CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/update/updateSlidesOffset.js
 function updateSlidesOffset() {
   var swiper = this;
   var slides = swiper.slides;

   for (var i = 0; i < slides.length; i += 1) {
     slides[i].swiperSlideOffset = swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop;
   }
 }
 // CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/update/updateSlidesProgress.js

 function updateSlidesProgress(translate) {
   if (translate === void 0) {
     translate = this && this.translate || 0;
   }

   var swiper = this;
   var params = swiper.params;
   var slides = swiper.slides,
       rtl = swiper.rtlTranslate;
   if (slides.length === 0) return;
   if (typeof slides[0].swiperSlideOffset === 'undefined') swiper.updateSlidesOffset();
   var offsetCenter = -translate;
   if (rtl) offsetCenter = translate; // Visible Slides

   slides.removeClass(params.slideVisibleClass);
   swiper.visibleSlidesIndexes = [];
   swiper.visibleSlides = [];

   for (var i = 0; i < slides.length; i += 1) {
     var slide = slides[i];
     var slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slide.swiperSlideOffset) / (slide.swiperSlideSize + params.spaceBetween);

     if (params.watchSlidesVisibility || params.centeredSlides && params.autoHeight) {
       var slideBefore = -(offsetCenter - slide.swiperSlideOffset);
       var slideAfter = slideBefore + swiper.slidesSizesGrid[i];
       var isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;

       if (isVisible) {
         swiper.visibleSlides.push(slide);
         swiper.visibleSlidesIndexes.push(i);
         slides.eq(i).addClass(params.slideVisibleClass);
       }
     }

     slide.progress = rtl ? -slideProgress : slideProgress;
   }

   swiper.visibleSlides = Object(dom["a" /* default */])(swiper.visibleSlides);
 }
 // CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/update/updateProgress.js

 function updateProgress(translate) {
   var swiper = this;

   if (typeof translate === 'undefined') {
     var multiplier = swiper.rtlTranslate ? -1 : 1; // eslint-disable-next-line

     translate = swiper && swiper.translate && swiper.translate * multiplier || 0;
   }

   var params = swiper.params;
   var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
   var progress = swiper.progress,
       isBeginning = swiper.isBeginning,
       isEnd = swiper.isEnd;
   var wasBeginning = isBeginning;
   var wasEnd = isEnd;

   if (translatesDiff === 0) {
     progress = 0;
     isBeginning = true;
     isEnd = true;
   } else {
     progress = (translate - swiper.minTranslate()) / translatesDiff;
     isBeginning = progress <= 0;
     isEnd = progress >= 1;
   }

   Object(utils["e" /* extend */])(swiper, {
     progress: progress,
     isBeginning: isBeginning,
     isEnd: isEnd
   });
   if (params.watchSlidesProgress || params.watchSlidesVisibility || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate);

   if (isBeginning && !wasBeginning) {
     swiper.emit('reachBeginning toEdge');
   }

   if (isEnd && !wasEnd) {
     swiper.emit('reachEnd toEdge');
   }

   if (wasBeginning && !isBeginning || wasEnd && !isEnd) {
     swiper.emit('fromEdge');
   }

   swiper.emit('progress', progress);
 }
 // CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/update/updateSlidesClasses.js
 function updateSlidesClasses() {
   var swiper = this;
   var slides = swiper.slides,
       params = swiper.params,
       $wrapperEl = swiper.$wrapperEl,
       activeIndex = swiper.activeIndex,
       realIndex = swiper.realIndex;
   var isVirtual = swiper.virtual && params.virtual.enabled;
   slides.removeClass(params.slideActiveClass + " " + params.slideNextClass + " " + params.slidePrevClass + " " + params.slideDuplicateActiveClass + " " + params.slideDuplicateNextClass + " " + params.slideDuplicatePrevClass);
   var activeSlide;

   if (isVirtual) {
     activeSlide = swiper.$wrapperEl.find("." + params.slideClass + "[data-swiper-slide-index=\"" + activeIndex + "\"]");
   } else {
     activeSlide = slides.eq(activeIndex);
   } // Active classes


   activeSlide.addClass(params.slideActiveClass);

   if (params.loop) {
     // Duplicate to all looped slides
     if (activeSlide.hasClass(params.slideDuplicateClass)) {
       $wrapperEl.children("." + params.slideClass + ":not(." + params.slideDuplicateClass + ")[data-swiper-slide-index=\"" + realIndex + "\"]").addClass(params.slideDuplicateActiveClass);
     } else {
       $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass + "[data-swiper-slide-index=\"" + realIndex + "\"]").addClass(params.slideDuplicateActiveClass);
     }
   } // Next Slide


   var nextSlide = activeSlide.nextAll("." + params.slideClass).eq(0).addClass(params.slideNextClass);

   if (params.loop && nextSlide.length === 0) {
     nextSlide = slides.eq(0);
     nextSlide.addClass(params.slideNextClass);
   } // Prev Slide


   var prevSlide = activeSlide.prevAll("." + params.slideClass).eq(0).addClass(params.slidePrevClass);

   if (params.loop && prevSlide.length === 0) {
     prevSlide = slides.eq(-1);
     prevSlide.addClass(params.slidePrevClass);
   }

   if (params.loop) {
     // Duplicate to all looped slides
     if (nextSlide.hasClass(params.slideDuplicateClass)) {
       $wrapperEl.children("." + params.slideClass + ":not(." + params.slideDuplicateClass + ")[data-swiper-slide-index=\"" + nextSlide.attr('data-swiper-slide-index') + "\"]").addClass(params.slideDuplicateNextClass);
     } else {
       $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass + "[data-swiper-slide-index=\"" + nextSlide.attr('data-swiper-slide-index') + "\"]").addClass(params.slideDuplicateNextClass);
     }

     if (prevSlide.hasClass(params.slideDuplicateClass)) {
       $wrapperEl.children("." + params.slideClass + ":not(." + params.slideDuplicateClass + ")[data-swiper-slide-index=\"" + prevSlide.attr('data-swiper-slide-index') + "\"]").addClass(params.slideDuplicatePrevClass);
     } else {
       $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass + "[data-swiper-slide-index=\"" + prevSlide.attr('data-swiper-slide-index') + "\"]").addClass(params.slideDuplicatePrevClass);
     }
   }

   swiper.emitSlidesClasses();
 }
 // CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/update/updateActiveIndex.js

 function updateActiveIndex(newActiveIndex) {
   var swiper = this;
   var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
   var slidesGrid = swiper.slidesGrid,
       snapGrid = swiper.snapGrid,
       params = swiper.params,
       previousIndex = swiper.activeIndex,
       previousRealIndex = swiper.realIndex,
       previousSnapIndex = swiper.snapIndex;
   var activeIndex = newActiveIndex;
   var snapIndex;

   if (typeof activeIndex === 'undefined') {
     for (var i = 0; i < slidesGrid.length; i += 1) {
       if (typeof slidesGrid[i + 1] !== 'undefined') {
         if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) {
           activeIndex = i;
         } else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) {
           activeIndex = i + 1;
         }
       } else if (translate >= slidesGrid[i]) {
         activeIndex = i;
       }
     } // Normalize slideIndex


     if (params.normalizeSlideIndex) {
       if (activeIndex < 0 || typeof activeIndex === 'undefined') activeIndex = 0;
     }
   }

   if (snapGrid.indexOf(translate) >= 0) {
     snapIndex = snapGrid.indexOf(translate);
   } else {
     var skip = Math.min(params.slidesPerGroupSkip, activeIndex);
     snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
   }

   if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;

   if (activeIndex === previousIndex) {
     if (snapIndex !== previousSnapIndex) {
       swiper.snapIndex = snapIndex;
       swiper.emit('snapIndexChange');
     }

     return;
   } // Get real index


   var realIndex = parseInt(swiper.slides.eq(activeIndex).attr('data-swiper-slide-index') || activeIndex, 10);
   Object(utils["e" /* extend */])(swiper, {
     snapIndex: snapIndex,
     realIndex: realIndex,
     previousIndex: previousIndex,
     activeIndex: activeIndex
   });
   swiper.emit('activeIndexChange');
   swiper.emit('snapIndexChange');

   if (previousRealIndex !== realIndex) {
     swiper.emit('realIndexChange');
   }

   if (swiper.initialized || swiper.params.runCallbacksOnInit) {
     swiper.emit('slideChange');
   }
 }
 // CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/update/updateClickedSlide.js

 function updateClickedSlide(e) {
   var swiper = this;
   var params = swiper.params;
   var slide = Object(dom["a" /* default */])(e.target).closest("." + params.slideClass)[0];
   var slideFound = false;
   var slideIndex;

   if (slide) {
     for (var i = 0; i < swiper.slides.length; i += 1) {
       if (swiper.slides[i] === slide) {
         slideFound = true;
         slideIndex = i;
         break;
       }
     }
   }

   if (slide && slideFound) {
     swiper.clickedSlide = slide;

     if (swiper.virtual && swiper.params.virtual.enabled) {
       swiper.clickedIndex = parseInt(Object(dom["a" /* default */])(slide).attr('data-swiper-slide-index'), 10);
     } else {
       swiper.clickedIndex = slideIndex;
     }
   } else {
     swiper.clickedSlide = undefined;
     swiper.clickedIndex = undefined;
     return;
   }

   if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) {
     swiper.slideToClickedSlide();
   }
 }
 // CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/update/index.js









 /* harmony default export */ var update = ({
   updateSize: updateSize,
   updateSlides: updateSlides,
   updateAutoHeight: updateAutoHeight,
   updateSlidesOffset: updateSlidesOffset,
   updateSlidesProgress: updateSlidesProgress,
   updateProgress: updateProgress,
   updateSlidesClasses: updateSlidesClasses,
   updateActiveIndex: updateActiveIndex,
   updateClickedSlide: updateClickedSlide
 });
 // CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/translate/getTranslate.js

 function getSwiperTranslate(axis) {
   if (axis === void 0) {
     axis = this.isHorizontal() ? 'x' : 'y';
   }

   var swiper = this;
   var params = swiper.params,
       rtl = swiper.rtlTranslate,
       translate = swiper.translate,
       $wrapperEl = swiper.$wrapperEl;

   if (params.virtualTranslate) {
     return rtl ? -translate : translate;
   }

   if (params.cssMode) {
     return translate;
   }

   var currentTranslate = Object(utils["f" /* getTranslate */])($wrapperEl[0], axis);
   if (rtl) currentTranslate = -currentTranslate;
   return currentTranslate || 0;
 }
 // CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/translate/setTranslate.js
 function setTranslate(translate, byController) {
   var swiper = this;
   var rtl = swiper.rtlTranslate,
       params = swiper.params,
       $wrapperEl = swiper.$wrapperEl,
       wrapperEl = swiper.wrapperEl,
       progress = swiper.progress;
   var x = 0;
   var y = 0;
   var z = 0;

   if (swiper.isHorizontal()) {
     x = rtl ? -translate : translate;
   } else {
     y = translate;
   }

   if (params.roundLengths) {
     x = Math.floor(x);
     y = Math.floor(y);
   }

   if (params.cssMode) {
     wrapperEl[swiper.isHorizontal() ? 'scrollLeft' : 'scrollTop'] = swiper.isHorizontal() ? -x : -y;
   } else if (!params.virtualTranslate) {
     $wrapperEl.transform("translate3d(" + x + "px, " + y + "px, " + z + "px)");
   }

   swiper.previousTranslate = swiper.translate;
   swiper.translate = swiper.isHorizontal() ? x : y; // Check if we need to update progress

   var newProgress;
   var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();

   if (translatesDiff === 0) {
     newProgress = 0;
   } else {
     newProgress = (translate - swiper.minTranslate()) / translatesDiff;
   }

   if (newProgress !== progress) {
     swiper.updateProgress(translate);
   }

   swiper.emit('setTranslate', swiper.translate, byController);
 }
 // CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/translate/minTranslate.js
 function minTranslate() {
   return -this.snapGrid[0];
 }
 // CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/translate/maxTranslate.js
 function maxTranslate() {
   return -this.snapGrid[this.snapGrid.length - 1];
 }
 // CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/translate/translateTo.js
 function translateTo(translate, speed, runCallbacks, translateBounds, internal) {
   if (translate === void 0) {
     translate = 0;
   }

   if (speed === void 0) {
     speed = this.params.speed;
   }

   if (runCallbacks === void 0) {
     runCallbacks = true;
   }

   if (translateBounds === void 0) {
     translateBounds = true;
   }

   var swiper = this;
   var params = swiper.params,
       wrapperEl = swiper.wrapperEl;

   if (swiper.animating && params.preventInteractionOnTransition) {
     return false;
   }

   var minTranslate = swiper.minTranslate();
   var maxTranslate = swiper.maxTranslate();
   var newTranslate;
   if (translateBounds && translate > minTranslate) newTranslate = minTranslate;else if (translateBounds && translate < maxTranslate) newTranslate = maxTranslate;else newTranslate = translate; // Update progress

   swiper.updateProgress(newTranslate);

   if (params.cssMode) {
     var isH = swiper.isHorizontal();

     if (speed === 0) {
       wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
     } else {
       // eslint-disable-next-line
       if (wrapperEl.scrollTo) {
         var _wrapperEl$scrollTo;

         wrapperEl.scrollTo((_wrapperEl$scrollTo = {}, _wrapperEl$scrollTo[isH ? 'left' : 'top'] = -newTranslate, _wrapperEl$scrollTo.behavior = 'smooth', _wrapperEl$scrollTo));
       } else {
         wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
       }
     }

     return true;
   }

   if (speed === 0) {
     swiper.setTransition(0);
     swiper.setTranslate(newTranslate);

     if (runCallbacks) {
       swiper.emit('beforeTransitionStart', speed, internal);
       swiper.emit('transitionEnd');
     }
   } else {
     swiper.setTransition(speed);
     swiper.setTranslate(newTranslate);

     if (runCallbacks) {
       swiper.emit('beforeTransitionStart', speed, internal);
       swiper.emit('transitionStart');
     }

     if (!swiper.animating) {
       swiper.animating = true;

       if (!swiper.onTranslateToWrapperTransitionEnd) {
         swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
           if (!swiper || swiper.destroyed) return;
           if (e.target !== this) return;
           swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
           swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onTranslateToWrapperTransitionEnd);
           swiper.onTranslateToWrapperTransitionEnd = null;
           delete swiper.onTranslateToWrapperTransitionEnd;

           if (runCallbacks) {
             swiper.emit('transitionEnd');
           }
         };
       }

       swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
       swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onTranslateToWrapperTransitionEnd);
     }
   }

   return true;
 }
 // CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/translate/index.js





 /* harmony default export */ var core_translate = ({
   getTranslate: getSwiperTranslate,
   setTranslate: setTranslate,
   minTranslate: minTranslate,
   maxTranslate: maxTranslate,
   translateTo: translateTo
 });
 // CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/transition/setTransition.js
 function setTransition(duration, byController) {
   var swiper = this;

   if (!swiper.params.cssMode) {
     swiper.$wrapperEl.transition(duration);
   }

   swiper.emit('setTransition', duration, byController);
 }
 // CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/transition/transitionStart.js
 function transitionStart(runCallbacks, direction) {
   if (runCallbacks === void 0) {
     runCallbacks = true;
   }

   var swiper = this;
   var activeIndex = swiper.activeIndex,
       params = swiper.params,
       previousIndex = swiper.previousIndex;
   if (params.cssMode) return;

   if (params.autoHeight) {
     swiper.updateAutoHeight();
   }

   var dir = direction;

   if (!dir) {
     if (activeIndex > previousIndex) dir = 'next';else if (activeIndex < previousIndex) dir = 'prev';else dir = 'reset';
   }

   swiper.emit('transitionStart');

   if (runCallbacks && activeIndex !== previousIndex) {
     if (dir === 'reset') {
       swiper.emit('slideResetTransitionStart');
       return;
     }

     swiper.emit('slideChangeTransitionStart');

     if (dir === 'next') {
       swiper.emit('slideNextTransitionStart');
     } else {
       swiper.emit('slidePrevTransitionStart');
     }
   }
 }
 // CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/transition/transitionEnd.js
 function transitionEnd(runCallbacks, direction) {
   if (runCallbacks === void 0) {
     runCallbacks = true;
   }

   var swiper = this;
   var activeIndex = swiper.activeIndex,
       previousIndex = swiper.previousIndex,
       params = swiper.params;
   swiper.animating = false;
   if (params.cssMode) return;
   swiper.setTransition(0);
   var dir = direction;

   if (!dir) {
     if (activeIndex > previousIndex) dir = 'next';else if (activeIndex < previousIndex) dir = 'prev';else dir = 'reset';
   }

   swiper.emit('transitionEnd');

   if (runCallbacks && activeIndex !== previousIndex) {
     if (dir === 'reset') {
       swiper.emit('slideResetTransitionEnd');
       return;
     }

     swiper.emit('slideChangeTransitionEnd');

     if (dir === 'next') {
       swiper.emit('slideNextTransitionEnd');
     } else {
       swiper.emit('slidePrevTransitionEnd');
     }
   }
 }
 // CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/transition/index.js



 /* harmony default export */ var transition = ({
   setTransition: setTransition,
   transitionStart: transitionStart,
   transitionEnd: transitionEnd
 });
 // CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/slide/slideTo.js
 function slideTo(index, speed, runCallbacks, internal, initial) {
   if (index === void 0) {
     index = 0;
   }

   if (speed === void 0) {
     speed = this.params.speed;
   }

   if (runCallbacks === void 0) {
     runCallbacks = true;
   }

   if (typeof index !== 'number' && typeof index !== 'string') {
     throw new Error("The 'index' argument cannot have type other than 'number' or 'string'. [" + typeof index + "] given.");
   }

   if (typeof index === 'string') {
     /**
      * The `index` argument converted from `string` to `number`.
      * @type {number}
      */
     var indexAsNumber = parseInt(index, 10);
     /**
      * Determines whether the `index` argument is a valid `number`
      * after being converted from the `string` type.
      * @type {boolean}
      */

     var isValidNumber = isFinite(indexAsNumber);

     if (!isValidNumber) {
       throw new Error("The passed-in 'index' (string) couldn't be converted to 'number'. [" + index + "] given.");
     } // Knowing that the converted `index` is a valid number,
     // we can update the original argument's value.


     index = indexAsNumber;
   }

   var swiper = this;
   var slideIndex = index;
   if (slideIndex < 0) slideIndex = 0;
   var params = swiper.params,
       snapGrid = swiper.snapGrid,
       slidesGrid = swiper.slidesGrid,
       previousIndex = swiper.previousIndex,
       activeIndex = swiper.activeIndex,
       rtl = swiper.rtlTranslate,
       wrapperEl = swiper.wrapperEl,
       enabled = swiper.enabled;

   if (swiper.animating && params.preventInteractionOnTransition || !enabled && !internal && !initial) {
     return false;
   }

   var skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
   var snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
   if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;

   if ((activeIndex || params.initialSlide || 0) === (previousIndex || 0) && runCallbacks) {
     swiper.emit('beforeSlideChangeStart');
   }

   var translate = -snapGrid[snapIndex]; // Update progress

   swiper.updateProgress(translate); // Normalize slideIndex

   if (params.normalizeSlideIndex) {
     for (var i = 0; i < slidesGrid.length; i += 1) {
       var normalizedTranslate = -Math.floor(translate * 100);
       var normalizedGird = Math.floor(slidesGrid[i] * 100);
       var normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);

       if (typeof slidesGrid[i + 1] !== 'undefined') {
         if (normalizedTranslate >= normalizedGird && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGird) / 2) {
           slideIndex = i;
         } else if (normalizedTranslate >= normalizedGird && normalizedTranslate < normalizedGridNext) {
           slideIndex = i + 1;
         }
       } else if (normalizedTranslate >= normalizedGird) {
         slideIndex = i;
       }
     }
   } // Directions locks


   if (swiper.initialized && slideIndex !== activeIndex) {
     if (!swiper.allowSlideNext && translate < swiper.translate && translate < swiper.minTranslate()) {
       return false;
     }

     if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
       if ((activeIndex || 0) !== slideIndex) return false;
     }
   }

   var direction;
   if (slideIndex > activeIndex) direction = 'next';else if (slideIndex < activeIndex) direction = 'prev';else direction = 'reset'; // Update Index

   if (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate) {
     swiper.updateActiveIndex(slideIndex); // Update Height

     if (params.autoHeight) {
       swiper.updateAutoHeight();
     }

     swiper.updateSlidesClasses();

     if (params.effect !== 'slide') {
       swiper.setTranslate(translate);
     }

     if (direction !== 'reset') {
       swiper.transitionStart(runCallbacks, direction);
       swiper.transitionEnd(runCallbacks, direction);
     }

     return false;
   }

   if (params.cssMode) {
     var isH = swiper.isHorizontal();
     var t = -translate;

     if (rtl) {
       t = wrapperEl.scrollWidth - wrapperEl.offsetWidth - t;
     }

     if (speed === 0) {
       wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
     } else {
       // eslint-disable-next-line
       if (wrapperEl.scrollTo) {
         var _wrapperEl$scrollTo;

         wrapperEl.scrollTo((_wrapperEl$scrollTo = {}, _wrapperEl$scrollTo[isH ? 'left' : 'top'] = t, _wrapperEl$scrollTo.behavior = 'smooth', _wrapperEl$scrollTo));
       } else {
         wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
       }
     }

     return true;
   }

   if (speed === 0) {
     swiper.setTransition(0);
     swiper.setTranslate(translate);
     swiper.updateActiveIndex(slideIndex);
     swiper.updateSlidesClasses();
     swiper.emit('beforeTransitionStart', speed, internal);
     swiper.transitionStart(runCallbacks, direction);
     swiper.transitionEnd(runCallbacks, direction);
   } else {
     swiper.setTransition(speed);
     swiper.setTranslate(translate);
     swiper.updateActiveIndex(slideIndex);
     swiper.updateSlidesClasses();
     swiper.emit('beforeTransitionStart', speed, internal);
     swiper.transitionStart(runCallbacks, direction);

     if (!swiper.animating) {
       swiper.animating = true;

       if (!swiper.onSlideToWrapperTransitionEnd) {
         swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
           if (!swiper || swiper.destroyed) return;
           if (e.target !== this) return;
           swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
           swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
           swiper.onSlideToWrapperTransitionEnd = null;
           delete swiper.onSlideToWrapperTransitionEnd;
           swiper.transitionEnd(runCallbacks, direction);
         };
       }

       swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
       swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
     }
   }

   return true;
 }
 // CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/slide/slideToLoop.js
 function slideToLoop(index, speed, runCallbacks, internal) {
   if (index === void 0) {
     index = 0;
   }

   if (speed === void 0) {
     speed = this.params.speed;
   }

   if (runCallbacks === void 0) {
     runCallbacks = true;
   }

   var swiper = this;
   var newIndex = index;

   if (swiper.params.loop) {
     newIndex += swiper.loopedSlides;
   }

   return swiper.slideTo(newIndex, speed, runCallbacks, internal);
 }
 // CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/slide/slideNext.js
 /* eslint no-unused-vars: "off" */
 function slideNext(speed, runCallbacks, internal) {
   if (speed === void 0) {
     speed = this.params.speed;
   }

   if (runCallbacks === void 0) {
     runCallbacks = true;
   }

   var swiper = this;
   var params = swiper.params,
       animating = swiper.animating,
       enabled = swiper.enabled;
   if (!enabled) return swiper;
   var increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup;

   if (params.loop) {
     if (animating && params.loopPreventsSlide) return false;
     swiper.loopFix(); // eslint-disable-next-line

     swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
   }

   return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
 }
 // CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/slide/slidePrev.js
 /* eslint no-unused-vars: "off" */
 function slidePrev(speed, runCallbacks, internal) {
   if (speed === void 0) {
     speed = this.params.speed;
   }

   if (runCallbacks === void 0) {
     runCallbacks = true;
   }

   var swiper = this;
   var params = swiper.params,
       animating = swiper.animating,
       snapGrid = swiper.snapGrid,
       slidesGrid = swiper.slidesGrid,
       rtlTranslate = swiper.rtlTranslate,
       enabled = swiper.enabled;
   if (!enabled) return swiper;

   if (params.loop) {
     if (animating && params.loopPreventsSlide) return false;
     swiper.loopFix(); // eslint-disable-next-line

     swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
   }

   var translate = rtlTranslate ? swiper.translate : -swiper.translate;

   function normalize(val) {
     if (val < 0) return -Math.floor(Math.abs(val));
     return Math.floor(val);
   }

   var normalizedTranslate = normalize(translate);
   var normalizedSnapGrid = snapGrid.map(function (val) {
     return normalize(val);
   });
   var prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];

   if (typeof prevSnap === 'undefined' && params.cssMode) {
     snapGrid.forEach(function (snap) {
       if (!prevSnap && normalizedTranslate >= snap) prevSnap = snap;
     });
   }

   var prevIndex;

   if (typeof prevSnap !== 'undefined') {
     prevIndex = slidesGrid.indexOf(prevSnap);
     if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
   }

   return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
 }
 // CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/slide/slideReset.js
 /* eslint no-unused-vars: "off" */
 function slideReset(speed, runCallbacks, internal) {
   if (speed === void 0) {
     speed = this.params.speed;
   }

   if (runCallbacks === void 0) {
     runCallbacks = true;
   }

   var swiper = this;
   return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
 }
 // CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/slide/slideToClosest.js
 /* eslint no-unused-vars: "off" */
 function slideToClosest(speed, runCallbacks, internal, threshold) {
   if (speed === void 0) {
     speed = this.params.speed;
   }

   if (runCallbacks === void 0) {
     runCallbacks = true;
   }

   if (threshold === void 0) {
     threshold = 0.5;
   }

   var swiper = this;
   var index = swiper.activeIndex;
   var skip = Math.min(swiper.params.slidesPerGroupSkip, index);
   var snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
   var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;

   if (translate >= swiper.snapGrid[snapIndex]) {
     // The current translate is on or after the current snap index, so the choice
     // is between the current index and the one after it.
     var currentSnap = swiper.snapGrid[snapIndex];
     var nextSnap = swiper.snapGrid[snapIndex + 1];

     if (translate - currentSnap > (nextSnap - currentSnap) * threshold) {
       index += swiper.params.slidesPerGroup;
     }
   } else {
     // The current translate is before the current snap index, so the choice
     // is between the current index and the one before it.
     var prevSnap = swiper.snapGrid[snapIndex - 1];
     var _currentSnap = swiper.snapGrid[snapIndex];

     if (translate - prevSnap <= (_currentSnap - prevSnap) * threshold) {
       index -= swiper.params.slidesPerGroup;
     }
   }

   index = Math.max(index, 0);
   index = Math.min(index, swiper.slidesGrid.length - 1);
   return swiper.slideTo(index, speed, runCallbacks, internal);
 }
 // CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/slide/slideToClickedSlide.js


 function slideToClickedSlide() {
   var swiper = this;
   var params = swiper.params,
       $wrapperEl = swiper.$wrapperEl;
   var slidesPerView = params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : params.slidesPerView;
   var slideToIndex = swiper.clickedIndex;
   var realIndex;

   if (params.loop) {
     if (swiper.animating) return;
     realIndex = parseInt(Object(dom["a" /* default */])(swiper.clickedSlide).attr('data-swiper-slide-index'), 10);

     if (params.centeredSlides) {
       if (slideToIndex < swiper.loopedSlides - slidesPerView / 2 || slideToIndex > swiper.slides.length - swiper.loopedSlides + slidesPerView / 2) {
         swiper.loopFix();
         slideToIndex = $wrapperEl.children("." + params.slideClass + "[data-swiper-slide-index=\"" + realIndex + "\"]:not(." + params.slideDuplicateClass + ")").eq(0).index();
         Object(utils["g" /* nextTick */])(function () {
           swiper.slideTo(slideToIndex);
         });
       } else {
         swiper.slideTo(slideToIndex);
       }
     } else if (slideToIndex > swiper.slides.length - slidesPerView) {
       swiper.loopFix();
       slideToIndex = $wrapperEl.children("." + params.slideClass + "[data-swiper-slide-index=\"" + realIndex + "\"]:not(." + params.slideDuplicateClass + ")").eq(0).index();
       Object(utils["g" /* nextTick */])(function () {
         swiper.slideTo(slideToIndex);
       });
     } else {
       swiper.slideTo(slideToIndex);
     }
   } else {
     swiper.slideTo(slideToIndex);
   }
 }
 // CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/slide/index.js







 /* harmony default export */ var core_slide = ({
   slideTo: slideTo,
   slideToLoop: slideToLoop,
   slideNext: slideNext,
   slidePrev: slidePrev,
   slideReset: slideReset,
   slideToClosest: slideToClosest,
   slideToClickedSlide: slideToClickedSlide
 });
 // CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/loop/loopCreate.js


 function loopCreate() {
   var swiper = this;
   var document = Object(ssr_window_esm["a" /* getDocument */])();
   var params = swiper.params,
       $wrapperEl = swiper.$wrapperEl; // Remove duplicated slides

   $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass).remove();
   var slides = $wrapperEl.children("." + params.slideClass);

   if (params.loopFillGroupWithBlank) {
     var blankSlidesNum = params.slidesPerGroup - slides.length % params.slidesPerGroup;

     if (blankSlidesNum !== params.slidesPerGroup) {
       for (var i = 0; i < blankSlidesNum; i += 1) {
         var blankNode = Object(dom["a" /* default */])(document.createElement('div')).addClass(params.slideClass + " " + params.slideBlankClass);
         $wrapperEl.append(blankNode);
       }

       slides = $wrapperEl.children("." + params.slideClass);
     }
   }

   if (params.slidesPerView === 'auto' && !params.loopedSlides) params.loopedSlides = slides.length;
   swiper.loopedSlides = Math.ceil(parseFloat(params.loopedSlides || params.slidesPerView, 10));
   swiper.loopedSlides += params.loopAdditionalSlides;

   if (swiper.loopedSlides > slides.length) {
     swiper.loopedSlides = slides.length;
   }

   var prependSlides = [];
   var appendSlides = [];
   slides.each(function (el, index) {
     var slide = Object(dom["a" /* default */])(el);

     if (index < swiper.loopedSlides) {
       appendSlides.push(el);
     }

     if (index < slides.length && index >= slides.length - swiper.loopedSlides) {
       prependSlides.push(el);
     }

     slide.attr('data-swiper-slide-index', index);
   });

   for (var _i = 0; _i < appendSlides.length; _i += 1) {
     $wrapperEl.append(Object(dom["a" /* default */])(appendSlides[_i].cloneNode(true)).addClass(params.slideDuplicateClass));
   }

   for (var _i2 = prependSlides.length - 1; _i2 >= 0; _i2 -= 1) {
     $wrapperEl.prepend(Object(dom["a" /* default */])(prependSlides[_i2].cloneNode(true)).addClass(params.slideDuplicateClass));
   }
 }
 // CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/loop/loopFix.js
 function loopFix() {
   var swiper = this;
   swiper.emit('beforeLoopFix');
   var activeIndex = swiper.activeIndex,
       slides = swiper.slides,
       loopedSlides = swiper.loopedSlides,
       allowSlidePrev = swiper.allowSlidePrev,
       allowSlideNext = swiper.allowSlideNext,
       snapGrid = swiper.snapGrid,
       rtl = swiper.rtlTranslate;
   var newIndex;
   swiper.allowSlidePrev = true;
   swiper.allowSlideNext = true;
   var snapTranslate = -snapGrid[activeIndex];
   var diff = snapTranslate - swiper.getTranslate(); // Fix For Negative Oversliding

   if (activeIndex < loopedSlides) {
     newIndex = slides.length - loopedSlides * 3 + activeIndex;
     newIndex += loopedSlides;
     var slideChanged = swiper.slideTo(newIndex, 0, false, true);

     if (slideChanged && diff !== 0) {
       swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
     }
   } else if (activeIndex >= slides.length - loopedSlides) {
     // Fix For Positive Oversliding
     newIndex = -slides.length + activeIndex + loopedSlides;
     newIndex += loopedSlides;

     var _slideChanged = swiper.slideTo(newIndex, 0, false, true);

     if (_slideChanged && diff !== 0) {
       swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
     }
   }

   swiper.allowSlidePrev = allowSlidePrev;
   swiper.allowSlideNext = allowSlideNext;
   swiper.emit('loopFix');
 }
 // CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/loop/loopDestroy.js
 function loopDestroy() {
   var swiper = this;
   var $wrapperEl = swiper.$wrapperEl,
       params = swiper.params,
       slides = swiper.slides;
   $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass + ",." + params.slideClass + "." + params.slideBlankClass).remove();
   slides.removeAttr('data-swiper-slide-index');
 }
 // CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/loop/index.js



 /* harmony default export */ var loop = ({
   loopCreate: loopCreate,
   loopFix: loopFix,
   loopDestroy: loopDestroy
 });
 // CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/grab-cursor/setGrabCursor.js
 function setGrabCursor(moving) {
   var swiper = this;
   if (swiper.support.touch || !swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
   var el = swiper.el;
   el.style.cursor = 'move';
   el.style.cursor = moving ? '-webkit-grabbing' : '-webkit-grab';
   el.style.cursor = moving ? '-moz-grabbin' : '-moz-grab';
   el.style.cursor = moving ? 'grabbing' : 'grab';
 }
 // CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/grab-cursor/unsetGrabCursor.js
 function unsetGrabCursor() {
   var swiper = this;

   if (swiper.support.touch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) {
     return;
   }

   swiper.el.style.cursor = '';
 }
 // CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/grab-cursor/index.js


 /* harmony default export */ var grab_cursor = ({
   setGrabCursor: setGrabCursor,
   unsetGrabCursor: unsetGrabCursor
 });
 // CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/manipulation/appendSlide.js
 function appendSlide(slides) {
   var swiper = this;
   var $wrapperEl = swiper.$wrapperEl,
       params = swiper.params;

   if (params.loop) {
     swiper.loopDestroy();
   }

   if (typeof slides === 'object' && 'length' in slides) {
     for (var i = 0; i < slides.length; i += 1) {
       if (slides[i]) $wrapperEl.append(slides[i]);
     }
   } else {
     $wrapperEl.append(slides);
   }

   if (params.loop) {
     swiper.loopCreate();
   }

   if (!(params.observer && swiper.support.observer)) {
     swiper.update();
   }
 }
 // CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/manipulation/prependSlide.js
 function prependSlide(slides) {
   var swiper = this;
   var params = swiper.params,
       $wrapperEl = swiper.$wrapperEl,
       activeIndex = swiper.activeIndex;

   if (params.loop) {
     swiper.loopDestroy();
   }

   var newActiveIndex = activeIndex + 1;

   if (typeof slides === 'object' && 'length' in slides) {
     for (var i = 0; i < slides.length; i += 1) {
       if (slides[i]) $wrapperEl.prepend(slides[i]);
     }

     newActiveIndex = activeIndex + slides.length;
   } else {
     $wrapperEl.prepend(slides);
   }

   if (params.loop) {
     swiper.loopCreate();
   }

   if (!(params.observer && swiper.support.observer)) {
     swiper.update();
   }

   swiper.slideTo(newActiveIndex, 0, false);
 }
 // CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/manipulation/addSlide.js
 function addSlide(index, slides) {
   var swiper = this;
   var $wrapperEl = swiper.$wrapperEl,
       params = swiper.params,
       activeIndex = swiper.activeIndex;
   var activeIndexBuffer = activeIndex;

   if (params.loop) {
     activeIndexBuffer -= swiper.loopedSlides;
     swiper.loopDestroy();
     swiper.slides = $wrapperEl.children("." + params.slideClass);
   }

   var baseLength = swiper.slides.length;

   if (index <= 0) {
     swiper.prependSlide(slides);
     return;
   }

   if (index >= baseLength) {
     swiper.appendSlide(slides);
     return;
   }

   var newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;
   var slidesBuffer = [];

   for (var i = baseLength - 1; i >= index; i -= 1) {
     var currentSlide = swiper.slides.eq(i);
     currentSlide.remove();
     slidesBuffer.unshift(currentSlide);
   }

   if (typeof slides === 'object' && 'length' in slides) {
     for (var _i = 0; _i < slides.length; _i += 1) {
       if (slides[_i]) $wrapperEl.append(slides[_i]);
     }

     newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
   } else {
     $wrapperEl.append(slides);
   }

   for (var _i2 = 0; _i2 < slidesBuffer.length; _i2 += 1) {
     $wrapperEl.append(slidesBuffer[_i2]);
   }

   if (params.loop) {
     swiper.loopCreate();
   }

   if (!(params.observer && swiper.support.observer)) {
     swiper.update();
   }

   if (params.loop) {
     swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
   } else {
     swiper.slideTo(newActiveIndex, 0, false);
   }
 }
 // CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/manipulation/removeSlide.js
 function removeSlide(slidesIndexes) {
   var swiper = this;
   var params = swiper.params,
       $wrapperEl = swiper.$wrapperEl,
       activeIndex = swiper.activeIndex;
   var activeIndexBuffer = activeIndex;

   if (params.loop) {
     activeIndexBuffer -= swiper.loopedSlides;
     swiper.loopDestroy();
     swiper.slides = $wrapperEl.children("." + params.slideClass);
   }

   var newActiveIndex = activeIndexBuffer;
   var indexToRemove;

   if (typeof slidesIndexes === 'object' && 'length' in slidesIndexes) {
     for (var i = 0; i < slidesIndexes.length; i += 1) {
       indexToRemove = slidesIndexes[i];
       if (swiper.slides[indexToRemove]) swiper.slides.eq(indexToRemove).remove();
       if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
     }

     newActiveIndex = Math.max(newActiveIndex, 0);
   } else {
     indexToRemove = slidesIndexes;
     if (swiper.slides[indexToRemove]) swiper.slides.eq(indexToRemove).remove();
     if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
     newActiveIndex = Math.max(newActiveIndex, 0);
   }

   if (params.loop) {
     swiper.loopCreate();
   }

   if (!(params.observer && swiper.support.observer)) {
     swiper.update();
   }

   if (params.loop) {
     swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
   } else {
     swiper.slideTo(newActiveIndex, 0, false);
   }
 }
 // CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/manipulation/removeAllSlides.js
 function removeAllSlides() {
   var swiper = this;
   var slidesIndexes = [];

   for (var i = 0; i < swiper.slides.length; i += 1) {
     slidesIndexes.push(i);
   }

   swiper.removeSlide(slidesIndexes);
 }
 // CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/manipulation/index.js





 /* harmony default export */ var manipulation = ({
   appendSlide: appendSlide,
   prependSlide: prependSlide,
   addSlide: addSlide,
   removeSlide: removeSlide,
   removeAllSlides: removeAllSlides
 });
 // CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/events/onTouchStart.js


  // Modified from https://stackoverflow.com/questions/54520554/custom-element-getrootnode-closest-function-crossing-multiple-parent-shadowd

 function closestElement(selector, base) {
   if (base === void 0) {
     base = this;
   }

   function __closestFrom(el) {
     if (!el || el === Object(ssr_window_esm["a" /* getDocument */])() || el === Object(ssr_window_esm["b" /* getWindow */])()) return null;
     if (el.assignedSlot) el = el.assignedSlot;
     var found = el.closest(selector);
     return found || __closestFrom(el.getRootNode().host);
   }

   return __closestFrom(base);
 }

 function onTouchStart(event) {
   var swiper = this;
   var document = Object(ssr_window_esm["a" /* getDocument */])();
   var window = Object(ssr_window_esm["b" /* getWindow */])();
   var data = swiper.touchEventsData;
   var params = swiper.params,
       touches = swiper.touches,
       enabled = swiper.enabled;
   if (!enabled) return;

   if (swiper.animating && params.preventInteractionOnTransition) {
     return;
   }

   var e = event;
   if (e.originalEvent) e = e.originalEvent;
   var $targetEl = Object(dom["a" /* default */])(e.target);

   if (params.touchEventsTarget === 'wrapper') {
     if (!$targetEl.closest(swiper.wrapperEl).length) return;
   }

   data.isTouchEvent = e.type === 'touchstart';
   if (!data.isTouchEvent && 'which' in e && e.which === 3) return;
   if (!data.isTouchEvent && 'button' in e && e.button > 0) return;
   if (data.isTouched && data.isMoved) return; // change target el for shadow root component

   var swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== '';

   if (swipingClassHasValue && e.target && e.target.shadowRoot && event.path && event.path[0]) {
     $targetEl = Object(dom["a" /* default */])(event.path[0]);
   }

   var noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : "." + params.noSwipingClass;
   var isTargetShadow = !!(e.target && e.target.shadowRoot); // use closestElement for shadow root element to get the actual closest for nested shadow root element

   if (params.noSwiping && (isTargetShadow ? closestElement(noSwipingSelector, e.target) : $targetEl.closest(noSwipingSelector)[0])) {
     swiper.allowClick = true;
     return;
   }

   if (params.swipeHandler) {
     if (!$targetEl.closest(params.swipeHandler)[0]) return;
   }

   touches.currentX = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
   touches.currentY = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
   var startX = touches.currentX;
   var startY = touches.currentY; // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore

   var edgeSwipeDetection = params.edgeSwipeDetection || params.iOSEdgeSwipeDetection;
   var edgeSwipeThreshold = params.edgeSwipeThreshold || params.iOSEdgeSwipeThreshold;

   if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window.innerWidth - edgeSwipeThreshold)) {
     if (edgeSwipeDetection === 'prevent') {
       event.preventDefault();
     } else {
       return;
     }
   }

   Object(utils["e" /* extend */])(data, {
     isTouched: true,
     isMoved: false,
     allowTouchCallbacks: true,
     isScrolling: undefined,
     startMoving: undefined
   });
   touches.startX = startX;
   touches.startY = startY;
   data.touchStartTime = Object(utils["h" /* now */])();
   swiper.allowClick = true;
   swiper.updateSize();
   swiper.swipeDirection = undefined;
   if (params.threshold > 0) data.allowThresholdMove = false;

   if (e.type !== 'touchstart') {
     var preventDefault = true;
     if ($targetEl.is(data.focusableElements)) preventDefault = false;

     if (document.activeElement && Object(dom["a" /* default */])(document.activeElement).is(data.focusableElements) && document.activeElement !== $targetEl[0]) {
       document.activeElement.blur();
     }

     var shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;

     if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !$targetEl[0].isContentEditable) {
       e.preventDefault();
     }
   }

   swiper.emit('touchStart', e);
 }
 // CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/events/onTouchMove.js



 function onTouchMove(event) {
   var document = Object(ssr_window_esm["a" /* getDocument */])();
   var swiper = this;
   var data = swiper.touchEventsData;
   var params = swiper.params,
       touches = swiper.touches,
       rtl = swiper.rtlTranslate,
       enabled = swiper.enabled;
   if (!enabled) return;
   var e = event;
   if (e.originalEvent) e = e.originalEvent;

   if (!data.isTouched) {
     if (data.startMoving && data.isScrolling) {
       swiper.emit('touchMoveOpposite', e);
     }

     return;
   }

   if (data.isTouchEvent && e.type !== 'touchmove') return;
   var targetTouch = e.type === 'touchmove' && e.targetTouches && (e.targetTouches[0] || e.changedTouches[0]);
   var pageX = e.type === 'touchmove' ? targetTouch.pageX : e.pageX;
   var pageY = e.type === 'touchmove' ? targetTouch.pageY : e.pageY;

   if (e.preventedByNestedSwiper) {
     touches.startX = pageX;
     touches.startY = pageY;
     return;
   }

   if (!swiper.allowTouchMove) {
     // isMoved = true;
     swiper.allowClick = false;

     if (data.isTouched) {
       Object(utils["e" /* extend */])(touches, {
         startX: pageX,
         startY: pageY,
         currentX: pageX,
         currentY: pageY
       });
       data.touchStartTime = Object(utils["h" /* now */])();
     }

     return;
   }

   if (data.isTouchEvent && params.touchReleaseOnEdges && !params.loop) {
     if (swiper.isVertical()) {
       // Vertical
       if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
         data.isTouched = false;
         data.isMoved = false;
         return;
       }
     } else if (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate()) {
       return;
     }
   }

   if (data.isTouchEvent && document.activeElement) {
     if (e.target === document.activeElement && Object(dom["a" /* default */])(e.target).is(data.focusableElements)) {
       data.isMoved = true;
       swiper.allowClick = false;
       return;
     }
   }

   if (data.allowTouchCallbacks) {
     swiper.emit('touchMove', e);
   }

   if (e.targetTouches && e.targetTouches.length > 1) return;
   touches.currentX = pageX;
   touches.currentY = pageY;
   var diffX = touches.currentX - touches.startX;
   var diffY = touches.currentY - touches.startY;
   if (swiper.params.threshold && Math.sqrt(Math.pow(diffX, 2) + Math.pow(diffY, 2)) < swiper.params.threshold) return;

   if (typeof data.isScrolling === 'undefined') {
     var touchAngle;

     if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) {
       data.isScrolling = false;
     } else {
       // eslint-disable-next-line
       if (diffX * diffX + diffY * diffY >= 25) {
         touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
         data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
       }
     }
   }

   if (data.isScrolling) {
     swiper.emit('touchMoveOpposite', e);
   }

   if (typeof data.startMoving === 'undefined') {
     if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) {
       data.startMoving = true;
     }
   }

   if (data.isScrolling) {
     data.isTouched = false;
     return;
   }

   if (!data.startMoving) {
     return;
   }

   swiper.allowClick = false;

   if (!params.cssMode && e.cancelable) {
     e.preventDefault();
   }

   if (params.touchMoveStopPropagation && !params.nested) {
     e.stopPropagation();
   }

   if (!data.isMoved) {
     if (params.loop) {
       swiper.loopFix();
     }

     data.startTranslate = swiper.getTranslate();
     swiper.setTransition(0);

     if (swiper.animating) {
       swiper.$wrapperEl.trigger('webkitTransitionEnd transitionend');
     }

     data.allowMomentumBounce = false; // Grab Cursor

     if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
       swiper.setGrabCursor(true);
     }

     swiper.emit('sliderFirstMove', e);
   }

   swiper.emit('sliderMove', e);
   data.isMoved = true;
   var diff = swiper.isHorizontal() ? diffX : diffY;
   touches.diff = diff;
   diff *= params.touchRatio;
   if (rtl) diff = -diff;
   swiper.swipeDirection = diff > 0 ? 'prev' : 'next';
   data.currentTranslate = diff + data.startTranslate;
   var disableParentSwiper = true;
   var resistanceRatio = params.resistanceRatio;

   if (params.touchReleaseOnEdges) {
     resistanceRatio = 0;
   }

   if (diff > 0 && data.currentTranslate > swiper.minTranslate()) {
     disableParentSwiper = false;
     if (params.resistance) data.currentTranslate = swiper.minTranslate() - 1 + Math.pow(-swiper.minTranslate() + data.startTranslate + diff, resistanceRatio);
   } else if (diff < 0 && data.currentTranslate < swiper.maxTranslate()) {
     disableParentSwiper = false;
     if (params.resistance) data.currentTranslate = swiper.maxTranslate() + 1 - Math.pow(swiper.maxTranslate() - data.startTranslate - diff, resistanceRatio);
   }

   if (disableParentSwiper) {
     e.preventedByNestedSwiper = true;
   } // Directions locks


   if (!swiper.allowSlideNext && swiper.swipeDirection === 'next' && data.currentTranslate < data.startTranslate) {
     data.currentTranslate = data.startTranslate;
   }

   if (!swiper.allowSlidePrev && swiper.swipeDirection === 'prev' && data.currentTranslate > data.startTranslate) {
     data.currentTranslate = data.startTranslate;
   }

   if (!swiper.allowSlidePrev && !swiper.allowSlideNext) {
     data.currentTranslate = data.startTranslate;
   } // Threshold


   if (params.threshold > 0) {
     if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
       if (!data.allowThresholdMove) {
         data.allowThresholdMove = true;
         touches.startX = touches.currentX;
         touches.startY = touches.currentY;
         data.currentTranslate = data.startTranslate;
         touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
         return;
       }
     } else {
       data.currentTranslate = data.startTranslate;
       return;
     }
   }

   if (!params.followFinger || params.cssMode) return; // Update active index in free mode

   if (params.freeMode || params.watchSlidesProgress || params.watchSlidesVisibility) {
     swiper.updateActiveIndex();
     swiper.updateSlidesClasses();
   }

   if (params.freeMode) {
     // Velocity
     if (data.velocities.length === 0) {
       data.velocities.push({
         position: touches[swiper.isHorizontal() ? 'startX' : 'startY'],
         time: data.touchStartTime
       });
     }

     data.velocities.push({
       position: touches[swiper.isHorizontal() ? 'currentX' : 'currentY'],
       time: Object(utils["h" /* now */])()
     });
   } // Update progress


   swiper.updateProgress(data.currentTranslate); // Update translate

   swiper.setTranslate(data.currentTranslate);
 }
 // CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/events/onTouchEnd.js

 function onTouchEnd(event) {
   var swiper = this;
   var data = swiper.touchEventsData;
   var params = swiper.params,
       touches = swiper.touches,
       rtl = swiper.rtlTranslate,
       $wrapperEl = swiper.$wrapperEl,
       slidesGrid = swiper.slidesGrid,
       snapGrid = swiper.snapGrid,
       enabled = swiper.enabled;
   if (!enabled) return;
   var e = event;
   if (e.originalEvent) e = e.originalEvent;

   if (data.allowTouchCallbacks) {
     swiper.emit('touchEnd', e);
   }

   data.allowTouchCallbacks = false;

   if (!data.isTouched) {
     if (data.isMoved && params.grabCursor) {
       swiper.setGrabCursor(false);
     }

     data.isMoved = false;
     data.startMoving = false;
     return;
   } // Return Grab Cursor


   if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
     swiper.setGrabCursor(false);
   } // Time diff


   var touchEndTime = Object(utils["h" /* now */])();
   var timeDiff = touchEndTime - data.touchStartTime; // Tap, doubleTap, Click

   if (swiper.allowClick) {
     swiper.updateClickedSlide(e);
     swiper.emit('tap click', e);

     if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) {
       swiper.emit('doubleTap doubleClick', e);
     }
   }

   data.lastClickTime = Object(utils["h" /* now */])();
   Object(utils["g" /* nextTick */])(function () {
     if (!swiper.destroyed) swiper.allowClick = true;
   });

   if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 || data.currentTranslate === data.startTranslate) {
     data.isTouched = false;
     data.isMoved = false;
     data.startMoving = false;
     return;
   }

   data.isTouched = false;
   data.isMoved = false;
   data.startMoving = false;
   var currentPos;

   if (params.followFinger) {
     currentPos = rtl ? swiper.translate : -swiper.translate;
   } else {
     currentPos = -data.currentTranslate;
   }

   if (params.cssMode) {
     return;
   }

   if (params.freeMode) {
     if (currentPos < -swiper.minTranslate()) {
       swiper.slideTo(swiper.activeIndex);
       return;
     }

     if (currentPos > -swiper.maxTranslate()) {
       if (swiper.slides.length < snapGrid.length) {
         swiper.slideTo(snapGrid.length - 1);
       } else {
         swiper.slideTo(swiper.slides.length - 1);
       }

       return;
     }

     if (params.freeModeMomentum) {
       if (data.velocities.length > 1) {
         var lastMoveEvent = data.velocities.pop();
         var velocityEvent = data.velocities.pop();
         var distance = lastMoveEvent.position - velocityEvent.position;
         var time = lastMoveEvent.time - velocityEvent.time;
         swiper.velocity = distance / time;
         swiper.velocity /= 2;

         if (Math.abs(swiper.velocity) < params.freeModeMinimumVelocity) {
           swiper.velocity = 0;
         } // this implies that the user stopped moving a finger then released.
         // There would be no events with distance zero, so the last event is stale.


         if (time > 150 || Object(utils["h" /* now */])() - lastMoveEvent.time > 300) {
           swiper.velocity = 0;
         }
       } else {
         swiper.velocity = 0;
       }

       swiper.velocity *= params.freeModeMomentumVelocityRatio;
       data.velocities.length = 0;
       var momentumDuration = 1000 * params.freeModeMomentumRatio;
       var momentumDistance = swiper.velocity * momentumDuration;
       var newPosition = swiper.translate + momentumDistance;
       if (rtl) newPosition = -newPosition;
       var doBounce = false;
       var afterBouncePosition;
       var bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeModeMomentumBounceRatio;
       var needsLoopFix;

       if (newPosition < swiper.maxTranslate()) {
         if (params.freeModeMomentumBounce) {
           if (newPosition + swiper.maxTranslate() < -bounceAmount) {
             newPosition = swiper.maxTranslate() - bounceAmount;
           }

           afterBouncePosition = swiper.maxTranslate();
           doBounce = true;
           data.allowMomentumBounce = true;
         } else {
           newPosition = swiper.maxTranslate();
         }

         if (params.loop && params.centeredSlides) needsLoopFix = true;
       } else if (newPosition > swiper.minTranslate()) {
         if (params.freeModeMomentumBounce) {
           if (newPosition - swiper.minTranslate() > bounceAmount) {
             newPosition = swiper.minTranslate() + bounceAmount;
           }

           afterBouncePosition = swiper.minTranslate();
           doBounce = true;
           data.allowMomentumBounce = true;
         } else {
           newPosition = swiper.minTranslate();
         }

         if (params.loop && params.centeredSlides) needsLoopFix = true;
       } else if (params.freeModeSticky) {
         var nextSlide;

         for (var j = 0; j < snapGrid.length; j += 1) {
           if (snapGrid[j] > -newPosition) {
             nextSlide = j;
             break;
           }
         }

         if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === 'next') {
           newPosition = snapGrid[nextSlide];
         } else {
           newPosition = snapGrid[nextSlide - 1];
         }

         newPosition = -newPosition;
       }

       if (needsLoopFix) {
         swiper.once('transitionEnd', function () {
           swiper.loopFix();
         });
       } // Fix duration


       if (swiper.velocity !== 0) {
         if (rtl) {
           momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
         } else {
           momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
         }

         if (params.freeModeSticky) {
           // If freeModeSticky is active and the user ends a swipe with a slow-velocity
           // event, then durations can be 20+ seconds to slide one (or zero!) slides.
           // It's easy to see this when simulating touch with mouse events. To fix this,
           // limit single-slide swipes to the default slide duration. This also has the
           // nice side effect of matching slide speed if the user stopped moving before
           // lifting finger or mouse vs. moving slowly before lifting the finger/mouse.
           // For faster swipes, also apply limits (albeit higher ones).
           var moveDistance = Math.abs((rtl ? -newPosition : newPosition) - swiper.translate);
           var currentSlideSize = swiper.slidesSizesGrid[swiper.activeIndex];

           if (moveDistance < currentSlideSize) {
             momentumDuration = params.speed;
           } else if (moveDistance < 2 * currentSlideSize) {
             momentumDuration = params.speed * 1.5;
           } else {
             momentumDuration = params.speed * 2.5;
           }
         }
       } else if (params.freeModeSticky) {
         swiper.slideToClosest();
         return;
       }

       if (params.freeModeMomentumBounce && doBounce) {
         swiper.updateProgress(afterBouncePosition);
         swiper.setTransition(momentumDuration);
         swiper.setTranslate(newPosition);
         swiper.transitionStart(true, swiper.swipeDirection);
         swiper.animating = true;
         $wrapperEl.transitionEnd(function () {
           if (!swiper || swiper.destroyed || !data.allowMomentumBounce) return;
           swiper.emit('momentumBounce');
           swiper.setTransition(params.speed);
           setTimeout(function () {
             swiper.setTranslate(afterBouncePosition);
             $wrapperEl.transitionEnd(function () {
               if (!swiper || swiper.destroyed) return;
               swiper.transitionEnd();
             });
           }, 0);
         });
       } else if (swiper.velocity) {
         swiper.updateProgress(newPosition);
         swiper.setTransition(momentumDuration);
         swiper.setTranslate(newPosition);
         swiper.transitionStart(true, swiper.swipeDirection);

         if (!swiper.animating) {
           swiper.animating = true;
           $wrapperEl.transitionEnd(function () {
             if (!swiper || swiper.destroyed) return;
             swiper.transitionEnd();
           });
         }
       } else {
         swiper.emit('_freeModeNoMomentumRelease');
         swiper.updateProgress(newPosition);
       }

       swiper.updateActiveIndex();
       swiper.updateSlidesClasses();
     } else if (params.freeModeSticky) {
       swiper.slideToClosest();
       return;
     } else if (params.freeMode) {
       swiper.emit('_freeModeNoMomentumRelease');
     }

     if (!params.freeModeMomentum || timeDiff >= params.longSwipesMs) {
       swiper.updateProgress();
       swiper.updateActiveIndex();
       swiper.updateSlidesClasses();
     }

     return;
   } // Find current slide


   var stopIndex = 0;
   var groupSize = swiper.slidesSizesGrid[0];

   for (var i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup) {
     var _increment = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;

     if (typeof slidesGrid[i + _increment] !== 'undefined') {
       if (currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + _increment]) {
         stopIndex = i;
         groupSize = slidesGrid[i + _increment] - slidesGrid[i];
       }
     } else if (currentPos >= slidesGrid[i]) {
       stopIndex = i;
       groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
     }
   } // Find current slide size


   var ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
   var increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;

   if (timeDiff > params.longSwipesMs) {
     // Long touches
     if (!params.longSwipes) {
       swiper.slideTo(swiper.activeIndex);
       return;
     }

     if (swiper.swipeDirection === 'next') {
       if (ratio >= params.longSwipesRatio) swiper.slideTo(stopIndex + increment);else swiper.slideTo(stopIndex);
     }

     if (swiper.swipeDirection === 'prev') {
       if (ratio > 1 - params.longSwipesRatio) swiper.slideTo(stopIndex + increment);else swiper.slideTo(stopIndex);
     }
   } else {
     // Short swipes
     if (!params.shortSwipes) {
       swiper.slideTo(swiper.activeIndex);
       return;
     }

     var isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);

     if (!isNavButtonTarget) {
       if (swiper.swipeDirection === 'next') {
         swiper.slideTo(stopIndex + increment);
       }

       if (swiper.swipeDirection === 'prev') {
         swiper.slideTo(stopIndex);
       }
     } else if (e.target === swiper.navigation.nextEl) {
       swiper.slideTo(stopIndex + increment);
     } else {
       swiper.slideTo(stopIndex);
     }
   }
 }
 // CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/events/onResize.js
 function onResize() {
   var swiper = this;
   var params = swiper.params,
       el = swiper.el;
   if (el && el.offsetWidth === 0) return; // Breakpoints

   if (params.breakpoints) {
     swiper.setBreakpoint();
   } // Save locks


   var allowSlideNext = swiper.allowSlideNext,
       allowSlidePrev = swiper.allowSlidePrev,
       snapGrid = swiper.snapGrid; // Disable locks on resize

   swiper.allowSlideNext = true;
   swiper.allowSlidePrev = true;
   swiper.updateSize();
   swiper.updateSlides();
   swiper.updateSlidesClasses();

   if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides) {
     swiper.slideTo(swiper.slides.length - 1, 0, false, true);
   } else {
     swiper.slideTo(swiper.activeIndex, 0, false, true);
   }

   if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
     swiper.autoplay.run();
   } // Return locks after resize


   swiper.allowSlidePrev = allowSlidePrev;
   swiper.allowSlideNext = allowSlideNext;

   if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) {
     swiper.checkOverflow();
   }
 }
 // CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/events/onClick.js
 function onClick(e) {
   var swiper = this;
   if (!swiper.enabled) return;

   if (!swiper.allowClick) {
     if (swiper.params.preventClicks) e.preventDefault();

     if (swiper.params.preventClicksPropagation && swiper.animating) {
       e.stopPropagation();
       e.stopImmediatePropagation();
     }
   }
 }
 // CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/events/onScroll.js
 function onScroll() {
   var swiper = this;
   var wrapperEl = swiper.wrapperEl,
       rtlTranslate = swiper.rtlTranslate,
       enabled = swiper.enabled;
   if (!enabled) return;
   swiper.previousTranslate = swiper.translate;

   if (swiper.isHorizontal()) {
     if (rtlTranslate) {
       swiper.translate = wrapperEl.scrollWidth - wrapperEl.offsetWidth - wrapperEl.scrollLeft;
     } else {
       swiper.translate = -wrapperEl.scrollLeft;
     }
   } else {
     swiper.translate = -wrapperEl.scrollTop;
   } // eslint-disable-next-line


   if (swiper.translate === -0) swiper.translate = 0;
   swiper.updateActiveIndex();
   swiper.updateSlidesClasses();
   var newProgress;
   var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();

   if (translatesDiff === 0) {
     newProgress = 0;
   } else {
     newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
   }

   if (newProgress !== swiper.progress) {
     swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
   }

   swiper.emit('setTranslate', swiper.translate, false);
 }
 // CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/events/index.js







 var dummyEventAttached = false;

 function dummyEventListener() {}

 function attachEvents() {
   var swiper = this;
   var document = Object(ssr_window_esm["a" /* getDocument */])();
   var params = swiper.params,
       touchEvents = swiper.touchEvents,
       el = swiper.el,
       wrapperEl = swiper.wrapperEl,
       device = swiper.device,
       support = swiper.support;
   swiper.onTouchStart = onTouchStart.bind(swiper);
   swiper.onTouchMove = onTouchMove.bind(swiper);
   swiper.onTouchEnd = onTouchEnd.bind(swiper);

   if (params.cssMode) {
     swiper.onScroll = onScroll.bind(swiper);
   }

   swiper.onClick = onClick.bind(swiper);
   var capture = !!params.nested; // Touch Events

   if (!support.touch && support.pointerEvents) {
     el.addEventListener(touchEvents.start, swiper.onTouchStart, false);
     document.addEventListener(touchEvents.move, swiper.onTouchMove, capture);
     document.addEventListener(touchEvents.end, swiper.onTouchEnd, false);
   } else {
     if (support.touch) {
       var passiveListener = touchEvents.start === 'touchstart' && support.passiveListener && params.passiveListeners ? {
         passive: true,
         capture: false
       } : false;
       el.addEventListener(touchEvents.start, swiper.onTouchStart, passiveListener);
       el.addEventListener(touchEvents.move, swiper.onTouchMove, support.passiveListener ? {
         passive: false,
         capture: capture
       } : capture);
       el.addEventListener(touchEvents.end, swiper.onTouchEnd, passiveListener);

       if (touchEvents.cancel) {
         el.addEventListener(touchEvents.cancel, swiper.onTouchEnd, passiveListener);
       }

       if (!dummyEventAttached) {
         document.addEventListener('touchstart', dummyEventListener);
         dummyEventAttached = true;
       }
     }

     if (params.simulateTouch && !device.ios && !device.android || params.simulateTouch && !support.touch && device.ios) {
       el.addEventListener('mousedown', swiper.onTouchStart, false);
       document.addEventListener('mousemove', swiper.onTouchMove, capture);
       document.addEventListener('mouseup', swiper.onTouchEnd, false);
     }
   } // Prevent Links Clicks


   if (params.preventClicks || params.preventClicksPropagation) {
     el.addEventListener('click', swiper.onClick, true);
   }

   if (params.cssMode) {
     wrapperEl.addEventListener('scroll', swiper.onScroll);
   } // Resize handler


   if (params.updateOnWindowResize) {
     swiper.on(device.ios || device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', onResize, true);
   } else {
     swiper.on('observerUpdate', onResize, true);
   }
 }

 function detachEvents() {
   var swiper = this;
   var document = Object(ssr_window_esm["a" /* getDocument */])();
   var params = swiper.params,
       touchEvents = swiper.touchEvents,
       el = swiper.el,
       wrapperEl = swiper.wrapperEl,
       device = swiper.device,
       support = swiper.support;
   var capture = !!params.nested; // Touch Events

   if (!support.touch && support.pointerEvents) {
     el.removeEventListener(touchEvents.start, swiper.onTouchStart, false);
     document.removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
     document.removeEventListener(touchEvents.end, swiper.onTouchEnd, false);
   } else {
     if (support.touch) {
       var passiveListener = touchEvents.start === 'onTouchStart' && support.passiveListener && params.passiveListeners ? {
         passive: true,
         capture: false
       } : false;
       el.removeEventListener(touchEvents.start, swiper.onTouchStart, passiveListener);
       el.removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
       el.removeEventListener(touchEvents.end, swiper.onTouchEnd, passiveListener);

       if (touchEvents.cancel) {
         el.removeEventListener(touchEvents.cancel, swiper.onTouchEnd, passiveListener);
       }
     }

     if (params.simulateTouch && !device.ios && !device.android || params.simulateTouch && !support.touch && device.ios) {
       el.removeEventListener('mousedown', swiper.onTouchStart, false);
       document.removeEventListener('mousemove', swiper.onTouchMove, capture);
       document.removeEventListener('mouseup', swiper.onTouchEnd, false);
     }
   } // Prevent Links Clicks


   if (params.preventClicks || params.preventClicksPropagation) {
     el.removeEventListener('click', swiper.onClick, true);
   }

   if (params.cssMode) {
     wrapperEl.removeEventListener('scroll', swiper.onScroll);
   } // Resize handler


   swiper.off(device.ios || device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', onResize);
 }

 /* harmony default export */ var events = ({
   attachEvents: attachEvents,
   detachEvents: detachEvents
 });
 // CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/breakpoints/setBreakpoint.js

 function setBreakpoint() {
   var swiper = this;
   var activeIndex = swiper.activeIndex,
       initialized = swiper.initialized,
       _swiper$loopedSlides = swiper.loopedSlides,
       loopedSlides = _swiper$loopedSlides === void 0 ? 0 : _swiper$loopedSlides,
       params = swiper.params,
       $el = swiper.$el;
   var breakpoints = params.breakpoints;
   if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return; // Get breakpoint for window width and update parameters

   var breakpoint = swiper.getBreakpoint(breakpoints, swiper.params.breakpointsBase, swiper.el);
   if (!breakpoint || swiper.currentBreakpoint === breakpoint) return;
   var breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;

   if (breakpointOnlyParams) {
     ['slidesPerView', 'spaceBetween', 'slidesPerGroup', 'slidesPerGroupSkip', 'slidesPerColumn'].forEach(function (param) {
       var paramValue = breakpointOnlyParams[param];
       if (typeof paramValue === 'undefined') return;

       if (param === 'slidesPerView' && (paramValue === 'AUTO' || paramValue === 'auto')) {
         breakpointOnlyParams[param] = 'auto';
       } else if (param === 'slidesPerView') {
         breakpointOnlyParams[param] = parseFloat(paramValue);
       } else {
         breakpointOnlyParams[param] = parseInt(paramValue, 10);
       }
     });
   }

   var breakpointParams = breakpointOnlyParams || swiper.originalParams;
   var wasMultiRow = params.slidesPerColumn > 1;
   var isMultiRow = breakpointParams.slidesPerColumn > 1;
   var wasEnabled = params.enabled;

   if (wasMultiRow && !isMultiRow) {
     $el.removeClass(params.containerModifierClass + "multirow " + params.containerModifierClass + "multirow-column");
     swiper.emitContainerClasses();
   } else if (!wasMultiRow && isMultiRow) {
     $el.addClass(params.containerModifierClass + "multirow");

     if (breakpointParams.slidesPerColumnFill && breakpointParams.slidesPerColumnFill === 'column' || !breakpointParams.slidesPerColumnFill && params.slidesPerColumnFill === 'column') {
       $el.addClass(params.containerModifierClass + "multirow-column");
     }

     swiper.emitContainerClasses();
   }

   var directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
   var needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);

   if (directionChanged && initialized) {
     swiper.changeDirection();
   }

   Object(utils["e" /* extend */])(swiper.params, breakpointParams);
   var isEnabled = swiper.params.enabled;
   Object(utils["e" /* extend */])(swiper, {
     allowTouchMove: swiper.params.allowTouchMove,
     allowSlideNext: swiper.params.allowSlideNext,
     allowSlidePrev: swiper.params.allowSlidePrev
   });

   if (wasEnabled && !isEnabled) {
     swiper.disable();
   } else if (!wasEnabled && isEnabled) {
     swiper.enable();
   }

   swiper.currentBreakpoint = breakpoint;
   swiper.emit('_beforeBreakpoint', breakpointParams);

   if (needsReLoop && initialized) {
     swiper.loopDestroy();
     swiper.loopCreate();
     swiper.updateSlides();
     swiper.slideTo(activeIndex - loopedSlides + swiper.loopedSlides, 0, false);
   }

   swiper.emit('breakpoint', breakpointParams);
 }
 // CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/breakpoints/getBreakpoint.js

 function getBreakpoint(breakpoints, base, containerEl) {
   if (base === void 0) {
     base = 'window';
   }

   if (!breakpoints || base === 'container' && !containerEl) return undefined;
   var breakpoint = false;
   var window = Object(ssr_window_esm["b" /* getWindow */])();
   var currentHeight = base === 'window' ? window.innerHeight : containerEl.clientHeight;
   var points = Object.keys(breakpoints).map(function (point) {
     if (typeof point === 'string' && point.indexOf('@') === 0) {
       var minRatio = parseFloat(point.substr(1));
       var value = currentHeight * minRatio;
       return {
         value: value,
         point: point
       };
     }

     return {
       value: point,
       point: point
     };
   });
   points.sort(function (a, b) {
     return parseInt(a.value, 10) - parseInt(b.value, 10);
   });

   for (var i = 0; i < points.length; i += 1) {
     var _points$i = points[i],
         point = _points$i.point,
         value = _points$i.value;

     if (base === 'window') {
       if (window.matchMedia("(min-width: " + value + "px)").matches) {
         breakpoint = point;
       }
     } else if (value <= containerEl.clientWidth) {
       breakpoint = point;
     }
   }

   return breakpoint || 'max';
 }
 // CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/breakpoints/index.js


 /* harmony default export */ var core_breakpoints = ({
   setBreakpoint: setBreakpoint,
   getBreakpoint: getBreakpoint
 });
 // CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/classes/addClasses.js
 function prepareClasses(entries, prefix) {
   var resultClasses = [];
   entries.forEach(function (item) {
     if (typeof item === 'object') {
       Object.keys(item).forEach(function (classNames) {
         if (item[classNames]) {
           resultClasses.push(prefix + classNames);
         }
       });
     } else if (typeof item === 'string') {
       resultClasses.push(prefix + item);
     }
   });
   return resultClasses;
 }

 function addClasses() {
   var swiper = this;
   var classNames = swiper.classNames,
       params = swiper.params,
       rtl = swiper.rtl,
       $el = swiper.$el,
       device = swiper.device,
       support = swiper.support; // prettier-ignore

   var suffixes = prepareClasses(['initialized', params.direction, {
     'pointer-events': support.pointerEvents && !support.touch
   }, {
     'free-mode': params.freeMode
   }, {
     'autoheight': params.autoHeight
   }, {
     'rtl': rtl
   }, {
     'multirow': params.slidesPerColumn > 1
   }, {
     'multirow-column': params.slidesPerColumn > 1 && params.slidesPerColumnFill === 'column'
   }, {
     'android': device.android
   }, {
     'ios': device.ios
   }, {
     'css-mode': params.cssMode
   }], params.containerModifierClass);
   classNames.push.apply(classNames, suffixes);
   $el.addClass([].concat(classNames).join(' '));
   swiper.emitContainerClasses();
 }
 // CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/classes/removeClasses.js
 function removeClasses() {
   var swiper = this;
   var $el = swiper.$el,
       classNames = swiper.classNames;
   $el.removeClass(classNames.join(' '));
   swiper.emitContainerClasses();
 }
 // CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/classes/index.js


 /* harmony default export */ var classes = ({
   addClasses: addClasses,
   removeClasses: removeClasses
 });
 // CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/images/loadImage.js


 function loadImage(imageEl, src, srcset, sizes, checkForComplete, callback) {
   var window = Object(ssr_window_esm["b" /* getWindow */])();
   var image;

   function onReady() {
     if (callback) callback();
   }

   var isPicture = Object(dom["a" /* default */])(imageEl).parent('picture')[0];

   if (!isPicture && (!imageEl.complete || !checkForComplete)) {
     if (src) {
       image = new window.Image();
       image.onload = onReady;
       image.onerror = onReady;

       if (sizes) {
         image.sizes = sizes;
       }

       if (srcset) {
         image.srcset = srcset;
       }

       if (src) {
         image.src = src;
       }
     } else {
       onReady();
     }
   } else {
     // image already loaded...
     onReady();
   }
 }
 // CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/images/preloadImages.js
 function preloadImages() {
   var swiper = this;
   swiper.imagesToLoad = swiper.$el.find('img');

   function onReady() {
     if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper.destroyed) return;
     if (swiper.imagesLoaded !== undefined) swiper.imagesLoaded += 1;

     if (swiper.imagesLoaded === swiper.imagesToLoad.length) {
       if (swiper.params.updateOnImagesReady) swiper.update();
       swiper.emit('imagesReady');
     }
   }

   for (var i = 0; i < swiper.imagesToLoad.length; i += 1) {
     var imageEl = swiper.imagesToLoad[i];
     swiper.loadImage(imageEl, imageEl.currentSrc || imageEl.getAttribute('src'), imageEl.srcset || imageEl.getAttribute('srcset'), imageEl.sizes || imageEl.getAttribute('sizes'), true, onReady);
   }
 }
 // CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/images/index.js


 /* harmony default export */ var core_images = ({
   loadImage: loadImage,
   preloadImages: preloadImages
 });
 // CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/check-overflow/index.js
 function checkOverflow() {
   var swiper = this;
   var params = swiper.params;
   var wasLocked = swiper.isLocked;
   var lastSlidePosition = swiper.slides.length > 0 && params.slidesOffsetBefore + params.spaceBetween * (swiper.slides.length - 1) + swiper.slides[0].offsetWidth * swiper.slides.length;

   if (params.slidesOffsetBefore && params.slidesOffsetAfter && lastSlidePosition) {
     swiper.isLocked = lastSlidePosition <= swiper.size;
   } else {
     swiper.isLocked = swiper.snapGrid.length === 1;
   }

   swiper.allowSlideNext = !swiper.isLocked;
   swiper.allowSlidePrev = !swiper.isLocked; // events

   if (wasLocked !== swiper.isLocked) swiper.emit(swiper.isLocked ? 'lock' : 'unlock');

   if (wasLocked && wasLocked !== swiper.isLocked) {
     swiper.isEnd = false;
     if (swiper.navigation) swiper.navigation.update();
   }
 }

 /* harmony default export */ var check_overflow = ({
   checkOverflow: checkOverflow
 });
 // CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/defaults.js
 /* harmony default export */ var defaults = ({
   init: true,
   direction: 'horizontal',
   touchEventsTarget: 'container',
   initialSlide: 0,
   speed: 300,
   cssMode: false,
   updateOnWindowResize: true,
   resizeObserver: false,
   nested: false,
   createElements: false,
   enabled: true,
   focusableElements: 'input, select, option, textarea, button, video, label',
   // Overrides
   width: null,
   height: null,
   //
   preventInteractionOnTransition: false,
   // ssr
   userAgent: null,
   url: null,
   // To support iOS's swipe-to-go-back gesture (when being used in-app).
   edgeSwipeDetection: false,
   edgeSwipeThreshold: 20,
   // Free mode
   freeMode: false,
   freeModeMomentum: true,
   freeModeMomentumRatio: 1,
   freeModeMomentumBounce: true,
   freeModeMomentumBounceRatio: 1,
   freeModeMomentumVelocityRatio: 1,
   freeModeSticky: false,
   freeModeMinimumVelocity: 0.02,
   // Autoheight
   autoHeight: false,
   // Set wrapper width
   setWrapperSize: false,
   // Virtual Translate
   virtualTranslate: false,
   // Effects
   effect: 'slide',
   // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
   // Breakpoints
   breakpoints: undefined,
   breakpointsBase: 'window',
   // Slides grid
   spaceBetween: 0,
   slidesPerView: 1,
   slidesPerColumn: 1,
   slidesPerColumnFill: 'column',
   slidesPerGroup: 1,
   slidesPerGroupSkip: 0,
   centeredSlides: false,
   centeredSlidesBounds: false,
   slidesOffsetBefore: 0,
   // in px
   slidesOffsetAfter: 0,
   // in px
   normalizeSlideIndex: true,
   centerInsufficientSlides: false,
   // Disable swiper and hide navigation when container not overflow
   watchOverflow: false,
   // Round length
   roundLengths: false,
   // Touches
   touchRatio: 1,
   touchAngle: 45,
   simulateTouch: true,
   shortSwipes: true,
   longSwipes: true,
   longSwipesRatio: 0.5,
   longSwipesMs: 300,
   followFinger: true,
   allowTouchMove: true,
   threshold: 0,
   touchMoveStopPropagation: false,
   touchStartPreventDefault: true,
   touchStartForcePreventDefault: false,
   touchReleaseOnEdges: false,
   // Unique Navigation Elements
   uniqueNavElements: true,
   // Resistance
   resistance: true,
   resistanceRatio: 0.85,
   // Progress
   watchSlidesProgress: false,
   watchSlidesVisibility: false,
   // Cursor
   grabCursor: false,
   // Clicks
   preventClicks: true,
   preventClicksPropagation: true,
   slideToClickedSlide: false,
   // Images
   preloadImages: true,
   updateOnImagesReady: true,
   // loop
   loop: false,
   loopAdditionalSlides: 0,
   loopedSlides: null,
   loopFillGroupWithBlank: false,
   loopPreventsSlide: true,
   // Swiping/no swiping
   allowSlidePrev: true,
   allowSlideNext: true,
   swipeHandler: null,
   // '.swipe-handler',
   noSwiping: true,
   noSwipingClass: 'swiper-no-swiping',
   noSwipingSelector: null,
   // Passive Listeners
   passiveListeners: true,
   // NS
   containerModifierClass: 'swiper-container-',
   // NEW
   slideClass: 'swiper-slide',
   slideBlankClass: 'swiper-slide-invisible-blank',
   slideActiveClass: 'swiper-slide-active',
   slideDuplicateActiveClass: 'swiper-slide-duplicate-active',
   slideVisibleClass: 'swiper-slide-visible',
   slideDuplicateClass: 'swiper-slide-duplicate',
   slideNextClass: 'swiper-slide-next',
   slideDuplicateNextClass: 'swiper-slide-duplicate-next',
   slidePrevClass: 'swiper-slide-prev',
   slideDuplicatePrevClass: 'swiper-slide-duplicate-prev',
   wrapperClass: 'swiper-wrapper',
   // Callbacks
   runCallbacksOnInit: true,
   // Internals
   _emitClasses: false
 });
 // CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/core-class.js
 function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

 function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

 /* eslint no-param-reassign: "off" */























 var prototypes = {
   modular: modular,
   eventsEmitter: events_emitter,
   update: update,
   translate: core_translate,
   transition: transition,
   slide: core_slide,
   loop: loop,
   grabCursor: grab_cursor,
   manipulation: manipulation,
   events: events,
   breakpoints: core_breakpoints,
   checkOverflow: check_overflow,
   classes: classes,
   images: core_images
 };
 var extendedDefaults = {};

 var core_class_Swiper = /*#__PURE__*/function () {
   function Swiper() {
     var el;
     var params;

     for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
       args[_key] = arguments[_key];
     }

     if (args.length === 1 && args[0].constructor && Object.prototype.toString.call(args[0]).slice(8, -1) === 'Object') {
       params = args[0];
     } else {
       el = args[0];
       params = args[1];
     }

     if (!params) params = {};
     params = Object(utils["e" /* extend */])({}, params);
     if (el && !params.el) params.el = el;

     if (params.el && Object(dom["a" /* default */])(params.el).length > 1) {
       var swipers = [];
       Object(dom["a" /* default */])(params.el).each(function (containerEl) {
         var newParams = Object(utils["e" /* extend */])({}, params, {
           el: containerEl
         });
         swipers.push(new Swiper(newParams));
       });
       return swipers;
     } // Swiper Instance


     var swiper = this;
     swiper.__swiper__ = true;
     swiper.support = getSupport();
     swiper.device = getDevice({
       userAgent: params.userAgent
     });
     swiper.browser = getBrowser();
     swiper.eventsListeners = {};
     swiper.eventsAnyListeners = [];

     if (typeof swiper.modules === 'undefined') {
       swiper.modules = {};
     }

     Object.keys(swiper.modules).forEach(function (moduleName) {
       var module = swiper.modules[moduleName];

       if (module.params) {
         var moduleParamName = Object.keys(module.params)[0];
         var moduleParams = module.params[moduleParamName];
         if (typeof moduleParams !== 'object' || moduleParams === null) return;

         if (['navigation', 'pagination', 'scrollbar'].indexOf(moduleParamName) >= 0 && params[moduleParamName] === true) {
           params[moduleParamName] = {
             auto: true
           };
         }

         if (!(moduleParamName in params && 'enabled' in moduleParams)) return;

         if (params[moduleParamName] === true) {
           params[moduleParamName] = {
             enabled: true
           };
         }

         if (typeof params[moduleParamName] === 'object' && !('enabled' in params[moduleParamName])) {
           params[moduleParamName].enabled = true;
         }

         if (!params[moduleParamName]) params[moduleParamName] = {
           enabled: false
         };
       }
     }); // Extend defaults with modules params

     var swiperParams = Object(utils["e" /* extend */])({}, defaults);
     swiper.useParams(swiperParams); // Extend defaults with passed params

     swiper.params = Object(utils["e" /* extend */])({}, swiperParams, extendedDefaults, params);
     swiper.originalParams = Object(utils["e" /* extend */])({}, swiper.params);
     swiper.passedParams = Object(utils["e" /* extend */])({}, params); // add event listeners

     if (swiper.params && swiper.params.on) {
       Object.keys(swiper.params.on).forEach(function (eventName) {
         swiper.on(eventName, swiper.params.on[eventName]);
       });
     }

     if (swiper.params && swiper.params.onAny) {
       swiper.onAny(swiper.params.onAny);
     } // Save Dom lib


     swiper.$ = dom["a" /* default */]; // Extend Swiper

     Object(utils["e" /* extend */])(swiper, {
       enabled: swiper.params.enabled,
       el: el,
       // Classes
       classNames: [],
       // Slides
       slides: Object(dom["a" /* default */])(),
       slidesGrid: [],
       snapGrid: [],
       slidesSizesGrid: [],
       // isDirection
       isHorizontal: function isHorizontal() {
         return swiper.params.direction === 'horizontal';
       },
       isVertical: function isVertical() {
         return swiper.params.direction === 'vertical';
       },
       // Indexes
       activeIndex: 0,
       realIndex: 0,
       //
       isBeginning: true,
       isEnd: false,
       // Props
       translate: 0,
       previousTranslate: 0,
       progress: 0,
       velocity: 0,
       animating: false,
       // Locks
       allowSlideNext: swiper.params.allowSlideNext,
       allowSlidePrev: swiper.params.allowSlidePrev,
       // Touch Events
       touchEvents: function touchEvents() {
         var touch = ['touchstart', 'touchmove', 'touchend', 'touchcancel'];
         var desktop = ['mousedown', 'mousemove', 'mouseup'];

         if (swiper.support.pointerEvents) {
           desktop = ['pointerdown', 'pointermove', 'pointerup'];
         }

         swiper.touchEventsTouch = {
           start: touch[0],
           move: touch[1],
           end: touch[2],
           cancel: touch[3]
         };
         swiper.touchEventsDesktop = {
           start: desktop[0],
           move: desktop[1],
           end: desktop[2]
         };
         return swiper.support.touch || !swiper.params.simulateTouch ? swiper.touchEventsTouch : swiper.touchEventsDesktop;
       }(),
       touchEventsData: {
         isTouched: undefined,
         isMoved: undefined,
         allowTouchCallbacks: undefined,
         touchStartTime: undefined,
         isScrolling: undefined,
         currentTranslate: undefined,
         startTranslate: undefined,
         allowThresholdMove: undefined,
         // Form elements to match
         focusableElements: swiper.params.focusableElements,
         // Last click time
         lastClickTime: Object(utils["h" /* now */])(),
         clickTimeout: undefined,
         // Velocities
         velocities: [],
         allowMomentumBounce: undefined,
         isTouchEvent: undefined,
         startMoving: undefined
       },
       // Clicks
       allowClick: true,
       // Touches
       allowTouchMove: swiper.params.allowTouchMove,
       touches: {
         startX: 0,
         startY: 0,
         currentX: 0,
         currentY: 0,
         diff: 0
       },
       // Images
       imagesToLoad: [],
       imagesLoaded: 0
     }); // Install Modules

     swiper.useModules();
     swiper.emit('_swiper'); // Init

     if (swiper.params.init) {
       swiper.init();
     } // Return app instance


     return swiper;
   }

   var _proto = Swiper.prototype;

   _proto.enable = function enable() {
     var swiper = this;
     if (swiper.enabled) return;
     swiper.enabled = true;

     if (swiper.params.grabCursor) {
       swiper.setGrabCursor();
     }

     swiper.emit('enable');
   };

   _proto.disable = function disable() {
     var swiper = this;
     if (!swiper.enabled) return;
     swiper.enabled = false;

     if (swiper.params.grabCursor) {
       swiper.unsetGrabCursor();
     }

     swiper.emit('disable');
   };

   _proto.setProgress = function setProgress(progress, speed) {
     var swiper = this;
     progress = Math.min(Math.max(progress, 0), 1);
     var min = swiper.minTranslate();
     var max = swiper.maxTranslate();
     var current = (max - min) * progress + min;
     swiper.translateTo(current, typeof speed === 'undefined' ? 0 : speed);
     swiper.updateActiveIndex();
     swiper.updateSlidesClasses();
   };

   _proto.emitContainerClasses = function emitContainerClasses() {
     var swiper = this;
     if (!swiper.params._emitClasses || !swiper.el) return;
     var classes = swiper.el.className.split(' ').filter(function (className) {
       return className.indexOf('swiper-container') === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
     });
     swiper.emit('_containerClasses', classes.join(' '));
   };

   _proto.getSlideClasses = function getSlideClasses(slideEl) {
     var swiper = this;
     return slideEl.className.split(' ').filter(function (className) {
       return className.indexOf('swiper-slide') === 0 || className.indexOf(swiper.params.slideClass) === 0;
     }).join(' ');
   };

   _proto.emitSlidesClasses = function emitSlidesClasses() {
     var swiper = this;
     if (!swiper.params._emitClasses || !swiper.el) return;
     var updates = [];
     swiper.slides.each(function (slideEl) {
       var classNames = swiper.getSlideClasses(slideEl);
       updates.push({
         slideEl: slideEl,
         classNames: classNames
       });
       swiper.emit('_slideClass', slideEl, classNames);
     });
     swiper.emit('_slideClasses', updates);
   };

   _proto.slidesPerViewDynamic = function slidesPerViewDynamic() {
     var swiper = this;
     var params = swiper.params,
         slides = swiper.slides,
         slidesGrid = swiper.slidesGrid,
         swiperSize = swiper.size,
         activeIndex = swiper.activeIndex;
     var spv = 1;

     if (params.centeredSlides) {
       var slideSize = slides[activeIndex].swiperSlideSize;
       var breakLoop;

       for (var i = activeIndex + 1; i < slides.length; i += 1) {
         if (slides[i] && !breakLoop) {
           slideSize += slides[i].swiperSlideSize;
           spv += 1;
           if (slideSize > swiperSize) breakLoop = true;
         }
       }

       for (var _i = activeIndex - 1; _i >= 0; _i -= 1) {
         if (slides[_i] && !breakLoop) {
           slideSize += slides[_i].swiperSlideSize;
           spv += 1;
           if (slideSize > swiperSize) breakLoop = true;
         }
       }
     } else {
       for (var _i2 = activeIndex + 1; _i2 < slides.length; _i2 += 1) {
         if (slidesGrid[_i2] - slidesGrid[activeIndex] < swiperSize) {
           spv += 1;
         }
       }
     }

     return spv;
   };

   _proto.update = function update() {
     var swiper = this;
     if (!swiper || swiper.destroyed) return;
     var snapGrid = swiper.snapGrid,
         params = swiper.params; // Breakpoints

     if (params.breakpoints) {
       swiper.setBreakpoint();
     }

     swiper.updateSize();
     swiper.updateSlides();
     swiper.updateProgress();
     swiper.updateSlidesClasses();

     function setTranslate() {
       var translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
       var newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
       swiper.setTranslate(newTranslate);
       swiper.updateActiveIndex();
       swiper.updateSlidesClasses();
     }

     var translated;

     if (swiper.params.freeMode) {
       setTranslate();

       if (swiper.params.autoHeight) {
         swiper.updateAutoHeight();
       }
     } else {
       if ((swiper.params.slidesPerView === 'auto' || swiper.params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) {
         translated = swiper.slideTo(swiper.slides.length - 1, 0, false, true);
       } else {
         translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
       }

       if (!translated) {
         setTranslate();
       }
     }

     if (params.watchOverflow && snapGrid !== swiper.snapGrid) {
       swiper.checkOverflow();
     }

     swiper.emit('update');
   };

   _proto.changeDirection = function changeDirection(newDirection, needUpdate) {
     if (needUpdate === void 0) {
       needUpdate = true;
     }

     var swiper = this;
     var currentDirection = swiper.params.direction;

     if (!newDirection) {
       // eslint-disable-next-line
       newDirection = currentDirection === 'horizontal' ? 'vertical' : 'horizontal';
     }

     if (newDirection === currentDirection || newDirection !== 'horizontal' && newDirection !== 'vertical') {
       return swiper;
     }

     swiper.$el.removeClass("" + swiper.params.containerModifierClass + currentDirection).addClass("" + swiper.params.containerModifierClass + newDirection);
     swiper.emitContainerClasses();
     swiper.params.direction = newDirection;
     swiper.slides.each(function (slideEl) {
       if (newDirection === 'vertical') {
         slideEl.style.width = '';
       } else {
         slideEl.style.height = '';
       }
     });
     swiper.emit('changeDirection');
     if (needUpdate) swiper.update();
     return swiper;
   };

   _proto.mount = function mount(el) {
     var swiper = this;
     if (swiper.mounted) return true; // Find el

     var $el = Object(dom["a" /* default */])(el || swiper.params.el);
     el = $el[0];

     if (!el) {
       return false;
     }

     el.swiper = swiper;

     var getWrapperSelector = function getWrapperSelector() {
       return "." + (swiper.params.wrapperClass || '').trim().split(' ').join('.');
     };

     var getWrapper = function getWrapper() {
       if (el && el.shadowRoot && el.shadowRoot.querySelector) {
         var res = Object(dom["a" /* default */])(el.shadowRoot.querySelector(getWrapperSelector())); // Children needs to return slot items

         res.children = function (options) {
           return $el.children(options);
         };

         return res;
       }

       return $el.children(getWrapperSelector());
     }; // Find Wrapper


     var $wrapperEl = getWrapper();

     if ($wrapperEl.length === 0 && swiper.params.createElements) {
       var document = Object(ssr_window_esm["a" /* getDocument */])();
       var wrapper = document.createElement('div');
       $wrapperEl = Object(dom["a" /* default */])(wrapper);
       wrapper.className = swiper.params.wrapperClass;
       $el.append(wrapper);
       $el.children("." + swiper.params.slideClass).each(function (slideEl) {
         $wrapperEl.append(slideEl);
       });
     }

     Object(utils["e" /* extend */])(swiper, {
       $el: $el,
       el: el,
       $wrapperEl: $wrapperEl,
       wrapperEl: $wrapperEl[0],
       mounted: true,
       // RTL
       rtl: el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl',
       rtlTranslate: swiper.params.direction === 'horizontal' && (el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl'),
       wrongRTL: $wrapperEl.css('display') === '-webkit-box'
     });
     return true;
   };

   _proto.init = function init(el) {
     var swiper = this;
     if (swiper.initialized) return swiper;
     var mounted = swiper.mount(el);
     if (mounted === false) return swiper;
     swiper.emit('beforeInit'); // Set breakpoint

     if (swiper.params.breakpoints) {
       swiper.setBreakpoint();
     } // Add Classes


     swiper.addClasses(); // Create loop

     if (swiper.params.loop) {
       swiper.loopCreate();
     } // Update size


     swiper.updateSize(); // Update slides

     swiper.updateSlides();

     if (swiper.params.watchOverflow) {
       swiper.checkOverflow();
     } // Set Grab Cursor


     if (swiper.params.grabCursor && swiper.enabled) {
       swiper.setGrabCursor();
     }

     if (swiper.params.preloadImages) {
       swiper.preloadImages();
     } // Slide To Initial Slide


     if (swiper.params.loop) {
       swiper.slideTo(swiper.params.initialSlide + swiper.loopedSlides, 0, swiper.params.runCallbacksOnInit, false, true);
     } else {
       swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
     } // Attach events


     swiper.attachEvents(); // Init Flag

     swiper.initialized = true; // Emit

     swiper.emit('init');
     swiper.emit('afterInit');
     return swiper;
   };

   _proto.destroy = function destroy(deleteInstance, cleanStyles) {
     if (deleteInstance === void 0) {
       deleteInstance = true;
     }

     if (cleanStyles === void 0) {
       cleanStyles = true;
     }

     var swiper = this;
     var params = swiper.params,
         $el = swiper.$el,
         $wrapperEl = swiper.$wrapperEl,
         slides = swiper.slides;

     if (typeof swiper.params === 'undefined' || swiper.destroyed) {
       return null;
     }

     swiper.emit('beforeDestroy'); // Init Flag

     swiper.initialized = false; // Detach events

     swiper.detachEvents(); // Destroy loop

     if (params.loop) {
       swiper.loopDestroy();
     } // Cleanup styles


     if (cleanStyles) {
       swiper.removeClasses();
       $el.removeAttr('style');
       $wrapperEl.removeAttr('style');

       if (slides && slides.length) {
         slides.removeClass([params.slideVisibleClass, params.slideActiveClass, params.slideNextClass, params.slidePrevClass].join(' ')).removeAttr('style').removeAttr('data-swiper-slide-index');
       }
     }

     swiper.emit('destroy'); // Detach emitter events

     Object.keys(swiper.eventsListeners).forEach(function (eventName) {
       swiper.off(eventName);
     });

     if (deleteInstance !== false) {
       swiper.$el[0].swiper = null;
       Object(utils["d" /* deleteProps */])(swiper);
     }

     swiper.destroyed = true;
     return null;
   };

   Swiper.extendDefaults = function extendDefaults(newDefaults) {
     Object(utils["e" /* extend */])(extendedDefaults, newDefaults);
   };

   Swiper.installModule = function installModule(module) {
     if (!Swiper.prototype.modules) Swiper.prototype.modules = {};
     var name = module.name || Object.keys(Swiper.prototype.modules).length + "_" + Object(utils["h" /* now */])();
     Swiper.prototype.modules[name] = module;
   };

   Swiper.use = function use(module) {
     if (Array.isArray(module)) {
       module.forEach(function (m) {
         return Swiper.installModule(m);
       });
       return Swiper;
     }

     Swiper.installModule(module);
     return Swiper;
   };

   _createClass(Swiper, null, [{
     key: "extendedDefaults",
     get: function get() {
       return extendedDefaults;
     }
   }, {
     key: "defaults",
     get: function get() {
       return defaults;
     }
   }]);

   return Swiper;
 }();

 Object.keys(prototypes).forEach(function (prototypeGroup) {
   Object.keys(prototypes[prototypeGroup]).forEach(function (protoMethod) {
     core_class_Swiper.prototype[protoMethod] = prototypes[prototypeGroup][protoMethod];
   });
 });
 core_class_Swiper.use([resize, observer_observer]);
 /* harmony default export */ var core_class = __webpack_exports__["a"] = (core_class_Swiper);

 /***/ }),
 /* 104 */
 /***/ (function(module, exports, __webpack_require__) {

 "use strict";
 // `Symbol.prototype.description` getter
 // https://tc39.es/ecma262/#sec-symbol.prototype.description

 var $ = __webpack_require__(13);
 var DESCRIPTORS = __webpack_require__(23);
 var global = __webpack_require__(2);
 var uncurryThis = __webpack_require__(5);
 var hasOwn = __webpack_require__(19);
 var isCallable = __webpack_require__(11);
 var isPrototypeOf = __webpack_require__(59);
 var toString = __webpack_require__(28);
 var defineProperty = __webpack_require__(26).f;
 var copyConstructorProperties = __webpack_require__(140);

 var NativeSymbol = global.Symbol;
 var SymbolPrototype = NativeSymbol && NativeSymbol.prototype;

 if (DESCRIPTORS && isCallable(NativeSymbol) && (!('description' in SymbolPrototype) ||
   // Safari 12 bug
   NativeSymbol().description !== undefined
 )) {
   var EmptyStringDescriptionStore = {};
   // wrap Symbol constructor for correct work with undefined description
   var SymbolWrapper = function Symbol() {
     var description = arguments.length < 1 || arguments[0] === undefined ? undefined : toString(arguments[0]);
     var result = isPrototypeOf(SymbolPrototype, this)
       ? new NativeSymbol(description)
       // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
       : description === undefined ? NativeSymbol() : NativeSymbol(description);
     if (description === '') EmptyStringDescriptionStore[result] = true;
     return result;
   };

   copyConstructorProperties(SymbolWrapper, NativeSymbol);
   SymbolWrapper.prototype = SymbolPrototype;
   SymbolPrototype.constructor = SymbolWrapper;

   var NATIVE_SYMBOL = String(NativeSymbol('test')) == 'Symbol(test)';
   var symbolToString = uncurryThis(SymbolPrototype.toString);
   var symbolValueOf = uncurryThis(SymbolPrototype.valueOf);
   var regexp = /^Symbol\((.*)\)[^)]+$/;
   var replace = uncurryThis(''.replace);
   var stringSlice = uncurryThis(''.slice);

   defineProperty(SymbolPrototype, 'description', {
     configurable: true,
     get: function description() {
       var symbol = symbolValueOf(this);
       var string = symbolToString(symbol);
       if (hasOwn(EmptyStringDescriptionStore, symbol)) return '';
       var desc = NATIVE_SYMBOL ? stringSlice(string, 7, -1) : replace(string, regexp, '$1');
       return desc === '' ? undefined : desc;
     }
   });

   $({ global: true, forced: true }, {
     Symbol: SymbolWrapper
   });
 }


 /***/ }),
 /* 105 */
 /***/ (function(module, exports, __webpack_require__) {

 var classof = __webpack_require__(47);

 // `IsArray` abstract operation
 // https://tc39.es/ecma262/#sec-isarray
 // eslint-disable-next-line es/no-array-isarray -- safe
 module.exports = Array.isArray || function isArray(argument) {
   return classof(argument) == 'Array';
 };


 /***/ }),
 /* 106 */
 /***/ (function(module, exports, __webpack_require__) {

 "use strict";

 var apply = __webpack_require__(117);
 var call = __webpack_require__(22);
 var uncurryThis = __webpack_require__(5);
 var fixRegExpWellKnownSymbolLogic = __webpack_require__(131);
 var isRegExp = __webpack_require__(130);
 var anObject = __webpack_require__(17);
 var requireObjectCoercible = __webpack_require__(37);
 var speciesConstructor = __webpack_require__(215);
 var advanceStringIndex = __webpack_require__(153);
 var toLength = __webpack_require__(88);
 var toString = __webpack_require__(28);
 var getMethod = __webpack_require__(58);
 var arraySlice = __webpack_require__(85);
 var callRegExpExec = __webpack_require__(129);
 var regexpExec = __webpack_require__(133);
 var stickyHelpers = __webpack_require__(154);
 var fails = __webpack_require__(10);

 var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y;
 var MAX_UINT32 = 0xFFFFFFFF;
 var min = Math.min;
 var $push = [].push;
 var exec = uncurryThis(/./.exec);
 var push = uncurryThis($push);
 var stringSlice = uncurryThis(''.slice);

 // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
 // Weex JS has frozen built-in prototypes, so use try / catch wrapper
 var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails(function () {
   // eslint-disable-next-line regexp/no-empty-group -- required for testing
   var re = /(?:)/;
   var originalExec = re.exec;
   re.exec = function () { return originalExec.apply(this, arguments); };
   var result = 'ab'.split(re);
   return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
 });

 // @@split logic
 fixRegExpWellKnownSymbolLogic('split', function (SPLIT, nativeSplit, maybeCallNative) {
   var internalSplit;
   if (
     'abbc'.split(/(b)*/)[1] == 'c' ||
     // eslint-disable-next-line regexp/no-empty-group -- required for testing
     'test'.split(/(?:)/, -1).length != 4 ||
     'ab'.split(/(?:ab)*/).length != 2 ||
     '.'.split(/(.?)(.?)/).length != 4 ||
     // eslint-disable-next-line regexp/no-empty-capturing-group, regexp/no-empty-group -- required for testing
     '.'.split(/()()/).length > 1 ||
     ''.split(/.?/).length
   ) {
     // based on es5-shim implementation, need to rework it
     internalSplit = function (separator, limit) {
       var string = toString(requireObjectCoercible(this));
       var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
       if (lim === 0) return [];
       if (separator === undefined) return [string];
       // If `separator` is not a regex, use native split
       if (!isRegExp(separator)) {
         return call(nativeSplit, string, separator, lim);
       }
       var output = [];
       var flags = (separator.ignoreCase ? 'i' : '') +
                   (separator.multiline ? 'm' : '') +
                   (separator.unicode ? 'u' : '') +
                   (separator.sticky ? 'y' : '');
       var lastLastIndex = 0;
       // Make `global` and avoid `lastIndex` issues by working with a copy
       var separatorCopy = new RegExp(separator.source, flags + 'g');
       var match, lastIndex, lastLength;
       while (match = call(regexpExec, separatorCopy, string)) {
         lastIndex = separatorCopy.lastIndex;
         if (lastIndex > lastLastIndex) {
           push(output, stringSlice(string, lastLastIndex, match.index));
           if (match.length > 1 && match.index < string.length) apply($push, output, arraySlice(match, 1));
           lastLength = match[0].length;
           lastLastIndex = lastIndex;
           if (output.length >= lim) break;
         }
         if (separatorCopy.lastIndex === match.index) separatorCopy.lastIndex++; // Avoid an infinite loop
       }
       if (lastLastIndex === string.length) {
         if (lastLength || !exec(separatorCopy, '')) push(output, '');
       } else push(output, stringSlice(string, lastLastIndex));
       return output.length > lim ? arraySlice(output, 0, lim) : output;
     };
   // Chakra, V8
   } else if ('0'.split(undefined, 0).length) {
     internalSplit = function (separator, limit) {
       return separator === undefined && limit === 0 ? [] : call(nativeSplit, this, separator, limit);
     };
   } else internalSplit = nativeSplit;

   return [
     // `String.prototype.split` method
     // https://tc39.es/ecma262/#sec-string.prototype.split
     function split(separator, limit) {
       var O = requireObjectCoercible(this);
       var splitter = separator == undefined ? undefined : getMethod(separator, SPLIT);
       return splitter
         ? call(splitter, separator, O, limit)
         : call(internalSplit, toString(O), separator, limit);
     },
     // `RegExp.prototype[@@split]` method
     // https://tc39.es/ecma262/#sec-regexp.prototype-@@split
     //
     // NOTE: This cannot be properly polyfilled in engines that don't support
     // the 'y' flag.
     function (string, limit) {
       var rx = anObject(this);
       var S = toString(string);
       var res = maybeCallNative(internalSplit, rx, S, limit, internalSplit !== nativeSplit);

       if (res.done) return res.value;

       var C = speciesConstructor(rx, RegExp);

       var unicodeMatching = rx.unicode;
       var flags = (rx.ignoreCase ? 'i' : '') +
                   (rx.multiline ? 'm' : '') +
                   (rx.unicode ? 'u' : '') +
                   (UNSUPPORTED_Y ? 'g' : 'y');

       // ^(? + rx + ) is needed, in combination with some S slicing, to
       // simulate the 'y' flag.
       var splitter = new C(UNSUPPORTED_Y ? '^(?:' + rx.source + ')' : rx, flags);
       var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
       if (lim === 0) return [];
       if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
       var p = 0;
       var q = 0;
       var A = [];
       while (q < S.length) {
         splitter.lastIndex = UNSUPPORTED_Y ? 0 : q;
         var z = callRegExpExec(splitter, UNSUPPORTED_Y ? stringSlice(S, q) : S);
         var e;
         if (
           z === null ||
           (e = min(toLength(splitter.lastIndex + (UNSUPPORTED_Y ? q : 0)), S.length)) === p
         ) {
           q = advanceStringIndex(S, q, unicodeMatching);
         } else {
           push(A, stringSlice(S, p, q));
           if (A.length === lim) return A;
           for (var i = 1; i <= z.length - 1; i++) {
             push(A, z[i]);
             if (A.length === lim) return A;
           }
           q = p = e;
         }
       }
       push(A, stringSlice(S, p));
       return A;
     }
   ];
 }, !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC, UNSUPPORTED_Y);


 /***/ }),
 /* 107 */
 /***/ (function(module, exports, __webpack_require__) {

 var uncurryThis = __webpack_require__(5);
 var fails = __webpack_require__(10);
 var isCallable = __webpack_require__(11);
 var classof = __webpack_require__(75);
 var getBuiltIn = __webpack_require__(33);
 var inspectSource = __webpack_require__(76);

 var noop = function () { /* empty */ };
 var empty = [];
 var construct = getBuiltIn('Reflect', 'construct');
 var constructorRegExp = /^\s*(?:class|function)\b/;
 var exec = uncurryThis(constructorRegExp.exec);
 var INCORRECT_TO_STRING = !constructorRegExp.exec(noop);

 var isConstructorModern = function (argument) {
   if (!isCallable(argument)) return false;
   try {
     construct(noop, empty, argument);
     return true;
   } catch (error) {
     return false;
   }
 };

 var isConstructorLegacy = function (argument) {
   if (!isCallable(argument)) return false;
   switch (classof(argument)) {
     case 'AsyncFunction':
     case 'GeneratorFunction':
     case 'AsyncGeneratorFunction': return false;
     // we can't check .prototype since constructors produced by .bind haven't it
   } return INCORRECT_TO_STRING || !!exec(constructorRegExp, inspectSource(argument));
 };

 // `IsConstructor` abstract operation
 // https://tc39.es/ecma262/#sec-isconstructor
 module.exports = !construct || fails(function () {
   var called;
   return isConstructorModern(isConstructorModern.call)
     || !isConstructorModern(Object)
     || !isConstructorModern(function () { called = true; })
     || called;
 }) ? isConstructorLegacy : isConstructorModern;


 /***/ }),
 /* 108 */
 /***/ (function(module, exports, __webpack_require__) {

 var defineProperty = __webpack_require__(26).f;
 var hasOwn = __webpack_require__(19);
 var wellKnownSymbol = __webpack_require__(12);

 var TO_STRING_TAG = wellKnownSymbol('toStringTag');

 module.exports = function (it, TAG, STATIC) {
   if (it && !hasOwn(it = STATIC ? it : it.prototype, TO_STRING_TAG)) {
     defineProperty(it, TO_STRING_TAG, { configurable: true, value: TAG });
   }
 };


 /***/ }),
 /* 109 */
 /***/ (function(module, exports, __webpack_require__) {

 "use strict";

 var $propertyIsEnumerable = {}.propertyIsEnumerable;
 // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
 var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

 // Nashorn ~ JDK8 bug
 var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({ 1: 2 }, 1);

 // `Object.prototype.propertyIsEnumerable` method implementation
 // https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
 exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
   var descriptor = getOwnPropertyDescriptor(this, V);
   return !!descriptor && descriptor.enumerable;
 } : $propertyIsEnumerable;


 /***/ }),
 /* 110 */
 /***/ (function(module, exports, __webpack_require__) {

 var global = __webpack_require__(2);

 var String = global.String;

 module.exports = function (argument) {
   try {
     return String(argument);
   } catch (error) {
     return 'Object';
   }
 };


 /***/ }),
 /* 111 */
 /***/ (function(module, exports, __webpack_require__) {

 /* eslint-disable es/no-symbol -- required for testing */
 var V8_VERSION = __webpack_require__(95);
 var fails = __webpack_require__(10);

 // eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
 module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
   var symbol = Symbol();
   // Chrome 38 Symbol has incorrect toString conversion
   // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
   return !String(symbol) || !(Object(symbol) instanceof Symbol) ||
     // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
     !Symbol.sham && V8_VERSION && V8_VERSION < 41;
 });


 /***/ }),
 /* 112 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";
 /* unused harmony export getRecentlyViewedProductsIds */
 /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return addToRecentlyViewedProducts; });
 /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return removeFromRecentlyViewedProducts; });
 /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addCurrentProductToRecentlyViewedProducts; });
 /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getRecentlyViewedProducts; });
 /* harmony import */ var regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(16);
 /* harmony import */ var regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51);
 /* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_1__);
 /* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25);
 /* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2__);
 /* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3);
 /* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_3__);
 /* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21);
 /* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_4__);
 /* harmony import */ var core_js_modules_es_string_split_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(106);
 /* harmony import */ var core_js_modules_es_string_split_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split_js__WEBPACK_IMPORTED_MODULE_5__);
 /* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(50);
 /* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_6__);
 /* harmony import */ var core_js_modules_es_array_join_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(115);
 /* harmony import */ var core_js_modules_es_array_join_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join_js__WEBPACK_IMPORTED_MODULE_7__);
 /* harmony import */ var core_js_modules_es_array_sort_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(324);
 /* harmony import */ var core_js_modules_es_array_sort_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_sort_js__WEBPACK_IMPORTED_MODULE_8__);
 /* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(29);
 /* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_9__);
 /* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(104);
 /* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_10__);
 /* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(114);
 /* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_11__);
 /* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(31);
 /* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_12__);
 /* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(27);
 /* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_13__);
 /* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(41);
 /* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_14__);
 /* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(73);
 /* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_15__);
 /* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(80);
 /* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_16__);
 /* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(63);
 /* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_17__);
 /* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(14);
 /* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_18__);
 /* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(40);
 /* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_19__);
 /* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(44);
 /* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_20__);
 /* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(8);
 /* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_21__);
 /* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(43);
 /* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_22__);
 /* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(46);
 /* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(js_cookie__WEBPACK_IMPORTED_MODULE_23__);
 /* harmony import */ var _savchukoleksii_shopify_template_checker__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(123);
 /* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(24);
 /* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_25__);


 function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

 function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

 function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

 function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

 function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

 function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

 function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

 function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

 function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

 function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

 function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }


























 function getRecentlyViewedProductsIds() {
   var recently_viewed = js_cookie__WEBPACK_IMPORTED_MODULE_23___default.a.get("recently_viewed");

   if (!recently_viewed) {
     js_cookie__WEBPACK_IMPORTED_MODULE_23___default.a.set("recently_viewed", "");
   }

   var ids = recently_viewed.split(",").filter(function (id) {
     return id;
   }).map(function (id) {
     return +id;
   });

   if (!Object(_savchukoleksii_shopify_template_checker__WEBPACK_IMPORTED_MODULE_24__[/* templateEquals */ "a"])("product")) {
     return ids;
   }

   return ids.filter(function (id) {
     var _window, _window$meta, _window$meta$product;

     return id !== +((_window = window) === null || _window === void 0 ? void 0 : (_window$meta = _window.meta) === null || _window$meta === void 0 ? void 0 : (_window$meta$product = _window$meta.product) === null || _window$meta$product === void 0 ? void 0 : _window$meta$product.id);
   });
 }
 function addToRecentlyViewedProducts(current_id) {
   if (!current_id) {
     return;
   }

   var recently_viewed = js_cookie__WEBPACK_IMPORTED_MODULE_23___default.a.get("recently_viewed");

   if (!recently_viewed) {
     js_cookie__WEBPACK_IMPORTED_MODULE_23___default.a.set("recently_viewed", "");
   }

   var recently_viewed_ids = [current_id].concat(_toConsumableArray(getRecentlyViewedProductsIds().filter(function (id) {
     return id !== current_id;
   })));
   js_cookie__WEBPACK_IMPORTED_MODULE_23___default.a.set("recently_viewed", recently_viewed_ids.join(","));
 }
 function removeFromRecentlyViewedProducts(current_id) {
   var recently_viewed = js_cookie__WEBPACK_IMPORTED_MODULE_23___default.a.get("recently_viewed");

   if (!recently_viewed) {
     js_cookie__WEBPACK_IMPORTED_MODULE_23___default.a.set("recently_viewed", "");
   }

   var recently_viewed_ids = getRecentlyViewedProductsIds().filter(function (id) {
     return +id !== current_id;
   });
   js_cookie__WEBPACK_IMPORTED_MODULE_23___default.a.set("recently_viewed", recently_viewed_ids.join(","));
 }
 function addCurrentProductToRecentlyViewedProducts() {
   var _window2, _window2$meta, _window2$meta$product;

   if (!Object(_savchukoleksii_shopify_template_checker__WEBPACK_IMPORTED_MODULE_24__[/* templateEquals */ "a"])("product")) {
     return;
   }

   var current_id = +((_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$meta = _window2.meta) === null || _window2$meta === void 0 ? void 0 : (_window2$meta$product = _window2$meta.product) === null || _window2$meta$product === void 0 ? void 0 : _window2$meta$product.id);
   addToRecentlyViewedProducts(current_id);
 }
 function getRecentlyViewedProducts() {
   return _getRecentlyViewedProducts.apply(this, arguments);
 }

 function _getRecentlyViewedProducts() {
   _getRecentlyViewedProducts = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
     var ids, search, response, html, productsJSON, order;
     return regeneratorRuntime.wrap(function _callee$(_context) {
       while (1) {
         switch (_context.prev = _context.next) {
           case 0:
             ids = getRecentlyViewedProductsIds();
             search = encodeURI(ids.map(function (id) {
               return "id:".concat(id);
             }).join(" OR "));
             _context.next = 4;
             return axios__WEBPACK_IMPORTED_MODULE_25___default.a.get("/search?q=".concat(search, "&type=product&view=products-json"));

           case 4:
             response = _context.sent.data;
             html = document.createElement("div");
             html.innerHTML = response;
             productsJSON = JSON.parse(html.querySelector("[data-json-response]").innerHTML);
             order = ids.reduce(function (ids, id, index) {
               return _objectSpread(_objectSpread({}, ids), {}, _defineProperty({}, id, index));
             }, {});
             productsJSON.sort(function (next, current) {
               return order[next.id] - order[current.id];
             });
             return _context.abrupt("return", productsJSON);

           case 11:
           case "end":
             return _context.stop();
         }
       }
     }, _callee);
   }));
   return _getRecentlyViewedProducts.apply(this, arguments);
 }

 /* unused harmony default export */ var _unused_webpack_default_export = ({
   addToRecentlyViewedProducts: addToRecentlyViewedProducts,
   removeFromRecentlyViewedProducts: removeFromRecentlyViewedProducts,
   addCurrentProductToRecentlyViewedProducts: addCurrentProductToRecentlyViewedProducts,
   getRecentlyViewedProductsIds: getRecentlyViewedProductsIds,
   getRecentlyViewedProducts: getRecentlyViewedProducts
 });

 /***/ }),
 /* 113 */
 /***/ (function(module, exports, __webpack_require__) {

 var DESCRIPTORS = __webpack_require__(23);
 var global = __webpack_require__(2);
 var uncurryThis = __webpack_require__(5);
 var isForced = __webpack_require__(86);
 var inheritIfRequired = __webpack_require__(145);
 var createNonEnumerableProperty = __webpack_require__(48);
 var defineProperty = __webpack_require__(26).f;
 var getOwnPropertyNames = __webpack_require__(74).f;
 var isPrototypeOf = __webpack_require__(59);
 var isRegExp = __webpack_require__(130);
 var toString = __webpack_require__(28);
 var regExpFlags = __webpack_require__(132);
 var stickyHelpers = __webpack_require__(154);
 var redefine = __webpack_require__(32);
 var fails = __webpack_require__(10);
 var hasOwn = __webpack_require__(19);
 var enforceInternalState = __webpack_require__(53).enforce;
 var setSpecies = __webpack_require__(163);
 var wellKnownSymbol = __webpack_require__(12);
 var UNSUPPORTED_DOT_ALL = __webpack_require__(204);
 var UNSUPPORTED_NCG = __webpack_require__(203);

 var MATCH = wellKnownSymbol('match');
 var NativeRegExp = global.RegExp;
 var RegExpPrototype = NativeRegExp.prototype;
 var SyntaxError = global.SyntaxError;
 var getFlags = uncurryThis(regExpFlags);
 var exec = uncurryThis(RegExpPrototype.exec);
 var charAt = uncurryThis(''.charAt);
 var replace = uncurryThis(''.replace);
 var stringIndexOf = uncurryThis(''.indexOf);
 var stringSlice = uncurryThis(''.slice);
 // TODO: Use only propper RegExpIdentifierName
 var IS_NCG = /^\?<[^\s\d!#%&*+<=>@^][^\s!#%&*+<=>@^]*>/;
 var re1 = /a/g;
 var re2 = /a/g;

 // "new" should create a new object, old webkit bug
 var CORRECT_NEW = new NativeRegExp(re1) !== re1;

 var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y;

 var BASE_FORCED = DESCRIPTORS &&
   (!CORRECT_NEW || UNSUPPORTED_Y || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG || fails(function () {
     re2[MATCH] = false;
     // RegExp constructor can alter flags and IsRegExp works correct with @@match
     return NativeRegExp(re1) != re1 || NativeRegExp(re2) == re2 || NativeRegExp(re1, 'i') != '/a/i';
   }));

 var handleDotAll = function (string) {
   var length = string.length;
   var index = 0;
   var result = '';
   var brackets = false;
   var chr;
   for (; index <= length; index++) {
     chr = charAt(string, index);
     if (chr === '\\') {
       result += chr + charAt(string, ++index);
       continue;
     }
     if (!brackets && chr === '.') {
       result += '[\\s\\S]';
     } else {
       if (chr === '[') {
         brackets = true;
       } else if (chr === ']') {
         brackets = false;
       } result += chr;
     }
   } return result;
 };

 var handleNCG = function (string) {
   var length = string.length;
   var index = 0;
   var result = '';
   var named = [];
   var names = {};
   var brackets = false;
   var ncg = false;
   var groupid = 0;
   var groupname = '';
   var chr;
   for (; index <= length; index++) {
     chr = charAt(string, index);
     if (chr === '\\') {
       chr = chr + charAt(string, ++index);
     } else if (chr === ']') {
       brackets = false;
     } else if (!brackets) switch (true) {
       case chr === '[':
         brackets = true;
         break;
       case chr === '(':
         if (exec(IS_NCG, stringSlice(string, index + 1))) {
           index += 2;
           ncg = true;
         }
         result += chr;
         groupid++;
         continue;
       case chr === '>' && ncg:
         if (groupname === '' || hasOwn(names, groupname)) {
           throw new SyntaxError('Invalid capture group name');
         }
         names[groupname] = true;
         named[named.length] = [groupname, groupid];
         ncg = false;
         groupname = '';
         continue;
     }
     if (ncg) groupname += chr;
     else result += chr;
   } return [result, named];
 };

 // `RegExp` constructor
 // https://tc39.es/ecma262/#sec-regexp-constructor
 if (isForced('RegExp', BASE_FORCED)) {
   var RegExpWrapper = function RegExp(pattern, flags) {
     var thisIsRegExp = isPrototypeOf(RegExpPrototype, this);
     var patternIsRegExp = isRegExp(pattern);
     var flagsAreUndefined = flags === undefined;
     var groups = [];
     var rawPattern = pattern;
     var rawFlags, dotAll, sticky, handled, result, state;

     if (!thisIsRegExp && patternIsRegExp && flagsAreUndefined && pattern.constructor === RegExpWrapper) {
       return pattern;
     }

     if (patternIsRegExp || isPrototypeOf(RegExpPrototype, pattern)) {
       pattern = pattern.source;
       if (flagsAreUndefined) flags = 'flags' in rawPattern ? rawPattern.flags : getFlags(rawPattern);
     }

     pattern = pattern === undefined ? '' : toString(pattern);
     flags = flags === undefined ? '' : toString(flags);
     rawPattern = pattern;

     if (UNSUPPORTED_DOT_ALL && 'dotAll' in re1) {
       dotAll = !!flags && stringIndexOf(flags, 's') > -1;
       if (dotAll) flags = replace(flags, /s/g, '');
     }

     rawFlags = flags;

     if (UNSUPPORTED_Y && 'sticky' in re1) {
       sticky = !!flags && stringIndexOf(flags, 'y') > -1;
       if (sticky) flags = replace(flags, /y/g, '');
     }

     if (UNSUPPORTED_NCG) {
       handled = handleNCG(pattern);
       pattern = handled[0];
       groups = handled[1];
     }

     result = inheritIfRequired(NativeRegExp(pattern, flags), thisIsRegExp ? this : RegExpPrototype, RegExpWrapper);

     if (dotAll || sticky || groups.length) {
       state = enforceInternalState(result);
       if (dotAll) {
         state.dotAll = true;
         state.raw = RegExpWrapper(handleDotAll(pattern), rawFlags);
       }
       if (sticky) state.sticky = true;
       if (groups.length) state.groups = groups;
     }

     if (pattern !== rawPattern) try {
       // fails in old engines, but we have no alternatives for unsupported regex syntax
       createNonEnumerableProperty(result, 'source', rawPattern === '' ? '(?:)' : rawPattern);
     } catch (error) { /* empty */ }

     return result;
   };

   var proxy = function (key) {
     key in RegExpWrapper || defineProperty(RegExpWrapper, key, {
       configurable: true,
       get: function () { return NativeRegExp[key]; },
       set: function (it) { NativeRegExp[key] = it; }
     });
   };

   for (var keys = getOwnPropertyNames(NativeRegExp), index = 0; keys.length > index;) {
     proxy(keys[index++]);
   }

   RegExpPrototype.constructor = RegExpWrapper;
   RegExpWrapper.prototype = RegExpPrototype;
   redefine(global, 'RegExp', RegExpWrapper);
 }

 // https://tc39.es/ecma262/#sec-get-regexp-@@species
 setSpecies('RegExp');


 /***/ }),
 /* 114 */
 /***/ (function(module, exports, __webpack_require__) {

 var defineWellKnownSymbol = __webpack_require__(188);

 // `Symbol.iterator` well-known symbol
 // https://tc39.es/ecma262/#sec-symbol.iterator
 defineWellKnownSymbol('iterator');


 /***/ }),
 /* 115 */
 /***/ (function(module, exports, __webpack_require__) {

 "use strict";

 var $ = __webpack_require__(13);
 var uncurryThis = __webpack_require__(5);
 var IndexedObject = __webpack_require__(89);
 var toIndexedObject = __webpack_require__(30);
 var arrayMethodIsStrict = __webpack_require__(150);

 var un$Join = uncurryThis([].join);

 var ES3_STRINGS = IndexedObject != Object;
 var STRICT_METHOD = arrayMethodIsStrict('join', ',');

 // `Array.prototype.join` method
 // https://tc39.es/ecma262/#sec-array.prototype.join
 $({ target: 'Array', proto: true, forced: ES3_STRINGS || !STRICT_METHOD }, {
   join: function join(separator) {
     return un$Join(toIndexedObject(this), separator === undefined ? ',' : separator);
   }
 });


 /***/ }),
 /* 116 */
 /***/ (function(module, exports, __webpack_require__) {

 var wellKnownSymbol = __webpack_require__(12);
 var create = __webpack_require__(55);
 var definePropertyModule = __webpack_require__(26);

 var UNSCOPABLES = wellKnownSymbol('unscopables');
 var ArrayPrototype = Array.prototype;

 // Array.prototype[@@unscopables]
 // https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
 if (ArrayPrototype[UNSCOPABLES] == undefined) {
   definePropertyModule.f(ArrayPrototype, UNSCOPABLES, {
     configurable: true,
     value: create(null)
   });
 }

 // add a key to Array.prototype[@@unscopables]
 module.exports = function (key) {
   ArrayPrototype[UNSCOPABLES][key] = true;
 };


 /***/ }),
 /* 117 */
 /***/ (function(module, exports) {

 var FunctionPrototype = Function.prototype;
 var apply = FunctionPrototype.apply;
 var bind = FunctionPrototype.bind;
 var call = FunctionPrototype.call;

 // eslint-disable-next-line es/no-reflect -- safe
 module.exports = typeof Reflect == 'object' && Reflect.apply || (bind ? call.bind(apply) : function () {
   return call.apply(apply, arguments);
 });


 /***/ }),
 /* 118 */
 /***/ (function(module, exports) {

 module.exports = {};


 /***/ }),
 /* 119 */
 /***/ (function(module, exports) {

 // eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
 exports.f = Object.getOwnPropertySymbols;


 /***/ }),
 /* 120 */
 /***/ (function(module, exports, __webpack_require__) {

 var uncurryThis = __webpack_require__(5);
 var hasOwn = __webpack_require__(19);
 var toIndexedObject = __webpack_require__(30);
 var indexOf = __webpack_require__(138).indexOf;
 var hiddenKeys = __webpack_require__(66);

 var push = uncurryThis([].push);

 module.exports = function (object, names) {
   var O = toIndexedObject(object);
   var i = 0;
   var result = [];
   var key;
   for (key in O) !hasOwn(hiddenKeys, key) && hasOwn(O, key) && push(result, key);
   // Don't enum bug & hidden keys
   while (names.length > i) if (hasOwn(O, key = names[i++])) {
     ~indexOf(result, key) || push(result, key);
   }
   return result;
 };


 /***/ }),
 /* 121 */
 /***/ (function(module, exports, __webpack_require__) {

 var DESCRIPTORS = __webpack_require__(23);
 var fails = __webpack_require__(10);
 var createElement = __webpack_require__(94);

 // Thank's IE8 for his funny defineProperty
 module.exports = !DESCRIPTORS && !fails(function () {
   // eslint-disable-next-line es/no-object-defineproperty -- requied for testing
   return Object.defineProperty(createElement('div'), 'a', {
     get: function () { return 7; }
   }).a != 7;
 });


 /***/ }),
 /* 122 */
 /***/ (function(module, exports, __webpack_require__) {

 /* eslint-disable es/no-symbol -- required for testing */
 var NATIVE_SYMBOL = __webpack_require__(111);

 module.exports = NATIVE_SYMBOL
   && !Symbol.sham
   && typeof Symbol.iterator == 'symbol';


 /***/ }),
 /* 123 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";
 /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return templateEquals; });
 /* unused harmony export templateNameEquals */
 /* unused harmony export templateSuffixEquals */
 /* unused harmony export templateDirectoryEquals */
 const regex = /(?<template>((?<directory>[a-zA-Z0-9_-]+)\/)?(?<name>[a-zA-Z0-9_-]+)\.?(?<suffix>[a-zA-Z0-9_-]+)?)(.+)?/;

 const themeTemplateMeta = document.querySelector('[property="theme:template"]');
 if(!themeTemplateMeta) {
     throw Error("template meta tag does not exist")
 }

 const templateString    = themeTemplateMeta.content;
 const parsed            = regex.exec(templateString).groups;

 function templateEquals(template) {
     return parsed.template === template;
 }

 function templateNameEquals(templateName) {
     return parsed.name === templateName;
 }

 function templateSuffixEquals(templateSuffix) {
     return parsed.suffix === templateSuffix;
 }

 function templateDirectoryEquals(templateDirectory) {
     return parsed.directory === templateDirectory;
 }

 /* unused harmony default export */ var _unused_webpack_default_export = ({
     templateEquals,
     templateNameEquals,
     templateSuffixEquals,
     templateDirectoryEquals,
 });

 /***/ }),
 /* 124 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";
 /* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25);
 /* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3);
 /* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1__);
 /* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21);
 /* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_2__);
 /* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54);
 /* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_3__);
 /* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36);
 /* harmony import */ var _savchukoleksii_shopify_theme_translations_tool__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70);
 /* harmony import */ var _savchukoleksii_shopify_theme_settings_tool__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(61);
 /* harmony import */ var _core_objects__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(38);
 /* harmony import */ var _shopify_theme_currency__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(71);
 /* harmony import */ var _shopify_theme_images__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(102);










 vue__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"].filter("money", function (value) {
   return Object(_shopify_theme_currency__WEBPACK_IMPORTED_MODULE_8__[/* formatMoney */ "a"])(value, "${{amount}}");
 });
 vue__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"].filter("moneyNoDecimals", function (value) {
   return Object(_shopify_theme_currency__WEBPACK_IMPORTED_MODULE_8__[/* formatMoney */ "a"])(value, "${{amount_no_decimals}}");
 });
 vue__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"].filter("img_url", function (src, size) {
   var settingsAll = _savchukoleksii_shopify_theme_settings_tool__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"].all();

   if (!src) {
     if (settingsAll.placeholder) {
       src = settingsAll.placeholder;
     } else {
       return null;
     }
   }

   return Object(_shopify_theme_images__WEBPACK_IMPORTED_MODULE_9__[/* getSizedImageUrl */ "a"])(src, size);
 });
 vue__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"].filter("asset_img_url", function (file) {
   var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
   var src = _core_objects__WEBPACK_IMPORTED_MODULE_7__[/* default */ "c"].get("assetsUrl").replace("%%file%%", file);

   if (!src) {
     return src;
   }

   if (!size) {
     return src;
   }

   return Object(_shopify_theme_images__WEBPACK_IMPORTED_MODULE_9__[/* getSizedImageUrl */ "a"])(src, size);
 });
 vue__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"].filter("file_img_url", function (file) {
   var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
   var src = _core_objects__WEBPACK_IMPORTED_MODULE_7__[/* default */ "c"].get("fileUrl").replace("%%file%%", file);

   if (!src) {
     return src;
   }

   if (!size) {
     return src;
   }

   return Object(_shopify_theme_images__WEBPACK_IMPORTED_MODULE_9__[/* getSizedImageUrl */ "a"])(src, size);
 });
 vue__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"].filter("t", function (value) {
   var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
   return _savchukoleksii_shopify_theme_translations_tool__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"].get(value, params);
 });
 vue__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"].filter("unescape", function unescape(value) {
   var doc = new DOMParser().parseFromString(value, "text/html");
   return doc.documentElement.textContent;
 });
 vue__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"].filter("routes", function routes(value) {
   return _core_objects__WEBPACK_IMPORTED_MODULE_7__[/* default */ "c"].routes(value);
 });
 vue__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"].filter("default_value", function routes(value, defaultValue) {
   if (value) {
     return value;
   }

   return defaultValue;
 });

 /***/ }),
 /* 125 */
 /***/ (function(module, exports, __webpack_require__) {

 "use strict";

 var call = __webpack_require__(22);
 var fixRegExpWellKnownSymbolLogic = __webpack_require__(131);
 var anObject = __webpack_require__(17);
 var requireObjectCoercible = __webpack_require__(37);
 var sameValue = __webpack_require__(320);
 var toString = __webpack_require__(28);
 var getMethod = __webpack_require__(58);
 var regExpExec = __webpack_require__(129);

 // @@search logic
 fixRegExpWellKnownSymbolLogic('search', function (SEARCH, nativeSearch, maybeCallNative) {
   return [
     // `String.prototype.search` method
     // https://tc39.es/ecma262/#sec-string.prototype.search
     function search(regexp) {
       var O = requireObjectCoercible(this);
       var searcher = regexp == undefined ? undefined : getMethod(regexp, SEARCH);
       return searcher ? call(searcher, regexp, O) : new RegExp(regexp)[SEARCH](toString(O));
     },
     // `RegExp.prototype[@@search]` method
     // https://tc39.es/ecma262/#sec-regexp.prototype-@@search
     function (string) {
       var rx = anObject(this);
       var S = toString(string);
       var res = maybeCallNative(nativeSearch, rx, S);

       if (res.done) return res.value;

       var previousLastIndex = rx.lastIndex;
       if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
       var result = regExpExec(rx, S);
       if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
       return result === null ? -1 : result.index;
     }
   ];
 });


 /***/ }),
 /* 126 */
 /***/ (function(module, exports, __webpack_require__) {

 "use strict";

 var toPropertyKey = __webpack_require__(93);
 var definePropertyModule = __webpack_require__(26);
 var createPropertyDescriptor = __webpack_require__(67);

 module.exports = function (object, key, value) {
   var propertyKey = toPropertyKey(key);
   if (propertyKey in object) definePropertyModule.f(object, propertyKey, createPropertyDescriptor(0, value));
   else object[propertyKey] = value;
 };


 /***/ }),
 /* 127 */
 /***/ (function(module, exports, __webpack_require__) {

 var fails = __webpack_require__(10);
 var wellKnownSymbol = __webpack_require__(12);
 var V8_VERSION = __webpack_require__(95);

 var SPECIES = wellKnownSymbol('species');

 module.exports = function (METHOD_NAME) {
   // We can't use this feature detection in V8 since it causes
   // deoptimization and serious performance degradation
   // https://github.com/zloirock/core-js/issues/677
   return V8_VERSION >= 51 || !fails(function () {
     var array = [];
     var constructor = array.constructor = {};
     constructor[SPECIES] = function () {
       return { foo: 1 };
     };
     return array[METHOD_NAME](Boolean).foo !== 1;
   });
 };


 /***/ }),
 /* 128 */
 /***/ (function(module, exports, __webpack_require__) {

 var arraySpeciesConstructor = __webpack_require__(151);

 // `ArraySpeciesCreate` abstract operation
 // https://tc39.es/ecma262/#sec-arrayspeciescreate
 module.exports = function (originalArray, length) {
   return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
 };


 /***/ }),
 /* 129 */
 /***/ (function(module, exports, __webpack_require__) {

 var global = __webpack_require__(2);
 var call = __webpack_require__(22);
 var anObject = __webpack_require__(17);
 var isCallable = __webpack_require__(11);
 var classof = __webpack_require__(47);
 var regexpExec = __webpack_require__(133);

 var TypeError = global.TypeError;

 // `RegExpExec` abstract operation
 // https://tc39.es/ecma262/#sec-regexpexec
 module.exports = function (R, S) {
   var exec = R.exec;
   if (isCallable(exec)) {
     var result = call(exec, R, S);
     if (result !== null) anObject(result);
     return result;
   }
   if (classof(R) === 'RegExp') return call(regexpExec, R, S);
   throw TypeError('RegExp#exec called on incompatible receiver');
 };


 /***/ }),
 /* 130 */
 /***/ (function(module, exports, __webpack_require__) {

 var isObject = __webpack_require__(18);
 var classof = __webpack_require__(47);
 var wellKnownSymbol = __webpack_require__(12);

 var MATCH = wellKnownSymbol('match');

 // `IsRegExp` abstract operation
 // https://tc39.es/ecma262/#sec-isregexp
 module.exports = function (it) {
   var isRegExp;
   return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classof(it) == 'RegExp');
 };


 /***/ }),
 /* 131 */
 /***/ (function(module, exports, __webpack_require__) {

 "use strict";

 // TODO: Remove from `core-js@4` since it's moved to entry points
 __webpack_require__(21);
 var uncurryThis = __webpack_require__(5);
 var redefine = __webpack_require__(32);
 var regexpExec = __webpack_require__(133);
 var fails = __webpack_require__(10);
 var wellKnownSymbol = __webpack_require__(12);
 var createNonEnumerableProperty = __webpack_require__(48);

 var SPECIES = wellKnownSymbol('species');
 var RegExpPrototype = RegExp.prototype;

 module.exports = function (KEY, exec, FORCED, SHAM) {
   var SYMBOL = wellKnownSymbol(KEY);

   var DELEGATES_TO_SYMBOL = !fails(function () {
     // String methods call symbol-named RegEp methods
     var O = {};
     O[SYMBOL] = function () { return 7; };
     return ''[KEY](O) != 7;
   });

   var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails(function () {
     // Symbol-named RegExp methods call .exec
     var execCalled = false;
     var re = /a/;

     if (KEY === 'split') {
       // We can't use real regex here since it causes deoptimization
       // and serious performance degradation in V8
       // https://github.com/zloirock/core-js/issues/306
       re = {};
       // RegExp[@@split] doesn't call the regex's exec method, but first creates
       // a new one. We need to return the patched regex when creating the new one.
       re.constructor = {};
       re.constructor[SPECIES] = function () { return re; };
       re.flags = '';
       re[SYMBOL] = /./[SYMBOL];
     }

     re.exec = function () { execCalled = true; return null; };

     re[SYMBOL]('');
     return !execCalled;
   });

   if (
     !DELEGATES_TO_SYMBOL ||
     !DELEGATES_TO_EXEC ||
     FORCED
   ) {
     var uncurriedNativeRegExpMethod = uncurryThis(/./[SYMBOL]);
     var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
       var uncurriedNativeMethod = uncurryThis(nativeMethod);
       var $exec = regexp.exec;
       if ($exec === regexpExec || $exec === RegExpPrototype.exec) {
         if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
           // The native String method already delegates to @@method (this
           // polyfilled function), leasing to infinite recursion.
           // We avoid it by directly calling the native @@method method.
           return { done: true, value: uncurriedNativeRegExpMethod(regexp, str, arg2) };
         }
         return { done: true, value: uncurriedNativeMethod(str, regexp, arg2) };
       }
       return { done: false };
     });

     redefine(String.prototype, KEY, methods[0]);
     redefine(RegExpPrototype, SYMBOL, methods[1]);
   }

   if (SHAM) createNonEnumerableProperty(RegExpPrototype[SYMBOL], 'sham', true);
 };


 /***/ }),
 /* 132 */
 /***/ (function(module, exports, __webpack_require__) {

 "use strict";

 var anObject = __webpack_require__(17);

 // `RegExp.prototype.flags` getter implementation
 // https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
 module.exports = function () {
   var that = anObject(this);
   var result = '';
   if (that.global) result += 'g';
   if (that.ignoreCase) result += 'i';
   if (that.multiline) result += 'm';
   if (that.dotAll) result += 's';
   if (that.unicode) result += 'u';
   if (that.sticky) result += 'y';
   return result;
 };


 /***/ }),
 /* 133 */
 /***/ (function(module, exports, __webpack_require__) {

 "use strict";

 /* eslint-disable regexp/no-empty-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */
 /* eslint-disable regexp/no-useless-quantifier -- testing */
 var call = __webpack_require__(22);
 var uncurryThis = __webpack_require__(5);
 var toString = __webpack_require__(28);
 var regexpFlags = __webpack_require__(132);
 var stickyHelpers = __webpack_require__(154);
 var shared = __webpack_require__(99);
 var create = __webpack_require__(55);
 var getInternalState = __webpack_require__(53).get;
 var UNSUPPORTED_DOT_ALL = __webpack_require__(204);
 var UNSUPPORTED_NCG = __webpack_require__(203);

 var nativeReplace = shared('native-string-replace', String.prototype.replace);
 var nativeExec = RegExp.prototype.exec;
 var patchedExec = nativeExec;
 var charAt = uncurryThis(''.charAt);
 var indexOf = uncurryThis(''.indexOf);
 var replace = uncurryThis(''.replace);
 var stringSlice = uncurryThis(''.slice);

 var UPDATES_LAST_INDEX_WRONG = (function () {
   var re1 = /a/;
   var re2 = /b*/g;
   call(nativeExec, re1, 'a');
   call(nativeExec, re2, 'a');
   return re1.lastIndex !== 0 || re2.lastIndex !== 0;
 })();

 var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y || stickyHelpers.BROKEN_CARET;

 // nonparticipating capturing group, copied from es5-shim's String#split patch.
 var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

 var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG;

 if (PATCH) {
   // eslint-disable-next-line max-statements -- TODO
   patchedExec = function exec(string) {
     var re = this;
     var state = getInternalState(re);
     var str = toString(string);
     var raw = state.raw;
     var result, reCopy, lastIndex, match, i, object, group;

     if (raw) {
       raw.lastIndex = re.lastIndex;
       result = call(patchedExec, raw, str);
       re.lastIndex = raw.lastIndex;
       return result;
     }

     var groups = state.groups;
     var sticky = UNSUPPORTED_Y && re.sticky;
     var flags = call(regexpFlags, re);
     var source = re.source;
     var charsAdded = 0;
     var strCopy = str;

     if (sticky) {
       flags = replace(flags, 'y', '');
       if (indexOf(flags, 'g') === -1) {
         flags += 'g';
       }

       strCopy = stringSlice(str, re.lastIndex);
       // Support anchored sticky behavior.
       if (re.lastIndex > 0 && (!re.multiline || re.multiline && charAt(str, re.lastIndex - 1) !== '\n')) {
         source = '(?: ' + source + ')';
         strCopy = ' ' + strCopy;
         charsAdded++;
       }
       // ^(? + rx + ) is needed, in combination with some str slicing, to
       // simulate the 'y' flag.
       reCopy = new RegExp('^(?:' + source + ')', flags);
     }

     if (NPCG_INCLUDED) {
       reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
     }
     if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

     match = call(nativeExec, sticky ? reCopy : re, strCopy);

     if (sticky) {
       if (match) {
         match.input = stringSlice(match.input, charsAdded);
         match[0] = stringSlice(match[0], charsAdded);
         match.index = re.lastIndex;
         re.lastIndex += match[0].length;
       } else re.lastIndex = 0;
     } else if (UPDATES_LAST_INDEX_WRONG && match) {
       re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
     }
     if (NPCG_INCLUDED && match && match.length > 1) {
       // Fix browsers whose `exec` methods don't consistently return `undefined`
       // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
       call(nativeReplace, match[0], reCopy, function () {
         for (i = 1; i < arguments.length - 2; i++) {
           if (arguments[i] === undefined) match[i] = undefined;
         }
       });
     }

     if (match && groups) {
       match.groups = object = create(null);
       for (i = 0; i < groups.length; i++) {
         group = groups[i];
         object[group[0]] = match[group[1]];
       }
     }

     return match;
   };
 }

 module.exports = patchedExec;


 /***/ }),
 /* 134 */
 /***/ (function(module, exports, __webpack_require__) {

 var getBuiltIn = __webpack_require__(33);

 module.exports = getBuiltIn('document', 'documentElement');


 /***/ }),
 /* 135 */
 /***/ (function(module, exports, __webpack_require__) {

 var classof = __webpack_require__(75);
 var getMethod = __webpack_require__(58);
 var Iterators = __webpack_require__(118);
 var wellKnownSymbol = __webpack_require__(12);

 var ITERATOR = wellKnownSymbol('iterator');

 module.exports = function (it) {
   if (it != undefined) return getMethod(it, ITERATOR)
     || getMethod(it, '@@iterator')
     || Iterators[classof(it)];
 };


 /***/ }),
 /* 136 */
 /***/ (function(module, exports, __webpack_require__) {

 var global = __webpack_require__(2);
 var isPrototypeOf = __webpack_require__(59);

 var TypeError = global.TypeError;

 module.exports = function (it, Prototype) {
   if (isPrototypeOf(Prototype, it)) return it;
   throw TypeError('Incorrect invocation');
 };


 /***/ }),
 /* 137 */
 /***/ (function(module, exports, __webpack_require__) {

 var toIntegerOrInfinity = __webpack_require__(65);

 var max = Math.max;
 var min = Math.min;

 // Helper for a popular repeating case of the spec:
 // Let integer be ? ToInteger(index).
 // If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
 module.exports = function (index, length) {
   var integer = toIntegerOrInfinity(index);
   return integer < 0 ? max(integer + length, 0) : min(integer, length);
 };


 /***/ }),
 /* 138 */
 /***/ (function(module, exports, __webpack_require__) {

 var toIndexedObject = __webpack_require__(30);
 var toAbsoluteIndex = __webpack_require__(137);
 var lengthOfArrayLike = __webpack_require__(56);

 // `Array.prototype.{ indexOf, includes }` methods implementation
 var createMethod = function (IS_INCLUDES) {
   return function ($this, el, fromIndex) {
     var O = toIndexedObject($this);
     var length = lengthOfArrayLike(O);
     var index = toAbsoluteIndex(fromIndex, length);
     var value;
     // Array#includes uses SameValueZero equality algorithm
     // eslint-disable-next-line no-self-compare -- NaN check
     if (IS_INCLUDES && el != el) while (length > index) {
       value = O[index++];
       // eslint-disable-next-line no-self-compare -- NaN check
       if (value != value) return true;
     // Array#indexOf ignores holes, Array#includes - not
     } else for (;length > index; index++) {
       if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
     } return !IS_INCLUDES && -1;
   };
 };

 module.exports = {
   // `Array.prototype.includes` method
   // https://tc39.es/ecma262/#sec-array.prototype.includes
   includes: createMethod(true),
   // `Array.prototype.indexOf` method
   // https://tc39.es/ecma262/#sec-array.prototype.indexof
   indexOf: createMethod(false)
 };


 /***/ }),
 /* 139 */
 /***/ (function(module, exports, __webpack_require__) {

 var getBuiltIn = __webpack_require__(33);
 var uncurryThis = __webpack_require__(5);
 var getOwnPropertyNamesModule = __webpack_require__(74);
 var getOwnPropertySymbolsModule = __webpack_require__(119);
 var anObject = __webpack_require__(17);

 var concat = uncurryThis([].concat);

 // all object keys, includes non-enumerable and symbols
 module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
   var keys = getOwnPropertyNamesModule.f(anObject(it));
   var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
   return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
 };


 /***/ }),
 /* 140 */
 /***/ (function(module, exports, __webpack_require__) {

 var hasOwn = __webpack_require__(19);
 var ownKeys = __webpack_require__(139);
 var getOwnPropertyDescriptorModule = __webpack_require__(52);
 var definePropertyModule = __webpack_require__(26);

 module.exports = function (target, source) {
   var keys = ownKeys(source);
   var defineProperty = definePropertyModule.f;
   var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
   for (var i = 0; i < keys.length; i++) {
     var key = keys[i];
     if (!hasOwn(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
   }
 };


 /***/ }),
 /* 141 */
 /***/ (function(module, exports, __webpack_require__) {

 var global = __webpack_require__(2);
 var call = __webpack_require__(22);
 var isObject = __webpack_require__(18);
 var isSymbol = __webpack_require__(92);
 var getMethod = __webpack_require__(58);
 var ordinaryToPrimitive = __webpack_require__(168);
 var wellKnownSymbol = __webpack_require__(12);

 var TypeError = global.TypeError;
 var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

 // `ToPrimitive` abstract operation
 // https://tc39.es/ecma262/#sec-toprimitive
 module.exports = function (input, pref) {
   if (!isObject(input) || isSymbol(input)) return input;
   var exoticToPrim = getMethod(input, TO_PRIMITIVE);
   var result;
   if (exoticToPrim) {
     if (pref === undefined) pref = 'default';
     result = call(exoticToPrim, input, pref);
     if (!isObject(result) || isSymbol(result)) return result;
     throw TypeError("Can't convert object to primitive value");
   }
   if (pref === undefined) pref = 'number';
   return ordinaryToPrimitive(input, pref);
 };


 /***/ }),
 /* 142 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";
 __webpack_require__.r(__webpack_exports__);
 /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "initPreferredStore", function() { return initPreferredStore; });
 /* harmony import */ var regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(16);
 /* harmony import */ var regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3);
 /* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1__);
 /* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14);
 /* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_2__);
 /* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8);
 /* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_3__);
 /* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(63);
 /* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_4__);
 /* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50);
 /* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_5__);
 /* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(25);
 /* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_6__);
 /* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(73);
 /* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_7__);
 /* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(27);
 /* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_8__);










 function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

 function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

 var selectors = {
   wrapper: ".account-preferred-store",
   select: ".account-preferred-store__select"
 };
 var modification = {
   available: "account-preferred-store--available"
 }; // TODO: test apps token.

 var parameters = {
   variableStore: "preferredStore",
   token: "33e4310d25bbd76d263ae98a811455be"
 };

 function PreferredStore(container) {
   var _localStorage$getItem,
       _this = this;

   this.container = container;
   this.select = this.container.querySelector(selectors.select);
   this.preferredStore = (_localStorage$getItem = localStorage.getItem(parameters.variableStore)) !== null && _localStorage$getItem !== void 0 ? _localStorage$getItem : null;
   this.locationUser = {};
   navigator.geolocation.getCurrentPosition(function (position) {
     _this.locationUser = {
       latitude: position.coords.latitude,
       longitude: position.coords.longitude
     };

     _this.updateSelect();
   }, function (error) {
     // eslint-disable-next-line no-console
     console.error("Error occurred. Error code: " + error.code);
     _this.locationUser = {
       latitude: 52.523287,
       longitude: 13.415478
     };

     _this.updateSelect();
   }, {
     timeout: 10 * 1000
   });
   this.eventChangeSelect();
 }

 PreferredStore.prototype.getStores = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
   var response;
   return regeneratorRuntime.wrap(function _callee$(_context) {
     while (1) {
       switch (_context.prev = _context.next) {
         case 0:
           _context.next = 2;
           return fetch("/api/2021-07/graphql.json", {
             method: "POST",
             headers: {
               "Content-Type": "application/json",
               "X-Shopify-Storefront-Access-Token": parameters.token
             },
             body: JSON.stringify({
               query: "\n\t\t\t\t   query LocationsByDistance($location: GeoCoordinateInput!) {\n\t\t\t\t\t  locations(near: $location, first: 10, sortKey: DISTANCE) {\n\t\t\t\t\t\tedges {\n\t\t\t\t\t\t  node {\n\t\t\t\t\t\t\tname\n\t\t\t\t\t\t\taddress {\n\t\t\t\t\t\t\t  city\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t  }\n\t\t\t\t\t\t}\n\t\t\t\t\t  }\n\t\t\t\t\t}\n\t\t\t\t  ",
               variables: {
                 location: this.locationUser
               }
             })
           });

         case 2:
           response = _context.sent;
           _context.next = 5;
           return response.json();

         case 5:
           return _context.abrupt("return", _context.sent);

         case 6:
         case "end":
           return _context.stop();
       }
     }
   }, _callee, this);
 }));
 PreferredStore.prototype.allStoresName = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
   var _graphStores$data, _graphStores$data$loc;

   var graphStores, edgesStores, stores;
   return regeneratorRuntime.wrap(function _callee2$(_context2) {
     while (1) {
       switch (_context2.prev = _context2.next) {
         case 0:
           _context2.next = 2;
           return this.getStores();

         case 2:
           graphStores = _context2.sent;
           edgesStores = graphStores === null || graphStores === void 0 ? void 0 : (_graphStores$data = graphStores.data) === null || _graphStores$data === void 0 ? void 0 : (_graphStores$data$loc = _graphStores$data.locations) === null || _graphStores$data$loc === void 0 ? void 0 : _graphStores$data$loc.edges;
           stores = [];

           if (edgesStores) {
             edgesStores.forEach(function (store) {
               var _store$node;

               var name = store === null || store === void 0 ? void 0 : (_store$node = store.node) === null || _store$node === void 0 ? void 0 : _store$node.name;
               if (name) stores.push(name);
             });
           }

           return _context2.abrupt("return", stores);

         case 7:
         case "end":
           return _context2.stop();
       }
     }
   }, _callee2, this);
 }));
 PreferredStore.prototype.updateSelect = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
   var _this2 = this;

   var storesName, options;
   return regeneratorRuntime.wrap(function _callee3$(_context3) {
     while (1) {
       switch (_context3.prev = _context3.next) {
         case 0:
           _context3.next = 2;
           return this.allStoresName();

         case 2:
           storesName = _context3.sent;
           options = "";
           storesName.forEach(function (storeName) {
             options += "<option value=\"".concat(storeName, "\" ").concat(_this2.preferredStore && _this2.preferredStore === storeName ? " selected" : "", ">").concat(storeName, "</option>");
           });
           this.select.innerHTML = options;

         case 6:
         case "end":
           return _context3.stop();
       }
     }
   }, _callee3, this);
 }));

 PreferredStore.prototype.eventChangeSelect = function () {
   this.select.addEventListener("change", function (e) {
     localStorage.setItem(parameters.variableStore, e.target.value);
   });
 };

 function initPreferredStore() {
   var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : selectors.wrapper;
   var containers = document.querySelectorAll(selector);

   if (!containers.length) {
     return;
   }

   Array.from(containers).filter(function (element) {
     return !element.classList.contains(modification.available);
   }).forEach(function (element) {
     new PreferredStore(element);
     element.classList.add(modification.available);
   });
 }

 /***/ }),
 /* 143 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";

 // CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/scripts/vue/components/ProductCard.vue?vue&type=template&id=8144aca2&
 var render = function () {
   var _vm = this
   var _h = _vm.$createElement
   var _c = _vm._self._c || _h
   return _c("div", {
     attrs: { id: "recently_viewed_product_" + _vm.product.id },
   })
 }
 var staticRenderFns = []
 render._withStripped = true


 // CONCATENATED MODULE: ./src/scripts/vue/components/ProductCard.vue?vue&type=template&id=8144aca2&

 // EXTERNAL MODULE: ./node_modules/regenerator-runtime/runtime.js
 var runtime = __webpack_require__(16);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
 var es_object_to_string = __webpack_require__(3);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.promise.js
 var es_promise = __webpack_require__(14);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.for-each.js
 var web_dom_collections_for_each = __webpack_require__(8);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
 var es_function_name = __webpack_require__(63);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
 var es_array_concat = __webpack_require__(50);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.join.js
 var es_array_join = __webpack_require__(115);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.map.js
 var es_array_map = __webpack_require__(51);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.includes.js
 var es_array_includes = __webpack_require__(82);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.includes.js
 var es_string_includes = __webpack_require__(81);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.filter.js
 var es_array_filter = __webpack_require__(25);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.exec.js
 var es_regexp_exec = __webpack_require__(21);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.split.js
 var es_string_split = __webpack_require__(106);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
 var es_object_keys = __webpack_require__(40);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
 var es_symbol = __webpack_require__(29);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptor.js
 var es_object_get_own_property_descriptor = __webpack_require__(44);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptors.js
 var es_object_get_own_property_descriptors = __webpack_require__(43);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.replace.js
 var es_string_replace = __webpack_require__(54);

 // CONCATENATED MODULE: ./src/scripts/core/helpers/handeize.js


 function handleize(value) {
   value = value.toLowerCase();
   var toReplace = ['"', "'", "\\", "(", ")", "[", "]"]; // For the old browsers

   for (var i = 0; i < toReplace.length; ++i) {
     value = value.replace(toReplace[i], "");
   }

   value = value.replace(/\W+/g, "-");

   if (value.charAt(value.length - 1) === "-") {
     value = value.replace(/-+z/, "");
   }

   if (value.charAt(0) === "-") {
     value = value.replace(/A-+/, "");
   }

   return value;
 }
 // EXTERNAL MODULE: ./node_modules/@savchukoleksii/shopify-theme-settings-tool/src/index.js
 var src = __webpack_require__(61);

 // EXTERNAL MODULE: ./node_modules/@shopify/theme-images/images.js
 var theme_images_images = __webpack_require__(102);

 // CONCATENATED MODULE: ./src/scripts/vue/filters/mapFilters.js

 function mapFilters(filters) {
   return filters.reduce(function (result, filter) {
     result[filter] = function () {
       var _this$$options$filter;

       return (_this$$options$filter = this.$options.filters)[filter].apply(_this$$options$filter, arguments);
     };

     return result;
   }, {});
 }
 // EXTERNAL MODULE: ./node_modules/axios/index.js
 var axios = __webpack_require__(24);
 var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

 // EXTERNAL MODULE: ./node_modules/js-cookie/src/js.cookie.js
 var js_cookie = __webpack_require__(46);
 var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);

 // EXTERNAL MODULE: ./src/scripts/components/product-card.js
 var product_card = __webpack_require__(49);

 // EXTERNAL MODULE: ./src/icons/icon-check.svg
 var icon_check = __webpack_require__(231);
 var icon_check_default = /*#__PURE__*/__webpack_require__.n(icon_check);

 // CONCATENATED MODULE: ./node_modules/babel-loader/lib??ref--0!./node_modules/vue-loader/lib??vue-loader-options!./src/scripts/vue/components/ProductCard.vue?vue&type=script&lang=js&
 function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

 function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

 function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



















 function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

 function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //








 /* harmony default export */ var ProductCardvue_type_script_lang_js_ = ({
   name: 'ProductCard',
   props: {
     product: {
       type: Object,
       required: true
     },
     show_wishlist: {
       type: Boolean,
       default: true
     },
     show_quickview: {
       type: Boolean,
       default: true
     },
     show_reviews: {
       type: Boolean,
       default: true
     }
   },
   data: function data() {
     return {
       activePrice: 0,
       activeComparedAtPrice: 0,
       productView: false,
       products: [],
       titleProductActive: "",
       productId: 0
     };
   },
   created: function created() {
     var _this = this;

     return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
       var res, html;
       return regeneratorRuntime.wrap(function _callee$(_context) {
         while (1) {
           switch (_context.prev = _context.next) {
             case 0:
               if (!(_this.titleProductActive !== _this.product.title)) {
                 _context.next = 17;
                 break;
               }

               _this.titleProductActive = _this.product.title;
               _context.next = 4;
               return _this.getProducts(_this.product.handle);

             case 4:
               _this.products = _context.sent;
               _this.activePrice = _this.product.price;
               _this.productId = _this.product.id;
               _this.activeComparedAtPrice = _this.product.compared_at_price;

               _this.checkView();

               _context.next = 11;
               return fetch("/products/".concat(_this.product.handle, "?view=product-card"));

             case 11:
               res = _context.sent;
               _context.next = 14;
               return res.text();

             case 14:
               html = _context.sent;
               document.querySelector('#recently_viewed_product_' + _this.productId).innerHTML = html;
               Object(product_card["initProductCards"])();

             case 17:
             case "end":
               return _context.stop();
           }
         }
       }, _callee);
     }))();
   },
   updated: function updated() {
     var _this2 = this;

     return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
       return regeneratorRuntime.wrap(function _callee2$(_context2) {
         while (1) {
           switch (_context2.prev = _context2.next) {
             case 0:
               if (!(_this2.titleProductActive !== _this2.product.title)) {
                 _context2.next = 10;
                 break;
               }

               _this2.titleProductActive = _this2.product.title;
               _context2.next = 4;
               return _this2.getProducts(_this2.product.handle);

             case 4:
               _this2.products = _context2.sent;
               _this2.activePrice = _this2.product.price;
               _this2.productId = _this2.product.id;
               _this2.activeComparedAtPrice = _this2.product.compared_at_price;

               _this2.checkView();

               Object(product_card["initProductCards"])();

             case 10:
             case "end":
               return _context2.stop();
           }
         }
       }, _callee2);
     }))();
   },
   computed: {
     product_card_side_tag_image_alt: function product_card_side_tag_image_alt() {
       return src["a" /* default */].get("product_card_side_tag_image_alt");
     }
   },
   methods: _objectSpread(_objectSpread({}, mapFilters(["file_img_url", "money"])), {}, {
     getProducts: function getProducts(handle) {
       return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
         var response, html;
         return regeneratorRuntime.wrap(function _callee3$(_context3) {
           while (1) {
             switch (_context3.prev = _context3.next) {
               case 0:
                 _context3.next = 2;
                 return axios_default.a.get("/products/".concat(handle, "?view=object-json"));

               case 2:
                 response = _context3.sent.data;
                 html = document.createElement("div");
                 html.innerHTML = response;
                 return _context3.abrupt("return", JSON.parse(html.querySelector("[data-json-products-group-response]").innerHTML));

               case 6:
               case "end":
                 return _context3.stop();
             }
           }
         }, _callee3);
       }))();
     },
     firstImage: function firstImage(images) {
       var _images$;

       var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'master';
       return Object(theme_images_images["a" /* getSizedImageUrl */])((_images$ = images[0]) === null || _images$ === void 0 ? void 0 : _images$.src, size);
     },
     lastImage: function lastImage(images) {
       var _images$2, _images;

       var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'master';
       return Object(theme_images_images["a" /* getSizedImageUrl */])(((_images$2 = images[1]) === null || _images$2 === void 0 ? void 0 : _images$2.src) || ((_images = images[images.length - 1]) === null || _images === void 0 ? void 0 : _images.src), size);
     },
     groupIs: function groupIs() {
       var groupIs = false;
       this.product.tags.forEach(function (tag) {
         if (tag.toLowerCase().indexOf('ygroup_') === 0) groupIs = true;
       });
       return groupIs;
     },
     colors: function colors() {
       var colors = [];
       this.products.forEach(function (product) {
         var _product$images$;

         colors.push({
           productId: product.id,
           image: (_product$images$ = product.images[0]) === null || _product$images$ === void 0 ? void 0 : _product$images$.src,
           hex: product.colorHex,
           sku: product.colorSKU
         });
       });
       return colors;
     },
     sizes: function sizes() {
       var _this3 = this;

       var sizeHtmls = [];
       this.products.forEach(function (product) {
         var sizes = '';
         var optionParam = null;
         var size_found = false;
         product.options.forEach(function (opt, index) {
           if (opt.name == 'Size' || opt.name == 'Size(Womens Waders)' || opt.name == 'Size (Mens Waders)') {
             optionParam = "option".concat(index + 1);
             size_found = true;
           }

           if (size_found) {
             var html = "";
             html += "\n\t\t\t\t\t\t<ul class=\"product-card__sizes-list ".concat(product.id == _this3.product.id ? 'product-card__sizes-list--active' : '', "\" data-product-size=\"").concat(index, "\">\n\t\t\t\t\t\t\t").concat(product.variants.map(function (variant) {
               if (variant.available) {
                 return "\n\t\t\t\t\t\t\t\t\t\t<li class=\"product-card__sizes-item ".concat(!variant.available ? 'product-card__sizes-item--disabled' : '', "\" data-product-fastadd=\"").concat(variant.available, "\" data-product-handle=\"").concat(product.handle, "\" data-product-variant=\"").concat(variant.id, "\">\n\t\t\t\t\t\t\t\t\t\t\t<span>").concat(variant[optionParam], "</span>\n\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t");
               }
             }).join(''), "\n\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t");
             sizeHtmls.push(html);
           }
         });
       });
       return sizeHtmls.join('');
     },
     countColors: function countColors() {
       var countColor = 0;
       this.products.forEach(function (product) {
         product.options.forEach(function (option) {
           if (option === 'Color' || option === 'Colour') countColor += 1;
         });
       });
       if (countColor < 1) countColor = 1;
       return countColor;
     },
     changeColor: function changeColor(numColor) {
       this.productId = this.products[numColor].id;
       this.activePrice = this.products[numColor].price;
       this.activeComparedAtPrice = this.products[numColor].compared_at_price;
       this.checkView();
     },
     icons: function icons() {
       var icons = [];
       this.products.forEach(function (product) {
         product.tags.forEach(function (tag) {
           if (tag.includes('picture:')) {
             var icon = tag.substr(8);
             if (!icons.includes(icon)) icons.push(icon);
           }
         });
       });
       return icons;
     },
     checkView: function checkView() {
       var recently_viewed = js_cookie_default.a.get("recently_viewed");
       var ids = recently_viewed.split(",").filter(function (id) {
         return id;
       }).map(function (id) {
         return +id;
       });
       this.productView = !!ids.includes(this.productId);
     }
   }),
   components: {
     IconCheck: icon_check_default.a
   }
 });
 // CONCATENATED MODULE: ./src/scripts/vue/components/ProductCard.vue?vue&type=script&lang=js&
  /* harmony default export */ var components_ProductCardvue_type_script_lang_js_ = (ProductCardvue_type_script_lang_js_);
 // EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
 var componentNormalizer = __webpack_require__(34);

 // CONCATENATED MODULE: ./src/scripts/vue/components/ProductCard.vue





 /* normalize component */

 var component = Object(componentNormalizer["a" /* default */])(
   components_ProductCardvue_type_script_lang_js_,
   render,
   staticRenderFns,
   false,
   null,
   null,
   null

 )

 component.options.__file = "src/scripts/vue/components/ProductCard.vue"
 /* harmony default export */ var ProductCard = __webpack_exports__["a"] = (component.exports);

 /***/ }),
 /* 144 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";
 __webpack_require__.r(__webpack_exports__);
 /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "initFilters", function() { return initFilters; });
 /* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3);
 /* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8);
 /* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_1__);
 /* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25);
 /* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2__);
 /* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73);
 /* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_3__);
 /* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27);
 /* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_4__);





 var selectors = {
   filter: {
     button: ".boost-pfs-filter-button",
     close: "boost-pfs-filter-option-collapsed"
   },
   option: {
     list: ".boost-pfs-filter-option-item-list",
     item: ".boost-pfs-filter-option-item",
     show: "filter-option--show"
   }
 };

 function Filters(container) {
   this.container = container;
   this.buttonToggle = this.container.querySelector(selectors.filter.button);

   if (!this.container.classList.contains(selectors.filter.close)) {
     this.activeOption();
   }

   this.initEvents();
 }

 Filters.prototype.initEvents = function () {
   var _this = this;

   this.buttonToggle.addEventListener("click", function () {
     var filterInOpen = !_this.container.classList.contains(selectors.filter.close);

     var optionItems = _this.container.querySelectorAll(selectors.option.item);

     if (filterInOpen) {
       optionItems.forEach(function (item, itemKey) {
         setTimeout(function () {
           item.classList.add(selectors.option.show);
         }, itemKey * 100);
       });
     } else {
       optionItems.forEach(function (item) {
         item.classList.remove(selectors.option.show);
       });
     }
   });
 };

 Filters.prototype.activeOption = function () {
   var optionItems = this.container.querySelectorAll(selectors.option.item);
   optionItems.forEach(function (item) {
     item.classList.add(selectors.option.show);
   });
 };

 function initFilters() {
   var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ".boost-pfs-filter-option";
   var containers = document.querySelectorAll(selector);

   if (!containers.length) {
     return;
   }

   Array.from(containers).filter(function (element) {
     return !element.classList.contains("filters--initialized");
   }).forEach(function (element) {
     new Filters(element);
     element.classList.add("filters--initialized");
   });
 }
 /* harmony default export */ __webpack_exports__["default"] = (Filters);

 /***/ }),
 /* 145 */
 /***/ (function(module, exports, __webpack_require__) {

 var isCallable = __webpack_require__(11);
 var isObject = __webpack_require__(18);
 var setPrototypeOf = __webpack_require__(164);

 // makes subclassing work correct for wrapped built-ins
 module.exports = function ($this, dummy, Wrapper) {
   var NewTarget, NewTargetPrototype;
   if (
     // it can work only with native `setPrototypeOf`
     setPrototypeOf &&
     // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
     isCallable(NewTarget = dummy.constructor) &&
     NewTarget !== Wrapper &&
     isObject(NewTargetPrototype = NewTarget.prototype) &&
     NewTargetPrototype !== Wrapper.prototype
   ) setPrototypeOf($this, NewTargetPrototype);
   return $this;
 };


 /***/ }),
 /* 146 */
 /***/ (function(module, exports, __webpack_require__) {

 "use strict";

 // TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`
 __webpack_require__(31);
 var $ = __webpack_require__(13);
 var global = __webpack_require__(2);
 var getBuiltIn = __webpack_require__(33);
 var call = __webpack_require__(22);
 var uncurryThis = __webpack_require__(5);
 var USE_NATIVE_URL = __webpack_require__(302);
 var redefine = __webpack_require__(32);
 var redefineAll = __webpack_require__(165);
 var setToStringTag = __webpack_require__(108);
 var createIteratorConstructor = __webpack_require__(210);
 var InternalStateModule = __webpack_require__(53);
 var anInstance = __webpack_require__(136);
 var isCallable = __webpack_require__(11);
 var hasOwn = __webpack_require__(19);
 var bind = __webpack_require__(64);
 var classof = __webpack_require__(75);
 var anObject = __webpack_require__(17);
 var isObject = __webpack_require__(18);
 var $toString = __webpack_require__(28);
 var create = __webpack_require__(55);
 var createPropertyDescriptor = __webpack_require__(67);
 var getIterator = __webpack_require__(161);
 var getIteratorMethod = __webpack_require__(135);
 var wellKnownSymbol = __webpack_require__(12);
 var arraySort = __webpack_require__(187);

 var ITERATOR = wellKnownSymbol('iterator');
 var URL_SEARCH_PARAMS = 'URLSearchParams';
 var URL_SEARCH_PARAMS_ITERATOR = URL_SEARCH_PARAMS + 'Iterator';
 var setInternalState = InternalStateModule.set;
 var getInternalParamsState = InternalStateModule.getterFor(URL_SEARCH_PARAMS);
 var getInternalIteratorState = InternalStateModule.getterFor(URL_SEARCH_PARAMS_ITERATOR);

 var n$Fetch = getBuiltIn('fetch');
 var N$Request = getBuiltIn('Request');
 var Headers = getBuiltIn('Headers');
 var RequestPrototype = N$Request && N$Request.prototype;
 var HeadersPrototype = Headers && Headers.prototype;
 var RegExp = global.RegExp;
 var TypeError = global.TypeError;
 var decodeURIComponent = global.decodeURIComponent;
 var encodeURIComponent = global.encodeURIComponent;
 var charAt = uncurryThis(''.charAt);
 var join = uncurryThis([].join);
 var push = uncurryThis([].push);
 var replace = uncurryThis(''.replace);
 var shift = uncurryThis([].shift);
 var splice = uncurryThis([].splice);
 var split = uncurryThis(''.split);
 var stringSlice = uncurryThis(''.slice);

 var plus = /\+/g;
 var sequences = Array(4);

 var percentSequence = function (bytes) {
   return sequences[bytes - 1] || (sequences[bytes - 1] = RegExp('((?:%[\\da-f]{2}){' + bytes + '})', 'gi'));
 };

 var percentDecode = function (sequence) {
   try {
     return decodeURIComponent(sequence);
   } catch (error) {
     return sequence;
   }
 };

 var deserialize = function (it) {
   var result = replace(it, plus, ' ');
   var bytes = 4;
   try {
     return decodeURIComponent(result);
   } catch (error) {
     while (bytes) {
       result = replace(result, percentSequence(bytes--), percentDecode);
     }
     return result;
   }
 };

 var find = /[!'()~]|%20/g;

 var replacements = {
   '!': '%21',
   "'": '%27',
   '(': '%28',
   ')': '%29',
   '~': '%7E',
   '%20': '+'
 };

 var replacer = function (match) {
   return replacements[match];
 };

 var serialize = function (it) {
   return replace(encodeURIComponent(it), find, replacer);
 };

 var parseSearchParams = function (result, query) {
   if (query) {
     var attributes = split(query, '&');
     var index = 0;
     var attribute, entry;
     while (index < attributes.length) {
       attribute = attributes[index++];
       if (attribute.length) {
         entry = split(attribute, '=');
         push(result, {
           key: deserialize(shift(entry)),
           value: deserialize(join(entry, '='))
         });
       }
     }
   }
 };

 var updateSearchParams = function (query) {
   this.entries.length = 0;
   parseSearchParams(this.entries, query);
 };

 var validateArgumentsLength = function (passed, required) {
   if (passed < required) throw TypeError('Not enough arguments');
 };

 var URLSearchParamsIterator = createIteratorConstructor(function Iterator(params, kind) {
   setInternalState(this, {
     type: URL_SEARCH_PARAMS_ITERATOR,
     iterator: getIterator(getInternalParamsState(params).entries),
     kind: kind
   });
 }, 'Iterator', function next() {
   var state = getInternalIteratorState(this);
   var kind = state.kind;
   var step = state.iterator.next();
   var entry = step.value;
   if (!step.done) {
     step.value = kind === 'keys' ? entry.key : kind === 'values' ? entry.value : [entry.key, entry.value];
   } return step;
 });

 // `URLSearchParams` constructor
 // https://url.spec.whatwg.org/#interface-urlsearchparams
 var URLSearchParamsConstructor = function URLSearchParams(/* init */) {
   anInstance(this, URLSearchParamsPrototype);
   var init = arguments.length > 0 ? arguments[0] : undefined;
   var that = this;
   var entries = [];
   var iteratorMethod, iterator, next, step, entryIterator, entryNext, first, second, key;

   setInternalState(that, {
     type: URL_SEARCH_PARAMS,
     entries: entries,
     updateURL: function () { /* empty */ },
     updateSearchParams: updateSearchParams
   });

   if (init !== undefined) {
     if (isObject(init)) {
       iteratorMethod = getIteratorMethod(init);
       if (iteratorMethod) {
         iterator = getIterator(init, iteratorMethod);
         next = iterator.next;
         while (!(step = call(next, iterator)).done) {
           entryIterator = getIterator(anObject(step.value));
           entryNext = entryIterator.next;
           if (
             (first = call(entryNext, entryIterator)).done ||
             (second = call(entryNext, entryIterator)).done ||
             !call(entryNext, entryIterator).done
           ) throw TypeError('Expected sequence with length 2');
           push(entries, { key: $toString(first.value), value: $toString(second.value) });
         }
       } else for (key in init) if (hasOwn(init, key)) push(entries, { key: key, value: $toString(init[key]) });
     } else {
       parseSearchParams(
         entries,
         typeof init == 'string' ? charAt(init, 0) === '?' ? stringSlice(init, 1) : init : $toString(init)
       );
     }
   }
 };

 var URLSearchParamsPrototype = URLSearchParamsConstructor.prototype;

 redefineAll(URLSearchParamsPrototype, {
   // `URLSearchParams.prototype.append` method
   // https://url.spec.whatwg.org/#dom-urlsearchparams-append
   append: function append(name, value) {
     validateArgumentsLength(arguments.length, 2);
     var state = getInternalParamsState(this);
     push(state.entries, { key: $toString(name), value: $toString(value) });
     state.updateURL();
   },
   // `URLSearchParams.prototype.delete` method
   // https://url.spec.whatwg.org/#dom-urlsearchparams-delete
   'delete': function (name) {
     validateArgumentsLength(arguments.length, 1);
     var state = getInternalParamsState(this);
     var entries = state.entries;
     var key = $toString(name);
     var index = 0;
     while (index < entries.length) {
       if (entries[index].key === key) splice(entries, index, 1);
       else index++;
     }
     state.updateURL();
   },
   // `URLSearchParams.prototype.get` method
   // https://url.spec.whatwg.org/#dom-urlsearchparams-get
   get: function get(name) {
     validateArgumentsLength(arguments.length, 1);
     var entries = getInternalParamsState(this).entries;
     var key = $toString(name);
     var index = 0;
     for (; index < entries.length; index++) {
       if (entries[index].key === key) return entries[index].value;
     }
     return null;
   },
   // `URLSearchParams.prototype.getAll` method
   // https://url.spec.whatwg.org/#dom-urlsearchparams-getall
   getAll: function getAll(name) {
     validateArgumentsLength(arguments.length, 1);
     var entries = getInternalParamsState(this).entries;
     var key = $toString(name);
     var result = [];
     var index = 0;
     for (; index < entries.length; index++) {
       if (entries[index].key === key) push(result, entries[index].value);
     }
     return result;
   },
   // `URLSearchParams.prototype.has` method
   // https://url.spec.whatwg.org/#dom-urlsearchparams-has
   has: function has(name) {
     validateArgumentsLength(arguments.length, 1);
     var entries = getInternalParamsState(this).entries;
     var key = $toString(name);
     var index = 0;
     while (index < entries.length) {
       if (entries[index++].key === key) return true;
     }
     return false;
   },
   // `URLSearchParams.prototype.set` method
   // https://url.spec.whatwg.org/#dom-urlsearchparams-set
   set: function set(name, value) {
     validateArgumentsLength(arguments.length, 1);
     var state = getInternalParamsState(this);
     var entries = state.entries;
     var found = false;
     var key = $toString(name);
     var val = $toString(value);
     var index = 0;
     var entry;
     for (; index < entries.length; index++) {
       entry = entries[index];
       if (entry.key === key) {
         if (found) splice(entries, index--, 1);
         else {
           found = true;
           entry.value = val;
         }
       }
     }
     if (!found) push(entries, { key: key, value: val });
     state.updateURL();
   },
   // `URLSearchParams.prototype.sort` method
   // https://url.spec.whatwg.org/#dom-urlsearchparams-sort
   sort: function sort() {
     var state = getInternalParamsState(this);
     arraySort(state.entries, function (a, b) {
       return a.key > b.key ? 1 : -1;
     });
     state.updateURL();
   },
   // `URLSearchParams.prototype.forEach` method
   forEach: function forEach(callback /* , thisArg */) {
     var entries = getInternalParamsState(this).entries;
     var boundFunction = bind(callback, arguments.length > 1 ? arguments[1] : undefined);
     var index = 0;
     var entry;
     while (index < entries.length) {
       entry = entries[index++];
       boundFunction(entry.value, entry.key, this);
     }
   },
   // `URLSearchParams.prototype.keys` method
   keys: function keys() {
     return new URLSearchParamsIterator(this, 'keys');
   },
   // `URLSearchParams.prototype.values` method
   values: function values() {
     return new URLSearchParamsIterator(this, 'values');
   },
   // `URLSearchParams.prototype.entries` method
   entries: function entries() {
     return new URLSearchParamsIterator(this, 'entries');
   }
 }, { enumerable: true });

 // `URLSearchParams.prototype[@@iterator]` method
 redefine(URLSearchParamsPrototype, ITERATOR, URLSearchParamsPrototype.entries, { name: 'entries' });

 // `URLSearchParams.prototype.toString` method
 // https://url.spec.whatwg.org/#urlsearchparams-stringification-behavior
 redefine(URLSearchParamsPrototype, 'toString', function toString() {
   var entries = getInternalParamsState(this).entries;
   var result = [];
   var index = 0;
   var entry;
   while (index < entries.length) {
     entry = entries[index++];
     push(result, serialize(entry.key) + '=' + serialize(entry.value));
   } return join(result, '&');
 }, { enumerable: true });

 setToStringTag(URLSearchParamsConstructor, URL_SEARCH_PARAMS);

 $({ global: true, forced: !USE_NATIVE_URL }, {
   URLSearchParams: URLSearchParamsConstructor
 });

 // Wrap `fetch` and `Request` for correct work with polyfilled `URLSearchParams`
 if (!USE_NATIVE_URL && isCallable(Headers)) {
   var headersHas = uncurryThis(HeadersPrototype.has);
   var headersSet = uncurryThis(HeadersPrototype.set);

   var wrapRequestOptions = function (init) {
     if (isObject(init)) {
       var body = init.body;
       var headers;
       if (classof(body) === URL_SEARCH_PARAMS) {
         headers = init.headers ? new Headers(init.headers) : new Headers();
         if (!headersHas(headers, 'content-type')) {
           headersSet(headers, 'content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
         }
         return create(init, {
           body: createPropertyDescriptor(0, $toString(body)),
           headers: createPropertyDescriptor(0, headers)
         });
       }
     } return init;
   };

   if (isCallable(n$Fetch)) {
     $({ global: true, enumerable: true, forced: true }, {
       fetch: function fetch(input /* , init */) {
         return n$Fetch(input, arguments.length > 1 ? wrapRequestOptions(arguments[1]) : {});
       }
     });
   }

   if (isCallable(N$Request)) {
     var RequestConstructor = function Request(input /* , init */) {
       anInstance(this, RequestPrototype);
       return new N$Request(input, arguments.length > 1 ? wrapRequestOptions(arguments[1]) : {});
     };

     RequestPrototype.constructor = RequestConstructor;
     RequestConstructor.prototype = RequestPrototype;

     $({ global: true, forced: true }, {
       Request: RequestConstructor
     });
   }
 }

 module.exports = {
   URLSearchParams: URLSearchParamsConstructor,
   getState: getInternalParamsState
 };


 /***/ }),
 /* 147 */
 /***/ (function(module, exports, __webpack_require__) {

 "use strict";


 var replace = String.prototype.replace;
 var percentTwenties = /%20/g;

 var Format = {
     RFC1738: 'RFC1738',
     RFC3986: 'RFC3986'
 };

 module.exports = {
     'default': Format.RFC3986,
     formatters: {
         RFC1738: function (value) {
             return replace.call(value, percentTwenties, '+');
         },
         RFC3986: function (value) {
             return String(value);
         }
     },
     RFC1738: Format.RFC1738,
     RFC3986: Format.RFC3986
 };


 /***/ }),
 /* 148 */
 /***/ (function(module, exports, __webpack_require__) {

 "use strict";


 var implementation = __webpack_require__(334);

 module.exports = Function.prototype.bind || implementation;


 /***/ }),
 /* 149 */
 /***/ (function(module, exports, __webpack_require__) {

 "use strict";


 var undefined;

 var $SyntaxError = SyntaxError;
 var $Function = Function;
 var $TypeError = TypeError;

 // eslint-disable-next-line consistent-return
 var getEvalledConstructor = function (expressionSyntax) {
   try {
     return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
   } catch (e) {}
 };

 var $gOPD = Object.getOwnPropertyDescriptor;
 if ($gOPD) {
   try {
     $gOPD({}, '');
   } catch (e) {
     $gOPD = null; // this is IE 8, which has a broken gOPD
   }
 }

 var throwTypeError = function () {
   throw new $TypeError();
 };
 var ThrowTypeError = $gOPD
   ? (function () {
     try {
       // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
       arguments.callee; // IE 8 does not throw here
       return throwTypeError;
     } catch (calleeThrows) {
       try {
         // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
         return $gOPD(arguments, 'callee').get;
       } catch (gOPDthrows) {
         return throwTypeError;
       }
     }
   }())
   : throwTypeError;

 var hasSymbols = __webpack_require__(336)();

 var getProto = Object.getPrototypeOf || function (x) { return x.__proto__; }; // eslint-disable-line no-proto

 var needsEval = {};

 var TypedArray = typeof Uint8Array === 'undefined' ? undefined : getProto(Uint8Array);

 var INTRINSICS = {
   '%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
   '%Array%': Array,
   '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
   '%ArrayIteratorPrototype%': hasSymbols ? getProto([][Symbol.iterator]()) : undefined,
   '%AsyncFromSyncIteratorPrototype%': undefined,
   '%AsyncFunction%': needsEval,
   '%AsyncGenerator%': needsEval,
   '%AsyncGeneratorFunction%': needsEval,
   '%AsyncIteratorPrototype%': needsEval,
   '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
   '%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
   '%Boolean%': Boolean,
   '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
   '%Date%': Date,
   '%decodeURI%': decodeURI,
   '%decodeURIComponent%': decodeURIComponent,
   '%encodeURI%': encodeURI,
   '%encodeURIComponent%': encodeURIComponent,
   '%Error%': Error,
   '%eval%': eval, // eslint-disable-line no-eval
   '%EvalError%': EvalError,
   '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
   '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
   '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
   '%Function%': $Function,
   '%GeneratorFunction%': needsEval,
   '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
   '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
   '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
   '%isFinite%': isFinite,
   '%isNaN%': isNaN,
   '%IteratorPrototype%': hasSymbols ? getProto(getProto([][Symbol.iterator]())) : undefined,
   '%JSON%': typeof JSON === 'object' ? JSON : undefined,
   '%Map%': typeof Map === 'undefined' ? undefined : Map,
   '%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols ? undefined : getProto(new Map()[Symbol.iterator]()),
   '%Math%': Math,
   '%Number%': Number,
   '%Object%': Object,
   '%parseFloat%': parseFloat,
   '%parseInt%': parseInt,
   '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
   '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
   '%RangeError%': RangeError,
   '%ReferenceError%': ReferenceError,
   '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
   '%RegExp%': RegExp,
   '%Set%': typeof Set === 'undefined' ? undefined : Set,
   '%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols ? undefined : getProto(new Set()[Symbol.iterator]()),
   '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
   '%String%': String,
   '%StringIteratorPrototype%': hasSymbols ? getProto(''[Symbol.iterator]()) : undefined,
   '%Symbol%': hasSymbols ? Symbol : undefined,
   '%SyntaxError%': $SyntaxError,
   '%ThrowTypeError%': ThrowTypeError,
   '%TypedArray%': TypedArray,
   '%TypeError%': $TypeError,
   '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
   '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
   '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
   '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
   '%URIError%': URIError,
   '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
   '%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
   '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet
 };

 var doEval = function doEval(name) {
   var value;
   if (name === '%AsyncFunction%') {
     value = getEvalledConstructor('async function () {}');
   } else if (name === '%GeneratorFunction%') {
     value = getEvalledConstructor('function* () {}');
   } else if (name === '%AsyncGeneratorFunction%') {
     value = getEvalledConstructor('async function* () {}');
   } else if (name === '%AsyncGenerator%') {
     var fn = doEval('%AsyncGeneratorFunction%');
     if (fn) {
       value = fn.prototype;
     }
   } else if (name === '%AsyncIteratorPrototype%') {
     var gen = doEval('%AsyncGenerator%');
     if (gen) {
       value = getProto(gen.prototype);
     }
   }

   INTRINSICS[name] = value;

   return value;
 };

 var LEGACY_ALIASES = {
   '%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
   '%ArrayPrototype%': ['Array', 'prototype'],
   '%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
   '%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
   '%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
   '%ArrayProto_values%': ['Array', 'prototype', 'values'],
   '%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
   '%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
   '%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
   '%BooleanPrototype%': ['Boolean', 'prototype'],
   '%DataViewPrototype%': ['DataView', 'prototype'],
   '%DatePrototype%': ['Date', 'prototype'],
   '%ErrorPrototype%': ['Error', 'prototype'],
   '%EvalErrorPrototype%': ['EvalError', 'prototype'],
   '%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
   '%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
   '%FunctionPrototype%': ['Function', 'prototype'],
   '%Generator%': ['GeneratorFunction', 'prototype'],
   '%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
   '%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
   '%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
   '%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
   '%JSONParse%': ['JSON', 'parse'],
   '%JSONStringify%': ['JSON', 'stringify'],
   '%MapPrototype%': ['Map', 'prototype'],
   '%NumberPrototype%': ['Number', 'prototype'],
   '%ObjectPrototype%': ['Object', 'prototype'],
   '%ObjProto_toString%': ['Object', 'prototype', 'toString'],
   '%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
   '%PromisePrototype%': ['Promise', 'prototype'],
   '%PromiseProto_then%': ['Promise', 'prototype', 'then'],
   '%Promise_all%': ['Promise', 'all'],
   '%Promise_reject%': ['Promise', 'reject'],
   '%Promise_resolve%': ['Promise', 'resolve'],
   '%RangeErrorPrototype%': ['RangeError', 'prototype'],
   '%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
   '%RegExpPrototype%': ['RegExp', 'prototype'],
   '%SetPrototype%': ['Set', 'prototype'],
   '%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
   '%StringPrototype%': ['String', 'prototype'],
   '%SymbolPrototype%': ['Symbol', 'prototype'],
   '%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
   '%TypedArrayPrototype%': ['TypedArray', 'prototype'],
   '%TypeErrorPrototype%': ['TypeError', 'prototype'],
   '%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
   '%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
   '%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
   '%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
   '%URIErrorPrototype%': ['URIError', 'prototype'],
   '%WeakMapPrototype%': ['WeakMap', 'prototype'],
   '%WeakSetPrototype%': ['WeakSet', 'prototype']
 };

 var bind = __webpack_require__(148);
 var hasOwn = __webpack_require__(333);
 var $concat = bind.call(Function.call, Array.prototype.concat);
 var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
 var $replace = bind.call(Function.call, String.prototype.replace);
 var $strSlice = bind.call(Function.call, String.prototype.slice);

 /* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
 var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
 var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
 var stringToPath = function stringToPath(string) {
   var first = $strSlice(string, 0, 1);
   var last = $strSlice(string, -1);
   if (first === '%' && last !== '%') {
     throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
   } else if (last === '%' && first !== '%') {
     throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
   }
   var result = [];
   $replace(string, rePropName, function (match, number, quote, subString) {
     result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
   });
   return result;
 };
 /* end adaptation */

 var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
   var intrinsicName = name;
   var alias;
   if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
     alias = LEGACY_ALIASES[intrinsicName];
     intrinsicName = '%' + alias[0] + '%';
   }

   if (hasOwn(INTRINSICS, intrinsicName)) {
     var value = INTRINSICS[intrinsicName];
     if (value === needsEval) {
       value = doEval(intrinsicName);
     }
     if (typeof value === 'undefined' && !allowMissing) {
       throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
     }

     return {
       alias: alias,
       name: intrinsicName,
       value: value
     };
   }

   throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
 };

 module.exports = function GetIntrinsic(name, allowMissing) {
   if (typeof name !== 'string' || name.length === 0) {
     throw new $TypeError('intrinsic name must be a non-empty string');
   }
   if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
     throw new $TypeError('"allowMissing" argument must be a boolean');
   }

   var parts = stringToPath(name);
   var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

   var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
   var intrinsicRealName = intrinsic.name;
   var value = intrinsic.value;
   var skipFurtherCaching = false;

   var alias = intrinsic.alias;
   if (alias) {
     intrinsicBaseName = alias[0];
     $spliceApply(parts, $concat([0, 1], alias));
   }

   for (var i = 1, isOwn = true; i < parts.length; i += 1) {
     var part = parts[i];
     var first = $strSlice(part, 0, 1);
     var last = $strSlice(part, -1);
     if (
       (
         (first === '"' || first === "'" || first === '`')
         || (last === '"' || last === "'" || last === '`')
       )
       && first !== last
     ) {
       throw new $SyntaxError('property names with quotes must have matching quotes');
     }
     if (part === 'constructor' || !isOwn) {
       skipFurtherCaching = true;
     }

     intrinsicBaseName += '.' + part;
     intrinsicRealName = '%' + intrinsicBaseName + '%';

     if (hasOwn(INTRINSICS, intrinsicRealName)) {
       value = INTRINSICS[intrinsicRealName];
     } else if (value != null) {
       if (!(part in value)) {
         if (!allowMissing) {
           throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
         }
         return void undefined;
       }
       if ($gOPD && (i + 1) >= parts.length) {
         var desc = $gOPD(value, part);
         isOwn = !!desc;

         // By convention, when a data property is converted to an accessor
         // property to emulate a data property that does not suffer from
         // the override mistake, that accessor's getter is marked with
         // an `originalValue` property. Here, when we detect this, we
         // uphold the illusion by pretending to see that original data
         // property, i.e., returning the value rather than the getter
         // itself.
         if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
           value = desc.get;
         } else {
           value = value[part];
         }
       } else {
         isOwn = hasOwn(value, part);
         value = value[part];
       }

       if (isOwn && !skipFurtherCaching) {
         INTRINSICS[intrinsicRealName] = value;
       }
     }
   }
   return value;
 };


 /***/ }),
 /* 150 */
 /***/ (function(module, exports, __webpack_require__) {

 "use strict";

 var fails = __webpack_require__(10);

 module.exports = function (METHOD_NAME, argument) {
   var method = [][METHOD_NAME];
   return !!method && fails(function () {
     // eslint-disable-next-line no-useless-call,no-throw-literal -- required for testing
     method.call(null, argument || function () { throw 1; }, 1);
   });
 };


 /***/ }),
 /* 151 */
 /***/ (function(module, exports, __webpack_require__) {

 var global = __webpack_require__(2);
 var isArray = __webpack_require__(105);
 var isConstructor = __webpack_require__(107);
 var isObject = __webpack_require__(18);
 var wellKnownSymbol = __webpack_require__(12);

 var SPECIES = wellKnownSymbol('species');
 var Array = global.Array;

 // a part of `ArraySpeciesCreate` abstract operation
 // https://tc39.es/ecma262/#sec-arrayspeciescreate
 module.exports = function (originalArray) {
   var C;
   if (isArray(originalArray)) {
     C = originalArray.constructor;
     // cross-realm fallback
     if (isConstructor(C) && (C === Array || isArray(C.prototype))) C = undefined;
     else if (isObject(C)) {
       C = C[SPECIES];
       if (C === null) C = undefined;
     }
   } return C === undefined ? Array : C;
 };


 /***/ }),
 /* 152 */
 /***/ (function(module, exports, __webpack_require__) {

 "use strict";
 /* WEBPACK VAR INJECTION */(function(process) {

 var utils = __webpack_require__(45);
 var normalizeHeaderName = __webpack_require__(355);
 var enhanceError = __webpack_require__(200);

 var DEFAULT_CONTENT_TYPE = {
   'Content-Type': 'application/x-www-form-urlencoded'
 };

 function setContentTypeIfUnset(headers, value) {
   if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
     headers['Content-Type'] = value;
   }
 }

 function getDefaultAdapter() {
   var adapter;
   if (typeof XMLHttpRequest !== 'undefined') {
     // For browsers use XHR adapter
     adapter = __webpack_require__(199);
   } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
     // For node use HTTP adapter
     adapter = __webpack_require__(199);
   }
   return adapter;
 }

 function stringifySafely(rawValue, parser, encoder) {
   if (utils.isString(rawValue)) {
     try {
       (parser || JSON.parse)(rawValue);
       return utils.trim(rawValue);
     } catch (e) {
       if (e.name !== 'SyntaxError') {
         throw e;
       }
     }
   }

   return (encoder || JSON.stringify)(rawValue);
 }

 var defaults = {

   transitional: {
     silentJSONParsing: true,
     forcedJSONParsing: true,
     clarifyTimeoutError: false
   },

   adapter: getDefaultAdapter(),

   transformRequest: [function transformRequest(data, headers) {
     normalizeHeaderName(headers, 'Accept');
     normalizeHeaderName(headers, 'Content-Type');

     if (utils.isFormData(data) ||
       utils.isArrayBuffer(data) ||
       utils.isBuffer(data) ||
       utils.isStream(data) ||
       utils.isFile(data) ||
       utils.isBlob(data)
     ) {
       return data;
     }
     if (utils.isArrayBufferView(data)) {
       return data.buffer;
     }
     if (utils.isURLSearchParams(data)) {
       setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
       return data.toString();
     }
     if (utils.isObject(data) || (headers && headers['Content-Type'] === 'application/json')) {
       setContentTypeIfUnset(headers, 'application/json');
       return stringifySafely(data);
     }
     return data;
   }],

   transformResponse: [function transformResponse(data) {
     var transitional = this.transitional;
     var silentJSONParsing = transitional && transitional.silentJSONParsing;
     var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
     var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';

     if (strictJSONParsing || (forcedJSONParsing && utils.isString(data) && data.length)) {
       try {
         return JSON.parse(data);
       } catch (e) {
         if (strictJSONParsing) {
           if (e.name === 'SyntaxError') {
             throw enhanceError(e, this, 'E_JSON_PARSE');
           }
           throw e;
         }
       }
     }

     return data;
   }],

   /**
    * A timeout in milliseconds to abort a request. If set to 0 (default) a
    * timeout is not created.
    */
   timeout: 0,

   xsrfCookieName: 'XSRF-TOKEN',
   xsrfHeaderName: 'X-XSRF-TOKEN',

   maxContentLength: -1,
   maxBodyLength: -1,

   validateStatus: function validateStatus(status) {
     return status >= 200 && status < 300;
   }
 };

 defaults.headers = {
   common: {
     'Accept': 'application/json, text/plain, */*'
   }
 };

 utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
   defaults.headers[method] = {};
 });

 utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
   defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
 });

 module.exports = defaults;

 /* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(155)))

 /***/ }),
 /* 153 */
 /***/ (function(module, exports, __webpack_require__) {

 "use strict";

 var charAt = __webpack_require__(207).charAt;

 // `AdvanceStringIndex` abstract operation
 // https://tc39.es/ecma262/#sec-advancestringindex
 module.exports = function (S, index, unicode) {
   return index + (unicode ? charAt(S, index).length : 1);
 };


 /***/ }),
 /* 154 */
 /***/ (function(module, exports, __webpack_require__) {

 var fails = __webpack_require__(10);
 var global = __webpack_require__(2);

 // babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
 var $RegExp = global.RegExp;

 exports.UNSUPPORTED_Y = fails(function () {
   var re = $RegExp('a', 'y');
   re.lastIndex = 2;
   return re.exec('abcd') != null;
 });

 exports.BROKEN_CARET = fails(function () {
   // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
   var re = $RegExp('^r', 'gy');
   re.lastIndex = 2;
   return re.exec('str') != null;
 });


 /***/ }),
 /* 155 */
 /***/ (function(module, exports) {

 // shim for using process in browser
 var process = module.exports = {};

 // cached from whatever global is present so that test runners that stub it
 // don't break things.  But we need to wrap it in a try catch in case it is
 // wrapped in strict mode code which doesn't define any globals.  It's inside a
 // function because try/catches deoptimize in certain engines.

 var cachedSetTimeout;
 var cachedClearTimeout;

 function defaultSetTimout() {
     throw new Error('setTimeout has not been defined');
 }
 function defaultClearTimeout () {
     throw new Error('clearTimeout has not been defined');
 }
 (function () {
     try {
         if (typeof setTimeout === 'function') {
             cachedSetTimeout = setTimeout;
         } else {
             cachedSetTimeout = defaultSetTimout;
         }
     } catch (e) {
         cachedSetTimeout = defaultSetTimout;
     }
     try {
         if (typeof clearTimeout === 'function') {
             cachedClearTimeout = clearTimeout;
         } else {
             cachedClearTimeout = defaultClearTimeout;
         }
     } catch (e) {
         cachedClearTimeout = defaultClearTimeout;
     }
 } ())
 function runTimeout(fun) {
     if (cachedSetTimeout === setTimeout) {
         //normal enviroments in sane situations
         return setTimeout(fun, 0);
     }
     // if setTimeout wasn't available but was latter defined
     if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
         cachedSetTimeout = setTimeout;
         return setTimeout(fun, 0);
     }
     try {
         // when when somebody has screwed with setTimeout but no I.E. maddness
         return cachedSetTimeout(fun, 0);
     } catch(e){
         try {
             // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
             return cachedSetTimeout.call(null, fun, 0);
         } catch(e){
             // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
             return cachedSetTimeout.call(this, fun, 0);
         }
     }


 }
 function runClearTimeout(marker) {
     if (cachedClearTimeout === clearTimeout) {
         //normal enviroments in sane situations
         return clearTimeout(marker);
     }
     // if clearTimeout wasn't available but was latter defined
     if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
         cachedClearTimeout = clearTimeout;
         return clearTimeout(marker);
     }
     try {
         // when when somebody has screwed with setTimeout but no I.E. maddness
         return cachedClearTimeout(marker);
     } catch (e){
         try {
             // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
             return cachedClearTimeout.call(null, marker);
         } catch (e){
             // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
             // Some versions of I.E. have different rules for clearTimeout vs setTimeout
             return cachedClearTimeout.call(this, marker);
         }
     }



 }
 var queue = [];
 var draining = false;
 var currentQueue;
 var queueIndex = -1;

 function cleanUpNextTick() {
     if (!draining || !currentQueue) {
         return;
     }
     draining = false;
     if (currentQueue.length) {
         queue = currentQueue.concat(queue);
     } else {
         queueIndex = -1;
     }
     if (queue.length) {
         drainQueue();
     }
 }

 function drainQueue() {
     if (draining) {
         return;
     }
     var timeout = runTimeout(cleanUpNextTick);
     draining = true;

     var len = queue.length;
     while(len) {
         currentQueue = queue;
         queue = [];
         while (++queueIndex < len) {
             if (currentQueue) {
                 currentQueue[queueIndex].run();
             }
         }
         queueIndex = -1;
         len = queue.length;
     }
     currentQueue = null;
     draining = false;
     runClearTimeout(timeout);
 }

 process.nextTick = function (fun) {
     var args = new Array(arguments.length - 1);
     if (arguments.length > 1) {
         for (var i = 1; i < arguments.length; i++) {
             args[i - 1] = arguments[i];
         }
     }
     queue.push(new Item(fun, args));
     if (queue.length === 1 && !draining) {
         runTimeout(drainQueue);
     }
 };

 // v8 likes predictible objects
 function Item(fun, array) {
     this.fun = fun;
     this.array = array;
 }
 Item.prototype.run = function () {
     this.fun.apply(null, this.array);
 };
 process.title = 'browser';
 process.browser = true;
 process.env = {};
 process.argv = [];
 process.version = ''; // empty string to avoid regexp issues
 process.versions = {};

 function noop() {}

 process.on = noop;
 process.addListener = noop;
 process.once = noop;
 process.off = noop;
 process.removeListener = noop;
 process.removeAllListeners = noop;
 process.emit = noop;
 process.prependListener = noop;
 process.prependOnceListener = noop;

 process.listeners = function (name) { return [] }

 process.binding = function (name) {
     throw new Error('process.binding is not supported');
 };

 process.cwd = function () { return '/' };
 process.chdir = function (dir) {
     throw new Error('process.chdir is not supported');
 };
 process.umask = function() { return 0; };


 /***/ }),
 /* 156 */
 /***/ (function(module, exports, __webpack_require__) {

 var global = __webpack_require__(2);
 var hasOwn = __webpack_require__(19);
 var isCallable = __webpack_require__(11);
 var toObject = __webpack_require__(42);
 var sharedKey = __webpack_require__(91);
 var CORRECT_PROTOTYPE_GETTER = __webpack_require__(208);

 var IE_PROTO = sharedKey('IE_PROTO');
 var Object = global.Object;
 var ObjectPrototype = Object.prototype;

 // `Object.getPrototypeOf` method
 // https://tc39.es/ecma262/#sec-object.getprototypeof
 module.exports = CORRECT_PROTOTYPE_GETTER ? Object.getPrototypeOf : function (O) {
   var object = toObject(O);
   if (hasOwn(object, IE_PROTO)) return object[IE_PROTO];
   var constructor = object.constructor;
   if (isCallable(constructor) && object instanceof constructor) {
     return constructor.prototype;
   } return object instanceof Object ? ObjectPrototype : null;
 };


 /***/ }),
 /* 157 */
 /***/ (function(module, exports, __webpack_require__) {

 "use strict";

 var $ = __webpack_require__(13);
 var call = __webpack_require__(22);
 var IS_PURE = __webpack_require__(60);
 var FunctionName = __webpack_require__(90);
 var isCallable = __webpack_require__(11);
 var createIteratorConstructor = __webpack_require__(210);
 var getPrototypeOf = __webpack_require__(156);
 var setPrototypeOf = __webpack_require__(164);
 var setToStringTag = __webpack_require__(108);
 var createNonEnumerableProperty = __webpack_require__(48);
 var redefine = __webpack_require__(32);
 var wellKnownSymbol = __webpack_require__(12);
 var Iterators = __webpack_require__(118);
 var IteratorsCore = __webpack_require__(209);

 var PROPER_FUNCTION_NAME = FunctionName.PROPER;
 var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
 var IteratorPrototype = IteratorsCore.IteratorPrototype;
 var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
 var ITERATOR = wellKnownSymbol('iterator');
 var KEYS = 'keys';
 var VALUES = 'values';
 var ENTRIES = 'entries';

 var returnThis = function () { return this; };

 module.exports = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
   createIteratorConstructor(IteratorConstructor, NAME, next);

   var getIterationMethod = function (KIND) {
     if (KIND === DEFAULT && defaultIterator) return defaultIterator;
     if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
     switch (KIND) {
       case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
       case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
       case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
     } return function () { return new IteratorConstructor(this); };
   };

   var TO_STRING_TAG = NAME + ' Iterator';
   var INCORRECT_VALUES_NAME = false;
   var IterablePrototype = Iterable.prototype;
   var nativeIterator = IterablePrototype[ITERATOR]
     || IterablePrototype['@@iterator']
     || DEFAULT && IterablePrototype[DEFAULT];
   var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
   var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
   var CurrentIteratorPrototype, methods, KEY;

   // fix native
   if (anyNativeIterator) {
     CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
     if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
       if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
         if (setPrototypeOf) {
           setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
         } else if (!isCallable(CurrentIteratorPrototype[ITERATOR])) {
           redefine(CurrentIteratorPrototype, ITERATOR, returnThis);
         }
       }
       // Set @@toStringTag to native iterators
       setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
       if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
     }
   }

   // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
   if (PROPER_FUNCTION_NAME && DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
     if (!IS_PURE && CONFIGURABLE_FUNCTION_NAME) {
       createNonEnumerableProperty(IterablePrototype, 'name', VALUES);
     } else {
       INCORRECT_VALUES_NAME = true;
       defaultIterator = function values() { return call(nativeIterator, this); };
     }
   }

   // export additional methods
   if (DEFAULT) {
     methods = {
       values: getIterationMethod(VALUES),
       keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
       entries: getIterationMethod(ENTRIES)
     };
     if (FORCED) for (KEY in methods) {
       if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
         redefine(IterablePrototype, KEY, methods[KEY]);
       }
     } else $({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
   }

   // define iterator
   if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) {
     redefine(IterablePrototype, ITERATOR, defaultIterator, { name: DEFAULT });
   }
   Iterators[NAME] = defaultIterator;

   return methods;
 };


 /***/ }),
 /* 158 */
 /***/ (function(module, exports, __webpack_require__) {

 var DESCRIPTORS = __webpack_require__(23);
 var definePropertyModule = __webpack_require__(26);
 var anObject = __webpack_require__(17);
 var toIndexedObject = __webpack_require__(30);
 var objectKeys = __webpack_require__(84);

 // `Object.defineProperties` method
 // https://tc39.es/ecma262/#sec-object.defineproperties
 // eslint-disable-next-line es/no-object-defineproperties -- safe
 module.exports = DESCRIPTORS ? Object.defineProperties : function defineProperties(O, Properties) {
   anObject(O);
   var props = toIndexedObject(Properties);
   var keys = objectKeys(Properties);
   var length = keys.length;
   var index = 0;
   var key;
   while (length > index) definePropertyModule.f(O, key = keys[index++], props[key]);
   return O;
 };


 /***/ }),
 /* 159 */
 /***/ (function(module, exports, __webpack_require__) {

 var classof = __webpack_require__(47);
 var global = __webpack_require__(2);

 module.exports = classof(global.process) == 'process';


 /***/ }),
 /* 160 */
 /***/ (function(module, exports, __webpack_require__) {

 var wellKnownSymbol = __webpack_require__(12);

 var ITERATOR = wellKnownSymbol('iterator');
 var SAFE_CLOSING = false;

 try {
   var called = 0;
   var iteratorWithReturn = {
     next: function () {
       return { done: !!called++ };
     },
     'return': function () {
       SAFE_CLOSING = true;
     }
   };
   iteratorWithReturn[ITERATOR] = function () {
     return this;
   };
   // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
   Array.from(iteratorWithReturn, function () { throw 2; });
 } catch (error) { /* empty */ }

 module.exports = function (exec, SKIP_CLOSING) {
   if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
   var ITERATION_SUPPORT = false;
   try {
     var object = {};
     object[ITERATOR] = function () {
       return {
         next: function () {
           return { done: ITERATION_SUPPORT = true };
         }
       };
     };
     exec(object);
   } catch (error) { /* empty */ }
   return ITERATION_SUPPORT;
 };


 /***/ }),
 /* 161 */
 /***/ (function(module, exports, __webpack_require__) {

 var global = __webpack_require__(2);
 var call = __webpack_require__(22);
 var aCallable = __webpack_require__(57);
 var anObject = __webpack_require__(17);
 var tryToString = __webpack_require__(110);
 var getIteratorMethod = __webpack_require__(135);

 var TypeError = global.TypeError;

 module.exports = function (argument, usingIterator) {
   var iteratorMethod = arguments.length < 2 ? getIteratorMethod(argument) : usingIterator;
   if (aCallable(iteratorMethod)) return anObject(call(iteratorMethod, argument));
   throw TypeError(tryToString(argument) + ' is not iterable');
 };


 /***/ }),
 /* 162 */
 /***/ (function(module, exports, __webpack_require__) {

 var global = __webpack_require__(2);
 var bind = __webpack_require__(64);
 var call = __webpack_require__(22);
 var anObject = __webpack_require__(17);
 var tryToString = __webpack_require__(110);
 var isArrayIteratorMethod = __webpack_require__(217);
 var lengthOfArrayLike = __webpack_require__(56);
 var isPrototypeOf = __webpack_require__(59);
 var getIterator = __webpack_require__(161);
 var getIteratorMethod = __webpack_require__(135);
 var iteratorClose = __webpack_require__(216);

 var TypeError = global.TypeError;

 var Result = function (stopped, result) {
   this.stopped = stopped;
   this.result = result;
 };

 var ResultPrototype = Result.prototype;

 module.exports = function (iterable, unboundFunction, options) {
   var that = options && options.that;
   var AS_ENTRIES = !!(options && options.AS_ENTRIES);
   var IS_ITERATOR = !!(options && options.IS_ITERATOR);
   var INTERRUPTED = !!(options && options.INTERRUPTED);
   var fn = bind(unboundFunction, that);
   var iterator, iterFn, index, length, result, next, step;

   var stop = function (condition) {
     if (iterator) iteratorClose(iterator, 'normal', condition);
     return new Result(true, condition);
   };

   var callFn = function (value) {
     if (AS_ENTRIES) {
       anObject(value);
       return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
     } return INTERRUPTED ? fn(value, stop) : fn(value);
   };

   if (IS_ITERATOR) {
     iterator = iterable;
   } else {
     iterFn = getIteratorMethod(iterable);
     if (!iterFn) throw TypeError(tryToString(iterable) + ' is not iterable');
     // optimisation for array iterators
     if (isArrayIteratorMethod(iterFn)) {
       for (index = 0, length = lengthOfArrayLike(iterable); length > index; index++) {
         result = callFn(iterable[index]);
         if (result && isPrototypeOf(ResultPrototype, result)) return result;
       } return new Result(false);
     }
     iterator = getIterator(iterable, iterFn);
   }

   next = iterator.next;
   while (!(step = call(next, iterator)).done) {
     try {
       result = callFn(step.value);
     } catch (error) {
       iteratorClose(iterator, 'throw', error);
     }
     if (typeof result == 'object' && result && isPrototypeOf(ResultPrototype, result)) return result;
   } return new Result(false);
 };


 /***/ }),
 /* 163 */
 /***/ (function(module, exports, __webpack_require__) {

 "use strict";

 var getBuiltIn = __webpack_require__(33);
 var definePropertyModule = __webpack_require__(26);
 var wellKnownSymbol = __webpack_require__(12);
 var DESCRIPTORS = __webpack_require__(23);

 var SPECIES = wellKnownSymbol('species');

 module.exports = function (CONSTRUCTOR_NAME) {
   var Constructor = getBuiltIn(CONSTRUCTOR_NAME);
   var defineProperty = definePropertyModule.f;

   if (DESCRIPTORS && Constructor && !Constructor[SPECIES]) {
     defineProperty(Constructor, SPECIES, {
       configurable: true,
       get: function () { return this; }
     });
   }
 };


 /***/ }),
 /* 164 */
 /***/ (function(module, exports, __webpack_require__) {

 /* eslint-disable no-proto -- safe */
 var uncurryThis = __webpack_require__(5);
 var anObject = __webpack_require__(17);
 var aPossiblePrototype = __webpack_require__(372);

 // `Object.setPrototypeOf` method
 // https://tc39.es/ecma262/#sec-object.setprototypeof
 // Works with __proto__ only. Old v8 can't work with null proto objects.
 // eslint-disable-next-line es/no-object-setprototypeof -- safe
 module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
   var CORRECT_SETTER = false;
   var test = {};
   var setter;
   try {
     // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
     setter = uncurryThis(Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set);
     setter(test, []);
     CORRECT_SETTER = test instanceof Array;
   } catch (error) { /* empty */ }
   return function setPrototypeOf(O, proto) {
     anObject(O);
     aPossiblePrototype(proto);
     if (CORRECT_SETTER) setter(O, proto);
     else O.__proto__ = proto;
     return O;
   };
 }() : undefined);


 /***/ }),
 /* 165 */
 /***/ (function(module, exports, __webpack_require__) {

 var redefine = __webpack_require__(32);

 module.exports = function (target, src, options) {
   for (var key in src) redefine(target, key, src[key], options);
   return target;
 };


 /***/ }),
 /* 166 */
 /***/ (function(module, exports, __webpack_require__) {

 "use strict";

 var TO_STRING_TAG_SUPPORT = __webpack_require__(100);
 var classof = __webpack_require__(75);

 // `Object.prototype.toString` method implementation
 // https://tc39.es/ecma262/#sec-object.prototype.tostring
 module.exports = TO_STRING_TAG_SUPPORT ? {}.toString : function toString() {
   return '[object ' + classof(this) + ']';
 };


 /***/ }),
 /* 167 */
 /***/ (function(module, exports, __webpack_require__) {

 var global = __webpack_require__(2);
 var isCallable = __webpack_require__(11);
 var inspectSource = __webpack_require__(76);

 var WeakMap = global.WeakMap;

 module.exports = isCallable(WeakMap) && /native code/.test(inspectSource(WeakMap));


 /***/ }),
 /* 168 */
 /***/ (function(module, exports, __webpack_require__) {

 var global = __webpack_require__(2);
 var call = __webpack_require__(22);
 var isCallable = __webpack_require__(11);
 var isObject = __webpack_require__(18);

 var TypeError = global.TypeError;

 // `OrdinaryToPrimitive` abstract operation
 // https://tc39.es/ecma262/#sec-ordinarytoprimitive
 module.exports = function (input, pref) {
   var fn, val;
   if (pref === 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
   if (isCallable(fn = input.valueOf) && !isObject(val = call(fn, input))) return val;
   if (pref !== 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
   throw TypeError("Can't convert object to primitive value");
 };


 /***/ }),
 /* 169 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";
 __webpack_require__.r(__webpack_exports__);

 // EXTERNAL MODULE: ./node_modules/@savchukoleksii/shopify-theme-settings-tool/src/index.js
 var src = __webpack_require__(61);

 // CONCATENATED MODULE: ./node_modules/@googlemaps/js-api-loader/dist/index.esm.js
 // do not edit .js files directly - edit src/index.jst



 var fastDeepEqual = function equal(a, b) {
   if (a === b) return true;

   if (a && b && typeof a == 'object' && typeof b == 'object') {
     if (a.constructor !== b.constructor) return false;

     var length, i, keys;
     if (Array.isArray(a)) {
       length = a.length;
       if (length != b.length) return false;
       for (i = length; i-- !== 0;)
         if (!equal(a[i], b[i])) return false;
       return true;
     }



     if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
     if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
     if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();

     keys = Object.keys(a);
     length = keys.length;
     if (length !== Object.keys(b).length) return false;

     for (i = length; i-- !== 0;)
       if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;

     for (i = length; i-- !== 0;) {
       var key = keys[i];

       if (!equal(a[key], b[key])) return false;
     }

     return true;
   }

   // true if both NaN, false otherwise
   return a!==a && b!==b;
 };

 /**
  * Copyright 2019 Google LLC. All Rights Reserved.
  *
  * Licensed under the Apache License, Version 2.0 (the "License");
  * you may not use this file except in compliance with the License.
  * You may obtain a copy of the License at.
  *
  *      Http://www.apache.org/licenses/LICENSE-2.0.
  *
  * Unless required by applicable law or agreed to in writing, software
  * distributed under the License is distributed on an "AS IS" BASIS,
  * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  * See the License for the specific language governing permissions and
  * limitations under the License.
  */
 const DEFAULT_ID = "__googleMapsScriptId";
 /**
  * The status of the [[Loader]].
  */
 var LoaderStatus;
 (function (LoaderStatus) {
     LoaderStatus[LoaderStatus["INITIALIZED"] = 0] = "INITIALIZED";
     LoaderStatus[LoaderStatus["LOADING"] = 1] = "LOADING";
     LoaderStatus[LoaderStatus["SUCCESS"] = 2] = "SUCCESS";
     LoaderStatus[LoaderStatus["FAILURE"] = 3] = "FAILURE";
 })(LoaderStatus || (LoaderStatus = {}));
 /**
  * [[Loader]] makes it easier to add Google Maps JavaScript API to your application
  * dynamically using
  * [Promises](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise).
  * It works by dynamically creating and appending a script node to the the
  * document head and wrapping the callback function so as to return a promise.
  *
  * ```
  * const loader = new Loader({
  *   apiKey: "",
  *   version: "weekly",
  *   libraries: ["places"]
  * });
  *
  * loader.load().then((google) => {
  *   const map = new google.maps.Map(...)
  * })
  * ```
  */
 class Loader {
     /**
      * Creates an instance of Loader using [[LoaderOptions]]. No defaults are set
      * using this library, instead the defaults are set by the Google Maps
      * JavaScript API server.
      *
      * ```
      * const loader = Loader({apiKey, version: 'weekly', libraries: ['places']});
      * ```
      */
     constructor({ apiKey, channel, client, id = DEFAULT_ID, libraries = [], language, region, version, mapIds, nonce, retries = 3, url = "https://maps.googleapis.com/maps/api/js", }) {
         this.CALLBACK = "__googleMapsCallback";
         this.callbacks = [];
         this.done = false;
         this.loading = false;
         this.errors = [];
         this.version = version;
         this.apiKey = apiKey;
         this.channel = channel;
         this.client = client;
         this.id = id || DEFAULT_ID; // Do not allow empty string
         this.libraries = libraries;
         this.language = language;
         this.region = region;
         this.mapIds = mapIds;
         this.nonce = nonce;
         this.retries = retries;
         this.url = url;
         if (Loader.instance) {
             if (!fastDeepEqual(this.options, Loader.instance.options)) {
                 throw new Error(`Loader must not be called again with different options. ${JSON.stringify(this.options)} !== ${JSON.stringify(Loader.instance.options)}`);
             }
             return Loader.instance;
         }
         Loader.instance = this;
     }
     get options() {
         return {
             version: this.version,
             apiKey: this.apiKey,
             channel: this.channel,
             client: this.client,
             id: this.id,
             libraries: this.libraries,
             language: this.language,
             region: this.region,
             mapIds: this.mapIds,
             nonce: this.nonce,
             url: this.url,
         };
     }
     get status() {
         if (this.errors.length) {
             return LoaderStatus.FAILURE;
         }
         if (this.done) {
             return LoaderStatus.SUCCESS;
         }
         if (this.loading) {
             return LoaderStatus.LOADING;
         }
         return LoaderStatus.INITIALIZED;
     }
     get failed() {
         return this.done && !this.loading && this.errors.length >= this.retries + 1;
     }
     /**
      * CreateUrl returns the Google Maps JavaScript API script url given the [[LoaderOptions]].
      *
      * @ignore
      */
     createUrl() {
         let url = this.url;
         url += `?callback=${this.CALLBACK}`;
         if (this.apiKey) {
             url += `&key=${this.apiKey}`;
         }
         if (this.channel) {
             url += `&channel=${this.channel}`;
         }
         if (this.client) {
             url += `&client=${this.client}`;
         }
         if (this.libraries.length > 0) {
             url += `&libraries=${this.libraries.join(",")}`;
         }
         if (this.language) {
             url += `&language=${this.language}`;
         }
         if (this.region) {
             url += `&region=${this.region}`;
         }
         if (this.version) {
             url += `&v=${this.version}`;
         }
         if (this.mapIds) {
             url += `&map_ids=${this.mapIds.join(",")}`;
         }
         return url;
     }
     deleteScript() {
         const script = document.getElementById(this.id);
         if (script) {
             script.remove();
         }
     }
     /**
      * Load the Google Maps JavaScript API script and return a Promise.
      */
     load() {
         return this.loadPromise();
     }
     /**
      * Load the Google Maps JavaScript API script and return a Promise.
      *
      * @ignore
      */
     loadPromise() {
         return new Promise((resolve, reject) => {
             this.loadCallback((err) => {
                 if (!err) {
                     resolve(window.google);
                 }
                 else {
                     reject(err.error);
                 }
             });
         });
     }
     /**
      * Load the Google Maps JavaScript API script with a callback.
      */
     loadCallback(fn) {
         this.callbacks.push(fn);
         this.execute();
     }
     /**
      * Set the script on document.
      */
     setScript() {
         if (document.getElementById(this.id)) {
             // TODO wrap onerror callback for cases where the script was loaded elsewhere
             this.callback();
             return;
         }
         const url = this.createUrl();
         const script = document.createElement("script");
         script.id = this.id;
         script.type = "text/javascript";
         script.src = url;
         script.onerror = this.loadErrorCallback.bind(this);
         script.defer = true;
         script.async = true;
         if (this.nonce) {
             script.nonce = this.nonce;
         }
         document.head.appendChild(script);
     }
     /**
      * Reset the loader state.
      */
     reset() {
         this.deleteScript();
         this.done = false;
         this.loading = false;
         this.errors = [];
         this.onerrorEvent = null;
     }
     resetIfRetryingFailed() {
         if (this.failed) {
             this.reset();
         }
     }
     loadErrorCallback(e) {
         this.errors.push(e);
         if (this.errors.length <= this.retries) {
             const delay = this.errors.length * Math.pow(2, this.errors.length);
             console.log(`Failed to load Google Maps script, retrying in ${delay} ms.`);
             setTimeout(() => {
                 this.deleteScript();
                 this.setScript();
             }, delay);
         }
         else {
             this.onerrorEvent = e;
             this.callback();
         }
     }
     setCallback() {
         window.__googleMapsCallback = this.callback.bind(this);
     }
     callback() {
         this.done = true;
         this.loading = false;
         this.callbacks.forEach((cb) => {
             cb(this.onerrorEvent);
         });
         this.callbacks = [];
     }
     execute() {
         this.resetIfRetryingFailed();
         if (this.done) {
             this.callback();
         }
         else {
             // short circuit and warn if google.maps is already loaded
             if (window.google && window.google.maps && window.google.maps.version) {
                 console.warn("Google Maps already loaded outside @googlemaps/js-api-loader." +
                     "This may result in undesirable behavior as options and script parameters may not match.");
                 this.callback();
                 return;
             }
             if (this.loading) ;
             else {
                 this.loading = true;
                 this.setCallback();
                 this.setScript();
             }
         }
     }
 }


 //# sourceMappingURL=index.esm.js.map

 // CONCATENATED MODULE: ./src/scripts/components/general/google-maps.js



 function initGoogleMapsApi() {
   var API_KEY_SETTING = "google_maps_api_key";
   var API_KEY = src["a" /* default */].get(API_KEY_SETTING);

   if (!API_KEY) {
     return null;
   }

   var loader = new Loader({
     apiKey: API_KEY
   });
   loader.load().then(function () {
     document.dispatchEvent(new CustomEvent("google:maps:loaded"));
   }).catch(function (error) {
     // eslint-disable-next-line
     console.error(error === null || error === void 0 ? void 0 : error.message);
   });
 }

 /* harmony default export */ var google_maps = __webpack_exports__["default"] = (initGoogleMapsApi);

 /***/ }),
 /* 170 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";
 __webpack_require__.r(__webpack_exports__);
 /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "initCustomerForm", function() { return initCustomerForm; });
 /* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3);
 /* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8);
 /* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_1__);
 /* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25);
 /* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2__);
 /* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73);
 /* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_3__);
 /* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27);
 /* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_4__);





 var selectors = {
   close: "[data-customer-addresses-close]"
 };
 var modifiers = {
   close: "address-form--close"
 };

 function CustomerForm(container) {
   this.container = container;
   this.body = document.querySelector("body");
   this.formId = this.container.dataset.customerAddresses;
   this.buttonsClose = this.container.querySelectorAll(selectors.close);
   this.initCloseForm();
   this.initOpenForm();
 }

 CustomerForm.prototype.initCloseForm = function () {
   var _this = this;

   this.buttonsClose.forEach(function (buttonClose) {
     buttonClose.addEventListener("click", function () {
       _this.body.style.overflow = "";

       _this.container.classList.add(modifiers.close);
     });
   });
 };

 CustomerForm.prototype.initOpenForm = function () {
   var _this2 = this;

   var openButtons = document.querySelectorAll("[data-customer-addresses-open=\"".concat(this.formId, "\"]"));
   openButtons.forEach(function (openButton) {
     openButton.addEventListener("click", function () {
       _this2.body.style.overflow = "hidden";

       _this2.container.classList.remove(modifiers.close);
     });
   });
 };

 function initCustomerForm() {
   var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ".address-form";
   var containers = document.querySelectorAll(selector);

   if (!containers.length) {
     return;
   }

   Array.from(containers).filter(function (element) {
     return !element.classList.contains("address-form--initialized");
   }).forEach(function (element) {
     new CustomerForm(element);
     element.classList.add("address-form--initialized");
   });
 }
 /* harmony default export */ __webpack_exports__["default"] = (CustomerForm);

 /***/ }),
 /* 171 */
 /***/ (function(module, exports, __webpack_require__) {

 "use strict";


 var stringify = __webpack_require__(338);
 var parse = __webpack_require__(328);
 var formats = __webpack_require__(147);

 module.exports = {
     formats: formats,
     parse: parse,
     stringify: stringify
 };


 /***/ }),
 /* 172 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";
 /* harmony import */ var _utils_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9);
 /* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6);
 function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



 var Navigation = {
   toggleEl: function toggleEl($el, disabled) {
     $el[disabled ? 'addClass' : 'removeClass'](this.params.navigation.disabledClass);
     if ($el[0] && $el[0].tagName === 'BUTTON') $el[0].disabled = disabled;
   },
   update: function update() {
     // Update Navigation Buttons
     var swiper = this;
     var params = swiper.params.navigation;
     var toggleEl = swiper.navigation.toggleEl;
     if (swiper.params.loop) return;
     var _swiper$navigation = swiper.navigation,
         $nextEl = _swiper$navigation.$nextEl,
         $prevEl = _swiper$navigation.$prevEl;

     if ($prevEl && $prevEl.length > 0) {
       if (swiper.isBeginning) {
         toggleEl($prevEl, true);
       } else {
         toggleEl($prevEl, false);
       }

       if (swiper.params.watchOverflow && swiper.enabled) {
         $prevEl[swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
       }
     }

     if ($nextEl && $nextEl.length > 0) {
       if (swiper.isEnd) {
         toggleEl($nextEl, true);
       } else {
         toggleEl($nextEl, false);
       }

       if (swiper.params.watchOverflow && swiper.enabled) {
         $nextEl[swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
       }
     }
   },
   onPrevClick: function onPrevClick(e) {
     var swiper = this;
     e.preventDefault();
     if (swiper.isBeginning && !swiper.params.loop) return;
     swiper.slidePrev();
   },
   onNextClick: function onNextClick(e) {
     var swiper = this;
     e.preventDefault();
     if (swiper.isEnd && !swiper.params.loop) return;
     swiper.slideNext();
   },
   init: function init() {
     var swiper = this;
     var params = swiper.params.navigation;
     swiper.params.navigation = Object(_utils_utils__WEBPACK_IMPORTED_MODULE_1__[/* createElementIfNotDefined */ "c"])(swiper.$el, swiper.params.navigation, swiper.params.createElements, {
       nextEl: 'swiper-button-next',
       prevEl: 'swiper-button-prev'
     });
     if (!(params.nextEl || params.prevEl)) return;
     var $nextEl;
     var $prevEl;

     if (params.nextEl) {
       $nextEl = Object(_utils_dom__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(params.nextEl);

       if (swiper.params.uniqueNavElements && typeof params.nextEl === 'string' && $nextEl.length > 1 && swiper.$el.find(params.nextEl).length === 1) {
         $nextEl = swiper.$el.find(params.nextEl);
       }
     }

     if (params.prevEl) {
       $prevEl = Object(_utils_dom__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(params.prevEl);

       if (swiper.params.uniqueNavElements && typeof params.prevEl === 'string' && $prevEl.length > 1 && swiper.$el.find(params.prevEl).length === 1) {
         $prevEl = swiper.$el.find(params.prevEl);
       }
     }

     if ($nextEl && $nextEl.length > 0) {
       $nextEl.on('click', swiper.navigation.onNextClick);
     }

     if ($prevEl && $prevEl.length > 0) {
       $prevEl.on('click', swiper.navigation.onPrevClick);
     }

     Object(_utils_utils__WEBPACK_IMPORTED_MODULE_1__[/* extend */ "e"])(swiper.navigation, {
       $nextEl: $nextEl,
       nextEl: $nextEl && $nextEl[0],
       $prevEl: $prevEl,
       prevEl: $prevEl && $prevEl[0]
     });

     if (!swiper.enabled) {
       if ($nextEl) $nextEl.addClass(params.lockClass);
       if ($prevEl) $prevEl.addClass(params.lockClass);
     }
   },
   destroy: function destroy() {
     var swiper = this;
     var _swiper$navigation2 = swiper.navigation,
         $nextEl = _swiper$navigation2.$nextEl,
         $prevEl = _swiper$navigation2.$prevEl;

     if ($nextEl && $nextEl.length) {
       $nextEl.off('click', swiper.navigation.onNextClick);
       $nextEl.removeClass(swiper.params.navigation.disabledClass);
     }

     if ($prevEl && $prevEl.length) {
       $prevEl.off('click', swiper.navigation.onPrevClick);
       $prevEl.removeClass(swiper.params.navigation.disabledClass);
     }
   }
 };
 /* harmony default export */ __webpack_exports__["a"] = ({
   name: 'navigation',
   params: {
     navigation: {
       nextEl: null,
       prevEl: null,
       hideOnClick: false,
       disabledClass: 'swiper-button-disabled',
       hiddenClass: 'swiper-button-hidden',
       lockClass: 'swiper-button-lock'
     }
   },
   create: function create() {
     var swiper = this;
     Object(_utils_utils__WEBPACK_IMPORTED_MODULE_1__[/* bindModuleMethods */ "a"])(swiper, {
       navigation: _extends({}, Navigation)
     });
   },
   on: {
     init: function init(swiper) {
       swiper.navigation.init();
       swiper.navigation.update();
     },
     toEdge: function toEdge(swiper) {
       swiper.navigation.update();
     },
     fromEdge: function fromEdge(swiper) {
       swiper.navigation.update();
     },
     destroy: function destroy(swiper) {
       swiper.navigation.destroy();
     },
     'enable disable': function enableDisable(swiper) {
       var _swiper$navigation3 = swiper.navigation,
           $nextEl = _swiper$navigation3.$nextEl,
           $prevEl = _swiper$navigation3.$prevEl;

       if ($nextEl) {
         $nextEl[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.navigation.lockClass);
       }

       if ($prevEl) {
         $prevEl[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.navigation.lockClass);
       }
     },
     click: function click(swiper, e) {
       var _swiper$navigation4 = swiper.navigation,
           $nextEl = _swiper$navigation4.$nextEl,
           $prevEl = _swiper$navigation4.$prevEl;
       var targetEl = e.target;

       if (swiper.params.navigation.hideOnClick && !Object(_utils_dom__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(targetEl).is($prevEl) && !Object(_utils_dom__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(targetEl).is($nextEl)) {
         if (swiper.pagination && swiper.params.pagination && swiper.params.pagination.clickable && (swiper.pagination.el === targetEl || swiper.pagination.el.contains(targetEl))) return;
         var isHidden;

         if ($nextEl) {
           isHidden = $nextEl.hasClass(swiper.params.navigation.hiddenClass);
         } else if ($prevEl) {
           isHidden = $prevEl.hasClass(swiper.params.navigation.hiddenClass);
         }

         if (isHidden === true) {
           swiper.emit('navigationShow');
         } else {
           swiper.emit('navigationHide');
         }

         if ($nextEl) {
           $nextEl.toggleClass(swiper.params.navigation.hiddenClass);
         }

         if ($prevEl) {
           $prevEl.toggleClass(swiper.params.navigation.hiddenClass);
         }
       }
     }
   }
 });

 /***/ }),
 /* 173 */
 /***/ (function(module, exports, __webpack_require__) {

 var $ = __webpack_require__(13);
 var uncurryThis = __webpack_require__(5);
 var hiddenKeys = __webpack_require__(66);
 var isObject = __webpack_require__(18);
 var hasOwn = __webpack_require__(19);
 var defineProperty = __webpack_require__(26).f;
 var getOwnPropertyNamesModule = __webpack_require__(74);
 var getOwnPropertyNamesExternalModule = __webpack_require__(190);
 var isExtensible = __webpack_require__(275);
 var uid = __webpack_require__(96);
 var FREEZING = __webpack_require__(273);

 var REQUIRED = false;
 var METADATA = uid('meta');
 var id = 0;

 var setMetadata = function (it) {
   defineProperty(it, METADATA, { value: {
     objectID: 'O' + id++, // object ID
     weakData: {}          // weak collections IDs
   } });
 };

 var fastKey = function (it, create) {
   // return a primitive with prefix
   if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
   if (!hasOwn(it, METADATA)) {
     // can't set metadata to uncaught frozen object
     if (!isExtensible(it)) return 'F';
     // not necessary to add metadata
     if (!create) return 'E';
     // add missing metadata
     setMetadata(it);
   // return object ID
   } return it[METADATA].objectID;
 };

 var getWeakData = function (it, create) {
   if (!hasOwn(it, METADATA)) {
     // can't set metadata to uncaught frozen object
     if (!isExtensible(it)) return true;
     // not necessary to add metadata
     if (!create) return false;
     // add missing metadata
     setMetadata(it);
   // return the store of weak collections IDs
   } return it[METADATA].weakData;
 };

 // add metadata on freeze-family methods calling
 var onFreeze = function (it) {
   if (FREEZING && REQUIRED && isExtensible(it) && !hasOwn(it, METADATA)) setMetadata(it);
   return it;
 };

 var enable = function () {
   meta.enable = function () { /* empty */ };
   REQUIRED = true;
   var getOwnPropertyNames = getOwnPropertyNamesModule.f;
   var splice = uncurryThis([].splice);
   var test = {};
   test[METADATA] = 1;

   // prevent exposing of metadata key
   if (getOwnPropertyNames(test).length) {
     getOwnPropertyNamesModule.f = function (it) {
       var result = getOwnPropertyNames(it);
       for (var i = 0, length = result.length; i < length; i++) {
         if (result[i] === METADATA) {
           splice(result, i, 1);
           break;
         }
       } return result;
     };

     $({ target: 'Object', stat: true, forced: true }, {
       getOwnPropertyNames: getOwnPropertyNamesExternalModule.f
     });
   }
 };

 var meta = module.exports = {
   enable: enable,
   fastKey: fastKey,
   getWeakData: getWeakData,
   onFreeze: onFreeze
 };

 hiddenKeys[METADATA] = true;


 /***/ }),
 /* 174 */
 /***/ (function(module, exports) {

 // a string of all valid unicode whitespaces
 module.exports = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002' +
   '\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


 /***/ }),
 /* 175 */
 /***/ (function(module, exports, __webpack_require__) {

 var uncurryThis = __webpack_require__(5);
 var requireObjectCoercible = __webpack_require__(37);
 var toString = __webpack_require__(28);
 var whitespaces = __webpack_require__(174);

 var replace = uncurryThis(''.replace);
 var whitespace = '[' + whitespaces + ']';
 var ltrim = RegExp('^' + whitespace + whitespace + '*');
 var rtrim = RegExp(whitespace + whitespace + '*$');

 // `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
 var createMethod = function (TYPE) {
   return function ($this) {
     var string = toString(requireObjectCoercible($this));
     if (TYPE & 1) string = replace(string, ltrim, '');
     if (TYPE & 2) string = replace(string, rtrim, '');
     return string;
   };
 };

 module.exports = {
   // `String.prototype.{ trimLeft, trimStart }` methods
   // https://tc39.es/ecma262/#sec-string.prototype.trimstart
   start: createMethod(1),
   // `String.prototype.{ trimRight, trimEnd }` methods
   // https://tc39.es/ecma262/#sec-string.prototype.trimend
   end: createMethod(2),
   // `String.prototype.trim` method
   // https://tc39.es/ecma262/#sec-string.prototype.trim
   trim: createMethod(3)
 };


 /***/ }),
 /* 176 */
 /***/ (function(module, exports, __webpack_require__) {

 "use strict";

 var DESCRIPTORS = __webpack_require__(23);
 var global = __webpack_require__(2);
 var uncurryThis = __webpack_require__(5);
 var isForced = __webpack_require__(86);
 var redefine = __webpack_require__(32);
 var hasOwn = __webpack_require__(19);
 var inheritIfRequired = __webpack_require__(145);
 var isPrototypeOf = __webpack_require__(59);
 var isSymbol = __webpack_require__(92);
 var toPrimitive = __webpack_require__(141);
 var fails = __webpack_require__(10);
 var getOwnPropertyNames = __webpack_require__(74).f;
 var getOwnPropertyDescriptor = __webpack_require__(52).f;
 var defineProperty = __webpack_require__(26).f;
 var thisNumberValue = __webpack_require__(186);
 var trim = __webpack_require__(175).trim;

 var NUMBER = 'Number';
 var NativeNumber = global[NUMBER];
 var NumberPrototype = NativeNumber.prototype;
 var TypeError = global.TypeError;
 var arraySlice = uncurryThis(''.slice);
 var charCodeAt = uncurryThis(''.charCodeAt);

 // `ToNumeric` abstract operation
 // https://tc39.es/ecma262/#sec-tonumeric
 var toNumeric = function (value) {
   var primValue = toPrimitive(value, 'number');
   return typeof primValue == 'bigint' ? primValue : toNumber(primValue);
 };

 // `ToNumber` abstract operation
 // https://tc39.es/ecma262/#sec-tonumber
 var toNumber = function (argument) {
   var it = toPrimitive(argument, 'number');
   var first, third, radix, maxCode, digits, length, index, code;
   if (isSymbol(it)) throw TypeError('Cannot convert a Symbol value to a number');
   if (typeof it == 'string' && it.length > 2) {
     it = trim(it);
     first = charCodeAt(it, 0);
     if (first === 43 || first === 45) {
       third = charCodeAt(it, 2);
       if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
     } else if (first === 48) {
       switch (charCodeAt(it, 1)) {
         case 66: case 98: radix = 2; maxCode = 49; break; // fast equal of /^0b[01]+$/i
         case 79: case 111: radix = 8; maxCode = 55; break; // fast equal of /^0o[0-7]+$/i
         default: return +it;
       }
       digits = arraySlice(it, 2);
       length = digits.length;
       for (index = 0; index < length; index++) {
         code = charCodeAt(digits, index);
         // parseInt parses a string to a first unavailable symbol
         // but ToNumber should return NaN if a string contains unavailable symbols
         if (code < 48 || code > maxCode) return NaN;
       } return parseInt(digits, radix);
     }
   } return +it;
 };

 // `Number` constructor
 // https://tc39.es/ecma262/#sec-number-constructor
 if (isForced(NUMBER, !NativeNumber(' 0o1') || !NativeNumber('0b1') || NativeNumber('+0x1'))) {
   var NumberWrapper = function Number(value) {
     var n = arguments.length < 1 ? 0 : NativeNumber(toNumeric(value));
     var dummy = this;
     // check on 1..constructor(foo) case
     return isPrototypeOf(NumberPrototype, dummy) && fails(function () { thisNumberValue(dummy); })
       ? inheritIfRequired(Object(n), dummy, NumberWrapper) : n;
   };
   for (var keys = DESCRIPTORS ? getOwnPropertyNames(NativeNumber) : (
     // ES3:
     'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
     // ES2015 (in case, if modules with ES2015 Number statics required before):
     'EPSILON,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,isFinite,isInteger,isNaN,isSafeInteger,parseFloat,parseInt,' +
     // ESNext
     'fromString,range'
   ).split(','), j = 0, key; keys.length > j; j++) {
     if (hasOwn(NativeNumber, key = keys[j]) && !hasOwn(NumberWrapper, key)) {
       defineProperty(NumberWrapper, key, getOwnPropertyDescriptor(NativeNumber, key));
     }
   }
   NumberWrapper.prototype = NumberPrototype;
   NumberPrototype.constructor = NumberWrapper;
   redefine(global, NUMBER, NumberWrapper);
 }


 /***/ }),
 /* 177 */
 /***/ (function(module, exports, __webpack_require__) {

 // TODO: Remove from `core-js@4`
 __webpack_require__(288);


 /***/ }),
 /* 178 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";
 __webpack_require__.r(__webpack_exports__);
 /* harmony import */ var _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
 /* harmony import */ var _components_slider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7);


 var selectors = {
   slider: "[data-slider-container]",
   arrowNext: "[data-slider-arrow-next]",
   arrowPrev: "[data-slider-arrow-prev]",
   pagination: "[data-slider-pagination]"
 };
 Object(_shopify_theme_sections__WEBPACK_IMPORTED_MODULE_0__[/* register */ "b"])("articles-slider", {
   slider: null,
   sliderContainer: null,
   options: {
     direction: "horizontal",
     loop: false,
     observer: true,
     observeParents: true,
     navigation: {
       nextEl: selectors.arrowNext,
       prevEl: selectors.arrowPrev
     },
     speed: 750
   },
   onLoad: function onLoad() {
     this.sliderContainer = this.container.querySelector(selectors.slider);

     if (!this.sliderContainer) {
       return null;
     }

     this.slider = new _components_slider__WEBPACK_IMPORTED_MODULE_1__["default"](this.sliderContainer, this.options);
   },
   onUnload: function onUnload() {
     if (!this.slider) {
       return null;
     }

     this.slider.destroy();
   }
 });

 /***/ }),
 /* 179 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";
 __webpack_require__.r(__webpack_exports__);
 /* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3);
 /* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8);
 /* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_1__);
 /* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14);
 /* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_2__);
 /* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31);
 /* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_3__);
 /* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27);
 /* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_4__);
 /* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41);
 /* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_5__);
 /* harmony import */ var regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(16);
 /* harmony import */ var regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_6__);
 /* harmony import */ var _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1);
 /* harmony import */ var _components_product_card__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(49);
 /* harmony import */ var _components_slider__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(7);








 function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

 function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }




 var selectors = {
   sliderContainer: "[data-nosto-slider]",
   sliderWrapper: "[data-nosto-slider-wrapper]",
   arrowNext: "[data-slider-arrow-next]",
   arrowPrev: "[data-slider-arrow-prev]"
 };
 var modifiers = {
   hidden: "hidden"
 };
 Object(_shopify_theme_sections__WEBPACK_IMPORTED_MODULE_7__[/* register */ "b"])("cart-recommendations", {
   nostoSectionId: null,
   products: [],
   slider: null,
   sliderContainer: null,
   sliderWrapper: null,
   sliderOptions: {
     direction: "horizontal",
     loop: false,
     navigation: {
       nextEl: selectors.arrowNext,
       prevEl: selectors.arrowPrev
     },
     speed: 750
   },
   onLoad: function () {
     var _onLoad = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
       return regeneratorRuntime.wrap(function _callee$(_context) {
         while (1) {
           switch (_context.prev = _context.next) {
             case 0:
               this.nostoSectionId = this.container.dataset.nostoSectionId;

               if (this.nostoSectionId) {
                 _context.next = 3;
                 break;
               }

               return _context.abrupt("return", null);

             case 3:
               this.sliderContainer = this.container.querySelector(selectors.sliderContainer);
               this.sliderWrapper = this.container.querySelector(selectors.sliderWrapper);

               if (!(!this.sliderContainer || !this.sliderWrapper)) {
                 _context.next = 7;
                 break;
               }

               return _context.abrupt("return", null);

             case 7:
               _context.next = 9;
               return this.initNostoRecommendations();

             case 9:
             case "end":
               return _context.stop();
           }
         }
       }, _callee, this);
     }));

     function onLoad() {
       return _onLoad.apply(this, arguments);
     }

     return onLoad;
   }(),
   initNostoRecommendations: function () {
     var _initNostoRecommendations = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
       var _this = this;

       return regeneratorRuntime.wrap(function _callee3$(_context3) {
         while (1) {
           switch (_context3.prev = _context3.next) {
             case 0:
               window.nostojs(function (api) {
                 api.defaultSession().viewProduct("" + window.__st.rid || "").setPlacements([_this.nostoSectionId]).load().then( /*#__PURE__*/function () {
                   var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(data) {
                     return regeneratorRuntime.wrap(function _callee2$(_context2) {
                       while (1) {
                         switch (_context2.prev = _context2.next) {
                           case 0:
                             _context2.next = 2;
                             return _this.initNostoProducts(data);

                           case 2:
                           case "end":
                             return _context2.stop();
                         }
                       }
                     }, _callee2);
                   }));

                   return function (_x) {
                     return _ref.apply(this, arguments);
                   };
                 }());
               });

             case 1:
             case "end":
               return _context3.stop();
           }
         }
       }, _callee3);
     }));

     function initNostoRecommendations() {
       return _initNostoRecommendations.apply(this, arguments);
     }

     return initNostoRecommendations;
   }(),
   initNostoProducts: function () {
     var _initNostoProducts = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(_ref2) {
       var _this2 = this;

       var recommendations, placement, promises, recommendedProducts, recommendedProductSlides;
       return regeneratorRuntime.wrap(function _callee4$(_context4) {
         while (1) {
           switch (_context4.prev = _context4.next) {
             case 0:
               recommendations = _ref2.recommendations;
               placement = this.nostoSectionId;

               if (!(!recommendations.hasOwnProperty(placement) || !recommendations[placement].products.length)) {
                 _context4.next = 4;
                 break;
               }

               return _context4.abrupt("return", null);

             case 4:
               this.products = recommendations[placement].products;
               promises = [];
               recommendations[placement].products.forEach(function (product) {
                 promises.push(fetch("".concat(product.url, "?view=product-card")).then(function (data) {
                   return data.text();
                 }));
               });
               _context4.next = 9;
               return Promise.all(promises);

             case 9:
               recommendedProducts = _context4.sent;
               recommendedProductSlides = recommendedProducts.reduce(function (products, product) {
                 var item = "<div class=\"swiper-slide slider__slide cart-recommendations__slider-slide\">\n\t\t\t\t\t".concat(product, "\n\t\t\t\t</div>");
                 products.push(item);
                 return products;
               }, []);

               if (recommendedProductSlides.length) {
                 _context4.next = 13;
                 break;
               }

               return _context4.abrupt("return", null);

             case 13:
               recommendedProductSlides.forEach(function (slide) {
                 _this2.sliderWrapper.innerHTML += slide;
               });
               Object(_components_product_card__WEBPACK_IMPORTED_MODULE_8__["initProductCards"])();
               this.container.classList.remove(modifiers.hidden);
               new _components_slider__WEBPACK_IMPORTED_MODULE_9__["default"](this.sliderContainer, this.sliderOptions);

             case 17:
             case "end":
               return _context4.stop();
           }
         }
       }, _callee4, this);
     }));

     function initNostoProducts(_x2) {
       return _initNostoProducts.apply(this, arguments);
     }

     return initNostoProducts;
   }(),
   onUnload: function onUnload() {
     if (!this.slider) {
       return null;
     }

     this.slider.destroy();
   }
 });

 /***/ }),
 /* 180 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";
 __webpack_require__.r(__webpack_exports__);
 /* harmony import */ var _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
 /* harmony import */ var _components_slider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7);


 var selectors = {
   slider: "[data-slider-container]",
   arrowNext: "[data-slider-arrow-next]",
   arrowPrev: "[data-slider-arrow-prev]",
   pagination: "[data-slider-pagination]"
 };
 Object(_shopify_theme_sections__WEBPACK_IMPORTED_MODULE_0__[/* register */ "b"])("content-cards", {
   slider: null,
   sliderContainer: null,
   options: {
     direction: "horizontal",
     loop: false,
     navigation: {
       nextEl: selectors.arrowNext,
       prevEl: selectors.arrowPrev
     },
     speed: 750
   },
   onLoad: function onLoad() {
     this.sliderContainer = this.container.querySelector(selectors.slider);

     if (!this.sliderContainer) {
       return null;
     }

     this.slider = new _components_slider__WEBPACK_IMPORTED_MODULE_1__["default"](this.sliderContainer, this.options);
   },
   onUnload: function onUnload() {
     if (!this.slider) {
       return null;
     }

     this.slider.destroy();
   }
 });

 /***/ }),
 /* 181 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";
 __webpack_require__.r(__webpack_exports__);
 /* harmony import */ var _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
 /* harmony import */ var _components_slider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7);


 var selectors = {
   slider: "[data-slider-container]",
   arrowNext: "[data-slider-arrow-next]",
   arrowPrev: "[data-slider-arrow-prev]",
   pagination: "[data-slider-pagination]"
 };
 Object(_shopify_theme_sections__WEBPACK_IMPORTED_MODULE_0__[/* register */ "b"])("product-recommendations__slider", {
   slider: null,
   sliderContainer: null,
   options: {
     direction: "horizontal",
     loop: false,
     navigation: {
       nextEl: selectors.arrowNext,
       prevEl: selectors.arrowPrev
     },
     speed: 750
   },
   onLoad: function onLoad() {
     this.sliderContainer = this.container.querySelector(selectors.slider);

     if (!this.sliderContainer) {
       return null;
     }

     this.slider = new _components_slider__WEBPACK_IMPORTED_MODULE_1__["default"](this.sliderContainer, this.options);
   },
   onUnload: function onUnload() {
     if (!this.slider) {
       return null;
     }

     this.slider.destroy();
   }
 });

 /***/ }),
 /* 182 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";
 __webpack_require__.r(__webpack_exports__);
 /* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3);
 /* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8);
 /* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_1__);
 /* harmony import */ var _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1);
 /* harmony import */ var _components_slider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7);




 var selectors = {
   sliderHow: "[data-slider-container]",
   sliderWhere: "[data-slider-container-where]",
   arrowNext: "[data-slider-arrow-next]",
   arrowPrev: "[data-slider-arrow-prev]",
   pagination: "[data-slider-pagination]",
   control: ".js-tabs-control"
 };
 Object(_shopify_theme_sections__WEBPACK_IMPORTED_MODULE_2__[/* register */ "b"])("four-column", {
   sliderHow: null,
   sliderWhere: null,
   sliderContainerHow: null,
   sliderContainerWhere: null,
   options: {
     slidesPerView: "auto",
     direction: "horizontal",
     loop: false,
     watchOverflow: true,
     centerInsufficientSlides: true,
     speed: 600
   },
   options2: {
     direction: "horizontal",
     loop: false,
     watchOverflow: true,
     centerInsufficientSlides: true,
     speed: 750
   },
   onLoad: function onLoad() {
     this.sliderContainerHow = this.container.querySelector(selectors.sliderHow);
     this.sliderContainerWhere = this.container.querySelector(selectors.sliderWhere);

     if (this.sliderContainerHow || this.sliderContainerWhere) {
       this.sliderHow = new _components_slider__WEBPACK_IMPORTED_MODULE_3__["default"](this.sliderContainerHow, this.options);
       this.sliderWhere = new _components_slider__WEBPACK_IMPORTED_MODULE_3__["default"](this.sliderContainerWhere, this.options2);
     } else {
       return null;
     }

     var tabControl = document.querySelector(selectors.control);
     var options = {
       attributes: true
     };

     function callback(mutationList) {
       mutationList.forEach(function (mutation) {
         if (mutation.type === "attributes" && mutation.attributeName === "class") {
           window.dispatchEvent(new Event("resize"));
         }
       });
     }

     var observer = new MutationObserver(callback);
     observer.observe(tabControl, options);
   },
   onUnload: function onUnload() {
     if (!this.sliderHow) {
       return null;
     }

     this.sliderHow.destroy();
   }
 });

 /***/ }),
 /* 183 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";
 __webpack_require__.r(__webpack_exports__);
 /* harmony import */ var regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(16);
 /* harmony import */ var regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3);
 /* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1__);
 /* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8);
 /* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_2__);
 /* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14);
 /* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_3__);
 /* harmony import */ var _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1);





 function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

 function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }


 var selectors = {
   features: "[data-features]",
   featuresButton: "[data-features-button]"
 };
 var modificators = {
   featuresVisible: "product-features--show"
 };
 Object(_shopify_theme_sections__WEBPACK_IMPORTED_MODULE_4__[/* register */ "b"])("product-overview", {
   onLoad: function () {
     var _onLoad = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
       var features, featuresButton;
       return regeneratorRuntime.wrap(function _callee$(_context) {
         while (1) {
           switch (_context.prev = _context.next) {
             case 0:
               features = document.querySelectorAll(selectors.features);
               featuresButton = document.querySelector(selectors.featuresButton);

               if (features && featuresButton) {
                 featuresButton.addEventListener("click", function () {
                   features.forEach(function (element) {
                     element.classList.add(modificators.featuresVisible);
                   });
                   featuresButton.remove();
                 });
               }

             case 3:
             case "end":
               return _context.stop();
           }
         }
       }, _callee);
     }));

     function onLoad() {
       return _onLoad.apply(this, arguments);
     }

     return onLoad;
   }()
 });

 /***/ }),
 /* 184 */
 /***/ (function(module, exports, __webpack_require__) {

 var $ = __webpack_require__(13);
 var assign = __webpack_require__(301);

 // `Object.assign` method
 // https://tc39.es/ecma262/#sec-object.assign
 // eslint-disable-next-line es/no-object-assign -- required for testing
 $({ target: 'Object', stat: true, forced: Object.assign !== assign }, {
   assign: assign
 });


 /***/ }),
 /* 185 */
 /***/ (function(module, exports, __webpack_require__) {

 "use strict";

 var call = __webpack_require__(22);
 var fixRegExpWellKnownSymbolLogic = __webpack_require__(131);
 var anObject = __webpack_require__(17);
 var toLength = __webpack_require__(88);
 var toString = __webpack_require__(28);
 var requireObjectCoercible = __webpack_require__(37);
 var getMethod = __webpack_require__(58);
 var advanceStringIndex = __webpack_require__(153);
 var regExpExec = __webpack_require__(129);

 // @@match logic
 fixRegExpWellKnownSymbolLogic('match', function (MATCH, nativeMatch, maybeCallNative) {
   return [
     // `String.prototype.match` method
     // https://tc39.es/ecma262/#sec-string.prototype.match
     function match(regexp) {
       var O = requireObjectCoercible(this);
       var matcher = regexp == undefined ? undefined : getMethod(regexp, MATCH);
       return matcher ? call(matcher, regexp, O) : new RegExp(regexp)[MATCH](toString(O));
     },
     // `RegExp.prototype[@@match]` method
     // https://tc39.es/ecma262/#sec-regexp.prototype-@@match
     function (string) {
       var rx = anObject(this);
       var S = toString(string);
       var res = maybeCallNative(nativeMatch, rx, S);

       if (res.done) return res.value;

       if (!rx.global) return regExpExec(rx, S);

       var fullUnicode = rx.unicode;
       rx.lastIndex = 0;
       var A = [];
       var n = 0;
       var result;
       while ((result = regExpExec(rx, S)) !== null) {
         var matchStr = toString(result[0]);
         A[n] = matchStr;
         if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
         n++;
       }
       return n === 0 ? null : A;
     }
   ];
 });


 /***/ }),
 /* 186 */
 /***/ (function(module, exports, __webpack_require__) {

 var uncurryThis = __webpack_require__(5);

 // `thisNumberValue` abstract operation
 // https://tc39.es/ecma262/#sec-thisnumbervalue
 module.exports = uncurryThis(1.0.valueOf);


 /***/ }),
 /* 187 */
 /***/ (function(module, exports, __webpack_require__) {

 var arraySlice = __webpack_require__(85);

 var floor = Math.floor;

 var mergeSort = function (array, comparefn) {
   var length = array.length;
   var middle = floor(length / 2);
   return length < 8 ? insertionSort(array, comparefn) : merge(
     array,
     mergeSort(arraySlice(array, 0, middle), comparefn),
     mergeSort(arraySlice(array, middle), comparefn),
     comparefn
   );
 };

 var insertionSort = function (array, comparefn) {
   var length = array.length;
   var i = 1;
   var element, j;

   while (i < length) {
     j = i;
     element = array[i];
     while (j && comparefn(array[j - 1], element) > 0) {
       array[j] = array[--j];
     }
     if (j !== i++) array[j] = element;
   } return array;
 };

 var merge = function (array, left, right, comparefn) {
   var llength = left.length;
   var rlength = right.length;
   var lindex = 0;
   var rindex = 0;

   while (lindex < llength || rindex < rlength) {
     array[lindex + rindex] = (lindex < llength && rindex < rlength)
       ? comparefn(left[lindex], right[rindex]) <= 0 ? left[lindex++] : right[rindex++]
       : lindex < llength ? left[lindex++] : right[rindex++];
   } return array;
 };

 module.exports = mergeSort;


 /***/ }),
 /* 188 */
 /***/ (function(module, exports, __webpack_require__) {

 var path = __webpack_require__(327);
 var hasOwn = __webpack_require__(19);
 var wrappedWellKnownSymbolModule = __webpack_require__(189);
 var defineProperty = __webpack_require__(26).f;

 module.exports = function (NAME) {
   var Symbol = path.Symbol || (path.Symbol = {});
   if (!hasOwn(Symbol, NAME)) defineProperty(Symbol, NAME, {
     value: wrappedWellKnownSymbolModule.f(NAME)
   });
 };


 /***/ }),
 /* 189 */
 /***/ (function(module, exports, __webpack_require__) {

 var wellKnownSymbol = __webpack_require__(12);

 exports.f = wellKnownSymbol;


 /***/ }),
 /* 190 */
 /***/ (function(module, exports, __webpack_require__) {

 /* eslint-disable es/no-object-getownpropertynames -- safe */
 var classof = __webpack_require__(47);
 var toIndexedObject = __webpack_require__(30);
 var $getOwnPropertyNames = __webpack_require__(74).f;
 var arraySlice = __webpack_require__(85);

 var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
   ? Object.getOwnPropertyNames(window) : [];

 var getWindowNames = function (it) {
   try {
     return $getOwnPropertyNames(it);
   } catch (error) {
     return arraySlice(windowNames);
   }
 };

 // fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
 module.exports.f = function getOwnPropertyNames(it) {
   return windowNames && classof(it) == 'Window'
     ? getWindowNames(it)
     : $getOwnPropertyNames(toIndexedObject(it));
 };


 /***/ }),
 /* 191 */
 /***/ (function(module, exports, __webpack_require__) {

 "use strict";


 var formats = __webpack_require__(147);

 var has = Object.prototype.hasOwnProperty;
 var isArray = Array.isArray;

 var hexTable = (function () {
     var array = [];
     for (var i = 0; i < 256; ++i) {
         array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
     }

     return array;
 }());

 var compactQueue = function compactQueue(queue) {
     while (queue.length > 1) {
         var item = queue.pop();
         var obj = item.obj[item.prop];

         if (isArray(obj)) {
             var compacted = [];

             for (var j = 0; j < obj.length; ++j) {
                 if (typeof obj[j] !== 'undefined') {
                     compacted.push(obj[j]);
                 }
             }

             item.obj[item.prop] = compacted;
         }
     }
 };

 var arrayToObject = function arrayToObject(source, options) {
     var obj = options && options.plainObjects ? Object.create(null) : {};
     for (var i = 0; i < source.length; ++i) {
         if (typeof source[i] !== 'undefined') {
             obj[i] = source[i];
         }
     }

     return obj;
 };

 var merge = function merge(target, source, options) {
     /* eslint no-param-reassign: 0 */
     if (!source) {
         return target;
     }

     if (typeof source !== 'object') {
         if (isArray(target)) {
             target.push(source);
         } else if (target && typeof target === 'object') {
             if ((options && (options.plainObjects || options.allowPrototypes)) || !has.call(Object.prototype, source)) {
                 target[source] = true;
             }
         } else {
             return [target, source];
         }

         return target;
     }

     if (!target || typeof target !== 'object') {
         return [target].concat(source);
     }

     var mergeTarget = target;
     if (isArray(target) && !isArray(source)) {
         mergeTarget = arrayToObject(target, options);
     }

     if (isArray(target) && isArray(source)) {
         source.forEach(function (item, i) {
             if (has.call(target, i)) {
                 var targetItem = target[i];
                 if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') {
                     target[i] = merge(targetItem, item, options);
                 } else {
                     target.push(item);
                 }
             } else {
                 target[i] = item;
             }
         });
         return target;
     }

     return Object.keys(source).reduce(function (acc, key) {
         var value = source[key];

         if (has.call(acc, key)) {
             acc[key] = merge(acc[key], value, options);
         } else {
             acc[key] = value;
         }
         return acc;
     }, mergeTarget);
 };

 var assign = function assignSingleSource(target, source) {
     return Object.keys(source).reduce(function (acc, key) {
         acc[key] = source[key];
         return acc;
     }, target);
 };

 var decode = function (str, decoder, charset) {
     var strWithoutPlus = str.replace(/\+/g, ' ');
     if (charset === 'iso-8859-1') {
         // unescape never throws, no try...catch needed:
         return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
     }
     // utf-8
     try {
         return decodeURIComponent(strWithoutPlus);
     } catch (e) {
         return strWithoutPlus;
     }
 };

 var encode = function encode(str, defaultEncoder, charset, kind, format) {
     // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
     // It has been adapted here for stricter adherence to RFC 3986
     if (str.length === 0) {
         return str;
     }

     var string = str;
     if (typeof str === 'symbol') {
         string = Symbol.prototype.toString.call(str);
     } else if (typeof str !== 'string') {
         string = String(str);
     }

     if (charset === 'iso-8859-1') {
         return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
             return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
         });
     }

     var out = '';
     for (var i = 0; i < string.length; ++i) {
         var c = string.charCodeAt(i);

         if (
             c === 0x2D // -
             || c === 0x2E // .
             || c === 0x5F // _
             || c === 0x7E // ~
             || (c >= 0x30 && c <= 0x39) // 0-9
             || (c >= 0x41 && c <= 0x5A) // a-z
             || (c >= 0x61 && c <= 0x7A) // A-Z
             || (format === formats.RFC1738 && (c === 0x28 || c === 0x29)) // ( )
         ) {
             out += string.charAt(i);
             continue;
         }

         if (c < 0x80) {
             out = out + hexTable[c];
             continue;
         }

         if (c < 0x800) {
             out = out + (hexTable[0xC0 | (c >> 6)] + hexTable[0x80 | (c & 0x3F)]);
             continue;
         }

         if (c < 0xD800 || c >= 0xE000) {
             out = out + (hexTable[0xE0 | (c >> 12)] + hexTable[0x80 | ((c >> 6) & 0x3F)] + hexTable[0x80 | (c & 0x3F)]);
             continue;
         }

         i += 1;
         c = 0x10000 + (((c & 0x3FF) << 10) | (string.charCodeAt(i) & 0x3FF));
         out += hexTable[0xF0 | (c >> 18)]
             + hexTable[0x80 | ((c >> 12) & 0x3F)]
             + hexTable[0x80 | ((c >> 6) & 0x3F)]
             + hexTable[0x80 | (c & 0x3F)];
     }

     return out;
 };

 var compact = function compact(value) {
     var queue = [{ obj: { o: value }, prop: 'o' }];
     var refs = [];

     for (var i = 0; i < queue.length; ++i) {
         var item = queue[i];
         var obj = item.obj[item.prop];

         var keys = Object.keys(obj);
         for (var j = 0; j < keys.length; ++j) {
             var key = keys[j];
             var val = obj[key];
             if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                 queue.push({ obj: obj, prop: key });
                 refs.push(val);
             }
         }
     }

     compactQueue(queue);

     return value;
 };

 var isRegExp = function isRegExp(obj) {
     return Object.prototype.toString.call(obj) === '[object RegExp]';
 };

 var isBuffer = function isBuffer(obj) {
     if (!obj || typeof obj !== 'object') {
         return false;
     }

     return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
 };

 var combine = function combine(a, b) {
     return [].concat(a, b);
 };

 var maybeMap = function maybeMap(val, fn) {
     if (isArray(val)) {
         var mapped = [];
         for (var i = 0; i < val.length; i += 1) {
             mapped.push(fn(val[i]));
         }
         return mapped;
     }
     return fn(val);
 };

 module.exports = {
     arrayToObject: arrayToObject,
     assign: assign,
     combine: combine,
     compact: compact,
     decode: decode,
     encode: encode,
     isBuffer: isBuffer,
     isRegExp: isRegExp,
     maybeMap: maybeMap,
     merge: merge
 };


 /***/ }),
 /* 192 */
 /***/ (function(module, exports, __webpack_require__) {

 var wellKnownSymbol = __webpack_require__(12);

 var MATCH = wellKnownSymbol('match');

 module.exports = function (METHOD_NAME) {
   var regexp = /./;
   try {
     '/./'[METHOD_NAME](regexp);
   } catch (error1) {
     try {
       regexp[MATCH] = false;
       return '/./'[METHOD_NAME](regexp);
     } catch (error2) { /* empty */ }
   } return false;
 };


 /***/ }),
 /* 193 */
 /***/ (function(module, exports, __webpack_require__) {

 var global = __webpack_require__(2);
 var isRegExp = __webpack_require__(130);

 var TypeError = global.TypeError;

 module.exports = function (it) {
   if (isRegExp(it)) {
     throw TypeError("The method doesn't accept regular expressions");
   } return it;
 };


 /***/ }),
 /* 194 */
 /***/ (function(module, exports, __webpack_require__) {

 var uncurryThis = __webpack_require__(5);
 var toObject = __webpack_require__(42);

 var floor = Math.floor;
 var charAt = uncurryThis(''.charAt);
 var replace = uncurryThis(''.replace);
 var stringSlice = uncurryThis(''.slice);
 var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
 var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;

 // `GetSubstitution` abstract operation
 // https://tc39.es/ecma262/#sec-getsubstitution
 module.exports = function (matched, str, position, captures, namedCaptures, replacement) {
   var tailPos = position + matched.length;
   var m = captures.length;
   var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
   if (namedCaptures !== undefined) {
     namedCaptures = toObject(namedCaptures);
     symbols = SUBSTITUTION_SYMBOLS;
   }
   return replace(replacement, symbols, function (match, ch) {
     var capture;
     switch (charAt(ch, 0)) {
       case '$': return '$';
       case '&': return matched;
       case '`': return stringSlice(str, 0, position);
       case "'": return stringSlice(str, tailPos);
       case '<':
         capture = namedCaptures[stringSlice(ch, 1, -1)];
         break;
       default: // \d\d?
         var n = +ch;
         if (n === 0) return match;
         if (n > m) {
           var f = floor(n / 10);
           if (f === 0) return match;
           if (f <= m) return captures[f - 1] === undefined ? charAt(ch, 1) : captures[f - 1] + charAt(ch, 1);
           return match;
         }
         capture = captures[n - 1];
     }
     return capture === undefined ? '' : capture;
   });
 };


 /***/ }),
 /* 195 */
 /***/ (function(module, exports, __webpack_require__) {

 "use strict";


 /**
  * A `Cancel` is an object that is thrown when an operation is canceled.
  *
  * @class
  * @param {string=} message The message.
  */
 function Cancel(message) {
   this.message = message;
 }

 Cancel.prototype.toString = function toString() {
   return 'Cancel' + (this.message ? ': ' + this.message : '');
 };

 Cancel.prototype.__CANCEL__ = true;

 module.exports = Cancel;


 /***/ }),
 /* 196 */
 /***/ (function(module, exports, __webpack_require__) {

 "use strict";


 var utils = __webpack_require__(45);

 /**
  * Config-specific merge-function which creates a new config-object
  * by merging two configuration objects together.
  *
  * @param {Object} config1
  * @param {Object} config2
  * @returns {Object} New object resulting from merging config2 to config1
  */
 module.exports = function mergeConfig(config1, config2) {
   // eslint-disable-next-line no-param-reassign
   config2 = config2 || {};
   var config = {};

   var valueFromConfig2Keys = ['url', 'method', 'data'];
   var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy', 'params'];
   var defaultToConfig2Keys = [
     'baseURL', 'transformRequest', 'transformResponse', 'paramsSerializer',
     'timeout', 'timeoutMessage', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
     'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress', 'decompress',
     'maxContentLength', 'maxBodyLength', 'maxRedirects', 'transport', 'httpAgent',
     'httpsAgent', 'cancelToken', 'socketPath', 'responseEncoding'
   ];
   var directMergeKeys = ['validateStatus'];

   function getMergedValue(target, source) {
     if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
       return utils.merge(target, source);
     } else if (utils.isPlainObject(source)) {
       return utils.merge({}, source);
     } else if (utils.isArray(source)) {
       return source.slice();
     }
     return source;
   }

   function mergeDeepProperties(prop) {
     if (!utils.isUndefined(config2[prop])) {
       config[prop] = getMergedValue(config1[prop], config2[prop]);
     } else if (!utils.isUndefined(config1[prop])) {
       config[prop] = getMergedValue(undefined, config1[prop]);
     }
   }

   utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
     if (!utils.isUndefined(config2[prop])) {
       config[prop] = getMergedValue(undefined, config2[prop]);
     }
   });

   utils.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);

   utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
     if (!utils.isUndefined(config2[prop])) {
       config[prop] = getMergedValue(undefined, config2[prop]);
     } else if (!utils.isUndefined(config1[prop])) {
       config[prop] = getMergedValue(undefined, config1[prop]);
     }
   });

   utils.forEach(directMergeKeys, function merge(prop) {
     if (prop in config2) {
       config[prop] = getMergedValue(config1[prop], config2[prop]);
     } else if (prop in config1) {
       config[prop] = getMergedValue(undefined, config1[prop]);
     }
   });

   var axiosKeys = valueFromConfig2Keys
     .concat(mergeDeepPropertiesKeys)
     .concat(defaultToConfig2Keys)
     .concat(directMergeKeys);

   var otherKeys = Object
     .keys(config1)
     .concat(Object.keys(config2))
     .filter(function filterAxiosKeys(key) {
       return axiosKeys.indexOf(key) === -1;
     });

   utils.forEach(otherKeys, mergeDeepProperties);

   return config;
 };


 /***/ }),
 /* 197 */
 /***/ (function(module, exports, __webpack_require__) {

 "use strict";


 module.exports = function isCancel(value) {
   return !!(value && value.__CANCEL__);
 };


 /***/ }),
 /* 198 */
 /***/ (function(module, exports, __webpack_require__) {

 "use strict";


 var enhanceError = __webpack_require__(200);

 /**
  * Create an Error with the specified message, config, error code, request and response.
  *
  * @param {string} message The error message.
  * @param {Object} config The config.
  * @param {string} [code] The error code (for example, 'ECONNABORTED').
  * @param {Object} [request] The request.
  * @param {Object} [response] The response.
  * @returns {Error} The created error.
  */
 module.exports = function createError(message, config, code, request, response) {
   var error = new Error(message);
   return enhanceError(error, config, code, request, response);
 };


 /***/ }),
 /* 199 */
 /***/ (function(module, exports, __webpack_require__) {

 "use strict";


 var utils = __webpack_require__(45);
 var settle = __webpack_require__(354);
 var cookies = __webpack_require__(353);
 var buildURL = __webpack_require__(201);
 var buildFullPath = __webpack_require__(352);
 var parseHeaders = __webpack_require__(349);
 var isURLSameOrigin = __webpack_require__(348);
 var createError = __webpack_require__(198);

 module.exports = function xhrAdapter(config) {
   return new Promise(function dispatchXhrRequest(resolve, reject) {
     var requestData = config.data;
     var requestHeaders = config.headers;
     var responseType = config.responseType;

     if (utils.isFormData(requestData)) {
       delete requestHeaders['Content-Type']; // Let the browser set it
     }

     var request = new XMLHttpRequest();

     // HTTP basic authentication
     if (config.auth) {
       var username = config.auth.username || '';
       var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
       requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
     }

     var fullPath = buildFullPath(config.baseURL, config.url);
     request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

     // Set the request timeout in MS
     request.timeout = config.timeout;

     function onloadend() {
       if (!request) {
         return;
       }
       // Prepare the response
       var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
       var responseData = !responseType || responseType === 'text' ||  responseType === 'json' ?
         request.responseText : request.response;
       var response = {
         data: responseData,
         status: request.status,
         statusText: request.statusText,
         headers: responseHeaders,
         config: config,
         request: request
       };

       settle(resolve, reject, response);

       // Clean up request
       request = null;
     }

     if ('onloadend' in request) {
       // Use onloadend if available
       request.onloadend = onloadend;
     } else {
       // Listen for ready state to emulate onloadend
       request.onreadystatechange = function handleLoad() {
         if (!request || request.readyState !== 4) {
           return;
         }

         // The request errored out and we didn't get a response, this will be
         // handled by onerror instead
         // With one exception: request that using file: protocol, most browsers
         // will return status as 0 even though it's a successful request
         if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
           return;
         }
         // readystate handler is calling before onerror or ontimeout handlers,
         // so we should call onloadend on the next 'tick'
         setTimeout(onloadend);
       };
     }

     // Handle browser request cancellation (as opposed to a manual cancellation)
     request.onabort = function handleAbort() {
       if (!request) {
         return;
       }

       reject(createError('Request aborted', config, 'ECONNABORTED', request));

       // Clean up request
       request = null;
     };

     // Handle low level network errors
     request.onerror = function handleError() {
       // Real errors are hidden from us by the browser
       // onerror should only fire if it's a network error
       reject(createError('Network Error', config, null, request));

       // Clean up request
       request = null;
     };

     // Handle timeout
     request.ontimeout = function handleTimeout() {
       var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
       if (config.timeoutErrorMessage) {
         timeoutErrorMessage = config.timeoutErrorMessage;
       }
       reject(createError(
         timeoutErrorMessage,
         config,
         config.transitional && config.transitional.clarifyTimeoutError ? 'ETIMEDOUT' : 'ECONNABORTED',
         request));

       // Clean up request
       request = null;
     };

     // Add xsrf header
     // This is only done if running in a standard browser environment.
     // Specifically not if we're in a web worker, or react-native.
     if (utils.isStandardBrowserEnv()) {
       // Add xsrf header
       var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
         cookies.read(config.xsrfCookieName) :
         undefined;

       if (xsrfValue) {
         requestHeaders[config.xsrfHeaderName] = xsrfValue;
       }
     }

     // Add headers to the request
     if ('setRequestHeader' in request) {
       utils.forEach(requestHeaders, function setRequestHeader(val, key) {
         if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
           // Remove Content-Type if data is undefined
           delete requestHeaders[key];
         } else {
           // Otherwise add header to the request
           request.setRequestHeader(key, val);
         }
       });
     }

     // Add withCredentials to request if needed
     if (!utils.isUndefined(config.withCredentials)) {
       request.withCredentials = !!config.withCredentials;
     }

     // Add responseType to request if needed
     if (responseType && responseType !== 'json') {
       request.responseType = config.responseType;
     }

     // Handle progress if needed
     if (typeof config.onDownloadProgress === 'function') {
       request.addEventListener('progress', config.onDownloadProgress);
     }

     // Not all browsers support upload events
     if (typeof config.onUploadProgress === 'function' && request.upload) {
       request.upload.addEventListener('progress', config.onUploadProgress);
     }

     if (config.cancelToken) {
       // Handle cancellation
       config.cancelToken.promise.then(function onCanceled(cancel) {
         if (!request) {
           return;
         }

         request.abort();
         reject(cancel);
         // Clean up request
         request = null;
       });
     }

     if (!requestData) {
       requestData = null;
     }

     // Send the request
     request.send(requestData);
   });
 };


 /***/ }),
 /* 200 */
 /***/ (function(module, exports, __webpack_require__) {

 "use strict";


 /**
  * Update an Error with the specified config, error code, and response.
  *
  * @param {Error} error The error to update.
  * @param {Object} config The config.
  * @param {string} [code] The error code (for example, 'ECONNABORTED').
  * @param {Object} [request] The request.
  * @param {Object} [response] The response.
  * @returns {Error} The error.
  */
 module.exports = function enhanceError(error, config, code, request, response) {
   error.config = config;
   if (code) {
     error.code = code;
   }

   error.request = request;
   error.response = response;
   error.isAxiosError = true;

   error.toJSON = function toJSON() {
     return {
       // Standard
       message: this.message,
       name: this.name,
       // Microsoft
       description: this.description,
       number: this.number,
       // Mozilla
       fileName: this.fileName,
       lineNumber: this.lineNumber,
       columnNumber: this.columnNumber,
       stack: this.stack,
       // Axios
       config: this.config,
       code: this.code
     };
   };
   return error;
 };


 /***/ }),
 /* 201 */
 /***/ (function(module, exports, __webpack_require__) {

 "use strict";


 var utils = __webpack_require__(45);

 function encode(val) {
   return encodeURIComponent(val).
     replace(/%3A/gi, ':').
     replace(/%24/g, '$').
     replace(/%2C/gi, ',').
     replace(/%20/g, '+').
     replace(/%5B/gi, '[').
     replace(/%5D/gi, ']');
 }

 /**
  * Build a URL by appending params to the end
  *
  * @param {string} url The base of the url (e.g., http://www.google.com)
  * @param {object} [params] The params to be appended
  * @returns {string} The formatted url
  */
 module.exports = function buildURL(url, params, paramsSerializer) {
   /*eslint no-param-reassign:0*/
   if (!params) {
     return url;
   }

   var serializedParams;
   if (paramsSerializer) {
     serializedParams = paramsSerializer(params);
   } else if (utils.isURLSearchParams(params)) {
     serializedParams = params.toString();
   } else {
     var parts = [];

     utils.forEach(params, function serialize(val, key) {
       if (val === null || typeof val === 'undefined') {
         return;
       }

       if (utils.isArray(val)) {
         key = key + '[]';
       } else {
         val = [val];
       }

       utils.forEach(val, function parseValue(v) {
         if (utils.isDate(v)) {
           v = v.toISOString();
         } else if (utils.isObject(v)) {
           v = JSON.stringify(v);
         }
         parts.push(encode(key) + '=' + encode(v));
       });
     });

     serializedParams = parts.join('&');
   }

   if (serializedParams) {
     var hashmarkIndex = url.indexOf('#');
     if (hashmarkIndex !== -1) {
       url = url.slice(0, hashmarkIndex);
     }

     url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
   }

   return url;
 };


 /***/ }),
 /* 202 */
 /***/ (function(module, exports, __webpack_require__) {

 "use strict";


 module.exports = function bind(fn, thisArg) {
   return function wrap() {
     var args = new Array(arguments.length);
     for (var i = 0; i < args.length; i++) {
       args[i] = arguments[i];
     }
     return fn.apply(thisArg, args);
   };
 };


 /***/ }),
 /* 203 */
 /***/ (function(module, exports, __webpack_require__) {

 var fails = __webpack_require__(10);
 var global = __webpack_require__(2);

 // babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
 var $RegExp = global.RegExp;

 module.exports = fails(function () {
   var re = $RegExp('(?<a>b)', 'g');
   return re.exec('b').groups.a !== 'b' ||
     'b'.replace(re, '$<a>c') !== 'bc';
 });


 /***/ }),
 /* 204 */
 /***/ (function(module, exports, __webpack_require__) {

 var fails = __webpack_require__(10);
 var global = __webpack_require__(2);

 // babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
 var $RegExp = global.RegExp;

 module.exports = fails(function () {
   var re = $RegExp('.', 's');
   return !(re.dotAll && re.exec('\n') && re.flags === 's');
 });


 /***/ }),
 /* 205 */
 /***/ (function(module, exports, __webpack_require__) {

 // in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
 var documentCreateElement = __webpack_require__(94);

 var classList = documentCreateElement('span').classList;
 var DOMTokenListPrototype = classList && classList.constructor && classList.constructor.prototype;

 module.exports = DOMTokenListPrototype === Object.prototype ? undefined : DOMTokenListPrototype;


 /***/ }),
 /* 206 */
 /***/ (function(module, exports) {

 // iterable DOM collections
 // flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
 module.exports = {
   CSSRuleList: 0,
   CSSStyleDeclaration: 0,
   CSSValueList: 0,
   ClientRectList: 0,
   DOMRectList: 0,
   DOMStringList: 0,
   DOMTokenList: 1,
   DataTransferItemList: 0,
   FileList: 0,
   HTMLAllCollection: 0,
   HTMLCollection: 0,
   HTMLFormElement: 0,
   HTMLSelectElement: 0,
   MediaList: 0,
   MimeTypeArray: 0,
   NamedNodeMap: 0,
   NodeList: 1,
   PaintRequestList: 0,
   Plugin: 0,
   PluginArray: 0,
   SVGLengthList: 0,
   SVGNumberList: 0,
   SVGPathSegList: 0,
   SVGPointList: 0,
   SVGStringList: 0,
   SVGTransformList: 0,
   SourceBufferList: 0,
   StyleSheetList: 0,
   TextTrackCueList: 0,
   TextTrackList: 0,
   TouchList: 0
 };


 /***/ }),
 /* 207 */
 /***/ (function(module, exports, __webpack_require__) {

 var uncurryThis = __webpack_require__(5);
 var toIntegerOrInfinity = __webpack_require__(65);
 var toString = __webpack_require__(28);
 var requireObjectCoercible = __webpack_require__(37);

 var charAt = uncurryThis(''.charAt);
 var charCodeAt = uncurryThis(''.charCodeAt);
 var stringSlice = uncurryThis(''.slice);

 var createMethod = function (CONVERT_TO_STRING) {
   return function ($this, pos) {
     var S = toString(requireObjectCoercible($this));
     var position = toIntegerOrInfinity(pos);
     var size = S.length;
     var first, second;
     if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
     first = charCodeAt(S, position);
     return first < 0xD800 || first > 0xDBFF || position + 1 === size
       || (second = charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF
         ? CONVERT_TO_STRING
           ? charAt(S, position)
           : first
         : CONVERT_TO_STRING
           ? stringSlice(S, position, position + 2)
           : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
   };
 };

 module.exports = {
   // `String.prototype.codePointAt` method
   // https://tc39.es/ecma262/#sec-string.prototype.codepointat
   codeAt: createMethod(false),
   // `String.prototype.at` method
   // https://github.com/mathiasbynens/String.prototype.at
   charAt: createMethod(true)
 };


 /***/ }),
 /* 208 */
 /***/ (function(module, exports, __webpack_require__) {

 var fails = __webpack_require__(10);

 module.exports = !fails(function () {
   function F() { /* empty */ }
   F.prototype.constructor = null;
   // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
   return Object.getPrototypeOf(new F()) !== F.prototype;
 });


 /***/ }),
 /* 209 */
 /***/ (function(module, exports, __webpack_require__) {

 "use strict";

 var fails = __webpack_require__(10);
 var isCallable = __webpack_require__(11);
 var create = __webpack_require__(55);
 var getPrototypeOf = __webpack_require__(156);
 var redefine = __webpack_require__(32);
 var wellKnownSymbol = __webpack_require__(12);
 var IS_PURE = __webpack_require__(60);

 var ITERATOR = wellKnownSymbol('iterator');
 var BUGGY_SAFARI_ITERATORS = false;

 // `%IteratorPrototype%` object
 // https://tc39.es/ecma262/#sec-%iteratorprototype%-object
 var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;

 /* eslint-disable es/no-array-prototype-keys -- safe */
 if ([].keys) {
   arrayIterator = [].keys();
   // Safari 8 has buggy iterators w/o `next`
   if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
   else {
     PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
     if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
   }
 }

 var NEW_ITERATOR_PROTOTYPE = IteratorPrototype == undefined || fails(function () {
   var test = {};
   // FF44- legacy iterators case
   return IteratorPrototype[ITERATOR].call(test) !== test;
 });

 if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype = {};
 else if (IS_PURE) IteratorPrototype = create(IteratorPrototype);

 // `%IteratorPrototype%[@@iterator]()` method
 // https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
 if (!isCallable(IteratorPrototype[ITERATOR])) {
   redefine(IteratorPrototype, ITERATOR, function () {
     return this;
   });
 }

 module.exports = {
   IteratorPrototype: IteratorPrototype,
   BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
 };


 /***/ }),
 /* 210 */
 /***/ (function(module, exports, __webpack_require__) {

 "use strict";

 var IteratorPrototype = __webpack_require__(209).IteratorPrototype;
 var create = __webpack_require__(55);
 var createPropertyDescriptor = __webpack_require__(67);
 var setToStringTag = __webpack_require__(108);
 var Iterators = __webpack_require__(118);

 var returnThis = function () { return this; };

 module.exports = function (IteratorConstructor, NAME, next) {
   var TO_STRING_TAG = NAME + ' Iterator';
   IteratorConstructor.prototype = create(IteratorPrototype, { next: createPropertyDescriptor(1, next) });
   setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
   Iterators[TO_STRING_TAG] = returnThis;
   return IteratorConstructor;
 };


 /***/ }),
 /* 211 */
 /***/ (function(module, exports, __webpack_require__) {

 "use strict";

 var aCallable = __webpack_require__(57);

 var PromiseCapability = function (C) {
   var resolve, reject;
   this.promise = new C(function ($$resolve, $$reject) {
     if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
     resolve = $$resolve;
     reject = $$reject;
   });
   this.resolve = aCallable(resolve);
   this.reject = aCallable(reject);
 };

 // `NewPromiseCapability` abstract operation
 // https://tc39.es/ecma262/#sec-newpromisecapability
 module.exports.f = function (C) {
   return new PromiseCapability(C);
 };


 /***/ }),
 /* 212 */
 /***/ (function(module, exports, __webpack_require__) {

 var userAgent = __webpack_require__(68);

 module.exports = /(?:ipad|iphone|ipod).*applewebkit/i.test(userAgent);


 /***/ }),
 /* 213 */
 /***/ (function(module, exports, __webpack_require__) {

 var global = __webpack_require__(2);
 var apply = __webpack_require__(117);
 var bind = __webpack_require__(64);
 var isCallable = __webpack_require__(11);
 var hasOwn = __webpack_require__(19);
 var fails = __webpack_require__(10);
 var html = __webpack_require__(134);
 var arraySlice = __webpack_require__(85);
 var createElement = __webpack_require__(94);
 var IS_IOS = __webpack_require__(212);
 var IS_NODE = __webpack_require__(159);

 var set = global.setImmediate;
 var clear = global.clearImmediate;
 var process = global.process;
 var Dispatch = global.Dispatch;
 var Function = global.Function;
 var MessageChannel = global.MessageChannel;
 var String = global.String;
 var counter = 0;
 var queue = {};
 var ONREADYSTATECHANGE = 'onreadystatechange';
 var location, defer, channel, port;

 try {
   // Deno throws a ReferenceError on `location` access without `--location` flag
   location = global.location;
 } catch (error) { /* empty */ }

 var run = function (id) {
   if (hasOwn(queue, id)) {
     var fn = queue[id];
     delete queue[id];
     fn();
   }
 };

 var runner = function (id) {
   return function () {
     run(id);
   };
 };

 var listener = function (event) {
   run(event.data);
 };

 var post = function (id) {
   // old engines have not location.origin
   global.postMessage(String(id), location.protocol + '//' + location.host);
 };

 // Node.js 0.9+ & IE10+ has setImmediate, otherwise:
 if (!set || !clear) {
   set = function setImmediate(fn) {
     var args = arraySlice(arguments, 1);
     queue[++counter] = function () {
       apply(isCallable(fn) ? fn : Function(fn), undefined, args);
     };
     defer(counter);
     return counter;
   };
   clear = function clearImmediate(id) {
     delete queue[id];
   };
   // Node.js 0.8-
   if (IS_NODE) {
     defer = function (id) {
       process.nextTick(runner(id));
     };
   // Sphere (JS game engine) Dispatch API
   } else if (Dispatch && Dispatch.now) {
     defer = function (id) {
       Dispatch.now(runner(id));
     };
   // Browsers with MessageChannel, includes WebWorkers
   // except iOS - https://github.com/zloirock/core-js/issues/624
   } else if (MessageChannel && !IS_IOS) {
     channel = new MessageChannel();
     port = channel.port2;
     channel.port1.onmessage = listener;
     defer = bind(port.postMessage, port);
   // Browsers with postMessage, skip WebWorkers
   // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
   } else if (
     global.addEventListener &&
     isCallable(global.postMessage) &&
     !global.importScripts &&
     location && location.protocol !== 'file:' &&
     !fails(post)
   ) {
     defer = post;
     global.addEventListener('message', listener, false);
   // IE8-
   } else if (ONREADYSTATECHANGE in createElement('script')) {
     defer = function (id) {
       html.appendChild(createElement('script'))[ONREADYSTATECHANGE] = function () {
         html.removeChild(this);
         run(id);
       };
     };
   // Rest old browsers
   } else {
     defer = function (id) {
       setTimeout(runner(id), 0);
     };
   }
 }

 module.exports = {
   set: set,
   clear: clear
 };


 /***/ }),
 /* 214 */
 /***/ (function(module, exports, __webpack_require__) {

 var global = __webpack_require__(2);
 var isConstructor = __webpack_require__(107);
 var tryToString = __webpack_require__(110);

 var TypeError = global.TypeError;

 // `Assert: IsConstructor(argument) is true`
 module.exports = function (argument) {
   if (isConstructor(argument)) return argument;
   throw TypeError(tryToString(argument) + ' is not a constructor');
 };


 /***/ }),
 /* 215 */
 /***/ (function(module, exports, __webpack_require__) {

 var anObject = __webpack_require__(17);
 var aConstructor = __webpack_require__(214);
 var wellKnownSymbol = __webpack_require__(12);

 var SPECIES = wellKnownSymbol('species');

 // `SpeciesConstructor` abstract operation
 // https://tc39.es/ecma262/#sec-speciesconstructor
 module.exports = function (O, defaultConstructor) {
   var C = anObject(O).constructor;
   var S;
   return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? defaultConstructor : aConstructor(S);
 };


 /***/ }),
 /* 216 */
 /***/ (function(module, exports, __webpack_require__) {

 var call = __webpack_require__(22);
 var anObject = __webpack_require__(17);
 var getMethod = __webpack_require__(58);

 module.exports = function (iterator, kind, value) {
   var innerResult, innerError;
   anObject(iterator);
   try {
     innerResult = getMethod(iterator, 'return');
     if (!innerResult) {
       if (kind === 'throw') throw value;
       return value;
     }
     innerResult = call(innerResult, iterator);
   } catch (error) {
     innerError = true;
     innerResult = error;
   }
   if (kind === 'throw') throw value;
   if (innerError) throw innerResult;
   anObject(innerResult);
   return value;
 };


 /***/ }),
 /* 217 */
 /***/ (function(module, exports, __webpack_require__) {

 var wellKnownSymbol = __webpack_require__(12);
 var Iterators = __webpack_require__(118);

 var ITERATOR = wellKnownSymbol('iterator');
 var ArrayPrototype = Array.prototype;

 // check on default Array iterator
 module.exports = function (it) {
   return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
 };


 /***/ }),
 /* 218 */
 /***/ (function(module, exports) {

 module.exports = {
   functional: true,

   render(_h, _vm) {
     const {
       _c,
       _v,
       data,
       children = []
     } = _vm;
     const {
       class: classNames,
       staticClass,
       style,
       staticStyle,
       attrs = {},
       ...rest
     } = data;
     return _c('svg', {
       class: ["icon icon-chevron", classNames, staticClass],
       style: [style, staticStyle],
       attrs: Object.assign({
         "fill": "none",
         "xmlns": "http://www.w3.org/2000/svg",
         "viewBox": "0 0 10 16"
       }, attrs),
       ...rest
     }, children.concat([_c('path', {
       attrs: {
         "fill-rule": "evenodd",
         "clip-rule": "evenodd",
         "d": "M10 7.978a1.469 1.469 0 00-.42-1.019L3.199.401a1.364 1.364 0 00-1.983 0l-.81.847C.146 1.517 0 1.881 0 2.26s.146.743.406 1.011L5 7.978.405 12.714c-.26.268-.406.632-.406 1.011 0 .38.146.743.406 1.012l.81.832a1.365 1.365 0 001.983 0l6.383-6.558A1.468 1.468 0 0010 7.978z",
         "fill": "#000"
       }
     })]));
   }

 };

 /***/ }),
 /* 219 */
 /***/ (function(module, exports) {

 // get successful control from form and assemble into object
 // http://www.w3.org/TR/html401/interact/forms.html#h-17.13.2

 // types which indicate a submit action and are not successful controls
 // these will be ignored
 var k_r_submitter = /^(?:submit|button|image|reset|file)$/i;

 // node names which could be successful controls
 var k_r_success_contrls = /^(?:input|select|textarea|keygen)/i;

 // Matches bracket notation.
 var brackets = /(\[[^\[\]]*\])/g;

 // serializes form fields
 // @param form MUST be an HTMLForm element
 // @param options is an optional argument to configure the serialization. Default output
 // with no options specified is a url encoded string
 //    - hash: [true | false] Configure the output type. If true, the output will
 //    be a js object.
 //    - serializer: [function] Optional serializer function to override the default one.
 //    The function takes 3 arguments (result, key, value) and should return new result
 //    hash and url encoded str serializers are provided with this module
 //    - disabled: [true | false]. If true serialize disabled fields.
 //    - empty: [true | false]. If true serialize empty fields
 function serialize(form, options) {
     if (typeof options != 'object') {
         options = { hash: !!options };
     }
     else if (options.hash === undefined) {
         options.hash = true;
     }

     var result = (options.hash) ? {} : '';
     var serializer = options.serializer || ((options.hash) ? hash_serializer : str_serialize);

     var elements = form && form.elements ? form.elements : [];

     //Object store each radio and set if it's empty or not
     var radio_store = Object.create(null);

     for (var i=0 ; i<elements.length ; ++i) {
         var element = elements[i];

         // ingore disabled fields
         if ((!options.disabled && element.disabled) || !element.name) {
             continue;
         }
         // ignore anyhting that is not considered a success field
         if (!k_r_success_contrls.test(element.nodeName) ||
             k_r_submitter.test(element.type)) {
             continue;
         }

         var key = element.name;
         var val = element.value;

         // we can't just use element.value for checkboxes cause some browsers lie to us
         // they say "on" for value when the box isn't checked
         if ((element.type === 'checkbox' || element.type === 'radio') && !element.checked) {
             val = undefined;
         }

         // If we want empty elements
         if (options.empty) {
             // for checkbox
             if (element.type === 'checkbox' && !element.checked) {
                 val = '';
             }

             // for radio
             if (element.type === 'radio') {
                 if (!radio_store[element.name] && !element.checked) {
                     radio_store[element.name] = false;
                 }
                 else if (element.checked) {
                     radio_store[element.name] = true;
                 }
             }

             // if options empty is true, continue only if its radio
             if (val == undefined && element.type == 'radio') {
                 continue;
             }
         }
         else {
             // value-less fields are ignored unless options.empty is true
             if (!val) {
                 continue;
             }
         }

         // multi select boxes
         if (element.type === 'select-multiple') {
             val = [];

             var selectOptions = element.options;
             var isSelectedOptions = false;
             for (var j=0 ; j<selectOptions.length ; ++j) {
                 var option = selectOptions[j];
                 var allowedEmpty = options.empty && !option.value;
                 var hasValue = (option.value || allowedEmpty);
                 if (option.selected && hasValue) {
                     isSelectedOptions = true;

                     // If using a hash serializer be sure to add the
                     // correct notation for an array in the multi-select
                     // context. Here the name attribute on the select element
                     // might be missing the trailing bracket pair. Both names
                     // "foo" and "foo[]" should be arrays.
                     if (options.hash && key.slice(key.length - 2) !== '[]') {
                         result = serializer(result, key + '[]', option.value);
                     }
                     else {
                         result = serializer(result, key, option.value);
                     }
                 }
             }

             // Serialize if no selected options and options.empty is true
             if (!isSelectedOptions && options.empty) {
                 result = serializer(result, key, '');
             }

             continue;
         }

         result = serializer(result, key, val);
     }

     // Check for all empty radio buttons and serialize them with key=""
     if (options.empty) {
         for (var key in radio_store) {
             if (!radio_store[key]) {
                 result = serializer(result, key, '');
             }
         }
     }

     return result;
 }

 function parse_keys(string) {
     var keys = [];
     var prefix = /^([^\[\]]*)/;
     var children = new RegExp(brackets);
     var match = prefix.exec(string);

     if (match[1]) {
         keys.push(match[1]);
     }

     while ((match = children.exec(string)) !== null) {
         keys.push(match[1]);
     }

     return keys;
 }

 function hash_assign(result, keys, value) {
     if (keys.length === 0) {
         result = value;
         return result;
     }

     var key = keys.shift();
     var between = key.match(/^\[(.+?)\]$/);

     if (key === '[]') {
         result = result || [];

         if (Array.isArray(result)) {
             result.push(hash_assign(null, keys, value));
         }
         else {
             // This might be the result of bad name attributes like "[][foo]",
             // in this case the original `result` object will already be
             // assigned to an object literal. Rather than coerce the object to
             // an array, or cause an exception the attribute "_values" is
             // assigned as an array.
             result._values = result._values || [];
             result._values.push(hash_assign(null, keys, value));
         }

         return result;
     }

     // Key is an attribute name and can be assigned directly.
     if (!between) {
         result[key] = hash_assign(result[key], keys, value);
     }
     else {
         var string = between[1];
         // +var converts the variable into a number
         // better than parseInt because it doesn't truncate away trailing
         // letters and actually fails if whole thing is not a number
         var index = +string;

         // If the characters between the brackets is not a number it is an
         // attribute name and can be assigned directly.
         if (isNaN(index)) {
             result = result || {};
             result[string] = hash_assign(result[string], keys, value);
         }
         else {
             result = result || [];
             result[index] = hash_assign(result[index], keys, value);
         }
     }

     return result;
 }

 // Object/hash encoding serializer.
 function hash_serializer(result, key, value) {
     var matches = key.match(brackets);

     // Has brackets? Use the recursive assignment function to walk the keys,
     // construct any missing objects in the result tree and make the assignment
     // at the end of the chain.
     if (matches) {
         var keys = parse_keys(key);
         hash_assign(result, keys, value);
     }
     else {
         // Non bracket notation can make assignments directly.
         var existing = result[key];

         // If the value has been assigned already (for instance when a radio and
         // a checkbox have the same name attribute) convert the previous value
         // into an array before pushing into it.
         //
         // NOTE: If this requirement were removed all hash creation and
         // assignment could go through `hash_assign`.
         if (existing) {
             if (!Array.isArray(existing)) {
                 result[key] = [ existing ];
             }

             result[key].push(value);
         }
         else {
             result[key] = value;
         }
     }

     return result;
 }

 // urlform encoding serializer
 function str_serialize(result, key, value) {
     // encode newlines as \r\n cause the html spec says so
     value = value.replace(/(\r)?\n/g, '\r\n');
     value = encodeURIComponent(value);

     // spaces should be '+' rather than '%20'.
     value = value.replace(/%20/g, '+');
     return result + (result ? '&' : '') + encodeURIComponent(key) + '=' + value;
 }

 module.exports = serialize;


 /***/ }),
 /* 220 */
 /***/ (function(module, exports) {

 module.exports = {
   functional: true,

   render(_h, _vm) {
     const {
       _c,
       _v,
       data,
       children = []
     } = _vm;
     const {
       class: classNames,
       staticClass,
       style,
       staticStyle,
       attrs = {},
       ...rest
     } = data;
     return _c('svg', {
       class: ["icon icon-close-black", classNames, staticClass],
       style: [style, staticStyle],
       attrs: Object.assign({
         "xmlns": "http://www.w3.org/2000/svg",
         "width": "13",
         "height": "13",
         "fill": "none"
       }, attrs),
       ...rest
     }, children.concat([_c('g', {
       attrs: {
         "fill": "#000",
         "clip-path": "url(#clip0)"
       }
     }, [_c('path', {
       attrs: {
         "d": "M10.254.379L.379 10.254a.535.535 0 000 .758l1.609 1.609a.535.535 0 00.757 0l9.875-9.876a.534.534 0 000-.757L11.012.378a.538.538 0 00-.758 0z"
       }
     }), _c('path', {
       attrs: {
         "d": "M1.988.38L.377 1.987a.537.537 0 000 .758l9.876 9.875c.21.21.548.21.758 0l1.608-1.609a.535.535 0 000-.758L2.745.38a.535.535 0 00-.758 0z"
       }
     })]), _c('defs', [_c('clipPath', {
       attrs: {
         "id": "clip0"
       }
     }, [_c('path', {
       attrs: {
         "fill": "#fff",
         "d": "M0 0h13v13H0z"
       }
     })])])]));
   }

 };

 /***/ }),
 /* 221 */
 /***/ (function(module, exports) {

 module.exports = {
   functional: true,

   render(_h, _vm) {
     const {
       _c,
       _v,
       data,
       children = []
     } = _vm;
     const {
       class: classNames,
       staticClass,
       style,
       staticStyle,
       attrs = {},
       ...rest
     } = data;
     return _c('svg', {
       class: ["icon icon-minus", classNames, staticClass],
       style: [style, staticStyle],
       attrs: Object.assign({
         "xmlns": "http://www.w3.org/2000/svg",
         "fill": "none",
         "viewBox": "0 0 20 20"
       }, attrs),
       ...rest
     }, children.concat([_c('path', {
       attrs: {
         "fill": "#000",
         "d": "M15.581 9.5c.232 0 .419.224.419.5s-.187.5-.419.5H4.42c-.233 0-.42-.224-.42-.5s.187-.5.419-.5H15.58z",
         "opacity": ".4"
       }
     })]));
   }

 };

 /***/ }),
 /* 222 */
 /***/ (function(module, exports) {

 module.exports = {
   functional: true,

   render(_h, _vm) {
     const {
       _c,
       _v,
       data,
       children = []
     } = _vm;
     const {
       class: classNames,
       staticClass,
       style,
       staticStyle,
       attrs = {},
       ...rest
     } = data;
     return _c('svg', {
       class: ["icon icon-plus", classNames, staticClass],
       style: [style, staticStyle],
       attrs: Object.assign({
         "xmlns": "http://www.w3.org/2000/svg",
         "fill": "none",
         "viewBox": "0 0 18 18"
       }, attrs),
       ...rest
     }, children.concat([_c('path', {
       attrs: {
         "fill": "#000",
         "fill-rule": "evenodd",
         "d": "M9.055 3a.491.491 0 00-.491.49l-.005 5.07-5.068.004a.49.49 0 100 .981l4.968-.004-.004 4.968a.492.492 0 00.981.001l.005-5.07 5.069-.004a.49.49 0 00-.001-.981l-4.968.004.005-4.968c0-.27-.22-.49-.491-.491z",
         "clip-rule": "evenodd",
         "opacity": ".405"
       }
     })]));
   }

 };

 /***/ }),
 /* 223 */
 /***/ (function(module, exports) {

 module.exports = {
   functional: true,

   render(_h, _vm) {
     const {
       _c,
       _v,
       data,
       children = []
     } = _vm;
     const {
       class: classNames,
       staticClass,
       style,
       staticStyle,
       attrs = {},
       ...rest
     } = data;
     return _c('svg', {
       class: ["icon icon-close-arrow", classNames, staticClass],
       style: [style, staticStyle],
       attrs: Object.assign({
         "xmlns": "http://www.w3.org/2000/svg",
         "width": "15",
         "height": "15",
         "fill": "none"
       }, attrs),
       ...rest
     }, children.concat([_c('path', {
       attrs: {
         "fill": "#000",
         "fill-rule": "evenodd",
         "d": "M12.737 8.548a.5.5 0 01-.5.5H.5a.5.5 0 01-.5-.5v-2.17a.5.5 0 01.5-.5h11.737a.5.5 0 01.5.5v2.17z",
         "clip-rule": "evenodd"
       }
     }), _c('path', {
       attrs: {
         "fill": "#000",
         "fill-rule": "evenodd",
         "d": "M14.644 7.172a.5.5 0 010 .709l-6.797 6.768a.5.5 0 01-.705 0l-1.543-1.537a.498.498 0 010-.708l6.796-6.768a.501.501 0 01.706 0l1.543 1.536z",
         "clip-rule": "evenodd"
       }
     }), _c('path', {
       attrs: {
         "fill": "#000",
         "fill-rule": "evenodd",
         "d": "M13.101 9.364a.501.501 0 01-.706 0L5.6 2.596a.498.498 0 010-.708L7.142.35a.5.5 0 01.705 0l6.797 6.768a.5.5 0 010 .709l-1.543 1.536z",
         "clip-rule": "evenodd"
       }
     })]));
   }

 };

 /***/ }),
 /* 224 */
 /***/ (function(module, exports) {

 module.exports = {
   functional: false,

   render(_h, _vm) {
     const {
       _c,
       _v,
       data,
       children = []
     } = _vm;
     const {
       class: classNames,
       staticClass,
       style,
       staticStyle,
       attrs = {},
       ...rest
     } = data;
     return _c('svg', {
       class: ["icon icon-laybuy", classNames, staticClass],
       style: [style, staticStyle],
       attrs: Object.assign({
         "width": "45",
         "height": "33",
         "fill": "none",
         "xmlns": "http://www.w3.org/2000/svg"
       }, attrs),
       ...rest
     }, children.concat([_c('path', {
       attrs: {
         "fill": "#786DFF",
         "d": "M0 0h45v33H0z"
       }
     }), _c('path', {
       attrs: {
         "fill-rule": "evenodd",
         "clip-rule": "evenodd",
         "d": "M24.134 7.747L21.97 9.91c-.15.15-.366 0-.366 0l-2.768-2.82a2.296 2.296 0 00-3.237 0 2.294 2.294 0 000 3.237l4.587 4.599a2.294 2.294 0 003.237 0l3.848-3.848.675-.691a1.18 1.18 0 011.67 0c.45.44.457 1.16.017 1.61l-.025.025-.695.699-6.985 6.991a.288.288 0 01-.407.013l-.013-.013-7.602-7.602a2.298 2.298 0 00-3.239 0 2.297 2.297 0 000 3.237l9.479 9.479-.051-.044c.896.89 2.342.89 3.238 0l8.825-8.824.093-.093a5.74 5.74 0 10-8.117-8.118z",
         "fill": "#fff"
       }
     })]));
   }

 };

 /***/ }),
 /* 225 */
 /***/ (function(module, exports) {

 module.exports = {
   functional: true,

   render(_h, _vm) {
     const {
       _c,
       _v,
       data,
       children = []
     } = _vm;
     const {
       class: classNames,
       staticClass,
       style,
       staticStyle,
       attrs = {},
       ...rest
     } = data;
     return _c('svg', {
       class: ["icon icon-clearpay", classNames, staticClass],
       style: [style, staticStyle],
       attrs: Object.assign({
         "width": "45",
         "height": "33",
         "fill": "none",
         "xmlns": "http://www.w3.org/2000/svg"
       }, attrs),
       ...rest
     }, children.concat([_c('path', {
       attrs: {
         "d": "M41.447 0H3.553C1.539 0 0 1.788 0 4.125v24.75C0 31.212 1.658 33 3.553 33h37.894C43.461 33 45 31.212 45 28.875V4.125C45 1.788 43.342 0 41.447 0z",
         "fill": "#B2FCE4"
       }
     }), _c('path', {
       attrs: {
         "d": "M33.7 9.35l-3.695-2.2-3.694-2.2c-2.464-1.375-5.611.413-5.611 3.3v.55c0 .275.137.55.41.688l1.78.962c.547.275 1.094-.137 1.094-.687v-1.1c0-.55.548-.963 1.095-.688L28.5 9.9l3.284 2.063c.548.275.548.962 0 1.237l-3.42 1.925-3.422 2.2c-.547.275-1.095-.137-1.095-.688v-.55c0-2.887-3.147-4.675-5.61-3.3l-3.695 2.2-3.695 2.2c-2.463 1.375-2.463 5.088 0 6.463l3.695 2.2 3.695 2.2c2.463 1.375 5.61-.413 5.61-3.3v-.55a.757.757 0 00-.41-.688l-1.78-.962c-.547-.275-1.094.137-1.094.688v1.1c0 .55-.547.962-1.095.687l-3.42-1.925-3.422-2.063c-.547-.274-.547-.962 0-1.237l3.421-1.925 3.421-1.925c.548-.275 1.095.137 1.095.688v.55c0 2.887 3.148 4.675 5.61 3.3l3.695-2.2 3.695-2.2c2.6-1.65 2.6-5.226.137-6.738z",
         "fill": "#000"
       }
     })]));
   }

 };

 /***/ }),
 /* 226 */
 /***/ (function(module, exports) {

 module.exports = {
   functional: true,

   render(_h, _vm) {
     const {
       _c,
       _v,
       data,
       children = []
     } = _vm;
     const {
       class: classNames,
       staticClass,
       style,
       staticStyle,
       attrs = {},
       ...rest
     } = data;
     return _c('svg', {
       class: ["icon icon-mastercard", classNames, staticClass],
       style: [style, staticStyle],
       attrs: Object.assign({
         "width": "45",
         "height": "33",
         "fill": "none",
         "xmlns": "http://www.w3.org/2000/svg"
       }, attrs),
       ...rest
     }, children.concat([_c('rect', {
       attrs: {
         "width": "45",
         "height": "33",
         "rx": "4",
         "fill": "#37495C"
       }
     }), _c('path', {
       attrs: {
         "fill-rule": "evenodd",
         "clip-rule": "evenodd",
         "d": "M19.236 23.835h7.489V10.378h-7.49v13.457z",
         "fill": "#F16522"
       }
     }), _c('path', {
       attrs: {
         "fill-rule": "evenodd",
         "clip-rule": "evenodd",
         "d": "M19.712 17.107a8.544 8.544 0 013.269-6.729 8.559 8.559 0 00-13.847 6.729 8.559 8.559 0 0013.847 6.728 8.544 8.544 0 01-3.27-6.728z",
         "fill": "#E41B24"
       }
     }), _c('path', {
       attrs: {
         "fill-rule": "evenodd",
         "clip-rule": "evenodd",
         "d": "M36.561 22.41v-.332h-.087l-.1.228-.099-.228h-.087v.332h.061v-.25l.094.215h.063l.094-.216v.25h.061zm-.55 0v-.276h.112v-.056h-.283v.056h.11v.276h.062zm.817-5.304a8.558 8.558 0 01-13.847 6.729 8.543 8.543 0 003.269-6.729 8.544 8.544 0 00-3.269-6.729 8.558 8.558 0 0113.847 6.729z",
         "fill": "#F89E1B"
       }
     })]));
   }

 };

 /***/ }),
 /* 227 */
 /***/ (function(module, exports) {

 module.exports = {
   functional: true,

   render(_h, _vm) {
     const {
       _c,
       _v,
       data,
       children = []
     } = _vm;
     const {
       class: classNames,
       staticClass,
       style,
       staticStyle,
       attrs = {},
       ...rest
     } = data;
     return _c('svg', {
       class: ["icon icon-american_express", classNames, staticClass],
       style: [style, staticStyle],
       attrs: Object.assign({
         "width": "45",
         "height": "33",
         "fill": "none",
         "xmlns": "http://www.w3.org/2000/svg"
       }, attrs),
       ...rest
     }, children.concat([_c('path', {
       attrs: {
         "fill-rule": "evenodd",
         "clip-rule": "evenodd",
         "d": "M45 31.24c0 .973-.672 1.76-1.5 1.76h-42C.67 33 0 32.212 0 31.24V1.76C0 .788.671 0 1.5 0h42c.828 0 1.5.788 1.5 1.76v29.48z",
         "fill": "#0078A9"
       }
     }), _c('path', {
       attrs: {
         "fill-rule": "evenodd",
         "clip-rule": "evenodd",
         "d": "M29.515 18h3.669v1.01h-2.546v.879h2.474v.89h-2.474v.925h2.546v.984h-3.67V18zm9.991 1.827c1.379.072 1.494.779 1.494 1.532 0 .879-.704 1.35-1.439 1.35h-2.357v-1.005h1.837c.311 0 .775 0 .775-.45 0-.214-.081-.35-.413-.386a13.004 13.004 0 00-.776-.054c-1.245-.034-1.536-.67-1.536-1.444 0-.879.603-1.36 1.338-1.36h2.357v1.006H39.06c-.392.004-.816-.048-.816.407 0 .288.21.345.474.372.093 0 .705.032.787.032zm-3.91 0c1.38.072 1.495.779 1.495 1.532 0 .879-.704 1.35-1.439 1.35h-2.357v-1.005h1.837c.31 0 .776 0 .776-.45 0-.214-.083-.35-.414-.386a13.076 13.076 0 00-.775-.054c-1.247-.034-1.535-.67-1.535-1.444 0-.879.601-1.36 1.336-1.36h2.356v1.006h-1.724c-.393.004-.816-.048-.816.407 0 .288.21.345.475.372.091 0 .703.032.785.032zm-12.081.315h-1.398v-1.126h1.402c.47 0 .619.31.619.54 0 .313-.164.586-.623.586zm-2.53 2.106l-1.613-1.956 1.613-1.832v3.788zm-4.29-.544h-2.588v-.926h2.476v-.89h-2.475v-.879l2.729.007 1.093 1.276-1.235 1.412zm7.197-3.694h-3.938l-1.286 1.455L17.424 18H13v4.688h4.28l1.348-1.549 1.315 1.56h2.154v-1.592h1.51c.581 0 1.643-.02 1.643-1.663 0-1.173-.806-1.434-1.358-1.434z",
         "fill": "#fff"
       }
     }), _c('path', {
       attrs: {
         "fill-rule": "evenodd",
         "clip-rule": "evenodd",
         "d": "M27.771 20.079h-1.398v-1.063h1.403c.469 0 .617.31.617.54 0 .313-.163.523-.622.523zm.968.485c.613-.314.776-.733.776-1.298 0-1.004-.795-1.255-1.347-1.255H25.25v4.688h1.122v-1.654h1.47c.388 0 .54.398.55.795l.03.86h1.093l-.041-.964c0-.754-.203-1.11-.735-1.172zm-2.961-4.076h1.074V12h-1.074v4.488zm-8.784-4.483H20.5v.965h-2.434v.841h2.365v.85h-2.365v.886H20.5v.941h-3.507v-4.483zm6.554 1.977h-1.336v-1.015h1.341c.448 0 .59.295.59.515 0 .3-.156.5-.595.5zm.927.464c.586-.299.742-.7.742-1.24 0-.961-.761-1.2-1.288-1.2h-2.79v4.482h1.073v-1.58h1.405c.37 0 .517.379.527.76l.029.82h1.044l-.038-.92c0-.721-.196-1.061-.704-1.122zm-17.518.074l.64-1.567.667 1.567H6.957zm7.561-2.515l-1.317 3.007-1.312-3.007h-1.683v4.318l-1.873-4.318h-1.42L5 16.488h1.132l.42-1h2.141l.425 1h2.16V13.16l1.435 3.328h.976l1.468-3.272v3.272h1.074v-4.483h-1.713zm16.816 2.517l.64-1.567.673 1.567h-1.313zm6.592-2.52v3.105l-1.81-3.104h-1.585v4.21l-1.829-4.208h-1.42l-1.478 3.473s-.625 0-.688-.016c-.258-.054-.663-.242-.668-1.032v-.325c0-1.051.556-1.128 1.27-1.128h.662v-.974h-1.4c-.489 0-1.55.382-1.586 2.223-.025 1.241.503 2.264 1.693 2.264h1.415l.419-1h2.141l.425 1h2.118v-3.282l1.93 3.283H39v-4.488h-1.074z",
         "fill": "#fff"
       }
     })]));
   }

 };

 /***/ }),
 /* 228 */
 /***/ (function(module, exports) {

 module.exports = {
   functional: true,

   render(_h, _vm) {
     const {
       _c,
       _v,
       data,
       children = []
     } = _vm;
     const {
       class: classNames,
       staticClass,
       style,
       staticStyle,
       attrs = {},
       ...rest
     } = data;
     return _c('svg', {
       class: ["icon icon-visa", classNames, staticClass],
       style: [style, staticStyle],
       attrs: Object.assign({
         "width": "45",
         "height": "33",
         "fill": "none",
         "xmlns": "http://www.w3.org/2000/svg"
       }, attrs),
       ...rest
     }, children.concat([_c('path', {
       attrs: {
         "d": "M0 4a4 4 0 014-4h37a4 4 0 014 4v25a4 4 0 01-4 4H4a4 4 0 01-4-4V4z",
         "fill": "#2550B7"
       }
     }), _c('mask', {
       staticStyle: {
         "mask-type": "alpha"
       },
       attrs: {
         "id": "a",
         "maskUnits": "userSpaceOnUse",
         "x": "29",
         "y": "12",
         "width": "10",
         "height": "10"
       }
     }, [_c('path', {
       attrs: {
         "fill-rule": "evenodd",
         "clip-rule": "evenodd",
         "d": "M34.39 12.076c-.589 0-.931.233-1.16.788l-3.166 7.688-.446 1.094c.842 0 1.66.002 2.479-.006.043 0 .106-.07.125-.12.14-.376.276-.754.401-1.135.042-.127.097-.173.234-.172.908.007 1.816.01 2.724-.002.182-.002.234.062.263.228.07.4.159.796.242 1.202h2.263v-.068c-.073-.323-.151-.645-.218-.97l-1.558-7.598c-.063-.308-.13-.616-.195-.929h-1.987zm.25 2.659l.03.005.716 3.502h-1.995l1.249-3.507z",
         "fill": "#fff"
       }
     })]), _c('g', {
       attrs: {
         "mask": "url(#a)"
       }
     }, [_c('path', {
       attrs: {
         "fill-rule": "evenodd",
         "clip-rule": "evenodd",
         "d": "M34.39 12.076c-.589 0-.931.233-1.16.788l-3.166 7.688-.446 1.094c.842 0 1.66.002 2.479-.006.043 0 .106-.07.125-.12.14-.376.276-.754.401-1.135.042-.127.097-.173.234-.172.908.007 1.816.01 2.724-.002.182-.002.234.062.263.228.07.4.159.796.242 1.202h2.263v-.068c-.073-.323-.151-.645-.218-.97l-1.558-7.598c-.063-.308-.13-.616-.195-.929h-1.987zm.25 2.659l.03.005.716 3.502h-1.995l1.249-3.507z",
         "fill": "#fff"
       }
     })]), _c('mask', {
       staticStyle: {
         "mask-type": "alpha"
       },
       attrs: {
         "id": "b",
         "maskUnits": "userSpaceOnUse",
         "x": "22",
         "y": "11",
         "width": "9",
         "height": "11"
       }
     }, [_c('path', {
       attrs: {
         "fill-rule": "evenodd",
         "clip-rule": "evenodd",
         "d": "M27.351 11.906c-.047.011-.093.028-.14.034-.855.105-1.657.356-2.333.922-.776.65-1.152 1.486-1.043 2.516.073.688.456 1.206.985 1.594.413.303.876.533 1.313.804.279.173.574.332.819.548.373.329.333.854-.076 1.134a1.746 1.746 0 01-.639.271c-.856.163-1.682.013-2.481-.315-.168-.068-.332-.146-.506-.224l-.439 2.09c.031.02.049.034.069.043.066.027.133.056.202.08a7.58 7.58 0 002.416.397h.005c.24 0 .482-.012.724-.035.767-.073 1.504-.269 2.154-.708 1.035-.7 1.49-1.687 1.337-2.942-.087-.709-.5-1.233-1.067-1.615-.481-.324-1.001-.588-1.497-.89a3.61 3.61 0 01-.62-.455c-.266-.256-.262-.607.017-.85a1.55 1.55 0 01.579-.314c.509-.144 1.03-.1 1.538.014.372.083.734.213 1.113.326l.423-2.018c-.287-.083-.55-.171-.82-.235-.297-.07-.598-.116-.896-.172H27.35z",
         "fill": "#fff"
       }
     })]), _c('g', {
       attrs: {
         "mask": "url(#b)"
       }
     }, [_c('path', {
       attrs: {
         "fill-rule": "evenodd",
         "clip-rule": "evenodd",
         "d": "M27.351 11.906c-.047.011-.093.028-.14.034-.855.105-1.657.356-2.333.922-.776.65-1.152 1.486-1.043 2.516.073.688.456 1.206.985 1.594.413.303.876.533 1.313.804.279.173.574.332.819.548.373.329.333.854-.076 1.134a1.746 1.746 0 01-.639.271c-.856.163-1.682.013-2.481-.315-.168-.068-.332-.146-.506-.224l-.439 2.09c.031.02.049.034.069.043.066.027.133.056.202.08a7.58 7.58 0 002.416.397h.005c.24 0 .482-.012.724-.035.767-.073 1.504-.269 2.154-.708 1.035-.7 1.49-1.687 1.337-2.942-.087-.709-.5-1.233-1.067-1.615-.481-.324-1.001-.588-1.497-.89a3.61 3.61 0 01-.62-.455c-.266-.256-.262-.607.017-.85a1.55 1.55 0 01.579-.314c.509-.144 1.03-.1 1.538.014.372.083.734.213 1.113.326l.423-2.018c-.287-.083-.55-.171-.82-.235-.297-.07-.598-.116-.896-.172H27.35z",
         "fill": "#fff"
       }
     })]), _c('mask', {
       staticStyle: {
         "mask-type": "alpha"
       },
       attrs: {
         "id": "c",
         "maskUnits": "userSpaceOnUse",
         "x": "8",
         "y": "12",
         "width": "12",
         "height": "10"
       }
     }, [_c('path', {
       attrs: {
         "fill-rule": "evenodd",
         "clip-rule": "evenodd",
         "d": "M17.064 12.223c-.795 2.06-1.595 4.118-2.394 6.176-.015.04-.038.075-.072.14l-.051-.26c-.323-1.742-.643-3.485-.97-5.226-.115-.615-.555-.976-1.166-.977h-3.86c-.269 0-.269 0-.272.287l.093.024c.72.174 1.427.389 2.108.694.424.19.65.5.764.954.616 2.476 1.25 4.947 1.873 7.42.036.142.087.198.243.196.735-.01 1.47-.008 2.206-.002.134.001.202-.034.257-.17 1.16-2.831 2.327-5.66 3.492-8.49l.37-.905c-.069-.003-.117-.008-.165-.008h-.634c-.535.001-1.07.002-1.606-.003h-.004c-.116 0-.17.039-.212.15z",
         "fill": "#fff"
       }
     })]), _c('g', {
       attrs: {
         "mask": "url(#c)"
       }
     }, [_c('path', {
       attrs: {
         "fill-rule": "evenodd",
         "clip-rule": "evenodd",
         "d": "M17.064 12.223c-.795 2.06-1.595 4.118-2.394 6.176-.015.04-.038.075-.072.14l-.051-.26c-.323-1.742-.643-3.485-.97-5.226-.115-.615-.555-.976-1.166-.977h-3.86c-.269 0-.269 0-.272.287l.093.024c.72.174 1.427.389 2.108.694.424.19.65.5.764.954.616 2.476 1.25 4.947 1.873 7.42.036.142.087.198.243.196.735-.01 1.47-.008 2.206-.002.134.001.202-.034.257-.17 1.16-2.831 2.327-5.66 3.492-8.49l.37-.905c-.069-.003-.117-.008-.165-.008h-.634c-.535.001-1.07.002-1.606-.003h-.004c-.116 0-.17.039-.212.15z",
         "fill": "#fff"
       }
     })]), _c('mask', {
       staticStyle: {
         "mask-type": "alpha"
       },
       attrs: {
         "id": "d",
         "maskUnits": "userSpaceOnUse",
         "x": "18",
         "y": "12",
         "width": "6",
         "height": "10"
       }
     }, [_c('path', {
       attrs: {
         "fill-rule": "evenodd",
         "clip-rule": "evenodd",
         "d": "M20.719 12.086l-2.009 9.56h.2c.669 0 1.337-.008 2.006.005.186.004.25-.054.287-.237.547-2.631 1.101-5.261 1.654-7.891l.3-1.437H20.72z",
         "fill": "#fff"
       }
     })]), _c('g', {
       attrs: {
         "mask": "url(#d)"
       }
     }, [_c('path', {
       attrs: {
         "fill-rule": "evenodd",
         "clip-rule": "evenodd",
         "d": "M20.719 12.086l-2.009 9.56h.2c.669 0 1.337-.008 2.006.005.186.004.25-.054.287-.237.547-2.631 1.101-5.261 1.654-7.891l.3-1.437H20.72z",
         "fill": "#fff"
       }
     })])]));
   }

 };

 /***/ }),
 /* 229 */
 /***/ (function(module, exports) {

 module.exports = {
   functional: true,

   render(_h, _vm) {
     const {
       _c,
       _v,
       data,
       children = []
     } = _vm;
     const {
       class: classNames,
       staticClass,
       style,
       staticStyle,
       attrs = {},
       ...rest
     } = data;
     return _c('svg', {
       class: ["icon icon-lock", classNames, staticClass],
       style: [style, staticStyle],
       attrs: Object.assign({
         "width": "20",
         "height": "22",
         "fill": "none",
         "xmlns": "http://www.w3.org/2000/svg"
       }, attrs),
       ...rest
     }, children.concat([_c('path', {
       attrs: {
         "fill-rule": "evenodd",
         "clip-rule": "evenodd",
         "d": "M20 6H0v16h20V6zm-9 5H9v6h2v-6z",
         "fill": "currentColor"
       }
     }), _c('circle', {
       attrs: {
         "cx": "10",
         "cy": "5",
         "r": "4",
         "stroke": "currentColor",
         "stroke-width": "2"
       }
     })]));
   }

 };

 /***/ }),
 /* 230 */
 /***/ (function(module, exports) {

 module.exports = {
   functional: true,

   render(_h, _vm) {
     const {
       _c,
       _v,
       data,
       children = []
     } = _vm;
     const {
       class: classNames,
       staticClass,
       style,
       staticStyle,
       attrs = {},
       ...rest
     } = data;
     return _c('svg', {
       class: ["icon icon-search", classNames, staticClass],
       style: [style, staticStyle],
       attrs: Object.assign({
         "width": "22",
         "height": "22",
         "fill": "none",
         "xmlns": "http://www.w3.org/2000/svg"
       }, attrs),
       ...rest
     }, children.concat([_c('circle', {
       attrs: {
         "cx": "8.5",
         "cy": "8.5",
         "r": "7.25",
         "stroke": "currentColor",
         "stroke-width": "2.5"
       }
     }), _c('path', {
       attrs: {
         "d": "M14 14l6.5 7",
         "stroke": "currentColor",
         "stroke-width": "2.5"
       }
     })]));
   }

 };

 /***/ }),
 /* 231 */
 /***/ (function(module, exports) {

 module.exports = {
   functional: true,

   render(_h, _vm) {
     const {
       _c,
       _v,
       data,
       children = []
     } = _vm;
     const {
       class: classNames,
       staticClass,
       style,
       staticStyle,
       attrs = {},
       ...rest
     } = data;
     return _c('svg', {
       class: ["icon icon-check", classNames, staticClass],
       style: [style, staticStyle],
       attrs: Object.assign({
         "width": "16",
         "height": "13",
         "fill": "none",
         "xmlns": "http://www.w3.org/2000/svg"
       }, attrs),
       ...rest
     }, children.concat([_c('path', {
       attrs: {
         "d": "M2 4.5L7 10l7.5-9",
         "stroke": "#fff",
         "stroke-width": "3"
       }
     })]));
   }

 };

 /***/ }),
 /* 232 */
 /***/ (function(module, exports, __webpack_require__) {

 /*! choices.js v9.0.1 | © 2019 Josh Johnson | https://github.com/jshjohnson/Choices#readme */
 (function webpackUniversalModuleDefinition(root, factory) {
   if(true)
     module.exports = factory();
   else {}
 })(window, function() {
 return /******/ (function(modules) { // webpackBootstrap
 /******/ 	// The module cache
 /******/ 	var installedModules = {};
 /******/
 /******/ 	// The require function
 /******/ 	function __webpack_require__(moduleId) {
 /******/
 /******/ 		// Check if module is in cache
 /******/ 		if(installedModules[moduleId]) {
 /******/ 			return installedModules[moduleId].exports;
 /******/ 		}
 /******/ 		// Create a new module (and put it into the cache)
 /******/ 		var module = installedModules[moduleId] = {
 /******/ 			i: moduleId,
 /******/ 			l: false,
 /******/ 			exports: {}
 /******/ 		};
 /******/
 /******/ 		// Execute the module function
 /******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
 /******/
 /******/ 		// Flag the module as loaded
 /******/ 		module.l = true;
 /******/
 /******/ 		// Return the exports of the module
 /******/ 		return module.exports;
 /******/ 	}
 /******/
 /******/
 /******/ 	// expose the modules object (__webpack_modules__)
 /******/ 	__webpack_require__.m = modules;
 /******/
 /******/ 	// expose the module cache
 /******/ 	__webpack_require__.c = installedModules;
 /******/
 /******/ 	// define getter function for harmony exports
 /******/ 	__webpack_require__.d = function(exports, name, getter) {
 /******/ 		if(!__webpack_require__.o(exports, name)) {
 /******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 /******/ 		}
 /******/ 	};
 /******/
 /******/ 	// define __esModule on exports
 /******/ 	__webpack_require__.r = function(exports) {
 /******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 /******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 /******/ 		}
 /******/ 		Object.defineProperty(exports, '__esModule', { value: true });
 /******/ 	};
 /******/
 /******/ 	// create a fake namespace object
 /******/ 	// mode & 1: value is a module id, require it
 /******/ 	// mode & 2: merge all properties of value into the ns
 /******/ 	// mode & 4: return value when already ns object
 /******/ 	// mode & 8|1: behave like require
 /******/ 	__webpack_require__.t = function(value, mode) {
 /******/ 		if(mode & 1) value = __webpack_require__(value);
 /******/ 		if(mode & 8) return value;
 /******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 /******/ 		var ns = Object.create(null);
 /******/ 		__webpack_require__.r(ns);
 /******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 /******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 /******/ 		return ns;
 /******/ 	};
 /******/
 /******/ 	// getDefaultExport function for compatibility with non-harmony modules
 /******/ 	__webpack_require__.n = function(module) {
 /******/ 		var getter = module && module.__esModule ?
 /******/ 			function getDefault() { return module['default']; } :
 /******/ 			function getModuleExports() { return module; };
 /******/ 		__webpack_require__.d(getter, 'a', getter);
 /******/ 		return getter;
 /******/ 	};
 /******/
 /******/ 	// Object.prototype.hasOwnProperty.call
 /******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
 /******/
 /******/ 	// __webpack_public_path__
 /******/ 	__webpack_require__.p = "/public/assets/scripts/";
 /******/
 /******/
 /******/ 	// Load entry module and return exports
 /******/ 	return __webpack_require__(__webpack_require__.s = 4);
 /******/ })
 /************************************************************************/
 /******/ ([
 /* 0 */
 /***/ (function(module, exports, __webpack_require__) {

 "use strict";


 var isMergeableObject = function isMergeableObject(value) {
   return isNonNullObject(value)
     && !isSpecial(value)
 };

 function isNonNullObject(value) {
   return !!value && typeof value === 'object'
 }

 function isSpecial(value) {
   var stringValue = Object.prototype.toString.call(value);

   return stringValue === '[object RegExp]'
     || stringValue === '[object Date]'
     || isReactElement(value)
 }

 // see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
 var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
 var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

 function isReactElement(value) {
   return value.$$typeof === REACT_ELEMENT_TYPE
 }

 function emptyTarget(val) {
   return Array.isArray(val) ? [] : {}
 }

 function cloneUnlessOtherwiseSpecified(value, options) {
   return (options.clone !== false && options.isMergeableObject(value))
     ? deepmerge(emptyTarget(value), value, options)
     : value
 }

 function defaultArrayMerge(target, source, options) {
   return target.concat(source).map(function(element) {
     return cloneUnlessOtherwiseSpecified(element, options)
   })
 }

 function getMergeFunction(key, options) {
   if (!options.customMerge) {
     return deepmerge
   }
   var customMerge = options.customMerge(key);
   return typeof customMerge === 'function' ? customMerge : deepmerge
 }

 function getEnumerableOwnPropertySymbols(target) {
   return Object.getOwnPropertySymbols
     ? Object.getOwnPropertySymbols(target).filter(function(symbol) {
       return target.propertyIsEnumerable(symbol)
     })
     : []
 }

 function getKeys(target) {
   return Object.keys(target).concat(getEnumerableOwnPropertySymbols(target))
 }

 // Protects from prototype poisoning and unexpected merging up the prototype chain.
 function propertyIsUnsafe(target, key) {
   try {
     return (key in target) // Properties are safe to merge if they don't exist in the target yet,
       && !(Object.hasOwnProperty.call(target, key) // unsafe if they exist up the prototype chain,
         && Object.propertyIsEnumerable.call(target, key)) // and also unsafe if they're nonenumerable.
   } catch (unused) {
     // Counterintuitively, it's safe to merge any property on a target that causes the `in` operator to throw.
     // This happens when trying to copy an object in the source over a plain string in the target.
     return false
   }
 }

 function mergeObject(target, source, options) {
   var destination = {};
   if (options.isMergeableObject(target)) {
     getKeys(target).forEach(function(key) {
       destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
     });
   }
   getKeys(source).forEach(function(key) {
     if (propertyIsUnsafe(target, key)) {
       return
     }

     if (!options.isMergeableObject(source[key]) || !target[key]) {
       destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
     } else {
       destination[key] = getMergeFunction(key, options)(target[key], source[key], options);
     }
   });
   return destination
 }

 function deepmerge(target, source, options) {
   options = options || {};
   options.arrayMerge = options.arrayMerge || defaultArrayMerge;
   options.isMergeableObject = options.isMergeableObject || isMergeableObject;
   // cloneUnlessOtherwiseSpecified is added to `options` so that custom arrayMerge()
   // implementations can use it. The caller may not replace it.
   options.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified;

   var sourceIsArray = Array.isArray(source);
   var targetIsArray = Array.isArray(target);
   var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

   if (!sourceAndTargetTypesMatch) {
     return cloneUnlessOtherwiseSpecified(source, options)
   } else if (sourceIsArray) {
     return options.arrayMerge(target, source, options)
   } else {
     return mergeObject(target, source, options)
   }
 }

 deepmerge.all = function deepmergeAll(array, options) {
   if (!Array.isArray(array)) {
     throw new Error('first argument should be an array')
   }

   return array.reduce(function(prev, next) {
     return deepmerge(prev, next, options)
   }, {})
 };

 var deepmerge_1 = deepmerge;

 module.exports = deepmerge_1;


 /***/ }),
 /* 1 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";
 /* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var _ponyfill_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3);
 /* global window */


 var root;

 if (typeof self !== 'undefined') {
   root = self;
 } else if (typeof window !== 'undefined') {
   root = window;
 } else if (typeof global !== 'undefined') {
   root = global;
 } else if (true) {
   root = module;
 } else {}

 var result = Object(_ponyfill_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(root);
 /* harmony default export */ __webpack_exports__["a"] = (result);

 /* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(5), __webpack_require__(6)(module)))

 /***/ }),
 /* 2 */
 /***/ (function(module, exports, __webpack_require__) {

 /*!
  * Fuse.js v3.4.5 - Lightweight fuzzy-search (http://fusejs.io)
  *
  * Copyright (c) 2012-2017 Kirollos Risk (http://kiro.me)
  * All Rights Reserved. Apache Software License 2.0
  *
  * http://www.apache.org/licenses/LICENSE-2.0
  */
 !function(e,t){ true?module.exports=t():undefined}(this,function(){return function(e){var t={};function n(r){if(t[r])return t[r].exports;var o=t[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,n),o.l=!0,o.exports}return n.m=e,n.c=t,n.d=function(e,t,r){n.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:r})},n.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},n.t=function(e,t){if(1&t&&(e=n(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(n.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var o in e)n.d(r,o,function(t){return e[t]}.bind(null,o));return r},n.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return n.d(t,"a",t),t},n.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},n.p="",n(n.s=1)}([function(e,t){e.exports=function(e){return Array.isArray?Array.isArray(e):"[object Array]"===Object.prototype.toString.call(e)}},function(e,t,n){function r(e){return(r="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function o(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}var i=n(2),a=n(8),s=n(0),c=function(){function e(t,n){var r=n.location,o=void 0===r?0:r,i=n.distance,s=void 0===i?100:i,c=n.threshold,h=void 0===c?.6:c,l=n.maxPatternLength,u=void 0===l?32:l,f=n.caseSensitive,d=void 0!==f&&f,v=n.tokenSeparator,p=void 0===v?/ +/g:v,g=n.findAllMatches,y=void 0!==g&&g,m=n.minMatchCharLength,k=void 0===m?1:m,S=n.id,x=void 0===S?null:S,b=n.keys,M=void 0===b?[]:b,_=n.shouldSort,L=void 0===_||_,w=n.getFn,A=void 0===w?a:w,C=n.sortFn,I=void 0===C?function(e,t){return e.score-t.score}:C,O=n.tokenize,j=void 0!==O&&O,P=n.matchAllTokens,F=void 0!==P&&P,T=n.includeMatches,z=void 0!==T&&T,E=n.includeScore,K=void 0!==E&&E,$=n.verbose,J=void 0!==$&&$;!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this.options={location:o,distance:s,threshold:h,maxPatternLength:u,isCaseSensitive:d,tokenSeparator:p,findAllMatches:y,minMatchCharLength:k,id:x,keys:M,includeMatches:z,includeScore:K,shouldSort:L,getFn:A,sortFn:I,verbose:J,tokenize:j,matchAllTokens:F},this.setCollection(t)}var t,n,c;return t=e,(n=[{key:"setCollection",value:function(e){return this.list=e,e}},{key:"search",value:function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{limit:!1};this._log('---------\nSearch pattern: "'.concat(e,'"'));var n=this._prepareSearchers(e),r=n.tokenSearchers,o=n.fullSearcher,i=this._search(r,o),a=i.weights,s=i.results;return this._computeScore(a,s),this.options.shouldSort&&this._sort(s),t.limit&&"number"==typeof t.limit&&(s=s.slice(0,t.limit)),this._format(s)}},{key:"_prepareSearchers",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"",t=[];if(this.options.tokenize)for(var n=e.split(this.options.tokenSeparator),r=0,o=n.length;r<o;r+=1)t.push(new i(n[r],this.options));return{tokenSearchers:t,fullSearcher:new i(e,this.options)}}},{key:"_search",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[],t=arguments.length>1?arguments[1]:void 0,n=this.list,r={},o=[];if("string"==typeof n[0]){for(var i=0,a=n.length;i<a;i+=1)this._analyze({key:"",value:n[i],record:i,index:i},{resultMap:r,results:o,tokenSearchers:e,fullSearcher:t});return{weights:null,results:o}}for(var s={},c=0,h=n.length;c<h;c+=1)for(var l=n[c],u=0,f=this.options.keys.length;u<f;u+=1){var d=this.options.keys[u];if("string"!=typeof d){if(s[d.name]={weight:1-d.weight||1},d.weight<=0||d.weight>1)throw new Error("Key weight has to be > 0 and <= 1");d=d.name}else s[d]={weight:1};this._analyze({key:d,value:this.options.getFn(l,d),record:l,index:c},{resultMap:r,results:o,tokenSearchers:e,fullSearcher:t})}return{weights:s,results:o}}},{key:"_analyze",value:function(e,t){var n=e.key,r=e.arrayIndex,o=void 0===r?-1:r,i=e.value,a=e.record,c=e.index,h=t.tokenSearchers,l=void 0===h?[]:h,u=t.fullSearcher,f=void 0===u?[]:u,d=t.resultMap,v=void 0===d?{}:d,p=t.results,g=void 0===p?[]:p;if(null!=i){var y=!1,m=-1,k=0;if("string"==typeof i){this._log("\nKey: ".concat(""===n?"-":n));var S=f.search(i);if(this._log('Full text: "'.concat(i,'", score: ').concat(S.score)),this.options.tokenize){for(var x=i.split(this.options.tokenSeparator),b=[],M=0;M<l.length;M+=1){var _=l[M];this._log('\nPattern: "'.concat(_.pattern,'"'));for(var L=!1,w=0;w<x.length;w+=1){var A=x[w],C=_.search(A),I={};C.isMatch?(I[A]=C.score,y=!0,L=!0,b.push(C.score)):(I[A]=1,this.options.matchAllTokens||b.push(1)),this._log('Token: "'.concat(A,'", score: ').concat(I[A]))}L&&(k+=1)}m=b[0];for(var O=b.length,j=1;j<O;j+=1)m+=b[j];m/=O,this._log("Token score average:",m)}var P=S.score;m>-1&&(P=(P+m)/2),this._log("Score average:",P);var F=!this.options.tokenize||!this.options.matchAllTokens||k>=l.length;if(this._log("\nCheck Matches: ".concat(F)),(y||S.isMatch)&&F){var T=v[c];T?T.output.push({key:n,arrayIndex:o,value:i,score:P,matchedIndices:S.matchedIndices}):(v[c]={item:a,output:[{key:n,arrayIndex:o,value:i,score:P,matchedIndices:S.matchedIndices}]},g.push(v[c]))}}else if(s(i))for(var z=0,E=i.length;z<E;z+=1)this._analyze({key:n,arrayIndex:z,value:i[z],record:a,index:c},{resultMap:v,results:g,tokenSearchers:l,fullSearcher:f})}}},{key:"_computeScore",value:function(e,t){this._log("\n\nComputing score:\n");for(var n=0,r=t.length;n<r;n+=1){for(var o=t[n].output,i=o.length,a=1,s=1,c=0;c<i;c+=1){var h=e?e[o[c].key].weight:1,l=(1===h?o[c].score:o[c].score||.001)*h;1!==h?s=Math.min(s,l):(o[c].nScore=l,a*=l)}t[n].score=1===s?a:s,this._log(t[n])}}},{key:"_sort",value:function(e){this._log("\n\nSorting...."),e.sort(this.options.sortFn)}},{key:"_format",value:function(e){var t=[];if(this.options.verbose){var n=[];this._log("\n\nOutput:\n\n",JSON.stringify(e,function(e,t){if("object"===r(t)&&null!==t){if(-1!==n.indexOf(t))return;n.push(t)}return t})),n=null}var o=[];this.options.includeMatches&&o.push(function(e,t){var n=e.output;t.matches=[];for(var r=0,o=n.length;r<o;r+=1){var i=n[r];if(0!==i.matchedIndices.length){var a={indices:i.matchedIndices,value:i.value};i.key&&(a.key=i.key),i.hasOwnProperty("arrayIndex")&&i.arrayIndex>-1&&(a.arrayIndex=i.arrayIndex),t.matches.push(a)}}}),this.options.includeScore&&o.push(function(e,t){t.score=e.score});for(var i=0,a=e.length;i<a;i+=1){var s=e[i];if(this.options.id&&(s.item=this.options.getFn(s.item,this.options.id)[0]),o.length){for(var c={item:s.item},h=0,l=o.length;h<l;h+=1)o[h](s,c);t.push(c)}else t.push(s.item)}return t}},{key:"_log",value:function(){var e;this.options.verbose&&(e=console).log.apply(e,arguments)}}])&&o(t.prototype,n),c&&o(t,c),e}();e.exports=c},function(e,t,n){function r(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}var o=n(3),i=n(4),a=n(7),s=function(){function e(t,n){var r=n.location,o=void 0===r?0:r,i=n.distance,s=void 0===i?100:i,c=n.threshold,h=void 0===c?.6:c,l=n.maxPatternLength,u=void 0===l?32:l,f=n.isCaseSensitive,d=void 0!==f&&f,v=n.tokenSeparator,p=void 0===v?/ +/g:v,g=n.findAllMatches,y=void 0!==g&&g,m=n.minMatchCharLength,k=void 0===m?1:m;!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this.options={location:o,distance:s,threshold:h,maxPatternLength:u,isCaseSensitive:d,tokenSeparator:p,findAllMatches:y,minMatchCharLength:k},this.pattern=this.options.isCaseSensitive?t:t.toLowerCase(),this.pattern.length<=u&&(this.patternAlphabet=a(this.pattern))}var t,n,s;return t=e,(n=[{key:"search",value:function(e){if(this.options.isCaseSensitive||(e=e.toLowerCase()),this.pattern===e)return{isMatch:!0,score:0,matchedIndices:[[0,e.length-1]]};var t=this.options,n=t.maxPatternLength,r=t.tokenSeparator;if(this.pattern.length>n)return o(e,this.pattern,r);var a=this.options,s=a.location,c=a.distance,h=a.threshold,l=a.findAllMatches,u=a.minMatchCharLength;return i(e,this.pattern,this.patternAlphabet,{location:s,distance:c,threshold:h,findAllMatches:l,minMatchCharLength:u})}}])&&r(t.prototype,n),s&&r(t,s),e}();e.exports=s},function(e,t){var n=/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g;e.exports=function(e,t){var r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:/ +/g,o=new RegExp(t.replace(n,"\\$&").replace(r,"|")),i=e.match(o),a=!!i,s=[];if(a)for(var c=0,h=i.length;c<h;c+=1){var l=i[c];s.push([e.indexOf(l),l.length-1])}return{score:a?.5:1,isMatch:a,matchedIndices:s}}},function(e,t,n){var r=n(5),o=n(6);e.exports=function(e,t,n,i){for(var a=i.location,s=void 0===a?0:a,c=i.distance,h=void 0===c?100:c,l=i.threshold,u=void 0===l?.6:l,f=i.findAllMatches,d=void 0!==f&&f,v=i.minMatchCharLength,p=void 0===v?1:v,g=s,y=e.length,m=u,k=e.indexOf(t,g),S=t.length,x=[],b=0;b<y;b+=1)x[b]=0;if(-1!==k){var M=r(t,{errors:0,currentLocation:k,expectedLocation:g,distance:h});if(m=Math.min(M,m),-1!==(k=e.lastIndexOf(t,g+S))){var _=r(t,{errors:0,currentLocation:k,expectedLocation:g,distance:h});m=Math.min(_,m)}}k=-1;for(var L=[],w=1,A=S+y,C=1<<S-1,I=0;I<S;I+=1){for(var O=0,j=A;O<j;){r(t,{errors:I,currentLocation:g+j,expectedLocation:g,distance:h})<=m?O=j:A=j,j=Math.floor((A-O)/2+O)}A=j;var P=Math.max(1,g-j+1),F=d?y:Math.min(g+j,y)+S,T=Array(F+2);T[F+1]=(1<<I)-1;for(var z=F;z>=P;z-=1){var E=z-1,K=n[e.charAt(E)];if(K&&(x[E]=1),T[z]=(T[z+1]<<1|1)&K,0!==I&&(T[z]|=(L[z+1]|L[z])<<1|1|L[z+1]),T[z]&C&&(w=r(t,{errors:I,currentLocation:E,expectedLocation:g,distance:h}))<=m){if(m=w,(k=E)<=g)break;P=Math.max(1,2*g-k)}}if(r(t,{errors:I+1,currentLocation:g,expectedLocation:g,distance:h})>m)break;L=T}return{isMatch:k>=0,score:0===w?.001:w,matchedIndices:o(x,p)}}},function(e,t){e.exports=function(e,t){var n=t.errors,r=void 0===n?0:n,o=t.currentLocation,i=void 0===o?0:o,a=t.expectedLocation,s=void 0===a?0:a,c=t.distance,h=void 0===c?100:c,l=r/e.length,u=Math.abs(s-i);return h?l+u/h:u?1:l}},function(e,t){e.exports=function(){for(var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[],t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:1,n=[],r=-1,o=-1,i=0,a=e.length;i<a;i+=1){var s=e[i];s&&-1===r?r=i:s||-1===r||((o=i-1)-r+1>=t&&n.push([r,o]),r=-1)}return e[i-1]&&i-r>=t&&n.push([r,i-1]),n}},function(e,t){e.exports=function(e){for(var t={},n=e.length,r=0;r<n;r+=1)t[e.charAt(r)]=0;for(var o=0;o<n;o+=1)t[e.charAt(o)]|=1<<n-o-1;return t}},function(e,t,n){var r=n(0);e.exports=function(e,t){return function e(t,n,o){if(n){var i=n.indexOf("."),a=n,s=null;-1!==i&&(a=n.slice(0,i),s=n.slice(i+1));var c=t[a];if(null!=c)if(s||"string"!=typeof c&&"number"!=typeof c)if(r(c))for(var h=0,l=c.length;h<l;h+=1)e(c[h],s,o);else s&&e(c,s,o);else o.push(c.toString())}else o.push(t);return o}(e,t,[])}}])});

 /***/ }),
 /* 3 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";
 /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return symbolObservablePonyfill; });
 function symbolObservablePonyfill(root) {
   var result;
   var Symbol = root.Symbol;

   if (typeof Symbol === 'function') {
     if (Symbol.observable) {
       result = Symbol.observable;
     } else {
       result = Symbol('observable');
       Symbol.observable = result;
     }
   } else {
     result = '@@observable';
   }

   return result;
 };


 /***/ }),
 /* 4 */
 /***/ (function(module, exports, __webpack_require__) {

 module.exports = __webpack_require__(7);


 /***/ }),
 /* 5 */
 /***/ (function(module, exports) {

 var g;

 // This works in non-strict mode
 g = (function() {
   return this;
 })();

 try {
   // This works if eval is allowed (see CSP)
   g = g || new Function("return this")();
 } catch (e) {
   // This works if the window reference is available
   if (typeof window === "object") g = window;
 }

 // g can still be undefined, but nothing to do about it...
 // We return undefined, instead of nothing here, so it's
 // easier to handle this case. if(!global) { ...}

 module.exports = g;


 /***/ }),
 /* 6 */
 /***/ (function(module, exports) {

 module.exports = function(originalModule) {
   if (!originalModule.webpackPolyfill) {
     var module = Object.create(originalModule);
     // module.parent = undefined by default
     if (!module.children) module.children = [];
     Object.defineProperty(module, "loaded", {
       enumerable: true,
       get: function() {
         return module.l;
       }
     });
     Object.defineProperty(module, "id", {
       enumerable: true,
       get: function() {
         return module.i;
       }
     });
     Object.defineProperty(module, "exports", {
       enumerable: true
     });
     module.webpackPolyfill = 1;
   }
   return module;
 };


 /***/ }),
 /* 7 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";
 __webpack_require__.r(__webpack_exports__);

 // EXTERNAL MODULE: ./node_modules/fuse.js/dist/fuse.js
 var dist_fuse = __webpack_require__(2);
 var fuse_default = /*#__PURE__*/__webpack_require__.n(dist_fuse);

 // EXTERNAL MODULE: ./node_modules/deepmerge/dist/cjs.js
 var cjs = __webpack_require__(0);
 var cjs_default = /*#__PURE__*/__webpack_require__.n(cjs);

 // EXTERNAL MODULE: ./node_modules/symbol-observable/es/index.js
 var es = __webpack_require__(1);

 // CONCATENATED MODULE: ./node_modules/redux/es/redux.js


 /**
  * These are private action types reserved by Redux.
  * For any unknown actions, you must return the current state.
  * If the current state is undefined, you must return the initial state.
  * Do not reference these action types directly in your code.
  */
 var randomString = function randomString() {
   return Math.random().toString(36).substring(7).split('').join('.');
 };

 var ActionTypes = {
   INIT: "@@redux/INIT" + randomString(),
   REPLACE: "@@redux/REPLACE" + randomString(),
   PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
     return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
   }
 };

 /**
  * @param {any} obj The object to inspect.
  * @returns {boolean} True if the argument appears to be a plain object.
  */
 function isPlainObject(obj) {
   if (typeof obj !== 'object' || obj === null) return false;
   var proto = obj;

   while (Object.getPrototypeOf(proto) !== null) {
     proto = Object.getPrototypeOf(proto);
   }

   return Object.getPrototypeOf(obj) === proto;
 }

 /**
  * Creates a Redux store that holds the state tree.
  * The only way to change the data in the store is to call `dispatch()` on it.
  *
  * There should only be a single store in your app. To specify how different
  * parts of the state tree respond to actions, you may combine several reducers
  * into a single reducer function by using `combineReducers`.
  *
  * @param {Function} reducer A function that returns the next state tree, given
  * the current state tree and the action to handle.
  *
  * @param {any} [preloadedState] The initial state. You may optionally specify it
  * to hydrate the state from the server in universal apps, or to restore a
  * previously serialized user session.
  * If you use `combineReducers` to produce the root reducer function, this must be
  * an object with the same shape as `combineReducers` keys.
  *
  * @param {Function} [enhancer] The store enhancer. You may optionally specify it
  * to enhance the store with third-party capabilities such as middleware,
  * time travel, persistence, etc. The only store enhancer that ships with Redux
  * is `applyMiddleware()`.
  *
  * @returns {Store} A Redux store that lets you read the state, dispatch actions
  * and subscribe to changes.
  */

 function createStore(reducer, preloadedState, enhancer) {
   var _ref2;

   if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') {
     throw new Error('It looks like you are passing several store enhancers to ' + 'createStore(). This is not supported. Instead, compose them ' + 'together to a single function.');
   }

   if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
     enhancer = preloadedState;
     preloadedState = undefined;
   }

   if (typeof enhancer !== 'undefined') {
     if (typeof enhancer !== 'function') {
       throw new Error('Expected the enhancer to be a function.');
     }

     return enhancer(createStore)(reducer, preloadedState);
   }

   if (typeof reducer !== 'function') {
     throw new Error('Expected the reducer to be a function.');
   }

   var currentReducer = reducer;
   var currentState = preloadedState;
   var currentListeners = [];
   var nextListeners = currentListeners;
   var isDispatching = false;
   /**
    * This makes a shallow copy of currentListeners so we can use
    * nextListeners as a temporary list while dispatching.
    *
    * This prevents any bugs around consumers calling
    * subscribe/unsubscribe in the middle of a dispatch.
    */

   function ensureCanMutateNextListeners() {
     if (nextListeners === currentListeners) {
       nextListeners = currentListeners.slice();
     }
   }
   /**
    * Reads the state tree managed by the store.
    *
    * @returns {any} The current state tree of your application.
    */


   function getState() {
     if (isDispatching) {
       throw new Error('You may not call store.getState() while the reducer is executing. ' + 'The reducer has already received the state as an argument. ' + 'Pass it down from the top reducer instead of reading it from the store.');
     }

     return currentState;
   }
   /**
    * Adds a change listener. It will be called any time an action is dispatched,
    * and some part of the state tree may potentially have changed. You may then
    * call `getState()` to read the current state tree inside the callback.
    *
    * You may call `dispatch()` from a change listener, with the following
    * caveats:
    *
    * 1. The subscriptions are snapshotted just before every `dispatch()` call.
    * If you subscribe or unsubscribe while the listeners are being invoked, this
    * will not have any effect on the `dispatch()` that is currently in progress.
    * However, the next `dispatch()` call, whether nested or not, will use a more
    * recent snapshot of the subscription list.
    *
    * 2. The listener should not expect to see all state changes, as the state
    * might have been updated multiple times during a nested `dispatch()` before
    * the listener is called. It is, however, guaranteed that all subscribers
    * registered before the `dispatch()` started will be called with the latest
    * state by the time it exits.
    *
    * @param {Function} listener A callback to be invoked on every dispatch.
    * @returns {Function} A function to remove this change listener.
    */


   function subscribe(listener) {
     if (typeof listener !== 'function') {
       throw new Error('Expected the listener to be a function.');
     }

     if (isDispatching) {
       throw new Error('You may not call store.subscribe() while the reducer is executing. ' + 'If you would like to be notified after the store has been updated, subscribe from a ' + 'component and invoke store.getState() in the callback to access the latest state. ' + 'See https://redux.js.org/api-reference/store#subscribe(listener) for more details.');
     }

     var isSubscribed = true;
     ensureCanMutateNextListeners();
     nextListeners.push(listener);
     return function unsubscribe() {
       if (!isSubscribed) {
         return;
       }

       if (isDispatching) {
         throw new Error('You may not unsubscribe from a store listener while the reducer is executing. ' + 'See https://redux.js.org/api-reference/store#subscribe(listener) for more details.');
       }

       isSubscribed = false;
       ensureCanMutateNextListeners();
       var index = nextListeners.indexOf(listener);
       nextListeners.splice(index, 1);
     };
   }
   /**
    * Dispatches an action. It is the only way to trigger a state change.
    *
    * The `reducer` function, used to create the store, will be called with the
    * current state tree and the given `action`. Its return value will
    * be considered the **next** state of the tree, and the change listeners
    * will be notified.
    *
    * The base implementation only supports plain object actions. If you want to
    * dispatch a Promise, an Observable, a thunk, or something else, you need to
    * wrap your store creating function into the corresponding middleware. For
    * example, see the documentation for the `redux-thunk` package. Even the
    * middleware will eventually dispatch plain object actions using this method.
    *
    * @param {Object} action A plain object representing “what changed”. It is
    * a good idea to keep actions serializable so you can record and replay user
    * sessions, or use the time travelling `redux-devtools`. An action must have
    * a `type` property which may not be `undefined`. It is a good idea to use
    * string constants for action types.
    *
    * @returns {Object} For convenience, the same action object you dispatched.
    *
    * Note that, if you use a custom middleware, it may wrap `dispatch()` to
    * return something else (for example, a Promise you can await).
    */


   function dispatch(action) {
     if (!isPlainObject(action)) {
       throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
     }

     if (typeof action.type === 'undefined') {
       throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
     }

     if (isDispatching) {
       throw new Error('Reducers may not dispatch actions.');
     }

     try {
       isDispatching = true;
       currentState = currentReducer(currentState, action);
     } finally {
       isDispatching = false;
     }

     var listeners = currentListeners = nextListeners;

     for (var i = 0; i < listeners.length; i++) {
       var listener = listeners[i];
       listener();
     }

     return action;
   }
   /**
    * Replaces the reducer currently used by the store to calculate the state.
    *
    * You might need this if your app implements code splitting and you want to
    * load some of the reducers dynamically. You might also need this if you
    * implement a hot reloading mechanism for Redux.
    *
    * @param {Function} nextReducer The reducer for the store to use instead.
    * @returns {void}
    */


   function replaceReducer(nextReducer) {
     if (typeof nextReducer !== 'function') {
       throw new Error('Expected the nextReducer to be a function.');
     }

     currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
     // Any reducers that existed in both the new and old rootReducer
     // will receive the previous state. This effectively populates
     // the new state tree with any relevant data from the old one.

     dispatch({
       type: ActionTypes.REPLACE
     });
   }
   /**
    * Interoperability point for observable/reactive libraries.
    * @returns {observable} A minimal observable of state changes.
    * For more information, see the observable proposal:
    * https://github.com/tc39/proposal-observable
    */


   function observable() {
     var _ref;

     var outerSubscribe = subscribe;
     return _ref = {
       /**
        * The minimal observable subscription method.
        * @param {Object} observer Any object that can be used as an observer.
        * The observer object should have a `next` method.
        * @returns {subscription} An object with an `unsubscribe` method that can
        * be used to unsubscribe the observable from the store, and prevent further
        * emission of values from the observable.
        */
       subscribe: function subscribe(observer) {
         if (typeof observer !== 'object' || observer === null) {
           throw new TypeError('Expected the observer to be an object.');
         }

         function observeState() {
           if (observer.next) {
             observer.next(getState());
           }
         }

         observeState();
         var unsubscribe = outerSubscribe(observeState);
         return {
           unsubscribe: unsubscribe
         };
       }
     }, _ref[es["a" /* default */]] = function () {
       return this;
     }, _ref;
   } // When a store is created, an "INIT" action is dispatched so that every
   // reducer returns their initial state. This effectively populates
   // the initial state tree.


   dispatch({
     type: ActionTypes.INIT
   });
   return _ref2 = {
     dispatch: dispatch,
     subscribe: subscribe,
     getState: getState,
     replaceReducer: replaceReducer
   }, _ref2[es["a" /* default */]] = observable, _ref2;
 }

 /**
  * Prints a warning in the console if it exists.
  *
  * @param {String} message The warning message.
  * @returns {void}
  */
 function warning(message) {
   /* eslint-disable no-console */
   if (typeof console !== 'undefined' && typeof console.error === 'function') {
     console.error(message);
   }
   /* eslint-enable no-console */


   try {
     // This error was thrown as a convenience so that if you enable
     // "break on all exceptions" in your console,
     // it would pause the execution at this line.
     throw new Error(message);
   } catch (e) {} // eslint-disable-line no-empty

 }

 function getUndefinedStateErrorMessage(key, action) {
   var actionType = action && action.type;
   var actionDescription = actionType && "action \"" + String(actionType) + "\"" || 'an action';
   return "Given " + actionDescription + ", reducer \"" + key + "\" returned undefined. " + "To ignore an action, you must explicitly return the previous state. " + "If you want this reducer to hold no value, you can return null instead of undefined.";
 }

 function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
   var reducerKeys = Object.keys(reducers);
   var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

   if (reducerKeys.length === 0) {
     return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
   }

   if (!isPlainObject(inputState)) {
     return "The " + argumentName + " has unexpected type of \"" + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
   }

   var unexpectedKeys = Object.keys(inputState).filter(function (key) {
     return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
   });
   unexpectedKeys.forEach(function (key) {
     unexpectedKeyCache[key] = true;
   });
   if (action && action.type === ActionTypes.REPLACE) return;

   if (unexpectedKeys.length > 0) {
     return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
   }
 }

 function assertReducerShape(reducers) {
   Object.keys(reducers).forEach(function (key) {
     var reducer = reducers[key];
     var initialState = reducer(undefined, {
       type: ActionTypes.INIT
     });

     if (typeof initialState === 'undefined') {
       throw new Error("Reducer \"" + key + "\" returned undefined during initialization. " + "If the state passed to the reducer is undefined, you must " + "explicitly return the initial state. The initial state may " + "not be undefined. If you don't want to set a value for this reducer, " + "you can use null instead of undefined.");
     }

     if (typeof reducer(undefined, {
       type: ActionTypes.PROBE_UNKNOWN_ACTION()
     }) === 'undefined') {
       throw new Error("Reducer \"" + key + "\" returned undefined when probed with a random type. " + ("Don't try to handle " + ActionTypes.INIT + " or other actions in \"redux/*\" ") + "namespace. They are considered private. Instead, you must return the " + "current state for any unknown actions, unless it is undefined, " + "in which case you must return the initial state, regardless of the " + "action type. The initial state may not be undefined, but can be null.");
     }
   });
 }
 /**
  * Turns an object whose values are different reducer functions, into a single
  * reducer function. It will call every child reducer, and gather their results
  * into a single state object, whose keys correspond to the keys of the passed
  * reducer functions.
  *
  * @param {Object} reducers An object whose values correspond to different
  * reducer functions that need to be combined into one. One handy way to obtain
  * it is to use ES6 `import * as reducers` syntax. The reducers may never return
  * undefined for any action. Instead, they should return their initial state
  * if the state passed to them was undefined, and the current state for any
  * unrecognized action.
  *
  * @returns {Function} A reducer function that invokes every reducer inside the
  * passed object, and builds a state object with the same shape.
  */


 function combineReducers(reducers) {
   var reducerKeys = Object.keys(reducers);
   var finalReducers = {};

   for (var i = 0; i < reducerKeys.length; i++) {
     var key = reducerKeys[i];

     if (false) {}

     if (typeof reducers[key] === 'function') {
       finalReducers[key] = reducers[key];
     }
   }

   var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
   // keys multiple times.

   var unexpectedKeyCache;

   if (false) {}

   var shapeAssertionError;

   try {
     assertReducerShape(finalReducers);
   } catch (e) {
     shapeAssertionError = e;
   }

   return function combination(state, action) {
     if (state === void 0) {
       state = {};
     }

     if (shapeAssertionError) {
       throw shapeAssertionError;
     }

     if (false) { var warningMessage; }

     var hasChanged = false;
     var nextState = {};

     for (var _i = 0; _i < finalReducerKeys.length; _i++) {
       var _key = finalReducerKeys[_i];
       var reducer = finalReducers[_key];
       var previousStateForKey = state[_key];
       var nextStateForKey = reducer(previousStateForKey, action);

       if (typeof nextStateForKey === 'undefined') {
         var errorMessage = getUndefinedStateErrorMessage(_key, action);
         throw new Error(errorMessage);
       }

       nextState[_key] = nextStateForKey;
       hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
     }

     return hasChanged ? nextState : state;
   };
 }

 function bindActionCreator(actionCreator, dispatch) {
   return function () {
     return dispatch(actionCreator.apply(this, arguments));
   };
 }
 /**
  * Turns an object whose values are action creators, into an object with the
  * same keys, but with every function wrapped into a `dispatch` call so they
  * may be invoked directly. This is just a convenience method, as you can call
  * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
  *
  * For convenience, you can also pass an action creator as the first argument,
  * and get a dispatch wrapped function in return.
  *
  * @param {Function|Object} actionCreators An object whose values are action
  * creator functions. One handy way to obtain it is to use ES6 `import * as`
  * syntax. You may also pass a single function.
  *
  * @param {Function} dispatch The `dispatch` function available on your Redux
  * store.
  *
  * @returns {Function|Object} The object mimicking the original object, but with
  * every action creator wrapped into the `dispatch` call. If you passed a
  * function as `actionCreators`, the return value will also be a single
  * function.
  */


 function bindActionCreators(actionCreators, dispatch) {
   if (typeof actionCreators === 'function') {
     return bindActionCreator(actionCreators, dispatch);
   }

   if (typeof actionCreators !== 'object' || actionCreators === null) {
     throw new Error("bindActionCreators expected an object or a function, instead received " + (actionCreators === null ? 'null' : typeof actionCreators) + ". " + "Did you write \"import ActionCreators from\" instead of \"import * as ActionCreators from\"?");
   }

   var boundActionCreators = {};

   for (var key in actionCreators) {
     var actionCreator = actionCreators[key];

     if (typeof actionCreator === 'function') {
       boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
     }
   }

   return boundActionCreators;
 }

 function _defineProperty(obj, key, value) {
   if (key in obj) {
     Object.defineProperty(obj, key, {
       value: value,
       enumerable: true,
       configurable: true,
       writable: true
     });
   } else {
     obj[key] = value;
   }

   return obj;
 }

 function ownKeys(object, enumerableOnly) {
   var keys = Object.keys(object);

   if (Object.getOwnPropertySymbols) {
     keys.push.apply(keys, Object.getOwnPropertySymbols(object));
   }

   if (enumerableOnly) keys = keys.filter(function (sym) {
     return Object.getOwnPropertyDescriptor(object, sym).enumerable;
   });
   return keys;
 }

 function _objectSpread2(target) {
   for (var i = 1; i < arguments.length; i++) {
     var source = arguments[i] != null ? arguments[i] : {};

     if (i % 2) {
       ownKeys(source, true).forEach(function (key) {
         _defineProperty(target, key, source[key]);
       });
     } else if (Object.getOwnPropertyDescriptors) {
       Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
     } else {
       ownKeys(source).forEach(function (key) {
         Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
       });
     }
   }

   return target;
 }

 /**
  * Composes single-argument functions from right to left. The rightmost
  * function can take multiple arguments as it provides the signature for
  * the resulting composite function.
  *
  * @param {...Function} funcs The functions to compose.
  * @returns {Function} A function obtained by composing the argument functions
  * from right to left. For example, compose(f, g, h) is identical to doing
  * (...args) => f(g(h(...args))).
  */
 function compose() {
   for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
     funcs[_key] = arguments[_key];
   }

   if (funcs.length === 0) {
     return function (arg) {
       return arg;
     };
   }

   if (funcs.length === 1) {
     return funcs[0];
   }

   return funcs.reduce(function (a, b) {
     return function () {
       return a(b.apply(void 0, arguments));
     };
   });
 }

 /**
  * Creates a store enhancer that applies middleware to the dispatch method
  * of the Redux store. This is handy for a variety of tasks, such as expressing
  * asynchronous actions in a concise manner, or logging every action payload.
  *
  * See `redux-thunk` package as an example of the Redux middleware.
  *
  * Because middleware is potentially asynchronous, this should be the first
  * store enhancer in the composition chain.
  *
  * Note that each middleware will be given the `dispatch` and `getState` functions
  * as named arguments.
  *
  * @param {...Function} middlewares The middleware chain to be applied.
  * @returns {Function} A store enhancer applying the middleware.
  */

 function applyMiddleware() {
   for (var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++) {
     middlewares[_key] = arguments[_key];
   }

   return function (createStore) {
     return function () {
       var store = createStore.apply(void 0, arguments);

       var _dispatch = function dispatch() {
         throw new Error('Dispatching while constructing your middleware is not allowed. ' + 'Other middleware would not be applied to this dispatch.');
       };

       var middlewareAPI = {
         getState: store.getState,
         dispatch: function dispatch() {
           return _dispatch.apply(void 0, arguments);
         }
       };
       var chain = middlewares.map(function (middleware) {
         return middleware(middlewareAPI);
       });
       _dispatch = compose.apply(void 0, chain)(store.dispatch);
       return _objectSpread2({}, store, {
         dispatch: _dispatch
       });
     };
   };
 }

 /*
  * This is a dummy function to check if the function name has been altered by minification.
  * If the function has been minified and NODE_ENV !== 'production', warn the user.
  */

 function isCrushed() {}

 if (false) {}



 // CONCATENATED MODULE: ./src/scripts/reducers/items.js
 var defaultState = [];
 function items_items(state, action) {
   if (state === void 0) {
     state = defaultState;
   }

   switch (action.type) {
     case 'ADD_ITEM':
       {
         // Add object to items array
         var newState = [].concat(state, [{
           id: action.id,
           choiceId: action.choiceId,
           groupId: action.groupId,
           value: action.value,
           label: action.label,
           active: true,
           highlighted: false,
           customProperties: action.customProperties,
           placeholder: action.placeholder || false,
           keyCode: null
         }]);
         return newState.map(function (obj) {
           var item = obj;
           item.highlighted = false;
           return item;
         });
       }

     case 'REMOVE_ITEM':
       {
         // Set item to inactive
         return state.map(function (obj) {
           var item = obj;

           if (item.id === action.id) {
             item.active = false;
           }

           return item;
         });
       }

     case 'HIGHLIGHT_ITEM':
       {
         return state.map(function (obj) {
           var item = obj;

           if (item.id === action.id) {
             item.highlighted = action.highlighted;
           }

           return item;
         });
       }

     default:
       {
         return state;
       }
   }
 }
 // CONCATENATED MODULE: ./src/scripts/reducers/groups.js
 var groups_defaultState = [];
 function groups(state, action) {
   if (state === void 0) {
     state = groups_defaultState;
   }

   switch (action.type) {
     case 'ADD_GROUP':
       {
         return [].concat(state, [{
           id: action.id,
           value: action.value,
           active: action.active,
           disabled: action.disabled
         }]);
       }

     case 'CLEAR_CHOICES':
       {
         return [];
       }

     default:
       {
         return state;
       }
   }
 }
 // CONCATENATED MODULE: ./src/scripts/reducers/choices.js
 var choices_defaultState = [];
 function choices_choices(state, action) {
   if (state === void 0) {
     state = choices_defaultState;
   }

   switch (action.type) {
     case 'ADD_CHOICE':
       {
         /*
             A disabled choice appears in the choice dropdown but cannot be selected
             A selected choice has been added to the passed input's value (added as an item)
             An active choice appears within the choice dropdown
          */
         return [].concat(state, [{
           id: action.id,
           elementId: action.elementId,
           groupId: action.groupId,
           value: action.value,
           label: action.label || action.value,
           disabled: action.disabled || false,
           selected: false,
           active: true,
           score: 9999,
           customProperties: action.customProperties,
           placeholder: action.placeholder || false,
           keyCode: null
         }]);
       }

     case 'ADD_ITEM':
       {
         // If all choices need to be activated
         if (action.activateOptions) {
           return state.map(function (obj) {
             var choice = obj;
             choice.active = action.active;
             return choice;
           });
         } // When an item is added and it has an associated choice,
         // we want to disable it so it can't be chosen again


         if (action.choiceId > -1) {
           return state.map(function (obj) {
             var choice = obj;

             if (choice.id === parseInt(action.choiceId, 10)) {
               choice.selected = true;
             }

             return choice;
           });
         }

         return state;
       }

     case 'REMOVE_ITEM':
       {
         // When an item is removed and it has an associated choice,
         // we want to re-enable it so it can be chosen again
         if (action.choiceId > -1) {
           return state.map(function (obj) {
             var choice = obj;

             if (choice.id === parseInt(action.choiceId, 10)) {
               choice.selected = false;
             }

             return choice;
           });
         }

         return state;
       }

     case 'FILTER_CHOICES':
       {
         return state.map(function (obj) {
           var choice = obj; // Set active state based on whether choice is
           // within filtered results

           choice.active = action.results.some(function (_ref) {
             var item = _ref.item,
                 score = _ref.score;

             if (item.id === choice.id) {
               choice.score = score;
               return true;
             }

             return false;
           });
           return choice;
         });
       }

     case 'ACTIVATE_CHOICES':
       {
         return state.map(function (obj) {
           var choice = obj;
           choice.active = action.active;
           return choice;
         });
       }

     case 'CLEAR_CHOICES':
       {
         return choices_defaultState;
       }

     default:
       {
         return state;
       }
   }
 }
 // CONCATENATED MODULE: ./src/scripts/reducers/general.js
 var general_defaultState = {
   loading: false
 };

 var general = function general(state, action) {
   if (state === void 0) {
     state = general_defaultState;
   }

   switch (action.type) {
     case 'SET_IS_LOADING':
       {
         return {
           loading: action.isLoading
         };
       }

     default:
       {
         return state;
       }
   }
 };

 /* harmony default export */ var reducers_general = (general);
 // CONCATENATED MODULE: ./src/scripts/lib/utils.js
 /**
  * @param {number} min
  * @param {number} max
  * @returns {number}
  */
 var getRandomNumber = function getRandomNumber(min, max) {
   return Math.floor(Math.random() * (max - min) + min);
 };
 /**
  * @param {number} length
  * @returns {string}
  */

 var generateChars = function generateChars(length) {
   return Array.from({
     length: length
   }, function () {
     return getRandomNumber(0, 36).toString(36);
   }).join('');
 };
 /**
  * @param {HTMLInputElement | HTMLSelectElement} element
  * @param {string} prefix
  * @returns {string}
  */

 var generateId = function generateId(element, prefix) {
   var id = element.id || element.name && element.name + "-" + generateChars(2) || generateChars(4);
   id = id.replace(/(:|\.|\[|\]|,)/g, '');
   id = prefix + "-" + id;
   return id;
 };
 /**
  * @param {any} obj
  * @returns {string}
  */

 var getType = function getType(obj) {
   return Object.prototype.toString.call(obj).slice(8, -1);
 };
 /**
  * @param {string} type
  * @param {any} obj
  * @returns {boolean}
  */

 var isType = function isType(type, obj) {
   return obj !== undefined && obj !== null && getType(obj) === type;
 };
 /**
  * @param {HTMLElement} element
  * @param {HTMLElement} [wrapper={HTMLDivElement}]
  * @returns {HTMLElement}
  */

 var utils_wrap = function wrap(element, wrapper) {
   if (wrapper === void 0) {
     wrapper = document.createElement('div');
   }

   if (element.nextSibling) {
     element.parentNode.insertBefore(wrapper, element.nextSibling);
   } else {
     element.parentNode.appendChild(wrapper);
   }

   return wrapper.appendChild(element);
 };
 /**
  * @param {Element} startEl
  * @param {string} selector
  * @param {1 | -1} direction
  * @returns {Element | undefined}
  */

 var getAdjacentEl = function getAdjacentEl(startEl, selector, direction) {
   if (direction === void 0) {
     direction = 1;
   }

   if (!(startEl instanceof Element) || typeof selector !== 'string') {
     return undefined;
   }

   var prop = (direction > 0 ? 'next' : 'previous') + "ElementSibling";
   var sibling = startEl[prop];

   while (sibling) {
     if (sibling.matches(selector)) {
       return sibling;
     }

     sibling = sibling[prop];
   }

   return sibling;
 };
 /**
  * @param {Element} element
  * @param {Element} parent
  * @param {-1 | 1} direction
  * @returns {boolean}
  */

 var isScrolledIntoView = function isScrolledIntoView(element, parent, direction) {
   if (direction === void 0) {
     direction = 1;
   }

   if (!element) {
     return false;
   }

   var isVisible;

   if (direction > 0) {
     // In view from bottom
     isVisible = parent.scrollTop + parent.offsetHeight >= element.offsetTop + element.offsetHeight;
   } else {
     // In view from top
     isVisible = element.offsetTop >= parent.scrollTop;
   }

   return isVisible;
 };
 /**
  * @param {any} value
  * @returns {any}
  */

 var sanitise = function sanitise(value) {
   if (typeof value !== 'string') {
     return value;
   }

   return value.replace(/&/g, '&amp;').replace(/>/g, '&rt;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
 };
 /**
  * @returns {() => (str: string) => Element}
  */

 var strToEl = function () {
   var tmpEl = document.createElement('div');
   return function (str) {
     var cleanedInput = str.trim();
     tmpEl.innerHTML = cleanedInput;
     var firldChild = tmpEl.children[0];

     while (tmpEl.firstChild) {
       tmpEl.removeChild(tmpEl.firstChild);
     }

     return firldChild;
   };
 }();
 /**
  * @param {{ label?: string, value: string }} a
  * @param {{ label?: string, value: string }} b
  * @returns {number}
  */

 var sortByAlpha = function sortByAlpha(_ref, _ref2) {
   var value = _ref.value,
       _ref$label = _ref.label,
       label = _ref$label === void 0 ? value : _ref$label;
   var value2 = _ref2.value,
       _ref2$label = _ref2.label,
       label2 = _ref2$label === void 0 ? value2 : _ref2$label;
   return label.localeCompare(label2, [], {
     sensitivity: 'base',
     ignorePunctuation: true,
     numeric: true
   });
 };
 /**
  * @param {{ score: number }} a
  * @param {{ score: number }} b
  */

 var sortByScore = function sortByScore(a, b) {
   return a.score - b.score;
 };
 /**
  * @param {HTMLElement} element
  * @param {string} type
  * @param {object} customArgs
  */

 var dispatchEvent = function dispatchEvent(element, type, customArgs) {
   if (customArgs === void 0) {
     customArgs = null;
   }

   var event = new CustomEvent(type, {
     detail: customArgs,
     bubbles: true,
     cancelable: true
   });
   return element.dispatchEvent(event);
 };
 /**
  * @param {array} array
  * @param {any} value
  * @param {string} [key="value"]
  * @returns {boolean}
  */

 var existsInArray = function existsInArray(array, value, key) {
   if (key === void 0) {
     key = 'value';
   }

   return array.some(function (item) {
     if (typeof value === 'string') {
       return item[key] === value.trim();
     }

     return item[key] === value;
   });
 };
 /**
  * @param {any} obj
  * @returns {any}
  */

 var cloneObject = function cloneObject(obj) {
   return JSON.parse(JSON.stringify(obj));
 };
 /**
  * Returns an array of keys present on the first but missing on the second object
  * @param {object} a
  * @param {object} b
  * @returns {string[]}
  */

 var diff = function diff(a, b) {
   var aKeys = Object.keys(a).sort();
   var bKeys = Object.keys(b).sort();
   return aKeys.filter(function (i) {
     return bKeys.indexOf(i) < 0;
   });
 };
 // CONCATENATED MODULE: ./src/scripts/reducers/index.js






 var appReducer = combineReducers({
   items: items_items,
   groups: groups,
   choices: choices_choices,
   general: reducers_general
 });

 var reducers_rootReducer = function rootReducer(passedState, action) {
   var state = passedState; // If we are clearing all items, groups and options we reassign
   // state and then pass that state to our proper reducer. This isn't
   // mutating our actual state
   // See: http://stackoverflow.com/a/35641992

   if (action.type === 'CLEAR_ALL') {
     state = undefined;
   } else if (action.type === 'RESET_TO') {
     return cloneObject(action.state);
   }

   return appReducer(state, action);
 };

 /* harmony default export */ var reducers = (reducers_rootReducer);
 // CONCATENATED MODULE: ./src/scripts/store/store.js
 function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

 function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }



 /**
  * @typedef {import('../../../types/index').Choices.Choice} Choice
  * @typedef {import('../../../types/index').Choices.Group} Group
  * @typedef {import('../../../types/index').Choices.Item} Item
  */

 var store_Store =
 /*#__PURE__*/
 function () {
   function Store() {
     this._store = createStore(reducers, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());
   }
   /**
    * Subscribe store to function call (wrapped Redux method)
    * @param  {Function} onChange Function to trigger when state changes
    * @return
    */


   var _proto = Store.prototype;

   _proto.subscribe = function subscribe(onChange) {
     this._store.subscribe(onChange);
   }
   /**
    * Dispatch event to store (wrapped Redux method)
    * @param  {{ type: string, [x: string]: any }} action Action to trigger
    * @return
    */
   ;

   _proto.dispatch = function dispatch(action) {
     this._store.dispatch(action);
   }
   /**
    * Get store object (wrapping Redux method)
    * @returns {object} State
    */
   ;

   /**
    * Get loading state from store
    * @returns {boolean} Loading State
    */
   _proto.isLoading = function isLoading() {
     return this.state.general.loading;
   }
   /**
    * Get single choice by it's ID
    * @param {string} id
    * @returns {Choice | undefined} Found choice
    */
   ;

   _proto.getChoiceById = function getChoiceById(id) {
     return this.activeChoices.find(function (choice) {
       return choice.id === parseInt(id, 10);
     });
   }
   /**
    * Get group by group id
    * @param  {number} id Group ID
    * @returns {Group | undefined} Group data
    */
   ;

   _proto.getGroupById = function getGroupById(id) {
     return this.groups.find(function (group) {
       return group.id === id;
     });
   };

   _createClass(Store, [{
     key: "state",
     get: function get() {
       return this._store.getState();
     }
     /**
      * Get items from store
      * @returns {Item[]} Item objects
      */

   }, {
     key: "items",
     get: function get() {
       return this.state.items;
     }
     /**
      * Get active items from store
      * @returns {Item[]} Item objects
      */

   }, {
     key: "activeItems",
     get: function get() {
       return this.items.filter(function (item) {
         return item.active === true;
       });
     }
     /**
      * Get highlighted items from store
      * @returns {Item[]} Item objects
      */

   }, {
     key: "highlightedActiveItems",
     get: function get() {
       return this.items.filter(function (item) {
         return item.active && item.highlighted;
       });
     }
     /**
      * Get choices from store
      * @returns {Choice[]} Option objects
      */

   }, {
     key: "choices",
     get: function get() {
       return this.state.choices;
     }
     /**
      * Get active choices from store
      * @returns {Choice[]} Option objects
      */

   }, {
     key: "activeChoices",
     get: function get() {
       return this.choices.filter(function (choice) {
         return choice.active === true;
       });
     }
     /**
      * Get selectable choices from store
      * @returns {Choice[]} Option objects
      */

   }, {
     key: "selectableChoices",
     get: function get() {
       return this.choices.filter(function (choice) {
         return choice.disabled !== true;
       });
     }
     /**
      * Get choices that can be searched (excluding placeholders)
      * @returns {Choice[]} Option objects
      */

   }, {
     key: "searchableChoices",
     get: function get() {
       return this.selectableChoices.filter(function (choice) {
         return choice.placeholder !== true;
       });
     }
     /**
      * Get placeholder choice from store
      * @returns {Choice | undefined} Found placeholder
      */

   }, {
     key: "placeholderChoice",
     get: function get() {
       return [].concat(this.choices).reverse().find(function (choice) {
         return choice.placeholder === true;
       });
     }
     /**
      * Get groups from store
      * @returns {Group[]} Group objects
      */

   }, {
     key: "groups",
     get: function get() {
       return this.state.groups;
     }
     /**
      * Get active groups from store
      * @returns {Group[]} Group objects
      */

   }, {
     key: "activeGroups",
     get: function get() {
       var groups = this.groups,
           choices = this.choices;
       return groups.filter(function (group) {
         var isActive = group.active === true && group.disabled === false;
         var hasActiveOptions = choices.some(function (choice) {
           return choice.active === true && choice.disabled === false;
         });
         return isActive && hasActiveOptions;
       }, []);
     }
   }]);

   return Store;
 }();


 // CONCATENATED MODULE: ./src/scripts/components/dropdown.js
 function dropdown_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

 function dropdown_createClass(Constructor, protoProps, staticProps) { if (protoProps) dropdown_defineProperties(Constructor.prototype, protoProps); if (staticProps) dropdown_defineProperties(Constructor, staticProps); return Constructor; }

 /**
  * @typedef {import('../../../types/index').Choices.passedElement} passedElement
  * @typedef {import('../../../types/index').Choices.ClassNames} ClassNames
  */
 var Dropdown =
 /*#__PURE__*/
 function () {
   /**
    * @param {{
    *  element: HTMLElement,
    *  type: passedElement['type'],
    *  classNames: ClassNames,
    * }} args
    */
   function Dropdown(_ref) {
     var element = _ref.element,
         type = _ref.type,
         classNames = _ref.classNames;
     this.element = element;
     this.classNames = classNames;
     this.type = type;
     this.isActive = false;
   }
   /**
    * Bottom position of dropdown in viewport coordinates
    * @returns {number} Vertical position
    */


   var _proto = Dropdown.prototype;

   /**
    * Find element that matches passed selector
    * @param {string} selector
    * @returns {HTMLElement | null}
    */
   _proto.getChild = function getChild(selector) {
     return this.element.querySelector(selector);
   }
   /**
    * Show dropdown to user by adding active state class
    * @returns {this}
    */
   ;

   _proto.show = function show() {
     this.element.classList.add(this.classNames.activeState);
     this.element.setAttribute('aria-expanded', 'true');
     this.isActive = true;
     return this;
   }
   /**
    * Hide dropdown from user
    * @returns {this}
    */
   ;

   _proto.hide = function hide() {
     this.element.classList.remove(this.classNames.activeState);
     this.element.setAttribute('aria-expanded', 'false');
     this.isActive = false;
     return this;
   };

   dropdown_createClass(Dropdown, [{
     key: "distanceFromTopWindow",
     get: function get() {
       return this.element.getBoundingClientRect().bottom;
     }
   }]);

   return Dropdown;
 }();


 // CONCATENATED MODULE: ./src/scripts/constants.js

 /**
  * @typedef {import('../../types/index').Choices.ClassNames} ClassNames
  * @typedef {import('../../types/index').Choices.Options} Options
  */

 /** @type {ClassNames} */

 var DEFAULT_CLASSNAMES = {
   containerOuter: 'choices',
   containerInner: 'choices__inner',
   input: 'choices__input',
   inputCloned: 'choices__input--cloned',
   list: 'choices__list',
   listItems: 'choices__list--multiple',
   listSingle: 'choices__list--single',
   listDropdown: 'choices__list--dropdown',
   item: 'choices__item',
   itemSelectable: 'choices__item--selectable',
   itemDisabled: 'choices__item--disabled',
   itemChoice: 'choices__item--choice',
   placeholder: 'choices__placeholder',
   group: 'choices__group',
   groupHeading: 'choices__heading',
   button: 'choices__button',
   activeState: 'is-active',
   focusState: 'is-focused',
   openState: 'is-open',
   disabledState: 'is-disabled',
   highlightedState: 'is-highlighted',
   selectedState: 'is-selected',
   flippedState: 'is-flipped',
   loadingState: 'is-loading',
   noResults: 'has-no-results',
   noChoices: 'has-no-choices'
 };
 /** @type {Options} */

 var DEFAULT_CONFIG = {
   items: [],
   choices: [],
   silent: false,
   renderChoiceLimit: -1,
   maxItemCount: -1,
   addItems: true,
   addItemFilter: null,
   removeItems: true,
   removeItemButton: false,
   editItems: false,
   duplicateItemsAllowed: true,
   delimiter: ',',
   paste: true,
   searchEnabled: true,
   searchChoices: true,
   searchFloor: 1,
   searchResultLimit: 4,
   searchFields: ['label', 'value'],
   position: 'auto',
   resetScrollPosition: true,
   shouldSort: true,
   shouldSortItems: false,
   sorter: sortByAlpha,
   placeholder: true,
   placeholderValue: null,
   searchPlaceholderValue: null,
   prependValue: null,
   appendValue: null,
   renderSelectedChoices: 'auto',
   loadingText: 'Loading...',
   noResultsText: 'No results found',
   noChoicesText: 'No choices to choose from',
   itemSelectText: 'Press to select',
   uniqueItemText: 'Only unique values can be added',
   customAddItemText: 'Only values matching specific conditions can be added',
   addItemText: function addItemText(value) {
     return "Press Enter to add <b>\"" + sanitise(value) + "\"</b>";
   },
   maxItemText: function maxItemText(maxItemCount) {
     return "Only " + maxItemCount + " values can be added";
   },
   valueComparer: function valueComparer(value1, value2) {
     return value1 === value2;
   },
   fuseOptions: {
     includeScore: true
   },
   callbackOnInit: null,
   callbackOnCreateTemplates: null,
   classNames: DEFAULT_CLASSNAMES
 };
 var EVENTS = {
   showDropdown: 'showDropdown',
   hideDropdown: 'hideDropdown',
   change: 'change',
   choice: 'choice',
   search: 'search',
   addItem: 'addItem',
   removeItem: 'removeItem',
   highlightItem: 'highlightItem',
   highlightChoice: 'highlightChoice'
 };
 var ACTION_TYPES = {
   ADD_CHOICE: 'ADD_CHOICE',
   FILTER_CHOICES: 'FILTER_CHOICES',
   ACTIVATE_CHOICES: 'ACTIVATE_CHOICES',
   CLEAR_CHOICES: 'CLEAR_CHOICES',
   ADD_GROUP: 'ADD_GROUP',
   ADD_ITEM: 'ADD_ITEM',
   REMOVE_ITEM: 'REMOVE_ITEM',
   HIGHLIGHT_ITEM: 'HIGHLIGHT_ITEM',
   CLEAR_ALL: 'CLEAR_ALL'
 };
 var KEY_CODES = {
   BACK_KEY: 46,
   DELETE_KEY: 8,
   ENTER_KEY: 13,
   A_KEY: 65,
   ESC_KEY: 27,
   UP_KEY: 38,
   DOWN_KEY: 40,
   PAGE_UP_KEY: 33,
   PAGE_DOWN_KEY: 34
 };
 var TEXT_TYPE = 'text';
 var SELECT_ONE_TYPE = 'select-one';
 var SELECT_MULTIPLE_TYPE = 'select-multiple';
 var SCROLLING_SPEED = 4;
 // CONCATENATED MODULE: ./src/scripts/components/container.js


 /**
  * @typedef {import('../../../types/index').Choices.passedElement} passedElement
  * @typedef {import('../../../types/index').Choices.ClassNames} ClassNames
  */

 var container_Container =
 /*#__PURE__*/
 function () {
   /**
    * @param {{
    *  element: HTMLElement,
    *  type: passedElement['type'],
    *  classNames: ClassNames,
    *  position
    * }} args
    */
   function Container(_ref) {
     var element = _ref.element,
         type = _ref.type,
         classNames = _ref.classNames,
         position = _ref.position;
     this.element = element;
     this.classNames = classNames;
     this.type = type;
     this.position = position;
     this.isOpen = false;
     this.isFlipped = false;
     this.isFocussed = false;
     this.isDisabled = false;
     this.isLoading = false;
     this._onFocus = this._onFocus.bind(this);
     this._onBlur = this._onBlur.bind(this);
   }

   var _proto = Container.prototype;

   _proto.addEventListeners = function addEventListeners() {
     this.element.addEventListener('focus', this._onFocus);
     this.element.addEventListener('blur', this._onBlur);
   };

   _proto.removeEventListeners = function removeEventListeners() {
     this.element.removeEventListener('focus', this._onFocus);
     this.element.removeEventListener('blur', this._onBlur);
   }
   /**
    * Determine whether container should be flipped based on passed
    * dropdown position
    * @param {number} dropdownPos
    * @returns {boolean}
    */
   ;

   _proto.shouldFlip = function shouldFlip(dropdownPos) {
     if (typeof dropdownPos !== 'number') {
       return false;
     } // If flip is enabled and the dropdown bottom position is
     // greater than the window height flip the dropdown.


     var shouldFlip = false;

     if (this.position === 'auto') {
       shouldFlip = !window.matchMedia("(min-height: " + (dropdownPos + 1) + "px)").matches;
     } else if (this.position === 'top') {
       shouldFlip = true;
     }

     return shouldFlip;
   }
   /**
    * @param {string} activeDescendantID
    */
   ;

   _proto.setActiveDescendant = function setActiveDescendant(activeDescendantID) {
     this.element.setAttribute('aria-activedescendant', activeDescendantID);
   };

   _proto.removeActiveDescendant = function removeActiveDescendant() {
     this.element.removeAttribute('aria-activedescendant');
   }
   /**
    * @param {number} dropdownPos
    */
   ;

   _proto.open = function open(dropdownPos) {
     this.element.classList.add(this.classNames.openState);
     this.element.setAttribute('aria-expanded', 'true');
     this.isOpen = true;

     if (this.shouldFlip(dropdownPos)) {
       this.element.classList.add(this.classNames.flippedState);
       this.isFlipped = true;
     }
   };

   _proto.close = function close() {
     this.element.classList.remove(this.classNames.openState);
     this.element.setAttribute('aria-expanded', 'false');
     this.removeActiveDescendant();
     this.isOpen = false; // A dropdown flips if it does not have space within the page

     if (this.isFlipped) {
       this.element.classList.remove(this.classNames.flippedState);
       this.isFlipped = false;
     }
   };

   _proto.focus = function focus() {
     if (!this.isFocussed) {
       this.element.focus();
     }
   };

   _proto.addFocusState = function addFocusState() {
     this.element.classList.add(this.classNames.focusState);
   };

   _proto.removeFocusState = function removeFocusState() {
     this.element.classList.remove(this.classNames.focusState);
   };

   _proto.enable = function enable() {
     this.element.classList.remove(this.classNames.disabledState);
     this.element.removeAttribute('aria-disabled');

     if (this.type === SELECT_ONE_TYPE) {
       this.element.setAttribute('tabindex', '0');
     }

     this.isDisabled = false;
   };

   _proto.disable = function disable() {
     this.element.classList.add(this.classNames.disabledState);
     this.element.setAttribute('aria-disabled', 'true');

     if (this.type === SELECT_ONE_TYPE) {
       this.element.setAttribute('tabindex', '-1');
     }

     this.isDisabled = true;
   }
   /**
    * @param {HTMLElement} element
    */
   ;

   _proto.wrap = function wrap(element) {
     utils_wrap(element, this.element);
   }
   /**
    * @param {Element} element
    */
   ;

   _proto.unwrap = function unwrap(element) {
     // Move passed element outside this element
     this.element.parentNode.insertBefore(element, this.element); // Remove this element

     this.element.parentNode.removeChild(this.element);
   };

   _proto.addLoadingState = function addLoadingState() {
     this.element.classList.add(this.classNames.loadingState);
     this.element.setAttribute('aria-busy', 'true');
     this.isLoading = true;
   };

   _proto.removeLoadingState = function removeLoadingState() {
     this.element.classList.remove(this.classNames.loadingState);
     this.element.removeAttribute('aria-busy');
     this.isLoading = false;
   };

   _proto._onFocus = function _onFocus() {
     this.isFocussed = true;
   };

   _proto._onBlur = function _onBlur() {
     this.isFocussed = false;
   };

   return Container;
 }();


 // CONCATENATED MODULE: ./src/scripts/components/input.js
 function input_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

 function input_createClass(Constructor, protoProps, staticProps) { if (protoProps) input_defineProperties(Constructor.prototype, protoProps); if (staticProps) input_defineProperties(Constructor, staticProps); return Constructor; }



 /**
  * @typedef {import('../../../types/index').Choices.passedElement} passedElement
  * @typedef {import('../../../types/index').Choices.ClassNames} ClassNames
  */

 var input_Input =
 /*#__PURE__*/
 function () {
   /**
    * @param {{
    *  element: HTMLInputElement,
    *  type: passedElement['type'],
    *  classNames: ClassNames,
    *  preventPaste: boolean
    * }} args
    */
   function Input(_ref) {
     var element = _ref.element,
         type = _ref.type,
         classNames = _ref.classNames,
         preventPaste = _ref.preventPaste;
     this.element = element;
     this.type = type;
     this.classNames = classNames;
     this.preventPaste = preventPaste;
     this.isFocussed = this.element === document.activeElement;
     this.isDisabled = element.disabled;
     this._onPaste = this._onPaste.bind(this);
     this._onInput = this._onInput.bind(this);
     this._onFocus = this._onFocus.bind(this);
     this._onBlur = this._onBlur.bind(this);
   }
   /**
    * @param {string} placeholder
    */


   var _proto = Input.prototype;

   _proto.addEventListeners = function addEventListeners() {
     this.element.addEventListener('paste', this._onPaste);
     this.element.addEventListener('input', this._onInput, {
       passive: true
     });
     this.element.addEventListener('focus', this._onFocus, {
       passive: true
     });
     this.element.addEventListener('blur', this._onBlur, {
       passive: true
     });
   };

   _proto.removeEventListeners = function removeEventListeners() {
     this.element.removeEventListener('input', this._onInput, {
       passive: true
     });
     this.element.removeEventListener('paste', this._onPaste);
     this.element.removeEventListener('focus', this._onFocus, {
       passive: true
     });
     this.element.removeEventListener('blur', this._onBlur, {
       passive: true
     });
   };

   _proto.enable = function enable() {
     this.element.removeAttribute('disabled');
     this.isDisabled = false;
   };

   _proto.disable = function disable() {
     this.element.setAttribute('disabled', '');
     this.isDisabled = true;
   };

   _proto.focus = function focus() {
     if (!this.isFocussed) {
       this.element.focus();
     }
   };

   _proto.blur = function blur() {
     if (this.isFocussed) {
       this.element.blur();
     }
   }
   /**
    * Set value of input to blank
    * @param {boolean} setWidth
    * @returns {this}
    */
   ;

   _proto.clear = function clear(setWidth) {
     if (setWidth === void 0) {
       setWidth = true;
     }

     if (this.element.value) {
       this.element.value = '';
     }

     if (setWidth) {
       this.setWidth();
     }

     return this;
   }
   /**
    * Set the correct input width based on placeholder
    * value or input value
    */
   ;

   _proto.setWidth = function setWidth() {
     // Resize input to contents or placeholder
     var _this$element = this.element,
         style = _this$element.style,
         value = _this$element.value,
         placeholder = _this$element.placeholder;
     style.minWidth = placeholder.length + 1 + "ch";
     style.width = value.length + 1 + "ch";
   }
   /**
    * @param {string} activeDescendantID
    */
   ;

   _proto.setActiveDescendant = function setActiveDescendant(activeDescendantID) {
     this.element.setAttribute('aria-activedescendant', activeDescendantID);
   };

   _proto.removeActiveDescendant = function removeActiveDescendant() {
     this.element.removeAttribute('aria-activedescendant');
   };

   _proto._onInput = function _onInput() {
     if (this.type !== SELECT_ONE_TYPE) {
       this.setWidth();
     }
   }
   /**
    * @param {Event} event
    */
   ;

   _proto._onPaste = function _onPaste(event) {
     if (this.preventPaste) {
       event.preventDefault();
     }
   };

   _proto._onFocus = function _onFocus() {
     this.isFocussed = true;
   };

   _proto._onBlur = function _onBlur() {
     this.isFocussed = false;
   };

   input_createClass(Input, [{
     key: "placeholder",
     set: function set(placeholder) {
       this.element.placeholder = placeholder;
     }
     /**
      * @returns {string}
      */

   }, {
     key: "value",
     get: function get() {
       return sanitise(this.element.value);
     }
     /**
      * @param {string} value
      */
     ,
     set: function set(value) {
       this.element.value = value;
     }
   }]);

   return Input;
 }();


 // CONCATENATED MODULE: ./src/scripts/components/list.js

 /**
  * @typedef {import('../../../types/index').Choices.Choice} Choice
  */

 var list_List =
 /*#__PURE__*/
 function () {
   /**
    * @param {{ element: HTMLElement }} args
    */
   function List(_ref) {
     var element = _ref.element;
     this.element = element;
     this.scrollPos = this.element.scrollTop;
     this.height = this.element.offsetHeight;
   }

   var _proto = List.prototype;

   _proto.clear = function clear() {
     this.element.innerHTML = '';
   }
   /**
    * @param {Element | DocumentFragment} node
    */
   ;

   _proto.append = function append(node) {
     this.element.appendChild(node);
   }
   /**
    * @param {string} selector
    * @returns {Element | null}
    */
   ;

   _proto.getChild = function getChild(selector) {
     return this.element.querySelector(selector);
   }
   /**
    * @returns {boolean}
    */
   ;

   _proto.hasChildren = function hasChildren() {
     return this.element.hasChildNodes();
   };

   _proto.scrollToTop = function scrollToTop() {
     this.element.scrollTop = 0;
   }
   /**
    * @param {Element} element
    * @param {1 | -1} direction
    */
   ;

   _proto.scrollToChildElement = function scrollToChildElement(element, direction) {
     var _this = this;

     if (!element) {
       return;
     }

     var listHeight = this.element.offsetHeight; // Scroll position of dropdown

     var listScrollPosition = this.element.scrollTop + listHeight;
     var elementHeight = element.offsetHeight; // Distance from bottom of element to top of parent

     var elementPos = element.offsetTop + elementHeight; // Difference between the element and scroll position

     var destination = direction > 0 ? this.element.scrollTop + elementPos - listScrollPosition : element.offsetTop;
     requestAnimationFrame(function () {
       _this._animateScroll(destination, direction);
     });
   }
   /**
    * @param {number} scrollPos
    * @param {number} strength
    * @param {number} destination
    */
   ;

   _proto._scrollDown = function _scrollDown(scrollPos, strength, destination) {
     var easing = (destination - scrollPos) / strength;
     var distance = easing > 1 ? easing : 1;
     this.element.scrollTop = scrollPos + distance;
   }
   /**
    * @param {number} scrollPos
    * @param {number} strength
    * @param {number} destination
    */
   ;

   _proto._scrollUp = function _scrollUp(scrollPos, strength, destination) {
     var easing = (scrollPos - destination) / strength;
     var distance = easing > 1 ? easing : 1;
     this.element.scrollTop = scrollPos - distance;
   }
   /**
    * @param {*} destination
    * @param {*} direction
    */
   ;

   _proto._animateScroll = function _animateScroll(destination, direction) {
     var _this2 = this;

     var strength = SCROLLING_SPEED;
     var choiceListScrollTop = this.element.scrollTop;
     var continueAnimation = false;

     if (direction > 0) {
       this._scrollDown(choiceListScrollTop, strength, destination);

       if (choiceListScrollTop < destination) {
         continueAnimation = true;
       }
     } else {
       this._scrollUp(choiceListScrollTop, strength, destination);

       if (choiceListScrollTop > destination) {
         continueAnimation = true;
       }
     }

     if (continueAnimation) {
       requestAnimationFrame(function () {
         _this2._animateScroll(destination, direction);
       });
     }
   };

   return List;
 }();


 // CONCATENATED MODULE: ./src/scripts/components/wrapped-element.js
 function wrapped_element_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

 function wrapped_element_createClass(Constructor, protoProps, staticProps) { if (protoProps) wrapped_element_defineProperties(Constructor.prototype, protoProps); if (staticProps) wrapped_element_defineProperties(Constructor, staticProps); return Constructor; }


 /**
  * @typedef {import('../../../types/index').Choices.passedElement} passedElement
  * @typedef {import('../../../types/index').Choices.ClassNames} ClassNames
  */

 var wrapped_element_WrappedElement =
 /*#__PURE__*/
 function () {
   /**
    * @param {{
    *  element: HTMLInputElement | HTMLSelectElement,
    *  classNames: ClassNames,
    * }} args
    */
   function WrappedElement(_ref) {
     var element = _ref.element,
         classNames = _ref.classNames;
     this.element = element;
     this.classNames = classNames;

     if (!(element instanceof HTMLInputElement) && !(element instanceof HTMLSelectElement)) {
       throw new TypeError('Invalid element passed');
     }

     this.isDisabled = false;
   }

   var _proto = WrappedElement.prototype;

   _proto.conceal = function conceal() {
     // Hide passed input
     this.element.classList.add(this.classNames.input);
     this.element.hidden = true; // Remove element from tab index

     this.element.tabIndex = -1; // Backup original styles if any

     var origStyle = this.element.getAttribute('style');

     if (origStyle) {
       this.element.setAttribute('data-choice-orig-style', origStyle);
     }

     this.element.setAttribute('data-choice', 'active');
   };

   _proto.reveal = function reveal() {
     // Reinstate passed element
     this.element.classList.remove(this.classNames.input);
     this.element.hidden = false;
     this.element.removeAttribute('tabindex'); // Recover original styles if any

     var origStyle = this.element.getAttribute('data-choice-orig-style');

     if (origStyle) {
       this.element.removeAttribute('data-choice-orig-style');
       this.element.setAttribute('style', origStyle);
     } else {
       this.element.removeAttribute('style');
     }

     this.element.removeAttribute('data-choice'); // Re-assign values - this is weird, I know
     // @todo Figure out why we need to do this

     this.element.value = this.element.value; // eslint-disable-line no-self-assign
   };

   _proto.enable = function enable() {
     this.element.removeAttribute('disabled');
     this.element.disabled = false;
     this.isDisabled = false;
   };

   _proto.disable = function disable() {
     this.element.setAttribute('disabled', '');
     this.element.disabled = true;
     this.isDisabled = true;
   };

   _proto.triggerEvent = function triggerEvent(eventType, data) {
     dispatchEvent(this.element, eventType, data);
   };

   wrapped_element_createClass(WrappedElement, [{
     key: "isActive",
     get: function get() {
       return this.element.dataset.choice === 'active';
     }
   }, {
     key: "dir",
     get: function get() {
       return this.element.dir;
     }
   }, {
     key: "value",
     get: function get() {
       return this.element.value;
     },
     set: function set(value) {
       // you must define setter here otherwise it will be readonly property
       this.element.value = value;
     }
   }]);

   return WrappedElement;
 }();


 // CONCATENATED MODULE: ./src/scripts/components/wrapped-input.js
 function wrapped_input_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

 function wrapped_input_createClass(Constructor, protoProps, staticProps) { if (protoProps) wrapped_input_defineProperties(Constructor.prototype, protoProps); if (staticProps) wrapped_input_defineProperties(Constructor, staticProps); return Constructor; }

 function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }


 /**
  * @typedef {import('../../../types/index').Choices.ClassNames} ClassNames
  * @typedef {import('../../../types/index').Choices.Item} Item
  */

 var WrappedInput =
 /*#__PURE__*/
 function (_WrappedElement) {
   _inheritsLoose(WrappedInput, _WrappedElement);

   /**
    * @param {{
    *  element: HTMLInputElement,
    *  classNames: ClassNames,
    *  delimiter: string
    * }} args
    */
   function WrappedInput(_ref) {
     var _this;

     var element = _ref.element,
         classNames = _ref.classNames,
         delimiter = _ref.delimiter;
     _this = _WrappedElement.call(this, {
       element: element,
       classNames: classNames
     }) || this;
     _this.delimiter = delimiter;
     return _this;
   }
   /**
    * @returns {string}
    */


   wrapped_input_createClass(WrappedInput, [{
     key: "value",
     get: function get() {
       return this.element.value;
     }
     /**
      * @param {Item[]} items
      */
     ,
     set: function set(items) {
       var itemValues = items.map(function (_ref2) {
         var value = _ref2.value;
         return value;
       });
       var joinedValues = itemValues.join(this.delimiter);
       this.element.setAttribute('value', joinedValues);
       this.element.value = joinedValues;
     }
   }]);

   return WrappedInput;
 }(wrapped_element_WrappedElement);


 // CONCATENATED MODULE: ./src/scripts/components/wrapped-select.js
 function wrapped_select_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

 function wrapped_select_createClass(Constructor, protoProps, staticProps) { if (protoProps) wrapped_select_defineProperties(Constructor.prototype, protoProps); if (staticProps) wrapped_select_defineProperties(Constructor, staticProps); return Constructor; }

 function wrapped_select_inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }


 /**
  * @typedef {import('../../../types/index').Choices.ClassNames} ClassNames
  * @typedef {import('../../../types/index').Choices.Item} Item
  * @typedef {import('../../../types/index').Choices.Choice} Choice
  */

 var WrappedSelect =
 /*#__PURE__*/
 function (_WrappedElement) {
   wrapped_select_inheritsLoose(WrappedSelect, _WrappedElement);

   /**
    * @param {{
    *  element: HTMLSelectElement,
    *  classNames: ClassNames,
    *  delimiter: string
    *  template: function
    * }} args
    */
   function WrappedSelect(_ref) {
     var _this;

     var element = _ref.element,
         classNames = _ref.classNames,
         template = _ref.template;
     _this = _WrappedElement.call(this, {
       element: element,
       classNames: classNames
     }) || this;
     _this.template = template;
     return _this;
   }

   var _proto = WrappedSelect.prototype;

   /**
    * @param {DocumentFragment} fragment
    */
   _proto.appendDocFragment = function appendDocFragment(fragment) {
     this.element.innerHTML = '';
     this.element.appendChild(fragment);
   };

   wrapped_select_createClass(WrappedSelect, [{
     key: "placeholderOption",
     get: function get() {
       return this.element.querySelector('option[value=""]') || // Backward compatibility layer for the non-standard placeholder attribute supported in older versions.
       this.element.querySelector('option[placeholder]');
     }
     /**
      * @returns {Element[]}
      */

   }, {
     key: "optionGroups",
     get: function get() {
       return Array.from(this.element.getElementsByTagName('OPTGROUP'));
     }
     /**
      * @returns {Item[] | Choice[]}
      */

   }, {
     key: "options",
     get: function get() {
       return Array.from(this.element.options);
     }
     /**
      * @param {Item[] | Choice[]} options
      */
     ,
     set: function set(options) {
       var _this2 = this;

       var fragment = document.createDocumentFragment();

       var addOptionToFragment = function addOptionToFragment(data) {
         // Create a standard select option
         var option = _this2.template(data); // Append it to fragment


         fragment.appendChild(option);
       }; // Add each list item to list


       options.forEach(function (optionData) {
         return addOptionToFragment(optionData);
       });
       this.appendDocFragment(fragment);
     }
   }]);

   return WrappedSelect;
 }(wrapped_element_WrappedElement);


 // CONCATENATED MODULE: ./src/scripts/components/index.js







 // CONCATENATED MODULE: ./src/scripts/templates.js
 /**
  * Helpers to create HTML elements used by Choices
  * Can be overridden by providing `callbackOnCreateTemplates` option
  * @typedef {import('../../types/index').Choices.Templates} Templates
  * @typedef {import('../../types/index').Choices.ClassNames} ClassNames
  * @typedef {import('../../types/index').Choices.Options} Options
  * @typedef {import('../../types/index').Choices.Item} Item
  * @typedef {import('../../types/index').Choices.Choice} Choice
  * @typedef {import('../../types/index').Choices.Group} Group
  */
 var TEMPLATES =
 /** @type {Templates} */
 {
   /**
    * @param {Partial<ClassNames>} classNames
    * @param {"ltr" | "rtl" | "auto"} dir
    * @param {boolean} isSelectElement
    * @param {boolean} isSelectOneElement
    * @param {boolean} searchEnabled
    * @param {"select-one" | "select-multiple" | "text"} passedElementType
    */
   containerOuter: function containerOuter(_ref, dir, isSelectElement, isSelectOneElement, searchEnabled, passedElementType) {
     var _containerOuter = _ref.containerOuter;
     var div = Object.assign(document.createElement('div'), {
       className: _containerOuter
     });
     div.dataset.type = passedElementType;

     if (dir) {
       div.dir = dir;
     }

     if (isSelectOneElement) {
       div.tabIndex = 0;
     }

     if (isSelectElement) {
       div.setAttribute('role', searchEnabled ? 'combobox' : 'listbox');

       if (searchEnabled) {
         div.setAttribute('aria-autocomplete', 'list');
       }
     }

     div.setAttribute('aria-haspopup', 'true');
     div.setAttribute('aria-expanded', 'false');
     return div;
   },

   /**
    * @param {Partial<ClassNames>} classNames
    */
   containerInner: function containerInner(_ref2) {
     var _containerInner = _ref2.containerInner;
     return Object.assign(document.createElement('div'), {
       className: _containerInner
     });
   },

   /**
    * @param {Partial<ClassNames>} classNames
    * @param {boolean} isSelectOneElement
    */
   itemList: function itemList(_ref3, isSelectOneElement) {
     var list = _ref3.list,
         listSingle = _ref3.listSingle,
         listItems = _ref3.listItems;
     return Object.assign(document.createElement('div'), {
       className: list + " " + (isSelectOneElement ? listSingle : listItems)
     });
   },

   /**
    * @param {Partial<ClassNames>} classNames
    * @param {string} value
    */
   placeholder: function placeholder(_ref4, value) {
     var _placeholder = _ref4.placeholder;
     return Object.assign(document.createElement('div'), {
       className: _placeholder,
       innerHTML: value
     });
   },

   /**
    * @param {Partial<ClassNames>} classNames
    * @param {Item} item
    * @param {boolean} removeItemButton
    */
   item: function item(_ref5, _ref6, removeItemButton) {
     var _item = _ref5.item,
         button = _ref5.button,
         highlightedState = _ref5.highlightedState,
         itemSelectable = _ref5.itemSelectable,
         placeholder = _ref5.placeholder;
     var id = _ref6.id,
         value = _ref6.value,
         label = _ref6.label,
         customProperties = _ref6.customProperties,
         active = _ref6.active,
         disabled = _ref6.disabled,
         highlighted = _ref6.highlighted,
         isPlaceholder = _ref6.placeholder;
     var div = Object.assign(document.createElement('div'), {
       className: _item,
       innerHTML: label
     });
     Object.assign(div.dataset, {
       item: '',
       id: id,
       value: value,
       customProperties: customProperties
     });

     if (active) {
       div.setAttribute('aria-selected', 'true');
     }

     if (disabled) {
       div.setAttribute('aria-disabled', 'true');
     }

     if (isPlaceholder) {
       div.classList.add(placeholder);
     }

     div.classList.add(highlighted ? highlightedState : itemSelectable);

     if (removeItemButton) {
       if (disabled) {
         div.classList.remove(itemSelectable);
       }

       div.dataset.deletable = '';
       /** @todo This MUST be localizable, not hardcoded! */

       var REMOVE_ITEM_TEXT = 'Remove item';
       var removeButton = Object.assign(document.createElement('button'), {
         type: 'button',
         className: button,
         innerHTML: REMOVE_ITEM_TEXT
       });
       removeButton.setAttribute('aria-label', REMOVE_ITEM_TEXT + ": '" + value + "'");
       removeButton.dataset.button = '';
       div.appendChild(removeButton);
     }

     return div;
   },

   /**
    * @param {Partial<ClassNames>} classNames
    * @param {boolean} isSelectOneElement
    */
   choiceList: function choiceList(_ref7, isSelectOneElement) {
     var list = _ref7.list;
     var div = Object.assign(document.createElement('div'), {
       className: list
     });

     if (!isSelectOneElement) {
       div.setAttribute('aria-multiselectable', 'true');
     }

     div.setAttribute('role', 'listbox');
     return div;
   },

   /**
    * @param {Partial<ClassNames>} classNames
    * @param {Group} group
    */
   choiceGroup: function choiceGroup(_ref8, _ref9) {
     var group = _ref8.group,
         groupHeading = _ref8.groupHeading,
         itemDisabled = _ref8.itemDisabled;
     var id = _ref9.id,
         value = _ref9.value,
         disabled = _ref9.disabled;
     var div = Object.assign(document.createElement('div'), {
       className: group + " " + (disabled ? itemDisabled : '')
     });
     div.setAttribute('role', 'group');
     Object.assign(div.dataset, {
       group: '',
       id: id,
       value: value
     });

     if (disabled) {
       div.setAttribute('aria-disabled', 'true');
     }

     div.appendChild(Object.assign(document.createElement('div'), {
       className: groupHeading,
       innerHTML: value
     }));
     return div;
   },

   /**
    * @param {Partial<ClassNames>} classNames
    * @param {Choice} choice
    * @param {Options['itemSelectText']} selectText
    */
   choice: function choice(_ref10, _ref11, selectText) {
     var item = _ref10.item,
         itemChoice = _ref10.itemChoice,
         itemSelectable = _ref10.itemSelectable,
         selectedState = _ref10.selectedState,
         itemDisabled = _ref10.itemDisabled,
         placeholder = _ref10.placeholder;
     var id = _ref11.id,
         value = _ref11.value,
         label = _ref11.label,
         groupId = _ref11.groupId,
         elementId = _ref11.elementId,
         isDisabled = _ref11.disabled,
         isSelected = _ref11.selected,
         isPlaceholder = _ref11.placeholder;
     var div = Object.assign(document.createElement('div'), {
       id: elementId,
       innerHTML: label,
       className: item + " " + itemChoice
     });

     if (isSelected) {
       div.classList.add(selectedState);
     }

     if (isPlaceholder) {
       div.classList.add(placeholder);
     }

     div.setAttribute('role', groupId > 0 ? 'treeitem' : 'option');
     Object.assign(div.dataset, {
       choice: '',
       id: id,
       value: value,
       selectText: selectText
     });

     if (isDisabled) {
       div.classList.add(itemDisabled);
       div.dataset.choiceDisabled = '';
       div.setAttribute('aria-disabled', 'true');
     } else {
       div.classList.add(itemSelectable);
       div.dataset.choiceSelectable = '';
     }

     return div;
   },

   /**
    * @param {Partial<ClassNames>} classNames
    * @param {string} placeholderValue
    */
   input: function input(_ref12, placeholderValue) {
     var _input = _ref12.input,
         inputCloned = _ref12.inputCloned;
     var inp = Object.assign(document.createElement('input'), {
       type: 'text',
       className: _input + " " + inputCloned,
       autocomplete: 'off',
       autocapitalize: 'off',
       spellcheck: false
     });
     inp.setAttribute('role', 'textbox');
     inp.setAttribute('aria-autocomplete', 'list');
     inp.setAttribute('aria-label', placeholderValue);
     return inp;
   },

   /**
    * @param {Partial<ClassNames>} classNames
    */
   dropdown: function dropdown(_ref13) {
     var list = _ref13.list,
         listDropdown = _ref13.listDropdown;
     var div = document.createElement('div');
     div.classList.add(list, listDropdown);
     div.setAttribute('aria-expanded', 'false');
     return div;
   },

   /**
    *
    * @param {Partial<ClassNames>} classNames
    * @param {string} innerHTML
    * @param {"no-choices" | "no-results" | ""} type
    */
   notice: function notice(_ref14, innerHTML, type) {
     var item = _ref14.item,
         itemChoice = _ref14.itemChoice,
         noResults = _ref14.noResults,
         noChoices = _ref14.noChoices;

     if (type === void 0) {
       type = '';
     }

     var classes = [item, itemChoice];

     if (type === 'no-choices') {
       classes.push(noChoices);
     } else if (type === 'no-results') {
       classes.push(noResults);
     }

     return Object.assign(document.createElement('div'), {
       innerHTML: innerHTML,
       className: classes.join(' ')
     });
   },

   /**
    * @param {Item} option
    */
   option: function option(_ref15) {
     var label = _ref15.label,
         value = _ref15.value,
         customProperties = _ref15.customProperties,
         active = _ref15.active,
         disabled = _ref15.disabled;
     var opt = new Option(label, value, false, active);

     if (customProperties) {
       opt.dataset.customProperties = customProperties;
     }

     opt.disabled = disabled;
     return opt;
   }
 };
 /* harmony default export */ var templates = (TEMPLATES);
 // CONCATENATED MODULE: ./src/scripts/actions/choices.js
 /**
  * @typedef {import('redux').Action} Action
  * @typedef {import('../../../types/index').Choices.Choice} Choice
  */

 /**
  * @argument {Choice} choice
  * @returns {Action & Choice}
  */

 var choices_addChoice = function addChoice(_ref) {
   var value = _ref.value,
       label = _ref.label,
       id = _ref.id,
       groupId = _ref.groupId,
       disabled = _ref.disabled,
       elementId = _ref.elementId,
       customProperties = _ref.customProperties,
       placeholder = _ref.placeholder,
       keyCode = _ref.keyCode;
   return {
     type: ACTION_TYPES.ADD_CHOICE,
     value: value,
     label: label,
     id: id,
     groupId: groupId,
     disabled: disabled,
     elementId: elementId,
     customProperties: customProperties,
     placeholder: placeholder,
     keyCode: keyCode
   };
 };
 /**
  * @argument {Choice[]} results
  * @returns {Action & { results: Choice[] }}
  */

 var choices_filterChoices = function filterChoices(results) {
   return {
     type: ACTION_TYPES.FILTER_CHOICES,
     results: results
   };
 };
 /**
  * @argument {boolean} active
  * @returns {Action & { active: boolean }}
  */

 var choices_activateChoices = function activateChoices(active) {
   if (active === void 0) {
     active = true;
   }

   return {
     type: ACTION_TYPES.ACTIVATE_CHOICES,
     active: active
   };
 };
 /**
  * @returns {Action}
  */

 var choices_clearChoices = function clearChoices() {
   return {
     type: ACTION_TYPES.CLEAR_CHOICES
   };
 };
 // CONCATENATED MODULE: ./src/scripts/actions/items.js

 /**
  * @typedef {import('redux').Action} Action
  * @typedef {import('../../../types/index').Choices.Item} Item
  */

 /**
  * @param {Item} item
  * @returns {Action & Item}
  */

 var items_addItem = function addItem(_ref) {
   var value = _ref.value,
       label = _ref.label,
       id = _ref.id,
       choiceId = _ref.choiceId,
       groupId = _ref.groupId,
       customProperties = _ref.customProperties,
       placeholder = _ref.placeholder,
       keyCode = _ref.keyCode;
   return {
     type: ACTION_TYPES.ADD_ITEM,
     value: value,
     label: label,
     id: id,
     choiceId: choiceId,
     groupId: groupId,
     customProperties: customProperties,
     placeholder: placeholder,
     keyCode: keyCode
   };
 };
 /**
  * @param {string} id
  * @param {string} choiceId
  * @returns {Action & { id: string, choiceId: string }}
  */

 var items_removeItem = function removeItem(id, choiceId) {
   return {
     type: ACTION_TYPES.REMOVE_ITEM,
     id: id,
     choiceId: choiceId
   };
 };
 /**
  * @param {string} id
  * @param {boolean} highlighted
  * @returns {Action & { id: string, highlighted: boolean }}
  */

 var items_highlightItem = function highlightItem(id, highlighted) {
   return {
     type: ACTION_TYPES.HIGHLIGHT_ITEM,
     id: id,
     highlighted: highlighted
   };
 };
 // CONCATENATED MODULE: ./src/scripts/actions/groups.js

 /**
  * @typedef {import('redux').Action} Action
  * @typedef {import('../../../types/index').Choices.Group} Group
  */

 /**
  * @param {Group} group
  * @returns {Action & Group}
  */

 var groups_addGroup = function addGroup(_ref) {
   var value = _ref.value,
       id = _ref.id,
       active = _ref.active,
       disabled = _ref.disabled;
   return {
     type: ACTION_TYPES.ADD_GROUP,
     value: value,
     id: id,
     active: active,
     disabled: disabled
   };
 };
 // CONCATENATED MODULE: ./src/scripts/actions/misc.js
 /**
  * @typedef {import('redux').Action} Action
  */

 /**
  * @returns {Action}
  */
 var clearAll = function clearAll() {
   return {
     type: 'CLEAR_ALL'
   };
 };
 /**
  * @param {any} state
  * @returns {Action & { state: object }}
  */

 var resetTo = function resetTo(state) {
   return {
     type: 'RESET_TO',
     state: state
   };
 };
 /**
  * @param {boolean} isLoading
  * @returns {Action & { isLoading: boolean }}
  */

 var setIsLoading = function setIsLoading(isLoading) {
   return {
     type: 'SET_IS_LOADING',
     isLoading: isLoading
   };
 };
 // CONCATENATED MODULE: ./src/scripts/choices.js
 function choices_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

 function choices_createClass(Constructor, protoProps, staticProps) { if (protoProps) choices_defineProperties(Constructor.prototype, protoProps); if (staticProps) choices_defineProperties(Constructor, staticProps); return Constructor; }












 /** @see {@link http://browserhacks.com/#hack-acea075d0ac6954f275a70023906050c} */

 var IS_IE11 = '-ms-scroll-limit' in document.documentElement.style && '-ms-ime-align' in document.documentElement.style;
 /**
  * @typedef {import('../../types/index').Choices.Choice} Choice
  * @typedef {import('../../types/index').Choices.Item} Item
  * @typedef {import('../../types/index').Choices.Group} Group
  * @typedef {import('../../types/index').Choices.Options} Options
  */

 /** @type {Partial<Options>} */

 var USER_DEFAULTS = {};
 /**
  * Choices
  * @author Josh Johnson<josh@joshuajohnson.co.uk>
  */

 var choices_Choices =
 /*#__PURE__*/
 function () {
   choices_createClass(Choices, null, [{
     key: "defaults",
     get: function get() {
       return Object.preventExtensions({
         get options() {
           return USER_DEFAULTS;
         },

         get templates() {
           return TEMPLATES;
         }

       });
     }
     /**
      * @param {string | HTMLInputElement | HTMLSelectElement} element
      * @param {Partial<Options>} userConfig
      */

   }]);

   function Choices(element, userConfig) {
     var _this = this;

     if (element === void 0) {
       element = '[data-choice]';
     }

     if (userConfig === void 0) {
       userConfig = {};
     }

     /** @type {Partial<Options>} */
     this.config = cjs_default.a.all([DEFAULT_CONFIG, Choices.defaults.options, userConfig], // When merging array configs, replace with a copy of the userConfig array,
     // instead of concatenating with the default array
     {
       arrayMerge: function arrayMerge(_, sourceArray) {
         return [].concat(sourceArray);
       }
     });
     var invalidConfigOptions = diff(this.config, DEFAULT_CONFIG);

     if (invalidConfigOptions.length) {
       console.warn('Unknown config option(s) passed', invalidConfigOptions.join(', '));
     }

     var passedElement = typeof element === 'string' ? document.querySelector(element) : element;

     if (!(passedElement instanceof HTMLInputElement || passedElement instanceof HTMLSelectElement)) {
       throw TypeError('Expected one of the following types text|select-one|select-multiple');
     }

     this._isTextElement = passedElement.type === TEXT_TYPE;
     this._isSelectOneElement = passedElement.type === SELECT_ONE_TYPE;
     this._isSelectMultipleElement = passedElement.type === SELECT_MULTIPLE_TYPE;
     this._isSelectElement = this._isSelectOneElement || this._isSelectMultipleElement;
     this.config.searchEnabled = this._isSelectMultipleElement || this.config.searchEnabled;

     if (!['auto', 'always'].includes(this.config.renderSelectedChoices)) {
       this.config.renderSelectedChoices = 'auto';
     }

     if (userConfig.addItemFilter && typeof userConfig.addItemFilter !== 'function') {
       var re = userConfig.addItemFilter instanceof RegExp ? userConfig.addItemFilter : new RegExp(userConfig.addItemFilter);
       this.config.addItemFilter = re.test.bind(re);
     }

     if (this._isTextElement) {
       this.passedElement = new WrappedInput({
         element: passedElement,
         classNames: this.config.classNames,
         delimiter: this.config.delimiter
       });
     } else {
       this.passedElement = new WrappedSelect({
         element: passedElement,
         classNames: this.config.classNames,
         template: function template(data) {
           return _this._templates.option(data);
         }
       });
     }

     this.initialised = false;
     this._store = new store_Store();
     this._initialState = {};
     this._currentState = {};
     this._prevState = {};
     this._currentValue = '';
     this._canSearch = this.config.searchEnabled;
     this._isScrollingOnIe = false;
     this._highlightPosition = 0;
     this._wasTap = true;
     this._placeholderValue = this._generatePlaceholderValue();
     this._baseId = generateId(this.passedElement.element, 'choices-');
     /**
      * setting direction in cases where it's explicitly set on passedElement
      * or when calculated direction is different from the document
      * @type {HTMLElement['dir']}
      */

     this._direction = this.passedElement.dir;

     if (!this._direction) {
       var _window$getComputedSt = window.getComputedStyle(this.passedElement.element),
           elementDirection = _window$getComputedSt.direction;

       var _window$getComputedSt2 = window.getComputedStyle(document.documentElement),
           documentDirection = _window$getComputedSt2.direction;

       if (elementDirection !== documentDirection) {
         this._direction = elementDirection;
       }
     }

     this._idNames = {
       itemChoice: 'item-choice'
     }; // Assign preset groups from passed element

     this._presetGroups = this.passedElement.optionGroups; // Assign preset options from passed element

     this._presetOptions = this.passedElement.options; // Assign preset choices from passed object

     this._presetChoices = this.config.choices; // Assign preset items from passed object first

     this._presetItems = this.config.items; // Add any values passed from attribute

     if (this.passedElement.value) {
       this._presetItems = this._presetItems.concat(this.passedElement.value.split(this.config.delimiter));
     } // Create array of choices from option elements


     if (this.passedElement.options) {
       this.passedElement.options.forEach(function (o) {
         _this._presetChoices.push({
           value: o.value,
           label: o.innerHTML,
           selected: o.selected,
           disabled: o.disabled || o.parentNode.disabled,
           placeholder: o.value === '' || o.hasAttribute('placeholder'),
           customProperties: o.getAttribute('data-custom-properties')
         });
       });
     }

     this._render = this._render.bind(this);
     this._onFocus = this._onFocus.bind(this);
     this._onBlur = this._onBlur.bind(this);
     this._onKeyUp = this._onKeyUp.bind(this);
     this._onKeyDown = this._onKeyDown.bind(this);
     this._onClick = this._onClick.bind(this);
     this._onTouchMove = this._onTouchMove.bind(this);
     this._onTouchEnd = this._onTouchEnd.bind(this);
     this._onMouseDown = this._onMouseDown.bind(this);
     this._onMouseOver = this._onMouseOver.bind(this);
     this._onFormReset = this._onFormReset.bind(this);
     this._onAKey = this._onAKey.bind(this);
     this._onEnterKey = this._onEnterKey.bind(this);
     this._onEscapeKey = this._onEscapeKey.bind(this);
     this._onDirectionKey = this._onDirectionKey.bind(this);
     this._onDeleteKey = this._onDeleteKey.bind(this); // If element has already been initialised with Choices, fail silently

     if (this.passedElement.isActive) {
       if (!this.config.silent) {
         console.warn('Trying to initialise Choices on element already initialised');
       }

       this.initialised = true;
       return;
     } // Let's go


     this.init();
   }

   var _proto = Choices.prototype;

   _proto.init = function init() {
     if (this.initialised) {
       return;
     }

     this._createTemplates();

     this._createElements();

     this._createStructure(); // Set initial state (We need to clone the state because some reducers
     // modify the inner objects properties in the state) 🤢


     this._initialState = cloneObject(this._store.state);

     this._store.subscribe(this._render);

     this._render();

     this._addEventListeners();

     var shouldDisable = !this.config.addItems || this.passedElement.element.hasAttribute('disabled');

     if (shouldDisable) {
       this.disable();
     }

     this.initialised = true;
     var callbackOnInit = this.config.callbackOnInit; // Run callback if it is a function

     if (callbackOnInit && typeof callbackOnInit === 'function') {
       callbackOnInit.call(this);
     }
   };

   _proto.destroy = function destroy() {
     if (!this.initialised) {
       return;
     }

     this._removeEventListeners();

     this.passedElement.reveal();
     this.containerOuter.unwrap(this.passedElement.element);
     this.clearStore();

     if (this._isSelectElement) {
       this.passedElement.options = this._presetOptions;
     }

     this._templates = null;
     this.initialised = false;
   };

   _proto.enable = function enable() {
     if (this.passedElement.isDisabled) {
       this.passedElement.enable();
     }

     if (this.containerOuter.isDisabled) {
       this._addEventListeners();

       this.input.enable();
       this.containerOuter.enable();
     }

     return this;
   };

   _proto.disable = function disable() {
     if (!this.passedElement.isDisabled) {
       this.passedElement.disable();
     }

     if (!this.containerOuter.isDisabled) {
       this._removeEventListeners();

       this.input.disable();
       this.containerOuter.disable();
     }

     return this;
   };

   _proto.highlightItem = function highlightItem(item, runEvent) {
     if (runEvent === void 0) {
       runEvent = true;
     }

     if (!item) {
       return this;
     }

     var id = item.id,
         _item$groupId = item.groupId,
         groupId = _item$groupId === void 0 ? -1 : _item$groupId,
         _item$value = item.value,
         value = _item$value === void 0 ? '' : _item$value,
         _item$label = item.label,
         label = _item$label === void 0 ? '' : _item$label;
     var group = groupId >= 0 ? this._store.getGroupById(groupId) : null;

     this._store.dispatch(items_highlightItem(id, true));

     if (runEvent) {
       this.passedElement.triggerEvent(EVENTS.highlightItem, {
         id: id,
         value: value,
         label: label,
         groupValue: group && group.value ? group.value : null
       });
     }

     return this;
   };

   _proto.unhighlightItem = function unhighlightItem(item) {
     if (!item) {
       return this;
     }

     var id = item.id,
         _item$groupId2 = item.groupId,
         groupId = _item$groupId2 === void 0 ? -1 : _item$groupId2,
         _item$value2 = item.value,
         value = _item$value2 === void 0 ? '' : _item$value2,
         _item$label2 = item.label,
         label = _item$label2 === void 0 ? '' : _item$label2;
     var group = groupId >= 0 ? this._store.getGroupById(groupId) : null;

     this._store.dispatch(items_highlightItem(id, false));

     this.passedElement.triggerEvent(EVENTS.highlightItem, {
       id: id,
       value: value,
       label: label,
       groupValue: group && group.value ? group.value : null
     });
     return this;
   };

   _proto.highlightAll = function highlightAll() {
     var _this2 = this;

     this._store.items.forEach(function (item) {
       return _this2.highlightItem(item);
     });

     return this;
   };

   _proto.unhighlightAll = function unhighlightAll() {
     var _this3 = this;

     this._store.items.forEach(function (item) {
       return _this3.unhighlightItem(item);
     });

     return this;
   };

   _proto.removeActiveItemsByValue = function removeActiveItemsByValue(value) {
     var _this4 = this;

     this._store.activeItems.filter(function (item) {
       return item.value === value;
     }).forEach(function (item) {
       return _this4._removeItem(item);
     });

     return this;
   };

   _proto.removeActiveItems = function removeActiveItems(excludedId) {
     var _this5 = this;

     this._store.activeItems.filter(function (_ref) {
       var id = _ref.id;
       return id !== excludedId;
     }).forEach(function (item) {
       return _this5._removeItem(item);
     });

     return this;
   };

   _proto.removeHighlightedItems = function removeHighlightedItems(runEvent) {
     var _this6 = this;

     if (runEvent === void 0) {
       runEvent = false;
     }

     this._store.highlightedActiveItems.forEach(function (item) {
       _this6._removeItem(item); // If this action was performed by the user
       // trigger the event


       if (runEvent) {
         _this6._triggerChange(item.value);
       }
     });

     return this;
   };

   _proto.showDropdown = function showDropdown(preventInputFocus) {
     var _this7 = this;

     if (this.dropdown.isActive) {
       return this;
     }

     requestAnimationFrame(function () {
       _this7.dropdown.show();

       _this7.containerOuter.open(_this7.dropdown.distanceFromTopWindow);

       if (!preventInputFocus && _this7._canSearch) {
         _this7.input.focus();
       }

       _this7.passedElement.triggerEvent(EVENTS.showDropdown, {});
     });
     return this;
   };

   _proto.hideDropdown = function hideDropdown(preventInputBlur) {
     var _this8 = this;

     if (!this.dropdown.isActive) {
       return this;
     }

     requestAnimationFrame(function () {
       _this8.dropdown.hide();

       _this8.containerOuter.close();

       if (!preventInputBlur && _this8._canSearch) {
         _this8.input.removeActiveDescendant();

         _this8.input.blur();
       }

       _this8.passedElement.triggerEvent(EVENTS.hideDropdown, {});
     });
     return this;
   };

   _proto.getValue = function getValue(valueOnly) {
     if (valueOnly === void 0) {
       valueOnly = false;
     }

     var values = this._store.activeItems.reduce(function (selectedItems, item) {
       var itemValue = valueOnly ? item.value : item;
       selectedItems.push(itemValue);
       return selectedItems;
     }, []);

     return this._isSelectOneElement ? values[0] : values;
   }
   /**
    * @param {string[] | import('../../types/index').Choices.Item[]} items
    */
   ;

   _proto.setValue = function setValue(items) {
     var _this9 = this;

     if (!this.initialised) {
       return this;
     }

     items.forEach(function (value) {
       return _this9._setChoiceOrItem(value);
     });
     return this;
   };

   _proto.setChoiceByValue = function setChoiceByValue(value) {
     var _this10 = this;

     if (!this.initialised || this._isTextElement) {
       return this;
     } // If only one value has been passed, convert to array


     var choiceValue = Array.isArray(value) ? value : [value]; // Loop through each value and

     choiceValue.forEach(function (val) {
       return _this10._findAndSelectChoiceByValue(val);
     });
     return this;
   }
   /**
    * Set choices of select input via an array of objects (or function that returns array of object or promise of it),
    * a value field name and a label field name.
    * This behaves the same as passing items via the choices option but can be called after initialising Choices.
    * This can also be used to add groups of choices (see example 2); Optionally pass a true `replaceChoices` value to remove any existing choices.
    * Optionally pass a `customProperties` object to add additional data to your choices (useful when searching/filtering etc).
    *
    * **Input types affected:** select-one, select-multiple
    *
    * @template {Choice[] | ((instance: Choices) => object[] | Promise<object[]>)} T
    * @param {T} [choicesArrayOrFetcher]
    * @param {string} [value = 'value'] - name of `value` field
    * @param {string} [label = 'label'] - name of 'label' field
    * @param {boolean} [replaceChoices = false] - whether to replace of add choices
    * @returns {this | Promise<this>}
    *
    * @example
    * ```js
    * const example = new Choices(element);
    *
    * example.setChoices([
    *   {value: 'One', label: 'Label One', disabled: true},
    *   {value: 'Two', label: 'Label Two', selected: true},
    *   {value: 'Three', label: 'Label Three'},
    * ], 'value', 'label', false);
    * ```
    *
    * @example
    * ```js
    * const example = new Choices(element);
    *
    * example.setChoices(async () => {
    *   try {
    *      const items = await fetch('/items');
    *      return items.json()
    *   } catch(err) {
    *      console.error(err)
    *   }
    * });
    * ```
    *
    * @example
    * ```js
    * const example = new Choices(element);
    *
    * example.setChoices([{
    *   label: 'Group one',
    *   id: 1,
    *   disabled: false,
    *   choices: [
    *     {value: 'Child One', label: 'Child One', selected: true},
    *     {value: 'Child Two', label: 'Child Two',  disabled: true},
    *     {value: 'Child Three', label: 'Child Three'},
    *   ]
    * },
    * {
    *   label: 'Group two',
    *   id: 2,
    *   disabled: false,
    *   choices: [
    *     {value: 'Child Four', label: 'Child Four', disabled: true},
    *     {value: 'Child Five', label: 'Child Five'},
    *     {value: 'Child Six', label: 'Child Six', customProperties: {
    *       description: 'Custom description about child six',
    *       random: 'Another random custom property'
    *     }},
    *   ]
    * }], 'value', 'label', false);
    * ```
    */
   ;

   _proto.setChoices = function setChoices(choicesArrayOrFetcher, value, label, replaceChoices) {
     var _this11 = this;

     if (choicesArrayOrFetcher === void 0) {
       choicesArrayOrFetcher = [];
     }

     if (value === void 0) {
       value = 'value';
     }

     if (label === void 0) {
       label = 'label';
     }

     if (replaceChoices === void 0) {
       replaceChoices = false;
     }

     if (!this.initialised) {
       throw new ReferenceError("setChoices was called on a non-initialized instance of Choices");
     }

     if (!this._isSelectElement) {
       throw new TypeError("setChoices can't be used with INPUT based Choices");
     }

     if (typeof value !== 'string' || !value) {
       throw new TypeError("value parameter must be a name of 'value' field in passed objects");
     } // Clear choices if needed


     if (replaceChoices) {
       this.clearChoices();
     }

     if (typeof choicesArrayOrFetcher === 'function') {
       // it's a choices fetcher function
       var fetcher = choicesArrayOrFetcher(this);

       if (typeof Promise === 'function' && fetcher instanceof Promise) {
         // that's a promise
         // eslint-disable-next-line compat/compat
         return new Promise(function (resolve) {
           return requestAnimationFrame(resolve);
         }).then(function () {
           return _this11._handleLoadingState(true);
         }).then(function () {
           return fetcher;
         }).then(function (data) {
           return _this11.setChoices(data, value, label, replaceChoices);
         }).catch(function (err) {
           if (!_this11.config.silent) {
             console.error(err);
           }
         }).then(function () {
           return _this11._handleLoadingState(false);
         }).then(function () {
           return _this11;
         });
       } // function returned something else than promise, let's check if it's an array of choices


       if (!Array.isArray(fetcher)) {
         throw new TypeError(".setChoices first argument function must return either array of choices or Promise, got: " + typeof fetcher);
       } // recursion with results, it's sync and choices were cleared already


       return this.setChoices(fetcher, value, label, false);
     }

     if (!Array.isArray(choicesArrayOrFetcher)) {
       throw new TypeError(".setChoices must be called either with array of choices with a function resulting into Promise of array of choices");
     }

     this.containerOuter.removeLoadingState();

     this._startLoading();

     choicesArrayOrFetcher.forEach(function (groupOrChoice) {
       if (groupOrChoice.choices) {
         _this11._addGroup({
           id: parseInt(groupOrChoice.id, 10) || null,
           group: groupOrChoice,
           valueKey: value,
           labelKey: label
         });
       } else {
         _this11._addChoice({
           value: groupOrChoice[value],
           label: groupOrChoice[label],
           isSelected: groupOrChoice.selected,
           isDisabled: groupOrChoice.disabled,
           customProperties: groupOrChoice.customProperties,
           placeholder: groupOrChoice.placeholder
         });
       }
     });

     this._stopLoading();

     return this;
   };

   _proto.clearChoices = function clearChoices() {
     this._store.dispatch(choices_clearChoices());

     return this;
   };

   _proto.clearStore = function clearStore() {
     this._store.dispatch(clearAll());

     return this;
   };

   _proto.clearInput = function clearInput() {
     var shouldSetInputWidth = !this._isSelectOneElement;
     this.input.clear(shouldSetInputWidth);

     if (!this._isTextElement && this._canSearch) {
       this._isSearching = false;

       this._store.dispatch(choices_activateChoices(true));
     }

     return this;
   };

   _proto._render = function _render() {
     if (this._store.isLoading()) {
       return;
     }

     this._currentState = this._store.state;
     var stateChanged = this._currentState.choices !== this._prevState.choices || this._currentState.groups !== this._prevState.groups || this._currentState.items !== this._prevState.items;
     var shouldRenderChoices = this._isSelectElement;
     var shouldRenderItems = this._currentState.items !== this._prevState.items;

     if (!stateChanged) {
       return;
     }

     if (shouldRenderChoices) {
       this._renderChoices();
     }

     if (shouldRenderItems) {
       this._renderItems();
     }

     this._prevState = this._currentState;
   };

   _proto._renderChoices = function _renderChoices() {
     var _this12 = this;

     var _this$_store = this._store,
         activeGroups = _this$_store.activeGroups,
         activeChoices = _this$_store.activeChoices;
     var choiceListFragment = document.createDocumentFragment();
     this.choiceList.clear();

     if (this.config.resetScrollPosition) {
       requestAnimationFrame(function () {
         return _this12.choiceList.scrollToTop();
       });
     } // If we have grouped options


     if (activeGroups.length >= 1 && !this._isSearching) {
       // If we have a placeholder choice along with groups
       var activePlaceholders = activeChoices.filter(function (activeChoice) {
         return activeChoice.placeholder === true && activeChoice.groupId === -1;
       });

       if (activePlaceholders.length >= 1) {
         choiceListFragment = this._createChoicesFragment(activePlaceholders, choiceListFragment);
       }

       choiceListFragment = this._createGroupsFragment(activeGroups, activeChoices, choiceListFragment);
     } else if (activeChoices.length >= 1) {
       choiceListFragment = this._createChoicesFragment(activeChoices, choiceListFragment);
     } // If we have choices to show


     if (choiceListFragment.childNodes && choiceListFragment.childNodes.length > 0) {
       var activeItems = this._store.activeItems;

       var canAddItem = this._canAddItem(activeItems, this.input.value); // ...and we can select them


       if (canAddItem.response) {
         // ...append them and highlight the first choice
         this.choiceList.append(choiceListFragment);

         this._highlightChoice();
       } else {
         // ...otherwise show a notice
         this.choiceList.append(this._getTemplate('notice', canAddItem.notice));
       }
     } else {
       // Otherwise show a notice
       var dropdownItem;
       var notice;

       if (this._isSearching) {
         notice = typeof this.config.noResultsText === 'function' ? this.config.noResultsText() : this.config.noResultsText;
         dropdownItem = this._getTemplate('notice', notice, 'no-results');
       } else {
         notice = typeof this.config.noChoicesText === 'function' ? this.config.noChoicesText() : this.config.noChoicesText;
         dropdownItem = this._getTemplate('notice', notice, 'no-choices');
       }

       this.choiceList.append(dropdownItem);
     }
   };

   _proto._renderItems = function _renderItems() {
     var activeItems = this._store.activeItems || [];
     this.itemList.clear(); // Create a fragment to store our list items
     // (so we don't have to update the DOM for each item)

     var itemListFragment = this._createItemsFragment(activeItems); // If we have items to add, append them


     if (itemListFragment.childNodes) {
       this.itemList.append(itemListFragment);
     }
   };

   _proto._createGroupsFragment = function _createGroupsFragment(groups, choices, fragment) {
     var _this13 = this;

     if (fragment === void 0) {
       fragment = document.createDocumentFragment();
     }

     var getGroupChoices = function getGroupChoices(group) {
       return choices.filter(function (choice) {
         if (_this13._isSelectOneElement) {
           return choice.groupId === group.id;
         }

         return choice.groupId === group.id && (_this13.config.renderSelectedChoices === 'always' || !choice.selected);
       });
     }; // If sorting is enabled, filter groups


     if (this.config.shouldSort) {
       groups.sort(this.config.sorter);
     }

     groups.forEach(function (group) {
       var groupChoices = getGroupChoices(group);

       if (groupChoices.length >= 1) {
         var dropdownGroup = _this13._getTemplate('choiceGroup', group);

         fragment.appendChild(dropdownGroup);

         _this13._createChoicesFragment(groupChoices, fragment, true);
       }
     });
     return fragment;
   };

   _proto._createChoicesFragment = function _createChoicesFragment(choices, fragment, withinGroup) {
     var _this14 = this;

     if (fragment === void 0) {
       fragment = document.createDocumentFragment();
     }

     if (withinGroup === void 0) {
       withinGroup = false;
     }

     // Create a fragment to store our list items (so we don't have to update the DOM for each item)
     var _this$config = this.config,
         renderSelectedChoices = _this$config.renderSelectedChoices,
         searchResultLimit = _this$config.searchResultLimit,
         renderChoiceLimit = _this$config.renderChoiceLimit;
     var filter = this._isSearching ? sortByScore : this.config.sorter;

     var appendChoice = function appendChoice(choice) {
       var shouldRender = renderSelectedChoices === 'auto' ? _this14._isSelectOneElement || !choice.selected : true;

       if (shouldRender) {
         var dropdownItem = _this14._getTemplate('choice', choice, _this14.config.itemSelectText);

         fragment.appendChild(dropdownItem);
       }
     };

     var rendererableChoices = choices;

     if (renderSelectedChoices === 'auto' && !this._isSelectOneElement) {
       rendererableChoices = choices.filter(function (choice) {
         return !choice.selected;
       });
     } // Split array into placeholders and "normal" choices


     var _rendererableChoices$ = rendererableChoices.reduce(function (acc, choice) {
       if (choice.placeholder) {
         acc.placeholderChoices.push(choice);
       } else {
         acc.normalChoices.push(choice);
       }

       return acc;
     }, {
       placeholderChoices: [],
       normalChoices: []
     }),
         placeholderChoices = _rendererableChoices$.placeholderChoices,
         normalChoices = _rendererableChoices$.normalChoices; // If sorting is enabled or the user is searching, filter choices


     if (this.config.shouldSort || this._isSearching) {
       normalChoices.sort(filter);
     }

     var choiceLimit = rendererableChoices.length; // Prepend placeholeder

     var sortedChoices = this._isSelectOneElement ? [].concat(placeholderChoices, normalChoices) : normalChoices;

     if (this._isSearching) {
       choiceLimit = searchResultLimit;
     } else if (renderChoiceLimit && renderChoiceLimit > 0 && !withinGroup) {
       choiceLimit = renderChoiceLimit;
     } // Add each choice to dropdown within range


     for (var i = 0; i < choiceLimit; i += 1) {
       if (sortedChoices[i]) {
         appendChoice(sortedChoices[i]);
       }
     }

     return fragment;
   };

   _proto._createItemsFragment = function _createItemsFragment(items, fragment) {
     var _this15 = this;

     if (fragment === void 0) {
       fragment = document.createDocumentFragment();
     }

     // Create fragment to add elements to
     var _this$config2 = this.config,
         shouldSortItems = _this$config2.shouldSortItems,
         sorter = _this$config2.sorter,
         removeItemButton = _this$config2.removeItemButton; // If sorting is enabled, filter items

     if (shouldSortItems && !this._isSelectOneElement) {
       items.sort(sorter);
     }

     if (this._isTextElement) {
       // Update the value of the hidden input
       this.passedElement.value = items;
     } else {
       // Update the options of the hidden input
       this.passedElement.options = items;
     }

     var addItemToFragment = function addItemToFragment(item) {
       // Create new list element
       var listItem = _this15._getTemplate('item', item, removeItemButton); // Append it to list


       fragment.appendChild(listItem);
     }; // Add each list item to list


     items.forEach(addItemToFragment);
     return fragment;
   };

   _proto._triggerChange = function _triggerChange(value) {
     if (value === undefined || value === null) {
       return;
     }

     this.passedElement.triggerEvent(EVENTS.change, {
       value: value
     });
   };

   _proto._selectPlaceholderChoice = function _selectPlaceholderChoice() {
     var placeholderChoice = this._store.placeholderChoice;

     if (placeholderChoice) {
       this._addItem({
         value: placeholderChoice.value,
         label: placeholderChoice.label,
         choiceId: placeholderChoice.id,
         groupId: placeholderChoice.groupId,
         placeholder: placeholderChoice.placeholder
       });

       this._triggerChange(placeholderChoice.value);
     }
   };

   _proto._handleButtonAction = function _handleButtonAction(activeItems, element) {
     if (!activeItems || !element || !this.config.removeItems || !this.config.removeItemButton) {
       return;
     }

     var itemId = element.parentNode.getAttribute('data-id');
     var itemToRemove = activeItems.find(function (item) {
       return item.id === parseInt(itemId, 10);
     }); // Remove item associated with button

     this._removeItem(itemToRemove);

     this._triggerChange(itemToRemove.value);

     if (this._isSelectOneElement) {
       this._selectPlaceholderChoice();
     }
   };

   _proto._handleItemAction = function _handleItemAction(activeItems, element, hasShiftKey) {
     var _this16 = this;

     if (hasShiftKey === void 0) {
       hasShiftKey = false;
     }

     if (!activeItems || !element || !this.config.removeItems || this._isSelectOneElement) {
       return;
     }

     var passedId = element.getAttribute('data-id'); // We only want to select one item with a click
     // so we deselect any items that aren't the target
     // unless shift is being pressed

     activeItems.forEach(function (item) {
       if (item.id === parseInt(passedId, 10) && !item.highlighted) {
         _this16.highlightItem(item);
       } else if (!hasShiftKey && item.highlighted) {
         _this16.unhighlightItem(item);
       }
     }); // Focus input as without focus, a user cannot do anything with a
     // highlighted item

     this.input.focus();
   };

   _proto._handleChoiceAction = function _handleChoiceAction(activeItems, element) {
     if (!activeItems || !element) {
       return;
     } // If we are clicking on an option


     var id = element.dataset.id;

     var choice = this._store.getChoiceById(id);

     if (!choice) {
       return;
     }

     var passedKeyCode = activeItems[0] && activeItems[0].keyCode ? activeItems[0].keyCode : null;
     var hasActiveDropdown = this.dropdown.isActive; // Update choice keyCode

     choice.keyCode = passedKeyCode;
     this.passedElement.triggerEvent(EVENTS.choice, {
       choice: choice
     });

     if (!choice.selected && !choice.disabled) {
       var canAddItem = this._canAddItem(activeItems, choice.value);

       if (canAddItem.response) {
         this._addItem({
           value: choice.value,
           label: choice.label,
           choiceId: choice.id,
           groupId: choice.groupId,
           customProperties: choice.customProperties,
           placeholder: choice.placeholder,
           keyCode: choice.keyCode
         });

         this._triggerChange(choice.value);
       }
     }

     this.clearInput(); // We want to close the dropdown if we are dealing with a single select box

     if (hasActiveDropdown && this._isSelectOneElement) {
       this.hideDropdown(true);
       this.containerOuter.focus();
     }
   };

   _proto._handleBackspace = function _handleBackspace(activeItems) {
     if (!this.config.removeItems || !activeItems) {
       return;
     }

     var lastItem = activeItems[activeItems.length - 1];
     var hasHighlightedItems = activeItems.some(function (item) {
       return item.highlighted;
     }); // If editing the last item is allowed and there are not other selected items,
     // we can edit the item value. Otherwise if we can remove items, remove all selected items

     if (this.config.editItems && !hasHighlightedItems && lastItem) {
       this.input.value = lastItem.value;
       this.input.setWidth();

       this._removeItem(lastItem);

       this._triggerChange(lastItem.value);
     } else {
       if (!hasHighlightedItems) {
         // Highlight last item if none already highlighted
         this.highlightItem(lastItem, false);
       }

       this.removeHighlightedItems(true);
     }
   };

   _proto._startLoading = function _startLoading() {
     this._store.dispatch(setIsLoading(true));
   };

   _proto._stopLoading = function _stopLoading() {
     this._store.dispatch(setIsLoading(false));
   };

   _proto._handleLoadingState = function _handleLoadingState(setLoading) {
     if (setLoading === void 0) {
       setLoading = true;
     }

     var placeholderItem = this.itemList.getChild("." + this.config.classNames.placeholder);

     if (setLoading) {
       this.disable();
       this.containerOuter.addLoadingState();

       if (this._isSelectOneElement) {
         if (!placeholderItem) {
           placeholderItem = this._getTemplate('placeholder', this.config.loadingText);
           this.itemList.append(placeholderItem);
         } else {
           placeholderItem.innerHTML = this.config.loadingText;
         }
       } else {
         this.input.placeholder = this.config.loadingText;
       }
     } else {
       this.enable();
       this.containerOuter.removeLoadingState();

       if (this._isSelectOneElement) {
         placeholderItem.innerHTML = this._placeholderValue || '';
       } else {
         this.input.placeholder = this._placeholderValue || '';
       }
     }
   };

   _proto._handleSearch = function _handleSearch(value) {
     if (!value || !this.input.isFocussed) {
       return;
     }

     var choices = this._store.choices;
     var _this$config3 = this.config,
         searchFloor = _this$config3.searchFloor,
         searchChoices = _this$config3.searchChoices;
     var hasUnactiveChoices = choices.some(function (option) {
       return !option.active;
     }); // Check that we have a value to search and the input was an alphanumeric character

     if (value && value.length >= searchFloor) {
       var resultCount = searchChoices ? this._searchChoices(value) : 0; // Trigger search event

       this.passedElement.triggerEvent(EVENTS.search, {
         value: value,
         resultCount: resultCount
       });
     } else if (hasUnactiveChoices) {
       // Otherwise reset choices to active
       this._isSearching = false;

       this._store.dispatch(choices_activateChoices(true));
     }
   };

   _proto._canAddItem = function _canAddItem(activeItems, value) {
     var canAddItem = true;
     var notice = typeof this.config.addItemText === 'function' ? this.config.addItemText(value) : this.config.addItemText;

     if (!this._isSelectOneElement) {
       var isDuplicateValue = existsInArray(activeItems, value);

       if (this.config.maxItemCount > 0 && this.config.maxItemCount <= activeItems.length) {
         // If there is a max entry limit and we have reached that limit
         // don't update
         canAddItem = false;
         notice = typeof this.config.maxItemText === 'function' ? this.config.maxItemText(this.config.maxItemCount) : this.config.maxItemText;
       }

       if (!this.config.duplicateItemsAllowed && isDuplicateValue && canAddItem) {
         canAddItem = false;
         notice = typeof this.config.uniqueItemText === 'function' ? this.config.uniqueItemText(value) : this.config.uniqueItemText;
       }

       if (this._isTextElement && this.config.addItems && canAddItem && typeof this.config.addItemFilter === 'function' && !this.config.addItemFilter(value)) {
         canAddItem = false;
         notice = typeof this.config.customAddItemText === 'function' ? this.config.customAddItemText(value) : this.config.customAddItemText;
       }
     }

     return {
       response: canAddItem,
       notice: notice
     };
   };

   _proto._searchChoices = function _searchChoices(value) {
     var newValue = typeof value === 'string' ? value.trim() : value;
     var currentValue = typeof this._currentValue === 'string' ? this._currentValue.trim() : this._currentValue;

     if (newValue.length < 1 && newValue === currentValue + " ") {
       return 0;
     } // If new value matches the desired length and is not the same as the current value with a space


     var haystack = this._store.searchableChoices;
     var needle = newValue;
     var keys = [].concat(this.config.searchFields);
     var options = Object.assign(this.config.fuseOptions, {
       keys: keys
     });
     var fuse = new fuse_default.a(haystack, options);
     var results = fuse.search(needle);
     this._currentValue = newValue;
     this._highlightPosition = 0;
     this._isSearching = true;

     this._store.dispatch(choices_filterChoices(results));

     return results.length;
   };

   _proto._addEventListeners = function _addEventListeners() {
     var _document = document,
         documentElement = _document.documentElement; // capture events - can cancel event processing or propagation

     documentElement.addEventListener('touchend', this._onTouchEnd, true);
     this.containerOuter.element.addEventListener('keydown', this._onKeyDown, true);
     this.containerOuter.element.addEventListener('mousedown', this._onMouseDown, true); // passive events - doesn't call `preventDefault` or `stopPropagation`

     documentElement.addEventListener('click', this._onClick, {
       passive: true
     });
     documentElement.addEventListener('touchmove', this._onTouchMove, {
       passive: true
     });
     this.dropdown.element.addEventListener('mouseover', this._onMouseOver, {
       passive: true
     });

     if (this._isSelectOneElement) {
       this.containerOuter.element.addEventListener('focus', this._onFocus, {
         passive: true
       });
       this.containerOuter.element.addEventListener('blur', this._onBlur, {
         passive: true
       });
     }

     this.input.element.addEventListener('keyup', this._onKeyUp, {
       passive: true
     });
     this.input.element.addEventListener('focus', this._onFocus, {
       passive: true
     });
     this.input.element.addEventListener('blur', this._onBlur, {
       passive: true
     });

     if (this.input.element.form) {
       this.input.element.form.addEventListener('reset', this._onFormReset, {
         passive: true
       });
     }

     this.input.addEventListeners();
   };

   _proto._removeEventListeners = function _removeEventListeners() {
     var _document2 = document,
         documentElement = _document2.documentElement;
     documentElement.removeEventListener('touchend', this._onTouchEnd, true);
     this.containerOuter.element.removeEventListener('keydown', this._onKeyDown, true);
     this.containerOuter.element.removeEventListener('mousedown', this._onMouseDown, true);
     documentElement.removeEventListener('click', this._onClick);
     documentElement.removeEventListener('touchmove', this._onTouchMove);
     this.dropdown.element.removeEventListener('mouseover', this._onMouseOver);

     if (this._isSelectOneElement) {
       this.containerOuter.element.removeEventListener('focus', this._onFocus);
       this.containerOuter.element.removeEventListener('blur', this._onBlur);
     }

     this.input.element.removeEventListener('keyup', this._onKeyUp);
     this.input.element.removeEventListener('focus', this._onFocus);
     this.input.element.removeEventListener('blur', this._onBlur);

     if (this.input.element.form) {
       this.input.element.form.removeEventListener('reset', this._onFormReset);
     }

     this.input.removeEventListeners();
   }
   /**
    * @param {KeyboardEvent} event
    */
   ;

   _proto._onKeyDown = function _onKeyDown(event) {
     var _keyDownActions;

     var target = event.target,
         keyCode = event.keyCode,
         ctrlKey = event.ctrlKey,
         metaKey = event.metaKey;
     var activeItems = this._store.activeItems;
     var hasFocusedInput = this.input.isFocussed;
     var hasActiveDropdown = this.dropdown.isActive;
     var hasItems = this.itemList.hasChildren();
     var keyString = String.fromCharCode(keyCode);
     var BACK_KEY = KEY_CODES.BACK_KEY,
         DELETE_KEY = KEY_CODES.DELETE_KEY,
         ENTER_KEY = KEY_CODES.ENTER_KEY,
         A_KEY = KEY_CODES.A_KEY,
         ESC_KEY = KEY_CODES.ESC_KEY,
         UP_KEY = KEY_CODES.UP_KEY,
         DOWN_KEY = KEY_CODES.DOWN_KEY,
         PAGE_UP_KEY = KEY_CODES.PAGE_UP_KEY,
         PAGE_DOWN_KEY = KEY_CODES.PAGE_DOWN_KEY;
     var hasCtrlDownKeyPressed = ctrlKey || metaKey; // If a user is typing and the dropdown is not active

     if (!this._isTextElement && /[a-zA-Z0-9-_ ]/.test(keyString)) {
       this.showDropdown();
     } // Map keys to key actions


     var keyDownActions = (_keyDownActions = {}, _keyDownActions[A_KEY] = this._onAKey, _keyDownActions[ENTER_KEY] = this._onEnterKey, _keyDownActions[ESC_KEY] = this._onEscapeKey, _keyDownActions[UP_KEY] = this._onDirectionKey, _keyDownActions[PAGE_UP_KEY] = this._onDirectionKey, _keyDownActions[DOWN_KEY] = this._onDirectionKey, _keyDownActions[PAGE_DOWN_KEY] = this._onDirectionKey, _keyDownActions[DELETE_KEY] = this._onDeleteKey, _keyDownActions[BACK_KEY] = this._onDeleteKey, _keyDownActions); // If keycode has a function, run it

     if (keyDownActions[keyCode]) {
       keyDownActions[keyCode]({
         event: event,
         target: target,
         keyCode: keyCode,
         metaKey: metaKey,
         activeItems: activeItems,
         hasFocusedInput: hasFocusedInput,
         hasActiveDropdown: hasActiveDropdown,
         hasItems: hasItems,
         hasCtrlDownKeyPressed: hasCtrlDownKeyPressed
       });
     }
   };

   _proto._onKeyUp = function _onKeyUp(_ref2) {
     var target = _ref2.target,
         keyCode = _ref2.keyCode;
     var value = this.input.value;
     var activeItems = this._store.activeItems;

     var canAddItem = this._canAddItem(activeItems, value);

     var backKey = KEY_CODES.BACK_KEY,
         deleteKey = KEY_CODES.DELETE_KEY; // We are typing into a text input and have a value, we want to show a dropdown
     // notice. Otherwise hide the dropdown

     if (this._isTextElement) {
       var canShowDropdownNotice = canAddItem.notice && value;

       if (canShowDropdownNotice) {
         var dropdownItem = this._getTemplate('notice', canAddItem.notice);

         this.dropdown.element.innerHTML = dropdownItem.outerHTML;
         this.showDropdown(true);
       } else {
         this.hideDropdown(true);
       }
     } else {
       var userHasRemovedValue = (keyCode === backKey || keyCode === deleteKey) && !target.value;
       var canReactivateChoices = !this._isTextElement && this._isSearching;
       var canSearch = this._canSearch && canAddItem.response;

       if (userHasRemovedValue && canReactivateChoices) {
         this._isSearching = false;

         this._store.dispatch(choices_activateChoices(true));
       } else if (canSearch) {
         this._handleSearch(this.input.value);
       }
     }

     this._canSearch = this.config.searchEnabled;
   };

   _proto._onAKey = function _onAKey(_ref3) {
     var hasItems = _ref3.hasItems,
         hasCtrlDownKeyPressed = _ref3.hasCtrlDownKeyPressed;

     // If CTRL + A or CMD + A have been pressed and there are items to select
     if (hasCtrlDownKeyPressed && hasItems) {
       this._canSearch = false;
       var shouldHightlightAll = this.config.removeItems && !this.input.value && this.input.element === document.activeElement;

       if (shouldHightlightAll) {
         this.highlightAll();
       }
     }
   };

   _proto._onEnterKey = function _onEnterKey(_ref4) {
     var event = _ref4.event,
         target = _ref4.target,
         activeItems = _ref4.activeItems,
         hasActiveDropdown = _ref4.hasActiveDropdown;
     var enterKey = KEY_CODES.ENTER_KEY;
     var targetWasButton = target.hasAttribute('data-button');

     if (this._isTextElement && target.value) {
       var value = this.input.value;

       var canAddItem = this._canAddItem(activeItems, value);

       if (canAddItem.response) {
         this.hideDropdown(true);

         this._addItem({
           value: value
         });

         this._triggerChange(value);

         this.clearInput();
       }
     }

     if (targetWasButton) {
       this._handleButtonAction(activeItems, target);

       event.preventDefault();
     }

     if (hasActiveDropdown) {
       var highlightedChoice = this.dropdown.getChild("." + this.config.classNames.highlightedState);

       if (highlightedChoice) {
         // add enter keyCode value
         if (activeItems[0]) {
           activeItems[0].keyCode = enterKey; // eslint-disable-line no-param-reassign
         }

         this._handleChoiceAction(activeItems, highlightedChoice);
       }

       event.preventDefault();
     } else if (this._isSelectOneElement) {
       this.showDropdown();
       event.preventDefault();
     }
   };

   _proto._onEscapeKey = function _onEscapeKey(_ref5) {
     var hasActiveDropdown = _ref5.hasActiveDropdown;

     if (hasActiveDropdown) {
       this.hideDropdown(true);
       this.containerOuter.focus();
     }
   };

   _proto._onDirectionKey = function _onDirectionKey(_ref6) {
     var event = _ref6.event,
         hasActiveDropdown = _ref6.hasActiveDropdown,
         keyCode = _ref6.keyCode,
         metaKey = _ref6.metaKey;
     var downKey = KEY_CODES.DOWN_KEY,
         pageUpKey = KEY_CODES.PAGE_UP_KEY,
         pageDownKey = KEY_CODES.PAGE_DOWN_KEY; // If up or down key is pressed, traverse through options

     if (hasActiveDropdown || this._isSelectOneElement) {
       this.showDropdown();
       this._canSearch = false;
       var directionInt = keyCode === downKey || keyCode === pageDownKey ? 1 : -1;
       var skipKey = metaKey || keyCode === pageDownKey || keyCode === pageUpKey;
       var selectableChoiceIdentifier = '[data-choice-selectable]';
       var nextEl;

       if (skipKey) {
         if (directionInt > 0) {
           nextEl = this.dropdown.element.querySelector(selectableChoiceIdentifier + ":last-of-type");
         } else {
           nextEl = this.dropdown.element.querySelector(selectableChoiceIdentifier);
         }
       } else {
         var currentEl = this.dropdown.element.querySelector("." + this.config.classNames.highlightedState);

         if (currentEl) {
           nextEl = getAdjacentEl(currentEl, selectableChoiceIdentifier, directionInt);
         } else {
           nextEl = this.dropdown.element.querySelector(selectableChoiceIdentifier);
         }
       }

       if (nextEl) {
         // We prevent default to stop the cursor moving
         // when pressing the arrow
         if (!isScrolledIntoView(nextEl, this.choiceList.element, directionInt)) {
           this.choiceList.scrollToChildElement(nextEl, directionInt);
         }

         this._highlightChoice(nextEl);
       } // Prevent default to maintain cursor position whilst
       // traversing dropdown options


       event.preventDefault();
     }
   };

   _proto._onDeleteKey = function _onDeleteKey(_ref7) {
     var event = _ref7.event,
         target = _ref7.target,
         hasFocusedInput = _ref7.hasFocusedInput,
         activeItems = _ref7.activeItems;

     // If backspace or delete key is pressed and the input has no value
     if (hasFocusedInput && !target.value && !this._isSelectOneElement) {
       this._handleBackspace(activeItems);

       event.preventDefault();
     }
   };

   _proto._onTouchMove = function _onTouchMove() {
     if (this._wasTap) {
       this._wasTap = false;
     }
   };

   _proto._onTouchEnd = function _onTouchEnd(event) {
     var _ref8 = event || event.touches[0],
         target = _ref8.target;

     var touchWasWithinContainer = this._wasTap && this.containerOuter.element.contains(target);

     if (touchWasWithinContainer) {
       var containerWasExactTarget = target === this.containerOuter.element || target === this.containerInner.element;

       if (containerWasExactTarget) {
         if (this._isTextElement) {
           this.input.focus();
         } else if (this._isSelectMultipleElement) {
           this.showDropdown();
         }
       } // Prevents focus event firing


       event.stopPropagation();
     }

     this._wasTap = true;
   }
   /**
    * Handles mousedown event in capture mode for containetOuter.element
    * @param {MouseEvent} event
    */
   ;

   _proto._onMouseDown = function _onMouseDown(event) {
     var target = event.target;

     if (!(target instanceof HTMLElement)) {
       return;
     } // If we have our mouse down on the scrollbar and are on IE11...


     if (IS_IE11 && this.choiceList.element.contains(target)) {
       // check if click was on a scrollbar area
       var firstChoice =
       /** @type {HTMLElement} */
       this.choiceList.element.firstElementChild;
       var isOnScrollbar = this._direction === 'ltr' ? event.offsetX >= firstChoice.offsetWidth : event.offsetX < firstChoice.offsetLeft;
       this._isScrollingOnIe = isOnScrollbar;
     }

     if (target === this.input.element) {
       return;
     }

     var item = target.closest('[data-button],[data-item],[data-choice]');

     if (item instanceof HTMLElement) {
       var hasShiftKey = event.shiftKey;
       var activeItems = this._store.activeItems;
       var dataset = item.dataset;

       if ('button' in dataset) {
         this._handleButtonAction(activeItems, item);
       } else if ('item' in dataset) {
         this._handleItemAction(activeItems, item, hasShiftKey);
       } else if ('choice' in dataset) {
         this._handleChoiceAction(activeItems, item);
       }
     }

     event.preventDefault();
   }
   /**
    * Handles mouseover event over this.dropdown
    * @param {MouseEvent} event
    */
   ;

   _proto._onMouseOver = function _onMouseOver(_ref9) {
     var target = _ref9.target;

     if (target instanceof HTMLElement && 'choice' in target.dataset) {
       this._highlightChoice(target);
     }
   };

   _proto._onClick = function _onClick(_ref10) {
     var target = _ref10.target;
     var clickWasWithinContainer = this.containerOuter.element.contains(target);

     if (clickWasWithinContainer) {
       if (!this.dropdown.isActive && !this.containerOuter.isDisabled) {
         if (this._isTextElement) {
           if (document.activeElement !== this.input.element) {
             this.input.focus();
           }
         } else {
           this.showDropdown();
           this.containerOuter.focus();
         }
       } else if (this._isSelectOneElement && target !== this.input.element && !this.dropdown.element.contains(target)) {
         this.hideDropdown();
       }
     } else {
       var hasHighlightedItems = this._store.highlightedActiveItems.length > 0;

       if (hasHighlightedItems) {
         this.unhighlightAll();
       }

       this.containerOuter.removeFocusState();
       this.hideDropdown(true);
     }
   };

   _proto._onFocus = function _onFocus(_ref11) {
     var _this17 = this,
         _focusActions;

     var target = _ref11.target;
     var focusWasWithinContainer = this.containerOuter.element.contains(target);

     if (!focusWasWithinContainer) {
       return;
     }

     var focusActions = (_focusActions = {}, _focusActions[TEXT_TYPE] = function () {
       if (target === _this17.input.element) {
         _this17.containerOuter.addFocusState();
       }
     }, _focusActions[SELECT_ONE_TYPE] = function () {
       _this17.containerOuter.addFocusState();

       if (target === _this17.input.element) {
         _this17.showDropdown(true);
       }
     }, _focusActions[SELECT_MULTIPLE_TYPE] = function () {
       if (target === _this17.input.element) {
         _this17.showDropdown(true); // If element is a select box, the focused element is the container and the dropdown
         // isn't already open, focus and show dropdown


         _this17.containerOuter.addFocusState();
       }
     }, _focusActions);
     focusActions[this.passedElement.element.type]();
   };

   _proto._onBlur = function _onBlur(_ref12) {
     var _this18 = this;

     var target = _ref12.target;
     var blurWasWithinContainer = this.containerOuter.element.contains(target);

     if (blurWasWithinContainer && !this._isScrollingOnIe) {
       var _blurActions;

       var activeItems = this._store.activeItems;
       var hasHighlightedItems = activeItems.some(function (item) {
         return item.highlighted;
       });
       var blurActions = (_blurActions = {}, _blurActions[TEXT_TYPE] = function () {
         if (target === _this18.input.element) {
           _this18.containerOuter.removeFocusState();

           if (hasHighlightedItems) {
             _this18.unhighlightAll();
           }

           _this18.hideDropdown(true);
         }
       }, _blurActions[SELECT_ONE_TYPE] = function () {
         _this18.containerOuter.removeFocusState();

         if (target === _this18.input.element || target === _this18.containerOuter.element && !_this18._canSearch) {
           _this18.hideDropdown(true);
         }
       }, _blurActions[SELECT_MULTIPLE_TYPE] = function () {
         if (target === _this18.input.element) {
           _this18.containerOuter.removeFocusState();

           _this18.hideDropdown(true);

           if (hasHighlightedItems) {
             _this18.unhighlightAll();
           }
         }
       }, _blurActions);
       blurActions[this.passedElement.element.type]();
     } else {
       // On IE11, clicking the scollbar blurs our input and thus
       // closes the dropdown. To stop this, we refocus our input
       // if we know we are on IE *and* are scrolling.
       this._isScrollingOnIe = false;
       this.input.element.focus();
     }
   };

   _proto._onFormReset = function _onFormReset() {
     this._store.dispatch(resetTo(this._initialState));
   };

   _proto._highlightChoice = function _highlightChoice(el) {
     var _this19 = this;

     if (el === void 0) {
       el = null;
     }

     var choices = Array.from(this.dropdown.element.querySelectorAll('[data-choice-selectable]'));

     if (!choices.length) {
       return;
     }

     var passedEl = el;
     var highlightedChoices = Array.from(this.dropdown.element.querySelectorAll("." + this.config.classNames.highlightedState)); // Remove any highlighted choices

     highlightedChoices.forEach(function (choice) {
       choice.classList.remove(_this19.config.classNames.highlightedState);
       choice.setAttribute('aria-selected', 'false');
     });

     if (passedEl) {
       this._highlightPosition = choices.indexOf(passedEl);
     } else {
       // Highlight choice based on last known highlight location
       if (choices.length > this._highlightPosition) {
         // If we have an option to highlight
         passedEl = choices[this._highlightPosition];
       } else {
         // Otherwise highlight the option before
         passedEl = choices[choices.length - 1];
       }

       if (!passedEl) {
         passedEl = choices[0];
       }
     }

     passedEl.classList.add(this.config.classNames.highlightedState);
     passedEl.setAttribute('aria-selected', 'true');
     this.passedElement.triggerEvent(EVENTS.highlightChoice, {
       el: passedEl
     });

     if (this.dropdown.isActive) {
       // IE11 ignores aria-label and blocks virtual keyboard
       // if aria-activedescendant is set without a dropdown
       this.input.setActiveDescendant(passedEl.id);
       this.containerOuter.setActiveDescendant(passedEl.id);
     }
   };

   _proto._addItem = function _addItem(_ref13) {
     var value = _ref13.value,
         _ref13$label = _ref13.label,
         label = _ref13$label === void 0 ? null : _ref13$label,
         _ref13$choiceId = _ref13.choiceId,
         choiceId = _ref13$choiceId === void 0 ? -1 : _ref13$choiceId,
         _ref13$groupId = _ref13.groupId,
         groupId = _ref13$groupId === void 0 ? -1 : _ref13$groupId,
         _ref13$customProperti = _ref13.customProperties,
         customProperties = _ref13$customProperti === void 0 ? null : _ref13$customProperti,
         _ref13$placeholder = _ref13.placeholder,
         placeholder = _ref13$placeholder === void 0 ? false : _ref13$placeholder,
         _ref13$keyCode = _ref13.keyCode,
         keyCode = _ref13$keyCode === void 0 ? null : _ref13$keyCode;
     var passedValue = typeof value === 'string' ? value.trim() : value;
     var passedKeyCode = keyCode;
     var passedCustomProperties = customProperties;
     var items = this._store.items;
     var passedLabel = label || passedValue;
     var passedOptionId = choiceId || -1;
     var group = groupId >= 0 ? this._store.getGroupById(groupId) : null;
     var id = items ? items.length + 1 : 1; // If a prepended value has been passed, prepend it

     if (this.config.prependValue) {
       passedValue = this.config.prependValue + passedValue.toString();
     } // If an appended value has been passed, append it


     if (this.config.appendValue) {
       passedValue += this.config.appendValue.toString();
     }

     this._store.dispatch(items_addItem({
       value: passedValue,
       label: passedLabel,
       id: id,
       choiceId: passedOptionId,
       groupId: groupId,
       customProperties: customProperties,
       placeholder: placeholder,
       keyCode: passedKeyCode
     }));

     if (this._isSelectOneElement) {
       this.removeActiveItems(id);
     } // Trigger change event


     this.passedElement.triggerEvent(EVENTS.addItem, {
       id: id,
       value: passedValue,
       label: passedLabel,
       customProperties: passedCustomProperties,
       groupValue: group && group.value ? group.value : undefined,
       keyCode: passedKeyCode
     });
     return this;
   };

   _proto._removeItem = function _removeItem(item) {
     if (!item || !isType('Object', item)) {
       return this;
     }

     var id = item.id,
         value = item.value,
         label = item.label,
         choiceId = item.choiceId,
         groupId = item.groupId;
     var group = groupId >= 0 ? this._store.getGroupById(groupId) : null;

     this._store.dispatch(items_removeItem(id, choiceId));

     if (group && group.value) {
       this.passedElement.triggerEvent(EVENTS.removeItem, {
         id: id,
         value: value,
         label: label,
         groupValue: group.value
       });
     } else {
       this.passedElement.triggerEvent(EVENTS.removeItem, {
         id: id,
         value: value,
         label: label
       });
     }

     return this;
   };

   _proto._addChoice = function _addChoice(_ref14) {
     var value = _ref14.value,
         _ref14$label = _ref14.label,
         label = _ref14$label === void 0 ? null : _ref14$label,
         _ref14$isSelected = _ref14.isSelected,
         isSelected = _ref14$isSelected === void 0 ? false : _ref14$isSelected,
         _ref14$isDisabled = _ref14.isDisabled,
         isDisabled = _ref14$isDisabled === void 0 ? false : _ref14$isDisabled,
         _ref14$groupId = _ref14.groupId,
         groupId = _ref14$groupId === void 0 ? -1 : _ref14$groupId,
         _ref14$customProperti = _ref14.customProperties,
         customProperties = _ref14$customProperti === void 0 ? null : _ref14$customProperti,
         _ref14$placeholder = _ref14.placeholder,
         placeholder = _ref14$placeholder === void 0 ? false : _ref14$placeholder,
         _ref14$keyCode = _ref14.keyCode,
         keyCode = _ref14$keyCode === void 0 ? null : _ref14$keyCode;

     if (typeof value === 'undefined' || value === null) {
       return;
     } // Generate unique id


     var choices = this._store.choices;
     var choiceLabel = label || value;
     var choiceId = choices ? choices.length + 1 : 1;
     var choiceElementId = this._baseId + "-" + this._idNames.itemChoice + "-" + choiceId;

     this._store.dispatch(choices_addChoice({
       id: choiceId,
       groupId: groupId,
       elementId: choiceElementId,
       value: value,
       label: choiceLabel,
       disabled: isDisabled,
       customProperties: customProperties,
       placeholder: placeholder,
       keyCode: keyCode
     }));

     if (isSelected) {
       this._addItem({
         value: value,
         label: choiceLabel,
         choiceId: choiceId,
         customProperties: customProperties,
         placeholder: placeholder,
         keyCode: keyCode
       });
     }
   };

   _proto._addGroup = function _addGroup(_ref15) {
     var _this20 = this;

     var group = _ref15.group,
         id = _ref15.id,
         _ref15$valueKey = _ref15.valueKey,
         valueKey = _ref15$valueKey === void 0 ? 'value' : _ref15$valueKey,
         _ref15$labelKey = _ref15.labelKey,
         labelKey = _ref15$labelKey === void 0 ? 'label' : _ref15$labelKey;
     var groupChoices = isType('Object', group) ? group.choices : Array.from(group.getElementsByTagName('OPTION'));
     var groupId = id || Math.floor(new Date().valueOf() * Math.random());
     var isDisabled = group.disabled ? group.disabled : false;

     if (groupChoices) {
       this._store.dispatch(groups_addGroup({
         value: group.label,
         id: groupId,
         active: true,
         disabled: isDisabled
       }));

       var addGroupChoices = function addGroupChoices(choice) {
         var isOptDisabled = choice.disabled || choice.parentNode && choice.parentNode.disabled;

         _this20._addChoice({
           value: choice[valueKey],
           label: isType('Object', choice) ? choice[labelKey] : choice.innerHTML,
           isSelected: choice.selected,
           isDisabled: isOptDisabled,
           groupId: groupId,
           customProperties: choice.customProperties,
           placeholder: choice.placeholder
         });
       };

       groupChoices.forEach(addGroupChoices);
     } else {
       this._store.dispatch(groups_addGroup({
         value: group.label,
         id: group.id,
         active: false,
         disabled: group.disabled
       }));
     }
   };

   _proto._getTemplate = function _getTemplate(template) {
     var _this$_templates$temp;

     if (!template) {
       return null;
     }

     var classNames = this.config.classNames;

     for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
       args[_key - 1] = arguments[_key];
     }

     return (_this$_templates$temp = this._templates[template]).call.apply(_this$_templates$temp, [this, classNames].concat(args));
   };

   _proto._createTemplates = function _createTemplates() {
     var callbackOnCreateTemplates = this.config.callbackOnCreateTemplates;
     var userTemplates = {};

     if (callbackOnCreateTemplates && typeof callbackOnCreateTemplates === 'function') {
       userTemplates = callbackOnCreateTemplates.call(this, strToEl);
     }

     this._templates = cjs_default()(TEMPLATES, userTemplates);
   };

   _proto._createElements = function _createElements() {
     this.containerOuter = new container_Container({
       element: this._getTemplate('containerOuter', this._direction, this._isSelectElement, this._isSelectOneElement, this.config.searchEnabled, this.passedElement.element.type),
       classNames: this.config.classNames,
       type: this.passedElement.element.type,
       position: this.config.position
     });
     this.containerInner = new container_Container({
       element: this._getTemplate('containerInner'),
       classNames: this.config.classNames,
       type: this.passedElement.element.type,
       position: this.config.position
     });
     this.input = new input_Input({
       element: this._getTemplate('input', this._placeholderValue),
       classNames: this.config.classNames,
       type: this.passedElement.element.type,
       preventPaste: !this.config.paste
     });
     this.choiceList = new list_List({
       element: this._getTemplate('choiceList', this._isSelectOneElement)
     });
     this.itemList = new list_List({
       element: this._getTemplate('itemList', this._isSelectOneElement)
     });
     this.dropdown = new Dropdown({
       element: this._getTemplate('dropdown'),
       classNames: this.config.classNames,
       type: this.passedElement.element.type
     });
   };

   _proto._createStructure = function _createStructure() {
     // Hide original element
     this.passedElement.conceal(); // Wrap input in container preserving DOM ordering

     this.containerInner.wrap(this.passedElement.element); // Wrapper inner container with outer container

     this.containerOuter.wrap(this.containerInner.element);

     if (this._isSelectOneElement) {
       this.input.placeholder = this.config.searchPlaceholderValue || '';
     } else if (this._placeholderValue) {
       this.input.placeholder = this._placeholderValue;
       this.input.setWidth();
     }

     this.containerOuter.element.appendChild(this.containerInner.element);
     this.containerOuter.element.appendChild(this.dropdown.element);
     this.containerInner.element.appendChild(this.itemList.element);

     if (!this._isTextElement) {
       this.dropdown.element.appendChild(this.choiceList.element);
     }

     if (!this._isSelectOneElement) {
       this.containerInner.element.appendChild(this.input.element);
     } else if (this.config.searchEnabled) {
       this.dropdown.element.insertBefore(this.input.element, this.dropdown.element.firstChild);
     }

     if (this._isSelectElement) {
       this._highlightPosition = 0;
       this._isSearching = false;

       this._startLoading();

       if (this._presetGroups.length) {
         this._addPredefinedGroups(this._presetGroups);
       } else {
         this._addPredefinedChoices(this._presetChoices);
       }

       this._stopLoading();
     }

     if (this._isTextElement) {
       this._addPredefinedItems(this._presetItems);
     }
   };

   _proto._addPredefinedGroups = function _addPredefinedGroups(groups) {
     var _this21 = this;

     // If we have a placeholder option
     var placeholderChoice = this.passedElement.placeholderOption;

     if (placeholderChoice && placeholderChoice.parentNode.tagName === 'SELECT') {
       this._addChoice({
         value: placeholderChoice.value,
         label: placeholderChoice.innerHTML,
         isSelected: placeholderChoice.selected,
         isDisabled: placeholderChoice.disabled,
         placeholder: true
       });
     }

     groups.forEach(function (group) {
       return _this21._addGroup({
         group: group,
         id: group.id || null
       });
     });
   };

   _proto._addPredefinedChoices = function _addPredefinedChoices(choices) {
     var _this22 = this;

     // If sorting is enabled or the user is searching, filter choices
     if (this.config.shouldSort) {
       choices.sort(this.config.sorter);
     }

     var hasSelectedChoice = choices.some(function (choice) {
       return choice.selected;
     });
     var firstEnabledChoiceIndex = choices.findIndex(function (choice) {
       return choice.disabled === undefined || !choice.disabled;
     });
     choices.forEach(function (choice, index) {
       var value = choice.value,
           label = choice.label,
           customProperties = choice.customProperties,
           placeholder = choice.placeholder;

       if (_this22._isSelectElement) {
         // If the choice is actually a group
         if (choice.choices) {
           _this22._addGroup({
             group: choice,
             id: choice.id || null
           });
         } else {
           /**
            * If there is a selected choice already or the choice is not the first in
            * the array, add each choice normally.
            *
            * Otherwise we pre-select the first enabled choice in the array ("select-one" only)
            */
           var shouldPreselect = _this22._isSelectOneElement && !hasSelectedChoice && index === firstEnabledChoiceIndex;
           var isSelected = shouldPreselect ? true : choice.selected;
           var isDisabled = choice.disabled;

           _this22._addChoice({
             value: value,
             label: label,
             isSelected: isSelected,
             isDisabled: isDisabled,
             customProperties: customProperties,
             placeholder: placeholder
           });
         }
       } else {
         _this22._addChoice({
           value: value,
           label: label,
           isSelected: choice.selected,
           isDisabled: choice.disabled,
           customProperties: customProperties,
           placeholder: placeholder
         });
       }
     });
   }
   /**
    * @param {Item[]} items
    */
   ;

   _proto._addPredefinedItems = function _addPredefinedItems(items) {
     var _this23 = this;

     items.forEach(function (item) {
       if (typeof item === 'object' && item.value) {
         _this23._addItem({
           value: item.value,
           label: item.label,
           choiceId: item.id,
           customProperties: item.customProperties,
           placeholder: item.placeholder
         });
       }

       if (typeof item === 'string') {
         _this23._addItem({
           value: item
         });
       }
     });
   };

   _proto._setChoiceOrItem = function _setChoiceOrItem(item) {
     var _this24 = this;

     var itemType = getType(item).toLowerCase();
     var handleType = {
       object: function object() {
         if (!item.value) {
           return;
         } // If we are dealing with a select input, we need to create an option first
         // that is then selected. For text inputs we can just add items normally.


         if (!_this24._isTextElement) {
           _this24._addChoice({
             value: item.value,
             label: item.label,
             isSelected: true,
             isDisabled: false,
             customProperties: item.customProperties,
             placeholder: item.placeholder
           });
         } else {
           _this24._addItem({
             value: item.value,
             label: item.label,
             choiceId: item.id,
             customProperties: item.customProperties,
             placeholder: item.placeholder
           });
         }
       },
       string: function string() {
         if (!_this24._isTextElement) {
           _this24._addChoice({
             value: item,
             label: item,
             isSelected: true,
             isDisabled: false
           });
         } else {
           _this24._addItem({
             value: item
           });
         }
       }
     };
     handleType[itemType]();
   };

   _proto._findAndSelectChoiceByValue = function _findAndSelectChoiceByValue(val) {
     var _this25 = this;

     var choices = this._store.choices; // Check 'value' property exists and the choice isn't already selected

     var foundChoice = choices.find(function (choice) {
       return _this25.config.valueComparer(choice.value, val);
     });

     if (foundChoice && !foundChoice.selected) {
       this._addItem({
         value: foundChoice.value,
         label: foundChoice.label,
         choiceId: foundChoice.id,
         groupId: foundChoice.groupId,
         customProperties: foundChoice.customProperties,
         placeholder: foundChoice.placeholder,
         keyCode: foundChoice.keyCode
       });
     }
   };

   _proto._generatePlaceholderValue = function _generatePlaceholderValue() {
     if (this._isSelectElement) {
       var placeholderOption = this.passedElement.placeholderOption;
       return placeholderOption ? placeholderOption.text : false;
     }

     var _this$config4 = this.config,
         placeholder = _this$config4.placeholder,
         placeholderValue = _this$config4.placeholderValue;
     var dataset = this.passedElement.element.dataset;

     if (placeholder) {
       if (placeholderValue) {
         return placeholderValue;
       }

       if (dataset.placeholder) {
         return dataset.placeholder;
       }
     }

     return false;
   };

   return Choices;
 }();

 /* harmony default export */ var scripts_choices = __webpack_exports__["default"] = (choices_Choices);

 /***/ })
 /******/ ])["default"];
 });

 /***/ }),
 /* 233 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";
 __webpack_require__.r(__webpack_exports__);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.find.js
 var es_array_find = __webpack_require__(39);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
 var es_object_to_string = __webpack_require__(3);

 // EXTERNAL MODULE: ./node_modules/@shopify/theme-sections/theme-sections.js + 1 modules
 var theme_sections = __webpack_require__(1);

 // EXTERNAL MODULE: ./src/scripts/components/slider.js
 var slider = __webpack_require__(7);

 // EXTERNAL MODULE: ./node_modules/regenerator-runtime/runtime.js
 var runtime = __webpack_require__(16);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
 var es_array_concat = __webpack_require__(50);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.promise.js
 var es_promise = __webpack_require__(14);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.exec.js
 var es_regexp_exec = __webpack_require__(21);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.replace.js
 var es_string_replace = __webpack_require__(54);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.string.replace-all.js
 var esnext_string_replace_all = __webpack_require__(177);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
 var es_symbol = __webpack_require__(29);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.description.js
 var es_symbol_description = __webpack_require__(104);

 // CONCATENATED MODULE: ./src/scripts/components/articles-fetcher.js











 function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

 function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

 function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

 function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

 function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

 var ArticlesFetcher = /*#__PURE__*/function () {
   function ArticlesFetcher() {
     _classCallCheck(this, ArticlesFetcher);
   }

   _createClass(ArticlesFetcher, [{
     key: "fetchByTag",
     value: function () {
       var _fetchByTag = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
         var tag,
             limit,
             graphQLQuery,
             response,
             _args = arguments;
         return regeneratorRuntime.wrap(function _callee$(_context) {
           while (1) {
             switch (_context.prev = _context.next) {
               case 0:
                 tag = _args.length > 0 && _args[0] !== undefined ? _args[0] : "*";
                 limit = _args.length > 1 && _args[1] !== undefined ? _args[1] : 10;

                 if (tag) {
                   _context.next = 4;
                   break;
                 }

                 return _context.abrupt("return", []);

               case 4:
                 graphQLQuery = "\n      {\n        articles(first:".concat(limit, ", query:\"tag:").concat(tag, "\") {\n          edges {\n            node {\n              id\n              handle\n              title\n              authorV2 {\n                name\n              }\n              onlineStoreUrl\n              excerpt\n              image {\n                url\n                altText\n              }\n              author: metafield(namespace:\"info\" ,key:\"author\") {\n                value\n              }\n              description: metafield(namespace:\"info\" ,key:\"subtitle\") {\n                value\n              }\n              readtime: metafield(namespace:\"info\" ,key:\"readtime\") {\n                value\n              }\n            }\n          }\n        }\n      }");
                 _context.next = 7;
                 return fetch('https://patagonia-au.myshopify.com/api/2022-01/graphql.json', {
                   method: 'POST',
                   headers: {
                     'Content-Type': 'application/graphql',
                     'X-Shopify-Storefront-Access-Token': '2eef2f61d732ef62fbeb5759d56cfb38'
                   },
                   body: graphQLQuery
                 });

               case 7:
                 response = _context.sent;
                 return _context.abrupt("return", response.json());

               case 9:
               case "end":
                 return _context.stop();
             }
           }
         }, _callee);
       }));

       function fetchByTag() {
         return _fetchByTag.apply(this, arguments);
       }

       return fetchByTag;
     }()
   }, {
     key: "populateCarousel",
     value: function populateCarousel(container, articles) {
       var length = articles.length;

       for (var i = 0; i < length; i++) {
         var article = articles[i].node;
         var $template = $('#card-template');
         var clone = $template.clone(true);
         var node = clone.prop('content');
         var $content = $(node).find('.slide');
         var html = $content.html();
         var newHtml = html;

         if (article.title) {
           newHtml = newHtml.replaceAll("[[article_title]]", article.title);
           newHtml = newHtml.replaceAll("api_title--hide", "");
         }

         if (article.author && article.author.value) {
           newHtml = newHtml.replaceAll("[[article_author]]", article.author.value);
           newHtml = newHtml.replaceAll("api_author--hide", "");
         }

         if (article.description && article.description.value) {
           newHtml = newHtml.replaceAll("[[article_description]]", article.description.value);
           newHtml = newHtml.replaceAll("api_description--hide", "");
         }

         if (article.readtime && article.readtime.value) {
           newHtml = newHtml.replaceAll("[[article_readtime]]", article.readtime.value);
         } else {
           newHtml = newHtml.replaceAll("[[article_readtime]]", "10 min Read");
         }

         if (article.excerp) {
           newHtml = newHtml.replaceAll("[[article_excerpt]]", article.excerp);
           newHtml = newHtml.replaceAll("api_excerpt--hide", "");
         }

         if (article.image && article.image.url) {
           var _article$image$altTex;

           var altText = (_article$image$altTex = article.image.altText) !== null && _article$image$altTex !== void 0 ? _article$image$altTex : article.title;
           newHtml = newHtml.replaceAll("[[image_src]]", article.image.url);
           newHtml = newHtml.replaceAll("[[image_alt]]", altText);
           newHtml = newHtml.replaceAll("api_image--hide", "");
         }

         if (article.onlineStoreUrl) {
           newHtml = newHtml.replaceAll("[[article_url]]", article.onlineStoreUrl);
         }

         $content.html(newHtml);
         container.append($content);
       }
     }
   }]);

   return ArticlesFetcher;
 }();

 ;
 /* harmony default export */ var articles_fetcher = (ArticlesFetcher);
 // CONCATENATED MODULE: ./src/scripts/sections/blog-article-carousel-api.js





 var selectors = {
   slider: "[data-slider-container-api]",
   arrowNext: "[data-slider-arrow-next]",
   arrowPrev: "[data-slider-arrow-prev]",
   pagination: "[data-slider-pagination]"
 };
 Object(theme_sections["b" /* register */])("articles-slider-api", {
   slider: null,
   sliderContainer: null,
   options: {
     direction: "horizontal",
     loop: false,
     navigation: {
       nextEl: selectors.arrowNext,
       prevEl: selectors.arrowPrev
     },
     speed: 750
   },
   onLoad: function onLoad() {
     var _this = this;

     console.log("enter airwaus");
     var $sliderContainer = $(this.container).find("[data-cards-wrapper-api]");
     var filterTag = $(this.container).data("articles-tag");
     var limit = $(this.container).data("articles-limit");
     var articleFetcher = new articles_fetcher();
     articleFetcher.fetchByTag(filterTag, limit).then(function (response) {
       var articles = response.data.articles.edges;
       console.log(articles);
       articleFetcher.populateCarousel($sliderContainer, articles);
       _this.sliderContainer = _this.container.querySelector(selectors.slider);

       if (!_this.sliderContainer) {
         return null;
       }

       _this.slider = new slider["default"](_this.sliderContainer, _this.options);
     });
   },
   onUnload: function onUnload() {
     if (!this.slider) {
       return null;
     }

     this.slider.destroy();
   }
 });

 /***/ }),
 /* 234 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";
 __webpack_require__.r(__webpack_exports__);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
 var es_object_to_string = __webpack_require__(3);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.promise.js
 var es_promise = __webpack_require__(14);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.for-each.js
 var web_dom_collections_for_each = __webpack_require__(8);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.exec.js
 var es_regexp_exec = __webpack_require__(21);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.replace.js
 var es_string_replace = __webpack_require__(54);

 // EXTERNAL MODULE: ./node_modules/regenerator-runtime/runtime.js
 var runtime = __webpack_require__(16);

 // EXTERNAL MODULE: ./node_modules/@shopify/theme-sections/theme-sections.js + 1 modules
 var theme_sections = __webpack_require__(1);

 // EXTERNAL MODULE: ./src/scripts/components/slider.js
 var slider = __webpack_require__(7);

 // EXTERNAL MODULE: ./node_modules/@shopify/theme-currency/currency.js
 var currency = __webpack_require__(71);

 // CONCATENATED MODULE: ./node_modules/@shopify/theme-product-form/listeners.js
 function Listeners() {
   this.entries = [];
 }

 Listeners.prototype.add = function(element, event, fn) {
   this.entries.push({ element: element, event: event, fn: fn });
   element.addEventListener(event, fn);
 };

 Listeners.prototype.removeAll = function() {
   this.entries = this.entries.filter(function(listener) {
     listener.element.removeEventListener(listener.event, listener.fn);
     return false;
   });
 };

 // CONCATENATED MODULE: ./node_modules/@shopify/theme-product/theme-product.js
 /**
  * Returns a product JSON object when passed a product URL
  * @param {*} url
  */
 function theme_product_getProductJson(handle) {
   return fetch('/products/' + handle + '.js').then(function(response) {
     return response.json();
   });
 }

 /**
  * Find a match in the project JSON (using a ID number) and return the variant (as an Object)
  * @param {Object} product Product JSON object
  * @param {Number} value Accepts Number (e.g. 6908023078973)
  * @returns {Object} The variant object once a match has been successful. Otherwise null will be return
  */
 function getVariantFromId(product, value) {
   _validateProductStructure(product);

   if (typeof value !== 'number') {
     throw new TypeError(value + ' is not a Number.');
   }

   var result = product.variants.filter(function(variant) {
     return variant.id === value;
   });

   return result[0] || null;
 }

 /**
  * Convert the Object (with 'name' and 'value' keys) into an Array of values, then find a match & return the variant (as an Object)
  * @param {Object} product Product JSON object
  * @param {Object} collection Object with 'name' and 'value' keys (e.g. [{ name: "Size", value: "36" }, { name: "Color", value: "Black" }])
  * @returns {Object || null} The variant object once a match has been successful. Otherwise null will be returned
  */
 function getVariantFromSerializedArray(product, collection) {
   _validateProductStructure(product);

   // If value is an array of options
   var optionArray = _createOptionArrayFromOptionCollection(product, collection);
   return getVariantFromOptionArray(product, optionArray);
 }

 /**
  * Find a match in the project JSON (using Array with option values) and return the variant (as an Object)
  * @param {Object} product Product JSON object
  * @param {Array} options List of submitted values (e.g. ['36', 'Black'])
  * @returns {Object || null} The variant object once a match has been successful. Otherwise null will be returned
  */
 function getVariantFromOptionArray(product, options) {
   _validateProductStructure(product);
   _validateOptionsArray(options);

   var result = product.variants.filter(function(variant) {
     return options.every(function(option, index) {
       return variant.options[index] === option;
     });
   });

   return result[0] || null;
 }

 /**
  * Creates an array of selected options from the object
  * Loops through the project.options and check if the "option name" exist (product.options.name) and matches the target
  * @param {Object} product Product JSON object
  * @param {Array} collection Array of object (e.g. [{ name: "Size", value: "36" }, { name: "Color", value: "Black" }])
  * @returns {Array} The result of the matched values. (e.g. ['36', 'Black'])
  */
 function _createOptionArrayFromOptionCollection(product, collection) {
   _validateProductStructure(product);
   _validateSerializedArray(collection);

   var optionArray = [];

   collection.forEach(function(option) {
     for (var i = 0; i < product.options.length; i++) {
       if (product.options[i].name.toLowerCase() === option.name.toLowerCase()) {
         optionArray[i] = option.value;
         break;
       }
     }
   });

   return optionArray;
 }

 /**
  * Check if the product data is a valid JS object
  * Error will be thrown if type is invalid
  * @param {object} product Product JSON object
  */
 function _validateProductStructure(product) {
   if (typeof product !== 'object') {
     throw new TypeError(product + ' is not an object.');
   }

   if (Object.keys(product).length === 0 && product.constructor === Object) {
     throw new Error(product + ' is empty.');
   }
 }

 /**
  * Validate the structure of the array
  * It must be formatted like jQuery's serializeArray()
  * @param {Array} collection Array of object [{ name: "Size", value: "36" }, { name: "Color", value: "Black" }]
  */
 function _validateSerializedArray(collection) {
   if (!Array.isArray(collection)) {
     throw new TypeError(collection + ' is not an array.');
   }

   if (collection.length === 0) {
     return [];
   }

   if (collection[0].hasOwnProperty('name')) {
     if (typeof collection[0].name !== 'string') {
       throw new TypeError(
         'Invalid value type passed for name of option ' +
           collection[0].name +
           '. Value should be string.'
       );
     }
   } else {
     throw new Error(collection[0] + 'does not contain name key.');
   }
 }

 /**
  * Validate the structure of the array
  * It must be formatted as list of values
  * @param {Array} collection Array of object (e.g. ['36', 'Black'])
  */
 function _validateOptionsArray(options) {
   if (Array.isArray(options) && typeof options[0] === 'object') {
     throw new Error(options + 'is not a valid array of options.');
   }
 }

 // CONCATENATED MODULE: ./node_modules/@shopify/theme-product-form/theme-product-form.js



 var selectors = {
   idInput: '[name="id"]',
   optionInput: '[name^="options"]',
   quantityInput: '[name="quantity"]',
   propertyInput: '[name^="properties"]'
 };

 // Public Methods
 // -----------------------------------------------------------------------------

 /**
  * Returns a URL with a variant ID query parameter. Useful for updating window.history
  * with a new URL based on the currently select product variant.
  * @param {string} url - The URL you wish to append the variant ID to
  * @param {number} id  - The variant ID you wish to append to the URL
  * @returns {string} - The new url which includes the variant ID query parameter
  */

 function getUrlWithVariant(url, id) {
   if (/variant=/.test(url)) {
     return url.replace(/(variant=)[^&]+/, '$1' + id);
   } else if (/\?/.test(url)) {
     return url.concat('&variant=').concat(id);
   }

   return url.concat('?variant=').concat(id);
 }

 /**
  * Constructor class that creates a new instance of a product form controller.
  *
  * @param {Element} element - DOM element which is equal to the <form> node wrapping product form inputs
  * @param {Object} product - A product object
  * @param {Object} options - Optional options object
  * @param {Function} options.onOptionChange - Callback for whenever an option input changes
  * @param {Function} options.onQuantityChange - Callback for whenever an quantity input changes
  * @param {Function} options.onPropertyChange - Callback for whenever a property input changes
  * @param {Function} options.onFormSubmit - Callback for whenever the product form is submitted
  */
 function ProductForm(element, product, options) {
   this.element = element;
   this.product = _validateProductObject(product);

   options = options || {};

   this._listeners = new Listeners();
   this._listeners.add(
     this.element,
     'submit',
     this._onSubmit.bind(this, options)
   );

   this.optionInputs = this._initInputs(
     selectors.optionInput,
     options.onOptionChange
   );

   this.quantityInputs = this._initInputs(
     selectors.quantityInput,
     options.onQuantityChange
   );

   this.propertyInputs = this._initInputs(
     selectors.propertyInput,
     options.onPropertyChange
   );
 }

 /**
  * Cleans up all event handlers that were assigned when the Product Form was constructed.
  * Useful for use when a section needs to be reloaded in the theme editor.
  */
 ProductForm.prototype.destroy = function() {
   this._listeners.removeAll();
 };

 /**
  * Getter method which returns the array of currently selected option values
  *
  * @returns {Array} An array of option values
  */
 ProductForm.prototype.options = function() {
   return _serializeOptionValues(this.optionInputs, function(item) {
     var regex = /(?:^(options\[))(.*?)(?:\])/;
     item.name = regex.exec(item.name)[2]; // Use just the value between 'options[' and ']'
     return item;
   });
 };

 /**
  * Getter method which returns the currently selected variant, or `null` if variant
  * doesn't exist.
  *
  * @returns {Object|null} Variant object
  */
 ProductForm.prototype.variant = function() {
   return getVariantFromSerializedArray(this.product, this.options());
 };

 /**
  * Getter method which returns a collection of objects containing name and values
  * of property inputs
  *
  * @returns {Array} Collection of objects with name and value keys
  */
 ProductForm.prototype.properties = function() {
   var properties = _serializePropertyValues(this.propertyInputs, function(
     propertyName
   ) {
     var regex = /(?:^(properties\[))(.*?)(?:\])/;
     var name = regex.exec(propertyName)[2]; // Use just the value between 'properties[' and ']'
     return name;
   });

   return Object.entries(properties).length === 0 ? null : properties;
 };

 /**
  * Getter method which returns the current quantity or 1 if no quantity input is
  * included in the form
  *
  * @returns {Array} Collection of objects with name and value keys
  */
 ProductForm.prototype.quantity = function() {
   return this.quantityInputs[0]
     ? Number.parseInt(this.quantityInputs[0].value, 10)
     : 1;
 };

 // Private Methods
 // -----------------------------------------------------------------------------
 ProductForm.prototype._setIdInputValue = function(value) {
   var idInputElement = this.element.querySelector(selectors.idInput);

   if (!idInputElement) {
     idInputElement = document.createElement('input');
     idInputElement.type = 'hidden';
     idInputElement.name = 'id';
     this.element.appendChild(idInputElement);
   }

   idInputElement.value = value.toString();
 };

 ProductForm.prototype._onSubmit = function(options, event) {
   event.dataset = this._getProductFormEventData();

   if (event.dataset.variant) {
     this._setIdInputValue(event.dataset.variant.id);
   }

   if (options.onFormSubmit) {
     options.onFormSubmit(event);
   }
 };

 ProductForm.prototype._onFormEvent = function(cb) {
   if (typeof cb === 'undefined') {
     return Function.prototype;
   }

   return function(event) {
     event.dataset = this._getProductFormEventData();
     cb(event);
   }.bind(this);
 };

 ProductForm.prototype._initInputs = function(selector, cb) {
   var elements = Array.prototype.slice.call(
     this.element.querySelectorAll(selector)
   );

   return elements.map(
     function(element) {
       this._listeners.add(element, 'change', this._onFormEvent(cb));
       return element;
     }.bind(this)
   );
 };

 ProductForm.prototype._getProductFormEventData = function() {
   return {
     options: this.options(),
     variant: this.variant(),
     properties: this.properties(),
     quantity: this.quantity()
   };
 };

 function _serializeOptionValues(inputs, transform) {
   return inputs.reduce(function(options, input) {
     if (
       input.checked || // If input is a checked (means type radio or checkbox)
       (input.type !== 'radio' && input.type !== 'checkbox') // Or if its any other type of input
     ) {
       options.push(transform({ name: input.name, value: input.value }));
     }

     return options;
   }, []);
 }

 function _serializePropertyValues(inputs, transform) {
   return inputs.reduce(function(properties, input) {
     if (
       input.checked || // If input is a checked (means type radio or checkbox)
       (input.type !== 'radio' && input.type !== 'checkbox') // Or if its any other type of input
     ) {
       properties[transform(input.name)] = input.value;
     }

     return properties;
   }, {});
 }

 function _validateProductObject(product) {
   if (typeof product !== 'object') {
     throw new TypeError(product + ' is not an object.');
   }

   if (typeof product.variants[0].options === 'undefined') {
     throw new TypeError(
       'Product object is invalid. Make sure you use the product object that is output from {{ product | json }} or from the http://[your-product-url].js route'
     );
   }

   return product;
 }

 // EXTERNAL MODULE: ./node_modules/form-serialize/index.js
 var form_serialize = __webpack_require__(219);
 var form_serialize_default = /*#__PURE__*/__webpack_require__.n(form_serialize);

 // CONCATENATED MODULE: ./src/scripts/core/helpers/addToCartSubmit.js

 function addToCartSubmit(event) {
   var successCallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
   event.preventDefault();
   var form = event.target;
   var formData = form_serialize_default()(form, {
     hash: true,
     disabled: true,
     empty: false
   });

   if (Array.isArray(formData.event_id)) {
     formData.event_id = formData.event_id.shift();
   }

   form.classList.add("adding");
   document.dispatchEvent(new CustomEvent("product:add", {
     detail: {
       items: [formData],
       callback: function callback() {
         setTimeout(function () {
           form.classList.remove("adding");
         }, 500);
         successCallback();
       },
       errorCallback: function errorCallback() {
         form.classList.remove("adding");
       }
     }
   }));
 }
 // EXTERNAL MODULE: ./node_modules/@savchukoleksii/shopify-theme-translations-tool/src/index.js + 1 modules
 var src = __webpack_require__(70);

 // EXTERNAL MODULE: ./node_modules/axios/index.js
 var axios = __webpack_require__(24);
 var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

 // CONCATENATED MODULE: ./src/scripts/sections/product.js







 function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

 function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

 /**
  * Product Template Script
  * ------------------------------------------------------------------------------
  * A file that contains scripts highly couple code to the Product template.
  *
  * @namespace product
  */







 window.addToCartSubmit = addToCartSubmit;
 var product_selectors = {
   addToCartButton: "[data-add-to-cart]",
   addToCartButtonText: "[data-add-to-cart-text]",
   productPriceContainer: "[data-product-price-container]",
   productPrice: "[data-product-price]",
   comparePrice: "[data-compare-price]",
   productForm: "[data-product-form]",
   productSlider: "[data-product-slider]",
   thumbnailsSlider: "[data-product-thumbnails]",
   productSku: "[data-product-sku]",
   productSkuValue: "[data-product-sku-value]",
   inventoriesJson: "[data-inventories-json]",
   slider: "[data-slider-container]",
   arrowNext: "[data-slider-arrow-next]",
   arrowPrev: "[data-slider-arrow-prev]",
   pagination: "[data-slider-pagination]",
   clickCollectTooltip: "[data-click-collect-tooltip]",
   sizeOptionInput: '[data-option-name="options[Size]"]'
 };
 var classes = {
   hidden: "hidden",
   notInitialized: "not-initialized"
 };
 Object(theme_sections["b" /* register */])("product", {
   product: {},
   inventories: {},
   slider: null,
   sliderContainer: null,
   productForm: null,
   enableHistoryState: false,
   options: {
     direction: "horizontal",
     loop: false,
     enabled: false,
     slidesPerView: 1,
     centeredSlides: true,
     navigation: {
       nextEl: product_selectors.arrowNext,
       prevEl: product_selectors.arrowPrev
     },
     speed: 750,
     breakpoints: {
       575: {
         slidesPerView: 2
       },
       768: {
         slidesPerView: 2
       }
     }
   },
   onLoad: function () {
     var _onLoad = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
       var productHandle;
       return regeneratorRuntime.wrap(function _callee$(_context) {
         while (1) {
           switch (_context.prev = _context.next) {
             case 0:
               productHandle = this.container.dataset.productHandle;
               this.initElements();

               if (this.sliderContainer) {
                 _context.next = 4;
                 break;
               }

               return _context.abrupt("return", null);

             case 4:
               this.slider = new slider["default"](this.sliderContainer, this.options);

               if (productHandle) {
                 _context.next = 7;
                 break;
               }

               return _context.abrupt("return");

             case 7:
               _context.next = 9;
               return this.getProductJson(productHandle);

             case 9:
               this.product = _context.sent;

               try {
                 this.inventories = JSON.parse(this.inventoriesJson.innerHTML);
               } catch (e) {}

               this.productForm = new ProductForm(this.form, this.product, {
                 onOptionChange: this.onOptionChange.bind(this),
                 onFormSubmit: function onFormSubmit(event) {
                   addToCartSubmit(event);
                 },
                 onQuantityChange: function onQuantityChange() {},
                 onPropertyChange: function onPropertyChange() {}
               });
               this.enableHistoryState = this.container.dataset.enableHistoryState || false;
               this.saveReferrer(); // this.updatePicUpTooltip();

             case 14:
             case "end":
               return _context.stop();
           }
         }
       }, _callee, this);
     }));

     function onLoad() {
       return _onLoad.apply(this, arguments);
     }

     return onLoad;
   }(),
   initElements: function initElements() {
     this.sliderContainer = this.container.querySelector(product_selectors.slider);
     this.sku = this.container.querySelector(product_selectors.productSku);
     this.skuValue = this.container.querySelector(product_selectors.productSkuValue);
     this.inventoriesJson = this.container.querySelector(product_selectors.inventoriesJson);
     this.form = this.container.querySelector(product_selectors.productForm);
     this.price = this.container.querySelector(product_selectors.productPrice);
     this.priceContainer = this.container.querySelector(product_selectors.productPriceContainer);
     this.comparePrice = this.container.querySelector(product_selectors.comparePrice);
     this.sizeOptionInput = this.container.querySelectorAll(product_selectors.sizeOptionInput);
   },
   onUnload: function onUnload() {
     var _this = this;

     var destroyProductForm = function destroyProductForm() {
       if (!_this.productForm) {
         return null;
       }

       _this.productForm.destroy();
     };

     if (!this.slider) {
       return null;
     }

     destroyProductForm();
     this.slider.destroy();
   },
   getProductJson: function () {
     var _getProductJson = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(handle) {
       var url, response, html;
       return regeneratorRuntime.wrap(function _callee2$(_context2) {
         while (1) {
           switch (_context2.prev = _context2.next) {
             case 0:
               url = "/products/".concat(handle, "?view=object-json");
               _context2.next = 3;
               return axios_default.a.get(url);

             case 3:
               response = _context2.sent.data;
               html = document.createElement("div");
               html.innerHTML = response;
               return _context2.abrupt("return", JSON.parse(html.querySelector("[data-json-response]").innerHTML));

             case 7:
             case "end":
               return _context2.stop();
           }
         }
       }, _callee2);
     }));

     function getProductJson(_x) {
       return _getProductJson.apply(this, arguments);
     }

     return getProductJson;
   }(),
   onOptionChange: function onOptionChange(event) {
     var variant = event.dataset.variant;
     this.updatePrice(variant);
     this.updateAddToCartState(variant);
     this.updateHistoryState(variant);
     this.updateSku(variant); // this.updatePicUpTooltip();

     this.fetchAvailability(variant);
   },
   fetchAvailability: function fetchAvailability(variant) {
     var pickupAvailability = this.container.querySelector("pickup-availability");

     if (!variant) {
       pickupAvailability.innerHTML = "";
       pickupAvailability.removeAttribute("available");
     } else {
       var variantSectionUrl = "/variants/".concat(variant.id, "/?section_id=pickup-availability");

       var _pickupAvailability = this.container.querySelector("pickup-availability");

       fetch(variantSectionUrl).then(function (response) {
         return response.text();
       }).then(function (text) {
         var sectionInnerHTML = new DOMParser().parseFromString(text, "text/html").querySelector(".shopify-section");

         _pickupAvailability.renderPreview(sectionInnerHTML);
       });
     }
   },
   updatePicUpTooltip: function updatePicUpTooltip() {
     var clickCollectTooltip = this.container.querySelector(product_selectors.clickCollectTooltip);
     this.sizeOptionInput.forEach(function (elem) {
       if (elem.checked) {
         clickCollectTooltip.classList.remove("disabled");
         clickCollectTooltip.classList.add(classes.hidden);
       }
     });
   },
   updatePrice: function updatePrice(variant) {
     if (!variant) {
       return null;
     }

     this.price.innerHTML = Object(currency["a" /* formatMoney */])(variant.price, null).replace(".00", "");
     /* hide price if variant is unavailable */
     // const available = variant.available;
     //
     // if (available) {
     // 	this.priceContainer.classList.remove(classes.hidden);
     // } else {
     // 	this.priceContainer.classList.add(classes.hidden);
     // }

     if (!this.comparePrice) {
       return null;
     }

     if (variant.compare_at_price > variant.price) {
       this.comparePrice.innerText = Object(currency["a" /* formatMoney */])(variant.compare_at_price, null).replace(".00", "");
       this.comparePrice.classList.remove(classes.hidden);
     } else {
       this.comparePrice.innerText = "";
       this.comparePrice.classList.add(classes.hidden);
     }
   },
   updateAddToCartState: function updateAddToCartState(variant) {
     var button = this.container.querySelector(product_selectors.addToCartButton);
     var buttonText = this.container.querySelector(product_selectors.addToCartButtonText);

     if (!button || !buttonText) {
       return null;
     }

     if (!variant) {
       button.disabled = true;
       buttonText.innerText = src["a" /* default */].get("products.product.sold_out");
       return false;
     }

     var available = variant.available;

     if (available) {
       button.disabled = false;
       if (variant.inventory_quantity > 5) buttonText.innerText = src["a" /* default */].get("products.product.add_to_cart");else buttonText.innerText = src["a" /* default */].get("products.product.add_to_cart_and_left_html", {
         count: variant.inventory_quantity
       });
     } else {
       button.disabled = true;
       buttonText.innerText = src["a" /* default */].get("products.product.sold_out");
     }
   },
   updateSku: function updateSku(variant) {
     if (!variant) {
       return null;
     }

     if (!this.sku || !this.skuValue) {
       return null;
     }

     if (variant.sku) {
       this.skuValue.innerHTML = variant.sku;
       this.sku.classList.remove(classes.hidden);
     } else {
       this.skuValue.innerHTML = "";
       this.sku.classList.add(classes.hidden);
     }
   },
   updateHistoryState: function updateHistoryState(variant) {
     if (!variant || !this.enableHistoryState) {
       return null;
     }

     var url = getUrlWithVariant(window.location.href, variant.id);
     window.history.replaceState({
       path: url
     }, "", url);
   },
   saveReferrer: function saveReferrer() {
     localStorage.removeItem("collection&product");
     if (!document.referrer.length) return null;
     localStorage.setItem("collection&product", JSON.stringify({
       collection: document.referrer,
       product: this.product.id
     }));
   }
 });
 var sizeInput = document.querySelectorAll(".product-option__select input[type=radio]");
 var productButton = document.querySelector(".js-product-form-button");
 var productButtonHide = document.querySelector(".js-product-form-button-hide");

 if (sizeInput && productButton) {
   sizeInput.forEach(function (element) {
     return element.addEventListener("change", function () {
       if (element.checked && productButtonHide) {
         productButton.classList.add("product-form__button--active");
         productButtonHide.classList.add("product-form__button--remove");
       }
     });
   });
 }

 /***/ }),
 /* 235 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";
 __webpack_require__.r(__webpack_exports__);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
 var es_object_to_string = __webpack_require__(3);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.promise.js
 var es_promise = __webpack_require__(14);

 // EXTERNAL MODULE: ./node_modules/regenerator-runtime/runtime.js
 var runtime = __webpack_require__(16);

 // EXTERNAL MODULE: ./node_modules/@shopify/theme-sections/theme-sections.js + 1 modules
 var theme_sections = __webpack_require__(1);

 // EXTERNAL MODULE: ./node_modules/vue/dist/vue.runtime.esm.js
 var vue_runtime_esm = __webpack_require__(36);

 // EXTERNAL MODULE: ./src/scripts/vue/filters/index.js
 var filters = __webpack_require__(124);

 // EXTERNAL MODULE: ./src/scripts/vue/store/index.js
 var store = __webpack_require__(20);

 // CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/scripts/vue/Wishlist.vue?vue&type=template&id=9f0b8a64&
 var Wishlistvue_type_template_id_9f0b8a64_render = function () {
   var _vm = this
   var _h = _vm.$createElement
   var _c = _vm._self._c || _h
   return _c("div", { staticClass: "wishlist", attrs: { id: "wishlist" } }, [
     _vm._v("\n\tWishlist\n"),
   ])
 }
 var staticRenderFns = []
 Wishlistvue_type_template_id_9f0b8a64_render._withStripped = true


 // CONCATENATED MODULE: ./src/scripts/vue/Wishlist.vue?vue&type=template&id=9f0b8a64&

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
 var es_object_keys = __webpack_require__(40);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
 var es_symbol = __webpack_require__(29);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.filter.js
 var es_array_filter = __webpack_require__(25);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptor.js
 var es_object_get_own_property_descriptor = __webpack_require__(44);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.for-each.js
 var web_dom_collections_for_each = __webpack_require__(8);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptors.js
 var es_object_get_own_property_descriptors = __webpack_require__(43);

 // EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
 var vuex_esm = __webpack_require__(79);

 // CONCATENATED MODULE: ./node_modules/babel-loader/lib??ref--0!./node_modules/vue-loader/lib??vue-loader-options!./src/scripts/vue/Wishlist.vue?vue&type=script&lang=js&








 function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

 function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

 function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

 //
 //
 //
 //
 //
 //


 var _createNamespacedHelp = Object(vuex_esm["a" /* createNamespacedHelpers */])("wishlist"),
     mapState = _createNamespacedHelp.mapState,
     mapActions = _createNamespacedHelp.mapActions,
     mapGetters = _createNamespacedHelp.mapGetters;

 var resizeChange = null;
 /* harmony default export */ var Wishlistvue_type_script_lang_js_ = ({
   name: 'Wishlist',
   data: function data() {
     return {};
   },
   mounted: function mounted() {},
   computed: _objectSpread({}, mapGetters([])),
   methods: _objectSpread({}, mapActions([])),
   components: {}
 });
 // CONCATENATED MODULE: ./src/scripts/vue/Wishlist.vue?vue&type=script&lang=js&
  /* harmony default export */ var vue_Wishlistvue_type_script_lang_js_ = (Wishlistvue_type_script_lang_js_);
 // EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
 var componentNormalizer = __webpack_require__(34);

 // CONCATENATED MODULE: ./src/scripts/vue/Wishlist.vue





 /* normalize component */

 var component = Object(componentNormalizer["a" /* default */])(
   vue_Wishlistvue_type_script_lang_js_,
   Wishlistvue_type_template_id_9f0b8a64_render,
   staticRenderFns,
   false,
   null,
   null,
   null

 )

 component.options.__file = "src/scripts/vue/Wishlist.vue"
 /* harmony default export */ var Wishlist = (component.exports);
 // EXTERNAL MODULE: ./src/scripts/vue/store/wishlist/wishlist.js + 1 modules
 var wishlist = __webpack_require__(77);

 // CONCATENATED MODULE: ./src/scripts/sections/wishlist.js




 function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

 function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }







 Object(theme_sections["b" /* register */])("wishlist", {
   onLoad: function onLoad() {
     this.init();
     this.initEvents();
   },
   init: function () {
     var _init = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
       return regeneratorRuntime.wrap(function _callee$(_context) {
         while (1) {
           switch (_context.prev = _context.next) {
             case 0:
               _context.next = 2;
               return store["a" /* store */].dispatch("wishlist/".concat(wishlist["b" /* ACTION_INIT_WISHLIST */]));

             case 2:
               new vue_runtime_esm["a" /* default */]({
                 store: store["a" /* store */],
                 render: function render(h) {
                   return h(Wishlist);
                 }
               }).$mount(this.container);

             case 3:
             case "end":
               return _context.stop();
           }
         }
       }, _callee, this);
     }));

     function init() {
       return _init.apply(this, arguments);
     }

     return init;
   }()
 });

 /***/ }),
 /* 236 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";
 __webpack_require__.r(__webpack_exports__);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
 var es_object_to_string = __webpack_require__(3);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.promise.js
 var es_promise = __webpack_require__(14);

 // EXTERNAL MODULE: ./node_modules/regenerator-runtime/runtime.js
 var runtime = __webpack_require__(16);

 // EXTERNAL MODULE: ./node_modules/@shopify/theme-sections/theme-sections.js + 1 modules
 var theme_sections = __webpack_require__(1);

 // EXTERNAL MODULE: ./node_modules/vue/dist/vue.runtime.esm.js
 var vue_runtime_esm = __webpack_require__(36);

 // EXTERNAL MODULE: ./src/scripts/vue/filters/index.js
 var filters = __webpack_require__(124);

 // EXTERNAL MODULE: ./src/scripts/vue/store/index.js
 var store = __webpack_require__(20);

 // EXTERNAL MODULE: ./src/scripts/vue/store/cart/cart.js + 1 modules
 var cart = __webpack_require__(15);

 // CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/scripts/vue/Cart.vue?vue&type=template&id=dc8a09ae&
 var Cartvue_type_template_id_dc8a09ae_render = function () {
   var _vm = this
   var _h = _vm.$createElement
   var _c = _vm._self._c || _h
   return _c("div", { staticClass: "cart", attrs: { id: "cart" } }, [
     _c("div", { staticClass: "cart__content" }, [
       !_vm.isEmptyCart
         ? _c("div", { staticClass: "cart__title" }, [
             _vm._v(
               "\n\t\t\t" +
                 _vm._s(_vm._f("t")("sections.cart.title")) +
                 " (" +
                 _vm._s(_vm.cart.item_count) +
                 ")\n\t\t"
             ),
           ])
         : _vm._e(),
       _vm._v(" "),
       _vm.isEmptyCart
         ? _c("div", { staticClass: "cart__warnings" }, [
             _c("h1", { staticClass: "cart__empty-text" }, [
               _vm._v(
                 "\n\t\t\t\t" +
                   _vm._s(_vm._f("t")("sections.cart.empty")) +
                   "\n\t\t\t"
               ),
             ]),
             _vm._v(" "),
             _c("div", { staticClass: "cart__login-title" }, [
               _vm._v(
                 "\n\t\t\t\t" +
                   _vm._s(_vm._f("t")("sections.cart.login.title")) +
                   "\n\t\t\t"
               ),
             ]),
             _vm._v(" "),
             _vm.customizer.login_link
               ? _c(
                   "a",
                   {
                     staticClass:
                       "button button--primary button--black cart__login-button",
                     attrs: { href: _vm.customizer.login_link },
                   },
                   [
                     _vm._v(
                       "\n\t\t\t\t" +
                         _vm._s(
                           _vm._f("t")("sections.cart.login.paragraph_html")
                         ) +
                         "\n\t\t\t"
                     ),
                   ]
                 )
               : _vm._e(),
             _vm._v(" "),
             _vm.customizer.shopping_link
               ? _c(
                   "a",
                   {
                     staticClass: "cart__continue-shopping",
                     attrs: { href: _vm.customizer.shopping_link },
                   },
                   [
                     _vm._v(
                       "\n\t\t\t\t" +
                         _vm._s(_vm._f("t")("general.continue_shopping")) +
                         "\n\t\t\t"
                     ),
                   ]
                 )
               : _vm._e(),
           ])
         : _c(
             "div",
             { staticClass: "cart__items" },
             _vm._l(_vm.cart.items, function (item) {
               return _c("div", { staticClass: "cart__item--wrapper" }, [
                 _c("div", { staticClass: "cart__item--mobile-header" }, [
                   _c(
                     "a",
                     {
                       staticClass: "cart__item-title cart__item--mobile",
                       attrs: { href: item.url },
                     },
                     [
                       _vm._v(
                         "\n\t\t\t\t\t\t" + _vm._s(item.title) + "\n\t\t\t\t\t"
                       ),
                     ]
                   ),
                   _vm._v(" "),
                   _c(
                     "span",
                     { staticClass: "cart__item-sku cart__item--mobile" },
                     [
                       _vm._v(
                         "\n\t\t\t\t\t\t" + _vm._s(item.sku) + "\n\t\t\t\t\t"
                       ),
                     ]
                   ),
                 ]),
                 _vm._v(" "),
                 _c("div", { staticClass: "cart__item" }, [
                   _c("div", { staticClass: "cart__item-image-wrapper" }, [
                     _c(
                       "a",
                       {
                         staticClass: "cart__item-image-content",
                         attrs: { href: item.url },
                       },
                       [
                         item.properties["_image"]
                           ? _c("img", {
                               staticClass: "cart__item-image",
                               attrs: {
                                 src: item.properties["_image"],
                                 alt: item.properties["_email"],
                               },
                             })
                           : item.image
                           ? _c("img", {
                               staticClass: "cart__item-image",
                               attrs: {
                                 src: _vm._f("img_url")(item.image.src, "171x"),
                                 alt: item.image.alt,
                               },
                             })
                           : _vm._e(),
                       ]
                     ),
                     _vm._v(" "),
                     item.variant.available
                       ? _c("span", { staticClass: "cart__item-status" }, [
                           _vm._v(
                             "\n\t\t\t\t\t\t\t" +
                               _vm._s(_vm._f("t")("sections.cart.in_stock")) +
                               "\n\t\t\t\t\t\t"
                           ),
                         ])
                       : _c("span", { staticClass: "cart__item-status" }, [
                           _vm._v(
                             "\n\t\t\t\t\t\t\t" +
                               _vm._s(_vm._f("t")("sections.cart.out_stock")) +
                               "\n\t\t\t\t\t\t"
                           ),
                         ]),
                   ]),
                   _vm._v(" "),
                   _c("div", { staticClass: "cart__item-wrapper" }, [
                     _c("div", { staticClass: "cart__item-content" }, [
                       _c("span", { staticClass: "cart__item-price" }, [
                         item.original_price < item.variant.compare_at_price
                           ? _c(
                               "div",
                               { staticClass: "cart__item-price-container" },
                               [
                                 _c(
                                   "span",
                                   { staticClass: "cart__item-original-price" },
                                   [
                                     _vm._v(
                                       "\n\t\t\t\t\t\t\t\t\t\t" +
                                         _vm._s(
                                           _vm._f("money")(item.original_price)
                                         ) +
                                         "\n\t\t\t\t\t\t\t\t\t"
                                     ),
                                   ]
                                 ),
                                 _vm._v(" "),
                                 _c(
                                   "span",
                                   {
                                     staticClass: "cart__item-compare-at-price",
                                   },
                                   [
                                     _vm._v(
                                       "\n\t\t\t\t\t\t\t\t\t\t" +
                                         _vm._s(
                                           _vm._f("money")(
                                             item.variant.compare_at_price
                                           )
                                         ) +
                                         "\n\t\t\t\t\t\t\t\t\t"
                                     ),
                                   ]
                                 ),
                               ]
                             )
                           : _c(
                               "span",
                               { staticClass: "cart__item-final-price" },
                               [
                                 _vm._v(
                                   _vm._s(_vm._f("money")(item.final_line_price))
                                 ),
                               ]
                             ),
                       ]),
                       _vm._v(" "),
                       _c(
                         "a",
                         {
                           staticClass: "cart__item-title cart__item--desktop",
                           attrs: { href: item.url },
                         },
                         [
                           _vm._v(
                             "\n\t\t\t\t\t\t\t\t" +
                               _vm._s(item.product.title) +
                               "\n\t\t\t\t\t\t\t"
                           ),
                         ]
                       ),
                       _vm._v(" "),
                       _c(
                         "span",
                         { staticClass: "cart__item-sku cart__item--desktop" },
                         [
                           _vm._v(
                             "\n\t\t\t\t\t\t\t\t" +
                               _vm._s(item.sku) +
                               "\n\t\t\t\t\t\t\t"
                           ),
                         ]
                       ),
                       _vm._v(" "),
                       item.options_with_values.length
                         ? _c(
                             "ul",
                             { staticClass: "cart__item-option-list" },
                             _vm._l(item.options_with_values, function (option) {
                               return _c(
                                 "li",
                                 { staticClass: "cart__item-option-item" },
                                 [
                                   _c(
                                     "span",
                                     {
                                       staticClass:
                                         "cart__item-option-item-name",
                                     },
                                     [_vm._v(_vm._s(option.name) + ":")]
                                   ),
                                   _vm._v(" "),
                                   _c(
                                     "span",
                                     {
                                       staticClass:
                                         "cart__item-option-item-value",
                                     },
                                     [_vm._v(_vm._s(option.value))]
                                   ),
                                 ]
                               )
                             }),
                             0
                           )
                         : _vm._e(),
                       _vm._v(" "),
                       _c("label", { staticClass: "cart__item-quantity" }, [
                         _c(
                           "span",
                           { staticClass: "cart__item-quantity-name" },
                           [
                             _vm._v(
                               _vm._s(_vm._f("t")("sections.cart.quantity")) +
                                 ": "
                             ),
                           ]
                         ),
                         _vm._v(" "),
                         _c(
                           "select",
                           {
                             staticClass: "cart__item-quantity-value",
                             on: {
                               change: function ($event) {
                                 return _vm.changeQuantityItem({
                                   key: item.key,
                                   quantity: $event.target.value,
                                 })
                               },
                             },
                           },
                           _vm._l(9, function (n) {
                             return n <= item.variant.inventory_quantity
                               ? _c(
                                   "option",
                                   {
                                     domProps: {
                                       value: n,
                                       selected:
                                         n === item.quantity ? "selected" : "",
                                     },
                                   },
                                   [_vm._v(_vm._s(n) + "\n\t\t\t\t\t\t\t\t\t")]
                                 )
                               : _vm._e()
                           }),
                           0
                         ),
                       ]),
                     ]),
                     _vm._v(" "),
                     _c("div", { staticClass: "cart__item-footer" }, [
                       _c("div", {
                         staticClass: "cart__item-icons",
                         domProps: { innerHTML: _vm._s(item.pictures) },
                       }),
                       _vm._v(" "),
                       _c(
                         "span",
                         {
                           staticClass: "cart__item-remove",
                           on: {
                             click: function ($event) {
                               return _vm.removesItem({ key: item.key })
                             },
                           },
                         },
                         [
                           _vm._v(
                             _vm._s(_vm._f("t")("sections.cart.remove_title"))
                           ),
                         ]
                       ),
                     ]),
                   ]),
                 ]),
               ])
             }),
             0
           ),
       _vm._v(" "),
       _vm.getPictureToString(_vm.cart.items) && _vm.footprintHTML
         ? _c("div", { staticClass: "order-footprint" }, [
             _c("div", { staticClass: "order-footprint__title" }, [
               _vm._v(
                 "\n\t\t\t\t" +
                   _vm._s(_vm._f("t")("templates.cart.order_footprint")) +
                   "\n\t\t\t"
               ),
             ]),
             _vm._v(" "),
             _c("span", { domProps: { innerHTML: _vm._s(_vm.footprintHTML) } }),
           ])
         : _vm._e(),
       _vm._v(" "),
       _vm.customizer.widget && _vm.customizer.widget.text
         ? _c("div", { staticClass: "cart-widget" }, [
             _c("img", {
               staticClass: "cart-widget__image",
               attrs: { src: _vm.customizer.widget.image },
             }),
             _vm._v(" "),
             _vm.customizer.widget.text
               ? _c("span", [
                   _vm._v(
                     "\n\t\t\t\t" +
                       _vm._s(this.customizer.widget.text) +
                       "\n\t\t\t\t"
                   ),
                   _c(
                     "a",
                     {
                       staticClass: "cart-widget__link",
                       attrs: { href: _vm.customizer.widget.link.url },
                     },
                     [
                       _vm._v(
                         "\n\t\t\t\t\t" +
                           _vm._s(this.customizer.widget.link.text) +
                           "\n\t\t\t\t"
                       ),
                     ]
                   ),
                 ])
               : _vm._e(),
           ])
         : _vm._e(),
     ]),
     _vm._v(" "),
     _c("div", { staticClass: "order-summary__wrapper" }, [
       _c("div", { staticClass: "order-summary" }, [
         _c("div", { staticClass: "order-summary__title" }, [
           _vm._v(
             "\n\t\t\t\t" +
               _vm._s(_vm._f("t")("sections.cart.summary.title")) +
               "\n\t\t\t"
           ),
         ]),
         _vm._v(" "),
         _c("div", { staticClass: "order-summary__row" }, [
           _c("div", { staticClass: "order-summary__key" }, [
             _vm._v(
               _vm._s(_vm._f("t")("sections.cart.summary.subtotal")) +
                 " (" +
                 _vm._s(_vm.cart.item_count) +
                 ")\n\t\t\t\t"
             ),
           ]),
           _vm._v(" "),
           _c("div", { staticClass: "order-summary__val" }, [
             _vm._v(
               "\n\t\t\t\t\t" +
                 _vm._s(_vm._f("money")(_vm.cart.items_subtotal_price)) +
                 "\n\t\t\t\t"
             ),
           ]),
         ]),
         _vm._v(" "),
         _c("div", { staticClass: "order-summary__row" }, [
           _c("div", { staticClass: "order-summary__key" }, [
             _vm._v(
               "\n\t\t\t\t\t" +
                 _vm._s(_vm._f("t")("sections.cart.summary.shipping1_html")) +
                 "\n\t\t\t\t\t"
             ),
             _c("br"),
             _vm._v(" "),
             _c("span", [
               _vm._v(
                 _vm._s(
                   _vm._f("t")("sections.cart.summary.shipping2_html", {
                     price: this.getShippingThreshold,
                   })
                 )
               ),
             ]),
           ]),
           _vm._v(" "),
           _vm.isShippingNotFree()
             ? _c("div", { staticClass: "order-summary__val" }, [_vm._v("$10")])
             : _c("div", { staticClass: "order-summary__val" }, [
                 _vm._v(
                   _vm._s(_vm._f("t")("sections.cart.summary.shipping_free"))
                 ),
               ]),
         ]),
         _vm._v(" "),
         _c("div", { staticClass: "order-summary__row" }, [
           _c("div", { staticClass: "order-summary__key" }, [
             _vm._v(
               "\n\t\t\t\t\t" +
                 _vm._s(_vm._f("t")("sections.cart.summary.tax")) +
                 "\n\t\t\t\t"
             ),
           ]),
           _vm._v(" "),
           _c("div", { staticClass: "order-summary__val" }, [_vm._v("-")]),
         ]),
         _vm._v(" "),
         _c("div", { staticClass: "order-summary__row order-summary__total" }, [
           _c("div", { staticClass: "order-summary__key" }, [
             _vm._v(
               "\n\t\t\t\t\t" +
                 _vm._s(_vm._f("t")("sections.cart.summary.total")) +
                 "\n\t\t\t\t"
             ),
           ]),
           _vm._v(" "),
           _c("div", { staticClass: "order-summary__val" }, [
             _vm._v(
               "\n\t\t\t\t\t" +
                 _vm._s(_vm._f("money")(_vm.cart.items_subtotal_price)) +
                 "\n\t\t\t\t"
             ),
           ]),
         ]),
         _vm._v(" "),
         !_vm.isEmptyCart
           ? _c(
               "a",
               {
                 staticClass: "order-summary__checkout",
                 attrs: { href: _vm._f("routes")(_vm.checkoutUrl) },
               },
               [_vm._v(_vm._s(_vm._f("t")("sections.cart.summary.checkout")))]
             )
           : _vm._e(),
         _vm._v(" "),
         !_vm.isEmptyCart
           ? _c(
               "a",
               {
                 staticClass: "order-summary__secure",
                 attrs: { href: _vm._f("routes")(_vm.checkoutUrl) },
               },
               [
                 _c("IconLock"),
                 _vm._v(
                   "\n\t\t\t\t" +
                     _vm._s(_vm._f("t")("sections.cart.summary.secure")) +
                     "\n\t\t\t"
                 ),
               ],
               1
             )
           : _vm._e(),
       ]),
       _vm._v(" "),
       _c("div", { staticClass: "order-summary__footer" }, [
         _c(
           "div",
           { staticClass: "order-summary__icons" },
           [
             _c("IconVisa"),
             _vm._v(" "),
             _c("IconAmericanExpress"),
             _vm._v(" "),
             _c("IconMasterCard"),
             _vm._v(" "),
             _c("IconClearPay"),
             _vm._v(" "),
             _c("IconLayBuy"),
           ],
           1
         ),
         _vm._v(" "),
         _vm.customizer.summary_text
           ? _c("div", { staticClass: "button order-summary__text" }, [
               _vm._v(
                 "\n\t\t\t\t" + _vm._s(_vm.customizer.summary_text) + "\n\t\t\t"
               ),
             ])
           : _vm._e(),
         _vm._v(" "),
         _vm.customizer.help_link && _vm.customizer.summary_help
           ? _c(
               "a",
               {
                 staticClass: "button order-summary__help",
                 attrs: { href: _vm.customizer.help_link },
               },
               [
                 _vm._v(
                   "\n\t\t\t\t" +
                     _vm._s(_vm.customizer.summary_help) +
                     "\n\t\t\t"
                 ),
               ]
             )
           : _vm._e(),
       ]),
     ]),
   ])
 }
 var staticRenderFns = []
 Cartvue_type_template_id_dc8a09ae_render._withStripped = true


 // CONCATENATED MODULE: ./src/scripts/vue/Cart.vue?vue&type=template&id=dc8a09ae&

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.assign.js
 var es_object_assign = __webpack_require__(184);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.for-each.js
 var web_dom_collections_for_each = __webpack_require__(8);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.includes.js
 var es_array_includes = __webpack_require__(82);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.includes.js
 var es_string_includes = __webpack_require__(81);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.join.js
 var es_array_join = __webpack_require__(115);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
 var es_object_keys = __webpack_require__(40);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
 var es_symbol = __webpack_require__(29);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.filter.js
 var es_array_filter = __webpack_require__(25);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptor.js
 var es_object_get_own_property_descriptor = __webpack_require__(44);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptors.js
 var es_object_get_own_property_descriptors = __webpack_require__(43);

 // EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
 var vuex_esm = __webpack_require__(79);

 // EXTERNAL MODULE: ./src/scripts/core/objects.js + 1 modules
 var objects = __webpack_require__(38);

 // EXTERNAL MODULE: ./node_modules/@savchukoleksii/shopify-theme-settings-tool/src/index.js
 var src = __webpack_require__(61);

 // EXTERNAL MODULE: ./src/icons/icon-lock.svg
 var icon_lock = __webpack_require__(229);
 var icon_lock_default = /*#__PURE__*/__webpack_require__.n(icon_lock);

 // EXTERNAL MODULE: ./src/icons/icon-visa.svg
 var icon_visa = __webpack_require__(228);
 var icon_visa_default = /*#__PURE__*/__webpack_require__.n(icon_visa);

 // EXTERNAL MODULE: ./src/icons/icon-american_express.svg
 var icon_american_express = __webpack_require__(227);
 var icon_american_express_default = /*#__PURE__*/__webpack_require__.n(icon_american_express);

 // EXTERNAL MODULE: ./src/icons/icon-mastercard.svg
 var icon_mastercard = __webpack_require__(226);
 var icon_mastercard_default = /*#__PURE__*/__webpack_require__.n(icon_mastercard);

 // EXTERNAL MODULE: ./src/icons/icon-clearpay.svg
 var icon_clearpay = __webpack_require__(225);
 var icon_clearpay_default = /*#__PURE__*/__webpack_require__.n(icon_clearpay);

 // EXTERNAL MODULE: ./src/icons/icon-laybuy.svg
 var icon_laybuy = __webpack_require__(224);
 var icon_laybuy_default = /*#__PURE__*/__webpack_require__.n(icon_laybuy);

 // EXTERNAL MODULE: ./node_modules/axios/index.js
 var axios = __webpack_require__(24);
 var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

 // CONCATENATED MODULE: ./node_modules/babel-loader/lib??ref--0!./node_modules/vue-loader/lib??vue-loader-options!./src/scripts/vue/Cart.vue?vue&type=script&lang=js&


 function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

 function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }














 function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

 function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

 function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //


 var _createNamespacedHelp = Object(vuex_esm["a" /* createNamespacedHelpers */])('cart'),
     mapState = _createNamespacedHelp.mapState,
     mapActions = _createNamespacedHelp.mapActions,
     mapGetters = _createNamespacedHelp.mapGetters;











 /* harmony default export */ var Cartvue_type_script_lang_js_ = ({
   name: 'Cart',
   data: function data() {
     return {
       customizer: {},
       checkoutUrl: objects["a" /* CHECKOUT */],
       cartUr: objects["b" /* ROUTE_CART */],
       footprintHTML: null,
       pictureProductHTML: {}
     };
   },
   mounted: function mounted() {
     this.initCustomizer();
   },
   computed: _objectSpread(_objectSpread({}, mapGetters([cart["g" /* GETTER_CART */], cart["h" /* GETTER_SETTINGS */]])), {}, {
     isEmptyCart: function isEmptyCart() {
       return this.cart.item_count === 0;
     },
     enableFreeShippingBar: function enableFreeShippingBar() {
       return this.customizer.enable_free_shipping_bar;
     },
     freeShippingThreshold: function freeShippingThreshold() {
       return this.customizer.free_shipping_threshold;
     },
     placeholderImage: function placeholderImage() {
       return src["a" /* default */].get('placeholder_image');
     },
     moneyFormat: function moneyFormat() {
       return objects["c" /* default */].get('shop.money_format');
     }
   }),
   methods: _objectSpread(_objectSpread({}, mapActions([cart["d" /* ACTION_INIT_CART */], cart["e" /* ACTION_REMOVE_ITEM */], cart["b" /* ACTION_CHANGE_QUANTITY */]])), {}, {
     initCustomizer: function initCustomizer() {
       var customizerDataHolder = document.getElementById('cart-customizer-data');

       if (!customizerDataHolder) {
         return null;
       }

       try {
         var data = JSON.parse(customizerDataHolder.innerHTML);
         this.customizer = Object.assign({}, {}, data.customizer);
       } catch (error) {}
     },
     icons: function icons(products) {
       var icons = [];
       products.forEach(function (product) {
         product.tags.forEach(function (tag) {
           if (tag.includes('picture:')) {
             var icon = tag.substr(8);
             if (!icons.includes(icon)) icons.push(icon);
           }
         });
       });
       return icons;
     },
     getPictureToString: function getPictureToString(products) {
       var _this = this;

       return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
         var icons, pictureString, response, html, data;
         return regeneratorRuntime.wrap(function _callee$(_context) {
           while (1) {
             switch (_context.prev = _context.next) {
               case 0:
                 icons = [];
                 products.forEach(function (product) {
                   product.product.tags.forEach(function (tag) {
                     if (tag.includes('picture:') && !icons.includes(tag)) icons.push(tag);
                   });
                 });
                 pictureString = '|' + icons.join('|') + '|';

                 if (!icons.length) {
                   _context.next = 14;
                   break;
                 }

                 console.log('icons', icons);
                 _context.next = 7;
                 return axios_default.a.get("/?section_id=order-footprint-block&tags=".concat(pictureString));

               case 7:
                 response = _context.sent.data;
                 html = document.createElement("div");
                 html.innerHTML = response;
                 data = html.querySelector("#shopify-section-order-footprint-block").innerHTML;
                 _this.footprintHTML = data;
                 _context.next = 15;
                 break;

               case 14:
                 _this.footprintHTML = null;

               case 15:
                 return _context.abrupt("return", true);

               case 16:
               case "end":
                 return _context.stop();
             }
           }
         }, _callee);
       }))();
     },
     isShippingNotFree: function isShippingNotFree() {
       var _this$customizer, _this$cart, _this$customizer2;

       var allGiftCards = this.cart.items.every(function (item) {
         return item.gift_card === true;
       });

       if (allGiftCards) {
         return false;
       }

       return !!((_this$customizer = this.customizer) !== null && _this$customizer !== void 0 && _this$customizer.shipping_price && ((_this$cart = this.cart) === null || _this$cart === void 0 ? void 0 : _this$cart.total_price) < ((_this$customizer2 = this.customizer) === null || _this$customizer2 === void 0 ? void 0 : _this$customizer2.shipping_threshold) * 100);
     },
     getShippingThreshold: function getShippingThreshold() {
       var _this$customizer3;

       return this.$options.filters.money(((_this$customizer3 = this.customizer) === null || _this$customizer3 === void 0 ? void 0 : _this$customizer3.shipping_threshold) * 100);
     },
     changeQuantityItem: function changeQuantityItem(data) {
       this.changeQuantity(data);
     },
     removesItem: function removesItem(data) {
       this.removeItem(data);
     }
   }),
   components: {
     IconLock: icon_lock_default.a,
     IconVisa: icon_visa_default.a,
     IconAmericanExpress: icon_american_express_default.a,
     IconMasterCard: icon_mastercard_default.a,
     IconClearPay: icon_clearpay_default.a,
     IconLayBuy: icon_laybuy_default.a
   }
 });
 // CONCATENATED MODULE: ./src/scripts/vue/Cart.vue?vue&type=script&lang=js&
  /* harmony default export */ var vue_Cartvue_type_script_lang_js_ = (Cartvue_type_script_lang_js_);
 // EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
 var componentNormalizer = __webpack_require__(34);

 // CONCATENATED MODULE: ./src/scripts/vue/Cart.vue





 /* normalize component */

 var component = Object(componentNormalizer["a" /* default */])(
   vue_Cartvue_type_script_lang_js_,
   Cartvue_type_template_id_dc8a09ae_render,
   staticRenderFns,
   false,
   null,
   null,
   null

 )

 component.options.__file = "src/scripts/vue/Cart.vue"
 /* harmony default export */ var Cart = (component.exports);
 // CONCATENATED MODULE: ./src/scripts/sections/cart.js




 function cart_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

 function cart_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { cart_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { cart_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }







 Object(theme_sections["b" /* register */])("cart", {
   onLoad: function onLoad() {
     this.init();
   },
   init: function () {
     var _init = cart_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
       return regeneratorRuntime.wrap(function _callee$(_context) {
         while (1) {
           switch (_context.prev = _context.next) {
             case 0:
               _context.next = 2;
               return store["a" /* store */].dispatch("cart/".concat(cart["d" /* ACTION_INIT_CART */]));

             case 2:
               new vue_runtime_esm["a" /* default */]({
                 store: store["a" /* store */],
                 render: function render(h) {
                   return h(Cart);
                 }
               }).$mount(this.container);

             case 3:
             case "end":
               return _context.stop();
           }
         }
       }, _callee, this);
     }));

     function init() {
       return _init.apply(this, arguments);
     }

     return init;
   }()
 });

 /***/ }),
 /* 237 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";
 __webpack_require__.r(__webpack_exports__);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
 var es_object_to_string = __webpack_require__(3);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.promise.js
 var es_promise = __webpack_require__(14);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
 var es_object_keys = __webpack_require__(40);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
 var es_symbol = __webpack_require__(29);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.filter.js
 var es_array_filter = __webpack_require__(25);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptor.js
 var es_object_get_own_property_descriptor = __webpack_require__(44);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.for-each.js
 var web_dom_collections_for_each = __webpack_require__(8);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptors.js
 var es_object_get_own_property_descriptors = __webpack_require__(43);

 // EXTERNAL MODULE: ./node_modules/regenerator-runtime/runtime.js
 var runtime = __webpack_require__(16);

 // EXTERNAL MODULE: ./node_modules/@shopify/theme-sections/theme-sections.js + 1 modules
 var theme_sections = __webpack_require__(1);

 // EXTERNAL MODULE: ./node_modules/vue/dist/vue.runtime.esm.js
 var vue_runtime_esm = __webpack_require__(36);

 // EXTERNAL MODULE: ./src/scripts/vue/filters/index.js
 var filters = __webpack_require__(124);

 // EXTERNAL MODULE: ./src/scripts/vue/store/index.js
 var store = __webpack_require__(20);

 // EXTERNAL MODULE: ./src/scripts/vue/store/recently-viewed-products/recently-viewed-products.js
 var recently_viewed_products = __webpack_require__(78);

 // CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/scripts/vue/RecentlyViewedProducts.vue?vue&type=template&id=4adc0099&
 var RecentlyViewedProductsvue_type_template_id_4adc0099_render = function () {
   var _vm = this
   var _h = _vm.$createElement
   var _c = _vm._self._c || _h
   return _vm.products.length > 0
     ? _c(
         "section",
         {
           ref: "section",
           staticClass: "recently-viewed-products",
           attrs: {
             id: "recently-viewed-products",
             "data-section-id": _vm.section.id,
             "data-section-type": _vm.section.type,
           },
         },
         [
           [
             _vm.title
               ? _c(
                   "div",
                   {
                     staticClass:
                       "container container--full-width recently-viewed-products__container",
                   },
                   [
                     _c(
                       "h2",
                       {
                         staticClass:
                           "section-title section-title--small recently-viewed-products__title",
                       },
                       [
                         _vm._v(
                           "\n\t\t\t\t\t" + _vm._s(_vm.title) + "\n\t\t\t\t"
                         ),
                       ]
                     ),
                   ]
                 )
               : _vm._e(),
             _vm._v(" "),
             _c(
               "div",
               {
                 staticClass:
                   "slider recently-viewed-products__slider slider--full-width",
               },
               [
                 _c(
                   "div",
                   {
                     ref: "slider",
                     class: {
                       "swiper-container": true,
                       container: true,
                       "container--full-width": true,
                       "recently-viewed-products__slider-container": true,
                       initialized: _vm.initialized,
                     },
                   },
                   [
                     _c(
                       "div",
                       { staticClass: "swiper-wrapper slider__wrapper" },
                       _vm._l(_vm.products, function (product, key) {
                         return _c(
                           "div",
                           {
                             key: key,
                             staticClass:
                               "swiper-slide slider__slide recently-viewed-products__slider-slide",
                           },
                           [_c("ProductCard", { attrs: { product: product } })],
                           1
                         )
                       }),
                       0
                     ),
                     _vm._v(" "),
                     _c(
                       "button",
                       {
                         ref: "arrowPrev",
                         staticClass:
                           "slider__arrow slider__arrow--prev recently-viewed-products__slider-arrow",
                       },
                       [_c("IconChevron")],
                       1
                     ),
                     _vm._v(" "),
                     _c(
                       "button",
                       {
                         ref: "arrowNext",
                         staticClass:
                           "slider__arrow slider__arrow--next recently-viewed-products__slider-arrow",
                       },
                       [_c("IconChevron")],
                       1
                     ),
                   ]
                 ),
               ]
             ),
           ],
         ],
         2
       )
     : _vm._e()
 }
 var staticRenderFns = []
 RecentlyViewedProductsvue_type_template_id_4adc0099_render._withStripped = true


 // CONCATENATED MODULE: ./src/scripts/vue/RecentlyViewedProducts.vue?vue&type=template&id=4adc0099&

 // EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
 var vuex_esm = __webpack_require__(79);

 // EXTERNAL MODULE: ./src/icons/icon-chevron.svg
 var icon_chevron = __webpack_require__(218);
 var icon_chevron_default = /*#__PURE__*/__webpack_require__.n(icon_chevron);

 // EXTERNAL MODULE: ./src/scripts/vue/components/ProductCard.vue + 6 modules
 var ProductCard = __webpack_require__(143);

 // EXTERNAL MODULE: ./node_modules/swiper/esm/components/core/core-class.js + 66 modules
 var core_class = __webpack_require__(103);

 // EXTERNAL MODULE: ./node_modules/ssr-window/ssr-window.esm.js
 var ssr_window_esm = __webpack_require__(4);

 // EXTERNAL MODULE: ./node_modules/swiper/esm/utils/dom.js + 1 modules
 var dom = __webpack_require__(9);

 // EXTERNAL MODULE: ./node_modules/swiper/esm/utils/utils.js
 var utils = __webpack_require__(6);

 // CONCATENATED MODULE: ./node_modules/swiper/esm/components/scrollbar/scrollbar.js
 function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }




 var Scrollbar = {
   setTranslate: function setTranslate() {
     var swiper = this;
     if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
     var scrollbar = swiper.scrollbar,
         rtl = swiper.rtlTranslate,
         progress = swiper.progress;
     var dragSize = scrollbar.dragSize,
         trackSize = scrollbar.trackSize,
         $dragEl = scrollbar.$dragEl,
         $el = scrollbar.$el;
     var params = swiper.params.scrollbar;
     var newSize = dragSize;
     var newPos = (trackSize - dragSize) * progress;

     if (rtl) {
       newPos = -newPos;

       if (newPos > 0) {
         newSize = dragSize - newPos;
         newPos = 0;
       } else if (-newPos + dragSize > trackSize) {
         newSize = trackSize + newPos;
       }
     } else if (newPos < 0) {
       newSize = dragSize + newPos;
       newPos = 0;
     } else if (newPos + dragSize > trackSize) {
       newSize = trackSize - newPos;
     }

     if (swiper.isHorizontal()) {
       $dragEl.transform("translate3d(" + newPos + "px, 0, 0)");
       $dragEl[0].style.width = newSize + "px";
     } else {
       $dragEl.transform("translate3d(0px, " + newPos + "px, 0)");
       $dragEl[0].style.height = newSize + "px";
     }

     if (params.hide) {
       clearTimeout(swiper.scrollbar.timeout);
       $el[0].style.opacity = 1;
       swiper.scrollbar.timeout = setTimeout(function () {
         $el[0].style.opacity = 0;
         $el.transition(400);
       }, 1000);
     }
   },
   setTransition: function setTransition(duration) {
     var swiper = this;
     if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
     swiper.scrollbar.$dragEl.transition(duration);
   },
   updateSize: function updateSize() {
     var swiper = this;
     if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
     var scrollbar = swiper.scrollbar;
     var $dragEl = scrollbar.$dragEl,
         $el = scrollbar.$el;
     $dragEl[0].style.width = '';
     $dragEl[0].style.height = '';
     var trackSize = swiper.isHorizontal() ? $el[0].offsetWidth : $el[0].offsetHeight;
     var divider = swiper.size / swiper.virtualSize;
     var moveDivider = divider * (trackSize / swiper.size);
     var dragSize;

     if (swiper.params.scrollbar.dragSize === 'auto') {
       dragSize = trackSize * divider;
     } else {
       dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
     }

     if (swiper.isHorizontal()) {
       $dragEl[0].style.width = dragSize + "px";
     } else {
       $dragEl[0].style.height = dragSize + "px";
     }

     if (divider >= 1) {
       $el[0].style.display = 'none';
     } else {
       $el[0].style.display = '';
     }

     if (swiper.params.scrollbar.hide) {
       $el[0].style.opacity = 0;
     }

     Object(utils["e" /* extend */])(scrollbar, {
       trackSize: trackSize,
       divider: divider,
       moveDivider: moveDivider,
       dragSize: dragSize
     });

     if (swiper.params.watchOverflow && swiper.enabled) {
       scrollbar.$el[swiper.isLocked ? 'addClass' : 'removeClass'](swiper.params.scrollbar.lockClass);
     }
   },
   getPointerPosition: function getPointerPosition(e) {
     var swiper = this;

     if (swiper.isHorizontal()) {
       return e.type === 'touchstart' || e.type === 'touchmove' ? e.targetTouches[0].clientX : e.clientX;
     }

     return e.type === 'touchstart' || e.type === 'touchmove' ? e.targetTouches[0].clientY : e.clientY;
   },
   setDragPosition: function setDragPosition(e) {
     var swiper = this;
     var scrollbar = swiper.scrollbar,
         rtl = swiper.rtlTranslate;
     var $el = scrollbar.$el,
         dragSize = scrollbar.dragSize,
         trackSize = scrollbar.trackSize,
         dragStartPos = scrollbar.dragStartPos;
     var positionRatio;
     positionRatio = (scrollbar.getPointerPosition(e) - $el.offset()[swiper.isHorizontal() ? 'left' : 'top'] - (dragStartPos !== null ? dragStartPos : dragSize / 2)) / (trackSize - dragSize);
     positionRatio = Math.max(Math.min(positionRatio, 1), 0);

     if (rtl) {
       positionRatio = 1 - positionRatio;
     }

     var position = swiper.minTranslate() + (swiper.maxTranslate() - swiper.minTranslate()) * positionRatio;
     swiper.updateProgress(position);
     swiper.setTranslate(position);
     swiper.updateActiveIndex();
     swiper.updateSlidesClasses();
   },
   onDragStart: function onDragStart(e) {
     var swiper = this;
     var params = swiper.params.scrollbar;
     var scrollbar = swiper.scrollbar,
         $wrapperEl = swiper.$wrapperEl;
     var $el = scrollbar.$el,
         $dragEl = scrollbar.$dragEl;
     swiper.scrollbar.isTouched = true;
     swiper.scrollbar.dragStartPos = e.target === $dragEl[0] || e.target === $dragEl ? scrollbar.getPointerPosition(e) - e.target.getBoundingClientRect()[swiper.isHorizontal() ? 'left' : 'top'] : null;
     e.preventDefault();
     e.stopPropagation();
     $wrapperEl.transition(100);
     $dragEl.transition(100);
     scrollbar.setDragPosition(e);
     clearTimeout(swiper.scrollbar.dragTimeout);
     $el.transition(0);

     if (params.hide) {
       $el.css('opacity', 1);
     }

     if (swiper.params.cssMode) {
       swiper.$wrapperEl.css('scroll-snap-type', 'none');
     }

     swiper.emit('scrollbarDragStart', e);
   },
   onDragMove: function onDragMove(e) {
     var swiper = this;
     var scrollbar = swiper.scrollbar,
         $wrapperEl = swiper.$wrapperEl;
     var $el = scrollbar.$el,
         $dragEl = scrollbar.$dragEl;
     if (!swiper.scrollbar.isTouched) return;
     if (e.preventDefault) e.preventDefault();else e.returnValue = false;
     scrollbar.setDragPosition(e);
     $wrapperEl.transition(0);
     $el.transition(0);
     $dragEl.transition(0);
     swiper.emit('scrollbarDragMove', e);
   },
   onDragEnd: function onDragEnd(e) {
     var swiper = this;
     var params = swiper.params.scrollbar;
     var scrollbar = swiper.scrollbar,
         $wrapperEl = swiper.$wrapperEl;
     var $el = scrollbar.$el;
     if (!swiper.scrollbar.isTouched) return;
     swiper.scrollbar.isTouched = false;

     if (swiper.params.cssMode) {
       swiper.$wrapperEl.css('scroll-snap-type', '');
       $wrapperEl.transition('');
     }

     if (params.hide) {
       clearTimeout(swiper.scrollbar.dragTimeout);
       swiper.scrollbar.dragTimeout = Object(utils["g" /* nextTick */])(function () {
         $el.css('opacity', 0);
         $el.transition(400);
       }, 1000);
     }

     swiper.emit('scrollbarDragEnd', e);

     if (params.snapOnRelease) {
       swiper.slideToClosest();
     }
   },
   enableDraggable: function enableDraggable() {
     var swiper = this;
     if (!swiper.params.scrollbar.el) return;
     var document = Object(ssr_window_esm["a" /* getDocument */])();
     var scrollbar = swiper.scrollbar,
         touchEventsTouch = swiper.touchEventsTouch,
         touchEventsDesktop = swiper.touchEventsDesktop,
         params = swiper.params,
         support = swiper.support;
     var $el = scrollbar.$el;
     var target = $el[0];
     var activeListener = support.passiveListener && params.passiveListeners ? {
       passive: false,
       capture: false
     } : false;
     var passiveListener = support.passiveListener && params.passiveListeners ? {
       passive: true,
       capture: false
     } : false;
     if (!target) return;

     if (!support.touch) {
       target.addEventListener(touchEventsDesktop.start, swiper.scrollbar.onDragStart, activeListener);
       document.addEventListener(touchEventsDesktop.move, swiper.scrollbar.onDragMove, activeListener);
       document.addEventListener(touchEventsDesktop.end, swiper.scrollbar.onDragEnd, passiveListener);
     } else {
       target.addEventListener(touchEventsTouch.start, swiper.scrollbar.onDragStart, activeListener);
       target.addEventListener(touchEventsTouch.move, swiper.scrollbar.onDragMove, activeListener);
       target.addEventListener(touchEventsTouch.end, swiper.scrollbar.onDragEnd, passiveListener);
     }
   },
   disableDraggable: function disableDraggable() {
     var swiper = this;
     if (!swiper.params.scrollbar.el) return;
     var document = Object(ssr_window_esm["a" /* getDocument */])();
     var scrollbar = swiper.scrollbar,
         touchEventsTouch = swiper.touchEventsTouch,
         touchEventsDesktop = swiper.touchEventsDesktop,
         params = swiper.params,
         support = swiper.support;
     var $el = scrollbar.$el;
     var target = $el[0];
     var activeListener = support.passiveListener && params.passiveListeners ? {
       passive: false,
       capture: false
     } : false;
     var passiveListener = support.passiveListener && params.passiveListeners ? {
       passive: true,
       capture: false
     } : false;
     if (!target) return;

     if (!support.touch) {
       target.removeEventListener(touchEventsDesktop.start, swiper.scrollbar.onDragStart, activeListener);
       document.removeEventListener(touchEventsDesktop.move, swiper.scrollbar.onDragMove, activeListener);
       document.removeEventListener(touchEventsDesktop.end, swiper.scrollbar.onDragEnd, passiveListener);
     } else {
       target.removeEventListener(touchEventsTouch.start, swiper.scrollbar.onDragStart, activeListener);
       target.removeEventListener(touchEventsTouch.move, swiper.scrollbar.onDragMove, activeListener);
       target.removeEventListener(touchEventsTouch.end, swiper.scrollbar.onDragEnd, passiveListener);
     }
   },
   init: function init() {
     var swiper = this;
     var scrollbar = swiper.scrollbar,
         $swiperEl = swiper.$el;
     swiper.params.scrollbar = Object(utils["c" /* createElementIfNotDefined */])($swiperEl, swiper.params.scrollbar, swiper.params.createElements, {
       el: 'swiper-scrollbar'
     });
     var params = swiper.params.scrollbar;
     if (!params.el) return;
     var $el = Object(dom["a" /* default */])(params.el);

     if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1 && $swiperEl.find(params.el).length === 1) {
       $el = $swiperEl.find(params.el);
     }

     var $dragEl = $el.find("." + swiper.params.scrollbar.dragClass);

     if ($dragEl.length === 0) {
       $dragEl = Object(dom["a" /* default */])("<div class=\"" + swiper.params.scrollbar.dragClass + "\"></div>");
       $el.append($dragEl);
     }

     Object(utils["e" /* extend */])(scrollbar, {
       $el: $el,
       el: $el[0],
       $dragEl: $dragEl,
       dragEl: $dragEl[0]
     });

     if (params.draggable) {
       scrollbar.enableDraggable();
     }

     if ($el) {
       $el[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.scrollbar.lockClass);
     }
   },
   destroy: function destroy() {
     var swiper = this;
     swiper.scrollbar.disableDraggable();
   }
 };
 /* harmony default export */ var scrollbar_scrollbar = ({
   name: 'scrollbar',
   params: {
     scrollbar: {
       el: null,
       dragSize: 'auto',
       hide: false,
       draggable: false,
       snapOnRelease: true,
       lockClass: 'swiper-scrollbar-lock',
       dragClass: 'swiper-scrollbar-drag'
     }
   },
   create: function create() {
     var swiper = this;
     Object(utils["a" /* bindModuleMethods */])(swiper, {
       scrollbar: _extends({
         isTouched: false,
         timeout: null,
         dragTimeout: null
       }, Scrollbar)
     });
   },
   on: {
     init: function init(swiper) {
       swiper.scrollbar.init();
       swiper.scrollbar.updateSize();
       swiper.scrollbar.setTranslate();
     },
     update: function update(swiper) {
       swiper.scrollbar.updateSize();
     },
     resize: function resize(swiper) {
       swiper.scrollbar.updateSize();
     },
     observerUpdate: function observerUpdate(swiper) {
       swiper.scrollbar.updateSize();
     },
     setTranslate: function setTranslate(swiper) {
       swiper.scrollbar.setTranslate();
     },
     setTransition: function setTransition(swiper, duration) {
       swiper.scrollbar.setTransition(duration);
     },
     'enable disable': function enableDisable(swiper) {
       var $el = swiper.scrollbar.$el;

       if ($el) {
         $el[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.scrollbar.lockClass);
       }
     },
     destroy: function destroy(swiper) {
       swiper.scrollbar.destroy();
     }
   }
 });
 // EXTERNAL MODULE: ./node_modules/swiper/esm/components/navigation/navigation.js
 var navigation = __webpack_require__(172);

 // CONCATENATED MODULE: ./node_modules/babel-loader/lib??ref--0!./node_modules/vue-loader/lib??vue-loader-options!./src/scripts/vue/RecentlyViewedProducts.vue?vue&type=script&lang=js&








 function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

 function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

 function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //




 var _createNamespacedHelp = Object(vuex_esm["a" /* createNamespacedHelpers */])("recently-viewed-products"),
     mapState = _createNamespacedHelp.mapState,
     mapActions = _createNamespacedHelp.mapActions,
     mapGetters = _createNamespacedHelp.mapGetters;



 core_class["a" /* default */].use([scrollbar_scrollbar, navigation["a" /* default */]]);
 /* harmony default export */ var RecentlyViewedProductsvue_type_script_lang_js_ = ({
   name: 'RecentlyViewedProducts',
   data: function data() {
     return {
       initialized: false
     };
   },
   mounted: function mounted() {
     var _this = this;

     var slider = this.$refs.slider;

     if (!slider) {
       return false;
     }

     var arrowPrev = this.$refs.arrowPrev;
     var arrowNext = this.$refs.arrowNext;
     var pagination = this.$refs.pagination;
     var options = {
       slidesPerView: "auto",
       spaceBetween: 0,
       navigation: {
         nextEl: arrowNext,
         prevEl: arrowPrev
       },
       pagination: {
         el: pagination,
         type: "bullets"
       },
       on: {
         afterInit: function afterInit() {
           _this.initialized = true;
         }
       }
     };
     new core_class["a" /* default */](slider, options);
   },
   computed: _objectSpread(_objectSpread({}, mapGetters([recently_viewed_products["b" /* GETTER_PRODUCTS */]])), {}, {
     section: function section() {
       return {
         id: this.$root.id,
         type: this.$root.type,
         settings: this.$root.settings,
         blocks: this.$root.blocks
       };
     },
     title: function title() {
       var _this$section$setting;

       return (_this$section$setting = this.section.settings) === null || _this$section$setting === void 0 ? void 0 : _this$section$setting.title;
     }
   }),
   components: {
     ProductCard: ProductCard["a" /* default */],
     IconChevron: icon_chevron_default.a
   }
 });
 // CONCATENATED MODULE: ./src/scripts/vue/RecentlyViewedProducts.vue?vue&type=script&lang=js&
  /* harmony default export */ var vue_RecentlyViewedProductsvue_type_script_lang_js_ = (RecentlyViewedProductsvue_type_script_lang_js_);
 // EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
 var componentNormalizer = __webpack_require__(34);

 // CONCATENATED MODULE: ./src/scripts/vue/RecentlyViewedProducts.vue





 /* normalize component */

 var component = Object(componentNormalizer["a" /* default */])(
   vue_RecentlyViewedProductsvue_type_script_lang_js_,
   RecentlyViewedProductsvue_type_template_id_4adc0099_render,
   staticRenderFns,
   false,
   null,
   null,
   null

 )

 component.options.__file = "src/scripts/vue/RecentlyViewedProducts.vue"
 /* harmony default export */ var RecentlyViewedProducts = (component.exports);
 // CONCATENATED MODULE: ./src/scripts/sections/recently-viewed-products.js










 function recently_viewed_products_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

 function recently_viewed_products_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { recently_viewed_products_ownKeys(Object(source), true).forEach(function (key) { recently_viewed_products_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { recently_viewed_products_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

 function recently_viewed_products_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

 function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

 function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }







 var selectors = {
   sectionData: "[data-section-data]"
 };
 Object(theme_sections["b" /* register */])("recently-viewed-products", {
   onLoad: function onLoad() {
     this.init();
   },
   init: function () {
     var _init = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
       var sectionData;
       return regeneratorRuntime.wrap(function _callee$(_context) {
         while (1) {
           switch (_context.prev = _context.next) {
             case 0:
               sectionData = JSON.parse(this.container.querySelector(selectors.sectionData).innerHTML);
               _context.next = 3;
               return store["a" /* store */].dispatch("recently-viewed-products/".concat(recently_viewed_products["a" /* ACTION_INIT_RECENTLY_VIEWED_PRODUCTS */]));

             case 3:
               new vue_runtime_esm["a" /* default */]({
                 store: store["a" /* store */],
                 data: function data() {
                   return recently_viewed_products_objectSpread({}, sectionData);
                 },
                 render: function render(h) {
                   return h(RecentlyViewedProducts);
                 }
               }).$mount(this.container);

             case 4:
             case "end":
               return _context.stop();
           }
         }
       }, _callee, this);
     }));

     function init() {
       return _init.apply(this, arguments);
     }

     return init;
   }()
 });

 /***/ }),
 /* 238 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";
 __webpack_require__.r(__webpack_exports__);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
 var es_object_to_string = __webpack_require__(3);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.for-each.js
 var web_dom_collections_for_each = __webpack_require__(8);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.promise.js
 var es_promise = __webpack_require__(14);

 // EXTERNAL MODULE: ./node_modules/regenerator-runtime/runtime.js
 var runtime = __webpack_require__(16);

 // EXTERNAL MODULE: ./node_modules/@shopify/theme-sections/theme-sections.js + 1 modules
 var theme_sections = __webpack_require__(1);

 // EXTERNAL MODULE: ./node_modules/vue/dist/vue.runtime.esm.js
 var vue_runtime_esm = __webpack_require__(36);

 // EXTERNAL MODULE: ./src/scripts/vue/filters/index.js
 var filters = __webpack_require__(124);

 // EXTERNAL MODULE: ./src/scripts/vue/store/index.js
 var store = __webpack_require__(20);

 // EXTERNAL MODULE: ./src/scripts/vue/store/cart/cart.js + 1 modules
 var cart = __webpack_require__(15);

 // CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/scripts/vue/Minicart.vue?vue&type=template&id=3ae49000&
 var Minicartvue_type_template_id_3ae49000_render = function () {
   var _vm = this
   var _h = _vm.$createElement
   var _c = _vm._self._c || _h
   return _c("div", { staticClass: "minicart", attrs: { id: "minicart" } }, [
     _c("div", {
       class: {
         minicart__overlay: true,
         "minicart__overlay--shown": _vm.isOpened,
       },
       on: { click: _vm.closeCart },
     }),
     _vm._v(" "),
     _c(
       "div",
       {
         staticClass: "minicart__container",
         class: { "minicart__container--open": _vm.isOpened },
         style: {
           height: _vm.getHeight,
         },
       },
       [
         _c("div", { staticClass: "minicart__wrapper" }, [
           _c(
             "div",
             {
               staticClass: "minicart__section minicart__section--header",
               class: { "minicart__header--empty": _vm.isEmptyMinicart },
             },
             [
               _c("div", { staticClass: "minicart__header-wrapper" }, [
                 _c(
                   "a",
                   {
                     staticClass: "minicart-product__header",
                     attrs: { href: _vm._f("routes")(_vm.cartUrl) },
                   },
                   [
                     _vm._v(
                       "\n\t\t\t\t" +
                         _vm._s(_vm._f("t")("templates.cart.title")) +
                         "\n\t\t\t\t"
                     ),
                   ]
                 ),
                 _vm._v(" "),
                 _c(
                   "div",
                   {
                     staticClass: "minicart__close",
                     on: { click: _vm.closeCart },
                   },
                   [_c("IconCloseArrow")],
                   1
                 ),
               ]),
             ]
           ),
           _vm._v(" "),
           _c(
             "div",
             {
               staticClass: "minicart__body",
               class: { "minicart__body--empty": _vm.isEmptyMinicart },
             },
             [
               _vm.isEmptyMinicart
                 ? _c("EmptyMinicart", {
                     attrs: {
                       "empty-button-text": _vm.customizer.empty_button_text,
                       "empty-button-url": _vm.customizer.empty_button_url,
                       "close-cart": _vm.closeCart,
                     },
                   })
                 : _c(
                     "div",
                     {
                       staticClass:
                         "minicart__section minicart__section--items js-minicart-items test",
                     },
                     _vm._l(_vm.cart.items, function (item) {
                       return _c(
                         "div",
                         { key: item.key, staticClass: "minicart-product" },
                         [
                           _c(
                             "div",
                             { staticClass: "minicart-product__wrapper" },
                             [
                               _c(
                                 "a",
                                 {
                                   staticClass:
                                     "minicart-product__column minicart-product__column--left",
                                   attrs: { href: item.url },
                                 },
                                 [
                                   item.properties["_image"]
                                     ? _c("img", {
                                         staticClass: "minicart-product__image",
                                         attrs: {
                                           src: item.properties["_image"],
                                           alt: item.properties["_email"],
                                         },
                                       })
                                     : item.image
                                     ? _c("img", {
                                         staticClass: "minicart-product__image",
                                         attrs: {
                                           src: _vm._f("img_url")(
                                             item.image.src,
                                             "100x"
                                           ),
                                           alt: item.image.alt,
                                         },
                                       })
                                     : _vm._e(),
                                 ]
                               ),
                               _vm._v(" "),
                               _c(
                                 "div",
                                 {
                                   staticClass:
                                     "minicart-product__column minicart-product__column--middle",
                                 },
                                 [
                                   _c(
                                     "a",
                                     {
                                       staticClass: "minicart-product__title",
                                       attrs: { href: item.url },
                                     },
                                     [
                                       _vm._v(
                                         "\n\t\t\t\t\t\t\t\t\t" +
                                           _vm._s(item.product.title) +
                                           "\n\t\t\t\t\t\t\t\t"
                                       ),
                                     ]
                                   ),
                                   _vm._v(" "),
                                   _c(
                                     "p",
                                     {
                                       staticClass: "minicart-product__variant",
                                     },
                                     [
                                       _vm._v(
                                         "\n\t\t\t\t\t\t\t\t\t" +
                                           _vm._s(item.variant.title) +
                                           "\n\t\t\t\t\t\t\t\t"
                                       ),
                                     ]
                                   ),
                                   _vm._v(" "),
                                   _c(
                                     "p",
                                     {
                                       staticClass: "minicart-product__variant",
                                     },
                                     [
                                       _vm._v(
                                         "\n\t\t\t\t\t\t\t\t\t" +
                                           (item.properties["From"] ? "\n\t\t\t\t\t\t\t\t\tFrom: " + _vm._s(item.properties["From"]) + "\n\t\t\t\t\t\t\t\t" : "")
                                           
 
                                       ),
                                     ]
                                   ),
                                   _vm._v(" "),
                                   _c(
                                     "p",
                                     {
                                       staticClass: "minicart-product__variant",
                                     },
                                     [
                                       _vm._v(
                                         "\n\t\t\t\t\t\t\t\t\t" +
                                           (item.properties["Recipient name"] ? "\n\t\t\t\t\t\t\t\t\tRecipient Name: " + _vm._s(item.properties["Recipient name"]) + "\n\t\t\t\t\t\t\t\t" : "")
                                           
 
                                       ),
                                     ]
                                   ),
                                   _vm._v(" "),
                                   _c(
                                     "p",
                                     {
                                       staticClass: "minicart-product__variant",
                                     },
                                     [
                                       _vm._v(
                                         "\n\t\t\t\t\t\t\t\t\t" +
                                        
                                           (item.properties["Recipient email"] ? "\n\t\t\t\t\t\t\t\t\tRecipient Email: " + _vm._s(item.properties["Recipient email"]) + "\n\t\t\t\t\t\t\t\t" : "") 
                                          
 
                                       ),
                                     ]
                                   ),
                                   _vm._v(" "),
                                   _c(
                                     "p",
                                     {
                                       staticClass: "minicart-product__variant",
                                     },
                                     [
                                       _vm._v(
                                         "\n\t\t\t\t\t\t\t\t\t" +
                                         
                                           (item.properties.Message ? "\n\t\t\t\t\t\t\t\t\tMessage: " + _vm._s(item.properties.Message) + "\n\t\t\t\t\t\t\t\t" : "") 
                                          
 
                                       ),
                                     ]
                                   ),
                                   _vm._v(" "),
                                   _c(
                                     "p",
                                     {
                                       staticClass: "minicart-product__variant",
                                     },
                                     [
                                       _vm._v(
                                         "\n\t\t\t\t\t\t\t\t\t" +
                                         
                                           (item.properties["Send on"] ? "\n\t\t\t\t\t\t\t\t\tSend On: " + _vm._s(item.properties["Send on"]) + "\n\t\t\t\t\t\t\t\t" : "")
 
                                       ),
                                     ]
                                   ),
                                   _vm._v(" "),
                                   _c(
                                     "button",
                                     {
                                       staticClass:
                                         "minicart-product__remove-button",
                                       attrs: { type: "button" },
                                       on: {
                                         click: function ($event) {
                                           return _vm.removeItem({
                                             key: item.key,
                                           })
                                         },
                                       },
                                     },
                                     [_c("IconCloseBlack")],
                                     1
                                   ),
                                   _vm._v(" "),
                                   _c(
                                     "div",
                                     { staticClass: "minicart-product__row" },
                                     [
                                       _c(
                                         "div",
                                         {
                                           staticClass:
                                             "minicart-product__quantity",
                                         },
                                         [
                                           _c(
                                             "button",
                                             {
                                               staticClass:
                                                 "minicart-product__quantity-button",
                                               on: {
                                                 click: function ($event) {
                                                   return _vm.changeQuantity({
                                                     key: item.key,
                                                     quantity: item.quantity - 1,
                                                   })
                                                 },
                                               },
                                             },
                                             [_c("IconMinus")],
                                             1
                                           ),
                                           _vm._v(" "),
                                           _c(
                                             "div",
                                             {
                                               staticClass:
                                                 "minicart-product__quantity-input-wrapper",
                                             },
                                             [
                                               _c("input", {
                                                 directives: [
                                                   {
                                                     name: "model",
                                                     rawName:
                                                       "v-model.number.lazy",
                                                     value: item.quantity,
                                                     expression: "item.quantity",
                                                     modifiers: {
                                                       number: true,
                                                       lazy: true,
                                                     },
                                                   },
                                                 ],
                                                 staticClass:
                                                   "minicart-product__quantity-input",
                                                 attrs: { type: "number" },
                                                 domProps: {
                                                   value: item.quantity,
                                                 },
                                                 on: {
                                                   change: [
                                                     function ($event) {
                                                       _vm.$set(
                                                         item,
                                                         "quantity",
                                                         _vm._n(
                                                           $event.target.value
                                                         )
                                                       )
                                                     },
                                                     function ($event) {
                                                       return _vm.changeQuantity(
                                                         {
                                                           key: item.key,
                                                           quantity:
                                                             item.quantity,
                                                         }
                                                       )
                                                     },
                                                   ],
                                                   blur: function ($event) {
                                                     return _vm.$forceUpdate()
                                                   },
                                                 },
                                               }),
                                             ]
                                           ),
                                           _vm._v(" "),
                                           _c(
                                             "button",
                                             {
                                               staticClass:
                                                 "minicart-product__quantity-button",
                                               on: {
                                                 click: function ($event) {
                                                   return _vm.changeQuantity({
                                                     key: item.key,
                                                     quantity: item.quantity + 1,
                                                   })
                                                 },
                                               },
                                             },
                                             [_c("IconPlus")],
                                             1
                                           ),
                                         ]
                                       ),
                                       _vm._v(" "),
                                       _c(
                                         "div",
                                         {
                                           staticClass: "minicart-product__save",
                                         },
                                         [
                                           _c(
                                             "button",
                                             {
                                               on: {
                                                 click: function ($event) {
                                                   $event.preventDefault()
                                                   return _vm.saveForLater({
                                                     key: item.key,
                                                   })
                                                 },
                                               },
                                             },
                                             [
                                               _vm._v(
                                                 "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                                   _vm._s(
                                                     _vm._f("t")(
                                                       "templates.cart.save_for_later"
                                                     )
                                                   ) +
                                                   "\n\t\t\t\t\t\t\t\t\t\t"
                                               ),
                                             ]
                                           ),
                                         ]
                                       ),
                                       _vm._v(" "),
                                       _c("p", {
                                         staticClass:
                                           "minicart-product__subtotal",
                                       }),
                                       item.original_price <
                                       item.variant.compare_at_price
                                         ? _c(
                                             "div",
                                             { staticClass: "price-container" },
                                             [
                                               _c(
                                                 "span",
                                                 {
                                                   staticClass: "original-price",
                                                 },
                                                 [
                                                   _vm._v(
                                                     "\n\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                       _vm._s(
                                                         _vm._f("money")(
                                                           item.original_price
                                                         )
                                                       ) +
                                                       "\n\t\t\t\t\t\t\t\t\t\t\t"
                                                   ),
                                                 ]
                                               ),
                                               _vm._v(" "),
                                               _c(
                                                 "span",
                                                 {
                                                   staticClass:
                                                     "compare-at-price",
                                                 },
                                                 [
                                                   _vm._v(
                                                     "\n\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                       _vm._s(
                                                         _vm._f("money")(
                                                           item.variant
                                                             .compare_at_price
                                                         )
                                                       ) +
                                                       "\n\t\t\t\t\t\t\t\t\t\t\t"
                                                   ),
                                                 ]
                                               ),
                                             ]
                                           )
                                         : _c(
                                             "span",
                                             { staticClass: "final-price" },
                                             [
                                               _vm._v(
                                                 _vm._s(
                                                   _vm._f("money")(
                                                     item.final_price
                                                   )
                                                 )
                                               ),
                                             ]
                                           ),
                                       _vm._v(" "),
                                       _c("p"),
                                     ]
                                   ),
                                 ]
                               ),
                             ]
                           ),
                         ]
                       )
                     }),
                     0
                   ),
             ],
             1
           ),
           _vm._v(" "),
           _c("div", { staticClass: "ss__recs__mini-cart minicart__section" }),
           _vm._v(" "),
           !_vm.isEmptyMinicart
             ? _c(
                 "div",
                 { staticClass: "minicart__section minicart__section--footer" },
                 [
                   _c("div", { staticClass: "minicart__subtotal-wrapper" }, [
                     _c("div", { staticClass: "minicart__subtotal-label" }, [
                       _vm._v(
                         "\n\t\t\t\t\t\t" +
                           _vm._s(_vm._f("t")("templates.cart.empty_subtotal")) +
                           "\n\t\t\t\t\t"
                       ),
                     ]),
                     _vm._v(" "),
                     _c("div", { staticClass: "minicart__subtotal-value" }, [
                       _vm._v(
                         "\n\t\t\t\t\t\t" +
                           _vm._s(_vm._f("money")(_vm.cart.total_price)) +
                           " Incl GST\n\t\t\t\t\t"
                       ),
                     ]),
                   ]),
                   _vm._v(" "),
                   _c("div", { staticClass: "minicart__subtotal-wrapper" }, [
                     _c("div", { staticClass: "minicart__subtotal-label" }, [
                       _vm._v(
                         "\n\t\t\t\t\t\t" +
                           _vm._s(_vm._f("t")("templates.cart.shipping_text")) +
                           "\n\t\t\t\t\t"
                       ),
                     ]),
                     _vm._v(" "),
                     _vm.isShippingNotFree()
                       ? _c("div", { staticClass: "minicart__subtotal-value shipping_price" }, [
                           _vm._v(
                               _vm._s( _vm.cart.items.length === 1 &&
                                _vm.cart.items[0].title.includes("Roaring Journals Print Edition")
                                  ? "Free"
                                  : "\n\t\t\t\t\t\t$" + _vm.customizer.shipping_price) +
                               "\n\t\t\t\t\t"
                           ),
                         ])
                       : _c("div", { staticClass: "minicart__subtotal-value" }, [
                           _vm._v(
                             "\n\t\t\t\t\t\t" +
                               _vm._s(
                                 _vm._f("t")("templates.cart.shipping_free")
                               ) +
                               "\n\t\t\t\t\t"
                           ),
                         ]),
                   ]),
                   _vm._v(" "),
                   _c(
                     "a",
                     {
                       staticClass:
                         "minicart__footer-button button button--primary button--reverse-hover",
                       attrs: { href: _vm._f("routes")(_vm.checkoutUrl) },
                     },
                     [
                       _vm._v(
                         "\n\t\t\t\t\t" +
                           _vm._s(_vm._f("t")("templates.cart.empty_checkout")) +
                           "\n\t\t\t\t"
                       ),
                     ]
                   ),
                 ]
               )
             : _vm._e(),
           _vm._v(" "),
           _vm.customizer.guarantee_title || _vm.customizer.guarantee_text
             ? _c(
                 "div",
                 {
                   staticClass: "minicart__section guarantee-block",
                   style: { backgroundColor: _vm.getGuaranteeColor },
                 },
                 [
                   _c("picture", [
                     _vm.getGuaranteeIcon
                       ? _c("img", {
                           staticClass: "guarantee-block__icon",
                           attrs: { src: _vm.getGuaranteeIcon, alt: "" },
                         })
                       : _vm._e(),
                   ]),
                   _vm._v(" "),
                   _vm.customizer.guarantee_title
                     ? _c("h3", { staticClass: "guarantee-block__title" }, [
                         _vm._v(
                           "\n\t\t\t\t\t" +
                             _vm._s(_vm.customizer.guarantee_title) +
                             "\n\t\t\t\t"
                         ),
                       ])
                     : _vm._e(),
                   _vm._v(" "),
                   _vm.customizer.guarantee_title
                     ? _c("div", {
                         staticClass: "guarantee-block__text",
                         domProps: {
                           innerHTML: _vm._s(_vm.customizer.guarantee_text),
                         },
                       })
                     : _vm._e(),
                 ]
               )
             : _vm._e(),
         ]),
       ]
     ),
   ])
 }
 var staticRenderFns = []
 Minicartvue_type_template_id_3ae49000_render._withStripped = true


 // CONCATENATED MODULE: ./src/scripts/vue/Minicart.vue?vue&type=template&id=3ae49000&

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.assign.js
 var es_object_assign = __webpack_require__(184);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
 var es_object_keys = __webpack_require__(40);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
 var es_symbol = __webpack_require__(29);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.filter.js
 var es_array_filter = __webpack_require__(25);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptor.js
 var es_object_get_own_property_descriptor = __webpack_require__(44);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptors.js
 var es_object_get_own_property_descriptors = __webpack_require__(43);

 // CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/scripts/vue/components/EmptyMinicart.vue?vue&type=template&id=0b82dcf4&
 var EmptyMinicartvue_type_template_id_0b82dcf4_render = function () {
   var _vm = this
   var _h = _vm.$createElement
   var _c = _vm._self._c || _h
   return _c(
     "div",
     {
       staticClass:
         "minicart__section minicart__section--empty js-minicart-items",
     },
     [
       _c("div", { staticClass: "minicart__empty-wrapper" }, [
         _c("div", { staticClass: "minicart__section-empty-message" }, [
           _vm._v(
             "\n\t\t\t" +
               _vm._s(_vm._f("t")("templates.cart.empty_title")) +
               "\n\t\t"
           ),
         ]),
         _vm._v(" "),
         _c(
           "div",
           {
             staticClass:
               "minicart__empty-button button button--primary button--reverse-hover",
             on: { click: _vm.closeCart },
           },
           [_vm._v(_vm._s(_vm.emptyButtonText))]
         ),
       ]),
     ]
   )
 }
 var EmptyMinicartvue_type_template_id_0b82dcf4_staticRenderFns = []
 EmptyMinicartvue_type_template_id_0b82dcf4_render._withStripped = true


 // CONCATENATED MODULE: ./src/scripts/vue/components/EmptyMinicart.vue?vue&type=template&id=0b82dcf4&

 // CONCATENATED MODULE: ./node_modules/babel-loader/lib??ref--0!./node_modules/vue-loader/lib??vue-loader-options!./src/scripts/vue/components/EmptyMinicart.vue?vue&type=script&lang=js&
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 /* harmony default export */ var EmptyMinicartvue_type_script_lang_js_ = ({
   name: 'EmptyMinicart',
   props: {
     closeCart: {
       type: Function,
       required: true
     },
     emptyButtonText: {
       type: String,
       required: false
     },
     emptyButtonUrl: {
       type: String,
       required: false
     }
   }
 });
 // CONCATENATED MODULE: ./src/scripts/vue/components/EmptyMinicart.vue?vue&type=script&lang=js&
  /* harmony default export */ var components_EmptyMinicartvue_type_script_lang_js_ = (EmptyMinicartvue_type_script_lang_js_);
 // EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
 var componentNormalizer = __webpack_require__(34);

 // CONCATENATED MODULE: ./src/scripts/vue/components/EmptyMinicart.vue





 /* normalize component */

 var component = Object(componentNormalizer["a" /* default */])(
   components_EmptyMinicartvue_type_script_lang_js_,
   EmptyMinicartvue_type_template_id_0b82dcf4_render,
   EmptyMinicartvue_type_template_id_0b82dcf4_staticRenderFns,
   false,
   null,
   null,
   null

 )

 component.options.__file = "src/scripts/vue/components/EmptyMinicart.vue"
 /* harmony default export */ var EmptyMinicart = (component.exports);
 // EXTERNAL MODULE: ./src/icons/icon-close-arrow.svg
 var icon_close_arrow = __webpack_require__(223);
 var icon_close_arrow_default = /*#__PURE__*/__webpack_require__.n(icon_close_arrow);

 // EXTERNAL MODULE: ./src/icons/icon-plus.svg
 var icon_plus = __webpack_require__(222);
 var icon_plus_default = /*#__PURE__*/__webpack_require__.n(icon_plus);

 // EXTERNAL MODULE: ./src/icons/icon-minus.svg
 var icon_minus = __webpack_require__(221);
 var icon_minus_default = /*#__PURE__*/__webpack_require__.n(icon_minus);

 // EXTERNAL MODULE: ./src/icons/icon-close-black.svg
 var icon_close_black = __webpack_require__(220);
 var icon_close_black_default = /*#__PURE__*/__webpack_require__.n(icon_close_black);

 // EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
 var vuex_esm = __webpack_require__(79);

 // EXTERNAL MODULE: ./src/scripts/core/objects.js + 1 modules
 var objects = __webpack_require__(38);

 // CONCATENATED MODULE: ./node_modules/babel-loader/lib??ref--0!./node_modules/vue-loader/lib??vue-loader-options!./src/scripts/vue/Minicart.vue?vue&type=script&lang=js&









 function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

 function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

 function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //







 var _createNamespacedHelp = Object(vuex_esm["a" /* createNamespacedHelpers */])("cart"),
     mapState = _createNamespacedHelp.mapState,
     mapActions = _createNamespacedHelp.mapActions,
     mapGetters = _createNamespacedHelp.mapGetters;

 var resizeChange = null;


 /* harmony default export */ var Minicartvue_type_script_lang_js_ = ({
   name: 'Minicart',
   data: function data() {
     return {
       isOpened: false,
       height: window.innerHeight,
       customizer: {},
       checkoutUrl: objects["a" /* CHECKOUT */],
       cartUrl: objects["b" /* ROUTE_CART */]
     };
   },
   mounted: function mounted() {
     var _this = this;

     document.addEventListener('minicart:open', this.openCart);
     window.addEventListener('resize', function () {
       clearTimeout(resizeChange);
       resizeChange = setTimeout(function () {
         _this.height = window.innerHeight;
       }, 50);
     });
     this.initCustomizer();
   },
   computed: _objectSpread(_objectSpread({}, mapGetters([cart["g" /* GETTER_CART */], cart["h" /* GETTER_SETTINGS */]])), {}, {
     getHeight: function getHeight() {
       return "".concat(this.height, "px");
     },
     isEmptyMinicart: function isEmptyMinicart() {
       return this.cart.items.length === 0;
     },
     getGuaranteeIcon: function getGuaranteeIcon() {
       return this.customizer.guarantee_icon;
     },
     getGuaranteeColor: function getGuaranteeColor() {
       return this.customizer.guarantee_color;
     }
   }),
   methods: _objectSpread(_objectSpread({}, mapActions([cart["d" /* ACTION_INIT_CART */], cart["e" /* ACTION_REMOVE_ITEM */], cart["b" /* ACTION_CHANGE_QUANTITY */], cart["f" /* ACTION_SAVE_FOR_LATER */]])), {}, {
     initCustomizer: function initCustomizer() {
       var customizerDataHolder = document.getElementById('minicart-customizer-data');

       if (!customizerDataHolder) {
         return null;
       }

       try {
         var data = JSON.parse(customizerDataHolder.innerHTML);
         this.customizer = Object.assign({}, {}, data.customizer);
       } catch (e) {}
     },
     closeCart: function closeCart(e) {
       if (e) {
         e.preventDefault();
       }

       this.clearBodyScroll();
       this.isOpened = false;
     },
     openCart: function openCart() {
       this.bodyScroll();
       this.isOpened = true;
     },
     clearBodyScroll: function clearBodyScroll() {
       bodyScrollLock.clearAllBodyScrollLocks();
       this.$el.querySelector('.js-minicart-items').scrollTo(0, 0);
     },
     bodyScroll: function bodyScroll() {
       bodyScrollLock.disableBodyScroll(this.$el.querySelector('.js-minicart-items'));
     },
     isShippingNotFree: function isShippingNotFree() {
       var _this$customizer, _this$cart, _this$customizer2;

       var allGiftCards = this.cart.items.every(function (item) {
         return item.gift_card === true;
       });

       if (allGiftCards) {
         return false;
       }

       return !!((_this$customizer = this.customizer) !== null && _this$customizer !== void 0 && _this$customizer.shipping_price && ((_this$cart = this.cart) === null || _this$cart === void 0 ? void 0 : _this$cart.total_price) < ((_this$customizer2 = this.customizer) === null || _this$customizer2 === void 0 ? void 0 : _this$customizer2.shipping_threshold) * 100);
     }
   }),
   components: {
     IconCloseArrow: icon_close_arrow_default.a,
     IconMinus: icon_minus_default.a,
     IconPlus: icon_plus_default.a,
     IconCloseBlack: icon_close_black_default.a,
     EmptyMinicart: EmptyMinicart
   }
 });
 // CONCATENATED MODULE: ./src/scripts/vue/Minicart.vue?vue&type=script&lang=js&
  /* harmony default export */ var vue_Minicartvue_type_script_lang_js_ = (Minicartvue_type_script_lang_js_);
 // CONCATENATED MODULE: ./src/scripts/vue/Minicart.vue





 /* normalize component */

 var Minicart_component = Object(componentNormalizer["a" /* default */])(
   vue_Minicartvue_type_script_lang_js_,
   Minicartvue_type_template_id_3ae49000_render,
   staticRenderFns,
   false,
   null,
   null,
   null

 )

 Minicart_component.options.__file = "src/scripts/vue/Minicart.vue"
 /* harmony default export */ var Minicart = (Minicart_component.exports);
 // EXTERNAL MODULE: ./node_modules/@savchukoleksii/shopify-template-checker/src/index.js
 var src = __webpack_require__(123);

 // CONCATENATED MODULE: ./src/scripts/sections/minicart.js





 function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

 function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }








 var selectors = {
   minicartOpener: ".js-open-minicart"
 };
 document.addEventListener("product:add", /*#__PURE__*/function () {
   var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(event) {
     var detail, items, errorCallback, callback;
     return regeneratorRuntime.wrap(function _callee$(_context) {
       while (1) {
         switch (_context.prev = _context.next) {
           case 0:
             detail = event.detail;

             if (detail) {
               _context.next = 3;
               break;
             }

             return _context.abrupt("return", null);

           case 3:
             items = detail.items;

             if (items) {
               _context.next = 6;
               break;
             }

             return _context.abrupt("return", null);

           case 6:
             errorCallback = typeof event.detail.errorCallback === "function" ? event.detail.errorCallback : function () {};
             _context.next = 9;
             return store["a" /* store */].dispatch("cart/".concat(cart["a" /* ACTION_ADD_TO_CART */]), {
               products: event.detail.items,
               errorCallback: errorCallback
             });

           case 9:
             callback = detail.callback;

             if (!(typeof callback === "function")) {
               _context.next = 13;
               break;
             }

             _context.next = 13;
             return callback();

           case 13:
             document.dispatchEvent(new CustomEvent("minicart:open"));

           case 14:
           case "end":
             return _context.stop();
         }
       }
     }, _callee);
   }));

   return function (_x) {
     return _ref.apply(this, arguments);
   };
 }());

 if (!Object(src["a" /* templateEquals */])("cart")) {
   Object(theme_sections["b" /* register */])("minicart", {
     minicartOpeners: null,
     windowWidth: null,
     onLoad: function onLoad() {
       this.init();
     },
     init: function () {
       var _init = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
         return regeneratorRuntime.wrap(function _callee2$(_context2) {
           while (1) {
             switch (_context2.prev = _context2.next) {
               case 0:
                 _context2.next = 2;
                 return store["a" /* store */].dispatch("cart/".concat(cart["d" /* ACTION_INIT_CART */]));

               case 2:
                 new vue_runtime_esm["a" /* default */]({
                   store: store["a" /* store */],
                   render: function render(h) {
                     return h(Minicart);
                   }
                 }).$mount(this.container);
                 this.minicartOpeners = document.querySelectorAll(selectors.minicartOpener);
                 this.initEvents();
                 this.windowWidth = window.innerWidth;

               case 6:
               case "end":
                 return _context2.stop();
             }
           }
         }, _callee2, this);
       }));

       function init() {
         return _init.apply(this, arguments);
       }

       return init;
     }(),
     initEvents: function initEvents() {
       var _this = this;

       if (!this.minicartOpeners) {
         return null;
       }

       this.minicartOpeners.forEach(function (opener) {
         opener.addEventListener("click", _this.open.bind(_this));
       });
     },
     open: function open(event) {
       event.preventDefault();
       document.dispatchEvent(new CustomEvent("minicart:open"));
     }
   });
 }

 /***/ }),
 /* 239 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";
 __webpack_require__.r(__webpack_exports__);

 // EXTERNAL MODULE: ./node_modules/regenerator-runtime/runtime.js
 var runtime = __webpack_require__(16);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
 var es_object_to_string = __webpack_require__(3);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.for-each.js
 var web_dom_collections_for_each = __webpack_require__(8);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.exec.js
 var es_regexp_exec = __webpack_require__(21);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.search.js
 var es_string_search = __webpack_require__(125);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.promise.js
 var es_promise = __webpack_require__(14);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
 var es_object_keys = __webpack_require__(40);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
 var es_symbol = __webpack_require__(29);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.filter.js
 var es_array_filter = __webpack_require__(25);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptor.js
 var es_object_get_own_property_descriptor = __webpack_require__(44);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptors.js
 var es_object_get_own_property_descriptors = __webpack_require__(43);

 // EXTERNAL MODULE: ./node_modules/@shopify/theme-sections/theme-sections.js + 1 modules
 var theme_sections = __webpack_require__(1);

 // EXTERNAL MODULE: ./node_modules/vue/dist/vue.runtime.esm.js
 var vue_runtime_esm = __webpack_require__(36);

 // EXTERNAL MODULE: ./src/scripts/vue/store/index.js
 var store = __webpack_require__(20);

 // EXTERNAL MODULE: ./src/scripts/vue/store/instant-search/instant-search.js
 var instant_search = __webpack_require__(35);

 // CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/scripts/vue/HeaderSearchResult.vue?vue&type=template&id=8bbf374a&
 var HeaderSearchResultvue_type_template_id_8bbf374a_render = function () {
   var _vm = this
   var _h = _vm.$createElement
   var _c = _vm._self._c || _h
   return _c("div", { staticClass: "header-search__contant" }, [
     _vm.suggestions.length > 0
       ? _c("div", { staticClass: "header-search__ask" }, [
           _c("span", { staticClass: "header-search__ask-header" }, [
             _vm._v(_vm._s(_vm._f("t")("general.search.suggestions"))),
           ]),
           _vm._v(" "),
           _c(
             "ul",
             { staticClass: "header-search__ask-list" },
             _vm._l(_vm.suggestions, function (suggestion, index) {
               return _c(
                 "li",
                 { key: index, staticClass: "header-search__ask-item" },
                 [
                   _c(
                     "a",
                     {
                       staticClass: "header-search__aks-item--text",
                       attrs: { href: _vm.getSearchUrlBySuggestion(suggestion) },
                     },
                     [_vm._v(_vm._s(suggestion))]
                   ),
                 ]
               )
             }),
             0
           ),
         ])
       : _vm.termSeggestion.length > 0
       ? _c("div", { staticClass: "header-search__ask" }, [
           _c("span", { staticClass: "header-search__ask-header" }, [
             _vm._v(_vm._s(_vm._f("t")("general.search.popular"))),
           ]),
           _vm._v(" "),
           _c(
             "ul",
             { staticClass: "header-search__ask-list" },
             _vm._l(_vm.termSeggestion, function (suggestion, index) {
               return _c(
                 "li",
                 { key: index, staticClass: "header-search__ask-item" },
                 [
                   _c(
                     "a",
                     {
                       staticClass: "header-search__aks-item--text",
                       attrs: { href: _vm.getSearchUrlBySuggestion(suggestion) },
                     },
                     [_vm._v(_vm._s(suggestion))]
                   ),
                 ]
               )
             }),
             0
           ),
         ])
       : _c("div", { staticClass: "header-search__ask" }, [
           _c("span", { staticClass: "header-search__ask-header" }, [
             _vm._v(_vm._s(_vm._f("t")("general.search.notfound"))),
           ]),
         ]),
     _vm._v(" "),
     _vm.products.length === 0 && _vm.query.length
       ? _c(
           "div",
           {
             staticClass:
               "header-search__products header-search__products--no-result",
           },
           [
             _vm._v("\n\t\tSorry, nothing found for "),
             _c("span", [_vm._v('"' + _vm._s(_vm.query) + '"')]),
           ]
         )
       : _vm.opened
       ? _c(
           "div",
           { staticClass: "header-search__products" },
           _vm._l(_vm.products, function (product, key) {
             return _c(
               "div",
               { key: key, staticClass: "header-search__product" },
               [_c("ProductCard", { attrs: { product: product } })],
               1
             )
           }),
           0
         )
       : _vm._e(),
   ])
 }
 var staticRenderFns = []
 HeaderSearchResultvue_type_template_id_8bbf374a_render._withStripped = true


 // CONCATENATED MODULE: ./src/scripts/vue/HeaderSearchResult.vue?vue&type=template&id=8bbf374a&

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.iterator.js
 var es_array_iterator = __webpack_require__(31);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.iterator.js
 var es_string_iterator = __webpack_require__(27);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.iterator.js
 var web_dom_collections_iterator = __webpack_require__(41);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/web.url-search-params.js
 var web_url_search_params = __webpack_require__(146);

 // EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.to-string.js
 var es_regexp_to_string = __webpack_require__(72);

 // EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
 var vuex_esm = __webpack_require__(79);

 // EXTERNAL MODULE: ./src/scripts/vue/components/ProductCard.vue + 6 modules
 var ProductCard = __webpack_require__(143);

 // CONCATENATED MODULE: ./src/scripts/vue/mixins/sectionData.js
 function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

 function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

 function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }








 /* harmony default export */ var mixins_sectionData = ({
   computed: {
     section: function section() {
       var _this = this;

       return ["id", "type", "settings", "blocks"].reduce(function (data, key) {
         var value = _this.$root[key];
         return _objectSpread(_objectSpread({}, data), {}, _defineProperty({}, key, value));
       }, {});
     }
   }
 });
 // CONCATENATED MODULE: ./node_modules/babel-loader/lib??ref--0!./node_modules/vue-loader/lib??vue-loader-options!./src/scripts/vue/HeaderSearchResult.vue?vue&type=script&lang=js&













 function HeaderSearchResultvue_type_script_lang_js_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

 function HeaderSearchResultvue_type_script_lang_js_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { HeaderSearchResultvue_type_script_lang_js_ownKeys(Object(source), true).forEach(function (key) { HeaderSearchResultvue_type_script_lang_js_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { HeaderSearchResultvue_type_script_lang_js_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

 function HeaderSearchResultvue_type_script_lang_js_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //



 var _createNamespacedHelp = Object(vuex_esm["a" /* createNamespacedHelpers */])("header-instant-search"),
     mapState = _createNamespacedHelp.mapState,
     mapActions = _createNamespacedHelp.mapActions,
     mapGetters = _createNamespacedHelp.mapGetters;



 /* harmony default export */ var HeaderSearchResultvue_type_script_lang_js_ = ({
   name: 'HeaderSearchResult',
   mixins: [mixins_sectionData],
   data: function data() {
     return {
       initialized: false
     };
   },
   mounted: function mounted() {
     this.initialized = true;
   },
   computed: HeaderSearchResultvue_type_script_lang_js_objectSpread({}, mapGetters({
     loading: instant_search["e" /* GETTER_LOADING */],
     opened: instant_search["f" /* GETTER_OPENED */],
     query: instant_search["h" /* GETTER_QUERY */],
     products: instant_search["g" /* GETTER_PRODUCTS */],
     suggestions: instant_search["i" /* GETTER_SUGGESTIONS */],
     termSeggestion: instant_search["j" /* GETTER_TERM_SUGGESTION */]
   })),
   methods: {
     getSearchUrlBySuggestion: function getSearchUrlBySuggestion(suggestion) {
       var params = new URLSearchParams();
       params.set("q", suggestion);
       return "/search?".concat(params.toString());
     }
   },
   components: {
     ProductCard: ProductCard["a" /* default */]
   }
 });
 // CONCATENATED MODULE: ./src/scripts/vue/HeaderSearchResult.vue?vue&type=script&lang=js&
  /* harmony default export */ var vue_HeaderSearchResultvue_type_script_lang_js_ = (HeaderSearchResultvue_type_script_lang_js_);
 // EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
 var componentNormalizer = __webpack_require__(34);

 // CONCATENATED MODULE: ./src/scripts/vue/HeaderSearchResult.vue





 /* normalize component */

 var component = Object(componentNormalizer["a" /* default */])(
   vue_HeaderSearchResultvue_type_script_lang_js_,
   HeaderSearchResultvue_type_template_id_8bbf374a_render,
   staticRenderFns,
   false,
   null,
   null,
   null

 )

 component.options.__file = "src/scripts/vue/HeaderSearchResult.vue"
 /* harmony default export */ var HeaderSearchResult = (component.exports);
 // CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/scripts/vue/HeaderSearchForm.vue?vue&type=template&id=356fcf02&
 var HeaderSearchFormvue_type_template_id_356fcf02_render = function () {
   var _vm = this
   var _h = _vm.$createElement
   var _c = _vm._self._c || _h
   return _c(
     "form",
     { attrs: { action: "#" } },
     [
       _c("IconSearch"),
       _vm._v(" "),
       _c("input", {
         attrs: {
           type: "search",
           placeholder: _vm._f("t")("general.search.search"),
           "data-header-search-input": "",
         },
         on: {
           keyup: function ($event) {
             if (
               !$event.type.indexOf("key") &&
               _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
             ) {
               return null
             }
             return _vm.onEnter.apply(null, arguments)
           },
           input: _vm.search,
         },
       }),
       _vm._v(" "),
       _c(
         "a",
         {
           staticClass: "button header-search__button",
           class: { "header-search__button--disabled": !_vm.statusSeach },
           attrs: { href: "#" },
           on: { click: _vm.onEnter },
         },
         [_vm._v("Submit")]
       ),
     ],
     1
   )
 }
 var HeaderSearchFormvue_type_template_id_356fcf02_staticRenderFns = []
 HeaderSearchFormvue_type_template_id_356fcf02_render._withStripped = true


 // CONCATENATED MODULE: ./src/scripts/vue/HeaderSearchForm.vue?vue&type=template&id=356fcf02&

 // CONCATENATED MODULE: ./node_modules/throttle-debounce/esm/index.js
 /* eslint-disable no-undefined,no-param-reassign,no-shadow */

 /**
  * Throttle execution of a function. Especially useful for rate limiting
  * execution of handlers on events like resize and scroll.
  *
  * @param  {number}    delay -          A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
  * @param  {boolean}   [noTrailing] -   Optional, defaults to false. If noTrailing is true, callback will only execute every `delay` milliseconds while the
  *                                    throttled-function is being called. If noTrailing is false or unspecified, callback will be executed one final time
  *                                    after the last throttled-function call. (After the throttled-function has not been called for `delay` milliseconds,
  *                                    the internal counter is reset).
  * @param  {Function}  callback -       A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
  *                                    to `callback` when the throttled-function is executed.
  * @param  {boolean}   [debounceMode] - If `debounceMode` is true (at begin), schedule `clear` to execute after `delay` ms. If `debounceMode` is false (at end),
  *                                    schedule `callback` to execute after `delay` ms.
  *
  * @returns {Function}  A new, throttled, function.
  */
 function throttle (delay, noTrailing, callback, debounceMode) {
   /*
    * After wrapper has stopped being called, this timeout ensures that
    * `callback` is executed at the proper times in `throttle` and `end`
    * debounce modes.
    */
   var timeoutID;
   var cancelled = false; // Keep track of the last time `callback` was executed.

   var lastExec = 0; // Function to clear existing timeout

   function clearExistingTimeout() {
     if (timeoutID) {
       clearTimeout(timeoutID);
     }
   } // Function to cancel next exec


   function cancel() {
     clearExistingTimeout();
     cancelled = true;
   } // `noTrailing` defaults to falsy.


   if (typeof noTrailing !== 'boolean') {
     debounceMode = callback;
     callback = noTrailing;
     noTrailing = undefined;
   }
   /*
    * The `wrapper` function encapsulates all of the throttling / debouncing
    * functionality and when executed will limit the rate at which `callback`
    * is executed.
    */


   function wrapper() {
     for (var _len = arguments.length, arguments_ = new Array(_len), _key = 0; _key < _len; _key++) {
       arguments_[_key] = arguments[_key];
     }

     var self = this;
     var elapsed = Date.now() - lastExec;

     if (cancelled) {
       return;
     } // Execute `callback` and update the `lastExec` timestamp.


     function exec() {
       lastExec = Date.now();
       callback.apply(self, arguments_);
     }
     /*
      * If `debounceMode` is true (at begin) this is used to clear the flag
      * to allow future `callback` executions.
      */


     function clear() {
       timeoutID = undefined;
     }

     if (debounceMode && !timeoutID) {
       /*
        * Since `wrapper` is being called for the first time and
        * `debounceMode` is true (at begin), execute `callback`.
        */
       exec();
     }

     clearExistingTimeout();

     if (debounceMode === undefined && elapsed > delay) {
       /*
        * In throttle mode, if `delay` time has been exceeded, execute
        * `callback`.
        */
       exec();
     } else if (noTrailing !== true) {
       /*
        * In trailing throttle mode, since `delay` time has not been
        * exceeded, schedule `callback` to execute `delay` ms after most
        * recent execution.
        *
        * If `debounceMode` is true (at begin), schedule `clear` to execute
        * after `delay` ms.
        *
        * If `debounceMode` is false (at end), schedule `callback` to
        * execute after `delay` ms.
        */
       timeoutID = setTimeout(debounceMode ? clear : exec, debounceMode === undefined ? delay - elapsed : delay);
     }
   }

   wrapper.cancel = cancel; // Return the wrapper function.

   return wrapper;
 }

 /* eslint-disable no-undefined */
 /**
  * Debounce execution of a function. Debouncing, unlike throttling,
  * guarantees that a function is only executed a single time, either at the
  * very beginning of a series of calls, or at the very end.
  *
  * @param  {number}   delay -         A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
  * @param  {boolean}  [atBegin] -     Optional, defaults to false. If atBegin is false or unspecified, callback will only be executed `delay` milliseconds
  *                                  after the last debounced-function call. If atBegin is true, callback will be executed only at the first debounced-function call.
  *                                  (After the throttled-function has not been called for `delay` milliseconds, the internal counter is reset).
  * @param  {Function} callback -      A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
  *                                  to `callback` when the debounced-function is executed.
  *
  * @returns {Function} A new, debounced function.
  */

 function debounce (delay, atBegin, callback) {
   return callback === undefined ? throttle(delay, atBegin, false) : throttle(delay, callback, atBegin !== false);
 }


 //# sourceMappingURL=index.js.map

 // EXTERNAL MODULE: ./src/icons/icon-search.svg
 var icon_search = __webpack_require__(230);
 var icon_search_default = /*#__PURE__*/__webpack_require__.n(icon_search);

 // CONCATENATED MODULE: ./node_modules/babel-loader/lib??ref--0!./node_modules/vue-loader/lib??vue-loader-options!./src/scripts/vue/HeaderSearchForm.vue?vue&type=script&lang=js&
 function HeaderSearchFormvue_type_script_lang_js_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

 function HeaderSearchFormvue_type_script_lang_js_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { HeaderSearchFormvue_type_script_lang_js_ownKeys(Object(source), true).forEach(function (key) { HeaderSearchFormvue_type_script_lang_js_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { HeaderSearchFormvue_type_script_lang_js_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

 function HeaderSearchFormvue_type_script_lang_js_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }















 //
 //
 //
 //
 //
 //
 //
 //


 var HeaderSearchFormvue_type_script_lang_js_createNamespacedHelp = Object(vuex_esm["a" /* createNamespacedHelpers */])("header-instant-search"),
     HeaderSearchFormvue_type_script_lang_js_mapState = HeaderSearchFormvue_type_script_lang_js_createNamespacedHelp.mapState,
     HeaderSearchFormvue_type_script_lang_js_mapActions = HeaderSearchFormvue_type_script_lang_js_createNamespacedHelp.mapActions,
     HeaderSearchFormvue_type_script_lang_js_mapGetters = HeaderSearchFormvue_type_script_lang_js_createNamespacedHelp.mapGetters;





 /* harmony default export */ var HeaderSearchFormvue_type_script_lang_js_ = ({
   name: 'HeaderSearchForm',
   mixins: [mixins_sectionData],
   data: function data() {
     return {
       initialized: false,
       statusSeach: false
     };
   },
   mounted: function mounted() {
     this.initialized = true;
   },
   beforeCreate: function beforeCreate() {
     var _this = this;

     this.search = debounce(500, function (event) {
       var value = event.target.value;
       _this.statusSeach = !!value;
       return _this.getResultsByQuery({
         query: value
       });
     });
   },
   computed: HeaderSearchFormvue_type_script_lang_js_objectSpread({}, HeaderSearchFormvue_type_script_lang_js_mapGetters({
     query: instant_search["h" /* GETTER_QUERY */]
   })),
   methods: HeaderSearchFormvue_type_script_lang_js_objectSpread(HeaderSearchFormvue_type_script_lang_js_objectSpread({}, HeaderSearchFormvue_type_script_lang_js_mapActions({
     getResultsByQuery: instant_search["b" /* ACTION_GET_RESULTS_BY_QUERY */],
     openDropdown: instant_search["d" /* ACTION_OPEN_DROPDOWN */],
     closeDropdown: instant_search["a" /* ACTION_CLOSE_DROPDOWN */]
   })), {}, {
     focus: function focus() {
       this.openDropdown();
     },
     onEnter: function onEnter(event) {
       event.preventDefault();
       var params = new URLSearchParams();
       var headerSearchInput = document.querySelector('[data-header-search-input]');
       params.set("q", headerSearchInput.value);
       location.href = "/search?".concat(params.toString());
     }
   }),
   components: {
     IconSearch: icon_search_default.a
   }
 });
 // CONCATENATED MODULE: ./src/scripts/vue/HeaderSearchForm.vue?vue&type=script&lang=js&
  /* harmony default export */ var vue_HeaderSearchFormvue_type_script_lang_js_ = (HeaderSearchFormvue_type_script_lang_js_);
 // CONCATENATED MODULE: ./src/scripts/vue/HeaderSearchForm.vue





 /* normalize component */

 var HeaderSearchForm_component = Object(componentNormalizer["a" /* default */])(
   vue_HeaderSearchFormvue_type_script_lang_js_,
   HeaderSearchFormvue_type_template_id_356fcf02_render,
   HeaderSearchFormvue_type_template_id_356fcf02_staticRenderFns,
   false,
   null,
   null,
   null

 )

 HeaderSearchForm_component.options.__file = "src/scripts/vue/HeaderSearchForm.vue"
 /* harmony default export */ var HeaderSearchForm = (HeaderSearchForm_component.exports);
 // CONCATENATED MODULE: ./src/scripts/sections/header.js


 function header_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

 function header_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { header_ownKeys(Object(source), true).forEach(function (key) { header_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { header_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

 function header_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

 function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

 function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

















 var selectors = {
   hamburger: {
     menu: "[data-hamburger-menu]",
     headerBack: "[data-hamburger-menu-back]",
     menuOpen: "[data-hamburger-menu-open]",
     menuClose: "[data-hamburger-menu-close]",
     droprownMenu: "[data-hamburger-menu-id]",
     hamburgerSubmenu: ".hamburger-submenu__list.js-toggle-content"
   },
   mobile: {
     menuItem: "[data-item-menu]",
     dropdown: "[data-dropdown]",
     backMenu: "[data-back-menu]"
   },
   header: {
     search: "[data-header-search]",
     searchOpen: "[data-header-search-open]",
     searchClose: "[data-header-search-close]",
     pinned: "[data-pinned-header]"
   },
   cart: {
     open: "[data-header-cart-open]",
     itemCount: "[data-cart-items-count]"
   },
   search: {
     form: "#header-instant-form",
     result: "#header-instant-result"
   },
   announcement: {
     announcementBar: "[data-announcement-bar]"
   },
   sections: {
     container: "#MainContent",
     collectionBanner: "__collection_banner"
   }
 };
 var modifiers = {
   hamburger: {
     dropdown: {
       open: "hamburger-menu--dropdown-open"
     },
     open: "hamburger-menu--open"
   },
   header: {
     pinned: "pinned",
     open: "js-open-header-search",
     sticky: "custom-sticky"
   }
 };
 Object(theme_sections["b" /* register */])("header", {
   sectionData: {},
   onLoad: function onLoad() {
     this.init();
   },
   init: function init() {
     var _this = this;

     this.body = document.querySelector("body");
     this.initHamburgerMenu();

     if (this.container.dataset.pinnedHeader === "true") {
       this.initPinnedHeader();
     }

     this.initHeaderSearch();

     if (location.pathname.indexOf("/collections/") !== -1) {
       this.initCheckections();
     }
     /** Init Cart */


     document.addEventListener("cart:item_count", function (e) {
       var _e$detail, _e$detail2;

       var itemCount = (e === null || e === void 0 ? void 0 : (_e$detail = e.detail) === null || _e$detail === void 0 ? void 0 : _e$detail.item_count) !== 0 ? e === null || e === void 0 ? void 0 : (_e$detail2 = e.detail) === null || _e$detail2 === void 0 ? void 0 : _e$detail2.item_count : "";
       _this.container.querySelectorAll(selectors.cart.itemCount).forEach(x => {
          x.textContent = itemCount;
        })
     });
   },
   initHamburgerMenu: function initHamburgerMenu() {
     var _this2 = this;

     this.container.addEventListener("click", function (e) {
       var element = e.target;

       if (element.closest(selectors.hamburger.menuOpen)) {
         _this2.container.querySelector(selectors.hamburger.menu).classList.add(modifiers.hamburger.open);

         document.querySelector("body").classList.add("no-scroll");
         return true;
       }

       if (element.closest(selectors.hamburger.menuClose)) {
         _this2.container.querySelector(selectors.hamburger.menu).classList.remove(modifiers.hamburger.open);

         var hamburgerMobileMenu = _this2.container.querySelectorAll(selectors.hamburger.droprownMenu);

         hamburgerMobileMenu.forEach(function (itemMobileMenu) {
           itemMobileMenu.classList.remove(modifiers.hamburger.open);
         });
         document.querySelector("body").classList.remove("no-scroll");
         return true;
       }

       if (element.closest(selectors.mobile.dropdown)) {
         element = element.closest(selectors.mobile.dropdown);

         _this2.container.querySelector("[data-hamburger-menu-id='" + element.dataset.dropdown + "']").classList.add(modifiers.hamburger.open);

         return true;
       }

       if (element.closest(selectors.mobile.backMenu)) {
         element = element.closest(selectors.mobile.backMenu);

         _this2.container.querySelector("[data-hamburger-menu-id='" + element.dataset.backMenu + "']").classList.remove(modifiers.hamburger.open);

         return true;
       }
     });
   },
   initPinnedHeader: function initPinnedHeader() {
     var _announcementBar$offs,
         _this3 = this;

     var announcementBar = document.querySelector(selectors.announcement.announcementBar);
     if (!this.container.dataset.pinnedHeader) return;
     var header = this.container;
     var announcementBarHeight = (_announcementBar$offs = announcementBar === null || announcementBar === void 0 ? void 0 : announcementBar.offsetHeight) !== null && _announcementBar$offs !== void 0 ? _announcementBar$offs : 0;

     var setHeaderHeight = function setHeaderHeight() {
       var height = header.offsetHeight;

       if (window.pageYOffset === 0) {
         height += announcementBarHeight;
       }

       document.documentElement.style.setProperty("--header-height", "".concat(height, "px"));
       var hamburgerSubmenuBoxs = document.querySelectorAll(selectors.hamburger.hamburgerSubmenu);

       if (window.innerWidth >= 992) {
         hamburgerSubmenuBoxs.forEach(function (hamburgerSubmenuBox) {
           hamburgerSubmenuBox.style.removeProperty("display");
         });
       } else {
         hamburgerSubmenuBoxs.forEach(function (hamburgerSubmenuBox) {
           hamburgerSubmenuBox.style.setProperty("display", "none");
         });
       }
     };

     var animation = false;
     setHeaderHeight();
     window.onresize = setHeaderHeight; // eslint-disable-next-line no-unused-vars

     var last_scroll = 0;
     header.style.top = "var(--headerTop)";
     window.addEventListener("scroll", function () {
       if (window.pageYOffset > announcementBarHeight + header.offsetHeight) {
         if ((last_scroll > window.pageYOffset || document.getElementById("header__container").classList.contains("has-subscribe-button")) && !header.classList.contains(modifiers.header.pinned)) {
           header.classList.add(modifiers.header.pinned);
           document.body.classList.add(modifiers.header.sticky);

           if (!animation) {
             _this3.body.style.setProperty("--headerTop", "0px" // header.offsetHeight * -1 + "px"
             );

             var animationHeaderTop = setInterval(function () {
               if (_this3.body.style.getPropertyValue("--headerTop") === "0px") {
                 animation = false;
                 clearInterval(animationHeaderTop);
                 return;
               }

               _this3.body.style.setProperty("--headerTop", parseInt(_this3.body.style.getPropertyValue("--headerTop")) + 2 + "px");
             }, 2);
           }

           animation = true;
         } else {
           if (header.classList.contains(modifiers.header.pinned) && last_scroll < window.pageYOffset && !document.getElementById("header__container").classList.contains("has-subscribe-button") && !header.contains(document.querySelector('.active_link'))) {
             if (!animation) {
               _this3.body.style.setProperty("--headerTop", "0px");

               var _animationHeaderTop = setInterval(function () {
                 if (_this3.body.style.getPropertyValue("--headerTop") === header.offsetHeight * -1 + "px") {
                   header.classList.remove(modifiers.header.pinned);
                   document.body.classList.remove(modifiers.header.sticky);
                   animation = false;
                   clearInterval(_animationHeaderTop);
                   return;
                 }

                 _this3.body.style.setProperty("--headerTop", parseInt(_this3.body.style.getPropertyValue("--headerTop")) - 10 + "px");
               }, 1);
             }

             animation = true;
           }
         }

         header.style.height = "80px";
       } else {
         header.style.height = "";
         header.classList.remove(modifiers.header.pinned);
         document.body.classList.remove(modifiers.header.sticky);
         animation = false;
       }

       setHeaderHeight();
       last_scroll = window.pageYOffset;
     });
   },
   initHeaderSearch: function () {
     var _initHeaderSearch = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
       var _this4 = this;

       var sectionData, searchForm, searchResult;
       return regeneratorRuntime.wrap(function _callee$(_context) {
         while (1) {
           switch (_context.prev = _context.next) {
             case 0:
               this.container.addEventListener("click", function (e) {
                 var element = e.target;

                 if (element.closest(selectors.header.searchOpen)) {
                   _this4.container.querySelector(selectors.header.search).classList.add(modifiers.header.open);

                   document.querySelector("body").classList.add("no-scroll");
                   document.querySelector("body").classList.add("modal-search");

                   _this4.container.querySelector('[data-header-search-input]').focus();
                   document.querySelector("predictive-search .search__input").focus();

                   return true;
                 }

                 if (element.closest(selectors.header.searchClose)) {
                   _this4.container.querySelector(selectors.header.search).classList.remove(modifiers.header.open);

                   document.querySelector("body").classList.remove("no-scroll");
                   document.querySelector("body").classList.remove("modal-search");
                   return true;
                 }
               });
               /** init vue component */

               _context.next = 3;
               return store["a" /* store */].dispatch("header-instant-search/".concat(instant_search["c" /* ACTION_INIT_INSTANT_SEARCH */]));

             case 3:
               sectionData = this.sectionData;
               searchForm = this.container.querySelector(selectors.search.form);

               if (searchForm) {
                 _context.next = 7;
                 break;
               }

               return _context.abrupt("return");

             case 7:
               new vue_runtime_esm["a" /* default */]({
                 store: store["a" /* store */],
                 data: function data() {
                   return header_objectSpread({}, sectionData);
                 },
                 render: function render(h) {
                   return h(HeaderSearchForm);
                 }
               }).$mount(searchForm);
               searchResult = this.container.querySelector(selectors.search.result);

               if (searchResult) {
                 _context.next = 11;
                 break;
               }

               return _context.abrupt("return");

             case 11:
               new vue_runtime_esm["a" /* default */]({
                 store: store["a" /* store */],
                 data: function data() {
                   return header_objectSpread({}, sectionData);
                 },
                 render: function render(h) {
                   return h(HeaderSearchResult);
                 }
               }).$mount(searchResult);

             case 12:
             case "end":
               return _context.stop();
           }
         }
       }, _callee, this);
     }));

     function initHeaderSearch() {
       return _initHeaderSearch.apply(this, arguments);
     }

     return initHeaderSearch;
   }(),
   initCheckections: function initCheckections() {
     if (document.body.classList.contains("template-404")) {
       return;
     }

     this.sectionContainer = document.querySelector(selectors.sections.container);
     var originalTitle = document.querySelector('[name="original_title"]');
     var bannerDefaultHtml = "<section class=\"collection-banner\">\n    <div class=\"global-banner\" style=\"--overlay-color: #000000;\n        --overlay-opacity: 0.3;\n        --text-color: #ffffff;\n        --desktop-vertical-pos: center;\n        --desktop-horizontal-pos: center;\n        --desktop-text-align: center;\n        --mobile-vertical-pos: center;\n        --mobile-horizontal-pos: center;\n        --mobile-text-align: center;\">\n        <div class=\"global-banner__overlay\"></div>\n        <div data-banner-content=\"\" class=\"global-banner__content\">\n            <div class=\"global-banner__title\">".concat(originalTitle === null || originalTitle === void 0 ? void 0 : originalTitle.content, "</div>\n            <div class=\"global-banner__buttons\">\n                <button class=\"button button--primary button--white collection-banner__filters-button js-filter-banner\">\n                    <svg width=\"14\" height=\"12\" viewBox=\"0 0 14 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" class=\"icon icon-filters\"><circle cx=\"11.5\" cy=\"2.5\" r=\"2\" stroke=\"currentColor\"></circle><circle cx=\"2.5\" cy=\"9.5\" r=\"2\" stroke=\"currentColor\"></circle><path fill=\"currentColor\" d=\"M0 2h10v1H0zm4 7h10v1H4z\"></path></svg>\n                    <span>Filter<span class=\"js-boost-filters-count\"></span></span>\n                </button>\n            </div>\n        </div>\n    </div>\n</section>");
     var oneSection = this.sectionContainer.querySelector(".shopify-section");

     if (oneSection.id.indexOf(selectors.sections.collectionBanner) === -1) {
       this.initPinnedHeader();
       this.container.style.setProperty("--pinned_color_background", "#fff");
       this.container.style.setProperty("--pinned_color", "#000");
       this.container.style.setProperty("--default_color_background", "#fff");
       this.container.style.setProperty("--default_color", "#000");
       this.container.style.setProperty("--hover_color_background", "#fff");
       this.container.style.setProperty("--hover_color", "#000");
       oneSection.insertAdjacentHTML("beforebegin", bannerDefaultHtml);
     }
   }
 });
 var searchIcon = document.querySelector(".js-header__side-item-search");

 if (searchIcon) {
   searchIcon.addEventListener("click", searchFocus);
 }

 function searchFocus() {
   var inputSearch = document.querySelector(".js-header-search__panel form input");

   if (inputSearch) {
     inputSearch.focus();
   }
 }

 /***/ }),
 /* 240 */,
 /* 241 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";
 __webpack_require__.r(__webpack_exports__);
 /* harmony import */ var regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(16);
 /* harmony import */ var regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3);
 /* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1__);
 /* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8);
 /* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_2__);
 /* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63);
 /* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_3__);
 /* harmony import */ var core_js_modules_es_regexp_constructor_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(113);
 /* harmony import */ var core_js_modules_es_regexp_constructor_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_constructor_js__WEBPACK_IMPORTED_MODULE_4__);
 /* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21);
 /* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_5__);
 /* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(72);
 /* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_6__);
 /* harmony import */ var core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(39);
 /* harmony import */ var core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_7__);
 /* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(73);
 /* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_8__);
 /* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(27);
 /* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_9__);
 /* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(14);
 /* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_10__);
 /* harmony import */ var _vue_store__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(20);
 /* harmony import */ var _vue_store_cart_cart__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(15);












 function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

 function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }



 var area = document.querySelector(".js-egift-card-form-textarea");
 var message = document.querySelector(".js-egift-card-message");
 var maxLength = 120;
 if (area && message) var checkLength = function checkLength() {
   if (area.value.length >= maxLength) {
     message.innerHTML = "the character exceeds 120 characters";
   }
 };
 setInterval(checkLength, 300);

 var changeImage = function changeImage() {
   var containerImages = document.querySelector(".egift-card__design-images");
   var previewImages = document.querySelector(".egift-card__form-image");
   containerImages === null || containerImages === void 0 ? void 0 : containerImages.addEventListener("change", function (e) {
     previewImages.src = e.target.dataset.imagePreview;
   });
 };

 changeImage();
 var selectors = {
   buttonAdd: "[data-button-add]"
 };
 var modifiers = {
   error: "egift-card__form-input--error"
 };
 window.addEventListener("gift.hero:initalized", function () {
   var _window = window,
       GiftHeroAPI = _window.GiftHeroAPI;
   var buttonAdd = document.querySelector(selectors.buttonAdd);
   buttonAdd.addEventListener("click", /*#__PURE__*/function () {
     var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(e) {
       var regex, errorStatus, date, inputs, dataToName;
       return regeneratorRuntime.wrap(function _callee$(_context) {
         while (1) {
           switch (_context.prev = _context.next) {
             case 0:
               e.preventDefault();
               regex = null;
               errorStatus = false;
               date = null;
               inputs = document.querySelectorAll('textarea, select, input[type="text"], input[type="datetime-local"], input[type="radio"]:checked'); // eslint-disable-next-line no-unused-vars

               dataToName = "|To: ";
               inputs.forEach(function (input) {
                 input.classList.remove(modifiers.error);

                 switch (input.name) {
                   case "properties[_image]":
                     GiftHeroAPI.setImage(input.value);
                     break;

                   case "properties[_to]":
                     {
                       if (input.value.length) {
                         dataToName += input.value;
                       } else {
                         input.classList.add(modifiers.error);
                         errorStatus = true;
                       }

                       break;
                     }

                   case "properties[_from]":
                     if (input.value.length) {
                       GiftHeroAPI.setFrom(input.value + dataToName);
                     } else {
                       input.classList.add(modifiers.error);
                       errorStatus = true;
                     }

                     break;

                   case "properties[email]":
                     regex = new RegExp(input.dataset.rule);

                     if (input.value.length && regex.test(input.value)) {
                       GiftHeroAPI.setEmail(input.value);
                     } else {
                       input.classList.add(modifiers.error);
                       errorStatus = true;
                     }

                     break;

                   case "properties[confirm_email]":
                     regex = new RegExp(input.dataset.rule); // eslint-disable-next-line no-case-declarations

                     var inputEmail = Array.from(inputs).find(function (input) {
                       return input.name === "properties[email]";
                     });

                     if (!input.value.length || !regex.test(event.target.value) || inputEmail.value !== input.value) {
                       input.classList.add(modifiers.error);
                       errorStatus = true;
                     }

                     break;

                   case "properties[_message]":
                     if (input.value.length < 120) {
                       if (input.value.length === 0) GiftHeroAPI.setMessage("none");else GiftHeroAPI.setMessage(input.value);
                     } else {
                       input.classList.add(modifiers.error);
                       errorStatus = true;
                     }

                     break;

                   case "id":
                     GiftHeroAPI.setVariant(input.value);
                     break;

                   case "properties[_delivery_date]":
                     date = new Date(input.value);

                     if (date == "Invalid Date") {
                       console.log("invalid");
                       input.classList.add(modifiers.error);
                       errorStatus = true;
                     } else {
                       console.log(date, "no invalid");
                       GiftHeroAPI.setDeliveryDate(date);
                     }

                     break;
                 }
               });
               console.log(GiftHeroAPI.validate());

               if (!(GiftHeroAPI.validate().valid && !errorStatus)) {
                 _context.next = 13;
                 break;
               }

               _context.next = 11;
               return GiftHeroAPI.addToCart(1);

             case 11:
               _context.next = 13;
               return updateMinicart();

             case 13:
             case "end":
               return _context.stop();
           }
         }
       }, _callee);
     }));

     return function (_x) {
       return _ref.apply(this, arguments);
     };
   }());

   var updateMinicart = /*#__PURE__*/function () {
     var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
       return regeneratorRuntime.wrap(function _callee2$(_context2) {
         while (1) {
           switch (_context2.prev = _context2.next) {
             case 0:
               _context2.next = 2;
               return _vue_store__WEBPACK_IMPORTED_MODULE_11__[/* store */ "a"].dispatch("cart/".concat(_vue_store_cart_cart__WEBPACK_IMPORTED_MODULE_12__[/* ACTION_GET_CART */ "c"]));

             case 2:
               document.dispatchEvent(new CustomEvent("minicart:open"));

             case 3:
             case "end":
               return _context2.stop();
           }
         }
       }, _callee2);
     }));

     return function updateMinicart() {
       return _ref2.apply(this, arguments);
     };
   }();
 });

 /***/ }),
 /* 242 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";
 __webpack_require__.r(__webpack_exports__);
 /* harmony import */ var regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(16);
 /* harmony import */ var regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3);
 /* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1__);
 /* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8);
 /* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_2__);
 /* harmony import */ var core_js_modules_es_regexp_constructor_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(113);
 /* harmony import */ var core_js_modules_es_regexp_constructor_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_constructor_js__WEBPACK_IMPORTED_MODULE_3__);
 /* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21);
 /* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_4__);
 /* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(72);
 /* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_5__);
 /* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(31);
 /* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_6__);
 /* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(27);
 /* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_7__);
 /* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(41);
 /* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_8__);
 /* harmony import */ var core_js_modules_web_url_search_params_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(146);
 /* harmony import */ var core_js_modules_web_url_search_params_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_url_search_params_js__WEBPACK_IMPORTED_MODULE_9__);
 /* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(14);
 /* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_10__);
 /* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(54);
 /* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_11__);
 /* harmony import */ var core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(39);
 /* harmony import */ var core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_12__);
 /* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(0);
 /* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_13__);


 function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

 function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }















 window.theme.customerRegistration = function () {
   var verificationInputs = document.querySelectorAll("[data-verification]");
   verificationInputs.forEach(function (verificationInput) {
     verificationInput.addEventListener("keyup", function (event) {
       var error = false;
       var rule = event.target.dataset.rule;

       if (rule && event.target.value.length) {
         var regex = new RegExp(rule);

         if (!regex.test(event.target.value)) {
           error = true;
           event.target.classList.add("verification-error");
         } else {
           event.target.classList.remove("verification-error");
         }
       } else {
         event.target.classList.remove("verification-error");
       }

       if (event.target.dataset.verificationType) {
         var verificationInputMain = document.querySelector("[data-verification=\"".concat(event.target.dataset.verification, "\"]:not([data-verification-type])"));

         if (event.target.value != verificationInputMain.value) {
           error = true;
           event.target.classList.add("verification-error");
         } else {
           if (!error) event.target.classList.remove("verification-error");
         }

         return;
       }

       var verificationInputConfirm = document.querySelector("[data-verification=\"".concat(event.target.dataset.verification, "\"][data-verification-type]"));
       if (!verificationInputConfirm.value.length) return;

       if (event.target.value != verificationInputConfirm.value) {
         verificationInputConfirm.classList.add("verification-error");
       } else {
         verificationInputConfirm.classList.remove("verification-error");
       }
     });
   });
   var buttonRegister = document.querySelector(".account-register__button");
   buttonRegister === null || buttonRegister === void 0 ? void 0 : buttonRegister.addEventListener("click", /*#__PURE__*/function () {
     var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(event) {
       var form, data;
       return regeneratorRuntime.wrap(function _callee$(_context) {
         while (1) {
           switch (_context.prev = _context.next) {
             case 0:
               event.preventDefault();
               form = document.querySelector("#create_customer");

               if (!checkRequiredInputs()) {
                 _context.next = 3;
                 break;
               }

               return _context.abrupt("return", null);

             case 3:
               form = document.querySelector("#create_customer");

               //if (!(form !== null && form !== void 0 && form.querySelector("[name=\"customer[subscription]\"]").checked && document.querySelector("[name=\"klaviyo_subscription_list_id\"]"))) {
                if (!(form !== null && form !== void 0  && document.querySelector("[name=\"klaviyo_subscription_list_id\"]"))) {
               _context.next = 13;
                 break;
               }

              //  data = new URLSearchParams();
              //  data.append("email", form.querySelector("[name=\"customer[email]\"]").value);
              //  data.append("first_name", form.querySelector("[name=\"customer[first_name]\"]").value);
              //  data.append("last_name", form.querySelector("[name=\"customer[last_name]\"]").value);
              //  data.append("$fields", "email, first_name, last_name");
              //  data.append("g", document.querySelector("[name=\"klaviyo_subscription_list_id\"]").value);
              //  _context.next = 13;
              //  return fetch("https://manage.kmail-lists.com/ajax/subscriptions/subscribe", {
              //    method: "POST",
              //    headers: {
              //      "Content-Type": "application/x-www-form-urlencoded",
              //      "Cache-Control": "no-cache"
              //    },
              //    body: data
              //  });

             case 13:
               // document.querySelector("#create_customer").submit();
              createAccount(jquery__WEBPACK_IMPORTED_MODULE_13___default()('[name="customer[first_name]"]').val(), jquery__WEBPACK_IMPORTED_MODULE_13___default()('[name="customer[last_name]"]').val(), jquery__WEBPACK_IMPORTED_MODULE_13___default()('[name="customer[email]"]').val(), jquery__WEBPACK_IMPORTED_MODULE_13___default()('[name="customer[password]"]').val());
              document.querySelector("#create_customer").submit();
              //location.href = "/account/register?view=finish";
             case 14:
             case "end":
               return _context.stop();
           }
         }
       }, _callee);
     }));

     return function (_x) {
       return _ref.apply(this, arguments);
     };
   }());
 }();

 function createAccount(firstName, lastName, email, password) {
   var escapedData = {
     firstName: escape(firstName),
     lastName: escape(lastName),
     email: escape(email),
     password: escape(password).replace(/\+/g, "%2B")
   };
   var data = "form_type=create_customer&utf8=%E2%9C%93&customer%5Bfirst_name%5D=";
   data += escapedData.firstName;
   data += "&customer%5Blast_name%5D=";
   data += escapedData.lastName;
   data += "&customer%5Bemail%5D=";
   data += escapedData.email;
   data += "&customer%5Bpassword%5D=";
   data += escapedData.password;
   jquery__WEBPACK_IMPORTED_MODULE_13___default.a.post("/account", data).done(function (response) {
     var logErrors = jquery__WEBPACK_IMPORTED_MODULE_13___default()(response).find(".errors").text();

     if (logErrors !== "" && logErrors !== "undefined") {
       jquery__WEBPACK_IMPORTED_MODULE_13___default()('[name="utf8"]').after("<div class=\"errors\">".concat(jquery__WEBPACK_IMPORTED_MODULE_13___default()(response).find(".errors").html(), "</div>"));
     } else {
       jquery__WEBPACK_IMPORTED_MODULE_13___default()(".account-register form").submit();
       //location.href = "/account/register?view=finish";
     }
   }).fail(function () {
     alert("error could not submit");
   });
   return false;
 }

 function checkRequiredInputs() {
   var $thisForm = document.querySelector(".account-register");
   var inputs = $thisForm.querySelectorAll("[required]");
   var error = false;
   inputs.forEach(function (input) {
     if (!input.value.length) {
       error = true;
       input.classList.add("verification-error");
     } else {
       input.classList.remove("verification-error");
     }
   });
   return error;
 }

 /***/ }),
 /* 243 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";
 __webpack_require__.r(__webpack_exports__);
 /* harmony import */ var core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39);
 /* harmony import */ var core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3);
 /* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1__);
 /* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(0);
 /* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_2__);




 window.theme.customerPasswordReset = function () {
   var config = {
     modal: "[data-password-reset]",
     open: "[data-password-reset-open]",
     close: "[data-password-reset-close]",
     openModal: "account-password-reset--open"
   };
   var passwordReset = jquery__WEBPACK_IMPORTED_MODULE_2___default()(config.modal);
   if (!passwordReset.length) return;
   jquery__WEBPACK_IMPORTED_MODULE_2___default()(config.close).on("click", closePasswordReset);
   jquery__WEBPACK_IMPORTED_MODULE_2___default()(config.open).on("click", openPasswordReset);
   if (window.location.pathname === '/account/login' && window.location.hash === '#recover') openPasswordReset();

   function closePasswordReset() {
     jquery__WEBPACK_IMPORTED_MODULE_2___default()("body").css({
       overflow: ""
     });
     passwordReset.removeClass(config.openModal);
   }

   function openPasswordReset() {
     jquery__WEBPACK_IMPORTED_MODULE_2___default()("body").css({
       overflow: "hidden"
     });

     if (!passwordReset.find(".account-password-reset__input").val().length) {
       passwordReset.find(".account-password-reset__input").val(jquery__WEBPACK_IMPORTED_MODULE_2___default()('[name="customer[email]"]').val());
     }

     passwordReset.addClass(config.openModal);
   }
 }();

 /***/ }),
 /* 244 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";
 __webpack_require__.r(__webpack_exports__);
 /* harmony import */ var core_js_modules_es_regexp_constructor_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(113);
 /* harmony import */ var core_js_modules_es_regexp_constructor_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_constructor_js__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21);
 /* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_1__);
 /* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72);
 /* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_2__);
 /* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(0);
 /* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_3__);




 /**
  * Password Template Script
  * ------------------------------------------------------------------------------
  * A file that contains scripts highly couple code to the Password template.
  *
  * @namespace password
  */

 window.theme.customerLogin = function () {
   jquery__WEBPACK_IMPORTED_MODULE_3___default()(".account-login__input").keyup(function () {
     if (!jquery__WEBPACK_IMPORTED_MODULE_3___default()(this).val().length) {
       jquery__WEBPACK_IMPORTED_MODULE_3___default()(this).addClass("verification-error");
       return false;
     }

     var rule = jquery__WEBPACK_IMPORTED_MODULE_3___default()(this).data("rule");

     if (rule) {
       var regex = new RegExp(rule);

       if (!regex.test(jquery__WEBPACK_IMPORTED_MODULE_3___default()(this).val())) {
         jquery__WEBPACK_IMPORTED_MODULE_3___default()(this).addClass("verification-error");
         return false;
       }
     }

     jquery__WEBPACK_IMPORTED_MODULE_3___default()(this).removeClass("verification-error");
   });
   jquery__WEBPACK_IMPORTED_MODULE_3___default()(".account-login").on("click", ".account-login__button", function (e) {
     e.preventDefault();
     var error = false;
     jquery__WEBPACK_IMPORTED_MODULE_3___default()(".account-login input").each(function (key, input) {
       var inputType = jquery__WEBPACK_IMPORTED_MODULE_3___default()(input).attr("type");
       if (inputType === "submit" || inputType === "hidden") return;

       if (!jquery__WEBPACK_IMPORTED_MODULE_3___default()(input).val().length) {
         error = true;
         jquery__WEBPACK_IMPORTED_MODULE_3___default()(input).addClass("verification-error");
       }

       var rule = jquery__WEBPACK_IMPORTED_MODULE_3___default()(input).data("rule");

       if (rule) {
         var regex = new RegExp(rule);

         if (!regex.test(jquery__WEBPACK_IMPORTED_MODULE_3___default()(input).val())) {
           jquery__WEBPACK_IMPORTED_MODULE_3___default()(this).addClass("verification-error");
           error = true;
         }
       }
     });
     if (error) return null;
     jquery__WEBPACK_IMPORTED_MODULE_3___default()(".account-login input").removeClass("verification-error");
     jquery__WEBPACK_IMPORTED_MODULE_3___default()(".account-login form").submit();
   });
   var config = {
     recoverPasswordForm: "#RecoverPassword",
     hideRecoverPasswordLink: "#HideRecoverPasswordLink"
   };

   if (!jquery__WEBPACK_IMPORTED_MODULE_3___default()(config.recoverPasswordForm).length) {
     return;
   }

   checkUrlHash();
   resetPasswordSuccess();
   jquery__WEBPACK_IMPORTED_MODULE_3___default()(config.recoverPasswordForm).on("click", onShowHidePasswordForm);
   jquery__WEBPACK_IMPORTED_MODULE_3___default()(config.hideRecoverPasswordLink).on("click", onShowHidePasswordForm);

   function onShowHidePasswordForm(evt) {
     evt.preventDefault();
     toggleRecoverPasswordForm();
   }

   function checkUrlHash() {
     var hash = window.location.hash; // Allow deep linking to recover password form

     if (hash === "#recover") {
       toggleRecoverPasswordForm();
     }
   }
   /**
    *  Show/Hide recover password form
    */


   function toggleRecoverPasswordForm() {
     jquery__WEBPACK_IMPORTED_MODULE_3___default()("#RecoverPasswordForm").toggleClass("hide");
     jquery__WEBPACK_IMPORTED_MODULE_3___default()("#CustomerLoginForm").toggleClass("hide");
   }
   /**
    *  Show reset password success message
    */


   function resetPasswordSuccess() {
     var $formState = jquery__WEBPACK_IMPORTED_MODULE_3___default()(".reset-password-success"); // check if reset password form was successfully submited.

     if (!$formState.length) {
       return;
     } // show success message


     jquery__WEBPACK_IMPORTED_MODULE_3___default()("#ResetSuccess").removeClass("hide");
   }
 }();

 /***/ }),
 /* 245 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";
 __webpack_require__.r(__webpack_exports__);
 /* harmony import */ var core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39);
 /* harmony import */ var core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3);
 /* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1__);
 /* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(0);
 /* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_2__);



 /**
  * Customer Addresses Script
  * ------------------------------------------------------------------------------
  * A file that contains scripts highly couple code to the Customer Addresses
  * template.
  *
  * @namespace customerAddresses
  */

 window.theme.customerAddresses = function () {
   var $newAddressForm = jquery__WEBPACK_IMPORTED_MODULE_2___default()("#AddressNewForm");

   if (!$newAddressForm.length) {
     return;
   } // Initialize observers on address selectors, defined in shopify_common.js


   if (window.Shopify) {
     new window.Shopify.CountryProvinceSelector("AddressCountryNew", "AddressProvinceNew", {
       hideElement: "AddressProvinceContainerNew"
     });
   } // Initialize each edit form's country/province selector


   jquery__WEBPACK_IMPORTED_MODULE_2___default()(".address-country-option").each(function () {
     var formId = jquery__WEBPACK_IMPORTED_MODULE_2___default()(this).data("form-id");
     var countrySelector = "AddressCountry_" + formId;
     var provinceSelector = "AddressProvince_" + formId;
     var containerSelector = "AddressProvinceContainer_" + formId;
     new window.Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
       hideElement: containerSelector
     });
   }); // Toggle new/edit address forms

   jquery__WEBPACK_IMPORTED_MODULE_2___default()(".address-new-toggle").on("click", function () {
     $newAddressForm.toggleClass("hide");
   });
   jquery__WEBPACK_IMPORTED_MODULE_2___default()(".address-edit-toggle").on("click", function () {
     var formId = jquery__WEBPACK_IMPORTED_MODULE_2___default()(this).data("form-id");
     jquery__WEBPACK_IMPORTED_MODULE_2___default()("#EditAddress_" + formId).toggleClass("hide");
   });
   jquery__WEBPACK_IMPORTED_MODULE_2___default()(".address-delete").on("click", function () {
     var $el = jquery__WEBPACK_IMPORTED_MODULE_2___default()(this);
     var formId = $el.data("form-id");
     var confirmMessage = $el.data("confirm-message");

     if (confirm(confirmMessage || "Are you sure you wish to delete this address?")) {
       window.Shopify.postLink("/account/addresses/" + formId, {
         parameters: {
           _method: "delete"
         }
       });
     }
   });
   var $AddressForm = jquery__WEBPACK_IMPORTED_MODULE_2___default()(".address-form__container");
   $AddressForm.on("click", ".address-form__save", function (e) {
     e.preventDefault();
     var $thisForm = jquery__WEBPACK_IMPORTED_MODULE_2___default()(e.target).closest(".address-form__container");
     var inputs = $thisForm.find("[required]:visible");
     var error = false;
     inputs.each(function (key, input) {
       if (!jquery__WEBPACK_IMPORTED_MODULE_2___default()(input).val().length) {
         error = true;
         jquery__WEBPACK_IMPORTED_MODULE_2___default()(input).addClass("verification-error");
       } else {
         jquery__WEBPACK_IMPORTED_MODULE_2___default()(input).removeClass("verification-error");
       }
     });
     if (error) return false;
     $thisForm.find("form").submit();
   });
 }();

 /***/ }),
 /* 246 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";
 __webpack_require__.r(__webpack_exports__);
 /* harmony import */ var regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(16);
 /* harmony import */ var regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3);
 /* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1__);
 /* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8);
 /* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_2__);
 /* harmony import */ var core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39);
 /* harmony import */ var core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_3__);
 /* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50);
 /* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_4__);
 /* harmony import */ var core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82);
 /* harmony import */ var core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_5__);
 /* harmony import */ var core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(81);
 /* harmony import */ var core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_6__);
 /* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(63);
 /* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_7__);
 /* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(21);
 /* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_8__);
 /* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(54);
 /* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_9__);
 /* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(14);
 /* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_10__);
 /* harmony import */ var _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(1);


 function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

 function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }












 var selectors = {
   inputForm: "[data-input-form]",
   finishForm: '[name="next_step_finish"]',
   selects: {
     container: "[data-selects]",
     input: "[data-input]",
     value: "[data-input-value]",
     list: "[data-list]",
     item: "[data-item]",
     close: "[data-close]",
     text: "[data-category-text]",
     value_customer_group: "[data-input-value-customer]",
   },
   country: {
     array: "[data-country-array]",
     input: "[data-country]",
     stateContainer: "[data-state-container]",
     stateValue: "[data-state-value]",
     stateList: "[data-state-list]"
   },
   buttonSend: "[data-button-send]"
 };
 var modifiers = {
   select: {
     open: "proprogram-form__category--open",
     itemActive: "proprogram-form__category-item--active"
   }
 };
 Object(_shopify_theme_sections__WEBPACK_IMPORTED_MODULE_11__[/* register */ "b"])("proprogram-form", {
   customerSaveOptions: undefined,
   prevStepForm: "/pages/proprogram-login",
   nextStepForm: "/pages/proprogram-form-2",
   onLoad: function onLoad() {
     this.checkUser();
     this.init();
   },
   checkUser: function checkUser() {
     var customer = window.CF.customer.data;
     if (!customer.id) location.href = this.prevStepForm;
   },
   init: function init() {
     var _this$container$query;

     this.finishForm = this.container.querySelector(selectors.finishForm);
     this.customerSaveOptions = {
       login: true,
       redirect: true,
       redirectUrl: this.finishForm ? this.finishForm.value : this.nextStepForm,
       formId: (_this$container$query = this.container.querySelector(selectors.inputForm)) === null || _this$container$query === void 0 ? void 0 : _this$container$query.value
     };
     this.buttonSendForm = this.container.querySelector(selectors.buttonSend);
     this.countryInput = this.container.querySelector(selectors.country.input);
     this.countryArray = this.container.querySelector(selectors.country.array) ? JSON.parse(this.container.querySelector(selectors.country.array).innerText) : null;
     this.stateContainer = this.container.querySelector(selectors.country.stateContainer);
     this.initSelects();
     this.updateState();
     this.initSendForm();
   },
   initSelects: function initSelects() {
     var _this = this;

     var selects = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
     if (!selects.length) this.selects = this.container.querySelectorAll(selectors.selects.container);else this.selects = selects;
     this.selects.forEach(function (select) {
       var selectInput = select.querySelector(selectors.selects.input);
       var selectInputValue = select.querySelector(selectors.selects.value);
       var selectInputValueCustomer = select.querySelector(selectors.selects.value_customer_group);

        if(window.CF.customer.data.tags){
          var category_tag_customer = window.CF.customer.data.tags.find(function (tag) {
            return tag.indexOf("cg-") != -1;
          });

        }

        if (select.classList.contains('pro_category')) {
          let Category_selected = localStorage.getItem('Category_Pro_Program');
          let Customer_group= localStorage.getItem('Customer_Group_Pro_Program');
          


          if (Category_selected == "undefined") {
            Category_selected = category_tag_customer;
          }
          //console.log("Category_selected", Category_selected);
          var select_value_form = select.querySelectorAll('.proprogram-form__category-item')
          //console.log("select_value_form", select_value_form)
          select_value_form.forEach(function(item_selected){
            //console.log("here item selected:", item_selected.dataset)
            if (item_selected.dataset.categoryName === Category_selected ){

              selectInput.innerText = item_selected.innerText;
              selectInputValue.value = item_selected.dataset.tag;
              _this.activeListItem(select, item_selected);
              if (selectInputValueCustomer){
              selectInputValueCustomer.value = item_selected.dataset.categoryName;
              }
            }

          })
        }

        if (select.classList.contains('country_select')) {

          if (window.CF.customer.data.addresses_count > 0 ){
            var country = window.CF.customer.data.default_address.country;
            var state_select = window.CF.customer.data.default_address.province;
          }
          var select_value_form = select.querySelectorAll('.proprogram-form__category-item')
          select_value_form.forEach(function(item_selected){

            if (item_selected.dataset.tag === country ){
              selectInput.innerText = item_selected.innerText;
              selectInputValue.value = item_selected.dataset.tag;
              _this.activeListItem(select, item_selected);
              _this.updateState(item_selected.dataset.tag);
            }
            if (item_selected.dataset.tag === state_select ){
              selectInput.innerText = item_selected.innerText;
              selectInputValue.value = item_selected.dataset.tag;
              _this.updateState(item_selected.dataset.tag);
              _this.activeListItem(select, item_selected);
            }

          })

        }


       select.addEventListener("click", function (e) {
         e.preventDefault();

          //console.log("here clicking select:" , e.target )
          // localStorage.setItem('Category_Pro_Program', e.target.dataset.categoryName);
          // localStorage.setItem('Customer_Group_Pro_Program', e.target.dataset.tag);

         if (e.target.closest(selectors.selects.input) || e.target.closest(selectors.selects.close)) {
           select.classList.toggle(modifiers.select.open);
         }

         if (e.target.closest(selectors.selects.item)) {
           var item = e.target;
           selectInput.innerText = item.innerText;
           selectInputValue.value = item.dataset.tag;

          //  if (selectInput.classList.contains('proprogram-form__category-input')) {
             
          //        localStorage.setItem('Category_Pro_Program', item.dataset.categoryName);
          //        localStorage.setItem('Customer_Group_Pro_Program', item.dataset.tag);
          //  }
        
           if (selectInputValueCustomer){

            selectInputValueCustomer.value = item.dataset.categoryName;
           }

           _this.activeListItem(select, item);

           select.classList.remove(modifiers.select.open);

            if (selectInputValue.closest(selectors.country.input)) {
              _this.updateState(selectInputValue.value);
            }
         }
       });
     });
   },
   activeListItem: function activeListItem(select, activeItem) {
     var listItems = select.querySelectorAll(selectors.selects.item);
     var categoriesText = this.container.querySelectorAll(selectors.selects.text);

     listItems.forEach(function (item, keyItem) {
       item.classList.remove(modifiers.select.itemActive);
       if (categoriesText.length) categoriesText[keyItem].classList.remove("proprogram-form__category-text--view");
        
       if (item === activeItem) {
         item.classList.add(modifiers.select.itemActive);
         
         if (categoriesText.length) categoriesText[keyItem].classList.add("proprogram-form__category-text--view");

        }
     });


   },
   initSendForm: function initSendForm() {
     var _this2 = this;

     this.buttonSendForm.addEventListener("click", /*#__PURE__*/function () {
       var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(e) {
         var fileIndex, fileInput, fileName, cfFileObject, hasEmptyInputFile = true ,hasEmptyInput = false; 
         return regeneratorRuntime.wrap(function _callee$(_context) {
           while (1) {
             switch (_context.prev = _context.next) {
               case 0:
                 e.preventDefault();
                 _this2.inputsForm = _this2.container.querySelectorAll('input[type="text"], textarea, input[type="radio"]:checked, input[type="hidden"], input[type="file"]');
                  // Reset any previous error styles
                  _this2.inputsForm.forEach(function (input) {
                    input.classList.remove('error');
                  });
                 _this2.inputsForm.forEach(function (input) {

                    if (input.dataset.proprogramName === "form_id") return;

                    if (input.required && input.value === "") { 
                      hasEmptyInput = true;
                      input.classList.add('error'); 
                      input.closest('.proprogram-form__group').classList.add('error');
                    } 
                    if (input.dataset.proprogramName === "tags[]") {
                      //console.log("here tags []", input.value)
                      window.CF.customer.addTag(input.value);
           
                    }
                    if(input.dataset.proprogramName === "customer_group" ){
                      // to add the customer group tag - the tag must be also in the form app.
                      var actualTag = window.CF.customer.data.tags.find(function (tag) {
                          return tag.indexOf("cg-") != -1;
                        });
                        window.CF.customer.removeTag(actualTag);
                        let Category = localStorage.getItem('Category_Pro_Program');
                        window.CF.customer.addTag(Category);
                        
                    }else if (input.dataset.proprogramName === "category" ) {
                      
                        var actualTag = window.CF.customer.data.tags.find(function (tag) {
                          return tag.indexOf("Category-") != -1;
                        });

                        
                        if(actualTag){
                          window.CF.customer.removeTag(actualTag);
                        }
                        
                        let Customer_group = localStorage.getItem('Customer_Group_Pro_Program');
                        window.CF.customer.addTag(Customer_group);
                        window.CF.customer.addTag("Patagonia Pro");
                    }else if (input.dataset.proprogramName === "file_one"  && input.value ) {
                        //window.CF.customer.addTag("Pro Program Documents Sent");

                    }
                     else {
                      window.CF.customer.set(input.dataset.proprogramName, input.value);
                    }
                 });


                 _this2.filesForm = _this2.container.querySelectorAll('input[type="file"]');

                 if (!_this2.filesForm.length) {
                   // fisrt save for form 1
                   _context.next = 16;
                   break;
                 }

                 fileIndex = 0;

               case 6:
                 if (!(fileIndex < _this2.filesForm.length)) {
                    //save data form 2
                  
                   _context.next = 16;
                     
                   break;
                 }

                 fileInput = _this2.filesForm[fileIndex].files[0];
                 fileName = _this2.filesForm[fileIndex].dataset.proprogramName;
                 _context.next = 11;
               
                 return _this2.uploadFile(fileInput);

               case 11:
            
                 cfFileObject = _context.sent;
                 window.CF.customer.set(fileName, cfFileObject);
               case 13:
                 fileIndex++;
                 _context.next = 6;
                 break;

               case 16:
                // window.CF.customer.save(_this2.customerSaveOptions).then(function (errorObj) {
                //   console.log(errorObj);
                // });
                if (!hasEmptyInput) {

                  // if (_this2.filesForm[0].files[0] != undefined){
                  //   console.log("here not empty file")
                  //   window.CF.customer.addTag("Pro Program Documents Sent");
                   
                  //  }

                  //console.log("window.CF.customer.data.file_one", window.CF.customer.data.file_one)
                  if (window.CF.customer.data.file_one){
                    // console.log("hereeee")
                   

                  }
                   //window.CF.customer.addTag("Pro Program Documents Sent");
                   window.CF.customer.addTag("Unapproved");
                   window.CF.customer.save(_this2.customerSaveOptions).then(function (errorObj) {
                  
                   console.log(errorObj);
                 });
                }

               case 17:
               case "end":
                 return _context.stop();
             }
           }
         }, _callee);
       }));

       return function (_x) {
         return _ref.apply(this, arguments);
       };
     }());
   },
   updateState: function updateState(country) {
     if (!this.stateContainer || !this.countryArray) return;
     var states = this.countryArray[country];
     var htmlStates = "";
     var category = false;

     if (states !== null && states !== void 0 && states.length) {
       var htmlProvince = "";
       states.forEach(function (state) {
         htmlProvince += "<div class=\"proprogram-form__category-item\" data-item=\"\" data-tag=\"".concat(state[0], "\">").concat(state[1], "</div>");
       });
       htmlStates = "\n\t\t\t\t\t<span class=\"proprogram-form__label\">State *</span>\n\t\t\t\t\t<div class=\"proprogram-form__category-wrapper\">\n\t\t\t\t\t\t<div class=\"proprogram-form__category\" data-selects=\"\">\n\t\t\t\t\t\t\t<input type=\"hidden\" data-input-value=\"\" data-proprogram-name=\"default_address.province\" data-state-value=\"\">\n\t\t\t\t\t\t\t<div class=\"proprogram-form__category-input\" data-input=\"\">State</div>\n\t\t\t\t\t\t\t<span class=\"proprogram-form__category-arrow\">\n\t\t\t\t\t\t\t\t<svg width=\"16\" height=\"11\" viewBox=\"0 0 16 11\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" class=\"icon icon-arrow-bottom\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.007 10.001a1.467 1.467 0 001.018-.419L15.576 3.2a1.367 1.367 0 000-1.983l-.846-.81A1.453 1.453 0 0013.72 0c-.38 0-.742.146-1.011.406L8.007 5.001 3.277.406A1.453 1.453 0 002.266 0a1.45 1.45 0 00-1.01.406l-.832.81a1.366 1.366 0 000 1.983l6.551 6.383a1.44 1.44 0 001.032.419z\" fill=\"#fff\"></path></svg>\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t<div class=\"proprogram-form__category-list\" data-list=\"\">\n\t\t\t\t\t\t\t\t<span class=\"proprogram-form__category-list-arrow\" data-close=\"\">\n\t\t\t\t\t\t\t\t\t<svg width=\"16\" height=\"11\" viewBox=\"0 0 16 11\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" class=\"icon icon-arrow-bottom\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.007 10.001a1.467 1.467 0 001.018-.419L15.576 3.2a1.367 1.367 0 000-1.983l-.846-.81A1.453 1.453 0 0013.72 0c-.38 0-.742.146-1.011.406L8.007 5.001 3.277.406A1.453 1.453 0 002.266 0a1.45 1.45 0 00-1.01.406l-.832.81a1.366 1.366 0 000 1.983l6.551 6.383a1.44 1.44 0 001.032.419z\" fill=\"#fff\"></path></svg>\n\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t<div class=\"proprogram-form__category-list-container\" data-state-list=\"\">".concat(htmlProvince, "</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t");
       category = true;
     } else {
       htmlStates = "\n\t\t\t\t<input class=\"proprogram-form__input\" type=\"text\" required=\"\" data-proprogram-name=\"default_address.province\">\n\t\t\t\t<span class=\"proprogram-form__highlight\"></span>\n\t\t\t\t<span class=\"proprogram-form__bar\"></span>\n\t\t\t\t<label class=\"proprogram-form__label\">State *</label>\n\t\t\t\t<span class=\"proprogram-form__error\"></span>\n\t\t\t";
     }

     this.stateContainer.innerHTML = htmlStates;

     if (category) {
       this.stateContainer.classList.add("proprogram-form__group--category");
       this.initSelects([this.stateContainer.querySelector(selectors.selects.container)]);
     } else {
       this.stateContainer.classList.remove("proprogram-form__group--category");
     }
   },

   /**
    * Parses and uploads the provided `file` object into a value that is compatible with a Customer Fields
    * file data column.
    *
    * @param file {File}
    * @returns {Promise<{extension: string, size: number, name: string, type: string, url: null | string} | null>}
    */
   uploadFile: function () {
     var _uploadFile = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(file) {
       var customerFieldsBaseApiUrl, shopDomain, extension, customerFieldsCompatibleFileObject, formData, options, response, json;
       return regeneratorRuntime.wrap(function _callee2$(_context2) {
         while (1) {
           switch (_context2.prev = _context2.next) {
             case 0:
               if (window.CF) {
                 _context2.next = 3;
                 break;
               }

               console.error("Unable to upload file, missing global CF object");
               return _context2.abrupt("return", null);

             case 3:
               customerFieldsBaseApiUrl = window.CF.baseApiUrl;

               if (customerFieldsBaseApiUrl) {
                 _context2.next = 7;
                 break;
               }

               console.error("Unable to upload file, missing base API URL");
               return _context2.abrupt("return", null);

             case 7:
               shopDomain = window.CF.domain;

               if (shopDomain) {
                 _context2.next = 11;
                 break;
               }

               console.error("Unable to upload file, missing shop domain");
               return _context2.abrupt("return", null);

             case 11:
               if (file instanceof File) {
                 _context2.next = 14;
                 break;
               }

               console.error("Unable to upload file, provided file is not a File object");
               return _context2.abrupt("return", null);

             case 14:
               extension = file.name.includes(".") ? file.name.substring(file.name.lastIndexOf("."), file.name.length).replace(".", "") : "";
               customerFieldsCompatibleFileObject = {
                 name: file.name,
                 size: file.size,
                 type: file.type,
                 extension: extension,
                 url: null
               };
               formData = new FormData();
               formData.append("customer[file]", file, file.name);
               formData.append("customer[domain]", shopDomain);
               options = {
                 method: "post",
                 body: formData
               };
               _context2.prev = 20;
               _context2.next = 23;
              
               return fetch("".concat(customerFieldsBaseApiUrl, "/customers/upload"), options);

             case 23:
               response = _context2.sent;
               _context2.next = 26;
               return response.json();

             case 26:
               json = _context2.sent;
               customerFieldsCompatibleFileObject.url = json.url;
               _context2.next = 34;
               break;

             case 30:
               _context2.prev = 30;
               _context2.t0 = _context2["catch"](20);
               console.error("Failed to upload file", _context2.t0);
               return _context2.abrupt("return", null);

             case 34:
               
               return _context2.abrupt("return", customerFieldsCompatibleFileObject);

             case 35:
             case "end":
               return _context2.stop();
           }
         }
       }, _callee2, null, [[20, 30]]);
     }));

     function uploadFile(_x2) {
       return _uploadFile.apply(this, arguments);
     }

     return uploadFile;
   }()
 });

 /***/ }),
 /* 247 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";
 __webpack_require__.r(__webpack_exports__);
 /* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3);
 /* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8);
 /* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_1__);
 /* harmony import */ var core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39);
 /* harmony import */ var core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_2__);
 /* harmony import */ var core_js_modules_es_regexp_constructor_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(113);
 /* harmony import */ var core_js_modules_es_regexp_constructor_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_constructor_js__WEBPACK_IMPORTED_MODULE_3__);
 /* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21);
 /* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_4__);
 /* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(72);
 /* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_5__);
 /* harmony import */ var _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1);







 var selectors = {
   inputForm: "[data-input-form]",
   category: {
     container: "[data-container]",
     input: "[data-input]",
     value_customer: "[data-input-value-customer]",
     list: {
       container: "[data-list]",
       close: "[data-close]",
       item: "[data-item]"
     },
     tag: "[data-category-tag]",
     text: {
       container: "[data-text]",
       approved: "[data-approved]",
       buttonApproved: "[data-button-approved]"
     }
   },
   passwordReset: {
     container: "[data-password-reset]",
     open: "[data-password-reset-open]",
     close: "[data-password-reset-close]"
   },
   register: {
     container: "[data-register]",
     open: "[data-register-open]",
     close: "[data-register-close]",
     form: {
       container: ".js-register-account",
       inputs: ".js-register-input",
       button: ".js-register-account-submit",
       signIn: ".js-register-to-signIn"
     }
   }
 };
 var modifiers = {
   category: {
     open: "proprogram-login__category--open",
     item: {
       active: "proprogram-login__category-item--active"
     },
     text: {
       view: "proprogram-login__category-text--view"
     }
   },
   passwordReset: {
     open: "proprogram-password-reset--open"
   },
   register: {
     open: "proprogram-register--open",
     finish: "proprogram-register--finish"
   }
 };
 Object(_shopify_theme_sections__WEBPACK_IMPORTED_MODULE_6__[/* register */ "b"])("proprogram-login", {
   nextStepForm: "/pages/proprogram-form",
   customerSaveOptions: undefined,
   onLoad: function onLoad() {
     this.checkUser();
     this.init();
   },
   checkUser: function checkUser() {
     var customer = window.CF.customer.data;
     //if (customer.id) location.href = this.nextStepForm;
   },
   init: function init() {
     var _this$container$query;

     this.customerSaveOptions = {
       login: true,
       redirect: true,
       redirectUrl: this.nextStepForm,
       formId: (_this$container$query = this.container.querySelector(selectors.inputForm)) === null || _this$container$query === void 0 ? void 0 : _this$container$query.value
     };
     this.category = this.container.querySelector(selectors.category.container);
     this.categoryInput = this.container.querySelector(selectors.category.input);
     this.categoryCustomer =  this.container.querySelector(selectors.category.value_customer);
     this.categoryTag = this.container.querySelector(selectors.category.tag);
     this.listItems = this.container.querySelectorAll(selectors.category.list.item);
     this.textItems = this.container.querySelectorAll(selectors.category.text.container);
    
     this.initTrigerList();
     this.initApproved();
     this.passwordReset = this.container.querySelector(selectors.passwordReset.container);
     this.passwordResetOpen = this.container.querySelectorAll(selectors.passwordReset.open);
     this.passwordResetClose = this.container.querySelectorAll(selectors.passwordReset.close);
     this.initOpenPasswordResetModal();
     this.initClosePasswordResetModal();
     this.register = this.container.querySelector(selectors.register.container);
     this.registerOpen = this.container.querySelectorAll(selectors.register.open);
     this.registerClose = this.container.querySelectorAll(selectors.register.close);
     this.initOpenRegisterModal();
     this.initCloseRegisterModal();
     this.registerForm = this.register.querySelector(selectors.register.form.container);
     //console.log("this.registerForm",this.registerForm)
     this.registerFormInputs = this.registerForm.querySelectorAll(selectors.register.form.inputs);
     this.registerFormSubmit = this.registerForm.querySelector(selectors.register.form.button);
     this.registerFormSignIn = this.registerForm.querySelector(selectors.register.form.signIn);
     this.registerFormContent = this.registerForm.querySelector(selectors.register.form.content);
     this.registerFormFinish = this.registerForm.querySelector(selectors.register.form.finish);
     this.initRegisterFormToSignIn();
     this.initCheckRuleToInput();
     this.initRegisterFormSend();
   },
   initTrigerList: function initTrigerList() {
     var _this = this;

     this.category.addEventListener("click", function (e) {
       e.preventDefault();

       if (e.target.closest(selectors.category.input) || e.target.closest(selectors.category.list.close)) {
         _this.category.classList.toggle(modifiers.category.open);
       }

       if (e.target.closest(selectors.category.list.item)) {
         var item = e.target;
         console.log("here input item", item.dataset )
         _this.categoryInput.innerText = item.innerText;
         _this.categoryTag.value = item.dataset.tag;
         _this.categoryCustomer.value = item.dataset.categoryName;

        //  HERE SET FIRST LOCAL STORAGE
        if (window.CF.customer){
          if(window.CF.customer.data.tags){
            var category_tag_customer = window.CF.customer.data.tags.find(function (tag) {
              return tag.indexOf("cg-") != -1;
            });

          }

        }
         _this.activeListItem(item);
         //var approved = document.querySelector(".proprogram-login__category-approved--checkbox");
         //console.log("here approved button 2", approved.value)
        // 
        // var buttonApprived = textItem.querySelector(selectors.category.text.buttonApproved);
        // buttonApprived.setAttribute("disabled", true)
        //var button_sign_in = document.querySelector(".button.proprogram-login__form-button")
        //button_sign_in.setAttribute("disabled", true)
        //var message = document.querySelectorAll(".proprogram-login__form-error.category_error")
        //var link_account = document.querySelector("a.proprogram-login__form-register-link")
        //link_account.classList.add("no-click");
        // message.forEach(element => {
        //   element.style.opacity = "1";
        //  });
        // 



         _this.category.classList.remove(modifiers.category.open);
       }
     });
   },
   initApproved: function initApproved() {
     this.textItems.forEach(function (textItem) {
       var approved = textItem.querySelector(selectors.category.text.approved);
      
       if (!approved) return null;
      
       var buttonApprived = textItem.querySelector(selectors.category.text.buttonApproved);
       approved.addEventListener("change", function (e) {
         e.preventDefault(); // buttonApprived.disabled = !e.target.checked;
         if (e.target.checked) buttonApprived.removeAttribute("disabled");else buttonApprived.setAttribute("disabled", true);
        //  if (e.target.checked){
        //   buttonApprived.removeAttribute("disabled");
        //   console.log("here approved")
        //   var button_sign_in = document.querySelector(".button.proprogram-login__form-button")
        //   button_sign_in.removeAttribute("disabled");
        //   var message = document.querySelectorAll(".proprogram-login__form-error.category_error")
        //   var link_account = document.querySelector("a.proprogram-login__form-register-link.no-click")
        //   link_account.classList.remove("no-click");
        //   message.forEach(element => {
        //     element.style.opacity = "0";
            
        //   });
          
        //  } else {
        //   console.log("here NOT approved")
        //   buttonApprived.setAttribute("disabled", true)
        //   var button_sign_in = document.querySelector(".button.proprogram-login__form-button")
        //   button_sign_in.setAttribute("disabled", true)
        //   var message = document.querySelectorAll(".proprogram-login__form-error.category_error")
        //   var link_account = document.querySelector("a.proprogram-login__form-register-link")
        //   link_account.classList.add("no-click");
        //   message.forEach(element => {
        //     element.style.opacity = "1";
            
        //   });
        // };
       });
     });
   },
   activeListItem: function activeListItem(activeItem) {
     var _this2 = this;
     //sessionStorage.removeItem('Category_Pro_Program');

     this.listItems.forEach(function (item, key) {
       item.classList.remove(modifiers.category.item.active);

       _this2.textItems[key].classList.remove(modifiers.category.text.view);

       if (item === activeItem) {
         item.classList.add(modifiers.category.item.active);
            console.log("here item active", activeItem.dataset.categoryName )
           
            localStorage.setItem('Category_Pro_Program', activeItem.dataset.categoryName);
            localStorage.setItem('Customer_Group_Pro_Program', activeItem.dataset.tag);
         _this2.textItems[key].classList.add(modifiers.category.text.view);
       }
     });
   },
   initOpenPasswordResetModal: function initOpenPasswordResetModal() {
     var _this3 = this;

     this.passwordResetOpen.forEach(function (resetOpen) {
       resetOpen.addEventListener("click", function (e) {
         e.preventDefault();

         _this3.passwordReset.classList.add(modifiers.passwordReset.open);
       });
     });
   },
   initClosePasswordResetModal: function initClosePasswordResetModal() {
     var _this4 = this;

     this.passwordResetClose.forEach(function (resetClose) {
       resetClose.addEventListener("click", function (e) {
         e.preventDefault();

         _this4.passwordReset.classList.remove(modifiers.passwordReset.open);
       });
     });
   },
   initOpenRegisterModal: function initOpenRegisterModal() {
     var _this5 = this;

     this.registerOpen.forEach(function (registerOpen) {
       registerOpen.addEventListener("click", function (e) {
         e.preventDefault();
         const target = document.querySelector('.proprogram-login__form');
          target.scrollIntoView({
            behavior: 'smooth', // adds a smooth scrolling animation
            block: 'center'     
          });
         
          setTimeout(() => {
           const header_pinned = document.querySelector("section.header");
            if (header_pinned){
            header_pinned.classList.remove("pinned");
              }
          }, 500);
        
         //document.querySelector("body").classList.add("no-scroll");

         //_this5.register.classList.add(modifiers.register.open);
       });
     });
   },
   initCloseRegisterModal: function initCloseRegisterModal() {
     var _this6 = this;

     this.registerClose.forEach(function (registerClose) {
       registerClose.addEventListener("click", function (e) {
         e.preventDefault();
         document.querySelector("body").classList.remove("no-scroll");

         _this6.register.classList.remove(modifiers.register.open);
       });
     });
   },
   initRegisterFormToSignIn: function initRegisterFormToSignIn() {
     var _this7 = this;

     this.registerFormSignIn.addEventListener("click", function (e) {
       e.preventDefault();
       document.querySelector("body").classList.remove("no-scroll");

       _this7.register.classList.remove(modifiers.register.open);

       _this7.container.querySelector('[name="customer[email]"]').focus();
     });
   },
   initCheckRuleToInput: function initCheckRuleToInput() {
     var _this8 = this;

     this.registerFormInputs.forEach(function (input) {
       input.addEventListener("keyup", function (e) {
        // console.log(_this8.checkRulesForm([e.target]));
       });
     });
   },
   initRegisterFormSend: function initRegisterFormSend() {
     var _this9 = this;


     if (!this.customerSaveOptions || !this.customerSaveOptions.formId) return;
     this.registerFormSubmit.addEventListener("click", function (e) {
       e.preventDefault();


       if (!_this9.checkRulesForm()) return;

       _this9.registerFormInputs.forEach(function (registerFormInput) {
         if (registerFormInput.dataset.proprogramName.indexOf("confirm_") === -1 && registerFormInput.dataset.proprogramName.indexOf("tags[]") === -1) window.CF.customer.set(registerFormInput.dataset.proprogramName, registerFormInput.value);

         if (registerFormInput.dataset.proprogramName.indexOf("tags[]") !== -1) {
           console.log("here tags []", registerFormInput.value)
           window.CF.customer.addTag(registerFormInput.value);

         }
         

         if(registerFormInput.dataset.proprogramName.indexOf("customer_group") !== -1){
            var actualTag = window.CF.customer.data.tags.find(function (tag) {
              return tag.indexOf("cg-") != -1;
            });
            window.CF.customer.removeTag(actualTag);
            window.CF.customer.addTag(registerFormInput.value);
          }
       });

       window.CF.customer.save(_this9.customerSaveOptions).then(function (errorObj) {
         console.log(errorObj);

         if(CF.customer.conditions && !errorObj) {
          const errors = {}
          // loop object customer conditions
          for(key in CF.customer.conditions) {
            errors[key] = [CF.customer.conditions[key]];
          }

          errorObj = errors;

         }

         if (errorObj) {
           var _loop = function _loop(name) {
             var input = Array.apply(null, _this9.registerFormInputs).find(function (input) {
               return input.dataset.proprogramName === name;
             });
             var inputError = input.closest(".proprogram-register__form-group").querySelector(".proprogram-register__form-error");
             inputError.innerText = errorObj[name][0];
             input.classList.add("verification-error");
           };

           for (var name in errorObj) {
             _loop(name);
           }
         } else {

              var data, form;
              form =  document.querySelector("#create_customer.js-register-account");
              _this9.register.classList.add(modifiers.register.finish);
             // setTimeout(function () {

                //location.href = "/pages/proprogram-form";
                // this code is to subscribed users in shopify
                // let data_fetch = {
                //   "email":  form.querySelector("[data-proprogram-name=email]").value
                //  }

                // fetch('/apps/datajet/task/66722e41fc6b553b70a52b2d', {
                //     method: "POST",
                //     body: JSON.stringify(data_fetch),
                //     headers: {
                //         'Content-Type': 'application/json'
                //     }
                // })
                // .then(res=> {

                // })
                // .then((res) => {

                // })
                // .finally(e => {});

              //}, 1000);




              // this code is to subscribed users directly  ONLY in Klaviyo .

		          //   data = new URLSearchParams();
              //   data.append("email", form.querySelector("[data-proprogram-name=email]").value);
              //   data.append("first_name", form.querySelector("[data-proprogram-name=first_name]").value);
              //   data.append("last_name", form.querySelector("[data-proprogram-name=last_name]").value);
              //   data.append("$fields", "email, first_name, last_name");
              //   data.append("g", document.querySelector("[name=\"klaviyo_subscription_list_id\"]").value);

              //  return fetch("https://manage.kmail-lists.com/ajax/subscriptions/subscribe", {
              //    method: "POST",
              //     headers: {
              //       "Content-Type": "application/x-www-form-urlencoded",
              //      "Cache-Control": "no-cache"
              //   },
              //     body: data
              // });


         }
       });
     });
   },
   checkRulesForm: function checkRulesForm() {
     var _this10 = this;

     var inputs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.registerFormInputs;
     var error = false;
     inputs.forEach(function (registerFormInput) {
       var rule = registerFormInput.dataset.proprogramRule;
       var verification = registerFormInput.dataset.proprogramVerification;
       var verificationType = registerFormInput.dataset.proprogramVerificationType;

       if (!registerFormInput.value.length) {
         error = true;
         registerFormInput.classList.add("verification-error");
       } else if (rule && registerFormInput.value.length) {
         var regex = new RegExp(rule);

         if (!regex.test(registerFormInput.value)) {
           error = true;
           registerFormInput.classList.add("verification-error");
         } else {
           registerFormInput.classList.remove("verification-error");
         }
       } else {
         registerFormInput.classList.remove("verification-error");
       }

       if (verificationType && verification) {
         var inputVerification = Array.apply(null, _this10.registerFormInputs).find(function (input) {
           return input.dataset.proprogramName === verification;
         });

         if (registerFormInput.value !== inputVerification.value) {
           error = true;
           registerFormInput.classList.add("verification-error");
         } else {
           registerFormInput.classList.remove("verification-error");
         }
       }
     });
     return !error;
   }
 });

 /***/ }),
 /* 248 */
 /***/ (function(module, exports) {

 /* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
 module.exports = __webpack_amd_options__;

 /* WEBPACK VAR INJECTION */}.call(this, {}))

 /***/ }),
 /* 249 */
 /***/ (function(module, exports, __webpack_require__) {

 var PROPER_FUNCTION_NAME = __webpack_require__(90).PROPER;
 var fails = __webpack_require__(10);
 var whitespaces = __webpack_require__(174);

 var non = '\u200B\u0085\u180E';

 // check that a method works with the correct list
 // of whitespaces and has a correct name
 module.exports = function (METHOD_NAME) {
   return fails(function () {
     return !!whitespaces[METHOD_NAME]()
       || non[METHOD_NAME]() !== non
       || (PROPER_FUNCTION_NAME && whitespaces[METHOD_NAME].name !== METHOD_NAME);
   });
 };


 /***/ }),
 /* 250 */
 /***/ (function(module, exports, __webpack_require__) {

 "use strict";

 var $ = __webpack_require__(13);
 var $trim = __webpack_require__(175).trim;
 var forcedStringTrimMethod = __webpack_require__(249);

 // `String.prototype.trim` method
 // https://tc39.es/ecma262/#sec-string.prototype.trim
 $({ target: 'String', proto: true, forced: forcedStringTrimMethod('trim') }, {
   trim: function trim() {
     return $trim(this);
   }
 });


 /***/ }),
 /* 251 */
 /***/ (function(module, exports, __webpack_require__) {

 "use strict";

 var $ = __webpack_require__(13);
 var call = __webpack_require__(22);

 // `URL.prototype.toJSON` method
 // https://url.spec.whatwg.org/#dom-url-tojson
 $({ target: 'URL', proto: true, enumerable: true }, {
   toJSON: function toJSON() {
     return call(URL.prototype.toString, this);
   }
 });


 /***/ }),
 /* 252 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";
 __webpack_require__.r(__webpack_exports__);
 /* harmony import */ var core_js_modules_es_array_join_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(115);
 /* harmony import */ var core_js_modules_es_array_join_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join_js__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21);
 /* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_1__);
 /* harmony import */ var core_js_modules_es_string_split_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(106);
 /* harmony import */ var core_js_modules_es_string_split_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split_js__WEBPACK_IMPORTED_MODULE_2__);
 /* harmony import */ var core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39);
 /* harmony import */ var core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_3__);
 /* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3);
 /* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_4__);
 /* harmony import */ var core_js_modules_es_string_search_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(125);
 /* harmony import */ var core_js_modules_es_string_search_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_search_js__WEBPACK_IMPORTED_MODULE_5__);
 /* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(54);
 /* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_6__);
 /* harmony import */ var core_js_modules_es_regexp_constructor_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(113);
 /* harmony import */ var core_js_modules_es_regexp_constructor_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_constructor_js__WEBPACK_IMPORTED_MODULE_7__);
 /* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(72);
 /* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_8__);
 /* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(176);
 /* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_9__);
 /* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(80);
 /* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_10__);
 /* harmony import */ var core_js_modules_web_url_to_json_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(251);
 /* harmony import */ var core_js_modules_web_url_to_json_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_url_to_json_js__WEBPACK_IMPORTED_MODULE_11__);
 /* harmony import */ var core_js_modules_es_string_trim_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(250);
 /* harmony import */ var core_js_modules_es_string_trim_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_trim_js__WEBPACK_IMPORTED_MODULE_12__);
 /* harmony import */ var core_js_modules_es_string_match_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(185);
 /* harmony import */ var core_js_modules_es_string_match_js__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_match_js__WEBPACK_IMPORTED_MODULE_13__);
 /* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(63);
 /* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_14__);
 /* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(25);
 /* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_15__);
 /* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(29);
 /* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_16__);
 /* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(104);
 /* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_17__);
 /* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(114);
 /* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_18__);
 /* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(31);
 /* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_19__);
 /* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(27);
 /* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_20__);
 /* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(41);
 /* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_21__);
 function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
























 /* eslint-disable */
 (function () {
   if (!document.querySelector('[data-section-type="ja-jobs-widget"]')) return false;
   var widgetVersion = "1";
   var baseUrl = "//apps.jobadder.com/widgets";
   var minjQueryVersion = "1.9.1";
   var widgetSettings = {
     key: "",
     showLoadingImage: true,
     enablePushState: true,
     jobSearchSettings: {
       showSearchForm: false,
       classificationsToExclude: [],
       showLabels: true,
       optionText: "",
       showKeywordSearch: true,
       autoSearch: false,
       showSearchButton: true,
       searchButtonText: "Search"
     },
     jobListSettings: {
       jobsPerPage: 5,
       showHotJobsOnly: false,
       titleIsLink: true,
       showDatePosted: true,
       datePostedFormat: "{0}",
       dateFormat: "d/M/yyyy",
       showClassifications: true,
       classificationsToExclude: [],
       showSalary: false,
       salaryFormat: "{0}",
       includeSalaryText: false,
       showJobReference: false,
       jobReferenceFormat: "{0}",
       alwaysShowPager: false,
       showPagerSummary: true,
       pagerGroupSize: 4,
       scrollOnPageChange: true,
       animateScrollOnPageChange: false,
       readMoreText: "More..",
       noJobsContent: "There are no jobs matching your criteria. Please try a broader search."
     },
     jobDetailsSettings: {
       jobID: null,
       showDatePosted: true,
       datePostedFormat: "{0}",
       dateFormat: "d/M/yyyy",
       showClassifications: true,
       classificationsToExclude: [],
       showSalary: false,
       salaryFormat: "{0}",
       includeSalaryText: false,
       showJobReference: false,
       jobReferenceFormat: "{0}",
       showBulletPoints: true,
       applyButtonText: "Apply Now",
       backLinkText: "Back to search results"
     },
     applicationFormSettings: {
       jobID: null,
       useExternalApplicationForm: false,
       showExternalApplicationFormInNewWindow: true,
       pageTitle: "Apply Now",
       showJobTitle: true,
       showJobSummary: false,
       formFields: "firstName,lastName,email,phone,mobile,resume,coverLetter,coverNote",
       formFieldLabels: "First name,Last name,Email address,Phone,Mobile,Resume,Cover letter,Cover note",
       showLabels: true,
       applyButtonText: "Apply Now",
       backLinkText: "Cancel",
       showLoadingImage: true,
       submittedContent: "Thank you - your application has been successfully submitted.",
       submittedRedirectUrl: ""
     }
   };
   var loadingImage = document.createElement("img");
   loadingImage.className = "ja-loading left";
   loadingImage.setAttribute("src", window._jaJobsSettings.loadingImageUrl || baseUrl + "/V" + widgetVersion + "/loading.gif");
   loadingImage.setAttribute("alt", "Loading..");

   if (window._jaJobsSettings.showLoadingImage !== false) {
     document.getElementById("ja-jobs-widget").appendChild(loadingImage);
   }

   var jQuery;

   if (window.jQuery === undefined || window.jQuery.fn.jquery < minjQueryVersion) {
     var scriptTag = document.createElement("script");
     scriptTag.setAttribute("type", "text/javascript");
     scriptTag.setAttribute("src", "//ajax.googleapis.com/ajax/libs/jquery/" + minjQueryVersion + "/jquery.min.js");

     if (scriptTag.readyState) {
       scriptTag.onreadystatechange = function () {
         if (this.readyState === "complete" || this.readyState === "loaded") {
           scriptLoadHandler();
         }
       };
     } else {
       scriptTag.onload = scriptLoadHandler;
     }

     (document.getElementsByTagName("head")[0] || document.documentElement).appendChild(scriptTag);
   } else {
     jQuery = window.jQuery;
     main();
   }

   function scriptLoadHandler() {
     jQuery = window.jQuery.noConflict(true);
     main();
   }

   function main() {
     jQuery(document).ready(function ($) {
       $.extend(true, widgetSettings, window._jaJobsSettings);
       widgetSettings.loadingImageUrl = widgetSettings.loadingImageUrl || baseUrl + "/V" + widgetVersion + "/loading.gif";
       var renderSearchFormRequest = {
         key: widgetSettings.key,
         classificationsToExclude: widgetSettings.jobSearchSettings.classificationsToExclude ? widgetSettings.jobSearchSettings.classificationsToExclude.join(",") : "",
         showLabels: widgetSettings.jobSearchSettings.showLabels,
         optionText: widgetSettings.jobSearchSettings.optionText,
         showKeywordSearch: widgetSettings.jobSearchSettings.showKeywordSearch,
         autoSearch: widgetSettings.jobSearchSettings.autoSearch,
         showSearchButton: widgetSettings.jobSearchSettings.showSearchButton,
         searchButtonText: widgetSettings.jobSearchSettings.searchButtonText
       };
       var renderJobListRequest = {
         key: widgetSettings.key,
         jobsPerPage: widgetSettings.jobListSettings.jobsPerPage,
         showHotJobsOnly: widgetSettings.jobListSettings.showHotJobsOnly,
         titleIsLink: widgetSettings.jobListSettings.titleIsLink,
         showDatePosted: widgetSettings.jobListSettings.showDatePosted,
         datePostedFormat: widgetSettings.jobListSettings.datePostedFormat,
         dateFormat: widgetSettings.jobListSettings.dateFormat,
         showClassifications: widgetSettings.jobListSettings.showClassifications,
         classificationsToExclude: widgetSettings.jobListSettings.classificationsToExclude ? widgetSettings.jobListSettings.classificationsToExclude.join(",") : "",
         showSalary: widgetSettings.jobListSettings.showSalary,
         salaryFormat: widgetSettings.jobListSettings.salaryFormat,
         includeSalaryText: widgetSettings.jobListSettings.includeSalaryText,
         showJobReference: widgetSettings.jobListSettings.showJobReference,
         jobReferenceFormat: widgetSettings.jobListSettings.jobReferenceFormat,
         alwaysShowPager: widgetSettings.jobListSettings.alwaysShowPager,
         showPagerSummary: widgetSettings.jobListSettings.showPagerSummary,
         pagerGroupSize: widgetSettings.jobListSettings.pagerGroupSize,
         scrollOnPageChange: widgetSettings.jobListSettings.scrollOnPageChange,
         animateScrollOnPageChange: widgetSettings.jobListSettings.animateScrollOnPageChange,
         readMoreText: widgetSettings.jobListSettings.readMoreText,
         noJobsContent: widgetSettings.jobListSettings.noJobsContent,
         renderPoweredByJobAdder: true
       };
       var renderJobDetailsRequest = {
         key: widgetSettings.key,
         showDatePosted: widgetSettings.jobDetailsSettings.showDatePosted,
         datePostedFormat: widgetSettings.jobDetailsSettings.datePostedFormat,
         dateFormat: widgetSettings.jobDetailsSettings.dateFormat,
         showClassifications: widgetSettings.jobDetailsSettings.showClassifications,
         classificationsToExclude: widgetSettings.jobDetailsSettings.classificationsToExclude ? widgetSettings.jobDetailsSettings.classificationsToExclude.join(",") : "",
         showSalary: widgetSettings.jobDetailsSettings.showSalary,
         salaryFormat: widgetSettings.jobDetailsSettings.salaryFormat,
         includeSalaryText: widgetSettings.jobDetailsSettings.includeSalaryText,
         showJobReference: widgetSettings.jobDetailsSettings.showJobReference,
         jobReferenceFormat: widgetSettings.jobDetailsSettings.jobReferenceFormat,
         showBulletPoints: widgetSettings.jobDetailsSettings.showBulletPoints,
         applyButtonText: widgetSettings.jobDetailsSettings.applyButtonText,
         backLinkText: widgetSettings.jobDetailsSettings.backLinkText,
         useExternalApplicationForm: widgetSettings.applicationFormSettings.useExternalApplicationForm,
         showExternalApplicationFormInNewWindow: widgetSettings.applicationFormSettings.showExternalApplicationFormInNewWindow
       };
       var renderApplicationFormRequest = {
         key: widgetSettings.key,
         ajaxSubmit: true,
         formUrl: [location.protocol, "//", location.host, location.pathname].join(""),
         useExternalApplicationForm: widgetSettings.applicationFormSettings.useExternalApplicationForm,
         showExternalApplicationFormInNewWindow: widgetSettings.applicationFormSettings.showExternalApplicationFormInNewWindow,
         pageTitle: widgetSettings.applicationFormSettings.pageTitle,
         showJobTitle: widgetSettings.applicationFormSettings.showJobTitle,
         showJobSummary: widgetSettings.applicationFormSettings.showJobSummary,
         formFields: widgetSettings.applicationFormSettings.formFields,
         formFieldLabels: widgetSettings.applicationFormSettings.formFieldLabels,
         showLabels: widgetSettings.applicationFormSettings.showLabels,
         applyButtonText: widgetSettings.applicationFormSettings.applyButtonText,
         backLinkText: widgetSettings.applicationFormSettings.backLinkText,
         submittedRedirectUrl: widgetSettings.applicationFormSettings.submittedRedirectUrl
       };

       if (renderApplicationFormRequest.formFields === "") {
         renderApplicationFormRequest.formFields = "firstName,lastName,email,resume";
         renderApplicationFormRequest.formFieldLabels = "First name,Last name,Email address,Resume";
       }

       var renderSubmittedRequest = {
         content: widgetSettings.applicationFormSettings.submittedContent
       };

       if (widgetSettings.key === "") {
         alert("Error: invalid/missing key");
         return;
       }

       var $widgetContainer = $("#ja-jobs-widget");
       var $loadingImage = $(loadingImage).hide().removeClass("left");
       var $jobSearchState = "";
       var searchParams = {
         classificationIDs: [],
         keywords: "",
         pageNumber: 1
       };
       var queryStringParams = {
         jobID: getParameterByName("ja-job"),
         classificationIDs: getParameterByName("ja-classifications"),
         keywords: getParameterByName("ja-keywords"),
         applyID: getParameterByName("ja-apply"),
         submitted: getParameterByName("ja-submitted"),
         jobUnavailable: getParameterByName("ja-job-unavailable")
       };

       if (widgetSettings.jobDetailsSettings.jobID && !isNaN(widgetSettings.jobDetailsSettings.jobID)) {
         queryStringParams.jobID = widgetSettings.jobDetailsSettings.jobID;
       }

       if (widgetSettings.applicationFormSettings.jobID && !isNaN(widgetSettings.applicationFormSettings.jobID)) {
         queryStringParams.applyID = widgetSettings.applicationFormSettings.jobID;
       }

       function init(pop) {
         queryStringParams = {
           jobID: getParameterByName("ja-job"),
           classificationIDs: getParameterByName("ja-classifications"),
           keywords: getParameterByName("ja-keywords"),
           applyID: getParameterByName("ja-apply"),
           submitted: getParameterByName("ja-submitted"),
           jobUnavailable: getParameterByName("ja-job-unavailable")
         };

         if (queryStringParams.jobUnavailable) {
           loadHtml("Jobs/RenderUnavailable", null, render);
         } else {
           if (queryStringParams.submitted) {
             loadHtml("Jobs/RenderSubmitted", renderSubmittedRequest, render);
           } else {
             if (queryStringParams.applyID && !isNaN(queryStringParams.applyID)) {
               renderApplicationForm(queryStringParams.applyID);
             } else {
               if (queryStringParams.jobID && !isNaN(queryStringParams.jobID)) {
                 renderJobDetailsRequest.jobID = queryStringParams.jobID;
                 loadHtml("Jobs/RenderJobDetails", renderJobDetailsRequest, render);
               } else {
                 if (queryStringParams.classificationIDs || queryStringParams.keywords) {
                   var classificationIDs = [];
                   var temp = queryStringParams.classificationIDs.split(",");

                   for (var i = 0; i < temp.length; i++) {
                     if (!isNaN(temp[i])) {
                       classificationIDs.push(temp[i]);
                     }
                   }

                   searchParams.classificationIDs = classificationIDs;
                   searchParams.keywords = queryStringParams.keywords;
                   renderJobListRequest.classificationIDs = searchParams.classificationIDs.join(",");
                   renderJobListRequest.keywords = queryStringParams.keywords;
                   renderJobListRequest.pageNumber = 1;

                   if (widgetSettings.jobSearchSettings.showSearchForm) {
                     loadHtml("Jobs/RenderSearchForm", renderSearchFormRequest, function (renderSearchFormResponse) {
                       $widgetContainer.html(renderSearchFormResponse);
                       loadHtml("Jobs/RenderJobList", renderJobListRequest, function (renderJobListResponse) {
                         $widgetContainer.append(renderJobListResponse);
                         refreshSearchForm();
                       });
                     });
                   } else {
                     loadHtml("Jobs/RenderJobList", renderJobListRequest, function (renderJobListResponse) {
                       $widgetContainer.append(renderJobListResponse);
                     });
                   }

                   pushJobListState(pop);
                 } else {
                   renderDefaultWidget(pop);
                 }
               }
             }
           }
         }
       }

       init();

       if (widgetSettings.enablePushState && history.pushState) {
         window.onpopstate = function (event) {
           var s = event.state;

           if (!s || !s.url) {
             return;
           }

           if (s.url.indexOf("Jobs/RenderJobList") > -1) {
             init(true);
           } else {
             if (s.url.indexOf("Jobs/RenderJobDetails") > -1 && s.jobID) {
               renderJobDetailsPage(s.jobID, true);
             } else {
               if (s.url.indexOf("Jobs/RenderApplicationForm") > -1 && s.jobID) {
                 renderApplicationForm(s.jobID, true);
               }
             }
           }
         };
       }

       $widgetContainer.on("change", ".ja-job-search select", function () {
         getChildClassifications($(this), function ($child) {
           $child.val("0");
         });

         if (widgetSettings.jobSearchSettings.autoSearch) {
           searchJobs();
         }
       });
       $widgetContainer.on("click", ".ja-job-search .ja-button", function () {
         searchJobs();
         return false;
       });

       function searchJobs() {
         var classificationIDs = [];
         var $selects = $(".ja-job-search select", $widgetContainer);
         $.each($selects, function (index, item) {
           var id = item.value;

           if (id !== "0" && !isNaN(id)) {
             classificationIDs.push(id);
           }
         });
         searchParams.classificationIDs = classificationIDs;
         var $txtKeywords = $("#ja-keywords");

         if ($txtKeywords.length) {
           searchParams.keywords = $txtKeywords.val();
         }

         renderJobListRequest.classificationIDs = classificationIDs.join(",");
         renderJobListRequest.keywords = searchParams.keywords;
         renderJobListRequest.renderPoweredByJobAdder = false;
         renderJobListRequest.pageNumber = 1;
         loadHtml("Jobs/RenderJobList", renderJobListRequest, function (renderJobListResponse) {
           $widgetContainer.find(".ja-job-list-container").replaceWith(renderJobListResponse);
         });
       }

       $widgetContainer.on("click", ".ja-pager a", function () {
         var pageNumber = $(this).data("page");

         if (pageNumber === "undefined" || pageNumber === null || isNaN(pageNumber)) {
           return false;
         }

         searchParams.pageNumber = pageNumber;
         renderJobListRequest.classificationIDs = searchParams.classificationIDs.join(",");
         renderJobListRequest.keywords = searchParams.keywords;
         renderJobListRequest.pageNumber = searchParams.pageNumber;
         renderJobListRequest.renderPoweredByJobAdder = false;
         loadHtml("Jobs/RenderJobList", renderJobListRequest, function (renderJobListResponse) {
           $widgetContainer.find(".ja-job-list-container").replaceWith(renderJobListResponse);

           if (widgetSettings.jobListSettings.scrollOnPageChange) {
             if (widgetSettings.jobListSettings.animateScrollOnPageChange) {
               $("html, body").animate({
                 scrollTop: $(".ja-job-list-container", $widgetContainer).offset().top
               }, 1000);
             } else {
               window.scrollTo(0, $widgetContainer.offset().top);
             }
           }
         });
         return false;
       });
       $widgetContainer.on("click", ".ja-job-list .title a, .ja-job-list .view-details", function (e) {
         e.preventDefault();
         var jobID = $(this).data("job-id");

         if (!jobID || isNaN(jobID)) {
           return false;
         }

         renderJobDetailsPage(jobID);
       });

       function renderJobDetailsPage(jobID, pop) {
         saveJobSearchState();
         renderJobDetailsRequest.jobID = jobID;
         loadHtml("Jobs/RenderJobDetails", renderJobDetailsRequest, function (renderJobDetailsResponse) {
           console.log(renderJobDetailsResponse);
           var contentJob = document.createElement("div");
           contentJob.innerHTML = renderJobDetailsResponse;
           window.open(contentJob.querySelector("[data-apply-url]").dataset.applyUrl + "?show=details", "_blank").focus();
         });
         return false;
       }

       $widgetContainer.on("click", ".ja-job-details .apply input", function () {
         var $this = $(this);
         var url = $this.data("apply-url");

         if (url && url.length) {
           if ($this.data("new-window")) {
             window.open(url);
           } else {
             loadHtml("Jobs/RenderApplicationFormIframe", {
               Url: url
             }, function (renderApplicationFormIframeResponse) {
               $widgetContainer.html(renderApplicationFormIframeResponse);
               $(".ja-apply-iframe").find("iframe").iFrameResize({
                 checkOrigin: false,
                 heightCalculationMethod: "bodyScroll"
               });
               window.scrollTo(0, $widgetContainer.offset().top);
             });
           }

           return false;
         }

         var jobID = $(this).data("job-id");

         if (!jobID || isNaN(jobID)) {
           return false;
         }

         renderApplicationForm(jobID);
         return false;
       });
       $widgetContainer.on("click", ".ja-job-details .back-link", function (e) {
         e.preventDefault();
         restoreJobSearchState();
         return false;
       });
       $widgetContainer.on("click", ".ja-job-unavailable .back-link", function () {
         restoreJobSearchState();
         return false;
       });

       function renderApplicationForm(jobID, pop) {
         window.scrollTo(0, $widgetContainer.offset().top);
         renderApplicationFormRequest.jobID = jobID;

         if ($.support.cors) {
           loadHtml("Jobs/RenderApplicationForm", renderApplicationFormRequest, function (renderApplicationFormResponse) {
             $widgetContainer.html(renderApplicationFormResponse);
             $widgetContainer.find(".ja-job-apply .ja-submit .ja-button").removeAttr("disabled");
           });
         } else {
           renderApplicationFormRequest.ajaxSubmit = false;
           renderApplicationFormRequest.errorMessage = getParameterByName("error");
           renderApplicationFormRequest.errorRequired = getParameterByName("error-required");
           renderApplicationFormRequest.errorEmail = getParameterByName("error-email");
           loadHtml("Jobs/RenderApplicationForm", renderApplicationFormRequest, function (renderApplicationFormResponse) {
             $widgetContainer.html(renderApplicationFormResponse);
             $.each(location.search.substr(1).split("&"), function (index, item) {
               var arr = item.split("=");

               if (arr.length == 2 && arr[0].indexOf("Candidate") === 0) {
                 $("#" + arr[0]).val(decodeURIComponent(arr[1]));
               }
             });
             $widgetContainer.find(".ja-job-apply .ja-submit .ja-button").removeAttr("disabled");
           });
         }

         if (widgetSettings.enablePushState && history.pushState && !pop) {
           history.pushState({
             jobID: jobID,
             url: "Jobs/RenderApplicationForm"
           }, "Jobs/RenderApplicationForm", "?ja-apply=" + jobID);
         }
       }

       $widgetContainer.one("click", ".ja-job-apply .ja-submit .ja-button", function () {
         submitApplicationForm();
         return false;
       });

       function submitApplicationForm() {
         var $form = $widgetContainer.find(".ja-job-apply form");
         var $btnSubmit = $form.find(".ja-submit .ja-button");
         var $linkBack = $form.find(".ja-submit .back-link");
         var $errorContainer = $form.find(".ja-error-container");
         var $errorMessage = $errorContainer.find(".ja-error-message");
         $btnSubmit.attr("disabled", "disabled");
         $linkBack.hide();

         if (widgetSettings.applicationFormSettings.showLoadingImage) {
           $loadingImage.show();
           $form.find(".ja-submit").append($loadingImage);
         }

         if ($.support.cors) {
           $form.ajaxSubmit({
             type: "POST",
             dataType: "json",
             iframe: false,
             success: function success(response, statusText, xhr) {
               var $errorFields = $form.find("input.error, select.error, textarea.error");
               $errorFields.removeClass("error").parents("form").find(".validation-error").remove();

               if (!response.Success) {
                 $errorMessage.text(response.ErrorMessage);
                 $errorContainer.show();

                 if (response.ValidationErrors) {
                   $.each(response.ValidationErrors, function (index, item) {
                     var $field = $("#" + item.FieldName);
                     var $span = $("<span></span>", {
                       class: "validation-error",
                       text: item.ErrorMessage
                     });
                     $field.addClass("error").parent(".ja-field").append($span);
                     $field.parent(".checkbox").append($span);
                   });
                 }

                 if (response.Unavailable) {
                   loadHtml("Jobs/RenderUnavailable", null, function (renderUnavailableResponse) {
                     $widgetContainer.html(renderUnavailableResponse);
                   });
                 }
               } else {
                 $errorMessage.text("");
                 $errorContainer.hide();

                 if (widgetSettings.applicationFormSettings.submittedRedirectUrl) {
                   window.location.href = widgetSettings.applicationFormSettings.submittedRedirectUrl;
                 } else {
                   loadHtml("Jobs/RenderSubmitted", renderSubmittedRequest, function (renderSubmittedResponse) {
                     $widgetContainer.html(renderSubmittedResponse);
                   });
                 }
               }
             },
             error: function error(jqXHR, textStatus, errorThrown) {
               $errorMessage.text("Failed to submit your application. Please try again.");
               $errorContainer.show();
             },
             complete: function complete(jqXHR, textStatus) {
               $loadingImage.remove();
               $linkBack.show();
               $btnSubmit.one("click", function () {
                 submitApplicationForm();
                 return false;
               }).removeAttr("disabled");
             }
           });
         } else {
           $form.submit();
         }

         return false;
       }

       $widgetContainer.on("click", ".ja-job-apply .back-link", function () {
         if (confirm("Are you sure you want to cancel?")) {
           restoreJobSearchState();
         }

         return false;
       });
       $widgetContainer.on("click", ".ja-apply-iframe .back-link", function () {
         var src = $widgetContainer.find("iframe").attr("src");

         if (src && src.toLowerCase().indexOf("submitted") !== -1 || src.toLowerCase().indexOf("closed") !== -1) {
           restoreJobSearchState();
         } else {
           if (confirm("Are you sure you want to cancel?")) {
             restoreJobSearchState();
           }
         }

         return false;
       });
       $widgetContainer.on("click", ".ja-application-submitted .back-link", function () {
         restoreJobSearchState();
         return false;
       });

       function loadHtml(url, request, successCallback, errorCallback, completeCallback) {
         if (!url) {
           return;
         }

         $.ajax({
           type: "GET",
           url: baseUrl + "/V" + widgetVersion + "/" + url,
           data: request,
           dataType: "jsonp",
           contentType: "application/json; charset=utf-8",
           beforeSend: function beforeSend() {
             if (widgetSettings.showLoadingImage) {
               $widgetContainer.append($loadingImage);
             }
           },
           success: function success(response, textStatus, jqXHR) {
             if (successCallback && typeof successCallback === "function") {
               successCallback(response, textStatus, jqXHR);
             }
           },
           error: function error(jqXHR, textStatus, errorThrown) {
             if (errorCallback && typeof errorCallback === "function") {
               errorCallback(jqXHR, textStatus, errorThrown);
             } else {
               logError("loadHtml error: " + errorThrown + ". Board reference: " + widgetSettings.key);
             }
           },
           complete: function complete(jqXHR, textStatus) {
             if (widgetSettings.showLoadingImage) {
               $loadingImage.remove();
             }

             if (completeCallback && typeof completeCallback === "function") {
               completeCallback(jqXHR, textStatus);
             }
           }
         });
       }

       function saveJobSearchState() {
         $jobSearchState = $widgetContainer.html();
       }

       function restoreJobSearchState(pop) {
         window.scrollTo(0, $widgetContainer.offset().top);

         if ($jobSearchState.length === 0) {
           renderDefaultWidget(pop);
           return;
         }

         $widgetContainer.html($jobSearchState);
         refreshSearchForm();

         if (widgetSettings.enablePushState && history.pushState && !pop) {
           history.back();
         }
       }

       function renderDefaultWidget(pop) {
         if (widgetSettings.jobSearchSettings.showSearchForm) {
           loadHtml("Jobs/RenderSearchForm", renderSearchFormRequest, function (renderSearchFormResponse) {
             $widgetContainer.html(renderSearchFormResponse);
             loadHtml("Jobs/RenderJobList", renderJobListRequest, function (renderJobListResponse) {
               $widgetContainer.append(renderJobListResponse);
             });
           });
         } else {
           loadHtml("Jobs/RenderJobList", renderJobListRequest, render);
         }

         pushJobListState(pop);
       }

       function render(res) {
         $widgetContainer.html(res);
       }

       function pushJobListState(pop) {
         if (widgetSettings.enablePushState && history.pushState && !pop) {
           history.pushState({
             url: "Jobs/RenderJobList"
           }, "Jobs/RenderJobList", "");
         }
       }

       function refreshSearchForm() {
         var $selects = $(".ja-job-search select[data-child]", $widgetContainer);
         $.each($selects, function (index, item) {
           var $select = $(item);
           $.each(searchParams.classificationIDs, function (innerIndex, classificationID) {
             if ($select.find('option[value="' + classificationID + '"]').length > 0) {
               $select.val(classificationID);
               return;
             }
           });

           if ($select.val()) {
             getChildClassifications($select, function ($childElement) {
               $.each(searchParams.classificationIDs, function (innerIndex, classificationID) {
                 if ($childElement.find('option[value="' + classificationID + '"]').length > 0) {
                   $childElement.val(classificationID);
                   return;
                 } else {
                   $childElement.val("0");
                 }
               });
             });
           }
         });
         $("#ja-keywords", $widgetContainer).val(searchParams.keywords);
       }

       function getChildClassifications(selectElement, successCallback) {
         var childID = selectElement.data("child");

         if (childID === "undefined") {
           return;
         }

         var $child = $("#" + childID);

         if ($child.length === 0) {
           return;
         }

         var firstItemText = $child.find("option").first().text();
         $child.find("option").remove();
         $child.append($("<option></option>").attr("value", "0").text("Loading.."));
         var getClassificationsRequest = {
           key: widgetSettings.key,
           parentID: selectElement.val()
         };
         loadHtml("Jobs/GetClassifications", getClassificationsRequest, function (getClassificationsResponse) {
           $child.find("option").remove();

           if (getClassificationsResponse.Success !== true) {
             $child.append($("<option></option>").attr("value", "0").text(getClassificationsResponse.ErrorMessage !== "" ? getClassificationsResponse.ErrorMessage : "Failed to load classifications"));
           } else {
             if (selectElement.val() > 0) {
               $.each(getClassificationsResponse.Items, function (index, item) {
                 $child.append($("<option></option>").attr("value", item.Value).text(item.Text));
               });
             }

             $child.prepend($("<option></option>").attr("value", "0").text(firstItemText));
           }

           if (successCallback && typeof successCallback === "function") {
             successCallback($child);
           }
         }, function (jqXHR, textStatus, errorThrown) {
           $child.find("option").remove();
           $child.append($("<option></option>").attr("value", "0").text("Error - " + errorThrown));
         });
       }

       function logError(errorMessage) {
         if (!errorMessage) {
           return;
         }

         var error = {
           errorMessage: errorMessage
         };
         $.ajax({
           type: "GET",
           url: baseUrl + "/V" + widgetVersion + "/Error/LogError",
           data: error,
           dataType: "json",
           contentType: "application/json; charset=utf-8"
         });
       }

       function getParameterByName(name) {
         name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
         var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
             results = regex.exec(location.search);
         return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
       }

       var JSON;

       if (!JSON) {
         JSON = {};
       }

       (function () {
         function f(n) {
           return n < 10 ? "0" + n : n;
         }

         if (typeof Date.prototype.toJSON !== "function") {
           Date.prototype.toJSON = function (key) {
             return isFinite(this.valueOf()) ? this.getUTCFullYear() + "-" + f(this.getUTCMonth() + 1) + "-" + f(this.getUTCDate()) + "T" + f(this.getUTCHours()) + ":" + f(this.getUTCMinutes()) + ":" + f(this.getUTCSeconds()) + "Z" : null;
           };

           String.prototype.toJSON = Number.prototype.toJSON = Boolean.prototype.toJSON = function (key) {
             return this.valueOf();
           };
         }

         var cx = /[\u0000\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,
             escapable = /[\\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,
             gap,
             indent,
             meta = {
           "\b": "\\b",
           "\t": "\\t",
           "\n": "\\n",
           "\f": "\\f",
           "\r": "\\r",
           '"': '\\"',
           "\\": "\\\\"
         },
             rep;

         function quote(string) {
           escapable.lastIndex = 0;
           return escapable.test(string) ? '"' + string.replace(escapable, function (a) {
             var c = meta[a];
             return typeof c === "string" ? c : "\\u" + ("0000" + a.charCodeAt(0).toString(16)).slice(-4);
           }) + '"' : '"' + string + '"';
         }

         function str(key, holder) {
           var i,
               k,
               v,
               length,
               mind = gap,
               partial,
               value = holder[key];

           if (value && _typeof(value) === "object" && typeof value.toJSON === "function") {
             value = value.toJSON(key);
           }

           if (typeof rep === "function") {
             value = rep.call(holder, key, value);
           }

           switch (_typeof(value)) {
             case "string":
               return quote(value);

             case "number":
               return isFinite(value) ? String(value) : "null";

             case "boolean":
             case "null":
               return String(value);

             case "object":
               if (!value) {
                 return "null";
               }

               gap += indent;
               partial = [];

               if (Object.prototype.toString.apply(value) === "[object Array]") {
                 length = value.length;

                 for (i = 0; i < length; i += 1) {
                   partial[i] = str(i, value) || "null";
                 }

                 v = partial.length === 0 ? "[]" : gap ? "[\n" + gap + partial.join(",\n" + gap) + "\n" + mind + "]" : "[" + partial.join(",") + "]";
                 gap = mind;
                 return v;
               }

               if (rep && _typeof(rep) === "object") {
                 length = rep.length;

                 for (i = 0; i < length; i += 1) {
                   if (typeof rep[i] === "string") {
                     k = rep[i];
                     v = str(k, value);

                     if (v) {
                       partial.push(quote(k) + (gap ? ": " : ":") + v);
                     }
                   }
                 }
               } else {
                 for (k in value) {
                   if (Object.prototype.hasOwnProperty.call(value, k)) {
                     v = str(k, value);

                     if (v) {
                       partial.push(quote(k) + (gap ? ": " : ":") + v);
                     }
                   }
                 }
               }

               v = partial.length === 0 ? "{}" : gap ? "{\n" + gap + partial.join(",\n" + gap) + "\n" + mind + "}" : "{" + partial.join(",") + "}";
               gap = mind;
               return v;
           }
         }

         if (typeof JSON.stringify !== "function") {
           JSON.stringify = function (value, replacer, space) {
             var i;
             gap = "";
             indent = "";

             if (typeof space === "number") {
               for (i = 0; i < space; i += 1) {
                 indent += " ";
               }
             } else {
               if (typeof space === "string") {
                 indent = space;
               }
             }

             rep = replacer;

             if (replacer && typeof replacer !== "function" && (_typeof(replacer) !== "object" || typeof replacer.length !== "number")) {
               throw new Error("JSON.stringify");
             }

             return str("", {
               "": value
             });
           };
         }

         if (typeof JSON.parse !== "function") {
           JSON.parse = function (text, reviver) {
             var j;

             function walk(holder, key) {
               var k,
                   v,
                   value = holder[key];

               if (value && _typeof(value) === "object") {
                 for (k in value) {
                   if (Object.prototype.hasOwnProperty.call(value, k)) {
                     v = walk(value, k);

                     if (v !== undefined) {
                       value[k] = v;
                     } else {
                       delete value[k];
                     }
                   }
                 }
               }

               return reviver.call(holder, key, value);
             }

             text = String(text);
             cx.lastIndex = 0;

             if (cx.test(text)) {
               text = text.replace(cx, function (a) {
                 return "\\u" + ("0000" + a.charCodeAt(0).toString(16)).slice(-4);
               });
             }

             if (/^[\],:{}\s]*$/.test(text.replace(/\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g, "@").replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, "]").replace(/(?:^|:|,)(?:\s*\[)+/g, ""))) {
               j = eval("(" + text + ")");
               return typeof reviver === "function" ? walk({
                 "": j
               }, "") : j;
             }

             throw new SyntaxError("JSON.parse");
           };
         }
       })();

       (function (a) {
         var d = {};
         d.fileapi = a("<input type='file'/>").get(0).files !== undefined;
         d.formdata = window.FormData !== undefined;
         var e = !!a.fn.prop;

         a.fn.attr2 = function () {
           if (!e) {
             return this.attr.apply(this, arguments);
           }

           var g = this.prop.apply(this, arguments);

           if (g && g.jquery || typeof g === "string") {
             return g;
           }

           return this.attr.apply(this, arguments);
         };

         a.fn.ajaxSubmit = function (B) {
           if (!this.length) {
             f("ajaxSubmit: skipping submit process - no element selected");
             return this;
           }

           var v,
               i,
               G,
               g = this;

           if (typeof B == "function") {
             B = {
               success: B
             };
           }

           v = this.attr2("method");
           i = this.attr2("action");
           G = typeof i === "string" ? a.trim(i) : "";
           G = G || window.location.href || "";

           if (G) {
             G = (G.match(/^([^#]+)/) || [])[1];
           }

           B = a.extend(true, {
             url: G,
             success: a.ajaxSettings.success,
             type: v || "GET",
             iframeSrc: /^https/i.test(window.location.href || "") ? "javascript:false" : "about:blank"
           }, B);
           var H = {};
           this.trigger("form-pre-serialize", [this, B, H]);

           if (H.veto) {
             f("ajaxSubmit: submit vetoed via form-pre-serialize trigger");
             return this;
           }

           if (B.beforeSerialize && B.beforeSerialize(this, B) === false) {
             f("ajaxSubmit: submit aborted via beforeSerialize callback");
             return this;
           }

           var F = B.traditional;

           if (F === undefined) {
             F = a.ajaxSettings.traditional;
           }

           var m = [];
           var D,
               h = this.formToArray(B.semantic, m);

           if (B.data) {
             B.extraData = B.data;
             D = a.param(B.data, F);
           }

           if (B.beforeSubmit && B.beforeSubmit(h, this, B) === false) {
             f("ajaxSubmit: submit aborted via beforeSubmit callback");
             return this;
           }

           this.trigger("form-submit-validate", [h, this, B, H]);

           if (H.veto) {
             f("ajaxSubmit: submit vetoed via form-submit-validate trigger");
             return this;
           }

           var C = a.param(h, F);

           if (D) {
             C = C ? C + "&" + D : D;
           }

           if (B.type.toUpperCase() == "GET") {
             B.url += (B.url.indexOf("?") >= 0 ? "&" : "?") + C;
             B.data = null;
           } else {
             B.data = C;
           }

           var j = [];

           if (B.resetForm) {
             j.push(function () {
               g.resetForm();
             });
           }

           if (B.clearForm) {
             j.push(function () {
               g.clearForm(B.includeHidden);
             });
           }

           if (!B.dataType && B.target) {
             var A = B.success || function () {};

             j.push(function (k) {
               var q = B.replaceTarget ? "replaceWith" : "html";
               a(B.target)[q](k).each(A, arguments);
             });
           } else {
             if (B.success) {
               j.push(B.success);
             }
           }

           B.success = function (q, K, L) {
             var k = B.context || this;

             for (var I = 0, J = j.length; I < J; I++) {
               j[I].apply(k, [q, K, L || g, g]);
             }
           };

           if (B.error) {
             var z = B.error;

             B.error = function (J, I, q) {
               var k = B.context || this;
               z.apply(k, [J, I, q, g]);
             };
           }

           if (B.complete) {
             var y = B.complete;

             B.complete = function (I, q) {
               var k = B.context || this;
               y.apply(k, [I, q, g]);
             };
           }

           var o = a('input[type=file]:enabled[value!=""]', this);
           var s = o.length > 0;
           var w = "multipart/form-data";
           var x = g.attr("enctype") == w || g.attr("encoding") == w;
           var n = d.fileapi && d.formdata;
           f("fileAPI :" + n);
           var E = (s || x) && !n;
           var t;

           if (B.iframe !== false && (B.iframe || E)) {
             if (B.closeKeepAlive) {
               a.get(B.closeKeepAlive, function () {
                 t = p(h);
               });
             } else {
               t = p(h);
             }
           } else {
             if ((s || x) && n) {
               t = r(h);
             } else {
               t = a.ajax(B);
             }
           }

           g.removeData("jqxhr").data("jqxhr", t);

           for (var u = 0; u < m.length; u++) {
             m[u] = null;
           }

           this.trigger("form-submit-notify", [this, B]);
           return this;

           function l(k) {
             var L = a.param(k).split("&");
             var I = L.length;
             var K = [];
             var q, J;

             for (q = 0; q < I; q++) {
               L[q] = L[q].replace(/\+/g, " ");
               J = L[q].split("=");
               K.push([decodeURIComponent(J[0]), decodeURIComponent(J[1])]);
             }

             return K;
           }

           function r(k) {
             var I = new FormData();

             for (var J = 0; J < k.length; J++) {
               I.append(k[J].name, k[J].value);
             }

             if (B.extraData) {
               var L = l(B.extraData);

               for (J = 0; J < L.length; J++) {
                 if (L[J]) {
                   I.append(L[J][0], L[J][1]);
                 }
               }
             }

             B.data = null;
             var K = a.extend(true, {}, a.ajaxSettings, B, {
               contentType: false,
               processData: false,
               cache: false,
               type: v || "POST"
             });

             if (B.uploadProgress) {
               K.xhr = function () {
                 var M = jQuery.ajaxSettings.xhr();

                 if (M.upload) {
                   M.upload.addEventListener("progress", function (N) {
                     var O = 0;
                     var P = N.loaded || N.position;
                     var Q = N.total;

                     if (N.lengthComputable) {
                       O = Math.ceil(P / Q * 100);
                     }

                     B.uploadProgress(N, P, Q, O);
                   }, false);
                 }

                 return M;
               };
             }

             K.data = null;
             var q = K.beforeSend;

             K.beforeSend = function (N, M) {
               M.data = I;

               if (q) {
                 q.call(this, N, M);
               }
             };

             return a.ajax(K);
           }

           function p(q) {
             var T = g[0],
                 S,
                 X,
                 ac,
                 U,
                 Y,
                 k,
                 Z,
                 ai,
                 ae,
                 aa,
                 af,
                 ag;
             var O = a.Deferred();

             if (q) {
               for (X = 0; X < m.length; X++) {
                 S = a(m[X]);

                 if (e) {
                   S.prop("disabled", false);
                 } else {
                   S.removeAttr("disabled");
                 }
               }
             }

             ac = a.extend(true, {}, a.ajaxSettings, B);
             ac.context = ac.context || ac;
             Y = "jqFormIO" + new Date().getTime();

             if (ac.iframeTarget) {
               k = a(ac.iframeTarget);
               aa = k.attr2("name");

               if (!aa) {
                 k.attr2("name", Y);
               } else {
                 Y = aa;
               }
             } else {
               k = a('<iframe name="' + Y + '" src="' + ac.iframeSrc + '" />');
               k.css({
                 position: "absolute",
                 top: "-1000px",
                 left: "-1000px"
               });
             }

             Z = k[0];
             ai = {
               aborted: 0,
               responseText: null,
               responseXML: null,
               status: 0,
               statusText: "n/a",
               getAllResponseHeaders: function getAllResponseHeaders() {},
               getResponseHeader: function getResponseHeader() {},
               setRequestHeader: function setRequestHeader() {},
               abort: function abort(al) {
                 var aj = al === "timeout" ? "timeout" : "aborted";
                 f("aborting upload... " + aj);
                 this.aborted = 1;

                 try {
                   if (Z.contentWindow.document.execCommand) {
                     Z.contentWindow.document.execCommand("Stop");
                   }
                 } catch (ak) {}

                 k.attr("src", ac.iframeSrc);
                 ai.error = aj;

                 if (ac.error) {
                   ac.error.call(ac.context, ai, aj, al);
                 }

                 if (U) {
                   a.event.trigger("ajaxError", [ai, ac, aj]);
                 }

                 if (ac.complete) {
                   ac.complete.call(ac.context, ai, aj);
                 }
               }
             };
             U = ac.global;

             if (U && 0 === a.active++) {
               a.event.trigger("ajaxStart");
             }

             if (U) {
               a.event.trigger("ajaxSend", [ai, ac]);
             }

             if (ac.beforeSend && ac.beforeSend.call(ac.context, ai, ac) === false) {
               if (ac.global) {
                 a.active--;
               }

               O.reject();
               return O;
             }

             if (ai.aborted) {
               O.reject();
               return O;
             }

             ae = T.clk;

             if (ae) {
               aa = ae.name;

               if (aa && !ae.disabled) {
                 ac.extraData = ac.extraData || {};
                 ac.extraData[aa] = ae.value;

                 if (ae.type == "image") {
                   ac.extraData[aa + ".x"] = T.clk_x;
                   ac.extraData[aa + ".y"] = T.clk_y;
                 }
               }
             }

             var K = 1;
             var ad = 2;

             function V(al) {
               var aj = null;

               try {
                 if (al.contentWindow) {
                   aj = al.contentWindow.document;
                 }
               } catch (ak) {
                 f("cannot get iframe.contentWindow document: " + ak);
               }

               if (aj) {
                 return aj;
               }

               try {
                 aj = al.contentDocument ? al.contentDocument : al.document;
               } catch (ak) {
                 f("cannot get iframe.contentDocument: " + ak);
                 aj = al.document;
               }

               return aj;
             }

             var M = a("meta[name=csrf-token]").attr("content");
             var L = a("meta[name=csrf-param]").attr("content");

             if (L && M) {
               ac.extraData = ac.extraData || {};
               ac.extraData[L] = M;
             }

             function R() {
               var ap = g.attr2("target"),
                   aj = g.attr2("action");
               T.setAttribute("target", Y);

               if (!v) {
                 T.setAttribute("method", "POST");
               }

               if (aj != ac.url) {
                 T.setAttribute("action", ac.url);
               }

               if (!ac.skipEncodingOverride && (!v || /post/i.test(v))) {
                 g.attr({
                   encoding: "multipart/form-data",
                   enctype: "multipart/form-data"
                 });
               }

               if (ac.timeout) {
                 ag = setTimeout(function () {
                   af = true;
                   J(K);
                 }, ac.timeout);
               }

               function ak() {
                 try {
                   var ar = V(Z).readyState;
                   f("state = " + ar);

                   if (ar && ar.toLowerCase() == "uninitialized") {
                     setTimeout(ak, 50);
                   }
                 } catch (aq) {
                   f("Server abort: ", aq, " (", aq.name, ")");
                   J(ad);

                   if (ag) {
                     clearTimeout(ag);
                   }

                   ag = undefined;
                 }
               }

               var am = [];

               try {
                 if (ac.extraData) {
                   for (var an in ac.extraData) {
                     if (ac.extraData.hasOwnProperty(an)) {
                       if (a.isPlainObject(ac.extraData[an]) && ac.extraData[an].hasOwnProperty("name") && ac.extraData[an].hasOwnProperty("value")) {
                         am.push(a('<input type="hidden" name="' + ac.extraData[an].name + '">').val(ac.extraData[an].value).appendTo(T)[0]);
                       } else {
                         am.push(a('<input type="hidden" name="' + an + '">').val(ac.extraData[an]).appendTo(T)[0]);
                       }
                     }
                   }
                 }

                 if (!ac.iframeTarget) {
                   k.appendTo("body");

                   if (Z.attachEvent) {
                     Z.attachEvent("onload", J);
                   } else {
                     Z.addEventListener("load", J, false);
                   }
                 }

                 setTimeout(ak, 15);

                 try {
                   T.submit();
                 } catch (al) {
                   var ao = document.createElement("form").submit;
                   ao.apply(T);
                 }
               } finally {
                 T.setAttribute("action", aj);

                 if (ap) {
                   T.setAttribute("target", ap);
                 } else {
                   g.removeAttr("target");
                 }

                 a(am).remove();
               }
             }

             if (ac.forceSync) {
               R();
             } else {
               setTimeout(R, 10);
             }

             var N,
                 P,
                 Q = 50,
                 I;

             function J(am) {
               if (ai.aborted || I) {
                 return;
               }

               P = V(Z);

               if (!P) {
                 f("cannot access response document");
                 am = ad;
               }

               if (am === K && ai) {
                 ai.abort("timeout");
                 O.reject(ai, "timeout");
                 return;
               } else {
                 if (am == ad && ai) {
                   ai.abort("server abort");
                   O.reject(ai, "error", "server abort");
                   return;
                 }
               }

               if (!P || P.location.href == ac.iframeSrc) {
                 if (!af) {
                   return;
                 }
               }

               if (Z.detachEvent) {
                 Z.detachEvent("onload", J);
               } else {
                 Z.removeEventListener("load", J, false);
               }

               var at = "success",
                   ao;

               try {
                 if (af) {
                   throw "timeout";
                 }

                 var ap = ac.dataType == "xml" || P.XMLDocument || a.isXMLDoc(P);
                 f("isXml=" + ap);

                 if (!ap && window.opera && (P.body === null || !P.body.innerHTML)) {
                   if (--Q) {
                     f("requeing onLoad callback, DOM not available");
                     setTimeout(J, 250);
                     return;
                   }
                 }

                 var ak = P.body ? P.body : P.documentElement;
                 ai.responseText = ak ? ak.innerHTML : null;
                 ai.responseXML = P.XMLDocument ? P.XMLDocument : P;

                 if (ap) {
                   ac.dataType = "xml";
                 }

                 ai.getResponseHeader = function (av) {
                   var aw = {
                     "content-type": ac.dataType
                   };
                   return aw[av];
                 };

                 if (ak) {
                   ai.status = Number(ak.getAttribute("status")) || ai.status;
                   ai.statusText = ak.getAttribute("statusText") || ai.statusText;
                 }

                 var al = (ac.dataType || "").toLowerCase();
                 var ar = /(json|script|text)/.test(al);

                 if (ar || ac.textarea) {
                   var au = P.getElementsByTagName("textarea")[0];

                   if (au) {
                     ai.responseText = au.value;
                     ai.status = Number(au.getAttribute("status")) || ai.status;
                     ai.statusText = au.getAttribute("statusText") || ai.statusText;
                   } else {
                     if (ar) {
                       var aq = P.getElementsByTagName("pre")[0];
                       var aj = P.getElementsByTagName("body")[0];

                       if (aq) {
                         ai.responseText = aq.textContent ? aq.textContent : aq.innerText;
                       } else {
                         if (aj) {
                           ai.responseText = aj.textContent ? aj.textContent : aj.innerText;
                         }
                       }
                     }
                   }
                 } else {
                   if (al == "xml" && !ai.responseXML && ai.responseText) {
                     ai.responseXML = ah(ai.responseText);
                   }
                 }

                 try {
                   N = W(ai, al, ac);
                 } catch (an) {
                   at = "parsererror";
                   ai.error = ao = an || at;
                 }
               } catch (an) {
                 f("error caught: ", an);
                 at = "error";
                 ai.error = ao = an || at;
               }

               if (ai.aborted) {
                 f("upload aborted");
                 at = null;
               }

               if (ai.status) {
                 at = ai.status >= 200 && ai.status < 300 || ai.status === 304 ? "success" : "error";
               }

               if (at === "success") {
                 if (ac.success) {
                   ac.success.call(ac.context, N, "success", ai);
                 }

                 O.resolve(ai.responseText, "success", ai);

                 if (U) {
                   a.event.trigger("ajaxSuccess", [ai, ac]);
                 }
               } else {
                 if (at) {
                   if (ao === undefined) {
                     ao = ai.statusText;
                   }

                   if (ac.error) {
                     ac.error.call(ac.context, ai, at, ao);
                   }

                   O.reject(ai, "error", ao);

                   if (U) {
                     a.event.trigger("ajaxError", [ai, ac, ao]);
                   }
                 }
               }

               if (U) {
                 a.event.trigger("ajaxComplete", [ai, ac]);
               }

               if (U && ! --a.active) {
                 a.event.trigger("ajaxStop");
               }

               if (ac.complete) {
                 ac.complete.call(ac.context, ai, at);
               }

               I = true;

               if (ac.timeout) {
                 clearTimeout(ag);
               }

               setTimeout(function () {
                 if (!ac.iframeTarget) {
                   k.remove();
                 }

                 ai.responseXML = null;
               }, 100);
             }

             var ah = a.parseXML || function (ak, aj) {
               if (window.ActiveXObject) {
                 aj = new ActiveXObject("Microsoft.XMLDOM");
                 aj.async = "false";
                 aj.loadXML(ak);
               } else {
                 aj = new DOMParser().parseFromString(ak, "text/xml");
               }

               return aj && aj.documentElement && aj.documentElement.nodeName != "parsererror" ? aj : null;
             };

             var ab = a.parseJSON || function (aj) {
               return window["eval"]("(" + aj + ")");
             };

             var W = function W(an, am, al) {
               var aj = an.getResponseHeader("content-type") || "",
                   ao = am === "xml" || !am && aj.indexOf("xml") >= 0,
                   ak = ao ? an.responseXML : an.responseText;

               if (ao && ak.documentElement.nodeName === "parsererror") {
                 if (a.error) {
                   a.error("parsererror");
                 }
               }

               if (al && al.dataFilter) {
                 ak = al.dataFilter(ak, am);
               }

               if (typeof ak === "string") {
                 if (am === "json" || !am && aj.indexOf("json") >= 0) {
                   ak = ab(ak);
                 } else {
                   if (am === "script" || !am && aj.indexOf("javascript") >= 0) {
                     a.globalEval(ak);
                   }
                 }
               }

               return ak;
             };

             return O;
           }
         };

         a.fn.ajaxForm = function (h) {
           h = h || {};
           h.delegation = h.delegation && a.isFunction(a.fn.on);

           if (!h.delegation && this.length === 0) {
             var g = {
               s: this.selector,
               c: this.context
             };

             if (!a.isReady && g.s) {
               f("DOM not ready, queuing ajaxForm");
               a(function () {
                 a(g.s, g.c).ajaxForm(h);
               });
               return this;
             }

             f("terminating; zero elements found by selector" + (a.isReady ? "" : " (DOM not ready)"));
             return this;
           }

           if (h.delegation) {
             a(document).off("submit.form-plugin", this.selector, c).off("click.form-plugin", this.selector, b).on("submit.form-plugin", this.selector, h, c).on("click.form-plugin", this.selector, h, b);
             return this;
           }

           return this.ajaxFormUnbind().bind("submit.form-plugin", h, c).bind("click.form-plugin", h, b);
         };

         function c(g) {
           var h = g.data;

           if (!g.isDefaultPrevented()) {
             g.preventDefault();
             a(this).ajaxSubmit(h);
           }
         }

         function b(h) {
           var l = h.target;
           var g = a(l);

           if (!g.is("[type=submit],[type=image]")) {
             var k = g.closest("[type=submit]");

             if (k.length === 0) {
               return;
             }

             l = k[0];
           }

           var i = this;
           i.clk = l;

           if (l.type == "image") {
             if (h.offsetX !== undefined) {
               i.clk_x = h.offsetX;
               i.clk_y = h.offsetY;
             } else {
               if (typeof a.fn.offset == "function") {
                 var j = g.offset();
                 i.clk_x = h.pageX - j.left;
                 i.clk_y = h.pageY - j.top;
               } else {
                 i.clk_x = h.pageX - l.offsetLeft;
                 i.clk_y = h.pageY - l.offsetTop;
               }
             }
           }

           setTimeout(function () {
             i.clk = i.clk_x = i.clk_y = null;
           }, 100);
         }

         a.fn.ajaxFormUnbind = function () {
           return this.unbind("submit.form-plugin click.form-plugin");
         };

         a.fn.formToArray = function (x, l) {
           var h = [];

           if (this.length === 0) {
             return h;
           }

           var p = this[0];
           var m = x ? p.getElementsByTagName("*") : p.elements;

           if (!m) {
             return h;
           }

           var q, s, w, y, k, u, t;

           for (q = 0, u = m.length; q < u; q++) {
             k = m[q];
             w = k.name;

             if (!w || k.disabled) {
               continue;
             }

             if (x && p.clk && k.type == "image") {
               if (p.clk == k) {
                 h.push({
                   name: w,
                   value: a(k).val(),
                   type: k.type
                 });
                 h.push({
                   name: w + ".x",
                   value: p.clk_x
                 }, {
                   name: w + ".y",
                   value: p.clk_y
                 });
               }

               continue;
             }

             y = a.fieldValue(k, true);

             if (y && y.constructor == Array) {
               if (l) {
                 l.push(k);
               }

               for (s = 0, t = y.length; s < t; s++) {
                 h.push({
                   name: w,
                   value: y[s]
                 });
               }
             } else {
               if (d.fileapi && k.type == "file") {
                 if (l) {
                   l.push(k);
                 }

                 var o = k.files;

                 if (o.length) {
                   for (s = 0; s < o.length; s++) {
                     h.push({
                       name: w,
                       value: o[s],
                       type: k.type
                     });
                   }
                 } else {
                   h.push({
                     name: w,
                     value: "",
                     type: k.type
                   });
                 }
               } else {
                 if (y !== null && typeof y != "undefined") {
                   if (l) {
                     l.push(k);
                   }

                   h.push({
                     name: w,
                     value: y,
                     type: k.type,
                     required: k.required
                   });
                 }
               }
             }
           }

           if (!x && p.clk) {
             var g = a(p.clk),
                 r = g[0];
             w = r.name;

             if (w && !r.disabled && r.type == "image") {
               h.push({
                 name: w,
                 value: g.val()
               });
               h.push({
                 name: w + ".x",
                 value: p.clk_x
               }, {
                 name: w + ".y",
                 value: p.clk_y
               });
             }
           }

           return h;
         };

         a.fn.formSerialize = function (g) {
           return a.param(this.formToArray(g));
         };

         a.fn.fieldSerialize = function (h) {
           var g = [];
           this.each(function () {
             var l = this.name;

             if (!l) {
               return;
             }

             var m = a.fieldValue(this, h);

             if (m && m.constructor == Array) {
               for (var j = 0, k = m.length; j < k; j++) {
                 g.push({
                   name: l,
                   value: m[j]
                 });
               }
             } else {
               if (m !== null && typeof m != "undefined") {
                 g.push({
                   name: this.name,
                   value: m
                 });
               }
             }
           });
           return a.param(g);
         };

         a.fn.fieldValue = function (k) {
           for (var m = [], h = 0, j = this.length; h < j; h++) {
             var g = this[h];
             var l = a.fieldValue(g, k);

             if (l === null || typeof l == "undefined" || l.constructor == Array && !l.length) {
               continue;
             }

             if (l.constructor == Array) {
               a.merge(m, l);
             } else {
               m.push(l);
             }
           }

           return m;
         };

         a.fieldValue = function (h, r) {
           var m = h.name,
               s = h.type,
               u = h.tagName.toLowerCase();

           if (r === undefined) {
             r = true;
           }

           if (r && (!m || h.disabled || s == "reset" || s == "button" || (s == "checkbox" || s == "radio") && !h.checked || (s == "submit" || s == "image") && h.form && h.form.clk != h || u == "select" && h.selectedIndex == -1)) {
             return null;
           }

           if (u == "select") {
             var k = h.selectedIndex;

             if (k < 0) {
               return null;
             }

             var g = [],
                 q = h.options;
             var o = s == "select-one";
             var l = o ? k + 1 : q.length;

             for (var j = o ? k : 0; j < l; j++) {
               var p = q[j];

               if (p.selected) {
                 var w = p.value;

                 if (!w) {
                   w = p.attributes && p.attributes.value && !p.attributes.value.specified ? p.text : p.value;
                 }

                 if (o) {
                   return w;
                 }

                 g.push(w);
               }
             }

             return g;
           }

           return a(h).val();
         };

         a.fn.clearForm = function (g) {
           return this.each(function () {
             a("input,select,textarea", this).clearFields(g);
           });
         };

         a.fn.clearFields = a.fn.clearInputs = function (g) {
           var h = /^(?:color|date|datetime|email|month|number|password|range|search|tel|text|time|url|week)$/i;
           return this.each(function () {
             var i = this.type,
                 j = this.tagName.toLowerCase();

             if (h.test(i) || j == "textarea") {
               this.value = "";
             } else {
               if (i == "checkbox" || i == "radio") {
                 this.checked = false;
               } else {
                 if (j == "select") {
                   this.selectedIndex = -1;
                 } else {
                   if (i == "file") {
                     if (/MSIE/.test(navigator.userAgent)) {
                       a(this).replaceWith(a(this).clone(true));
                     } else {
                       a(this).val("");
                     }
                   } else {
                     if (g) {
                       if (g === true && /hidden/.test(i) || typeof g == "string" && a(this).is(g)) {
                         this.value = "";
                       }
                     }
                   }
                 }
               }
             }
           });
         };

         a.fn.resetForm = function () {
           return this.each(function () {
             if (typeof this.reset == "function" || _typeof(this.reset) == "object" && !this.reset.nodeType) {
               this.reset();
             }
           });
         };

         a.fn.enable = function (g) {
           if (g === undefined) {
             g = true;
           }

           return this.each(function () {
             this.disabled = !g;
           });
         };

         a.fn.selected = function (g) {
           if (g === undefined) {
             g = true;
           }

           return this.each(function () {
             var i = this.type;

             if (i == "checkbox" || i == "radio") {
               this.checked = g;
             } else {
               if (this.tagName.toLowerCase() == "option") {
                 var h = a(this).parent("select");

                 if (g && h[0] && h[0].type == "select-one") {
                   h.find("option").selected(false);
                 }

                 this.selected = g;
               }
             }
           });
         };

         a.fn.ajaxSubmit.debug = false;

         function f() {
           if (!a.fn.ajaxSubmit.debug) {
             return;
           }

           var g = "[jquery.form] " + Array.prototype.join.call(arguments, "");

           if (window.console && window.console.log) {
             window.console.log(g);
           } else {
             if (window.opera && window.opera.postError) {
               window.opera.postError(g);
             }
           }
         }
       })($);

       !function () {
         function a(a, b, c) {
           "addEventListener" in window ? a.addEventListener(b, c, !1) : "attachEvent" in window && a.attachEvent("on" + b, c);
         }

         function b() {
           var a,
               b = ["moz", "webkit", "o", "ms"];

           for (a = 0; a < b.length && !w; a += 1) {
             w = window[b[a] + "RequestAnimationFrame"];
           }

           w || c(" RequestAnimationFrame not supported");
         }

         function c(a) {
           y.log && "object" == (typeof console === "undefined" ? "undefined" : _typeof(console)) && console.log(s + "[Host page" + u + "]" + a);
         }

         function d(a) {
           function b() {
             function a() {
               h(z), f(), y.resizedCallback(z);
             }

             i(a, z, "resetPage");
           }

           function d(a) {
             var b = a.id;
             c(" Removing iFrame: " + b), a.parentNode.removeChild(a), y.closedCallback(b), c(" --");
           }

           function e() {
             var a = x.substr(t).split(":");
             return {
               iframe: document.getElementById(a[0]),
               id: a[0],
               height: a[1],
               width: a[2],
               type: a[3]
             };
           }

           function j(a) {
             var b = Number(y["max" + a]),
                 d = Number(y["min" + a]),
                 e = a.toLowerCase(),
                 f = Number(z[e]);

             if (d > b) {
               throw new Error("Value for min" + a + " can not be greater than max" + a);
             }

             c(" Checking " + e + " is in range " + d + "-" + b), d > f && (f = d, c(" Set " + e + " to min value")), f > b && (f = b, c(" Set " + e + " to max value")), z[e] = "" + f;
           }

           function k() {
             var b = a.origin,
                 d = z.iframe.src.split("/").slice(0, 3).join("/");

             if (y.checkOrigin && (c(" Checking connection is from: " + d), "" + b != "null" && b !== d)) {
               throw new Error("Unexpected message received from: " + b + " for " + z.iframe.id + ". Message was: " + a.data + ". This error can be disabled by adding the checkOrigin: false option.");
             }

             return !0;
           }

           function l() {
             return s === ("" + x).substr(0, t);
           }

           function m() {
             var a = (z.type in {
               true: 1,
               false: 1
             });
             return a && c(" Ignoring init message from meta parent page"), a;
           }

           function n() {
             var a = x.substr(x.indexOf(":") + r + 6);
             c(" MessageCallback passed: {iframe: " + z.iframe.id + ", message: " + a + "}"), y.messageCallback({
               iframe: z.iframe,
               message: a
             }), c(" --");
           }

           function o() {
             if (null === z.iframe) {
               throw new Error("iFrame (" + z.id + ") does not exist on " + u);
             }

             return !0;
           }

           function q() {
             c(" Reposition requested from iFrame"), v = {
               x: z.width,
               y: z.height
             }, f();
           }

           function w() {
             switch (z.type) {
               case "close":
                 d(z.iframe), y.resizedCallback(z);
                 break;

               case "message":
                 n();
                 break;

               case "scrollTo":
                 q();
                 break;

               case "reset":
                 g(z);
                 break;

               case "init":
                 b(), y.initCallback(z.iframe);
                 break;

               default:
                 b();
             }
           }

           var x = a.data,
               z = {};
           l() && (c(" Received: " + x), z = e(), j("Height"), j("Width"), !m() && o() && k() && (w(), p = !1));
         }

         function e() {
           null === v && (v = {
             x: void 0 !== window.pageXOffset ? window.pageXOffset : document.documentElement.scrollLeft,
             y: void 0 !== window.pageYOffset ? window.pageYOffset : document.documentElement.scrollTop
           }, c(" Get position: " + v.x + "," + v.y));
         }

         function f() {
           null !== v && (window.scrollTo(v.x, v.y), c(" Set position: " + v.x + "," + v.y), v = null);
         }

         function g(a) {
           function b() {
             h(a), j("reset", "reset", a.iframe);
           }

           c(" Size reset requested by " + ("init" === a.type ? "host page" : "iFrame")), e(), i(b, a, "init");
         }

         function h(a) {
           function b(b) {
             a.iframe.style[b] = a[b] + "px", c(" IFrame (" + a.iframe.id + ") " + b + " set to " + a[b] + "px");
           }

           y.sizeHeight && b("height"), y.sizeWidth && b("width");
         }

         function i(a, b, d) {
           d !== b.type && w ? (c(" Requesting animation frame"), w(a)) : a();
         }

         function j(a, b, d) {
           c("[" + a + "] Sending msg to iframe (" + b + ")"), d.contentWindow.postMessage(s + b, "*");
         }

         function k() {
           function b() {
             function a(a) {
               1 / 0 !== y[a] && 0 !== y[a] && (k.style[a] = y[a] + "px", c(" Set " + a + " = " + y[a] + "px"));
             }

             a("maxHeight"), a("minHeight"), a("maxWidth"), a("minWidth");
           }

           function d(a) {
             return "" === a && (k.id = a = "iFrameResizer" + o++, c(" Added missing iframe ID: " + a + " (" + k.src + ")")), a;
           }

           function e() {
             c(" IFrame scrolling " + (y.scrolling ? "enabled" : "disabled") + " for " + l), k.style.overflow = !1 === y.scrolling ? "hidden" : "auto", k.scrolling = !1 === y.scrolling ? "no" : "yes";
           }

           function f() {
             ("number" == typeof y.bodyMargin || "0" === y.bodyMargin) && (y.bodyMarginV1 = y.bodyMargin, y.bodyMargin = "" + y.bodyMargin + "px");
           }

           function h() {
             return l + ":" + y.bodyMarginV1 + ":" + y.sizeWidth + ":" + y.log + ":" + y.interval + ":" + y.enablePublicMethods + ":" + y.autoResize + ":" + y.bodyMargin + ":" + y.heightCalculationMethod + ":" + y.bodyBackground + ":" + y.bodyPadding + ":" + y.tolerance;
           }

           function i(b) {
             a(k, "load", function () {
               var a = p;
               j("iFrame.onload", b, k), !a && y.heightCalculationMethod in x && g({
                 iframe: k,
                 height: 0,
                 width: 0,
                 type: "init"
               });
             }), j("init", b, k);
           }

           var k = this,
               l = d(k.id);
           e(), b(), f(), i(h());
         }

         function l(a) {
           if ("object" != _typeof(a)) {
             throw new TypeError("Options is not an object.");
           }
         }

         function m() {
           function a(a) {
             if ("IFRAME" !== a.tagName.toUpperCase()) {
               throw new TypeError("Expected <IFRAME> tag, found <" + a.tagName + ">.");
             }

             k.call(a);
           }

           function b(a) {
             a = a || {}, l(a);

             for (var b in z) {
               z.hasOwnProperty(b) && (y[b] = a.hasOwnProperty(b) ? a[b] : z[b]);
             }
           }

           return function (c, d) {
             b(c), Array.prototype.forEach.call(document.querySelectorAll(d || "iframe"), a);
           };
         }

         function n(a) {
           a.fn.iFrameResize = function (b) {
             return l(b), y = a.extend({}, z, b), this.filter("iframe").each(k).end();
           };
         }

         var o = 0,
             p = !0,
             q = "message",
             r = q.length,
             s = "[iFrameSizer]",
             t = s.length,
             u = "",
             v = null,
             w = window.requestAnimationFrame,
             x = {
           max: 1,
           scroll: 1,
           bodyScroll: 1,
           documentElementScroll: 1
         },
             y = {},
             z = {
           autoResize: !0,
           bodyBackground: null,
           bodyMargin: null,
           bodyMarginV1: 8,
           bodyPadding: null,
           checkOrigin: !0,
           enablePublicMethods: !1,
           heightCalculationMethod: "offset",
           interval: 32,
           log: !1,
           maxHeight: 1 / 0,
           maxWidth: 1 / 0,
           minHeight: 0,
           minWidth: 0,
           scrolling: !1,
           sizeHeight: !0,
           sizeWidth: !1,
           tolerance: 0,
           closedCallback: function closedCallback() {},
           initCallback: function initCallback() {},
           messageCallback: function messageCallback() {},
           resizedCallback: function resizedCallback() {}
         };
         b(), a(window, "message", d), "jQuery" in window && n(jQuery), "function" == typeof define && __webpack_require__(248) ? define(function () {
           return m();
         }) : window.iFrameResize = m();
       }();
     });
   }
 })();

 /***/ }),
 /* 253 */
 /***/ (function(module, exports) {

 (function () {
   window.onload = function () {
     var reviewSection = document.querySelector(".reviews_section");
     //var reviewSectionV3 = document.querySelector("#yotpo-reviews-container");
     var tab_reviews = document.querySelector(".yotpo-main-widget-tabs");

     if (!reviewSection ) {
       return null;
     }

     var reviewButtons = document.querySelector(".reviews-widget__buttons");
     var yotpoWriteReviewButton = document.querySelector(".write-button.write-review-button");
     var writeReviewButton = document.querySelector("#yotpo-write-a-review");

     var yotpoContent = document.querySelector(".yotpo-nav-content");
     var hideAllReviewsButton = document.querySelector("[data-hide-all-reviews]");



     setTimeout(function () {

       if (document.querySelector(".main-widget") && document.querySelector(".main-widget").classList.contains("yotpo-no-reviews")) {
         return;
       }

       if (writeReviewButton !== null && yotpoWriteReviewButton !== null) {
         yotpoWriteReviewButton.classList.add("hidden");
         writeReviewButton.classList.remove("hidden");
       }

       if (yotpoContent !== null) {
         yotpoContent.appendChild(hideAllReviewsButton);
       }

       reviewButtons.classList.remove("hidden");
     }, 100);
     document.querySelector("[data-show-all-reviews]").addEventListener("click", function (e) {
       reviewSection === null || reviewSection === void 0 ? void 0 : reviewSection.classList.add("show-reviews");

       //reviewSectionV3 === null || reviewSectionV3 === void 0 ? void 0 : reviewSectionV3.classList.add("show-reviews");
       reviewButtons === null || reviewButtons === void 0 ? void 0 : reviewButtons.classList.add("hidden");
       e.target.classList.add("hidden");

       if (hideAllReviewsButton !== null) {
         hideAllReviewsButton.classList.toggle("hidden");
       }
     });

     if (hideAllReviewsButton) {
       hideAllReviewsButton.addEventListener("click", function (e) {
         reviewSection === null || reviewSection === void 0 ? void 0 : reviewSection.classList.add("show-reviews");
         //reviewSectionV3 === null || reviewSectionV3 === void 0 ? void 0 : reviewSectionV3.classList.add("show-reviews");
         reviewButtons === null || reviewButtons === void 0 ? void 0 : reviewButtons.classList.remove("hidden");
         document.querySelector("[data-show-all-reviews]").classList.toggle("hidden");

         if (hideAllReviewsButton !== null) {
           hideAllReviewsButton.classList.toggle("hidden");
         }
       });

       if (writeReviewButton !== null && yotpoWriteReviewButton !== null) {
         writeReviewButton.addEventListener("click", function () {
           yotpoWriteReviewButton.click();
         });
       }
     }
   };
 })();

 /***/ }),
 /* 254 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";
 __webpack_require__.r(__webpack_exports__);
 /* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(51);
 /* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony import */ var _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1);


 /* eslint-disable */

 var selectors = {
   map: ".js-individual-map"
 };
 Object(_shopify_theme_sections__WEBPACK_IMPORTED_MODULE_1__[/* register */ "b"])("individual-map", {
   mapElement: null,
   map: null,
   marker: null,
   coordinates: {
     lat: 0,
     lng: 0
   },
   options: {
     zoom: 15
   },
   onLoad: function onLoad() {
     this.mapElement = this.container.querySelector(selectors.map);

     if (!this.mapElement) {
       return null;
     }

     document.addEventListener("google:maps:loaded", this.initMap.bind(this));
   },
   initMap: function initMap() {
     var self = this;
     var latitude = parseFloat(this.mapElement.dataset.storeLatitude);
     var longitude = parseFloat(this.mapElement.dataset.storeLongitude);

     if (!latitude || !longitude) {
       return null;
     }

     this.coordinates = {
       lat: latitude,
       lng: longitude
     };
     this.options.center = this.coordinates;
     this.map = new google.maps.Map(this.mapElement, this.options);
     this.marker = new google.maps.Marker({
       position: self.coordinates,
       map: self.map
     });
   }
 });
 /* eslint-enable */

 /***/ }),
 /* 255 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";
 __webpack_require__.r(__webpack_exports__);
 /* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(51);
 /* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3);
 /* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1__);
 /* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8);
 /* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_2__);




 (function () {
   var sections = document.querySelectorAll(".js-row-image-template-item");

   if (!sections.length) {
     return null;
   }

   var sectionScrolledModifier = "row-image-template__item--scrolled";

   var intersectionHandler = function intersectionHandler(entries) {
     entries.map(function (entry) {
       return entry.target.classList.toggle(sectionScrolledModifier, entry.isIntersecting);
     });
   };

   var observer = new IntersectionObserver(intersectionHandler);
   sections.forEach(function (section) {
     return observer.observe(section);
   });
 })();

 /***/ }),
 /* 256 */
 /***/ (function(module, exports) {

 var filmMain = document.querySelector(".js-climate-description-with-img");

 var handleScroll = function handleScroll() {
   if (filmMain) {
     var offset = filmMain.offsetTop - 700;

     if (window.pageYOffset > offset) {
       filmMain.classList.add("climate-description-with-img--scrolled");
     } else {
       filmMain.classList.remove("climate-description-with-img--scrolled");
     }
   }
 };

 window.addEventListener("scroll", handleScroll);

 /***/ }),
 /* 257 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";
 __webpack_require__.r(__webpack_exports__);
 /* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80);
 /* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_0__);

 window.addEventListener("load", function () {
   var selectors = {
     main: ".wornwear-with-bg-section-wrapper",
     content: ".wornwear-with-bg-section__content",
     bg: ".wornwear-with-bg-section__bg",
     bgContainer: ".wornwear-with-bg-section__bg-container"
   };
   var container = document.querySelector(selectors.main);
   if (!container) return true;
   var bg = container.querySelector(selectors.bg);
   var bgContainer = bg.querySelector(selectors.bgContainer);
   bgContainer.classList.add("bg-image-2");
   var contents = [].slice.call(container.querySelectorAll(selectors.content), 0);

   var documentScroll = function documentScroll() {
     if (window.pageYOffset > container.offsetTop) {
       bg.classList.add("bg-size");
     } else {
       bg.classList.remove("bg-size");
     }

     if (window.pageYOffset > container.offsetTop + contents[0].offsetHeight - 500) {
       bgContainer.classList.add("bg-image-2");
     } else {
       bgContainer.classList.remove("bg-image-2");
     }
   };

   window.addEventListener("scroll", documentScroll);
 });

 /***/ }),
 /* 258 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";
 __webpack_require__.r(__webpack_exports__);
 /* harmony import */ var _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
 /* harmony import */ var _components_slider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7);


 var selectors = {
   slider: "[data-slider-container]",
   arrowNext: "[data-slider-arrow-next]",
   arrowPrev: "[data-slider-arrow-prev]",
   scrollbar: "[data-slider-scrollbar]"
 };
 Object(_shopify_theme_sections__WEBPACK_IMPORTED_MODULE_0__[/* register */ "b"])("inverse-cards-slider", {
   slider: null,
   sliderContainer: null,
   options: {
     slidesPerView: "auto",
     direction: "horizontal",
     freeMode: true,
     loop: false,
     navigation: {
       nextEl: selectors.arrowNext,
       prevEl: selectors.arrowPrev
     },
     scrollbar: {
       el: selectors.scrollbar,
       draggable: true,
       dragSize: 50
     },
     watchOverflow: true,
     speed: 600
   },
   onLoad: function onLoad() {
     this.sliderContainer = this.container.querySelector(selectors.slider);

     if (this.sliderContainer) {
       this.slider = new _components_slider__WEBPACK_IMPORTED_MODULE_1__["default"](this.sliderContainer, this.options);
     }
   },
   onUnload: function onUnload() {
     if (!this.slider) {
       return null;
     }

     this.slider.destroy();
   }
 });

 /***/ }),
 /* 259 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";
 __webpack_require__.r(__webpack_exports__);
 /* harmony import */ var _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
 /* harmony import */ var _components_slider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7);


 var selectors = {
   slider: "[data-slider-container]",
   arrowNext: "[data-slider-arrow-next]",
   arrowPrev: "[data-slider-arrow-prev]"
 };
 Object(_shopify_theme_sections__WEBPACK_IMPORTED_MODULE_0__[/* register */ "b"])("recall-info-product", {
   slider: null,
   sliderContainer: null,
   spaceBetween: 8,
   slidesPerView: "auto",
   options: {
     direction: "horizontal",
     loop: false,
     watchOverflow: true,
     speed: 750,
     navigation: {
       nextEl: selectors.arrowNext,
       prevEl: selectors.arrowPrev
     }
   },
   onLoad: function onLoad() {
     this.sliderContainer = this.container.querySelector(selectors.slider);

     if (!this.sliderContainer) {
       return null;
     }

     this.slider = new _components_slider__WEBPACK_IMPORTED_MODULE_1__["default"](this.sliderContainer, this.options);
   },
   onUnload: function onUnload() {
     if (!this.slider) {
       return null;
     }

     this.slider.destroy();
   }
 });

 /***/ }),
 /* 260 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";
 __webpack_require__.r(__webpack_exports__);
 /* harmony import */ var _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);

 var selectors = {
   table: "[data-table]",
   item: "[data-item]",
   modal: "[data-item-modal]",
   open: "[data-item-modal-open]",
   close: "[data-item-modal-close]"
 };
 var modifiers = {
   open: "recall-upf-table__modal--open"
 };
 Object(_shopify_theme_sections__WEBPACK_IMPORTED_MODULE_0__[/* register */ "b"])("recall-upf-table", {
   onLoad: function onLoad() {
     this.init();
   },
   init: function init() {
     this.body = document.querySelector("body");
     this.upfTable = this.container.querySelector(selectors.table);
     this.openButton();
     this.closeButton();
   },
   openButton: function openButton() {
     var _this = this;

     this.upfTable.addEventListener("click", function (e) {
       if (!e.target.closest(selectors.open)) return null;
       _this.body.style.overflow = "hidden";
       var item = e.target.closest(selectors.item);
       var modal = item.querySelector(selectors.modal);
       modal.classList.add(modifiers.open);
     });
   },
   closeButton: function closeButton() {
     var _this2 = this;

     this.upfTable.addEventListener("click", function (e) {
       if (!e.target.closest(selectors.close)) return null;
       _this2.body.style.overflow = "";
       var item = e.target.closest(selectors.item);
       var modal = item.querySelector(selectors.modal);
       modal.classList.remove(modifiers.open);
     });
   }
 });

 /***/ }),
 /* 261 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";
 __webpack_require__.r(__webpack_exports__);
 /* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3);
 /* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8);
 /* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_1__);
 /* harmony import */ var _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1);
 /* harmony import */ var _components_slider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7);




 var selectors = {
   card: "[data-card]",
   modals: "[data-card-modals]",
   modal: "[data-card-modal]",
   open: "[data-card-modal-open]",
   close: "[data-card-modal-close]",
   slider: "[data-slider-container]",
   arrowNext: "[data-slider-arrow-next]",
   arrowPrev: "[data-slider-arrow-prev]"
 };
 var modifiers = {
   open: "climate-card__modal--open"
 };
 Object(_shopify_theme_sections__WEBPACK_IMPORTED_MODULE_2__[/* register */ "b"])("climate-cards", {
   slider: null,
   sliderContainer: null,
   spaceBetween: 8,
   slidesPerView: "auto",
   options: {
     direction: "horizontal",
     loop: false,
     watchOverflow: true,
     speed: 750,
     navigation: {
       nextEl: selectors.arrowNext,
       prevEl: selectors.arrowPrev
     }
   },
   onLoad: function onLoad() {
     this.init();
   },
   init: function init() {
     this.sliderContainer = this.container.querySelector(selectors.slider);

     if (this.sliderContainer) {
       this.slider = new _components_slider__WEBPACK_IMPORTED_MODULE_3__["default"](this.sliderContainer, this.options);
     } else {
       return null;
     }

     this.body = document.querySelector("body");
     this.mainContainer = document.querySelector("#MainContent");
     this.cards = this.container.querySelectorAll(selectors.card);
     this.modals = this.container.querySelector(selectors.modals);
     this.openButton();
     this.closeButton();
   },
   openButton: function openButton() {
     var _this = this;

     this.cards.forEach(function (card) {
       var openButton = card.querySelector(selectors.open);
       var keyButton = card.dataset.cardKey;

       var modal = _this.modals.querySelector("[data-card-modal-key=\"".concat(keyButton, "\"]"));

       openButton.addEventListener("click", function () {
         _this.body.style.overflow = "hidden";
         _this.mainContainer.style.zIndex = "9999";
         modal.classList.add(modifiers.open);
       });
     });
   },
   closeButton: function closeButton() {
     var _this2 = this;

     this.cards.forEach(function (card) {
       var keyButton = card.dataset.cardKey;

       var modal = _this2.modals.querySelector("[data-card-modal-key=\"".concat(keyButton, "\"]"));

       var closeButtons = modal.querySelectorAll(selectors.close);
       closeButtons.forEach(function (closeButton) {
         closeButton.addEventListener("click", function () {
           _this2.body.style.overflow = "";
           _this2.mainContainer.style.zIndex = "";
           modal.classList.remove(modifiers.open);
         });
       });
     });
   },
   onUnload: function onUnload() {
     if (!this.slider) {
       return null;
     }

     this.slider.destroy();
   }
 });

 /***/ }),
 /* 262 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";
 __webpack_require__.r(__webpack_exports__);
 /* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(51);
 /* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3);
 /* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1__);
 /* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8);
 /* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_2__);
 /* harmony import */ var _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1);




 var selectors = {
   config: "[data-chart-config]"
 };
 Object(_shopify_theme_sections__WEBPACK_IMPORTED_MODULE_3__[/* register */ "b"])("climate-chart", {
   onLoad: function onLoad() {
     this.init();
   },
   init: function init() {
     var _JSON$parse, _this$container$query, _this$container$query2;

     this.config = (_JSON$parse = JSON.parse(this.container.querySelector(selectors.config).innerHTML)) !== null && _JSON$parse !== void 0 ? _JSON$parse : null;
     if (!this.config) return null;
     this.canvas = (_this$container$query = (_this$container$query2 = this.container.querySelector(".js-chart-schema")) === null || _this$container$query2 === void 0 ? void 0 : _this$container$query2.querySelector("canvas")) !== null && _this$container$query !== void 0 ? _this$container$query : null;
     if (!this.canvas) return null;
     this.renderChart();
   },
   renderChart: function renderChart() {
     var _this = this;

     var configChart = {
       type: "doughnut",
       data: {
         labels: this.config.labels,
         datasets: [{
           data: this.config.percent,
           backgroundColor: this.config.backgroundColor,
           borderColor: "#FFFFFF00"
         }]
       },
       options: {
         rotation: 90,
         responsive: true,
         aspectRatio: function aspectRatio() {
           return Math.min(Math.max(window.innerWidth / window.innerHeight, 0.5), 1);
         },
         layout: {
           padding: 10
         },
         plugins: {
           tooltip: {
             displayColors: false,
             backgroundColor: "#000",
             bodyFont: {
               family: "var(--font-body-family), sans-serif"
             },
             footerFont: {
               family: "var(--font-body-family), sans-serif"
             },
             bodySpacing: 0,
             padding: 10,
             callbacks: {
               footer: function footer(item) {
                 return item[0].formattedValue + "%";
               },
               label: function label(item) {
                 return item.label;
               }
             }
           },
           legend: {
             maxWidth: 500,
             onClick: function onClick() {},
             align: "center",
             position: "bottom",
             title: {
               display: true,
               padding: 5,
               text: ""
             },
             fullSize: false,
             labels: {
               color: "#000",
               font: {
                 size: 12,
                 family: "var(--font-body-family), sans-serif"
               },
               padding: 14,
               boxHeight: 18,
               textAlign: "center",
               usePointStyle: true,
               generateLabels: function generateLabels(chart) {
                 var data = chart.data;

                 if (data.labels.length && data.datasets.length) {
                   var pointStyle = chart.legend.options.labels.pointStyle;
                   return data.labels.map(function (label, i) {
                     var meta = chart.getDatasetMeta(0);
                     var style = meta.controller.getStyle(i);
                     return {
                       text: label + " " + chart.data.datasets[0].data[i] + "%",
                       fillStyle: style.backgroundColor,
                       strokeStyle: style.borderColor,
                       lineWidth: style.borderWidth,
                       pointStyle: pointStyle,
                       hidden: !chart.getDataVisibility(i),
                       index: i
                     };
                   });
                 }

                 return [];
               }
             }
           }
         }
       },
       plugins: [{
         id: "a11y",
         afterInit: function afterInit(chart) {
           var table = document.createElement("table");
           var html = "<thead><tr><th>Source</th><th>Percentage</th></tr></thead><tbody>";
           chart.data.labels.forEach(function (label, i) {
             html += "<tr><td>" + label + "</td><td>" + chart.data.datasets[0].data[i] + "%</td></tr>";
           });
           html += "</tbody>";
           table.innerHTML = html;

           _this.canvas.appendChild(table);
         }
       }]
     }; // eslint-disable-next-line no-undef

     new Chart(this.canvas.getContext("2d"), configChart);
   }
 });

 /***/ }),
 /* 263 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";
 __webpack_require__.r(__webpack_exports__);
 /* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3);
 /* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8);
 /* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_1__);



 (function () {
   document.addEventListener("click", function (event) {
     var eventTarget = event.target;

     if (eventTarget.classList.contains("js-blog-select-holder")) {
       eventTarget.closest(".js-blog-select-dropdown").classList.add("blog-select__dropdown--active");
     } else {
       var navigationSelect = document.querySelectorAll(".js-blog-select-dropdown");

       if (navigationSelect) {
         navigationSelect.forEach(function (element) {
           return element.classList.remove("blog-select__dropdown--active");
         });
       }
     }
   });
 })();

 /***/ }),
 /* 264 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";
 __webpack_require__.r(__webpack_exports__);
 /* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3);
 /* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8);
 /* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_1__);
 /* harmony import */ var _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1);



 var selectors = {
   modal: "[data-card-modal]",
   open: "[data-card-modal-open]",
   close: "[data-card-modal-close]"
 };
 var modifiers = {
   open: "gift-card__modal--open"
 };
 Object(_shopify_theme_sections__WEBPACK_IMPORTED_MODULE_2__[/* register */ "b"])("gift-card", {
   onLoad: function onLoad() {
     this.init();
   },
   init: function init() {
     this.body = document.querySelector("body");
     this.mainContainer = document.querySelector("#MainContent");
     this.modal = this.container.querySelector(selectors.modal);
     this.openButtons = this.container.querySelectorAll(selectors.open);
     this.closeButtons = this.modal.querySelectorAll(selectors.close);
     this.openButton();
     this.closeButton();
   },
   openButton: function openButton() {
     var _this = this;

     this.openButtons.forEach(function (button) {
       button.addEventListener("click", function (e) {
         e.preventDefault();
         _this.body.style.overflow = "hidden";
         _this.mainContainer.style.zIndex = "9999";

         _this.modal.classList.add(modifiers.open);
       });
     });
   },
   closeButton: function closeButton() {
     var _this2 = this;

     this.closeButtons.forEach(function (button) {
       button.addEventListener("click", function () {
         _this2.body.style.overflow = "";
         _this2.mainContainer.style.zIndex = "";

         _this2.modal.classList.remove(modifiers.open);
       });
     });
   }
 });

 /***/ }),
 /* 265 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";
 __webpack_require__.r(__webpack_exports__);
 /* harmony import */ var _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
 /* harmony import */ var _components_slider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7);


 var selectors = {
   slider: "[data-slider-container]",
   arrowNext: "[data-slider-arrow-next]",
   arrowPrev: "[data-slider-arrow-prev]",
   scrollbar: "[data-slider-scrollbar]"
 };
 Object(_shopify_theme_sections__WEBPACK_IMPORTED_MODULE_0__[/* register */ "b"])("cards-inverse", {
   slider: null,
   sliderContainer: null,
   options: {
     direction: "horizontal",
     slidesPerView: "auto",
     freeMode: true,
     loop: false,
     navigation: {
       nextEl: selectors.arrowNext,
       prevEl: selectors.arrowPrev
     },
     scrollbar: {
       el: selectors.scrollbar,
       draggable: true,
       dragSize: 50
     },
     watchOverflow: true,
     // centerInsufficientSlides: true,
     speed: 600
   },
   onLoad: function onLoad() {
     this.sliderContainer = this.container.querySelector(selectors.slider);

     if (this.sliderContainer) {
       this.slider = new _components_slider__WEBPACK_IMPORTED_MODULE_1__["default"](this.sliderContainer, this.options);
     }
   },
   onUnload: function onUnload() {
     if (!this.slider) {
       return null;
     }

     this.slider.destroy();
   }
 });

 /***/ }),
 /* 266 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";
 __webpack_require__.r(__webpack_exports__);
 /* harmony import */ var _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
 /* harmony import */ var _components_slider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7);


 var selectors = {
   slider: "[data-slider-container]",
   arrowNext: "[data-slider-arrow-next]",
   arrowPrev: "[data-slider-arrow-prev]",
   pagination: "[data-slider-pagination]"
 };
 Object(_shopify_theme_sections__WEBPACK_IMPORTED_MODULE_0__[/* register */ "b"])("block-cards-carousel", {
   slider: null,
   sliderContainer: null,
   slidesPerView: "auto",
   options: {
     direction: "horizontal",
     loop: false,
       observer: true,
       observeParents: true,
     speed: 400,
     navigation: {
       nextEl: selectors.arrowNext,
       prevEl: selectors.arrowPrev
     }
   },
   onLoad: function onLoad() {
     this.sliderContainer = this.container.querySelector(selectors.slider);
     if (!this.sliderContainer) {
       return null;
     }

     this.slider = new _components_slider__WEBPACK_IMPORTED_MODULE_1__["default"](this.sliderContainer, this.options);
   },
   onUnload: function onUnload() {
     if (!this.slider) {
       return null;
     }

     this.slider.destroy();
   }
 });

 /***/ }),
 /* 267 */
 /***/ (function(module, exports) {

 var closeButton = document.querySelector(".hero-film__popup-close");
 var videoEl = document.querySelector(".hero-film__popup-content iframe");

 if (closeButton && videoEl) {
   closeButton.addEventListener("click", function () {
     videoEl.setAttribute("src", "");
   });
 }

 /***/ }),
 /* 268 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";
 __webpack_require__.r(__webpack_exports__);
 /* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3);
 /* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8);
 /* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_1__);



 (function () {
   var contentImages = document.querySelectorAll(".js-main-article-content p > img");
   if (!contentImages.length) return;
   contentImages.forEach(function (element) {
     return element.parentElement.classList.add("main-article__content-image");
   });
 })();

 /***/ }),
 /* 269 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";
 __webpack_require__.r(__webpack_exports__);
 /* harmony import */ var _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
 /* harmony import */ var _components_slider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7);


 var selectors = {
   slider: "[data-slider-container]",
   arrowNext: "[data-slider-arrow-next]",
   arrowPrev: "[data-slider-arrow-prev]",
   pagination: "[data-slider-pagination]"
 };
 Object(_shopify_theme_sections__WEBPACK_IMPORTED_MODULE_0__[/* register */ "b"])("sport-carousel-slider", {
   slider: null,
   sliderContainer: null,
   options: {
     direction: "horizontal",
     loop: false,
     navigation: {
       nextEl: selectors.arrowNext,
       prevEl: selectors.arrowPrev
     },
     speed: 750
   },
   onLoad: function onLoad() {
     this.sliderContainer = this.container.querySelector(selectors.slider);

     if (!this.sliderContainer) {
       return null;
     }

     this.slider = new _components_slider__WEBPACK_IMPORTED_MODULE_1__["default"](this.sliderContainer, this.options);
   },
   onUnload: function onUnload() {
     if (!this.slider) {
       return null;
     }

     this.slider.destroy();
   }
 });

 /***/ }),
 /* 270 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";
 __webpack_require__.r(__webpack_exports__);
 /* harmony import */ var _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
 /* harmony import */ var _components_slider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7);


 var selectors = {
   slider: "[data-slider-container]",
   arrowNext: "[data-slider-arrow-next]",
   arrowPrev: "[data-slider-arrow-prev]"
 };
 Object(_shopify_theme_sections__WEBPACK_IMPORTED_MODULE_0__[/* register */ "b"])("content-block-carousel", {
   slider: null,
   sliderContainer: null,
   options: {
     direction: "horizontal",
     loop: false,
     navigation: {
       nextEl: selectors.arrowNext,
       prevEl: selectors.arrowPrev
     },
     speed: 750
   },
   onLoad: function onLoad() {
     this.sliderContainer = this.container.querySelector(selectors.slider);

     if (!this.sliderContainer) {
       return null;
     }

     this.slider = new _components_slider__WEBPACK_IMPORTED_MODULE_1__["default"](this.sliderContainer, this.options);
   },
   onUnload: function onUnload() {
     if (!this.slider) {
       return null;
     }

     this.slider.destroy();
   }
 });

 /***/ }),
 /* 271 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";
 __webpack_require__.r(__webpack_exports__);
 /* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3);
 /* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8);
 /* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_1__);
 /* harmony import */ var _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1);
 /* harmony import */ var _components_popup__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(101);




 var selectors = {
   trigger: "[data-film-trigger]",
   container: "[data-film-carousel-popup]",
   videoModalIframe: "[data-film-carousel-popup-iframe]"
 };
 Object(_shopify_theme_sections__WEBPACK_IMPORTED_MODULE_2__[/* register */ "b"])("film-carousel-popup", {
   videoModalIframeWrapper: null,
   onLoad: function onLoad() {
     this.videoModalIframe = this.container.querySelector(selectors.videoModalIframe);
     this.initOpenTriggers();
     this.initCloseTriggers();
   },
   initOpenTriggers: function initOpenTriggers() {
     var popupTriggerAll = document.querySelectorAll(selectors.trigger);
     var popup = document.querySelector(selectors.container);
     var that = this;

     if (!popupTriggerAll || !popup) {
       return null;
     }

     this.shippingPopup = new _components_popup__WEBPACK_IMPORTED_MODULE_3__["default"]();
     popupTriggerAll.forEach(function (elem) {
       var modalIframe = that.videoModalIframe;
       var videoId = elem.dataset.filmId;
       modalIframe.src = "";
       elem.addEventListener("click", function () {
         document.dispatchEvent(new CustomEvent("popup:open", {
           detail: {
             popup: popup
           }
         }));
         modalIframe.src = "https://www.youtube.com/embed/".concat(videoId);
       });
     });
   },
   initCloseTriggers: function initCloseTriggers() {
     var _this = this;

     document.addEventListener("popup:close", function () {
       _this.videoModalIframe.src = "";
     });
   }
 });

 /***/ }),
 /* 272 */
 /***/ (function(module, exports, __webpack_require__) {

 "use strict";

 var defineProperty = __webpack_require__(26).f;
 var create = __webpack_require__(55);
 var redefineAll = __webpack_require__(165);
 var bind = __webpack_require__(64);
 var anInstance = __webpack_require__(136);
 var iterate = __webpack_require__(162);
 var defineIterator = __webpack_require__(157);
 var setSpecies = __webpack_require__(163);
 var DESCRIPTORS = __webpack_require__(23);
 var fastKey = __webpack_require__(173).fastKey;
 var InternalStateModule = __webpack_require__(53);

 var setInternalState = InternalStateModule.set;
 var internalStateGetterFor = InternalStateModule.getterFor;

 module.exports = {
   getConstructor: function (wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
     var Constructor = wrapper(function (that, iterable) {
       anInstance(that, Prototype);
       setInternalState(that, {
         type: CONSTRUCTOR_NAME,
         index: create(null),
         first: undefined,
         last: undefined,
         size: 0
       });
       if (!DESCRIPTORS) that.size = 0;
       if (iterable != undefined) iterate(iterable, that[ADDER], { that: that, AS_ENTRIES: IS_MAP });
     });

     var Prototype = Constructor.prototype;

     var getInternalState = internalStateGetterFor(CONSTRUCTOR_NAME);

     var define = function (that, key, value) {
       var state = getInternalState(that);
       var entry = getEntry(that, key);
       var previous, index;
       // change existing entry
       if (entry) {
         entry.value = value;
       // create new entry
       } else {
         state.last = entry = {
           index: index = fastKey(key, true),
           key: key,
           value: value,
           previous: previous = state.last,
           next: undefined,
           removed: false
         };
         if (!state.first) state.first = entry;
         if (previous) previous.next = entry;
         if (DESCRIPTORS) state.size++;
         else that.size++;
         // add to index
         if (index !== 'F') state.index[index] = entry;
       } return that;
     };

     var getEntry = function (that, key) {
       var state = getInternalState(that);
       // fast case
       var index = fastKey(key);
       var entry;
       if (index !== 'F') return state.index[index];
       // frozen object case
       for (entry = state.first; entry; entry = entry.next) {
         if (entry.key == key) return entry;
       }
     };

     redefineAll(Prototype, {
       // `{ Map, Set }.prototype.clear()` methods
       // https://tc39.es/ecma262/#sec-map.prototype.clear
       // https://tc39.es/ecma262/#sec-set.prototype.clear
       clear: function clear() {
         var that = this;
         var state = getInternalState(that);
         var data = state.index;
         var entry = state.first;
         while (entry) {
           entry.removed = true;
           if (entry.previous) entry.previous = entry.previous.next = undefined;
           delete data[entry.index];
           entry = entry.next;
         }
         state.first = state.last = undefined;
         if (DESCRIPTORS) state.size = 0;
         else that.size = 0;
       },
       // `{ Map, Set }.prototype.delete(key)` methods
       // https://tc39.es/ecma262/#sec-map.prototype.delete
       // https://tc39.es/ecma262/#sec-set.prototype.delete
       'delete': function (key) {
         var that = this;
         var state = getInternalState(that);
         var entry = getEntry(that, key);
         if (entry) {
           var next = entry.next;
           var prev = entry.previous;
           delete state.index[entry.index];
           entry.removed = true;
           if (prev) prev.next = next;
           if (next) next.previous = prev;
           if (state.first == entry) state.first = next;
           if (state.last == entry) state.last = prev;
           if (DESCRIPTORS) state.size--;
           else that.size--;
         } return !!entry;
       },
       // `{ Map, Set }.prototype.forEach(callbackfn, thisArg = undefined)` methods
       // https://tc39.es/ecma262/#sec-map.prototype.foreach
       // https://tc39.es/ecma262/#sec-set.prototype.foreach
       forEach: function forEach(callbackfn /* , that = undefined */) {
         var state = getInternalState(this);
         var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
         var entry;
         while (entry = entry ? entry.next : state.first) {
           boundFunction(entry.value, entry.key, this);
           // revert to the last existing entry
           while (entry && entry.removed) entry = entry.previous;
         }
       },
       // `{ Map, Set}.prototype.has(key)` methods
       // https://tc39.es/ecma262/#sec-map.prototype.has
       // https://tc39.es/ecma262/#sec-set.prototype.has
       has: function has(key) {
         return !!getEntry(this, key);
       }
     });

     redefineAll(Prototype, IS_MAP ? {
       // `Map.prototype.get(key)` method
       // https://tc39.es/ecma262/#sec-map.prototype.get
       get: function get(key) {
         var entry = getEntry(this, key);
         return entry && entry.value;
       },
       // `Map.prototype.set(key, value)` method
       // https://tc39.es/ecma262/#sec-map.prototype.set
       set: function set(key, value) {
         return define(this, key === 0 ? 0 : key, value);
       }
     } : {
       // `Set.prototype.add(value)` method
       // https://tc39.es/ecma262/#sec-set.prototype.add
       add: function add(value) {
         return define(this, value = value === 0 ? 0 : value, value);
       }
     });
     if (DESCRIPTORS) defineProperty(Prototype, 'size', {
       get: function () {
         return getInternalState(this).size;
       }
     });
     return Constructor;
   },
   setStrong: function (Constructor, CONSTRUCTOR_NAME, IS_MAP) {
     var ITERATOR_NAME = CONSTRUCTOR_NAME + ' Iterator';
     var getInternalCollectionState = internalStateGetterFor(CONSTRUCTOR_NAME);
     var getInternalIteratorState = internalStateGetterFor(ITERATOR_NAME);
     // `{ Map, Set }.prototype.{ keys, values, entries, @@iterator }()` methods
     // https://tc39.es/ecma262/#sec-map.prototype.entries
     // https://tc39.es/ecma262/#sec-map.prototype.keys
     // https://tc39.es/ecma262/#sec-map.prototype.values
     // https://tc39.es/ecma262/#sec-map.prototype-@@iterator
     // https://tc39.es/ecma262/#sec-set.prototype.entries
     // https://tc39.es/ecma262/#sec-set.prototype.keys
     // https://tc39.es/ecma262/#sec-set.prototype.values
     // https://tc39.es/ecma262/#sec-set.prototype-@@iterator
     defineIterator(Constructor, CONSTRUCTOR_NAME, function (iterated, kind) {
       setInternalState(this, {
         type: ITERATOR_NAME,
         target: iterated,
         state: getInternalCollectionState(iterated),
         kind: kind,
         last: undefined
       });
     }, function () {
       var state = getInternalIteratorState(this);
       var kind = state.kind;
       var entry = state.last;
       // revert to the last existing entry
       while (entry && entry.removed) entry = entry.previous;
       // get next entry
       if (!state.target || !(state.last = entry = entry ? entry.next : state.state.first)) {
         // or finish the iteration
         state.target = undefined;
         return { value: undefined, done: true };
       }
       // return step by kind
       if (kind == 'keys') return { value: entry.key, done: false };
       if (kind == 'values') return { value: entry.value, done: false };
       return { value: [entry.key, entry.value], done: false };
     }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

     // `{ Map, Set }.prototype[@@species]` accessors
     // https://tc39.es/ecma262/#sec-get-map-@@species
     // https://tc39.es/ecma262/#sec-get-set-@@species
     setSpecies(CONSTRUCTOR_NAME);
   }
 };


 /***/ }),
 /* 273 */
 /***/ (function(module, exports, __webpack_require__) {

 var fails = __webpack_require__(10);

 module.exports = !fails(function () {
   // eslint-disable-next-line es/no-object-isextensible, es/no-object-preventextensions -- required for testing
   return Object.isExtensible(Object.preventExtensions({}));
 });


 /***/ }),
 /* 274 */
 /***/ (function(module, exports, __webpack_require__) {

 // FF26- bug: ArrayBuffers are non-extensible, but Object.isExtensible does not report it
 var fails = __webpack_require__(10);

 module.exports = fails(function () {
   if (typeof ArrayBuffer == 'function') {
     var buffer = new ArrayBuffer(8);
     // eslint-disable-next-line es/no-object-isextensible, es/no-object-defineproperty -- safe
     if (Object.isExtensible(buffer)) Object.defineProperty(buffer, 'a', { value: 8 });
   }
 });


 /***/ }),
 /* 275 */
 /***/ (function(module, exports, __webpack_require__) {

 var fails = __webpack_require__(10);
 var isObject = __webpack_require__(18);
 var classof = __webpack_require__(47);
 var ARRAY_BUFFER_NON_EXTENSIBLE = __webpack_require__(274);

 // eslint-disable-next-line es/no-object-isextensible -- safe
 var $isExtensible = Object.isExtensible;
 var FAILS_ON_PRIMITIVES = fails(function () { $isExtensible(1); });

 // `Object.isExtensible` method
 // https://tc39.es/ecma262/#sec-object.isextensible
 module.exports = (FAILS_ON_PRIMITIVES || ARRAY_BUFFER_NON_EXTENSIBLE) ? function isExtensible(it) {
   if (!isObject(it)) return false;
   if (ARRAY_BUFFER_NON_EXTENSIBLE && classof(it) == 'ArrayBuffer') return false;
   return $isExtensible ? $isExtensible(it) : true;
 } : $isExtensible;


 /***/ }),
 /* 276 */
 /***/ (function(module, exports, __webpack_require__) {

 "use strict";

 var $ = __webpack_require__(13);
 var global = __webpack_require__(2);
 var uncurryThis = __webpack_require__(5);
 var isForced = __webpack_require__(86);
 var redefine = __webpack_require__(32);
 var InternalMetadataModule = __webpack_require__(173);
 var iterate = __webpack_require__(162);
 var anInstance = __webpack_require__(136);
 var isCallable = __webpack_require__(11);
 var isObject = __webpack_require__(18);
 var fails = __webpack_require__(10);
 var checkCorrectnessOfIteration = __webpack_require__(160);
 var setToStringTag = __webpack_require__(108);
 var inheritIfRequired = __webpack_require__(145);

 module.exports = function (CONSTRUCTOR_NAME, wrapper, common) {
   var IS_MAP = CONSTRUCTOR_NAME.indexOf('Map') !== -1;
   var IS_WEAK = CONSTRUCTOR_NAME.indexOf('Weak') !== -1;
   var ADDER = IS_MAP ? 'set' : 'add';
   var NativeConstructor = global[CONSTRUCTOR_NAME];
   var NativePrototype = NativeConstructor && NativeConstructor.prototype;
   var Constructor = NativeConstructor;
   var exported = {};

   var fixMethod = function (KEY) {
     var uncurriedNativeMethod = uncurryThis(NativePrototype[KEY]);
     redefine(NativePrototype, KEY,
       KEY == 'add' ? function add(value) {
         uncurriedNativeMethod(this, value === 0 ? 0 : value);
         return this;
       } : KEY == 'delete' ? function (key) {
         return IS_WEAK && !isObject(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
       } : KEY == 'get' ? function get(key) {
         return IS_WEAK && !isObject(key) ? undefined : uncurriedNativeMethod(this, key === 0 ? 0 : key);
       } : KEY == 'has' ? function has(key) {
         return IS_WEAK && !isObject(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
       } : function set(key, value) {
         uncurriedNativeMethod(this, key === 0 ? 0 : key, value);
         return this;
       }
     );
   };

   var REPLACE = isForced(
     CONSTRUCTOR_NAME,
     !isCallable(NativeConstructor) || !(IS_WEAK || NativePrototype.forEach && !fails(function () {
       new NativeConstructor().entries().next();
     }))
   );

   if (REPLACE) {
     // create collection constructor
     Constructor = common.getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER);
     InternalMetadataModule.enable();
   } else if (isForced(CONSTRUCTOR_NAME, true)) {
     var instance = new Constructor();
     // early implementations not supports chaining
     var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
     // V8 ~ Chromium 40- weak-collections throws on primitives, but should return false
     var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
     // most early implementations doesn't supports iterables, most modern - not close it correctly
     // eslint-disable-next-line no-new -- required for testing
     var ACCEPT_ITERABLES = checkCorrectnessOfIteration(function (iterable) { new NativeConstructor(iterable); });
     // for early implementations -0 and +0 not the same
     var BUGGY_ZERO = !IS_WEAK && fails(function () {
       // V8 ~ Chromium 42- fails only with 5+ elements
       var $instance = new NativeConstructor();
       var index = 5;
       while (index--) $instance[ADDER](index, index);
       return !$instance.has(-0);
     });

     if (!ACCEPT_ITERABLES) {
       Constructor = wrapper(function (dummy, iterable) {
         anInstance(dummy, NativePrototype);
         var that = inheritIfRequired(new NativeConstructor(), dummy, Constructor);
         if (iterable != undefined) iterate(iterable, that[ADDER], { that: that, AS_ENTRIES: IS_MAP });
         return that;
       });
       Constructor.prototype = NativePrototype;
       NativePrototype.constructor = Constructor;
     }

     if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
       fixMethod('delete');
       fixMethod('has');
       IS_MAP && fixMethod('get');
     }

     if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);

     // weak collections should not contains .clear method
     if (IS_WEAK && NativePrototype.clear) delete NativePrototype.clear;
   }

   exported[CONSTRUCTOR_NAME] = Constructor;
   $({ global: true, forced: Constructor != NativeConstructor }, exported);

   setToStringTag(Constructor, CONSTRUCTOR_NAME);

   if (!IS_WEAK) common.setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP);

   return Constructor;
 };


 /***/ }),
 /* 277 */
 /***/ (function(module, exports, __webpack_require__) {

 "use strict";

 var collection = __webpack_require__(276);
 var collectionStrong = __webpack_require__(272);

 // `Map` constructor
 // https://tc39.es/ecma262/#sec-map-objects
 collection('Map', function (init) {
   return function Map() { return init(this, arguments.length ? arguments[0] : undefined); };
 }, collectionStrong);


 /***/ }),
 /* 278 */
 /***/ (function(module, exports, __webpack_require__) {

 "use strict";

 var global = __webpack_require__(2);
 var uncurryThis = __webpack_require__(5);
 var aCallable = __webpack_require__(57);
 var isObject = __webpack_require__(18);
 var hasOwn = __webpack_require__(19);
 var arraySlice = __webpack_require__(85);

 var Function = global.Function;
 var concat = uncurryThis([].concat);
 var join = uncurryThis([].join);
 var factories = {};

 var construct = function (C, argsLength, args) {
   if (!hasOwn(factories, argsLength)) {
     for (var list = [], i = 0; i < argsLength; i++) list[i] = 'a[' + i + ']';
     factories[argsLength] = Function('C,a', 'return new C(' + join(list, ',') + ')');
   } return factories[argsLength](C, args);
 };

 // `Function.prototype.bind` method implementation
 // https://tc39.es/ecma262/#sec-function.prototype.bind
 module.exports = Function.bind || function bind(that /* , ...args */) {
   var F = aCallable(this);
   var Prototype = F.prototype;
   var partArgs = arraySlice(arguments, 1);
   var boundFunction = function bound(/* args... */) {
     var args = concat(partArgs, arraySlice(arguments));
     return this instanceof boundFunction ? construct(F, args.length, args) : F.apply(that, args);
   };
   if (isObject(Prototype)) boundFunction.prototype = Prototype;
   return boundFunction;
 };


 /***/ }),
 /* 279 */
 /***/ (function(module, exports, __webpack_require__) {

 var $ = __webpack_require__(13);
 var getBuiltIn = __webpack_require__(33);
 var apply = __webpack_require__(117);
 var bind = __webpack_require__(278);
 var aConstructor = __webpack_require__(214);
 var anObject = __webpack_require__(17);
 var isObject = __webpack_require__(18);
 var create = __webpack_require__(55);
 var fails = __webpack_require__(10);

 var nativeConstruct = getBuiltIn('Reflect', 'construct');
 var ObjectPrototype = Object.prototype;
 var push = [].push;

 // `Reflect.construct` method
 // https://tc39.es/ecma262/#sec-reflect.construct
 // MS Edge supports only 2 arguments and argumentsList argument is optional
 // FF Nightly sets third argument as `new.target`, but does not create `this` from it
 var NEW_TARGET_BUG = fails(function () {
   function F() { /* empty */ }
   return !(nativeConstruct(function () { /* empty */ }, [], F) instanceof F);
 });

 var ARGS_BUG = !fails(function () {
   nativeConstruct(function () { /* empty */ });
 });

 var FORCED = NEW_TARGET_BUG || ARGS_BUG;

 $({ target: 'Reflect', stat: true, forced: FORCED, sham: FORCED }, {
   construct: function construct(Target, args /* , newTarget */) {
     aConstructor(Target);
     anObject(args);
     var newTarget = arguments.length < 3 ? Target : aConstructor(arguments[2]);
     if (ARGS_BUG && !NEW_TARGET_BUG) return nativeConstruct(Target, args, newTarget);
     if (Target == newTarget) {
       // w/o altered newTarget, optimization for 0-4 arguments
       switch (args.length) {
         case 0: return new Target();
         case 1: return new Target(args[0]);
         case 2: return new Target(args[0], args[1]);
         case 3: return new Target(args[0], args[1], args[2]);
         case 4: return new Target(args[0], args[1], args[2], args[3]);
       }
       // w/o altered newTarget, lot of arguments case
       var $args = [null];
       apply(push, $args, args);
       return new (apply(bind, Target, $args))();
     }
     // with altered newTarget, not support built-in constructors
     var proto = newTarget.prototype;
     var instance = create(isObject(proto) ? proto : ObjectPrototype);
     var result = apply(Target, instance, args);
     return isObject(result) ? result : instance;
   }
 });


 /***/ }),
 /* 280 */
 /***/ (function(module, exports, __webpack_require__) {

 var $ = __webpack_require__(13);
 var fails = __webpack_require__(10);
 var toObject = __webpack_require__(42);
 var nativeGetPrototypeOf = __webpack_require__(156);
 var CORRECT_PROTOTYPE_GETTER = __webpack_require__(208);

 var FAILS_ON_PRIMITIVES = fails(function () { nativeGetPrototypeOf(1); });

 // `Object.getPrototypeOf` method
 // https://tc39.es/ecma262/#sec-object.getprototypeof
 $({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES, sham: !CORRECT_PROTOTYPE_GETTER }, {
   getPrototypeOf: function getPrototypeOf(it) {
     return nativeGetPrototypeOf(toObject(it));
   }
 });



 /***/ }),
 /* 281 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";
 __webpack_require__.r(__webpack_exports__);
 /* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50);
 /* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3);
 /* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1__);
 /* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14);
 /* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_2__);
 /* harmony import */ var core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39);
 /* harmony import */ var core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_3__);
 /* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(63);
 /* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_4__);
 /* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21);
 /* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_5__);
 /* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(54);
 /* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_6__);
 /* harmony import */ var core_js_modules_esnext_string_replace_all_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(177);
 /* harmony import */ var core_js_modules_esnext_string_replace_all_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_string_replace_all_js__WEBPACK_IMPORTED_MODULE_7__);
 /* harmony import */ var core_js_modules_es_object_get_prototype_of_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(280);
 /* harmony import */ var core_js_modules_es_object_get_prototype_of_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_prototype_of_js__WEBPACK_IMPORTED_MODULE_8__);
 /* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(72);
 /* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_9__);
 /* harmony import */ var core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(279);
 /* harmony import */ var core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_10__);
 /* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(31);
 /* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_11__);
 /* harmony import */ var core_js_modules_es_map_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(277);
 /* harmony import */ var core_js_modules_es_map_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_map_js__WEBPACK_IMPORTED_MODULE_12__);
 /* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(27);
 /* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_13__);
 /* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(41);
 /* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_14__);
 /* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(29);
 /* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_15__);
 /* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(104);
 /* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_16__);
 /* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(114);
 /* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_17__);
 function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }




















 function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

 function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

 function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

 function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

 function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

 function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

 function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

 function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

 function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

 function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

 function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

 function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

 function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

 if (!customElements.get("pickup-availability")) {
   customElements.define("pickup-availability", /*#__PURE__*/function (_HTMLElement) {
     _inherits(PickupAvailability, _HTMLElement);

     var _super = _createSuper(PickupAvailability);

     function PickupAvailability() {
       var _this;

       _classCallCheck(this, PickupAvailability);

       _this = _super.call(this);
       if (!_this.hasAttribute("available")) return _possibleConstructorReturn(_this);
       _this.errorHtml = _this.querySelector("template").content.firstElementChild.cloneNode(true);
       _this.onClickRefreshList = _this.onClickRefreshList.bind(_assertThisInitialized(_this));

       if (_this.dataset.variantId) {
         _this.fetchAvailability(_this.dataset.variantId);
       }

       return _this;
     }

     _createClass(PickupAvailability, [{
       key: "fetchAvailability",
       value: function fetchAvailability(variantId) {
         var _this2 = this;

         var variantSectionUrl = "".concat(this.dataset.baseUrl, "variants/").concat(variantId, "/?section_id=pickup-availability");
         fetch(variantSectionUrl).then(function (response) {
           return response.text();
         }).then(function (text) {
           var sectionInnerHTML = new DOMParser().parseFromString(text, "text/html").querySelector(".shopify-section");

           _this2.renderPreview(sectionInnerHTML);
         }).catch(function () {
           var button = _this2.querySelector("button");

           if (button) button.removeEventListener("click", _this2.onClickRefreshList);

           _this2.renderError();
         });
       }
     }, {
       key: "onClickRefreshList",
       value: function onClickRefreshList() {
         this.fetchAvailability(this.dataset.variantId);
       }
     }, {
       key: "renderError",
       value: function renderError() {
         this.innerHTML = "";
         this.appendChild(this.errorHtml);
         this.querySelector("button").addEventListener("click", this.onClickRefreshList);
       }
     }, {
       key: "renderPreview",
       value: function renderPreview(sectionInnerHTML) {
         var _localStorage$getItem;

         var drawer = document.querySelector("pickup-availability-drawer");
         if (drawer) drawer.remove();

         if (!sectionInnerHTML.querySelector("pickup-availability-preview")) {
           this.innerHTML = "";
           this.removeAttribute("available");
           return;
         }

         var jsonPickup = JSON.parse(sectionInnerHTML.querySelector("#pick_up_json").innerHTML);
         var htmlStructure = sectionInnerHTML.querySelector("pickup-availability-preview").outerHTML;
         var preferredStore = (_localStorage$getItem = localStorage.getItem("preferredStore")) !== null && _localStorage$getItem !== void 0 ? _localStorage$getItem : null;

         if (preferredStore) {
           var isPreferredStore = jsonPickup.pickups.find(function (pickup) {
             return pickup.name === preferredStore;
           });

           if (isPreferredStore && isPreferredStore.available) {
             htmlStructure = htmlStructure.replaceAll("[[hidden]]", "");
             htmlStructure = htmlStructure.replace(/<pickup-availability-image><\/pickup-availability-image>/g, jsonPickup.iconAvailabe);
             var htmlAvailability = jsonPickup.templateAvailabeHtml.replace(/<location>/g, isPreferredStore.name);
             htmlStructure = htmlStructure.replace(/<pickup-availability-status><\/pickup-availability-status>/g, jsonPickup.availabilityStatus);
             htmlStructure = htmlStructure.replace(/<pickup-availability-caption-large><\/pickup-availability-caption-large>/g, htmlAvailability);
             htmlStructure = htmlStructure.replace(/<pickup-availability-caption><\/pickup-availability-caption>/g, isPreferredStore.pick_up_time);
           } else if (isPreferredStore && !isPreferredStore.available) {
             htmlStructure = htmlStructure.replaceAll("[[hidden]]", "hidden");
             htmlStructure = htmlStructure.replace(/<pickup-availability-image><\/pickup-availability-image>/g, jsonPickup.iconUnavailabe);
             var htmlUnavailability = jsonPickup.templateUnavailableHtml.replace(/<location>/g, isPreferredStore.name);
             htmlStructure = htmlStructure.replace(/<pickup-availability-status><\/pickup-availability-status>/g, jsonPickup.unavailabilityStatus);
             htmlStructure = htmlStructure.replace(/<pickup-availability-caption-large><\/pickup-availability-caption-large>/g, htmlUnavailability);
             htmlStructure = htmlStructure.replace(/<pickup-availability-caption><\/pickup-availability-caption>/g, "");
           } else {
             htmlStructure = htmlStructure.replaceAll("[[hidden]]", "hidden");
             htmlStructure = htmlStructure.replace(/<pickup-availability-image><\/pickup-availability-image>/g, "");
             htmlStructure = htmlStructure.replace(/<pickup-availability-status><\/pickup-availability-status>/g, "");
             htmlStructure = htmlStructure.replace(/<pickup-availability-caption-large><\/pickup-availability-caption-large>/g, "");
             htmlStructure = htmlStructure.replace(/<pickup-availability-caption><\/pickup-availability-caption>/g, "");
           }
         } else {
           htmlStructure = htmlStructure.replaceAll("[[hidden]]", "hidden");
         }

         this.innerHTML = htmlStructure;
         this.setAttribute("available", "");
         var pickupDrawer = sectionInnerHTML.querySelector("pickup-availability-drawer");

         if (pickupDrawer) {
           document.body.appendChild(pickupDrawer);
         }

         this.querySelector("button").addEventListener("click", function (evt) {
           document.querySelector("pickup-availability-drawer").show(evt.target);
         });
       }
     }]);

     return PickupAvailability;
   }( /*#__PURE__*/_wrapNativeSuper(HTMLElement)));
 }

 if (!customElements.get("pickup-availability-drawer")) {
   customElements.define("pickup-availability-drawer", /*#__PURE__*/function (_HTMLElement2) {
     _inherits(PickupAvailabilityDrawer, _HTMLElement2);

     var _super2 = _createSuper(PickupAvailabilityDrawer);

     function PickupAvailabilityDrawer() {
       var _this3;

       _classCallCheck(this, PickupAvailabilityDrawer);

       _this3 = _super2.call(this);
       _this3.onBodyClick = _this3.handleBodyClick.bind(_assertThisInitialized(_this3));

       _this3.querySelector("button").addEventListener("click", function () {
         _this3.hide();
       });

       _this3.addEventListener("keyup", function () {
         if (event.code.toUpperCase() === "ESCAPE") _this3.hide();
       });

       return _this3;
     }

     _createClass(PickupAvailabilityDrawer, [{
       key: "handleBodyClick",
       value: function handleBodyClick(evt) {
         var target = evt.target;

         if (!!target.closest("[modal-close]") || target != this && !target.closest("pickup-availability-drawer") && target.id != "ShowPickupAvailabilityDrawer") {
           this.hide();
         }
       }
     }, {
       key: "hide",
       value: function hide() {
         this.removeAttribute("open");
         document.body.removeEventListener("click", this.onBodyClick);
         document.body.classList.remove("overflow-hidden"); // removeTrapFocus(this.focusElement);
       }
     }, {
       key: "show",
       value: function show(focusElement) {
         this.focusElement = focusElement;
         this.setAttribute("open", "");
         document.body.addEventListener("click", this.onBodyClick);
         document.body.classList.add("overflow-hidden"); // trapFocus(this);
       }
     }]);

     return PickupAvailabilityDrawer;
   }( /*#__PURE__*/_wrapNativeSuper(HTMLElement)));
 }

 /***/ }),
 /* 282 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";
 __webpack_require__.r(__webpack_exports__);
 /* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3);
 /* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8);
 /* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_1__);
 /* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(176);
 /* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_2__);



 window.addEventListener("DOMContentLoaded", function () {
   var selectors = {
     buttons: "[data-caption-button]",
     block: '[data-section-type="netplus-banner-section"]',
     newBlock: "[data-new-popup]",
     caption: "[data-caption]",
     content: "[data-content]",
     iconMore: "[data-caption-button-more]",
     animated: ".netplus-banner-section--animated",
     iconClose: "[data-caption-button-close]",
     popupClose: "[data-film-popup-close]",
     popupVideo: "[data-film-popup-video]"
   };
   var modifiers = {
     show: "netplus-banner-section__caption--show",
     scrolled: "netplus-banner-section--scrolled",
     paralax: "netplus-banner-section--parrax",
     contentHidden: "netplus-banner-section__content--hidden"
   };
   var bannerAnimated = document.querySelectorAll(selectors.animated);
   var sectionsItem = document.querySelectorAll(".js-netplus-banner-section-item");
   var imagesItem = document.querySelectorAll(".js-netplus-banner-section__image");
   sectionsItem.forEach(function (elem, ind) {
     elem.id = "section--".concat(ind + 1);
   });
   imagesItem.forEach(function (elem, ind) {
     elem.dataset.imageIndex = ind + 1;
   });
   var playButton = document.querySelectorAll(".play-button");
   var filmBanners = document.querySelectorAll(selectors.newBlock);

   if (filmBanners) {
     filmBanners.forEach(function (item) {
       var filmPopupVideo = item.querySelector(selectors.popupVideo);
       var filmPopupClose = item.querySelector(selectors.popupClose);

       if (filmPopupVideo && filmPopupClose) {
         playButton.forEach(function (item) {
           item.addEventListener("click", function () {
             if (!filmPopupVideo.getAttribute("src")) {
               filmPopupVideo.setAttribute("src", filmPopupVideo.getAttribute("data-src"));
             }
           });
         });
         window.addEventListener("DOMContentLoaded", function () {
           filmPopupVideo.setAttribute("src", "");
         });
         filmPopupClose.addEventListener("click", function () {
           filmPopupVideo.setAttribute("src", "");
         });
       }
     });
   }

   if (bannerAnimated) {
     bannerAnimated.forEach(function (item) {
       var handleScroll = function handleScroll() {
         var bannerOffset = item.offsetTop - 600;

         if (window.pageYOffset > bannerOffset) {
           item.classList.add(modifiers.scrolled);
           item.classList.add(modifiers.paralax);
         } else {
           item.classList.remove(modifiers.scrolled);
           item.classList.remove(modifiers.paralax);
         }
       };

       window.addEventListener("scroll", handleScroll);
     });
   }

   var handleClickCaption = function handleClickCaption(e) {
     if (!e.target.hasAttribute("data-caption-button")) {
       return;
     }

     var parent = e.target.closest(selectors.block);
     var captionBlock = parent.querySelector(selectors.caption);
     captionBlock.classList.toggle(modifiers.show);

     if (captionBlock.classList.contains(modifiers.show)) {
       e.target.querySelector(selectors.iconMore).style.display = "none";
       e.target.querySelector(selectors.iconClose).style.display = "block";
       parent.querySelector(selectors.content).classList.add(modifiers.contentHidden);
     } else {
       e.target.querySelector(selectors.iconMore).style.display = "block";
       e.target.querySelector(selectors.iconClose).style.display = "none";
       parent.querySelector(selectors.content).classList.remove(modifiers.contentHidden);
     }
   };

   document.addEventListener("click", handleClickCaption);
 });
 window.addEventListener("DOMContentLoaded", function () {
   var activeClass = "netplus-banner-section__image--active";
   var countOfSections = document.querySelectorAll(".js-netplus-banner-section-item").length;
   var offsetsArray = [];

   for (var i = 1; i <= countOfSections; i++) {
     var section = document.querySelector("#section--".concat(i));
     var offValue = section.offsetTop + section.offsetHeight - 100 + section.offsetParent.offsetParent.offsetTop;
     offsetsArray.push(offValue);
     section.dataset.offTop = offValue;
   }

   var scrollHandler = function scrollHandler(index, scrollWay) {
     document.querySelectorAll(".js-netplus-banner-section__image").forEach(function (item) {
       if (item.dataset.imageLast && scrollWay == "down" || item.dataset.imageFirst) {
         return false;
       }

       item.classList.remove(activeClass);
     });

     if (document.querySelector("[data-image-index=\"".concat(index, "\"]"))) {
       document.querySelector("[data-image-index=\"".concat(index, "\"]")).classList.add(activeClass);
     } else {
       document.querySelector("[data-image-index=\"1\"]").classList.add(activeClass);
     }
   };

   function elementInViewport(el) {
     var elinfo = {
       dataTop: Number(el.dataset.offTop),
       top: el.offsetTop,
       height: el.offsetHeight + 700
     }; // let offSize = window.innerWidth > 768 ? -700 * (window.innerWidth / 1200) : -700 * (window.innerWidth / 768);

     var scrollPosition = window.pageYOffset;
     var elementPositionFromTop = elinfo.dataTop;
     var calculatedOffSize = 200; // Attempted to calculate but wasn't able to come up with a formula

     var userSpecifiedOffSize = document.querySelector('.netplus-banner-section-wrapper[data-scroll-offset]') && document.querySelector('.netplus-banner-section-wrapper[data-scroll-offset]').getAttribute('data-scroll-offset');
     var offSize = userSpecifiedOffSize ? Number(userSpecifiedOffSize) : calculatedOffSize;

     if (elementPositionFromTop - offSize < scrollPosition) {
       return false;
     }

     return true;
   }

   var lastScrollTop = 0;
   var scrollWay = undefined;
   window.addEventListener("scroll", function () {
     var st = window.pageYOffset || document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"

     if (st > lastScrollTop) {
       scrollWay = "down";
     } else {
       scrollWay = "up";
     }

     lastScrollTop = st <= 0 ? 0 : st;

     for (var _i = 1; _i <= offsetsArray.length; _i++) {
       var elem = document.querySelector("#section--".concat(_i));

       if (elementInViewport(elem)) {
         scrollHandler(_i, scrollWay);
         break;
       }
     }
   }, false);
 });

 /***/ }),
 /* 283 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";
 __webpack_require__.r(__webpack_exports__);
 /* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3);
 /* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8);
 /* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_1__);


 window.addEventListener("DOMContentLoaded", function () {
   var selectors = {
     buttons: "[data-caption-button]",
     block: '[data-section-type="columns-with-bg-section"]',
     caption: "[data-caption]",
     content: "[data-content]",
     iconMore: "[data-caption-button-more]",
     animated: ".columns-with-bg-section--animated",
     iconClose: "[data-caption-button-close]"
   };
   var modifiers = {
     show: "columns-with-bg-section__caption--show",
     scrolled: "columns-with-bg-section--scrolled",
     paralax: "columns-with-bg-section--parrax",
     contentHidden: "columns-with-bg-section__content--hidden"
   };
   var bannerAnimated = document.querySelectorAll(selectors.animated);
   var sectionsItem = document.querySelectorAll(".js-columns-with-bg-section-item");
   var imagesItem = document.querySelectorAll(".js-columns-with-bg-section__image");
   sectionsItem.forEach(function (elem, ind) {
     elem.id = "section--".concat(ind + 1);
   });
   imagesItem.forEach(function (elem, ind) {
     elem.dataset.imageIndex = ind + 1;
   });

   if (bannerAnimated) {
     bannerAnimated.forEach(function (item) {
       var handleScroll = function handleScroll() {
         var bannerOffset = item.offsetTop - 600;

         if (window.pageYOffset > bannerOffset) {
           item.classList.add(modifiers.scrolled);
           item.classList.add(modifiers.paralax);
         } else {
           item.classList.remove(modifiers.scrolled);
           item.classList.remove(modifiers.paralax);
         }
       };

       window.addEventListener("scroll", handleScroll);
     });
   }

   var handleClickCaption = function handleClickCaption(e) {
     if (!e.target.hasAttribute("data-caption-button")) {
       return;
     }

     var parent = e.target.closest(selectors.block);
     var captionBlock = parent.querySelector(selectors.caption);
     captionBlock.classList.toggle(modifiers.show);

     if (captionBlock.classList.contains(modifiers.show)) {
       e.target.querySelector(selectors.iconMore).style.display = "none";
       e.target.querySelector(selectors.iconClose).style.display = "block";
       parent.querySelector(selectors.content).classList.add(modifiers.contentHidden);
     } else {
       e.target.querySelector(selectors.iconMore).style.display = "block";
       e.target.querySelector(selectors.iconClose).style.display = "none";
       parent.querySelector(selectors.content).classList.remove(modifiers.contentHidden);
     }
   };

   document.addEventListener("click", handleClickCaption);
 });
 window.addEventListener("DOMContentLoaded", function () {
   var activeClass = "columns-with-bg-section__image--active";
   var countOfSections = document.querySelectorAll(".js-columns-with-bg-section-item").length;
   var offsetsArray = [];

   for (var i = 1; i <= countOfSections; i++) {
     var section = document.querySelector("#section--".concat(i));
     var offValue = section.offsetTop + section.offsetHeight - 100 + section.offsetParent.offsetParent.offsetTop;
     offsetsArray.push(offValue);
     section.dataset.offTop = offValue;
   }

   var scrollHandler = function scrollHandler(index, scrollWay) {
     document.querySelectorAll(".js-columns-with-bg-section__image").forEach(function (item) {
       if (item.dataset.imageLast && scrollWay == "down" || item.dataset.imageFirst) {
         return false;
       }

       item.classList.remove(activeClass);
     });

     if (document.querySelector("[data-image-index=\"".concat(index, "\"]"))) {
       document.querySelector("[data-image-index=\"".concat(index, "\"]")).classList.add(activeClass);
     } else {
       document.querySelector("[data-image-index=\"1\"]").classList.add(activeClass);
     }
   };

   function elementInViewport(el) {
     var elinfo = {
       dataTop: el.dataset.offTop,
       top: el.offsetTop,
       height: el.offsetHeight + 700
     };
     var offSize = 200;

     if (elinfo.dataTop - offSize < window.pageYOffset) {
       return false;
     }

     return true;
   }

   var lastScrollTop = 0;
   var scrollWay = undefined;
   window.addEventListener("scroll", function () {
     var st = window.pageYOffset || document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"

     if (st > lastScrollTop) {
       scrollWay = "down";
     } else {
       scrollWay = "up";
     }

     lastScrollTop = st <= 0 ? 0 : st;

     for (var _i = 1; _i <= offsetsArray.length; _i++) {
       var elem = document.querySelector("#section--".concat(_i));

       if (elementInViewport(elem)) {
         scrollHandler(_i, scrollWay);
         break;
       }
     }
   }, false);
 });

 /***/ }),
 /* 284 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";
 __webpack_require__.r(__webpack_exports__);
 /* harmony import */ var _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
 /* harmony import */ var _components_slider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7);


 var selectors = {
   slider: "[data-slider-container]",
   arrowNext: "[data-slider-arrow-next]",
   arrowPrev: "[data-slider-arrow-prev]",
   pagination: "[data-slider-pagination]"
 };
 Object(_shopify_theme_sections__WEBPACK_IMPORTED_MODULE_0__[/* register */ "b"])("products-carousel", {
   slider: null,
   sliderContainer: null,
   options: {
     direction: "horizontal",
     loop: false,
     navigation: {
       nextEl: selectors.arrowNext,
       prevEl: selectors.arrowPrev
     },
     speed: 750
   },
   options2: {
    grid: {
      rows: 3,
    }
  },
   onLoad: function onLoad() {
     this.sliderContainer = this.container.querySelector(selectors.slider);

     if (!this.sliderContainer) {
       return null;
     }


     this.slider = new _components_slider__WEBPACK_IMPORTED_MODULE_1__["default"](this.sliderContainer, this.options);
   },
   onUnload: function onUnload() {
     if (!this.slider) {
       return null;
     }

     this.slider.destroy();
   }
 });

 /***/ }),
 /* 285 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";
 __webpack_require__.r(__webpack_exports__);
 /* harmony import */ var _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
 /* harmony import */ var _components_slider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7);


 var selectors = {
   slider: "[data-slider-container]",
   arrowNext: "[data-slider-arrow-next]",
   arrowPrev: "[data-slider-arrow-prev]"
 };
 Object(_shopify_theme_sections__WEBPACK_IMPORTED_MODULE_0__[/* register */ "b"])("subcategories-carousel", {
   slider: null,
   sliderContainer: null,
   slidesPerView: "auto",
   options: {
     direction: "horizontal",
     loop: false,
     watchOverflow: true,
     speed: 750,
     navigation: {
       nextEl: selectors.arrowNext,
       prevEl: selectors.arrowPrev
     }
   },
   onLoad: function onLoad() {
     this.sliderContainer = this.container.querySelector(selectors.slider);

     if (!this.sliderContainer) {
       return null;
     }

     this.slider = new _components_slider__WEBPACK_IMPORTED_MODULE_1__["default"](this.sliderContainer, this.options);
   },
   onUnload: function onUnload() {
     if (!this.slider) {
       return null;
     }

     this.slider.destroy();
   }
 });

 /***/ }),
 /* 286 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";
 __webpack_require__.r(__webpack_exports__);
 /* harmony import */ var _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
 /* harmony import */ var _components_slider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7);


 var selectors = {
   slider: "[data-slider-container]",
   arrowNext: "[data-slider-arrow-next]",
   arrowPrev: "[data-slider-arrow-prev]",
   pagination: "[data-slider-pagination]"
 };
 Object(_shopify_theme_sections__WEBPACK_IMPORTED_MODULE_0__[/* register */ "b"])("collection-cards-carousel", {
   slider: null,
   sliderContainer: null,
   slidesPerView: "auto",
   options: {
     direction: "horizontal",
     loop: false,
     watchOverflow: true,
     speed: 400,
     navigation: {
       nextEl: selectors.arrowNext,
       prevEl: selectors.arrowPrev
     }
   },
   onLoad: function onLoad() {
     this.sliderContainer = this.container.querySelector(selectors.slider);

     if (!this.sliderContainer) {
       return null;
     }

     this.slider = new _components_slider__WEBPACK_IMPORTED_MODULE_1__["default"](this.sliderContainer, this.options);
   },
   onUnload: function onUnload() {
     if (!this.slider) {
       return null;
     }

     this.slider.destroy();
   }
 });

 /***/ }),
 /* 287 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";
 __webpack_require__.r(__webpack_exports__);
 /* harmony import */ var _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
 /* harmony import */ var _components_slider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7);


 var selectors = {
   slider: "[data-slider-container]",
   arrowNext: "[data-slider-arrow-next]",
   arrowPrev: "[data-slider-arrow-prev]",
   pagination: "[data-slider-pagination]"
 };
 Object(_shopify_theme_sections__WEBPACK_IMPORTED_MODULE_0__[/* register */ "b"])("stories-carousel", {
   slider: null,
   sliderContainer: null,
   spaceBetween: 8,
   slidesPerView: "auto",
   options: {
     direction: "horizontal",
     loop: false,
     watchOverflow: true,
     speed: 750,
     navigation: {
       nextEl: selectors.arrowNext,
       prevEl: selectors.arrowPrev
     }
   },
   onLoad: function onLoad() {
     this.sliderContainer = this.container.querySelector(selectors.slider);

     if (!this.sliderContainer) {
       return null;
     }

     this.slider = new _components_slider__WEBPACK_IMPORTED_MODULE_1__["default"](this.sliderContainer, this.options);
   },
   onUnload: function onUnload() {
     if (!this.slider) {
       return null;
     }

     this.slider.destroy();
   }
 });

 /***/ }),
 /* 288 */
 /***/ (function(module, exports, __webpack_require__) {

 "use strict";

 var $ = __webpack_require__(13);
 var global = __webpack_require__(2);
 var call = __webpack_require__(22);
 var uncurryThis = __webpack_require__(5);
 var requireObjectCoercible = __webpack_require__(37);
 var isCallable = __webpack_require__(11);
 var isRegExp = __webpack_require__(130);
 var toString = __webpack_require__(28);
 var getMethod = __webpack_require__(58);
 var regExpFlags = __webpack_require__(132);
 var getSubstitution = __webpack_require__(194);
 var wellKnownSymbol = __webpack_require__(12);
 var IS_PURE = __webpack_require__(60);

 var REPLACE = wellKnownSymbol('replace');
 var RegExpPrototype = RegExp.prototype;
 var TypeError = global.TypeError;
 var getFlags = uncurryThis(regExpFlags);
 var indexOf = uncurryThis(''.indexOf);
 var replace = uncurryThis(''.replace);
 var stringSlice = uncurryThis(''.slice);
 var max = Math.max;

 var stringIndexOf = function (string, searchValue, fromIndex) {
   if (fromIndex > string.length) return -1;
   if (searchValue === '') return fromIndex;
   return indexOf(string, searchValue, fromIndex);
 };

 // `String.prototype.replaceAll` method
 // https://tc39.es/ecma262/#sec-string.prototype.replaceall
 $({ target: 'String', proto: true }, {
   replaceAll: function replaceAll(searchValue, replaceValue) {
     var O = requireObjectCoercible(this);
     var IS_REG_EXP, flags, replacer, string, searchString, functionalReplace, searchLength, advanceBy, replacement;
     var position = 0;
     var endOfLastMatch = 0;
     var result = '';
     if (searchValue != null) {
       IS_REG_EXP = isRegExp(searchValue);
       if (IS_REG_EXP) {
         flags = toString(requireObjectCoercible('flags' in RegExpPrototype
           ? searchValue.flags
           : getFlags(searchValue)
         ));
         if (!~indexOf(flags, 'g')) throw TypeError('`.replaceAll` does not allow non-global regexes');
       }
       replacer = getMethod(searchValue, REPLACE);
       if (replacer) {
         return call(replacer, searchValue, O, replaceValue);
       } else if (IS_PURE && IS_REG_EXP) {
         return replace(toString(O), searchValue, replaceValue);
       }
     }
     string = toString(O);
     searchString = toString(searchValue);
     functionalReplace = isCallable(replaceValue);
     if (!functionalReplace) replaceValue = toString(replaceValue);
     searchLength = searchString.length;
     advanceBy = max(1, searchLength);
     position = stringIndexOf(string, searchString, 0);
     while (position !== -1) {
       replacement = functionalReplace
         ? toString(replaceValue(searchString, position, string))
         : getSubstitution(searchString, string, position, [], undefined, replaceValue);
       result += stringSlice(string, endOfLastMatch, position) + replacement;
       endOfLastMatch = position + searchLength;
       position = stringIndexOf(string, searchString, position + advanceBy);
     }
     if (endOfLastMatch < string.length) {
       result += stringSlice(string, endOfLastMatch);
     }
     return result;
   }
 });


 /***/ }),
 /* 289 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";
 __webpack_require__.r(__webpack_exports__);
 /* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3);
 /* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8);
 /* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_1__);
 /* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29);
 /* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_2__);
 /* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(104);
 /* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_3__);
 /* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(114);
 /* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_4__);
 /* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(31);
 /* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_5__);
 /* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(27);
 /* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_6__);
 /* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(41);
 /* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_7__);
 /* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(73);
 /* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_8__);
 /* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(80);
 /* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_9__);
 /* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(63);
 /* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_10__);
 /* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(21);
 /* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_11__);
 /* harmony import */ var _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(1);
 /* harmony import */ var _components_slider__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(7);













 function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

 function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

 function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

 function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

 function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

 function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }



 var selectors = {
   cards: ".film-carousel__slide",
   button: ".button",
   slider: "[data-slider-container]",
   arrowNext: "[data-slider-arrow-next]",
   arrowPrev: "[data-slider-arrow-prev]",
   pagination: "[data-slider-pagination]"
 };
 Object(_shopify_theme_sections__WEBPACK_IMPORTED_MODULE_12__[/* register */ "b"])("film-carousel", {
   slider: null,
   sliderContainer: null,
   options: {
     direction: "horizontal",
     loop: false,
     navigation: {
       nextEl: selectors.arrowNext,
       prevEl: selectors.arrowPrev
     },
     speed: 750
   },
   onLoad: function onLoad() {
     this.sliderContainer = this.container.querySelector(selectors.slider);

     if (!this.sliderContainer) {
       return null;
     }

     this.slider = new _components_slider__WEBPACK_IMPORTED_MODULE_13__["default"](this.sliderContainer, this.options);
     var filmCarouselCards = this.container.querySelectorAll(selectors.cards);

     var handleMouseEnter = function handleMouseEnter(e) {
       var button = e.currentTarget.querySelector(selectors.button);
       var hoverColor = button.getAttribute("data-hover-color");

       var defaultClasses = _toConsumableArray(button.classList);

       e.currentTarget.addEventListener("mouseleave", function () {
         button.classList = [];
         defaultClasses.forEach(function (defaultClass) {
           return button.classList.add(defaultClass);
         });
       });
       button.classList = "button button--primary button--".concat(hoverColor, " film-carousel__slide-button");
     };

     filmCarouselCards.forEach(function (item) {
       item.addEventListener("mouseenter", handleMouseEnter);
     });
   },
   onUnload: function onUnload() {
     if (!this.slider) {
       return null;
     }

     this.slider.destroy();
   }
 });

 /***/ }),
 /* 290 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";
 __webpack_require__.r(__webpack_exports__);
 /* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3);
 /* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8);
 /* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_1__);
 /* harmony import */ var _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1);
 /* harmony import */ var _components_slider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7);




 var selectors = {
   slider: "[data-slider-container]",
   arrowNext: "[data-slider-arrow-next]",
   arrowPrev: "[data-slider-arrow-prev]"
 };
 Object(_shopify_theme_sections__WEBPACK_IMPORTED_MODULE_2__[/* register */ "b"])("main-article-section", {
   slider: null,
   sliderContainer: null,
   spaceBetween: 8,
   slidesPerView: "auto",
   options: {
     direction: "horizontal",
     loop: false,
     watchOverflow: true,
     speed: 750,
     navigation: {
       nextEl: selectors.arrowNext,
       prevEl: selectors.arrowPrev
     }
   },
   onLoad: function onLoad() {
     this.sliderContainer = this.container.querySelector(selectors.slider);

     if (this.sliderContainer) {
       this.slider = new _components_slider__WEBPACK_IMPORTED_MODULE_3__["default"](this.sliderContainer, this.options);
     } else {
       return null;
     }
   },
   onUnload: function onUnload() {
     if (!this.slider) {
       return null;
     }

     this.slider.destroy();
   }
 });

 (function () {
   if (window.innerWidth < 767) {
     var largeCard = document.querySelectorAll(".js-article-card-blog");

     if (!largeCard.length) {
       return;
     }

     largeCard.forEach(function (item) {
       item.classList.remove("article-card-blog--large");
     });
   }
 })();

 /***/ }),
 /* 291 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";
 __webpack_require__.r(__webpack_exports__);
 /* harmony import */ var _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);

 var selectors = {
   trigger: "[data-modal-trigger]",
   close: "[data-modal-close]",
   modal: "[data-modal]"
 };
 var modifiers = {
   show: "article-modal--show",
   hidden: "overflow-hidden"
 };
 Object(_shopify_theme_sections__WEBPACK_IMPORTED_MODULE_0__[/* register */ "b"])("article-navigation", {
   onLoad: function onLoad() {
     this.handleNavigation();
   },
   handleNavigation: function handleNavigation() {
     var html = document.querySelector("html");
     var body = document.querySelector("body");
     var trigger = document.querySelector(selectors.trigger);
     var modal = document.querySelector(selectors.modal);
     var modalClose = document.querySelector(selectors.close);

     if (!trigger || !modalClose) {
       return null;
     }

     trigger.addEventListener("click", function () {
       html.classList.add(modifiers.hidden);
       body.classList.add(modifiers.show);
       modal.classList.add(modifiers.show);
     });
     modalClose.addEventListener("click", function () {
       html.classList.remove(modifiers.hidden);
       body.classList.remove(modifiers.show);
       modal.classList.remove(modifiers.show);
     });
   }
 });

 /***/ }),
 /* 292 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";
 __webpack_require__.r(__webpack_exports__);
 /* harmony import */ var _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);

 var selectors = {
   caption: {
     content: "[data-banner-caption]",
     button: "[data-banner-caption-button]",
     iconMore: "[data-banner-caption-button-more]",
     iconClose: "[data-banner-caption-button-close]"
   },
   content: "[data-banner-content]"
 };
 var modifiers = {
   caption: {
     show: "global-quote__caption--show"
   },
   scrolled: "global-quote--scrolled",
   animated: "global-quote--animated",
   contentHidden: "global-quote__content--hidden",
   hidden: "hidden",
   buttonShow: "visible"
 };
 Object(_shopify_theme_sections__WEBPACK_IMPORTED_MODULE_0__[/* register */ "b"])("global-quote", {
   quoteContent: null,
   onLoad: function onLoad() {
     this.quoteContent = this.container.querySelector(selectors.content);
     this.initAnimation();
     this.initCaption();
   },
   initAnimation: function initAnimation() {
     var _this = this;

     if (!this.container.classList.contains(modifiers.animated)) {
       return null;
     }

     var handleScroll = function handleScroll() {
       var bannerOffset = _this.container.offsetTop - 300;

       if (window.pageYOffset > bannerOffset) {
         _this.container.classList.add(modifiers.scrolled);
       } else {
         _this.container.classList.remove(modifiers.scrolled);
       }
     };

     window.addEventListener("scroll", handleScroll);
   },
   initCaption: function initCaption() {
     var _this2 = this;

     var captionButton = this.container.querySelector(selectors.caption.button);
     var captionContent = this.container.querySelector(selectors.caption.content);

     if (!captionButton || !captionContent) {
       return null;
     }

     var iconMore = this.container.querySelector(selectors.caption.iconMore);
     var iconClose = this.container.querySelector(selectors.caption.iconClose);

     var handleClickCaption = function handleClickCaption() {
       captionContent.classList.toggle(modifiers.caption.show);

       if (captionContent.classList.contains(modifiers.caption.show)) {
         iconMore.classList.add(modifiers.hidden);
         iconMore.classList.remove(modifiers.buttonShow);
         iconClose.classList.remove(modifiers.hidden);
         iconClose.classList.add(modifiers.buttonShow);

         if (!_this2.quoteContent) {
           return false;
         }

         _this2.quoteContent.classList.add(modifiers.contentHidden);
       } else {
         iconMore.classList.remove(modifiers.hidden);
         iconMore.classList.add(modifiers.buttonShow);
         iconClose.classList.remove(modifiers.buttonShow);
         iconClose.classList.add(modifiers.hidden);

         if (!_this2.quoteContent) {
           return false;
         }

         _this2.quoteContent.classList.remove(modifiers.contentHidden);
       }
     };

     captionButton.addEventListener("click", handleClickCaption);
   }
 });

 /***/ }),
 /* 293 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";
 __webpack_require__.r(__webpack_exports__);
 /* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3);
 /* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8);
 /* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_1__);


 window.addEventListener("DOMContentLoaded", function () {
   var selectors = {
     buttons: "[data-banner-caption-button]",
     banner: '[data-section-type="hero-film"]',
     caption: "[data-banner-caption]",
     content: "[data-banner-content]",
     animated: ".hero-film--animated",
     iconMore: "[data-banner-caption-button-more]",
     iconClose: "[data-banner-caption-button-close]",
     popup: "[data-film-popup]",
     popupClose: "[data-film-popup-close]",
     popupVideo: "[data-film-popup-video]",
     popupButton: "[data-film-popup-button]",
     mainContent: "#MainContent"
   };
   var modifiers = {
     show: "hero-film__caption--show",
     scrolled: "hero-film--scrolled",
     contentHidden: "hero-film__content--hidden",
     popupShow: "hero-film__popup--show"
   };
   var filmBanners = document.querySelectorAll(selectors.banner);

   if (filmBanners) {
     filmBanners.forEach(function (item) {
       var mainContent = document.querySelector(selectors.mainContent);
       var filmPopup = item.querySelector(selectors.popup);
       var filmPopupButton = item.querySelector(selectors.popupButton);
       var filmPopupVideo = item.querySelector(selectors.popupVideo);
       var filmPopupClose = item.querySelector(selectors.popupClose);

       if (filmPopup && filmPopupButton && filmPopupVideo && filmPopupClose) {
         filmPopupButton.addEventListener("click", function () {
          localStorage.setItem('film_scroll', window.pageYOffset);
           var id_of_section = filmPopupButton.getAttribute('data-film-popup-button-section');
           document.querySelectorAll('.shopify-section').forEach(function (section) {
             if (section.getAttribute('id') != 'shopify-section-' + id_of_section) section.style.display = "none";
           });
           document.getElementById('shopify-section-' + id_of_section).style.overflow = "initial";
           document.getElementById('shopify-section-' + id_of_section).querySelector('.hero-film').style.height = "100vh";

           if (!filmPopupVideo.getAttribute("src")) {
             filmPopupVideo.setAttribute("src", filmPopupVideo.getAttribute("data-src"));
           }

           mainContent.style.zIndex = 9999;
           filmPopup.classList.add(modifiers.popupShow);
           document.querySelector("html").classList.add("overflow-hidden");
         });
         filmPopupClose.addEventListener("click", function () {
           var id_of_section = filmPopupButton.getAttribute('data-film-popup-button-section');
           document.querySelectorAll('.shopify-section').forEach(function (section) {
             if (section.getAttribute('id') != 'shopify-section-' + id_of_section) section.style.display = "block";
           });
           document.getElementById('shopify-section-' + id_of_section).style.overflow = "hidden";
           document.getElementById('shopify-section-' + id_of_section).querySelector('.hero-film').style.height = "auto";
           filmPopupVideo.setAttribute("src", "");
           filmPopup.classList.remove(modifiers.popupShow);
           mainContent.style.zIndex = "";
           document.querySelector("html").classList.remove("overflow-hidden");
           if(localStorage.getItem('film_scroll')) {
            window.scrollTo({
              top: localStorage.getItem('film_scroll'),
              left: 0,
              behavior: "instant",
             });
           }
         });
       }
     });
   }

   var bannerAnimated = document.querySelectorAll(selectors.animated);

   if (bannerAnimated) {
     bannerAnimated.forEach(function (banner) {
       var handleScroll = function handleScroll() {
         var bannerOffset = banner.offsetTop - 300;

         if (window.pageYOffset > bannerOffset) {
           banner.classList.add(modifiers.scrolled);
         } else {
           banner.classList.remove(modifiers.scrolled);
         }
       };

       window.addEventListener("scroll", handleScroll);
     });
   }

   var handleClickCaption = function handleClickCaption(e) {
     if (!e.target.hasAttribute("data-banner-caption-button")) {
       return;
     }

     var parent = e.target.closest(selectors.banner);
     var captionBlock = parent.querySelector(selectors.caption);
     captionBlock.classList.toggle(modifiers.show);

     if (captionBlock.classList.contains(modifiers.show)) {
       e.target.querySelector(selectors.iconMore).style.display = "none";
       e.target.querySelector(selectors.iconClose).style.display = "block";
       document.querySelector(selectors.content).classList.add(modifiers.contentHidden);
     } else {
       e.target.querySelector(selectors.iconMore).style.display = "block";
       e.target.querySelector(selectors.iconClose).style.display = "none";
       document.querySelector(selectors.content).classList.remove(modifiers.contentHidden);
     }
   };

   document.addEventListener("click", handleClickCaption);
 });

 /***/ }),
 /* 294 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";
 __webpack_require__.r(__webpack_exports__);
 /* harmony import */ var _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);

 var selectors = {
   buttons: "[data-banner-caption-button]",
   caption: "[data-banner-caption]",
   content: "[data-banner-content]",
   animated: ".global-banner--animated",
   iconMore: "[data-banner-caption-button-more]",
   iconClose: "[data-banner-caption-button-close]",
   scrollButton: "[data-scroll-button]"
 };
 var modifiers = {
   hidden: "hidden",
   buttonShow: "visible",
   show: "global-banner__caption--show",
   scrolled: "global-banner--scrolled",
   contentHidden: "global-banner__content--hidden",
   bannerAnimated: "global-banner--animated"
 };
 Object(_shopify_theme_sections__WEBPACK_IMPORTED_MODULE_0__[/* register */ "b"])("global-banner", {
   isAnimated: false,
   scrollArrow: null,
   onLoad: function onLoad() {
     this.isAnimated = this.container.classList.contains(modifiers.bannerAnimated);
     this.scrollArrow = this.container.querySelector(selectors.scrollButton);
     this.animateBanner();
     this.initScrollArrow();
     this.initCaption();
   },
   animateBanner: function animateBanner() {
     var _this = this;

     if (!this.isAnimated) {
       return null;
     }

     var handleScroll = function handleScroll() {
       var bannerOffset = _this.container.offsetTop - 300;

       if (window.pageYOffset > bannerOffset) {
         _this.container.classList.add(modifiers.scrolled);
       } else {
         _this.container.classList.remove(modifiers.scrolled);
       }
     };

     window.addEventListener("scroll", handleScroll);
   },
   initScrollArrow: function initScrollArrow() {
     if (!this.scrollArrow) {
       return null;
     }

     var handleClick = function handleClick() {
       window.scrollTo({
         top: window.innerHeight,
         left: 0,
         behavior: "smooth"
       });
     };

     this.scrollArrow.addEventListener("click", handleClick);
   },
   initCaption: function initCaption() {
     var _this2 = this;

     var handleCaptionClick = function handleCaptionClick(e) {
       if (!e.target.closest(selectors.buttons)) {
         return null;
       }

       var captionBlock = _this2.container.querySelector(selectors.caption);

       if (!captionBlock) {
         return null;
       }

       var contentBlock = _this2.container.querySelector(selectors.content);

       var iconMore = _this2.container.querySelector(selectors.iconMore);

       var iconClose = _this2.container.querySelector(selectors.iconClose);

       captionBlock.classList.toggle(modifiers.show);

       if (captionBlock.classList.contains(modifiers.show)) {
         iconMore.classList.add(modifiers.hidden);
         iconMore.classList.remove(modifiers.buttonShow);
         iconClose.classList.remove(modifiers.hidden);
         iconClose.classList.add(modifiers.buttonShow);

         if (!contentBlock) {
           return null;
         }

         contentBlock.classList.add(modifiers.contentHidden);
       } else {
         iconMore.classList.remove(modifiers.hidden);
         iconMore.classList.add(modifiers.buttonShow);
         iconClose.classList.remove(modifiers.buttonShow);
         iconClose.classList.add(modifiers.hidden);

         if (!contentBlock) {
           return null;
         }

         contentBlock.classList.remove(modifiers.contentHidden);
       }
     };

     document.addEventListener("click", handleCaptionClick);
   }
 });

 /***/ }),
 /* 295 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";
 __webpack_require__.r(__webpack_exports__);
 /* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3);
 /* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8);
 /* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_1__);


 window.addEventListener("DOMContentLoaded", function () {
   var selectors = {
     buttons: "[data-block-caption-button]",
     banner: '[data-section-type="sign-up-block"]',
     caption: "[data-block-caption]",
     content: "[data-block-content]",
     animated: ".sign-up-block--animated",
     iconMore: "[data-block-caption-button-more]",
     iconClose: "[data-block-caption-button-close]",
     scrollButton: "[data-scroll-button]",
     close: "[data-popup-close]",
     overlay: "[data-popup-overlay]"
   };
   var modifiers = {
     show: "sign-up-block__caption--show",
     scrolled: "sign-up-block--scrolled",
     contentHidden: "sign-up-block__content--hidden"
   };
   var bannerAnimated = document.querySelector(selectors.animated);

   if (bannerAnimated) {
     var handleScroll = function handleScroll() {
       var bannerOffset = bannerAnimated.offsetTop - 300;

       if (window.pageYOffset > bannerOffset) {
         bannerAnimated.classList.add(modifiers.scrolled);
       } else {
         bannerAnimated.classList.remove(modifiers.scrolled);
       }
     };

     window.addEventListener("scroll", handleScroll);
   }

   var scrollArrow = document.querySelector(selectors.scrollButton);

   if (scrollArrow) {
     scrollArrow.addEventListener("click", function () {
       window.scrollTo({
         top: window.innerHeight,
         left: 0,
         behavior: "smooth"
       });
     });
   }

   var handleClickCaption = function handleClickCaption(e) {
     if (!e.target.hasAttribute("data-block-caption-button")) {
       return;
     }

     var parent = e.target.closest(selectors.banner);
     var captionBlock = parent.querySelector(selectors.caption);
     captionBlock.classList.toggle(modifiers.show);

     if (captionBlock.classList.contains(modifiers.show)) {
       e.target.querySelector(selectors.iconMore).style.display = "none";
       e.target.querySelector(selectors.iconClose).style.display = "block";
       document.querySelector(selectors.content).classList.add(modifiers.contentHidden);
     } else {
       e.target.querySelector(selectors.iconMore).style.display = "block";
       e.target.querySelector(selectors.iconClose).style.display = "none";
       document.querySelector(selectors.content).classList.remove(modifiers.contentHidden);
     }
   };

   var signUpBlock = function signUpBlock() {
     var signupCloseIcon = document.querySelector(selectors.close); // const signupOverlay = document.querySelector( selectors.overlay );

     if (signupCloseIcon) {
       signupCloseIcon.addEventListener("click", function () {
         var elem = document.querySelector(".sign-up-block__form");
         if (elem.classList.contains("popup--open")) elem.classList.toggle("popup--open");
         document.querySelector("body").style.overflow = "visible";
       });
     } // if (signupOverlay) {
     // 	signupOverlay.addEventListener("click", function () {
     // 		let elem = document.querySelector(".sign-up-block__form");
     // 		if (elem.classList.contains("popup--open"))
     // 			elem.classList.toggle("popup--open");
     // 	});
     // }

   };

   signUpBlock();
   document.addEventListener("click", handleClickCaption);
 });
 var PopupContainer = document.querySelectorAll("[data-popup]");
 var PopupTrigger = document.querySelectorAll("[data-popup-trigger]");

 if (PopupTrigger && PopupContainer) {
   PopupTrigger.forEach(function (item, index) {
     return item.addEventListener("click", function () {
       document.dispatchEvent(new CustomEvent("popup:open", {
         detail: {
           popup: PopupContainer[index]
         }
       }));
     });
   });
 }

 /***/ }),
 /* 296 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";
 __webpack_require__.r(__webpack_exports__);
 /* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3);
 /* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8);
 /* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_1__);
 /* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14);
 /* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_2__);
 /* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31);
 /* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_3__);
 /* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27);
 /* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_4__);
 /* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41);
 /* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_5__);
 /* harmony import */ var regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(16);
 /* harmony import */ var regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_6__);
 /* harmony import */ var _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1);
 /* harmony import */ var _components_product_card__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(49);
 /* harmony import */ var _components_slider__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(7);








 function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

 function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }




 var selectors = {
   sliderContainer: "[data-product-complete-look-slider]",
   sliderWrapper: "[data-product-complete-look-slider-wrapper]",
   arrowNext: "[data-slider-arrow-next]",
   arrowPrev: "[data-slider-arrow-prev]"
 };
 var modifiers = {
   hidden: "hidden"
 };
 Object(_shopify_theme_sections__WEBPACK_IMPORTED_MODULE_7__[/* register */ "b"])("product-complete-look", {
   nostoSectionId: null,
   products: [],
   slider: null,
   sliderContainer: null,
   sliderWrapper: null,
   sliderOptions: {
     direction: "horizontal",
     loop: false,
     navigation: {
       nextEl: selectors.arrowNext,
       prevEl: selectors.arrowPrev
     },
     speed: 750
   },
   onLoad: function () {
     var _onLoad = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
       return regeneratorRuntime.wrap(function _callee$(_context) {
         while (1) {
           switch (_context.prev = _context.next) {
             case 0:
               this.nostoSectionId = this.container.dataset.nostoSectionId;

               if (this.nostoSectionId) {
                 _context.next = 3;
                 break;
               }

               return _context.abrupt("return", null);

             case 3:
               this.sliderContainer = this.container.querySelector(selectors.sliderContainer);
               this.sliderWrapper = this.container.querySelector(selectors.sliderWrapper);

               if (!(!this.sliderContainer || !this.sliderWrapper)) {
                 _context.next = 7;
                 break;
               }

               return _context.abrupt("return", null);

             case 7:
               _context.next = 9;
               return this.initNostoRecommendations();

             case 9:
             case "end":
               return _context.stop();
           }
         }
       }, _callee, this);
     }));

     function onLoad() {
       return _onLoad.apply(this, arguments);
     }

     return onLoad;
   }(),
   initNostoRecommendations: function () {
     var _initNostoRecommendations = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
       var _this = this;

       return regeneratorRuntime.wrap(function _callee3$(_context3) {
         while (1) {
           switch (_context3.prev = _context3.next) {
             case 0:
               window.nostojs(function (api) {
                 api.defaultSession().viewProduct("" + window.__st.rid || "").setPlacements([_this.nostoSectionId]).load().then( /*#__PURE__*/function () {
                   var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(data) {
                     return regeneratorRuntime.wrap(function _callee2$(_context2) {
                       while (1) {
                         switch (_context2.prev = _context2.next) {
                           case 0:
                             _context2.next = 2;
                             return _this.initNostoProducts(data);

                           case 2:
                           case "end":
                             return _context2.stop();
                         }
                       }
                     }, _callee2);
                   }));

                   return function (_x) {
                     return _ref.apply(this, arguments);
                   };
                 }());
               });

             case 1:
             case "end":
               return _context3.stop();
           }
         }
       }, _callee3);
     }));

     function initNostoRecommendations() {
       return _initNostoRecommendations.apply(this, arguments);
     }

     return initNostoRecommendations;
   }(),
   initNostoProducts: function () {
     var _initNostoProducts = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(_ref2) {
       var _this2 = this;

       var recommendations, placement, promises, recommendedProducts, recommendedProductSlides;
       return regeneratorRuntime.wrap(function _callee4$(_context4) {
         while (1) {
           switch (_context4.prev = _context4.next) {
             case 0:
               recommendations = _ref2.recommendations;
               placement = this.nostoSectionId;

               if (!(!recommendations.hasOwnProperty(placement) || !recommendations[placement].products.length)) {
                 _context4.next = 4;
                 break;
               }

               return _context4.abrupt("return", null);

             case 4:
               this.products = recommendations[placement].products;
               promises = [];
               recommendations[placement].products.forEach(function (product) {
                 promises.push(fetch("".concat(product.url, "?view=product-card")).then(function (data) {
                   return data.text();
                 }));
               });
               _context4.next = 9;
               return Promise.all(promises);

             case 9:
               recommendedProducts = _context4.sent;
               recommendedProductSlides = recommendedProducts.reduce(function (products, product) {
                 var item = "<div class=\"swiper-slide slider__slide product-complete-look__slider-slide\">\n\t\t\t\t\t".concat(product, "\n\t\t\t\t</div>");
                 products.push(item);
                 return products;
               }, []);

               if (recommendedProductSlides.length) {
                 _context4.next = 13;
                 break;
               }

               return _context4.abrupt("return", null);

             case 13:
               recommendedProductSlides.forEach(function (slide) {
                 _this2.sliderWrapper.innerHTML += slide;
               });
               Object(_components_product_card__WEBPACK_IMPORTED_MODULE_8__["initProductCards"])();
               this.container.classList.remove(modifiers.hidden);
               new _components_slider__WEBPACK_IMPORTED_MODULE_9__["default"](this.sliderContainer, this.sliderOptions);

             case 17:
             case "end":
               return _context4.stop();
           }
         }
       }, _callee4, this);
     }));

     function initNostoProducts(_x2) {
       return _initNostoProducts.apply(this, arguments);
     }

     return initNostoProducts;
   }(),
   onUnload: function onUnload() {
     if (!this.slider) {
       return null;
     }

     this.slider.destroy();
   }
 });

 /***/ }),
 /* 297 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";
 __webpack_require__.r(__webpack_exports__);
 /* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3);
 /* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8);
 /* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_1__);
 /* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14);
 /* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_2__);
 /* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31);
 /* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_3__);
 /* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27);
 /* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_4__);
 /* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41);
 /* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_5__);
 /* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(50);
 /* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_6__);
 /* harmony import */ var regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(16);
 /* harmony import */ var regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_7__);
 /* harmony import */ var _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1);
 /* harmony import */ var _components_product_card__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(49);
 /* harmony import */ var _components_slider__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(7);









 function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

 function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }




 var selectors = {
   sliderContainer: "[data-recommendations-slider]",
   sliderWrapper: "[data-recommendations-slider-wrapper]",
   arrowNext: "[data-slider-arrow-next]",
   arrowPrev: "[data-slider-arrow-prev]"
 };
 var modifiers = {
   hidden: "hidden"
 };
 Object(_shopify_theme_sections__WEBPACK_IMPORTED_MODULE_8__[/* register */ "b"])("product-recommendations", {
   nostoSectionId: null,
   products: [],
   slider: null,
   sliderContainer: null,
   sliderWrapper: null,
   sliderOptions: {
     direction: "horizontal",
     loop: false,
     navigation: {
       nextEl: selectors.arrowNext,
       prevEl: selectors.arrowPrev
     },
     speed: 750
   },
   onLoad: function () {
     var _onLoad = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
       return regeneratorRuntime.wrap(function _callee$(_context) {
         while (1) {
           switch (_context.prev = _context.next) {
             case 0:
               this.nostoSectionId = this.container.dataset.nostoSectionId;

               if (this.nostoSectionId) {
                 _context.next = 3;
                 break;
               }

               return _context.abrupt("return", null);

             case 3:
               this.sliderContainer = this.container.querySelector(selectors.sliderContainer);
               this.sliderWrapper = this.container.querySelector(selectors.sliderWrapper);

               if (!(!this.sliderContainer || !this.sliderWrapper)) {
                 _context.next = 7;
                 break;
               }

               return _context.abrupt("return", null);

             case 7:
               _context.next = 9;
               return this.initNostoRecommendations();

             case 9:
             case "end":
               return _context.stop();
           }
         }
       }, _callee, this);
     }));

     function onLoad() {
       return _onLoad.apply(this, arguments);
     }

     return onLoad;
   }(),
   initNostoRecommendations: function () {
     var _initNostoRecommendations = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
       var _this = this;

       return regeneratorRuntime.wrap(function _callee3$(_context3) {
         while (1) {
           switch (_context3.prev = _context3.next) {
             case 0:
               window.nostojs(function (api) {
                 api.defaultSession().viewProduct("" + window.__st.rid || "").setPlacements([_this.nostoSectionId]).load().then( /*#__PURE__*/function () {
                   var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(data) {
                     return regeneratorRuntime.wrap(function _callee2$(_context2) {
                       while (1) {
                         switch (_context2.prev = _context2.next) {
                           case 0:
                             _context2.next = 2;
                             return _this.initNostoProducts(data);

                           case 2:
                           case "end":
                             return _context2.stop();
                         }
                       }
                     }, _callee2);
                   }));

                   return function (_x) {
                     return _ref.apply(this, arguments);
                   };
                 }());
               });

             case 1:
             case "end":
               return _context3.stop();
           }
         }
       }, _callee3);
     }));

     function initNostoRecommendations() {
       return _initNostoRecommendations.apply(this, arguments);
     }

     return initNostoRecommendations;
   }(),
   initNostoProducts: function () {
     var _initNostoProducts = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(_ref2) {
       var _this2 = this;

       var recommendations, placement, promises, recommendedProducts, nosto_resultid, nosto_src, recommendedProductSlides, productDivs, button_mobile, modal;
       return regeneratorRuntime.wrap(function _callee4$(_context4) {
         while (1) {
           switch (_context4.prev = _context4.next) {
             case 0:
               recommendations = _ref2.recommendations;
               placement = this.nostoSectionId;

               if (!(!recommendations.hasOwnProperty(placement) || !recommendations[placement].products.length)) {
                 _context4.next = 4;
                 break;
               }

               return _context4.abrupt("return", null);

             case 4:
               this.products = recommendations[placement].products;
               promises = [];
               recommendations[placement].products.forEach(function (product) {
                 promises.push(fetch("".concat(product.url, "?view=product-card")).then(function (data) {
                   return data.text();
                 }));
               });
               _context4.next = 9;
               return Promise.all(promises);

             case 9:
               recommendedProducts = _context4.sent;
               nosto_resultid = recommendations[placement].params.nosto;
               nosto_src = recommendations[placement].params.refSrc;
               recommendedProductSlides = recommendedProducts.reduce(function (products, product) {
                 var item = "<div class=\"swiper-slide slider__slide product-recommendations__slider-slide\" nosto-refsrc=\"".concat(nosto_src, "\" result-id-nosto=").concat(nosto_resultid, ">\n\t\t\t\t\t").concat(product, "\n\t\t\t\t</div>");
                 products.push(item);
                 return products;
               }, []);

               if (recommendedProductSlides.length) {
                 _context4.next = 15;
                 break;
               }

               return _context4.abrupt("return", null);

             case 15:
               recommendedProductSlides.forEach(function (slide) {
                 _this2.sliderWrapper.innerHTML += slide;
               });
               Object(_components_product_card__WEBPACK_IMPORTED_MODULE_9__["initProductCards"])();
               this.container.classList.remove(modifiers.hidden);
               new _components_slider__WEBPACK_IMPORTED_MODULE_10__["default"](this.sliderContainer, this.sliderOptions);
               productDivs = document.querySelectorAll('.swiper-slide.product-recommendations__slider-slide');
               const button_mobiles = document.querySelectorAll('.quick-add-mobile');
               modal = this.container.querySelector('.myModal'); // Iterate through each element and attach a click event listener

               productDivs.forEach(function (productDiv) {
                 productDiv.addEventListener('click', function (event) {
                  let isContain = false;
                  button_mobiles.forEach(x => {
                    if(!isContain) {
                      isContain = x.contains(event.target)
                    }
                  })
                   if (!isContain && !modal.contains(event.target)) {
                     // Prevent the default link behavior
                     event.preventDefault(); // Get the URL of the <a> element within the clicked <div>

                     var aElement = productDiv.querySelector('a.product-card__images-box--show');
                     var href = aElement.getAttribute('href'); // Get the values of the attributes from the <div>

                     var resultIdNosto = productDiv.getAttribute('result-id-nosto');
                     var nostoRefsrc = productDiv.getAttribute('nosto-refsrc'); // Create the modified URL with the attributes as query parameters

                     var modifiedURL = "".concat(href, "?refSrc=").concat(nostoRefsrc, "&nosto=").concat(resultIdNosto); // Redirect to the modified URL

                     window.location.href = modifiedURL; // nostojs(function(api) {
                     //   api
                     //   .defaultSession()
                     //   .recordAttribution("vp", resultIdNosto, nostoRefsrc)
                     //   .done()
                     //   });
                     // nostojs(api => {
                     //   api.defaultSession()
                     //    .viewProduct(nostoRefsrc) // id of product currently being viewed
                     //    .setRef(nostoRefsrc, resultIdNosto) // id of product and slot that resulted in the product view
                     //    .setPlacements([this.nostoSectionId]) // placements to request content for on the product page
                     //    .update()
                     //    .then(data => console.log("here data click recommendations", data))
                     //  })
                   }
                 });
               });

             case 23:
             case "end":
               return _context4.stop();
           }
         }
       }, _callee4, this);
     }));

     function initNostoProducts(_x2) {
       return _initNostoProducts.apply(this, arguments);
     }

     return initNostoProducts;
   }(),
   onUnload: function onUnload() {
     if (!this.slider) {
       return null;
     }

     this.slider.destroy();
   }
 });

 /***/ }),
 /* 298 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";
 __webpack_require__.r(__webpack_exports__);
 /* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3);
 /* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8);
 /* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_1__);
 /* harmony import */ var _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1);
 /* harmony import */ var body_scroll_lock__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62);
 /* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(103);





 var selectors = {
   mainSlider: "[data-product-media-content-slider]",
   mainSlide: "[data-product-media-content-slide]",
   modal: "[data-product-media-content-modal]",
   modalClosures: "[data-product-content-modal-close]",
   modalSlider: "[data-product-media-content-modal-slider]",
   modalSlide: "[data-product-media-content-modal-slide]",
   modalScrollWrapper: "[data-product-content-modal-scroll]",
   modalSlidesWrapper: "[data-product-media-content-modal-slides-wrapper]",
   videoModal: "[data-product-media-video-modal]",
   videoModalClosures: "[data-product-media-video-modal-close]",
   videoModalIframeWrapper: "[data-product-media-video-modal-iframe-wrapper]"
 };
 var modifiers = {
   modalVisible: "is-visible"
 };
 Object(_shopify_theme_sections__WEBPACK_IMPORTED_MODULE_2__[/* register */ "b"])("product-media-content", {
   mainSliderWrapper: null,
   modal: null,
   modalSliderWrapper: null,
   modalScrollWrapper: null,
   modalSlidesWrapper: null,
   videoModalIframeWrapper: null,
   player: null,
   currentVideoID: null,
   breakpoint: window.matchMedia("(min-width: 992px)"),
   mainSlider: null,
   modalSlider: null,
   handleMainSlideClick: function handleMainSlideClick() {},
   handleVideoModalClose: function handleVideoModalClose() {},
   handleYoutubeAPIReady: function handleYoutubeAPIReady() {},
   handleBreakpointChange: function handleBreakpointChange() {},
   handleCloseMainModal: function handleCloseMainModal() {},
   onLoad: function onLoad() {
     this.mainSliderWrapper = this.container.querySelector(selectors.mainSlider);
     this.modal = this.container.querySelector(selectors.modal);
     this.modalScrollWrapper = this.modal.querySelector(selectors.modalScrollWrapper);
     this.modalSliderWrapper = this.modal.querySelector(selectors.modalSlider);
     this.modalSlidesWrapper = this.modal.querySelector(selectors.modalSlidesWrapper);
     this.videoModal = this.container.querySelector(selectors.videoModal);
     this.videoModalIframeWrapper = this.container.querySelector(selectors.videoModalIframeWrapper);
     this.handleMainSlideClick = this.onMainSlideClick.bind(this);
     this.handleVideoModalClose = this.closeVideoModal.bind(this);
     this.handleYoutubeAPIReady = this.onYoutubeAPIReady.bind(this);
     this.handleCloseMainModal = this.closeMainModal.bind(this);
     this.handleBreakpointChange = this.onBreakpointChange.bind(this);
     this.init();
   },
   init: function init() {
     this.attachListeners();
     this.handleBreakpointChange();
     this.movingImage();
   },
   initSliders: function initSliders() {
     this.mainSlider = new swiper__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"](this.mainSliderWrapper, {
       direction: "horizontal",
       slidesPerView: 1,
       observer: true,
       keyboard: {
         enabled: true,
         onlyInViewport: false
       },
       breakpoints: {
         768: {
           slidesPerView: 2
         }
       },
       a11y: true
     });
     this.modalSlider = new swiper__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"](this.modalSliderWrapper, {
       allowTouchMove: false,
       direction: "horizontal",
       effect: "fade",
       slidesOffsetBefore: 0,
       slidesOffsetAfter: 0,
       slidesPerView: 1,
       spaceBetween: 0,
       speed: 0,
       observer: true,
       keyboard: {
         enabled: true,
         onlyInViewport: false
       },
       a11y: true,
       zoom: {
         maxRatio: 2
       }
     });
   },
   destroySliders: function destroySliders() {
     if (this.mainSlider) {
       this.mainSlider.destroy(true, true);
       this.mainSlider = null;
     }

     if (this.modalSlider) {
       this.modalSlider.destroy(true, true);
       this.modalSlider = null;
     }
   },
   onMainSlideClick: function onMainSlideClick(e, target) {
     e.preventDefault();
     var _target$dataset = target.dataset,
         youtubeVideoId = _target$dataset.youtubeVideoId,
         slideIndexIgnoringVideo = _target$dataset.productMediaContentSlideIndex;

     if (youtubeVideoId) {
       this.openVideoModal(youtubeVideoId);
     } else {
       this.openMainModal(slideIndexIgnoringVideo);
     }
   },
   openMainModal: function openMainModal(slideIndex) {
     this.modal.classList.add(modifiers.modalVisible);

     if (this.modalSlider) {
       this.modalSlider.slideTo(slideIndex, 0); // this.modalSlider.zoom.in();
     } else {
       var selectedSlide = this.modalSlidesWrapper.children[slideIndex];
       var padding = 0;
       this.modalScrollWrapper.scrollTo(0, selectedSlide.offsetTop + padding);
     }

     Object(body_scroll_lock__WEBPACK_IMPORTED_MODULE_3__["disableBodyScroll"])(this.modalScrollWrapper);
     document.querySelector("#MainContent").style.zIndex = 9999;
   },
   closeMainModal: function closeMainModal() {
     this.modal.classList.remove(modifiers.modalVisible);
     Object(body_scroll_lock__WEBPACK_IMPORTED_MODULE_3__["enableBodyScroll"])(this.modalScrollWrapper);
     document.querySelector("#MainContent").style.zIndex = "";
   },
   openVideoModal: function openVideoModal(youtubeVideoId) {
     this.videoModal.classList.add(modifiers.modalVisible);
     Object(body_scroll_lock__WEBPACK_IMPORTED_MODULE_3__["disableBodyScroll"])(this.videoModal);
     document.querySelector("#MainContent").style.zIndex = 9999;

     if (this.currentVideoID === youtubeVideoId) {// return null;
     }

     if (this.player) {
       this.player.destroy();
       this.player = null;
     }

     this.currentVideoID = youtubeVideoId;

     if (!window.YT || !window.YT.Player) {
       window.addEventListener("youtube:loaded", this.handleYoutubeAPIReady);
     } else {
       this.handleYoutubeAPIReady();
     }
   },
   onYoutubeAPIReady: function onYoutubeAPIReady() {
     var currentVideoID = this.currentVideoID;
     this.player = new window.YT.Player(this.videoModalIframeWrapper, {
       height: "100%",
       width: "100%",
       videoId: currentVideoID,
       playerVars: {
         controls: 1,
         state: 0,
         start: 0,
         showinfo: 0,
         modestbranding: 1,
         loop: 1,
         fs: 1,
         iv_load_policy: 1,
         autohide: 0,
         rel: 0,
         html5: 1,
         cc_load_policy: 1
       }
     });
   },
   closeVideoModal: function closeVideoModal() {
     window.removeEventListener("youtube:loaded", this.handleYoutubeAPIReady);

     if (this.player) {
       this.player.destroy();
       this.player = null;
     }

     this.videoModal.classList.remove(modifiers.modalVisible);
     Object(body_scroll_lock__WEBPACK_IMPORTED_MODULE_3__["enableBodyScroll"])(this.videoModal);
     document.querySelector("#MainContent").style.zIndex = "";
   },
   onBreakpointChange: function onBreakpointChange() {
     if (this.breakpoint.matches) {
       this.destroySliders();
       return null;
     }

     this.initSliders();
   },
   attachListeners: function attachListeners() {
     this.modal.customDelegate("click", selectors.modalClosures, this.handleCloseMainModal);
     this.mainSliderWrapper.customDelegate("click", selectors.mainSlide, this.handleMainSlideClick);
     this.videoModal.customDelegate("click", selectors.videoModalClosures, this.handleVideoModalClose);
     this.breakpoint.addEventListener("change", this.handleBreakpointChange);
   },
   movingImage: function movingImage() {
     var _this = this;

     var body = document.querySelector("body");
     var imageBoxs = document.querySelectorAll(".zoom-container");
     imageBoxs.forEach(function (imageBox) {
       var image = imageBox.querySelector("img");
       var left = 0,
           tp = 0,
           xx,
           yy,
           statusZoom = false,
           noClick = true; // imageBox.onmousedown = function (e) {
       // 	if (!statusZoom) return;
       // 	noClick = true;
       // 	xx = e.offsetX;
       // 	yy = e.offsetY;
       // 	function moveAt(e) {
       // 		image.style.left = left + e.offsetX - xx + "px";
       // 		image.style.top = tp + e.offsetY - yy + "px";
       // 		noClick = false;
       // 	}
       // 	imageBox.onmousemove = function (e) {
       // 		moveAt(e);
       // 	};
       // 	imageBox.onmouseleave = imageBox.onmouseup = function () {
       // 		left = parseFloat(image.style.left);
       // 		tp = parseFloat(image.style.top);
       // 		imageBox.onmouseleave = null;
       // 		imageBox.onmousemove = null;
       // 		imageBox.onmouseup = null;
       // 	};
       // };

       imageBox.addEventListener("touchstart", function (e) {
         if (!statusZoom) return;
         body.classList.add("no-scroll");
         _this.modalScrollWrapper.style.overflow = "hidden";
         noClick = true;
         xx = e.touches[0].pageX - e.touches[0].target.offsetLeft;
         yy = e.touches[0].pageY - e.touches[0].target.offsetTop;

         function moveAt(e) {
           image.style.left = left + (e.touches[0].pageX - e.touches[0].target.offsetLeft) - xx + "px";
           image.style.top = tp + (e.touches[0].pageY - e.touches[0].target.offsetTop) - yy + "px";
           noClick = false;
         }

         imageBox.addEventListener("touchmove", function (e) {
           moveAt(e);
         }, false);
         imageBox.addEventListener("touchend", function () {
           left = parseFloat(image.style.left);
           tp = parseFloat(image.style.top);
           body.classList.remove("no-scroll");
           _this.modalScrollWrapper.style.overflow = "";
         }, false);
       }, false);
       imageBox.addEventListener("click", function (e) {
         e.preventDefault();
         if (!noClick) return;
         var el = this;
         var zoomScreen = el.querySelector("img");
         var scroll = 0;
         var scrollSpeed = 80;
         statusZoom = !statusZoom;

         if (statusZoom) {
           imageBox.classList.add("zoom");
           zoomScreen.style.transform = "scale(2) translateY(0)";
         } else {
           imageBox.classList.remove("zoom");
           zoomScreen.style.transform = "scale(1) translateY(0)";
           image.style.left = 0;
           image.style.top = 0;
         }

         el.addEventListener("wheel", function (e) {
           e.preventDefault();
           var zoomed = el.classList.contains("zoom");
           var stopScroll = zoomScreen.height / 4;
           var newScrollSpeed = 0;

           function scrollImg(e) {
             if (e.deltaY > 0) {
               newScrollSpeed = scroll > -stopScroll ? scrollSpeed : 0;
               zoomScreen.style.transform = "scale(2) translateY(".concat(scroll -= newScrollSpeed, "px)");
             } else {
               newScrollSpeed = scroll < stopScroll ? scrollSpeed : 0;
               zoomScreen.style.transform = "scale(2) translateY(".concat(scroll += newScrollSpeed, "px)");
             }
           }

           if (zoomed) {
             scrollImg(e);
           }
         });
       });
     });
   }
 });

 /***/ }),
 /* 299 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";
 __webpack_require__.r(__webpack_exports__);
 /* harmony import */ var _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
 /* harmony import */ var _components_popup__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(101);


 var selectors = {
   trigger: "[data-shipping-trigger]",
   container: "[data-shipping-popup]"
 };
 var modifiers = {
   hidden: "hidden"
 };
 Object(_shopify_theme_sections__WEBPACK_IMPORTED_MODULE_0__[/* register */ "b"])("product-shipping-popup", {
   onLoad: function onLoad() {
     this.initOpenTriggers();
   },
   initOpenTriggers: function initOpenTriggers() {
     var popupTrigger = document.querySelector(selectors.trigger);
     var popup = document.querySelector(selectors.container);

     if (!popupTrigger || !popup) {
       return null;
     }

     this.shippingPopup = new _components_popup__WEBPACK_IMPORTED_MODULE_1__["default"]();
     popupTrigger.classList.remove(modifiers.hidden);
     popupTrigger.addEventListener("click", function () {
       document.dispatchEvent(new CustomEvent("popup:open", {
         detail: {
           popup: popup
         }
       }));
     });
   }
 });

 /***/ }),
 /* 300 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";
 __webpack_require__.r(__webpack_exports__);
 /* harmony import */ var _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
 /* harmony import */ var _components_popup__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(101);


 var selectors = {
   trigger: "[data-sizes-trigger]",
   container: "[data-sizes-popup]"
 };
 var modifiers = {
   hidden: "hidden"
 };
 Object(_shopify_theme_sections__WEBPACK_IMPORTED_MODULE_0__[/* register */ "b"])("product-sizes-popup", {
   onLoad: function onLoad() {
     this.initOpenTriggers();
   },
   initOpenTriggers: function initOpenTriggers() {
     var popupTrigger = document.querySelector(selectors.trigger);
     var popup = document.querySelector(selectors.container);

     if (!popupTrigger || !popup) {
       return null;
     }

     this.shippingPopup = new _components_popup__WEBPACK_IMPORTED_MODULE_1__["default"]();
     popupTrigger.classList.remove(modifiers.hidden);
     popupTrigger.addEventListener("click", function () {
       document.dispatchEvent(new CustomEvent("popup:open", {
         detail: {
           popup: popup
         }
       }));
     });
   }
 });

 /***/ }),
 /* 301 */
 /***/ (function(module, exports, __webpack_require__) {

 "use strict";

 var DESCRIPTORS = __webpack_require__(23);
 var uncurryThis = __webpack_require__(5);
 var call = __webpack_require__(22);
 var fails = __webpack_require__(10);
 var objectKeys = __webpack_require__(84);
 var getOwnPropertySymbolsModule = __webpack_require__(119);
 var propertyIsEnumerableModule = __webpack_require__(109);
 var toObject = __webpack_require__(42);
 var IndexedObject = __webpack_require__(89);

 // eslint-disable-next-line es/no-object-assign -- safe
 var $assign = Object.assign;
 // eslint-disable-next-line es/no-object-defineproperty -- required for testing
 var defineProperty = Object.defineProperty;
 var concat = uncurryThis([].concat);

 // `Object.assign` method
 // https://tc39.es/ecma262/#sec-object.assign
 module.exports = !$assign || fails(function () {
   // should have correct order of operations (Edge bug)
   if (DESCRIPTORS && $assign({ b: 1 }, $assign(defineProperty({}, 'a', {
     enumerable: true,
     get: function () {
       defineProperty(this, 'b', {
         value: 3,
         enumerable: false
       });
     }
   }), { b: 2 })).b !== 1) return true;
   // should work with symbols and should have deterministic property order (V8 bug)
   var A = {};
   var B = {};
   // eslint-disable-next-line es/no-symbol -- safe
   var symbol = Symbol();
   var alphabet = 'abcdefghijklmnopqrst';
   A[symbol] = 7;
   alphabet.split('').forEach(function (chr) { B[chr] = chr; });
   return $assign({}, A)[symbol] != 7 || objectKeys($assign({}, B)).join('') != alphabet;
 }) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
   var T = toObject(target);
   var argumentsLength = arguments.length;
   var index = 1;
   var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
   var propertyIsEnumerable = propertyIsEnumerableModule.f;
   while (argumentsLength > index) {
     var S = IndexedObject(arguments[index++]);
     var keys = getOwnPropertySymbols ? concat(objectKeys(S), getOwnPropertySymbols(S)) : objectKeys(S);
     var length = keys.length;
     var j = 0;
     var key;
     while (length > j) {
       key = keys[j++];
       if (!DESCRIPTORS || call(propertyIsEnumerable, S, key)) T[key] = S[key];
     }
   } return T;
 } : $assign;


 /***/ }),
 /* 302 */
 /***/ (function(module, exports, __webpack_require__) {

 var fails = __webpack_require__(10);
 var wellKnownSymbol = __webpack_require__(12);
 var IS_PURE = __webpack_require__(60);

 var ITERATOR = wellKnownSymbol('iterator');

 module.exports = !fails(function () {
   var url = new URL('b?a=1&b=2&c=3', 'http://a');
   var searchParams = url.searchParams;
   var result = '';
   url.pathname = 'c%20d';
   searchParams.forEach(function (value, key) {
     searchParams['delete']('b');
     result += key + value;
   });
   return (IS_PURE && !url.toJSON)
     || !searchParams.sort
     || url.href !== 'http://a/c%20d?a=1&c=3'
     || searchParams.get('c') !== '3'
     || String(new URLSearchParams('?a=1')) !== 'a=1'
     || !searchParams[ITERATOR]
     // throws in Edge
     || new URL('https://a@b').username !== 'a'
     || new URLSearchParams(new URLSearchParams('a=b')).get('a') !== 'b'
     // not punycoded in Edge
     || new URL('http://тест').host !== 'xn--e1aybc'
     // not escaped in Chrome 62-
     || new URL('http://a#б').hash !== '#%D0%B1'
     // fails in Chrome 66-
     || result !== 'a1c3'
     // throws in Safari
     || new URL('http://x', undefined).host !== 'x';
 });


 /***/ }),
 /* 303 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";
 __webpack_require__.r(__webpack_exports__);
 /* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3);
 /* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8);
 /* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_1__);
 /* harmony import */ var _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1);




 (function () {
   var selectors = {
     messagesBlock: ".announcement-bar__messages",
     message: "[data-message-id]",
     announcement: {
       announcementBar: "[data-announcement-bar]"
     }
   };
   var modifiers = {
     active: "announcement-bar__message--active",
     show: "announcement-bar__message--show"
   };
   var messageId = 1;
   var messageNextTime = 5000;

   var animateBar = function animateBar() {
     var messages_block = document.querySelector(selectors.messagesBlock);
     var messages = messages_block.querySelectorAll(selectors.message);
     var messageActiveId = messageId;
     messages.forEach(function (message) {
       if (+message.dataset.messageId === messageActiveId) {
         setTimeout(function () {
           message.classList.add(modifiers.show);
         }, 500);
         setTimeout(function () {
           message.classList.add(modifiers.active);
         }, 1000);
         document.querySelector(selectors.announcement.announcementBar).style.background = message.dataset.backgroundColor;
         messageId = +message.dataset.nextMessageId;
         messageNextTime = 0 + message.dataset.nextMessageTime;
       } else {
         message.classList.remove(modifiers.active);
         setTimeout(function () {
           message.classList.remove(modifiers.show);
         }, 500);
       }
     });
     setTimeout(animateBar, messageNextTime);
   };

   Object(_shopify_theme_sections__WEBPACK_IMPORTED_MODULE_2__[/* register */ "b"])("announcement-bar", {
     onLoad: function onLoad() {
       this.init();
     },
     init: function init() {
       this.initMessageAnimation();
     },
     initMessageAnimation: function initMessageAnimation() {
       animateBar();
     }
   });
 })();

 /***/ }),
 /* 304 */
 /***/ (function(module, exports) {

 document.addEventListener("DOMContentLoaded", function () {
   var imageBox = document.querySelector(".zoomer");
   var body = document.querySelector("body");
   var statusZ = false;
   var scroll = 0;
   var scrollSpeed = 80;
   var left = 0,
       tp = 0,
       xx,
       yy;

   if (imageBox) {
     imageBox.addEventListener("touchstart", function (e) {
       if (!statusZ) return;
       var image = imageBox.querySelector("img");
       body.classList.add("no-scroll");
       xx = e.touches[0].pageX - e.touches[0].target.offsetLeft;
       yy = e.touches[0].pageY - e.touches[0].target.offsetTop;

       function moveAt(e) {
         image.style.left = left + (e.touches[0].pageX - e.touches[0].target.offsetLeft) - xx + "px";
         image.style.top = tp + (e.touches[0].pageY - e.touches[0].target.offsetTop) - yy + "px";
       }

       imageBox.addEventListener("touchmove", function (e) {
         moveAt(e);
       }, false);
       imageBox.addEventListener("touchend", function () {
         left = parseFloat(image.style.left);
         tp = parseFloat(image.style.top);
         body.classList.remove("no-scroll");
       }, false);
     }, false);
     imageBox.addEventListener("click", function (e) {
       e.preventDefault();
       var el = this;
       var zoomScreen = el.querySelector("img");
       statusZ = !statusZ;

       if (statusZ) {
         imageBox.classList.add("zoom");
         zoomScreen.style.transform = "scale(2) translateY(0)";
       } else {
         imageBox.classList.remove("zoom");
         zoomScreen.style.transform = "scale(1) translateY(0)";
       }

       el.addEventListener("wheel", function (e) {
         e.preventDefault();
         var zoomed = el.classList.contains("zoom");
         var stopScroll = zoomScreen.height / 4;
         var newScrollSpeed = 0;

         function scrollImg(e) {
           if (e.deltaY > 0) {
             newScrollSpeed = scroll > -stopScroll ? scrollSpeed : 0;
             zoomScreen.style.transform = "scale(2) translateY(".concat(scroll -= newScrollSpeed, "px)");
           } else {
             newScrollSpeed = scroll < stopScroll ? scrollSpeed : 0;
             zoomScreen.style.transform = "scale(2) translateY(".concat(scroll += newScrollSpeed, "px)");
           }
         }

         if (zoomed) {
           scrollImg(e);
         }
       });
     });
   }
 });

 /***/ }),
 /* 305 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";
 __webpack_require__.r(__webpack_exports__);
 /* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80);
 /* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3);
 /* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1__);
 /* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8);
 /* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_2__);




 (function () {
   document.addEventListener("DOMContentLoaded", function () {
     startAnimation();

     function startAnimation() {
       var animateElements = [].slice.call(document.querySelectorAll(".js-animate"));

       if (animateElements.length < 1) {
         return;
       }

       if ("IntersectionObserver" in window) {
         var options = {
           rootMargin: "-100px"
         };
         var animateObserver = new IntersectionObserver(function (entries) {
           entries.forEach(function (entry) {
             if (entry.isIntersecting) {
               var element = entry.target;
               var elementAnimationName = element.dataset.animationName;
               element.classList.add(elementAnimationName);
               animateObserver.unobserve(element);
               element.classList.remove("js-animate");
             }
           });
         }, options);
         animateElements.forEach(function (element) {
           animateObserver.observe(element);
         });
       } else {
         // Not supported, load all images immediately
         animateElements.forEach(function (element) {
           element.classList.add("animate__bounceIn");
         });
       }
     }
   });
 })();

 /***/ }),
 /* 306 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";
 __webpack_require__.r(__webpack_exports__);
 /* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21);
 /* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony import */ var core_js_modules_es_string_split_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(106);
 /* harmony import */ var core_js_modules_es_string_split_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split_js__WEBPACK_IMPORTED_MODULE_1__);



 (function () {
   function setCookie(cname, cvalue, exdays) {
     var d = new Date();
     d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
     var expires = "expires=" + d.toGMTString();
     document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
   }

   function getCookie(cname) {
     var name = cname + "=";
     var decodedCookie = decodeURIComponent(document.cookie);
     var ca = decodedCookie.split(";");

     for (var i = 0; i < ca.length; i++) {
       var c = ca[i];

       while (c.charAt(0) == " ") {
         c = c.substring(1);
       }

       if (c.indexOf(name) == 0) {
         return c.substring(name.length, c.length);
       }
     }

     return "";
   }

   var delayPopup = document.querySelector(".newsletter-popup");

   if (delayPopup) {
     delayPopup = delayPopup.dataset.delay * 1000;
   }

   var cookieDate = document.querySelector(".newsletter-popup");

   if (cookieDate) {
     cookieDate = cookieDate.dataset.cookie;
   }

   var cookiePopup = getCookie("newsletter");
   var newsletterPopup = document.querySelector(".newsletter-popup");

   if (!cookiePopup) {
     setTimeout(function () {
       if (newsletterPopup) {
         newsletterPopup.classList.add("popup--open");
         setCookie("newsletter", true, cookieDate);
       }
     }, delayPopup);
   }

   var iconClose = document.querySelector(".newsletter__icon-close");

   if (iconClose) {
     iconClose.addEventListener("click", function () {
       var elem = document.querySelector(".newsletter-popup");
       if (elem.classList.contains("popup--open")) elem.classList.toggle("popup--open");
     });
   }
 })();

 /***/ }),
 /* 307 */
 /***/ (function(module, exports, __webpack_require__) {

 var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var require;var require;/*!
  * Select2 4.1.0-rc.0
  * https://select2.github.io
  *
  * Released under the MIT license
  * https://github.com/select2/select2/blob/master/LICENSE.md
  */
 ;(function (factory) {
   if (true) {
     // AMD. Register as an anonymous module.
     !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
         __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
         (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
         __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
   } else {}
 } (function (jQuery) {
   // This is needed so we can catch the AMD loader configuration and use it
   // The inner file should be wrapped (by `banner.start.js`) in a function that
   // returns the AMD loader references.
   var S2 =(function () {
   // Restore the Select2 AMD loader so it can be used
   // Needed mostly in the language files, where the loader is not inserted
   if (jQuery && jQuery.fn && jQuery.fn.select2 && jQuery.fn.select2.amd) {
     var S2 = jQuery.fn.select2.amd;
   }
 var S2;(function () { if (!S2 || !S2.requirejs) {
 if (!S2) { S2 = {}; } else { require = S2; }
 /**
  * @license almond 0.3.3 Copyright jQuery Foundation and other contributors.
  * Released under MIT license, http://github.com/requirejs/almond/LICENSE
  */
 //Going sloppy to avoid 'use strict' string cost, but strict practices should
 //be followed.
 /*global setTimeout: false */

 var requirejs, require, define;
 (function (undef) {
     var main, req, makeMap, handlers,
         defined = {},
         waiting = {},
         config = {},
         defining = {},
         hasOwn = Object.prototype.hasOwnProperty,
         aps = [].slice,
         jsSuffixRegExp = /\.js$/;

     function hasProp(obj, prop) {
         return hasOwn.call(obj, prop);
     }

     /**
      * Given a relative module name, like ./something, normalize it to
      * a real name that can be mapped to a path.
      * @param {String} name the relative name
      * @param {String} baseName a real name that the name arg is relative
      * to.
      * @returns {String} normalized name
      */
     function normalize(name, baseName) {
         var nameParts, nameSegment, mapValue, foundMap, lastIndex,
             foundI, foundStarMap, starI, i, j, part, normalizedBaseParts,
             baseParts = baseName && baseName.split("/"),
             map = config.map,
             starMap = (map && map['*']) || {};

         //Adjust any relative paths.
         if (name) {
             name = name.split('/');
             lastIndex = name.length - 1;

             // If wanting node ID compatibility, strip .js from end
             // of IDs. Have to do this here, and not in nameToUrl
             // because node allows either .js or non .js to map
             // to same file.
             if (config.nodeIdCompat && jsSuffixRegExp.test(name[lastIndex])) {
                 name[lastIndex] = name[lastIndex].replace(jsSuffixRegExp, '');
             }

             // Starts with a '.' so need the baseName
             if (name[0].charAt(0) === '.' && baseParts) {
                 //Convert baseName to array, and lop off the last part,
                 //so that . matches that 'directory' and not name of the baseName's
                 //module. For instance, baseName of 'one/two/three', maps to
                 //'one/two/three.js', but we want the directory, 'one/two' for
                 //this normalization.
                 normalizedBaseParts = baseParts.slice(0, baseParts.length - 1);
                 name = normalizedBaseParts.concat(name);
             }

             //start trimDots
             for (i = 0; i < name.length; i++) {
                 part = name[i];
                 if (part === '.') {
                     name.splice(i, 1);
                     i -= 1;
                 } else if (part === '..') {
                     // If at the start, or previous value is still ..,
                     // keep them so that when converted to a path it may
                     // still work when converted to a path, even though
                     // as an ID it is less than ideal. In larger point
                     // releases, may be better to just kick out an error.
                     if (i === 0 || (i === 1 && name[2] === '..') || name[i - 1] === '..') {
                         continue;
                     } else if (i > 0) {
                         name.splice(i - 1, 2);
                         i -= 2;
                     }
                 }
             }
             //end trimDots

             name = name.join('/');
         }

         //Apply map config if available.
         if ((baseParts || starMap) && map) {
             nameParts = name.split('/');

             for (i = nameParts.length; i > 0; i -= 1) {
                 nameSegment = nameParts.slice(0, i).join("/");

                 if (baseParts) {
                     //Find the longest baseName segment match in the config.
                     //So, do joins on the biggest to smallest lengths of baseParts.
                     for (j = baseParts.length; j > 0; j -= 1) {
                         mapValue = map[baseParts.slice(0, j).join('/')];

                         //baseName segment has  config, find if it has one for
                         //this name.
                         if (mapValue) {
                             mapValue = mapValue[nameSegment];
                             if (mapValue) {
                                 //Match, update name to the new value.
                                 foundMap = mapValue;
                                 foundI = i;
                                 break;
                             }
                         }
                     }
                 }

                 if (foundMap) {
                     break;
                 }

                 //Check for a star map match, but just hold on to it,
                 //if there is a shorter segment match later in a matching
                 //config, then favor over this star map.
                 if (!foundStarMap && starMap && starMap[nameSegment]) {
                     foundStarMap = starMap[nameSegment];
                     starI = i;
                 }
             }

             if (!foundMap && foundStarMap) {
                 foundMap = foundStarMap;
                 foundI = starI;
             }

             if (foundMap) {
                 nameParts.splice(0, foundI, foundMap);
                 name = nameParts.join('/');
             }
         }

         return name;
     }

     function makeRequire(relName, forceSync) {
         return function () {
             //A version of a require function that passes a moduleName
             //value for items that may need to
             //look up paths relative to the moduleName
             var args = aps.call(arguments, 0);

             //If first arg is not require('string'), and there is only
             //one arg, it is the array form without a callback. Insert
             //a null so that the following concat is correct.
             if (typeof args[0] !== 'string' && args.length === 1) {
                 args.push(null);
             }
             return req.apply(undef, args.concat([relName, forceSync]));
         };
     }

     function makeNormalize(relName) {
         return function (name) {
             return normalize(name, relName);
         };
     }

     function makeLoad(depName) {
         return function (value) {
             defined[depName] = value;
         };
     }

     function callDep(name) {
         if (hasProp(waiting, name)) {
             var args = waiting[name];
             delete waiting[name];
             defining[name] = true;
             main.apply(undef, args);
         }

         if (!hasProp(defined, name) && !hasProp(defining, name)) {
             throw new Error('No ' + name);
         }
         return defined[name];
     }

     //Turns a plugin!resource to [plugin, resource]
     //with the plugin being undefined if the name
     //did not have a plugin prefix.
     function splitPrefix(name) {
         var prefix,
             index = name ? name.indexOf('!') : -1;
         if (index > -1) {
             prefix = name.substring(0, index);
             name = name.substring(index + 1, name.length);
         }
         return [prefix, name];
     }

     //Creates a parts array for a relName where first part is plugin ID,
     //second part is resource ID. Assumes relName has already been normalized.
     function makeRelParts(relName) {
         return relName ? splitPrefix(relName) : [];
     }

     /**
      * Makes a name map, normalizing the name, and using a plugin
      * for normalization if necessary. Grabs a ref to plugin
      * too, as an optimization.
      */
     makeMap = function (name, relParts) {
         var plugin,
             parts = splitPrefix(name),
             prefix = parts[0],
             relResourceName = relParts[1];

         name = parts[1];

         if (prefix) {
             prefix = normalize(prefix, relResourceName);
             plugin = callDep(prefix);
         }

         //Normalize according
         if (prefix) {
             if (plugin && plugin.normalize) {
                 name = plugin.normalize(name, makeNormalize(relResourceName));
             } else {
                 name = normalize(name, relResourceName);
             }
         } else {
             name = normalize(name, relResourceName);
             parts = splitPrefix(name);
             prefix = parts[0];
             name = parts[1];
             if (prefix) {
                 plugin = callDep(prefix);
             }
         }

         //Using ridiculous property names for space reasons
         return {
             f: prefix ? prefix + '!' + name : name, //fullName
             n: name,
             pr: prefix,
             p: plugin
         };
     };

     function makeConfig(name) {
         return function () {
             return (config && config.config && config.config[name]) || {};
         };
     }

     handlers = {
         require: function (name) {
             return makeRequire(name);
         },
         exports: function (name) {
             var e = defined[name];
             if (typeof e !== 'undefined') {
                 return e;
             } else {
                 return (defined[name] = {});
             }
         },
         module: function (name) {
             return {
                 id: name,
                 uri: '',
                 exports: defined[name],
                 config: makeConfig(name)
             };
         }
     };

     main = function (name, deps, callback, relName) {
         var cjsModule, depName, ret, map, i, relParts,
             args = [],
             callbackType = typeof callback,
             usingExports;

         //Use name if no relName
         relName = relName || name;
         relParts = makeRelParts(relName);

         //Call the callback to define the module, if necessary.
         if (callbackType === 'undefined' || callbackType === 'function') {
             //Pull out the defined dependencies and pass the ordered
             //values to the callback.
             //Default to [require, exports, module] if no deps
             deps = !deps.length && callback.length ? ['require', 'exports', 'module'] : deps;
             for (i = 0; i < deps.length; i += 1) {
                 map = makeMap(deps[i], relParts);
                 depName = map.f;

                 //Fast path CommonJS standard dependencies.
                 if (depName === "require") {
                     args[i] = handlers.require(name);
                 } else if (depName === "exports") {
                     //CommonJS module spec 1.1
                     args[i] = handlers.exports(name);
                     usingExports = true;
                 } else if (depName === "module") {
                     //CommonJS module spec 1.1
                     cjsModule = args[i] = handlers.module(name);
                 } else if (hasProp(defined, depName) ||
                            hasProp(waiting, depName) ||
                            hasProp(defining, depName)) {
                     args[i] = callDep(depName);
                 } else if (map.p) {
                     map.p.load(map.n, makeRequire(relName, true), makeLoad(depName), {});
                     args[i] = defined[depName];
                 } else {
                     throw new Error(name + ' missing ' + depName);
                 }
             }

             ret = callback ? callback.apply(defined[name], args) : undefined;

             if (name) {
                 //If setting exports via "module" is in play,
                 //favor that over return value and exports. After that,
                 //favor a non-undefined return value over exports use.
                 if (cjsModule && cjsModule.exports !== undef &&
                         cjsModule.exports !== defined[name]) {
                     defined[name] = cjsModule.exports;
                 } else if (ret !== undef || !usingExports) {
                     //Use the return value from the function.
                     defined[name] = ret;
                 }
             }
         } else if (name) {
             //May just be an object definition for the module. Only
             //worry about defining if have a module name.
             defined[name] = callback;
         }
     };

     requirejs = require = req = function (deps, callback, relName, forceSync, alt) {
         if (typeof deps === "string") {
             if (handlers[deps]) {
                 //callback in this case is really relName
                 return handlers[deps](callback);
             }
             //Just return the module wanted. In this scenario, the
             //deps arg is the module name, and second arg (if passed)
             //is just the relName.
             //Normalize module name, if it contains . or ..
             return callDep(makeMap(deps, makeRelParts(callback)).f);
         } else if (!deps.splice) {
             //deps is a config object, not an array.
             config = deps;
             if (config.deps) {
                 req(config.deps, config.callback);
             }
             if (!callback) {
                 return;
             }

             if (callback.splice) {
                 //callback is an array, which means it is a dependency list.
                 //Adjust args if there are dependencies
                 deps = callback;
                 callback = relName;
                 relName = null;
             } else {
                 deps = undef;
             }
         }

         //Support require(['a'])
         callback = callback || function () {};

         //If relName is a function, it is an errback handler,
         //so remove it.
         if (typeof relName === 'function') {
             relName = forceSync;
             forceSync = alt;
         }

         //Simulate async callback;
         if (forceSync) {
             main(undef, deps, callback, relName);
         } else {
             //Using a non-zero value because of concern for what old browsers
             //do, and latest browsers "upgrade" to 4 if lower value is used:
             //http://www.whatwg.org/specs/web-apps/current-work/multipage/timers.html#dom-windowtimers-settimeout:
             //If want a value immediately, use require('id') instead -- something
             //that works in almond on the global level, but not guaranteed and
             //unlikely to work in other AMD implementations.
             setTimeout(function () {
                 main(undef, deps, callback, relName);
             }, 4);
         }

         return req;
     };

     /**
      * Just drops the config on the floor, but returns req in case
      * the config return value is used.
      */
     req.config = function (cfg) {
         return req(cfg);
     };

     /**
      * Expose module registry for debugging and tooling
      */
     requirejs._defined = defined;

     define = function (name, deps, callback) {
         if (typeof name !== 'string') {
             throw new Error('See almond README: incorrect module build, no module name');
         }

         //This module may not have dependencies
         if (!deps.splice) {
             //deps is not an array, so probably means
             //an object literal or factory function for
             //the value. Adjust args.
             callback = deps;
             deps = [];
         }

         if (!hasProp(defined, name) && !hasProp(waiting, name)) {
             waiting[name] = [name, deps, callback];
         }
     };

     define.amd = {
         jQuery: true
     };
 }());

 S2.requirejs = requirejs;S2.require = require;S2.define = define;
 }
 }());
 S2.define("almond", function(){});

 /* global jQuery:false, $:false */
 S2.define('jquery',[],function () {
   var _$ = jQuery || $;

   if (_$ == null && console && console.error) {
     console.error(
       'Select2: An instance of jQuery or a jQuery-compatible library was not ' +
       'found. Make sure that you are including jQuery before Select2 on your ' +
       'web page.'
     );
   }

   return _$;
 });

 S2.define('select2/utils',[
   'jquery'
 ], function ($) {
   var Utils = {};

   Utils.Extend = function (ChildClass, SuperClass) {
     var __hasProp = {}.hasOwnProperty;

     function BaseConstructor () {
       this.constructor = ChildClass;
     }

     for (var key in SuperClass) {
       if (__hasProp.call(SuperClass, key)) {
         ChildClass[key] = SuperClass[key];
       }
     }

     BaseConstructor.prototype = SuperClass.prototype;
     ChildClass.prototype = new BaseConstructor();
     ChildClass.__super__ = SuperClass.prototype;

     return ChildClass;
   };

   function getMethods (theClass) {
     var proto = theClass.prototype;

     var methods = [];

     for (var methodName in proto) {
       var m = proto[methodName];

       if (typeof m !== 'function') {
         continue;
       }

       if (methodName === 'constructor') {
         continue;
       }

       methods.push(methodName);
     }

     return methods;
   }

   Utils.Decorate = function (SuperClass, DecoratorClass) {
     var decoratedMethods = getMethods(DecoratorClass);
     var superMethods = getMethods(SuperClass);

     function DecoratedClass () {
       var unshift = Array.prototype.unshift;

       var argCount = DecoratorClass.prototype.constructor.length;

       var calledConstructor = SuperClass.prototype.constructor;

       if (argCount > 0) {
         unshift.call(arguments, SuperClass.prototype.constructor);

         calledConstructor = DecoratorClass.prototype.constructor;
       }

       calledConstructor.apply(this, arguments);
     }

     DecoratorClass.displayName = SuperClass.displayName;

     function ctr () {
       this.constructor = DecoratedClass;
     }

     DecoratedClass.prototype = new ctr();

     for (var m = 0; m < superMethods.length; m++) {
       var superMethod = superMethods[m];

       DecoratedClass.prototype[superMethod] =
         SuperClass.prototype[superMethod];
     }

     var calledMethod = function (methodName) {
       // Stub out the original method if it's not decorating an actual method
       var originalMethod = function () {};

       if (methodName in DecoratedClass.prototype) {
         originalMethod = DecoratedClass.prototype[methodName];
       }

       var decoratedMethod = DecoratorClass.prototype[methodName];

       return function () {
         var unshift = Array.prototype.unshift;

         unshift.call(arguments, originalMethod);

         return decoratedMethod.apply(this, arguments);
       };
     };

     for (var d = 0; d < decoratedMethods.length; d++) {
       var decoratedMethod = decoratedMethods[d];

       DecoratedClass.prototype[decoratedMethod] = calledMethod(decoratedMethod);
     }

     return DecoratedClass;
   };

   var Observable = function () {
     this.listeners = {};
   };

   Observable.prototype.on = function (event, callback) {
     this.listeners = this.listeners || {};

     if (event in this.listeners) {
       this.listeners[event].push(callback);
     } else {
       this.listeners[event] = [callback];
     }
   };

   Observable.prototype.trigger = function (event) {
     var slice = Array.prototype.slice;
     var params = slice.call(arguments, 1);

     this.listeners = this.listeners || {};

     // Params should always come in as an array
     if (params == null) {
       params = [];
     }

     // If there are no arguments to the event, use a temporary object
     if (params.length === 0) {
       params.push({});
     }

     // Set the `_type` of the first object to the event
     params[0]._type = event;

     if (event in this.listeners) {
       this.invoke(this.listeners[event], slice.call(arguments, 1));
     }

     if ('*' in this.listeners) {
       this.invoke(this.listeners['*'], arguments);
     }
   };

   Observable.prototype.invoke = function (listeners, params) {
     for (var i = 0, len = listeners.length; i < len; i++) {
       listeners[i].apply(this, params);
     }
   };

   Utils.Observable = Observable;

   Utils.generateChars = function (length) {
     var chars = '';

     for (var i = 0; i < length; i++) {
       var randomChar = Math.floor(Math.random() * 36);
       chars += randomChar.toString(36);
     }

     return chars;
   };

   Utils.bind = function (func, context) {
     return function () {
       func.apply(context, arguments);
     };
   };

   Utils._convertData = function (data) {
     for (var originalKey in data) {
       var keys = originalKey.split('-');

       var dataLevel = data;

       if (keys.length === 1) {
         continue;
       }

       for (var k = 0; k < keys.length; k++) {
         var key = keys[k];

         // Lowercase the first letter
         // By default, dash-separated becomes camelCase
         key = key.substring(0, 1).toLowerCase() + key.substring(1);

         if (!(key in dataLevel)) {
           dataLevel[key] = {};
         }

         if (k == keys.length - 1) {
           dataLevel[key] = data[originalKey];
         }

         dataLevel = dataLevel[key];
       }

       delete data[originalKey];
     }

     return data;
   };

   Utils.hasScroll = function (index, el) {
     // Adapted from the function created by @ShadowScripter
     // and adapted by @BillBarry on the Stack Exchange Code Review website.
     // The original code can be found at
     // http://codereview.stackexchange.com/q/13338
     // and was designed to be used with the Sizzle selector engine.

     var $el = $(el);
     var overflowX = el.style.overflowX;
     var overflowY = el.style.overflowY;

     //Check both x and y declarations
     if (overflowX === overflowY &&
         (overflowY === 'hidden' || overflowY === 'visible')) {
       return false;
     }

     if (overflowX === 'scroll' || overflowY === 'scroll') {
       return true;
     }

     return ($el.innerHeight() < el.scrollHeight ||
       $el.innerWidth() < el.scrollWidth);
   };

   Utils.escapeMarkup = function (markup) {
     var replaceMap = {
       '\\': '&#92;',
       '&': '&amp;',
       '<': '&lt;',
       '>': '&gt;',
       '"': '&quot;',
       '\'': '&#39;',
       '/': '&#47;'
     };

     // Do not try to escape the markup if it's not a string
     if (typeof markup !== 'string') {
       return markup;
     }

     return String(markup).replace(/[&<>"'\/\\]/g, function (match) {
       return replaceMap[match];
     });
   };

   // Cache objects in Utils.__cache instead of $.data (see #4346)
   Utils.__cache = {};

   var id = 0;
   Utils.GetUniqueElementId = function (element) {
     // Get a unique element Id. If element has no id,
     // creates a new unique number, stores it in the id
     // attribute and returns the new id with a prefix.
     // If an id already exists, it simply returns it with a prefix.

     var select2Id = element.getAttribute('data-select2-id');

     if (select2Id != null) {
       return select2Id;
     }

     // If element has id, use it.
     if (element.id) {
       select2Id = 'select2-data-' + element.id;
     } else {
       select2Id = 'select2-data-' + (++id).toString() +
         '-' + Utils.generateChars(4);
     }

     element.setAttribute('data-select2-id', select2Id);

     return select2Id;
   };

   Utils.StoreData = function (element, name, value) {
     // Stores an item in the cache for a specified element.
     // name is the cache key.
     var id = Utils.GetUniqueElementId(element);
     if (!Utils.__cache[id]) {
       Utils.__cache[id] = {};
     }

     Utils.__cache[id][name] = value;
   };

   Utils.GetData = function (element, name) {
     // Retrieves a value from the cache by its key (name)
     // name is optional. If no name specified, return
     // all cache items for the specified element.
     // and for a specified element.
     var id = Utils.GetUniqueElementId(element);
     if (name) {
       if (Utils.__cache[id]) {
         if (Utils.__cache[id][name] != null) {
           return Utils.__cache[id][name];
         }
         return $(element).data(name); // Fallback to HTML5 data attribs.
       }
       return $(element).data(name); // Fallback to HTML5 data attribs.
     } else {
       return Utils.__cache[id];
     }
   };

   Utils.RemoveData = function (element) {
     // Removes all cached items for a specified element.
     var id = Utils.GetUniqueElementId(element);
     if (Utils.__cache[id] != null) {
       delete Utils.__cache[id];
     }

     element.removeAttribute('data-select2-id');
   };

   Utils.copyNonInternalCssClasses = function (dest, src) {
     var classes;

     var destinationClasses = dest.getAttribute('class').trim().split(/\s+/);

     destinationClasses = destinationClasses.filter(function (clazz) {
       // Save all Select2 classes
       return clazz.indexOf('select2-') === 0;
     });

     var sourceClasses = src.getAttribute('class').trim().split(/\s+/);

     sourceClasses = sourceClasses.filter(function (clazz) {
       // Only copy non-Select2 classes
       return clazz.indexOf('select2-') !== 0;
     });

     var replacements = destinationClasses.concat(sourceClasses);

     dest.setAttribute('class', replacements.join(' '));
   };

   return Utils;
 });

 S2.define('select2/results',[
   'jquery',
   './utils'
 ], function ($, Utils) {
   function Results ($element, options, dataAdapter) {
     this.$element = $element;
     this.data = dataAdapter;
     this.options = options;

     Results.__super__.constructor.call(this);
   }

   Utils.Extend(Results, Utils.Observable);

   Results.prototype.render = function () {
     var $results = $(
       '<ul class="select2-results__options" role="listbox"></ul>'
     );

     if (this.options.get('multiple')) {
       $results.attr('aria-multiselectable', 'true');
     }

     this.$results = $results;

     return $results;
   };

   Results.prototype.clear = function () {
     this.$results.empty();
   };

   Results.prototype.displayMessage = function (params) {
     var escapeMarkup = this.options.get('escapeMarkup');

     this.clear();
     this.hideLoading();

     var $message = $(
       '<li role="alert" aria-live="assertive"' +
       ' class="select2-results__option"></li>'
     );

     var message = this.options.get('translations').get(params.message);

     $message.append(
       escapeMarkup(
         message(params.args)
       )
     );

     $message[0].className += ' select2-results__message';

     this.$results.append($message);
   };

   Results.prototype.hideMessages = function () {
     this.$results.find('.select2-results__message').remove();
   };

   Results.prototype.append = function (data) {
     this.hideLoading();

     var $options = [];

     if (data.results == null || data.results.length === 0) {
       if (this.$results.children().length === 0) {
         this.trigger('results:message', {
           message: 'noResults'
         });
       }

       return;
     }

     data.results = this.sort(data.results);

     for (var d = 0; d < data.results.length; d++) {
       var item = data.results[d];

       var $option = this.option(item);

       $options.push($option);
     }

     this.$results.append($options);
   };

   Results.prototype.position = function ($results, $dropdown) {
     var $resultsContainer = $dropdown.find('.select2-results');
     $resultsContainer.append($results);
   };

   Results.prototype.sort = function (data) {
     var sorter = this.options.get('sorter');

     return sorter(data);
   };

   Results.prototype.highlightFirstItem = function () {
     var $options = this.$results
       .find('.select2-results__option--selectable');

     var $selected = $options.filter('.select2-results__option--selected');

     // Check if there are any selected options
     if ($selected.length > 0) {
       // If there are selected options, highlight the first
       $selected.first().trigger('mouseenter');
     } else {
       // If there are no selected options, highlight the first option
       // in the dropdown
       $options.first().trigger('mouseenter');
     }

     this.ensureHighlightVisible();
   };

   Results.prototype.setClasses = function () {
     var self = this;

     this.data.current(function (selected) {
       var selectedIds = selected.map(function (s) {
         return s.id.toString();
       });

       var $options = self.$results
         .find('.select2-results__option--selectable');

       $options.each(function () {
         var $option = $(this);

         var item = Utils.GetData(this, 'data');

         // id needs to be converted to a string when comparing
         var id = '' + item.id;

         if ((item.element != null && item.element.selected) ||
             (item.element == null && selectedIds.indexOf(id) > -1)) {
           this.classList.add('select2-results__option--selected');
           $option.attr('aria-selected', 'true');
         } else {
           this.classList.remove('select2-results__option--selected');
           $option.attr('aria-selected', 'false');
         }
       });

     });
   };

   Results.prototype.showLoading = function (params) {
     this.hideLoading();

     var loadingMore = this.options.get('translations').get('searching');

     var loading = {
       disabled: true,
       loading: true,
       text: loadingMore(params)
     };
     var $loading = this.option(loading);
     $loading.className += ' loading-results';

     this.$results.prepend($loading);
   };

   Results.prototype.hideLoading = function () {
     this.$results.find('.loading-results').remove();
   };

   Results.prototype.option = function (data) {
     var option = document.createElement('li');
     option.classList.add('select2-results__option');
     option.classList.add('select2-results__option--selectable');

     var attrs = {
       'role': 'option'
     };

     var matches = window.Element.prototype.matches ||
       window.Element.prototype.msMatchesSelector ||
       window.Element.prototype.webkitMatchesSelector;

     if ((data.element != null && matches.call(data.element, ':disabled')) ||
         (data.element == null && data.disabled)) {
       attrs['aria-disabled'] = 'true';

       option.classList.remove('select2-results__option--selectable');
       option.classList.add('select2-results__option--disabled');
     }

     if (data.id == null) {
       option.classList.remove('select2-results__option--selectable');
     }

     if (data._resultId != null) {
       option.id = data._resultId;
     }

     if (data.title) {
       option.title = data.title;
     }

     if (data.children) {
       attrs.role = 'group';
       attrs['aria-label'] = data.text;

       option.classList.remove('select2-results__option--selectable');
       option.classList.add('select2-results__option--group');
     }

     for (var attr in attrs) {
       var val = attrs[attr];

       option.setAttribute(attr, val);
     }

     if (data.children) {
       var $option = $(option);

       var label = document.createElement('strong');
       label.className = 'select2-results__group';

       this.template(data, label);

       var $children = [];

       for (var c = 0; c < data.children.length; c++) {
         var child = data.children[c];

         var $child = this.option(child);

         $children.push($child);
       }

       var $childrenContainer = $('<ul></ul>', {
         'class': 'select2-results__options select2-results__options--nested',
         'role': 'none'
       });

       $childrenContainer.append($children);

       $option.append(label);
       $option.append($childrenContainer);
     } else {
       this.template(data, option);
     }

     Utils.StoreData(option, 'data', data);

     return option;
   };

   Results.prototype.bind = function (container, $container) {
     var self = this;

     var id = container.id + '-results';

     this.$results.attr('id', id);

     container.on('results:all', function (params) {
       self.clear();
       self.append(params.data);

       if (container.isOpen()) {
         self.setClasses();
         self.highlightFirstItem();
       }
     });

     container.on('results:append', function (params) {
       self.append(params.data);

       if (container.isOpen()) {
         self.setClasses();
       }
     });

     container.on('query', function (params) {
       self.hideMessages();
       self.showLoading(params);
     });

     container.on('select', function () {
       if (!container.isOpen()) {
         return;
       }

       self.setClasses();

       if (self.options.get('scrollAfterSelect')) {
         self.highlightFirstItem();
       }
     });

     container.on('unselect', function () {
       if (!container.isOpen()) {
         return;
       }

       self.setClasses();

       if (self.options.get('scrollAfterSelect')) {
         self.highlightFirstItem();
       }
     });

     container.on('open', function () {
       // When the dropdown is open, aria-expended="true"
       self.$results.attr('aria-expanded', 'true');
       self.$results.attr('aria-hidden', 'false');

       self.setClasses();
       self.ensureHighlightVisible();
     });

     container.on('close', function () {
       // When the dropdown is closed, aria-expended="false"
       self.$results.attr('aria-expanded', 'false');
       self.$results.attr('aria-hidden', 'true');
       self.$results.removeAttr('aria-activedescendant');
     });

     container.on('results:toggle', function () {
       var $highlighted = self.getHighlightedResults();

       if ($highlighted.length === 0) {
         return;
       }

       $highlighted.trigger('mouseup');
     });

     container.on('results:select', function () {
       var $highlighted = self.getHighlightedResults();

       if ($highlighted.length === 0) {
         return;
       }

       var data = Utils.GetData($highlighted[0], 'data');

       if ($highlighted.hasClass('select2-results__option--selected')) {
         self.trigger('close', {});
       } else {
         self.trigger('select', {
           data: data
         });
       }
     });

     container.on('results:previous', function () {
       var $highlighted = self.getHighlightedResults();

       var $options = self.$results.find('.select2-results__option--selectable');

       var currentIndex = $options.index($highlighted);

       // If we are already at the top, don't move further
       // If no options, currentIndex will be -1
       if (currentIndex <= 0) {
         return;
       }

       var nextIndex = currentIndex - 1;

       // If none are highlighted, highlight the first
       if ($highlighted.length === 0) {
         nextIndex = 0;
       }

       var $next = $options.eq(nextIndex);

       $next.trigger('mouseenter');

       var currentOffset = self.$results.offset().top;
       var nextTop = $next.offset().top;
       var nextOffset = self.$results.scrollTop() + (nextTop - currentOffset);

       if (nextIndex === 0) {
         self.$results.scrollTop(0);
       } else if (nextTop - currentOffset < 0) {
         self.$results.scrollTop(nextOffset);
       }
     });

     container.on('results:next', function () {
       var $highlighted = self.getHighlightedResults();

       var $options = self.$results.find('.select2-results__option--selectable');

       var currentIndex = $options.index($highlighted);

       var nextIndex = currentIndex + 1;

       // If we are at the last option, stay there
       if (nextIndex >= $options.length) {
         return;
       }

       var $next = $options.eq(nextIndex);

       $next.trigger('mouseenter');

       var currentOffset = self.$results.offset().top +
         self.$results.outerHeight(false);
       var nextBottom = $next.offset().top + $next.outerHeight(false);
       var nextOffset = self.$results.scrollTop() + nextBottom - currentOffset;

       if (nextIndex === 0) {
         self.$results.scrollTop(0);
       } else if (nextBottom > currentOffset) {
         self.$results.scrollTop(nextOffset);
       }
     });

     container.on('results:focus', function (params) {
       params.element[0].classList.add('select2-results__option--highlighted');
       params.element[0].setAttribute('aria-selected', 'true');
     });

     container.on('results:message', function (params) {
       self.displayMessage(params);
     });

     if ($.fn.mousewheel) {
       this.$results.on('mousewheel', function (e) {
         var top = self.$results.scrollTop();

         var bottom = self.$results.get(0).scrollHeight - top + e.deltaY;

         var isAtTop = e.deltaY > 0 && top - e.deltaY <= 0;
         var isAtBottom = e.deltaY < 0 && bottom <= self.$results.height();

         if (isAtTop) {
           self.$results.scrollTop(0);

           e.preventDefault();
           e.stopPropagation();
         } else if (isAtBottom) {
           self.$results.scrollTop(
             self.$results.get(0).scrollHeight - self.$results.height()
           );

           e.preventDefault();
           e.stopPropagation();
         }
       });
     }

     this.$results.on('mouseup', '.select2-results__option--selectable',
       function (evt) {
       var $this = $(this);

       var data = Utils.GetData(this, 'data');

       if ($this.hasClass('select2-results__option--selected')) {
         if (self.options.get('multiple')) {
           self.trigger('unselect', {
             originalEvent: evt,
             data: data
           });
         } else {
           self.trigger('close', {});
         }

         return;
       }

       self.trigger('select', {
         originalEvent: evt,
         data: data
       });
     });

     this.$results.on('mouseenter', '.select2-results__option--selectable',
       function (evt) {
       var data = Utils.GetData(this, 'data');

       self.getHighlightedResults()
           .removeClass('select2-results__option--highlighted')
           .attr('aria-selected', 'false');

       self.trigger('results:focus', {
         data: data,
         element: $(this)
       });
     });
   };

   Results.prototype.getHighlightedResults = function () {
     var $highlighted = this.$results
     .find('.select2-results__option--highlighted');

     return $highlighted;
   };

   Results.prototype.destroy = function () {
     this.$results.remove();
   };

   Results.prototype.ensureHighlightVisible = function () {
     var $highlighted = this.getHighlightedResults();

     if ($highlighted.length === 0) {
       return;
     }

     var $options = this.$results.find('.select2-results__option--selectable');

     var currentIndex = $options.index($highlighted);

     var currentOffset = this.$results.offset().top;
     var nextTop = $highlighted.offset().top;
     var nextOffset = this.$results.scrollTop() + (nextTop - currentOffset);

     var offsetDelta = nextTop - currentOffset;
     nextOffset -= $highlighted.outerHeight(false) * 2;

     if (currentIndex <= 2) {
       this.$results.scrollTop(0);
     } else if (offsetDelta > this.$results.outerHeight() || offsetDelta < 0) {
       this.$results.scrollTop(nextOffset);
     }
   };

   Results.prototype.template = function (result, container) {
     var template = this.options.get('templateResult');
     var escapeMarkup = this.options.get('escapeMarkup');

     var content = template(result, container);

     if (content == null) {
       container.style.display = 'none';
     } else if (typeof content === 'string') {
       container.innerHTML = escapeMarkup(content);
     } else {
       $(container).append(content);
     }
   };

   return Results;
 });

 S2.define('select2/keys',[

 ], function () {
   var KEYS = {
     BACKSPACE: 8,
     TAB: 9,
     ENTER: 13,
     SHIFT: 16,
     CTRL: 17,
     ALT: 18,
     ESC: 27,
     SPACE: 32,
     PAGE_UP: 33,
     PAGE_DOWN: 34,
     END: 35,
     HOME: 36,
     LEFT: 37,
     UP: 38,
     RIGHT: 39,
     DOWN: 40,
     DELETE: 46
   };

   return KEYS;
 });

 S2.define('select2/selection/base',[
   'jquery',
   '../utils',
   '../keys'
 ], function ($, Utils, KEYS) {
   function BaseSelection ($element, options) {
     this.$element = $element;
     this.options = options;

     BaseSelection.__super__.constructor.call(this);
   }

   Utils.Extend(BaseSelection, Utils.Observable);

   BaseSelection.prototype.render = function () {
     var $selection = $(
       '<span class="select2-selection" role="combobox" ' +
       ' aria-haspopup="true" aria-expanded="false">' +
       '</span>'
     );

     this._tabindex = 0;

     if (Utils.GetData(this.$element[0], 'old-tabindex') != null) {
       this._tabindex = Utils.GetData(this.$element[0], 'old-tabindex');
     } else if (this.$element.attr('tabindex') != null) {
       this._tabindex = this.$element.attr('tabindex');
     }

     $selection.attr('title', this.$element.attr('title'));
     $selection.attr('tabindex', this._tabindex);
     $selection.attr('aria-disabled', 'false');

     this.$selection = $selection;

     return $selection;
   };

   BaseSelection.prototype.bind = function (container, $container) {
     var self = this;

     var resultsId = container.id + '-results';

     this.container = container;

     this.$selection.on('focus', function (evt) {
       self.trigger('focus', evt);
     });

     this.$selection.on('blur', function (evt) {
       self._handleBlur(evt);
     });

     this.$selection.on('keydown', function (evt) {
       self.trigger('keypress', evt);

       if (evt.which === KEYS.SPACE) {
         evt.preventDefault();
       }
     });

     container.on('results:focus', function (params) {
       self.$selection.attr('aria-activedescendant', params.data._resultId);
     });

     container.on('selection:update', function (params) {
       self.update(params.data);
     });

     container.on('open', function () {
       // When the dropdown is open, aria-expanded="true"
       self.$selection.attr('aria-expanded', 'true');
       self.$selection.attr('aria-owns', resultsId);

       self._attachCloseHandler(container);
     });

     container.on('close', function () {
       // When the dropdown is closed, aria-expanded="false"
       self.$selection.attr('aria-expanded', 'false');
       self.$selection.removeAttr('aria-activedescendant');
       self.$selection.removeAttr('aria-owns');

       self.$selection.trigger('focus');

       self._detachCloseHandler(container);
     });

     container.on('enable', function () {
       self.$selection.attr('tabindex', self._tabindex);
       self.$selection.attr('aria-disabled', 'false');
     });

     container.on('disable', function () {
       self.$selection.attr('tabindex', '-1');
       self.$selection.attr('aria-disabled', 'true');
     });
   };

   BaseSelection.prototype._handleBlur = function (evt) {
     var self = this;

     // This needs to be delayed as the active element is the body when the tab
     // key is pressed, possibly along with others.
     window.setTimeout(function () {
       // Don't trigger `blur` if the focus is still in the selection
       if (
         (document.activeElement == self.$selection[0]) ||
         ($.contains(self.$selection[0], document.activeElement))
       ) {
         return;
       }

       self.trigger('blur', evt);
     }, 1);
   };

   BaseSelection.prototype._attachCloseHandler = function (container) {

     $(document.body).on('mousedown.select2.' + container.id, function (e) {
       var $target = $(e.target);

       var $select = $target.closest('.select2');

       var $all = $('.select2.select2-container--open');

       $all.each(function () {
         if (this == $select[0]) {
           return;
         }

         var $element = Utils.GetData(this, 'element');

         $element.select2('close');
       });
     });
   };

   BaseSelection.prototype._detachCloseHandler = function (container) {
     $(document.body).off('mousedown.select2.' + container.id);
   };

   BaseSelection.prototype.position = function ($selection, $container) {
     var $selectionContainer = $container.find('.selection');
     $selectionContainer.append($selection);
   };

   BaseSelection.prototype.destroy = function () {
     this._detachCloseHandler(this.container);
   };

   BaseSelection.prototype.update = function (data) {
     throw new Error('The `update` method must be defined in child classes.');
   };

   /**
    * Helper method to abstract the "enabled" (not "disabled") state of this
    * object.
    *
    * @return {true} if the instance is not disabled.
    * @return {false} if the instance is disabled.
    */
   BaseSelection.prototype.isEnabled = function () {
     return !this.isDisabled();
   };

   /**
    * Helper method to abstract the "disabled" state of this object.
    *
    * @return {true} if the disabled option is true.
    * @return {false} if the disabled option is false.
    */
   BaseSelection.prototype.isDisabled = function () {
     return this.options.get('disabled');
   };

   return BaseSelection;
 });

 S2.define('select2/selection/single',[
   'jquery',
   './base',
   '../utils',
   '../keys'
 ], function ($, BaseSelection, Utils, KEYS) {
   function SingleSelection () {
     SingleSelection.__super__.constructor.apply(this, arguments);
   }

   Utils.Extend(SingleSelection, BaseSelection);

   SingleSelection.prototype.render = function () {
     var $selection = SingleSelection.__super__.render.call(this);

     $selection[0].classList.add('select2-selection--single');

     $selection.html(
       '<span class="select2-selection__rendered"></span>' +
       '<span class="select2-selection__arrow" role="presentation">' +
         '<b role="presentation"></b>' +
       '</span>'
     );

     return $selection;
   };

   SingleSelection.prototype.bind = function (container, $container) {
     var self = this;

     SingleSelection.__super__.bind.apply(this, arguments);

     var id = container.id + '-container';

     this.$selection.find('.select2-selection__rendered')
       .attr('id', id)
       .attr('role', 'textbox')
       .attr('aria-readonly', 'true');
     this.$selection.attr('aria-labelledby', id);
     this.$selection.attr('aria-controls', id);

     this.$selection.on('mousedown', function (evt) {
       // Only respond to left clicks
       if (evt.which !== 1) {
         return;
       }

       self.trigger('toggle', {
         originalEvent: evt
       });
     });

     this.$selection.on('focus', function (evt) {
       // User focuses on the container
     });

     this.$selection.on('blur', function (evt) {
       // User exits the container
     });

     container.on('focus', function (evt) {
       if (!container.isOpen()) {
         self.$selection.trigger('focus');
       }
     });
   };

   SingleSelection.prototype.clear = function () {
     var $rendered = this.$selection.find('.select2-selection__rendered');
     $rendered.empty();
     $rendered.removeAttr('title'); // clear tooltip on empty
   };

   SingleSelection.prototype.display = function (data, container) {
     var template = this.options.get('templateSelection');
     var escapeMarkup = this.options.get('escapeMarkup');

     return escapeMarkup(template(data, container));
   };

   SingleSelection.prototype.selectionContainer = function () {
     return $('<span></span>');
   };

   SingleSelection.prototype.update = function (data) {
     if (data.length === 0) {
       this.clear();
       return;
     }

     var selection = data[0];

     var $rendered = this.$selection.find('.select2-selection__rendered');
     var formatted = this.display(selection, $rendered);

     $rendered.empty().append(formatted);

     var title = selection.title || selection.text;

     if (title) {
       $rendered.attr('title', title);
     } else {
       $rendered.removeAttr('title');
     }
   };

   return SingleSelection;
 });

 S2.define('select2/selection/multiple',[
   'jquery',
   './base',
   '../utils'
 ], function ($, BaseSelection, Utils) {
   function MultipleSelection ($element, options) {
     MultipleSelection.__super__.constructor.apply(this, arguments);
   }

   Utils.Extend(MultipleSelection, BaseSelection);

   MultipleSelection.prototype.render = function () {
     var $selection = MultipleSelection.__super__.render.call(this);

     $selection[0].classList.add('select2-selection--multiple');

     $selection.html(
       '<ul class="select2-selection__rendered"></ul>'
     );

     return $selection;
   };

   MultipleSelection.prototype.bind = function (container, $container) {
     var self = this;

     MultipleSelection.__super__.bind.apply(this, arguments);

     var id = container.id + '-container';
     this.$selection.find('.select2-selection__rendered').attr('id', id);

     this.$selection.on('click', function (evt) {
       self.trigger('toggle', {
         originalEvent: evt
       });
     });

     this.$selection.on(
       'click',
       '.select2-selection__choice__remove',
       function (evt) {
         // Ignore the event if it is disabled
         if (self.isDisabled()) {
           return;
         }

         var $remove = $(this);
         var $selection = $remove.parent();

         var data = Utils.GetData($selection[0], 'data');

         self.trigger('unselect', {
           originalEvent: evt,
           data: data
         });
       }
     );

     this.$selection.on(
       'keydown',
       '.select2-selection__choice__remove',
       function (evt) {
         // Ignore the event if it is disabled
         if (self.isDisabled()) {
           return;
         }

         evt.stopPropagation();
       }
     );
   };

   MultipleSelection.prototype.clear = function () {
     var $rendered = this.$selection.find('.select2-selection__rendered');
     $rendered.empty();
     $rendered.removeAttr('title');
   };

   MultipleSelection.prototype.display = function (data, container) {
     var template = this.options.get('templateSelection');
     var escapeMarkup = this.options.get('escapeMarkup');

     return escapeMarkup(template(data, container));
   };

   MultipleSelection.prototype.selectionContainer = function () {
     var $container = $(
       '<li class="select2-selection__choice">' +
         '<button type="button" class="select2-selection__choice__remove" ' +
         'tabindex="-1">' +
           '<span aria-hidden="true">&times;</span>' +
         '</button>' +
         '<span class="select2-selection__choice__display"></span>' +
       '</li>'
     );

     return $container;
   };

   MultipleSelection.prototype.update = function (data) {
     this.clear();

     if (data.length === 0) {
       return;
     }

     var $selections = [];

     var selectionIdPrefix = this.$selection.find('.select2-selection__rendered')
       .attr('id') + '-choice-';

     for (var d = 0; d < data.length; d++) {
       var selection = data[d];

       var $selection = this.selectionContainer();
       var formatted = this.display(selection, $selection);

       var selectionId = selectionIdPrefix + Utils.generateChars(4) + '-';

       if (selection.id) {
         selectionId += selection.id;
       } else {
         selectionId += Utils.generateChars(4);
       }

       $selection.find('.select2-selection__choice__display')
         .append(formatted)
         .attr('id', selectionId);

       var title = selection.title || selection.text;

       if (title) {
         $selection.attr('title', title);
       }

       var removeItem = this.options.get('translations').get('removeItem');

       var $remove = $selection.find('.select2-selection__choice__remove');

       $remove.attr('title', removeItem());
       $remove.attr('aria-label', removeItem());
       $remove.attr('aria-describedby', selectionId);

       Utils.StoreData($selection[0], 'data', selection);

       $selections.push($selection);
     }

     var $rendered = this.$selection.find('.select2-selection__rendered');

     $rendered.append($selections);
   };

   return MultipleSelection;
 });

 S2.define('select2/selection/placeholder',[

 ], function () {
   function Placeholder (decorated, $element, options) {
     this.placeholder = this.normalizePlaceholder(options.get('placeholder'));

     decorated.call(this, $element, options);
   }

   Placeholder.prototype.normalizePlaceholder = function (_, placeholder) {
     if (typeof placeholder === 'string') {
       placeholder = {
         id: '',
         text: placeholder
       };
     }

     return placeholder;
   };

   Placeholder.prototype.createPlaceholder = function (decorated, placeholder) {
     var $placeholder = this.selectionContainer();

     $placeholder.html(this.display(placeholder));
     $placeholder[0].classList.add('select2-selection__placeholder');
     $placeholder[0].classList.remove('select2-selection__choice');

     var placeholderTitle = placeholder.title ||
       placeholder.text ||
       $placeholder.text();

     this.$selection.find('.select2-selection__rendered').attr(
       'title',
       placeholderTitle
     );

     return $placeholder;
   };

   Placeholder.prototype.update = function (decorated, data) {
     var singlePlaceholder = (
       data.length == 1 && data[0].id != this.placeholder.id
     );
     var multipleSelections = data.length > 1;

     if (multipleSelections || singlePlaceholder) {
       return decorated.call(this, data);
     }

     this.clear();

     var $placeholder = this.createPlaceholder(this.placeholder);

     this.$selection.find('.select2-selection__rendered').append($placeholder);
   };

   return Placeholder;
 });

 S2.define('select2/selection/allowClear',[
   'jquery',
   '../keys',
   '../utils'
 ], function ($, KEYS, Utils) {
   function AllowClear () { }

   AllowClear.prototype.bind = function (decorated, container, $container) {
     var self = this;

     decorated.call(this, container, $container);

     if (this.placeholder == null) {
       if (this.options.get('debug') && window.console && console.error) {
         console.error(
           'Select2: The `allowClear` option should be used in combination ' +
           'with the `placeholder` option.'
         );
       }
     }

     this.$selection.on('mousedown', '.select2-selection__clear',
       function (evt) {
         self._handleClear(evt);
     });

     container.on('keypress', function (evt) {
       self._handleKeyboardClear(evt, container);
     });
   };

   AllowClear.prototype._handleClear = function (_, evt) {
     // Ignore the event if it is disabled
     if (this.isDisabled()) {
       return;
     }

     var $clear = this.$selection.find('.select2-selection__clear');

     // Ignore the event if nothing has been selected
     if ($clear.length === 0) {
       return;
     }

     evt.stopPropagation();

     var data = Utils.GetData($clear[0], 'data');

     var previousVal = this.$element.val();
     this.$element.val(this.placeholder.id);

     var unselectData = {
       data: data
     };
     this.trigger('clear', unselectData);
     if (unselectData.prevented) {
       this.$element.val(previousVal);
       return;
     }

     for (var d = 0; d < data.length; d++) {
       unselectData = {
         data: data[d]
       };

       // Trigger the `unselect` event, so people can prevent it from being
       // cleared.
       this.trigger('unselect', unselectData);

       // If the event was prevented, don't clear it out.
       if (unselectData.prevented) {
         this.$element.val(previousVal);
         return;
       }
     }

     this.$element.trigger('input').trigger('change');

     this.trigger('toggle', {});
   };

   AllowClear.prototype._handleKeyboardClear = function (_, evt, container) {
     if (container.isOpen()) {
       return;
     }

     if (evt.which == KEYS.DELETE || evt.which == KEYS.BACKSPACE) {
       this._handleClear(evt);
     }
   };

   AllowClear.prototype.update = function (decorated, data) {
     decorated.call(this, data);

     this.$selection.find('.select2-selection__clear').remove();
     this.$selection[0].classList.remove('select2-selection--clearable');

     if (this.$selection.find('.select2-selection__placeholder').length > 0 ||
         data.length === 0) {
       return;
     }

     var selectionId = this.$selection.find('.select2-selection__rendered')
       .attr('id');

     var removeAll = this.options.get('translations').get('removeAllItems');

     var $remove = $(
       '<button type="button" class="select2-selection__clear" tabindex="-1">' +
         '<span aria-hidden="true">&times;</span>' +
       '</button>'
     );
     $remove.attr('title', removeAll());
     $remove.attr('aria-label', removeAll());
     $remove.attr('aria-describedby', selectionId);
     Utils.StoreData($remove[0], 'data', data);

     this.$selection.prepend($remove);
     this.$selection[0].classList.add('select2-selection--clearable');
   };

   return AllowClear;
 });

 S2.define('select2/selection/search',[
   'jquery',
   '../utils',
   '../keys'
 ], function ($, Utils, KEYS) {
   function Search (decorated, $element, options) {
     decorated.call(this, $element, options);
   }

   Search.prototype.render = function (decorated) {
     var searchLabel = this.options.get('translations').get('search');
     var $search = $(
       '<span class="select2-search select2-search--inline">' +
         '<textarea class="select2-search__field"'+
         ' type="search" tabindex="-1"' +
         ' autocorrect="off" autocapitalize="none"' +
         ' spellcheck="false" role="searchbox" aria-autocomplete="list" >' +
         '</textarea>' +
       '</span>'
     );

     this.$searchContainer = $search;
     this.$search = $search.find('textarea');

     this.$search.prop('autocomplete', this.options.get('autocomplete'));
     this.$search.attr('aria-label', searchLabel());

     var $rendered = decorated.call(this);

     this._transferTabIndex();
     $rendered.append(this.$searchContainer);

     return $rendered;
   };

   Search.prototype.bind = function (decorated, container, $container) {
     var self = this;

     var resultsId = container.id + '-results';
     var selectionId = container.id + '-container';

     decorated.call(this, container, $container);

     self.$search.attr('aria-describedby', selectionId);

     container.on('open', function () {
       self.$search.attr('aria-controls', resultsId);
       self.$search.trigger('focus');
     });

     container.on('close', function () {
       self.$search.val('');
       self.resizeSearch();
       self.$search.removeAttr('aria-controls');
       self.$search.removeAttr('aria-activedescendant');
       self.$search.trigger('focus');
     });

     container.on('enable', function () {
       self.$search.prop('disabled', false);

       self._transferTabIndex();
     });

     container.on('disable', function () {
       self.$search.prop('disabled', true);
     });

     container.on('focus', function (evt) {
       self.$search.trigger('focus');
     });

     container.on('results:focus', function (params) {
       if (params.data._resultId) {
         self.$search.attr('aria-activedescendant', params.data._resultId);
       } else {
         self.$search.removeAttr('aria-activedescendant');
       }
     });

     this.$selection.on('focusin', '.select2-search--inline', function (evt) {
       self.trigger('focus', evt);
     });

     this.$selection.on('focusout', '.select2-search--inline', function (evt) {
       self._handleBlur(evt);
     });

     this.$selection.on('keydown', '.select2-search--inline', function (evt) {
       evt.stopPropagation();

       self.trigger('keypress', evt);

       self._keyUpPrevented = evt.isDefaultPrevented();

       var key = evt.which;

       if (key === KEYS.BACKSPACE && self.$search.val() === '') {
         var $previousChoice = self.$selection
           .find('.select2-selection__choice').last();

         if ($previousChoice.length > 0) {
           var item = Utils.GetData($previousChoice[0], 'data');

           self.searchRemoveChoice(item);

           evt.preventDefault();
         }
       }
     });

     this.$selection.on('click', '.select2-search--inline', function (evt) {
       if (self.$search.val()) {
         evt.stopPropagation();
       }
     });

     // Try to detect the IE version should the `documentMode` property that
     // is stored on the document. This is only implemented in IE and is
     // slightly cleaner than doing a user agent check.
     // This property is not available in Edge, but Edge also doesn't have
     // this bug.
     var msie = document.documentMode;
     var disableInputEvents = msie && msie <= 11;

     // Workaround for browsers which do not support the `input` event
     // This will prevent double-triggering of events for browsers which support
     // both the `keyup` and `input` events.
     this.$selection.on(
       'input.searchcheck',
       '.select2-search--inline',
       function (evt) {
         // IE will trigger the `input` event when a placeholder is used on a
         // search box. To get around this issue, we are forced to ignore all
         // `input` events in IE and keep using `keyup`.
         if (disableInputEvents) {
           self.$selection.off('input.search input.searchcheck');
           return;
         }

         // Unbind the duplicated `keyup` event
         self.$selection.off('keyup.search');
       }
     );

     this.$selection.on(
       'keyup.search input.search',
       '.select2-search--inline',
       function (evt) {
         // IE will trigger the `input` event when a placeholder is used on a
         // search box. To get around this issue, we are forced to ignore all
         // `input` events in IE and keep using `keyup`.
         if (disableInputEvents && evt.type === 'input') {
           self.$selection.off('input.search input.searchcheck');
           return;
         }

         var key = evt.which;

         // We can freely ignore events from modifier keys
         if (key == KEYS.SHIFT || key == KEYS.CTRL || key == KEYS.ALT) {
           return;
         }

         // Tabbing will be handled during the `keydown` phase
         if (key == KEYS.TAB) {
           return;
         }

         self.handleSearch(evt);
       }
     );
   };

   /**
    * This method will transfer the tabindex attribute from the rendered
    * selection to the search box. This allows for the search box to be used as
    * the primary focus instead of the selection container.
    *
    * @private
    */
   Search.prototype._transferTabIndex = function (decorated) {
     this.$search.attr('tabindex', this.$selection.attr('tabindex'));
     this.$selection.attr('tabindex', '-1');
   };

   Search.prototype.createPlaceholder = function (decorated, placeholder) {
     this.$search.attr('placeholder', placeholder.text);
   };

   Search.prototype.update = function (decorated, data) {
     var searchHadFocus = this.$search[0] == document.activeElement;

     this.$search.attr('placeholder', '');

     decorated.call(this, data);

     this.resizeSearch();
     if (searchHadFocus) {
       this.$search.trigger('focus');
     }
   };

   Search.prototype.handleSearch = function () {
     this.resizeSearch();

     if (!this._keyUpPrevented) {
       var input = this.$search.val();

       this.trigger('query', {
         term: input
       });
     }

     this._keyUpPrevented = false;
   };

   Search.prototype.searchRemoveChoice = function (decorated, item) {
     this.trigger('unselect', {
       data: item
     });

     this.$search.val(item.text);
     this.handleSearch();
   };

   Search.prototype.resizeSearch = function () {
     this.$search.css('width', '25px');

     var width = '100%';

     if (this.$search.attr('placeholder') === '') {
       var minimumWidth = this.$search.val().length + 1;

       width = (minimumWidth * 0.75) + 'em';
     }

     this.$search.css('width', width);
   };

   return Search;
 });

 S2.define('select2/selection/selectionCss',[
   '../utils'
 ], function (Utils) {
   function SelectionCSS () { }

   SelectionCSS.prototype.render = function (decorated) {
     var $selection = decorated.call(this);

     var selectionCssClass = this.options.get('selectionCssClass') || '';

     if (selectionCssClass.indexOf(':all:') !== -1) {
       selectionCssClass = selectionCssClass.replace(':all:', '');

       Utils.copyNonInternalCssClasses($selection[0], this.$element[0]);
     }

     $selection.addClass(selectionCssClass);

     return $selection;
   };

   return SelectionCSS;
 });

 S2.define('select2/selection/eventRelay',[
   'jquery'
 ], function ($) {
   function EventRelay () { }

   EventRelay.prototype.bind = function (decorated, container, $container) {
     var self = this;
     var relayEvents = [
       'open', 'opening',
       'close', 'closing',
       'select', 'selecting',
       'unselect', 'unselecting',
       'clear', 'clearing'
     ];

     var preventableEvents = [
       'opening', 'closing', 'selecting', 'unselecting', 'clearing'
     ];

     decorated.call(this, container, $container);

     container.on('*', function (name, params) {
       // Ignore events that should not be relayed
       if (relayEvents.indexOf(name) === -1) {
         return;
       }

       // The parameters should always be an object
       params = params || {};

       // Generate the jQuery event for the Select2 event
       var evt = $.Event('select2:' + name, {
         params: params
       });

       self.$element.trigger(evt);

       // Only handle preventable events if it was one
       if (preventableEvents.indexOf(name) === -1) {
         return;
       }

       params.prevented = evt.isDefaultPrevented();
     });
   };

   return EventRelay;
 });

 S2.define('select2/translation',[
   'jquery',
   'require'
 ], function ($, require) {
   function Translation (dict) {
     this.dict = dict || {};
   }

   Translation.prototype.all = function () {
     return this.dict;
   };

   Translation.prototype.get = function (key) {
     return this.dict[key];
   };

   Translation.prototype.extend = function (translation) {
     this.dict = $.extend({}, translation.all(), this.dict);
   };

   // Static functions

   Translation._cache = {};

   Translation.loadPath = function (path) {
     if (!(path in Translation._cache)) {
       var translations = require(path);

       Translation._cache[path] = translations;
     }

     return new Translation(Translation._cache[path]);
   };

   return Translation;
 });

 S2.define('select2/diacritics',[

 ], function () {
   var diacritics = {
     '\u24B6': 'A',
     '\uFF21': 'A',
     '\u00C0': 'A',
     '\u00C1': 'A',
     '\u00C2': 'A',
     '\u1EA6': 'A',
     '\u1EA4': 'A',
     '\u1EAA': 'A',
     '\u1EA8': 'A',
     '\u00C3': 'A',
     '\u0100': 'A',
     '\u0102': 'A',
     '\u1EB0': 'A',
     '\u1EAE': 'A',
     '\u1EB4': 'A',
     '\u1EB2': 'A',
     '\u0226': 'A',
     '\u01E0': 'A',
     '\u00C4': 'A',
     '\u01DE': 'A',
     '\u1EA2': 'A',
     '\u00C5': 'A',
     '\u01FA': 'A',
     '\u01CD': 'A',
     '\u0200': 'A',
     '\u0202': 'A',
     '\u1EA0': 'A',
     '\u1EAC': 'A',
     '\u1EB6': 'A',
     '\u1E00': 'A',
     '\u0104': 'A',
     '\u023A': 'A',
     '\u2C6F': 'A',
     '\uA732': 'AA',
     '\u00C6': 'AE',
     '\u01FC': 'AE',
     '\u01E2': 'AE',
     '\uA734': 'AO',
     '\uA736': 'AU',
     '\uA738': 'AV',
     '\uA73A': 'AV',
     '\uA73C': 'AY',
     '\u24B7': 'B',
     '\uFF22': 'B',
     '\u1E02': 'B',
     '\u1E04': 'B',
     '\u1E06': 'B',
     '\u0243': 'B',
     '\u0182': 'B',
     '\u0181': 'B',
     '\u24B8': 'C',
     '\uFF23': 'C',
     '\u0106': 'C',
     '\u0108': 'C',
     '\u010A': 'C',
     '\u010C': 'C',
     '\u00C7': 'C',
     '\u1E08': 'C',
     '\u0187': 'C',
     '\u023B': 'C',
     '\uA73E': 'C',
     '\u24B9': 'D',
     '\uFF24': 'D',
     '\u1E0A': 'D',
     '\u010E': 'D',
     '\u1E0C': 'D',
     '\u1E10': 'D',
     '\u1E12': 'D',
     '\u1E0E': 'D',
     '\u0110': 'D',
     '\u018B': 'D',
     '\u018A': 'D',
     '\u0189': 'D',
     '\uA779': 'D',
     '\u01F1': 'DZ',
     '\u01C4': 'DZ',
     '\u01F2': 'Dz',
     '\u01C5': 'Dz',
     '\u24BA': 'E',
     '\uFF25': 'E',
     '\u00C8': 'E',
     '\u00C9': 'E',
     '\u00CA': 'E',
     '\u1EC0': 'E',
     '\u1EBE': 'E',
     '\u1EC4': 'E',
     '\u1EC2': 'E',
     '\u1EBC': 'E',
     '\u0112': 'E',
     '\u1E14': 'E',
     '\u1E16': 'E',
     '\u0114': 'E',
     '\u0116': 'E',
     '\u00CB': 'E',
     '\u1EBA': 'E',
     '\u011A': 'E',
     '\u0204': 'E',
     '\u0206': 'E',
     '\u1EB8': 'E',
     '\u1EC6': 'E',
     '\u0228': 'E',
     '\u1E1C': 'E',
     '\u0118': 'E',
     '\u1E18': 'E',
     '\u1E1A': 'E',
     '\u0190': 'E',
     '\u018E': 'E',
     '\u24BB': 'F',
     '\uFF26': 'F',
     '\u1E1E': 'F',
     '\u0191': 'F',
     '\uA77B': 'F',
     '\u24BC': 'G',
     '\uFF27': 'G',
     '\u01F4': 'G',
     '\u011C': 'G',
     '\u1E20': 'G',
     '\u011E': 'G',
     '\u0120': 'G',
     '\u01E6': 'G',
     '\u0122': 'G',
     '\u01E4': 'G',
     '\u0193': 'G',
     '\uA7A0': 'G',
     '\uA77D': 'G',
     '\uA77E': 'G',
     '\u24BD': 'H',
     '\uFF28': 'H',
     '\u0124': 'H',
     '\u1E22': 'H',
     '\u1E26': 'H',
     '\u021E': 'H',
     '\u1E24': 'H',
     '\u1E28': 'H',
     '\u1E2A': 'H',
     '\u0126': 'H',
     '\u2C67': 'H',
     '\u2C75': 'H',
     '\uA78D': 'H',
     '\u24BE': 'I',
     '\uFF29': 'I',
     '\u00CC': 'I',
     '\u00CD': 'I',
     '\u00CE': 'I',
     '\u0128': 'I',
     '\u012A': 'I',
     '\u012C': 'I',
     '\u0130': 'I',
     '\u00CF': 'I',
     '\u1E2E': 'I',
     '\u1EC8': 'I',
     '\u01CF': 'I',
     '\u0208': 'I',
     '\u020A': 'I',
     '\u1ECA': 'I',
     '\u012E': 'I',
     '\u1E2C': 'I',
     '\u0197': 'I',
     '\u24BF': 'J',
     '\uFF2A': 'J',
     '\u0134': 'J',
     '\u0248': 'J',
     '\u24C0': 'K',
     '\uFF2B': 'K',
     '\u1E30': 'K',
     '\u01E8': 'K',
     '\u1E32': 'K',
     '\u0136': 'K',
     '\u1E34': 'K',
     '\u0198': 'K',
     '\u2C69': 'K',
     '\uA740': 'K',
     '\uA742': 'K',
     '\uA744': 'K',
     '\uA7A2': 'K',
     '\u24C1': 'L',
     '\uFF2C': 'L',
     '\u013F': 'L',
     '\u0139': 'L',
     '\u013D': 'L',
     '\u1E36': 'L',
     '\u1E38': 'L',
     '\u013B': 'L',
     '\u1E3C': 'L',
     '\u1E3A': 'L',
     '\u0141': 'L',
     '\u023D': 'L',
     '\u2C62': 'L',
     '\u2C60': 'L',
     '\uA748': 'L',
     '\uA746': 'L',
     '\uA780': 'L',
     '\u01C7': 'LJ',
     '\u01C8': 'Lj',
     '\u24C2': 'M',
     '\uFF2D': 'M',
     '\u1E3E': 'M',
     '\u1E40': 'M',
     '\u1E42': 'M',
     '\u2C6E': 'M',
     '\u019C': 'M',
     '\u24C3': 'N',
     '\uFF2E': 'N',
     '\u01F8': 'N',
     '\u0143': 'N',
     '\u00D1': 'N',
     '\u1E44': 'N',
     '\u0147': 'N',
     '\u1E46': 'N',
     '\u0145': 'N',
     '\u1E4A': 'N',
     '\u1E48': 'N',
     '\u0220': 'N',
     '\u019D': 'N',
     '\uA790': 'N',
     '\uA7A4': 'N',
     '\u01CA': 'NJ',
     '\u01CB': 'Nj',
     '\u24C4': 'O',
     '\uFF2F': 'O',
     '\u00D2': 'O',
     '\u00D3': 'O',
     '\u00D4': 'O',
     '\u1ED2': 'O',
     '\u1ED0': 'O',
     '\u1ED6': 'O',
     '\u1ED4': 'O',
     '\u00D5': 'O',
     '\u1E4C': 'O',
     '\u022C': 'O',
     '\u1E4E': 'O',
     '\u014C': 'O',
     '\u1E50': 'O',
     '\u1E52': 'O',
     '\u014E': 'O',
     '\u022E': 'O',
     '\u0230': 'O',
     '\u00D6': 'O',
     '\u022A': 'O',
     '\u1ECE': 'O',
     '\u0150': 'O',
     '\u01D1': 'O',
     '\u020C': 'O',
     '\u020E': 'O',
     '\u01A0': 'O',
     '\u1EDC': 'O',
     '\u1EDA': 'O',
     '\u1EE0': 'O',
     '\u1EDE': 'O',
     '\u1EE2': 'O',
     '\u1ECC': 'O',
     '\u1ED8': 'O',
     '\u01EA': 'O',
     '\u01EC': 'O',
     '\u00D8': 'O',
     '\u01FE': 'O',
     '\u0186': 'O',
     '\u019F': 'O',
     '\uA74A': 'O',
     '\uA74C': 'O',
     '\u0152': 'OE',
     '\u01A2': 'OI',
     '\uA74E': 'OO',
     '\u0222': 'OU',
     '\u24C5': 'P',
     '\uFF30': 'P',
     '\u1E54': 'P',
     '\u1E56': 'P',
     '\u01A4': 'P',
     '\u2C63': 'P',
     '\uA750': 'P',
     '\uA752': 'P',
     '\uA754': 'P',
     '\u24C6': 'Q',
     '\uFF31': 'Q',
     '\uA756': 'Q',
     '\uA758': 'Q',
     '\u024A': 'Q',
     '\u24C7': 'R',
     '\uFF32': 'R',
     '\u0154': 'R',
     '\u1E58': 'R',
     '\u0158': 'R',
     '\u0210': 'R',
     '\u0212': 'R',
     '\u1E5A': 'R',
     '\u1E5C': 'R',
     '\u0156': 'R',
     '\u1E5E': 'R',
     '\u024C': 'R',
     '\u2C64': 'R',
     '\uA75A': 'R',
     '\uA7A6': 'R',
     '\uA782': 'R',
     '\u24C8': 'S',
     '\uFF33': 'S',
     '\u1E9E': 'S',
     '\u015A': 'S',
     '\u1E64': 'S',
     '\u015C': 'S',
     '\u1E60': 'S',
     '\u0160': 'S',
     '\u1E66': 'S',
     '\u1E62': 'S',
     '\u1E68': 'S',
     '\u0218': 'S',
     '\u015E': 'S',
     '\u2C7E': 'S',
     '\uA7A8': 'S',
     '\uA784': 'S',
     '\u24C9': 'T',
     '\uFF34': 'T',
     '\u1E6A': 'T',
     '\u0164': 'T',
     '\u1E6C': 'T',
     '\u021A': 'T',
     '\u0162': 'T',
     '\u1E70': 'T',
     '\u1E6E': 'T',
     '\u0166': 'T',
     '\u01AC': 'T',
     '\u01AE': 'T',
     '\u023E': 'T',
     '\uA786': 'T',
     '\uA728': 'TZ',
     '\u24CA': 'U',
     '\uFF35': 'U',
     '\u00D9': 'U',
     '\u00DA': 'U',
     '\u00DB': 'U',
     '\u0168': 'U',
     '\u1E78': 'U',
     '\u016A': 'U',
     '\u1E7A': 'U',
     '\u016C': 'U',
     '\u00DC': 'U',
     '\u01DB': 'U',
     '\u01D7': 'U',
     '\u01D5': 'U',
     '\u01D9': 'U',
     '\u1EE6': 'U',
     '\u016E': 'U',
     '\u0170': 'U',
     '\u01D3': 'U',
     '\u0214': 'U',
     '\u0216': 'U',
     '\u01AF': 'U',
     '\u1EEA': 'U',
     '\u1EE8': 'U',
     '\u1EEE': 'U',
     '\u1EEC': 'U',
     '\u1EF0': 'U',
     '\u1EE4': 'U',
     '\u1E72': 'U',
     '\u0172': 'U',
     '\u1E76': 'U',
     '\u1E74': 'U',
     '\u0244': 'U',
     '\u24CB': 'V',
     '\uFF36': 'V',
     '\u1E7C': 'V',
     '\u1E7E': 'V',
     '\u01B2': 'V',
     '\uA75E': 'V',
     '\u0245': 'V',
     '\uA760': 'VY',
     '\u24CC': 'W',
     '\uFF37': 'W',
     '\u1E80': 'W',
     '\u1E82': 'W',
     '\u0174': 'W',
     '\u1E86': 'W',
     '\u1E84': 'W',
     '\u1E88': 'W',
     '\u2C72': 'W',
     '\u24CD': 'X',
     '\uFF38': 'X',
     '\u1E8A': 'X',
     '\u1E8C': 'X',
     '\u24CE': 'Y',
     '\uFF39': 'Y',
     '\u1EF2': 'Y',
     '\u00DD': 'Y',
     '\u0176': 'Y',
     '\u1EF8': 'Y',
     '\u0232': 'Y',
     '\u1E8E': 'Y',
     '\u0178': 'Y',
     '\u1EF6': 'Y',
     '\u1EF4': 'Y',
     '\u01B3': 'Y',
     '\u024E': 'Y',
     '\u1EFE': 'Y',
     '\u24CF': 'Z',
     '\uFF3A': 'Z',
     '\u0179': 'Z',
     '\u1E90': 'Z',
     '\u017B': 'Z',
     '\u017D': 'Z',
     '\u1E92': 'Z',
     '\u1E94': 'Z',
     '\u01B5': 'Z',
     '\u0224': 'Z',
     '\u2C7F': 'Z',
     '\u2C6B': 'Z',
     '\uA762': 'Z',
     '\u24D0': 'a',
     '\uFF41': 'a',
     '\u1E9A': 'a',
     '\u00E0': 'a',
     '\u00E1': 'a',
     '\u00E2': 'a',
     '\u1EA7': 'a',
     '\u1EA5': 'a',
     '\u1EAB': 'a',
     '\u1EA9': 'a',
     '\u00E3': 'a',
     '\u0101': 'a',
     '\u0103': 'a',
     '\u1EB1': 'a',
     '\u1EAF': 'a',
     '\u1EB5': 'a',
     '\u1EB3': 'a',
     '\u0227': 'a',
     '\u01E1': 'a',
     '\u00E4': 'a',
     '\u01DF': 'a',
     '\u1EA3': 'a',
     '\u00E5': 'a',
     '\u01FB': 'a',
     '\u01CE': 'a',
     '\u0201': 'a',
     '\u0203': 'a',
     '\u1EA1': 'a',
     '\u1EAD': 'a',
     '\u1EB7': 'a',
     '\u1E01': 'a',
     '\u0105': 'a',
     '\u2C65': 'a',
     '\u0250': 'a',
     '\uA733': 'aa',
     '\u00E6': 'ae',
     '\u01FD': 'ae',
     '\u01E3': 'ae',
     '\uA735': 'ao',
     '\uA737': 'au',
     '\uA739': 'av',
     '\uA73B': 'av',
     '\uA73D': 'ay',
     '\u24D1': 'b',
     '\uFF42': 'b',
     '\u1E03': 'b',
     '\u1E05': 'b',
     '\u1E07': 'b',
     '\u0180': 'b',
     '\u0183': 'b',
     '\u0253': 'b',
     '\u24D2': 'c',
     '\uFF43': 'c',
     '\u0107': 'c',
     '\u0109': 'c',
     '\u010B': 'c',
     '\u010D': 'c',
     '\u00E7': 'c',
     '\u1E09': 'c',
     '\u0188': 'c',
     '\u023C': 'c',
     '\uA73F': 'c',
     '\u2184': 'c',
     '\u24D3': 'd',
     '\uFF44': 'd',
     '\u1E0B': 'd',
     '\u010F': 'd',
     '\u1E0D': 'd',
     '\u1E11': 'd',
     '\u1E13': 'd',
     '\u1E0F': 'd',
     '\u0111': 'd',
     '\u018C': 'd',
     '\u0256': 'd',
     '\u0257': 'd',
     '\uA77A': 'd',
     '\u01F3': 'dz',
     '\u01C6': 'dz',
     '\u24D4': 'e',
     '\uFF45': 'e',
     '\u00E8': 'e',
     '\u00E9': 'e',
     '\u00EA': 'e',
     '\u1EC1': 'e',
     '\u1EBF': 'e',
     '\u1EC5': 'e',
     '\u1EC3': 'e',
     '\u1EBD': 'e',
     '\u0113': 'e',
     '\u1E15': 'e',
     '\u1E17': 'e',
     '\u0115': 'e',
     '\u0117': 'e',
     '\u00EB': 'e',
     '\u1EBB': 'e',
     '\u011B': 'e',
     '\u0205': 'e',
     '\u0207': 'e',
     '\u1EB9': 'e',
     '\u1EC7': 'e',
     '\u0229': 'e',
     '\u1E1D': 'e',
     '\u0119': 'e',
     '\u1E19': 'e',
     '\u1E1B': 'e',
     '\u0247': 'e',
     '\u025B': 'e',
     '\u01DD': 'e',
     '\u24D5': 'f',
     '\uFF46': 'f',
     '\u1E1F': 'f',
     '\u0192': 'f',
     '\uA77C': 'f',
     '\u24D6': 'g',
     '\uFF47': 'g',
     '\u01F5': 'g',
     '\u011D': 'g',
     '\u1E21': 'g',
     '\u011F': 'g',
     '\u0121': 'g',
     '\u01E7': 'g',
     '\u0123': 'g',
     '\u01E5': 'g',
     '\u0260': 'g',
     '\uA7A1': 'g',
     '\u1D79': 'g',
     '\uA77F': 'g',
     '\u24D7': 'h',
     '\uFF48': 'h',
     '\u0125': 'h',
     '\u1E23': 'h',
     '\u1E27': 'h',
     '\u021F': 'h',
     '\u1E25': 'h',
     '\u1E29': 'h',
     '\u1E2B': 'h',
     '\u1E96': 'h',
     '\u0127': 'h',
     '\u2C68': 'h',
     '\u2C76': 'h',
     '\u0265': 'h',
     '\u0195': 'hv',
     '\u24D8': 'i',
     '\uFF49': 'i',
     '\u00EC': 'i',
     '\u00ED': 'i',
     '\u00EE': 'i',
     '\u0129': 'i',
     '\u012B': 'i',
     '\u012D': 'i',
     '\u00EF': 'i',
     '\u1E2F': 'i',
     '\u1EC9': 'i',
     '\u01D0': 'i',
     '\u0209': 'i',
     '\u020B': 'i',
     '\u1ECB': 'i',
     '\u012F': 'i',
     '\u1E2D': 'i',
     '\u0268': 'i',
     '\u0131': 'i',
     '\u24D9': 'j',
     '\uFF4A': 'j',
     '\u0135': 'j',
     '\u01F0': 'j',
     '\u0249': 'j',
     '\u24DA': 'k',
     '\uFF4B': 'k',
     '\u1E31': 'k',
     '\u01E9': 'k',
     '\u1E33': 'k',
     '\u0137': 'k',
     '\u1E35': 'k',
     '\u0199': 'k',
     '\u2C6A': 'k',
     '\uA741': 'k',
     '\uA743': 'k',
     '\uA745': 'k',
     '\uA7A3': 'k',
     '\u24DB': 'l',
     '\uFF4C': 'l',
     '\u0140': 'l',
     '\u013A': 'l',
     '\u013E': 'l',
     '\u1E37': 'l',
     '\u1E39': 'l',
     '\u013C': 'l',
     '\u1E3D': 'l',
     '\u1E3B': 'l',
     '\u017F': 'l',
     '\u0142': 'l',
     '\u019A': 'l',
     '\u026B': 'l',
     '\u2C61': 'l',
     '\uA749': 'l',
     '\uA781': 'l',
     '\uA747': 'l',
     '\u01C9': 'lj',
     '\u24DC': 'm',
     '\uFF4D': 'm',
     '\u1E3F': 'm',
     '\u1E41': 'm',
     '\u1E43': 'm',
     '\u0271': 'm',
     '\u026F': 'm',
     '\u24DD': 'n',
     '\uFF4E': 'n',
     '\u01F9': 'n',
     '\u0144': 'n',
     '\u00F1': 'n',
     '\u1E45': 'n',
     '\u0148': 'n',
     '\u1E47': 'n',
     '\u0146': 'n',
     '\u1E4B': 'n',
     '\u1E49': 'n',
     '\u019E': 'n',
     '\u0272': 'n',
     '\u0149': 'n',
     '\uA791': 'n',
     '\uA7A5': 'n',
     '\u01CC': 'nj',
     '\u24DE': 'o',
     '\uFF4F': 'o',
     '\u00F2': 'o',
     '\u00F3': 'o',
     '\u00F4': 'o',
     '\u1ED3': 'o',
     '\u1ED1': 'o',
     '\u1ED7': 'o',
     '\u1ED5': 'o',
     '\u00F5': 'o',
     '\u1E4D': 'o',
     '\u022D': 'o',
     '\u1E4F': 'o',
     '\u014D': 'o',
     '\u1E51': 'o',
     '\u1E53': 'o',
     '\u014F': 'o',
     '\u022F': 'o',
     '\u0231': 'o',
     '\u00F6': 'o',
     '\u022B': 'o',
     '\u1ECF': 'o',
     '\u0151': 'o',
     '\u01D2': 'o',
     '\u020D': 'o',
     '\u020F': 'o',
     '\u01A1': 'o',
     '\u1EDD': 'o',
     '\u1EDB': 'o',
     '\u1EE1': 'o',
     '\u1EDF': 'o',
     '\u1EE3': 'o',
     '\u1ECD': 'o',
     '\u1ED9': 'o',
     '\u01EB': 'o',
     '\u01ED': 'o',
     '\u00F8': 'o',
     '\u01FF': 'o',
     '\u0254': 'o',
     '\uA74B': 'o',
     '\uA74D': 'o',
     '\u0275': 'o',
     '\u0153': 'oe',
     '\u01A3': 'oi',
     '\u0223': 'ou',
     '\uA74F': 'oo',
     '\u24DF': 'p',
     '\uFF50': 'p',
     '\u1E55': 'p',
     '\u1E57': 'p',
     '\u01A5': 'p',
     '\u1D7D': 'p',
     '\uA751': 'p',
     '\uA753': 'p',
     '\uA755': 'p',
     '\u24E0': 'q',
     '\uFF51': 'q',
     '\u024B': 'q',
     '\uA757': 'q',
     '\uA759': 'q',
     '\u24E1': 'r',
     '\uFF52': 'r',
     '\u0155': 'r',
     '\u1E59': 'r',
     '\u0159': 'r',
     '\u0211': 'r',
     '\u0213': 'r',
     '\u1E5B': 'r',
     '\u1E5D': 'r',
     '\u0157': 'r',
     '\u1E5F': 'r',
     '\u024D': 'r',
     '\u027D': 'r',
     '\uA75B': 'r',
     '\uA7A7': 'r',
     '\uA783': 'r',
     '\u24E2': 's',
     '\uFF53': 's',
     '\u00DF': 's',
     '\u015B': 's',
     '\u1E65': 's',
     '\u015D': 's',
     '\u1E61': 's',
     '\u0161': 's',
     '\u1E67': 's',
     '\u1E63': 's',
     '\u1E69': 's',
     '\u0219': 's',
     '\u015F': 's',
     '\u023F': 's',
     '\uA7A9': 's',
     '\uA785': 's',
     '\u1E9B': 's',
     '\u24E3': 't',
     '\uFF54': 't',
     '\u1E6B': 't',
     '\u1E97': 't',
     '\u0165': 't',
     '\u1E6D': 't',
     '\u021B': 't',
     '\u0163': 't',
     '\u1E71': 't',
     '\u1E6F': 't',
     '\u0167': 't',
     '\u01AD': 't',
     '\u0288': 't',
     '\u2C66': 't',
     '\uA787': 't',
     '\uA729': 'tz',
     '\u24E4': 'u',
     '\uFF55': 'u',
     '\u00F9': 'u',
     '\u00FA': 'u',
     '\u00FB': 'u',
     '\u0169': 'u',
     '\u1E79': 'u',
     '\u016B': 'u',
     '\u1E7B': 'u',
     '\u016D': 'u',
     '\u00FC': 'u',
     '\u01DC': 'u',
     '\u01D8': 'u',
     '\u01D6': 'u',
     '\u01DA': 'u',
     '\u1EE7': 'u',
     '\u016F': 'u',
     '\u0171': 'u',
     '\u01D4': 'u',
     '\u0215': 'u',
     '\u0217': 'u',
     '\u01B0': 'u',
     '\u1EEB': 'u',
     '\u1EE9': 'u',
     '\u1EEF': 'u',
     '\u1EED': 'u',
     '\u1EF1': 'u',
     '\u1EE5': 'u',
     '\u1E73': 'u',
     '\u0173': 'u',
     '\u1E77': 'u',
     '\u1E75': 'u',
     '\u0289': 'u',
     '\u24E5': 'v',
     '\uFF56': 'v',
     '\u1E7D': 'v',
     '\u1E7F': 'v',
     '\u028B': 'v',
     '\uA75F': 'v',
     '\u028C': 'v',
     '\uA761': 'vy',
     '\u24E6': 'w',
     '\uFF57': 'w',
     '\u1E81': 'w',
     '\u1E83': 'w',
     '\u0175': 'w',
     '\u1E87': 'w',
     '\u1E85': 'w',
     '\u1E98': 'w',
     '\u1E89': 'w',
     '\u2C73': 'w',
     '\u24E7': 'x',
     '\uFF58': 'x',
     '\u1E8B': 'x',
     '\u1E8D': 'x',
     '\u24E8': 'y',
     '\uFF59': 'y',
     '\u1EF3': 'y',
     '\u00FD': 'y',
     '\u0177': 'y',
     '\u1EF9': 'y',
     '\u0233': 'y',
     '\u1E8F': 'y',
     '\u00FF': 'y',
     '\u1EF7': 'y',
     '\u1E99': 'y',
     '\u1EF5': 'y',
     '\u01B4': 'y',
     '\u024F': 'y',
     '\u1EFF': 'y',
     '\u24E9': 'z',
     '\uFF5A': 'z',
     '\u017A': 'z',
     '\u1E91': 'z',
     '\u017C': 'z',
     '\u017E': 'z',
     '\u1E93': 'z',
     '\u1E95': 'z',
     '\u01B6': 'z',
     '\u0225': 'z',
     '\u0240': 'z',
     '\u2C6C': 'z',
     '\uA763': 'z',
     '\u0386': '\u0391',
     '\u0388': '\u0395',
     '\u0389': '\u0397',
     '\u038A': '\u0399',
     '\u03AA': '\u0399',
     '\u038C': '\u039F',
     '\u038E': '\u03A5',
     '\u03AB': '\u03A5',
     '\u038F': '\u03A9',
     '\u03AC': '\u03B1',
     '\u03AD': '\u03B5',
     '\u03AE': '\u03B7',
     '\u03AF': '\u03B9',
     '\u03CA': '\u03B9',
     '\u0390': '\u03B9',
     '\u03CC': '\u03BF',
     '\u03CD': '\u03C5',
     '\u03CB': '\u03C5',
     '\u03B0': '\u03C5',
     '\u03CE': '\u03C9',
     '\u03C2': '\u03C3',
     '\u2019': '\''
   };

   return diacritics;
 });

 S2.define('select2/data/base',[
   '../utils'
 ], function (Utils) {
   function BaseAdapter ($element, options) {
     BaseAdapter.__super__.constructor.call(this);
   }

   Utils.Extend(BaseAdapter, Utils.Observable);

   BaseAdapter.prototype.current = function (callback) {
     throw new Error('The `current` method must be defined in child classes.');
   };

   BaseAdapter.prototype.query = function (params, callback) {
     throw new Error('The `query` method must be defined in child classes.');
   };

   BaseAdapter.prototype.bind = function (container, $container) {
     // Can be implemented in subclasses
   };

   BaseAdapter.prototype.destroy = function () {
     // Can be implemented in subclasses
   };

   BaseAdapter.prototype.generateResultId = function (container, data) {
     var id = container.id + '-result-';

     id += Utils.generateChars(4);

     if (data.id != null) {
       id += '-' + data.id.toString();
     } else {
       id += '-' + Utils.generateChars(4);
     }
     return id;
   };

   return BaseAdapter;
 });

 S2.define('select2/data/select',[
   './base',
   '../utils',
   'jquery'
 ], function (BaseAdapter, Utils, $) {
   function SelectAdapter ($element, options) {
     this.$element = $element;
     this.options = options;

     SelectAdapter.__super__.constructor.call(this);
   }

   Utils.Extend(SelectAdapter, BaseAdapter);

   SelectAdapter.prototype.current = function (callback) {
     var self = this;

     var data = Array.prototype.map.call(
       this.$element[0].querySelectorAll(':checked'),
       function (selectedElement) {
         return self.item($(selectedElement));
       }
     );

     callback(data);
   };

   SelectAdapter.prototype.select = function (data) {
     var self = this;

     data.selected = true;

     // If data.element is a DOM node, use it instead
     if (
       data.element != null && data.element.tagName.toLowerCase() === 'option'
     ) {
       data.element.selected = true;

       this.$element.trigger('input').trigger('change');

       return;
     }

     if (this.$element.prop('multiple')) {
       this.current(function (currentData) {
         var val = [];

         data = [data];
         data.push.apply(data, currentData);

         for (var d = 0; d < data.length; d++) {
           var id = data[d].id;

           if (val.indexOf(id) === -1) {
             val.push(id);
           }
         }

         self.$element.val(val);
         self.$element.trigger('input').trigger('change');
       });
     } else {
       var val = data.id;

       this.$element.val(val);
       this.$element.trigger('input').trigger('change');
     }
   };

   SelectAdapter.prototype.unselect = function (data) {
     var self = this;

     if (!this.$element.prop('multiple')) {
       return;
     }

     data.selected = false;

     if (
       data.element != null &&
       data.element.tagName.toLowerCase() === 'option'
     ) {
       data.element.selected = false;

       this.$element.trigger('input').trigger('change');

       return;
     }

     this.current(function (currentData) {
       var val = [];

       for (var d = 0; d < currentData.length; d++) {
         var id = currentData[d].id;

         if (id !== data.id && val.indexOf(id) === -1) {
           val.push(id);
         }
       }

       self.$element.val(val);

       self.$element.trigger('input').trigger('change');
     });
   };

   SelectAdapter.prototype.bind = function (container, $container) {
     var self = this;

     this.container = container;

     container.on('select', function (params) {
       self.select(params.data);
     });

     container.on('unselect', function (params) {
       self.unselect(params.data);
     });
   };

   SelectAdapter.prototype.destroy = function () {
     // Remove anything added to child elements
     this.$element.find('*').each(function () {
       // Remove any custom data set by Select2
       Utils.RemoveData(this);
     });
   };

   SelectAdapter.prototype.query = function (params, callback) {
     var data = [];
     var self = this;

     var $options = this.$element.children();

     $options.each(function () {
       if (
         this.tagName.toLowerCase() !== 'option' &&
         this.tagName.toLowerCase() !== 'optgroup'
       ) {
         return;
       }

       var $option = $(this);

       var option = self.item($option);

       var matches = self.matches(params, option);

       if (matches !== null) {
         data.push(matches);
       }
     });

     callback({
       results: data
     });
   };

   SelectAdapter.prototype.addOptions = function ($options) {
     this.$element.append($options);
   };

   SelectAdapter.prototype.option = function (data) {
     var option;

     if (data.children) {
       option = document.createElement('optgroup');
       option.label = data.text;
     } else {
       option = document.createElement('option');

       if (option.textContent !== undefined) {
         option.textContent = data.text;
       } else {
         option.innerText = data.text;
       }
     }

     if (data.id !== undefined) {
       option.value = data.id;
     }

     if (data.disabled) {
       option.disabled = true;
     }

     if (data.selected) {
       option.selected = true;
     }

     if (data.title) {
       option.title = data.title;
     }

     var normalizedData = this._normalizeItem(data);
     normalizedData.element = option;

     // Override the option's data with the combined data
     Utils.StoreData(option, 'data', normalizedData);

     return $(option);
   };

   SelectAdapter.prototype.item = function ($option) {
     var data = {};

     data = Utils.GetData($option[0], 'data');

     if (data != null) {
       return data;
     }

     var option = $option[0];

     if (option.tagName.toLowerCase() === 'option') {
       data = {
         id: $option.val(),
         text: $option.text(),
         disabled: $option.prop('disabled'),
         selected: $option.prop('selected'),
         title: $option.prop('title')
       };
     } else if (option.tagName.toLowerCase() === 'optgroup') {
       data = {
         text: $option.prop('label'),
         children: [],
         title: $option.prop('title')
       };

       var $children = $option.children('option');
       var children = [];

       for (var c = 0; c < $children.length; c++) {
         var $child = $($children[c]);

         var child = this.item($child);

         children.push(child);
       }

       data.children = children;
     }

     data = this._normalizeItem(data);
     data.element = $option[0];

     Utils.StoreData($option[0], 'data', data);

     return data;
   };

   SelectAdapter.prototype._normalizeItem = function (item) {
     if (item !== Object(item)) {
       item = {
         id: item,
         text: item
       };
     }

     item = $.extend({}, {
       text: ''
     }, item);

     var defaults = {
       selected: false,
       disabled: false
     };

     if (item.id != null) {
       item.id = item.id.toString();
     }

     if (item.text != null) {
       item.text = item.text.toString();
     }

     if (item._resultId == null && item.id && this.container != null) {
       item._resultId = this.generateResultId(this.container, item);
     }

     return $.extend({}, defaults, item);
   };

   SelectAdapter.prototype.matches = function (params, data) {
     var matcher = this.options.get('matcher');

     return matcher(params, data);
   };

   return SelectAdapter;
 });

 S2.define('select2/data/array',[
   './select',
   '../utils',
   'jquery'
 ], function (SelectAdapter, Utils, $) {
   function ArrayAdapter ($element, options) {
     this._dataToConvert = options.get('data') || [];

     ArrayAdapter.__super__.constructor.call(this, $element, options);
   }

   Utils.Extend(ArrayAdapter, SelectAdapter);

   ArrayAdapter.prototype.bind = function (container, $container) {
     ArrayAdapter.__super__.bind.call(this, container, $container);

     this.addOptions(this.convertToOptions(this._dataToConvert));
   };

   ArrayAdapter.prototype.select = function (data) {
     var $option = this.$element.find('option').filter(function (i, elm) {
       return elm.value == data.id.toString();
     });

     if ($option.length === 0) {
       $option = this.option(data);

       this.addOptions($option);
     }

     ArrayAdapter.__super__.select.call(this, data);
   };

   ArrayAdapter.prototype.convertToOptions = function (data) {
     var self = this;

     var $existing = this.$element.find('option');
     var existingIds = $existing.map(function () {
       return self.item($(this)).id;
     }).get();

     var $options = [];

     // Filter out all items except for the one passed in the argument
     function onlyItem (item) {
       return function () {
         return $(this).val() == item.id;
       };
     }

     for (var d = 0; d < data.length; d++) {
       var item = this._normalizeItem(data[d]);

       // Skip items which were pre-loaded, only merge the data
       if (existingIds.indexOf(item.id) >= 0) {
         var $existingOption = $existing.filter(onlyItem(item));

         var existingData = this.item($existingOption);
         var newData = $.extend(true, {}, item, existingData);

         var $newOption = this.option(newData);

         $existingOption.replaceWith($newOption);

         continue;
       }

       var $option = this.option(item);

       if (item.children) {
         var $children = this.convertToOptions(item.children);

         $option.append($children);
       }

       $options.push($option);
     }

     return $options;
   };

   return ArrayAdapter;
 });

 S2.define('select2/data/ajax',[
   './array',
   '../utils',
   'jquery'
 ], function (ArrayAdapter, Utils, $) {
   function AjaxAdapter ($element, options) {
     this.ajaxOptions = this._applyDefaults(options.get('ajax'));

     if (this.ajaxOptions.processResults != null) {
       this.processResults = this.ajaxOptions.processResults;
     }

     AjaxAdapter.__super__.constructor.call(this, $element, options);
   }

   Utils.Extend(AjaxAdapter, ArrayAdapter);

   AjaxAdapter.prototype._applyDefaults = function (options) {
     var defaults = {
       data: function (params) {
         return $.extend({}, params, {
           q: params.term
         });
       },
       transport: function (params, success, failure) {
         var $request = $.ajax(params);

         $request.then(success);
         $request.fail(failure);

         return $request;
       }
     };

     return $.extend({}, defaults, options, true);
   };

   AjaxAdapter.prototype.processResults = function (results) {
     return results;
   };

   AjaxAdapter.prototype.query = function (params, callback) {
     var matches = [];
     var self = this;

     if (this._request != null) {
       // JSONP requests cannot always be aborted
       if (typeof this._request.abort === 'function') {
         this._request.abort();
       }

       this._request = null;
     }

     var options = $.extend({
       type: 'GET'
     }, this.ajaxOptions);

     if (typeof options.url === 'function') {
       options.url = options.url.call(this.$element, params);
     }

     if (typeof options.data === 'function') {
       options.data = options.data.call(this.$element, params);
     }

     function request () {
       var $request = options.transport(options, function (data) {
         var results = self.processResults(data, params);

         if (self.options.get('debug') && window.console && console.error) {
           // Check to make sure that the response included a `results` key.
           if (!results || !results.results || !Array.isArray(results.results)) {
             console.error(
               'Select2: The AJAX results did not return an array in the ' +
               '`results` key of the response.'
             );
           }
         }

         callback(results);
       }, function () {
         // Attempt to detect if a request was aborted
         // Only works if the transport exposes a status property
         if ('status' in $request &&
             ($request.status === 0 || $request.status === '0')) {
           return;
         }

         self.trigger('results:message', {
           message: 'errorLoading'
         });
       });

       self._request = $request;
     }

     if (this.ajaxOptions.delay && params.term != null) {
       if (this._queryTimeout) {
         window.clearTimeout(this._queryTimeout);
       }

       this._queryTimeout = window.setTimeout(request, this.ajaxOptions.delay);
     } else {
       request();
     }
   };

   return AjaxAdapter;
 });

 S2.define('select2/data/tags',[
   'jquery'
 ], function ($) {
   function Tags (decorated, $element, options) {
     var tags = options.get('tags');

     var createTag = options.get('createTag');

     if (createTag !== undefined) {
       this.createTag = createTag;
     }

     var insertTag = options.get('insertTag');

     if (insertTag !== undefined) {
         this.insertTag = insertTag;
     }

     decorated.call(this, $element, options);

     if (Array.isArray(tags)) {
       for (var t = 0; t < tags.length; t++) {
         var tag = tags[t];
         var item = this._normalizeItem(tag);

         var $option = this.option(item);

         this.$element.append($option);
       }
     }
   }

   Tags.prototype.query = function (decorated, params, callback) {
     var self = this;

     this._removeOldTags();

     if (params.term == null || params.page != null) {
       decorated.call(this, params, callback);
       return;
     }

     function wrapper (obj, child) {
       var data = obj.results;

       for (var i = 0; i < data.length; i++) {
         var option = data[i];

         var checkChildren = (
           option.children != null &&
           !wrapper({
             results: option.children
           }, true)
         );

         var optionText = (option.text || '').toUpperCase();
         var paramsTerm = (params.term || '').toUpperCase();

         var checkText = optionText === paramsTerm;

         if (checkText || checkChildren) {
           if (child) {
             return false;
           }

           obj.data = data;
           callback(obj);

           return;
         }
       }

       if (child) {
         return true;
       }

       var tag = self.createTag(params);

       if (tag != null) {
         var $option = self.option(tag);
         $option.attr('data-select2-tag', 'true');

         self.addOptions([$option]);

         self.insertTag(data, tag);
       }

       obj.results = data;

       callback(obj);
     }

     decorated.call(this, params, wrapper);
   };

   Tags.prototype.createTag = function (decorated, params) {
     if (params.term == null) {
       return null;
     }

     var term = params.term.trim();

     if (term === '') {
       return null;
     }

     return {
       id: term,
       text: term
     };
   };

   Tags.prototype.insertTag = function (_, data, tag) {
     data.unshift(tag);
   };

   Tags.prototype._removeOldTags = function (_) {
     var $options = this.$element.find('option[data-select2-tag]');

     $options.each(function () {
       if (this.selected) {
         return;
       }

       $(this).remove();
     });
   };

   return Tags;
 });

 S2.define('select2/data/tokenizer',[
   'jquery'
 ], function ($) {
   function Tokenizer (decorated, $element, options) {
     var tokenizer = options.get('tokenizer');

     if (tokenizer !== undefined) {
       this.tokenizer = tokenizer;
     }

     decorated.call(this, $element, options);
   }

   Tokenizer.prototype.bind = function (decorated, container, $container) {
     decorated.call(this, container, $container);

     this.$search =  container.dropdown.$search || container.selection.$search ||
       $container.find('.select2-search__field');
   };

   Tokenizer.prototype.query = function (decorated, params, callback) {
     var self = this;

     function createAndSelect (data) {
       // Normalize the data object so we can use it for checks
       var item = self._normalizeItem(data);

       // Check if the data object already exists as a tag
       // Select it if it doesn't
       var $existingOptions = self.$element.find('option').filter(function () {
         return $(this).val() === item.id;
       });

       // If an existing option wasn't found for it, create the option
       if (!$existingOptions.length) {
         var $option = self.option(item);
         $option.attr('data-select2-tag', true);

         self._removeOldTags();
         self.addOptions([$option]);
       }

       // Select the item, now that we know there is an option for it
       select(item);
     }

     function select (data) {
       self.trigger('select', {
         data: data
       });
     }

     params.term = params.term || '';

     var tokenData = this.tokenizer(params, this.options, createAndSelect);

     if (tokenData.term !== params.term) {
       // Replace the search term if we have the search box
       if (this.$search.length) {
         this.$search.val(tokenData.term);
         this.$search.trigger('focus');
       }

       params.term = tokenData.term;
     }

     decorated.call(this, params, callback);
   };

   Tokenizer.prototype.tokenizer = function (_, params, options, callback) {
     var separators = options.get('tokenSeparators') || [];
     var term = params.term;
     var i = 0;

     var createTag = this.createTag || function (params) {
       return {
         id: params.term,
         text: params.term
       };
     };

     while (i < term.length) {
       var termChar = term[i];

       if (separators.indexOf(termChar) === -1) {
         i++;

         continue;
       }

       var part = term.substr(0, i);
       var partParams = $.extend({}, params, {
         term: part
       });

       var data = createTag(partParams);

       if (data == null) {
         i++;
         continue;
       }

       callback(data);

       // Reset the term to not include the tokenized portion
       term = term.substr(i + 1) || '';
       i = 0;
     }

     return {
       term: term
     };
   };

   return Tokenizer;
 });

 S2.define('select2/data/minimumInputLength',[

 ], function () {
   function MinimumInputLength (decorated, $e, options) {
     this.minimumInputLength = options.get('minimumInputLength');

     decorated.call(this, $e, options);
   }

   MinimumInputLength.prototype.query = function (decorated, params, callback) {
     params.term = params.term || '';

     if (params.term.length < this.minimumInputLength) {
       this.trigger('results:message', {
         message: 'inputTooShort',
         args: {
           minimum: this.minimumInputLength,
           input: params.term,
           params: params
         }
       });

       return;
     }

     decorated.call(this, params, callback);
   };

   return MinimumInputLength;
 });

 S2.define('select2/data/maximumInputLength',[

 ], function () {
   function MaximumInputLength (decorated, $e, options) {
     this.maximumInputLength = options.get('maximumInputLength');

     decorated.call(this, $e, options);
   }

   MaximumInputLength.prototype.query = function (decorated, params, callback) {
     params.term = params.term || '';

     if (this.maximumInputLength > 0 &&
         params.term.length > this.maximumInputLength) {
       this.trigger('results:message', {
         message: 'inputTooLong',
         args: {
           maximum: this.maximumInputLength,
           input: params.term,
           params: params
         }
       });

       return;
     }

     decorated.call(this, params, callback);
   };

   return MaximumInputLength;
 });

 S2.define('select2/data/maximumSelectionLength',[

 ], function (){
   function MaximumSelectionLength (decorated, $e, options) {
     this.maximumSelectionLength = options.get('maximumSelectionLength');

     decorated.call(this, $e, options);
   }

   MaximumSelectionLength.prototype.bind =
     function (decorated, container, $container) {
       var self = this;

       decorated.call(this, container, $container);

       container.on('select', function () {
         self._checkIfMaximumSelected();
       });
   };

   MaximumSelectionLength.prototype.query =
     function (decorated, params, callback) {
       var self = this;

       this._checkIfMaximumSelected(function () {
         decorated.call(self, params, callback);
       });
   };

   MaximumSelectionLength.prototype._checkIfMaximumSelected =
     function (_, successCallback) {
       var self = this;

       this.current(function (currentData) {
         var count = currentData != null ? currentData.length : 0;
         if (self.maximumSelectionLength > 0 &&
           count >= self.maximumSelectionLength) {
           self.trigger('results:message', {
             message: 'maximumSelected',
             args: {
               maximum: self.maximumSelectionLength
             }
           });
           return;
         }

         if (successCallback) {
           successCallback();
         }
       });
   };

   return MaximumSelectionLength;
 });

 S2.define('select2/dropdown',[
   'jquery',
   './utils'
 ], function ($, Utils) {
   function Dropdown ($element, options) {
     this.$element = $element;
     this.options = options;

     Dropdown.__super__.constructor.call(this);
   }

   Utils.Extend(Dropdown, Utils.Observable);

   Dropdown.prototype.render = function () {
     var $dropdown = $(
       '<span class="select2-dropdown">' +
         '<span class="select2-results"></span>' +
       '</span>'
     );

     $dropdown.attr('dir', this.options.get('dir'));

     this.$dropdown = $dropdown;

     return $dropdown;
   };

   Dropdown.prototype.bind = function () {
     // Should be implemented in subclasses
   };

   Dropdown.prototype.position = function ($dropdown, $container) {
     // Should be implemented in subclasses
   };

   Dropdown.prototype.destroy = function () {
     // Remove the dropdown from the DOM
     this.$dropdown.remove();
   };

   return Dropdown;
 });

 S2.define('select2/dropdown/search',[
   'jquery'
 ], function ($) {
   function Search () { }

   Search.prototype.render = function (decorated) {
     var $rendered = decorated.call(this);
     var searchLabel = this.options.get('translations').get('search');

     var $search = $(
       '<span class="select2-search select2-search--dropdown">' +
         '<input class="select2-search__field" type="search" tabindex="-1"' +
         ' autocorrect="off" autocapitalize="none"' +
         ' spellcheck="false" role="searchbox" aria-autocomplete="list" />' +
       '</span>'
     );

     this.$searchContainer = $search;
     this.$search = $search.find('input');

     this.$search.prop('autocomplete', this.options.get('autocomplete'));
     this.$search.attr('aria-label', searchLabel());

     $rendered.prepend($search);

     return $rendered;
   };

   Search.prototype.bind = function (decorated, container, $container) {
     var self = this;

     var resultsId = container.id + '-results';

     decorated.call(this, container, $container);

     this.$search.on('keydown', function (evt) {
       self.trigger('keypress', evt);

       self._keyUpPrevented = evt.isDefaultPrevented();
     });

     // Workaround for browsers which do not support the `input` event
     // This will prevent double-triggering of events for browsers which support
     // both the `keyup` and `input` events.
     this.$search.on('input', function (evt) {
       // Unbind the duplicated `keyup` event
       $(this).off('keyup');
     });

     this.$search.on('keyup input', function (evt) {
       self.handleSearch(evt);
     });

     container.on('open', function () {
       self.$search.attr('tabindex', 0);
       self.$search.attr('aria-controls', resultsId);

       self.$search.trigger('focus');

       window.setTimeout(function () {
         self.$search.trigger('focus');
       }, 0);
     });

     container.on('close', function () {
       self.$search.attr('tabindex', -1);
       self.$search.removeAttr('aria-controls');
       self.$search.removeAttr('aria-activedescendant');

       self.$search.val('');
       self.$search.trigger('blur');
     });

     container.on('focus', function () {
       if (!container.isOpen()) {
         self.$search.trigger('focus');
       }
     });

     container.on('results:all', function (params) {
       if (params.query.term == null || params.query.term === '') {
         var showSearch = self.showSearch(params);

         if (showSearch) {
           self.$searchContainer[0].classList.remove('select2-search--hide');
         } else {
           self.$searchContainer[0].classList.add('select2-search--hide');
         }
       }
     });

     container.on('results:focus', function (params) {
       if (params.data._resultId) {
         self.$search.attr('aria-activedescendant', params.data._resultId);
       } else {
         self.$search.removeAttr('aria-activedescendant');
       }
     });
   };

   Search.prototype.handleSearch = function (evt) {
     if (!this._keyUpPrevented) {
       var input = this.$search.val();

       this.trigger('query', {
         term: input
       });
     }

     this._keyUpPrevented = false;
   };

   Search.prototype.showSearch = function (_, params) {
     return true;
   };

   return Search;
 });

 S2.define('select2/dropdown/hidePlaceholder',[

 ], function () {
   function HidePlaceholder (decorated, $element, options, dataAdapter) {
     this.placeholder = this.normalizePlaceholder(options.get('placeholder'));

     decorated.call(this, $element, options, dataAdapter);
   }

   HidePlaceholder.prototype.append = function (decorated, data) {
     data.results = this.removePlaceholder(data.results);

     decorated.call(this, data);
   };

   HidePlaceholder.prototype.normalizePlaceholder = function (_, placeholder) {
     if (typeof placeholder === 'string') {
       placeholder = {
         id: '',
         text: placeholder
       };
     }

     return placeholder;
   };

   HidePlaceholder.prototype.removePlaceholder = function (_, data) {
     var modifiedData = data.slice(0);

     for (var d = data.length - 1; d >= 0; d--) {
       var item = data[d];

       if (this.placeholder.id === item.id) {
         modifiedData.splice(d, 1);
       }
     }

     return modifiedData;
   };

   return HidePlaceholder;
 });

 S2.define('select2/dropdown/infiniteScroll',[
   'jquery'
 ], function ($) {
   function InfiniteScroll (decorated, $element, options, dataAdapter) {
     this.lastParams = {};

     decorated.call(this, $element, options, dataAdapter);

     this.$loadingMore = this.createLoadingMore();
     this.loading = false;
   }

   InfiniteScroll.prototype.append = function (decorated, data) {
     this.$loadingMore.remove();
     this.loading = false;

     decorated.call(this, data);

     if (this.showLoadingMore(data)) {
       this.$results.append(this.$loadingMore);
       this.loadMoreIfNeeded();
     }
   };

   InfiniteScroll.prototype.bind = function (decorated, container, $container) {
     var self = this;

     decorated.call(this, container, $container);

     container.on('query', function (params) {
       self.lastParams = params;
       self.loading = true;
     });

     container.on('query:append', function (params) {
       self.lastParams = params;
       self.loading = true;
     });

     this.$results.on('scroll', this.loadMoreIfNeeded.bind(this));
   };

   InfiniteScroll.prototype.loadMoreIfNeeded = function () {
     var isLoadMoreVisible = $.contains(
       document.documentElement,
       this.$loadingMore[0]
     );

     if (this.loading || !isLoadMoreVisible) {
       return;
     }

     var currentOffset = this.$results.offset().top +
       this.$results.outerHeight(false);
     var loadingMoreOffset = this.$loadingMore.offset().top +
       this.$loadingMore.outerHeight(false);

     if (currentOffset + 50 >= loadingMoreOffset) {
       this.loadMore();
     }
   };

   InfiniteScroll.prototype.loadMore = function () {
     this.loading = true;

     var params = $.extend({}, {page: 1}, this.lastParams);

     params.page++;

     this.trigger('query:append', params);
   };

   InfiniteScroll.prototype.showLoadingMore = function (_, data) {
     return data.pagination && data.pagination.more;
   };

   InfiniteScroll.prototype.createLoadingMore = function () {
     var $option = $(
       '<li ' +
       'class="select2-results__option select2-results__option--load-more"' +
       'role="option" aria-disabled="true"></li>'
     );

     var message = this.options.get('translations').get('loadingMore');

     $option.html(message(this.lastParams));

     return $option;
   };

   return InfiniteScroll;
 });

 S2.define('select2/dropdown/attachBody',[
   'jquery',
   '../utils'
 ], function ($, Utils) {
   function AttachBody (decorated, $element, options) {
     this.$dropdownParent = $(options.get('dropdownParent') || document.body);

     decorated.call(this, $element, options);
   }

   AttachBody.prototype.bind = function (decorated, container, $container) {
     var self = this;

     decorated.call(this, container, $container);

     container.on('open', function () {
       self._showDropdown();
       self._attachPositioningHandler(container);

       // Must bind after the results handlers to ensure correct sizing
       self._bindContainerResultHandlers(container);
     });

     container.on('close', function () {
       self._hideDropdown();
       self._detachPositioningHandler(container);
     });

     this.$dropdownContainer.on('mousedown', function (evt) {
       evt.stopPropagation();
     });
   };

   AttachBody.prototype.destroy = function (decorated) {
     decorated.call(this);

     this.$dropdownContainer.remove();
   };

   AttachBody.prototype.position = function (decorated, $dropdown, $container) {
     // Clone all of the container classes
     $dropdown.attr('class', $container.attr('class'));

     $dropdown[0].classList.remove('select2');
     $dropdown[0].classList.add('select2-container--open');

     $dropdown.css({
       position: 'absolute',
       top: -999999
     });

     this.$container = $container;
   };

   AttachBody.prototype.render = function (decorated) {
     var $container = $('<span></span>');

     var $dropdown = decorated.call(this);
     $container.append($dropdown);

     this.$dropdownContainer = $container;

     return $container;
   };

   AttachBody.prototype._hideDropdown = function (decorated) {
     this.$dropdownContainer.detach();
   };

   AttachBody.prototype._bindContainerResultHandlers =
       function (decorated, container) {

     // These should only be bound once
     if (this._containerResultsHandlersBound) {
       return;
     }

     var self = this;

     container.on('results:all', function () {
       self._positionDropdown();
       self._resizeDropdown();
     });

     container.on('results:append', function () {
       self._positionDropdown();
       self._resizeDropdown();
     });

     container.on('results:message', function () {
       self._positionDropdown();
       self._resizeDropdown();
     });

     container.on('select', function () {
       self._positionDropdown();
       self._resizeDropdown();
     });

     container.on('unselect', function () {
       self._positionDropdown();
       self._resizeDropdown();
     });

     this._containerResultsHandlersBound = true;
   };

   AttachBody.prototype._attachPositioningHandler =
       function (decorated, container) {
     var self = this;

     var scrollEvent = 'scroll.select2.' + container.id;
     var resizeEvent = 'resize.select2.' + container.id;
     var orientationEvent = 'orientationchange.select2.' + container.id;

     var $watchers = this.$container.parents().filter(Utils.hasScroll);
     $watchers.each(function () {
       Utils.StoreData(this, 'select2-scroll-position', {
         x: $(this).scrollLeft(),
         y: $(this).scrollTop()
       });
     });

     $watchers.on(scrollEvent, function (ev) {
       var position = Utils.GetData(this, 'select2-scroll-position');
       $(this).scrollTop(position.y);
     });

     $(window).on(scrollEvent + ' ' + resizeEvent + ' ' + orientationEvent,
       function (e) {
       self._positionDropdown();
       self._resizeDropdown();
     });
   };

   AttachBody.prototype._detachPositioningHandler =
       function (decorated, container) {
     var scrollEvent = 'scroll.select2.' + container.id;
     var resizeEvent = 'resize.select2.' + container.id;
     var orientationEvent = 'orientationchange.select2.' + container.id;

     var $watchers = this.$container.parents().filter(Utils.hasScroll);
     $watchers.off(scrollEvent);

     $(window).off(scrollEvent + ' ' + resizeEvent + ' ' + orientationEvent);
   };

   AttachBody.prototype._positionDropdown = function () {
     var $window = $(window);

     var isCurrentlyAbove = this.$dropdown[0].classList
       .contains('select2-dropdown--above');
     var isCurrentlyBelow = this.$dropdown[0].classList
       .contains('select2-dropdown--below');

     var newDirection = null;

     var offset = this.$container.offset();

     offset.bottom = offset.top + this.$container.outerHeight(false);

     var container = {
       height: this.$container.outerHeight(false)
     };

     container.top = offset.top;
     container.bottom = offset.top + container.height;

     var dropdown = {
       height: this.$dropdown.outerHeight(false)
     };

     var viewport = {
       top: $window.scrollTop(),
       bottom: $window.scrollTop() + $window.height()
     };

     var enoughRoomAbove = viewport.top < (offset.top - dropdown.height);
     var enoughRoomBelow = viewport.bottom > (offset.bottom + dropdown.height);

     var css = {
       left: offset.left,
       top: container.bottom
     };

     // Determine what the parent element is to use for calculating the offset
     var $offsetParent = this.$dropdownParent;

     // For statically positioned elements, we need to get the element
     // that is determining the offset
     if ($offsetParent.css('position') === 'static') {
       $offsetParent = $offsetParent.offsetParent();
     }

     var parentOffset = {
       top: 0,
       left: 0
     };

     if (
       $.contains(document.body, $offsetParent[0]) ||
       $offsetParent[0].isConnected
       ) {
       parentOffset = $offsetParent.offset();
     }

     css.top -= parentOffset.top;
     css.left -= parentOffset.left;

     if (!isCurrentlyAbove && !isCurrentlyBelow) {
       newDirection = 'below';
     }

     if (!enoughRoomBelow && enoughRoomAbove && !isCurrentlyAbove) {
       newDirection = 'above';
     } else if (!enoughRoomAbove && enoughRoomBelow && isCurrentlyAbove) {
       newDirection = 'below';
     }

     if (newDirection == 'above' ||
       (isCurrentlyAbove && newDirection !== 'below')) {
       css.top = container.top - parentOffset.top - dropdown.height;
     }

     if (newDirection != null) {
       this.$dropdown[0].classList.remove('select2-dropdown--below');
       this.$dropdown[0].classList.remove('select2-dropdown--above');
       this.$dropdown[0].classList.add('select2-dropdown--' + newDirection);

       this.$container[0].classList.remove('select2-container--below');
       this.$container[0].classList.remove('select2-container--above');
       this.$container[0].classList.add('select2-container--' + newDirection);
     }

     this.$dropdownContainer.css(css);
   };

   AttachBody.prototype._resizeDropdown = function () {
     var css = {
       width: this.$container.outerWidth(false) + 'px'
     };

     if (this.options.get('dropdownAutoWidth')) {
       css.minWidth = css.width;
       css.position = 'relative';
       css.width = 'auto';
     }

     this.$dropdown.css(css);
   };

   AttachBody.prototype._showDropdown = function (decorated) {
     this.$dropdownContainer.appendTo(this.$dropdownParent);

     this._positionDropdown();
     this._resizeDropdown();
   };

   return AttachBody;
 });

 S2.define('select2/dropdown/minimumResultsForSearch',[

 ], function () {
   function countResults (data) {
     var count = 0;

     for (var d = 0; d < data.length; d++) {
       var item = data[d];

       if (item.children) {
         count += countResults(item.children);
       } else {
         count++;
       }
     }

     return count;
   }

   function MinimumResultsForSearch (decorated, $element, options, dataAdapter) {
     this.minimumResultsForSearch = options.get('minimumResultsForSearch');

     if (this.minimumResultsForSearch < 0) {
       this.minimumResultsForSearch = Infinity;
     }

     decorated.call(this, $element, options, dataAdapter);
   }

   MinimumResultsForSearch.prototype.showSearch = function (decorated, params) {
     if (countResults(params.data.results) < this.minimumResultsForSearch) {
       return false;
     }

     return decorated.call(this, params);
   };

   return MinimumResultsForSearch;
 });

 S2.define('select2/dropdown/selectOnClose',[
   '../utils'
 ], function (Utils) {
   function SelectOnClose () { }

   SelectOnClose.prototype.bind = function (decorated, container, $container) {
     var self = this;

     decorated.call(this, container, $container);

     container.on('close', function (params) {
       self._handleSelectOnClose(params);
     });
   };

   SelectOnClose.prototype._handleSelectOnClose = function (_, params) {
     if (params && params.originalSelect2Event != null) {
       var event = params.originalSelect2Event;

       // Don't select an item if the close event was triggered from a select or
       // unselect event
       if (event._type === 'select' || event._type === 'unselect') {
         return;
       }
     }

     var $highlightedResults = this.getHighlightedResults();

     // Only select highlighted results
     if ($highlightedResults.length < 1) {
       return;
     }

     var data = Utils.GetData($highlightedResults[0], 'data');

     // Don't re-select already selected resulte
     if (
       (data.element != null && data.element.selected) ||
       (data.element == null && data.selected)
     ) {
       return;
     }

     this.trigger('select', {
         data: data
     });
   };

   return SelectOnClose;
 });

 S2.define('select2/dropdown/closeOnSelect',[

 ], function () {
   function CloseOnSelect () { }

   CloseOnSelect.prototype.bind = function (decorated, container, $container) {
     var self = this;

     decorated.call(this, container, $container);

     container.on('select', function (evt) {
       self._selectTriggered(evt);
     });

     container.on('unselect', function (evt) {
       self._selectTriggered(evt);
     });
   };

   CloseOnSelect.prototype._selectTriggered = function (_, evt) {
     var originalEvent = evt.originalEvent;

     // Don't close if the control key is being held
     if (originalEvent && (originalEvent.ctrlKey || originalEvent.metaKey)) {
       return;
     }

     this.trigger('close', {
       originalEvent: originalEvent,
       originalSelect2Event: evt
     });
   };

   return CloseOnSelect;
 });

 S2.define('select2/dropdown/dropdownCss',[
   '../utils'
 ], function (Utils) {
   function DropdownCSS () { }

   DropdownCSS.prototype.render = function (decorated) {
     var $dropdown = decorated.call(this);

     var dropdownCssClass = this.options.get('dropdownCssClass') || '';

     if (dropdownCssClass.indexOf(':all:') !== -1) {
       dropdownCssClass = dropdownCssClass.replace(':all:', '');

       Utils.copyNonInternalCssClasses($dropdown[0], this.$element[0]);
     }

     $dropdown.addClass(dropdownCssClass);

     return $dropdown;
   };

   return DropdownCSS;
 });

 S2.define('select2/dropdown/tagsSearchHighlight',[
   '../utils'
 ], function (Utils) {
   function TagsSearchHighlight () { }

   TagsSearchHighlight.prototype.highlightFirstItem = function (decorated) {
     var $options = this.$results
     .find(
       '.select2-results__option--selectable' +
       ':not(.select2-results__option--selected)'
     );

     if ($options.length > 0) {
       var $firstOption = $options.first();
       var data = Utils.GetData($firstOption[0], 'data');
       var firstElement = data.element;

       if (firstElement && firstElement.getAttribute) {
         if (firstElement.getAttribute('data-select2-tag') === 'true') {
           $firstOption.trigger('mouseenter');

           return;
         }
       }
     }

     decorated.call(this);
   };

   return TagsSearchHighlight;
 });

 S2.define('select2/i18n/en',[],function () {
   // English
   return {
     errorLoading: function () {
       return 'The results could not be loaded.';
     },
     inputTooLong: function (args) {
       var overChars = args.input.length - args.maximum;

       var message = 'Please delete ' + overChars + ' character';

       if (overChars != 1) {
         message += 's';
       }

       return message;
     },
     inputTooShort: function (args) {
       var remainingChars = args.minimum - args.input.length;

       var message = 'Please enter ' + remainingChars + ' or more characters';

       return message;
     },
     loadingMore: function () {
       return 'Loading more results…';
     },
     maximumSelected: function (args) {
       var message = 'You can only select ' + args.maximum + ' item';

       if (args.maximum != 1) {
         message += 's';
       }

       return message;
     },
     noResults: function () {
       return 'No results found';
     },
     searching: function () {
       return 'Searching…';
     },
     removeAllItems: function () {
       return 'Remove all items';
     },
     removeItem: function () {
       return 'Remove item';
     },
     search: function() {
       return 'Search';
     }
   };
 });

 S2.define('select2/defaults',[
   'jquery',

   './results',

   './selection/single',
   './selection/multiple',
   './selection/placeholder',
   './selection/allowClear',
   './selection/search',
   './selection/selectionCss',
   './selection/eventRelay',

   './utils',
   './translation',
   './diacritics',

   './data/select',
   './data/array',
   './data/ajax',
   './data/tags',
   './data/tokenizer',
   './data/minimumInputLength',
   './data/maximumInputLength',
   './data/maximumSelectionLength',

   './dropdown',
   './dropdown/search',
   './dropdown/hidePlaceholder',
   './dropdown/infiniteScroll',
   './dropdown/attachBody',
   './dropdown/minimumResultsForSearch',
   './dropdown/selectOnClose',
   './dropdown/closeOnSelect',
   './dropdown/dropdownCss',
   './dropdown/tagsSearchHighlight',

   './i18n/en'
 ], function ($,

              ResultsList,

              SingleSelection, MultipleSelection, Placeholder, AllowClear,
              SelectionSearch, SelectionCSS, EventRelay,

              Utils, Translation, DIACRITICS,

              SelectData, ArrayData, AjaxData, Tags, Tokenizer,
              MinimumInputLength, MaximumInputLength, MaximumSelectionLength,

              Dropdown, DropdownSearch, HidePlaceholder, InfiniteScroll,
              AttachBody, MinimumResultsForSearch, SelectOnClose, CloseOnSelect,
              DropdownCSS, TagsSearchHighlight,

              EnglishTranslation) {
   function Defaults () {
     this.reset();
   }

   Defaults.prototype.apply = function (options) {
     options = $.extend(true, {}, this.defaults, options);

     if (options.dataAdapter == null) {
       if (options.ajax != null) {
         options.dataAdapter = AjaxData;
       } else if (options.data != null) {
         options.dataAdapter = ArrayData;
       } else {
         options.dataAdapter = SelectData;
       }

       if (options.minimumInputLength > 0) {
         options.dataAdapter = Utils.Decorate(
           options.dataAdapter,
           MinimumInputLength
         );
       }

       if (options.maximumInputLength > 0) {
         options.dataAdapter = Utils.Decorate(
           options.dataAdapter,
           MaximumInputLength
         );
       }

       if (options.maximumSelectionLength > 0) {
         options.dataAdapter = Utils.Decorate(
           options.dataAdapter,
           MaximumSelectionLength
         );
       }

       if (options.tags) {
         options.dataAdapter = Utils.Decorate(options.dataAdapter, Tags);
       }

       if (options.tokenSeparators != null || options.tokenizer != null) {
         options.dataAdapter = Utils.Decorate(
           options.dataAdapter,
           Tokenizer
         );
       }
     }

     if (options.resultsAdapter == null) {
       options.resultsAdapter = ResultsList;

       if (options.ajax != null) {
         options.resultsAdapter = Utils.Decorate(
           options.resultsAdapter,
           InfiniteScroll
         );
       }

       if (options.placeholder != null) {
         options.resultsAdapter = Utils.Decorate(
           options.resultsAdapter,
           HidePlaceholder
         );
       }

       if (options.selectOnClose) {
         options.resultsAdapter = Utils.Decorate(
           options.resultsAdapter,
           SelectOnClose
         );
       }

       if (options.tags) {
         options.resultsAdapter = Utils.Decorate(
           options.resultsAdapter,
           TagsSearchHighlight
         );
       }
     }

     if (options.dropdownAdapter == null) {
       if (options.multiple) {
         options.dropdownAdapter = Dropdown;
       } else {
         var SearchableDropdown = Utils.Decorate(Dropdown, DropdownSearch);

         options.dropdownAdapter = SearchableDropdown;
       }

       if (options.minimumResultsForSearch !== 0) {
         options.dropdownAdapter = Utils.Decorate(
           options.dropdownAdapter,
           MinimumResultsForSearch
         );
       }

       if (options.closeOnSelect) {
         options.dropdownAdapter = Utils.Decorate(
           options.dropdownAdapter,
           CloseOnSelect
         );
       }

       if (options.dropdownCssClass != null) {
         options.dropdownAdapter = Utils.Decorate(
           options.dropdownAdapter,
           DropdownCSS
         );
       }

       options.dropdownAdapter = Utils.Decorate(
         options.dropdownAdapter,
         AttachBody
       );
     }

     if (options.selectionAdapter == null) {
       if (options.multiple) {
         options.selectionAdapter = MultipleSelection;
       } else {
         options.selectionAdapter = SingleSelection;
       }

       // Add the placeholder mixin if a placeholder was specified
       if (options.placeholder != null) {
         options.selectionAdapter = Utils.Decorate(
           options.selectionAdapter,
           Placeholder
         );
       }

       if (options.allowClear) {
         options.selectionAdapter = Utils.Decorate(
           options.selectionAdapter,
           AllowClear
         );
       }

       if (options.multiple) {
         options.selectionAdapter = Utils.Decorate(
           options.selectionAdapter,
           SelectionSearch
         );
       }

       if (options.selectionCssClass != null) {
         options.selectionAdapter = Utils.Decorate(
           options.selectionAdapter,
           SelectionCSS
         );
       }

       options.selectionAdapter = Utils.Decorate(
         options.selectionAdapter,
         EventRelay
       );
     }

     // If the defaults were not previously applied from an element, it is
     // possible for the language option to have not been resolved
     options.language = this._resolveLanguage(options.language);

     // Always fall back to English since it will always be complete
     options.language.push('en');

     var uniqueLanguages = [];

     for (var l = 0; l < options.language.length; l++) {
       var language = options.language[l];

       if (uniqueLanguages.indexOf(language) === -1) {
         uniqueLanguages.push(language);
       }
     }

     options.language = uniqueLanguages;

     options.translations = this._processTranslations(
       options.language,
       options.debug
     );

     return options;
   };

   Defaults.prototype.reset = function () {
     function stripDiacritics (text) {
       // Used 'uni range + named function' from http://jsperf.com/diacritics/18
       function match(a) {
         return DIACRITICS[a] || a;
       }

       return text.replace(/[^\u0000-\u007E]/g, match);
     }

     function matcher (params, data) {
       // Always return the object if there is nothing to compare
       if (params.term == null || params.term.trim() === '') {
         return data;
       }

       // Do a recursive check for options with children
       if (data.children && data.children.length > 0) {
         // Clone the data object if there are children
         // This is required as we modify the object to remove any non-matches
         var match = $.extend(true, {}, data);

         // Check each child of the option
         for (var c = data.children.length - 1; c >= 0; c--) {
           var child = data.children[c];

           var matches = matcher(params, child);

           // If there wasn't a match, remove the object in the array
           if (matches == null) {
             match.children.splice(c, 1);
           }
         }

         // If any children matched, return the new object
         if (match.children.length > 0) {
           return match;
         }

         // If there were no matching children, check just the plain object
         return matcher(params, match);
       }

       var original = stripDiacritics(data.text).toUpperCase();
       var term = stripDiacritics(params.term).toUpperCase();

       // Check if the text contains the term
       if (original.indexOf(term) > -1) {
         return data;
       }

       // If it doesn't contain the term, don't return anything
       return null;
     }

     this.defaults = {
       amdLanguageBase: './i18n/',
       autocomplete: 'off',
       closeOnSelect: true,
       debug: false,
       dropdownAutoWidth: false,
       escapeMarkup: Utils.escapeMarkup,
       language: {},
       matcher: matcher,
       minimumInputLength: 0,
       maximumInputLength: 0,
       maximumSelectionLength: 0,
       minimumResultsForSearch: 0,
       selectOnClose: false,
       scrollAfterSelect: false,
       sorter: function (data) {
         return data;
       },
       templateResult: function (result) {
         return result.text;
       },
       templateSelection: function (selection) {
         return selection.text;
       },
       theme: 'default',
       width: 'resolve'
     };
   };

   Defaults.prototype.applyFromElement = function (options, $element) {
     var optionLanguage = options.language;
     var defaultLanguage = this.defaults.language;
     var elementLanguage = $element.prop('lang');
     var parentLanguage = $element.closest('[lang]').prop('lang');

     var languages = Array.prototype.concat.call(
       this._resolveLanguage(elementLanguage),
       this._resolveLanguage(optionLanguage),
       this._resolveLanguage(defaultLanguage),
       this._resolveLanguage(parentLanguage)
     );

     options.language = languages;

     return options;
   };

   Defaults.prototype._resolveLanguage = function (language) {
     if (!language) {
       return [];
     }

     if ($.isEmptyObject(language)) {
       return [];
     }

     if ($.isPlainObject(language)) {
       return [language];
     }

     var languages;

     if (!Array.isArray(language)) {
       languages = [language];
     } else {
       languages = language;
     }

     var resolvedLanguages = [];

     for (var l = 0; l < languages.length; l++) {
       resolvedLanguages.push(languages[l]);

       if (typeof languages[l] === 'string' && languages[l].indexOf('-') > 0) {
         // Extract the region information if it is included
         var languageParts = languages[l].split('-');
         var baseLanguage = languageParts[0];

         resolvedLanguages.push(baseLanguage);
       }
     }

     return resolvedLanguages;
   };

   Defaults.prototype._processTranslations = function (languages, debug) {
     var translations = new Translation();

     for (var l = 0; l < languages.length; l++) {
       var languageData = new Translation();

       var language = languages[l];

       if (typeof language === 'string') {
         try {
           // Try to load it with the original name
           languageData = Translation.loadPath(language);
         } catch (e) {
           try {
             // If we couldn't load it, check if it wasn't the full path
             language = this.defaults.amdLanguageBase + language;
             languageData = Translation.loadPath(language);
           } catch (ex) {
             // The translation could not be loaded at all. Sometimes this is
             // because of a configuration problem, other times this can be
             // because of how Select2 helps load all possible translation files
             if (debug && window.console && console.warn) {
               console.warn(
                 'Select2: The language file for "' + language + '" could ' +
                 'not be automatically loaded. A fallback will be used instead.'
               );
             }
           }
         }
       } else if ($.isPlainObject(language)) {
         languageData = new Translation(language);
       } else {
         languageData = language;
       }

       translations.extend(languageData);
     }

     return translations;
   };

   Defaults.prototype.set = function (key, value) {
     var camelKey = $.camelCase(key);

     var data = {};
     data[camelKey] = value;

     var convertedData = Utils._convertData(data);

     $.extend(true, this.defaults, convertedData);
   };

   var defaults = new Defaults();

   return defaults;
 });

 S2.define('select2/options',[
   'jquery',
   './defaults',
   './utils'
 ], function ($, Defaults, Utils) {
   function Options (options, $element) {
     this.options = options;

     if ($element != null) {
       this.fromElement($element);
     }

     if ($element != null) {
       this.options = Defaults.applyFromElement(this.options, $element);
     }

     this.options = Defaults.apply(this.options);
   }

   Options.prototype.fromElement = function ($e) {
     var excludedData = ['select2'];

     if (this.options.multiple == null) {
       this.options.multiple = $e.prop('multiple');
     }

     if (this.options.disabled == null) {
       this.options.disabled = $e.prop('disabled');
     }

     if (this.options.autocomplete == null && $e.prop('autocomplete')) {
       this.options.autocomplete = $e.prop('autocomplete');
     }

     if (this.options.dir == null) {
       if ($e.prop('dir')) {
         this.options.dir = $e.prop('dir');
       } else if ($e.closest('[dir]').prop('dir')) {
         this.options.dir = $e.closest('[dir]').prop('dir');
       } else {
         this.options.dir = 'ltr';
       }
     }

     $e.prop('disabled', this.options.disabled);
     $e.prop('multiple', this.options.multiple);

     if (Utils.GetData($e[0], 'select2Tags')) {
       if (this.options.debug && window.console && console.warn) {
         console.warn(
           'Select2: The `data-select2-tags` attribute has been changed to ' +
           'use the `data-data` and `data-tags="true"` attributes and will be ' +
           'removed in future versions of Select2.'
         );
       }

       Utils.StoreData($e[0], 'data', Utils.GetData($e[0], 'select2Tags'));
       Utils.StoreData($e[0], 'tags', true);
     }

     if (Utils.GetData($e[0], 'ajaxUrl')) {
       if (this.options.debug && window.console && console.warn) {
         console.warn(
           'Select2: The `data-ajax-url` attribute has been changed to ' +
           '`data-ajax--url` and support for the old attribute will be removed' +
           ' in future versions of Select2.'
         );
       }

       $e.attr('ajax--url', Utils.GetData($e[0], 'ajaxUrl'));
       Utils.StoreData($e[0], 'ajax-Url', Utils.GetData($e[0], 'ajaxUrl'));
     }

     var dataset = {};

     function upperCaseLetter(_, letter) {
       return letter.toUpperCase();
     }

     // Pre-load all of the attributes which are prefixed with `data-`
     for (var attr = 0; attr < $e[0].attributes.length; attr++) {
       var attributeName = $e[0].attributes[attr].name;
       var prefix = 'data-';

       if (attributeName.substr(0, prefix.length) == prefix) {
         // Get the contents of the attribute after `data-`
         var dataName = attributeName.substring(prefix.length);

         // Get the data contents from the consistent source
         // This is more than likely the jQuery data helper
         var dataValue = Utils.GetData($e[0], dataName);

         // camelCase the attribute name to match the spec
         var camelDataName = dataName.replace(/-([a-z])/g, upperCaseLetter);

         // Store the data attribute contents into the dataset since
         dataset[camelDataName] = dataValue;
       }
     }

     // Prefer the element's `dataset` attribute if it exists
     // jQuery 1.x does not correctly handle data attributes with multiple dashes
     if ($.fn.jquery && $.fn.jquery.substr(0, 2) == '1.' && $e[0].dataset) {
       dataset = $.extend(true, {}, $e[0].dataset, dataset);
     }

     // Prefer our internal data cache if it exists
     var data = $.extend(true, {}, Utils.GetData($e[0]), dataset);

     data = Utils._convertData(data);

     for (var key in data) {
       if (excludedData.indexOf(key) > -1) {
         continue;
       }

       if ($.isPlainObject(this.options[key])) {
         $.extend(this.options[key], data[key]);
       } else {
         this.options[key] = data[key];
       }
     }

     return this;
   };

   Options.prototype.get = function (key) {
     return this.options[key];
   };

   Options.prototype.set = function (key, val) {
     this.options[key] = val;
   };

   return Options;
 });

 S2.define('select2/core',[
   'jquery',
   './options',
   './utils',
   './keys'
 ], function ($, Options, Utils, KEYS) {
   var Select2 = function ($element, options) {
     if (Utils.GetData($element[0], 'select2') != null) {
       Utils.GetData($element[0], 'select2').destroy();
     }

     this.$element = $element;

     this.id = this._generateId($element);

     options = options || {};

     this.options = new Options(options, $element);

     Select2.__super__.constructor.call(this);

     // Set up the tabindex

     var tabindex = $element.attr('tabindex') || 0;
     Utils.StoreData($element[0], 'old-tabindex', tabindex);
     $element.attr('tabindex', '-1');

     // Set up containers and adapters

     var DataAdapter = this.options.get('dataAdapter');
     this.dataAdapter = new DataAdapter($element, this.options);

     var $container = this.render();

     this._placeContainer($container);

     var SelectionAdapter = this.options.get('selectionAdapter');
     this.selection = new SelectionAdapter($element, this.options);
     this.$selection = this.selection.render();

     this.selection.position(this.$selection, $container);

     var DropdownAdapter = this.options.get('dropdownAdapter');
     this.dropdown = new DropdownAdapter($element, this.options);
     this.$dropdown = this.dropdown.render();

     this.dropdown.position(this.$dropdown, $container);

     var ResultsAdapter = this.options.get('resultsAdapter');
     this.results = new ResultsAdapter($element, this.options, this.dataAdapter);
     this.$results = this.results.render();

     this.results.position(this.$results, this.$dropdown);

     // Bind events

     var self = this;

     // Bind the container to all of the adapters
     this._bindAdapters();

     // Register any DOM event handlers
     this._registerDomEvents();

     // Register any internal event handlers
     this._registerDataEvents();
     this._registerSelectionEvents();
     this._registerDropdownEvents();
     this._registerResultsEvents();
     this._registerEvents();

     // Set the initial state
     this.dataAdapter.current(function (initialData) {
       self.trigger('selection:update', {
         data: initialData
       });
     });

     // Hide the original select
     $element[0].classList.add('select2-hidden-accessible');
     $element.attr('aria-hidden', 'true');

     // Synchronize any monitored attributes
     this._syncAttributes();

     Utils.StoreData($element[0], 'select2', this);

     // Ensure backwards compatibility with $element.data('select2').
     $element.data('select2', this);
   };

   Utils.Extend(Select2, Utils.Observable);

   Select2.prototype._generateId = function ($element) {
     var id = '';

     if ($element.attr('id') != null) {
       id = $element.attr('id');
     } else if ($element.attr('name') != null) {
       id = $element.attr('name') + '-' + Utils.generateChars(2);
     } else {
       id = Utils.generateChars(4);
     }

     id = id.replace(/(:|\.|\[|\]|,)/g, '');
     id = 'select2-' + id;

     return id;
   };

   Select2.prototype._placeContainer = function ($container) {
     $container.insertAfter(this.$element);

     var width = this._resolveWidth(this.$element, this.options.get('width'));

     if (width != null) {
       $container.css('width', width);
     }
   };

   Select2.prototype._resolveWidth = function ($element, method) {
     var WIDTH = /^width:(([-+]?([0-9]*\.)?[0-9]+)(px|em|ex|%|in|cm|mm|pt|pc))/i;

     if (method == 'resolve') {
       var styleWidth = this._resolveWidth($element, 'style');

       if (styleWidth != null) {
         return styleWidth;
       }

       return this._resolveWidth($element, 'element');
     }

     if (method == 'element') {
       var elementWidth = $element.outerWidth(false);

       if (elementWidth <= 0) {
         return 'auto';
       }

       return elementWidth + 'px';
     }

     if (method == 'style') {
       var style = $element.attr('style');

       if (typeof(style) !== 'string') {
         return null;
       }

       var attrs = style.split(';');

       for (var i = 0, l = attrs.length; i < l; i = i + 1) {
         var attr = attrs[i].replace(/\s/g, '');
         var matches = attr.match(WIDTH);

         if (matches !== null && matches.length >= 1) {
           return matches[1];
         }
       }

       return null;
     }

     if (method == 'computedstyle') {
       var computedStyle = window.getComputedStyle($element[0]);

       return computedStyle.width;
     }

     return method;
   };

   Select2.prototype._bindAdapters = function () {
     this.dataAdapter.bind(this, this.$container);
     this.selection.bind(this, this.$container);

     this.dropdown.bind(this, this.$container);
     this.results.bind(this, this.$container);
   };

   Select2.prototype._registerDomEvents = function () {
     var self = this;

     this.$element.on('change.select2', function () {
       self.dataAdapter.current(function (data) {
         self.trigger('selection:update', {
           data: data
         });
       });
     });

     this.$element.on('focus.select2', function (evt) {
       self.trigger('focus', evt);
     });

     this._syncA = Utils.bind(this._syncAttributes, this);
     this._syncS = Utils.bind(this._syncSubtree, this);

     this._observer = new window.MutationObserver(function (mutations) {
       self._syncA();
       self._syncS(mutations);
     });
     this._observer.observe(this.$element[0], {
       attributes: true,
       childList: true,
       subtree: false
     });
   };

   Select2.prototype._registerDataEvents = function () {
     var self = this;

     this.dataAdapter.on('*', function (name, params) {
       self.trigger(name, params);
     });
   };

   Select2.prototype._registerSelectionEvents = function () {
     var self = this;
     var nonRelayEvents = ['toggle', 'focus'];

     this.selection.on('toggle', function () {
       self.toggleDropdown();
     });

     this.selection.on('focus', function (params) {
       self.focus(params);
     });

     this.selection.on('*', function (name, params) {
       if (nonRelayEvents.indexOf(name) !== -1) {
         return;
       }

       self.trigger(name, params);
     });
   };

   Select2.prototype._registerDropdownEvents = function () {
     var self = this;

     this.dropdown.on('*', function (name, params) {
       self.trigger(name, params);
     });
   };

   Select2.prototype._registerResultsEvents = function () {
     var self = this;

     this.results.on('*', function (name, params) {
       self.trigger(name, params);
     });
   };

   Select2.prototype._registerEvents = function () {
     var self = this;

     this.on('open', function () {
       self.$container[0].classList.add('select2-container--open');
     });

     this.on('close', function () {
       self.$container[0].classList.remove('select2-container--open');
     });

     this.on('enable', function () {
       self.$container[0].classList.remove('select2-container--disabled');
     });

     this.on('disable', function () {
       self.$container[0].classList.add('select2-container--disabled');
     });

     this.on('blur', function () {
       self.$container[0].classList.remove('select2-container--focus');
     });

     this.on('query', function (params) {
       if (!self.isOpen()) {
         self.trigger('open', {});
       }

       this.dataAdapter.query(params, function (data) {
         self.trigger('results:all', {
           data: data,
           query: params
         });
       });
     });

     this.on('query:append', function (params) {
       this.dataAdapter.query(params, function (data) {
         self.trigger('results:append', {
           data: data,
           query: params
         });
       });
     });

     this.on('keypress', function (evt) {
       var key = evt.which;

       if (self.isOpen()) {
         if (key === KEYS.ESC || (key === KEYS.UP && evt.altKey)) {
           self.close(evt);

           evt.preventDefault();
         } else if (key === KEYS.ENTER || key === KEYS.TAB) {
           self.trigger('results:select', {});

           evt.preventDefault();
         } else if ((key === KEYS.SPACE && evt.ctrlKey)) {
           self.trigger('results:toggle', {});

           evt.preventDefault();
         } else if (key === KEYS.UP) {
           self.trigger('results:previous', {});

           evt.preventDefault();
         } else if (key === KEYS.DOWN) {
           self.trigger('results:next', {});

           evt.preventDefault();
         }
       } else {
         if (key === KEYS.ENTER || key === KEYS.SPACE ||
             (key === KEYS.DOWN && evt.altKey)) {
           self.open();

           evt.preventDefault();
         }
       }
     });
   };

   Select2.prototype._syncAttributes = function () {
     this.options.set('disabled', this.$element.prop('disabled'));

     if (this.isDisabled()) {
       if (this.isOpen()) {
         this.close();
       }

       this.trigger('disable', {});
     } else {
       this.trigger('enable', {});
     }
   };

   Select2.prototype._isChangeMutation = function (mutations) {
     var self = this;

     if (mutations.addedNodes && mutations.addedNodes.length > 0) {
       for (var n = 0; n < mutations.addedNodes.length; n++) {
         var node = mutations.addedNodes[n];

         if (node.selected) {
           return true;
         }
       }
     } else if (mutations.removedNodes && mutations.removedNodes.length > 0) {
       return true;
     } else if (Array.isArray(mutations)) {
       return mutations.some(function (mutation) {
         return self._isChangeMutation(mutation);
       });
     }

     return false;
   };

   Select2.prototype._syncSubtree = function (mutations) {
     var changed = this._isChangeMutation(mutations);
     var self = this;

     // Only re-pull the data if we think there is a change
     if (changed) {
       this.dataAdapter.current(function (currentData) {
         self.trigger('selection:update', {
           data: currentData
         });
       });
     }
   };

   /**
    * Override the trigger method to automatically trigger pre-events when
    * there are events that can be prevented.
    */
   Select2.prototype.trigger = function (name, args) {
     var actualTrigger = Select2.__super__.trigger;
     var preTriggerMap = {
       'open': 'opening',
       'close': 'closing',
       'select': 'selecting',
       'unselect': 'unselecting',
       'clear': 'clearing'
     };

     if (args === undefined) {
       args = {};
     }

     if (name in preTriggerMap) {
       var preTriggerName = preTriggerMap[name];
       var preTriggerArgs = {
         prevented: false,
         name: name,
         args: args
       };

       actualTrigger.call(this, preTriggerName, preTriggerArgs);

       if (preTriggerArgs.prevented) {
         args.prevented = true;

         return;
       }
     }

     actualTrigger.call(this, name, args);
   };

   Select2.prototype.toggleDropdown = function () {
     if (this.isDisabled()) {
       return;
     }

     if (this.isOpen()) {
       this.close();
     } else {
       this.open();
     }
   };

   Select2.prototype.open = function () {
     if (this.isOpen()) {
       return;
     }

     if (this.isDisabled()) {
       return;
     }

     this.trigger('query', {});
   };

   Select2.prototype.close = function (evt) {
     if (!this.isOpen()) {
       return;
     }

     this.trigger('close', { originalEvent : evt });
   };

   /**
    * Helper method to abstract the "enabled" (not "disabled") state of this
    * object.
    *
    * @return {true} if the instance is not disabled.
    * @return {false} if the instance is disabled.
    */
   Select2.prototype.isEnabled = function () {
     return !this.isDisabled();
   };

   /**
    * Helper method to abstract the "disabled" state of this object.
    *
    * @return {true} if the disabled option is true.
    * @return {false} if the disabled option is false.
    */
   Select2.prototype.isDisabled = function () {
     return this.options.get('disabled');
   };

   Select2.prototype.isOpen = function () {
     return this.$container[0].classList.contains('select2-container--open');
   };

   Select2.prototype.hasFocus = function () {
     return this.$container[0].classList.contains('select2-container--focus');
   };

   Select2.prototype.focus = function (data) {
     // No need to re-trigger focus events if we are already focused
     if (this.hasFocus()) {
       return;
     }

     this.$container[0].classList.add('select2-container--focus');
     this.trigger('focus', {});
   };

   Select2.prototype.enable = function (args) {
     if (this.options.get('debug') && window.console && console.warn) {
       console.warn(
         'Select2: The `select2("enable")` method has been deprecated and will' +
         ' be removed in later Select2 versions. Use $element.prop("disabled")' +
         ' instead.'
       );
     }

     if (args == null || args.length === 0) {
       args = [true];
     }

     var disabled = !args[0];

     this.$element.prop('disabled', disabled);
   };

   Select2.prototype.data = function () {
     if (this.options.get('debug') &&
         arguments.length > 0 && window.console && console.warn) {
       console.warn(
         'Select2: Data can no longer be set using `select2("data")`. You ' +
         'should consider setting the value instead using `$element.val()`.'
       );
     }

     var data = [];

     this.dataAdapter.current(function (currentData) {
       data = currentData;
     });

     return data;
   };

   Select2.prototype.val = function (args) {
     if (this.options.get('debug') && window.console && console.warn) {
       console.warn(
         'Select2: The `select2("val")` method has been deprecated and will be' +
         ' removed in later Select2 versions. Use $element.val() instead.'
       );
     }

     if (args == null || args.length === 0) {
       return this.$element.val();
     }

     var newVal = args[0];

     if (Array.isArray(newVal)) {
       newVal = newVal.map(function (obj) {
         return obj.toString();
       });
     }

     this.$element.val(newVal).trigger('input').trigger('change');
   };

   Select2.prototype.destroy = function () {
     Utils.RemoveData(this.$container[0]);
     this.$container.remove();

     this._observer.disconnect();
     this._observer = null;

     this._syncA = null;
     this._syncS = null;

     this.$element.off('.select2');
     this.$element.attr('tabindex',
     Utils.GetData(this.$element[0], 'old-tabindex'));

     this.$element[0].classList.remove('select2-hidden-accessible');
     this.$element.attr('aria-hidden', 'false');
     Utils.RemoveData(this.$element[0]);
     this.$element.removeData('select2');

     this.dataAdapter.destroy();
     this.selection.destroy();
     this.dropdown.destroy();
     this.results.destroy();

     this.dataAdapter = null;
     this.selection = null;
     this.dropdown = null;
     this.results = null;
   };

   Select2.prototype.render = function () {
     var $container = $(
       '<span class="select2 select2-container">' +
         '<span class="selection"></span>' +
         '<span class="dropdown-wrapper" aria-hidden="true"></span>' +
       '</span>'
     );

     $container.attr('dir', this.options.get('dir'));

     this.$container = $container;

     this.$container[0].classList
       .add('select2-container--' + this.options.get('theme'));

     Utils.StoreData($container[0], 'element', this.$element);

     return $container;
   };

   return Select2;
 });

 S2.define('jquery-mousewheel',[
   'jquery'
 ], function ($) {
   // Used to shim jQuery.mousewheel for non-full builds.
   return $;
 });

 S2.define('jquery.select2',[
   'jquery',
   'jquery-mousewheel',

   './select2/core',
   './select2/defaults',
   './select2/utils'
 ], function ($, _, Select2, Defaults, Utils) {
   if ($.fn.select2 == null) {
     // All methods that should return the element
     var thisMethods = ['open', 'close', 'destroy'];

     $.fn.select2 = function (options) {
       options = options || {};

       if (typeof options === 'object') {
         this.each(function () {
           var instanceOptions = $.extend(true, {}, options);

           var instance = new Select2($(this), instanceOptions);
         });

         return this;
       } else if (typeof options === 'string') {
         var ret;
         var args = Array.prototype.slice.call(arguments, 1);

         this.each(function () {
           var instance = Utils.GetData(this, 'select2');

           if (instance == null && window.console && console.error) {
             console.error(
               'The select2(\'' + options + '\') method was called on an ' +
               'element that is not using Select2.'
             );
           }

           ret = instance[options].apply(instance, args);
         });

         // Check if we should be returning `this`
         if (thisMethods.indexOf(options) > -1) {
           return this;
         }

         return ret;
       } else {
         throw new Error('Invalid arguments for Select2: ' + options);
       }
     };
   }

   if ($.fn.select2.defaults == null) {
     $.fn.select2.defaults = Defaults;
   }

   return Select2;
 });

   // Return the AMD loader configuration so it can be used outside of this file
   return {
     define: S2.define,
     require: S2.require
   };
 }());

   // Autoload the jQuery bindings
   // We know that all of the modules exist above this, so we're safe
   var select2 = S2.require('jquery.select2');

   // Hold the AMD module references on the jQuery function that was just loaded
   // This allows Select2 to use the internal loader outside of this file, such
   // as in the language files.
   jQuery.fn.select2.amd = S2;

   // Return the Select2 instance for anyone who is importing it.
   return select2;
 }));


 /***/ }),
 /* 308 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";
 __webpack_require__.r(__webpack_exports__);
 /* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
 /* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony import */ var select2__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(307);
 /* harmony import */ var select2__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(select2__WEBPACK_IMPORTED_MODULE_1__);
 /* harmony import */ var choices_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(232);
 /* harmony import */ var choices_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(choices_js__WEBPACK_IMPORTED_MODULE_2__);



 var selectors = {
   select2: {
     container: "[data-custom-select]",
     dropdownHolder: "[data-custom-select-dropdown]"
   },
   choices: {
     container: "[data-custom-choices]"
   }
 };
 var attributes = {
   select2: {
     selectPlaceholder: "data-custom-select-placeholder"
   },
   choices: {
     selectPlaceholder: "data-custom-choices-placeholder"
   }
 };

 (function () {
   var $selects = jquery__WEBPACK_IMPORTED_MODULE_0___default()(selectors.select2.container);
   var $choices = jquery__WEBPACK_IMPORTED_MODULE_0___default()(selectors.choices.container);

   if (!$selects.length && !$choices.length) {
     return null;
   }

   $selects.each(initCustomSelect2);
   $choices.each(initCustomChoices);

   function initCustomSelect2() {
     var $select = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this);
     var placeholderValue = $select.attr(attributes.select2.selectPlaceholder);
     var options = {
       dropdownParent: $select.siblings(selectors.select2.dropdownHolder),
       minimumResultsForSearch: -1
     };

     if (placeholderValue) {
       options.placeholder = placeholderValue;
     }

     $select.select2(options);
   }

   function initCustomChoices() {
     var select = this;
     var placeholderValue = jquery__WEBPACK_IMPORTED_MODULE_0___default()(select).attr(attributes.choices.selectPlaceholder);
     var options = {
       searchEnabled: false,
       itemSelectText: ""
     };

     if (placeholderValue) {
       options.placeholder = true;
       options.placeholderValue = placeholderValue;
     }

     new choices_js__WEBPACK_IMPORTED_MODULE_2___default.a(select, options);
   }
 })();

 /***/ }),
 /* 309 */
 /***/ (function(module, exports) {

 document.addEventListener("click", function (e) {
   var target = e.target;

   if (target.hasAttribute("data-print-button")) {
     window.print();
   }
 });

 /***/ }),
 /* 310 */
 /***/ (function(module, exports) {

 var selectors = {
   button: "[data-country-button]",
   close: "[data-country-modal-close]",
   modal: "[data-country-modal]",
   select: "[data-country-select]",
   submit: "[data-country-select-submit]"
 };
 var modifiers = {
   show: "country-modal--show"
 };

 var handleCountrySelect = function handleCountrySelect() {
   var html = document.querySelector("html");
   var button = document.querySelector(selectors.button);
   var modal = document.querySelector(selectors.modal);
   var modalClose = document.querySelector(selectors.close);
   var select = document.querySelector(selectors.select);
   var selectSubmit = document.querySelector(selectors.submit);
   if (!button) return;

   if (!button || !modalClose || !selectSubmit) {
     return null;
   }

   button.addEventListener("click", function () {
     html.classList.add("overflow-hidden");
     modal.classList.add(modifiers.show);
   });
   if (!modalClose) return;
   modalClose.addEventListener("click", function () {
     html.classList.remove("overflow-hidden");
     modal.classList.remove(modifiers.show);
   });
   if (!selectSubmit) return;
   selectSubmit.addEventListener("click", function () {
     window.location = select.value;
   });
 };

 window.addEventListener("DOMContentLoaded", handleCountrySelect);

 /***/ }),
 /* 311 */
 /***/ (function(module, exports) {

 window.addEventListener("DOMContentLoaded", function () {
   var showCookiePolicyInfo = function showCookiePolicyInfo() {
     var selectors = {
       block: "[data-cookie-policy]",
       button: "[data-cookie-policy-button]",
       close: "[data-cookie-policy-close]"
     };
     var modifiers = {
       show: "cookie-policy--show"
     };
     var cookiePolicyBlock = document.querySelector(selectors.block);
     var cookiePolicyButton = document.querySelector(selectors.button);
     var cookiePolicyClose = document.querySelector(selectors.close);
     cookiePolicyBlock.classList.add(modifiers.show);
     cookiePolicyButton.addEventListener("click", function () {
       window.localStorage.setItem("cookiePolicyAgree", "true");
       cookiePolicyBlock.classList.remove(modifiers.show);
     });
     cookiePolicyClose.addEventListener("click", function () {
       window.localStorage.setItem("cookiePolicyAgree", "false");
       cookiePolicyBlock.classList.remove(modifiers.show);
     });
   };

   if (!window.localStorage.getItem("cookiePolicyAgree")) {
     setTimeout(showCookiePolicyInfo, 10000);
   }
 });

 /***/ }),
 /* 312 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";
 __webpack_require__.r(__webpack_exports__);
 /* harmony import */ var body_scroll_lock__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62);

 var selectors = {
   popup: "[data-popup]",
   content: "[data-popup-content]",
   close: "[data-popup-close]"
 };
 var modifiers = {
   open: "popup--open"
 };

 (function () {
   initPopups();

   function initPopups() {
     document.addEventListener("click", function (event) {
       var target = event.target;
       var closeButton = target.closest(selectors.close);

       if (!closeButton) {
         return null;
       }

       var popup = closeButton.closest(selectors.popup);
       document.dispatchEvent(new CustomEvent("popup:close", {
         detail: {
           popup: popup
         }
       }));
     });
     initEvents();
   }

   function initEvents() {
     // let popup;
     document.addEventListener("popup:open", function (event) {
       var popup = event.detail.popup;

       if (!popup) {
         return null;
       }

       var scrollContent = popup.querySelector(selectors.content);
       Object(body_scroll_lock__WEBPACK_IMPORTED_MODULE_0__["disableBodyScroll"])(scrollContent);
       popup.classList.add(modifiers.open);
     });
     document.addEventListener("popup:close", function (event) {
       var popup = event.detail.popup;

       if (!popup) {
         return null;
       }

       popup.classList.remove(modifiers.open);
       var scrollContent = popup.querySelector(selectors.content);
       Object(body_scroll_lock__WEBPACK_IMPORTED_MODULE_0__["enableBodyScroll"])(scrollContent);
     });
   }

   initEvents();
 })();

 /***/ }),
 /* 313 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";
 __webpack_require__.r(__webpack_exports__);
 /* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50);
 /* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(0);
 /* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_1__);


 var selectors = {
   container: ".js-tabs-container",
   control: ".js-tabs-control",
   content: ".js-tabs-content"
 };
 var modifiers = {
   active: "active"
 };

 (function () {
   var $container = jquery__WEBPACK_IMPORTED_MODULE_1___default()(selectors.container);

   if (!$container.length) {
     return null;
   }

   $container.on("click", selectors.control, function () {
     var $currentControl = jquery__WEBPACK_IMPORTED_MODULE_1___default()(this);

     if ($currentControl.hasClass(modifiers.active)) {
       return null;
     }

     var currentIndex = $currentControl.attr("data-index");
     var $currentContent = jquery__WEBPACK_IMPORTED_MODULE_1___default()("".concat(selectors.content, "[data-index=").concat(currentIndex, "]"));
     jquery__WEBPACK_IMPORTED_MODULE_1___default()(selectors.control).removeClass(modifiers.active);
     jquery__WEBPACK_IMPORTED_MODULE_1___default()(selectors.content).removeClass(modifiers.active);
     $currentControl.addClass(modifiers.active);
     $currentContent.addClass(modifiers.active);
   });
 })();

 /***/ }),
 /* 314 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";
 __webpack_require__.r(__webpack_exports__);
 /* harmony import */ var core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39);
 /* harmony import */ var core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3);
 /* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1__);
 /* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25);
 /* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2__);
 /* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50);
 /* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_3__);
 /* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(0);
 /* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_4__);





 var selectors = {
   container: ".js-toggle-container",
   item: ".js-toggle-item",
   button: ".js-toggle-button",
   content: ".js-toggle-content"
 };
 var attributes = {
   accordionMode: "data-accordion-mode"
 };
 var modifiers = {
   active: "active"
 };
 var accordionModes = {
   single: "single",
   multiple: "multiple"
 };

 (function () {
   var $container = jquery__WEBPACK_IMPORTED_MODULE_4___default()(selectors.container);
   var $button = jquery__WEBPACK_IMPORTED_MODULE_4___default()(selectors.button);

   if (!$button.length) {
     return null;
   }

   if ($container.length) {
     $container.on("click", selectors.button, toggleAccordion);
   } else {
     $button.on("click", toggleAccordion);
   }

   function toggleAccordion() {
     var $accordion = jquery__WEBPACK_IMPORTED_MODULE_4___default()(this).parent(selectors.item);
     var $accordionContent = $accordion.find(selectors.content);

     if (!$accordionContent) {
       return null;
     }

     var $accordionContainer = $accordion.parents(selectors.container);

     if ($accordionContainer.length) {
       var accordionMode = $accordionContainer.attr(attributes.accordionMode);

       if (accordionMode === accordionModes.single) {
         var $openAccordions = $accordionContainer.find("".concat(selectors.item, ".").concat(modifiers.active)).filter(function (index, el) {
           return el !== $accordion[0];
         });
         $openAccordions.removeClass(modifiers.active);
         $openAccordions.find(selectors.content).stop().slideToggle(250, function () {
           jquery__WEBPACK_IMPORTED_MODULE_4___default()(this).css("height", "");
         });
       }
     }

     $accordion.toggleClass(modifiers.active);
     $accordionContent.stop().slideToggle(250, function () {
       jquery__WEBPACK_IMPORTED_MODULE_4___default()(this).css("height", "");
     });
   }
 })();

 /***/ }),
 /* 315 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";
 __webpack_require__.r(__webpack_exports__);
 /* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80);
 /* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31);
 /* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_1__);
 /* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3);
 /* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_2__);
 /* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14);
 /* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_3__);
 /* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27);
 /* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_4__);
 /* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41);
 /* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_5__);
 /* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(51);
 /* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_6__);
 /* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(21);
 /* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_7__);
 /* harmony import */ var core_js_modules_es_string_match_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(185);
 /* harmony import */ var core_js_modules_es_string_match_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_match_js__WEBPACK_IMPORTED_MODULE_8__);
 /* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(8);
 /* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_9__);











 (function () {
   /*
    *
    *	Lazy load images script with CACHE check.
    *	If images in cache - lazy load would not start.
    *
    *	If you don't need a feature with caches image - comment code.
    *
    *	HTML basic structure
    *	<picture class="lazy">
    *		<source data-srcset="img-src-for-1x-screen 1x, img-src-for-2x-screen 2x" >
    *		<img src="img-src-thumbnail-40x-resolution" data-srcset="img-src-default-resolution" srcset="img-src-thumbnail-40x-resolution" alt="">
    *	</picture>
    */
   function lazyLoadImages() {
     if (window.caches) {
       var lazyImages = [].slice.call(document.querySelectorAll(".lazy [data-srcset]"));
       Promise.all(lazyImages.map(function (img) {
         var src = img.getAttribute("data-srcset");
         return window.caches.match(src).then(function (response) {
           if (response) {
             img.setAttribute("srcset", src);
             img.removeAttribute("data-srcset");
             img.parentElement.classList.remove("lazy");
           }
         });
       })).then(lazyLoadPictures);
     } else {
       lazyLoadPictures();
     }
   }

   function lazyLoadPictures() {
     var lazyImages = [].slice.call(document.querySelectorAll(".lazy [data-srcset]"));

     if (lazyImages.length < 1) {
       return;
     }

     if ("IntersectionObserver" in window) {
       var lazyImageObserver = new IntersectionObserver(function (entries) {
         entries.forEach(function (entry) {
           if (entry.isIntersecting) {
             var lazyImage = entry.target;
             lazyImage.srcset = lazyImage.dataset.srcset;
             caches.open("images").then(function (cache) {
               cache.addAll([lazyImage.dataset.srcset]).then(function () {});
             });
             lazyImage.parentElement.classList.remove("lazy");
             lazyImageObserver.unobserve(lazyImage);
           }
         });
       });
       lazyImages.forEach(function (lazyImage) {
         lazyImageObserver.observe(lazyImage);
       });
     } else {
       // Not supported, load all images immediately
       lazyImages.forEach(function (image) {
         image.srcset = image.dataset.srcset;
       });
     }
   }

   document.addEventListener("DOMContentLoaded", lazyLoadImages);
   document.addEventListener("images:lazyload", lazyLoadImages);
   document.addEventListener("infScroll.append", lazyLoadImages);
 })();

 /***/ }),
 /* 316 */
 /***/ (function(module, exports, __webpack_require__) {

 "use strict";

 var global = __webpack_require__(2);
 var toIntegerOrInfinity = __webpack_require__(65);
 var toString = __webpack_require__(28);
 var requireObjectCoercible = __webpack_require__(37);

 var RangeError = global.RangeError;

 // `String.prototype.repeat` method implementation
 // https://tc39.es/ecma262/#sec-string.prototype.repeat
 module.exports = function repeat(count) {
   var str = toString(requireObjectCoercible(this));
   var result = '';
   var n = toIntegerOrInfinity(count);
   if (n < 0 || n == Infinity) throw RangeError('Wrong number of repetitions');
   for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) result += str;
   return result;
 };


 /***/ }),
 /* 317 */
 /***/ (function(module, exports, __webpack_require__) {

 "use strict";

 var $ = __webpack_require__(13);
 var global = __webpack_require__(2);
 var uncurryThis = __webpack_require__(5);
 var toIntegerOrInfinity = __webpack_require__(65);
 var thisNumberValue = __webpack_require__(186);
 var $repeat = __webpack_require__(316);
 var fails = __webpack_require__(10);

 var RangeError = global.RangeError;
 var String = global.String;
 var floor = Math.floor;
 var repeat = uncurryThis($repeat);
 var stringSlice = uncurryThis(''.slice);
 var un$ToFixed = uncurryThis(1.0.toFixed);

 var pow = function (x, n, acc) {
   return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
 };

 var log = function (x) {
   var n = 0;
   var x2 = x;
   while (x2 >= 4096) {
     n += 12;
     x2 /= 4096;
   }
   while (x2 >= 2) {
     n += 1;
     x2 /= 2;
   } return n;
 };

 var multiply = function (data, n, c) {
   var index = -1;
   var c2 = c;
   while (++index < 6) {
     c2 += n * data[index];
     data[index] = c2 % 1e7;
     c2 = floor(c2 / 1e7);
   }
 };

 var divide = function (data, n) {
   var index = 6;
   var c = 0;
   while (--index >= 0) {
     c += data[index];
     data[index] = floor(c / n);
     c = (c % n) * 1e7;
   }
 };

 var dataToString = function (data) {
   var index = 6;
   var s = '';
   while (--index >= 0) {
     if (s !== '' || index === 0 || data[index] !== 0) {
       var t = String(data[index]);
       s = s === '' ? t : s + repeat('0', 7 - t.length) + t;
     }
   } return s;
 };

 var FORCED = fails(function () {
   return un$ToFixed(0.00008, 3) !== '0.000' ||
     un$ToFixed(0.9, 0) !== '1' ||
     un$ToFixed(1.255, 2) !== '1.25' ||
     un$ToFixed(1000000000000000128.0, 0) !== '1000000000000000128';
 }) || !fails(function () {
   // V8 ~ Android 4.3-
   un$ToFixed({});
 });

 // `Number.prototype.toFixed` method
 // https://tc39.es/ecma262/#sec-number.prototype.tofixed
 $({ target: 'Number', proto: true, forced: FORCED }, {
   toFixed: function toFixed(fractionDigits) {
     var number = thisNumberValue(this);
     var fractDigits = toIntegerOrInfinity(fractionDigits);
     var data = [0, 0, 0, 0, 0, 0];
     var sign = '';
     var result = '0';
     var e, z, j, k;

     if (fractDigits < 0 || fractDigits > 20) throw RangeError('Incorrect fraction digits');
     // eslint-disable-next-line no-self-compare -- NaN check
     if (number != number) return 'NaN';
     if (number <= -1e21 || number >= 1e21) return String(number);
     if (number < 0) {
       sign = '-';
       number = -number;
     }
     if (number > 1e-21) {
       e = log(number * pow(2, 69, 1)) - 69;
       z = e < 0 ? number * pow(2, -e, 1) : number / pow(2, e, 1);
       z *= 0x10000000000000;
       e = 52 - e;
       if (e > 0) {
         multiply(data, 0, z);
         j = fractDigits;
         while (j >= 7) {
           multiply(data, 1e7, 0);
           j -= 7;
         }
         multiply(data, pow(10, j, 1), 0);
         j = e - 1;
         while (j >= 23) {
           divide(data, 1 << 23);
           j -= 23;
         }
         divide(data, 1 << j);
         multiply(data, 1, 1);
         divide(data, 2);
         result = dataToString(data);
       } else {
         multiply(data, 0, z);
         multiply(data, 1 << -e, 0);
         result = dataToString(data) + repeat('0', fractDigits);
       }
     }
     if (fractDigits > 0) {
       k = result.length;
       result = sign + (k <= fractDigits
         ? '0.' + repeat('0', fractDigits - k) + result
         : stringSlice(result, 0, k - fractDigits) + '.' + stringSlice(result, k - fractDigits));
     } else {
       result = sign + result;
     } return result;
   }
 });


 /***/ }),
 /* 318 */
 /***/ (function(module, exports, __webpack_require__) {

 /* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
     "use strict";

     if (global.setImmediate) {
         return;
     }

     var nextHandle = 1; // Spec says greater than zero
     var tasksByHandle = {};
     var currentlyRunningATask = false;
     var doc = global.document;
     var registerImmediate;

     function setImmediate(callback) {
       // Callback can either be a function or a string
       if (typeof callback !== "function") {
         callback = new Function("" + callback);
       }
       // Copy function arguments
       var args = new Array(arguments.length - 1);
       for (var i = 0; i < args.length; i++) {
           args[i] = arguments[i + 1];
       }
       // Store and register the task
       var task = { callback: callback, args: args };
       tasksByHandle[nextHandle] = task;
       registerImmediate(nextHandle);
       return nextHandle++;
     }

     function clearImmediate(handle) {
         delete tasksByHandle[handle];
     }

     function run(task) {
         var callback = task.callback;
         var args = task.args;
         switch (args.length) {
         case 0:
             callback();
             break;
         case 1:
             callback(args[0]);
             break;
         case 2:
             callback(args[0], args[1]);
             break;
         case 3:
             callback(args[0], args[1], args[2]);
             break;
         default:
             callback.apply(undefined, args);
             break;
         }
     }

     function runIfPresent(handle) {
         // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
         // So if we're currently running a task, we'll need to delay this invocation.
         if (currentlyRunningATask) {
             // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
             // "too much recursion" error.
             setTimeout(runIfPresent, 0, handle);
         } else {
             var task = tasksByHandle[handle];
             if (task) {
                 currentlyRunningATask = true;
                 try {
                     run(task);
                 } finally {
                     clearImmediate(handle);
                     currentlyRunningATask = false;
                 }
             }
         }
     }

     function installNextTickImplementation() {
         registerImmediate = function(handle) {
             process.nextTick(function () { runIfPresent(handle); });
         };
     }

     function canUsePostMessage() {
         // The test against `importScripts` prevents this implementation from being installed inside a web worker,
         // where `global.postMessage` means something completely different and can't be used for this purpose.
         if (global.postMessage && !global.importScripts) {
             var postMessageIsAsynchronous = true;
             var oldOnMessage = global.onmessage;
             global.onmessage = function() {
                 postMessageIsAsynchronous = false;
             };
             global.postMessage("", "*");
             global.onmessage = oldOnMessage;
             return postMessageIsAsynchronous;
         }
     }

     function installPostMessageImplementation() {
         // Installs an event handler on `global` for the `message` event: see
         // * https://developer.mozilla.org/en/DOM/window.postMessage
         // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

         var messagePrefix = "setImmediate$" + Math.random() + "$";
         var onGlobalMessage = function(event) {
             if (event.source === global &&
                 typeof event.data === "string" &&
                 event.data.indexOf(messagePrefix) === 0) {
                 runIfPresent(+event.data.slice(messagePrefix.length));
             }
         };

         if (global.addEventListener) {
             global.addEventListener("message", onGlobalMessage, false);
         } else {
             global.attachEvent("onmessage", onGlobalMessage);
         }

         registerImmediate = function(handle) {
             global.postMessage(messagePrefix + handle, "*");
         };
     }

     function installMessageChannelImplementation() {
         var channel = new MessageChannel();
         channel.port1.onmessage = function(event) {
             var handle = event.data;
             runIfPresent(handle);
         };

         registerImmediate = function(handle) {
             channel.port2.postMessage(handle);
         };
     }

     function installReadyStateChangeImplementation() {
         var html = doc.documentElement;
         registerImmediate = function(handle) {
             // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
             // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
             var script = doc.createElement("script");
             script.onreadystatechange = function () {
                 runIfPresent(handle);
                 script.onreadystatechange = null;
                 html.removeChild(script);
                 script = null;
             };
             html.appendChild(script);
         };
     }

     function installSetTimeoutImplementation() {
         registerImmediate = function(handle) {
             setTimeout(runIfPresent, 0, handle);
         };
     }

     // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
     var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
     attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

     // Don't get fooled by e.g. browserify environments.
     if ({}.toString.call(global.process) === "[object process]") {
         // For Node.js before 0.9
         installNextTickImplementation();

     } else if (canUsePostMessage()) {
         // For non-IE10 modern browsers
         installPostMessageImplementation();

     } else if (global.MessageChannel) {
         // For web workers, where supported
         installMessageChannelImplementation();

     } else if (doc && "onreadystatechange" in doc.createElement("script")) {
         // For IE 6–8
         installReadyStateChangeImplementation();

     } else {
         // For older browsers
         installSetTimeoutImplementation();
     }

     attachTo.setImmediate = setImmediate;
     attachTo.clearImmediate = clearImmediate;
 }(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

 /* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(69), __webpack_require__(155)))

 /***/ }),
 /* 319 */
 /***/ (function(module, exports, __webpack_require__) {

 /* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
             (typeof self !== "undefined" && self) ||
             window;
 var apply = Function.prototype.apply;

 // DOM APIs, for completeness

 exports.setTimeout = function() {
   return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
 };
 exports.setInterval = function() {
   return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
 };
 exports.clearTimeout =
 exports.clearInterval = function(timeout) {
   if (timeout) {
     timeout.close();
   }
 };

 function Timeout(id, clearFn) {
   this._id = id;
   this._clearFn = clearFn;
 }
 Timeout.prototype.unref = Timeout.prototype.ref = function() {};
 Timeout.prototype.close = function() {
   this._clearFn.call(scope, this._id);
 };

 // Does not start the time, just sets up the members needed.
 exports.enroll = function(item, msecs) {
   clearTimeout(item._idleTimeoutId);
   item._idleTimeout = msecs;
 };

 exports.unenroll = function(item) {
   clearTimeout(item._idleTimeoutId);
   item._idleTimeout = -1;
 };

 exports._unrefActive = exports.active = function(item) {
   clearTimeout(item._idleTimeoutId);

   var msecs = item._idleTimeout;
   if (msecs >= 0) {
     item._idleTimeoutId = setTimeout(function onTimeout() {
       if (item._onTimeout)
         item._onTimeout();
     }, msecs);
   }
 };

 // setimmediate attaches itself to the global object
 __webpack_require__(318);
 // On some exotic environments, it's not clear which object `setimmediate` was
 // able to install onto.  Search each possibility in the same order as the
 // `setimmediate` library.
 exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                        (typeof global !== "undefined" && global.setImmediate) ||
                        (this && this.setImmediate);
 exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                          (typeof global !== "undefined" && global.clearImmediate) ||
                          (this && this.clearImmediate);

 /* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(69)))

 /***/ }),
 /* 320 */
 /***/ (function(module, exports) {

 // `SameValue` abstract operation
 // https://tc39.es/ecma262/#sec-samevalue
 // eslint-disable-next-line es/no-object-is -- safe
 module.exports = Object.is || function is(x, y) {
   // eslint-disable-next-line no-self-compare -- NaN check
   return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
 };


 /***/ }),
 /* 321 */
 /***/ (function(module, exports, __webpack_require__) {

 var userAgent = __webpack_require__(68);

 var webkit = userAgent.match(/AppleWebKit\/(\d+)\./);

 module.exports = !!webkit && +webkit[1];


 /***/ }),
 /* 322 */
 /***/ (function(module, exports, __webpack_require__) {

 var UA = __webpack_require__(68);

 module.exports = /MSIE|Trident/.test(UA);


 /***/ }),
 /* 323 */
 /***/ (function(module, exports, __webpack_require__) {

 var userAgent = __webpack_require__(68);

 var firefox = userAgent.match(/firefox\/(\d+)/i);

 module.exports = !!firefox && +firefox[1];


 /***/ }),
 /* 324 */
 /***/ (function(module, exports, __webpack_require__) {

 "use strict";

 var $ = __webpack_require__(13);
 var uncurryThis = __webpack_require__(5);
 var aCallable = __webpack_require__(57);
 var toObject = __webpack_require__(42);
 var lengthOfArrayLike = __webpack_require__(56);
 var toString = __webpack_require__(28);
 var fails = __webpack_require__(10);
 var internalSort = __webpack_require__(187);
 var arrayMethodIsStrict = __webpack_require__(150);
 var FF = __webpack_require__(323);
 var IE_OR_EDGE = __webpack_require__(322);
 var V8 = __webpack_require__(95);
 var WEBKIT = __webpack_require__(321);

 var test = [];
 var un$Sort = uncurryThis(test.sort);
 var push = uncurryThis(test.push);

 // IE8-
 var FAILS_ON_UNDEFINED = fails(function () {
   test.sort(undefined);
 });
 // V8 bug
 var FAILS_ON_NULL = fails(function () {
   test.sort(null);
 });
 // Old WebKit
 var STRICT_METHOD = arrayMethodIsStrict('sort');

 var STABLE_SORT = !fails(function () {
   // feature detection can be too slow, so check engines versions
   if (V8) return V8 < 70;
   if (FF && FF > 3) return;
   if (IE_OR_EDGE) return true;
   if (WEBKIT) return WEBKIT < 603;

   var result = '';
   var code, chr, value, index;

   // generate an array with more 512 elements (Chakra and old V8 fails only in this case)
   for (code = 65; code < 76; code++) {
     chr = String.fromCharCode(code);

     switch (code) {
       case 66: case 69: case 70: case 72: value = 3; break;
       case 68: case 71: value = 4; break;
       default: value = 2;
     }

     for (index = 0; index < 47; index++) {
       test.push({ k: chr + index, v: value });
     }
   }

   test.sort(function (a, b) { return b.v - a.v; });

   for (index = 0; index < test.length; index++) {
     chr = test[index].k.charAt(0);
     if (result.charAt(result.length - 1) !== chr) result += chr;
   }

   return result !== 'DGBEFHACIJK';
 });

 var FORCED = FAILS_ON_UNDEFINED || !FAILS_ON_NULL || !STRICT_METHOD || !STABLE_SORT;

 var getSortCompare = function (comparefn) {
   return function (x, y) {
     if (y === undefined) return -1;
     if (x === undefined) return 1;
     if (comparefn !== undefined) return +comparefn(x, y) || 0;
     return toString(x) > toString(y) ? 1 : -1;
   };
 };

 // `Array.prototype.sort` method
 // https://tc39.es/ecma262/#sec-array.prototype.sort
 $({ target: 'Array', proto: true, forced: FORCED }, {
   sort: function sort(comparefn) {
     if (comparefn !== undefined) aCallable(comparefn);

     var array = toObject(this);

     if (STABLE_SORT) return comparefn === undefined ? un$Sort(array) : un$Sort(array, comparefn);

     var items = [];
     var arrayLength = lengthOfArrayLike(array);
     var itemsLength, index;

     for (index = 0; index < arrayLength; index++) {
       if (index in array) push(items, array[index]);
     }

     internalSort(items, getSortCompare(comparefn));

     itemsLength = items.length;
     index = 0;

     while (index < itemsLength) array[index] = items[index++];
     while (index < arrayLength) delete array[index++];

     return array;
   }
 });


 /***/ }),
 /* 325 */
 /***/ (function(module, exports, __webpack_require__) {

 var anObject = __webpack_require__(17);
 var iteratorClose = __webpack_require__(216);

 // call something on iterator step with safe closing on error
 module.exports = function (iterator, fn, value, ENTRIES) {
   try {
     return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
   } catch (error) {
     iteratorClose(iterator, 'throw', error);
   }
 };


 /***/ }),
 /* 326 */
 /***/ (function(module, exports, __webpack_require__) {

 "use strict";

 var global = __webpack_require__(2);
 var bind = __webpack_require__(64);
 var call = __webpack_require__(22);
 var toObject = __webpack_require__(42);
 var callWithSafeIterationClosing = __webpack_require__(325);
 var isArrayIteratorMethod = __webpack_require__(217);
 var isConstructor = __webpack_require__(107);
 var lengthOfArrayLike = __webpack_require__(56);
 var createProperty = __webpack_require__(126);
 var getIterator = __webpack_require__(161);
 var getIteratorMethod = __webpack_require__(135);

 var Array = global.Array;

 // `Array.from` method implementation
 // https://tc39.es/ecma262/#sec-array.from
 module.exports = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
   var O = toObject(arrayLike);
   var IS_CONSTRUCTOR = isConstructor(this);
   var argumentsLength = arguments.length;
   var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
   var mapping = mapfn !== undefined;
   if (mapping) mapfn = bind(mapfn, argumentsLength > 2 ? arguments[2] : undefined);
   var iteratorMethod = getIteratorMethod(O);
   var index = 0;
   var length, result, step, iterator, next, value;
   // if the target is not iterable or it's an array with the default iterator - use a simple case
   if (iteratorMethod && !(this == Array && isArrayIteratorMethod(iteratorMethod))) {
     iterator = getIterator(O, iteratorMethod);
     next = iterator.next;
     result = IS_CONSTRUCTOR ? new this() : [];
     for (;!(step = call(next, iterator)).done; index++) {
       value = mapping ? callWithSafeIterationClosing(iterator, mapfn, [step.value, index], true) : step.value;
       createProperty(result, index, value);
     }
   } else {
     length = lengthOfArrayLike(O);
     result = IS_CONSTRUCTOR ? new this(length) : Array(length);
     for (;length > index; index++) {
       value = mapping ? mapfn(O[index], index) : O[index];
       createProperty(result, index, value);
     }
   }
   result.length = index;
   return result;
 };


 /***/ }),
 /* 327 */
 /***/ (function(module, exports, __webpack_require__) {

 var global = __webpack_require__(2);

 module.exports = global;


 /***/ }),
 /* 328 */
 /***/ (function(module, exports, __webpack_require__) {

 "use strict";


 var utils = __webpack_require__(191);

 var has = Object.prototype.hasOwnProperty;
 var isArray = Array.isArray;

 var defaults = {
     allowDots: false,
     allowPrototypes: false,
     allowSparse: false,
     arrayLimit: 20,
     charset: 'utf-8',
     charsetSentinel: false,
     comma: false,
     decoder: utils.decode,
     delimiter: '&',
     depth: 5,
     ignoreQueryPrefix: false,
     interpretNumericEntities: false,
     parameterLimit: 1000,
     parseArrays: true,
     plainObjects: false,
     strictNullHandling: false
 };

 var interpretNumericEntities = function (str) {
     return str.replace(/&#(\d+);/g, function ($0, numberStr) {
         return String.fromCharCode(parseInt(numberStr, 10));
     });
 };

 var parseArrayValue = function (val, options) {
     if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) {
         return val.split(',');
     }

     return val;
 };

 // This is what browsers will submit when the ✓ character occurs in an
 // application/x-www-form-urlencoded body and the encoding of the page containing
 // the form is iso-8859-1, or when the submitted form has an accept-charset
 // attribute of iso-8859-1. Presumably also with other charsets that do not contain
 // the ✓ character, such as us-ascii.
 var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')

 // These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
 var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')

 var parseValues = function parseQueryStringValues(str, options) {
     var obj = {};
     var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
     var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
     var parts = cleanStr.split(options.delimiter, limit);
     var skipIndex = -1; // Keep track of where the utf8 sentinel was found
     var i;

     var charset = options.charset;
     if (options.charsetSentinel) {
         for (i = 0; i < parts.length; ++i) {
             if (parts[i].indexOf('utf8=') === 0) {
                 if (parts[i] === charsetSentinel) {
                     charset = 'utf-8';
                 } else if (parts[i] === isoSentinel) {
                     charset = 'iso-8859-1';
                 }
                 skipIndex = i;
                 i = parts.length; // The eslint settings do not allow break;
             }
         }
     }

     for (i = 0; i < parts.length; ++i) {
         if (i === skipIndex) {
             continue;
         }
         var part = parts[i];

         var bracketEqualsPos = part.indexOf(']=');
         var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;

         var key, val;
         if (pos === -1) {
             key = options.decoder(part, defaults.decoder, charset, 'key');
             val = options.strictNullHandling ? null : '';
         } else {
             key = options.decoder(part.slice(0, pos), defaults.decoder, charset, 'key');
             val = utils.maybeMap(
                 parseArrayValue(part.slice(pos + 1), options),
                 function (encodedVal) {
                     return options.decoder(encodedVal, defaults.decoder, charset, 'value');
                 }
             );
         }

         if (val && options.interpretNumericEntities && charset === 'iso-8859-1') {
             val = interpretNumericEntities(val);
         }

         if (part.indexOf('[]=') > -1) {
             val = isArray(val) ? [val] : val;
         }

         if (has.call(obj, key)) {
             obj[key] = utils.combine(obj[key], val);
         } else {
             obj[key] = val;
         }
     }

     return obj;
 };

 var parseObject = function (chain, val, options, valuesParsed) {
     var leaf = valuesParsed ? val : parseArrayValue(val, options);

     for (var i = chain.length - 1; i >= 0; --i) {
         var obj;
         var root = chain[i];

         if (root === '[]' && options.parseArrays) {
             obj = [].concat(leaf);
         } else {
             obj = options.plainObjects ? Object.create(null) : {};
             var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
             var index = parseInt(cleanRoot, 10);
             if (!options.parseArrays && cleanRoot === '') {
                 obj = { 0: leaf };
             } else if (
                 !isNaN(index)
                 && root !== cleanRoot
                 && String(index) === cleanRoot
                 && index >= 0
                 && (options.parseArrays && index <= options.arrayLimit)
             ) {
                 obj = [];
                 obj[index] = leaf;
             } else {
                 obj[cleanRoot] = leaf;
             }
         }

         leaf = obj;
     }

     return leaf;
 };

 var parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
     if (!givenKey) {
         return;
     }

     // Transform dot notation to bracket notation
     var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;

     // The regex chunks

     var brackets = /(\[[^[\]]*])/;
     var child = /(\[[^[\]]*])/g;

     // Get the parent

     var segment = options.depth > 0 && brackets.exec(key);
     var parent = segment ? key.slice(0, segment.index) : key;

     // Stash the parent if it exists

     var keys = [];
     if (parent) {
         // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
         if (!options.plainObjects && has.call(Object.prototype, parent)) {
             if (!options.allowPrototypes) {
                 return;
             }
         }

         keys.push(parent);
     }

     // Loop through children appending to the array until we hit depth

     var i = 0;
     while (options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth) {
         i += 1;
         if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
             if (!options.allowPrototypes) {
                 return;
             }
         }
         keys.push(segment[1]);
     }

     // If there's a remainder, just add whatever is left

     if (segment) {
         keys.push('[' + key.slice(segment.index) + ']');
     }

     return parseObject(keys, val, options, valuesParsed);
 };

 var normalizeParseOptions = function normalizeParseOptions(opts) {
     if (!opts) {
         return defaults;
     }

     if (opts.decoder !== null && opts.decoder !== undefined && typeof opts.decoder !== 'function') {
         throw new TypeError('Decoder has to be a function.');
     }

     if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
         throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
     }
     var charset = typeof opts.charset === 'undefined' ? defaults.charset : opts.charset;

     return {
         allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
         allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : defaults.allowPrototypes,
         allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : defaults.allowSparse,
         arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : defaults.arrayLimit,
         charset: charset,
         charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
         comma: typeof opts.comma === 'boolean' ? opts.comma : defaults.comma,
         decoder: typeof opts.decoder === 'function' ? opts.decoder : defaults.decoder,
         delimiter: typeof opts.delimiter === 'string' || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
         // eslint-disable-next-line no-implicit-coercion, no-extra-parens
         depth: (typeof opts.depth === 'number' || opts.depth === false) ? +opts.depth : defaults.depth,
         ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
         interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
         parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : defaults.parameterLimit,
         parseArrays: opts.parseArrays !== false,
         plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : defaults.plainObjects,
         strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
     };
 };

 module.exports = function (str, opts) {
     var options = normalizeParseOptions(opts);

     if (str === '' || str === null || typeof str === 'undefined') {
         return options.plainObjects ? Object.create(null) : {};
     }

     var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
     var obj = options.plainObjects ? Object.create(null) : {};

     // Iterate over the keys and setup the new object

     var keys = Object.keys(tempObj);
     for (var i = 0; i < keys.length; ++i) {
         var key = keys[i];
         var newObj = parseKeys(key, tempObj[key], options, typeof str === 'string');
         obj = utils.merge(obj, newObj, options);
     }

     if (options.allowSparse === true) {
         return obj;
     }

     return utils.compact(obj);
 };


 /***/ }),
 /* 329 */
 /***/ (function(module, exports) {

 /* (ignored) */

 /***/ }),
 /* 330 */
 /***/ (function(module, exports, __webpack_require__) {

 var hasMap = typeof Map === 'function' && Map.prototype;
 var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
 var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === 'function' ? mapSizeDescriptor.get : null;
 var mapForEach = hasMap && Map.prototype.forEach;
 var hasSet = typeof Set === 'function' && Set.prototype;
 var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
 var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === 'function' ? setSizeDescriptor.get : null;
 var setForEach = hasSet && Set.prototype.forEach;
 var hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
 var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
 var hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
 var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
 var hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
 var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
 var booleanValueOf = Boolean.prototype.valueOf;
 var objectToString = Object.prototype.toString;
 var functionToString = Function.prototype.toString;
 var match = String.prototype.match;
 var bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
 var gOPS = Object.getOwnPropertySymbols;
 var symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
 var hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
 var isEnumerable = Object.prototype.propertyIsEnumerable;

 var gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || (
     [].__proto__ === Array.prototype // eslint-disable-line no-proto
         ? function (O) {
             return O.__proto__; // eslint-disable-line no-proto
         }
         : null
 );

 var inspectCustom = __webpack_require__(329).custom;
 var inspectSymbol = inspectCustom && isSymbol(inspectCustom) ? inspectCustom : null;
 var toStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag !== 'undefined' ? Symbol.toStringTag : null;

 module.exports = function inspect_(obj, options, depth, seen) {
     var opts = options || {};

     if (has(opts, 'quoteStyle') && (opts.quoteStyle !== 'single' && opts.quoteStyle !== 'double')) {
         throw new TypeError('option "quoteStyle" must be "single" or "double"');
     }
     if (
         has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number'
             ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity
             : opts.maxStringLength !== null
         )
     ) {
         throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
     }
     var customInspect = has(opts, 'customInspect') ? opts.customInspect : true;
     if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') {
         throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
     }

     if (
         has(opts, 'indent')
         && opts.indent !== null
         && opts.indent !== '\t'
         && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)
     ) {
         throw new TypeError('options "indent" must be "\\t", an integer > 0, or `null`');
     }

     if (typeof obj === 'undefined') {
         return 'undefined';
     }
     if (obj === null) {
         return 'null';
     }
     if (typeof obj === 'boolean') {
         return obj ? 'true' : 'false';
     }

     if (typeof obj === 'string') {
         return inspectString(obj, opts);
     }
     if (typeof obj === 'number') {
         if (obj === 0) {
             return Infinity / obj > 0 ? '0' : '-0';
         }
         return String(obj);
     }
     if (typeof obj === 'bigint') {
         return String(obj) + 'n';
     }

     var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
     if (typeof depth === 'undefined') { depth = 0; }
     if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') {
         return isArray(obj) ? '[Array]' : '[Object]';
     }

     var indent = getIndent(opts, depth);

     if (typeof seen === 'undefined') {
         seen = [];
     } else if (indexOf(seen, obj) >= 0) {
         return '[Circular]';
     }

     function inspect(value, from, noIndent) {
         if (from) {
             seen = seen.slice();
             seen.push(from);
         }
         if (noIndent) {
             var newOpts = {
                 depth: opts.depth
             };
             if (has(opts, 'quoteStyle')) {
                 newOpts.quoteStyle = opts.quoteStyle;
             }
             return inspect_(value, newOpts, depth + 1, seen);
         }
         return inspect_(value, opts, depth + 1, seen);
     }

     if (typeof obj === 'function') {
         var name = nameOf(obj);
         var keys = arrObjKeys(obj, inspect);
         return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + keys.join(', ') + ' }' : '');
     }
     if (isSymbol(obj)) {
         var symString = hasShammedSymbols ? String(obj).replace(/^(Symbol\(.*\))_[^)]*$/, '$1') : symToString.call(obj);
         return typeof obj === 'object' && !hasShammedSymbols ? markBoxed(symString) : symString;
     }
     if (isElement(obj)) {
         var s = '<' + String(obj.nodeName).toLowerCase();
         var attrs = obj.attributes || [];
         for (var i = 0; i < attrs.length; i++) {
             s += ' ' + attrs[i].name + '=' + wrapQuotes(quote(attrs[i].value), 'double', opts);
         }
         s += '>';
         if (obj.childNodes && obj.childNodes.length) { s += '...'; }
         s += '</' + String(obj.nodeName).toLowerCase() + '>';
         return s;
     }
     if (isArray(obj)) {
         if (obj.length === 0) { return '[]'; }
         var xs = arrObjKeys(obj, inspect);
         if (indent && !singleLineValues(xs)) {
             return '[' + indentedJoin(xs, indent) + ']';
         }
         return '[ ' + xs.join(', ') + ' ]';
     }
     if (isError(obj)) {
         var parts = arrObjKeys(obj, inspect);
         if (parts.length === 0) { return '[' + String(obj) + ']'; }
         return '{ [' + String(obj) + '] ' + parts.join(', ') + ' }';
     }
     if (typeof obj === 'object' && customInspect) {
         if (inspectSymbol && typeof obj[inspectSymbol] === 'function') {
             return obj[inspectSymbol]();
         } else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') {
             return obj.inspect();
         }
     }
     if (isMap(obj)) {
         var mapParts = [];
         mapForEach.call(obj, function (value, key) {
             mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
         });
         return collectionOf('Map', mapSize.call(obj), mapParts, indent);
     }
     if (isSet(obj)) {
         var setParts = [];
         setForEach.call(obj, function (value) {
             setParts.push(inspect(value, obj));
         });
         return collectionOf('Set', setSize.call(obj), setParts, indent);
     }
     if (isWeakMap(obj)) {
         return weakCollectionOf('WeakMap');
     }
     if (isWeakSet(obj)) {
         return weakCollectionOf('WeakSet');
     }
     if (isWeakRef(obj)) {
         return weakCollectionOf('WeakRef');
     }
     if (isNumber(obj)) {
         return markBoxed(inspect(Number(obj)));
     }
     if (isBigInt(obj)) {
         return markBoxed(inspect(bigIntValueOf.call(obj)));
     }
     if (isBoolean(obj)) {
         return markBoxed(booleanValueOf.call(obj));
     }
     if (isString(obj)) {
         return markBoxed(inspect(String(obj)));
     }
     if (!isDate(obj) && !isRegExp(obj)) {
         var ys = arrObjKeys(obj, inspect);
         var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
         var protoTag = obj instanceof Object ? '' : 'null prototype';
         var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? toStr(obj).slice(8, -1) : protoTag ? 'Object' : '';
         var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
         var tag = constructorTag + (stringTag || protoTag ? '[' + [].concat(stringTag || [], protoTag || []).join(': ') + '] ' : '');
         if (ys.length === 0) { return tag + '{}'; }
         if (indent) {
             return tag + '{' + indentedJoin(ys, indent) + '}';
         }
         return tag + '{ ' + ys.join(', ') + ' }';
     }
     return String(obj);
 };

 function wrapQuotes(s, defaultStyle, opts) {
     var quoteChar = (opts.quoteStyle || defaultStyle) === 'double' ? '"' : "'";
     return quoteChar + s + quoteChar;
 }

 function quote(s) {
     return String(s).replace(/"/g, '&quot;');
 }

 function isArray(obj) { return toStr(obj) === '[object Array]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
 function isDate(obj) { return toStr(obj) === '[object Date]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
 function isRegExp(obj) { return toStr(obj) === '[object RegExp]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
 function isError(obj) { return toStr(obj) === '[object Error]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
 function isString(obj) { return toStr(obj) === '[object String]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
 function isNumber(obj) { return toStr(obj) === '[object Number]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
 function isBoolean(obj) { return toStr(obj) === '[object Boolean]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }

 // Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
 function isSymbol(obj) {
     if (hasShammedSymbols) {
         return obj && typeof obj === 'object' && obj instanceof Symbol;
     }
     if (typeof obj === 'symbol') {
         return true;
     }
     if (!obj || typeof obj !== 'object' || !symToString) {
         return false;
     }
     try {
         symToString.call(obj);
         return true;
     } catch (e) {}
     return false;
 }

 function isBigInt(obj) {
     if (!obj || typeof obj !== 'object' || !bigIntValueOf) {
         return false;
     }
     try {
         bigIntValueOf.call(obj);
         return true;
     } catch (e) {}
     return false;
 }

 var hasOwn = Object.prototype.hasOwnProperty || function (key) { return key in this; };
 function has(obj, key) {
     return hasOwn.call(obj, key);
 }

 function toStr(obj) {
     return objectToString.call(obj);
 }

 function nameOf(f) {
     if (f.name) { return f.name; }
     var m = match.call(functionToString.call(f), /^function\s*([\w$]+)/);
     if (m) { return m[1]; }
     return null;
 }

 function indexOf(xs, x) {
     if (xs.indexOf) { return xs.indexOf(x); }
     for (var i = 0, l = xs.length; i < l; i++) {
         if (xs[i] === x) { return i; }
     }
     return -1;
 }

 function isMap(x) {
     if (!mapSize || !x || typeof x !== 'object') {
         return false;
     }
     try {
         mapSize.call(x);
         try {
             setSize.call(x);
         } catch (s) {
             return true;
         }
         return x instanceof Map; // core-js workaround, pre-v2.5.0
     } catch (e) {}
     return false;
 }

 function isWeakMap(x) {
     if (!weakMapHas || !x || typeof x !== 'object') {
         return false;
     }
     try {
         weakMapHas.call(x, weakMapHas);
         try {
             weakSetHas.call(x, weakSetHas);
         } catch (s) {
             return true;
         }
         return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
     } catch (e) {}
     return false;
 }

 function isWeakRef(x) {
     if (!weakRefDeref || !x || typeof x !== 'object') {
         return false;
     }
     try {
         weakRefDeref.call(x);
         return true;
     } catch (e) {}
     return false;
 }

 function isSet(x) {
     if (!setSize || !x || typeof x !== 'object') {
         return false;
     }
     try {
         setSize.call(x);
         try {
             mapSize.call(x);
         } catch (m) {
             return true;
         }
         return x instanceof Set; // core-js workaround, pre-v2.5.0
     } catch (e) {}
     return false;
 }

 function isWeakSet(x) {
     if (!weakSetHas || !x || typeof x !== 'object') {
         return false;
     }
     try {
         weakSetHas.call(x, weakSetHas);
         try {
             weakMapHas.call(x, weakMapHas);
         } catch (s) {
             return true;
         }
         return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
     } catch (e) {}
     return false;
 }

 function isElement(x) {
     if (!x || typeof x !== 'object') { return false; }
     if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) {
         return true;
     }
     return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
 }

 function inspectString(str, opts) {
     if (str.length > opts.maxStringLength) {
         var remaining = str.length - opts.maxStringLength;
         var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
         return inspectString(str.slice(0, opts.maxStringLength), opts) + trailer;
     }
     // eslint-disable-next-line no-control-regex
     var s = str.replace(/(['\\])/g, '\\$1').replace(/[\x00-\x1f]/g, lowbyte);
     return wrapQuotes(s, 'single', opts);
 }

 function lowbyte(c) {
     var n = c.charCodeAt(0);
     var x = {
         8: 'b',
         9: 't',
         10: 'n',
         12: 'f',
         13: 'r'
     }[n];
     if (x) { return '\\' + x; }
     return '\\x' + (n < 0x10 ? '0' : '') + n.toString(16).toUpperCase();
 }

 function markBoxed(str) {
     return 'Object(' + str + ')';
 }

 function weakCollectionOf(type) {
     return type + ' { ? }';
 }

 function collectionOf(type, size, entries, indent) {
     var joinedEntries = indent ? indentedJoin(entries, indent) : entries.join(', ');
     return type + ' (' + size + ') {' + joinedEntries + '}';
 }

 function singleLineValues(xs) {
     for (var i = 0; i < xs.length; i++) {
         if (indexOf(xs[i], '\n') >= 0) {
             return false;
         }
     }
     return true;
 }

 function getIndent(opts, depth) {
     var baseIndent;
     if (opts.indent === '\t') {
         baseIndent = '\t';
     } else if (typeof opts.indent === 'number' && opts.indent > 0) {
         baseIndent = Array(opts.indent + 1).join(' ');
     } else {
         return null;
     }
     return {
         base: baseIndent,
         prev: Array(depth + 1).join(baseIndent)
     };
 }

 function indentedJoin(xs, indent) {
     if (xs.length === 0) { return ''; }
     var lineJoiner = '\n' + indent.prev + indent.base;
     return lineJoiner + xs.join(',' + lineJoiner) + '\n' + indent.prev;
 }

 function arrObjKeys(obj, inspect) {
     var isArr = isArray(obj);
     var xs = [];
     if (isArr) {
         xs.length = obj.length;
         for (var i = 0; i < obj.length; i++) {
             xs[i] = has(obj, i) ? inspect(obj[i], obj) : '';
         }
     }
     var syms = typeof gOPS === 'function' ? gOPS(obj) : [];
     var symMap;
     if (hasShammedSymbols) {
         symMap = {};
         for (var k = 0; k < syms.length; k++) {
             symMap['$' + syms[k]] = syms[k];
         }
     }

     for (var key in obj) { // eslint-disable-line no-restricted-syntax
         if (!has(obj, key)) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
         if (isArr && String(Number(key)) === key && key < obj.length) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
         if (hasShammedSymbols && symMap['$' + key] instanceof Symbol) {
             // this is to prevent shammed Symbols, which are stored as strings, from being included in the string key section
             continue; // eslint-disable-line no-restricted-syntax, no-continue
         } else if ((/[^\w$]/).test(key)) {
             xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
         } else {
             xs.push(key + ': ' + inspect(obj[key], obj));
         }
     }
     if (typeof gOPS === 'function') {
         for (var j = 0; j < syms.length; j++) {
             if (isEnumerable.call(obj, syms[j])) {
                 xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
             }
         }
     }
     return xs;
 }


 /***/ }),
 /* 331 */
 /***/ (function(module, exports, __webpack_require__) {

 "use strict";


 var bind = __webpack_require__(148);
 var GetIntrinsic = __webpack_require__(149);

 var $apply = GetIntrinsic('%Function.prototype.apply%');
 var $call = GetIntrinsic('%Function.prototype.call%');
 var $reflectApply = GetIntrinsic('%Reflect.apply%', true) || bind.call($call, $apply);

 var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);
 var $defineProperty = GetIntrinsic('%Object.defineProperty%', true);
 var $max = GetIntrinsic('%Math.max%');

 if ($defineProperty) {
   try {
     $defineProperty({}, 'a', { value: 1 });
   } catch (e) {
     // IE 8 has a broken defineProperty
     $defineProperty = null;
   }
 }

 module.exports = function callBind(originalFunction) {
   var func = $reflectApply(bind, $call, arguments);
   if ($gOPD && $defineProperty) {
     var desc = $gOPD(func, 'length');
     if (desc.configurable) {
       // original length, plus the receiver, minus any additional arguments (after the receiver)
       $defineProperty(
         func,
         'length',
         { value: 1 + $max(0, originalFunction.length - (arguments.length - 1)) }
       );
     }
   }
   return func;
 };

 var applyBind = function applyBind() {
   return $reflectApply(bind, $apply, arguments);
 };

 if ($defineProperty) {
   $defineProperty(module.exports, 'apply', { value: applyBind });
 } else {
   module.exports.apply = applyBind;
 }


 /***/ }),
 /* 332 */
 /***/ (function(module, exports, __webpack_require__) {

 "use strict";


 var GetIntrinsic = __webpack_require__(149);

 var callBind = __webpack_require__(331);

 var $indexOf = callBind(GetIntrinsic('String.prototype.indexOf'));

 module.exports = function callBoundIntrinsic(name, allowMissing) {
   var intrinsic = GetIntrinsic(name, !!allowMissing);
   if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
     return callBind(intrinsic);
   }
   return intrinsic;
 };


 /***/ }),
 /* 333 */
 /***/ (function(module, exports, __webpack_require__) {

 "use strict";


 var bind = __webpack_require__(148);

 module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);


 /***/ }),
 /* 334 */
 /***/ (function(module, exports, __webpack_require__) {

 "use strict";


 /* eslint no-invalid-this: 1 */

 var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
 var slice = Array.prototype.slice;
 var toStr = Object.prototype.toString;
 var funcType = '[object Function]';

 module.exports = function bind(that) {
     var target = this;
     if (typeof target !== 'function' || toStr.call(target) !== funcType) {
         throw new TypeError(ERROR_MESSAGE + target);
     }
     var args = slice.call(arguments, 1);

     var bound;
     var binder = function () {
         if (this instanceof bound) {
             var result = target.apply(
                 this,
                 args.concat(slice.call(arguments))
             );
             if (Object(result) === result) {
                 return result;
             }
             return this;
         } else {
             return target.apply(
                 that,
                 args.concat(slice.call(arguments))
             );
         }
     };

     var boundLength = Math.max(0, target.length - args.length);
     var boundArgs = [];
     for (var i = 0; i < boundLength; i++) {
         boundArgs.push('$' + i);
     }

     bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);

     if (target.prototype) {
         var Empty = function Empty() {};
         Empty.prototype = target.prototype;
         bound.prototype = new Empty();
         Empty.prototype = null;
     }

     return bound;
 };


 /***/ }),
 /* 335 */
 /***/ (function(module, exports, __webpack_require__) {

 "use strict";


 /* eslint complexity: [2, 18], max-statements: [2, 33] */
 module.exports = function hasSymbols() {
   if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
   if (typeof Symbol.iterator === 'symbol') { return true; }

   var obj = {};
   var sym = Symbol('test');
   var symObj = Object(sym);
   if (typeof sym === 'string') { return false; }

   if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
   if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

   // temp disabled per https://github.com/ljharb/object.assign/issues/17
   // if (sym instanceof Symbol) { return false; }
   // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
   // if (!(symObj instanceof Symbol)) { return false; }

   // if (typeof Symbol.prototype.toString !== 'function') { return false; }
   // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

   var symVal = 42;
   obj[sym] = symVal;
   for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
   if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

   if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

   var syms = Object.getOwnPropertySymbols(obj);
   if (syms.length !== 1 || syms[0] !== sym) { return false; }

   if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

   if (typeof Object.getOwnPropertyDescriptor === 'function') {
     var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
     if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
   }

   return true;
 };


 /***/ }),
 /* 336 */
 /***/ (function(module, exports, __webpack_require__) {

 "use strict";


 var origSymbol = typeof Symbol !== 'undefined' && Symbol;
 var hasSymbolSham = __webpack_require__(335);

 module.exports = function hasNativeSymbols() {
   if (typeof origSymbol !== 'function') { return false; }
   if (typeof Symbol !== 'function') { return false; }
   if (typeof origSymbol('foo') !== 'symbol') { return false; }
   if (typeof Symbol('bar') !== 'symbol') { return false; }

   return hasSymbolSham();
 };


 /***/ }),
 /* 337 */
 /***/ (function(module, exports, __webpack_require__) {

 "use strict";


 var GetIntrinsic = __webpack_require__(149);
 var callBound = __webpack_require__(332);
 var inspect = __webpack_require__(330);

 var $TypeError = GetIntrinsic('%TypeError%');
 var $WeakMap = GetIntrinsic('%WeakMap%', true);
 var $Map = GetIntrinsic('%Map%', true);

 var $weakMapGet = callBound('WeakMap.prototype.get', true);
 var $weakMapSet = callBound('WeakMap.prototype.set', true);
 var $weakMapHas = callBound('WeakMap.prototype.has', true);
 var $mapGet = callBound('Map.prototype.get', true);
 var $mapSet = callBound('Map.prototype.set', true);
 var $mapHas = callBound('Map.prototype.has', true);

 /*
  * This function traverses the list returning the node corresponding to the
  * given key.
  *
  * That node is also moved to the head of the list, so that if it's accessed
  * again we don't need to traverse the whole list. By doing so, all the recently
  * used nodes can be accessed relatively quickly.
  */
 var listGetNode = function (list, key) { // eslint-disable-line consistent-return
   for (var prev = list, curr; (curr = prev.next) !== null; prev = curr) {
     if (curr.key === key) {
       prev.next = curr.next;
       curr.next = list.next;
       list.next = curr; // eslint-disable-line no-param-reassign
       return curr;
     }
   }
 };

 var listGet = function (objects, key) {
   var node = listGetNode(objects, key);
   return node && node.value;
 };
 var listSet = function (objects, key, value) {
   var node = listGetNode(objects, key);
   if (node) {
     node.value = value;
   } else {
     // Prepend the new node to the beginning of the list
     objects.next = { // eslint-disable-line no-param-reassign
       key: key,
       next: objects.next,
       value: value
     };
   }
 };
 var listHas = function (objects, key) {
   return !!listGetNode(objects, key);
 };

 module.exports = function getSideChannel() {
   var $wm;
   var $m;
   var $o;
   var channel = {
     assert: function (key) {
       if (!channel.has(key)) {
         throw new $TypeError('Side channel does not contain ' + inspect(key));
       }
     },
     get: function (key) { // eslint-disable-line consistent-return
       if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
         if ($wm) {
           return $weakMapGet($wm, key);
         }
       } else if ($Map) {
         if ($m) {
           return $mapGet($m, key);
         }
       } else {
         if ($o) { // eslint-disable-line no-lonely-if
           return listGet($o, key);
         }
       }
     },
     has: function (key) {
       if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
         if ($wm) {
           return $weakMapHas($wm, key);
         }
       } else if ($Map) {
         if ($m) {
           return $mapHas($m, key);
         }
       } else {
         if ($o) { // eslint-disable-line no-lonely-if
           return listHas($o, key);
         }
       }
       return false;
     },
     set: function (key, value) {
       if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
         if (!$wm) {
           $wm = new $WeakMap();
         }
         $weakMapSet($wm, key, value);
       } else if ($Map) {
         if (!$m) {
           $m = new $Map();
         }
         $mapSet($m, key, value);
       } else {
         if (!$o) {
           /*
            * Initialize the linked list as an empty node, so that we don't have
            * to special-case handling of the first node: we can always refer to
            * it as (previous node).next, instead of something like (list).head
            */
           $o = { key: {}, next: null };
         }
         listSet($o, key, value);
       }
     }
   };
   return channel;
 };


 /***/ }),
 /* 338 */
 /***/ (function(module, exports, __webpack_require__) {

 "use strict";


 var getSideChannel = __webpack_require__(337);
 var utils = __webpack_require__(191);
 var formats = __webpack_require__(147);
 var has = Object.prototype.hasOwnProperty;

 var arrayPrefixGenerators = {
     brackets: function brackets(prefix) {
         return prefix + '[]';
     },
     comma: 'comma',
     indices: function indices(prefix, key) {
         return prefix + '[' + key + ']';
     },
     repeat: function repeat(prefix) {
         return prefix;
     }
 };

 var isArray = Array.isArray;
 var push = Array.prototype.push;
 var pushToArray = function (arr, valueOrArray) {
     push.apply(arr, isArray(valueOrArray) ? valueOrArray : [valueOrArray]);
 };

 var toISO = Date.prototype.toISOString;

 var defaultFormat = formats['default'];
 var defaults = {
     addQueryPrefix: false,
     allowDots: false,
     charset: 'utf-8',
     charsetSentinel: false,
     delimiter: '&',
     encode: true,
     encoder: utils.encode,
     encodeValuesOnly: false,
     format: defaultFormat,
     formatter: formats.formatters[defaultFormat],
     // deprecated
     indices: false,
     serializeDate: function serializeDate(date) {
         return toISO.call(date);
     },
     skipNulls: false,
     strictNullHandling: false
 };

 var isNonNullishPrimitive = function isNonNullishPrimitive(v) {
     return typeof v === 'string'
         || typeof v === 'number'
         || typeof v === 'boolean'
         || typeof v === 'symbol'
         || typeof v === 'bigint';
 };

 var stringify = function stringify(
     object,
     prefix,
     generateArrayPrefix,
     strictNullHandling,
     skipNulls,
     encoder,
     filter,
     sort,
     allowDots,
     serializeDate,
     format,
     formatter,
     encodeValuesOnly,
     charset,
     sideChannel
 ) {
     var obj = object;

     if (sideChannel.has(object)) {
         throw new RangeError('Cyclic object value');
     }

     if (typeof filter === 'function') {
         obj = filter(prefix, obj);
     } else if (obj instanceof Date) {
         obj = serializeDate(obj);
     } else if (generateArrayPrefix === 'comma' && isArray(obj)) {
         obj = utils.maybeMap(obj, function (value) {
             if (value instanceof Date) {
                 return serializeDate(value);
             }
             return value;
         });
     }

     if (obj === null) {
         if (strictNullHandling) {
             return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder, charset, 'key', format) : prefix;
         }

         obj = '';
     }

     if (isNonNullishPrimitive(obj) || utils.isBuffer(obj)) {
         if (encoder) {
             var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder, charset, 'key', format);
             return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder, charset, 'value', format))];
         }
         return [formatter(prefix) + '=' + formatter(String(obj))];
     }

     var values = [];

     if (typeof obj === 'undefined') {
         return values;
     }

     var objKeys;
     if (generateArrayPrefix === 'comma' && isArray(obj)) {
         // we need to join elements in
         objKeys = [{ value: obj.length > 0 ? obj.join(',') || null : undefined }];
     } else if (isArray(filter)) {
         objKeys = filter;
     } else {
         var keys = Object.keys(obj);
         objKeys = sort ? keys.sort(sort) : keys;
     }

     for (var i = 0; i < objKeys.length; ++i) {
         var key = objKeys[i];
         var value = typeof key === 'object' && key.value !== undefined ? key.value : obj[key];

         if (skipNulls && value === null) {
             continue;
         }

         var keyPrefix = isArray(obj)
             ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(prefix, key) : prefix
             : prefix + (allowDots ? '.' + key : '[' + key + ']');

         sideChannel.set(object, true);
         var valueSideChannel = getSideChannel();
         pushToArray(values, stringify(
             value,
             keyPrefix,
             generateArrayPrefix,
             strictNullHandling,
             skipNulls,
             encoder,
             filter,
             sort,
             allowDots,
             serializeDate,
             format,
             formatter,
             encodeValuesOnly,
             charset,
             valueSideChannel
         ));
     }

     return values;
 };

 var normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
     if (!opts) {
         return defaults;
     }

     if (opts.encoder !== null && opts.encoder !== undefined && typeof opts.encoder !== 'function') {
         throw new TypeError('Encoder has to be a function.');
     }

     var charset = opts.charset || defaults.charset;
     if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
         throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
     }

     var format = formats['default'];
     if (typeof opts.format !== 'undefined') {
         if (!has.call(formats.formatters, opts.format)) {
             throw new TypeError('Unknown format option provided.');
         }
         format = opts.format;
     }
     var formatter = formats.formatters[format];

     var filter = defaults.filter;
     if (typeof opts.filter === 'function' || isArray(opts.filter)) {
         filter = opts.filter;
     }

     return {
         addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : defaults.addQueryPrefix,
         allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
         charset: charset,
         charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
         delimiter: typeof opts.delimiter === 'undefined' ? defaults.delimiter : opts.delimiter,
         encode: typeof opts.encode === 'boolean' ? opts.encode : defaults.encode,
         encoder: typeof opts.encoder === 'function' ? opts.encoder : defaults.encoder,
         encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : defaults.encodeValuesOnly,
         filter: filter,
         format: format,
         formatter: formatter,
         serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : defaults.serializeDate,
         skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : defaults.skipNulls,
         sort: typeof opts.sort === 'function' ? opts.sort : null,
         strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
     };
 };

 module.exports = function (object, opts) {
     var obj = object;
     var options = normalizeStringifyOptions(opts);

     var objKeys;
     var filter;

     if (typeof options.filter === 'function') {
         filter = options.filter;
         obj = filter('', obj);
     } else if (isArray(options.filter)) {
         filter = options.filter;
         objKeys = filter;
     }

     var keys = [];

     if (typeof obj !== 'object' || obj === null) {
         return '';
     }

     var arrayFormat;
     if (opts && opts.arrayFormat in arrayPrefixGenerators) {
         arrayFormat = opts.arrayFormat;
     } else if (opts && 'indices' in opts) {
         arrayFormat = opts.indices ? 'indices' : 'repeat';
     } else {
         arrayFormat = 'indices';
     }

     var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];

     if (!objKeys) {
         objKeys = Object.keys(obj);
     }

     if (options.sort) {
         objKeys.sort(options.sort);
     }

     var sideChannel = getSideChannel();
     for (var i = 0; i < objKeys.length; ++i) {
         var key = objKeys[i];

         if (options.skipNulls && obj[key] === null) {
             continue;
         }
         pushToArray(keys, stringify(
             obj[key],
             key,
             generateArrayPrefix,
             options.strictNullHandling,
             options.skipNulls,
             options.encode ? options.encoder : null,
             options.filter,
             options.sort,
             options.allowDots,
             options.serializeDate,
             options.format,
             options.formatter,
             options.encodeValuesOnly,
             options.charset,
             sideChannel
         ));
     }

     var joined = keys.join(options.delimiter);
     var prefix = options.addQueryPrefix === true ? '?' : '';

     if (options.charsetSentinel) {
         if (options.charset === 'iso-8859-1') {
             // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
             prefix += 'utf8=%26%2310003%3B&';
         } else {
             // encodeURIComponent('✓')
             prefix += 'utf8=%E2%9C%93&';
         }
     }

     return joined.length > 0 ? prefix + joined : '';
 };


 /***/ }),
 /* 339 */
 /***/ (function(module, exports, __webpack_require__) {

 "use strict";

 var $ = __webpack_require__(13);
 var uncurryThis = __webpack_require__(5);
 var getOwnPropertyDescriptor = __webpack_require__(52).f;
 var toLength = __webpack_require__(88);
 var toString = __webpack_require__(28);
 var notARegExp = __webpack_require__(193);
 var requireObjectCoercible = __webpack_require__(37);
 var correctIsRegExpLogic = __webpack_require__(192);
 var IS_PURE = __webpack_require__(60);

 // eslint-disable-next-line es/no-string-prototype-startswith -- safe
 var un$StartsWith = uncurryThis(''.startsWith);
 var stringSlice = uncurryThis(''.slice);
 var min = Math.min;

 var CORRECT_IS_REGEXP_LOGIC = correctIsRegExpLogic('startsWith');
 // https://github.com/zloirock/core-js/pull/702
 var MDN_POLYFILL_BUG = !IS_PURE && !CORRECT_IS_REGEXP_LOGIC && !!function () {
   var descriptor = getOwnPropertyDescriptor(String.prototype, 'startsWith');
   return descriptor && !descriptor.writable;
 }();

 // `String.prototype.startsWith` method
 // https://tc39.es/ecma262/#sec-string.prototype.startswith
 $({ target: 'String', proto: true, forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC }, {
   startsWith: function startsWith(searchString /* , position = 0 */) {
     var that = toString(requireObjectCoercible(this));
     notARegExp(searchString);
     var index = toLength(min(arguments.length > 1 ? arguments[1] : undefined, that.length));
     var search = toString(searchString);
     return un$StartsWith
       ? un$StartsWith(that, search, index)
       : stringSlice(that, index, index + search.length) === search;
   }
 });


 /***/ }),
 /* 340 */
 /***/ (function(module, exports, __webpack_require__) {

 "use strict";

 var $forEach = __webpack_require__(83).forEach;
 var arrayMethodIsStrict = __webpack_require__(150);

 var STRICT_METHOD = arrayMethodIsStrict('forEach');

 // `Array.prototype.forEach` method implementation
 // https://tc39.es/ecma262/#sec-array.prototype.foreach
 module.exports = !STRICT_METHOD ? function forEach(callbackfn /* , thisArg */) {
   return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
 // eslint-disable-next-line es/no-array-prototype-foreach -- safe
 } : [].forEach;


 /***/ }),
 /* 341 */
 /***/ (function(module, exports, __webpack_require__) {

 var DESCRIPTORS = __webpack_require__(23);
 var uncurryThis = __webpack_require__(5);
 var objectKeys = __webpack_require__(84);
 var toIndexedObject = __webpack_require__(30);
 var $propertyIsEnumerable = __webpack_require__(109).f;

 var propertyIsEnumerable = uncurryThis($propertyIsEnumerable);
 var push = uncurryThis([].push);

 // `Object.{ entries, values }` methods implementation
 var createMethod = function (TO_ENTRIES) {
   return function (it) {
     var O = toIndexedObject(it);
     var keys = objectKeys(O);
     var length = keys.length;
     var i = 0;
     var result = [];
     var key;
     while (length > i) {
       key = keys[i++];
       if (!DESCRIPTORS || propertyIsEnumerable(O, key)) {
         push(result, TO_ENTRIES ? [key, O[key]] : O[key]);
       }
     }
     return result;
   };
 };

 module.exports = {
   // `Object.entries` method
   // https://tc39.es/ecma262/#sec-object.entries
   entries: createMethod(true),
   // `Object.values` method
   // https://tc39.es/ecma262/#sec-object.values
   values: createMethod(false)
 };


 /***/ }),
 /* 342 */
 /***/ (function(module, exports, __webpack_require__) {

 var $ = __webpack_require__(13);
 var $values = __webpack_require__(341).values;

 // `Object.values` method
 // https://tc39.es/ecma262/#sec-object.values
 $({ target: 'Object', stat: true }, {
   values: function values(O) {
     return $values(O);
   }
 });


 /***/ }),
 /* 343 */
 /***/ (function(module, exports, __webpack_require__) {

 "use strict";


 /**
  * Determines whether the payload is an error thrown by Axios
  *
  * @param {*} payload The value to test
  * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
  */
 module.exports = function isAxiosError(payload) {
   return (typeof payload === 'object') && (payload.isAxiosError === true);
 };


 /***/ }),
 /* 344 */
 /***/ (function(module, exports, __webpack_require__) {

 "use strict";


 /**
  * Syntactic sugar for invoking a function and expanding an array for arguments.
  *
  * Common use case would be to use `Function.prototype.apply`.
  *
  *  ```js
  *  function f(x, y, z) {}
  *  var args = [1, 2, 3];
  *  f.apply(null, args);
  *  ```
  *
  * With `spread` this example can be re-written.
  *
  *  ```js
  *  spread(function(x, y, z) {})([1, 2, 3]);
  *  ```
  *
  * @param {Function} callback
  * @returns {Function}
  */
 module.exports = function spread(callback) {
   return function wrap(arr) {
     return callback.apply(null, arr);
   };
 };


 /***/ }),
 /* 345 */
 /***/ (function(module, exports, __webpack_require__) {

 "use strict";


 var Cancel = __webpack_require__(195);

 /**
  * A `CancelToken` is an object that can be used to request cancellation of an operation.
  *
  * @class
  * @param {Function} executor The executor function.
  */
 function CancelToken(executor) {
   if (typeof executor !== 'function') {
     throw new TypeError('executor must be a function.');
   }

   var resolvePromise;
   this.promise = new Promise(function promiseExecutor(resolve) {
     resolvePromise = resolve;
   });

   var token = this;
   executor(function cancel(message) {
     if (token.reason) {
       // Cancellation has already been requested
       return;
     }

     token.reason = new Cancel(message);
     resolvePromise(token.reason);
   });
 }

 /**
  * Throws a `Cancel` if cancellation has been requested.
  */
 CancelToken.prototype.throwIfRequested = function throwIfRequested() {
   if (this.reason) {
     throw this.reason;
   }
 };

 /**
  * Returns an object that contains a new `CancelToken` and a function that, when called,
  * cancels the `CancelToken`.
  */
 CancelToken.source = function source() {
   var cancel;
   var token = new CancelToken(function executor(c) {
     cancel = c;
   });
   return {
     token: token,
     cancel: cancel
   };
 };

 module.exports = CancelToken;


 /***/ }),
 /* 346 */
 /***/ (function(module) {

 module.exports = {"name":"axios","version":"0.21.4","description":"Promise based HTTP client for the browser and node.js","main":"index.js","scripts":{"test":"grunt test","start":"node ./sandbox/server.js","build":"NODE_ENV=production grunt build","preversion":"npm test","version":"npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json","postversion":"git push && git push --tags","examples":"node ./examples/server.js","coveralls":"cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js","fix":"eslint --fix lib/**/*.js"},"repository":{"type":"git","url":"https://github.com/axios/axios.git"},"keywords":["xhr","http","ajax","promise","node"],"author":"Matt Zabriskie","license":"MIT","bugs":{"url":"https://github.com/axios/axios/issues"},"homepage":"https://axios-http.com","devDependencies":{"coveralls":"^3.0.0","es6-promise":"^4.2.4","grunt":"^1.3.0","grunt-banner":"^0.6.0","grunt-cli":"^1.2.0","grunt-contrib-clean":"^1.1.0","grunt-contrib-watch":"^1.0.0","grunt-eslint":"^23.0.0","grunt-karma":"^4.0.0","grunt-mocha-test":"^0.13.3","grunt-ts":"^6.0.0-beta.19","grunt-webpack":"^4.0.2","istanbul-instrumenter-loader":"^1.0.0","jasmine-core":"^2.4.1","karma":"^6.3.2","karma-chrome-launcher":"^3.1.0","karma-firefox-launcher":"^2.1.0","karma-jasmine":"^1.1.1","karma-jasmine-ajax":"^0.1.13","karma-safari-launcher":"^1.0.0","karma-sauce-launcher":"^4.3.6","karma-sinon":"^1.0.5","karma-sourcemap-loader":"^0.3.8","karma-webpack":"^4.0.2","load-grunt-tasks":"^3.5.2","minimist":"^1.2.0","mocha":"^8.2.1","sinon":"^4.5.0","terser-webpack-plugin":"^4.2.3","typescript":"^4.0.5","url-search-params":"^0.10.0","webpack":"^4.44.2","webpack-dev-server":"^3.11.0"},"browser":{"./lib/adapters/http.js":"./lib/adapters/xhr.js"},"jsdelivr":"dist/axios.min.js","unpkg":"dist/axios.min.js","typings":"./index.d.ts","dependencies":{"follow-redirects":"^1.14.0"},"bundlesize":[{"path":"./dist/axios.min.js","threshold":"5kB"}]};

 /***/ }),
 /* 347 */
 /***/ (function(module, exports, __webpack_require__) {

 "use strict";


 var pkg = __webpack_require__(346);

 var validators = {};

 // eslint-disable-next-line func-names
 ['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function(type, i) {
   validators[type] = function validator(thing) {
     return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
   };
 });

 var deprecatedWarnings = {};
 var currentVerArr = pkg.version.split('.');

 /**
  * Compare package versions
  * @param {string} version
  * @param {string?} thanVersion
  * @returns {boolean}
  */
 function isOlderVersion(version, thanVersion) {
   var pkgVersionArr = thanVersion ? thanVersion.split('.') : currentVerArr;
   var destVer = version.split('.');
   for (var i = 0; i < 3; i++) {
     if (pkgVersionArr[i] > destVer[i]) {
       return true;
     } else if (pkgVersionArr[i] < destVer[i]) {
       return false;
     }
   }
   return false;
 }

 /**
  * Transitional option validator
  * @param {function|boolean?} validator
  * @param {string?} version
  * @param {string} message
  * @returns {function}
  */
 validators.transitional = function transitional(validator, version, message) {
   var isDeprecated = version && isOlderVersion(version);

   function formatMessage(opt, desc) {
     return '[Axios v' + pkg.version + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
   }

   // eslint-disable-next-line func-names
   return function(value, opt, opts) {
     if (validator === false) {
       throw new Error(formatMessage(opt, ' has been removed in ' + version));
     }

     if (isDeprecated && !deprecatedWarnings[opt]) {
       deprecatedWarnings[opt] = true;
       // eslint-disable-next-line no-console
       console.warn(
         formatMessage(
           opt,
           ' has been deprecated since v' + version + ' and will be removed in the near future'
         )
       );
     }

     return validator ? validator(value, opt, opts) : true;
   };
 };

 /**
  * Assert object's properties type
  * @param {object} options
  * @param {object} schema
  * @param {boolean?} allowUnknown
  */

 function assertOptions(options, schema, allowUnknown) {
   if (typeof options !== 'object') {
     throw new TypeError('options must be an object');
   }
   var keys = Object.keys(options);
   var i = keys.length;
   while (i-- > 0) {
     var opt = keys[i];
     var validator = schema[opt];
     if (validator) {
       var value = options[opt];
       var result = value === undefined || validator(value, opt, options);
       if (result !== true) {
         throw new TypeError('option ' + opt + ' must be ' + result);
       }
       continue;
     }
     if (allowUnknown !== true) {
       throw Error('Unknown option ' + opt);
     }
   }
 }

 module.exports = {
   isOlderVersion: isOlderVersion,
   assertOptions: assertOptions,
   validators: validators
 };


 /***/ }),
 /* 348 */
 /***/ (function(module, exports, __webpack_require__) {

 "use strict";


 var utils = __webpack_require__(45);

 module.exports = (
   utils.isStandardBrowserEnv() ?

   // Standard browser envs have full support of the APIs needed to test
   // whether the request URL is of the same origin as current location.
     (function standardBrowserEnv() {
       var msie = /(msie|trident)/i.test(navigator.userAgent);
       var urlParsingNode = document.createElement('a');
       var originURL;

       /**
     * Parse a URL to discover it's components
     *
     * @param {String} url The URL to be parsed
     * @returns {Object}
     */
       function resolveURL(url) {
         var href = url;

         if (msie) {
         // IE needs attribute set twice to normalize properties
           urlParsingNode.setAttribute('href', href);
           href = urlParsingNode.href;
         }

         urlParsingNode.setAttribute('href', href);

         // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
         return {
           href: urlParsingNode.href,
           protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
           host: urlParsingNode.host,
           search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
           hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
           hostname: urlParsingNode.hostname,
           port: urlParsingNode.port,
           pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
             urlParsingNode.pathname :
             '/' + urlParsingNode.pathname
         };
       }

       originURL = resolveURL(window.location.href);

       /**
     * Determine if a URL shares the same origin as the current location
     *
     * @param {String} requestURL The URL to test
     * @returns {boolean} True if URL shares the same origin, otherwise false
     */
       return function isURLSameOrigin(requestURL) {
         var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
         return (parsed.protocol === originURL.protocol &&
             parsed.host === originURL.host);
       };
     })() :

   // Non standard browser envs (web workers, react-native) lack needed support.
     (function nonStandardBrowserEnv() {
       return function isURLSameOrigin() {
         return true;
       };
     })()
 );


 /***/ }),
 /* 349 */
 /***/ (function(module, exports, __webpack_require__) {

 "use strict";


 var utils = __webpack_require__(45);

 // Headers whose duplicates are ignored by node
 // c.f. https://nodejs.org/api/http.html#http_message_headers
 var ignoreDuplicateOf = [
   'age', 'authorization', 'content-length', 'content-type', 'etag',
   'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
   'last-modified', 'location', 'max-forwards', 'proxy-authorization',
   'referer', 'retry-after', 'user-agent'
 ];

 /**
  * Parse headers into an object
  *
  * ```
  * Date: Wed, 27 Aug 2014 08:58:49 GMT
  * Content-Type: application/json
  * Connection: keep-alive
  * Transfer-Encoding: chunked
  * ```
  *
  * @param {String} headers Headers needing to be parsed
  * @returns {Object} Headers parsed into an object
  */
 module.exports = function parseHeaders(headers) {
   var parsed = {};
   var key;
   var val;
   var i;

   if (!headers) { return parsed; }

   utils.forEach(headers.split('\n'), function parser(line) {
     i = line.indexOf(':');
     key = utils.trim(line.substr(0, i)).toLowerCase();
     val = utils.trim(line.substr(i + 1));

     if (key) {
       if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
         return;
       }
       if (key === 'set-cookie') {
         parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
       } else {
         parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
       }
     }
   });

   return parsed;
 };


 /***/ }),
 /* 350 */
 /***/ (function(module, exports, __webpack_require__) {

 "use strict";


 /**
  * Creates a new URL by combining the specified URLs
  *
  * @param {string} baseURL The base URL
  * @param {string} relativeURL The relative URL
  * @returns {string} The combined URL
  */
 module.exports = function combineURLs(baseURL, relativeURL) {
   return relativeURL
     ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
     : baseURL;
 };


 /***/ }),
 /* 351 */
 /***/ (function(module, exports, __webpack_require__) {

 "use strict";


 /**
  * Determines whether the specified URL is absolute
  *
  * @param {string} url The URL to test
  * @returns {boolean} True if the specified URL is absolute, otherwise false
  */
 module.exports = function isAbsoluteURL(url) {
   // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
   // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
   // by any combination of letters, digits, plus, period, or hyphen.
   return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
 };


 /***/ }),
 /* 352 */
 /***/ (function(module, exports, __webpack_require__) {

 "use strict";


 var isAbsoluteURL = __webpack_require__(351);
 var combineURLs = __webpack_require__(350);

 /**
  * Creates a new URL by combining the baseURL with the requestedURL,
  * only when the requestedURL is not already an absolute URL.
  * If the requestURL is absolute, this function returns the requestedURL untouched.
  *
  * @param {string} baseURL The base URL
  * @param {string} requestedURL Absolute or relative URL to combine
  * @returns {string} The combined full path
  */
 module.exports = function buildFullPath(baseURL, requestedURL) {
   if (baseURL && !isAbsoluteURL(requestedURL)) {
     return combineURLs(baseURL, requestedURL);
   }
   return requestedURL;
 };


 /***/ }),
 /* 353 */
 /***/ (function(module, exports, __webpack_require__) {

 "use strict";


 var utils = __webpack_require__(45);

 module.exports = (
   utils.isStandardBrowserEnv() ?

   // Standard browser envs support document.cookie
     (function standardBrowserEnv() {
       return {
         write: function write(name, value, expires, path, domain, secure) {
           var cookie = [];
           cookie.push(name + '=' + encodeURIComponent(value));

           if (utils.isNumber(expires)) {
             cookie.push('expires=' + new Date(expires).toGMTString());
           }

           if (utils.isString(path)) {
             cookie.push('path=' + path);
           }

           if (utils.isString(domain)) {
             cookie.push('domain=' + domain);
           }

           if (secure === true) {
             cookie.push('secure');
           }

           document.cookie = cookie.join('; ');
         },

         read: function read(name) {
           var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
           return (match ? decodeURIComponent(match[3]) : null);
         },

         remove: function remove(name) {
           this.write(name, '', Date.now() - 86400000);
         }
       };
     })() :

   // Non standard browser env (web workers, react-native) lack needed support.
     (function nonStandardBrowserEnv() {
       return {
         write: function write() {},
         read: function read() { return null; },
         remove: function remove() {}
       };
     })()
 );


 /***/ }),
 /* 354 */
 /***/ (function(module, exports, __webpack_require__) {

 "use strict";


 var createError = __webpack_require__(198);

 /**
  * Resolve or reject a Promise based on response status.
  *
  * @param {Function} resolve A function that resolves the promise.
  * @param {Function} reject A function that rejects the promise.
  * @param {object} response The response.
  */
 module.exports = function settle(resolve, reject, response) {
   var validateStatus = response.config.validateStatus;
   if (!response.status || !validateStatus || validateStatus(response.status)) {
     resolve(response);
   } else {
     reject(createError(
       'Request failed with status code ' + response.status,
       response.config,
       null,
       response.request,
       response
     ));
   }
 };


 /***/ }),
 /* 355 */
 /***/ (function(module, exports, __webpack_require__) {

 "use strict";


 var utils = __webpack_require__(45);

 module.exports = function normalizeHeaderName(headers, normalizedName) {
   utils.forEach(headers, function processHeader(value, name) {
     if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
       headers[normalizedName] = value;
       delete headers[name];
     }
   });
 };


 /***/ }),
 /* 356 */
 /***/ (function(module, exports, __webpack_require__) {

 "use strict";


 var utils = __webpack_require__(45);
 var defaults = __webpack_require__(152);

 /**
  * Transform the data for a request or a response
  *
  * @param {Object|String} data The data to be transformed
  * @param {Array} headers The headers for the request or response
  * @param {Array|Function} fns A single function or Array of functions
  * @returns {*} The resulting transformed data
  */
 module.exports = function transformData(data, headers, fns) {
   var context = this || defaults;
   /*eslint no-param-reassign:0*/
   utils.forEach(fns, function transform(fn) {
     data = fn.call(context, data, headers);
   });

   return data;
 };


 /***/ }),
 /* 357 */
 /***/ (function(module, exports, __webpack_require__) {

 "use strict";


 var utils = __webpack_require__(45);
 var transformData = __webpack_require__(356);
 var isCancel = __webpack_require__(197);
 var defaults = __webpack_require__(152);

 /**
  * Throws a `Cancel` if cancellation has been requested.
  */
 function throwIfCancellationRequested(config) {
   if (config.cancelToken) {
     config.cancelToken.throwIfRequested();
   }
 }

 /**
  * Dispatch a request to the server using the configured adapter.
  *
  * @param {object} config The config that is to be used for the request
  * @returns {Promise} The Promise to be fulfilled
  */
 module.exports = function dispatchRequest(config) {
   throwIfCancellationRequested(config);

   // Ensure headers exist
   config.headers = config.headers || {};

   // Transform request data
   config.data = transformData.call(
     config,
     config.data,
     config.headers,
     config.transformRequest
   );

   // Flatten headers
   config.headers = utils.merge(
     config.headers.common || {},
     config.headers[config.method] || {},
     config.headers
   );

   utils.forEach(
     ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
     function cleanHeaderConfig(method) {
       delete config.headers[method];
     }
   );

   var adapter = config.adapter || defaults.adapter;

   return adapter(config).then(function onAdapterResolution(response) {
     throwIfCancellationRequested(config);

     // Transform response data
     response.data = transformData.call(
       config,
       response.data,
       response.headers,
       config.transformResponse
     );

     return response;
   }, function onAdapterRejection(reason) {
     if (!isCancel(reason)) {
       throwIfCancellationRequested(config);

       // Transform response data
       if (reason && reason.response) {
         reason.response.data = transformData.call(
           config,
           reason.response.data,
           reason.response.headers,
           config.transformResponse
         );
       }
     }

     return Promise.reject(reason);
   });
 };


 /***/ }),
 /* 358 */
 /***/ (function(module, exports, __webpack_require__) {

 "use strict";


 var utils = __webpack_require__(45);

 function InterceptorManager() {
   this.handlers = [];
 }

 /**
  * Add a new interceptor to the stack
  *
  * @param {Function} fulfilled The function to handle `then` for a `Promise`
  * @param {Function} rejected The function to handle `reject` for a `Promise`
  *
  * @return {Number} An ID used to remove interceptor later
  */
 InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
   this.handlers.push({
     fulfilled: fulfilled,
     rejected: rejected,
     synchronous: options ? options.synchronous : false,
     runWhen: options ? options.runWhen : null
   });
   return this.handlers.length - 1;
 };

 /**
  * Remove an interceptor from the stack
  *
  * @param {Number} id The ID that was returned by `use`
  */
 InterceptorManager.prototype.eject = function eject(id) {
   if (this.handlers[id]) {
     this.handlers[id] = null;
   }
 };

 /**
  * Iterate over all the registered interceptors
  *
  * This method is particularly useful for skipping over any
  * interceptors that may have become `null` calling `eject`.
  *
  * @param {Function} fn The function to call for each interceptor
  */
 InterceptorManager.prototype.forEach = function forEach(fn) {
   utils.forEach(this.handlers, function forEachHandler(h) {
     if (h !== null) {
       fn(h);
     }
   });
 };

 module.exports = InterceptorManager;


 /***/ }),
 /* 359 */
 /***/ (function(module, exports, __webpack_require__) {

 "use strict";


 var utils = __webpack_require__(45);
 var buildURL = __webpack_require__(201);
 var InterceptorManager = __webpack_require__(358);
 var dispatchRequest = __webpack_require__(357);
 var mergeConfig = __webpack_require__(196);
 var validator = __webpack_require__(347);

 var validators = validator.validators;
 /**
  * Create a new instance of Axios
  *
  * @param {Object} instanceConfig The default config for the instance
  */
 function Axios(instanceConfig) {
   this.defaults = instanceConfig;
   this.interceptors = {
     request: new InterceptorManager(),
     response: new InterceptorManager()
   };
 }

 /**
  * Dispatch a request
  *
  * @param {Object} config The config specific for this request (merged with this.defaults)
  */
 Axios.prototype.request = function request(config) {
   /*eslint no-param-reassign:0*/
   // Allow for axios('example/url'[, config]) a la fetch API
   if (typeof config === 'string') {
     config = arguments[1] || {};
     config.url = arguments[0];
   } else {
     config = config || {};
   }

   config = mergeConfig(this.defaults, config);

   // Set config.method
   if (config.method) {
     config.method = config.method.toLowerCase();
   } else if (this.defaults.method) {
     config.method = this.defaults.method.toLowerCase();
   } else {
     config.method = 'get';
   }

   var transitional = config.transitional;

   if (transitional !== undefined) {
     validator.assertOptions(transitional, {
       silentJSONParsing: validators.transitional(validators.boolean, '1.0.0'),
       forcedJSONParsing: validators.transitional(validators.boolean, '1.0.0'),
       clarifyTimeoutError: validators.transitional(validators.boolean, '1.0.0')
     }, false);
   }

   // filter out skipped interceptors
   var requestInterceptorChain = [];
   var synchronousRequestInterceptors = true;
   this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
     if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
       return;
     }

     synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

     requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
   });

   var responseInterceptorChain = [];
   this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
     responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
   });

   var promise;

   if (!synchronousRequestInterceptors) {
     var chain = [dispatchRequest, undefined];

     Array.prototype.unshift.apply(chain, requestInterceptorChain);
     chain = chain.concat(responseInterceptorChain);

     promise = Promise.resolve(config);
     while (chain.length) {
       promise = promise.then(chain.shift(), chain.shift());
     }

     return promise;
   }


   var newConfig = config;
   while (requestInterceptorChain.length) {
     var onFulfilled = requestInterceptorChain.shift();
     var onRejected = requestInterceptorChain.shift();
     try {
       newConfig = onFulfilled(newConfig);
     } catch (error) {
       onRejected(error);
       break;
     }
   }

   try {
     promise = dispatchRequest(newConfig);
   } catch (error) {
     return Promise.reject(error);
   }

   while (responseInterceptorChain.length) {
     promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
   }

   return promise;
 };

 Axios.prototype.getUri = function getUri(config) {
   config = mergeConfig(this.defaults, config);
   return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
 };

 // Provide aliases for supported request methods
 utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
   /*eslint func-names:0*/
   Axios.prototype[method] = function(url, config) {
     return this.request(mergeConfig(config || {}, {
       method: method,
       url: url,
       data: (config || {}).data
     }));
   };
 });

 utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
   /*eslint func-names:0*/
   Axios.prototype[method] = function(url, data, config) {
     return this.request(mergeConfig(config || {}, {
       method: method,
       url: url,
       data: data
     }));
   };
 });

 module.exports = Axios;


 /***/ }),
 /* 360 */
 /***/ (function(module, exports, __webpack_require__) {

 "use strict";


 var utils = __webpack_require__(45);
 var bind = __webpack_require__(202);
 var Axios = __webpack_require__(359);
 var mergeConfig = __webpack_require__(196);
 var defaults = __webpack_require__(152);

 /**
  * Create an instance of Axios
  *
  * @param {Object} defaultConfig The default config for the instance
  * @return {Axios} A new instance of Axios
  */
 function createInstance(defaultConfig) {
   var context = new Axios(defaultConfig);
   var instance = bind(Axios.prototype.request, context);

   // Copy axios.prototype to instance
   utils.extend(instance, Axios.prototype, context);

   // Copy context to instance
   utils.extend(instance, context);

   return instance;
 }

 // Create the default instance to be exported
 var axios = createInstance(defaults);

 // Expose Axios class to allow class inheritance
 axios.Axios = Axios;

 // Factory for creating new instances
 axios.create = function create(instanceConfig) {
   return createInstance(mergeConfig(axios.defaults, instanceConfig));
 };

 // Expose Cancel & CancelToken
 axios.Cancel = __webpack_require__(195);
 axios.CancelToken = __webpack_require__(345);
 axios.isCancel = __webpack_require__(197);

 // Expose all/spread
 axios.all = function all(promises) {
   return Promise.all(promises);
 };
 axios.spread = __webpack_require__(344);

 // Expose isAxiosError
 axios.isAxiosError = __webpack_require__(343);

 module.exports = axios;

 // Allow use of default import syntax in TypeScript
 module.exports.default = axios;


 /***/ }),
 /* 361 */
 /***/ (function(module, exports) {

 HTMLElement.prototype.customDelegate = function customDelegate(eventName, elementSelector, handler) {
   this.addEventListener(eventName, function (e) {
     var element = e.target.closest(elementSelector);

     if (element) {
       handler.call(element, e, element);
     }
   }, false);
 };

 /***/ }),
 /* 362 */
 /***/ (function(module, exports, __webpack_require__) {

 /* WEBPACK VAR INJECTION */(function(process, global) {/*!
  * @overview es6-promise - a tiny implementation of Promises/A+.
  * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
  * @license   Licensed under MIT license
  *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
  * @version   v4.2.8+1e68dce6
  */

 (function (global, factory) {
    true ? module.exports = factory() :
   undefined;
 }(this, (function () { 'use strict';

 function objectOrFunction(x) {
   var type = typeof x;
   return x !== null && (type === 'object' || type === 'function');
 }

 function isFunction(x) {
   return typeof x === 'function';
 }



 var _isArray = void 0;
 if (Array.isArray) {
   _isArray = Array.isArray;
 } else {
   _isArray = function (x) {
     return Object.prototype.toString.call(x) === '[object Array]';
   };
 }

 var isArray = _isArray;

 var len = 0;
 var vertxNext = void 0;
 var customSchedulerFn = void 0;

 var asap = function asap(callback, arg) {
   queue[len] = callback;
   queue[len + 1] = arg;
   len += 2;
   if (len === 2) {
     // If len is 2, that means that we need to schedule an async flush.
     // If additional callbacks are queued before the queue is flushed, they
     // will be processed by this flush that we are scheduling.
     if (customSchedulerFn) {
       customSchedulerFn(flush);
     } else {
       scheduleFlush();
     }
   }
 };

 function setScheduler(scheduleFn) {
   customSchedulerFn = scheduleFn;
 }

 function setAsap(asapFn) {
   asap = asapFn;
 }

 var browserWindow = typeof window !== 'undefined' ? window : undefined;
 var browserGlobal = browserWindow || {};
 var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
 var isNode = typeof self === 'undefined' && typeof process !== 'undefined' && {}.toString.call(process) === '[object process]';

 // test for web worker but not in IE10
 var isWorker = typeof Uint8ClampedArray !== 'undefined' && typeof importScripts !== 'undefined' && typeof MessageChannel !== 'undefined';

 // node
 function useNextTick() {
   // node version 0.10.x displays a deprecation warning when nextTick is used recursively
   // see https://github.com/cujojs/when/issues/410 for details
   return function () {
     return process.nextTick(flush);
   };
 }

 // vertx
 function useVertxTimer() {
   if (typeof vertxNext !== 'undefined') {
     return function () {
       vertxNext(flush);
     };
   }

   return useSetTimeout();
 }

 function useMutationObserver() {
   var iterations = 0;
   var observer = new BrowserMutationObserver(flush);
   var node = document.createTextNode('');
   observer.observe(node, { characterData: true });

   return function () {
     node.data = iterations = ++iterations % 2;
   };
 }

 // web worker
 function useMessageChannel() {
   var channel = new MessageChannel();
   channel.port1.onmessage = flush;
   return function () {
     return channel.port2.postMessage(0);
   };
 }

 function useSetTimeout() {
   // Store setTimeout reference so es6-promise will be unaffected by
   // other code modifying setTimeout (like sinon.useFakeTimers())
   var globalSetTimeout = setTimeout;
   return function () {
     return globalSetTimeout(flush, 1);
   };
 }

 var queue = new Array(1000);
 function flush() {
   for (var i = 0; i < len; i += 2) {
     var callback = queue[i];
     var arg = queue[i + 1];

     callback(arg);

     queue[i] = undefined;
     queue[i + 1] = undefined;
   }

   len = 0;
 }

 function attemptVertx() {
   try {
     var vertx = Function('return this')().require('vertx');
     vertxNext = vertx.runOnLoop || vertx.runOnContext;
     return useVertxTimer();
   } catch (e) {
     return useSetTimeout();
   }
 }

 var scheduleFlush = void 0;
 // Decide what async method to use to triggering processing of queued callbacks:
 if (isNode) {
   scheduleFlush = useNextTick();
 } else if (BrowserMutationObserver) {
   scheduleFlush = useMutationObserver();
 } else if (isWorker) {
   scheduleFlush = useMessageChannel();
 } else if (browserWindow === undefined && "function" === 'function') {
   scheduleFlush = attemptVertx();
 } else {
   scheduleFlush = useSetTimeout();
 }

 function then(onFulfillment, onRejection) {
   var parent = this;

   var child = new this.constructor(noop);

   if (child[PROMISE_ID] === undefined) {
     makePromise(child);
   }

   var _state = parent._state;


   if (_state) {
     var callback = arguments[_state - 1];
     asap(function () {
       return invokeCallback(_state, child, callback, parent._result);
     });
   } else {
     subscribe(parent, child, onFulfillment, onRejection);
   }

   return child;
 }

 /**
   `Promise.resolve` returns a promise that will become resolved with the
   passed `value`. It is shorthand for the following:

   ```javascript
   let promise = new Promise(function(resolve, reject){
     resolve(1);
   });

   promise.then(function(value){
     // value === 1
   });
   ```

   Instead of writing the above, your code now simply becomes the following:

   ```javascript
   let promise = Promise.resolve(1);

   promise.then(function(value){
     // value === 1
   });
   ```

   @method resolve
   @static
   @param {Any} value value that the returned promise will be resolved with
   Useful for tooling.
   @return {Promise} a promise that will become fulfilled with the given
   `value`
 */
 function resolve$1(object) {
   /*jshint validthis:true */
   var Constructor = this;

   if (object && typeof object === 'object' && object.constructor === Constructor) {
     return object;
   }

   var promise = new Constructor(noop);
   resolve(promise, object);
   return promise;
 }

 var PROMISE_ID = Math.random().toString(36).substring(2);

 function noop() {}

 var PENDING = void 0;
 var FULFILLED = 1;
 var REJECTED = 2;

 function selfFulfillment() {
   return new TypeError("You cannot resolve a promise with itself");
 }

 function cannotReturnOwn() {
   return new TypeError('A promises callback cannot return that same promise.');
 }

 function tryThen(then$$1, value, fulfillmentHandler, rejectionHandler) {
   try {
     then$$1.call(value, fulfillmentHandler, rejectionHandler);
   } catch (e) {
     return e;
   }
 }

 function handleForeignThenable(promise, thenable, then$$1) {
   asap(function (promise) {
     var sealed = false;
     var error = tryThen(then$$1, thenable, function (value) {
       if (sealed) {
         return;
       }
       sealed = true;
       if (thenable !== value) {
         resolve(promise, value);
       } else {
         fulfill(promise, value);
       }
     }, function (reason) {
       if (sealed) {
         return;
       }
       sealed = true;

       reject(promise, reason);
     }, 'Settle: ' + (promise._label || ' unknown promise'));

     if (!sealed && error) {
       sealed = true;
       reject(promise, error);
     }
   }, promise);
 }

 function handleOwnThenable(promise, thenable) {
   if (thenable._state === FULFILLED) {
     fulfill(promise, thenable._result);
   } else if (thenable._state === REJECTED) {
     reject(promise, thenable._result);
   } else {
     subscribe(thenable, undefined, function (value) {
       return resolve(promise, value);
     }, function (reason) {
       return reject(promise, reason);
     });
   }
 }

 function handleMaybeThenable(promise, maybeThenable, then$$1) {
   if (maybeThenable.constructor === promise.constructor && then$$1 === then && maybeThenable.constructor.resolve === resolve$1) {
     handleOwnThenable(promise, maybeThenable);
   } else {
     if (then$$1 === undefined) {
       fulfill(promise, maybeThenable);
     } else if (isFunction(then$$1)) {
       handleForeignThenable(promise, maybeThenable, then$$1);
     } else {
       fulfill(promise, maybeThenable);
     }
   }
 }

 function resolve(promise, value) {
   if (promise === value) {
     reject(promise, selfFulfillment());
   } else if (objectOrFunction(value)) {
     var then$$1 = void 0;
     try {
       then$$1 = value.then;
     } catch (error) {
       reject(promise, error);
       return;
     }
     handleMaybeThenable(promise, value, then$$1);
   } else {
     fulfill(promise, value);
   }
 }

 function publishRejection(promise) {
   if (promise._onerror) {
     promise._onerror(promise._result);
   }

   publish(promise);
 }

 function fulfill(promise, value) {
   if (promise._state !== PENDING) {
     return;
   }

   promise._result = value;
   promise._state = FULFILLED;

   if (promise._subscribers.length !== 0) {
     asap(publish, promise);
   }
 }

 function reject(promise, reason) {
   if (promise._state !== PENDING) {
     return;
   }
   promise._state = REJECTED;
   promise._result = reason;

   asap(publishRejection, promise);
 }

 function subscribe(parent, child, onFulfillment, onRejection) {
   var _subscribers = parent._subscribers;
   var length = _subscribers.length;


   parent._onerror = null;

   _subscribers[length] = child;
   _subscribers[length + FULFILLED] = onFulfillment;
   _subscribers[length + REJECTED] = onRejection;

   if (length === 0 && parent._state) {
     asap(publish, parent);
   }
 }

 function publish(promise) {
   var subscribers = promise._subscribers;
   var settled = promise._state;

   if (subscribers.length === 0) {
     return;
   }

   var child = void 0,
       callback = void 0,
       detail = promise._result;

   for (var i = 0; i < subscribers.length; i += 3) {
     child = subscribers[i];
     callback = subscribers[i + settled];

     if (child) {
       invokeCallback(settled, child, callback, detail);
     } else {
       callback(detail);
     }
   }

   promise._subscribers.length = 0;
 }

 function invokeCallback(settled, promise, callback, detail) {
   var hasCallback = isFunction(callback),
       value = void 0,
       error = void 0,
       succeeded = true;

   if (hasCallback) {
     try {
       value = callback(detail);
     } catch (e) {
       succeeded = false;
       error = e;
     }

     if (promise === value) {
       reject(promise, cannotReturnOwn());
       return;
     }
   } else {
     value = detail;
   }

   if (promise._state !== PENDING) {
     // noop
   } else if (hasCallback && succeeded) {
     resolve(promise, value);
   } else if (succeeded === false) {
     reject(promise, error);
   } else if (settled === FULFILLED) {
     fulfill(promise, value);
   } else if (settled === REJECTED) {
     reject(promise, value);
   }
 }

 function initializePromise(promise, resolver) {
   try {
     resolver(function resolvePromise(value) {
       resolve(promise, value);
     }, function rejectPromise(reason) {
       reject(promise, reason);
     });
   } catch (e) {
     reject(promise, e);
   }
 }

 var id = 0;
 function nextId() {
   return id++;
 }

 function makePromise(promise) {
   promise[PROMISE_ID] = id++;
   promise._state = undefined;
   promise._result = undefined;
   promise._subscribers = [];
 }

 function validationError() {
   return new Error('Array Methods must be provided an Array');
 }

 var Enumerator = function () {
   function Enumerator(Constructor, input) {
     this._instanceConstructor = Constructor;
     this.promise = new Constructor(noop);

     if (!this.promise[PROMISE_ID]) {
       makePromise(this.promise);
     }

     if (isArray(input)) {
       this.length = input.length;
       this._remaining = input.length;

       this._result = new Array(this.length);

       if (this.length === 0) {
         fulfill(this.promise, this._result);
       } else {
         this.length = this.length || 0;
         this._enumerate(input);
         if (this._remaining === 0) {
           fulfill(this.promise, this._result);
         }
       }
     } else {
       reject(this.promise, validationError());
     }
   }

   Enumerator.prototype._enumerate = function _enumerate(input) {
     for (var i = 0; this._state === PENDING && i < input.length; i++) {
       this._eachEntry(input[i], i);
     }
   };

   Enumerator.prototype._eachEntry = function _eachEntry(entry, i) {
     var c = this._instanceConstructor;
     var resolve$$1 = c.resolve;


     if (resolve$$1 === resolve$1) {
       var _then = void 0;
       var error = void 0;
       var didError = false;
       try {
         _then = entry.then;
       } catch (e) {
         didError = true;
         error = e;
       }

       if (_then === then && entry._state !== PENDING) {
         this._settledAt(entry._state, i, entry._result);
       } else if (typeof _then !== 'function') {
         this._remaining--;
         this._result[i] = entry;
       } else if (c === Promise$1) {
         var promise = new c(noop);
         if (didError) {
           reject(promise, error);
         } else {
           handleMaybeThenable(promise, entry, _then);
         }
         this._willSettleAt(promise, i);
       } else {
         this._willSettleAt(new c(function (resolve$$1) {
           return resolve$$1(entry);
         }), i);
       }
     } else {
       this._willSettleAt(resolve$$1(entry), i);
     }
   };

   Enumerator.prototype._settledAt = function _settledAt(state, i, value) {
     var promise = this.promise;


     if (promise._state === PENDING) {
       this._remaining--;

       if (state === REJECTED) {
         reject(promise, value);
       } else {
         this._result[i] = value;
       }
     }

     if (this._remaining === 0) {
       fulfill(promise, this._result);
     }
   };

   Enumerator.prototype._willSettleAt = function _willSettleAt(promise, i) {
     var enumerator = this;

     subscribe(promise, undefined, function (value) {
       return enumerator._settledAt(FULFILLED, i, value);
     }, function (reason) {
       return enumerator._settledAt(REJECTED, i, reason);
     });
   };

   return Enumerator;
 }();

 /**
   `Promise.all` accepts an array of promises, and returns a new promise which
   is fulfilled with an array of fulfillment values for the passed promises, or
   rejected with the reason of the first passed promise to be rejected. It casts all
   elements of the passed iterable to promises as it runs this algorithm.

   Example:

   ```javascript
   let promise1 = resolve(1);
   let promise2 = resolve(2);
   let promise3 = resolve(3);
   let promises = [ promise1, promise2, promise3 ];

   Promise.all(promises).then(function(array){
     // The array here would be [ 1, 2, 3 ];
   });
   ```

   If any of the `promises` given to `all` are rejected, the first promise
   that is rejected will be given as an argument to the returned promises's
   rejection handler. For example:

   Example:

   ```javascript
   let promise1 = resolve(1);
   let promise2 = reject(new Error("2"));
   let promise3 = reject(new Error("3"));
   let promises = [ promise1, promise2, promise3 ];

   Promise.all(promises).then(function(array){
     // Code here never runs because there are rejected promises!
   }, function(error) {
     // error.message === "2"
   });
   ```

   @method all
   @static
   @param {Array} entries array of promises
   @param {String} label optional string for labeling the promise.
   Useful for tooling.
   @return {Promise} promise that is fulfilled when all `promises` have been
   fulfilled, or rejected if any of them become rejected.
   @static
 */
 function all(entries) {
   return new Enumerator(this, entries).promise;
 }

 /**
   `Promise.race` returns a new promise which is settled in the same way as the
   first passed promise to settle.

   Example:

   ```javascript
   let promise1 = new Promise(function(resolve, reject){
     setTimeout(function(){
       resolve('promise 1');
     }, 200);
   });

   let promise2 = new Promise(function(resolve, reject){
     setTimeout(function(){
       resolve('promise 2');
     }, 100);
   });

   Promise.race([promise1, promise2]).then(function(result){
     // result === 'promise 2' because it was resolved before promise1
     // was resolved.
   });
   ```

   `Promise.race` is deterministic in that only the state of the first
   settled promise matters. For example, even if other promises given to the
   `promises` array argument are resolved, but the first settled promise has
   become rejected before the other promises became fulfilled, the returned
   promise will become rejected:

   ```javascript
   let promise1 = new Promise(function(resolve, reject){
     setTimeout(function(){
       resolve('promise 1');
     }, 200);
   });

   let promise2 = new Promise(function(resolve, reject){
     setTimeout(function(){
       reject(new Error('promise 2'));
     }, 100);
   });

   Promise.race([promise1, promise2]).then(function(result){
     // Code here never runs
   }, function(reason){
     // reason.message === 'promise 2' because promise 2 became rejected before
     // promise 1 became fulfilled
   });
   ```

   An example real-world use case is implementing timeouts:

   ```javascript
   Promise.race([ajax('foo.json'), timeout(5000)])
   ```

   @method race
   @static
   @param {Array} promises array of promises to observe
   Useful for tooling.
   @return {Promise} a promise which settles in the same way as the first passed
   promise to settle.
 */
 function race(entries) {
   /*jshint validthis:true */
   var Constructor = this;

   if (!isArray(entries)) {
     return new Constructor(function (_, reject) {
       return reject(new TypeError('You must pass an array to race.'));
     });
   } else {
     return new Constructor(function (resolve, reject) {
       var length = entries.length;
       for (var i = 0; i < length; i++) {
         Constructor.resolve(entries[i]).then(resolve, reject);
       }
     });
   }
 }

 /**
   `Promise.reject` returns a promise rejected with the passed `reason`.
   It is shorthand for the following:

   ```javascript
   let promise = new Promise(function(resolve, reject){
     reject(new Error('WHOOPS'));
   });

   promise.then(function(value){
     // Code here doesn't run because the promise is rejected!
   }, function(reason){
     // reason.message === 'WHOOPS'
   });
   ```

   Instead of writing the above, your code now simply becomes the following:

   ```javascript
   let promise = Promise.reject(new Error('WHOOPS'));

   promise.then(function(value){
     // Code here doesn't run because the promise is rejected!
   }, function(reason){
     // reason.message === 'WHOOPS'
   });
   ```

   @method reject
   @static
   @param {Any} reason value that the returned promise will be rejected with.
   Useful for tooling.
   @return {Promise} a promise rejected with the given `reason`.
 */
 function reject$1(reason) {
   /*jshint validthis:true */
   var Constructor = this;
   var promise = new Constructor(noop);
   reject(promise, reason);
   return promise;
 }

 function needsResolver() {
   throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
 }

 function needsNew() {
   throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
 }

 /**
   Promise objects represent the eventual result of an asynchronous operation. The
   primary way of interacting with a promise is through its `then` method, which
   registers callbacks to receive either a promise's eventual value or the reason
   why the promise cannot be fulfilled.

   Terminology
   -----------

   - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
   - `thenable` is an object or function that defines a `then` method.
   - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
   - `exception` is a value that is thrown using the throw statement.
   - `reason` is a value that indicates why a promise was rejected.
   - `settled` the final resting state of a promise, fulfilled or rejected.

   A promise can be in one of three states: pending, fulfilled, or rejected.

   Promises that are fulfilled have a fulfillment value and are in the fulfilled
   state.  Promises that are rejected have a rejection reason and are in the
   rejected state.  A fulfillment value is never a thenable.

   Promises can also be said to *resolve* a value.  If this value is also a
   promise, then the original promise's settled state will match the value's
   settled state.  So a promise that *resolves* a promise that rejects will
   itself reject, and a promise that *resolves* a promise that fulfills will
   itself fulfill.


   Basic Usage:
   ------------

   ```js
   let promise = new Promise(function(resolve, reject) {
     // on success
     resolve(value);

     // on failure
     reject(reason);
   });

   promise.then(function(value) {
     // on fulfillment
   }, function(reason) {
     // on rejection
   });
   ```

   Advanced Usage:
   ---------------

   Promises shine when abstracting away asynchronous interactions such as
   `XMLHttpRequest`s.

   ```js
   function getJSON(url) {
     return new Promise(function(resolve, reject){
       let xhr = new XMLHttpRequest();

       xhr.open('GET', url);
       xhr.onreadystatechange = handler;
       xhr.responseType = 'json';
       xhr.setRequestHeader('Accept', 'application/json');
       xhr.send();

       function handler() {
         if (this.readyState === this.DONE) {
           if (this.status === 200) {
             resolve(this.response);
           } else {
             reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
           }
         }
       };
     });
   }

   getJSON('/posts.json').then(function(json) {
     // on fulfillment
   }, function(reason) {
     // on rejection
   });
   ```

   Unlike callbacks, promises are great composable primitives.

   ```js
   Promise.all([
     getJSON('/posts'),
     getJSON('/comments')
   ]).then(function(values){
     values[0] // => postsJSON
     values[1] // => commentsJSON

     return values;
   });
   ```

   @class Promise
   @param {Function} resolver
   Useful for tooling.
   @constructor
 */

 var Promise$1 = function () {
   function Promise(resolver) {
     this[PROMISE_ID] = nextId();
     this._result = this._state = undefined;
     this._subscribers = [];

     if (noop !== resolver) {
       typeof resolver !== 'function' && needsResolver();
       this instanceof Promise ? initializePromise(this, resolver) : needsNew();
     }
   }

   /**
   The primary way of interacting with a promise is through its `then` method,
   which registers callbacks to receive either a promise's eventual value or the
   reason why the promise cannot be fulfilled.
    ```js
   findUser().then(function(user){
     // user is available
   }, function(reason){
     // user is unavailable, and you are given the reason why
   });
   ```
    Chaining
   --------
    The return value of `then` is itself a promise.  This second, 'downstream'
   promise is resolved with the return value of the first promise's fulfillment
   or rejection handler, or rejected if the handler throws an exception.
    ```js
   findUser().then(function (user) {
     return user.name;
   }, function (reason) {
     return 'default name';
   }).then(function (userName) {
     // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
     // will be `'default name'`
   });
    findUser().then(function (user) {
     throw new Error('Found user, but still unhappy');
   }, function (reason) {
     throw new Error('`findUser` rejected and we're unhappy');
   }).then(function (value) {
     // never reached
   }, function (reason) {
     // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
     // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
   });
   ```
   If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
    ```js
   findUser().then(function (user) {
     throw new PedagogicalException('Upstream error');
   }).then(function (value) {
     // never reached
   }).then(function (value) {
     // never reached
   }, function (reason) {
     // The `PedgagocialException` is propagated all the way down to here
   });
   ```
    Assimilation
   ------------
    Sometimes the value you want to propagate to a downstream promise can only be
   retrieved asynchronously. This can be achieved by returning a promise in the
   fulfillment or rejection handler. The downstream promise will then be pending
   until the returned promise is settled. This is called *assimilation*.
    ```js
   findUser().then(function (user) {
     return findCommentsByAuthor(user);
   }).then(function (comments) {
     // The user's comments are now available
   });
   ```
    If the assimliated promise rejects, then the downstream promise will also reject.
    ```js
   findUser().then(function (user) {
     return findCommentsByAuthor(user);
   }).then(function (comments) {
     // If `findCommentsByAuthor` fulfills, we'll have the value here
   }, function (reason) {
     // If `findCommentsByAuthor` rejects, we'll have the reason here
   });
   ```
    Simple Example
   --------------
    Synchronous Example
    ```javascript
   let result;
    try {
     result = findResult();
     // success
   } catch(reason) {
     // failure
   }
   ```
    Errback Example
    ```js
   findResult(function(result, err){
     if (err) {
       // failure
     } else {
       // success
     }
   });
   ```
    Promise Example;
    ```javascript
   findResult().then(function(result){
     // success
   }, function(reason){
     // failure
   });
   ```
    Advanced Example
   --------------
    Synchronous Example
    ```javascript
   let author, books;
    try {
     author = findAuthor();
     books  = findBooksByAuthor(author);
     // success
   } catch(reason) {
     // failure
   }
   ```
    Errback Example
    ```js
    function foundBooks(books) {
    }
    function failure(reason) {
    }
    findAuthor(function(author, err){
     if (err) {
       failure(err);
       // failure
     } else {
       try {
         findBoooksByAuthor(author, function(books, err) {
           if (err) {
             failure(err);
           } else {
             try {
               foundBooks(books);
             } catch(reason) {
               failure(reason);
             }
           }
         });
       } catch(error) {
         failure(err);
       }
       // success
     }
   });
   ```
    Promise Example;
    ```javascript
   findAuthor().
     then(findBooksByAuthor).
     then(function(books){
       // found books
   }).catch(function(reason){
     // something went wrong
   });
   ```
    @method then
   @param {Function} onFulfilled
   @param {Function} onRejected
   Useful for tooling.
   @return {Promise}
   */

   /**
   `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
   as the catch block of a try/catch statement.
   ```js
   function findAuthor(){
   throw new Error('couldn't find that author');
   }
   // synchronous
   try {
   findAuthor();
   } catch(reason) {
   // something went wrong
   }
   // async with promises
   findAuthor().catch(function(reason){
   // something went wrong
   });
   ```
   @method catch
   @param {Function} onRejection
   Useful for tooling.
   @return {Promise}
   */


   Promise.prototype.catch = function _catch(onRejection) {
     return this.then(null, onRejection);
   };

   /**
     `finally` will be invoked regardless of the promise's fate just as native
     try/catch/finally behaves

     Synchronous example:

     ```js
     findAuthor() {
       if (Math.random() > 0.5) {
         throw new Error();
       }
       return new Author();
     }

     try {
       return findAuthor(); // succeed or fail
     } catch(error) {
       return findOtherAuther();
     } finally {
       // always runs
       // doesn't affect the return value
     }
     ```

     Asynchronous example:

     ```js
     findAuthor().catch(function(reason){
       return findOtherAuther();
     }).finally(function(){
       // author was either found, or not
     });
     ```

     @method finally
     @param {Function} callback
     @return {Promise}
   */


   Promise.prototype.finally = function _finally(callback) {
     var promise = this;
     var constructor = promise.constructor;

     if (isFunction(callback)) {
       return promise.then(function (value) {
         return constructor.resolve(callback()).then(function () {
           return value;
         });
       }, function (reason) {
         return constructor.resolve(callback()).then(function () {
           throw reason;
         });
       });
     }

     return promise.then(callback, callback);
   };

   return Promise;
 }();

 Promise$1.prototype.then = then;
 Promise$1.all = all;
 Promise$1.race = race;
 Promise$1.resolve = resolve$1;
 Promise$1.reject = reject$1;
 Promise$1._setScheduler = setScheduler;
 Promise$1._setAsap = setAsap;
 Promise$1._asap = asap;

 /*global self*/
 function polyfill() {
   var local = void 0;

   if (typeof global !== 'undefined') {
     local = global;
   } else if (typeof self !== 'undefined') {
     local = self;
   } else {
     try {
       local = Function('return this')();
     } catch (e) {
       throw new Error('polyfill failed because global object is unavailable in this environment');
     }
   }

   var P = local.Promise;

   if (P) {
     var promiseToString = null;
     try {
       promiseToString = Object.prototype.toString.call(P.resolve());
     } catch (e) {
       // silently ignored
     }

     if (promiseToString === '[object Promise]' && !P.cast) {
       return;
     }
   }

   local.Promise = Promise$1;
 }

 // Strange compat..
 Promise$1.polyfill = polyfill;
 Promise$1.Promise = Promise$1;

 return Promise$1;

 })));



 //# sourceMappingURL=es6-promise.map

 /* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(155), __webpack_require__(69)))

 /***/ }),
 /* 363 */
 /***/ (function(module, exports, __webpack_require__) {

 "use strict";
 // This file can be required in Browserify and Node.js for automatic polyfill
 // To use it:  require('es6-promise/auto');

 module.exports = __webpack_require__(362).polyfill();


 /***/ }),
 /* 364 */
 /***/ (function(module, exports) {

 self.fetch||(self.fetch=function(e,n){return n=n||{},new Promise(function(t,s){var r=new XMLHttpRequest,o=[],u=[],i={},a=function(){return{ok:2==(r.status/100|0),statusText:r.statusText,status:r.status,url:r.responseURL,text:function(){return Promise.resolve(r.responseText)},json:function(){return Promise.resolve(r.responseText).then(JSON.parse)},blob:function(){return Promise.resolve(new Blob([r.response]))},clone:a,headers:{keys:function(){return o},entries:function(){return u},get:function(e){return i[e.toLowerCase()]},has:function(e){return e.toLowerCase()in i}}}};for(var c in r.open(n.method||"get",e,!0),r.onload=function(){r.getAllResponseHeaders().replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm,function(e,n,t){o.push(n=n.toLowerCase()),u.push([n,t]),i[n]=i[n]?i[n]+","+t:t}),t(a())},r.onerror=s,r.withCredentials="include"==n.credentials,n.headers)r.setRequestHeader(c,n.headers[c]);r.send(n.body||null)})});


 /***/ }),
 /* 365 */
 /***/ (function(module, exports) {

 module.exports = typeof window == 'object';


 /***/ }),
 /* 366 */
 /***/ (function(module, exports) {

 module.exports = function (exec) {
   try {
     return { error: false, value: exec() };
   } catch (error) {
     return { error: true, value: error };
   }
 };


 /***/ }),
 /* 367 */
 /***/ (function(module, exports, __webpack_require__) {

 var global = __webpack_require__(2);

 module.exports = function (a, b) {
   var console = global.console;
   if (console && console.error) {
     arguments.length == 1 ? console.error(a) : console.error(a, b);
   }
 };


 /***/ }),
 /* 368 */
 /***/ (function(module, exports, __webpack_require__) {

 var anObject = __webpack_require__(17);
 var isObject = __webpack_require__(18);
 var newPromiseCapability = __webpack_require__(211);

 module.exports = function (C, x) {
   anObject(C);
   if (isObject(x) && x.constructor === C) return x;
   var promiseCapability = newPromiseCapability.f(C);
   var resolve = promiseCapability.resolve;
   resolve(x);
   return promiseCapability.promise;
 };


 /***/ }),
 /* 369 */
 /***/ (function(module, exports, __webpack_require__) {

 var userAgent = __webpack_require__(68);

 module.exports = /web0s(?!.*chrome)/i.test(userAgent);


 /***/ }),
 /* 370 */
 /***/ (function(module, exports, __webpack_require__) {

 var userAgent = __webpack_require__(68);
 var global = __webpack_require__(2);

 module.exports = /ipad|iphone|ipod/i.test(userAgent) && global.Pebble !== undefined;


 /***/ }),
 /* 371 */
 /***/ (function(module, exports, __webpack_require__) {

 var global = __webpack_require__(2);
 var bind = __webpack_require__(64);
 var getOwnPropertyDescriptor = __webpack_require__(52).f;
 var macrotask = __webpack_require__(213).set;
 var IS_IOS = __webpack_require__(212);
 var IS_IOS_PEBBLE = __webpack_require__(370);
 var IS_WEBOS_WEBKIT = __webpack_require__(369);
 var IS_NODE = __webpack_require__(159);

 var MutationObserver = global.MutationObserver || global.WebKitMutationObserver;
 var document = global.document;
 var process = global.process;
 var Promise = global.Promise;
 // Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
 var queueMicrotaskDescriptor = getOwnPropertyDescriptor(global, 'queueMicrotask');
 var queueMicrotask = queueMicrotaskDescriptor && queueMicrotaskDescriptor.value;

 var flush, head, last, notify, toggle, node, promise, then;

 // modern engines have queueMicrotask method
 if (!queueMicrotask) {
   flush = function () {
     var parent, fn;
     if (IS_NODE && (parent = process.domain)) parent.exit();
     while (head) {
       fn = head.fn;
       head = head.next;
       try {
         fn();
       } catch (error) {
         if (head) notify();
         else last = undefined;
         throw error;
       }
     } last = undefined;
     if (parent) parent.enter();
   };

   // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
   // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
   if (!IS_IOS && !IS_NODE && !IS_WEBOS_WEBKIT && MutationObserver && document) {
     toggle = true;
     node = document.createTextNode('');
     new MutationObserver(flush).observe(node, { characterData: true });
     notify = function () {
       node.data = toggle = !toggle;
     };
   // environments with maybe non-completely correct, but existent Promise
   } else if (!IS_IOS_PEBBLE && Promise && Promise.resolve) {
     // Promise.resolve without an argument throws an error in LG WebOS 2
     promise = Promise.resolve(undefined);
     // workaround of WebKit ~ iOS Safari 10.1 bug
     promise.constructor = Promise;
     then = bind(promise.then, promise);
     notify = function () {
       then(flush);
     };
   // Node.js without promises
   } else if (IS_NODE) {
     notify = function () {
       process.nextTick(flush);
     };
   // for other environments - macrotask based on:
   // - setImmediate
   // - MessageChannel
   // - window.postMessag
   // - onreadystatechange
   // - setTimeout
   } else {
     // strange IE + webpack dev server bug - use .bind(global)
     macrotask = bind(macrotask, global);
     notify = function () {
       macrotask(flush);
     };
   }
 }

 module.exports = queueMicrotask || function (fn) {
   var task = { fn: fn, next: undefined };
   if (last) last.next = task;
   if (!head) {
     head = task;
     notify();
   } last = task;
 };


 /***/ }),
 /* 372 */
 /***/ (function(module, exports, __webpack_require__) {

 var global = __webpack_require__(2);
 var isCallable = __webpack_require__(11);

 var String = global.String;
 var TypeError = global.TypeError;

 module.exports = function (argument) {
   if (typeof argument == 'object' || isCallable(argument)) return argument;
   throw TypeError("Can't set " + String(argument) + ' as a prototype');
 };


 /***/ }),
 /* 373 */
 /***/ (function(module, exports, __webpack_require__) {

 var global = __webpack_require__(2);

 module.exports = global.Promise;


 /***/ }),
 /* 374 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";
 __webpack_require__.r(__webpack_exports__);
 /* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(16);
 /* harmony import */ var regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3);
 /* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1__);
 /* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14);
 /* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_2__);
 /* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31);
 /* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_3__);
 /* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27);
 /* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_4__);
 /* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41);
 /* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_5__);
 /* harmony import */ var unfetch_polyfill__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(364);
 /* harmony import */ var unfetch_polyfill__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(unfetch_polyfill__WEBPACK_IMPORTED_MODULE_6__);
 /* harmony import */ var es6_promise_auto__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(363);
 /* harmony import */ var es6_promise_auto__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(es6_promise_auto__WEBPACK_IMPORTED_MODULE_7__);
 /* harmony import */ var _core_helpers_customDelegate__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(361);
 /* harmony import */ var _core_helpers_customDelegate__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_core_helpers_customDelegate__WEBPACK_IMPORTED_MODULE_8__);
 /* harmony import */ var _core_objects__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(38);
 /* harmony import */ var _savchukoleksii_shopify_theme_translations_tool__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(70);
 /* harmony import */ var _savchukoleksii_shopify_theme_settings_tool__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(61);
 /* harmony import */ var _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(1);
 /* harmony import */ var _vue_store__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(20);
 /* harmony import */ var _vue_store_wishlist_wishlist__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(77);
 /* harmony import */ var _vue_store_cart_cart__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(15);
 /* harmony import */ var _vue_store_recently_viewed_products_recently_viewed_products__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(78);
 /* harmony import */ var _core_helpers_recentlyViewedProducts__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(112);
 /* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(103);
 /* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(377);
 /* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(376);
 /* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(375);
 /* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(172);
 /* harmony import */ var body_scroll_lock__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(62);
 /* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(0);
 /* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_24__);
 /* harmony import */ var _components_product_card__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(49);
 /* harmony import */ var _components_filters__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(144);
 /* harmony import */ var _components_customer_form__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(170);
 /* harmony import */ var _sections_account_preferred_store__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(142);
 /* harmony import */ var _components_general_google_maps__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(169);


 function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

 function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }



















 var DOMContentLoadedPromise = new Promise(function (resolve) {
   document.addEventListener("DOMContentLoaded", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
     return regeneratorRuntime.wrap(function _callee$(_context) {
       while (1) {
         switch (_context.prev = _context.next) {
           case 0:
             resolve();

           case 1:
           case "end":
             return _context.stop();
         }
       }
     }, _callee);
   })));
 });

 global.bodyScrollLock = body_scroll_lock__WEBPACK_IMPORTED_MODULE_23__;






 global.jQuery = jquery__WEBPACK_IMPORTED_MODULE_24___default.a;
 global.$ = jquery__WEBPACK_IMPORTED_MODULE_24___default.a;
 window.theme = window.theme || {};
 /*================ Components ================*/

 __webpack_require__(315);

 __webpack_require__(7);

 __webpack_require__(314);

 __webpack_require__(313);

 __webpack_require__(312);

 __webpack_require__(311);

 __webpack_require__(310);

 __webpack_require__(309);

 __webpack_require__(101);

 __webpack_require__(308);

 __webpack_require__(49);

 __webpack_require__(7);

 __webpack_require__(144);

 __webpack_require__(306);

 __webpack_require__(170);

 __webpack_require__(305);

 __webpack_require__(304);
 /*================ Sections ================*/


 __webpack_require__(303);

 __webpack_require__(239);

 __webpack_require__(236);

 __webpack_require__(238);

 __webpack_require__(300);

 __webpack_require__(299);

 __webpack_require__(234);

 __webpack_require__(298);

 __webpack_require__(183);

 __webpack_require__(297);

 __webpack_require__(296);

 __webpack_require__(182);

 __webpack_require__(237);

 __webpack_require__(182);

 __webpack_require__(235);

 __webpack_require__(181);

 __webpack_require__(295);

 __webpack_require__(294);

 __webpack_require__(293);

 __webpack_require__(181);

 __webpack_require__(292);

 __webpack_require__(180);

 __webpack_require__(291);

 __webpack_require__(290);

 __webpack_require__(179);

 __webpack_require__(289);

 __webpack_require__(178);

 __webpack_require__(233);

 __webpack_require__(180);

 __webpack_require__(287);

 __webpack_require__(286);

 __webpack_require__(285);

 __webpack_require__(284);

 __webpack_require__(283);

 __webpack_require__(282);

 __webpack_require__(179);

 __webpack_require__(281);

 __webpack_require__(178);

 __webpack_require__(271);

 __webpack_require__(270);

 __webpack_require__(183);

 __webpack_require__(269);

 __webpack_require__(268);

 __webpack_require__(267);

 __webpack_require__(266);

 __webpack_require__(265);

 __webpack_require__(264);

 __webpack_require__(263);

 __webpack_require__(262);

 __webpack_require__(261);

 __webpack_require__(260);

 __webpack_require__(259);

 __webpack_require__(258);

 __webpack_require__(257);

 __webpack_require__(142);

 __webpack_require__(256);

 __webpack_require__(255);

 __webpack_require__(169);

 __webpack_require__(254);

 __webpack_require__(142);

 __webpack_require__(253);

 __webpack_require__(252);

 __webpack_require__(247);

 __webpack_require__(246);
 /*================ Templates ================*/


 __webpack_require__(245);

 __webpack_require__(244);

 __webpack_require__(243);

 __webpack_require__(242);

 __webpack_require__(241);

 swiper__WEBPACK_IMPORTED_MODULE_18__[/* default */ "a"].use([swiper__WEBPACK_IMPORTED_MODULE_19__[/* default */ "a"], swiper__WEBPACK_IMPORTED_MODULE_20__[/* default */ "a"], swiper__WEBPACK_IMPORTED_MODULE_21__[/* default */ "a"], swiper__WEBPACK_IMPORTED_MODULE_22__[/* default */ "a"]]);

 _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
   return regeneratorRuntime.wrap(function _callee2$(_context2) {
     while (1) {
       switch (_context2.prev = _context2.next) {
         case 0:
           _context2.prev = 0;
           _context2.next = 3;
           return Promise.all([_savchukoleksii_shopify_theme_translations_tool__WEBPACK_IMPORTED_MODULE_10__[/* default */ "a"].load(), _savchukoleksii_shopify_theme_settings_tool__WEBPACK_IMPORTED_MODULE_11__[/* default */ "a"].load(), _core_objects__WEBPACK_IMPORTED_MODULE_9__[/* default */ "c"].load(), DOMContentLoadedPromise]);

         case 3:
           document.dispatchEvent(new CustomEvent("theme:all:loaded"));
           _context2.next = 8;
           break;

         case 6:
           _context2.prev = 6;
           _context2.t0 = _context2["catch"](0);

         case 8:
           _context2.next = 10;
           return Promise.all([_vue_store__WEBPACK_IMPORTED_MODULE_13__[/* store */ "a"].dispatch("wishlist/".concat(_vue_store_wishlist_wishlist__WEBPACK_IMPORTED_MODULE_14__[/* ACTION_INIT_WISHLIST */ "b"])), _vue_store__WEBPACK_IMPORTED_MODULE_13__[/* store */ "a"].dispatch("cart/".concat(_vue_store_cart_cart__WEBPACK_IMPORTED_MODULE_15__[/* ACTION_INIT_CART */ "d"])), _vue_store__WEBPACK_IMPORTED_MODULE_13__[/* store */ "a"].dispatch("recently-viewed-products/".concat(_vue_store_recently_viewed_products_recently_viewed_products__WEBPACK_IMPORTED_MODULE_16__[/* ACTION_INIT_RECENTLY_VIEWED_PRODUCTS */ "a"]))]);

         case 10:
           Object(_core_helpers_recentlyViewedProducts__WEBPACK_IMPORTED_MODULE_17__[/* addCurrentProductToRecentlyViewedProducts */ "a"])();
           _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_12__[/* load */ "a"]("*");
           Object(_components_product_card__WEBPACK_IMPORTED_MODULE_25__["initProductCards"])();
           Object(_components_filters__WEBPACK_IMPORTED_MODULE_26__["initFilters"])();
           Object(_sections_account_preferred_store__WEBPACK_IMPORTED_MODULE_28__["initPreferredStore"])();
           Object(_components_customer_form__WEBPACK_IMPORTED_MODULE_27__["initCustomerForm"])();
           Object(_components_general_google_maps__WEBPACK_IMPORTED_MODULE_29__["default"])();
           document.addEventListener("bpf:filter:afterRender", function () {
             Object(_components_filters__WEBPACK_IMPORTED_MODULE_26__["initFilters"])();
           });
           document.addEventListener("bpf:product:render", function (e) {
             window.initProductCards(e.detail.selector);
             e.detail.selector.classList.add("product-card--initialized");
           });

         case 19:
         case "end":
           return _context2.stop();
       }
     }
   }, _callee2, null, [[0, 6]]);
 }))();
 /* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(69)))

 /***/ }),
 /* 375 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";
 /* harmony import */ var _utils_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9);
 /* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6);
 function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



 var A11y = {
   getRandomNumber: function getRandomNumber(size) {
     if (size === void 0) {
       size = 16;
     }

     var randomChar = function randomChar() {
       return Math.round(16 * Math.random()).toString(16);
     };

     return 'x'.repeat(size).replace(/x/g, randomChar);
   },
   makeElFocusable: function makeElFocusable($el) {
     $el.attr('tabIndex', '0');
     return $el;
   },
   makeElNotFocusable: function makeElNotFocusable($el) {
     $el.attr('tabIndex', '-1');
     return $el;
   },
   addElRole: function addElRole($el, role) {
     $el.attr('role', role);
     return $el;
   },
   addElRoleDescription: function addElRoleDescription($el, description) {
     $el.attr('aria-roledescription', description);
     return $el;
   },
   addElControls: function addElControls($el, controls) {
     $el.attr('aria-controls', controls);
     return $el;
   },
   addElLabel: function addElLabel($el, label) {
     $el.attr('aria-label', label);
     return $el;
   },
   addElId: function addElId($el, id) {
     $el.attr('id', id);
     return $el;
   },
   addElLive: function addElLive($el, live) {
     $el.attr('aria-live', live);
     return $el;
   },
   disableEl: function disableEl($el) {
     $el.attr('aria-disabled', true);
     return $el;
   },
   enableEl: function enableEl($el) {
     $el.attr('aria-disabled', false);
     return $el;
   },
   onEnterOrSpaceKey: function onEnterOrSpaceKey(e) {
     if (e.keyCode !== 13 && e.keyCode !== 32) return;
     var swiper = this;
     var params = swiper.params.a11y;
     var $targetEl = Object(_utils_dom__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(e.target);

     if (swiper.navigation && swiper.navigation.$nextEl && $targetEl.is(swiper.navigation.$nextEl)) {
       if (!(swiper.isEnd && !swiper.params.loop)) {
         swiper.slideNext();
       }

       if (swiper.isEnd) {
         swiper.a11y.notify(params.lastSlideMessage);
       } else {
         swiper.a11y.notify(params.nextSlideMessage);
       }
     }

     if (swiper.navigation && swiper.navigation.$prevEl && $targetEl.is(swiper.navigation.$prevEl)) {
       if (!(swiper.isBeginning && !swiper.params.loop)) {
         swiper.slidePrev();
       }

       if (swiper.isBeginning) {
         swiper.a11y.notify(params.firstSlideMessage);
       } else {
         swiper.a11y.notify(params.prevSlideMessage);
       }
     }

     if (swiper.pagination && $targetEl.is(Object(_utils_utils__WEBPACK_IMPORTED_MODULE_1__[/* classesToSelector */ "b"])(swiper.params.pagination.bulletClass))) {
       $targetEl[0].click();
     }
   },
   notify: function notify(message) {
     var swiper = this;
     var notification = swiper.a11y.liveRegion;
     if (notification.length === 0) return;
     notification.html('');
     notification.html(message);
   },
   updateNavigation: function updateNavigation() {
     var swiper = this;
     if (swiper.params.loop || !swiper.navigation) return;
     var _swiper$navigation = swiper.navigation,
         $nextEl = _swiper$navigation.$nextEl,
         $prevEl = _swiper$navigation.$prevEl;

     if ($prevEl && $prevEl.length > 0) {
       if (swiper.isBeginning) {
         swiper.a11y.disableEl($prevEl);
         swiper.a11y.makeElNotFocusable($prevEl);
       } else {
         swiper.a11y.enableEl($prevEl);
         swiper.a11y.makeElFocusable($prevEl);
       }
     }

     if ($nextEl && $nextEl.length > 0) {
       if (swiper.isEnd) {
         swiper.a11y.disableEl($nextEl);
         swiper.a11y.makeElNotFocusable($nextEl);
       } else {
         swiper.a11y.enableEl($nextEl);
         swiper.a11y.makeElFocusable($nextEl);
       }
     }
   },
   updatePagination: function updatePagination() {
     var swiper = this;
     var params = swiper.params.a11y;

     if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
       swiper.pagination.bullets.each(function (bulletEl) {
         var $bulletEl = Object(_utils_dom__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(bulletEl);
         swiper.a11y.makeElFocusable($bulletEl);

         if (!swiper.params.pagination.renderBullet) {
           swiper.a11y.addElRole($bulletEl, 'button');
           swiper.a11y.addElLabel($bulletEl, params.paginationBulletMessage.replace(/\{\{index\}\}/, $bulletEl.index() + 1));
         }
       });
     }
   },
   init: function init() {
     var swiper = this;
     var params = swiper.params.a11y;
     swiper.$el.append(swiper.a11y.liveRegion); // Container

     var $containerEl = swiper.$el;

     if (params.containerRoleDescriptionMessage) {
       swiper.a11y.addElRoleDescription($containerEl, params.containerRoleDescriptionMessage);
     }

     if (params.containerMessage) {
       swiper.a11y.addElLabel($containerEl, params.containerMessage);
     } // Wrapper


     var $wrapperEl = swiper.$wrapperEl;
     var wrapperId = $wrapperEl.attr('id') || "swiper-wrapper-" + swiper.a11y.getRandomNumber(16);
     var live = swiper.params.autoplay && swiper.params.autoplay.enabled ? 'off' : 'polite';
     swiper.a11y.addElId($wrapperEl, wrapperId);
     swiper.a11y.addElLive($wrapperEl, live); // Slide

     if (params.itemRoleDescriptionMessage) {
       swiper.a11y.addElRoleDescription(Object(_utils_dom__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(swiper.slides), params.itemRoleDescriptionMessage);
     }

     swiper.a11y.addElRole(Object(_utils_dom__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(swiper.slides), params.slideRole);
     var slidesLength = swiper.params.loop ? swiper.slides.filter(function (el) {
       return !el.classList.contains(swiper.params.slideDuplicateClass);
     }).length : swiper.slides.length;
     swiper.slides.each(function (slideEl, index) {
       var $slideEl = Object(_utils_dom__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(slideEl);
       var slideIndex = swiper.params.loop ? parseInt($slideEl.attr('data-swiper-slide-index'), 10) : index;
       var ariaLabelMessage = params.slideLabelMessage.replace(/\{\{index\}\}/, slideIndex + 1).replace(/\{\{slidesLength\}\}/, slidesLength);
       swiper.a11y.addElLabel($slideEl, ariaLabelMessage);
     }); // Navigation

     var $nextEl;
     var $prevEl;

     if (swiper.navigation && swiper.navigation.$nextEl) {
       $nextEl = swiper.navigation.$nextEl;
     }

     if (swiper.navigation && swiper.navigation.$prevEl) {
       $prevEl = swiper.navigation.$prevEl;
     }

     if ($nextEl && $nextEl.length) {
       swiper.a11y.makeElFocusable($nextEl);

       if ($nextEl[0].tagName !== 'BUTTON') {
         swiper.a11y.addElRole($nextEl, 'button');
         $nextEl.on('keydown', swiper.a11y.onEnterOrSpaceKey);
       }

       swiper.a11y.addElLabel($nextEl, params.nextSlideMessage);
       swiper.a11y.addElControls($nextEl, wrapperId);
     }

     if ($prevEl && $prevEl.length) {
       swiper.a11y.makeElFocusable($prevEl);

       if ($prevEl[0].tagName !== 'BUTTON') {
         swiper.a11y.addElRole($prevEl, 'button');
         $prevEl.on('keydown', swiper.a11y.onEnterOrSpaceKey);
       }

       swiper.a11y.addElLabel($prevEl, params.prevSlideMessage);
       swiper.a11y.addElControls($prevEl, wrapperId);
     } // Pagination


     if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
       swiper.pagination.$el.on('keydown', Object(_utils_utils__WEBPACK_IMPORTED_MODULE_1__[/* classesToSelector */ "b"])(swiper.params.pagination.bulletClass), swiper.a11y.onEnterOrSpaceKey);
     }
   },
   destroy: function destroy() {
     var swiper = this;
     if (swiper.a11y.liveRegion && swiper.a11y.liveRegion.length > 0) swiper.a11y.liveRegion.remove();
     var $nextEl;
     var $prevEl;

     if (swiper.navigation && swiper.navigation.$nextEl) {
       $nextEl = swiper.navigation.$nextEl;
     }

     if (swiper.navigation && swiper.navigation.$prevEl) {
       $prevEl = swiper.navigation.$prevEl;
     }

     if ($nextEl) {
       $nextEl.off('keydown', swiper.a11y.onEnterOrSpaceKey);
     }

     if ($prevEl) {
       $prevEl.off('keydown', swiper.a11y.onEnterOrSpaceKey);
     } // Pagination


     if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
       swiper.pagination.$el.off('keydown', Object(_utils_utils__WEBPACK_IMPORTED_MODULE_1__[/* classesToSelector */ "b"])(swiper.params.pagination.bulletClass), swiper.a11y.onEnterOrSpaceKey);
     }
   }
 };
 /* harmony default export */ __webpack_exports__["a"] = ({
   name: 'a11y',
   params: {
     a11y: {
       enabled: true,
       notificationClass: 'swiper-notification',
       prevSlideMessage: 'Previous slide',
       nextSlideMessage: 'Next slide',
       firstSlideMessage: 'This is the first slide',
       lastSlideMessage: 'This is the last slide',
       paginationBulletMessage: 'Go to slide {{index}}',
       slideLabelMessage: '{{index}} / {{slidesLength}}',
       containerMessage: null,
       containerRoleDescriptionMessage: null,
       itemRoleDescriptionMessage: null,
       slideRole: 'group'
     }
   },
   create: function create() {
     var swiper = this;
     Object(_utils_utils__WEBPACK_IMPORTED_MODULE_1__[/* bindModuleMethods */ "a"])(swiper, {
       a11y: _extends({}, A11y, {
         liveRegion: Object(_utils_dom__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])("<span class=\"" + swiper.params.a11y.notificationClass + "\" aria-live=\"assertive\" aria-atomic=\"true\"></span>")
       })
     });
   },
   on: {
     afterInit: function afterInit(swiper) {
       if (!swiper.params.a11y.enabled) return;
       swiper.a11y.init();
       swiper.a11y.updateNavigation();
     },
     toEdge: function toEdge(swiper) {
       if (!swiper.params.a11y.enabled) return;
       swiper.a11y.updateNavigation();
     },
     fromEdge: function fromEdge(swiper) {
       if (!swiper.params.a11y.enabled) return;
       swiper.a11y.updateNavigation();
     },
     paginationUpdate: function paginationUpdate(swiper) {
       if (!swiper.params.a11y.enabled) return;
       swiper.a11y.updatePagination();
     },
     destroy: function destroy(swiper) {
       if (!swiper.params.a11y.enabled) return;
       swiper.a11y.destroy();
     }
   }
 });

 /***/ }),
 /* 376 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";
 /* harmony import */ var ssr_window__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4);
 /* harmony import */ var _utils_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9);
 /* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6);
 function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }




 var Zoom = {
   // Calc Scale From Multi-touches
   getDistanceBetweenTouches: function getDistanceBetweenTouches(e) {
     if (e.targetTouches.length < 2) return 1;
     var x1 = e.targetTouches[0].pageX;
     var y1 = e.targetTouches[0].pageY;
     var x2 = e.targetTouches[1].pageX;
     var y2 = e.targetTouches[1].pageY;
     var distance = Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
     return distance;
   },
   // Events
   onGestureStart: function onGestureStart(e) {
     var swiper = this;
     var support = swiper.support;
     var params = swiper.params.zoom;
     var zoom = swiper.zoom;
     var gesture = zoom.gesture;
     zoom.fakeGestureTouched = false;
     zoom.fakeGestureMoved = false;

     if (!support.gestures) {
       if (e.type !== 'touchstart' || e.type === 'touchstart' && e.targetTouches.length < 2) {
         return;
       }

       zoom.fakeGestureTouched = true;
       gesture.scaleStart = Zoom.getDistanceBetweenTouches(e);
     }

     if (!gesture.$slideEl || !gesture.$slideEl.length) {
       gesture.$slideEl = Object(_utils_dom__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(e.target).closest("." + swiper.params.slideClass);
       if (gesture.$slideEl.length === 0) gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
       gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas, picture, .swiper-zoom-target');
       gesture.$imageWrapEl = gesture.$imageEl.parent("." + params.containerClass);
       gesture.maxRatio = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;

       if (gesture.$imageWrapEl.length === 0) {
         gesture.$imageEl = undefined;
         return;
       }
     }

     if (gesture.$imageEl) {
       gesture.$imageEl.transition(0);
     }

     swiper.zoom.isScaling = true;
   },
   onGestureChange: function onGestureChange(e) {
     var swiper = this;
     var support = swiper.support;
     var params = swiper.params.zoom;
     var zoom = swiper.zoom;
     var gesture = zoom.gesture;

     if (!support.gestures) {
       if (e.type !== 'touchmove' || e.type === 'touchmove' && e.targetTouches.length < 2) {
         return;
       }

       zoom.fakeGestureMoved = true;
       gesture.scaleMove = Zoom.getDistanceBetweenTouches(e);
     }

     if (!gesture.$imageEl || gesture.$imageEl.length === 0) {
       if (e.type === 'gesturechange') zoom.onGestureStart(e);
       return;
     }

     if (support.gestures) {
       zoom.scale = e.scale * zoom.currentScale;
     } else {
       zoom.scale = gesture.scaleMove / gesture.scaleStart * zoom.currentScale;
     }

     if (zoom.scale > gesture.maxRatio) {
       zoom.scale = gesture.maxRatio - 1 + Math.pow(zoom.scale - gesture.maxRatio + 1, 0.5);
     }

     if (zoom.scale < params.minRatio) {
       zoom.scale = params.minRatio + 1 - Math.pow(params.minRatio - zoom.scale + 1, 0.5);
     }

     gesture.$imageEl.transform("translate3d(0,0,0) scale(" + zoom.scale + ")");
   },
   onGestureEnd: function onGestureEnd(e) {
     var swiper = this;
     var device = swiper.device;
     var support = swiper.support;
     var params = swiper.params.zoom;
     var zoom = swiper.zoom;
     var gesture = zoom.gesture;

     if (!support.gestures) {
       if (!zoom.fakeGestureTouched || !zoom.fakeGestureMoved) {
         return;
       }

       if (e.type !== 'touchend' || e.type === 'touchend' && e.changedTouches.length < 2 && !device.android) {
         return;
       }

       zoom.fakeGestureTouched = false;
       zoom.fakeGestureMoved = false;
     }

     if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
     zoom.scale = Math.max(Math.min(zoom.scale, gesture.maxRatio), params.minRatio);
     gesture.$imageEl.transition(swiper.params.speed).transform("translate3d(0,0,0) scale(" + zoom.scale + ")");
     zoom.currentScale = zoom.scale;
     zoom.isScaling = false;
     if (zoom.scale === 1) gesture.$slideEl = undefined;
   },
   onTouchStart: function onTouchStart(e) {
     var swiper = this;
     var device = swiper.device;
     var zoom = swiper.zoom;
     var gesture = zoom.gesture,
         image = zoom.image;
     if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
     if (image.isTouched) return;
     if (device.android && e.cancelable) e.preventDefault();
     image.isTouched = true;
     image.touchesStart.x = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
     image.touchesStart.y = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
   },
   onTouchMove: function onTouchMove(e) {
     var swiper = this;
     var zoom = swiper.zoom;
     var gesture = zoom.gesture,
         image = zoom.image,
         velocity = zoom.velocity;
     if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
     swiper.allowClick = false;
     if (!image.isTouched || !gesture.$slideEl) return;

     if (!image.isMoved) {
       image.width = gesture.$imageEl[0].offsetWidth;
       image.height = gesture.$imageEl[0].offsetHeight;
       image.startX = Object(_utils_utils__WEBPACK_IMPORTED_MODULE_2__[/* getTranslate */ "f"])(gesture.$imageWrapEl[0], 'x') || 0;
       image.startY = Object(_utils_utils__WEBPACK_IMPORTED_MODULE_2__[/* getTranslate */ "f"])(gesture.$imageWrapEl[0], 'y') || 0;
       gesture.slideWidth = gesture.$slideEl[0].offsetWidth;
       gesture.slideHeight = gesture.$slideEl[0].offsetHeight;
       gesture.$imageWrapEl.transition(0);
     } // Define if we need image drag


     var scaledWidth = image.width * zoom.scale;
     var scaledHeight = image.height * zoom.scale;
     if (scaledWidth < gesture.slideWidth && scaledHeight < gesture.slideHeight) return;
     image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
     image.maxX = -image.minX;
     image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
     image.maxY = -image.minY;
     image.touchesCurrent.x = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
     image.touchesCurrent.y = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;

     if (!image.isMoved && !zoom.isScaling) {
       if (swiper.isHorizontal() && (Math.floor(image.minX) === Math.floor(image.startX) && image.touchesCurrent.x < image.touchesStart.x || Math.floor(image.maxX) === Math.floor(image.startX) && image.touchesCurrent.x > image.touchesStart.x)) {
         image.isTouched = false;
         return;
       }

       if (!swiper.isHorizontal() && (Math.floor(image.minY) === Math.floor(image.startY) && image.touchesCurrent.y < image.touchesStart.y || Math.floor(image.maxY) === Math.floor(image.startY) && image.touchesCurrent.y > image.touchesStart.y)) {
         image.isTouched = false;
         return;
       }
     }

     if (e.cancelable) {
       e.preventDefault();
     }

     e.stopPropagation();
     image.isMoved = true;
     image.currentX = image.touchesCurrent.x - image.touchesStart.x + image.startX;
     image.currentY = image.touchesCurrent.y - image.touchesStart.y + image.startY;

     if (image.currentX < image.minX) {
       image.currentX = image.minX + 1 - Math.pow(image.minX - image.currentX + 1, 0.8);
     }

     if (image.currentX > image.maxX) {
       image.currentX = image.maxX - 1 + Math.pow(image.currentX - image.maxX + 1, 0.8);
     }

     if (image.currentY < image.minY) {
       image.currentY = image.minY + 1 - Math.pow(image.minY - image.currentY + 1, 0.8);
     }

     if (image.currentY > image.maxY) {
       image.currentY = image.maxY - 1 + Math.pow(image.currentY - image.maxY + 1, 0.8);
     } // Velocity


     if (!velocity.prevPositionX) velocity.prevPositionX = image.touchesCurrent.x;
     if (!velocity.prevPositionY) velocity.prevPositionY = image.touchesCurrent.y;
     if (!velocity.prevTime) velocity.prevTime = Date.now();
     velocity.x = (image.touchesCurrent.x - velocity.prevPositionX) / (Date.now() - velocity.prevTime) / 2;
     velocity.y = (image.touchesCurrent.y - velocity.prevPositionY) / (Date.now() - velocity.prevTime) / 2;
     if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2) velocity.x = 0;
     if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2) velocity.y = 0;
     velocity.prevPositionX = image.touchesCurrent.x;
     velocity.prevPositionY = image.touchesCurrent.y;
     velocity.prevTime = Date.now();
     gesture.$imageWrapEl.transform("translate3d(" + image.currentX + "px, " + image.currentY + "px,0)");
   },
   onTouchEnd: function onTouchEnd() {
     var swiper = this;
     var zoom = swiper.zoom;
     var gesture = zoom.gesture,
         image = zoom.image,
         velocity = zoom.velocity;
     if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;

     if (!image.isTouched || !image.isMoved) {
       image.isTouched = false;
       image.isMoved = false;
       return;
     }

     image.isTouched = false;
     image.isMoved = false;
     var momentumDurationX = 300;
     var momentumDurationY = 300;
     var momentumDistanceX = velocity.x * momentumDurationX;
     var newPositionX = image.currentX + momentumDistanceX;
     var momentumDistanceY = velocity.y * momentumDurationY;
     var newPositionY = image.currentY + momentumDistanceY; // Fix duration

     if (velocity.x !== 0) momentumDurationX = Math.abs((newPositionX - image.currentX) / velocity.x);
     if (velocity.y !== 0) momentumDurationY = Math.abs((newPositionY - image.currentY) / velocity.y);
     var momentumDuration = Math.max(momentumDurationX, momentumDurationY);
     image.currentX = newPositionX;
     image.currentY = newPositionY; // Define if we need image drag

     var scaledWidth = image.width * zoom.scale;
     var scaledHeight = image.height * zoom.scale;
     image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
     image.maxX = -image.minX;
     image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
     image.maxY = -image.minY;
     image.currentX = Math.max(Math.min(image.currentX, image.maxX), image.minX);
     image.currentY = Math.max(Math.min(image.currentY, image.maxY), image.minY);
     gesture.$imageWrapEl.transition(momentumDuration).transform("translate3d(" + image.currentX + "px, " + image.currentY + "px,0)");
   },
   onTransitionEnd: function onTransitionEnd() {
     var swiper = this;
     var zoom = swiper.zoom;
     var gesture = zoom.gesture;

     if (gesture.$slideEl && swiper.previousIndex !== swiper.activeIndex) {
       if (gesture.$imageEl) {
         gesture.$imageEl.transform('translate3d(0,0,0) scale(1)');
       }

       if (gesture.$imageWrapEl) {
         gesture.$imageWrapEl.transform('translate3d(0,0,0)');
       }

       zoom.scale = 1;
       zoom.currentScale = 1;
       gesture.$slideEl = undefined;
       gesture.$imageEl = undefined;
       gesture.$imageWrapEl = undefined;
     }
   },
   // Toggle Zoom
   toggle: function toggle(e) {
     var swiper = this;
     var zoom = swiper.zoom;

     if (zoom.scale && zoom.scale !== 1) {
       // Zoom Out
       zoom.out();
     } else {
       // Zoom In
       zoom.in(e);
     }
   },
   in: function _in(e) {
     var swiper = this;
     var window = Object(ssr_window__WEBPACK_IMPORTED_MODULE_0__[/* getWindow */ "b"])();
     var zoom = swiper.zoom;
     var params = swiper.params.zoom;
     var gesture = zoom.gesture,
         image = zoom.image;

     if (!gesture.$slideEl) {
       if (e && e.target) {
         gesture.$slideEl = Object(_utils_dom__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(e.target).closest("." + swiper.params.slideClass);
       }

       if (!gesture.$slideEl) {
         if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) {
           gesture.$slideEl = swiper.$wrapperEl.children("." + swiper.params.slideActiveClass);
         } else {
           gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
         }
       }

       gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas, picture, .swiper-zoom-target');
       gesture.$imageWrapEl = gesture.$imageEl.parent("." + params.containerClass);
     }

     if (!gesture.$imageEl || gesture.$imageEl.length === 0 || !gesture.$imageWrapEl || gesture.$imageWrapEl.length === 0) return;
     gesture.$slideEl.addClass("" + params.zoomedSlideClass);
     var touchX;
     var touchY;
     var offsetX;
     var offsetY;
     var diffX;
     var diffY;
     var translateX;
     var translateY;
     var imageWidth;
     var imageHeight;
     var scaledWidth;
     var scaledHeight;
     var translateMinX;
     var translateMinY;
     var translateMaxX;
     var translateMaxY;
     var slideWidth;
     var slideHeight;

     if (typeof image.touchesStart.x === 'undefined' && e) {
       touchX = e.type === 'touchend' ? e.changedTouches[0].pageX : e.pageX;
       touchY = e.type === 'touchend' ? e.changedTouches[0].pageY : e.pageY;
     } else {
       touchX = image.touchesStart.x;
       touchY = image.touchesStart.y;
     }

     zoom.scale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
     zoom.currentScale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;

     if (e) {
       slideWidth = gesture.$slideEl[0].offsetWidth;
       slideHeight = gesture.$slideEl[0].offsetHeight;
       offsetX = gesture.$slideEl.offset().left + window.scrollX;
       offsetY = gesture.$slideEl.offset().top + window.scrollY;
       diffX = offsetX + slideWidth / 2 - touchX;
       diffY = offsetY + slideHeight / 2 - touchY;
       imageWidth = gesture.$imageEl[0].offsetWidth;
       imageHeight = gesture.$imageEl[0].offsetHeight;
       scaledWidth = imageWidth * zoom.scale;
       scaledHeight = imageHeight * zoom.scale;
       translateMinX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
       translateMinY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
       translateMaxX = -translateMinX;
       translateMaxY = -translateMinY;
       translateX = diffX * zoom.scale;
       translateY = diffY * zoom.scale;

       if (translateX < translateMinX) {
         translateX = translateMinX;
       }

       if (translateX > translateMaxX) {
         translateX = translateMaxX;
       }

       if (translateY < translateMinY) {
         translateY = translateMinY;
       }

       if (translateY > translateMaxY) {
         translateY = translateMaxY;
       }
     } else {
       translateX = 0;
       translateY = 0;
     }

     gesture.$imageWrapEl.transition(300).transform("translate3d(" + translateX + "px, " + translateY + "px,0)");
     gesture.$imageEl.transition(300).transform("translate3d(0,0,0) scale(" + zoom.scale + ")");
   },
   out: function out() {
     var swiper = this;
     var zoom = swiper.zoom;
     var params = swiper.params.zoom;
     var gesture = zoom.gesture;

     if (!gesture.$slideEl) {
       if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) {
         gesture.$slideEl = swiper.$wrapperEl.children("." + swiper.params.slideActiveClass);
       } else {
         gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
       }

       gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas, picture, .swiper-zoom-target');
       gesture.$imageWrapEl = gesture.$imageEl.parent("." + params.containerClass);
     }

     if (!gesture.$imageEl || gesture.$imageEl.length === 0 || !gesture.$imageWrapEl || gesture.$imageWrapEl.length === 0) return;
     zoom.scale = 1;
     zoom.currentScale = 1;
     gesture.$imageWrapEl.transition(300).transform('translate3d(0,0,0)');
     gesture.$imageEl.transition(300).transform('translate3d(0,0,0) scale(1)');
     gesture.$slideEl.removeClass("" + params.zoomedSlideClass);
     gesture.$slideEl = undefined;
   },
   toggleGestures: function toggleGestures(method) {
     var swiper = this;
     var zoom = swiper.zoom;
     var selector = zoom.slideSelector,
         passive = zoom.passiveListener;
     swiper.$wrapperEl[method]('gesturestart', selector, zoom.onGestureStart, passive);
     swiper.$wrapperEl[method]('gesturechange', selector, zoom.onGestureChange, passive);
     swiper.$wrapperEl[method]('gestureend', selector, zoom.onGestureEnd, passive);
   },
   enableGestures: function enableGestures() {
     if (this.zoom.gesturesEnabled) return;
     this.zoom.gesturesEnabled = true;
     this.zoom.toggleGestures('on');
   },
   disableGestures: function disableGestures() {
     if (!this.zoom.gesturesEnabled) return;
     this.zoom.gesturesEnabled = false;
     this.zoom.toggleGestures('off');
   },
   // Attach/Detach Events
   enable: function enable() {
     var swiper = this;
     var support = swiper.support;
     var zoom = swiper.zoom;
     if (zoom.enabled) return;
     zoom.enabled = true;
     var passiveListener = swiper.touchEvents.start === 'touchstart' && support.passiveListener && swiper.params.passiveListeners ? {
       passive: true,
       capture: false
     } : false;
     var activeListenerWithCapture = support.passiveListener ? {
       passive: false,
       capture: true
     } : true;
     var slideSelector = "." + swiper.params.slideClass;
     swiper.zoom.passiveListener = passiveListener;
     swiper.zoom.slideSelector = slideSelector; // Scale image

     if (support.gestures) {
       swiper.$wrapperEl.on(swiper.touchEvents.start, swiper.zoom.enableGestures, passiveListener);
       swiper.$wrapperEl.on(swiper.touchEvents.end, swiper.zoom.disableGestures, passiveListener);
     } else if (swiper.touchEvents.start === 'touchstart') {
       swiper.$wrapperEl.on(swiper.touchEvents.start, slideSelector, zoom.onGestureStart, passiveListener);
       swiper.$wrapperEl.on(swiper.touchEvents.move, slideSelector, zoom.onGestureChange, activeListenerWithCapture);
       swiper.$wrapperEl.on(swiper.touchEvents.end, slideSelector, zoom.onGestureEnd, passiveListener);

       if (swiper.touchEvents.cancel) {
         swiper.$wrapperEl.on(swiper.touchEvents.cancel, slideSelector, zoom.onGestureEnd, passiveListener);
       }
     } // Move image


     swiper.$wrapperEl.on(swiper.touchEvents.move, "." + swiper.params.zoom.containerClass, zoom.onTouchMove, activeListenerWithCapture);
   },
   disable: function disable() {
     var swiper = this;
     var zoom = swiper.zoom;
     if (!zoom.enabled) return;
     var support = swiper.support;
     swiper.zoom.enabled = false;
     var passiveListener = swiper.touchEvents.start === 'touchstart' && support.passiveListener && swiper.params.passiveListeners ? {
       passive: true,
       capture: false
     } : false;
     var activeListenerWithCapture = support.passiveListener ? {
       passive: false,
       capture: true
     } : true;
     var slideSelector = "." + swiper.params.slideClass; // Scale image

     if (support.gestures) {
       swiper.$wrapperEl.off(swiper.touchEvents.start, swiper.zoom.enableGestures, passiveListener);
       swiper.$wrapperEl.off(swiper.touchEvents.end, swiper.zoom.disableGestures, passiveListener);
     } else if (swiper.touchEvents.start === 'touchstart') {
       swiper.$wrapperEl.off(swiper.touchEvents.start, slideSelector, zoom.onGestureStart, passiveListener);
       swiper.$wrapperEl.off(swiper.touchEvents.move, slideSelector, zoom.onGestureChange, activeListenerWithCapture);
       swiper.$wrapperEl.off(swiper.touchEvents.end, slideSelector, zoom.onGestureEnd, passiveListener);

       if (swiper.touchEvents.cancel) {
         swiper.$wrapperEl.off(swiper.touchEvents.cancel, slideSelector, zoom.onGestureEnd, passiveListener);
       }
     } // Move image


     swiper.$wrapperEl.off(swiper.touchEvents.move, "." + swiper.params.zoom.containerClass, zoom.onTouchMove, activeListenerWithCapture);
   }
 };
 /* harmony default export */ __webpack_exports__["a"] = ({
   name: 'zoom',
   params: {
     zoom: {
       enabled: false,
       maxRatio: 3,
       minRatio: 1,
       toggle: true,
       containerClass: 'swiper-zoom-container',
       zoomedSlideClass: 'swiper-slide-zoomed'
     }
   },
   create: function create() {
     var swiper = this;
     Object(_utils_utils__WEBPACK_IMPORTED_MODULE_2__[/* bindModuleMethods */ "a"])(swiper, {
       zoom: _extends({
         enabled: false,
         scale: 1,
         currentScale: 1,
         isScaling: false,
         gesture: {
           $slideEl: undefined,
           slideWidth: undefined,
           slideHeight: undefined,
           $imageEl: undefined,
           $imageWrapEl: undefined,
           maxRatio: 3
         },
         image: {
           isTouched: undefined,
           isMoved: undefined,
           currentX: undefined,
           currentY: undefined,
           minX: undefined,
           minY: undefined,
           maxX: undefined,
           maxY: undefined,
           width: undefined,
           height: undefined,
           startX: undefined,
           startY: undefined,
           touchesStart: {},
           touchesCurrent: {}
         },
         velocity: {
           x: undefined,
           y: undefined,
           prevPositionX: undefined,
           prevPositionY: undefined,
           prevTime: undefined
         }
       }, Zoom)
     });
     var scale = 1;
     Object.defineProperty(swiper.zoom, 'scale', {
       get: function get() {
         return scale;
       },
       set: function set(value) {
         if (scale !== value) {
           var imageEl = swiper.zoom.gesture.$imageEl ? swiper.zoom.gesture.$imageEl[0] : undefined;
           var slideEl = swiper.zoom.gesture.$slideEl ? swiper.zoom.gesture.$slideEl[0] : undefined;
           swiper.emit('zoomChange', value, imageEl, slideEl);
         }

         scale = value;
       }
     });
   },
   on: {
     init: function init(swiper) {
       if (swiper.params.zoom.enabled) {
         swiper.zoom.enable();
       }
     },
     destroy: function destroy(swiper) {
       swiper.zoom.disable();
     },
     touchStart: function touchStart(swiper, e) {
       if (!swiper.zoom.enabled) return;
       swiper.zoom.onTouchStart(e);
     },
     touchEnd: function touchEnd(swiper, e) {
       if (!swiper.zoom.enabled) return;
       swiper.zoom.onTouchEnd(e);
     },
     doubleTap: function doubleTap(swiper, e) {
       if (!swiper.animating && swiper.params.zoom.enabled && swiper.zoom.enabled && swiper.params.zoom.toggle) {
         swiper.zoom.toggle(e);
       }
     },
     transitionEnd: function transitionEnd(swiper) {
       if (swiper.zoom.enabled && swiper.params.zoom.enabled) {
         swiper.zoom.onTransitionEnd();
       }
     },
     slideChange: function slideChange(swiper) {
       if (swiper.zoom.enabled && swiper.params.zoom.enabled && swiper.params.cssMode) {
         swiper.zoom.onTransitionEnd();
       }
     }
   }
 });

 /***/ }),
 /* 377 */
 /***/ (function(module, __webpack_exports__, __webpack_require__) {

 "use strict";
 /* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6);
 function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }


 var Fade = {
   setTranslate: function setTranslate() {
     var swiper = this;
     var slides = swiper.slides;

     for (var i = 0; i < slides.length; i += 1) {
       var $slideEl = swiper.slides.eq(i);
       var offset = $slideEl[0].swiperSlideOffset;
       var tx = -offset;
       if (!swiper.params.virtualTranslate) tx -= swiper.translate;
       var ty = 0;

       if (!swiper.isHorizontal()) {
         ty = tx;
         tx = 0;
       }

       var slideOpacity = swiper.params.fadeEffect.crossFade ? Math.max(1 - Math.abs($slideEl[0].progress), 0) : 1 + Math.min(Math.max($slideEl[0].progress, -1), 0);
       $slideEl.css({
         opacity: slideOpacity
       }).transform("translate3d(" + tx + "px, " + ty + "px, 0px)");
     }
   },
   setTransition: function setTransition(duration) {
     var swiper = this;
     var slides = swiper.slides,
         $wrapperEl = swiper.$wrapperEl;
     slides.transition(duration);

     if (swiper.params.virtualTranslate && duration !== 0) {
       var eventTriggered = false;
       slides.transitionEnd(function () {
         if (eventTriggered) return;
         if (!swiper || swiper.destroyed) return;
         eventTriggered = true;
         swiper.animating = false;
         var triggerEvents = ['webkitTransitionEnd', 'transitionend'];

         for (var i = 0; i < triggerEvents.length; i += 1) {
           $wrapperEl.trigger(triggerEvents[i]);
         }
       });
     }
   }
 };
 /* harmony default export */ __webpack_exports__["a"] = ({
   name: 'effect-fade',
   params: {
     fadeEffect: {
       crossFade: false
     }
   },
   create: function create() {
     var swiper = this;
     Object(_utils_utils__WEBPACK_IMPORTED_MODULE_0__[/* bindModuleMethods */ "a"])(swiper, {
       fadeEffect: _extends({}, Fade)
     });
   },
   on: {
     beforeInit: function beforeInit(swiper) {
       if (swiper.params.effect !== 'fade') return;
       swiper.classNames.push(swiper.params.containerModifierClass + "fade");
       var overwriteParams = {
         slidesPerView: 1,
         slidesPerColumn: 1,
         slidesPerGroup: 1,
         watchSlidesProgress: true,
         spaceBetween: 0,
         virtualTranslate: true
       };
       Object(_utils_utils__WEBPACK_IMPORTED_MODULE_0__[/* extend */ "e"])(swiper.params, overwriteParams);
       Object(_utils_utils__WEBPACK_IMPORTED_MODULE_0__[/* extend */ "e"])(swiper.originalParams, overwriteParams);
     },
     setTranslate: function setTranslate(swiper) {
       if (swiper.params.effect !== 'fade') return;
       swiper.fadeEffect.setTranslate();
     },
     setTransition: function setTransition(swiper, duration) {
       if (swiper.params.effect !== 'fade') return;
       swiper.fadeEffect.setTransition(duration);
     }
   }
 });

 /***/ })
 /******/ ]);
